!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).browser = {});
}(this, function (e) {
  "use strict";

  var t = "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {},
    n = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
  function r(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }
  function i(e) {
    if (e.__esModule) return e;
    var t = e.default;
    if ("function" == typeof t) {
      var n = function e() {
        return this instanceof e ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
      };
      n.prototype = t.prototype;
    } else n = {};
    return Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.keys(e).forEach(function (t) {
      var r = Object.getOwnPropertyDescriptor(e, t);
      Object.defineProperty(n, t, r.get ? r : {
        enumerable: !0,
        get: function () {
          return e[t];
        }
      });
    }), n;
  }
  var o = {
    exports: {}
  };
  !function (e, t) {
    var r = "undefined" != typeof self ? self : n,
      i = function () {
        function e() {
          this.fetch = !1, this.DOMException = r.DOMException;
        }
        return e.prototype = r, new e();
      }();
    !function (e) {
      !function (t) {
        var n = ("URLSearchParams" in e),
          r = "Symbol" in e && "iterator" in Symbol,
          i = "FileReader" in e && "Blob" in e && function () {
            try {
              return new Blob(), !0;
            } catch (e) {
              return !1;
            }
          }(),
          o = ("FormData" in e),
          a = ("ArrayBuffer" in e);
        if (a) var s = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
          u = ArrayBuffer.isView || function (e) {
            return e && s.indexOf(Object.prototype.toString.call(e)) > -1;
          };
        function c(e) {
          if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
          return e.toLowerCase();
        }
        function l(e) {
          return "string" != typeof e && (e = String(e)), e;
        }
        function d(e) {
          var t = {
            next: function () {
              var t = e.shift();
              return {
                done: void 0 === t,
                value: t
              };
            }
          };
          return r && (t[Symbol.iterator] = function () {
            return t;
          }), t;
        }
        function f(e) {
          this.map = {}, e instanceof f ? e.forEach(function (e, t) {
            this.append(t, e);
          }, this) : Array.isArray(e) ? e.forEach(function (e) {
            this.append(e[0], e[1]);
          }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
            this.append(t, e[t]);
          }, this);
        }
        function h(e) {
          if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
          e.bodyUsed = !0;
        }
        function p(e) {
          return new Promise(function (t, n) {
            e.onload = function () {
              t(e.result);
            }, e.onerror = function () {
              n(e.error);
            };
          });
        }
        function m(e) {
          var t = new FileReader(),
            n = p(t);
          return t.readAsArrayBuffer(e), n;
        }
        function g(e) {
          if (e.slice) return e.slice(0);
          var t = new Uint8Array(e.byteLength);
          return t.set(new Uint8Array(e)), t.buffer;
        }
        function v() {
          return this.bodyUsed = !1, this._initBody = function (e) {
            var t;
            this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : i && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : o && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : n && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : a && i && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = g(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : a && (ArrayBuffer.prototype.isPrototypeOf(e) || u(e)) ? this._bodyArrayBuffer = g(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, i && (this.blob = function () {
            var e = h(this);
            if (e) return e;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function () {
            return this._bodyArrayBuffer ? h(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(m);
          }), this.text = function () {
            var e,
              t,
              n,
              r = h(this);
            if (r) return r;
            if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader(), n = p(t), t.readAsText(e), n;
            if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
              for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++) n[r] = String.fromCharCode(t[r]);
              return n.join("");
            }(this._bodyArrayBuffer));
            if (this._bodyFormData) throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, o && (this.formData = function () {
            return this.text().then(w);
          }), this.json = function () {
            return this.text().then(JSON.parse);
          }, this;
        }
        f.prototype.append = function (e, t) {
          e = c(e), t = l(t);
          var n = this.map[e];
          this.map[e] = n ? n + ", " + t : t;
        }, f.prototype.delete = function (e) {
          delete this.map[c(e)];
        }, f.prototype.get = function (e) {
          return e = c(e), this.has(e) ? this.map[e] : null;
        }, f.prototype.has = function (e) {
          return this.map.hasOwnProperty(c(e));
        }, f.prototype.set = function (e, t) {
          this.map[c(e)] = l(t);
        }, f.prototype.forEach = function (e, t) {
          for (var n in this.map) this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
        }, f.prototype.keys = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push(n);
          }), d(e);
        }, f.prototype.values = function () {
          var e = [];
          return this.forEach(function (t) {
            e.push(t);
          }), d(e);
        }, f.prototype.entries = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push([n, t]);
          }), d(e);
        }, r && (f.prototype[Symbol.iterator] = f.prototype.entries);
        var b = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function y(e, t) {
          var n = (t = t || {}).body;
          if (e instanceof y) {
            if (e.bodyUsed) throw new TypeError("Already read");
            this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new f(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, n || null == e._bodyInit || (n = e._bodyInit, e.bodyUsed = !0);
          } else this.url = String(e);
          if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new f(t.headers)), this.method = function (e) {
            var t = e.toUpperCase();
            return b.indexOf(t) > -1 ? t : e;
          }(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && n) throw new TypeError("Body not allowed for GET or HEAD requests");
          this._initBody(n);
        }
        function w(e) {
          var t = new FormData();
          return e.trim().split("&").forEach(function (e) {
            if (e) {
              var n = e.split("="),
                r = n.shift().replace(/\+/g, " "),
                i = n.join("=").replace(/\+/g, " ");
              t.append(decodeURIComponent(r), decodeURIComponent(i));
            }
          }), t;
        }
        function A(e, t) {
          t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new f(t.headers), this.url = t.url || "", this._initBody(e);
        }
        y.prototype.clone = function () {
          return new y(this, {
            body: this._bodyInit
          });
        }, v.call(y.prototype), v.call(A.prototype), A.prototype.clone = function () {
          return new A(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new f(this.headers),
            url: this.url
          });
        }, A.error = function () {
          var e = new A(null, {
            status: 0,
            statusText: ""
          });
          return e.type = "error", e;
        };
        var _ = [301, 302, 303, 307, 308];
        A.redirect = function (e, t) {
          if (-1 === _.indexOf(t)) throw new RangeError("Invalid status code");
          return new A(null, {
            status: t,
            headers: {
              location: e
            }
          });
        }, t.DOMException = e.DOMException;
        try {
          new t.DOMException();
        } catch (e) {
          t.DOMException = function (e, t) {
            this.message = e, this.name = t;
            var n = Error(e);
            this.stack = n.stack;
          }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
        }
        function E(e, n) {
          return new Promise(function (r, o) {
            var a = new y(e, n);
            if (a.signal && a.signal.aborted) return o(new t.DOMException("Aborted", "AbortError"));
            var s = new XMLHttpRequest();
            function u() {
              s.abort();
            }
            s.onload = function () {
              var e,
                t,
                n = {
                  status: s.status,
                  statusText: s.statusText,
                  headers: (e = s.getAllResponseHeaders() || "", t = new f(), e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
                    var n = e.split(":"),
                      r = n.shift().trim();
                    if (r) {
                      var i = n.join(":").trim();
                      t.append(r, i);
                    }
                  }), t)
                };
              n.url = "responseURL" in s ? s.responseURL : n.headers.get("X-Request-URL");
              var i = "response" in s ? s.response : s.responseText;
              r(new A(i, n));
            }, s.onerror = function () {
              o(new TypeError("Network request failed"));
            }, s.ontimeout = function () {
              o(new TypeError("Network request failed"));
            }, s.onabort = function () {
              o(new t.DOMException("Aborted", "AbortError"));
            }, s.open(a.method, a.url, !0), "include" === a.credentials ? s.withCredentials = !0 : "omit" === a.credentials && (s.withCredentials = !1), "responseType" in s && i && (s.responseType = "blob"), a.headers.forEach(function (e, t) {
              s.setRequestHeader(t, e);
            }), a.signal && (a.signal.addEventListener("abort", u), s.onreadystatechange = function () {
              4 === s.readyState && a.signal.removeEventListener("abort", u);
            }), s.send(void 0 === a._bodyInit ? null : a._bodyInit);
          });
        }
        E.polyfill = !0, e.fetch || (e.fetch = E, e.Headers = f, e.Request = y, e.Response = A), t.Headers = f, t.Request = y, t.Response = A, t.fetch = E, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }({});
    }(i), i.fetch.ponyfill = !0, delete i.fetch.polyfill;
    var o = i;
    (t = o.fetch).default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e.exports = t;
  }(o, o.exports);
  var a = r(o.exports),
    s = [],
    u = [],
    c = "undefined" != typeof Uint8Array ? Uint8Array : Array,
    l = !1;
  function d() {
    l = !0;
    for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0; t < 64; ++t) s[t] = e[t], u[e.charCodeAt(t)] = t;
    u["-".charCodeAt(0)] = 62, u["_".charCodeAt(0)] = 63;
  }
  function f(e, t, n) {
    for (var r, i, o = [], a = t; a < n; a += 3) r = (e[a] << 16) + (e[a + 1] << 8) + e[a + 2], o.push(s[(i = r) >> 18 & 63] + s[i >> 12 & 63] + s[i >> 6 & 63] + s[63 & i]);
    return o.join("");
  }
  function h(e) {
    var t;
    l || d();
    for (var n = e.length, r = n % 3, i = "", o = [], a = 16383, u = 0, c = n - r; u < c; u += a) o.push(f(e, u, u + a > c ? c : u + a));
    return 1 === r ? (t = e[n - 1], i += s[t >> 2], i += s[t << 4 & 63], i += "==") : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], i += s[t >> 10], i += s[t >> 4 & 63], i += s[t << 2 & 63], i += "="), o.push(i), o.join("");
  }
  function p(e, t, n, r, i) {
    var o,
      a,
      s = 8 * i - r - 1,
      u = (1 << s) - 1,
      c = u >> 1,
      l = -7,
      d = n ? i - 1 : 0,
      f = n ? -1 : 1,
      h = e[t + d];
    for (d += f, o = h & (1 << -l) - 1, h >>= -l, l += s; l > 0; o = 256 * o + e[t + d], d += f, l -= 8);
    for (a = o & (1 << -l) - 1, o >>= -l, l += r; l > 0; a = 256 * a + e[t + d], d += f, l -= 8);
    if (0 === o) o = 1 - c;else {
      if (o === u) return a ? NaN : 1 / 0 * (h ? -1 : 1);
      a += Math.pow(2, r), o -= c;
    }
    return (h ? -1 : 1) * a * Math.pow(2, o - r);
  }
  function m(e, t, n, r, i, o) {
    var a,
      s,
      u,
      c = 8 * o - i - 1,
      l = (1 << c) - 1,
      d = l >> 1,
      f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
      h = r ? 0 : o - 1,
      p = r ? 1 : -1,
      m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = l) : (a = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), (t += a + d >= 1 ? f / u : f * Math.pow(2, 1 - d)) * u >= 2 && (a++, u /= 2), a + d >= l ? (s = 0, a = l) : a + d >= 1 ? (s = (t * u - 1) * Math.pow(2, i), a += d) : (s = t * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; e[n + h] = 255 & s, h += p, s /= 256, i -= 8);
    for (a = a << i | s, c += i; c > 0; e[n + h] = 255 & a, h += p, a /= 256, c -= 8);
    e[n + h - p] |= 128 * m;
  }
  var g = {}.toString,
    v = Array.isArray || function (e) {
      return "[object Array]" == g.call(e);
    };
  A.TYPED_ARRAY_SUPPORT = void 0 === t.TYPED_ARRAY_SUPPORT || t.TYPED_ARRAY_SUPPORT;
  var b = y();
  function y() {
    return A.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
  }
  function w(e, t) {
    if (y() < t) throw new RangeError("Invalid typed array length");
    return A.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = A.prototype : (null === e && (e = new A(t)), e.length = t), e;
  }
  function A(e, t, n) {
    if (!(A.TYPED_ARRAY_SUPPORT || this instanceof A)) return new A(e, t, n);
    if ("number" == typeof e) {
      if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
      return S(this, e);
    }
    return _(this, e, t, n);
  }
  function _(e, t, n, r) {
    if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
    return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, n, r) {
      if (t.byteLength, n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");
      if (t.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
      t = void 0 === n && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, n) : new Uint8Array(t, n, r);
      A.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = A.prototype : e = k(e, t);
      return e;
    }(e, t, n, r) : "string" == typeof t ? function (e, t, n) {
      "string" == typeof n && "" !== n || (n = "utf8");
      if (!A.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
      var r = 0 | x(t, n);
      e = w(e, r);
      var i = e.write(t, n);
      i !== r && (e = e.slice(0, i));
      return e;
    }(e, t, n) : function (e, t) {
      if (C(t)) {
        var n = 0 | M(t.length);
        return 0 === (e = w(e, n)).length || t.copy(e, 0, 0, n), e;
      }
      if (t) {
        if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (r = t.length) != r ? w(e, 0) : k(e, t);
        if ("Buffer" === t.type && v(t.data)) return k(e, t.data);
      }
      var r;
      throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
    }(e, t);
  }
  function E(e) {
    if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
    if (e < 0) throw new RangeError('"size" argument must not be negative');
  }
  function S(e, t) {
    if (E(t), e = w(e, t < 0 ? 0 : 0 | M(t)), !A.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) e[n] = 0;
    return e;
  }
  function k(e, t) {
    var n = t.length < 0 ? 0 : 0 | M(t.length);
    e = w(e, n);
    for (var r = 0; r < n; r += 1) e[r] = 255 & t[r];
    return e;
  }
  function M(e) {
    if (e >= y()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + y().toString(16) + " bytes");
    return 0 | e;
  }
  function C(e) {
    return !(null == e || !e._isBuffer);
  }
  function x(e, t) {
    if (C(e)) return e.length;
    if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
    "string" != typeof e && (e = "" + e);
    var n = e.length;
    if (0 === n) return 0;
    for (var r = !1;;) switch (t) {
      case "ascii":
      case "latin1":
      case "binary":
        return n;
      case "utf8":
      case "utf-8":
      case void 0:
        return te(e).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return 2 * n;
      case "hex":
        return n >>> 1;
      case "base64":
        return ne(e).length;
      default:
        if (r) return te(e).length;
        t = ("" + t).toLowerCase(), r = !0;
    }
  }
  function R(e, t, n) {
    var r = !1;
    if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
    if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
    if ((n >>>= 0) <= (t >>>= 0)) return "";
    for (e || (e = "utf8");;) switch (e) {
      case "hex":
        return H(this, t, n);
      case "utf8":
      case "utf-8":
        return z(this, t, n);
      case "ascii":
        return q(this, t, n);
      case "latin1":
      case "binary":
        return K(this, t, n);
      case "base64":
        return F(this, t, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return V(this, t, n);
      default:
        if (r) throw new TypeError("Unknown encoding: " + e);
        e = (e + "").toLowerCase(), r = !0;
    }
  }
  function I(e, t, n) {
    var r = e[t];
    e[t] = e[n], e[n] = r;
  }
  function T(e, t, n, r, i) {
    if (0 === e.length) return -1;
    if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
      if (i) return -1;
      n = e.length - 1;
    } else if (n < 0) {
      if (!i) return -1;
      n = 0;
    }
    if ("string" == typeof t && (t = A.from(t, r)), C(t)) return 0 === t.length ? -1 : P(e, t, n, r, i);
    if ("number" == typeof t) return t &= 255, A.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : P(e, [t], n, r, i);
    throw new TypeError("val must be string, number or Buffer");
  }
  function P(e, t, n, r, i) {
    var o,
      a = 1,
      s = e.length,
      u = t.length;
    if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
      if (e.length < 2 || t.length < 2) return -1;
      a = 2, s /= 2, u /= 2, n /= 2;
    }
    function c(e, t) {
      return 1 === a ? e[t] : e.readUInt16BE(t * a);
    }
    if (i) {
      var l = -1;
      for (o = n; o < s; o++) if (c(e, o) === c(t, -1 === l ? 0 : o - l)) {
        if (-1 === l && (l = o), o - l + 1 === u) return l * a;
      } else -1 !== l && (o -= o - l), l = -1;
    } else for (n + u > s && (n = s - u), o = n; o >= 0; o--) {
      for (var d = !0, f = 0; f < u; f++) if (c(e, o + f) !== c(t, f)) {
        d = !1;
        break;
      }
      if (d) return o;
    }
    return -1;
  }
  function O(e, t, n, r) {
    n = Number(n) || 0;
    var i = e.length - n;
    r ? (r = Number(r)) > i && (r = i) : r = i;
    var o = t.length;
    if (o % 2 != 0) throw new TypeError("Invalid hex string");
    r > o / 2 && (r = o / 2);
    for (var a = 0; a < r; ++a) {
      var s = parseInt(t.substr(2 * a, 2), 16);
      if (isNaN(s)) return a;
      e[n + a] = s;
    }
    return a;
  }
  function L(e, t, n, r) {
    return re(te(t, e.length - n), e, n, r);
  }
  function N(e, t, n, r) {
    return re(function (e) {
      for (var t = [], n = 0; n < e.length; ++n) t.push(255 & e.charCodeAt(n));
      return t;
    }(t), e, n, r);
  }
  function D(e, t, n, r) {
    return N(e, t, n, r);
  }
  function B(e, t, n, r) {
    return re(ne(t), e, n, r);
  }
  function j(e, t, n, r) {
    return re(function (e, t) {
      for (var n, r, i, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) r = (n = e.charCodeAt(a)) >> 8, i = n % 256, o.push(i), o.push(r);
      return o;
    }(t, e.length - n), e, n, r);
  }
  function F(e, t, n) {
    return 0 === t && n === e.length ? h(e) : h(e.slice(t, n));
  }
  function z(e, t, n) {
    n = Math.min(e.length, n);
    for (var r = [], i = t; i < n;) {
      var o,
        a,
        s,
        u,
        c = e[i],
        l = null,
        d = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
      if (i + d <= n) switch (d) {
        case 1:
          c < 128 && (l = c);
          break;
        case 2:
          128 == (192 & (o = e[i + 1])) && (u = (31 & c) << 6 | 63 & o) > 127 && (l = u);
          break;
        case 3:
          o = e[i + 1], a = e[i + 2], 128 == (192 & o) && 128 == (192 & a) && (u = (15 & c) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (u < 55296 || u > 57343) && (l = u);
          break;
        case 4:
          o = e[i + 1], a = e[i + 2], s = e[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (u = (15 & c) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && u < 1114112 && (l = u);
      }
      null === l ? (l = 65533, d = 1) : l > 65535 && (l -= 65536, r.push(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), r.push(l), i += d;
    }
    return function (e) {
      var t = e.length;
      if (t <= U) return String.fromCharCode.apply(String, e);
      var n = "",
        r = 0;
      for (; r < t;) n += String.fromCharCode.apply(String, e.slice(r, r += U));
      return n;
    }(r);
  }
  A.poolSize = 8192, A._augment = function (e) {
    return e.__proto__ = A.prototype, e;
  }, A.from = function (e, t, n) {
    return _(null, e, t, n);
  }, A.TYPED_ARRAY_SUPPORT && (A.prototype.__proto__ = Uint8Array.prototype, A.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && A[Symbol.species]), A.alloc = function (e, t, n) {
    return function (e, t, n, r) {
      return E(t), t <= 0 ? w(e, t) : void 0 !== n ? "string" == typeof r ? w(e, t).fill(n, r) : w(e, t).fill(n) : w(e, t);
    }(null, e, t, n);
  }, A.allocUnsafe = function (e) {
    return S(null, e);
  }, A.allocUnsafeSlow = function (e) {
    return S(null, e);
  }, A.isBuffer = ie, A.compare = function (e, t) {
    if (!C(e) || !C(t)) throw new TypeError("Arguments must be Buffers");
    if (e === t) return 0;
    for (var n = e.length, r = t.length, i = 0, o = Math.min(n, r); i < o; ++i) if (e[i] !== t[i]) {
      n = e[i], r = t[i];
      break;
    }
    return n < r ? -1 : r < n ? 1 : 0;
  }, A.isEncoding = function (e) {
    switch (String(e).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, A.concat = function (e, t) {
    if (!v(e)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (0 === e.length) return A.alloc(0);
    var n;
    if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) t += e[n].length;
    var r = A.allocUnsafe(t),
      i = 0;
    for (n = 0; n < e.length; ++n) {
      var o = e[n];
      if (!C(o)) throw new TypeError('"list" argument must be an Array of Buffers');
      o.copy(r, i), i += o.length;
    }
    return r;
  }, A.byteLength = x, A.prototype._isBuffer = !0, A.prototype.swap16 = function () {
    var e = this.length;
    if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var t = 0; t < e; t += 2) I(this, t, t + 1);
    return this;
  }, A.prototype.swap32 = function () {
    var e = this.length;
    if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var t = 0; t < e; t += 4) I(this, t, t + 3), I(this, t + 1, t + 2);
    return this;
  }, A.prototype.swap64 = function () {
    var e = this.length;
    if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var t = 0; t < e; t += 8) I(this, t, t + 7), I(this, t + 1, t + 6), I(this, t + 2, t + 5), I(this, t + 3, t + 4);
    return this;
  }, A.prototype.toString = function () {
    var e = 0 | this.length;
    return 0 === e ? "" : 0 === arguments.length ? z(this, 0, e) : R.apply(this, arguments);
  }, A.prototype.equals = function (e) {
    if (!C(e)) throw new TypeError("Argument must be a Buffer");
    return this === e || 0 === A.compare(this, e);
  }, A.prototype.inspect = function () {
    var e = "";
    return this.length > 0 && (e = this.toString("hex", 0, 50).match(/.{2}/g).join(" "), this.length > 50 && (e += " ... ")), "<Buffer " + e + ">";
  }, A.prototype.compare = function (e, t, n, r, i) {
    if (!C(e)) throw new TypeError("Argument must be a Buffer");
    if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw new RangeError("out of range index");
    if (r >= i && t >= n) return 0;
    if (r >= i) return -1;
    if (t >= n) return 1;
    if (this === e) return 0;
    for (var o = (i >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (t >>>= 0), s = Math.min(o, a), u = this.slice(r, i), c = e.slice(t, n), l = 0; l < s; ++l) if (u[l] !== c[l]) {
      o = u[l], a = c[l];
      break;
    }
    return o < a ? -1 : a < o ? 1 : 0;
  }, A.prototype.includes = function (e, t, n) {
    return -1 !== this.indexOf(e, t, n);
  }, A.prototype.indexOf = function (e, t, n) {
    return T(this, e, t, n, !0);
  }, A.prototype.lastIndexOf = function (e, t, n) {
    return T(this, e, t, n, !1);
  }, A.prototype.write = function (e, t, n, r) {
    if (void 0 === t) r = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;else {
      if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
      t |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
    }
    var i = this.length - t;
    if ((void 0 === n || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    r || (r = "utf8");
    for (var o = !1;;) switch (r) {
      case "hex":
        return O(this, e, t, n);
      case "utf8":
      case "utf-8":
        return L(this, e, t, n);
      case "ascii":
        return N(this, e, t, n);
      case "latin1":
      case "binary":
        return D(this, e, t, n);
      case "base64":
        return B(this, e, t, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return j(this, e, t, n);
      default:
        if (o) throw new TypeError("Unknown encoding: " + r);
        r = ("" + r).toLowerCase(), o = !0;
    }
  }, A.prototype.toJSON = function () {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  var U = 4096;
  function q(e, t, n) {
    var r = "";
    n = Math.min(e.length, n);
    for (var i = t; i < n; ++i) r += String.fromCharCode(127 & e[i]);
    return r;
  }
  function K(e, t, n) {
    var r = "";
    n = Math.min(e.length, n);
    for (var i = t; i < n; ++i) r += String.fromCharCode(e[i]);
    return r;
  }
  function H(e, t, n) {
    var r = e.length;
    (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
    for (var i = "", o = t; o < n; ++o) i += ee(e[o]);
    return i;
  }
  function V(e, t, n) {
    for (var r = e.slice(t, n), i = "", o = 0; o < r.length; o += 2) i += String.fromCharCode(r[o] + 256 * r[o + 1]);
    return i;
  }
  function $(e, t, n) {
    if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
    if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
  }
  function W(e, t, n, r, i, o) {
    if (!C(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
    if (n + r > e.length) throw new RangeError("Index out of range");
  }
  function Y(e, t, n, r) {
    t < 0 && (t = 65535 + t + 1);
    for (var i = 0, o = Math.min(e.length - n, 2); i < o; ++i) e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
  }
  function G(e, t, n, r) {
    t < 0 && (t = 4294967295 + t + 1);
    for (var i = 0, o = Math.min(e.length - n, 4); i < o; ++i) e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
  }
  function Q(e, t, n, r, i, o) {
    if (n + r > e.length) throw new RangeError("Index out of range");
    if (n < 0) throw new RangeError("Index out of range");
  }
  function Z(e, t, n, r, i) {
    return i || Q(e, 0, n, 4), m(e, t, n, r, 23, 4), n + 4;
  }
  function J(e, t, n, r, i) {
    return i || Q(e, 0, n, 8), m(e, t, n, r, 52, 8), n + 8;
  }
  A.prototype.slice = function (e, t) {
    var n,
      r = this.length;
    if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), A.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = A.prototype;else {
      var i = t - e;
      n = new A(i, void 0);
      for (var o = 0; o < i; ++o) n[o] = this[o + e];
    }
    return n;
  }, A.prototype.readUIntLE = function (e, t, n) {
    e |= 0, t |= 0, n || $(e, t, this.length);
    for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) r += this[e + o] * i;
    return r;
  }, A.prototype.readUIntBE = function (e, t, n) {
    e |= 0, t |= 0, n || $(e, t, this.length);
    for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) r += this[e + --t] * i;
    return r;
  }, A.prototype.readUInt8 = function (e, t) {
    return t || $(e, 1, this.length), this[e];
  }, A.prototype.readUInt16LE = function (e, t) {
    return t || $(e, 2, this.length), this[e] | this[e + 1] << 8;
  }, A.prototype.readUInt16BE = function (e, t) {
    return t || $(e, 2, this.length), this[e] << 8 | this[e + 1];
  }, A.prototype.readUInt32LE = function (e, t) {
    return t || $(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
  }, A.prototype.readUInt32BE = function (e, t) {
    return t || $(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
  }, A.prototype.readIntLE = function (e, t, n) {
    e |= 0, t |= 0, n || $(e, t, this.length);
    for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) r += this[e + o] * i;
    return r >= (i *= 128) && (r -= Math.pow(2, 8 * t)), r;
  }, A.prototype.readIntBE = function (e, t, n) {
    e |= 0, t |= 0, n || $(e, t, this.length);
    for (var r = t, i = 1, o = this[e + --r]; r > 0 && (i *= 256);) o += this[e + --r] * i;
    return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
  }, A.prototype.readInt8 = function (e, t) {
    return t || $(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
  }, A.prototype.readInt16LE = function (e, t) {
    t || $(e, 2, this.length);
    var n = this[e] | this[e + 1] << 8;
    return 32768 & n ? 4294901760 | n : n;
  }, A.prototype.readInt16BE = function (e, t) {
    t || $(e, 2, this.length);
    var n = this[e + 1] | this[e] << 8;
    return 32768 & n ? 4294901760 | n : n;
  }, A.prototype.readInt32LE = function (e, t) {
    return t || $(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
  }, A.prototype.readInt32BE = function (e, t) {
    return t || $(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
  }, A.prototype.readFloatLE = function (e, t) {
    return t || $(e, 4, this.length), p(this, e, !0, 23, 4);
  }, A.prototype.readFloatBE = function (e, t) {
    return t || $(e, 4, this.length), p(this, e, !1, 23, 4);
  }, A.prototype.readDoubleLE = function (e, t) {
    return t || $(e, 8, this.length), p(this, e, !0, 52, 8);
  }, A.prototype.readDoubleBE = function (e, t) {
    return t || $(e, 8, this.length), p(this, e, !1, 52, 8);
  }, A.prototype.writeUIntLE = function (e, t, n, r) {
    (e = +e, t |= 0, n |= 0, r) || W(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
    var i = 1,
      o = 0;
    for (this[t] = 255 & e; ++o < n && (i *= 256);) this[t + o] = e / i & 255;
    return t + n;
  }, A.prototype.writeUIntBE = function (e, t, n, r) {
    (e = +e, t |= 0, n |= 0, r) || W(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
    var i = n - 1,
      o = 1;
    for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) this[t + i] = e / o & 255;
    return t + n;
  }, A.prototype.writeUInt8 = function (e, t, n) {
    return e = +e, t |= 0, n || W(this, e, t, 1, 255, 0), A.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
  }, A.prototype.writeUInt16LE = function (e, t, n) {
    return e = +e, t |= 0, n || W(this, e, t, 2, 65535, 0), A.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : Y(this, e, t, !0), t + 2;
  }, A.prototype.writeUInt16BE = function (e, t, n) {
    return e = +e, t |= 0, n || W(this, e, t, 2, 65535, 0), A.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : Y(this, e, t, !1), t + 2;
  }, A.prototype.writeUInt32LE = function (e, t, n) {
    return e = +e, t |= 0, n || W(this, e, t, 4, 4294967295, 0), A.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : G(this, e, t, !0), t + 4;
  }, A.prototype.writeUInt32BE = function (e, t, n) {
    return e = +e, t |= 0, n || W(this, e, t, 4, 4294967295, 0), A.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : G(this, e, t, !1), t + 4;
  }, A.prototype.writeIntLE = function (e, t, n, r) {
    if (e = +e, t |= 0, !r) {
      var i = Math.pow(2, 8 * n - 1);
      W(this, e, t, n, i - 1, -i);
    }
    var o = 0,
      a = 1,
      s = 0;
    for (this[t] = 255 & e; ++o < n && (a *= 256);) e < 0 && 0 === s && 0 !== this[t + o - 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
    return t + n;
  }, A.prototype.writeIntBE = function (e, t, n, r) {
    if (e = +e, t |= 0, !r) {
      var i = Math.pow(2, 8 * n - 1);
      W(this, e, t, n, i - 1, -i);
    }
    var o = n - 1,
      a = 1,
      s = 0;
    for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) e < 0 && 0 === s && 0 !== this[t + o + 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
    return t + n;
  }, A.prototype.writeInt8 = function (e, t, n) {
    return e = +e, t |= 0, n || W(this, e, t, 1, 127, -128), A.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
  }, A.prototype.writeInt16LE = function (e, t, n) {
    return e = +e, t |= 0, n || W(this, e, t, 2, 32767, -32768), A.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : Y(this, e, t, !0), t + 2;
  }, A.prototype.writeInt16BE = function (e, t, n) {
    return e = +e, t |= 0, n || W(this, e, t, 2, 32767, -32768), A.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : Y(this, e, t, !1), t + 2;
  }, A.prototype.writeInt32LE = function (e, t, n) {
    return e = +e, t |= 0, n || W(this, e, t, 4, 2147483647, -2147483648), A.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : G(this, e, t, !0), t + 4;
  }, A.prototype.writeInt32BE = function (e, t, n) {
    return e = +e, t |= 0, n || W(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), A.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : G(this, e, t, !1), t + 4;
  }, A.prototype.writeFloatLE = function (e, t, n) {
    return Z(this, e, t, !0, n);
  }, A.prototype.writeFloatBE = function (e, t, n) {
    return Z(this, e, t, !1, n);
  }, A.prototype.writeDoubleLE = function (e, t, n) {
    return J(this, e, t, !0, n);
  }, A.prototype.writeDoubleBE = function (e, t, n) {
    return J(this, e, t, !1, n);
  }, A.prototype.copy = function (e, t, n, r) {
    if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;
    if (0 === e.length || 0 === this.length) return 0;
    if (t < 0) throw new RangeError("targetStart out of bounds");
    if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
    if (r < 0) throw new RangeError("sourceEnd out of bounds");
    r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
    var i,
      o = r - n;
    if (this === e && n < t && t < r) for (i = o - 1; i >= 0; --i) e[i + t] = this[i + n];else if (o < 1e3 || !A.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) e[i + t] = this[i + n];else Uint8Array.prototype.set.call(e, this.subarray(n, n + o), t);
    return o;
  }, A.prototype.fill = function (e, t, n, r) {
    if ("string" == typeof e) {
      if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === e.length) {
        var i = e.charCodeAt(0);
        i < 256 && (e = i);
      }
      if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
      if ("string" == typeof r && !A.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
    } else "number" == typeof e && (e &= 255);
    if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
    if (n <= t) return this;
    var o;
    if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < n; ++o) this[o] = e;else {
      var a = C(e) ? e : te(new A(e, r).toString()),
        s = a.length;
      for (o = 0; o < n - t; ++o) this[o + t] = a[o % s];
    }
    return this;
  };
  var X = /[^+\/0-9A-Za-z-_]/g;
  function ee(e) {
    return e < 16 ? "0" + e.toString(16) : e.toString(16);
  }
  function te(e, t) {
    var n;
    t = t || 1 / 0;
    for (var r = e.length, i = null, o = [], a = 0; a < r; ++a) {
      if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
        if (!i) {
          if (n > 56319) {
            (t -= 3) > -1 && o.push(239, 191, 189);
            continue;
          }
          if (a + 1 === r) {
            (t -= 3) > -1 && o.push(239, 191, 189);
            continue;
          }
          i = n;
          continue;
        }
        if (n < 56320) {
          (t -= 3) > -1 && o.push(239, 191, 189), i = n;
          continue;
        }
        n = 65536 + (i - 55296 << 10 | n - 56320);
      } else i && (t -= 3) > -1 && o.push(239, 191, 189);
      if (i = null, n < 128) {
        if ((t -= 1) < 0) break;
        o.push(n);
      } else if (n < 2048) {
        if ((t -= 2) < 0) break;
        o.push(n >> 6 | 192, 63 & n | 128);
      } else if (n < 65536) {
        if ((t -= 3) < 0) break;
        o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
      } else {
        if (!(n < 1114112)) throw new Error("Invalid code point");
        if ((t -= 4) < 0) break;
        o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
      }
    }
    return o;
  }
  function ne(e) {
    return function (e) {
      var t, n, r, i, o, a;
      l || d();
      var s = e.length;
      if (s % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      o = "=" === e[s - 2] ? 2 : "=" === e[s - 1] ? 1 : 0, a = new c(3 * s / 4 - o), r = o > 0 ? s - 4 : s;
      var f = 0;
      for (t = 0, n = 0; t < r; t += 4, n += 3) i = u[e.charCodeAt(t)] << 18 | u[e.charCodeAt(t + 1)] << 12 | u[e.charCodeAt(t + 2)] << 6 | u[e.charCodeAt(t + 3)], a[f++] = i >> 16 & 255, a[f++] = i >> 8 & 255, a[f++] = 255 & i;
      return 2 === o ? (i = u[e.charCodeAt(t)] << 2 | u[e.charCodeAt(t + 1)] >> 4, a[f++] = 255 & i) : 1 === o && (i = u[e.charCodeAt(t)] << 10 | u[e.charCodeAt(t + 1)] << 4 | u[e.charCodeAt(t + 2)] >> 2, a[f++] = i >> 8 & 255, a[f++] = 255 & i), a;
    }(function (e) {
      if ((e = function (e) {
        return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
      }(e).replace(X, "")).length < 2) return "";
      for (; e.length % 4 != 0;) e += "=";
      return e;
    }(e));
  }
  function re(e, t, n, r) {
    for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) t[i + n] = e[i];
    return i;
  }
  function ie(e) {
    return null != e && (!!e._isBuffer || oe(e) || function (e) {
      return "function" == typeof e.readFloatLE && "function" == typeof e.slice && oe(e.slice(0, 0));
    }(e));
  }
  function oe(e) {
    return !!e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
  }
  var ae = Object.freeze({
      __proto__: null,
      Buffer: A,
      INSPECT_MAX_BYTES: 50,
      SlowBuffer: function (e) {
        return +e != e && (e = 0), A.alloc(+e);
      },
      isBuffer: ie,
      kMaxLength: b
    }),
    se = {},
    ue = {},
    ce = {},
    le = i(ae),
    de = {};
  function fe() {
    throw new Error("setTimeout has not been defined");
  }
  function he() {
    throw new Error("clearTimeout has not been defined");
  }
  var pe = fe,
    me = he;
  function ge(e) {
    if (pe === setTimeout) return setTimeout(e, 0);
    if ((pe === fe || !pe) && setTimeout) return pe = setTimeout, setTimeout(e, 0);
    try {
      return pe(e, 0);
    } catch (t) {
      try {
        return pe.call(null, e, 0);
      } catch (t) {
        return pe.call(this, e, 0);
      }
    }
  }
  "function" == typeof t.setTimeout && (pe = setTimeout), "function" == typeof t.clearTimeout && (me = clearTimeout);
  var ve,
    be = [],
    ye = !1,
    we = -1;
  function Ae() {
    ye && ve && (ye = !1, ve.length ? be = ve.concat(be) : we = -1, be.length && _e());
  }
  function _e() {
    if (!ye) {
      var e = ge(Ae);
      ye = !0;
      for (var t = be.length; t;) {
        for (ve = be, be = []; ++we < t;) ve && ve[we].run();
        we = -1, t = be.length;
      }
      ve = null, ye = !1, function (e) {
        if (me === clearTimeout) return clearTimeout(e);
        if ((me === he || !me) && clearTimeout) return me = clearTimeout, clearTimeout(e);
        try {
          return me(e);
        } catch (t) {
          try {
            return me.call(null, e);
          } catch (t) {
            return me.call(this, e);
          }
        }
      }(e);
    }
  }
  function Ee(e) {
    var t = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
    be.push(new Se(e, t)), 1 !== be.length || ye || ge(_e);
  }
  function Se(e, t) {
    this.fun = e, this.array = t;
  }
  Se.prototype.run = function () {
    this.fun.apply(null, this.array);
  };
  function ke() {}
  var Me = ke,
    Ce = ke,
    xe = ke,
    Re = ke,
    Ie = ke,
    Te = ke,
    Pe = ke;
  var Oe = t.performance || {},
    Le = Oe.now || Oe.mozNow || Oe.msNow || Oe.oNow || Oe.webkitNow || function () {
      return new Date().getTime();
    };
  var Ne = new Date();
  var De,
    Be = {
      nextTick: Ee,
      title: "browser",
      browser: !0,
      env: {},
      argv: [],
      version: "",
      versions: {},
      on: Me,
      addListener: Ce,
      once: xe,
      off: Re,
      removeListener: Ie,
      removeAllListeners: Te,
      emit: Pe,
      binding: function (e) {
        throw new Error("process.binding is not supported");
      },
      cwd: function () {
        return "/";
      },
      chdir: function (e) {
        throw new Error("process.chdir is not supported");
      },
      umask: function () {
        return 0;
      },
      hrtime: function (e) {
        var t = .001 * Le.call(Oe),
          n = Math.floor(t),
          r = Math.floor(t % 1 * 1e9);
        return e && (n -= e[0], (r -= e[1]) < 0 && (n--, r += 1e9)), [n, r];
      },
      platform: "browser",
      release: {},
      config: {},
      uptime: function () {
        return (new Date() - Ne) / 1e3;
      }
    },
    je = {
      exports: {}
    },
    Fe = {
      exports: {}
    };
  function ze() {
    return De || (De = 1, function (e, t) {
      var n = le,
        r = n.Buffer;
      function i(e, t) {
        for (var n in e) t[n] = e[n];
      }
      function o(e, t, n) {
        return r(e, t, n);
      }
      r.from && r.alloc && r.allocUnsafe && r.allocUnsafeSlow ? e.exports = n : (i(n, t), t.Buffer = o), o.prototype = Object.create(r.prototype), i(r, o), o.from = function (e, t, n) {
        if ("number" == typeof e) throw new TypeError("Argument must not be a number");
        return r(e, t, n);
      }, o.alloc = function (e, t, n) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        var i = r(e);
        return void 0 !== t ? "string" == typeof n ? i.fill(t, n) : i.fill(t) : i.fill(0), i;
      }, o.allocUnsafe = function (e) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        return r(e);
      }, o.allocUnsafeSlow = function (e) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        return n.SlowBuffer(e);
      };
    }(Fe, Fe.exports)), Fe.exports;
  }
  var Ue = 65536,
    qe = 4294967295;
  var Ke = ze().Buffer,
    He = n.crypto || n.msCrypto;
  He && He.getRandomValues ? je.exports = function (e, t) {
    if (e > qe) throw new RangeError("requested too many random bytes");
    var n = Ke.allocUnsafe(e);
    if (e > 0) if (e > Ue) for (var r = 0; r < e; r += Ue) He.getRandomValues(n.slice(r, r + Ue));else He.getRandomValues(n);
    if ("function" == typeof t) return Ee(function () {
      t(null, n);
    });
    return n;
  } : je.exports = function () {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
  };
  var Ve = je.exports,
    $e = {
      exports: {}
    };
  "function" == typeof Object.create ? $e.exports = function (e, t) {
    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : $e.exports = function (e, t) {
    if (t) {
      e.super_ = t;
      var n = function () {};
      n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
    }
  };
  var We = $e.exports,
    Ye = {
      exports: {}
    };
  function Ge() {}
  function Qe() {
    Qe.init.call(this);
  }
  function Ze(e) {
    return void 0 === e._maxListeners ? Qe.defaultMaxListeners : e._maxListeners;
  }
  function Je(e, t, n, r) {
    var i, o, a;
    if ("function" != typeof n) throw new TypeError('"listener" argument must be a function');
    if ((o = e._events) ? (o.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), a = o[t]) : (o = e._events = new Ge(), e._eventsCount = 0), a) {
      if ("function" == typeof a ? a = o[t] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n), !a.warned && (i = Ze(e)) && i > 0 && a.length > i) {
        a.warned = !0;
        var s = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + t + " listeners added. Use emitter.setMaxListeners() to increase limit");
        s.name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = a.length, function (e) {
          "function" == typeof console.warn ? console.warn(e) : console.log(e);
        }(s);
      }
    } else a = o[t] = n, ++e._eventsCount;
    return e;
  }
  function Xe(e, t, n) {
    var r = !1;
    function i() {
      e.removeListener(t, i), r || (r = !0, n.apply(e, arguments));
    }
    return i.listener = n, i;
  }
  function et(e) {
    var t = this._events;
    if (t) {
      var n = t[e];
      if ("function" == typeof n) return 1;
      if (n) return n.length;
    }
    return 0;
  }
  function tt(e, t) {
    for (var n = new Array(t); t--;) n[t] = e[t];
    return n;
  }
  Ge.prototype = Object.create(null), Qe.EventEmitter = Qe, Qe.usingDomains = !1, Qe.prototype.domain = void 0, Qe.prototype._events = void 0, Qe.prototype._maxListeners = void 0, Qe.defaultMaxListeners = 10, Qe.init = function () {
    this.domain = null, Qe.usingDomains && undefined.active, this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = new Ge(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, Qe.prototype.setMaxListeners = function (e) {
    if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
    return this._maxListeners = e, this;
  }, Qe.prototype.getMaxListeners = function () {
    return Ze(this);
  }, Qe.prototype.emit = function (e) {
    var t,
      n,
      r,
      i,
      o,
      a,
      s,
      u = "error" === e;
    if (a = this._events) u = u && null == a.error;else if (!u) return !1;
    if (s = this.domain, u) {
      if (t = arguments[1], !s) {
        if (t instanceof Error) throw t;
        var c = new Error('Uncaught, unspecified "error" event. (' + t + ")");
        throw c.context = t, c;
      }
      return t || (t = new Error('Uncaught, unspecified "error" event')), t.domainEmitter = this, t.domain = s, t.domainThrown = !1, s.emit("error", t), !1;
    }
    if (!(n = a[e])) return !1;
    var l = "function" == typeof n;
    switch (r = arguments.length) {
      case 1:
        !function (e, t, n) {
          if (t) e.call(n);else for (var r = e.length, i = tt(e, r), o = 0; o < r; ++o) i[o].call(n);
        }(n, l, this);
        break;
      case 2:
        !function (e, t, n, r) {
          if (t) e.call(n, r);else for (var i = e.length, o = tt(e, i), a = 0; a < i; ++a) o[a].call(n, r);
        }(n, l, this, arguments[1]);
        break;
      case 3:
        !function (e, t, n, r, i) {
          if (t) e.call(n, r, i);else for (var o = e.length, a = tt(e, o), s = 0; s < o; ++s) a[s].call(n, r, i);
        }(n, l, this, arguments[1], arguments[2]);
        break;
      case 4:
        !function (e, t, n, r, i, o) {
          if (t) e.call(n, r, i, o);else for (var a = e.length, s = tt(e, a), u = 0; u < a; ++u) s[u].call(n, r, i, o);
        }(n, l, this, arguments[1], arguments[2], arguments[3]);
        break;
      default:
        for (i = new Array(r - 1), o = 1; o < r; o++) i[o - 1] = arguments[o];
        !function (e, t, n, r) {
          if (t) e.apply(n, r);else for (var i = e.length, o = tt(e, i), a = 0; a < i; ++a) o[a].apply(n, r);
        }(n, l, this, i);
    }
    return !0;
  }, Qe.prototype.addListener = function (e, t) {
    return Je(this, e, t, !1);
  }, Qe.prototype.on = Qe.prototype.addListener, Qe.prototype.prependListener = function (e, t) {
    return Je(this, e, t, !0);
  }, Qe.prototype.once = function (e, t) {
    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
    return this.on(e, Xe(this, e, t)), this;
  }, Qe.prototype.prependOnceListener = function (e, t) {
    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
    return this.prependListener(e, Xe(this, e, t)), this;
  }, Qe.prototype.removeListener = function (e, t) {
    var n, r, i, o, a;
    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
    if (!(r = this._events)) return this;
    if (!(n = r[e])) return this;
    if (n === t || n.listener && n.listener === t) 0 == --this._eventsCount ? this._events = new Ge() : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
      for (i = -1, o = n.length; o-- > 0;) if (n[o] === t || n[o].listener && n[o].listener === t) {
        a = n[o].listener, i = o;
        break;
      }
      if (i < 0) return this;
      if (1 === n.length) {
        if (n[0] = void 0, 0 == --this._eventsCount) return this._events = new Ge(), this;
        delete r[e];
      } else !function (e, t) {
        for (var n = t, r = n + 1, i = e.length; r < i; n += 1, r += 1) e[n] = e[r];
        e.pop();
      }(n, i);
      r.removeListener && this.emit("removeListener", e, a || t);
    }
    return this;
  }, Qe.prototype.removeAllListeners = function (e) {
    var t, n;
    if (!(n = this._events)) return this;
    if (!n.removeListener) return 0 === arguments.length ? (this._events = new Ge(), this._eventsCount = 0) : n[e] && (0 == --this._eventsCount ? this._events = new Ge() : delete n[e]), this;
    if (0 === arguments.length) {
      for (var r, i = Object.keys(n), o = 0; o < i.length; ++o) "removeListener" !== (r = i[o]) && this.removeAllListeners(r);
      return this.removeAllListeners("removeListener"), this._events = new Ge(), this._eventsCount = 0, this;
    }
    if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (t) do {
      this.removeListener(e, t[t.length - 1]);
    } while (t[0]);
    return this;
  }, Qe.prototype.listeners = function (e) {
    var t,
      n,
      r = this._events;
    return n = r && (t = r[e]) ? "function" == typeof t ? [t.listener || t] : function (e) {
      for (var t = new Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
      return t;
    }(t) : [], n;
  }, Qe.listenerCount = function (e, t) {
    return "function" == typeof e.listenerCount ? e.listenerCount(t) : et.call(e, t);
  }, Qe.prototype.listenerCount = et, Qe.prototype.eventNames = function () {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };
  var nt = i(Object.freeze({
      __proto__: null,
      EventEmitter: Qe,
      default: Qe
    })),
    rt = nt.EventEmitter,
    it = "function" == typeof Object.create ? function (e, t) {
      e.super_ = t, e.prototype = Object.create(t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : function (e, t) {
      e.super_ = t;
      var n = function () {};
      n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
    },
    ot = /%[sdj%]/g;
  function at(e) {
    if (!_t(e)) {
      for (var t = [], n = 0; n < arguments.length; n++) t.push(dt(arguments[n]));
      return t.join(" ");
    }
    n = 1;
    for (var r = arguments, i = r.length, o = String(e).replace(ot, function (e) {
        if ("%%" === e) return "%";
        if (n >= i) return e;
        switch (e) {
          case "%s":
            return String(r[n++]);
          case "%d":
            return Number(r[n++]);
          case "%j":
            try {
              return JSON.stringify(r[n++]);
            } catch (e) {
              return "[Circular]";
            }
          default:
            return e;
        }
      }), a = r[n]; n < i; a = r[++n]) yt(a) || !Mt(a) ? o += " " + a : o += " " + dt(a);
    return o;
  }
  function st(e, n) {
    if (St(t.process)) return function () {
      return st(e, n).apply(this, arguments);
    };
    if (!0 === Be.noDeprecation) return e;
    var r = !1;
    return function () {
      if (!r) {
        if (Be.throwDeprecation) throw new Error(n);
        Be.traceDeprecation ? console.trace(n) : console.error(n), r = !0;
      }
      return e.apply(this, arguments);
    };
  }
  var ut,
    ct = {};
  function lt(e) {
    if (St(ut) && (ut = Be.env.NODE_DEBUG || ""), e = e.toUpperCase(), !ct[e]) if (new RegExp("\\b" + e + "\\b", "i").test(ut)) {
      ct[e] = function () {
        var t = at.apply(null, arguments);
        console.error("%s %d: %s", e, 0, t);
      };
    } else ct[e] = function () {};
    return ct[e];
  }
  function dt(e, t) {
    var n = {
      seen: [],
      stylize: ht
    };
    return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), bt(t) ? n.showHidden = t : t && Dt(n, t), St(n.showHidden) && (n.showHidden = !1), St(n.depth) && (n.depth = 2), St(n.colors) && (n.colors = !1), St(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = ft), pt(n, e, n.depth);
  }
  function ft(e, t) {
    var n = dt.styles[t];
    return n ? "[" + dt.colors[n][0] + "m" + e + "[" + dt.colors[n][1] + "m" : e;
  }
  function ht(e, t) {
    return e;
  }
  function pt(e, t, n) {
    if (e.customInspect && t && Rt(t.inspect) && t.inspect !== dt && (!t.constructor || t.constructor.prototype !== t)) {
      var r = t.inspect(n, e);
      return _t(r) || (r = pt(e, r, n)), r;
    }
    var i = function (e, t) {
      if (St(t)) return e.stylize("undefined", "undefined");
      if (_t(t)) {
        var n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return e.stylize(n, "string");
      }
      if (At(t)) return e.stylize("" + t, "number");
      if (bt(t)) return e.stylize("" + t, "boolean");
      if (yt(t)) return e.stylize("null", "null");
    }(e, t);
    if (i) return i;
    var o = Object.keys(t),
      a = function (e) {
        var t = {};
        return e.forEach(function (e, n) {
          t[e] = !0;
        }), t;
      }(o);
    if (e.showHidden && (o = Object.getOwnPropertyNames(t)), xt(t) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return mt(t);
    if (0 === o.length) {
      if (Rt(t)) {
        var s = t.name ? ": " + t.name : "";
        return e.stylize("[Function" + s + "]", "special");
      }
      if (kt(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
      if (Ct(t)) return e.stylize(Date.prototype.toString.call(t), "date");
      if (xt(t)) return mt(t);
    }
    var u,
      c = "",
      l = !1,
      d = ["{", "}"];
    (vt(t) && (l = !0, d = ["[", "]"]), Rt(t)) && (c = " [Function" + (t.name ? ": " + t.name : "") + "]");
    return kt(t) && (c = " " + RegExp.prototype.toString.call(t)), Ct(t) && (c = " " + Date.prototype.toUTCString.call(t)), xt(t) && (c = " " + mt(t)), 0 !== o.length || l && 0 != t.length ? n < 0 ? kt(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), u = l ? function (e, t, n, r, i) {
      for (var o = [], a = 0, s = t.length; a < s; ++a) Bt(t, String(a)) ? o.push(gt(e, t, n, r, String(a), !0)) : o.push("");
      return i.forEach(function (i) {
        i.match(/^\d+$/) || o.push(gt(e, t, n, r, i, !0));
      }), o;
    }(e, t, n, a, o) : o.map(function (r) {
      return gt(e, t, n, a, r, l);
    }), e.seen.pop(), function (e, t, n) {
      var r = e.reduce(function (e, t) {
        return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      if (r > 60) return n[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + n[1];
      return n[0] + t + " " + e.join(", ") + " " + n[1];
    }(u, c, d)) : d[0] + c + d[1];
  }
  function mt(e) {
    return "[" + Error.prototype.toString.call(e) + "]";
  }
  function gt(e, t, n, r, i, o) {
    var a, s, u;
    if ((u = Object.getOwnPropertyDescriptor(t, i) || {
      value: t[i]
    }).get ? s = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (s = e.stylize("[Setter]", "special")), Bt(r, i) || (a = "[" + i + "]"), s || (e.seen.indexOf(u.value) < 0 ? (s = yt(n) ? pt(e, u.value, null) : pt(e, u.value, n - 1)).indexOf("\n") > -1 && (s = o ? s.split("\n").map(function (e) {
      return "  " + e;
    }).join("\n").substr(2) : "\n" + s.split("\n").map(function (e) {
      return "   " + e;
    }).join("\n")) : s = e.stylize("[Circular]", "special")), St(a)) {
      if (o && i.match(/^\d+$/)) return s;
      (a = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
    }
    return a + ": " + s;
  }
  function vt(e) {
    return Array.isArray(e);
  }
  function bt(e) {
    return "boolean" == typeof e;
  }
  function yt(e) {
    return null === e;
  }
  function wt(e) {
    return null == e;
  }
  function At(e) {
    return "number" == typeof e;
  }
  function _t(e) {
    return "string" == typeof e;
  }
  function Et(e) {
    return "symbol" == typeof e;
  }
  function St(e) {
    return void 0 === e;
  }
  function kt(e) {
    return Mt(e) && "[object RegExp]" === Pt(e);
  }
  function Mt(e) {
    return "object" == typeof e && null !== e;
  }
  function Ct(e) {
    return Mt(e) && "[object Date]" === Pt(e);
  }
  function xt(e) {
    return Mt(e) && ("[object Error]" === Pt(e) || e instanceof Error);
  }
  function Rt(e) {
    return "function" == typeof e;
  }
  function It(e) {
    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
  }
  function Tt(e) {
    return ie(e);
  }
  function Pt(e) {
    return Object.prototype.toString.call(e);
  }
  function Ot(e) {
    return e < 10 ? "0" + e.toString(10) : e.toString(10);
  }
  dt.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, dt.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    regexp: "red"
  };
  var Lt = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  function Nt() {
    console.log("%s - %s", function () {
      var e = new Date(),
        t = [Ot(e.getHours()), Ot(e.getMinutes()), Ot(e.getSeconds())].join(":");
      return [e.getDate(), Lt[e.getMonth()], t].join(" ");
    }(), at.apply(null, arguments));
  }
  function Dt(e, t) {
    if (!t || !Mt(t)) return e;
    for (var n = Object.keys(t), r = n.length; r--;) e[n[r]] = t[n[r]];
    return e;
  }
  function Bt(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }
  var jt,
    Ft,
    zt = {
      inherits: it,
      _extend: Dt,
      log: Nt,
      isBuffer: Tt,
      isPrimitive: It,
      isFunction: Rt,
      isError: xt,
      isDate: Ct,
      isObject: Mt,
      isRegExp: kt,
      isUndefined: St,
      isSymbol: Et,
      isString: _t,
      isNumber: At,
      isNullOrUndefined: wt,
      isNull: yt,
      isBoolean: bt,
      isArray: vt,
      inspect: dt,
      deprecate: st,
      format: at,
      debuglog: lt
    },
    Ut = i(Object.freeze({
      __proto__: null,
      _extend: Dt,
      debuglog: lt,
      default: zt,
      deprecate: st,
      format: at,
      inherits: it,
      inspect: dt,
      isArray: vt,
      isBoolean: bt,
      isBuffer: Tt,
      isDate: Ct,
      isError: xt,
      isFunction: Rt,
      isNull: yt,
      isNullOrUndefined: wt,
      isNumber: At,
      isObject: Mt,
      isPrimitive: It,
      isRegExp: kt,
      isString: _t,
      isSymbol: Et,
      isUndefined: St,
      log: Nt
    }));
  function qt() {
    if (Ft) return jt;
    function e(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function t(t) {
      for (var r = 1; r < arguments.length; r++) {
        var i = null != arguments[r] ? arguments[r] : {};
        r % 2 ? e(Object(i), !0).forEach(function (e) {
          n(t, e, i[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : e(Object(i)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
        });
      }
      return t;
    }
    function n(e, t, n) {
      return (t = i(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function r(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, i(r.key), r);
      }
    }
    function i(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var r = n.call(e, t || "default");
          if ("object" != typeof r) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(e);
      }(e, "string");
      return "symbol" == typeof t ? t : String(t);
    }
    Ft = 1;
    var o = le.Buffer,
      a = Ut.inspect,
      s = a && a.custom || "inspect";
    return jt = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.head = null, this.tail = null, this.length = 0;
      }
      var n, i, u;
      return n = e, i = [{
        key: "push",
        value: function (e) {
          var t = {
            data: e,
            next: null
          };
          this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
        }
      }, {
        key: "unshift",
        value: function (e) {
          var t = {
            data: e,
            next: this.head
          };
          0 === this.length && (this.tail = t), this.head = t, ++this.length;
        }
      }, {
        key: "shift",
        value: function () {
          if (0 !== this.length) {
            var e = this.head.data;
            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
          }
        }
      }, {
        key: "clear",
        value: function () {
          this.head = this.tail = null, this.length = 0;
        }
      }, {
        key: "join",
        value: function (e) {
          if (0 === this.length) return "";
          for (var t = this.head, n = "" + t.data; t = t.next;) n += e + t.data;
          return n;
        }
      }, {
        key: "concat",
        value: function (e) {
          if (0 === this.length) return o.alloc(0);
          for (var t, n, r, i = o.allocUnsafe(e >>> 0), a = this.head, s = 0; a;) t = a.data, n = i, r = s, o.prototype.copy.call(t, n, r), s += a.data.length, a = a.next;
          return i;
        }
      }, {
        key: "consume",
        value: function (e, t) {
          var n;
          return e < this.head.data.length ? (n = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : n = e === this.head.data.length ? this.shift() : t ? this._getString(e) : this._getBuffer(e), n;
        }
      }, {
        key: "first",
        value: function () {
          return this.head.data;
        }
      }, {
        key: "_getString",
        value: function (e) {
          var t = this.head,
            n = 1,
            r = t.data;
          for (e -= r.length; t = t.next;) {
            var i = t.data,
              o = e > i.length ? i.length : e;
            if (o === i.length ? r += i : r += i.slice(0, e), 0 == (e -= o)) {
              o === i.length ? (++n, t.next ? this.head = t.next : this.head = this.tail = null) : (this.head = t, t.data = i.slice(o));
              break;
            }
            ++n;
          }
          return this.length -= n, r;
        }
      }, {
        key: "_getBuffer",
        value: function (e) {
          var t = o.allocUnsafe(e),
            n = this.head,
            r = 1;
          for (n.data.copy(t), e -= n.data.length; n = n.next;) {
            var i = n.data,
              a = e > i.length ? i.length : e;
            if (i.copy(t, t.length - e, 0, a), 0 == (e -= a)) {
              a === i.length ? (++r, n.next ? this.head = n.next : this.head = this.tail = null) : (this.head = n, n.data = i.slice(a));
              break;
            }
            ++r;
          }
          return this.length -= r, t;
        }
      }, {
        key: s,
        value: function (e, n) {
          return a(this, t(t({}, n), {}, {
            depth: 0,
            customInspect: !1
          }));
        }
      }], i && r(n.prototype, i), u && r(n, u), Object.defineProperty(n, "prototype", {
        writable: !1
      }), e;
    }(), jt;
  }
  function Kt(e, t) {
    Vt(e, t), Ht(e);
  }
  function Ht(e) {
    e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
  }
  function Vt(e, t) {
    e.emit("error", t);
  }
  var $t = {
      destroy: function (e, t) {
        var n = this,
          r = this._readableState && this._readableState.destroyed,
          i = this._writableState && this._writableState.destroyed;
        return r || i ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, Ee(Vt, this, e)) : Ee(Vt, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function (e) {
          !t && e ? n._writableState ? n._writableState.errorEmitted ? Ee(Ht, n) : (n._writableState.errorEmitted = !0, Ee(Kt, n, e)) : Ee(Kt, n, e) : t ? (Ee(Ht, n), t(e)) : Ee(Ht, n);
        }), this);
      },
      undestroy: function () {
        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
      },
      errorOrDestroy: function (e, t) {
        var n = e._readableState,
          r = e._writableState;
        n && n.autoDestroy || r && r.autoDestroy ? e.destroy(t) : e.emit("error", t);
      }
    },
    Wt = {};
  var Yt = {};
  function Gt(e, t, n) {
    n || (n = Error);
    var r = function (e) {
      var n, r;
      function i(n, r, i) {
        return e.call(this, function (e, n, r) {
          return "string" == typeof t ? t : t(e, n, r);
        }(n, r, i)) || this;
      }
      return r = e, (n = i).prototype = Object.create(r.prototype), n.prototype.constructor = n, n.__proto__ = r, i;
    }(n);
    r.prototype.name = n.name, r.prototype.code = e, Yt[e] = r;
  }
  function Qt(e, t) {
    if (Array.isArray(e)) {
      var n = e.length;
      return e = e.map(function (e) {
        return String(e);
      }), n > 2 ? "one of ".concat(t, " ").concat(e.slice(0, n - 1).join(", "), ", or ") + e[n - 1] : 2 === n ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
    }
    return "of ".concat(t, " ").concat(String(e));
  }
  Gt("ERR_INVALID_OPT_VALUE", function (e, t) {
    return 'The value "' + t + '" is invalid for option "' + e + '"';
  }, TypeError), Gt("ERR_INVALID_ARG_TYPE", function (e, t, n) {
    var r, i, o, a;
    if ("string" == typeof t && (i = "not ", t.substr(!o || o < 0 ? 0 : +o, i.length) === i) ? (r = "must not be", t = t.replace(/^not /, "")) : r = "must be", function (e, t, n) {
      return (void 0 === n || n > e.length) && (n = e.length), e.substring(n - t.length, n) === t;
    }(e, " argument")) a = "The ".concat(e, " ").concat(r, " ").concat(Qt(t, "type"));else {
      var s = function (e, t, n) {
        return "number" != typeof n && (n = 0), !(n + t.length > e.length) && -1 !== e.indexOf(t, n);
      }(e, ".") ? "property" : "argument";
      a = 'The "'.concat(e, '" ').concat(s, " ").concat(r, " ").concat(Qt(t, "type"));
    }
    return a += ". Received type ".concat(typeof n);
  }, TypeError), Gt("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), Gt("ERR_METHOD_NOT_IMPLEMENTED", function (e) {
    return "The " + e + " method is not implemented";
  }), Gt("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), Gt("ERR_STREAM_DESTROYED", function (e) {
    return "Cannot call " + e + " after a stream was destroyed";
  }), Gt("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), Gt("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), Gt("ERR_STREAM_WRITE_AFTER_END", "write after end"), Gt("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), Gt("ERR_UNKNOWN_ENCODING", function (e) {
    return "Unknown encoding: " + e;
  }, TypeError), Gt("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), Wt.codes = Yt;
  var Zt = Wt.codes.ERR_INVALID_OPT_VALUE;
  var Jt,
    Xt,
    en,
    tn,
    nn = {
      getHighWaterMark: function (e, t, n, r) {
        var i = function (e, t, n) {
          return null != e.highWaterMark ? e.highWaterMark : t ? e[n] : null;
        }(t, r, n);
        if (null != i) {
          if (!isFinite(i) || Math.floor(i) !== i || i < 0) throw new Zt(r ? n : "highWaterMark", i);
          return Math.floor(i);
        }
        return e.objectMode ? 16 : 16384;
      }
    },
    rn = function (e, t) {
      if (on("noDeprecation")) return e;
      var n = !1;
      return function () {
        if (!n) {
          if (on("throwDeprecation")) throw new Error(t);
          on("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
        }
        return e.apply(this, arguments);
      };
    };
  function on(e) {
    try {
      if (!n.localStorage) return !1;
    } catch (e) {
      return !1;
    }
    var t = n.localStorage[e];
    return null != t && "true" === String(t).toLowerCase();
  }
  function an() {
    if (Xt) return Jt;
    function e(e) {
      var t = this;
      this.next = null, this.entry = null, this.finish = function () {
        !function (e, t, n) {
          var r = e.entry;
          e.entry = null;
          for (; r;) {
            var i = r.callback;
            t.pendingcb--, i(n), r = r.next;
          }
          t.corkedRequestsFree.next = e;
        }(t, e);
      };
    }
    var t;
    Xt = 1, Jt = _, _.WritableState = A;
    var r = {
        deprecate: rn
      },
      i = rt,
      o = le.Buffer,
      a = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function () {};
    var s,
      u = $t,
      c = nn.getHighWaterMark,
      l = Wt.codes,
      d = l.ERR_INVALID_ARG_TYPE,
      f = l.ERR_METHOD_NOT_IMPLEMENTED,
      h = l.ERR_MULTIPLE_CALLBACK,
      p = l.ERR_STREAM_CANNOT_PIPE,
      m = l.ERR_STREAM_DESTROYED,
      g = l.ERR_STREAM_NULL_VALUES,
      v = l.ERR_STREAM_WRITE_AFTER_END,
      b = l.ERR_UNKNOWN_ENCODING,
      y = u.errorOrDestroy;
    function w() {}
    function A(n, r, i) {
      t = t || sn(), n = n || {}, "boolean" != typeof i && (i = r instanceof t), this.objectMode = !!n.objectMode, i && (this.objectMode = this.objectMode || !!n.writableObjectMode), this.highWaterMark = c(this, n, "writableHighWaterMark", i), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
      var o = !1 === n.decodeStrings;
      this.decodeStrings = !o, this.defaultEncoding = n.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
        !function (e, t) {
          var n = e._writableState,
            r = n.sync,
            i = n.writecb;
          if ("function" != typeof i) throw new h();
          if (function (e) {
            e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
          }(n), t) !function (e, t, n, r, i) {
            --t.pendingcb, n ? (Ee(i, r), Ee(x, e, t), e._writableState.errorEmitted = !0, y(e, r)) : (i(r), e._writableState.errorEmitted = !0, y(e, r), x(e, t));
          }(e, n, r, t, i);else {
            var o = M(n) || e.destroyed;
            o || n.corked || n.bufferProcessing || !n.bufferedRequest || k(e, n), r ? Ee(S, e, n, o, i) : S(e, n, o, i);
          }
        }(r, e);
      }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== n.emitClose, this.autoDestroy = !!n.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
    }
    function _(e) {
      var n = this instanceof (t = t || sn());
      if (!n && !s.call(_, this)) return new _(e);
      this._writableState = new A(e, this, n), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), i.call(this);
    }
    function E(e, t, n, r, i, o, a) {
      t.writelen = r, t.writecb = a, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new m("write")) : n ? e._writev(i, t.onwrite) : e._write(i, o, t.onwrite), t.sync = !1;
    }
    function S(e, t, n, r) {
      n || function (e, t) {
        0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
      }(e, t), t.pendingcb--, r(), x(e, t);
    }
    function k(t, n) {
      n.bufferProcessing = !0;
      var r = n.bufferedRequest;
      if (t._writev && r && r.next) {
        var i = n.bufferedRequestCount,
          o = new Array(i),
          a = n.corkedRequestsFree;
        a.entry = r;
        for (var s = 0, u = !0; r;) o[s] = r, r.isBuf || (u = !1), r = r.next, s += 1;
        o.allBuffers = u, E(t, n, !0, n.length, o, "", a.finish), n.pendingcb++, n.lastBufferedRequest = null, a.next ? (n.corkedRequestsFree = a.next, a.next = null) : n.corkedRequestsFree = new e(n), n.bufferedRequestCount = 0;
      } else {
        for (; r;) {
          var c = r.chunk,
            l = r.encoding,
            d = r.callback;
          if (E(t, n, !1, n.objectMode ? 1 : c.length, c, l, d), r = r.next, n.bufferedRequestCount--, n.writing) break;
        }
        null === r && (n.lastBufferedRequest = null);
      }
      n.bufferedRequest = r, n.bufferProcessing = !1;
    }
    function M(e) {
      return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
    }
    function C(e, t) {
      e._final(function (n) {
        t.pendingcb--, n && y(e, n), t.prefinished = !0, e.emit("prefinish"), x(e, t);
      });
    }
    function x(e, t) {
      var n = M(t);
      if (n && (function (e, t) {
        t.prefinished || t.finalCalled || ("function" != typeof e._final || t.destroyed ? (t.prefinished = !0, e.emit("prefinish")) : (t.pendingcb++, t.finalCalled = !0, Ee(C, e, t)));
      }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
        var r = e._readableState;
        (!r || r.autoDestroy && r.endEmitted) && e.destroy();
      }
      return n;
    }
    return We(_, i), A.prototype.getBuffer = function () {
      for (var e = this.bufferedRequest, t = []; e;) t.push(e), e = e.next;
      return t;
    }, function () {
      try {
        Object.defineProperty(A.prototype, "buffer", {
          get: r.deprecate(function () {
            return this.getBuffer();
          }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
      } catch (e) {}
    }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (s = Function.prototype[Symbol.hasInstance], Object.defineProperty(_, Symbol.hasInstance, {
      value: function (e) {
        return !!s.call(this, e) || this === _ && e && e._writableState instanceof A;
      }
    })) : s = function (e) {
      return e instanceof this;
    }, _.prototype.pipe = function () {
      y(this, new p());
    }, _.prototype.write = function (e, t, n) {
      var r,
        i = this._writableState,
        s = !1,
        u = !i.objectMode && (r = e, o.isBuffer(r) || r instanceof a);
      return u && !o.isBuffer(e) && (e = function (e) {
        return o.from(e);
      }(e)), "function" == typeof t && (n = t, t = null), u ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof n && (n = w), i.ending ? function (e, t) {
        var n = new v();
        y(e, n), Ee(t, n);
      }(this, n) : (u || function (e, t, n, r) {
        var i;
        return null === n ? i = new g() : "string" == typeof n || t.objectMode || (i = new d("chunk", ["string", "Buffer"], n)), !i || (y(e, i), Ee(r, i), !1);
      }(this, i, e, n)) && (i.pendingcb++, s = function (e, t, n, r, i, a) {
        if (!n) {
          var s = function (e, t, n) {
            e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = o.from(t, n));
            return t;
          }(t, r, i);
          r !== s && (n = !0, i = "buffer", r = s);
        }
        var u = t.objectMode ? 1 : r.length;
        t.length += u;
        var c = t.length < t.highWaterMark;
        c || (t.needDrain = !0);
        if (t.writing || t.corked) {
          var l = t.lastBufferedRequest;
          t.lastBufferedRequest = {
            chunk: r,
            encoding: i,
            isBuf: n,
            callback: a,
            next: null
          }, l ? l.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
        } else E(e, t, !1, u, r, i, a);
        return c;
      }(this, i, u, e, t, n)), s;
    }, _.prototype.cork = function () {
      this._writableState.corked++;
    }, _.prototype.uncork = function () {
      var e = this._writableState;
      e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || k(this, e));
    }, _.prototype.setDefaultEncoding = function (e) {
      if ("string" == typeof e && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new b(e);
      return this._writableState.defaultEncoding = e, this;
    }, Object.defineProperty(_.prototype, "writableBuffer", {
      enumerable: !1,
      get: function () {
        return this._writableState && this._writableState.getBuffer();
      }
    }), Object.defineProperty(_.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function () {
        return this._writableState.highWaterMark;
      }
    }), _.prototype._write = function (e, t, n) {
      n(new f("_write()"));
    }, _.prototype._writev = null, _.prototype.end = function (e, t, n) {
      var r = this._writableState;
      return "function" == typeof e ? (n = e, e = null, t = null) : "function" == typeof t && (n = t, t = null), null != e && this.write(e, t), r.corked && (r.corked = 1, this.uncork()), r.ending || function (e, t, n) {
        t.ending = !0, x(e, t), n && (t.finished ? Ee(n) : e.once("finish", n));
        t.ended = !0, e.writable = !1;
      }(this, r, n), this;
    }, Object.defineProperty(_.prototype, "writableLength", {
      enumerable: !1,
      get: function () {
        return this._writableState.length;
      }
    }), Object.defineProperty(_.prototype, "destroyed", {
      enumerable: !1,
      get: function () {
        return void 0 !== this._writableState && this._writableState.destroyed;
      },
      set: function (e) {
        this._writableState && (this._writableState.destroyed = e);
      }
    }), _.prototype.destroy = u.destroy, _.prototype._undestroy = u.undestroy, _.prototype._destroy = function (e, t) {
      t(e);
    }, Jt;
  }
  function sn() {
    if (tn) return en;
    tn = 1;
    var e = Object.keys || function (e) {
      var t = [];
      for (var n in e) t.push(n);
      return t;
    };
    en = a;
    var t = An(),
      n = an();
    We(a, t);
    for (var r = e(n.prototype), i = 0; i < r.length; i++) {
      var o = r[i];
      a.prototype[o] || (a.prototype[o] = n.prototype[o]);
    }
    function a(e) {
      if (!(this instanceof a)) return new a(e);
      t.call(this, e), n.call(this, e), this.allowHalfOpen = !0, e && (!1 === e.readable && (this.readable = !1), !1 === e.writable && (this.writable = !1), !1 === e.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", s)));
    }
    function s() {
      this._writableState.ended || Ee(u, this);
    }
    function u(e) {
      e.end();
    }
    return Object.defineProperty(a.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function () {
        return this._writableState.highWaterMark;
      }
    }), Object.defineProperty(a.prototype, "writableBuffer", {
      enumerable: !1,
      get: function () {
        return this._writableState && this._writableState.getBuffer();
      }
    }), Object.defineProperty(a.prototype, "writableLength", {
      enumerable: !1,
      get: function () {
        return this._writableState.length;
      }
    }), Object.defineProperty(a.prototype, "destroyed", {
      enumerable: !1,
      get: function () {
        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function (e) {
        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
      }
    }), en;
  }
  var un,
    cn = {};
  function ln() {
    if (un) return cn;
    un = 1;
    var e = ze().Buffer,
      t = e.isEncoding || function (e) {
        switch ((e = "" + e) && e.toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;
          default:
            return !1;
        }
      };
    function n(n) {
      var r;
      switch (this.encoding = function (n) {
        var r = function (e) {
          if (!e) return "utf8";
          for (var t;;) switch (e) {
            case "utf8":
            case "utf-8":
              return "utf8";
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return "utf16le";
            case "latin1":
            case "binary":
              return "latin1";
            case "base64":
            case "ascii":
            case "hex":
              return e;
            default:
              if (t) return;
              e = ("" + e).toLowerCase(), t = !0;
          }
        }(n);
        if ("string" != typeof r && (e.isEncoding === t || !t(n))) throw new Error("Unknown encoding: " + n);
        return r || n;
      }(n), this.encoding) {
        case "utf16le":
          this.text = o, this.end = a, r = 4;
          break;
        case "utf8":
          this.fillLast = i, r = 4;
          break;
        case "base64":
          this.text = s, this.end = u, r = 3;
          break;
        default:
          return this.write = c, void (this.end = l);
      }
      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(r);
    }
    function r(e) {
      return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
    }
    function i(e) {
      var t = this.lastTotal - this.lastNeed,
        n = function (e, t, n) {
          if (128 != (192 & t[0])) return e.lastNeed = 0, "�";
          if (e.lastNeed > 1 && t.length > 1) {
            if (128 != (192 & t[1])) return e.lastNeed = 1, "�";
            if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "�";
          }
        }(this, e);
      return void 0 !== n ? n : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
    }
    function o(e, t) {
      if ((e.length - t) % 2 == 0) {
        var n = e.toString("utf16le", t);
        if (n) {
          var r = n.charCodeAt(n.length - 1);
          if (r >= 55296 && r <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], n.slice(0, -1);
        }
        return n;
      }
      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
    }
    function a(e) {
      var t = e && e.length ? this.write(e) : "";
      if (this.lastNeed) {
        var n = this.lastTotal - this.lastNeed;
        return t + this.lastChar.toString("utf16le", 0, n);
      }
      return t;
    }
    function s(e, t) {
      var n = (e.length - t) % 3;
      return 0 === n ? e.toString("base64", t) : (this.lastNeed = 3 - n, this.lastTotal = 3, 1 === n ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - n));
    }
    function u(e) {
      var t = e && e.length ? this.write(e) : "";
      return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
    }
    function c(e) {
      return e.toString(this.encoding);
    }
    function l(e) {
      return e && e.length ? this.write(e) : "";
    }
    return cn.StringDecoder = n, n.prototype.write = function (e) {
      if (0 === e.length) return "";
      var t, n;
      if (this.lastNeed) {
        if (void 0 === (t = this.fillLast(e))) return "";
        n = this.lastNeed, this.lastNeed = 0;
      } else n = 0;
      return n < e.length ? t ? t + this.text(e, n) : this.text(e, n) : t || "";
    }, n.prototype.end = function (e) {
      var t = e && e.length ? this.write(e) : "";
      return this.lastNeed ? t + "�" : t;
    }, n.prototype.text = function (e, t) {
      var n = function (e, t, n) {
        var i = t.length - 1;
        if (i < n) return 0;
        var o = r(t[i]);
        if (o >= 0) return o > 0 && (e.lastNeed = o - 1), o;
        if (--i < n || -2 === o) return 0;
        if (o = r(t[i]), o >= 0) return o > 0 && (e.lastNeed = o - 2), o;
        if (--i < n || -2 === o) return 0;
        if (o = r(t[i]), o >= 0) return o > 0 && (2 === o ? o = 0 : e.lastNeed = o - 3), o;
        return 0;
      }(this, e, t);
      if (!this.lastNeed) return e.toString("utf8", t);
      this.lastTotal = n;
      var i = e.length - (n - this.lastNeed);
      return e.copy(this.lastChar, 0, i), e.toString("utf8", t, i);
    }, n.prototype.fillLast = function (e) {
      if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
    }, cn;
  }
  var dn = Wt.codes.ERR_STREAM_PREMATURE_CLOSE;
  function fn() {}
  var hn,
    pn,
    mn,
    gn,
    vn,
    bn,
    yn = function e(t, n, r) {
      if ("function" == typeof n) return e(t, null, n);
      n || (n = {}), r = function (e) {
        var t = !1;
        return function () {
          if (!t) {
            t = !0;
            for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
            e.apply(this, r);
          }
        };
      }(r || fn);
      var i = n.readable || !1 !== n.readable && t.readable,
        o = n.writable || !1 !== n.writable && t.writable,
        a = function () {
          t.writable || u();
        },
        s = t._writableState && t._writableState.finished,
        u = function () {
          o = !1, s = !0, i || r.call(t);
        },
        c = t._readableState && t._readableState.endEmitted,
        l = function () {
          i = !1, c = !0, o || r.call(t);
        },
        d = function (e) {
          r.call(t, e);
        },
        f = function () {
          var e;
          return i && !c ? (t._readableState && t._readableState.ended || (e = new dn()), r.call(t, e)) : o && !s ? (t._writableState && t._writableState.ended || (e = new dn()), r.call(t, e)) : void 0;
        },
        h = function () {
          t.req.on("finish", u);
        };
      return !function (e) {
        return e.setHeader && "function" == typeof e.abort;
      }(t) ? o && !t._writableState && (t.on("end", a), t.on("close", a)) : (t.on("complete", u), t.on("abort", f), t.req ? h() : t.on("request", h)), t.on("end", l), t.on("finish", u), !1 !== n.error && t.on("error", d), t.on("close", f), function () {
        t.removeListener("complete", u), t.removeListener("abort", f), t.removeListener("request", h), t.req && t.req.removeListener("finish", u), t.removeListener("end", a), t.removeListener("close", a), t.removeListener("finish", u), t.removeListener("end", l), t.removeListener("error", d), t.removeListener("close", f);
      };
    };
  function wn() {
    if (pn) return hn;
    var e;
    function t(e, t, n) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var r = n.call(e, t || "default");
            if ("object" != typeof r) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : String(t);
      }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    pn = 1;
    var n = yn,
      r = Symbol("lastResolve"),
      i = Symbol("lastReject"),
      o = Symbol("error"),
      a = Symbol("ended"),
      s = Symbol("lastPromise"),
      u = Symbol("handlePromise"),
      c = Symbol("stream");
    function l(e, t) {
      return {
        value: e,
        done: t
      };
    }
    function d(e) {
      var t = e[r];
      if (null !== t) {
        var n = e[c].read();
        null !== n && (e[s] = null, e[r] = null, e[i] = null, t(l(n, !1)));
      }
    }
    function f(e) {
      Ee(d, e);
    }
    var h = Object.getPrototypeOf(function () {}),
      p = Object.setPrototypeOf((t(e = {
        get stream() {
          return this[c];
        },
        next: function () {
          var e = this,
            t = this[o];
          if (null !== t) return Promise.reject(t);
          if (this[a]) return Promise.resolve(l(void 0, !0));
          if (this[c].destroyed) return new Promise(function (t, n) {
            Ee(function () {
              e[o] ? n(e[o]) : t(l(void 0, !0));
            });
          });
          var n,
            r = this[s];
          if (r) n = new Promise(function (e, t) {
            return function (n, r) {
              e.then(function () {
                t[a] ? n(l(void 0, !0)) : t[u](n, r);
              }, r);
            };
          }(r, this));else {
            var i = this[c].read();
            if (null !== i) return Promise.resolve(l(i, !1));
            n = new Promise(this[u]);
          }
          return this[s] = n, n;
        }
      }, Symbol.asyncIterator, function () {
        return this;
      }), t(e, "return", function () {
        var e = this;
        return new Promise(function (t, n) {
          e[c].destroy(null, function (e) {
            e ? n(e) : t(l(void 0, !0));
          });
        });
      }), e), h);
    return hn = function (e) {
      var d,
        h = Object.create(p, (t(d = {}, c, {
          value: e,
          writable: !0
        }), t(d, r, {
          value: null,
          writable: !0
        }), t(d, i, {
          value: null,
          writable: !0
        }), t(d, o, {
          value: null,
          writable: !0
        }), t(d, a, {
          value: e._readableState.endEmitted,
          writable: !0
        }), t(d, u, {
          value: function (e, t) {
            var n = h[c].read();
            n ? (h[s] = null, h[r] = null, h[i] = null, e(l(n, !1))) : (h[r] = e, h[i] = t);
          },
          writable: !0
        }), d));
      return h[s] = null, n(e, function (e) {
        if (e && "ERR_STREAM_PREMATURE_CLOSE" !== e.code) {
          var t = h[i];
          return null !== t && (h[s] = null, h[r] = null, h[i] = null, t(e)), void (h[o] = e);
        }
        var n = h[r];
        null !== n && (h[s] = null, h[r] = null, h[i] = null, n(l(void 0, !0))), h[a] = !0;
      }), e.on("readable", f.bind(null, h)), h;
    }, hn;
  }
  function An() {
    if (bn) return vn;
    var e;
    bn = 1, vn = _, _.ReadableState = A, nt.EventEmitter;
    var t = function (e, t) {
        return e.listeners(t).length;
      },
      r = rt,
      i = le.Buffer,
      o = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function () {};
    var a,
      s = Ut;
    a = s && s.debuglog ? s.debuglog("stream") : function () {};
    var u,
      c,
      l,
      d = qt(),
      f = $t,
      h = nn.getHighWaterMark,
      p = Wt.codes,
      m = p.ERR_INVALID_ARG_TYPE,
      g = p.ERR_STREAM_PUSH_AFTER_EOF,
      v = p.ERR_METHOD_NOT_IMPLEMENTED,
      b = p.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
    We(_, r);
    var y = f.errorOrDestroy,
      w = ["error", "close", "destroy", "pause", "resume"];
    function A(t, n, r) {
      e = e || sn(), t = t || {}, "boolean" != typeof r && (r = n instanceof e), this.objectMode = !!t.objectMode, r && (this.objectMode = this.objectMode || !!t.readableObjectMode), this.highWaterMark = h(this, t, "readableHighWaterMark", r), this.buffer = new d(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (u || (u = ln().StringDecoder), this.decoder = new u(t.encoding), this.encoding = t.encoding);
    }
    function _(t) {
      if (e = e || sn(), !(this instanceof _)) return new _(t);
      var n = this instanceof e;
      this._readableState = new A(t, this, n), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), r.call(this);
    }
    function E(e, t, n, r, s) {
      a("readableAddChunk", t);
      var u,
        c = e._readableState;
      if (null === t) c.reading = !1, function (e, t) {
        if (a("onEofChunk"), t.ended) return;
        if (t.decoder) {
          var n = t.decoder.end();
          n && n.length && (t.buffer.push(n), t.length += t.objectMode ? 1 : n.length);
        }
        t.ended = !0, t.sync ? C(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, x(e)));
      }(e, c);else if (s || (u = function (e, t) {
        var n;
        r = t, i.isBuffer(r) || r instanceof o || "string" == typeof t || void 0 === t || e.objectMode || (n = new m("chunk", ["string", "Buffer", "Uint8Array"], t));
        var r;
        return n;
      }(c, t)), u) y(e, u);else if (c.objectMode || t && t.length > 0) {
        if ("string" == typeof t || c.objectMode || Object.getPrototypeOf(t) === i.prototype || (t = function (e) {
          return i.from(e);
        }(t)), r) c.endEmitted ? y(e, new b()) : S(e, c, t, !0);else if (c.ended) y(e, new g());else {
          if (c.destroyed) return !1;
          c.reading = !1, c.decoder && !n ? (t = c.decoder.write(t), c.objectMode || 0 !== t.length ? S(e, c, t, !1) : R(e, c)) : S(e, c, t, !1);
        }
      } else r || (c.reading = !1, R(e, c));
      return !c.ended && (c.length < c.highWaterMark || 0 === c.length);
    }
    function S(e, t, n, r) {
      t.flowing && 0 === t.length && !t.sync ? (t.awaitDrain = 0, e.emit("data", n)) : (t.length += t.objectMode ? 1 : n.length, r ? t.buffer.unshift(n) : t.buffer.push(n), t.needReadable && C(e)), R(e, t);
    }
    Object.defineProperty(_.prototype, "destroyed", {
      enumerable: !1,
      get: function () {
        return void 0 !== this._readableState && this._readableState.destroyed;
      },
      set: function (e) {
        this._readableState && (this._readableState.destroyed = e);
      }
    }), _.prototype.destroy = f.destroy, _.prototype._undestroy = f.undestroy, _.prototype._destroy = function (e, t) {
      t(e);
    }, _.prototype.push = function (e, t) {
      var n,
        r = this._readableState;
      return r.objectMode ? n = !0 : "string" == typeof e && ((t = t || r.defaultEncoding) !== r.encoding && (e = i.from(e, t), t = ""), n = !0), E(this, e, t, !1, n);
    }, _.prototype.unshift = function (e) {
      return E(this, e, null, !0, !1);
    }, _.prototype.isPaused = function () {
      return !1 === this._readableState.flowing;
    }, _.prototype.setEncoding = function (e) {
      u || (u = ln().StringDecoder);
      var t = new u(e);
      this._readableState.decoder = t, this._readableState.encoding = this._readableState.decoder.encoding;
      for (var n = this._readableState.buffer.head, r = ""; null !== n;) r += t.write(n.data), n = n.next;
      return this._readableState.buffer.clear(), "" !== r && this._readableState.buffer.push(r), this._readableState.length = r.length, this;
    };
    var k = 1073741824;
    function M(e, t) {
      return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function (e) {
        return e >= k ? e = k : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
      }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
    }
    function C(e) {
      var t = e._readableState;
      a("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (a("emitReadable", t.flowing), t.emittedReadable = !0, Ee(x, e));
    }
    function x(e) {
      var t = e._readableState;
      a("emitReadable_", t.destroyed, t.length, t.ended), t.destroyed || !t.length && !t.ended || (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, L(e);
    }
    function R(e, t) {
      t.readingMore || (t.readingMore = !0, Ee(I, e, t));
    }
    function I(e, t) {
      for (; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && 0 === t.length);) {
        var n = t.length;
        if (a("maybeReadMore read 0"), e.read(0), n === t.length) break;
      }
      t.readingMore = !1;
    }
    function T(e) {
      var t = e._readableState;
      t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
    }
    function P(e) {
      a("readable nexttick read 0"), e.read(0);
    }
    function O(e, t) {
      a("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), L(e), t.flowing && !t.reading && e.read(0);
    }
    function L(e) {
      var t = e._readableState;
      for (a("flow", t.flowing); t.flowing && null !== e.read(););
    }
    function N(e, t) {
      return 0 === t.length ? null : (t.objectMode ? n = t.buffer.shift() : !e || e >= t.length ? (n = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : n = t.buffer.consume(e, t.decoder), n);
      var n;
    }
    function D(e) {
      var t = e._readableState;
      a("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, Ee(B, t, e));
    }
    function B(e, t) {
      if (a("endReadableNT", e.endEmitted, e.length), !e.endEmitted && 0 === e.length && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
        var n = t._writableState;
        (!n || n.autoDestroy && n.finished) && t.destroy();
      }
    }
    function j(e, t) {
      for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
      return -1;
    }
    return _.prototype.read = function (e) {
      a("read", e), e = parseInt(e, 10);
      var t = this._readableState,
        n = e;
      if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && ((0 !== t.highWaterMark ? t.length >= t.highWaterMark : t.length > 0) || t.ended)) return a("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? D(this) : C(this), null;
      if (0 === (e = M(e, t)) && t.ended) return 0 === t.length && D(this), null;
      var r,
        i = t.needReadable;
      return a("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && a("length less than watermark", i = !0), t.ended || t.reading ? a("reading or ended", i = !1) : i && (a("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = M(n, t))), null === (r = e > 0 ? N(e, t) : null) ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), 0 === t.length && (t.ended || (t.needReadable = !0), n !== e && t.ended && D(this)), null !== r && this.emit("data", r), r;
    }, _.prototype._read = function (e) {
      y(this, new v("_read()"));
    }, _.prototype.pipe = function (e, n) {
      var r = this,
        i = this._readableState;
      switch (i.pipesCount) {
        case 0:
          i.pipes = e;
          break;
        case 1:
          i.pipes = [i.pipes, e];
          break;
        default:
          i.pipes.push(e);
      }
      i.pipesCount += 1, a("pipe count=%d opts=%j", i.pipesCount, n);
      var o = (!n || !1 !== n.end) && e !== Be.stdout && e !== Be.stderr ? u : m;
      function s(t, n) {
        a("onunpipe"), t === r && n && !1 === n.hasUnpiped && (n.hasUnpiped = !0, a("cleanup"), e.removeListener("close", h), e.removeListener("finish", p), e.removeListener("drain", c), e.removeListener("error", f), e.removeListener("unpipe", s), r.removeListener("end", u), r.removeListener("end", m), r.removeListener("data", d), l = !0, !i.awaitDrain || e._writableState && !e._writableState.needDrain || c());
      }
      function u() {
        a("onend"), e.end();
      }
      i.endEmitted ? Ee(o) : r.once("end", o), e.on("unpipe", s);
      var c = function (e) {
        return function () {
          var n = e._readableState;
          a("pipeOnDrain", n.awaitDrain), n.awaitDrain && n.awaitDrain--, 0 === n.awaitDrain && t(e, "data") && (n.flowing = !0, L(e));
        };
      }(r);
      e.on("drain", c);
      var l = !1;
      function d(t) {
        a("ondata");
        var n = e.write(t);
        a("dest.write", n), !1 === n && ((1 === i.pipesCount && i.pipes === e || i.pipesCount > 1 && -1 !== j(i.pipes, e)) && !l && (a("false write response, pause", i.awaitDrain), i.awaitDrain++), r.pause());
      }
      function f(n) {
        a("onerror", n), m(), e.removeListener("error", f), 0 === t(e, "error") && y(e, n);
      }
      function h() {
        e.removeListener("finish", p), m();
      }
      function p() {
        a("onfinish"), e.removeListener("close", h), m();
      }
      function m() {
        a("unpipe"), r.unpipe(e);
      }
      return r.on("data", d), function (e, t, n) {
        if ("function" == typeof e.prependListener) return e.prependListener(t, n);
        e._events && e._events[t] ? Array.isArray(e._events[t]) ? e._events[t].unshift(n) : e._events[t] = [n, e._events[t]] : e.on(t, n);
      }(e, "error", f), e.once("close", h), e.once("finish", p), e.emit("pipe", r), i.flowing || (a("pipe resume"), r.resume()), e;
    }, _.prototype.unpipe = function (e) {
      var t = this._readableState,
        n = {
          hasUnpiped: !1
        };
      if (0 === t.pipesCount) return this;
      if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, n)), this;
      if (!e) {
        var r = t.pipes,
          i = t.pipesCount;
        t.pipes = null, t.pipesCount = 0, t.flowing = !1;
        for (var o = 0; o < i; o++) r[o].emit("unpipe", this, {
          hasUnpiped: !1
        });
        return this;
      }
      var a = j(t.pipes, e);
      return -1 === a || (t.pipes.splice(a, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, n)), this;
    }, _.prototype.on = function (e, t) {
      var n = r.prototype.on.call(this, e, t),
        i = this._readableState;
      return "data" === e ? (i.readableListening = this.listenerCount("readable") > 0, !1 !== i.flowing && this.resume()) : "readable" === e && (i.endEmitted || i.readableListening || (i.readableListening = i.needReadable = !0, i.flowing = !1, i.emittedReadable = !1, a("on readable", i.length, i.reading), i.length ? C(this) : i.reading || Ee(P, this))), n;
    }, _.prototype.addListener = _.prototype.on, _.prototype.removeListener = function (e, t) {
      var n = r.prototype.removeListener.call(this, e, t);
      return "readable" === e && Ee(T, this), n;
    }, _.prototype.removeAllListeners = function (e) {
      var t = r.prototype.removeAllListeners.apply(this, arguments);
      return "readable" !== e && void 0 !== e || Ee(T, this), t;
    }, _.prototype.resume = function () {
      var e = this._readableState;
      return e.flowing || (a("resume"), e.flowing = !e.readableListening, function (e, t) {
        t.resumeScheduled || (t.resumeScheduled = !0, Ee(O, e, t));
      }(this, e)), e.paused = !1, this;
    }, _.prototype.pause = function () {
      return a("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (a("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
    }, _.prototype.wrap = function (e) {
      var t = this,
        n = this._readableState,
        r = !1;
      for (var i in e.on("end", function () {
        if (a("wrapped end"), n.decoder && !n.ended) {
          var e = n.decoder.end();
          e && e.length && t.push(e);
        }
        t.push(null);
      }), e.on("data", function (i) {
        (a("wrapped data"), n.decoder && (i = n.decoder.write(i)), n.objectMode && null == i) || (n.objectMode || i && i.length) && (t.push(i) || (r = !0, e.pause()));
      }), e) void 0 === this[i] && "function" == typeof e[i] && (this[i] = function (t) {
        return function () {
          return e[t].apply(e, arguments);
        };
      }(i));
      for (var o = 0; o < w.length; o++) e.on(w[o], this.emit.bind(this, w[o]));
      return this._read = function (t) {
        a("wrapped _read", t), r && (r = !1, e.resume());
      }, this;
    }, "function" == typeof Symbol && (_.prototype[Symbol.asyncIterator] = function () {
      return void 0 === c && (c = wn()), c(this);
    }), Object.defineProperty(_.prototype, "readableHighWaterMark", {
      enumerable: !1,
      get: function () {
        return this._readableState.highWaterMark;
      }
    }), Object.defineProperty(_.prototype, "readableBuffer", {
      enumerable: !1,
      get: function () {
        return this._readableState && this._readableState.buffer;
      }
    }), Object.defineProperty(_.prototype, "readableFlowing", {
      enumerable: !1,
      get: function () {
        return this._readableState.flowing;
      },
      set: function (e) {
        this._readableState && (this._readableState.flowing = e);
      }
    }), _._fromList = N, Object.defineProperty(_.prototype, "readableLength", {
      enumerable: !1,
      get: function () {
        return this._readableState.length;
      }
    }), "function" == typeof Symbol && (_.from = function (e, t) {
      return void 0 === l && (l = gn ? mn : (gn = 1, mn = function () {
        throw new Error("Readable.from is not available in the browser");
      })), l(_, e, t);
    }), vn;
  }
  var _n = In,
    En = Wt.codes,
    Sn = En.ERR_METHOD_NOT_IMPLEMENTED,
    kn = En.ERR_MULTIPLE_CALLBACK,
    Mn = En.ERR_TRANSFORM_ALREADY_TRANSFORMING,
    Cn = En.ERR_TRANSFORM_WITH_LENGTH_0,
    xn = sn();
  function Rn(e, t) {
    var n = this._transformState;
    n.transforming = !1;
    var r = n.writecb;
    if (null === r) return this.emit("error", new kn());
    n.writechunk = null, n.writecb = null, null != t && this.push(t), r(e);
    var i = this._readableState;
    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
  }
  function In(e) {
    if (!(this instanceof In)) return new In(e);
    xn.call(this, e), this._transformState = {
      afterTransform: Rn.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", Tn);
  }
  function Tn() {
    var e = this;
    "function" != typeof this._flush || this._readableState.destroyed ? Pn(this, null, null) : this._flush(function (t, n) {
      Pn(e, t, n);
    });
  }
  function Pn(e, t, n) {
    if (t) return e.emit("error", t);
    if (null != n && e.push(n), e._writableState.length) throw new Cn();
    if (e._transformState.transforming) throw new Mn();
    return e.push(null);
  }
  We(In, xn), In.prototype.push = function (e, t) {
    return this._transformState.needTransform = !1, xn.prototype.push.call(this, e, t);
  }, In.prototype._transform = function (e, t, n) {
    n(new Sn("_transform()"));
  }, In.prototype._write = function (e, t, n) {
    var r = this._transformState;
    if (r.writecb = n, r.writechunk = e, r.writeencoding = t, !r.transforming) {
      var i = this._readableState;
      (r.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
    }
  }, In.prototype._read = function (e) {
    var t = this._transformState;
    null === t.writechunk || t.transforming ? t.needTransform = !0 : (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform));
  }, In.prototype._destroy = function (e, t) {
    xn.prototype._destroy.call(this, e, function (e) {
      t(e);
    });
  };
  var On,
    Ln = Dn,
    Nn = _n;
  function Dn(e) {
    if (!(this instanceof Dn)) return new Dn(e);
    Nn.call(this, e);
  }
  We(Dn, Nn), Dn.prototype._transform = function (e, t, n) {
    n(null, e);
  };
  var Bn = Wt.codes,
    jn = Bn.ERR_MISSING_ARGS,
    Fn = Bn.ERR_STREAM_DESTROYED;
  function zn(e) {
    if (e) throw e;
  }
  function Un(e) {
    e();
  }
  function qn(e, t) {
    return e.pipe(t);
  }
  var Kn = function () {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
    var r,
      i = function (e) {
        return e.length ? "function" != typeof e[e.length - 1] ? zn : e.pop() : zn;
      }(t);
    if (Array.isArray(t[0]) && (t = t[0]), t.length < 2) throw new jn("streams");
    var o = t.map(function (e, n) {
      var a = n < t.length - 1;
      return function (e, t, n, r) {
        r = function (e) {
          var t = !1;
          return function () {
            t || (t = !0, e.apply(void 0, arguments));
          };
        }(r);
        var i = !1;
        e.on("close", function () {
          i = !0;
        }), void 0 === On && (On = yn), On(e, {
          readable: t,
          writable: n
        }, function (e) {
          if (e) return r(e);
          i = !0, r();
        });
        var o = !1;
        return function (t) {
          if (!i && !o) return o = !0, function (e) {
            return e.setHeader && "function" == typeof e.abort;
          }(e) ? e.abort() : "function" == typeof e.destroy ? e.destroy() : void r(t || new Fn("pipe"));
        };
      }(e, a, n > 0, function (e) {
        r || (r = e), e && o.forEach(Un), a || (o.forEach(Un), i(r));
      });
    });
    return t.reduce(qn);
  };
  !function (e, t) {
    (t = e.exports = An()).Stream = t, t.Readable = t, t.Writable = an(), t.Duplex = sn(), t.Transform = _n, t.PassThrough = Ln, t.finished = yn, t.pipeline = Kn;
  }(Ye, Ye.exports);
  var Hn = Ye.exports,
    Vn = ze().Buffer,
    $n = Hn.Transform;
  function Wn(e) {
    $n.call(this), this._block = Vn.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  We(Wn, $n), Wn.prototype._transform = function (e, t, n) {
    var r = null;
    try {
      this.update(e, t);
    } catch (e) {
      r = e;
    }
    n(r);
  }, Wn.prototype._flush = function (e) {
    var t = null;
    try {
      this.push(this.digest());
    } catch (e) {
      t = e;
    }
    e(t);
  }, Wn.prototype.update = function (e, t) {
    if (function (e, t) {
      if (!Vn.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
    }(e, "Data"), this._finalized) throw new Error("Digest already called");
    Vn.isBuffer(e) || (e = Vn.from(e, t));
    for (var n = this._block, r = 0; this._blockOffset + e.length - r >= this._blockSize;) {
      for (var i = this._blockOffset; i < this._blockSize;) n[i++] = e[r++];
      this._update(), this._blockOffset = 0;
    }
    for (; r < e.length;) n[this._blockOffset++] = e[r++];
    for (var o = 0, a = 8 * e.length; a > 0; ++o) this._length[o] += a, (a = this._length[o] / 4294967296 | 0) > 0 && (this._length[o] -= 4294967296 * a);
    return this;
  }, Wn.prototype._update = function () {
    throw new Error("_update is not implemented");
  }, Wn.prototype.digest = function (e) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var t = this._digest();
    void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;
    for (var n = 0; n < 4; ++n) this._length[n] = 0;
    return t;
  }, Wn.prototype._digest = function () {
    throw new Error("_digest is not implemented");
  };
  var Yn = Wn,
    Gn = We,
    Qn = Yn,
    Zn = ze().Buffer,
    Jn = new Array(16);
  function Xn() {
    Qn.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  function er(e, t) {
    return e << t | e >>> 32 - t;
  }
  function tr(e, t, n, r, i, o, a) {
    return er(e + (t & n | ~t & r) + i + o | 0, a) + t | 0;
  }
  function nr(e, t, n, r, i, o, a) {
    return er(e + (t & r | n & ~r) + i + o | 0, a) + t | 0;
  }
  function rr(e, t, n, r, i, o, a) {
    return er(e + (t ^ n ^ r) + i + o | 0, a) + t | 0;
  }
  function ir(e, t, n, r, i, o, a) {
    return er(e + (n ^ (t | ~r)) + i + o | 0, a) + t | 0;
  }
  Gn(Xn, Qn), Xn.prototype._update = function () {
    for (var e = Jn, t = 0; t < 16; ++t) e[t] = this._block.readInt32LE(4 * t);
    var n = this._a,
      r = this._b,
      i = this._c,
      o = this._d;
    n = tr(n, r, i, o, e[0], 3614090360, 7), o = tr(o, n, r, i, e[1], 3905402710, 12), i = tr(i, o, n, r, e[2], 606105819, 17), r = tr(r, i, o, n, e[3], 3250441966, 22), n = tr(n, r, i, o, e[4], 4118548399, 7), o = tr(o, n, r, i, e[5], 1200080426, 12), i = tr(i, o, n, r, e[6], 2821735955, 17), r = tr(r, i, o, n, e[7], 4249261313, 22), n = tr(n, r, i, o, e[8], 1770035416, 7), o = tr(o, n, r, i, e[9], 2336552879, 12), i = tr(i, o, n, r, e[10], 4294925233, 17), r = tr(r, i, o, n, e[11], 2304563134, 22), n = tr(n, r, i, o, e[12], 1804603682, 7), o = tr(o, n, r, i, e[13], 4254626195, 12), i = tr(i, o, n, r, e[14], 2792965006, 17), n = nr(n, r = tr(r, i, o, n, e[15], 1236535329, 22), i, o, e[1], 4129170786, 5), o = nr(o, n, r, i, e[6], 3225465664, 9), i = nr(i, o, n, r, e[11], 643717713, 14), r = nr(r, i, o, n, e[0], 3921069994, 20), n = nr(n, r, i, o, e[5], 3593408605, 5), o = nr(o, n, r, i, e[10], 38016083, 9), i = nr(i, o, n, r, e[15], 3634488961, 14), r = nr(r, i, o, n, e[4], 3889429448, 20), n = nr(n, r, i, o, e[9], 568446438, 5), o = nr(o, n, r, i, e[14], 3275163606, 9), i = nr(i, o, n, r, e[3], 4107603335, 14), r = nr(r, i, o, n, e[8], 1163531501, 20), n = nr(n, r, i, o, e[13], 2850285829, 5), o = nr(o, n, r, i, e[2], 4243563512, 9), i = nr(i, o, n, r, e[7], 1735328473, 14), n = rr(n, r = nr(r, i, o, n, e[12], 2368359562, 20), i, o, e[5], 4294588738, 4), o = rr(o, n, r, i, e[8], 2272392833, 11), i = rr(i, o, n, r, e[11], 1839030562, 16), r = rr(r, i, o, n, e[14], 4259657740, 23), n = rr(n, r, i, o, e[1], 2763975236, 4), o = rr(o, n, r, i, e[4], 1272893353, 11), i = rr(i, o, n, r, e[7], 4139469664, 16), r = rr(r, i, o, n, e[10], 3200236656, 23), n = rr(n, r, i, o, e[13], 681279174, 4), o = rr(o, n, r, i, e[0], 3936430074, 11), i = rr(i, o, n, r, e[3], 3572445317, 16), r = rr(r, i, o, n, e[6], 76029189, 23), n = rr(n, r, i, o, e[9], 3654602809, 4), o = rr(o, n, r, i, e[12], 3873151461, 11), i = rr(i, o, n, r, e[15], 530742520, 16), n = ir(n, r = rr(r, i, o, n, e[2], 3299628645, 23), i, o, e[0], 4096336452, 6), o = ir(o, n, r, i, e[7], 1126891415, 10), i = ir(i, o, n, r, e[14], 2878612391, 15), r = ir(r, i, o, n, e[5], 4237533241, 21), n = ir(n, r, i, o, e[12], 1700485571, 6), o = ir(o, n, r, i, e[3], 2399980690, 10), i = ir(i, o, n, r, e[10], 4293915773, 15), r = ir(r, i, o, n, e[1], 2240044497, 21), n = ir(n, r, i, o, e[8], 1873313359, 6), o = ir(o, n, r, i, e[15], 4264355552, 10), i = ir(i, o, n, r, e[6], 2734768916, 15), r = ir(r, i, o, n, e[13], 1309151649, 21), n = ir(n, r, i, o, e[4], 4149444226, 6), o = ir(o, n, r, i, e[11], 3174756917, 10), i = ir(i, o, n, r, e[2], 718787259, 15), r = ir(r, i, o, n, e[9], 3951481745, 21), this._a = this._a + n | 0, this._b = this._b + r | 0, this._c = this._c + i | 0, this._d = this._d + o | 0;
  }, Xn.prototype._digest = function () {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var e = Zn.allocUnsafe(16);
    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
  };
  var or = Xn,
    ar = le.Buffer,
    sr = We,
    ur = Yn,
    cr = new Array(16),
    lr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
    dr = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
    fr = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
    hr = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11],
    pr = [0, 1518500249, 1859775393, 2400959708, 2840853838],
    mr = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function gr() {
    ur.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  function vr(e, t) {
    return e << t | e >>> 32 - t;
  }
  function br(e, t, n, r, i, o, a, s) {
    return vr(e + (t ^ n ^ r) + o + a | 0, s) + i | 0;
  }
  function yr(e, t, n, r, i, o, a, s) {
    return vr(e + (t & n | ~t & r) + o + a | 0, s) + i | 0;
  }
  function wr(e, t, n, r, i, o, a, s) {
    return vr(e + ((t | ~n) ^ r) + o + a | 0, s) + i | 0;
  }
  function Ar(e, t, n, r, i, o, a, s) {
    return vr(e + (t & r | n & ~r) + o + a | 0, s) + i | 0;
  }
  function _r(e, t, n, r, i, o, a, s) {
    return vr(e + (t ^ (n | ~r)) + o + a | 0, s) + i | 0;
  }
  sr(gr, ur), gr.prototype._update = function () {
    for (var e = cr, t = 0; t < 16; ++t) e[t] = this._block.readInt32LE(4 * t);
    for (var n = 0 | this._a, r = 0 | this._b, i = 0 | this._c, o = 0 | this._d, a = 0 | this._e, s = 0 | this._a, u = 0 | this._b, c = 0 | this._c, l = 0 | this._d, d = 0 | this._e, f = 0; f < 80; f += 1) {
      var h, p;
      f < 16 ? (h = br(n, r, i, o, a, e[lr[f]], pr[0], fr[f]), p = _r(s, u, c, l, d, e[dr[f]], mr[0], hr[f])) : f < 32 ? (h = yr(n, r, i, o, a, e[lr[f]], pr[1], fr[f]), p = Ar(s, u, c, l, d, e[dr[f]], mr[1], hr[f])) : f < 48 ? (h = wr(n, r, i, o, a, e[lr[f]], pr[2], fr[f]), p = wr(s, u, c, l, d, e[dr[f]], mr[2], hr[f])) : f < 64 ? (h = Ar(n, r, i, o, a, e[lr[f]], pr[3], fr[f]), p = yr(s, u, c, l, d, e[dr[f]], mr[3], hr[f])) : (h = _r(n, r, i, o, a, e[lr[f]], pr[4], fr[f]), p = br(s, u, c, l, d, e[dr[f]], mr[4], hr[f])), n = a, a = o, o = vr(i, 10), i = r, r = h, s = d, d = l, l = vr(c, 10), c = u, u = p;
    }
    var m = this._b + i + l | 0;
    this._b = this._c + o + d | 0, this._c = this._d + a + s | 0, this._d = this._e + n + u | 0, this._e = this._a + r + c | 0, this._a = m;
  }, gr.prototype._digest = function () {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var e = ar.alloc ? ar.alloc(20) : new ar(20);
    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
  };
  var Er = gr,
    Sr = {
      exports: {}
    },
    kr = ze().Buffer;
  function Mr(e, t) {
    this._block = kr.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
  }
  Mr.prototype.update = function (e, t) {
    "string" == typeof e && (t = t || "utf8", e = kr.from(e, t));
    for (var n = this._block, r = this._blockSize, i = e.length, o = this._len, a = 0; a < i;) {
      for (var s = o % r, u = Math.min(i - a, r - s), c = 0; c < u; c++) n[s + c] = e[a + c];
      a += u, (o += u) % r == 0 && this._update(n);
    }
    return this._len += i, this;
  }, Mr.prototype.digest = function (e) {
    var t = this._len % this._blockSize;
    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var n = 8 * this._len;
    if (n <= 4294967295) this._block.writeUInt32BE(n, this._blockSize - 4);else {
      var r = (4294967295 & n) >>> 0,
        i = (n - r) / 4294967296;
      this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(r, this._blockSize - 4);
    }
    this._update(this._block);
    var o = this._hash();
    return e ? o.toString(e) : o;
  }, Mr.prototype._update = function () {
    throw new Error("_update must be implemented by subclass");
  };
  var Cr = Mr,
    xr = We,
    Rr = Cr,
    Ir = ze().Buffer,
    Tr = [1518500249, 1859775393, -1894007588, -899497514],
    Pr = new Array(80);
  function Or() {
    this.init(), this._w = Pr, Rr.call(this, 64, 56);
  }
  function Lr(e) {
    return e << 30 | e >>> 2;
  }
  function Nr(e, t, n, r) {
    return 0 === e ? t & n | ~t & r : 2 === e ? t & n | t & r | n & r : t ^ n ^ r;
  }
  xr(Or, Rr), Or.prototype.init = function () {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  }, Or.prototype._update = function (e) {
    for (var t, n = this._w, r = 0 | this._a, i = 0 | this._b, o = 0 | this._c, a = 0 | this._d, s = 0 | this._e, u = 0; u < 16; ++u) n[u] = e.readInt32BE(4 * u);
    for (; u < 80; ++u) n[u] = n[u - 3] ^ n[u - 8] ^ n[u - 14] ^ n[u - 16];
    for (var c = 0; c < 80; ++c) {
      var l = ~~(c / 20),
        d = 0 | ((t = r) << 5 | t >>> 27) + Nr(l, i, o, a) + s + n[c] + Tr[l];
      s = a, a = o, o = Lr(i), i = r, r = d;
    }
    this._a = r + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = a + this._d | 0, this._e = s + this._e | 0;
  }, Or.prototype._hash = function () {
    var e = Ir.allocUnsafe(20);
    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
  };
  var Dr = Or,
    Br = We,
    jr = Cr,
    Fr = ze().Buffer,
    zr = [1518500249, 1859775393, -1894007588, -899497514],
    Ur = new Array(80);
  function qr() {
    this.init(), this._w = Ur, jr.call(this, 64, 56);
  }
  function Kr(e) {
    return e << 5 | e >>> 27;
  }
  function Hr(e) {
    return e << 30 | e >>> 2;
  }
  function Vr(e, t, n, r) {
    return 0 === e ? t & n | ~t & r : 2 === e ? t & n | t & r | n & r : t ^ n ^ r;
  }
  Br(qr, jr), qr.prototype.init = function () {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  }, qr.prototype._update = function (e) {
    for (var t, n = this._w, r = 0 | this._a, i = 0 | this._b, o = 0 | this._c, a = 0 | this._d, s = 0 | this._e, u = 0; u < 16; ++u) n[u] = e.readInt32BE(4 * u);
    for (; u < 80; ++u) n[u] = (t = n[u - 3] ^ n[u - 8] ^ n[u - 14] ^ n[u - 16]) << 1 | t >>> 31;
    for (var c = 0; c < 80; ++c) {
      var l = ~~(c / 20),
        d = Kr(r) + Vr(l, i, o, a) + s + n[c] + zr[l] | 0;
      s = a, a = o, o = Hr(i), i = r, r = d;
    }
    this._a = r + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = a + this._d | 0, this._e = s + this._e | 0;
  }, qr.prototype._hash = function () {
    var e = Fr.allocUnsafe(20);
    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
  };
  var $r = qr,
    Wr = We,
    Yr = Cr,
    Gr = ze().Buffer,
    Qr = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
    Zr = new Array(64);
  function Jr() {
    this.init(), this._w = Zr, Yr.call(this, 64, 56);
  }
  function Xr(e, t, n) {
    return n ^ e & (t ^ n);
  }
  function ei(e, t, n) {
    return e & t | n & (e | t);
  }
  function ti(e) {
    return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
  }
  function ni(e) {
    return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
  }
  function ri(e) {
    return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
  }
  function ii(e) {
    return (e >>> 17 | e << 15) ^ (e >>> 19 | e << 13) ^ e >>> 10;
  }
  Wr(Jr, Yr), Jr.prototype.init = function () {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  }, Jr.prototype._update = function (e) {
    for (var t = this._w, n = 0 | this._a, r = 0 | this._b, i = 0 | this._c, o = 0 | this._d, a = 0 | this._e, s = 0 | this._f, u = 0 | this._g, c = 0 | this._h, l = 0; l < 16; ++l) t[l] = e.readInt32BE(4 * l);
    for (; l < 64; ++l) t[l] = ii(t[l - 2]) + t[l - 7] + ri(t[l - 15]) + t[l - 16] | 0;
    for (var d = 0; d < 64; ++d) {
      var f = c + ni(a) + Xr(a, s, u) + Qr[d] + t[d] | 0,
        h = ti(n) + ei(n, r, i) | 0;
      c = u, u = s, s = a, a = o + f | 0, o = i, i = r, r = n, n = f + h | 0;
    }
    this._a = n + this._a | 0, this._b = r + this._b | 0, this._c = i + this._c | 0, this._d = o + this._d | 0, this._e = a + this._e | 0, this._f = s + this._f | 0, this._g = u + this._g | 0, this._h = c + this._h | 0;
  }, Jr.prototype._hash = function () {
    var e = Gr.allocUnsafe(32);
    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
  };
  var oi = Jr,
    ai = We,
    si = oi,
    ui = Cr,
    ci = ze().Buffer,
    li = new Array(64);
  function di() {
    this.init(), this._w = li, ui.call(this, 64, 56);
  }
  ai(di, si), di.prototype.init = function () {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, di.prototype._hash = function () {
    var e = ci.allocUnsafe(28);
    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
  };
  var fi = di,
    hi = We,
    pi = Cr,
    mi = ze().Buffer,
    gi = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591],
    vi = new Array(160);
  function bi() {
    this.init(), this._w = vi, pi.call(this, 128, 112);
  }
  function yi(e, t, n) {
    return n ^ e & (t ^ n);
  }
  function wi(e, t, n) {
    return e & t | n & (e | t);
  }
  function Ai(e, t) {
    return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
  }
  function _i(e, t) {
    return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
  }
  function Ei(e, t) {
    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
  }
  function Si(e, t) {
    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
  }
  function ki(e, t) {
    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
  }
  function Mi(e, t) {
    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
  }
  function Ci(e, t) {
    return e >>> 0 < t >>> 0 ? 1 : 0;
  }
  hi(bi, pi), bi.prototype.init = function () {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  }, bi.prototype._update = function (e) {
    for (var t = this._w, n = 0 | this._ah, r = 0 | this._bh, i = 0 | this._ch, o = 0 | this._dh, a = 0 | this._eh, s = 0 | this._fh, u = 0 | this._gh, c = 0 | this._hh, l = 0 | this._al, d = 0 | this._bl, f = 0 | this._cl, h = 0 | this._dl, p = 0 | this._el, m = 0 | this._fl, g = 0 | this._gl, v = 0 | this._hl, b = 0; b < 32; b += 2) t[b] = e.readInt32BE(4 * b), t[b + 1] = e.readInt32BE(4 * b + 4);
    for (; b < 160; b += 2) {
      var y = t[b - 30],
        w = t[b - 30 + 1],
        A = Ei(y, w),
        _ = Si(w, y),
        E = ki(y = t[b - 4], w = t[b - 4 + 1]),
        S = Mi(w, y),
        k = t[b - 14],
        M = t[b - 14 + 1],
        C = t[b - 32],
        x = t[b - 32 + 1],
        R = _ + M | 0,
        I = A + k + Ci(R, _) | 0;
      I = (I = I + E + Ci(R = R + S | 0, S) | 0) + C + Ci(R = R + x | 0, x) | 0, t[b] = I, t[b + 1] = R;
    }
    for (var T = 0; T < 160; T += 2) {
      I = t[T], R = t[T + 1];
      var P = wi(n, r, i),
        O = wi(l, d, f),
        L = Ai(n, l),
        N = Ai(l, n),
        D = _i(a, p),
        B = _i(p, a),
        j = gi[T],
        F = gi[T + 1],
        z = yi(a, s, u),
        U = yi(p, m, g),
        q = v + B | 0,
        K = c + D + Ci(q, v) | 0;
      K = (K = (K = K + z + Ci(q = q + U | 0, U) | 0) + j + Ci(q = q + F | 0, F) | 0) + I + Ci(q = q + R | 0, R) | 0;
      var H = N + O | 0,
        V = L + P + Ci(H, N) | 0;
      c = u, v = g, u = s, g = m, s = a, m = p, a = o + K + Ci(p = h + q | 0, h) | 0, o = i, h = f, i = r, f = d, r = n, d = l, n = K + V + Ci(l = q + H | 0, q) | 0;
    }
    this._al = this._al + l | 0, this._bl = this._bl + d | 0, this._cl = this._cl + f | 0, this._dl = this._dl + h | 0, this._el = this._el + p | 0, this._fl = this._fl + m | 0, this._gl = this._gl + g | 0, this._hl = this._hl + v | 0, this._ah = this._ah + n + Ci(this._al, l) | 0, this._bh = this._bh + r + Ci(this._bl, d) | 0, this._ch = this._ch + i + Ci(this._cl, f) | 0, this._dh = this._dh + o + Ci(this._dl, h) | 0, this._eh = this._eh + a + Ci(this._el, p) | 0, this._fh = this._fh + s + Ci(this._fl, m) | 0, this._gh = this._gh + u + Ci(this._gl, g) | 0, this._hh = this._hh + c + Ci(this._hl, v) | 0;
  }, bi.prototype._hash = function () {
    var e = mi.allocUnsafe(64);
    function t(t, n, r) {
      e.writeInt32BE(t, r), e.writeInt32BE(n, r + 4);
    }
    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
  };
  var xi = bi,
    Ri = We,
    Ii = xi,
    Ti = Cr,
    Pi = ze().Buffer,
    Oi = new Array(160);
  function Li() {
    this.init(), this._w = Oi, Ti.call(this, 128, 112);
  }
  Ri(Li, Ii), Li.prototype.init = function () {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, Li.prototype._hash = function () {
    var e = Pi.allocUnsafe(48);
    function t(t, n, r) {
      e.writeInt32BE(t, r), e.writeInt32BE(n, r + 4);
    }
    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
  };
  var Ni = Li,
    Di = Sr.exports = function (e) {
      e = e.toLowerCase();
      var t = Di[e];
      if (!t) throw new Error(e + " is not supported (we accept pull requests)");
      return new t();
    };
  Di.sha = Dr, Di.sha1 = $r, Di.sha224 = fi, Di.sha256 = oi, Di.sha384 = Ni, Di.sha512 = xi;
  var Bi = Sr.exports;
  function ji() {
    this.head = null, this.tail = null, this.length = 0;
  }
  ji.prototype.push = function (e) {
    var t = {
      data: e,
      next: null
    };
    this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
  }, ji.prototype.unshift = function (e) {
    var t = {
      data: e,
      next: this.head
    };
    0 === this.length && (this.tail = t), this.head = t, ++this.length;
  }, ji.prototype.shift = function () {
    if (0 !== this.length) {
      var e = this.head.data;
      return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
    }
  }, ji.prototype.clear = function () {
    this.head = this.tail = null, this.length = 0;
  }, ji.prototype.join = function (e) {
    if (0 === this.length) return "";
    for (var t = this.head, n = "" + t.data; t = t.next;) n += e + t.data;
    return n;
  }, ji.prototype.concat = function (e) {
    if (0 === this.length) return A.alloc(0);
    if (1 === this.length) return this.head.data;
    for (var t = A.allocUnsafe(e >>> 0), n = this.head, r = 0; n;) n.data.copy(t, r), r += n.data.length, n = n.next;
    return t;
  };
  var Fi = A.isEncoding || function (e) {
    switch (e && e.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function zi(e) {
    switch (this.encoding = (e || "utf8").toLowerCase().replace(/[-_]/, ""), function (e) {
      if (e && !Fi(e)) throw new Error("Unknown encoding: " + e);
    }(e), this.encoding) {
      case "utf8":
        this.surrogateSize = 3;
        break;
      case "ucs2":
      case "utf16le":
        this.surrogateSize = 2, this.detectIncompleteChar = qi;
        break;
      case "base64":
        this.surrogateSize = 3, this.detectIncompleteChar = Ki;
        break;
      default:
        return void (this.write = Ui);
    }
    this.charBuffer = new A(6), this.charReceived = 0, this.charLength = 0;
  }
  function Ui(e) {
    return e.toString(this.encoding);
  }
  function qi(e) {
    this.charReceived = e.length % 2, this.charLength = this.charReceived ? 2 : 0;
  }
  function Ki(e) {
    this.charReceived = e.length % 3, this.charLength = this.charReceived ? 3 : 0;
  }
  zi.prototype.write = function (e) {
    for (var t = ""; this.charLength;) {
      var n = e.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : e.length;
      if (e.copy(this.charBuffer, this.charReceived, 0, n), this.charReceived += n, this.charReceived < this.charLength) return "";
      if (e = e.slice(n, e.length), !((i = (t = this.charBuffer.slice(0, this.charLength).toString(this.encoding)).charCodeAt(t.length - 1)) >= 55296 && i <= 56319)) {
        if (this.charReceived = this.charLength = 0, 0 === e.length) return t;
        break;
      }
      this.charLength += this.surrogateSize, t = "";
    }
    this.detectIncompleteChar(e);
    var r = e.length;
    this.charLength && (e.copy(this.charBuffer, 0, e.length - this.charReceived, r), r -= this.charReceived);
    var i;
    r = (t += e.toString(this.encoding, 0, r)).length - 1;
    if ((i = t.charCodeAt(r)) >= 55296 && i <= 56319) {
      var o = this.surrogateSize;
      return this.charLength += o, this.charReceived += o, this.charBuffer.copy(this.charBuffer, o, 0, o), e.copy(this.charBuffer, 0, 0, o), t.substring(0, r);
    }
    return t;
  }, zi.prototype.detectIncompleteChar = function (e) {
    for (var t = e.length >= 3 ? 3 : e.length; t > 0; t--) {
      var n = e[e.length - t];
      if (1 == t && n >> 5 == 6) {
        this.charLength = 2;
        break;
      }
      if (t <= 2 && n >> 4 == 14) {
        this.charLength = 3;
        break;
      }
      if (t <= 3 && n >> 3 == 30) {
        this.charLength = 4;
        break;
      }
    }
    this.charReceived = t;
  }, zi.prototype.end = function (e) {
    var t = "";
    if (e && e.length && (t = this.write(e)), this.charReceived) {
      var n = this.charReceived,
        r = this.charBuffer,
        i = this.encoding;
      t += r.slice(0, n).toString(i);
    }
    return t;
  };
  var Hi = Object.freeze({
    __proto__: null,
    StringDecoder: zi
  });
  Wi.ReadableState = $i;
  var Vi = lt("stream");
  function $i(e, t) {
    e = e || {}, this.objectMode = !!e.objectMode, t instanceof _o && (this.objectMode = this.objectMode || !!e.readableObjectMode);
    var n = e.highWaterMark,
      r = this.objectMode ? 16 : 16384;
    this.highWaterMark = n || 0 === n ? n : r, this.highWaterMark = ~~this.highWaterMark, this.buffer = new ji(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.ranOut = !1, this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (this.decoder = new zi(e.encoding), this.encoding = e.encoding);
  }
  function Wi(e) {
    if (!(this instanceof Wi)) return new Wi(e);
    this._readableState = new $i(e, this), this.readable = !0, e && "function" == typeof e.read && (this._read = e.read), Qe.call(this);
  }
  function Yi(e, t, n, r, i) {
    var o = function (e, t) {
      var n = null;
      ie(t) || "string" == typeof t || null == t || e.objectMode || (n = new TypeError("Invalid non-string/buffer chunk"));
      return n;
    }(t, n);
    if (o) e.emit("error", o);else if (null === n) t.reading = !1, function (e, t) {
      if (t.ended) return;
      if (t.decoder) {
        var n = t.decoder.end();
        n && n.length && (t.buffer.push(n), t.length += t.objectMode ? 1 : n.length);
      }
      t.ended = !0, Zi(e);
    }(e, t);else if (t.objectMode || n && n.length > 0) {
      if (t.ended && !i) {
        var a = new Error("stream.push() after EOF");
        e.emit("error", a);
      } else if (t.endEmitted && i) {
        var s = new Error("stream.unshift() after end event");
        e.emit("error", s);
      } else {
        var u;
        !t.decoder || i || r || (n = t.decoder.write(n), u = !t.objectMode && 0 === n.length), i || (t.reading = !1), u || (t.flowing && 0 === t.length && !t.sync ? (e.emit("data", n), e.read(0)) : (t.length += t.objectMode ? 1 : n.length, i ? t.buffer.unshift(n) : t.buffer.push(n), t.needReadable && Zi(e))), function (e, t) {
          t.readingMore || (t.readingMore = !0, Ee(Xi, e, t));
        }(e, t);
      }
    } else i || (t.reading = !1);
    return function (e) {
      return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
    }(t);
  }
  it(Wi, Qe), Wi.prototype.push = function (e, t) {
    var n = this._readableState;
    return n.objectMode || "string" != typeof e || (t = t || n.defaultEncoding) !== n.encoding && (e = A.from(e, t), t = ""), Yi(this, n, e, t, !1);
  }, Wi.prototype.unshift = function (e) {
    return Yi(this, this._readableState, e, "", !0);
  }, Wi.prototype.isPaused = function () {
    return !1 === this._readableState.flowing;
  }, Wi.prototype.setEncoding = function (e) {
    return this._readableState.decoder = new zi(e), this._readableState.encoding = e, this;
  };
  var Gi = 8388608;
  function Qi(e, t) {
    return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function (e) {
      return e >= Gi ? e = Gi : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
    }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
  }
  function Zi(e) {
    var t = e._readableState;
    t.needReadable = !1, t.emittedReadable || (Vi("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? Ee(Ji, e) : Ji(e));
  }
  function Ji(e) {
    Vi("emit readable"), e.emit("readable"), no(e);
  }
  function Xi(e, t) {
    for (var n = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (Vi("maybeReadMore read 0"), e.read(0), n !== t.length);) n = t.length;
    t.readingMore = !1;
  }
  function eo(e) {
    Vi("readable nexttick read 0"), e.read(0);
  }
  function to(e, t) {
    t.reading || (Vi("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), no(e), t.flowing && !t.reading && e.read(0);
  }
  function no(e) {
    var t = e._readableState;
    for (Vi("flow", t.flowing); t.flowing && null !== e.read(););
  }
  function ro(e, t) {
    return 0 === t.length ? null : (t.objectMode ? n = t.buffer.shift() : !e || e >= t.length ? (n = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : n = function (e, t, n) {
      var r;
      e < t.head.data.length ? (r = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : r = e === t.head.data.length ? t.shift() : n ? function (e, t) {
        var n = t.head,
          r = 1,
          i = n.data;
        e -= i.length;
        for (; n = n.next;) {
          var o = n.data,
            a = e > o.length ? o.length : e;
          if (a === o.length ? i += o : i += o.slice(0, e), 0 === (e -= a)) {
            a === o.length ? (++r, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = o.slice(a));
            break;
          }
          ++r;
        }
        return t.length -= r, i;
      }(e, t) : function (e, t) {
        var n = A.allocUnsafe(e),
          r = t.head,
          i = 1;
        r.data.copy(n), e -= r.data.length;
        for (; r = r.next;) {
          var o = r.data,
            a = e > o.length ? o.length : e;
          if (o.copy(n, n.length - e, 0, a), 0 === (e -= a)) {
            a === o.length ? (++i, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = o.slice(a));
            break;
          }
          ++i;
        }
        return t.length -= i, n;
      }(e, t);
      return r;
    }(e, t.buffer, t.decoder), n);
    var n;
  }
  function io(e) {
    var t = e._readableState;
    if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    t.endEmitted || (t.ended = !0, Ee(oo, t, e));
  }
  function oo(e, t) {
    e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
  }
  function ao(e, t) {
    for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
    return -1;
  }
  function so() {}
  function uo(e, t, n) {
    this.chunk = e, this.encoding = t, this.callback = n, this.next = null;
  }
  function co(e, t) {
    Object.defineProperty(this, "buffer", {
      get: st(function () {
        return this.getBuffer();
      }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
    }), e = e || {}, this.objectMode = !!e.objectMode, t instanceof _o && (this.objectMode = this.objectMode || !!e.writableObjectMode);
    var n = e.highWaterMark,
      r = this.objectMode ? 16 : 16384;
    this.highWaterMark = n || 0 === n ? n : r, this.highWaterMark = ~~this.highWaterMark, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1;
    var i = !1 === e.decodeStrings;
    this.decodeStrings = !i, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
      !function (e, t) {
        var n = e._writableState,
          r = n.sync,
          i = n.writecb;
        if (function (e) {
          e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
        }(n), t) !function (e, t, n, r, i) {
          --t.pendingcb, n ? Ee(i, r) : i(r);
          e._writableState.errorEmitted = !0, e.emit("error", r);
        }(e, n, r, t, i);else {
          var o = mo(n);
          o || n.corked || n.bufferProcessing || !n.bufferedRequest || po(e, n), r ? Ee(ho, e, n, o, i) : ho(e, n, o, i);
        }
      }(t, e);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new bo(this);
  }
  function lo(e) {
    if (!(this instanceof lo || this instanceof _o)) return new lo(e);
    this._writableState = new co(e, this), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev)), Qe.call(this);
  }
  function fo(e, t, n, r, i, o, a) {
    t.writelen = r, t.writecb = a, t.writing = !0, t.sync = !0, n ? e._writev(i, t.onwrite) : e._write(i, o, t.onwrite), t.sync = !1;
  }
  function ho(e, t, n, r) {
    n || function (e, t) {
      0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
    }(e, t), t.pendingcb--, r(), vo(e, t);
  }
  function po(e, t) {
    t.bufferProcessing = !0;
    var n = t.bufferedRequest;
    if (e._writev && n && n.next) {
      var r = t.bufferedRequestCount,
        i = new Array(r),
        o = t.corkedRequestsFree;
      o.entry = n;
      for (var a = 0; n;) i[a] = n, n = n.next, a += 1;
      fo(e, t, !0, t.length, i, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new bo(t);
    } else {
      for (; n;) {
        var s = n.chunk,
          u = n.encoding,
          c = n.callback;
        if (fo(e, t, !1, t.objectMode ? 1 : s.length, s, u, c), n = n.next, t.writing) break;
      }
      null === n && (t.lastBufferedRequest = null);
    }
    t.bufferedRequestCount = 0, t.bufferedRequest = n, t.bufferProcessing = !1;
  }
  function mo(e) {
    return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
  }
  function go(e, t) {
    t.prefinished || (t.prefinished = !0, e.emit("prefinish"));
  }
  function vo(e, t) {
    var n = mo(t);
    return n && (0 === t.pendingcb ? (go(e, t), t.finished = !0, e.emit("finish")) : go(e, t)), n;
  }
  function bo(e) {
    var t = this;
    this.next = null, this.entry = null, this.finish = function (n) {
      var r = t.entry;
      for (t.entry = null; r;) {
        var i = r.callback;
        e.pendingcb--, i(n), r = r.next;
      }
      e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t;
    };
  }
  Wi.prototype.read = function (e) {
    Vi("read", e), e = parseInt(e, 10);
    var t = this._readableState,
      n = e;
    if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return Vi("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? io(this) : Zi(this), null;
    if (0 === (e = Qi(e, t)) && t.ended) return 0 === t.length && io(this), null;
    var r,
      i = t.needReadable;
    return Vi("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && Vi("length less than watermark", i = !0), t.ended || t.reading ? Vi("reading or ended", i = !1) : i && (Vi("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = Qi(n, t))), null === (r = e > 0 ? ro(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), n !== e && t.ended && io(this)), null !== r && this.emit("data", r), r;
  }, Wi.prototype._read = function (e) {
    this.emit("error", new Error("not implemented"));
  }, Wi.prototype.pipe = function (e, t) {
    var n = this,
      r = this._readableState;
    switch (r.pipesCount) {
      case 0:
        r.pipes = e;
        break;
      case 1:
        r.pipes = [r.pipes, e];
        break;
      default:
        r.pipes.push(e);
    }
    r.pipesCount += 1, Vi("pipe count=%d opts=%j", r.pipesCount, t);
    var i = !t || !1 !== t.end ? a : c;
    function o(e) {
      Vi("onunpipe"), e === n && c();
    }
    function a() {
      Vi("onend"), e.end();
    }
    r.endEmitted ? Ee(i) : n.once("end", i), e.on("unpipe", o);
    var s = function (e) {
      return function () {
        var t = e._readableState;
        Vi("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && e.listeners("data").length && (t.flowing = !0, no(e));
      };
    }(n);
    e.on("drain", s);
    var u = !1;
    function c() {
      Vi("cleanup"), e.removeListener("close", h), e.removeListener("finish", p), e.removeListener("drain", s), e.removeListener("error", f), e.removeListener("unpipe", o), n.removeListener("end", a), n.removeListener("end", c), n.removeListener("data", d), u = !0, !r.awaitDrain || e._writableState && !e._writableState.needDrain || s();
    }
    var l = !1;
    function d(t) {
      Vi("ondata"), l = !1, !1 !== e.write(t) || l || ((1 === r.pipesCount && r.pipes === e || r.pipesCount > 1 && -1 !== ao(r.pipes, e)) && !u && (Vi("false write response, pause", n._readableState.awaitDrain), n._readableState.awaitDrain++, l = !0), n.pause());
    }
    function f(t) {
      Vi("onerror", t), m(), e.removeListener("error", f), 0 === function (e, t) {
        return e.listeners(t).length;
      }(e, "error") && e.emit("error", t);
    }
    function h() {
      e.removeListener("finish", p), m();
    }
    function p() {
      Vi("onfinish"), e.removeListener("close", h), m();
    }
    function m() {
      Vi("unpipe"), n.unpipe(e);
    }
    return n.on("data", d), function (e, t, n) {
      if ("function" == typeof e.prependListener) return e.prependListener(t, n);
      e._events && e._events[t] ? Array.isArray(e._events[t]) ? e._events[t].unshift(n) : e._events[t] = [n, e._events[t]] : e.on(t, n);
    }(e, "error", f), e.once("close", h), e.once("finish", p), e.emit("pipe", n), r.flowing || (Vi("pipe resume"), n.resume()), e;
  }, Wi.prototype.unpipe = function (e) {
    var t = this._readableState;
    if (0 === t.pipesCount) return this;
    if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this)), this;
    if (!e) {
      var n = t.pipes,
        r = t.pipesCount;
      t.pipes = null, t.pipesCount = 0, t.flowing = !1;
      for (var i = 0; i < r; i++) n[i].emit("unpipe", this);
      return this;
    }
    var o = ao(t.pipes, e);
    return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this)), this;
  }, Wi.prototype.on = function (e, t) {
    var n = Qe.prototype.on.call(this, e, t);
    if ("data" === e) !1 !== this._readableState.flowing && this.resume();else if ("readable" === e) {
      var r = this._readableState;
      r.endEmitted || r.readableListening || (r.readableListening = r.needReadable = !0, r.emittedReadable = !1, r.reading ? r.length && Zi(this) : Ee(eo, this));
    }
    return n;
  }, Wi.prototype.addListener = Wi.prototype.on, Wi.prototype.resume = function () {
    var e = this._readableState;
    return e.flowing || (Vi("resume"), e.flowing = !0, function (e, t) {
      t.resumeScheduled || (t.resumeScheduled = !0, Ee(to, e, t));
    }(this, e)), this;
  }, Wi.prototype.pause = function () {
    return Vi("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (Vi("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  }, Wi.prototype.wrap = function (e) {
    var t = this._readableState,
      n = !1,
      r = this;
    for (var i in e.on("end", function () {
      if (Vi("wrapped end"), t.decoder && !t.ended) {
        var e = t.decoder.end();
        e && e.length && r.push(e);
      }
      r.push(null);
    }), e.on("data", function (i) {
      (Vi("wrapped data"), t.decoder && (i = t.decoder.write(i)), t.objectMode && null == i) || (t.objectMode || i && i.length) && (r.push(i) || (n = !0, e.pause()));
    }), e) void 0 === this[i] && "function" == typeof e[i] && (this[i] = function (t) {
      return function () {
        return e[t].apply(e, arguments);
      };
    }(i));
    return function (e, t) {
      for (var n = 0, r = e.length; n < r; n++) t(e[n], n);
    }(["error", "close", "destroy", "pause", "resume"], function (t) {
      e.on(t, r.emit.bind(r, t));
    }), r._read = function (t) {
      Vi("wrapped _read", t), n && (n = !1, e.resume());
    }, r;
  }, Wi._fromList = ro, lo.WritableState = co, it(lo, Qe), co.prototype.getBuffer = function () {
    for (var e = this.bufferedRequest, t = []; e;) t.push(e), e = e.next;
    return t;
  }, lo.prototype.pipe = function () {
    this.emit("error", new Error("Cannot pipe, not readable"));
  }, lo.prototype.write = function (e, t, n) {
    var r = this._writableState,
      i = !1;
    return "function" == typeof t && (n = t, t = null), A.isBuffer(e) ? t = "buffer" : t || (t = r.defaultEncoding), "function" != typeof n && (n = so), r.ended ? function (e, t) {
      var n = new Error("write after end");
      e.emit("error", n), Ee(t, n);
    }(this, n) : function (e, t, n, r) {
      var i = !0,
        o = !1;
      return null === n ? o = new TypeError("May not write null values to stream") : A.isBuffer(n) || "string" == typeof n || void 0 === n || t.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (e.emit("error", o), Ee(r, o), i = !1), i;
    }(this, r, e, n) && (r.pendingcb++, i = function (e, t, n, r, i) {
      n = function (e, t, n) {
        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = A.from(t, n));
        return t;
      }(t, n, r), A.isBuffer(n) && (r = "buffer");
      var o = t.objectMode ? 1 : n.length;
      t.length += o;
      var a = t.length < t.highWaterMark;
      a || (t.needDrain = !0);
      if (t.writing || t.corked) {
        var s = t.lastBufferedRequest;
        t.lastBufferedRequest = new uo(n, r, i), s ? s.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
      } else fo(e, t, !1, o, n, r, i);
      return a;
    }(this, r, e, t, n)), i;
  }, lo.prototype.cork = function () {
    this._writableState.corked++;
  }, lo.prototype.uncork = function () {
    var e = this._writableState;
    e.corked && (e.corked--, e.writing || e.corked || e.finished || e.bufferProcessing || !e.bufferedRequest || po(this, e));
  }, lo.prototype.setDefaultEncoding = function (e) {
    if ("string" == typeof e && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
    return this._writableState.defaultEncoding = e, this;
  }, lo.prototype._write = function (e, t, n) {
    n(new Error("not implemented"));
  }, lo.prototype._writev = null, lo.prototype.end = function (e, t, n) {
    var r = this._writableState;
    "function" == typeof e ? (n = e, e = null, t = null) : "function" == typeof t && (n = t, t = null), null != e && this.write(e, t), r.corked && (r.corked = 1, this.uncork()), r.ending || r.finished || function (e, t, n) {
      t.ending = !0, vo(e, t), n && (t.finished ? Ee(n) : e.once("finish", n));
      t.ended = !0, e.writable = !1;
    }(this, r, n);
  }, it(_o, Wi);
  for (var yo = Object.keys(lo.prototype), wo = 0; wo < yo.length; wo++) {
    var Ao = yo[wo];
    _o.prototype[Ao] || (_o.prototype[Ao] = lo.prototype[Ao]);
  }
  function _o(e) {
    if (!(this instanceof _o)) return new _o(e);
    Wi.call(this, e), lo.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", Eo);
  }
  function Eo() {
    this.allowHalfOpen || this._writableState.ended || Ee(So, this);
  }
  function So(e) {
    e.end();
  }
  function ko(e) {
    this.afterTransform = function (t, n) {
      return function (e, t, n) {
        var r = e._transformState;
        r.transforming = !1;
        var i = r.writecb;
        if (!i) return e.emit("error", new Error("no writecb in Transform class"));
        r.writechunk = null, r.writecb = null, null != n && e.push(n);
        i(t);
        var o = e._readableState;
        o.reading = !1, (o.needReadable || o.length < o.highWaterMark) && e._read(o.highWaterMark);
      }(e, t, n);
    }, this.needTransform = !1, this.transforming = !1, this.writecb = null, this.writechunk = null, this.writeencoding = null;
  }
  function Mo(e) {
    if (!(this instanceof Mo)) return new Mo(e);
    _o.call(this, e), this._transformState = new ko(this);
    var t = this;
    this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.once("prefinish", function () {
      "function" == typeof this._flush ? this._flush(function (e) {
        Co(t, e);
      }) : Co(t);
    });
  }
  function Co(e, t) {
    if (t) return e.emit("error", t);
    var n = e._writableState,
      r = e._transformState;
    if (n.length) throw new Error("Calling transform done when ws.length != 0");
    if (r.transforming) throw new Error("Calling transform done when still transforming");
    return e.push(null);
  }
  function xo(e) {
    if (!(this instanceof xo)) return new xo(e);
    Mo.call(this, e);
  }
  function Ro() {
    Qe.call(this);
  }
  it(Mo, _o), Mo.prototype.push = function (e, t) {
    return this._transformState.needTransform = !1, _o.prototype.push.call(this, e, t);
  }, Mo.prototype._transform = function (e, t, n) {
    throw new Error("Not implemented");
  }, Mo.prototype._write = function (e, t, n) {
    var r = this._transformState;
    if (r.writecb = n, r.writechunk = e, r.writeencoding = t, !r.transforming) {
      var i = this._readableState;
      (r.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
    }
  }, Mo.prototype._read = function (e) {
    var t = this._transformState;
    null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
  }, it(xo, Mo), xo.prototype._transform = function (e, t, n) {
    n(null, e);
  }, it(Ro, Qe), Ro.Readable = Wi, Ro.Writable = lo, Ro.Duplex = _o, Ro.Transform = Mo, Ro.PassThrough = xo, Ro.Stream = Ro, Ro.prototype.pipe = function (e, t) {
    var n = this;
    function r(t) {
      e.writable && !1 === e.write(t) && n.pause && n.pause();
    }
    function i() {
      n.readable && n.resume && n.resume();
    }
    n.on("data", r), e.on("drain", i), e._isStdio || t && !1 === t.end || (n.on("end", a), n.on("close", s));
    var o = !1;
    function a() {
      o || (o = !0, e.end());
    }
    function s() {
      o || (o = !0, "function" == typeof e.destroy && e.destroy());
    }
    function u(e) {
      if (c(), 0 === Qe.listenerCount(this, "error")) throw e;
    }
    function c() {
      n.removeListener("data", r), e.removeListener("drain", i), n.removeListener("end", a), n.removeListener("close", s), n.removeListener("error", u), e.removeListener("error", u), n.removeListener("end", c), n.removeListener("close", c), e.removeListener("close", c);
    }
    return n.on("error", u), e.on("error", u), n.on("end", c), n.on("close", c), e.on("close", c), e.emit("pipe", n), e;
  };
  var Io = i(Object.freeze({
      __proto__: null,
      Duplex: _o,
      PassThrough: xo,
      Readable: Wi,
      Stream: Ro,
      Transform: Mo,
      Writable: lo,
      default: Ro
    })),
    To = i(Hi),
    Po = ze().Buffer,
    Oo = Io.Transform,
    Lo = To.StringDecoder;
  function No(e) {
    Oo.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  We(No, Oo), No.prototype.update = function (e, t, n) {
    "string" == typeof e && (e = Po.from(e, t));
    var r = this._update(e);
    return this.hashMode ? this : (n && (r = this._toString(r, n)), r);
  }, No.prototype.setAutoPadding = function () {}, No.prototype.getAuthTag = function () {
    throw new Error("trying to get auth tag in unsupported state");
  }, No.prototype.setAuthTag = function () {
    throw new Error("trying to set auth tag in unsupported state");
  }, No.prototype.setAAD = function () {
    throw new Error("trying to set aad in unsupported state");
  }, No.prototype._transform = function (e, t, n) {
    var r;
    try {
      this.hashMode ? this._update(e) : this.push(this._update(e));
    } catch (e) {
      r = e;
    } finally {
      n(r);
    }
  }, No.prototype._flush = function (e) {
    var t;
    try {
      this.push(this.__final());
    } catch (e) {
      t = e;
    }
    e(t);
  }, No.prototype._finalOrDigest = function (e) {
    var t = this.__final() || Po.alloc(0);
    return e && (t = this._toString(t, e, !0)), t;
  }, No.prototype._toString = function (e, t, n) {
    if (this._decoder || (this._decoder = new Lo(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");
    var r = this._decoder.write(e);
    return n && (r += this._decoder.end()), r;
  };
  var Do = No,
    Bo = or,
    jo = Er,
    Fo = Bi,
    zo = Do;
  function Uo(e) {
    zo.call(this, "digest"), this._hash = e;
  }
  We(Uo, zo), Uo.prototype._update = function (e) {
    this._hash.update(e);
  }, Uo.prototype._final = function () {
    return this._hash.digest();
  };
  var qo = function (e) {
      return "md5" === (e = e.toLowerCase()) ? new Bo() : "rmd160" === e || "ripemd160" === e ? new jo() : new Uo(Fo(e));
    },
    Ko = We,
    Ho = ze().Buffer,
    Vo = Do,
    $o = Ho.alloc(128),
    Wo = 64;
  function Yo(e, t) {
    Vo.call(this, "digest"), "string" == typeof t && (t = Ho.from(t)), this._alg = e, this._key = t, t.length > Wo ? t = e(t) : t.length < Wo && (t = Ho.concat([t, $o], Wo));
    for (var n = this._ipad = Ho.allocUnsafe(Wo), r = this._opad = Ho.allocUnsafe(Wo), i = 0; i < Wo; i++) n[i] = 54 ^ t[i], r[i] = 92 ^ t[i];
    this._hash = [n];
  }
  Ko(Yo, Vo), Yo.prototype._update = function (e) {
    this._hash.push(e);
  }, Yo.prototype._final = function () {
    var e = this._alg(Ho.concat(this._hash));
    return this._alg(Ho.concat([this._opad, e]));
  };
  var Go = or,
    Qo = function (e) {
      return new Go().update(e).digest();
    },
    Zo = We,
    Jo = Yo,
    Xo = Do,
    ea = ze().Buffer,
    ta = Qo,
    na = Er,
    ra = Bi,
    ia = ea.alloc(128);
  function oa(e, t) {
    Xo.call(this, "digest"), "string" == typeof t && (t = ea.from(t));
    var n = "sha512" === e || "sha384" === e ? 128 : 64;
    (this._alg = e, this._key = t, t.length > n) ? t = ("rmd160" === e ? new na() : ra(e)).update(t).digest() : t.length < n && (t = ea.concat([t, ia], n));
    for (var r = this._ipad = ea.allocUnsafe(n), i = this._opad = ea.allocUnsafe(n), o = 0; o < n; o++) r[o] = 54 ^ t[o], i[o] = 92 ^ t[o];
    this._hash = "rmd160" === e ? new na() : ra(e), this._hash.update(r);
  }
  Zo(oa, Xo), oa.prototype._update = function (e) {
    this._hash.update(e);
  }, oa.prototype._final = function () {
    var e = this._hash.digest();
    return ("rmd160" === this._alg ? new na() : ra(this._alg)).update(this._opad).update(e).digest();
  };
  var aa,
    sa = function (e, t) {
      return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new oa("rmd160", t) : "md5" === e ? new Jo(ta, t) : new oa(e, t);
    },
    ua = {
      sha224WithRSAEncryption: {
        sign: "rsa",
        hash: "sha224",
        id: "302d300d06096086480165030402040500041c"
      },
      "RSA-SHA224": {
        sign: "ecdsa/rsa",
        hash: "sha224",
        id: "302d300d06096086480165030402040500041c"
      },
      sha256WithRSAEncryption: {
        sign: "rsa",
        hash: "sha256",
        id: "3031300d060960864801650304020105000420"
      },
      "RSA-SHA256": {
        sign: "ecdsa/rsa",
        hash: "sha256",
        id: "3031300d060960864801650304020105000420"
      },
      sha384WithRSAEncryption: {
        sign: "rsa",
        hash: "sha384",
        id: "3041300d060960864801650304020205000430"
      },
      "RSA-SHA384": {
        sign: "ecdsa/rsa",
        hash: "sha384",
        id: "3041300d060960864801650304020205000430"
      },
      sha512WithRSAEncryption: {
        sign: "rsa",
        hash: "sha512",
        id: "3051300d060960864801650304020305000440"
      },
      "RSA-SHA512": {
        sign: "ecdsa/rsa",
        hash: "sha512",
        id: "3051300d060960864801650304020305000440"
      },
      "RSA-SHA1": {
        sign: "rsa",
        hash: "sha1",
        id: "3021300906052b0e03021a05000414"
      },
      "ecdsa-with-SHA1": {
        sign: "ecdsa",
        hash: "sha1",
        id: ""
      },
      sha256: {
        sign: "ecdsa",
        hash: "sha256",
        id: ""
      },
      sha224: {
        sign: "ecdsa",
        hash: "sha224",
        id: ""
      },
      sha384: {
        sign: "ecdsa",
        hash: "sha384",
        id: ""
      },
      sha512: {
        sign: "ecdsa",
        hash: "sha512",
        id: ""
      },
      "DSA-SHA": {
        sign: "dsa",
        hash: "sha1",
        id: ""
      },
      "DSA-SHA1": {
        sign: "dsa",
        hash: "sha1",
        id: ""
      },
      DSA: {
        sign: "dsa",
        hash: "sha1",
        id: ""
      },
      "DSA-WITH-SHA224": {
        sign: "dsa",
        hash: "sha224",
        id: ""
      },
      "DSA-SHA224": {
        sign: "dsa",
        hash: "sha224",
        id: ""
      },
      "DSA-WITH-SHA256": {
        sign: "dsa",
        hash: "sha256",
        id: ""
      },
      "DSA-SHA256": {
        sign: "dsa",
        hash: "sha256",
        id: ""
      },
      "DSA-WITH-SHA384": {
        sign: "dsa",
        hash: "sha384",
        id: ""
      },
      "DSA-SHA384": {
        sign: "dsa",
        hash: "sha384",
        id: ""
      },
      "DSA-WITH-SHA512": {
        sign: "dsa",
        hash: "sha512",
        id: ""
      },
      "DSA-SHA512": {
        sign: "dsa",
        hash: "sha512",
        id: ""
      },
      "DSA-RIPEMD160": {
        sign: "dsa",
        hash: "rmd160",
        id: ""
      },
      ripemd160WithRSA: {
        sign: "rsa",
        hash: "rmd160",
        id: "3021300906052b2403020105000414"
      },
      "RSA-RIPEMD160": {
        sign: "rsa",
        hash: "rmd160",
        id: "3021300906052b2403020105000414"
      },
      md5WithRSAEncryption: {
        sign: "rsa",
        hash: "md5",
        id: "3020300c06082a864886f70d020505000410"
      },
      "RSA-MD5": {
        sign: "rsa",
        hash: "md5",
        id: "3020300c06082a864886f70d020505000410"
      }
    },
    ca = ua,
    la = {},
    da = Math.pow(2, 30) - 1,
    fa = function (e, t) {
      if ("number" != typeof e) throw new TypeError("Iterations not a number");
      if (e < 0) throw new TypeError("Bad iterations");
      if ("number" != typeof t) throw new TypeError("Key length not a number");
      if (t < 0 || t > da || t != t) throw new TypeError("Bad key length");
    };
  if (n.process && n.process.browser) aa = "utf-8";else if (n.process && n.process.version) {
    aa = parseInt(Be.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary";
  } else aa = "utf-8";
  var ha = aa,
    pa = ze().Buffer,
    ma = function (e, t, n) {
      if (pa.isBuffer(e)) return e;
      if ("string" == typeof e) return pa.from(e, t);
      if (ArrayBuffer.isView(e)) return pa.from(e.buffer);
      throw new TypeError(n + " must be a string, a Buffer, a typed array or a DataView");
    },
    ga = Qo,
    va = Er,
    ba = Bi,
    ya = ze().Buffer,
    wa = fa,
    Aa = ha,
    _a = ma,
    Ea = ya.alloc(128),
    Sa = {
      md5: 16,
      sha1: 20,
      sha224: 28,
      sha256: 32,
      sha384: 48,
      sha512: 64,
      rmd160: 20,
      ripemd160: 20
    };
  function ka(e, t, n) {
    var r = function (e) {
        function t(t) {
          return ba(e).update(t).digest();
        }
        function n(e) {
          return new va().update(e).digest();
        }
        return "rmd160" === e || "ripemd160" === e ? n : "md5" === e ? ga : t;
      }(e),
      i = "sha512" === e || "sha384" === e ? 128 : 64;
    t.length > i ? t = r(t) : t.length < i && (t = ya.concat([t, Ea], i));
    for (var o = ya.allocUnsafe(i + Sa[e]), a = ya.allocUnsafe(i + Sa[e]), s = 0; s < i; s++) o[s] = 54 ^ t[s], a[s] = 92 ^ t[s];
    var u = ya.allocUnsafe(i + n + 4);
    o.copy(u, 0, 0, i), this.ipad1 = u, this.ipad2 = o, this.opad = a, this.alg = e, this.blocksize = i, this.hash = r, this.size = Sa[e];
  }
  ka.prototype.run = function (e, t) {
    return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  var Ma,
    Ca,
    xa = function (e, t, n, r, i) {
      wa(n, r);
      var o = new ka(i = i || "sha1", e = _a(e, Aa, "Password"), (t = _a(t, Aa, "Salt")).length),
        a = ya.allocUnsafe(r),
        s = ya.allocUnsafe(t.length + 4);
      t.copy(s, 0, 0, t.length);
      for (var u = 0, c = Sa[i], l = Math.ceil(r / c), d = 1; d <= l; d++) {
        s.writeUInt32BE(d, t.length);
        for (var f = o.run(s, o.ipad1), h = f, p = 1; p < n; p++) {
          h = o.run(h, o.ipad2);
          for (var m = 0; m < c; m++) f[m] ^= h[m];
        }
        f.copy(a, u), u += c;
      }
      return a;
    },
    Ra = ze().Buffer,
    Ia = fa,
    Ta = ha,
    Pa = xa,
    Oa = ma,
    La = n.crypto && n.crypto.subtle,
    Na = {
      sha: "SHA-1",
      "sha-1": "SHA-1",
      sha1: "SHA-1",
      sha256: "SHA-256",
      "sha-256": "SHA-256",
      sha384: "SHA-384",
      "sha-384": "SHA-384",
      "sha-512": "SHA-512",
      sha512: "SHA-512"
    },
    Da = [];
  function Ba() {
    return Ca || (Ca = n.process && n.process.nextTick ? n.process.nextTick : n.queueMicrotask ? n.queueMicrotask : n.setImmediate ? n.setImmediate : n.setTimeout);
  }
  function ja(e, t, n, r, i) {
    return La.importKey("raw", e, {
      name: "PBKDF2"
    }, !1, ["deriveBits"]).then(function (e) {
      return La.deriveBits({
        name: "PBKDF2",
        salt: t,
        iterations: n,
        hash: {
          name: i
        }
      }, e, r << 3);
    }).then(function (e) {
      return Ra.from(e);
    });
  }
  la.pbkdf2 = function (e, t, r, i, o, a) {
    "function" == typeof o && (a = o, o = void 0);
    var s = Na[(o = o || "sha1").toLowerCase()];
    if (s && "function" == typeof n.Promise) {
      if (Ia(r, i), e = Oa(e, Ta, "Password"), t = Oa(t, Ta, "Salt"), "function" != typeof a) throw new Error("No callback provided to pbkdf2");
      !function (e, t) {
        e.then(function (e) {
          Ba()(function () {
            t(null, e);
          });
        }, function (e) {
          Ba()(function () {
            t(e);
          });
        });
      }(function (e) {
        if (n.process && !n.process.browser) return Promise.resolve(!1);
        if (!La || !La.importKey || !La.deriveBits) return Promise.resolve(!1);
        if (void 0 !== Da[e]) return Da[e];
        var t = ja(Ma = Ma || Ra.alloc(8), Ma, 10, 128, e).then(function () {
          return !0;
        }).catch(function () {
          return !1;
        });
        return Da[e] = t, t;
      }(s).then(function (n) {
        return n ? ja(e, t, r, i, s) : Pa(e, t, r, i, o);
      }), a);
    } else Ba()(function () {
      var n;
      try {
        n = Pa(e, t, r, i, o);
      } catch (e) {
        return a(e);
      }
      a(null, n);
    });
  }, la.pbkdf2Sync = xa;
  var Fa = {},
    za = {},
    Ua = {
      readUInt32BE: function (e, t) {
        return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
      },
      writeUInt32BE: function (e, t, n) {
        e[0 + n] = t >>> 24, e[1 + n] = t >>> 16 & 255, e[2 + n] = t >>> 8 & 255, e[3 + n] = 255 & t;
      },
      ip: function (e, t, n, r) {
        for (var i = 0, o = 0, a = 6; a >= 0; a -= 2) {
          for (var s = 0; s <= 24; s += 8) i <<= 1, i |= t >>> s + a & 1;
          for (s = 0; s <= 24; s += 8) i <<= 1, i |= e >>> s + a & 1;
        }
        for (a = 6; a >= 0; a -= 2) {
          for (s = 1; s <= 25; s += 8) o <<= 1, o |= t >>> s + a & 1;
          for (s = 1; s <= 25; s += 8) o <<= 1, o |= e >>> s + a & 1;
        }
        n[r + 0] = i >>> 0, n[r + 1] = o >>> 0;
      },
      rip: function (e, t, n, r) {
        for (var i = 0, o = 0, a = 0; a < 4; a++) for (var s = 24; s >= 0; s -= 8) i <<= 1, i |= t >>> s + a & 1, i <<= 1, i |= e >>> s + a & 1;
        for (a = 4; a < 8; a++) for (s = 24; s >= 0; s -= 8) o <<= 1, o |= t >>> s + a & 1, o <<= 1, o |= e >>> s + a & 1;
        n[r + 0] = i >>> 0, n[r + 1] = o >>> 0;
      },
      pc1: function (e, t, n, r) {
        for (var i = 0, o = 0, a = 7; a >= 5; a--) {
          for (var s = 0; s <= 24; s += 8) i <<= 1, i |= t >> s + a & 1;
          for (s = 0; s <= 24; s += 8) i <<= 1, i |= e >> s + a & 1;
        }
        for (s = 0; s <= 24; s += 8) i <<= 1, i |= t >> s + a & 1;
        for (a = 1; a <= 3; a++) {
          for (s = 0; s <= 24; s += 8) o <<= 1, o |= t >> s + a & 1;
          for (s = 0; s <= 24; s += 8) o <<= 1, o |= e >> s + a & 1;
        }
        for (s = 0; s <= 24; s += 8) o <<= 1, o |= e >> s + a & 1;
        n[r + 0] = i >>> 0, n[r + 1] = o >>> 0;
      },
      r28shl: function (e, t) {
        return e << t & 268435455 | e >>> 28 - t;
      }
    },
    qa = [14, 11, 17, 4, 27, 23, 25, 0, 13, 22, 7, 18, 5, 9, 16, 24, 2, 20, 12, 21, 1, 8, 15, 26, 15, 4, 25, 19, 9, 1, 26, 16, 5, 11, 23, 8, 12, 7, 17, 0, 22, 3, 10, 14, 6, 20, 27, 24];
  Ua.pc2 = function (e, t, n, r) {
    for (var i = 0, o = 0, a = qa.length >>> 1, s = 0; s < a; s++) i <<= 1, i |= e >>> qa[s] & 1;
    for (s = a; s < qa.length; s++) o <<= 1, o |= t >>> qa[s] & 1;
    n[r + 0] = i >>> 0, n[r + 1] = o >>> 0;
  }, Ua.expand = function (e, t, n) {
    var r = 0,
      i = 0;
    r = (1 & e) << 5 | e >>> 27;
    for (var o = 23; o >= 15; o -= 4) r <<= 6, r |= e >>> o & 63;
    for (o = 11; o >= 3; o -= 4) i |= e >>> o & 63, i <<= 6;
    i |= (31 & e) << 1 | e >>> 31, t[n + 0] = r >>> 0, t[n + 1] = i >>> 0;
  };
  var Ka = [14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1, 3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8, 4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7, 15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13, 15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14, 9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5, 0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2, 5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9, 10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10, 1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1, 13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7, 11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12, 7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3, 1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9, 10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8, 15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14, 2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1, 8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6, 4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13, 15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3, 12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5, 0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8, 9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10, 7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13, 4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10, 3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6, 1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7, 10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12, 13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4, 10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2, 7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13, 0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11];
  Ua.substitute = function (e, t) {
    for (var n = 0, r = 0; r < 4; r++) {
      n <<= 4, n |= Ka[64 * r + (e >>> 18 - 6 * r & 63)];
    }
    for (r = 0; r < 4; r++) {
      n <<= 4, n |= Ka[256 + 64 * r + (t >>> 18 - 6 * r & 63)];
    }
    return n >>> 0;
  };
  var Ha = [16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22, 30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7];
  Ua.permute = function (e) {
    for (var t = 0, n = 0; n < Ha.length; n++) t <<= 1, t |= e >>> Ha[n] & 1;
    return t >>> 0;
  }, Ua.padSplit = function (e, t, n) {
    for (var r = e.toString(2); r.length < t;) r = "0" + r;
    for (var i = [], o = 0; o < t; o += n) i.push(r.slice(o, o + n));
    return i.join(" ");
  };
  var Va = $a;
  function $a(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
  }
  $a.equal = function (e, t, n) {
    if (e != t) throw new Error(n || "Assertion failed: " + e + " != " + t);
  };
  var Wa = Va;
  function Ya(e) {
    this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = !1 !== e.padding;
  }
  var Ga = Ya;
  Ya.prototype._init = function () {}, Ya.prototype.update = function (e) {
    return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
  }, Ya.prototype._buffer = function (e, t) {
    for (var n = Math.min(this.buffer.length - this.bufferOff, e.length - t), r = 0; r < n; r++) this.buffer[this.bufferOff + r] = e[t + r];
    return this.bufferOff += n, n;
  }, Ya.prototype._flushBuffer = function (e, t) {
    return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
  }, Ya.prototype._updateEncrypt = function (e) {
    var t = 0,
      n = 0,
      r = (this.bufferOff + e.length) / this.blockSize | 0,
      i = new Array(r * this.blockSize);
    0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (n += this._flushBuffer(i, n)));
    for (var o = e.length - (e.length - t) % this.blockSize; t < o; t += this.blockSize) this._update(e, t, i, n), n += this.blockSize;
    for (; t < e.length; t++, this.bufferOff++) this.buffer[this.bufferOff] = e[t];
    return i;
  }, Ya.prototype._updateDecrypt = function (e) {
    for (var t = 0, n = 0, r = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, i = new Array(r * this.blockSize); r > 0; r--) t += this._buffer(e, t), n += this._flushBuffer(i, n);
    return t += this._buffer(e, t), i;
  }, Ya.prototype.final = function (e) {
    var t, n;
    return e && (t = this.update(e)), n = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(n) : n;
  }, Ya.prototype._pad = function (e, t) {
    if (0 === t) return !1;
    for (; t < e.length;) e[t++] = 0;
    return !0;
  }, Ya.prototype._finalEncrypt = function () {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var e = new Array(this.blockSize);
    return this._update(this.buffer, 0, e, 0), e;
  }, Ya.prototype._unpad = function (e) {
    return e;
  }, Ya.prototype._finalDecrypt = function () {
    Wa.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var e = new Array(this.blockSize);
    return this._flushBuffer(e, 0), this._unpad(e);
  };
  var Qa = Va,
    Za = Ua,
    Ja = Ga;
  function Xa() {
    this.tmp = new Array(2), this.keys = null;
  }
  function es(e) {
    Ja.call(this, e);
    var t = new Xa();
    this._desState = t, this.deriveKeys(t, e.key);
  }
  We(es, Ja);
  var ts = es;
  es.create = function (e) {
    return new es(e);
  };
  var ns = [1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1];
  es.prototype.deriveKeys = function (e, t) {
    e.keys = new Array(32), Qa.equal(t.length, this.blockSize, "Invalid key length");
    var n = Za.readUInt32BE(t, 0),
      r = Za.readUInt32BE(t, 4);
    Za.pc1(n, r, e.tmp, 0), n = e.tmp[0], r = e.tmp[1];
    for (var i = 0; i < e.keys.length; i += 2) {
      var o = ns[i >>> 1];
      n = Za.r28shl(n, o), r = Za.r28shl(r, o), Za.pc2(n, r, e.keys, i);
    }
  }, es.prototype._update = function (e, t, n, r) {
    var i = this._desState,
      o = Za.readUInt32BE(e, t),
      a = Za.readUInt32BE(e, t + 4);
    Za.ip(o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, o, a, i.tmp, 0) : this._decrypt(i, o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], Za.writeUInt32BE(n, o, r), Za.writeUInt32BE(n, a, r + 4);
  }, es.prototype._pad = function (e, t) {
    if (!1 === this.padding) return !1;
    for (var n = e.length - t, r = t; r < e.length; r++) e[r] = n;
    return !0;
  }, es.prototype._unpad = function (e) {
    if (!1 === this.padding) return e;
    for (var t = e[e.length - 1], n = e.length - t; n < e.length; n++) Qa.equal(e[n], t);
    return e.slice(0, e.length - t);
  }, es.prototype._encrypt = function (e, t, n, r, i) {
    for (var o = t, a = n, s = 0; s < e.keys.length; s += 2) {
      var u = e.keys[s],
        c = e.keys[s + 1];
      Za.expand(a, e.tmp, 0), u ^= e.tmp[0], c ^= e.tmp[1];
      var l = Za.substitute(u, c),
        d = a;
      a = (o ^ Za.permute(l)) >>> 0, o = d;
    }
    Za.rip(a, o, r, i);
  }, es.prototype._decrypt = function (e, t, n, r, i) {
    for (var o = n, a = t, s = e.keys.length - 2; s >= 0; s -= 2) {
      var u = e.keys[s],
        c = e.keys[s + 1];
      Za.expand(o, e.tmp, 0), u ^= e.tmp[0], c ^= e.tmp[1];
      var l = Za.substitute(u, c),
        d = o;
      o = (a ^ Za.permute(l)) >>> 0, a = d;
    }
    Za.rip(o, a, r, i);
  };
  var rs = {},
    is = Va,
    os = We,
    as = {};
  function ss(e) {
    is.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var t = 0; t < this.iv.length; t++) this.iv[t] = e[t];
  }
  rs.instantiate = function (e) {
    function t(t) {
      e.call(this, t), this._cbcInit();
    }
    os(t, e);
    for (var n = Object.keys(as), r = 0; r < n.length; r++) {
      var i = n[r];
      t.prototype[i] = as[i];
    }
    return t.create = function (e) {
      return new t(e);
    }, t;
  }, as._cbcInit = function () {
    var e = new ss(this.options.iv);
    this._cbcState = e;
  }, as._update = function (e, t, n, r) {
    var i = this._cbcState,
      o = this.constructor.super_.prototype,
      a = i.iv;
    if ("encrypt" === this.type) {
      for (var s = 0; s < this.blockSize; s++) a[s] ^= e[t + s];
      o._update.call(this, a, 0, n, r);
      for (s = 0; s < this.blockSize; s++) a[s] = n[r + s];
    } else {
      o._update.call(this, e, t, n, r);
      for (s = 0; s < this.blockSize; s++) n[r + s] ^= a[s];
      for (s = 0; s < this.blockSize; s++) a[s] = e[t + s];
    }
  };
  var us = Va,
    cs = Ga,
    ls = ts;
  function ds(e, t) {
    us.equal(t.length, 24, "Invalid key length");
    var n = t.slice(0, 8),
      r = t.slice(8, 16),
      i = t.slice(16, 24);
    this.ciphers = "encrypt" === e ? [ls.create({
      type: "encrypt",
      key: n
    }), ls.create({
      type: "decrypt",
      key: r
    }), ls.create({
      type: "encrypt",
      key: i
    })] : [ls.create({
      type: "decrypt",
      key: i
    }), ls.create({
      type: "encrypt",
      key: r
    }), ls.create({
      type: "decrypt",
      key: n
    })];
  }
  function fs(e) {
    cs.call(this, e);
    var t = new ds(this.type, this.options.key);
    this._edeState = t;
  }
  We(fs, cs);
  var hs = fs;
  fs.create = function (e) {
    return new fs(e);
  }, fs.prototype._update = function (e, t, n, r) {
    var i = this._edeState;
    i.ciphers[0]._update(e, t, n, r), i.ciphers[1]._update(n, r, n, r), i.ciphers[2]._update(n, r, n, r);
  }, fs.prototype._pad = ls.prototype._pad, fs.prototype._unpad = ls.prototype._unpad, za.utils = Ua, za.Cipher = Ga, za.DES = ts, za.CBC = rs, za.EDE = hs;
  var ps = Do,
    ms = za,
    gs = We,
    vs = ze().Buffer,
    bs = {
      "des-ede3-cbc": ms.CBC.instantiate(ms.EDE),
      "des-ede3": ms.EDE,
      "des-ede-cbc": ms.CBC.instantiate(ms.EDE),
      "des-ede": ms.EDE,
      "des-cbc": ms.CBC.instantiate(ms.DES),
      "des-ecb": ms.DES
    };
  bs.des = bs["des-cbc"], bs.des3 = bs["des-ede3-cbc"];
  var ys = ws;
  function ws(e) {
    ps.call(this);
    var t,
      n = e.mode.toLowerCase(),
      r = bs[n];
    t = e.decrypt ? "decrypt" : "encrypt";
    var i = e.key;
    vs.isBuffer(i) || (i = vs.from(i)), "des-ede" !== n && "des-ede-cbc" !== n || (i = vs.concat([i, i.slice(0, 8)]));
    var o = e.iv;
    vs.isBuffer(o) || (o = vs.from(o)), this._des = r.create({
      key: i,
      iv: o,
      type: t
    });
  }
  gs(ws, ps), ws.prototype._update = function (e) {
    return vs.from(this._des.update(e));
  }, ws.prototype._final = function () {
    return vs.from(this._des.final());
  };
  var As = {},
    _s = {},
    Es = {
      encrypt: function (e, t) {
        return e._cipher.encryptBlock(t);
      },
      decrypt: function (e, t) {
        return e._cipher.decryptBlock(t);
      }
    },
    Ss = {},
    ks = function (e, t) {
      for (var n = Math.min(e.length, t.length), r = new A(n), i = 0; i < n; ++i) r[i] = e[i] ^ t[i];
      return r;
    },
    Ms = ks;
  Ss.encrypt = function (e, t) {
    var n = Ms(t, e._prev);
    return e._prev = e._cipher.encryptBlock(n), e._prev;
  }, Ss.decrypt = function (e, t) {
    var n = e._prev;
    e._prev = t;
    var r = e._cipher.decryptBlock(t);
    return Ms(r, n);
  };
  var Cs = {},
    xs = ze().Buffer,
    Rs = ks;
  function Is(e, t, n) {
    var r = t.length,
      i = Rs(t, e._cache);
    return e._cache = e._cache.slice(r), e._prev = xs.concat([e._prev, n ? t : i]), i;
  }
  Cs.encrypt = function (e, t, n) {
    for (var r, i = xs.allocUnsafe(0); t.length;) {
      if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = xs.allocUnsafe(0)), !(e._cache.length <= t.length)) {
        i = xs.concat([i, Is(e, t, n)]);
        break;
      }
      r = e._cache.length, i = xs.concat([i, Is(e, t.slice(0, r), n)]), t = t.slice(r);
    }
    return i;
  };
  var Ts = {},
    Ps = ze().Buffer;
  function Os(e, t, n) {
    var r = e._cipher.encryptBlock(e._prev)[0] ^ t;
    return e._prev = Ps.concat([e._prev.slice(1), Ps.from([n ? t : r])]), r;
  }
  Ts.encrypt = function (e, t, n) {
    for (var r = t.length, i = Ps.allocUnsafe(r), o = -1; ++o < r;) i[o] = Os(e, t[o], n);
    return i;
  };
  var Ls = {},
    Ns = ze().Buffer;
  function Ds(e, t, n) {
    for (var r, i, o = -1, a = 0; ++o < 8;) r = t & 1 << 7 - o ? 128 : 0, a += (128 & (i = e._cipher.encryptBlock(e._prev)[0] ^ r)) >> o % 8, e._prev = Bs(e._prev, n ? r : i);
    return a;
  }
  function Bs(e, t) {
    var n = e.length,
      r = -1,
      i = Ns.allocUnsafe(e.length);
    for (e = Ns.concat([e, Ns.from([t])]); ++r < n;) i[r] = e[r] << 1 | e[r + 1] >> 7;
    return i;
  }
  Ls.encrypt = function (e, t, n) {
    for (var r = t.length, i = Ns.allocUnsafe(r), o = -1; ++o < r;) i[o] = Ds(e, t[o], n);
    return i;
  };
  var js = {},
    Fs = ks;
  function zs(e) {
    return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
  }
  js.encrypt = function (e, t) {
    for (; e._cache.length < t.length;) e._cache = A.concat([e._cache, zs(e)]);
    var n = e._cache.slice(0, t.length);
    return e._cache = e._cache.slice(t.length), Fs(t, n);
  };
  var Us = {};
  var qs = function (e) {
      for (var t, n = e.length; n--;) {
        if (255 !== (t = e.readUInt8(n))) {
          t++, e.writeUInt8(t, n);
          break;
        }
        e.writeUInt8(0, n);
      }
    },
    Ks = ks,
    Hs = ze().Buffer,
    Vs = qs;
  function $s(e) {
    var t = e._cipher.encryptBlockRaw(e._prev);
    return Vs(e._prev), t;
  }
  Us.encrypt = function (e, t) {
    var n = Math.ceil(t.length / 16),
      r = e._cache.length;
    e._cache = Hs.concat([e._cache, Hs.allocUnsafe(16 * n)]);
    for (var i = 0; i < n; i++) {
      var o = $s(e),
        a = r + 16 * i;
      e._cache.writeUInt32BE(o[0], a + 0), e._cache.writeUInt32BE(o[1], a + 4), e._cache.writeUInt32BE(o[2], a + 8), e._cache.writeUInt32BE(o[3], a + 12);
    }
    var s = e._cache.slice(0, t.length);
    return e._cache = e._cache.slice(t.length), Ks(t, s);
  };
  var Ws = {
      "aes-128-ecb": {
        cipher: "AES",
        key: 128,
        iv: 0,
        mode: "ECB",
        type: "block"
      },
      "aes-192-ecb": {
        cipher: "AES",
        key: 192,
        iv: 0,
        mode: "ECB",
        type: "block"
      },
      "aes-256-ecb": {
        cipher: "AES",
        key: 256,
        iv: 0,
        mode: "ECB",
        type: "block"
      },
      "aes-128-cbc": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      "aes-192-cbc": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      "aes-256-cbc": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      aes128: {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      aes192: {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      aes256: {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      "aes-128-cfb": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CFB",
        type: "stream"
      },
      "aes-192-cfb": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CFB",
        type: "stream"
      },
      "aes-256-cfb": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CFB",
        type: "stream"
      },
      "aes-128-cfb8": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CFB8",
        type: "stream"
      },
      "aes-192-cfb8": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CFB8",
        type: "stream"
      },
      "aes-256-cfb8": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CFB8",
        type: "stream"
      },
      "aes-128-cfb1": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CFB1",
        type: "stream"
      },
      "aes-192-cfb1": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CFB1",
        type: "stream"
      },
      "aes-256-cfb1": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CFB1",
        type: "stream"
      },
      "aes-128-ofb": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "OFB",
        type: "stream"
      },
      "aes-192-ofb": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "OFB",
        type: "stream"
      },
      "aes-256-ofb": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "OFB",
        type: "stream"
      },
      "aes-128-ctr": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CTR",
        type: "stream"
      },
      "aes-192-ctr": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CTR",
        type: "stream"
      },
      "aes-256-ctr": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CTR",
        type: "stream"
      },
      "aes-128-gcm": {
        cipher: "AES",
        key: 128,
        iv: 12,
        mode: "GCM",
        type: "auth"
      },
      "aes-192-gcm": {
        cipher: "AES",
        key: 192,
        iv: 12,
        mode: "GCM",
        type: "auth"
      },
      "aes-256-gcm": {
        cipher: "AES",
        key: 256,
        iv: 12,
        mode: "GCM",
        type: "auth"
      }
    },
    Ys = {
      ECB: Es,
      CBC: Ss,
      CFB: Cs,
      CFB8: Ts,
      CFB1: Ls,
      OFB: js,
      CTR: Us,
      GCM: Us
    },
    Gs = Ws;
  for (var Qs in Gs) Gs[Qs].module = Ys[Gs[Qs].mode];
  var Zs = Gs,
    Js = {},
    Xs = ze().Buffer;
  function eu(e) {
    Xs.isBuffer(e) || (e = Xs.from(e));
    for (var t = e.length / 4 | 0, n = new Array(t), r = 0; r < t; r++) n[r] = e.readUInt32BE(4 * r);
    return n;
  }
  function tu(e) {
    for (; 0 < e.length; e++) e[0] = 0;
  }
  function nu(e, t, n, r, i) {
    for (var o, a, s, u, c = n[0], l = n[1], d = n[2], f = n[3], h = e[0] ^ t[0], p = e[1] ^ t[1], m = e[2] ^ t[2], g = e[3] ^ t[3], v = 4, b = 1; b < i; b++) o = c[h >>> 24] ^ l[p >>> 16 & 255] ^ d[m >>> 8 & 255] ^ f[255 & g] ^ t[v++], a = c[p >>> 24] ^ l[m >>> 16 & 255] ^ d[g >>> 8 & 255] ^ f[255 & h] ^ t[v++], s = c[m >>> 24] ^ l[g >>> 16 & 255] ^ d[h >>> 8 & 255] ^ f[255 & p] ^ t[v++], u = c[g >>> 24] ^ l[h >>> 16 & 255] ^ d[p >>> 8 & 255] ^ f[255 & m] ^ t[v++], h = o, p = a, m = s, g = u;
    return o = (r[h >>> 24] << 24 | r[p >>> 16 & 255] << 16 | r[m >>> 8 & 255] << 8 | r[255 & g]) ^ t[v++], a = (r[p >>> 24] << 24 | r[m >>> 16 & 255] << 16 | r[g >>> 8 & 255] << 8 | r[255 & h]) ^ t[v++], s = (r[m >>> 24] << 24 | r[g >>> 16 & 255] << 16 | r[h >>> 8 & 255] << 8 | r[255 & p]) ^ t[v++], u = (r[g >>> 24] << 24 | r[h >>> 16 & 255] << 16 | r[p >>> 8 & 255] << 8 | r[255 & m]) ^ t[v++], [o >>>= 0, a >>>= 0, s >>>= 0, u >>>= 0];
  }
  var ru = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54],
    iu = function () {
      for (var e = new Array(256), t = 0; t < 256; t++) e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
      for (var n = [], r = [], i = [[], [], [], []], o = [[], [], [], []], a = 0, s = 0, u = 0; u < 256; ++u) {
        var c = s ^ s << 1 ^ s << 2 ^ s << 3 ^ s << 4;
        c = c >>> 8 ^ 255 & c ^ 99, n[a] = c, r[c] = a;
        var l = e[a],
          d = e[l],
          f = e[d],
          h = 257 * e[c] ^ 16843008 * c;
        i[0][a] = h << 24 | h >>> 8, i[1][a] = h << 16 | h >>> 16, i[2][a] = h << 8 | h >>> 24, i[3][a] = h, h = 16843009 * f ^ 65537 * d ^ 257 * l ^ 16843008 * a, o[0][c] = h << 24 | h >>> 8, o[1][c] = h << 16 | h >>> 16, o[2][c] = h << 8 | h >>> 24, o[3][c] = h, 0 === a ? a = s = 1 : (a = l ^ e[e[e[f ^ l]]], s ^= e[e[s]]);
      }
      return {
        SBOX: n,
        INV_SBOX: r,
        SUB_MIX: i,
        INV_SUB_MIX: o
      };
    }();
  function ou(e) {
    this._key = eu(e), this._reset();
  }
  ou.blockSize = 16, ou.keySize = 32, ou.prototype.blockSize = ou.blockSize, ou.prototype.keySize = ou.keySize, ou.prototype._reset = function () {
    for (var e = this._key, t = e.length, n = t + 6, r = 4 * (n + 1), i = [], o = 0; o < t; o++) i[o] = e[o];
    for (o = t; o < r; o++) {
      var a = i[o - 1];
      o % t == 0 ? (a = a << 8 | a >>> 24, a = iu.SBOX[a >>> 24] << 24 | iu.SBOX[a >>> 16 & 255] << 16 | iu.SBOX[a >>> 8 & 255] << 8 | iu.SBOX[255 & a], a ^= ru[o / t | 0] << 24) : t > 6 && o % t == 4 && (a = iu.SBOX[a >>> 24] << 24 | iu.SBOX[a >>> 16 & 255] << 16 | iu.SBOX[a >>> 8 & 255] << 8 | iu.SBOX[255 & a]), i[o] = i[o - t] ^ a;
    }
    for (var s = [], u = 0; u < r; u++) {
      var c = r - u,
        l = i[c - (u % 4 ? 0 : 4)];
      s[u] = u < 4 || c <= 4 ? l : iu.INV_SUB_MIX[0][iu.SBOX[l >>> 24]] ^ iu.INV_SUB_MIX[1][iu.SBOX[l >>> 16 & 255]] ^ iu.INV_SUB_MIX[2][iu.SBOX[l >>> 8 & 255]] ^ iu.INV_SUB_MIX[3][iu.SBOX[255 & l]];
    }
    this._nRounds = n, this._keySchedule = i, this._invKeySchedule = s;
  }, ou.prototype.encryptBlockRaw = function (e) {
    return nu(e = eu(e), this._keySchedule, iu.SUB_MIX, iu.SBOX, this._nRounds);
  }, ou.prototype.encryptBlock = function (e) {
    var t = this.encryptBlockRaw(e),
      n = Xs.allocUnsafe(16);
    return n.writeUInt32BE(t[0], 0), n.writeUInt32BE(t[1], 4), n.writeUInt32BE(t[2], 8), n.writeUInt32BE(t[3], 12), n;
  }, ou.prototype.decryptBlock = function (e) {
    var t = (e = eu(e))[1];
    e[1] = e[3], e[3] = t;
    var n = nu(e, this._invKeySchedule, iu.INV_SUB_MIX, iu.INV_SBOX, this._nRounds),
      r = Xs.allocUnsafe(16);
    return r.writeUInt32BE(n[0], 0), r.writeUInt32BE(n[3], 4), r.writeUInt32BE(n[2], 8), r.writeUInt32BE(n[1], 12), r;
  }, ou.prototype.scrub = function () {
    tu(this._keySchedule), tu(this._invKeySchedule), tu(this._key);
  }, Js.AES = ou;
  var au = ze().Buffer,
    su = au.alloc(16, 0);
  function uu(e) {
    var t = au.allocUnsafe(16);
    return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
  }
  function cu(e) {
    this.h = e, this.state = au.alloc(16, 0), this.cache = au.allocUnsafe(0);
  }
  cu.prototype.ghash = function (e) {
    for (var t = -1; ++t < e.length;) this.state[t] ^= e[t];
    this._multiply();
  }, cu.prototype._multiply = function () {
    for (var e, t, n, r = [(e = this.h).readUInt32BE(0), e.readUInt32BE(4), e.readUInt32BE(8), e.readUInt32BE(12)], i = [0, 0, 0, 0], o = -1; ++o < 128;) {
      for (0 != (this.state[~~(o / 8)] & 1 << 7 - o % 8) && (i[0] ^= r[0], i[1] ^= r[1], i[2] ^= r[2], i[3] ^= r[3]), n = 0 != (1 & r[3]), t = 3; t > 0; t--) r[t] = r[t] >>> 1 | (1 & r[t - 1]) << 31;
      r[0] = r[0] >>> 1, n && (r[0] = r[0] ^ 225 << 24);
    }
    this.state = uu(i);
  }, cu.prototype.update = function (e) {
    var t;
    for (this.cache = au.concat([this.cache, e]); this.cache.length >= 16;) t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
  }, cu.prototype.final = function (e, t) {
    return this.cache.length && this.ghash(au.concat([this.cache, su], 16)), this.ghash(uu([0, e, 0, t])), this.state;
  };
  var lu = cu,
    du = Js,
    fu = ze().Buffer,
    hu = Do,
    pu = lu,
    mu = ks,
    gu = qs;
  function vu(e, t, n, r) {
    hu.call(this);
    var i = fu.alloc(4, 0);
    this._cipher = new du.AES(t);
    var o = this._cipher.encryptBlock(i);
    this._ghash = new pu(o), n = function (e, t, n) {
      if (12 === t.length) return e._finID = fu.concat([t, fu.from([0, 0, 0, 1])]), fu.concat([t, fu.from([0, 0, 0, 2])]);
      var r = new pu(n),
        i = t.length,
        o = i % 16;
      r.update(t), o && (o = 16 - o, r.update(fu.alloc(o, 0))), r.update(fu.alloc(8, 0));
      var a = 8 * i,
        s = fu.alloc(8);
      s.writeUIntBE(a, 0, 8), r.update(s), e._finID = r.state;
      var u = fu.from(e._finID);
      return gu(u), u;
    }(this, n, o), this._prev = fu.from(n), this._cache = fu.allocUnsafe(0), this._secCache = fu.allocUnsafe(0), this._decrypt = r, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
  }
  We(vu, hu), vu.prototype._update = function (e) {
    if (!this._called && this._alen) {
      var t = 16 - this._alen % 16;
      t < 16 && (t = fu.alloc(t, 0), this._ghash.update(t));
    }
    this._called = !0;
    var n = this._mode.encrypt(this, e);
    return this._decrypt ? this._ghash.update(e) : this._ghash.update(n), this._len += e.length, n;
  }, vu.prototype._final = function () {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var e = mu(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && function (e, t) {
      var n = 0;
      e.length !== t.length && n++;
      for (var r = Math.min(e.length, t.length), i = 0; i < r; ++i) n += e[i] ^ t[i];
      return n;
    }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = e, this._cipher.scrub();
  }, vu.prototype.getAuthTag = function () {
    if (this._decrypt || !fu.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, vu.prototype.setAuthTag = function (e) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = e;
  }, vu.prototype.setAAD = function (e) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(e), this._alen += e.length;
  };
  var bu = vu,
    yu = Js,
    wu = ze().Buffer,
    Au = Do;
  function _u(e, t, n, r) {
    Au.call(this), this._cipher = new yu.AES(t), this._prev = wu.from(n), this._cache = wu.allocUnsafe(0), this._secCache = wu.allocUnsafe(0), this._decrypt = r, this._mode = e;
  }
  We(_u, Au), _u.prototype._update = function (e) {
    return this._mode.encrypt(this, e, this._decrypt);
  }, _u.prototype._final = function () {
    this._cipher.scrub();
  };
  var Eu = _u,
    Su = ze().Buffer,
    ku = or;
  var Mu = function (e, t, n, r) {
      if (Su.isBuffer(e) || (e = Su.from(e, "binary")), t && (Su.isBuffer(t) || (t = Su.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");
      for (var i = n / 8, o = Su.alloc(i), a = Su.alloc(r || 0), s = Su.alloc(0); i > 0 || r > 0;) {
        var u = new ku();
        u.update(s), u.update(e), t && u.update(t), s = u.digest();
        var c = 0;
        if (i > 0) {
          var l = o.length - i;
          c = Math.min(i, s.length), s.copy(o, l, 0, c), i -= c;
        }
        if (c < s.length && r > 0) {
          var d = a.length - r,
            f = Math.min(r, s.length - c);
          s.copy(a, d, c, c + f), r -= f;
        }
      }
      return s.fill(0), {
        key: o,
        iv: a
      };
    },
    Cu = Zs,
    xu = bu,
    Ru = ze().Buffer,
    Iu = Eu,
    Tu = Do,
    Pu = Js,
    Ou = Mu;
  function Lu(e, t, n) {
    Tu.call(this), this._cache = new Du(), this._cipher = new Pu.AES(t), this._prev = Ru.from(n), this._mode = e, this._autopadding = !0;
  }
  We(Lu, Tu), Lu.prototype._update = function (e) {
    var t, n;
    this._cache.add(e);
    for (var r = []; t = this._cache.get();) n = this._mode.encrypt(this, t), r.push(n);
    return Ru.concat(r);
  };
  var Nu = Ru.alloc(16, 16);
  function Du() {
    this.cache = Ru.allocUnsafe(0);
  }
  function Bu(e, t, n) {
    var r = Cu[e.toLowerCase()];
    if (!r) throw new TypeError("invalid suite type");
    if ("string" == typeof t && (t = Ru.from(t)), t.length !== r.key / 8) throw new TypeError("invalid key length " + t.length);
    if ("string" == typeof n && (n = Ru.from(n)), "GCM" !== r.mode && n.length !== r.iv) throw new TypeError("invalid iv length " + n.length);
    return "stream" === r.type ? new Iu(r.module, t, n) : "auth" === r.type ? new xu(r.module, t, n) : new Lu(r.module, t, n);
  }
  Lu.prototype._final = function () {
    var e = this._cache.flush();
    if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
    if (!e.equals(Nu)) throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, Lu.prototype.setAutoPadding = function (e) {
    return this._autopadding = !!e, this;
  }, Du.prototype.add = function (e) {
    this.cache = Ru.concat([this.cache, e]);
  }, Du.prototype.get = function () {
    if (this.cache.length > 15) {
      var e = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), e;
    }
    return null;
  }, Du.prototype.flush = function () {
    for (var e = 16 - this.cache.length, t = Ru.allocUnsafe(e), n = -1; ++n < e;) t.writeUInt8(e, n);
    return Ru.concat([this.cache, t]);
  }, _s.createCipheriv = Bu, _s.createCipher = function (e, t) {
    var n = Cu[e.toLowerCase()];
    if (!n) throw new TypeError("invalid suite type");
    var r = Ou(t, !1, n.key, n.iv);
    return Bu(e, r.key, r.iv);
  };
  var ju = {},
    Fu = bu,
    zu = ze().Buffer,
    Uu = Zs,
    qu = Eu,
    Ku = Do,
    Hu = Js,
    Vu = Mu;
  function $u(e, t, n) {
    Ku.call(this), this._cache = new Wu(), this._last = void 0, this._cipher = new Hu.AES(t), this._prev = zu.from(n), this._mode = e, this._autopadding = !0;
  }
  function Wu() {
    this.cache = zu.allocUnsafe(0);
  }
  function Yu(e, t, n) {
    var r = Uu[e.toLowerCase()];
    if (!r) throw new TypeError("invalid suite type");
    if ("string" == typeof n && (n = zu.from(n)), "GCM" !== r.mode && n.length !== r.iv) throw new TypeError("invalid iv length " + n.length);
    if ("string" == typeof t && (t = zu.from(t)), t.length !== r.key / 8) throw new TypeError("invalid key length " + t.length);
    return "stream" === r.type ? new qu(r.module, t, n, !0) : "auth" === r.type ? new Fu(r.module, t, n, !0) : new $u(r.module, t, n);
  }
  We($u, Ku), $u.prototype._update = function (e) {
    var t, n;
    this._cache.add(e);
    for (var r = []; t = this._cache.get(this._autopadding);) n = this._mode.decrypt(this, t), r.push(n);
    return zu.concat(r);
  }, $u.prototype._final = function () {
    var e = this._cache.flush();
    if (this._autopadding) return function (e) {
      var t = e[15];
      if (t < 1 || t > 16) throw new Error("unable to decrypt data");
      var n = -1;
      for (; ++n < t;) if (e[n + (16 - t)] !== t) throw new Error("unable to decrypt data");
      if (16 === t) return;
      return e.slice(0, 16 - t);
    }(this._mode.decrypt(this, e));
    if (e) throw new Error("data not multiple of block length");
  }, $u.prototype.setAutoPadding = function (e) {
    return this._autopadding = !!e, this;
  }, Wu.prototype.add = function (e) {
    this.cache = zu.concat([this.cache, e]);
  }, Wu.prototype.get = function (e) {
    var t;
    if (e) {
      if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
    } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
    return null;
  }, Wu.prototype.flush = function () {
    if (this.cache.length) return this.cache;
  }, ju.createDecipher = function (e, t) {
    var n = Uu[e.toLowerCase()];
    if (!n) throw new TypeError("invalid suite type");
    var r = Vu(t, !1, n.key, n.iv);
    return Yu(e, r.key, r.iv);
  }, ju.createDecipheriv = Yu;
  var Gu = _s,
    Qu = ju,
    Zu = Ws;
  As.createCipher = As.Cipher = Gu.createCipher, As.createCipheriv = As.Cipheriv = Gu.createCipheriv, As.createDecipher = As.Decipher = Qu.createDecipher, As.createDecipheriv = As.Decipheriv = Qu.createDecipheriv, As.listCiphers = As.getCiphers = function () {
    return Object.keys(Zu);
  };
  var Ju = {};
  !function (e) {
    e["des-ecb"] = {
      key: 8,
      iv: 0
    }, e["des-cbc"] = e.des = {
      key: 8,
      iv: 8
    }, e["des-ede3-cbc"] = e.des3 = {
      key: 24,
      iv: 8
    }, e["des-ede3"] = {
      key: 24,
      iv: 0
    }, e["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, e["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(Ju);
  var Xu = ys,
    ec = As,
    tc = Zs,
    nc = Ju,
    rc = Mu;
  function ic(e, t, n) {
    if (e = e.toLowerCase(), tc[e]) return ec.createCipheriv(e, t, n);
    if (nc[e]) return new Xu({
      key: t,
      iv: n,
      mode: e
    });
    throw new TypeError("invalid suite type");
  }
  function oc(e, t, n) {
    if (e = e.toLowerCase(), tc[e]) return ec.createDecipheriv(e, t, n);
    if (nc[e]) return new Xu({
      key: t,
      iv: n,
      mode: e,
      decrypt: !0
    });
    throw new TypeError("invalid suite type");
  }
  Fa.createCipher = Fa.Cipher = function (e, t) {
    var n, r;
    if (e = e.toLowerCase(), tc[e]) n = tc[e].key, r = tc[e].iv;else {
      if (!nc[e]) throw new TypeError("invalid suite type");
      n = 8 * nc[e].key, r = nc[e].iv;
    }
    var i = rc(t, !1, n, r);
    return ic(e, i.key, i.iv);
  }, Fa.createCipheriv = Fa.Cipheriv = ic, Fa.createDecipher = Fa.Decipher = function (e, t) {
    var n, r;
    if (e = e.toLowerCase(), tc[e]) n = tc[e].key, r = tc[e].iv;else {
      if (!nc[e]) throw new TypeError("invalid suite type");
      n = 8 * nc[e].key, r = nc[e].iv;
    }
    var i = rc(t, !1, n, r);
    return oc(e, i.key, i.iv);
  }, Fa.createDecipheriv = Fa.Decipheriv = oc, Fa.listCiphers = Fa.getCiphers = function () {
    return Object.keys(nc).concat(ec.getCiphers());
  };
  var ac = {},
    sc = {
      exports: {}
    };
  !function (e) {
    !function (e, t) {
      function n(e, t) {
        if (!e) throw new Error(t || "Assertion failed");
      }
      function r(e, t) {
        e.super_ = t;
        var n = function () {};
        n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
      }
      function i(e, t, n) {
        if (i.isBN(e)) return e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (n = t, t = 10), this._init(e || 0, t || 10, n || "be"));
      }
      var o;
      "object" == typeof e ? e.exports = i : t.BN = i, i.BN = i, i.wordSize = 26;
      try {
        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : le.Buffer;
      } catch (e) {}
      function a(e, t) {
        var n = e.charCodeAt(t);
        return n >= 65 && n <= 70 ? n - 55 : n >= 97 && n <= 102 ? n - 87 : n - 48 & 15;
      }
      function s(e, t, n) {
        var r = a(e, n);
        return n - 1 >= t && (r |= a(e, n - 1) << 4), r;
      }
      function u(e, t, n, r) {
        for (var i = 0, o = Math.min(e.length, n), a = t; a < o; a++) {
          var s = e.charCodeAt(a) - 48;
          i *= r, i += s >= 49 ? s - 49 + 10 : s >= 17 ? s - 17 + 10 : s;
        }
        return i;
      }
      i.isBN = function (e) {
        return e instanceof i || null !== e && "object" == typeof e && e.constructor.wordSize === i.wordSize && Array.isArray(e.words);
      }, i.max = function (e, t) {
        return e.cmp(t) > 0 ? e : t;
      }, i.min = function (e, t) {
        return e.cmp(t) < 0 ? e : t;
      }, i.prototype._init = function (e, t, r) {
        if ("number" == typeof e) return this._initNumber(e, t, r);
        if ("object" == typeof e) return this._initArray(e, t, r);
        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
        var i = 0;
        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
      }, i.prototype._initNumber = function (e, t, r) {
        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (n(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
      }, i.prototype._initArray = function (e, t, r) {
        if (n("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) this.words[i] = 0;
        var o,
          a,
          s = 0;
        if ("be" === r) for (i = e.length - 1, o = 0; i >= 0; i -= 3) a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);else if ("le" === r) for (i = 0, o = 0; i < e.length; i += 3) a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
        return this.strip();
      }, i.prototype._parseHex = function (e, t, n) {
        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
        for (var r = 0; r < this.length; r++) this.words[r] = 0;
        var i,
          o = 0,
          a = 0;
        if ("be" === n) for (r = e.length - 1; r >= t; r -= 2) i = s(e, t, r) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;else for (r = (e.length - t) % 2 == 0 ? t + 1 : t; r < e.length; r += 2) i = s(e, t, r) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
        this.strip();
      }, i.prototype._parseBase = function (e, t, n) {
        this.words = [0], this.length = 1;
        for (var r = 0, i = 1; i <= 67108863; i *= t) r++;
        r--, i = i / t | 0;
        for (var o = e.length - n, a = o % r, s = Math.min(o, o - a) + n, c = 0, l = n; l < s; l += r) c = u(e, l, l + r, t), this.imuln(i), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
        if (0 !== a) {
          var d = 1;
          for (c = u(e, l, e.length, t), l = 0; l < a; l++) d *= t;
          this.imuln(d), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
        }
        this.strip();
      }, i.prototype.copy = function (e) {
        e.words = new Array(this.length);
        for (var t = 0; t < this.length; t++) e.words[t] = this.words[t];
        e.length = this.length, e.negative = this.negative, e.red = this.red;
      }, i.prototype.clone = function () {
        var e = new i(null);
        return this.copy(e), e;
      }, i.prototype._expand = function (e) {
        for (; this.length < e;) this.words[this.length++] = 0;
        return this;
      }, i.prototype.strip = function () {
        for (; this.length > 1 && 0 === this.words[this.length - 1];) this.length--;
        return this._normSign();
      }, i.prototype._normSign = function () {
        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
      }, i.prototype.inspect = function () {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var c = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
        l = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
        d = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
      function f(e, t, n) {
        n.negative = t.negative ^ e.negative;
        var r = e.length + t.length | 0;
        n.length = r, r = r - 1 | 0;
        var i = 0 | e.words[0],
          o = 0 | t.words[0],
          a = i * o,
          s = 67108863 & a,
          u = a / 67108864 | 0;
        n.words[0] = s;
        for (var c = 1; c < r; c++) {
          for (var l = u >>> 26, d = 67108863 & u, f = Math.min(c, t.length - 1), h = Math.max(0, c - e.length + 1); h <= f; h++) {
            var p = c - h | 0;
            l += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[h]) + d) / 67108864 | 0, d = 67108863 & a;
          }
          n.words[c] = 0 | d, u = 0 | l;
        }
        return 0 !== u ? n.words[c] = 0 | u : n.length--, n.strip();
      }
      i.prototype.toString = function (e, t) {
        var r;
        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
          r = "";
          for (var i = 0, o = 0, a = 0; a < this.length; a++) {
            var s = this.words[a],
              u = (16777215 & (s << i | o)).toString(16);
            r = 0 !== (o = s >>> 24 - i & 16777215) || a !== this.length - 1 ? c[6 - u.length] + u + r : u + r, (i += 2) >= 26 && (i -= 26, a--);
          }
          for (0 !== o && (r = o.toString(16) + r); r.length % t != 0;) r = "0" + r;
          return 0 !== this.negative && (r = "-" + r), r;
        }
        if (e === (0 | e) && e >= 2 && e <= 36) {
          var f = l[e],
            h = d[e];
          r = "";
          var p = this.clone();
          for (p.negative = 0; !p.isZero();) {
            var m = p.modn(h).toString(e);
            r = (p = p.idivn(h)).isZero() ? m + r : c[f - m.length] + m + r;
          }
          for (this.isZero() && (r = "0" + r); r.length % t != 0;) r = "0" + r;
          return 0 !== this.negative && (r = "-" + r), r;
        }
        n(!1, "Base should be between 2 and 36");
      }, i.prototype.toNumber = function () {
        var e = this.words[0];
        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
      }, i.prototype.toJSON = function () {
        return this.toString(16);
      }, i.prototype.toBuffer = function (e, t) {
        return n(void 0 !== o), this.toArrayLike(o, e, t);
      }, i.prototype.toArray = function (e, t) {
        return this.toArrayLike(Array, e, t);
      }, i.prototype.toArrayLike = function (e, t, r) {
        var i = this.byteLength(),
          o = r || Math.max(1, i);
        n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0"), this.strip();
        var a,
          s,
          u = "le" === t,
          c = new e(o),
          l = this.clone();
        if (u) {
          for (s = 0; !l.isZero(); s++) a = l.andln(255), l.iushrn(8), c[s] = a;
          for (; s < o; s++) c[s] = 0;
        } else {
          for (s = 0; s < o - i; s++) c[s] = 0;
          for (s = 0; !l.isZero(); s++) a = l.andln(255), l.iushrn(8), c[o - s - 1] = a;
        }
        return c;
      }, Math.clz32 ? i.prototype._countBits = function (e) {
        return 32 - Math.clz32(e);
      } : i.prototype._countBits = function (e) {
        var t = e,
          n = 0;
        return t >= 4096 && (n += 13, t >>>= 13), t >= 64 && (n += 7, t >>>= 7), t >= 8 && (n += 4, t >>>= 4), t >= 2 && (n += 2, t >>>= 2), n + t;
      }, i.prototype._zeroBits = function (e) {
        if (0 === e) return 26;
        var t = e,
          n = 0;
        return 0 == (8191 & t) && (n += 13, t >>>= 13), 0 == (127 & t) && (n += 7, t >>>= 7), 0 == (15 & t) && (n += 4, t >>>= 4), 0 == (3 & t) && (n += 2, t >>>= 2), 0 == (1 & t) && n++, n;
      }, i.prototype.bitLength = function () {
        var e = this.words[this.length - 1],
          t = this._countBits(e);
        return 26 * (this.length - 1) + t;
      }, i.prototype.zeroBits = function () {
        if (this.isZero()) return 0;
        for (var e = 0, t = 0; t < this.length; t++) {
          var n = this._zeroBits(this.words[t]);
          if (e += n, 26 !== n) break;
        }
        return e;
      }, i.prototype.byteLength = function () {
        return Math.ceil(this.bitLength() / 8);
      }, i.prototype.toTwos = function (e) {
        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
      }, i.prototype.fromTwos = function (e) {
        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
      }, i.prototype.isNeg = function () {
        return 0 !== this.negative;
      }, i.prototype.neg = function () {
        return this.clone().ineg();
      }, i.prototype.ineg = function () {
        return this.isZero() || (this.negative ^= 1), this;
      }, i.prototype.iuor = function (e) {
        for (; this.length < e.length;) this.words[this.length++] = 0;
        for (var t = 0; t < e.length; t++) this.words[t] = this.words[t] | e.words[t];
        return this.strip();
      }, i.prototype.ior = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuor(e);
      }, i.prototype.or = function (e) {
        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
      }, i.prototype.uor = function (e) {
        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
      }, i.prototype.iuand = function (e) {
        var t;
        t = this.length > e.length ? e : this;
        for (var n = 0; n < t.length; n++) this.words[n] = this.words[n] & e.words[n];
        return this.length = t.length, this.strip();
      }, i.prototype.iand = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuand(e);
      }, i.prototype.and = function (e) {
        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
      }, i.prototype.uand = function (e) {
        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
      }, i.prototype.iuxor = function (e) {
        var t, n;
        this.length > e.length ? (t = this, n = e) : (t = e, n = this);
        for (var r = 0; r < n.length; r++) this.words[r] = t.words[r] ^ n.words[r];
        if (this !== t) for (; r < t.length; r++) this.words[r] = t.words[r];
        return this.length = t.length, this.strip();
      }, i.prototype.ixor = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuxor(e);
      }, i.prototype.xor = function (e) {
        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
      }, i.prototype.uxor = function (e) {
        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
      }, i.prototype.inotn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = 0 | Math.ceil(e / 26),
          r = e % 26;
        this._expand(t), r > 0 && t--;
        for (var i = 0; i < t; i++) this.words[i] = 67108863 & ~this.words[i];
        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
      }, i.prototype.notn = function (e) {
        return this.clone().inotn(e);
      }, i.prototype.setn = function (e, t) {
        n("number" == typeof e && e >= 0);
        var r = e / 26 | 0,
          i = e % 26;
        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
      }, i.prototype.iadd = function (e) {
        var t, n, r;
        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
        this.length > e.length ? (n = this, r = e) : (n = e, r = this);
        for (var i = 0, o = 0; o < r.length; o++) t = (0 | n.words[o]) + (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
        for (; 0 !== i && o < n.length; o++) t = (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
        if (this.length = n.length, 0 !== i) this.words[this.length] = i, this.length++;else if (n !== this) for (; o < n.length; o++) this.words[o] = n.words[o];
        return this;
      }, i.prototype.add = function (e) {
        var t;
        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
      }, i.prototype.isub = function (e) {
        if (0 !== e.negative) {
          e.negative = 0;
          var t = this.iadd(e);
          return e.negative = 1, t._normSign();
        }
        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
        var n,
          r,
          i = this.cmp(e);
        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        i > 0 ? (n = this, r = e) : (n = e, r = this);
        for (var o = 0, a = 0; a < r.length; a++) o = (t = (0 | n.words[a]) - (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
        for (; 0 !== o && a < n.length; a++) o = (t = (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
        if (0 === o && a < n.length && n !== this) for (; a < n.length; a++) this.words[a] = n.words[a];
        return this.length = Math.max(this.length, a), n !== this && (this.negative = 1), this.strip();
      }, i.prototype.sub = function (e) {
        return this.clone().isub(e);
      };
      var h = function (e, t, n) {
        var r,
          i,
          o,
          a = e.words,
          s = t.words,
          u = n.words,
          c = 0,
          l = 0 | a[0],
          d = 8191 & l,
          f = l >>> 13,
          h = 0 | a[1],
          p = 8191 & h,
          m = h >>> 13,
          g = 0 | a[2],
          v = 8191 & g,
          b = g >>> 13,
          y = 0 | a[3],
          w = 8191 & y,
          A = y >>> 13,
          _ = 0 | a[4],
          E = 8191 & _,
          S = _ >>> 13,
          k = 0 | a[5],
          M = 8191 & k,
          C = k >>> 13,
          x = 0 | a[6],
          R = 8191 & x,
          I = x >>> 13,
          T = 0 | a[7],
          P = 8191 & T,
          O = T >>> 13,
          L = 0 | a[8],
          N = 8191 & L,
          D = L >>> 13,
          B = 0 | a[9],
          j = 8191 & B,
          F = B >>> 13,
          z = 0 | s[0],
          U = 8191 & z,
          q = z >>> 13,
          K = 0 | s[1],
          H = 8191 & K,
          V = K >>> 13,
          $ = 0 | s[2],
          W = 8191 & $,
          Y = $ >>> 13,
          G = 0 | s[3],
          Q = 8191 & G,
          Z = G >>> 13,
          J = 0 | s[4],
          X = 8191 & J,
          ee = J >>> 13,
          te = 0 | s[5],
          ne = 8191 & te,
          re = te >>> 13,
          ie = 0 | s[6],
          oe = 8191 & ie,
          ae = ie >>> 13,
          se = 0 | s[7],
          ue = 8191 & se,
          ce = se >>> 13,
          le = 0 | s[8],
          de = 8191 & le,
          fe = le >>> 13,
          he = 0 | s[9],
          pe = 8191 & he,
          me = he >>> 13;
        n.negative = e.negative ^ t.negative, n.length = 19;
        var ge = (c + (r = Math.imul(d, U)) | 0) + ((8191 & (i = (i = Math.imul(d, q)) + Math.imul(f, U) | 0)) << 13) | 0;
        c = ((o = Math.imul(f, q)) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, r = Math.imul(p, U), i = (i = Math.imul(p, q)) + Math.imul(m, U) | 0, o = Math.imul(m, q);
        var ve = (c + (r = r + Math.imul(d, H) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, V) | 0) + Math.imul(f, H) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, V) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, r = Math.imul(v, U), i = (i = Math.imul(v, q)) + Math.imul(b, U) | 0, o = Math.imul(b, q), r = r + Math.imul(p, H) | 0, i = (i = i + Math.imul(p, V) | 0) + Math.imul(m, H) | 0, o = o + Math.imul(m, V) | 0;
        var be = (c + (r = r + Math.imul(d, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Y) | 0) + Math.imul(f, W) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, Y) | 0) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, r = Math.imul(w, U), i = (i = Math.imul(w, q)) + Math.imul(A, U) | 0, o = Math.imul(A, q), r = r + Math.imul(v, H) | 0, i = (i = i + Math.imul(v, V) | 0) + Math.imul(b, H) | 0, o = o + Math.imul(b, V) | 0, r = r + Math.imul(p, W) | 0, i = (i = i + Math.imul(p, Y) | 0) + Math.imul(m, W) | 0, o = o + Math.imul(m, Y) | 0;
        var ye = (c + (r = r + Math.imul(d, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Z) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, Z) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, r = Math.imul(E, U), i = (i = Math.imul(E, q)) + Math.imul(S, U) | 0, o = Math.imul(S, q), r = r + Math.imul(w, H) | 0, i = (i = i + Math.imul(w, V) | 0) + Math.imul(A, H) | 0, o = o + Math.imul(A, V) | 0, r = r + Math.imul(v, W) | 0, i = (i = i + Math.imul(v, Y) | 0) + Math.imul(b, W) | 0, o = o + Math.imul(b, Y) | 0, r = r + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, Z) | 0) + Math.imul(m, Q) | 0, o = o + Math.imul(m, Z) | 0;
        var we = (c + (r = r + Math.imul(d, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, r = Math.imul(M, U), i = (i = Math.imul(M, q)) + Math.imul(C, U) | 0, o = Math.imul(C, q), r = r + Math.imul(E, H) | 0, i = (i = i + Math.imul(E, V) | 0) + Math.imul(S, H) | 0, o = o + Math.imul(S, V) | 0, r = r + Math.imul(w, W) | 0, i = (i = i + Math.imul(w, Y) | 0) + Math.imul(A, W) | 0, o = o + Math.imul(A, Y) | 0, r = r + Math.imul(v, Q) | 0, i = (i = i + Math.imul(v, Z) | 0) + Math.imul(b, Q) | 0, o = o + Math.imul(b, Z) | 0, r = r + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, X) | 0, o = o + Math.imul(m, ee) | 0;
        var Ae = (c + (r = r + Math.imul(d, ne) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, re) | 0) + Math.imul(f, ne) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, re) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, r = Math.imul(R, U), i = (i = Math.imul(R, q)) + Math.imul(I, U) | 0, o = Math.imul(I, q), r = r + Math.imul(M, H) | 0, i = (i = i + Math.imul(M, V) | 0) + Math.imul(C, H) | 0, o = o + Math.imul(C, V) | 0, r = r + Math.imul(E, W) | 0, i = (i = i + Math.imul(E, Y) | 0) + Math.imul(S, W) | 0, o = o + Math.imul(S, Y) | 0, r = r + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, Z) | 0) + Math.imul(A, Q) | 0, o = o + Math.imul(A, Z) | 0, r = r + Math.imul(v, X) | 0, i = (i = i + Math.imul(v, ee) | 0) + Math.imul(b, X) | 0, o = o + Math.imul(b, ee) | 0, r = r + Math.imul(p, ne) | 0, i = (i = i + Math.imul(p, re) | 0) + Math.imul(m, ne) | 0, o = o + Math.imul(m, re) | 0;
        var _e = (c + (r = r + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ae) | 0) + Math.imul(f, oe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ae) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, r = Math.imul(P, U), i = (i = Math.imul(P, q)) + Math.imul(O, U) | 0, o = Math.imul(O, q), r = r + Math.imul(R, H) | 0, i = (i = i + Math.imul(R, V) | 0) + Math.imul(I, H) | 0, o = o + Math.imul(I, V) | 0, r = r + Math.imul(M, W) | 0, i = (i = i + Math.imul(M, Y) | 0) + Math.imul(C, W) | 0, o = o + Math.imul(C, Y) | 0, r = r + Math.imul(E, Q) | 0, i = (i = i + Math.imul(E, Z) | 0) + Math.imul(S, Q) | 0, o = o + Math.imul(S, Z) | 0, r = r + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(A, X) | 0, o = o + Math.imul(A, ee) | 0, r = r + Math.imul(v, ne) | 0, i = (i = i + Math.imul(v, re) | 0) + Math.imul(b, ne) | 0, o = o + Math.imul(b, re) | 0, r = r + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, ae) | 0;
        var Ee = (c + (r = r + Math.imul(d, ue) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ce) | 0) + Math.imul(f, ue) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, r = Math.imul(N, U), i = (i = Math.imul(N, q)) + Math.imul(D, U) | 0, o = Math.imul(D, q), r = r + Math.imul(P, H) | 0, i = (i = i + Math.imul(P, V) | 0) + Math.imul(O, H) | 0, o = o + Math.imul(O, V) | 0, r = r + Math.imul(R, W) | 0, i = (i = i + Math.imul(R, Y) | 0) + Math.imul(I, W) | 0, o = o + Math.imul(I, Y) | 0, r = r + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, Z) | 0) + Math.imul(C, Q) | 0, o = o + Math.imul(C, Z) | 0, r = r + Math.imul(E, X) | 0, i = (i = i + Math.imul(E, ee) | 0) + Math.imul(S, X) | 0, o = o + Math.imul(S, ee) | 0, r = r + Math.imul(w, ne) | 0, i = (i = i + Math.imul(w, re) | 0) + Math.imul(A, ne) | 0, o = o + Math.imul(A, re) | 0, r = r + Math.imul(v, oe) | 0, i = (i = i + Math.imul(v, ae) | 0) + Math.imul(b, oe) | 0, o = o + Math.imul(b, ae) | 0, r = r + Math.imul(p, ue) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, ue) | 0, o = o + Math.imul(m, ce) | 0;
        var Se = (c + (r = r + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, fe) | 0) + Math.imul(f, de) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, r = Math.imul(j, U), i = (i = Math.imul(j, q)) + Math.imul(F, U) | 0, o = Math.imul(F, q), r = r + Math.imul(N, H) | 0, i = (i = i + Math.imul(N, V) | 0) + Math.imul(D, H) | 0, o = o + Math.imul(D, V) | 0, r = r + Math.imul(P, W) | 0, i = (i = i + Math.imul(P, Y) | 0) + Math.imul(O, W) | 0, o = o + Math.imul(O, Y) | 0, r = r + Math.imul(R, Q) | 0, i = (i = i + Math.imul(R, Z) | 0) + Math.imul(I, Q) | 0, o = o + Math.imul(I, Z) | 0, r = r + Math.imul(M, X) | 0, i = (i = i + Math.imul(M, ee) | 0) + Math.imul(C, X) | 0, o = o + Math.imul(C, ee) | 0, r = r + Math.imul(E, ne) | 0, i = (i = i + Math.imul(E, re) | 0) + Math.imul(S, ne) | 0, o = o + Math.imul(S, re) | 0, r = r + Math.imul(w, oe) | 0, i = (i = i + Math.imul(w, ae) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, ae) | 0, r = r + Math.imul(v, ue) | 0, i = (i = i + Math.imul(v, ce) | 0) + Math.imul(b, ue) | 0, o = o + Math.imul(b, ce) | 0, r = r + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, de) | 0, o = o + Math.imul(m, fe) | 0;
        var ke = (c + (r = r + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, r = Math.imul(j, H), i = (i = Math.imul(j, V)) + Math.imul(F, H) | 0, o = Math.imul(F, V), r = r + Math.imul(N, W) | 0, i = (i = i + Math.imul(N, Y) | 0) + Math.imul(D, W) | 0, o = o + Math.imul(D, Y) | 0, r = r + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, Z) | 0) + Math.imul(O, Q) | 0, o = o + Math.imul(O, Z) | 0, r = r + Math.imul(R, X) | 0, i = (i = i + Math.imul(R, ee) | 0) + Math.imul(I, X) | 0, o = o + Math.imul(I, ee) | 0, r = r + Math.imul(M, ne) | 0, i = (i = i + Math.imul(M, re) | 0) + Math.imul(C, ne) | 0, o = o + Math.imul(C, re) | 0, r = r + Math.imul(E, oe) | 0, i = (i = i + Math.imul(E, ae) | 0) + Math.imul(S, oe) | 0, o = o + Math.imul(S, ae) | 0, r = r + Math.imul(w, ue) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(A, ue) | 0, o = o + Math.imul(A, ce) | 0, r = r + Math.imul(v, de) | 0, i = (i = i + Math.imul(v, fe) | 0) + Math.imul(b, de) | 0, o = o + Math.imul(b, fe) | 0;
        var Me = (c + (r = r + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, r = Math.imul(j, W), i = (i = Math.imul(j, Y)) + Math.imul(F, W) | 0, o = Math.imul(F, Y), r = r + Math.imul(N, Q) | 0, i = (i = i + Math.imul(N, Z) | 0) + Math.imul(D, Q) | 0, o = o + Math.imul(D, Z) | 0, r = r + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(O, X) | 0, o = o + Math.imul(O, ee) | 0, r = r + Math.imul(R, ne) | 0, i = (i = i + Math.imul(R, re) | 0) + Math.imul(I, ne) | 0, o = o + Math.imul(I, re) | 0, r = r + Math.imul(M, oe) | 0, i = (i = i + Math.imul(M, ae) | 0) + Math.imul(C, oe) | 0, o = o + Math.imul(C, ae) | 0, r = r + Math.imul(E, ue) | 0, i = (i = i + Math.imul(E, ce) | 0) + Math.imul(S, ue) | 0, o = o + Math.imul(S, ce) | 0, r = r + Math.imul(w, de) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(A, de) | 0, o = o + Math.imul(A, fe) | 0;
        var Ce = (c + (r = r + Math.imul(v, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(v, me) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(b, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, r = Math.imul(j, Q), i = (i = Math.imul(j, Z)) + Math.imul(F, Q) | 0, o = Math.imul(F, Z), r = r + Math.imul(N, X) | 0, i = (i = i + Math.imul(N, ee) | 0) + Math.imul(D, X) | 0, o = o + Math.imul(D, ee) | 0, r = r + Math.imul(P, ne) | 0, i = (i = i + Math.imul(P, re) | 0) + Math.imul(O, ne) | 0, o = o + Math.imul(O, re) | 0, r = r + Math.imul(R, oe) | 0, i = (i = i + Math.imul(R, ae) | 0) + Math.imul(I, oe) | 0, o = o + Math.imul(I, ae) | 0, r = r + Math.imul(M, ue) | 0, i = (i = i + Math.imul(M, ce) | 0) + Math.imul(C, ue) | 0, o = o + Math.imul(C, ce) | 0, r = r + Math.imul(E, de) | 0, i = (i = i + Math.imul(E, fe) | 0) + Math.imul(S, de) | 0, o = o + Math.imul(S, fe) | 0;
        var xe = (c + (r = r + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(A, me) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, r = Math.imul(j, X), i = (i = Math.imul(j, ee)) + Math.imul(F, X) | 0, o = Math.imul(F, ee), r = r + Math.imul(N, ne) | 0, i = (i = i + Math.imul(N, re) | 0) + Math.imul(D, ne) | 0, o = o + Math.imul(D, re) | 0, r = r + Math.imul(P, oe) | 0, i = (i = i + Math.imul(P, ae) | 0) + Math.imul(O, oe) | 0, o = o + Math.imul(O, ae) | 0, r = r + Math.imul(R, ue) | 0, i = (i = i + Math.imul(R, ce) | 0) + Math.imul(I, ue) | 0, o = o + Math.imul(I, ce) | 0, r = r + Math.imul(M, de) | 0, i = (i = i + Math.imul(M, fe) | 0) + Math.imul(C, de) | 0, o = o + Math.imul(C, fe) | 0;
        var Re = (c + (r = r + Math.imul(E, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(E, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, r = Math.imul(j, ne), i = (i = Math.imul(j, re)) + Math.imul(F, ne) | 0, o = Math.imul(F, re), r = r + Math.imul(N, oe) | 0, i = (i = i + Math.imul(N, ae) | 0) + Math.imul(D, oe) | 0, o = o + Math.imul(D, ae) | 0, r = r + Math.imul(P, ue) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(O, ue) | 0, o = o + Math.imul(O, ce) | 0, r = r + Math.imul(R, de) | 0, i = (i = i + Math.imul(R, fe) | 0) + Math.imul(I, de) | 0, o = o + Math.imul(I, fe) | 0;
        var Ie = (c + (r = r + Math.imul(M, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, me) | 0) + Math.imul(C, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(C, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, r = Math.imul(j, oe), i = (i = Math.imul(j, ae)) + Math.imul(F, oe) | 0, o = Math.imul(F, ae), r = r + Math.imul(N, ue) | 0, i = (i = i + Math.imul(N, ce) | 0) + Math.imul(D, ue) | 0, o = o + Math.imul(D, ce) | 0, r = r + Math.imul(P, de) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(O, de) | 0, o = o + Math.imul(O, fe) | 0;
        var Te = (c + (r = r + Math.imul(R, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(R, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, r = Math.imul(j, ue), i = (i = Math.imul(j, ce)) + Math.imul(F, ue) | 0, o = Math.imul(F, ce), r = r + Math.imul(N, de) | 0, i = (i = i + Math.imul(N, fe) | 0) + Math.imul(D, de) | 0, o = o + Math.imul(D, fe) | 0;
        var Pe = (c + (r = r + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(O, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(O, me) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, r = Math.imul(j, de), i = (i = Math.imul(j, fe)) + Math.imul(F, de) | 0, o = Math.imul(F, fe);
        var Oe = (c + (r = r + Math.imul(N, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(N, me) | 0) + Math.imul(D, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(D, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863;
        var Le = (c + (r = Math.imul(j, pe)) | 0) + ((8191 & (i = (i = Math.imul(j, me)) + Math.imul(F, pe) | 0)) << 13) | 0;
        return c = ((o = Math.imul(F, me)) + (i >>> 13) | 0) + (Le >>> 26) | 0, Le &= 67108863, u[0] = ge, u[1] = ve, u[2] = be, u[3] = ye, u[4] = we, u[5] = Ae, u[6] = _e, u[7] = Ee, u[8] = Se, u[9] = ke, u[10] = Me, u[11] = Ce, u[12] = xe, u[13] = Re, u[14] = Ie, u[15] = Te, u[16] = Pe, u[17] = Oe, u[18] = Le, 0 !== c && (u[19] = c, n.length++), n;
      };
      function p(e, t, n) {
        return new m().mulp(e, t, n);
      }
      function m(e, t) {
        this.x = e, this.y = t;
      }
      Math.imul || (h = f), i.prototype.mulTo = function (e, t) {
        var n,
          r = this.length + e.length;
        return n = 10 === this.length && 10 === e.length ? h(this, e, t) : r < 63 ? f(this, e, t) : r < 1024 ? function (e, t, n) {
          n.negative = t.negative ^ e.negative, n.length = e.length + t.length;
          for (var r = 0, i = 0, o = 0; o < n.length - 1; o++) {
            var a = i;
            i = 0;
            for (var s = 67108863 & r, u = Math.min(o, t.length - 1), c = Math.max(0, o - e.length + 1); c <= u; c++) {
              var l = o - c,
                d = (0 | e.words[l]) * (0 | t.words[c]),
                f = 67108863 & d;
              s = 67108863 & (f = f + s | 0), i += (a = (a = a + (d / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, a &= 67108863;
            }
            n.words[o] = s, r = a, a = i;
          }
          return 0 !== r ? n.words[o] = r : n.length--, n.strip();
        }(this, e, t) : p(this, e, t), n;
      }, m.prototype.makeRBT = function (e) {
        for (var t = new Array(e), n = i.prototype._countBits(e) - 1, r = 0; r < e; r++) t[r] = this.revBin(r, n, e);
        return t;
      }, m.prototype.revBin = function (e, t, n) {
        if (0 === e || e === n - 1) return e;
        for (var r = 0, i = 0; i < t; i++) r |= (1 & e) << t - i - 1, e >>= 1;
        return r;
      }, m.prototype.permute = function (e, t, n, r, i, o) {
        for (var a = 0; a < o; a++) r[a] = t[e[a]], i[a] = n[e[a]];
      }, m.prototype.transform = function (e, t, n, r, i, o) {
        this.permute(o, e, t, n, r, i);
        for (var a = 1; a < i; a <<= 1) for (var s = a << 1, u = Math.cos(2 * Math.PI / s), c = Math.sin(2 * Math.PI / s), l = 0; l < i; l += s) for (var d = u, f = c, h = 0; h < a; h++) {
          var p = n[l + h],
            m = r[l + h],
            g = n[l + h + a],
            v = r[l + h + a],
            b = d * g - f * v;
          v = d * v + f * g, g = b, n[l + h] = p + g, r[l + h] = m + v, n[l + h + a] = p - g, r[l + h + a] = m - v, h !== s && (b = u * d - c * f, f = u * f + c * d, d = b);
        }
      }, m.prototype.guessLen13b = function (e, t) {
        var n = 1 | Math.max(t, e),
          r = 1 & n,
          i = 0;
        for (n = n / 2 | 0; n; n >>>= 1) i++;
        return 1 << i + 1 + r;
      }, m.prototype.conjugate = function (e, t, n) {
        if (!(n <= 1)) for (var r = 0; r < n / 2; r++) {
          var i = e[r];
          e[r] = e[n - r - 1], e[n - r - 1] = i, i = t[r], t[r] = -t[n - r - 1], t[n - r - 1] = -i;
        }
      }, m.prototype.normalize13b = function (e, t) {
        for (var n = 0, r = 0; r < t / 2; r++) {
          var i = 8192 * Math.round(e[2 * r + 1] / t) + Math.round(e[2 * r] / t) + n;
          e[r] = 67108863 & i, n = i < 67108864 ? 0 : i / 67108864 | 0;
        }
        return e;
      }, m.prototype.convert13b = function (e, t, r, i) {
        for (var o = 0, a = 0; a < t; a++) o += 0 | e[a], r[2 * a] = 8191 & o, o >>>= 13, r[2 * a + 1] = 8191 & o, o >>>= 13;
        for (a = 2 * t; a < i; ++a) r[a] = 0;
        n(0 === o), n(0 == (-8192 & o));
      }, m.prototype.stub = function (e) {
        for (var t = new Array(e), n = 0; n < e; n++) t[n] = 0;
        return t;
      }, m.prototype.mulp = function (e, t, n) {
        var r = 2 * this.guessLen13b(e.length, t.length),
          i = this.makeRBT(r),
          o = this.stub(r),
          a = new Array(r),
          s = new Array(r),
          u = new Array(r),
          c = new Array(r),
          l = new Array(r),
          d = new Array(r),
          f = n.words;
        f.length = r, this.convert13b(e.words, e.length, a, r), this.convert13b(t.words, t.length, c, r), this.transform(a, o, s, u, r, i), this.transform(c, o, l, d, r, i);
        for (var h = 0; h < r; h++) {
          var p = s[h] * l[h] - u[h] * d[h];
          u[h] = s[h] * d[h] + u[h] * l[h], s[h] = p;
        }
        return this.conjugate(s, u, r), this.transform(s, u, f, o, r, i), this.conjugate(f, o, r), this.normalize13b(f, r), n.negative = e.negative ^ t.negative, n.length = e.length + t.length, n.strip();
      }, i.prototype.mul = function (e) {
        var t = new i(null);
        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
      }, i.prototype.mulf = function (e) {
        var t = new i(null);
        return t.words = new Array(this.length + e.length), p(this, e, t);
      }, i.prototype.imul = function (e) {
        return this.clone().mulTo(e, this);
      }, i.prototype.imuln = function (e) {
        n("number" == typeof e), n(e < 67108864);
        for (var t = 0, r = 0; r < this.length; r++) {
          var i = (0 | this.words[r]) * e,
            o = (67108863 & i) + (67108863 & t);
          t >>= 26, t += i / 67108864 | 0, t += o >>> 26, this.words[r] = 67108863 & o;
        }
        return 0 !== t && (this.words[r] = t, this.length++), this;
      }, i.prototype.muln = function (e) {
        return this.clone().imuln(e);
      }, i.prototype.sqr = function () {
        return this.mul(this);
      }, i.prototype.isqr = function () {
        return this.imul(this.clone());
      }, i.prototype.pow = function (e) {
        var t = function (e) {
          for (var t = new Array(e.bitLength()), n = 0; n < t.length; n++) {
            var r = n / 26 | 0,
              i = n % 26;
            t[n] = (e.words[r] & 1 << i) >>> i;
          }
          return t;
        }(e);
        if (0 === t.length) return new i(1);
        for (var n = this, r = 0; r < t.length && 0 === t[r]; r++, n = n.sqr());
        if (++r < t.length) for (var o = n.sqr(); r < t.length; r++, o = o.sqr()) 0 !== t[r] && (n = n.mul(o));
        return n;
      }, i.prototype.iushln = function (e) {
        n("number" == typeof e && e >= 0);
        var t,
          r = e % 26,
          i = (e - r) / 26,
          o = 67108863 >>> 26 - r << 26 - r;
        if (0 !== r) {
          var a = 0;
          for (t = 0; t < this.length; t++) {
            var s = this.words[t] & o,
              u = (0 | this.words[t]) - s << r;
            this.words[t] = u | a, a = s >>> 26 - r;
          }
          a && (this.words[t] = a, this.length++);
        }
        if (0 !== i) {
          for (t = this.length - 1; t >= 0; t--) this.words[t + i] = this.words[t];
          for (t = 0; t < i; t++) this.words[t] = 0;
          this.length += i;
        }
        return this.strip();
      }, i.prototype.ishln = function (e) {
        return n(0 === this.negative), this.iushln(e);
      }, i.prototype.iushrn = function (e, t, r) {
        var i;
        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
        var o = e % 26,
          a = Math.min((e - o) / 26, this.length),
          s = 67108863 ^ 67108863 >>> o << o,
          u = r;
        if (i -= a, i = Math.max(0, i), u) {
          for (var c = 0; c < a; c++) u.words[c] = this.words[c];
          u.length = a;
        }
        if (0 === a) ;else if (this.length > a) for (this.length -= a, c = 0; c < this.length; c++) this.words[c] = this.words[c + a];else this.words[0] = 0, this.length = 1;
        var l = 0;
        for (c = this.length - 1; c >= 0 && (0 !== l || c >= i); c--) {
          var d = 0 | this.words[c];
          this.words[c] = l << 26 - o | d >>> o, l = d & s;
        }
        return u && 0 !== l && (u.words[u.length++] = l), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
      }, i.prototype.ishrn = function (e, t, r) {
        return n(0 === this.negative), this.iushrn(e, t, r);
      }, i.prototype.shln = function (e) {
        return this.clone().ishln(e);
      }, i.prototype.ushln = function (e) {
        return this.clone().iushln(e);
      }, i.prototype.shrn = function (e) {
        return this.clone().ishrn(e);
      }, i.prototype.ushrn = function (e) {
        return this.clone().iushrn(e);
      }, i.prototype.testn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = e % 26,
          r = (e - t) / 26,
          i = 1 << t;
        return !(this.length <= r) && !!(this.words[r] & i);
      }, i.prototype.imaskn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = e % 26,
          r = (e - t) / 26;
        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
          var i = 67108863 ^ 67108863 >>> t << t;
          this.words[this.length - 1] &= i;
        }
        return this.strip();
      }, i.prototype.maskn = function (e) {
        return this.clone().imaskn(e);
      }, i.prototype.iaddn = function (e) {
        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
      }, i.prototype._iaddn = function (e) {
        this.words[0] += e;
        for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
        return this.length = Math.max(this.length, t + 1), this;
      }, i.prototype.isubn = function (e) {
        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) this.words[t] += 67108864, this.words[t + 1] -= 1;
        return this.strip();
      }, i.prototype.addn = function (e) {
        return this.clone().iaddn(e);
      }, i.prototype.subn = function (e) {
        return this.clone().isubn(e);
      }, i.prototype.iabs = function () {
        return this.negative = 0, this;
      }, i.prototype.abs = function () {
        return this.clone().iabs();
      }, i.prototype._ishlnsubmul = function (e, t, r) {
        var i,
          o,
          a = e.length + r;
        this._expand(a);
        var s = 0;
        for (i = 0; i < e.length; i++) {
          o = (0 | this.words[i + r]) + s;
          var u = (0 | e.words[i]) * t;
          s = ((o -= 67108863 & u) >> 26) - (u / 67108864 | 0), this.words[i + r] = 67108863 & o;
        }
        for (; i < this.length - r; i++) s = (o = (0 | this.words[i + r]) + s) >> 26, this.words[i + r] = 67108863 & o;
        if (0 === s) return this.strip();
        for (n(-1 === s), s = 0, i = 0; i < this.length; i++) s = (o = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & o;
        return this.negative = 1, this.strip();
      }, i.prototype._wordDiv = function (e, t) {
        var n = (this.length, e.length),
          r = this.clone(),
          o = e,
          a = 0 | o.words[o.length - 1];
        0 !== (n = 26 - this._countBits(a)) && (o = o.ushln(n), r.iushln(n), a = 0 | o.words[o.length - 1]);
        var s,
          u = r.length - o.length;
        if ("mod" !== t) {
          (s = new i(null)).length = u + 1, s.words = new Array(s.length);
          for (var c = 0; c < s.length; c++) s.words[c] = 0;
        }
        var l = r.clone()._ishlnsubmul(o, 1, u);
        0 === l.negative && (r = l, s && (s.words[u] = 1));
        for (var d = u - 1; d >= 0; d--) {
          var f = 67108864 * (0 | r.words[o.length + d]) + (0 | r.words[o.length + d - 1]);
          for (f = Math.min(f / a | 0, 67108863), r._ishlnsubmul(o, f, d); 0 !== r.negative;) f--, r.negative = 0, r._ishlnsubmul(o, 1, d), r.isZero() || (r.negative ^= 1);
          s && (s.words[d] = f);
        }
        return s && s.strip(), r.strip(), "div" !== t && 0 !== n && r.iushrn(n), {
          div: s || null,
          mod: r
        };
      }, i.prototype.divmod = function (e, t, r) {
        return n(!e.isZero()), this.isZero() ? {
          div: new i(0),
          mod: new i(0)
        } : 0 !== this.negative && 0 === e.negative ? (s = this.neg().divmod(e, t), "mod" !== t && (o = s.div.neg()), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.iadd(e)), {
          div: o,
          mod: a
        }) : 0 === this.negative && 0 !== e.negative ? (s = this.divmod(e.neg(), t), "mod" !== t && (o = s.div.neg()), {
          div: o,
          mod: s.mod
        }) : 0 != (this.negative & e.negative) ? (s = this.neg().divmod(e.neg(), t), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.isub(e)), {
          div: s.div,
          mod: a
        }) : e.length > this.length || this.cmp(e) < 0 ? {
          div: new i(0),
          mod: this
        } : 1 === e.length ? "div" === t ? {
          div: this.divn(e.words[0]),
          mod: null
        } : "mod" === t ? {
          div: null,
          mod: new i(this.modn(e.words[0]))
        } : {
          div: this.divn(e.words[0]),
          mod: new i(this.modn(e.words[0]))
        } : this._wordDiv(e, t);
        var o, a, s;
      }, i.prototype.div = function (e) {
        return this.divmod(e, "div", !1).div;
      }, i.prototype.mod = function (e) {
        return this.divmod(e, "mod", !1).mod;
      }, i.prototype.umod = function (e) {
        return this.divmod(e, "mod", !0).mod;
      }, i.prototype.divRound = function (e) {
        var t = this.divmod(e);
        if (t.mod.isZero()) return t.div;
        var n = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
          r = e.ushrn(1),
          i = e.andln(1),
          o = n.cmp(r);
        return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
      }, i.prototype.modn = function (e) {
        n(e <= 67108863);
        for (var t = (1 << 26) % e, r = 0, i = this.length - 1; i >= 0; i--) r = (t * r + (0 | this.words[i])) % e;
        return r;
      }, i.prototype.idivn = function (e) {
        n(e <= 67108863);
        for (var t = 0, r = this.length - 1; r >= 0; r--) {
          var i = (0 | this.words[r]) + 67108864 * t;
          this.words[r] = i / e | 0, t = i % e;
        }
        return this.strip();
      }, i.prototype.divn = function (e) {
        return this.clone().idivn(e);
      }, i.prototype.egcd = function (e) {
        n(0 === e.negative), n(!e.isZero());
        var t = this,
          r = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();
        for (var o = new i(1), a = new i(0), s = new i(0), u = new i(1), c = 0; t.isEven() && r.isEven();) t.iushrn(1), r.iushrn(1), ++c;
        for (var l = r.clone(), d = t.clone(); !t.isZero();) {
          for (var f = 0, h = 1; 0 == (t.words[0] & h) && f < 26; ++f, h <<= 1);
          if (f > 0) for (t.iushrn(f); f-- > 0;) (o.isOdd() || a.isOdd()) && (o.iadd(l), a.isub(d)), o.iushrn(1), a.iushrn(1);
          for (var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
          if (p > 0) for (r.iushrn(p); p-- > 0;) (s.isOdd() || u.isOdd()) && (s.iadd(l), u.isub(d)), s.iushrn(1), u.iushrn(1);
          t.cmp(r) >= 0 ? (t.isub(r), o.isub(s), a.isub(u)) : (r.isub(t), s.isub(o), u.isub(a));
        }
        return {
          a: s,
          b: u,
          gcd: r.iushln(c)
        };
      }, i.prototype._invmp = function (e) {
        n(0 === e.negative), n(!e.isZero());
        var t = this,
          r = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();
        for (var o, a = new i(1), s = new i(0), u = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;) {
          for (var c = 0, l = 1; 0 == (t.words[0] & l) && c < 26; ++c, l <<= 1);
          if (c > 0) for (t.iushrn(c); c-- > 0;) a.isOdd() && a.iadd(u), a.iushrn(1);
          for (var d = 0, f = 1; 0 == (r.words[0] & f) && d < 26; ++d, f <<= 1);
          if (d > 0) for (r.iushrn(d); d-- > 0;) s.isOdd() && s.iadd(u), s.iushrn(1);
          t.cmp(r) >= 0 ? (t.isub(r), a.isub(s)) : (r.isub(t), s.isub(a));
        }
        return (o = 0 === t.cmpn(1) ? a : s).cmpn(0) < 0 && o.iadd(e), o;
      }, i.prototype.gcd = function (e) {
        if (this.isZero()) return e.abs();
        if (e.isZero()) return this.abs();
        var t = this.clone(),
          n = e.clone();
        t.negative = 0, n.negative = 0;
        for (var r = 0; t.isEven() && n.isEven(); r++) t.iushrn(1), n.iushrn(1);
        for (;;) {
          for (; t.isEven();) t.iushrn(1);
          for (; n.isEven();) n.iushrn(1);
          var i = t.cmp(n);
          if (i < 0) {
            var o = t;
            t = n, n = o;
          } else if (0 === i || 0 === n.cmpn(1)) break;
          t.isub(n);
        }
        return n.iushln(r);
      }, i.prototype.invm = function (e) {
        return this.egcd(e).a.umod(e);
      }, i.prototype.isEven = function () {
        return 0 == (1 & this.words[0]);
      }, i.prototype.isOdd = function () {
        return 1 == (1 & this.words[0]);
      }, i.prototype.andln = function (e) {
        return this.words[0] & e;
      }, i.prototype.bincn = function (e) {
        n("number" == typeof e);
        var t = e % 26,
          r = (e - t) / 26,
          i = 1 << t;
        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
        for (var o = i, a = r; 0 !== o && a < this.length; a++) {
          var s = 0 | this.words[a];
          o = (s += o) >>> 26, s &= 67108863, this.words[a] = s;
        }
        return 0 !== o && (this.words[a] = o, this.length++), this;
      }, i.prototype.isZero = function () {
        return 1 === this.length && 0 === this.words[0];
      }, i.prototype.cmpn = function (e) {
        var t,
          r = e < 0;
        if (0 !== this.negative && !r) return -1;
        if (0 === this.negative && r) return 1;
        if (this.strip(), this.length > 1) t = 1;else {
          r && (e = -e), n(e <= 67108863, "Number is too big");
          var i = 0 | this.words[0];
          t = i === e ? 0 : i < e ? -1 : 1;
        }
        return 0 !== this.negative ? 0 | -t : t;
      }, i.prototype.cmp = function (e) {
        if (0 !== this.negative && 0 === e.negative) return -1;
        if (0 === this.negative && 0 !== e.negative) return 1;
        var t = this.ucmp(e);
        return 0 !== this.negative ? 0 | -t : t;
      }, i.prototype.ucmp = function (e) {
        if (this.length > e.length) return 1;
        if (this.length < e.length) return -1;
        for (var t = 0, n = this.length - 1; n >= 0; n--) {
          var r = 0 | this.words[n],
            i = 0 | e.words[n];
          if (r !== i) {
            r < i ? t = -1 : r > i && (t = 1);
            break;
          }
        }
        return t;
      }, i.prototype.gtn = function (e) {
        return 1 === this.cmpn(e);
      }, i.prototype.gt = function (e) {
        return 1 === this.cmp(e);
      }, i.prototype.gten = function (e) {
        return this.cmpn(e) >= 0;
      }, i.prototype.gte = function (e) {
        return this.cmp(e) >= 0;
      }, i.prototype.ltn = function (e) {
        return -1 === this.cmpn(e);
      }, i.prototype.lt = function (e) {
        return -1 === this.cmp(e);
      }, i.prototype.lten = function (e) {
        return this.cmpn(e) <= 0;
      }, i.prototype.lte = function (e) {
        return this.cmp(e) <= 0;
      }, i.prototype.eqn = function (e) {
        return 0 === this.cmpn(e);
      }, i.prototype.eq = function (e) {
        return 0 === this.cmp(e);
      }, i.red = function (e) {
        return new _(e);
      }, i.prototype.toRed = function (e) {
        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
      }, i.prototype.fromRed = function () {
        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, i.prototype._forceRed = function (e) {
        return this.red = e, this;
      }, i.prototype.forceRed = function (e) {
        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
      }, i.prototype.redAdd = function (e) {
        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
      }, i.prototype.redIAdd = function (e) {
        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
      }, i.prototype.redSub = function (e) {
        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
      }, i.prototype.redISub = function (e) {
        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
      }, i.prototype.redShl = function (e) {
        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
      }, i.prototype.redMul = function (e) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
      }, i.prototype.redIMul = function (e) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
      }, i.prototype.redSqr = function () {
        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, i.prototype.redISqr = function () {
        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, i.prototype.redSqrt = function () {
        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, i.prototype.redInvm = function () {
        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, i.prototype.redNeg = function () {
        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, i.prototype.redPow = function (e) {
        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
      };
      var g = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function v(e, t) {
        this.name = e, this.p = new i(t, 16), this.n = this.p.bitLength(), this.k = new i(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      function b() {
        v.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
      }
      function y() {
        v.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
      }
      function w() {
        v.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
      }
      function A() {
        v.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
      }
      function _(e) {
        if ("string" == typeof e) {
          var t = i._prime(e);
          this.m = t.p, this.prime = t;
        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
      }
      function E(e) {
        _.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new i(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      v.prototype._tmp = function () {
        var e = new i(null);
        return e.words = new Array(Math.ceil(this.n / 13)), e;
      }, v.prototype.ireduce = function (e) {
        var t,
          n = e;
        do {
          this.split(n, this.tmp), t = (n = (n = this.imulK(n)).iadd(this.tmp)).bitLength();
        } while (t > this.n);
        var r = t < this.n ? -1 : n.ucmp(this.p);
        return 0 === r ? (n.words[0] = 0, n.length = 1) : r > 0 ? n.isub(this.p) : void 0 !== n.strip ? n.strip() : n._strip(), n;
      }, v.prototype.split = function (e, t) {
        e.iushrn(this.n, 0, t);
      }, v.prototype.imulK = function (e) {
        return e.imul(this.k);
      }, r(b, v), b.prototype.split = function (e, t) {
        for (var n = 4194303, r = Math.min(e.length, 9), i = 0; i < r; i++) t.words[i] = e.words[i];
        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
        var o = e.words[9];
        for (t.words[t.length++] = o & n, i = 10; i < e.length; i++) {
          var a = 0 | e.words[i];
          e.words[i - 10] = (a & n) << 4 | o >>> 22, o = a;
        }
        o >>>= 22, e.words[i - 10] = o, 0 === o && e.length > 10 ? e.length -= 10 : e.length -= 9;
      }, b.prototype.imulK = function (e) {
        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
        for (var t = 0, n = 0; n < e.length; n++) {
          var r = 0 | e.words[n];
          t += 977 * r, e.words[n] = 67108863 & t, t = 64 * r + (t / 67108864 | 0);
        }
        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
      }, r(y, v), r(w, v), r(A, v), A.prototype.imulK = function (e) {
        for (var t = 0, n = 0; n < e.length; n++) {
          var r = 19 * (0 | e.words[n]) + t,
            i = 67108863 & r;
          r >>>= 26, e.words[n] = i, t = r;
        }
        return 0 !== t && (e.words[e.length++] = t), e;
      }, i._prime = function (e) {
        if (g[e]) return g[e];
        var t;
        if ("k256" === e) t = new b();else if ("p224" === e) t = new y();else if ("p192" === e) t = new w();else {
          if ("p25519" !== e) throw new Error("Unknown prime " + e);
          t = new A();
        }
        return g[e] = t, t;
      }, _.prototype._verify1 = function (e) {
        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
      }, _.prototype._verify2 = function (e, t) {
        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
      }, _.prototype.imod = function (e) {
        return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
      }, _.prototype.neg = function (e) {
        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
      }, _.prototype.add = function (e, t) {
        this._verify2(e, t);
        var n = e.add(t);
        return n.cmp(this.m) >= 0 && n.isub(this.m), n._forceRed(this);
      }, _.prototype.iadd = function (e, t) {
        this._verify2(e, t);
        var n = e.iadd(t);
        return n.cmp(this.m) >= 0 && n.isub(this.m), n;
      }, _.prototype.sub = function (e, t) {
        this._verify2(e, t);
        var n = e.sub(t);
        return n.cmpn(0) < 0 && n.iadd(this.m), n._forceRed(this);
      }, _.prototype.isub = function (e, t) {
        this._verify2(e, t);
        var n = e.isub(t);
        return n.cmpn(0) < 0 && n.iadd(this.m), n;
      }, _.prototype.shl = function (e, t) {
        return this._verify1(e), this.imod(e.ushln(t));
      }, _.prototype.imul = function (e, t) {
        return this._verify2(e, t), this.imod(e.imul(t));
      }, _.prototype.mul = function (e, t) {
        return this._verify2(e, t), this.imod(e.mul(t));
      }, _.prototype.isqr = function (e) {
        return this.imul(e, e.clone());
      }, _.prototype.sqr = function (e) {
        return this.mul(e, e);
      }, _.prototype.sqrt = function (e) {
        if (e.isZero()) return e.clone();
        var t = this.m.andln(3);
        if (n(t % 2 == 1), 3 === t) {
          var r = this.m.add(new i(1)).iushrn(2);
          return this.pow(e, r);
        }
        for (var o = this.m.subn(1), a = 0; !o.isZero() && 0 === o.andln(1);) a++, o.iushrn(1);
        n(!o.isZero());
        var s = new i(1).toRed(this),
          u = s.redNeg(),
          c = this.m.subn(1).iushrn(1),
          l = this.m.bitLength();
        for (l = new i(2 * l * l).toRed(this); 0 !== this.pow(l, c).cmp(u);) l.redIAdd(u);
        for (var d = this.pow(l, o), f = this.pow(e, o.addn(1).iushrn(1)), h = this.pow(e, o), p = a; 0 !== h.cmp(s);) {
          for (var m = h, g = 0; 0 !== m.cmp(s); g++) m = m.redSqr();
          n(g < p);
          var v = this.pow(d, new i(1).iushln(p - g - 1));
          f = f.redMul(v), d = v.redSqr(), h = h.redMul(d), p = g;
        }
        return f;
      }, _.prototype.invm = function (e) {
        var t = e._invmp(this.m);
        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
      }, _.prototype.pow = function (e, t) {
        if (t.isZero()) return new i(1).toRed(this);
        if (0 === t.cmpn(1)) return e.clone();
        var n = new Array(16);
        n[0] = new i(1).toRed(this), n[1] = e;
        for (var r = 2; r < n.length; r++) n[r] = this.mul(n[r - 1], e);
        var o = n[0],
          a = 0,
          s = 0,
          u = t.bitLength() % 26;
        for (0 === u && (u = 26), r = t.length - 1; r >= 0; r--) {
          for (var c = t.words[r], l = u - 1; l >= 0; l--) {
            var d = c >> l & 1;
            o !== n[0] && (o = this.sqr(o)), 0 !== d || 0 !== a ? (a <<= 1, a |= d, (4 === ++s || 0 === r && 0 === l) && (o = this.mul(o, n[a]), s = 0, a = 0)) : s = 0;
          }
          u = 26;
        }
        return o;
      }, _.prototype.convertTo = function (e) {
        var t = e.umod(this.m);
        return t === e ? t.clone() : t;
      }, _.prototype.convertFrom = function (e) {
        var t = e.clone();
        return t.red = null, t;
      }, i.mont = function (e) {
        return new E(e);
      }, r(E, _), E.prototype.convertTo = function (e) {
        return this.imod(e.ushln(this.shift));
      }, E.prototype.convertFrom = function (e) {
        var t = this.imod(e.mul(this.rinv));
        return t.red = null, t;
      }, E.prototype.imul = function (e, t) {
        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
        var n = e.imul(t),
          r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          i = n.isub(r).iushrn(this.shift),
          o = i;
        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
      }, E.prototype.mul = function (e, t) {
        if (e.isZero() || t.isZero()) return new i(0)._forceRed(this);
        var n = e.mul(t),
          r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          o = n.isub(r).iushrn(this.shift),
          a = o;
        return o.cmp(this.m) >= 0 ? a = o.isub(this.m) : o.cmpn(0) < 0 && (a = o.iadd(this.m)), a._forceRed(this);
      }, E.prototype.invm = function (e) {
        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
      };
    }(e, n);
  }(sc);
  var uc,
    cc,
    lc,
    dc,
    fc,
    hc = sc.exports,
    pc = {
      exports: {}
    };
  function mc() {
    if (uc) return pc.exports;
    var e;
    function t(e) {
      this.rand = e;
    }
    if (uc = 1, pc.exports = function (n) {
      return e || (e = new t(null)), e.generate(n);
    }, pc.exports.Rand = t, t.prototype.generate = function (e) {
      return this._rand(e);
    }, t.prototype._rand = function (e) {
      if (this.rand.getBytes) return this.rand.getBytes(e);
      for (var t = new Uint8Array(e), n = 0; n < t.length; n++) t[n] = this.rand.getByte();
      return t;
    }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? t.prototype._rand = function (e) {
      var t = new Uint8Array(e);
      return self.crypto.getRandomValues(t), t;
    } : self.msCrypto && self.msCrypto.getRandomValues ? t.prototype._rand = function (e) {
      var t = new Uint8Array(e);
      return self.msCrypto.getRandomValues(t), t;
    } : "object" == typeof window && (t.prototype._rand = function () {
      throw new Error("Not implemented yet");
    });else try {
      var n = Fm();
      if ("function" != typeof n.randomBytes) throw new Error("Not supported");
      t.prototype._rand = function (e) {
        return n.randomBytes(e);
      };
    } catch (e) {}
    return pc.exports;
  }
  function gc() {
    if (lc) return cc;
    lc = 1;
    var e = hc,
      t = mc();
    function n(e) {
      this.rand = e || new t.Rand();
    }
    return cc = n, n.create = function (e) {
      return new n(e);
    }, n.prototype._randbelow = function (t) {
      var n = t.bitLength(),
        r = Math.ceil(n / 8);
      do {
        var i = new e(this.rand.generate(r));
      } while (i.cmp(t) >= 0);
      return i;
    }, n.prototype._randrange = function (e, t) {
      var n = t.sub(e);
      return e.add(this._randbelow(n));
    }, n.prototype.test = function (t, n, r) {
      var i = t.bitLength(),
        o = e.mont(t),
        a = new e(1).toRed(o);
      n || (n = Math.max(1, i / 48 | 0));
      for (var s = t.subn(1), u = 0; !s.testn(u); u++);
      for (var c = t.shrn(u), l = s.toRed(o); n > 0; n--) {
        var d = this._randrange(new e(2), s);
        r && r(d);
        var f = d.toRed(o).redPow(c);
        if (0 !== f.cmp(a) && 0 !== f.cmp(l)) {
          for (var h = 1; h < u; h++) {
            if (0 === (f = f.redSqr()).cmp(a)) return !1;
            if (0 === f.cmp(l)) break;
          }
          if (h === u) return !1;
        }
      }
      return !0;
    }, n.prototype.getDivisor = function (t, n) {
      var r = t.bitLength(),
        i = e.mont(t),
        o = new e(1).toRed(i);
      n || (n = Math.max(1, r / 48 | 0));
      for (var a = t.subn(1), s = 0; !a.testn(s); s++);
      for (var u = t.shrn(s), c = a.toRed(i); n > 0; n--) {
        var l = this._randrange(new e(2), a),
          d = t.gcd(l);
        if (0 !== d.cmpn(1)) return d;
        var f = l.toRed(i).redPow(u);
        if (0 !== f.cmp(o) && 0 !== f.cmp(c)) {
          for (var h = 1; h < s; h++) {
            if (0 === (f = f.redSqr()).cmp(o)) return f.fromRed().subn(1).gcd(t);
            if (0 === f.cmp(c)) break;
          }
          if (h === s) return (f = f.redSqr()).fromRed().subn(1).gcd(t);
        }
      }
      return !1;
    }, cc;
  }
  function vc() {
    if (fc) return dc;
    fc = 1;
    var e = Ve;
    dc = m, m.simpleSieve = h, m.fermatTest = p;
    var t = hc,
      n = new t(24),
      r = new (gc())(),
      i = new t(1),
      o = new t(2),
      a = new t(5);
    new t(16), new t(8);
    var s = new t(10),
      u = new t(3);
    new t(7);
    var c = new t(11),
      l = new t(4);
    new t(12);
    var d = null;
    function f() {
      if (null !== d) return d;
      var e = [];
      e[0] = 2;
      for (var t = 1, n = 3; n < 1048576; n += 2) {
        for (var r = Math.ceil(Math.sqrt(n)), i = 0; i < t && e[i] <= r && n % e[i] != 0; i++);
        t !== i && e[i] <= r || (e[t++] = n);
      }
      return d = e, e;
    }
    function h(e) {
      for (var t = f(), n = 0; n < t.length; n++) if (0 === e.modn(t[n])) return 0 === e.cmpn(t[n]);
      return !0;
    }
    function p(e) {
      var n = t.mont(e);
      return 0 === o.toRed(n).redPow(e.subn(1)).fromRed().cmpn(1);
    }
    function m(d, f) {
      if (d < 16) return new t(2 === f || 5 === f ? [140, 123] : [140, 39]);
      var m, g;
      for (f = new t(f);;) {
        for (m = new t(e(Math.ceil(d / 8))); m.bitLength() > d;) m.ishrn(1);
        if (m.isEven() && m.iadd(i), m.testn(1) || m.iadd(o), f.cmp(o)) {
          if (!f.cmp(a)) for (; m.mod(s).cmp(u);) m.iadd(l);
        } else for (; m.mod(n).cmp(c);) m.iadd(l);
        if (h(g = m.shrn(1)) && h(m) && p(g) && p(m) && r.test(g) && r.test(m)) return m;
      }
    }
    return dc;
  }
  var bc,
    yc,
    wc,
    Ac = {
      modp1: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
      },
      modp2: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
      },
      modp5: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
      },
      modp14: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
      },
      modp15: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
      },
      modp16: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
      },
      modp17: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
      },
      modp18: {
        gen: "02",
        prime: "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"
      }
    };
  function _c() {
    if (yc) return bc;
    yc = 1;
    var e = hc,
      t = new (gc())(),
      n = new e(24),
      r = new e(11),
      i = new e(10),
      o = new e(3),
      a = new e(7),
      s = vc(),
      u = Ve;
    function c(t, n) {
      return n = n || "utf8", ie(t) || (t = new A(t, n)), this._pub = new e(t), this;
    }
    function l(t, n) {
      return n = n || "utf8", ie(t) || (t = new A(t, n)), this._priv = new e(t), this;
    }
    bc = f;
    var d = {};
    function f(t, n, r) {
      this.setGenerator(n), this.__prime = new e(t), this._prime = e.mont(this.__prime), this._primeLen = t.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, r ? (this.setPublicKey = c, this.setPrivateKey = l) : this._primeCode = 8;
    }
    function h(e, t) {
      var n = new A(e.toArray());
      return t ? n.toString(t) : n;
    }
    return Object.defineProperty(f.prototype, "verifyError", {
      enumerable: !0,
      get: function () {
        return "number" != typeof this._primeCode && (this._primeCode = function (e, u) {
          var c = u.toString("hex"),
            l = [c, e.toString(16)].join("_");
          if (l in d) return d[l];
          var f,
            h = 0;
          if (e.isEven() || !s.simpleSieve || !s.fermatTest(e) || !t.test(e)) return h += 1, h += "02" === c || "05" === c ? 8 : 4, d[l] = h, h;
          switch (t.test(e.shrn(1)) || (h += 2), c) {
            case "02":
              e.mod(n).cmp(r) && (h += 8);
              break;
            case "05":
              (f = e.mod(i)).cmp(o) && f.cmp(a) && (h += 8);
              break;
            default:
              h += 4;
          }
          return d[l] = h, h;
        }(this.__prime, this.__gen)), this._primeCode;
      }
    }), f.prototype.generateKeys = function () {
      return this._priv || (this._priv = new e(u(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
    }, f.prototype.computeSecret = function (t) {
      var n = new A((t = (t = new e(t)).toRed(this._prime)).redPow(this._priv).fromRed().toArray()),
        r = this.getPrime();
      if (n.length < r.length) {
        var i = new A(r.length - n.length);
        i.fill(0), n = A.concat([i, n]);
      }
      return n;
    }, f.prototype.getPublicKey = function (e) {
      return h(this._pub, e);
    }, f.prototype.getPrivateKey = function (e) {
      return h(this._priv, e);
    }, f.prototype.getPrime = function (e) {
      return h(this.__prime, e);
    }, f.prototype.getGenerator = function (e) {
      return h(this._gen, e);
    }, f.prototype.setGenerator = function (t, n) {
      return n = n || "utf8", ie(t) || (t = new A(t, n)), this.__gen = t, this._gen = new e(t), this;
    }, bc;
  }
  var Ec = {
      exports: {}
    },
    Sc = {
      exports: {}
    };
  !function (e) {
    !function (e, t) {
      function n(e, t) {
        if (!e) throw new Error(t || "Assertion failed");
      }
      function r(e, t) {
        e.super_ = t;
        var n = function () {};
        n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
      }
      function i(e, t, n) {
        if (i.isBN(e)) return e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (n = t, t = 10), this._init(e || 0, t || 10, n || "be"));
      }
      var o;
      "object" == typeof e ? e.exports = i : t.BN = i, i.BN = i, i.wordSize = 26;
      try {
        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : le.Buffer;
      } catch (e) {}
      function a(e, t) {
        var r = e.charCodeAt(t);
        return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void n(!1, "Invalid character in " + e);
      }
      function s(e, t, n) {
        var r = a(e, n);
        return n - 1 >= t && (r |= a(e, n - 1) << 4), r;
      }
      function u(e, t, r, i) {
        for (var o = 0, a = 0, s = Math.min(e.length, r), u = t; u < s; u++) {
          var c = e.charCodeAt(u) - 48;
          o *= i, a = c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c, n(c >= 0 && a < i, "Invalid character"), o += a;
        }
        return o;
      }
      function c(e, t) {
        e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
      }
      if (i.isBN = function (e) {
        return e instanceof i || null !== e && "object" == typeof e && e.constructor.wordSize === i.wordSize && Array.isArray(e.words);
      }, i.max = function (e, t) {
        return e.cmp(t) > 0 ? e : t;
      }, i.min = function (e, t) {
        return e.cmp(t) < 0 ? e : t;
      }, i.prototype._init = function (e, t, r) {
        if ("number" == typeof e) return this._initNumber(e, t, r);
        if ("object" == typeof e) return this._initArray(e, t, r);
        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
        var i = 0;
        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
      }, i.prototype._initNumber = function (e, t, r) {
        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (n(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
      }, i.prototype._initArray = function (e, t, r) {
        if (n("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) this.words[i] = 0;
        var o,
          a,
          s = 0;
        if ("be" === r) for (i = e.length - 1, o = 0; i >= 0; i -= 3) a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);else if ("le" === r) for (i = 0, o = 0; i < e.length; i += 3) a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
        return this._strip();
      }, i.prototype._parseHex = function (e, t, n) {
        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
        for (var r = 0; r < this.length; r++) this.words[r] = 0;
        var i,
          o = 0,
          a = 0;
        if ("be" === n) for (r = e.length - 1; r >= t; r -= 2) i = s(e, t, r) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;else for (r = (e.length - t) % 2 == 0 ? t + 1 : t; r < e.length; r += 2) i = s(e, t, r) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
        this._strip();
      }, i.prototype._parseBase = function (e, t, n) {
        this.words = [0], this.length = 1;
        for (var r = 0, i = 1; i <= 67108863; i *= t) r++;
        r--, i = i / t | 0;
        for (var o = e.length - n, a = o % r, s = Math.min(o, o - a) + n, c = 0, l = n; l < s; l += r) c = u(e, l, l + r, t), this.imuln(i), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
        if (0 !== a) {
          var d = 1;
          for (c = u(e, l, e.length, t), l = 0; l < a; l++) d *= t;
          this.imuln(d), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
        }
        this._strip();
      }, i.prototype.copy = function (e) {
        e.words = new Array(this.length);
        for (var t = 0; t < this.length; t++) e.words[t] = this.words[t];
        e.length = this.length, e.negative = this.negative, e.red = this.red;
      }, i.prototype._move = function (e) {
        c(e, this);
      }, i.prototype.clone = function () {
        var e = new i(null);
        return this.copy(e), e;
      }, i.prototype._expand = function (e) {
        for (; this.length < e;) this.words[this.length++] = 0;
        return this;
      }, i.prototype._strip = function () {
        for (; this.length > 1 && 0 === this.words[this.length - 1];) this.length--;
        return this._normSign();
      }, i.prototype._normSign = function () {
        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
      }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
        i.prototype[Symbol.for("nodejs.util.inspect.custom")] = l;
      } catch (e) {
        i.prototype.inspect = l;
      } else i.prototype.inspect = l;
      function l() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var d = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
        f = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
        h = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
      i.prototype.toString = function (e, t) {
        var r;
        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
          r = "";
          for (var i = 0, o = 0, a = 0; a < this.length; a++) {
            var s = this.words[a],
              u = (16777215 & (s << i | o)).toString(16);
            o = s >>> 24 - i & 16777215, (i += 2) >= 26 && (i -= 26, a--), r = 0 !== o || a !== this.length - 1 ? d[6 - u.length] + u + r : u + r;
          }
          for (0 !== o && (r = o.toString(16) + r); r.length % t != 0;) r = "0" + r;
          return 0 !== this.negative && (r = "-" + r), r;
        }
        if (e === (0 | e) && e >= 2 && e <= 36) {
          var c = f[e],
            l = h[e];
          r = "";
          var p = this.clone();
          for (p.negative = 0; !p.isZero();) {
            var m = p.modrn(l).toString(e);
            r = (p = p.idivn(l)).isZero() ? m + r : d[c - m.length] + m + r;
          }
          for (this.isZero() && (r = "0" + r); r.length % t != 0;) r = "0" + r;
          return 0 !== this.negative && (r = "-" + r), r;
        }
        n(!1, "Base should be between 2 and 36");
      }, i.prototype.toNumber = function () {
        var e = this.words[0];
        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
      }, i.prototype.toJSON = function () {
        return this.toString(16, 2);
      }, o && (i.prototype.toBuffer = function (e, t) {
        return this.toArrayLike(o, e, t);
      }), i.prototype.toArray = function (e, t) {
        return this.toArrayLike(Array, e, t);
      };
      function p(e, t, n) {
        n.negative = t.negative ^ e.negative;
        var r = e.length + t.length | 0;
        n.length = r, r = r - 1 | 0;
        var i = 0 | e.words[0],
          o = 0 | t.words[0],
          a = i * o,
          s = 67108863 & a,
          u = a / 67108864 | 0;
        n.words[0] = s;
        for (var c = 1; c < r; c++) {
          for (var l = u >>> 26, d = 67108863 & u, f = Math.min(c, t.length - 1), h = Math.max(0, c - e.length + 1); h <= f; h++) {
            var p = c - h | 0;
            l += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[h]) + d) / 67108864 | 0, d = 67108863 & a;
          }
          n.words[c] = 0 | d, u = 0 | l;
        }
        return 0 !== u ? n.words[c] = 0 | u : n.length--, n._strip();
      }
      i.prototype.toArrayLike = function (e, t, r) {
        this._strip();
        var i = this.byteLength(),
          o = r || Math.max(1, i);
        n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0");
        var a = function (e, t) {
          return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
        }(e, o);
        return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](a, i), a;
      }, i.prototype._toArrayLikeLE = function (e, t) {
        for (var n = 0, r = 0, i = 0, o = 0; i < this.length; i++) {
          var a = this.words[i] << o | r;
          e[n++] = 255 & a, n < e.length && (e[n++] = a >> 8 & 255), n < e.length && (e[n++] = a >> 16 & 255), 6 === o ? (n < e.length && (e[n++] = a >> 24 & 255), r = 0, o = 0) : (r = a >>> 24, o += 2);
        }
        if (n < e.length) for (e[n++] = r; n < e.length;) e[n++] = 0;
      }, i.prototype._toArrayLikeBE = function (e, t) {
        for (var n = e.length - 1, r = 0, i = 0, o = 0; i < this.length; i++) {
          var a = this.words[i] << o | r;
          e[n--] = 255 & a, n >= 0 && (e[n--] = a >> 8 & 255), n >= 0 && (e[n--] = a >> 16 & 255), 6 === o ? (n >= 0 && (e[n--] = a >> 24 & 255), r = 0, o = 0) : (r = a >>> 24, o += 2);
        }
        if (n >= 0) for (e[n--] = r; n >= 0;) e[n--] = 0;
      }, Math.clz32 ? i.prototype._countBits = function (e) {
        return 32 - Math.clz32(e);
      } : i.prototype._countBits = function (e) {
        var t = e,
          n = 0;
        return t >= 4096 && (n += 13, t >>>= 13), t >= 64 && (n += 7, t >>>= 7), t >= 8 && (n += 4, t >>>= 4), t >= 2 && (n += 2, t >>>= 2), n + t;
      }, i.prototype._zeroBits = function (e) {
        if (0 === e) return 26;
        var t = e,
          n = 0;
        return 0 == (8191 & t) && (n += 13, t >>>= 13), 0 == (127 & t) && (n += 7, t >>>= 7), 0 == (15 & t) && (n += 4, t >>>= 4), 0 == (3 & t) && (n += 2, t >>>= 2), 0 == (1 & t) && n++, n;
      }, i.prototype.bitLength = function () {
        var e = this.words[this.length - 1],
          t = this._countBits(e);
        return 26 * (this.length - 1) + t;
      }, i.prototype.zeroBits = function () {
        if (this.isZero()) return 0;
        for (var e = 0, t = 0; t < this.length; t++) {
          var n = this._zeroBits(this.words[t]);
          if (e += n, 26 !== n) break;
        }
        return e;
      }, i.prototype.byteLength = function () {
        return Math.ceil(this.bitLength() / 8);
      }, i.prototype.toTwos = function (e) {
        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
      }, i.prototype.fromTwos = function (e) {
        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
      }, i.prototype.isNeg = function () {
        return 0 !== this.negative;
      }, i.prototype.neg = function () {
        return this.clone().ineg();
      }, i.prototype.ineg = function () {
        return this.isZero() || (this.negative ^= 1), this;
      }, i.prototype.iuor = function (e) {
        for (; this.length < e.length;) this.words[this.length++] = 0;
        for (var t = 0; t < e.length; t++) this.words[t] = this.words[t] | e.words[t];
        return this._strip();
      }, i.prototype.ior = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuor(e);
      }, i.prototype.or = function (e) {
        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
      }, i.prototype.uor = function (e) {
        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
      }, i.prototype.iuand = function (e) {
        var t;
        t = this.length > e.length ? e : this;
        for (var n = 0; n < t.length; n++) this.words[n] = this.words[n] & e.words[n];
        return this.length = t.length, this._strip();
      }, i.prototype.iand = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuand(e);
      }, i.prototype.and = function (e) {
        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
      }, i.prototype.uand = function (e) {
        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
      }, i.prototype.iuxor = function (e) {
        var t, n;
        this.length > e.length ? (t = this, n = e) : (t = e, n = this);
        for (var r = 0; r < n.length; r++) this.words[r] = t.words[r] ^ n.words[r];
        if (this !== t) for (; r < t.length; r++) this.words[r] = t.words[r];
        return this.length = t.length, this._strip();
      }, i.prototype.ixor = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuxor(e);
      }, i.prototype.xor = function (e) {
        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
      }, i.prototype.uxor = function (e) {
        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
      }, i.prototype.inotn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = 0 | Math.ceil(e / 26),
          r = e % 26;
        this._expand(t), r > 0 && t--;
        for (var i = 0; i < t; i++) this.words[i] = 67108863 & ~this.words[i];
        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this._strip();
      }, i.prototype.notn = function (e) {
        return this.clone().inotn(e);
      }, i.prototype.setn = function (e, t) {
        n("number" == typeof e && e >= 0);
        var r = e / 26 | 0,
          i = e % 26;
        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this._strip();
      }, i.prototype.iadd = function (e) {
        var t, n, r;
        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
        this.length > e.length ? (n = this, r = e) : (n = e, r = this);
        for (var i = 0, o = 0; o < r.length; o++) t = (0 | n.words[o]) + (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
        for (; 0 !== i && o < n.length; o++) t = (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
        if (this.length = n.length, 0 !== i) this.words[this.length] = i, this.length++;else if (n !== this) for (; o < n.length; o++) this.words[o] = n.words[o];
        return this;
      }, i.prototype.add = function (e) {
        var t;
        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
      }, i.prototype.isub = function (e) {
        if (0 !== e.negative) {
          e.negative = 0;
          var t = this.iadd(e);
          return e.negative = 1, t._normSign();
        }
        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
        var n,
          r,
          i = this.cmp(e);
        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        i > 0 ? (n = this, r = e) : (n = e, r = this);
        for (var o = 0, a = 0; a < r.length; a++) o = (t = (0 | n.words[a]) - (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
        for (; 0 !== o && a < n.length; a++) o = (t = (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
        if (0 === o && a < n.length && n !== this) for (; a < n.length; a++) this.words[a] = n.words[a];
        return this.length = Math.max(this.length, a), n !== this && (this.negative = 1), this._strip();
      }, i.prototype.sub = function (e) {
        return this.clone().isub(e);
      };
      var m = function (e, t, n) {
        var r,
          i,
          o,
          a = e.words,
          s = t.words,
          u = n.words,
          c = 0,
          l = 0 | a[0],
          d = 8191 & l,
          f = l >>> 13,
          h = 0 | a[1],
          p = 8191 & h,
          m = h >>> 13,
          g = 0 | a[2],
          v = 8191 & g,
          b = g >>> 13,
          y = 0 | a[3],
          w = 8191 & y,
          A = y >>> 13,
          _ = 0 | a[4],
          E = 8191 & _,
          S = _ >>> 13,
          k = 0 | a[5],
          M = 8191 & k,
          C = k >>> 13,
          x = 0 | a[6],
          R = 8191 & x,
          I = x >>> 13,
          T = 0 | a[7],
          P = 8191 & T,
          O = T >>> 13,
          L = 0 | a[8],
          N = 8191 & L,
          D = L >>> 13,
          B = 0 | a[9],
          j = 8191 & B,
          F = B >>> 13,
          z = 0 | s[0],
          U = 8191 & z,
          q = z >>> 13,
          K = 0 | s[1],
          H = 8191 & K,
          V = K >>> 13,
          $ = 0 | s[2],
          W = 8191 & $,
          Y = $ >>> 13,
          G = 0 | s[3],
          Q = 8191 & G,
          Z = G >>> 13,
          J = 0 | s[4],
          X = 8191 & J,
          ee = J >>> 13,
          te = 0 | s[5],
          ne = 8191 & te,
          re = te >>> 13,
          ie = 0 | s[6],
          oe = 8191 & ie,
          ae = ie >>> 13,
          se = 0 | s[7],
          ue = 8191 & se,
          ce = se >>> 13,
          le = 0 | s[8],
          de = 8191 & le,
          fe = le >>> 13,
          he = 0 | s[9],
          pe = 8191 & he,
          me = he >>> 13;
        n.negative = e.negative ^ t.negative, n.length = 19;
        var ge = (c + (r = Math.imul(d, U)) | 0) + ((8191 & (i = (i = Math.imul(d, q)) + Math.imul(f, U) | 0)) << 13) | 0;
        c = ((o = Math.imul(f, q)) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, r = Math.imul(p, U), i = (i = Math.imul(p, q)) + Math.imul(m, U) | 0, o = Math.imul(m, q);
        var ve = (c + (r = r + Math.imul(d, H) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, V) | 0) + Math.imul(f, H) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, V) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, r = Math.imul(v, U), i = (i = Math.imul(v, q)) + Math.imul(b, U) | 0, o = Math.imul(b, q), r = r + Math.imul(p, H) | 0, i = (i = i + Math.imul(p, V) | 0) + Math.imul(m, H) | 0, o = o + Math.imul(m, V) | 0;
        var be = (c + (r = r + Math.imul(d, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Y) | 0) + Math.imul(f, W) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, Y) | 0) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, r = Math.imul(w, U), i = (i = Math.imul(w, q)) + Math.imul(A, U) | 0, o = Math.imul(A, q), r = r + Math.imul(v, H) | 0, i = (i = i + Math.imul(v, V) | 0) + Math.imul(b, H) | 0, o = o + Math.imul(b, V) | 0, r = r + Math.imul(p, W) | 0, i = (i = i + Math.imul(p, Y) | 0) + Math.imul(m, W) | 0, o = o + Math.imul(m, Y) | 0;
        var ye = (c + (r = r + Math.imul(d, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Z) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, Z) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, r = Math.imul(E, U), i = (i = Math.imul(E, q)) + Math.imul(S, U) | 0, o = Math.imul(S, q), r = r + Math.imul(w, H) | 0, i = (i = i + Math.imul(w, V) | 0) + Math.imul(A, H) | 0, o = o + Math.imul(A, V) | 0, r = r + Math.imul(v, W) | 0, i = (i = i + Math.imul(v, Y) | 0) + Math.imul(b, W) | 0, o = o + Math.imul(b, Y) | 0, r = r + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, Z) | 0) + Math.imul(m, Q) | 0, o = o + Math.imul(m, Z) | 0;
        var we = (c + (r = r + Math.imul(d, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, r = Math.imul(M, U), i = (i = Math.imul(M, q)) + Math.imul(C, U) | 0, o = Math.imul(C, q), r = r + Math.imul(E, H) | 0, i = (i = i + Math.imul(E, V) | 0) + Math.imul(S, H) | 0, o = o + Math.imul(S, V) | 0, r = r + Math.imul(w, W) | 0, i = (i = i + Math.imul(w, Y) | 0) + Math.imul(A, W) | 0, o = o + Math.imul(A, Y) | 0, r = r + Math.imul(v, Q) | 0, i = (i = i + Math.imul(v, Z) | 0) + Math.imul(b, Q) | 0, o = o + Math.imul(b, Z) | 0, r = r + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, X) | 0, o = o + Math.imul(m, ee) | 0;
        var Ae = (c + (r = r + Math.imul(d, ne) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, re) | 0) + Math.imul(f, ne) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, re) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, r = Math.imul(R, U), i = (i = Math.imul(R, q)) + Math.imul(I, U) | 0, o = Math.imul(I, q), r = r + Math.imul(M, H) | 0, i = (i = i + Math.imul(M, V) | 0) + Math.imul(C, H) | 0, o = o + Math.imul(C, V) | 0, r = r + Math.imul(E, W) | 0, i = (i = i + Math.imul(E, Y) | 0) + Math.imul(S, W) | 0, o = o + Math.imul(S, Y) | 0, r = r + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, Z) | 0) + Math.imul(A, Q) | 0, o = o + Math.imul(A, Z) | 0, r = r + Math.imul(v, X) | 0, i = (i = i + Math.imul(v, ee) | 0) + Math.imul(b, X) | 0, o = o + Math.imul(b, ee) | 0, r = r + Math.imul(p, ne) | 0, i = (i = i + Math.imul(p, re) | 0) + Math.imul(m, ne) | 0, o = o + Math.imul(m, re) | 0;
        var _e = (c + (r = r + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ae) | 0) + Math.imul(f, oe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ae) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, r = Math.imul(P, U), i = (i = Math.imul(P, q)) + Math.imul(O, U) | 0, o = Math.imul(O, q), r = r + Math.imul(R, H) | 0, i = (i = i + Math.imul(R, V) | 0) + Math.imul(I, H) | 0, o = o + Math.imul(I, V) | 0, r = r + Math.imul(M, W) | 0, i = (i = i + Math.imul(M, Y) | 0) + Math.imul(C, W) | 0, o = o + Math.imul(C, Y) | 0, r = r + Math.imul(E, Q) | 0, i = (i = i + Math.imul(E, Z) | 0) + Math.imul(S, Q) | 0, o = o + Math.imul(S, Z) | 0, r = r + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(A, X) | 0, o = o + Math.imul(A, ee) | 0, r = r + Math.imul(v, ne) | 0, i = (i = i + Math.imul(v, re) | 0) + Math.imul(b, ne) | 0, o = o + Math.imul(b, re) | 0, r = r + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, ae) | 0;
        var Ee = (c + (r = r + Math.imul(d, ue) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ce) | 0) + Math.imul(f, ue) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, r = Math.imul(N, U), i = (i = Math.imul(N, q)) + Math.imul(D, U) | 0, o = Math.imul(D, q), r = r + Math.imul(P, H) | 0, i = (i = i + Math.imul(P, V) | 0) + Math.imul(O, H) | 0, o = o + Math.imul(O, V) | 0, r = r + Math.imul(R, W) | 0, i = (i = i + Math.imul(R, Y) | 0) + Math.imul(I, W) | 0, o = o + Math.imul(I, Y) | 0, r = r + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, Z) | 0) + Math.imul(C, Q) | 0, o = o + Math.imul(C, Z) | 0, r = r + Math.imul(E, X) | 0, i = (i = i + Math.imul(E, ee) | 0) + Math.imul(S, X) | 0, o = o + Math.imul(S, ee) | 0, r = r + Math.imul(w, ne) | 0, i = (i = i + Math.imul(w, re) | 0) + Math.imul(A, ne) | 0, o = o + Math.imul(A, re) | 0, r = r + Math.imul(v, oe) | 0, i = (i = i + Math.imul(v, ae) | 0) + Math.imul(b, oe) | 0, o = o + Math.imul(b, ae) | 0, r = r + Math.imul(p, ue) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, ue) | 0, o = o + Math.imul(m, ce) | 0;
        var Se = (c + (r = r + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, fe) | 0) + Math.imul(f, de) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, r = Math.imul(j, U), i = (i = Math.imul(j, q)) + Math.imul(F, U) | 0, o = Math.imul(F, q), r = r + Math.imul(N, H) | 0, i = (i = i + Math.imul(N, V) | 0) + Math.imul(D, H) | 0, o = o + Math.imul(D, V) | 0, r = r + Math.imul(P, W) | 0, i = (i = i + Math.imul(P, Y) | 0) + Math.imul(O, W) | 0, o = o + Math.imul(O, Y) | 0, r = r + Math.imul(R, Q) | 0, i = (i = i + Math.imul(R, Z) | 0) + Math.imul(I, Q) | 0, o = o + Math.imul(I, Z) | 0, r = r + Math.imul(M, X) | 0, i = (i = i + Math.imul(M, ee) | 0) + Math.imul(C, X) | 0, o = o + Math.imul(C, ee) | 0, r = r + Math.imul(E, ne) | 0, i = (i = i + Math.imul(E, re) | 0) + Math.imul(S, ne) | 0, o = o + Math.imul(S, re) | 0, r = r + Math.imul(w, oe) | 0, i = (i = i + Math.imul(w, ae) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, ae) | 0, r = r + Math.imul(v, ue) | 0, i = (i = i + Math.imul(v, ce) | 0) + Math.imul(b, ue) | 0, o = o + Math.imul(b, ce) | 0, r = r + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, de) | 0, o = o + Math.imul(m, fe) | 0;
        var ke = (c + (r = r + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, r = Math.imul(j, H), i = (i = Math.imul(j, V)) + Math.imul(F, H) | 0, o = Math.imul(F, V), r = r + Math.imul(N, W) | 0, i = (i = i + Math.imul(N, Y) | 0) + Math.imul(D, W) | 0, o = o + Math.imul(D, Y) | 0, r = r + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, Z) | 0) + Math.imul(O, Q) | 0, o = o + Math.imul(O, Z) | 0, r = r + Math.imul(R, X) | 0, i = (i = i + Math.imul(R, ee) | 0) + Math.imul(I, X) | 0, o = o + Math.imul(I, ee) | 0, r = r + Math.imul(M, ne) | 0, i = (i = i + Math.imul(M, re) | 0) + Math.imul(C, ne) | 0, o = o + Math.imul(C, re) | 0, r = r + Math.imul(E, oe) | 0, i = (i = i + Math.imul(E, ae) | 0) + Math.imul(S, oe) | 0, o = o + Math.imul(S, ae) | 0, r = r + Math.imul(w, ue) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(A, ue) | 0, o = o + Math.imul(A, ce) | 0, r = r + Math.imul(v, de) | 0, i = (i = i + Math.imul(v, fe) | 0) + Math.imul(b, de) | 0, o = o + Math.imul(b, fe) | 0;
        var Me = (c + (r = r + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, r = Math.imul(j, W), i = (i = Math.imul(j, Y)) + Math.imul(F, W) | 0, o = Math.imul(F, Y), r = r + Math.imul(N, Q) | 0, i = (i = i + Math.imul(N, Z) | 0) + Math.imul(D, Q) | 0, o = o + Math.imul(D, Z) | 0, r = r + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(O, X) | 0, o = o + Math.imul(O, ee) | 0, r = r + Math.imul(R, ne) | 0, i = (i = i + Math.imul(R, re) | 0) + Math.imul(I, ne) | 0, o = o + Math.imul(I, re) | 0, r = r + Math.imul(M, oe) | 0, i = (i = i + Math.imul(M, ae) | 0) + Math.imul(C, oe) | 0, o = o + Math.imul(C, ae) | 0, r = r + Math.imul(E, ue) | 0, i = (i = i + Math.imul(E, ce) | 0) + Math.imul(S, ue) | 0, o = o + Math.imul(S, ce) | 0, r = r + Math.imul(w, de) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(A, de) | 0, o = o + Math.imul(A, fe) | 0;
        var Ce = (c + (r = r + Math.imul(v, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(v, me) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(b, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, r = Math.imul(j, Q), i = (i = Math.imul(j, Z)) + Math.imul(F, Q) | 0, o = Math.imul(F, Z), r = r + Math.imul(N, X) | 0, i = (i = i + Math.imul(N, ee) | 0) + Math.imul(D, X) | 0, o = o + Math.imul(D, ee) | 0, r = r + Math.imul(P, ne) | 0, i = (i = i + Math.imul(P, re) | 0) + Math.imul(O, ne) | 0, o = o + Math.imul(O, re) | 0, r = r + Math.imul(R, oe) | 0, i = (i = i + Math.imul(R, ae) | 0) + Math.imul(I, oe) | 0, o = o + Math.imul(I, ae) | 0, r = r + Math.imul(M, ue) | 0, i = (i = i + Math.imul(M, ce) | 0) + Math.imul(C, ue) | 0, o = o + Math.imul(C, ce) | 0, r = r + Math.imul(E, de) | 0, i = (i = i + Math.imul(E, fe) | 0) + Math.imul(S, de) | 0, o = o + Math.imul(S, fe) | 0;
        var xe = (c + (r = r + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(A, me) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, r = Math.imul(j, X), i = (i = Math.imul(j, ee)) + Math.imul(F, X) | 0, o = Math.imul(F, ee), r = r + Math.imul(N, ne) | 0, i = (i = i + Math.imul(N, re) | 0) + Math.imul(D, ne) | 0, o = o + Math.imul(D, re) | 0, r = r + Math.imul(P, oe) | 0, i = (i = i + Math.imul(P, ae) | 0) + Math.imul(O, oe) | 0, o = o + Math.imul(O, ae) | 0, r = r + Math.imul(R, ue) | 0, i = (i = i + Math.imul(R, ce) | 0) + Math.imul(I, ue) | 0, o = o + Math.imul(I, ce) | 0, r = r + Math.imul(M, de) | 0, i = (i = i + Math.imul(M, fe) | 0) + Math.imul(C, de) | 0, o = o + Math.imul(C, fe) | 0;
        var Re = (c + (r = r + Math.imul(E, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(E, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, r = Math.imul(j, ne), i = (i = Math.imul(j, re)) + Math.imul(F, ne) | 0, o = Math.imul(F, re), r = r + Math.imul(N, oe) | 0, i = (i = i + Math.imul(N, ae) | 0) + Math.imul(D, oe) | 0, o = o + Math.imul(D, ae) | 0, r = r + Math.imul(P, ue) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(O, ue) | 0, o = o + Math.imul(O, ce) | 0, r = r + Math.imul(R, de) | 0, i = (i = i + Math.imul(R, fe) | 0) + Math.imul(I, de) | 0, o = o + Math.imul(I, fe) | 0;
        var Ie = (c + (r = r + Math.imul(M, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, me) | 0) + Math.imul(C, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(C, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, r = Math.imul(j, oe), i = (i = Math.imul(j, ae)) + Math.imul(F, oe) | 0, o = Math.imul(F, ae), r = r + Math.imul(N, ue) | 0, i = (i = i + Math.imul(N, ce) | 0) + Math.imul(D, ue) | 0, o = o + Math.imul(D, ce) | 0, r = r + Math.imul(P, de) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(O, de) | 0, o = o + Math.imul(O, fe) | 0;
        var Te = (c + (r = r + Math.imul(R, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(R, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, r = Math.imul(j, ue), i = (i = Math.imul(j, ce)) + Math.imul(F, ue) | 0, o = Math.imul(F, ce), r = r + Math.imul(N, de) | 0, i = (i = i + Math.imul(N, fe) | 0) + Math.imul(D, de) | 0, o = o + Math.imul(D, fe) | 0;
        var Pe = (c + (r = r + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(O, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(O, me) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, r = Math.imul(j, de), i = (i = Math.imul(j, fe)) + Math.imul(F, de) | 0, o = Math.imul(F, fe);
        var Oe = (c + (r = r + Math.imul(N, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(N, me) | 0) + Math.imul(D, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(D, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863;
        var Le = (c + (r = Math.imul(j, pe)) | 0) + ((8191 & (i = (i = Math.imul(j, me)) + Math.imul(F, pe) | 0)) << 13) | 0;
        return c = ((o = Math.imul(F, me)) + (i >>> 13) | 0) + (Le >>> 26) | 0, Le &= 67108863, u[0] = ge, u[1] = ve, u[2] = be, u[3] = ye, u[4] = we, u[5] = Ae, u[6] = _e, u[7] = Ee, u[8] = Se, u[9] = ke, u[10] = Me, u[11] = Ce, u[12] = xe, u[13] = Re, u[14] = Ie, u[15] = Te, u[16] = Pe, u[17] = Oe, u[18] = Le, 0 !== c && (u[19] = c, n.length++), n;
      };
      function g(e, t, n) {
        n.negative = t.negative ^ e.negative, n.length = e.length + t.length;
        for (var r = 0, i = 0, o = 0; o < n.length - 1; o++) {
          var a = i;
          i = 0;
          for (var s = 67108863 & r, u = Math.min(o, t.length - 1), c = Math.max(0, o - e.length + 1); c <= u; c++) {
            var l = o - c,
              d = (0 | e.words[l]) * (0 | t.words[c]),
              f = 67108863 & d;
            s = 67108863 & (f = f + s | 0), i += (a = (a = a + (d / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, a &= 67108863;
          }
          n.words[o] = s, r = a, a = i;
        }
        return 0 !== r ? n.words[o] = r : n.length--, n._strip();
      }
      function v(e, t, n) {
        return g(e, t, n);
      }
      Math.imul || (m = p), i.prototype.mulTo = function (e, t) {
        var n = this.length + e.length;
        return 10 === this.length && 10 === e.length ? m(this, e, t) : n < 63 ? p(this, e, t) : n < 1024 ? g(this, e, t) : v(this, e, t);
      }, i.prototype.mul = function (e) {
        var t = new i(null);
        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
      }, i.prototype.mulf = function (e) {
        var t = new i(null);
        return t.words = new Array(this.length + e.length), v(this, e, t);
      }, i.prototype.imul = function (e) {
        return this.clone().mulTo(e, this);
      }, i.prototype.imuln = function (e) {
        var t = e < 0;
        t && (e = -e), n("number" == typeof e), n(e < 67108864);
        for (var r = 0, i = 0; i < this.length; i++) {
          var o = (0 | this.words[i]) * e,
            a = (67108863 & o) + (67108863 & r);
          r >>= 26, r += o / 67108864 | 0, r += a >>> 26, this.words[i] = 67108863 & a;
        }
        return 0 !== r && (this.words[i] = r, this.length++), t ? this.ineg() : this;
      }, i.prototype.muln = function (e) {
        return this.clone().imuln(e);
      }, i.prototype.sqr = function () {
        return this.mul(this);
      }, i.prototype.isqr = function () {
        return this.imul(this.clone());
      }, i.prototype.pow = function (e) {
        var t = function (e) {
          for (var t = new Array(e.bitLength()), n = 0; n < t.length; n++) {
            var r = n / 26 | 0,
              i = n % 26;
            t[n] = e.words[r] >>> i & 1;
          }
          return t;
        }(e);
        if (0 === t.length) return new i(1);
        for (var n = this, r = 0; r < t.length && 0 === t[r]; r++, n = n.sqr());
        if (++r < t.length) for (var o = n.sqr(); r < t.length; r++, o = o.sqr()) 0 !== t[r] && (n = n.mul(o));
        return n;
      }, i.prototype.iushln = function (e) {
        n("number" == typeof e && e >= 0);
        var t,
          r = e % 26,
          i = (e - r) / 26,
          o = 67108863 >>> 26 - r << 26 - r;
        if (0 !== r) {
          var a = 0;
          for (t = 0; t < this.length; t++) {
            var s = this.words[t] & o,
              u = (0 | this.words[t]) - s << r;
            this.words[t] = u | a, a = s >>> 26 - r;
          }
          a && (this.words[t] = a, this.length++);
        }
        if (0 !== i) {
          for (t = this.length - 1; t >= 0; t--) this.words[t + i] = this.words[t];
          for (t = 0; t < i; t++) this.words[t] = 0;
          this.length += i;
        }
        return this._strip();
      }, i.prototype.ishln = function (e) {
        return n(0 === this.negative), this.iushln(e);
      }, i.prototype.iushrn = function (e, t, r) {
        var i;
        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
        var o = e % 26,
          a = Math.min((e - o) / 26, this.length),
          s = 67108863 ^ 67108863 >>> o << o,
          u = r;
        if (i -= a, i = Math.max(0, i), u) {
          for (var c = 0; c < a; c++) u.words[c] = this.words[c];
          u.length = a;
        }
        if (0 === a) ;else if (this.length > a) for (this.length -= a, c = 0; c < this.length; c++) this.words[c] = this.words[c + a];else this.words[0] = 0, this.length = 1;
        var l = 0;
        for (c = this.length - 1; c >= 0 && (0 !== l || c >= i); c--) {
          var d = 0 | this.words[c];
          this.words[c] = l << 26 - o | d >>> o, l = d & s;
        }
        return u && 0 !== l && (u.words[u.length++] = l), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
      }, i.prototype.ishrn = function (e, t, r) {
        return n(0 === this.negative), this.iushrn(e, t, r);
      }, i.prototype.shln = function (e) {
        return this.clone().ishln(e);
      }, i.prototype.ushln = function (e) {
        return this.clone().iushln(e);
      }, i.prototype.shrn = function (e) {
        return this.clone().ishrn(e);
      }, i.prototype.ushrn = function (e) {
        return this.clone().iushrn(e);
      }, i.prototype.testn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = e % 26,
          r = (e - t) / 26,
          i = 1 << t;
        return !(this.length <= r) && !!(this.words[r] & i);
      }, i.prototype.imaskn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = e % 26,
          r = (e - t) / 26;
        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
          var i = 67108863 ^ 67108863 >>> t << t;
          this.words[this.length - 1] &= i;
        }
        return this._strip();
      }, i.prototype.maskn = function (e) {
        return this.clone().imaskn(e);
      }, i.prototype.iaddn = function (e) {
        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
      }, i.prototype._iaddn = function (e) {
        this.words[0] += e;
        for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
        return this.length = Math.max(this.length, t + 1), this;
      }, i.prototype.isubn = function (e) {
        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) this.words[t] += 67108864, this.words[t + 1] -= 1;
        return this._strip();
      }, i.prototype.addn = function (e) {
        return this.clone().iaddn(e);
      }, i.prototype.subn = function (e) {
        return this.clone().isubn(e);
      }, i.prototype.iabs = function () {
        return this.negative = 0, this;
      }, i.prototype.abs = function () {
        return this.clone().iabs();
      }, i.prototype._ishlnsubmul = function (e, t, r) {
        var i,
          o,
          a = e.length + r;
        this._expand(a);
        var s = 0;
        for (i = 0; i < e.length; i++) {
          o = (0 | this.words[i + r]) + s;
          var u = (0 | e.words[i]) * t;
          s = ((o -= 67108863 & u) >> 26) - (u / 67108864 | 0), this.words[i + r] = 67108863 & o;
        }
        for (; i < this.length - r; i++) s = (o = (0 | this.words[i + r]) + s) >> 26, this.words[i + r] = 67108863 & o;
        if (0 === s) return this._strip();
        for (n(-1 === s), s = 0, i = 0; i < this.length; i++) s = (o = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & o;
        return this.negative = 1, this._strip();
      }, i.prototype._wordDiv = function (e, t) {
        var n = (this.length, e.length),
          r = this.clone(),
          o = e,
          a = 0 | o.words[o.length - 1];
        0 !== (n = 26 - this._countBits(a)) && (o = o.ushln(n), r.iushln(n), a = 0 | o.words[o.length - 1]);
        var s,
          u = r.length - o.length;
        if ("mod" !== t) {
          (s = new i(null)).length = u + 1, s.words = new Array(s.length);
          for (var c = 0; c < s.length; c++) s.words[c] = 0;
        }
        var l = r.clone()._ishlnsubmul(o, 1, u);
        0 === l.negative && (r = l, s && (s.words[u] = 1));
        for (var d = u - 1; d >= 0; d--) {
          var f = 67108864 * (0 | r.words[o.length + d]) + (0 | r.words[o.length + d - 1]);
          for (f = Math.min(f / a | 0, 67108863), r._ishlnsubmul(o, f, d); 0 !== r.negative;) f--, r.negative = 0, r._ishlnsubmul(o, 1, d), r.isZero() || (r.negative ^= 1);
          s && (s.words[d] = f);
        }
        return s && s._strip(), r._strip(), "div" !== t && 0 !== n && r.iushrn(n), {
          div: s || null,
          mod: r
        };
      }, i.prototype.divmod = function (e, t, r) {
        return n(!e.isZero()), this.isZero() ? {
          div: new i(0),
          mod: new i(0)
        } : 0 !== this.negative && 0 === e.negative ? (s = this.neg().divmod(e, t), "mod" !== t && (o = s.div.neg()), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.iadd(e)), {
          div: o,
          mod: a
        }) : 0 === this.negative && 0 !== e.negative ? (s = this.divmod(e.neg(), t), "mod" !== t && (o = s.div.neg()), {
          div: o,
          mod: s.mod
        }) : 0 != (this.negative & e.negative) ? (s = this.neg().divmod(e.neg(), t), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.isub(e)), {
          div: s.div,
          mod: a
        }) : e.length > this.length || this.cmp(e) < 0 ? {
          div: new i(0),
          mod: this
        } : 1 === e.length ? "div" === t ? {
          div: this.divn(e.words[0]),
          mod: null
        } : "mod" === t ? {
          div: null,
          mod: new i(this.modrn(e.words[0]))
        } : {
          div: this.divn(e.words[0]),
          mod: new i(this.modrn(e.words[0]))
        } : this._wordDiv(e, t);
        var o, a, s;
      }, i.prototype.div = function (e) {
        return this.divmod(e, "div", !1).div;
      }, i.prototype.mod = function (e) {
        return this.divmod(e, "mod", !1).mod;
      }, i.prototype.umod = function (e) {
        return this.divmod(e, "mod", !0).mod;
      }, i.prototype.divRound = function (e) {
        var t = this.divmod(e);
        if (t.mod.isZero()) return t.div;
        var n = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
          r = e.ushrn(1),
          i = e.andln(1),
          o = n.cmp(r);
        return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
      }, i.prototype.modrn = function (e) {
        var t = e < 0;
        t && (e = -e), n(e <= 67108863);
        for (var r = (1 << 26) % e, i = 0, o = this.length - 1; o >= 0; o--) i = (r * i + (0 | this.words[o])) % e;
        return t ? -i : i;
      }, i.prototype.modn = function (e) {
        return this.modrn(e);
      }, i.prototype.idivn = function (e) {
        var t = e < 0;
        t && (e = -e), n(e <= 67108863);
        for (var r = 0, i = this.length - 1; i >= 0; i--) {
          var o = (0 | this.words[i]) + 67108864 * r;
          this.words[i] = o / e | 0, r = o % e;
        }
        return this._strip(), t ? this.ineg() : this;
      }, i.prototype.divn = function (e) {
        return this.clone().idivn(e);
      }, i.prototype.egcd = function (e) {
        n(0 === e.negative), n(!e.isZero());
        var t = this,
          r = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();
        for (var o = new i(1), a = new i(0), s = new i(0), u = new i(1), c = 0; t.isEven() && r.isEven();) t.iushrn(1), r.iushrn(1), ++c;
        for (var l = r.clone(), d = t.clone(); !t.isZero();) {
          for (var f = 0, h = 1; 0 == (t.words[0] & h) && f < 26; ++f, h <<= 1);
          if (f > 0) for (t.iushrn(f); f-- > 0;) (o.isOdd() || a.isOdd()) && (o.iadd(l), a.isub(d)), o.iushrn(1), a.iushrn(1);
          for (var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
          if (p > 0) for (r.iushrn(p); p-- > 0;) (s.isOdd() || u.isOdd()) && (s.iadd(l), u.isub(d)), s.iushrn(1), u.iushrn(1);
          t.cmp(r) >= 0 ? (t.isub(r), o.isub(s), a.isub(u)) : (r.isub(t), s.isub(o), u.isub(a));
        }
        return {
          a: s,
          b: u,
          gcd: r.iushln(c)
        };
      }, i.prototype._invmp = function (e) {
        n(0 === e.negative), n(!e.isZero());
        var t = this,
          r = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();
        for (var o, a = new i(1), s = new i(0), u = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;) {
          for (var c = 0, l = 1; 0 == (t.words[0] & l) && c < 26; ++c, l <<= 1);
          if (c > 0) for (t.iushrn(c); c-- > 0;) a.isOdd() && a.iadd(u), a.iushrn(1);
          for (var d = 0, f = 1; 0 == (r.words[0] & f) && d < 26; ++d, f <<= 1);
          if (d > 0) for (r.iushrn(d); d-- > 0;) s.isOdd() && s.iadd(u), s.iushrn(1);
          t.cmp(r) >= 0 ? (t.isub(r), a.isub(s)) : (r.isub(t), s.isub(a));
        }
        return (o = 0 === t.cmpn(1) ? a : s).cmpn(0) < 0 && o.iadd(e), o;
      }, i.prototype.gcd = function (e) {
        if (this.isZero()) return e.abs();
        if (e.isZero()) return this.abs();
        var t = this.clone(),
          n = e.clone();
        t.negative = 0, n.negative = 0;
        for (var r = 0; t.isEven() && n.isEven(); r++) t.iushrn(1), n.iushrn(1);
        for (;;) {
          for (; t.isEven();) t.iushrn(1);
          for (; n.isEven();) n.iushrn(1);
          var i = t.cmp(n);
          if (i < 0) {
            var o = t;
            t = n, n = o;
          } else if (0 === i || 0 === n.cmpn(1)) break;
          t.isub(n);
        }
        return n.iushln(r);
      }, i.prototype.invm = function (e) {
        return this.egcd(e).a.umod(e);
      }, i.prototype.isEven = function () {
        return 0 == (1 & this.words[0]);
      }, i.prototype.isOdd = function () {
        return 1 == (1 & this.words[0]);
      }, i.prototype.andln = function (e) {
        return this.words[0] & e;
      }, i.prototype.bincn = function (e) {
        n("number" == typeof e);
        var t = e % 26,
          r = (e - t) / 26,
          i = 1 << t;
        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
        for (var o = i, a = r; 0 !== o && a < this.length; a++) {
          var s = 0 | this.words[a];
          o = (s += o) >>> 26, s &= 67108863, this.words[a] = s;
        }
        return 0 !== o && (this.words[a] = o, this.length++), this;
      }, i.prototype.isZero = function () {
        return 1 === this.length && 0 === this.words[0];
      }, i.prototype.cmpn = function (e) {
        var t,
          r = e < 0;
        if (0 !== this.negative && !r) return -1;
        if (0 === this.negative && r) return 1;
        if (this._strip(), this.length > 1) t = 1;else {
          r && (e = -e), n(e <= 67108863, "Number is too big");
          var i = 0 | this.words[0];
          t = i === e ? 0 : i < e ? -1 : 1;
        }
        return 0 !== this.negative ? 0 | -t : t;
      }, i.prototype.cmp = function (e) {
        if (0 !== this.negative && 0 === e.negative) return -1;
        if (0 === this.negative && 0 !== e.negative) return 1;
        var t = this.ucmp(e);
        return 0 !== this.negative ? 0 | -t : t;
      }, i.prototype.ucmp = function (e) {
        if (this.length > e.length) return 1;
        if (this.length < e.length) return -1;
        for (var t = 0, n = this.length - 1; n >= 0; n--) {
          var r = 0 | this.words[n],
            i = 0 | e.words[n];
          if (r !== i) {
            r < i ? t = -1 : r > i && (t = 1);
            break;
          }
        }
        return t;
      }, i.prototype.gtn = function (e) {
        return 1 === this.cmpn(e);
      }, i.prototype.gt = function (e) {
        return 1 === this.cmp(e);
      }, i.prototype.gten = function (e) {
        return this.cmpn(e) >= 0;
      }, i.prototype.gte = function (e) {
        return this.cmp(e) >= 0;
      }, i.prototype.ltn = function (e) {
        return -1 === this.cmpn(e);
      }, i.prototype.lt = function (e) {
        return -1 === this.cmp(e);
      }, i.prototype.lten = function (e) {
        return this.cmpn(e) <= 0;
      }, i.prototype.lte = function (e) {
        return this.cmp(e) <= 0;
      }, i.prototype.eqn = function (e) {
        return 0 === this.cmpn(e);
      }, i.prototype.eq = function (e) {
        return 0 === this.cmp(e);
      }, i.red = function (e) {
        return new S(e);
      }, i.prototype.toRed = function (e) {
        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
      }, i.prototype.fromRed = function () {
        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, i.prototype._forceRed = function (e) {
        return this.red = e, this;
      }, i.prototype.forceRed = function (e) {
        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
      }, i.prototype.redAdd = function (e) {
        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
      }, i.prototype.redIAdd = function (e) {
        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
      }, i.prototype.redSub = function (e) {
        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
      }, i.prototype.redISub = function (e) {
        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
      }, i.prototype.redShl = function (e) {
        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
      }, i.prototype.redMul = function (e) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
      }, i.prototype.redIMul = function (e) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
      }, i.prototype.redSqr = function () {
        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, i.prototype.redISqr = function () {
        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, i.prototype.redSqrt = function () {
        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, i.prototype.redInvm = function () {
        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, i.prototype.redNeg = function () {
        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, i.prototype.redPow = function (e) {
        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
      };
      var b = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function y(e, t) {
        this.name = e, this.p = new i(t, 16), this.n = this.p.bitLength(), this.k = new i(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      function w() {
        y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
      }
      function A() {
        y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
      }
      function _() {
        y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
      }
      function E() {
        y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
      }
      function S(e) {
        if ("string" == typeof e) {
          var t = i._prime(e);
          this.m = t.p, this.prime = t;
        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
      }
      function k(e) {
        S.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new i(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      y.prototype._tmp = function () {
        var e = new i(null);
        return e.words = new Array(Math.ceil(this.n / 13)), e;
      }, y.prototype.ireduce = function (e) {
        var t,
          n = e;
        do {
          this.split(n, this.tmp), t = (n = (n = this.imulK(n)).iadd(this.tmp)).bitLength();
        } while (t > this.n);
        var r = t < this.n ? -1 : n.ucmp(this.p);
        return 0 === r ? (n.words[0] = 0, n.length = 1) : r > 0 ? n.isub(this.p) : void 0 !== n.strip ? n.strip() : n._strip(), n;
      }, y.prototype.split = function (e, t) {
        e.iushrn(this.n, 0, t);
      }, y.prototype.imulK = function (e) {
        return e.imul(this.k);
      }, r(w, y), w.prototype.split = function (e, t) {
        for (var n = 4194303, r = Math.min(e.length, 9), i = 0; i < r; i++) t.words[i] = e.words[i];
        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
        var o = e.words[9];
        for (t.words[t.length++] = o & n, i = 10; i < e.length; i++) {
          var a = 0 | e.words[i];
          e.words[i - 10] = (a & n) << 4 | o >>> 22, o = a;
        }
        o >>>= 22, e.words[i - 10] = o, 0 === o && e.length > 10 ? e.length -= 10 : e.length -= 9;
      }, w.prototype.imulK = function (e) {
        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
        for (var t = 0, n = 0; n < e.length; n++) {
          var r = 0 | e.words[n];
          t += 977 * r, e.words[n] = 67108863 & t, t = 64 * r + (t / 67108864 | 0);
        }
        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
      }, r(A, y), r(_, y), r(E, y), E.prototype.imulK = function (e) {
        for (var t = 0, n = 0; n < e.length; n++) {
          var r = 19 * (0 | e.words[n]) + t,
            i = 67108863 & r;
          r >>>= 26, e.words[n] = i, t = r;
        }
        return 0 !== t && (e.words[e.length++] = t), e;
      }, i._prime = function (e) {
        if (b[e]) return b[e];
        var t;
        if ("k256" === e) t = new w();else if ("p224" === e) t = new A();else if ("p192" === e) t = new _();else {
          if ("p25519" !== e) throw new Error("Unknown prime " + e);
          t = new E();
        }
        return b[e] = t, t;
      }, S.prototype._verify1 = function (e) {
        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
      }, S.prototype._verify2 = function (e, t) {
        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
      }, S.prototype.imod = function (e) {
        return this.prime ? this.prime.ireduce(e)._forceRed(this) : (c(e, e.umod(this.m)._forceRed(this)), e);
      }, S.prototype.neg = function (e) {
        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
      }, S.prototype.add = function (e, t) {
        this._verify2(e, t);
        var n = e.add(t);
        return n.cmp(this.m) >= 0 && n.isub(this.m), n._forceRed(this);
      }, S.prototype.iadd = function (e, t) {
        this._verify2(e, t);
        var n = e.iadd(t);
        return n.cmp(this.m) >= 0 && n.isub(this.m), n;
      }, S.prototype.sub = function (e, t) {
        this._verify2(e, t);
        var n = e.sub(t);
        return n.cmpn(0) < 0 && n.iadd(this.m), n._forceRed(this);
      }, S.prototype.isub = function (e, t) {
        this._verify2(e, t);
        var n = e.isub(t);
        return n.cmpn(0) < 0 && n.iadd(this.m), n;
      }, S.prototype.shl = function (e, t) {
        return this._verify1(e), this.imod(e.ushln(t));
      }, S.prototype.imul = function (e, t) {
        return this._verify2(e, t), this.imod(e.imul(t));
      }, S.prototype.mul = function (e, t) {
        return this._verify2(e, t), this.imod(e.mul(t));
      }, S.prototype.isqr = function (e) {
        return this.imul(e, e.clone());
      }, S.prototype.sqr = function (e) {
        return this.mul(e, e);
      }, S.prototype.sqrt = function (e) {
        if (e.isZero()) return e.clone();
        var t = this.m.andln(3);
        if (n(t % 2 == 1), 3 === t) {
          var r = this.m.add(new i(1)).iushrn(2);
          return this.pow(e, r);
        }
        for (var o = this.m.subn(1), a = 0; !o.isZero() && 0 === o.andln(1);) a++, o.iushrn(1);
        n(!o.isZero());
        var s = new i(1).toRed(this),
          u = s.redNeg(),
          c = this.m.subn(1).iushrn(1),
          l = this.m.bitLength();
        for (l = new i(2 * l * l).toRed(this); 0 !== this.pow(l, c).cmp(u);) l.redIAdd(u);
        for (var d = this.pow(l, o), f = this.pow(e, o.addn(1).iushrn(1)), h = this.pow(e, o), p = a; 0 !== h.cmp(s);) {
          for (var m = h, g = 0; 0 !== m.cmp(s); g++) m = m.redSqr();
          n(g < p);
          var v = this.pow(d, new i(1).iushln(p - g - 1));
          f = f.redMul(v), d = v.redSqr(), h = h.redMul(d), p = g;
        }
        return f;
      }, S.prototype.invm = function (e) {
        var t = e._invmp(this.m);
        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
      }, S.prototype.pow = function (e, t) {
        if (t.isZero()) return new i(1).toRed(this);
        if (0 === t.cmpn(1)) return e.clone();
        var n = new Array(16);
        n[0] = new i(1).toRed(this), n[1] = e;
        for (var r = 2; r < n.length; r++) n[r] = this.mul(n[r - 1], e);
        var o = n[0],
          a = 0,
          s = 0,
          u = t.bitLength() % 26;
        for (0 === u && (u = 26), r = t.length - 1; r >= 0; r--) {
          for (var c = t.words[r], l = u - 1; l >= 0; l--) {
            var d = c >> l & 1;
            o !== n[0] && (o = this.sqr(o)), 0 !== d || 0 !== a ? (a <<= 1, a |= d, (4 === ++s || 0 === r && 0 === l) && (o = this.mul(o, n[a]), s = 0, a = 0)) : s = 0;
          }
          u = 26;
        }
        return o;
      }, S.prototype.convertTo = function (e) {
        var t = e.umod(this.m);
        return t === e ? t.clone() : t;
      }, S.prototype.convertFrom = function (e) {
        var t = e.clone();
        return t.red = null, t;
      }, i.mont = function (e) {
        return new k(e);
      }, r(k, S), k.prototype.convertTo = function (e) {
        return this.imod(e.ushln(this.shift));
      }, k.prototype.convertFrom = function (e) {
        var t = this.imod(e.mul(this.rinv));
        return t.red = null, t;
      }, k.prototype.imul = function (e, t) {
        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
        var n = e.imul(t),
          r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          i = n.isub(r).iushrn(this.shift),
          o = i;
        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
      }, k.prototype.mul = function (e, t) {
        if (e.isZero() || t.isZero()) return new i(0)._forceRed(this);
        var n = e.mul(t),
          r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          o = n.isub(r).iushrn(this.shift),
          a = o;
        return o.cmp(this.m) >= 0 ? a = o.isub(this.m) : o.cmpn(0) < 0 && (a = o.iadd(this.m)), a._forceRed(this);
      }, k.prototype.invm = function (e) {
        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
      };
    }(e, n);
  }(Sc);
  var kc = Sc.exports,
    Mc = Ve;
  function Cc(e) {
    var t,
      n = e.modulus.byteLength();
    do {
      t = new kc(Mc(n));
    } while (t.cmp(e.modulus) >= 0 || !t.umod(e.prime1) || !t.umod(e.prime2));
    return t;
  }
  function xc(e, t) {
    var n = function (e) {
        var t = Cc(e);
        return {
          blinder: t.toRed(kc.mont(e.modulus)).redPow(new kc(e.publicExponent)).fromRed(),
          unblinder: t.invm(e.modulus)
        };
      }(t),
      r = t.modulus.byteLength(),
      i = new kc(e).mul(n.blinder).umod(t.modulus),
      o = i.toRed(kc.mont(t.prime1)),
      a = i.toRed(kc.mont(t.prime2)),
      s = t.coefficient,
      u = t.prime1,
      c = t.prime2,
      l = o.redPow(t.exponent1).fromRed(),
      d = a.redPow(t.exponent2).fromRed(),
      f = l.isub(d).imul(s).umod(u).imul(c);
    return d.iadd(f).imul(n.unblinder).umod(t.modulus).toArrayLike(A, "be", r);
  }
  xc.getr = Cc;
  var Rc = xc,
    Ic = {},
    Tc = {
      name: "elliptic",
      version: "6.5.4",
      description: "EC cryptography",
      main: "lib/elliptic.js",
      files: ["lib"],
      scripts: {
        lint: "eslint lib test",
        "lint:fix": "npm run lint -- --fix",
        unit: "istanbul test _mocha --reporter=spec test/index.js",
        test: "npm run lint && npm run unit",
        version: "grunt dist && git add dist/"
      },
      repository: {
        type: "git",
        url: "git@github.com:indutny/elliptic"
      },
      keywords: ["EC", "Elliptic", "curve", "Cryptography"],
      author: "Fedor Indutny <fedor@indutny.com>",
      license: "MIT",
      bugs: {
        url: "https://github.com/indutny/elliptic/issues"
      },
      homepage: "https://github.com/indutny/elliptic",
      devDependencies: {
        brfs: "^2.0.2",
        coveralls: "^3.1.0",
        eslint: "^7.6.0",
        grunt: "^1.2.1",
        "grunt-browserify": "^5.3.0",
        "grunt-cli": "^1.3.2",
        "grunt-contrib-connect": "^3.0.0",
        "grunt-contrib-copy": "^1.0.0",
        "grunt-contrib-uglify": "^5.0.0",
        "grunt-mocha-istanbul": "^5.0.2",
        "grunt-saucelabs": "^9.0.1",
        istanbul: "^0.4.5",
        mocha: "^8.0.1"
      },
      dependencies: {
        "bn.js": "^4.11.9",
        brorand: "^1.1.0",
        "hash.js": "^1.0.0",
        "hmac-drbg": "^1.0.1",
        inherits: "^2.0.4",
        "minimalistic-assert": "^1.0.1",
        "minimalistic-crypto-utils": "^1.0.1"
      }
    },
    Pc = {},
    Oc = {};
  !function (e) {
    var t = e;
    function n(e) {
      return 1 === e.length ? "0" + e : e;
    }
    function r(e) {
      for (var t = "", r = 0; r < e.length; r++) t += n(e[r].toString(16));
      return t;
    }
    t.toArray = function (e, t) {
      if (Array.isArray(e)) return e.slice();
      if (!e) return [];
      var n = [];
      if ("string" != typeof e) {
        for (var r = 0; r < e.length; r++) n[r] = 0 | e[r];
        return n;
      }
      if ("hex" === t) {
        (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);
        for (r = 0; r < e.length; r += 2) n.push(parseInt(e[r] + e[r + 1], 16));
      } else for (r = 0; r < e.length; r++) {
        var i = e.charCodeAt(r),
          o = i >> 8,
          a = 255 & i;
        o ? n.push(o, a) : n.push(a);
      }
      return n;
    }, t.zero2 = n, t.toHex = r, t.encode = function (e, t) {
      return "hex" === t ? r(e) : e;
    };
  }(Oc), function (e) {
    var t = e,
      n = hc,
      r = Va,
      i = Oc;
    t.assert = r, t.toArray = i.toArray, t.zero2 = i.zero2, t.toHex = i.toHex, t.encode = i.encode, t.getNAF = function (e, t, n) {
      var r = new Array(Math.max(e.bitLength(), n) + 1);
      r.fill(0);
      for (var i = 1 << t + 1, o = e.clone(), a = 0; a < r.length; a++) {
        var s,
          u = o.andln(i - 1);
        o.isOdd() ? (s = u > (i >> 1) - 1 ? (i >> 1) - u : u, o.isubn(s)) : s = 0, r[a] = s, o.iushrn(1);
      }
      return r;
    }, t.getJSF = function (e, t) {
      var n = [[], []];
      e = e.clone(), t = t.clone();
      for (var r, i = 0, o = 0; e.cmpn(-i) > 0 || t.cmpn(-o) > 0;) {
        var a,
          s,
          u = e.andln(3) + i & 3,
          c = t.andln(3) + o & 3;
        3 === u && (u = -1), 3 === c && (c = -1), a = 0 == (1 & u) ? 0 : 3 !== (r = e.andln(7) + i & 7) && 5 !== r || 2 !== c ? u : -u, n[0].push(a), s = 0 == (1 & c) ? 0 : 3 !== (r = t.andln(7) + o & 7) && 5 !== r || 2 !== u ? c : -c, n[1].push(s), 2 * i === a + 1 && (i = 1 - i), 2 * o === s + 1 && (o = 1 - o), e.iushrn(1), t.iushrn(1);
      }
      return n;
    }, t.cachedProperty = function (e, t, n) {
      var r = "_" + t;
      e.prototype[t] = function () {
        return void 0 !== this[r] ? this[r] : this[r] = n.call(this);
      };
    }, t.parseBytes = function (e) {
      return "string" == typeof e ? t.toArray(e, "hex") : e;
    }, t.intFromLE = function (e) {
      return new n(e, "hex", "le");
    };
  }(Pc);
  var Lc = {},
    Nc = hc,
    Dc = Pc,
    Bc = Dc.getNAF,
    jc = Dc.getJSF,
    Fc = Dc.assert;
  function zc(e, t) {
    this.type = e, this.p = new Nc(t.p, 16), this.red = t.prime ? Nc.red(t.prime) : Nc.mont(this.p), this.zero = new Nc(0).toRed(this.red), this.one = new Nc(1).toRed(this.red), this.two = new Nc(2).toRed(this.red), this.n = t.n && new Nc(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var n = this.n && this.p.div(this.n);
    !n || n.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  var Uc = zc;
  function qc(e, t) {
    this.curve = e, this.type = t, this.precomputed = null;
  }
  zc.prototype.point = function () {
    throw new Error("Not implemented");
  }, zc.prototype.validate = function () {
    throw new Error("Not implemented");
  }, zc.prototype._fixedNafMul = function (e, t) {
    Fc(e.precomputed);
    var n = e._getDoubles(),
      r = Bc(t, 1, this._bitLength),
      i = (1 << n.step + 1) - (n.step % 2 == 0 ? 2 : 1);
    i /= 3;
    var o,
      a,
      s = [];
    for (o = 0; o < r.length; o += n.step) {
      a = 0;
      for (var u = o + n.step - 1; u >= o; u--) a = (a << 1) + r[u];
      s.push(a);
    }
    for (var c = this.jpoint(null, null, null), l = this.jpoint(null, null, null), d = i; d > 0; d--) {
      for (o = 0; o < s.length; o++) (a = s[o]) === d ? l = l.mixedAdd(n.points[o]) : a === -d && (l = l.mixedAdd(n.points[o].neg()));
      c = c.add(l);
    }
    return c.toP();
  }, zc.prototype._wnafMul = function (e, t) {
    var n = 4,
      r = e._getNAFPoints(n);
    n = r.wnd;
    for (var i = r.points, o = Bc(t, n, this._bitLength), a = this.jpoint(null, null, null), s = o.length - 1; s >= 0; s--) {
      for (var u = 0; s >= 0 && 0 === o[s]; s--) u++;
      if (s >= 0 && u++, a = a.dblp(u), s < 0) break;
      var c = o[s];
      Fc(0 !== c), a = "affine" === e.type ? c > 0 ? a.mixedAdd(i[c - 1 >> 1]) : a.mixedAdd(i[-c - 1 >> 1].neg()) : c > 0 ? a.add(i[c - 1 >> 1]) : a.add(i[-c - 1 >> 1].neg());
    }
    return "affine" === e.type ? a.toP() : a;
  }, zc.prototype._wnafMulAdd = function (e, t, n, r, i) {
    var o,
      a,
      s,
      u = this._wnafT1,
      c = this._wnafT2,
      l = this._wnafT3,
      d = 0;
    for (o = 0; o < r; o++) {
      var f = (s = t[o])._getNAFPoints(e);
      u[o] = f.wnd, c[o] = f.points;
    }
    for (o = r - 1; o >= 1; o -= 2) {
      var h = o - 1,
        p = o;
      if (1 === u[h] && 1 === u[p]) {
        var m = [t[h], null, null, t[p]];
        0 === t[h].y.cmp(t[p].y) ? (m[1] = t[h].add(t[p]), m[2] = t[h].toJ().mixedAdd(t[p].neg())) : 0 === t[h].y.cmp(t[p].y.redNeg()) ? (m[1] = t[h].toJ().mixedAdd(t[p]), m[2] = t[h].add(t[p].neg())) : (m[1] = t[h].toJ().mixedAdd(t[p]), m[2] = t[h].toJ().mixedAdd(t[p].neg()));
        var g = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
          v = jc(n[h], n[p]);
        for (d = Math.max(v[0].length, d), l[h] = new Array(d), l[p] = new Array(d), a = 0; a < d; a++) {
          var b = 0 | v[0][a],
            y = 0 | v[1][a];
          l[h][a] = g[3 * (b + 1) + (y + 1)], l[p][a] = 0, c[h] = m;
        }
      } else l[h] = Bc(n[h], u[h], this._bitLength), l[p] = Bc(n[p], u[p], this._bitLength), d = Math.max(l[h].length, d), d = Math.max(l[p].length, d);
    }
    var w = this.jpoint(null, null, null),
      A = this._wnafT4;
    for (o = d; o >= 0; o--) {
      for (var _ = 0; o >= 0;) {
        var E = !0;
        for (a = 0; a < r; a++) A[a] = 0 | l[a][o], 0 !== A[a] && (E = !1);
        if (!E) break;
        _++, o--;
      }
      if (o >= 0 && _++, w = w.dblp(_), o < 0) break;
      for (a = 0; a < r; a++) {
        var S = A[a];
        0 !== S && (S > 0 ? s = c[a][S - 1 >> 1] : S < 0 && (s = c[a][-S - 1 >> 1].neg()), w = "affine" === s.type ? w.mixedAdd(s) : w.add(s));
      }
    }
    for (o = 0; o < r; o++) c[o] = null;
    return i ? w : w.toP();
  }, zc.BasePoint = qc, qc.prototype.eq = function () {
    throw new Error("Not implemented");
  }, qc.prototype.validate = function () {
    return this.curve.validate(this);
  }, zc.prototype.decodePoint = function (e, t) {
    e = Dc.toArray(e, t);
    var n = this.p.byteLength();
    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * n) return 6 === e[0] ? Fc(e[e.length - 1] % 2 == 0) : 7 === e[0] && Fc(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + n), e.slice(1 + n, 1 + 2 * n));
    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === n) return this.pointFromX(e.slice(1, 1 + n), 3 === e[0]);
    throw new Error("Unknown point format");
  }, qc.prototype.encodeCompressed = function (e) {
    return this.encode(e, !0);
  }, qc.prototype._encode = function (e) {
    var t = this.curve.p.byteLength(),
      n = this.getX().toArray("be", t);
    return e ? [this.getY().isEven() ? 2 : 3].concat(n) : [4].concat(n, this.getY().toArray("be", t));
  }, qc.prototype.encode = function (e, t) {
    return Dc.encode(this._encode(t), e);
  }, qc.prototype.precompute = function (e) {
    if (this.precomputed) return this;
    var t = {
      doubles: null,
      naf: null,
      beta: null
    };
    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
  }, qc.prototype._hasDoubles = function (e) {
    if (!this.precomputed) return !1;
    var t = this.precomputed.doubles;
    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
  }, qc.prototype._getDoubles = function (e, t) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    for (var n = [this], r = this, i = 0; i < t; i += e) {
      for (var o = 0; o < e; o++) r = r.dbl();
      n.push(r);
    }
    return {
      step: e,
      points: n
    };
  }, qc.prototype._getNAFPoints = function (e) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    for (var t = [this], n = (1 << e) - 1, r = 1 === n ? null : this.dbl(), i = 1; i < n; i++) t[i] = t[i - 1].add(r);
    return {
      wnd: e,
      points: t
    };
  }, qc.prototype._getBeta = function () {
    return null;
  }, qc.prototype.dblp = function (e) {
    for (var t = this, n = 0; n < e; n++) t = t.dbl();
    return t;
  };
  var Kc = hc,
    Hc = We,
    Vc = Uc,
    $c = Pc.assert;
  function Wc(e) {
    Vc.call(this, "short", e), this.a = new Kc(e.a, 16).toRed(this.red), this.b = new Kc(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  Hc(Wc, Vc);
  var Yc = Wc;
  function Gc(e, t, n, r) {
    Vc.BasePoint.call(this, e, "affine"), null === t && null === n ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new Kc(t, 16), this.y = new Kc(n, 16), r && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  function Qc(e, t, n, r) {
    Vc.BasePoint.call(this, e, "jacobian"), null === t && null === n && null === r ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new Kc(0)) : (this.x = new Kc(t, 16), this.y = new Kc(n, 16), this.z = new Kc(r, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  Wc.prototype._getEndomorphism = function (e) {
    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
      var t, n;
      if (e.beta) t = new Kc(e.beta, 16).toRed(this.red);else {
        var r = this._getEndoRoots(this.p);
        t = (t = r[0].cmp(r[1]) < 0 ? r[0] : r[1]).toRed(this.red);
      }
      if (e.lambda) n = new Kc(e.lambda, 16);else {
        var i = this._getEndoRoots(this.n);
        0 === this.g.mul(i[0]).x.cmp(this.g.x.redMul(t)) ? n = i[0] : (n = i[1], $c(0 === this.g.mul(n).x.cmp(this.g.x.redMul(t))));
      }
      return {
        beta: t,
        lambda: n,
        basis: e.basis ? e.basis.map(function (e) {
          return {
            a: new Kc(e.a, 16),
            b: new Kc(e.b, 16)
          };
        }) : this._getEndoBasis(n)
      };
    }
  }, Wc.prototype._getEndoRoots = function (e) {
    var t = e === this.p ? this.red : Kc.mont(e),
      n = new Kc(2).toRed(t).redInvm(),
      r = n.redNeg(),
      i = new Kc(3).toRed(t).redNeg().redSqrt().redMul(n);
    return [r.redAdd(i).fromRed(), r.redSub(i).fromRed()];
  }, Wc.prototype._getEndoBasis = function (e) {
    for (var t, n, r, i, o, a, s, u, c, l = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), d = e, f = this.n.clone(), h = new Kc(1), p = new Kc(0), m = new Kc(0), g = new Kc(1), v = 0; 0 !== d.cmpn(0);) {
      var b = f.div(d);
      u = f.sub(b.mul(d)), c = m.sub(b.mul(h));
      var y = g.sub(b.mul(p));
      if (!r && u.cmp(l) < 0) t = s.neg(), n = h, r = u.neg(), i = c;else if (r && 2 == ++v) break;
      s = u, f = d, d = u, m = h, h = c, g = p, p = y;
    }
    o = u.neg(), a = c;
    var w = r.sqr().add(i.sqr());
    return o.sqr().add(a.sqr()).cmp(w) >= 0 && (o = t, a = n), r.negative && (r = r.neg(), i = i.neg()), o.negative && (o = o.neg(), a = a.neg()), [{
      a: r,
      b: i
    }, {
      a: o,
      b: a
    }];
  }, Wc.prototype._endoSplit = function (e) {
    var t = this.endo.basis,
      n = t[0],
      r = t[1],
      i = r.b.mul(e).divRound(this.n),
      o = n.b.neg().mul(e).divRound(this.n),
      a = i.mul(n.a),
      s = o.mul(r.a),
      u = i.mul(n.b),
      c = o.mul(r.b);
    return {
      k1: e.sub(a).sub(s),
      k2: u.add(c).neg()
    };
  }, Wc.prototype.pointFromX = function (e, t) {
    (e = new Kc(e, 16)).red || (e = e.toRed(this.red));
    var n = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),
      r = n.redSqrt();
    if (0 !== r.redSqr().redSub(n).cmp(this.zero)) throw new Error("invalid point");
    var i = r.fromRed().isOdd();
    return (t && !i || !t && i) && (r = r.redNeg()), this.point(e, r);
  }, Wc.prototype.validate = function (e) {
    if (e.inf) return !0;
    var t = e.x,
      n = e.y,
      r = this.a.redMul(t),
      i = t.redSqr().redMul(t).redIAdd(r).redIAdd(this.b);
    return 0 === n.redSqr().redISub(i).cmpn(0);
  }, Wc.prototype._endoWnafMulAdd = function (e, t, n) {
    for (var r = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < e.length; o++) {
      var a = this._endoSplit(t[o]),
        s = e[o],
        u = s._getBeta();
      a.k1.negative && (a.k1.ineg(), s = s.neg(!0)), a.k2.negative && (a.k2.ineg(), u = u.neg(!0)), r[2 * o] = s, r[2 * o + 1] = u, i[2 * o] = a.k1, i[2 * o + 1] = a.k2;
    }
    for (var c = this._wnafMulAdd(1, r, i, 2 * o, n), l = 0; l < 2 * o; l++) r[l] = null, i[l] = null;
    return c;
  }, Hc(Gc, Vc.BasePoint), Wc.prototype.point = function (e, t, n) {
    return new Gc(this, e, t, n);
  }, Wc.prototype.pointFromJSON = function (e, t) {
    return Gc.fromJSON(this, e, t);
  }, Gc.prototype._getBeta = function () {
    if (this.curve.endo) {
      var e = this.precomputed;
      if (e && e.beta) return e.beta;
      var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (e) {
        var n = this.curve,
          r = function (e) {
            return n.point(e.x.redMul(n.endo.beta), e.y);
          };
        e.beta = t, t.precomputed = {
          beta: null,
          naf: e.naf && {
            wnd: e.naf.wnd,
            points: e.naf.points.map(r)
          },
          doubles: e.doubles && {
            step: e.doubles.step,
            points: e.doubles.points.map(r)
          }
        };
      }
      return t;
    }
  }, Gc.prototype.toJSON = function () {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, Gc.fromJSON = function (e, t, n) {
    "string" == typeof t && (t = JSON.parse(t));
    var r = e.point(t[0], t[1], n);
    if (!t[2]) return r;
    function i(t) {
      return e.point(t[0], t[1], n);
    }
    var o = t[2];
    return r.precomputed = {
      beta: null,
      doubles: o.doubles && {
        step: o.doubles.step,
        points: [r].concat(o.doubles.points.map(i))
      },
      naf: o.naf && {
        wnd: o.naf.wnd,
        points: [r].concat(o.naf.points.map(i))
      }
    }, r;
  }, Gc.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, Gc.prototype.isInfinity = function () {
    return this.inf;
  }, Gc.prototype.add = function (e) {
    if (this.inf) return e;
    if (e.inf) return this;
    if (this.eq(e)) return this.dbl();
    if (this.neg().eq(e)) return this.curve.point(null, null);
    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
    var t = this.y.redSub(e.y);
    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
    var n = t.redSqr().redISub(this.x).redISub(e.x),
      r = t.redMul(this.x.redSub(n)).redISub(this.y);
    return this.curve.point(n, r);
  }, Gc.prototype.dbl = function () {
    if (this.inf) return this;
    var e = this.y.redAdd(this.y);
    if (0 === e.cmpn(0)) return this.curve.point(null, null);
    var t = this.curve.a,
      n = this.x.redSqr(),
      r = e.redInvm(),
      i = n.redAdd(n).redIAdd(n).redIAdd(t).redMul(r),
      o = i.redSqr().redISub(this.x.redAdd(this.x)),
      a = i.redMul(this.x.redSub(o)).redISub(this.y);
    return this.curve.point(o, a);
  }, Gc.prototype.getX = function () {
    return this.x.fromRed();
  }, Gc.prototype.getY = function () {
    return this.y.fromRed();
  }, Gc.prototype.mul = function (e) {
    return e = new Kc(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
  }, Gc.prototype.mulAdd = function (e, t, n) {
    var r = [this, t],
      i = [e, n];
    return this.curve.endo ? this.curve._endoWnafMulAdd(r, i) : this.curve._wnafMulAdd(1, r, i, 2);
  }, Gc.prototype.jmulAdd = function (e, t, n) {
    var r = [this, t],
      i = [e, n];
    return this.curve.endo ? this.curve._endoWnafMulAdd(r, i, !0) : this.curve._wnafMulAdd(1, r, i, 2, !0);
  }, Gc.prototype.eq = function (e) {
    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
  }, Gc.prototype.neg = function (e) {
    if (this.inf) return this;
    var t = this.curve.point(this.x, this.y.redNeg());
    if (e && this.precomputed) {
      var n = this.precomputed,
        r = function (e) {
          return e.neg();
        };
      t.precomputed = {
        naf: n.naf && {
          wnd: n.naf.wnd,
          points: n.naf.points.map(r)
        },
        doubles: n.doubles && {
          step: n.doubles.step,
          points: n.doubles.points.map(r)
        }
      };
    }
    return t;
  }, Gc.prototype.toJ = function () {
    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
  }, Hc(Qc, Vc.BasePoint), Wc.prototype.jpoint = function (e, t, n) {
    return new Qc(this, e, t, n);
  }, Qc.prototype.toP = function () {
    if (this.isInfinity()) return this.curve.point(null, null);
    var e = this.z.redInvm(),
      t = e.redSqr(),
      n = this.x.redMul(t),
      r = this.y.redMul(t).redMul(e);
    return this.curve.point(n, r);
  }, Qc.prototype.neg = function () {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, Qc.prototype.add = function (e) {
    if (this.isInfinity()) return e;
    if (e.isInfinity()) return this;
    var t = e.z.redSqr(),
      n = this.z.redSqr(),
      r = this.x.redMul(t),
      i = e.x.redMul(n),
      o = this.y.redMul(t.redMul(e.z)),
      a = e.y.redMul(n.redMul(this.z)),
      s = r.redSub(i),
      u = o.redSub(a);
    if (0 === s.cmpn(0)) return 0 !== u.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
    var c = s.redSqr(),
      l = c.redMul(s),
      d = r.redMul(c),
      f = u.redSqr().redIAdd(l).redISub(d).redISub(d),
      h = u.redMul(d.redISub(f)).redISub(o.redMul(l)),
      p = this.z.redMul(e.z).redMul(s);
    return this.curve.jpoint(f, h, p);
  }, Qc.prototype.mixedAdd = function (e) {
    if (this.isInfinity()) return e.toJ();
    if (e.isInfinity()) return this;
    var t = this.z.redSqr(),
      n = this.x,
      r = e.x.redMul(t),
      i = this.y,
      o = e.y.redMul(t).redMul(this.z),
      a = n.redSub(r),
      s = i.redSub(o);
    if (0 === a.cmpn(0)) return 0 !== s.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
    var u = a.redSqr(),
      c = u.redMul(a),
      l = n.redMul(u),
      d = s.redSqr().redIAdd(c).redISub(l).redISub(l),
      f = s.redMul(l.redISub(d)).redISub(i.redMul(c)),
      h = this.z.redMul(a);
    return this.curve.jpoint(d, f, h);
  }, Qc.prototype.dblp = function (e) {
    if (0 === e) return this;
    if (this.isInfinity()) return this;
    if (!e) return this.dbl();
    var t;
    if (this.curve.zeroA || this.curve.threeA) {
      var n = this;
      for (t = 0; t < e; t++) n = n.dbl();
      return n;
    }
    var r = this.curve.a,
      i = this.curve.tinv,
      o = this.x,
      a = this.y,
      s = this.z,
      u = s.redSqr().redSqr(),
      c = a.redAdd(a);
    for (t = 0; t < e; t++) {
      var l = o.redSqr(),
        d = c.redSqr(),
        f = d.redSqr(),
        h = l.redAdd(l).redIAdd(l).redIAdd(r.redMul(u)),
        p = o.redMul(d),
        m = h.redSqr().redISub(p.redAdd(p)),
        g = p.redISub(m),
        v = h.redMul(g);
      v = v.redIAdd(v).redISub(f);
      var b = c.redMul(s);
      t + 1 < e && (u = u.redMul(f)), o = m, s = b, c = v;
    }
    return this.curve.jpoint(o, c.redMul(i), s);
  }, Qc.prototype.dbl = function () {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, Qc.prototype._zeroDbl = function () {
    var e, t, n;
    if (this.zOne) {
      var r = this.x.redSqr(),
        i = this.y.redSqr(),
        o = i.redSqr(),
        a = this.x.redAdd(i).redSqr().redISub(r).redISub(o);
      a = a.redIAdd(a);
      var s = r.redAdd(r).redIAdd(r),
        u = s.redSqr().redISub(a).redISub(a),
        c = o.redIAdd(o);
      c = (c = c.redIAdd(c)).redIAdd(c), e = u, t = s.redMul(a.redISub(u)).redISub(c), n = this.y.redAdd(this.y);
    } else {
      var l = this.x.redSqr(),
        d = this.y.redSqr(),
        f = d.redSqr(),
        h = this.x.redAdd(d).redSqr().redISub(l).redISub(f);
      h = h.redIAdd(h);
      var p = l.redAdd(l).redIAdd(l),
        m = p.redSqr(),
        g = f.redIAdd(f);
      g = (g = g.redIAdd(g)).redIAdd(g), e = m.redISub(h).redISub(h), t = p.redMul(h.redISub(e)).redISub(g), n = (n = this.y.redMul(this.z)).redIAdd(n);
    }
    return this.curve.jpoint(e, t, n);
  }, Qc.prototype._threeDbl = function () {
    var e, t, n;
    if (this.zOne) {
      var r = this.x.redSqr(),
        i = this.y.redSqr(),
        o = i.redSqr(),
        a = this.x.redAdd(i).redSqr().redISub(r).redISub(o);
      a = a.redIAdd(a);
      var s = r.redAdd(r).redIAdd(r).redIAdd(this.curve.a),
        u = s.redSqr().redISub(a).redISub(a);
      e = u;
      var c = o.redIAdd(o);
      c = (c = c.redIAdd(c)).redIAdd(c), t = s.redMul(a.redISub(u)).redISub(c), n = this.y.redAdd(this.y);
    } else {
      var l = this.z.redSqr(),
        d = this.y.redSqr(),
        f = this.x.redMul(d),
        h = this.x.redSub(l).redMul(this.x.redAdd(l));
      h = h.redAdd(h).redIAdd(h);
      var p = f.redIAdd(f),
        m = (p = p.redIAdd(p)).redAdd(p);
      e = h.redSqr().redISub(m), n = this.y.redAdd(this.z).redSqr().redISub(d).redISub(l);
      var g = d.redSqr();
      g = (g = (g = g.redIAdd(g)).redIAdd(g)).redIAdd(g), t = h.redMul(p.redISub(e)).redISub(g);
    }
    return this.curve.jpoint(e, t, n);
  }, Qc.prototype._dbl = function () {
    var e = this.curve.a,
      t = this.x,
      n = this.y,
      r = this.z,
      i = r.redSqr().redSqr(),
      o = t.redSqr(),
      a = n.redSqr(),
      s = o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)),
      u = t.redAdd(t),
      c = (u = u.redIAdd(u)).redMul(a),
      l = s.redSqr().redISub(c.redAdd(c)),
      d = c.redISub(l),
      f = a.redSqr();
    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
    var h = s.redMul(d).redISub(f),
      p = n.redAdd(n).redMul(r);
    return this.curve.jpoint(l, h, p);
  }, Qc.prototype.trpl = function () {
    if (!this.curve.zeroA) return this.dbl().add(this);
    var e = this.x.redSqr(),
      t = this.y.redSqr(),
      n = this.z.redSqr(),
      r = t.redSqr(),
      i = e.redAdd(e).redIAdd(e),
      o = i.redSqr(),
      a = this.x.redAdd(t).redSqr().redISub(e).redISub(r),
      s = (a = (a = (a = a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(),
      u = r.redIAdd(r);
    u = (u = (u = u.redIAdd(u)).redIAdd(u)).redIAdd(u);
    var c = i.redIAdd(a).redSqr().redISub(o).redISub(s).redISub(u),
      l = t.redMul(c);
    l = (l = l.redIAdd(l)).redIAdd(l);
    var d = this.x.redMul(s).redISub(l);
    d = (d = d.redIAdd(d)).redIAdd(d);
    var f = this.y.redMul(c.redMul(u.redISub(c)).redISub(a.redMul(s)));
    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
    var h = this.z.redAdd(a).redSqr().redISub(n).redISub(s);
    return this.curve.jpoint(d, f, h);
  }, Qc.prototype.mul = function (e, t) {
    return e = new Kc(e, t), this.curve._wnafMul(this, e);
  }, Qc.prototype.eq = function (e) {
    if ("affine" === e.type) return this.eq(e.toJ());
    if (this === e) return !0;
    var t = this.z.redSqr(),
      n = e.z.redSqr();
    if (0 !== this.x.redMul(n).redISub(e.x.redMul(t)).cmpn(0)) return !1;
    var r = t.redMul(this.z),
      i = n.redMul(e.z);
    return 0 === this.y.redMul(i).redISub(e.y.redMul(r)).cmpn(0);
  }, Qc.prototype.eqXToP = function (e) {
    var t = this.z.redSqr(),
      n = e.toRed(this.curve.red).redMul(t);
    if (0 === this.x.cmp(n)) return !0;
    for (var r = e.clone(), i = this.curve.redN.redMul(t);;) {
      if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
      if (n.redIAdd(i), 0 === this.x.cmp(n)) return !0;
    }
  }, Qc.prototype.inspect = function () {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, Qc.prototype.isInfinity = function () {
    return 0 === this.z.cmpn(0);
  };
  var Zc = hc,
    Jc = We,
    Xc = Uc,
    el = Pc;
  function tl(e) {
    Xc.call(this, "mont", e), this.a = new Zc(e.a, 16).toRed(this.red), this.b = new Zc(e.b, 16).toRed(this.red), this.i4 = new Zc(4).toRed(this.red).redInvm(), this.two = new Zc(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  Jc(tl, Xc);
  var nl = tl;
  function rl(e, t, n) {
    Xc.BasePoint.call(this, e, "projective"), null === t && null === n ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new Zc(t, 16), this.z = new Zc(n, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  tl.prototype.validate = function (e) {
    var t = e.normalize().x,
      n = t.redSqr(),
      r = n.redMul(t).redAdd(n.redMul(this.a)).redAdd(t);
    return 0 === r.redSqrt().redSqr().cmp(r);
  }, Jc(rl, Xc.BasePoint), tl.prototype.decodePoint = function (e, t) {
    return this.point(el.toArray(e, t), 1);
  }, tl.prototype.point = function (e, t) {
    return new rl(this, e, t);
  }, tl.prototype.pointFromJSON = function (e) {
    return rl.fromJSON(this, e);
  }, rl.prototype.precompute = function () {}, rl.prototype._encode = function () {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, rl.fromJSON = function (e, t) {
    return new rl(e, t[0], t[1] || e.one);
  }, rl.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, rl.prototype.isInfinity = function () {
    return 0 === this.z.cmpn(0);
  }, rl.prototype.dbl = function () {
    var e = this.x.redAdd(this.z).redSqr(),
      t = this.x.redSub(this.z).redSqr(),
      n = e.redSub(t),
      r = e.redMul(t),
      i = n.redMul(t.redAdd(this.curve.a24.redMul(n)));
    return this.curve.point(r, i);
  }, rl.prototype.add = function () {
    throw new Error("Not supported on Montgomery curve");
  }, rl.prototype.diffAdd = function (e, t) {
    var n = this.x.redAdd(this.z),
      r = this.x.redSub(this.z),
      i = e.x.redAdd(e.z),
      o = e.x.redSub(e.z).redMul(n),
      a = i.redMul(r),
      s = t.z.redMul(o.redAdd(a).redSqr()),
      u = t.x.redMul(o.redISub(a).redSqr());
    return this.curve.point(s, u);
  }, rl.prototype.mul = function (e) {
    for (var t = e.clone(), n = this, r = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1)) i.push(t.andln(1));
    for (var o = i.length - 1; o >= 0; o--) 0 === i[o] ? (n = n.diffAdd(r, this), r = r.dbl()) : (r = n.diffAdd(r, this), n = n.dbl());
    return r;
  }, rl.prototype.mulAdd = function () {
    throw new Error("Not supported on Montgomery curve");
  }, rl.prototype.jumlAdd = function () {
    throw new Error("Not supported on Montgomery curve");
  }, rl.prototype.eq = function (e) {
    return 0 === this.getX().cmp(e.getX());
  }, rl.prototype.normalize = function () {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, rl.prototype.getX = function () {
    return this.normalize(), this.x.fromRed();
  };
  var il = hc,
    ol = We,
    al = Uc,
    sl = Pc.assert;
  function ul(e) {
    this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, al.call(this, "edwards", e), this.a = new il(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new il(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new il(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), sl(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
  }
  ol(ul, al);
  var cl = ul;
  function ll(e, t, n, r, i) {
    al.BasePoint.call(this, e, "projective"), null === t && null === n && null === r ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new il(t, 16), this.y = new il(n, 16), this.z = r ? new il(r, 16) : this.curve.one, this.t = i && new il(i, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  ul.prototype._mulA = function (e) {
    return this.mOneA ? e.redNeg() : this.a.redMul(e);
  }, ul.prototype._mulC = function (e) {
    return this.oneC ? e : this.c.redMul(e);
  }, ul.prototype.jpoint = function (e, t, n, r) {
    return this.point(e, t, n, r);
  }, ul.prototype.pointFromX = function (e, t) {
    (e = new il(e, 16)).red || (e = e.toRed(this.red));
    var n = e.redSqr(),
      r = this.c2.redSub(this.a.redMul(n)),
      i = this.one.redSub(this.c2.redMul(this.d).redMul(n)),
      o = r.redMul(i.redInvm()),
      a = o.redSqrt();
    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
    var s = a.fromRed().isOdd();
    return (t && !s || !t && s) && (a = a.redNeg()), this.point(e, a);
  }, ul.prototype.pointFromY = function (e, t) {
    (e = new il(e, 16)).red || (e = e.toRed(this.red));
    var n = e.redSqr(),
      r = n.redSub(this.c2),
      i = n.redMul(this.d).redMul(this.c2).redSub(this.a),
      o = r.redMul(i.redInvm());
    if (0 === o.cmp(this.zero)) {
      if (t) throw new Error("invalid point");
      return this.point(this.zero, e);
    }
    var a = o.redSqrt();
    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
    return a.fromRed().isOdd() !== t && (a = a.redNeg()), this.point(a, e);
  }, ul.prototype.validate = function (e) {
    if (e.isInfinity()) return !0;
    e.normalize();
    var t = e.x.redSqr(),
      n = e.y.redSqr(),
      r = t.redMul(this.a).redAdd(n),
      i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(n)));
    return 0 === r.cmp(i);
  }, ol(ll, al.BasePoint), ul.prototype.pointFromJSON = function (e) {
    return ll.fromJSON(this, e);
  }, ul.prototype.point = function (e, t, n, r) {
    return new ll(this, e, t, n, r);
  }, ll.fromJSON = function (e, t) {
    return new ll(e, t[0], t[1], t[2]);
  }, ll.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, ll.prototype.isInfinity = function () {
    return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
  }, ll.prototype._extDbl = function () {
    var e = this.x.redSqr(),
      t = this.y.redSqr(),
      n = this.z.redSqr();
    n = n.redIAdd(n);
    var r = this.curve._mulA(e),
      i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t),
      o = r.redAdd(t),
      a = o.redSub(n),
      s = r.redSub(t),
      u = i.redMul(a),
      c = o.redMul(s),
      l = i.redMul(s),
      d = a.redMul(o);
    return this.curve.point(u, c, d, l);
  }, ll.prototype._projDbl = function () {
    var e,
      t,
      n,
      r,
      i,
      o,
      a = this.x.redAdd(this.y).redSqr(),
      s = this.x.redSqr(),
      u = this.y.redSqr();
    if (this.curve.twisted) {
      var c = (r = this.curve._mulA(s)).redAdd(u);
      this.zOne ? (e = a.redSub(s).redSub(u).redMul(c.redSub(this.curve.two)), t = c.redMul(r.redSub(u)), n = c.redSqr().redSub(c).redSub(c)) : (i = this.z.redSqr(), o = c.redSub(i).redISub(i), e = a.redSub(s).redISub(u).redMul(o), t = c.redMul(r.redSub(u)), n = c.redMul(o));
    } else r = s.redAdd(u), i = this.curve._mulC(this.z).redSqr(), o = r.redSub(i).redSub(i), e = this.curve._mulC(a.redISub(r)).redMul(o), t = this.curve._mulC(r).redMul(s.redISub(u)), n = r.redMul(o);
    return this.curve.point(e, t, n);
  }, ll.prototype.dbl = function () {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, ll.prototype._extAdd = function (e) {
    var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)),
      n = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),
      r = this.t.redMul(this.curve.dd).redMul(e.t),
      i = this.z.redMul(e.z.redAdd(e.z)),
      o = n.redSub(t),
      a = i.redSub(r),
      s = i.redAdd(r),
      u = n.redAdd(t),
      c = o.redMul(a),
      l = s.redMul(u),
      d = o.redMul(u),
      f = a.redMul(s);
    return this.curve.point(c, l, f, d);
  }, ll.prototype._projAdd = function (e) {
    var t,
      n,
      r = this.z.redMul(e.z),
      i = r.redSqr(),
      o = this.x.redMul(e.x),
      a = this.y.redMul(e.y),
      s = this.curve.d.redMul(o).redMul(a),
      u = i.redSub(s),
      c = i.redAdd(s),
      l = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(o).redISub(a),
      d = r.redMul(u).redMul(l);
    return this.curve.twisted ? (t = r.redMul(c).redMul(a.redSub(this.curve._mulA(o))), n = u.redMul(c)) : (t = r.redMul(c).redMul(a.redSub(o)), n = this.curve._mulC(u).redMul(c)), this.curve.point(d, t, n);
  }, ll.prototype.add = function (e) {
    return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
  }, ll.prototype.mul = function (e) {
    return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
  }, ll.prototype.mulAdd = function (e, t, n) {
    return this.curve._wnafMulAdd(1, [this, t], [e, n], 2, !1);
  }, ll.prototype.jmulAdd = function (e, t, n) {
    return this.curve._wnafMulAdd(1, [this, t], [e, n], 2, !0);
  }, ll.prototype.normalize = function () {
    if (this.zOne) return this;
    var e = this.z.redInvm();
    return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
  }, ll.prototype.neg = function () {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
  }, ll.prototype.getX = function () {
    return this.normalize(), this.x.fromRed();
  }, ll.prototype.getY = function () {
    return this.normalize(), this.y.fromRed();
  }, ll.prototype.eq = function (e) {
    return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
  }, ll.prototype.eqXToP = function (e) {
    var t = e.toRed(this.curve.red).redMul(this.z);
    if (0 === this.x.cmp(t)) return !0;
    for (var n = e.clone(), r = this.curve.redN.redMul(this.z);;) {
      if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
      if (t.redIAdd(r), 0 === this.x.cmp(t)) return !0;
    }
  }, ll.prototype.toP = ll.prototype.normalize, ll.prototype.mixedAdd = ll.prototype.add, function (e) {
    var t = e;
    t.base = Uc, t.short = Yc, t.mont = nl, t.edwards = cl;
  }(Lc);
  var dl = {},
    fl = {},
    hl = {},
    pl = Va,
    ml = We;
  function gl(e, t) {
    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
  }
  function vl(e) {
    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
  }
  function bl(e) {
    return 1 === e.length ? "0" + e : e;
  }
  function yl(e) {
    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
  }
  hl.inherits = ml, hl.toArray = function (e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var n = [];
    if ("string" == typeof e) {
      if (t) {
        if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2) n.push(parseInt(e[i] + e[i + 1], 16));
      } else for (var r = 0, i = 0; i < e.length; i++) {
        var o = e.charCodeAt(i);
        o < 128 ? n[r++] = o : o < 2048 ? (n[r++] = o >> 6 | 192, n[r++] = 63 & o | 128) : gl(e, i) ? (o = 65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++i)), n[r++] = o >> 18 | 240, n[r++] = o >> 12 & 63 | 128, n[r++] = o >> 6 & 63 | 128, n[r++] = 63 & o | 128) : (n[r++] = o >> 12 | 224, n[r++] = o >> 6 & 63 | 128, n[r++] = 63 & o | 128);
      }
    } else for (i = 0; i < e.length; i++) n[i] = 0 | e[i];
    return n;
  }, hl.toHex = function (e) {
    for (var t = "", n = 0; n < e.length; n++) t += bl(e[n].toString(16));
    return t;
  }, hl.htonl = vl, hl.toHex32 = function (e, t) {
    for (var n = "", r = 0; r < e.length; r++) {
      var i = e[r];
      "little" === t && (i = vl(i)), n += yl(i.toString(16));
    }
    return n;
  }, hl.zero2 = bl, hl.zero8 = yl, hl.join32 = function (e, t, n, r) {
    var i = n - t;
    pl(i % 4 == 0);
    for (var o = new Array(i / 4), a = 0, s = t; a < o.length; a++, s += 4) {
      var u;
      u = "big" === r ? e[s] << 24 | e[s + 1] << 16 | e[s + 2] << 8 | e[s + 3] : e[s + 3] << 24 | e[s + 2] << 16 | e[s + 1] << 8 | e[s], o[a] = u >>> 0;
    }
    return o;
  }, hl.split32 = function (e, t) {
    for (var n = new Array(4 * e.length), r = 0, i = 0; r < e.length; r++, i += 4) {
      var o = e[r];
      "big" === t ? (n[i] = o >>> 24, n[i + 1] = o >>> 16 & 255, n[i + 2] = o >>> 8 & 255, n[i + 3] = 255 & o) : (n[i + 3] = o >>> 24, n[i + 2] = o >>> 16 & 255, n[i + 1] = o >>> 8 & 255, n[i] = 255 & o);
    }
    return n;
  }, hl.rotr32 = function (e, t) {
    return e >>> t | e << 32 - t;
  }, hl.rotl32 = function (e, t) {
    return e << t | e >>> 32 - t;
  }, hl.sum32 = function (e, t) {
    return e + t >>> 0;
  }, hl.sum32_3 = function (e, t, n) {
    return e + t + n >>> 0;
  }, hl.sum32_4 = function (e, t, n, r) {
    return e + t + n + r >>> 0;
  }, hl.sum32_5 = function (e, t, n, r, i) {
    return e + t + n + r + i >>> 0;
  }, hl.sum64 = function (e, t, n, r) {
    var i = e[t],
      o = r + e[t + 1] >>> 0,
      a = (o < r ? 1 : 0) + n + i;
    e[t] = a >>> 0, e[t + 1] = o;
  }, hl.sum64_hi = function (e, t, n, r) {
    return (t + r >>> 0 < t ? 1 : 0) + e + n >>> 0;
  }, hl.sum64_lo = function (e, t, n, r) {
    return t + r >>> 0;
  }, hl.sum64_4_hi = function (e, t, n, r, i, o, a, s) {
    var u = 0,
      c = t;
    return u += (c = c + r >>> 0) < t ? 1 : 0, u += (c = c + o >>> 0) < o ? 1 : 0, e + n + i + a + (u += (c = c + s >>> 0) < s ? 1 : 0) >>> 0;
  }, hl.sum64_4_lo = function (e, t, n, r, i, o, a, s) {
    return t + r + o + s >>> 0;
  }, hl.sum64_5_hi = function (e, t, n, r, i, o, a, s, u, c) {
    var l = 0,
      d = t;
    return l += (d = d + r >>> 0) < t ? 1 : 0, l += (d = d + o >>> 0) < o ? 1 : 0, l += (d = d + s >>> 0) < s ? 1 : 0, e + n + i + a + u + (l += (d = d + c >>> 0) < c ? 1 : 0) >>> 0;
  }, hl.sum64_5_lo = function (e, t, n, r, i, o, a, s, u, c) {
    return t + r + o + s + c >>> 0;
  }, hl.rotr64_hi = function (e, t, n) {
    return (t << 32 - n | e >>> n) >>> 0;
  }, hl.rotr64_lo = function (e, t, n) {
    return (e << 32 - n | t >>> n) >>> 0;
  }, hl.shr64_hi = function (e, t, n) {
    return e >>> n;
  }, hl.shr64_lo = function (e, t, n) {
    return (e << 32 - n | t >>> n) >>> 0;
  };
  var wl = {},
    Al = hl,
    _l = Va;
  function El() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  wl.BlockHash = El, El.prototype.update = function (e, t) {
    if (e = Al.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
      var n = (e = this.pending).length % this._delta8;
      this.pending = e.slice(e.length - n, e.length), 0 === this.pending.length && (this.pending = null), e = Al.join32(e, 0, e.length - n, this.endian);
      for (var r = 0; r < e.length; r += this._delta32) this._update(e, r, r + this._delta32);
    }
    return this;
  }, El.prototype.digest = function (e) {
    return this.update(this._pad()), _l(null === this.pending), this._digest(e);
  }, El.prototype._pad = function () {
    var e = this.pendingTotal,
      t = this._delta8,
      n = t - (e + this.padLength) % t,
      r = new Array(n + this.padLength);
    r[0] = 128;
    for (var i = 1; i < n; i++) r[i] = 0;
    if (e <<= 3, "big" === this.endian) {
      for (var o = 8; o < this.padLength; o++) r[i++] = 0;
      r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = e >>> 24 & 255, r[i++] = e >>> 16 & 255, r[i++] = e >>> 8 & 255, r[i++] = 255 & e;
    } else for (r[i++] = 255 & e, r[i++] = e >>> 8 & 255, r[i++] = e >>> 16 & 255, r[i++] = e >>> 24 & 255, r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = 0, o = 8; o < this.padLength; o++) r[i++] = 0;
    return r;
  };
  var Sl = {},
    kl = {},
    Ml = hl.rotr32;
  function Cl(e, t, n) {
    return e & t ^ ~e & n;
  }
  function xl(e, t, n) {
    return e & t ^ e & n ^ t & n;
  }
  function Rl(e, t, n) {
    return e ^ t ^ n;
  }
  kl.ft_1 = function (e, t, n, r) {
    return 0 === e ? Cl(t, n, r) : 1 === e || 3 === e ? Rl(t, n, r) : 2 === e ? xl(t, n, r) : void 0;
  }, kl.ch32 = Cl, kl.maj32 = xl, kl.p32 = Rl, kl.s0_256 = function (e) {
    return Ml(e, 2) ^ Ml(e, 13) ^ Ml(e, 22);
  }, kl.s1_256 = function (e) {
    return Ml(e, 6) ^ Ml(e, 11) ^ Ml(e, 25);
  }, kl.g0_256 = function (e) {
    return Ml(e, 7) ^ Ml(e, 18) ^ e >>> 3;
  }, kl.g1_256 = function (e) {
    return Ml(e, 17) ^ Ml(e, 19) ^ e >>> 10;
  };
  var Il = hl,
    Tl = wl,
    Pl = kl,
    Ol = Il.rotl32,
    Ll = Il.sum32,
    Nl = Il.sum32_5,
    Dl = Pl.ft_1,
    Bl = Tl.BlockHash,
    jl = [1518500249, 1859775393, 2400959708, 3395469782];
  function Fl() {
    if (!(this instanceof Fl)) return new Fl();
    Bl.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
  }
  Il.inherits(Fl, Bl);
  var zl = Fl;
  Fl.blockSize = 512, Fl.outSize = 160, Fl.hmacStrength = 80, Fl.padLength = 64, Fl.prototype._update = function (e, t) {
    for (var n = this.W, r = 0; r < 16; r++) n[r] = e[t + r];
    for (; r < n.length; r++) n[r] = Ol(n[r - 3] ^ n[r - 8] ^ n[r - 14] ^ n[r - 16], 1);
    var i = this.h[0],
      o = this.h[1],
      a = this.h[2],
      s = this.h[3],
      u = this.h[4];
    for (r = 0; r < n.length; r++) {
      var c = ~~(r / 20),
        l = Nl(Ol(i, 5), Dl(c, o, a, s), u, n[r], jl[c]);
      u = s, s = a, a = Ol(o, 30), o = i, i = l;
    }
    this.h[0] = Ll(this.h[0], i), this.h[1] = Ll(this.h[1], o), this.h[2] = Ll(this.h[2], a), this.h[3] = Ll(this.h[3], s), this.h[4] = Ll(this.h[4], u);
  }, Fl.prototype._digest = function (e) {
    return "hex" === e ? Il.toHex32(this.h, "big") : Il.split32(this.h, "big");
  };
  var Ul = hl,
    ql = wl,
    Kl = kl,
    Hl = Va,
    Vl = Ul.sum32,
    $l = Ul.sum32_4,
    Wl = Ul.sum32_5,
    Yl = Kl.ch32,
    Gl = Kl.maj32,
    Ql = Kl.s0_256,
    Zl = Kl.s1_256,
    Jl = Kl.g0_256,
    Xl = Kl.g1_256,
    ed = ql.BlockHash,
    td = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
  function nd() {
    if (!(this instanceof nd)) return new nd();
    ed.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = td, this.W = new Array(64);
  }
  Ul.inherits(nd, ed);
  var rd = nd;
  nd.blockSize = 512, nd.outSize = 256, nd.hmacStrength = 192, nd.padLength = 64, nd.prototype._update = function (e, t) {
    for (var n = this.W, r = 0; r < 16; r++) n[r] = e[t + r];
    for (; r < n.length; r++) n[r] = $l(Xl(n[r - 2]), n[r - 7], Jl(n[r - 15]), n[r - 16]);
    var i = this.h[0],
      o = this.h[1],
      a = this.h[2],
      s = this.h[3],
      u = this.h[4],
      c = this.h[5],
      l = this.h[6],
      d = this.h[7];
    for (Hl(this.k.length === n.length), r = 0; r < n.length; r++) {
      var f = Wl(d, Zl(u), Yl(u, c, l), this.k[r], n[r]),
        h = Vl(Ql(i), Gl(i, o, a));
      d = l, l = c, c = u, u = Vl(s, f), s = a, a = o, o = i, i = Vl(f, h);
    }
    this.h[0] = Vl(this.h[0], i), this.h[1] = Vl(this.h[1], o), this.h[2] = Vl(this.h[2], a), this.h[3] = Vl(this.h[3], s), this.h[4] = Vl(this.h[4], u), this.h[5] = Vl(this.h[5], c), this.h[6] = Vl(this.h[6], l), this.h[7] = Vl(this.h[7], d);
  }, nd.prototype._digest = function (e) {
    return "hex" === e ? Ul.toHex32(this.h, "big") : Ul.split32(this.h, "big");
  };
  var id = hl,
    od = rd;
  function ad() {
    if (!(this instanceof ad)) return new ad();
    od.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
  }
  id.inherits(ad, od);
  var sd = ad;
  ad.blockSize = 512, ad.outSize = 224, ad.hmacStrength = 192, ad.padLength = 64, ad.prototype._digest = function (e) {
    return "hex" === e ? id.toHex32(this.h.slice(0, 7), "big") : id.split32(this.h.slice(0, 7), "big");
  };
  var ud = hl,
    cd = wl,
    ld = Va,
    dd = ud.rotr64_hi,
    fd = ud.rotr64_lo,
    hd = ud.shr64_hi,
    pd = ud.shr64_lo,
    md = ud.sum64,
    gd = ud.sum64_hi,
    vd = ud.sum64_lo,
    bd = ud.sum64_4_hi,
    yd = ud.sum64_4_lo,
    wd = ud.sum64_5_hi,
    Ad = ud.sum64_5_lo,
    _d = cd.BlockHash,
    Ed = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];
  function Sd() {
    if (!(this instanceof Sd)) return new Sd();
    _d.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = Ed, this.W = new Array(160);
  }
  ud.inherits(Sd, _d);
  var kd = Sd;
  function Md(e, t, n, r, i) {
    var o = e & n ^ ~e & i;
    return o < 0 && (o += 4294967296), o;
  }
  function Cd(e, t, n, r, i, o) {
    var a = t & r ^ ~t & o;
    return a < 0 && (a += 4294967296), a;
  }
  function xd(e, t, n, r, i) {
    var o = e & n ^ e & i ^ n & i;
    return o < 0 && (o += 4294967296), o;
  }
  function Rd(e, t, n, r, i, o) {
    var a = t & r ^ t & o ^ r & o;
    return a < 0 && (a += 4294967296), a;
  }
  function Id(e, t) {
    var n = dd(e, t, 28) ^ dd(t, e, 2) ^ dd(t, e, 7);
    return n < 0 && (n += 4294967296), n;
  }
  function Td(e, t) {
    var n = fd(e, t, 28) ^ fd(t, e, 2) ^ fd(t, e, 7);
    return n < 0 && (n += 4294967296), n;
  }
  function Pd(e, t) {
    var n = dd(e, t, 14) ^ dd(e, t, 18) ^ dd(t, e, 9);
    return n < 0 && (n += 4294967296), n;
  }
  function Od(e, t) {
    var n = fd(e, t, 14) ^ fd(e, t, 18) ^ fd(t, e, 9);
    return n < 0 && (n += 4294967296), n;
  }
  function Ld(e, t) {
    var n = dd(e, t, 1) ^ dd(e, t, 8) ^ hd(e, t, 7);
    return n < 0 && (n += 4294967296), n;
  }
  function Nd(e, t) {
    var n = fd(e, t, 1) ^ fd(e, t, 8) ^ pd(e, t, 7);
    return n < 0 && (n += 4294967296), n;
  }
  function Dd(e, t) {
    var n = dd(e, t, 19) ^ dd(t, e, 29) ^ hd(e, t, 6);
    return n < 0 && (n += 4294967296), n;
  }
  function Bd(e, t) {
    var n = fd(e, t, 19) ^ fd(t, e, 29) ^ pd(e, t, 6);
    return n < 0 && (n += 4294967296), n;
  }
  Sd.blockSize = 1024, Sd.outSize = 512, Sd.hmacStrength = 192, Sd.padLength = 128, Sd.prototype._prepareBlock = function (e, t) {
    for (var n = this.W, r = 0; r < 32; r++) n[r] = e[t + r];
    for (; r < n.length; r += 2) {
      var i = Dd(n[r - 4], n[r - 3]),
        o = Bd(n[r - 4], n[r - 3]),
        a = n[r - 14],
        s = n[r - 13],
        u = Ld(n[r - 30], n[r - 29]),
        c = Nd(n[r - 30], n[r - 29]),
        l = n[r - 32],
        d = n[r - 31];
      n[r] = bd(i, o, a, s, u, c, l, d), n[r + 1] = yd(i, o, a, s, u, c, l, d);
    }
  }, Sd.prototype._update = function (e, t) {
    this._prepareBlock(e, t);
    var n = this.W,
      r = this.h[0],
      i = this.h[1],
      o = this.h[2],
      a = this.h[3],
      s = this.h[4],
      u = this.h[5],
      c = this.h[6],
      l = this.h[7],
      d = this.h[8],
      f = this.h[9],
      h = this.h[10],
      p = this.h[11],
      m = this.h[12],
      g = this.h[13],
      v = this.h[14],
      b = this.h[15];
    ld(this.k.length === n.length);
    for (var y = 0; y < n.length; y += 2) {
      var w = v,
        A = b,
        _ = Pd(d, f),
        E = Od(d, f),
        S = Md(d, f, h, p, m),
        k = Cd(d, f, h, p, m, g),
        M = this.k[y],
        C = this.k[y + 1],
        x = n[y],
        R = n[y + 1],
        I = wd(w, A, _, E, S, k, M, C, x, R),
        T = Ad(w, A, _, E, S, k, M, C, x, R);
      w = Id(r, i), A = Td(r, i), _ = xd(r, i, o, a, s), E = Rd(r, i, o, a, s, u);
      var P = gd(w, A, _, E),
        O = vd(w, A, _, E);
      v = m, b = g, m = h, g = p, h = d, p = f, d = gd(c, l, I, T), f = vd(l, l, I, T), c = s, l = u, s = o, u = a, o = r, a = i, r = gd(I, T, P, O), i = vd(I, T, P, O);
    }
    md(this.h, 0, r, i), md(this.h, 2, o, a), md(this.h, 4, s, u), md(this.h, 6, c, l), md(this.h, 8, d, f), md(this.h, 10, h, p), md(this.h, 12, m, g), md(this.h, 14, v, b);
  }, Sd.prototype._digest = function (e) {
    return "hex" === e ? ud.toHex32(this.h, "big") : ud.split32(this.h, "big");
  };
  var jd = hl,
    Fd = kd;
  function zd() {
    if (!(this instanceof zd)) return new zd();
    Fd.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
  }
  jd.inherits(zd, Fd);
  var Ud = zd;
  zd.blockSize = 1024, zd.outSize = 384, zd.hmacStrength = 192, zd.padLength = 128, zd.prototype._digest = function (e) {
    return "hex" === e ? jd.toHex32(this.h.slice(0, 12), "big") : jd.split32(this.h.slice(0, 12), "big");
  }, Sl.sha1 = zl, Sl.sha224 = sd, Sl.sha256 = rd, Sl.sha384 = Ud, Sl.sha512 = kd;
  var qd = {},
    Kd = hl,
    Hd = wl,
    Vd = Kd.rotl32,
    $d = Kd.sum32,
    Wd = Kd.sum32_3,
    Yd = Kd.sum32_4,
    Gd = Hd.BlockHash;
  function Qd() {
    if (!(this instanceof Qd)) return new Qd();
    Gd.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  function Zd(e, t, n, r) {
    return e <= 15 ? t ^ n ^ r : e <= 31 ? t & n | ~t & r : e <= 47 ? (t | ~n) ^ r : e <= 63 ? t & r | n & ~r : t ^ (n | ~r);
  }
  function Jd(e) {
    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
  }
  function Xd(e) {
    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
  }
  Kd.inherits(Qd, Gd), qd.ripemd160 = Qd, Qd.blockSize = 512, Qd.outSize = 160, Qd.hmacStrength = 192, Qd.padLength = 64, Qd.prototype._update = function (e, t) {
    for (var n = this.h[0], r = this.h[1], i = this.h[2], o = this.h[3], a = this.h[4], s = n, u = r, c = i, l = o, d = a, f = 0; f < 80; f++) {
      var h = $d(Vd(Yd(n, Zd(f, r, i, o), e[ef[f] + t], Jd(f)), nf[f]), a);
      n = a, a = o, o = Vd(i, 10), i = r, r = h, h = $d(Vd(Yd(s, Zd(79 - f, u, c, l), e[tf[f] + t], Xd(f)), rf[f]), d), s = d, d = l, l = Vd(c, 10), c = u, u = h;
    }
    h = Wd(this.h[1], i, l), this.h[1] = Wd(this.h[2], o, d), this.h[2] = Wd(this.h[3], a, s), this.h[3] = Wd(this.h[4], n, u), this.h[4] = Wd(this.h[0], r, c), this.h[0] = h;
  }, Qd.prototype._digest = function (e) {
    return "hex" === e ? Kd.toHex32(this.h, "little") : Kd.split32(this.h, "little");
  };
  var ef = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
    tf = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
    nf = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
    rf = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11],
    of = hl,
    af = Va;
  function sf(e, t, n) {
    if (!(this instanceof sf)) return new sf(e, t, n);
    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(of.toArray(t, n));
  }
  var uf,
    cf,
    lf = sf;
  sf.prototype._init = function (e) {
    e.length > this.blockSize && (e = new this.Hash().update(e).digest()), af(e.length <= this.blockSize);
    for (var t = e.length; t < this.blockSize; t++) e.push(0);
    for (t = 0; t < e.length; t++) e[t] ^= 54;
    for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) e[t] ^= 106;
    this.outer = new this.Hash().update(e);
  }, sf.prototype.update = function (e, t) {
    return this.inner.update(e, t), this;
  }, sf.prototype.digest = function (e) {
    return this.outer.update(this.inner.digest()), this.outer.digest(e);
  }, function (e) {
    var t = e;
    t.utils = hl, t.common = wl, t.sha = Sl, t.ripemd = qd, t.hmac = lf, t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
  }(fl), function (e) {
    var t,
      n = e,
      r = fl,
      i = Lc,
      o = Pc.assert;
    function a(e) {
      "short" === e.type ? this.curve = new i.short(e) : "edwards" === e.type ? this.curve = new i.edwards(e) : this.curve = new i.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, o(this.g.validate(), "Invalid curve"), o(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    function s(e, t) {
      Object.defineProperty(n, e, {
        configurable: !0,
        enumerable: !0,
        get: function () {
          var r = new a(t);
          return Object.defineProperty(n, e, {
            configurable: !0,
            enumerable: !0,
            value: r
          }), r;
        }
      });
    }
    n.PresetCurve = a, s("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: r.sha256,
      gRed: !1,
      g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
    }), s("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: r.sha256,
      gRed: !1,
      g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
    }), s("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: r.sha256,
      gRed: !1,
      g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
    }), s("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: r.sha384,
      gRed: !1,
      g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
    }), s("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: r.sha512,
      gRed: !1,
      g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
    }), s("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: ["9"]
    }), s("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
    });
    try {
      t = cf ? uf : (cf = 1, uf = {
        doubles: {
          step: 4,
          points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]
        },
        naf: {
          wnd: 7,
          points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]
        }
      });
    } catch (e) {
      t = void 0;
    }
    s("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: r.sha256,
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [{
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      }, {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }],
      gRed: !1,
      g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", t]
    });
  }(dl);
  var df = fl,
    ff = Oc,
    hf = Va;
  function pf(e) {
    if (!(this instanceof pf)) return new pf(e);
    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var t = ff.toArray(e.entropy, e.entropyEnc || "hex"),
      n = ff.toArray(e.nonce, e.nonceEnc || "hex"),
      r = ff.toArray(e.pers, e.persEnc || "hex");
    hf(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, n, r);
  }
  var mf = pf;
  pf.prototype._init = function (e, t, n) {
    var r = e.concat(t).concat(n);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var i = 0; i < this.V.length; i++) this.K[i] = 0, this.V[i] = 1;
    this._update(r), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, pf.prototype._hmac = function () {
    return new df.hmac(this.hash, this.K);
  }, pf.prototype._update = function (e) {
    var t = this._hmac().update(this.V).update([0]);
    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
  }, pf.prototype.reseed = function (e, t, n, r) {
    "string" != typeof t && (r = n, n = t, t = null), e = ff.toArray(e, t), n = ff.toArray(n, r), hf(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(n || [])), this._reseed = 1;
  }, pf.prototype.generate = function (e, t, n, r) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    "string" != typeof t && (r = n, n = t, t = null), n && (n = ff.toArray(n, r || "hex"), this._update(n));
    for (var i = []; i.length < e;) this.V = this._hmac().update(this.V).digest(), i = i.concat(this.V);
    var o = i.slice(0, e);
    return this._update(n), this._reseed++, ff.encode(o, t);
  };
  var gf = hc,
    vf = Pc.assert;
  function bf(e, t) {
    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
  }
  var yf = bf;
  bf.fromPublic = function (e, t, n) {
    return t instanceof bf ? t : new bf(e, {
      pub: t,
      pubEnc: n
    });
  }, bf.fromPrivate = function (e, t, n) {
    return t instanceof bf ? t : new bf(e, {
      priv: t,
      privEnc: n
    });
  }, bf.prototype.validate = function () {
    var e = this.getPublic();
    return e.isInfinity() ? {
      result: !1,
      reason: "Invalid public key"
    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
      result: !0,
      reason: null
    } : {
      result: !1,
      reason: "Public key * N != O"
    } : {
      result: !1,
      reason: "Public key is not a point"
    };
  }, bf.prototype.getPublic = function (e, t) {
    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
  }, bf.prototype.getPrivate = function (e) {
    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
  }, bf.prototype._importPrivate = function (e, t) {
    this.priv = new gf(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, bf.prototype._importPublic = function (e, t) {
    if (e.x || e.y) return "mont" === this.ec.curve.type ? vf(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || vf(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
    this.pub = this.ec.curve.decodePoint(e, t);
  }, bf.prototype.derive = function (e) {
    return e.validate() || vf(e.validate(), "public point not validated"), e.mul(this.priv).getX();
  }, bf.prototype.sign = function (e, t, n) {
    return this.ec.sign(e, this, t, n);
  }, bf.prototype.verify = function (e, t) {
    return this.ec.verify(e, t, this);
  }, bf.prototype.inspect = function () {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  };
  var wf = hc,
    Af = Pc,
    _f = Af.assert;
  function Ef(e, t) {
    if (e instanceof Ef) return e;
    this._importDER(e, t) || (_f(e.r && e.s, "Signature without r or s"), this.r = new wf(e.r, 16), this.s = new wf(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
  }
  var Sf,
    kf,
    Mf = Ef;
  function Cf() {
    this.place = 0;
  }
  function xf(e, t) {
    var n = e[t.place++];
    if (!(128 & n)) return n;
    var r = 15 & n;
    if (0 === r || r > 4) return !1;
    for (var i = 0, o = 0, a = t.place; o < r; o++, a++) i <<= 8, i |= e[a], i >>>= 0;
    return !(i <= 127) && (t.place = a, i);
  }
  function Rf(e) {
    for (var t = 0, n = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < n;) t++;
    return 0 === t ? e : e.slice(t);
  }
  function If(e, t) {
    if (t < 128) e.push(t);else {
      var n = 1 + (Math.log(t) / Math.LN2 >>> 3);
      for (e.push(128 | n); --n;) e.push(t >>> (n << 3) & 255);
      e.push(t);
    }
  }
  Ef.prototype._importDER = function (e, t) {
    e = Af.toArray(e, t);
    var n = new Cf();
    if (48 !== e[n.place++]) return !1;
    var r = xf(e, n);
    if (!1 === r) return !1;
    if (r + n.place !== e.length) return !1;
    if (2 !== e[n.place++]) return !1;
    var i = xf(e, n);
    if (!1 === i) return !1;
    var o = e.slice(n.place, i + n.place);
    if (n.place += i, 2 !== e[n.place++]) return !1;
    var a = xf(e, n);
    if (!1 === a) return !1;
    if (e.length !== a + n.place) return !1;
    var s = e.slice(n.place, a + n.place);
    if (0 === o[0]) {
      if (!(128 & o[1])) return !1;
      o = o.slice(1);
    }
    if (0 === s[0]) {
      if (!(128 & s[1])) return !1;
      s = s.slice(1);
    }
    return this.r = new wf(o), this.s = new wf(s), this.recoveryParam = null, !0;
  }, Ef.prototype.toDER = function (e) {
    var t = this.r.toArray(),
      n = this.s.toArray();
    for (128 & t[0] && (t = [0].concat(t)), 128 & n[0] && (n = [0].concat(n)), t = Rf(t), n = Rf(n); !(n[0] || 128 & n[1]);) n = n.slice(1);
    var r = [2];
    If(r, t.length), (r = r.concat(t)).push(2), If(r, n.length);
    var i = r.concat(n),
      o = [48];
    return If(o, i.length), o = o.concat(i), Af.encode(o, e);
  };
  var Tf = Pc,
    Pf = Tf.assert,
    Of = Tf.parseBytes,
    Lf = Tf.cachedProperty;
  function Nf(e, t) {
    this.eddsa = e, this._secret = Of(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = Of(t.pub);
  }
  Nf.fromPublic = function (e, t) {
    return t instanceof Nf ? t : new Nf(e, {
      pub: t
    });
  }, Nf.fromSecret = function (e, t) {
    return t instanceof Nf ? t : new Nf(e, {
      secret: t
    });
  }, Nf.prototype.secret = function () {
    return this._secret;
  }, Lf(Nf, "pubBytes", function () {
    return this.eddsa.encodePoint(this.pub());
  }), Lf(Nf, "pub", function () {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), Lf(Nf, "privBytes", function () {
    var e = this.eddsa,
      t = this.hash(),
      n = e.encodingLength - 1,
      r = t.slice(0, e.encodingLength);
    return r[0] &= 248, r[n] &= 127, r[n] |= 64, r;
  }), Lf(Nf, "priv", function () {
    return this.eddsa.decodeInt(this.privBytes());
  }), Lf(Nf, "hash", function () {
    return this.eddsa.hash().update(this.secret()).digest();
  }), Lf(Nf, "messagePrefix", function () {
    return this.hash().slice(this.eddsa.encodingLength);
  }), Nf.prototype.sign = function (e) {
    return Pf(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
  }, Nf.prototype.verify = function (e, t) {
    return this.eddsa.verify(e, t, this);
  }, Nf.prototype.getSecret = function (e) {
    return Pf(this._secret, "KeyPair is public only"), Tf.encode(this.secret(), e);
  }, Nf.prototype.getPublic = function (e) {
    return Tf.encode(this.pubBytes(), e);
  };
  var Df = Nf,
    Bf = hc,
    jf = Pc,
    Ff = jf.assert,
    zf = jf.cachedProperty,
    Uf = jf.parseBytes;
  function qf(e, t) {
    this.eddsa = e, "object" != typeof t && (t = Uf(t)), Array.isArray(t) && (t = {
      R: t.slice(0, e.encodingLength),
      S: t.slice(e.encodingLength)
    }), Ff(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof Bf && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
  }
  zf(qf, "S", function () {
    return this.eddsa.decodeInt(this.Sencoded());
  }), zf(qf, "R", function () {
    return this.eddsa.decodePoint(this.Rencoded());
  }), zf(qf, "Rencoded", function () {
    return this.eddsa.encodePoint(this.R());
  }), zf(qf, "Sencoded", function () {
    return this.eddsa.encodeInt(this.S());
  }), qf.prototype.toBytes = function () {
    return this.Rencoded().concat(this.Sencoded());
  }, qf.prototype.toHex = function () {
    return jf.encode(this.toBytes(), "hex").toUpperCase();
  };
  var Kf = qf,
    Hf = fl,
    Vf = dl,
    $f = Pc,
    Wf = $f.assert,
    Yf = $f.parseBytes,
    Gf = Df,
    Qf = Kf;
  function Zf(e) {
    if (Wf("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof Zf)) return new Zf(e);
    e = Vf[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = Hf.sha512;
  }
  var Jf,
    Xf = Zf;
  function eh() {
    return Jf || (Jf = 1, function (e) {
      var t = e;
      t.version = Tc.version, t.utils = Pc, t.rand = mc(), t.curve = Lc, t.curves = dl, t.ec = function () {
        if (kf) return Sf;
        kf = 1;
        var e = hc,
          t = mf,
          n = Pc,
          r = dl,
          i = mc(),
          o = n.assert,
          a = yf,
          s = Mf;
        function u(e) {
          if (!(this instanceof u)) return new u(e);
          "string" == typeof e && (o(Object.prototype.hasOwnProperty.call(r, e), "Unknown curve " + e), e = r[e]), e instanceof r.PresetCurve && (e = {
            curve: e
          }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
        }
        return Sf = u, u.prototype.keyPair = function (e) {
          return new a(this, e);
        }, u.prototype.keyFromPrivate = function (e, t) {
          return a.fromPrivate(this, e, t);
        }, u.prototype.keyFromPublic = function (e, t) {
          return a.fromPublic(this, e, t);
        }, u.prototype.genKeyPair = function (n) {
          n || (n = {});
          for (var r = new t({
              hash: this.hash,
              pers: n.pers,
              persEnc: n.persEnc || "utf8",
              entropy: n.entropy || i(this.hash.hmacStrength),
              entropyEnc: n.entropy && n.entropyEnc || "utf8",
              nonce: this.n.toArray()
            }), o = this.n.byteLength(), a = this.n.sub(new e(2));;) {
            var s = new e(r.generate(o));
            if (!(s.cmp(a) > 0)) return s.iaddn(1), this.keyFromPrivate(s);
          }
        }, u.prototype._truncateToN = function (e, t) {
          var n = 8 * e.byteLength() - this.n.bitLength();
          return n > 0 && (e = e.ushrn(n)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
        }, u.prototype.sign = function (n, r, i, o) {
          "object" == typeof i && (o = i, i = null), o || (o = {}), r = this.keyFromPrivate(r, i), n = this._truncateToN(new e(n, 16));
          for (var a = this.n.byteLength(), u = r.getPrivate().toArray("be", a), c = n.toArray("be", a), l = new t({
              hash: this.hash,
              entropy: u,
              nonce: c,
              pers: o.pers,
              persEnc: o.persEnc || "utf8"
            }), d = this.n.sub(new e(1)), f = 0;; f++) {
            var h = o.k ? o.k(f) : new e(l.generate(this.n.byteLength()));
            if (!((h = this._truncateToN(h, !0)).cmpn(1) <= 0 || h.cmp(d) >= 0)) {
              var p = this.g.mul(h);
              if (!p.isInfinity()) {
                var m = p.getX(),
                  g = m.umod(this.n);
                if (0 !== g.cmpn(0)) {
                  var v = h.invm(this.n).mul(g.mul(r.getPrivate()).iadd(n));
                  if (0 !== (v = v.umod(this.n)).cmpn(0)) {
                    var b = (p.getY().isOdd() ? 1 : 0) | (0 !== m.cmp(g) ? 2 : 0);
                    return o.canonical && v.cmp(this.nh) > 0 && (v = this.n.sub(v), b ^= 1), new s({
                      r: g,
                      s: v,
                      recoveryParam: b
                    });
                  }
                }
              }
            }
          }
        }, u.prototype.verify = function (t, n, r, i) {
          t = this._truncateToN(new e(t, 16)), r = this.keyFromPublic(r, i);
          var o = (n = new s(n, "hex")).r,
            a = n.s;
          if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
          if (a.cmpn(1) < 0 || a.cmp(this.n) >= 0) return !1;
          var u,
            c = a.invm(this.n),
            l = c.mul(t).umod(this.n),
            d = c.mul(o).umod(this.n);
          return this.curve._maxwellTrick ? !(u = this.g.jmulAdd(l, r.getPublic(), d)).isInfinity() && u.eqXToP(o) : !(u = this.g.mulAdd(l, r.getPublic(), d)).isInfinity() && 0 === u.getX().umod(this.n).cmp(o);
        }, u.prototype.recoverPubKey = function (t, n, r, i) {
          o((3 & r) === r, "The recovery param is more than two bits"), n = new s(n, i);
          var a = this.n,
            u = new e(t),
            c = n.r,
            l = n.s,
            d = 1 & r,
            f = r >> 1;
          if (c.cmp(this.curve.p.umod(this.curve.n)) >= 0 && f) throw new Error("Unable to find sencond key candinate");
          c = f ? this.curve.pointFromX(c.add(this.curve.n), d) : this.curve.pointFromX(c, d);
          var h = n.r.invm(a),
            p = a.sub(u).mul(h).umod(a),
            m = l.mul(h).umod(a);
          return this.g.mulAdd(p, c, m);
        }, u.prototype.getKeyRecoveryParam = function (e, t, n, r) {
          if (null !== (t = new s(t, r)).recoveryParam) return t.recoveryParam;
          for (var i = 0; i < 4; i++) {
            var o;
            try {
              o = this.recoverPubKey(e, t, i);
            } catch (e) {
              continue;
            }
            if (o.eq(n)) return i;
          }
          throw new Error("Unable to find valid recovery factor");
        }, Sf;
      }(), t.eddsa = Xf;
    }(Ic)), Ic;
  }
  Zf.prototype.sign = function (e, t) {
    e = Yf(e);
    var n = this.keyFromSecret(t),
      r = this.hashInt(n.messagePrefix(), e),
      i = this.g.mul(r),
      o = this.encodePoint(i),
      a = this.hashInt(o, n.pubBytes(), e).mul(n.priv()),
      s = r.add(a).umod(this.curve.n);
    return this.makeSignature({
      R: i,
      S: s,
      Rencoded: o
    });
  }, Zf.prototype.verify = function (e, t, n) {
    e = Yf(e), t = this.makeSignature(t);
    var r = this.keyFromPublic(n),
      i = this.hashInt(t.Rencoded(), r.pubBytes(), e),
      o = this.g.mul(t.S());
    return t.R().add(r.pub().mul(i)).eq(o);
  }, Zf.prototype.hashInt = function () {
    for (var e = this.hash(), t = 0; t < arguments.length; t++) e.update(arguments[t]);
    return $f.intFromLE(e.digest()).umod(this.curve.n);
  }, Zf.prototype.keyFromPublic = function (e) {
    return Gf.fromPublic(this, e);
  }, Zf.prototype.keyFromSecret = function (e) {
    return Gf.fromSecret(this, e);
  }, Zf.prototype.makeSignature = function (e) {
    return e instanceof Qf ? e : new Qf(this, e);
  }, Zf.prototype.encodePoint = function (e) {
    var t = e.getY().toArray("le", this.encodingLength);
    return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
  }, Zf.prototype.decodePoint = function (e) {
    var t = (e = $f.parseBytes(e)).length - 1,
      n = e.slice(0, t).concat(-129 & e[t]),
      r = 0 != (128 & e[t]),
      i = $f.intFromLE(n);
    return this.curve.pointFromY(i, r);
  }, Zf.prototype.encodeInt = function (e) {
    return e.toArray("le", this.encodingLength);
  }, Zf.prototype.decodeInt = function (e) {
    return $f.intFromLE(e);
  }, Zf.prototype.isPoint = function (e) {
    return e instanceof this.pointClass;
  };
  var th = {
    exports: {}
  };
  !function (e) {
    !function (e, t) {
      function n(e, t) {
        if (!e) throw new Error(t || "Assertion failed");
      }
      function r(e, t) {
        e.super_ = t;
        var n = function () {};
        n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
      }
      function i(e, t, n) {
        if (i.isBN(e)) return e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (n = t, t = 10), this._init(e || 0, t || 10, n || "be"));
      }
      var o;
      "object" == typeof e ? e.exports = i : t.BN = i, i.BN = i, i.wordSize = 26;
      try {
        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : le.Buffer;
      } catch (e) {}
      function a(e, t) {
        var r = e.charCodeAt(t);
        return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void n(!1, "Invalid character in " + e);
      }
      function s(e, t, n) {
        var r = a(e, n);
        return n - 1 >= t && (r |= a(e, n - 1) << 4), r;
      }
      function u(e, t, r, i) {
        for (var o = 0, a = 0, s = Math.min(e.length, r), u = t; u < s; u++) {
          var c = e.charCodeAt(u) - 48;
          o *= i, a = c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c, n(c >= 0 && a < i, "Invalid character"), o += a;
        }
        return o;
      }
      function c(e, t) {
        e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
      }
      if (i.isBN = function (e) {
        return e instanceof i || null !== e && "object" == typeof e && e.constructor.wordSize === i.wordSize && Array.isArray(e.words);
      }, i.max = function (e, t) {
        return e.cmp(t) > 0 ? e : t;
      }, i.min = function (e, t) {
        return e.cmp(t) < 0 ? e : t;
      }, i.prototype._init = function (e, t, r) {
        if ("number" == typeof e) return this._initNumber(e, t, r);
        if ("object" == typeof e) return this._initArray(e, t, r);
        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
        var i = 0;
        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
      }, i.prototype._initNumber = function (e, t, r) {
        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (n(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
      }, i.prototype._initArray = function (e, t, r) {
        if (n("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) this.words[i] = 0;
        var o,
          a,
          s = 0;
        if ("be" === r) for (i = e.length - 1, o = 0; i >= 0; i -= 3) a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);else if ("le" === r) for (i = 0, o = 0; i < e.length; i += 3) a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
        return this._strip();
      }, i.prototype._parseHex = function (e, t, n) {
        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
        for (var r = 0; r < this.length; r++) this.words[r] = 0;
        var i,
          o = 0,
          a = 0;
        if ("be" === n) for (r = e.length - 1; r >= t; r -= 2) i = s(e, t, r) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;else for (r = (e.length - t) % 2 == 0 ? t + 1 : t; r < e.length; r += 2) i = s(e, t, r) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
        this._strip();
      }, i.prototype._parseBase = function (e, t, n) {
        this.words = [0], this.length = 1;
        for (var r = 0, i = 1; i <= 67108863; i *= t) r++;
        r--, i = i / t | 0;
        for (var o = e.length - n, a = o % r, s = Math.min(o, o - a) + n, c = 0, l = n; l < s; l += r) c = u(e, l, l + r, t), this.imuln(i), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
        if (0 !== a) {
          var d = 1;
          for (c = u(e, l, e.length, t), l = 0; l < a; l++) d *= t;
          this.imuln(d), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
        }
        this._strip();
      }, i.prototype.copy = function (e) {
        e.words = new Array(this.length);
        for (var t = 0; t < this.length; t++) e.words[t] = this.words[t];
        e.length = this.length, e.negative = this.negative, e.red = this.red;
      }, i.prototype._move = function (e) {
        c(e, this);
      }, i.prototype.clone = function () {
        var e = new i(null);
        return this.copy(e), e;
      }, i.prototype._expand = function (e) {
        for (; this.length < e;) this.words[this.length++] = 0;
        return this;
      }, i.prototype._strip = function () {
        for (; this.length > 1 && 0 === this.words[this.length - 1];) this.length--;
        return this._normSign();
      }, i.prototype._normSign = function () {
        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
      }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
        i.prototype[Symbol.for("nodejs.util.inspect.custom")] = l;
      } catch (e) {
        i.prototype.inspect = l;
      } else i.prototype.inspect = l;
      function l() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var d = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
        f = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
        h = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
      i.prototype.toString = function (e, t) {
        var r;
        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
          r = "";
          for (var i = 0, o = 0, a = 0; a < this.length; a++) {
            var s = this.words[a],
              u = (16777215 & (s << i | o)).toString(16);
            o = s >>> 24 - i & 16777215, (i += 2) >= 26 && (i -= 26, a--), r = 0 !== o || a !== this.length - 1 ? d[6 - u.length] + u + r : u + r;
          }
          for (0 !== o && (r = o.toString(16) + r); r.length % t != 0;) r = "0" + r;
          return 0 !== this.negative && (r = "-" + r), r;
        }
        if (e === (0 | e) && e >= 2 && e <= 36) {
          var c = f[e],
            l = h[e];
          r = "";
          var p = this.clone();
          for (p.negative = 0; !p.isZero();) {
            var m = p.modrn(l).toString(e);
            r = (p = p.idivn(l)).isZero() ? m + r : d[c - m.length] + m + r;
          }
          for (this.isZero() && (r = "0" + r); r.length % t != 0;) r = "0" + r;
          return 0 !== this.negative && (r = "-" + r), r;
        }
        n(!1, "Base should be between 2 and 36");
      }, i.prototype.toNumber = function () {
        var e = this.words[0];
        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
      }, i.prototype.toJSON = function () {
        return this.toString(16, 2);
      }, o && (i.prototype.toBuffer = function (e, t) {
        return this.toArrayLike(o, e, t);
      }), i.prototype.toArray = function (e, t) {
        return this.toArrayLike(Array, e, t);
      };
      function p(e, t, n) {
        n.negative = t.negative ^ e.negative;
        var r = e.length + t.length | 0;
        n.length = r, r = r - 1 | 0;
        var i = 0 | e.words[0],
          o = 0 | t.words[0],
          a = i * o,
          s = 67108863 & a,
          u = a / 67108864 | 0;
        n.words[0] = s;
        for (var c = 1; c < r; c++) {
          for (var l = u >>> 26, d = 67108863 & u, f = Math.min(c, t.length - 1), h = Math.max(0, c - e.length + 1); h <= f; h++) {
            var p = c - h | 0;
            l += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[h]) + d) / 67108864 | 0, d = 67108863 & a;
          }
          n.words[c] = 0 | d, u = 0 | l;
        }
        return 0 !== u ? n.words[c] = 0 | u : n.length--, n._strip();
      }
      i.prototype.toArrayLike = function (e, t, r) {
        this._strip();
        var i = this.byteLength(),
          o = r || Math.max(1, i);
        n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0");
        var a = function (e, t) {
          return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
        }(e, o);
        return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](a, i), a;
      }, i.prototype._toArrayLikeLE = function (e, t) {
        for (var n = 0, r = 0, i = 0, o = 0; i < this.length; i++) {
          var a = this.words[i] << o | r;
          e[n++] = 255 & a, n < e.length && (e[n++] = a >> 8 & 255), n < e.length && (e[n++] = a >> 16 & 255), 6 === o ? (n < e.length && (e[n++] = a >> 24 & 255), r = 0, o = 0) : (r = a >>> 24, o += 2);
        }
        if (n < e.length) for (e[n++] = r; n < e.length;) e[n++] = 0;
      }, i.prototype._toArrayLikeBE = function (e, t) {
        for (var n = e.length - 1, r = 0, i = 0, o = 0; i < this.length; i++) {
          var a = this.words[i] << o | r;
          e[n--] = 255 & a, n >= 0 && (e[n--] = a >> 8 & 255), n >= 0 && (e[n--] = a >> 16 & 255), 6 === o ? (n >= 0 && (e[n--] = a >> 24 & 255), r = 0, o = 0) : (r = a >>> 24, o += 2);
        }
        if (n >= 0) for (e[n--] = r; n >= 0;) e[n--] = 0;
      }, Math.clz32 ? i.prototype._countBits = function (e) {
        return 32 - Math.clz32(e);
      } : i.prototype._countBits = function (e) {
        var t = e,
          n = 0;
        return t >= 4096 && (n += 13, t >>>= 13), t >= 64 && (n += 7, t >>>= 7), t >= 8 && (n += 4, t >>>= 4), t >= 2 && (n += 2, t >>>= 2), n + t;
      }, i.prototype._zeroBits = function (e) {
        if (0 === e) return 26;
        var t = e,
          n = 0;
        return 0 == (8191 & t) && (n += 13, t >>>= 13), 0 == (127 & t) && (n += 7, t >>>= 7), 0 == (15 & t) && (n += 4, t >>>= 4), 0 == (3 & t) && (n += 2, t >>>= 2), 0 == (1 & t) && n++, n;
      }, i.prototype.bitLength = function () {
        var e = this.words[this.length - 1],
          t = this._countBits(e);
        return 26 * (this.length - 1) + t;
      }, i.prototype.zeroBits = function () {
        if (this.isZero()) return 0;
        for (var e = 0, t = 0; t < this.length; t++) {
          var n = this._zeroBits(this.words[t]);
          if (e += n, 26 !== n) break;
        }
        return e;
      }, i.prototype.byteLength = function () {
        return Math.ceil(this.bitLength() / 8);
      }, i.prototype.toTwos = function (e) {
        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
      }, i.prototype.fromTwos = function (e) {
        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
      }, i.prototype.isNeg = function () {
        return 0 !== this.negative;
      }, i.prototype.neg = function () {
        return this.clone().ineg();
      }, i.prototype.ineg = function () {
        return this.isZero() || (this.negative ^= 1), this;
      }, i.prototype.iuor = function (e) {
        for (; this.length < e.length;) this.words[this.length++] = 0;
        for (var t = 0; t < e.length; t++) this.words[t] = this.words[t] | e.words[t];
        return this._strip();
      }, i.prototype.ior = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuor(e);
      }, i.prototype.or = function (e) {
        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
      }, i.prototype.uor = function (e) {
        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
      }, i.prototype.iuand = function (e) {
        var t;
        t = this.length > e.length ? e : this;
        for (var n = 0; n < t.length; n++) this.words[n] = this.words[n] & e.words[n];
        return this.length = t.length, this._strip();
      }, i.prototype.iand = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuand(e);
      }, i.prototype.and = function (e) {
        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
      }, i.prototype.uand = function (e) {
        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
      }, i.prototype.iuxor = function (e) {
        var t, n;
        this.length > e.length ? (t = this, n = e) : (t = e, n = this);
        for (var r = 0; r < n.length; r++) this.words[r] = t.words[r] ^ n.words[r];
        if (this !== t) for (; r < t.length; r++) this.words[r] = t.words[r];
        return this.length = t.length, this._strip();
      }, i.prototype.ixor = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuxor(e);
      }, i.prototype.xor = function (e) {
        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
      }, i.prototype.uxor = function (e) {
        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
      }, i.prototype.inotn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = 0 | Math.ceil(e / 26),
          r = e % 26;
        this._expand(t), r > 0 && t--;
        for (var i = 0; i < t; i++) this.words[i] = 67108863 & ~this.words[i];
        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this._strip();
      }, i.prototype.notn = function (e) {
        return this.clone().inotn(e);
      }, i.prototype.setn = function (e, t) {
        n("number" == typeof e && e >= 0);
        var r = e / 26 | 0,
          i = e % 26;
        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this._strip();
      }, i.prototype.iadd = function (e) {
        var t, n, r;
        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
        this.length > e.length ? (n = this, r = e) : (n = e, r = this);
        for (var i = 0, o = 0; o < r.length; o++) t = (0 | n.words[o]) + (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
        for (; 0 !== i && o < n.length; o++) t = (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
        if (this.length = n.length, 0 !== i) this.words[this.length] = i, this.length++;else if (n !== this) for (; o < n.length; o++) this.words[o] = n.words[o];
        return this;
      }, i.prototype.add = function (e) {
        var t;
        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
      }, i.prototype.isub = function (e) {
        if (0 !== e.negative) {
          e.negative = 0;
          var t = this.iadd(e);
          return e.negative = 1, t._normSign();
        }
        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
        var n,
          r,
          i = this.cmp(e);
        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        i > 0 ? (n = this, r = e) : (n = e, r = this);
        for (var o = 0, a = 0; a < r.length; a++) o = (t = (0 | n.words[a]) - (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
        for (; 0 !== o && a < n.length; a++) o = (t = (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
        if (0 === o && a < n.length && n !== this) for (; a < n.length; a++) this.words[a] = n.words[a];
        return this.length = Math.max(this.length, a), n !== this && (this.negative = 1), this._strip();
      }, i.prototype.sub = function (e) {
        return this.clone().isub(e);
      };
      var m = function (e, t, n) {
        var r,
          i,
          o,
          a = e.words,
          s = t.words,
          u = n.words,
          c = 0,
          l = 0 | a[0],
          d = 8191 & l,
          f = l >>> 13,
          h = 0 | a[1],
          p = 8191 & h,
          m = h >>> 13,
          g = 0 | a[2],
          v = 8191 & g,
          b = g >>> 13,
          y = 0 | a[3],
          w = 8191 & y,
          A = y >>> 13,
          _ = 0 | a[4],
          E = 8191 & _,
          S = _ >>> 13,
          k = 0 | a[5],
          M = 8191 & k,
          C = k >>> 13,
          x = 0 | a[6],
          R = 8191 & x,
          I = x >>> 13,
          T = 0 | a[7],
          P = 8191 & T,
          O = T >>> 13,
          L = 0 | a[8],
          N = 8191 & L,
          D = L >>> 13,
          B = 0 | a[9],
          j = 8191 & B,
          F = B >>> 13,
          z = 0 | s[0],
          U = 8191 & z,
          q = z >>> 13,
          K = 0 | s[1],
          H = 8191 & K,
          V = K >>> 13,
          $ = 0 | s[2],
          W = 8191 & $,
          Y = $ >>> 13,
          G = 0 | s[3],
          Q = 8191 & G,
          Z = G >>> 13,
          J = 0 | s[4],
          X = 8191 & J,
          ee = J >>> 13,
          te = 0 | s[5],
          ne = 8191 & te,
          re = te >>> 13,
          ie = 0 | s[6],
          oe = 8191 & ie,
          ae = ie >>> 13,
          se = 0 | s[7],
          ue = 8191 & se,
          ce = se >>> 13,
          le = 0 | s[8],
          de = 8191 & le,
          fe = le >>> 13,
          he = 0 | s[9],
          pe = 8191 & he,
          me = he >>> 13;
        n.negative = e.negative ^ t.negative, n.length = 19;
        var ge = (c + (r = Math.imul(d, U)) | 0) + ((8191 & (i = (i = Math.imul(d, q)) + Math.imul(f, U) | 0)) << 13) | 0;
        c = ((o = Math.imul(f, q)) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, r = Math.imul(p, U), i = (i = Math.imul(p, q)) + Math.imul(m, U) | 0, o = Math.imul(m, q);
        var ve = (c + (r = r + Math.imul(d, H) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, V) | 0) + Math.imul(f, H) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, V) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, r = Math.imul(v, U), i = (i = Math.imul(v, q)) + Math.imul(b, U) | 0, o = Math.imul(b, q), r = r + Math.imul(p, H) | 0, i = (i = i + Math.imul(p, V) | 0) + Math.imul(m, H) | 0, o = o + Math.imul(m, V) | 0;
        var be = (c + (r = r + Math.imul(d, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Y) | 0) + Math.imul(f, W) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, Y) | 0) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, r = Math.imul(w, U), i = (i = Math.imul(w, q)) + Math.imul(A, U) | 0, o = Math.imul(A, q), r = r + Math.imul(v, H) | 0, i = (i = i + Math.imul(v, V) | 0) + Math.imul(b, H) | 0, o = o + Math.imul(b, V) | 0, r = r + Math.imul(p, W) | 0, i = (i = i + Math.imul(p, Y) | 0) + Math.imul(m, W) | 0, o = o + Math.imul(m, Y) | 0;
        var ye = (c + (r = r + Math.imul(d, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Z) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, Z) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, r = Math.imul(E, U), i = (i = Math.imul(E, q)) + Math.imul(S, U) | 0, o = Math.imul(S, q), r = r + Math.imul(w, H) | 0, i = (i = i + Math.imul(w, V) | 0) + Math.imul(A, H) | 0, o = o + Math.imul(A, V) | 0, r = r + Math.imul(v, W) | 0, i = (i = i + Math.imul(v, Y) | 0) + Math.imul(b, W) | 0, o = o + Math.imul(b, Y) | 0, r = r + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, Z) | 0) + Math.imul(m, Q) | 0, o = o + Math.imul(m, Z) | 0;
        var we = (c + (r = r + Math.imul(d, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, r = Math.imul(M, U), i = (i = Math.imul(M, q)) + Math.imul(C, U) | 0, o = Math.imul(C, q), r = r + Math.imul(E, H) | 0, i = (i = i + Math.imul(E, V) | 0) + Math.imul(S, H) | 0, o = o + Math.imul(S, V) | 0, r = r + Math.imul(w, W) | 0, i = (i = i + Math.imul(w, Y) | 0) + Math.imul(A, W) | 0, o = o + Math.imul(A, Y) | 0, r = r + Math.imul(v, Q) | 0, i = (i = i + Math.imul(v, Z) | 0) + Math.imul(b, Q) | 0, o = o + Math.imul(b, Z) | 0, r = r + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, X) | 0, o = o + Math.imul(m, ee) | 0;
        var Ae = (c + (r = r + Math.imul(d, ne) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, re) | 0) + Math.imul(f, ne) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, re) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, r = Math.imul(R, U), i = (i = Math.imul(R, q)) + Math.imul(I, U) | 0, o = Math.imul(I, q), r = r + Math.imul(M, H) | 0, i = (i = i + Math.imul(M, V) | 0) + Math.imul(C, H) | 0, o = o + Math.imul(C, V) | 0, r = r + Math.imul(E, W) | 0, i = (i = i + Math.imul(E, Y) | 0) + Math.imul(S, W) | 0, o = o + Math.imul(S, Y) | 0, r = r + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, Z) | 0) + Math.imul(A, Q) | 0, o = o + Math.imul(A, Z) | 0, r = r + Math.imul(v, X) | 0, i = (i = i + Math.imul(v, ee) | 0) + Math.imul(b, X) | 0, o = o + Math.imul(b, ee) | 0, r = r + Math.imul(p, ne) | 0, i = (i = i + Math.imul(p, re) | 0) + Math.imul(m, ne) | 0, o = o + Math.imul(m, re) | 0;
        var _e = (c + (r = r + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ae) | 0) + Math.imul(f, oe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ae) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, r = Math.imul(P, U), i = (i = Math.imul(P, q)) + Math.imul(O, U) | 0, o = Math.imul(O, q), r = r + Math.imul(R, H) | 0, i = (i = i + Math.imul(R, V) | 0) + Math.imul(I, H) | 0, o = o + Math.imul(I, V) | 0, r = r + Math.imul(M, W) | 0, i = (i = i + Math.imul(M, Y) | 0) + Math.imul(C, W) | 0, o = o + Math.imul(C, Y) | 0, r = r + Math.imul(E, Q) | 0, i = (i = i + Math.imul(E, Z) | 0) + Math.imul(S, Q) | 0, o = o + Math.imul(S, Z) | 0, r = r + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(A, X) | 0, o = o + Math.imul(A, ee) | 0, r = r + Math.imul(v, ne) | 0, i = (i = i + Math.imul(v, re) | 0) + Math.imul(b, ne) | 0, o = o + Math.imul(b, re) | 0, r = r + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, ae) | 0;
        var Ee = (c + (r = r + Math.imul(d, ue) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ce) | 0) + Math.imul(f, ue) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, r = Math.imul(N, U), i = (i = Math.imul(N, q)) + Math.imul(D, U) | 0, o = Math.imul(D, q), r = r + Math.imul(P, H) | 0, i = (i = i + Math.imul(P, V) | 0) + Math.imul(O, H) | 0, o = o + Math.imul(O, V) | 0, r = r + Math.imul(R, W) | 0, i = (i = i + Math.imul(R, Y) | 0) + Math.imul(I, W) | 0, o = o + Math.imul(I, Y) | 0, r = r + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, Z) | 0) + Math.imul(C, Q) | 0, o = o + Math.imul(C, Z) | 0, r = r + Math.imul(E, X) | 0, i = (i = i + Math.imul(E, ee) | 0) + Math.imul(S, X) | 0, o = o + Math.imul(S, ee) | 0, r = r + Math.imul(w, ne) | 0, i = (i = i + Math.imul(w, re) | 0) + Math.imul(A, ne) | 0, o = o + Math.imul(A, re) | 0, r = r + Math.imul(v, oe) | 0, i = (i = i + Math.imul(v, ae) | 0) + Math.imul(b, oe) | 0, o = o + Math.imul(b, ae) | 0, r = r + Math.imul(p, ue) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, ue) | 0, o = o + Math.imul(m, ce) | 0;
        var Se = (c + (r = r + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, fe) | 0) + Math.imul(f, de) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, r = Math.imul(j, U), i = (i = Math.imul(j, q)) + Math.imul(F, U) | 0, o = Math.imul(F, q), r = r + Math.imul(N, H) | 0, i = (i = i + Math.imul(N, V) | 0) + Math.imul(D, H) | 0, o = o + Math.imul(D, V) | 0, r = r + Math.imul(P, W) | 0, i = (i = i + Math.imul(P, Y) | 0) + Math.imul(O, W) | 0, o = o + Math.imul(O, Y) | 0, r = r + Math.imul(R, Q) | 0, i = (i = i + Math.imul(R, Z) | 0) + Math.imul(I, Q) | 0, o = o + Math.imul(I, Z) | 0, r = r + Math.imul(M, X) | 0, i = (i = i + Math.imul(M, ee) | 0) + Math.imul(C, X) | 0, o = o + Math.imul(C, ee) | 0, r = r + Math.imul(E, ne) | 0, i = (i = i + Math.imul(E, re) | 0) + Math.imul(S, ne) | 0, o = o + Math.imul(S, re) | 0, r = r + Math.imul(w, oe) | 0, i = (i = i + Math.imul(w, ae) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, ae) | 0, r = r + Math.imul(v, ue) | 0, i = (i = i + Math.imul(v, ce) | 0) + Math.imul(b, ue) | 0, o = o + Math.imul(b, ce) | 0, r = r + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, de) | 0, o = o + Math.imul(m, fe) | 0;
        var ke = (c + (r = r + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, r = Math.imul(j, H), i = (i = Math.imul(j, V)) + Math.imul(F, H) | 0, o = Math.imul(F, V), r = r + Math.imul(N, W) | 0, i = (i = i + Math.imul(N, Y) | 0) + Math.imul(D, W) | 0, o = o + Math.imul(D, Y) | 0, r = r + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, Z) | 0) + Math.imul(O, Q) | 0, o = o + Math.imul(O, Z) | 0, r = r + Math.imul(R, X) | 0, i = (i = i + Math.imul(R, ee) | 0) + Math.imul(I, X) | 0, o = o + Math.imul(I, ee) | 0, r = r + Math.imul(M, ne) | 0, i = (i = i + Math.imul(M, re) | 0) + Math.imul(C, ne) | 0, o = o + Math.imul(C, re) | 0, r = r + Math.imul(E, oe) | 0, i = (i = i + Math.imul(E, ae) | 0) + Math.imul(S, oe) | 0, o = o + Math.imul(S, ae) | 0, r = r + Math.imul(w, ue) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(A, ue) | 0, o = o + Math.imul(A, ce) | 0, r = r + Math.imul(v, de) | 0, i = (i = i + Math.imul(v, fe) | 0) + Math.imul(b, de) | 0, o = o + Math.imul(b, fe) | 0;
        var Me = (c + (r = r + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, r = Math.imul(j, W), i = (i = Math.imul(j, Y)) + Math.imul(F, W) | 0, o = Math.imul(F, Y), r = r + Math.imul(N, Q) | 0, i = (i = i + Math.imul(N, Z) | 0) + Math.imul(D, Q) | 0, o = o + Math.imul(D, Z) | 0, r = r + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(O, X) | 0, o = o + Math.imul(O, ee) | 0, r = r + Math.imul(R, ne) | 0, i = (i = i + Math.imul(R, re) | 0) + Math.imul(I, ne) | 0, o = o + Math.imul(I, re) | 0, r = r + Math.imul(M, oe) | 0, i = (i = i + Math.imul(M, ae) | 0) + Math.imul(C, oe) | 0, o = o + Math.imul(C, ae) | 0, r = r + Math.imul(E, ue) | 0, i = (i = i + Math.imul(E, ce) | 0) + Math.imul(S, ue) | 0, o = o + Math.imul(S, ce) | 0, r = r + Math.imul(w, de) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(A, de) | 0, o = o + Math.imul(A, fe) | 0;
        var Ce = (c + (r = r + Math.imul(v, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(v, me) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(b, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, r = Math.imul(j, Q), i = (i = Math.imul(j, Z)) + Math.imul(F, Q) | 0, o = Math.imul(F, Z), r = r + Math.imul(N, X) | 0, i = (i = i + Math.imul(N, ee) | 0) + Math.imul(D, X) | 0, o = o + Math.imul(D, ee) | 0, r = r + Math.imul(P, ne) | 0, i = (i = i + Math.imul(P, re) | 0) + Math.imul(O, ne) | 0, o = o + Math.imul(O, re) | 0, r = r + Math.imul(R, oe) | 0, i = (i = i + Math.imul(R, ae) | 0) + Math.imul(I, oe) | 0, o = o + Math.imul(I, ae) | 0, r = r + Math.imul(M, ue) | 0, i = (i = i + Math.imul(M, ce) | 0) + Math.imul(C, ue) | 0, o = o + Math.imul(C, ce) | 0, r = r + Math.imul(E, de) | 0, i = (i = i + Math.imul(E, fe) | 0) + Math.imul(S, de) | 0, o = o + Math.imul(S, fe) | 0;
        var xe = (c + (r = r + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(A, me) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, r = Math.imul(j, X), i = (i = Math.imul(j, ee)) + Math.imul(F, X) | 0, o = Math.imul(F, ee), r = r + Math.imul(N, ne) | 0, i = (i = i + Math.imul(N, re) | 0) + Math.imul(D, ne) | 0, o = o + Math.imul(D, re) | 0, r = r + Math.imul(P, oe) | 0, i = (i = i + Math.imul(P, ae) | 0) + Math.imul(O, oe) | 0, o = o + Math.imul(O, ae) | 0, r = r + Math.imul(R, ue) | 0, i = (i = i + Math.imul(R, ce) | 0) + Math.imul(I, ue) | 0, o = o + Math.imul(I, ce) | 0, r = r + Math.imul(M, de) | 0, i = (i = i + Math.imul(M, fe) | 0) + Math.imul(C, de) | 0, o = o + Math.imul(C, fe) | 0;
        var Re = (c + (r = r + Math.imul(E, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(E, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, r = Math.imul(j, ne), i = (i = Math.imul(j, re)) + Math.imul(F, ne) | 0, o = Math.imul(F, re), r = r + Math.imul(N, oe) | 0, i = (i = i + Math.imul(N, ae) | 0) + Math.imul(D, oe) | 0, o = o + Math.imul(D, ae) | 0, r = r + Math.imul(P, ue) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(O, ue) | 0, o = o + Math.imul(O, ce) | 0, r = r + Math.imul(R, de) | 0, i = (i = i + Math.imul(R, fe) | 0) + Math.imul(I, de) | 0, o = o + Math.imul(I, fe) | 0;
        var Ie = (c + (r = r + Math.imul(M, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, me) | 0) + Math.imul(C, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(C, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, r = Math.imul(j, oe), i = (i = Math.imul(j, ae)) + Math.imul(F, oe) | 0, o = Math.imul(F, ae), r = r + Math.imul(N, ue) | 0, i = (i = i + Math.imul(N, ce) | 0) + Math.imul(D, ue) | 0, o = o + Math.imul(D, ce) | 0, r = r + Math.imul(P, de) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(O, de) | 0, o = o + Math.imul(O, fe) | 0;
        var Te = (c + (r = r + Math.imul(R, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(R, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, r = Math.imul(j, ue), i = (i = Math.imul(j, ce)) + Math.imul(F, ue) | 0, o = Math.imul(F, ce), r = r + Math.imul(N, de) | 0, i = (i = i + Math.imul(N, fe) | 0) + Math.imul(D, de) | 0, o = o + Math.imul(D, fe) | 0;
        var Pe = (c + (r = r + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(O, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(O, me) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, r = Math.imul(j, de), i = (i = Math.imul(j, fe)) + Math.imul(F, de) | 0, o = Math.imul(F, fe);
        var Oe = (c + (r = r + Math.imul(N, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(N, me) | 0) + Math.imul(D, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(D, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863;
        var Le = (c + (r = Math.imul(j, pe)) | 0) + ((8191 & (i = (i = Math.imul(j, me)) + Math.imul(F, pe) | 0)) << 13) | 0;
        return c = ((o = Math.imul(F, me)) + (i >>> 13) | 0) + (Le >>> 26) | 0, Le &= 67108863, u[0] = ge, u[1] = ve, u[2] = be, u[3] = ye, u[4] = we, u[5] = Ae, u[6] = _e, u[7] = Ee, u[8] = Se, u[9] = ke, u[10] = Me, u[11] = Ce, u[12] = xe, u[13] = Re, u[14] = Ie, u[15] = Te, u[16] = Pe, u[17] = Oe, u[18] = Le, 0 !== c && (u[19] = c, n.length++), n;
      };
      function g(e, t, n) {
        n.negative = t.negative ^ e.negative, n.length = e.length + t.length;
        for (var r = 0, i = 0, o = 0; o < n.length - 1; o++) {
          var a = i;
          i = 0;
          for (var s = 67108863 & r, u = Math.min(o, t.length - 1), c = Math.max(0, o - e.length + 1); c <= u; c++) {
            var l = o - c,
              d = (0 | e.words[l]) * (0 | t.words[c]),
              f = 67108863 & d;
            s = 67108863 & (f = f + s | 0), i += (a = (a = a + (d / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, a &= 67108863;
          }
          n.words[o] = s, r = a, a = i;
        }
        return 0 !== r ? n.words[o] = r : n.length--, n._strip();
      }
      function v(e, t, n) {
        return g(e, t, n);
      }
      Math.imul || (m = p), i.prototype.mulTo = function (e, t) {
        var n = this.length + e.length;
        return 10 === this.length && 10 === e.length ? m(this, e, t) : n < 63 ? p(this, e, t) : n < 1024 ? g(this, e, t) : v(this, e, t);
      }, i.prototype.mul = function (e) {
        var t = new i(null);
        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
      }, i.prototype.mulf = function (e) {
        var t = new i(null);
        return t.words = new Array(this.length + e.length), v(this, e, t);
      }, i.prototype.imul = function (e) {
        return this.clone().mulTo(e, this);
      }, i.prototype.imuln = function (e) {
        var t = e < 0;
        t && (e = -e), n("number" == typeof e), n(e < 67108864);
        for (var r = 0, i = 0; i < this.length; i++) {
          var o = (0 | this.words[i]) * e,
            a = (67108863 & o) + (67108863 & r);
          r >>= 26, r += o / 67108864 | 0, r += a >>> 26, this.words[i] = 67108863 & a;
        }
        return 0 !== r && (this.words[i] = r, this.length++), t ? this.ineg() : this;
      }, i.prototype.muln = function (e) {
        return this.clone().imuln(e);
      }, i.prototype.sqr = function () {
        return this.mul(this);
      }, i.prototype.isqr = function () {
        return this.imul(this.clone());
      }, i.prototype.pow = function (e) {
        var t = function (e) {
          for (var t = new Array(e.bitLength()), n = 0; n < t.length; n++) {
            var r = n / 26 | 0,
              i = n % 26;
            t[n] = e.words[r] >>> i & 1;
          }
          return t;
        }(e);
        if (0 === t.length) return new i(1);
        for (var n = this, r = 0; r < t.length && 0 === t[r]; r++, n = n.sqr());
        if (++r < t.length) for (var o = n.sqr(); r < t.length; r++, o = o.sqr()) 0 !== t[r] && (n = n.mul(o));
        return n;
      }, i.prototype.iushln = function (e) {
        n("number" == typeof e && e >= 0);
        var t,
          r = e % 26,
          i = (e - r) / 26,
          o = 67108863 >>> 26 - r << 26 - r;
        if (0 !== r) {
          var a = 0;
          for (t = 0; t < this.length; t++) {
            var s = this.words[t] & o,
              u = (0 | this.words[t]) - s << r;
            this.words[t] = u | a, a = s >>> 26 - r;
          }
          a && (this.words[t] = a, this.length++);
        }
        if (0 !== i) {
          for (t = this.length - 1; t >= 0; t--) this.words[t + i] = this.words[t];
          for (t = 0; t < i; t++) this.words[t] = 0;
          this.length += i;
        }
        return this._strip();
      }, i.prototype.ishln = function (e) {
        return n(0 === this.negative), this.iushln(e);
      }, i.prototype.iushrn = function (e, t, r) {
        var i;
        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
        var o = e % 26,
          a = Math.min((e - o) / 26, this.length),
          s = 67108863 ^ 67108863 >>> o << o,
          u = r;
        if (i -= a, i = Math.max(0, i), u) {
          for (var c = 0; c < a; c++) u.words[c] = this.words[c];
          u.length = a;
        }
        if (0 === a) ;else if (this.length > a) for (this.length -= a, c = 0; c < this.length; c++) this.words[c] = this.words[c + a];else this.words[0] = 0, this.length = 1;
        var l = 0;
        for (c = this.length - 1; c >= 0 && (0 !== l || c >= i); c--) {
          var d = 0 | this.words[c];
          this.words[c] = l << 26 - o | d >>> o, l = d & s;
        }
        return u && 0 !== l && (u.words[u.length++] = l), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
      }, i.prototype.ishrn = function (e, t, r) {
        return n(0 === this.negative), this.iushrn(e, t, r);
      }, i.prototype.shln = function (e) {
        return this.clone().ishln(e);
      }, i.prototype.ushln = function (e) {
        return this.clone().iushln(e);
      }, i.prototype.shrn = function (e) {
        return this.clone().ishrn(e);
      }, i.prototype.ushrn = function (e) {
        return this.clone().iushrn(e);
      }, i.prototype.testn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = e % 26,
          r = (e - t) / 26,
          i = 1 << t;
        return !(this.length <= r) && !!(this.words[r] & i);
      }, i.prototype.imaskn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = e % 26,
          r = (e - t) / 26;
        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
          var i = 67108863 ^ 67108863 >>> t << t;
          this.words[this.length - 1] &= i;
        }
        return this._strip();
      }, i.prototype.maskn = function (e) {
        return this.clone().imaskn(e);
      }, i.prototype.iaddn = function (e) {
        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
      }, i.prototype._iaddn = function (e) {
        this.words[0] += e;
        for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
        return this.length = Math.max(this.length, t + 1), this;
      }, i.prototype.isubn = function (e) {
        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) this.words[t] += 67108864, this.words[t + 1] -= 1;
        return this._strip();
      }, i.prototype.addn = function (e) {
        return this.clone().iaddn(e);
      }, i.prototype.subn = function (e) {
        return this.clone().isubn(e);
      }, i.prototype.iabs = function () {
        return this.negative = 0, this;
      }, i.prototype.abs = function () {
        return this.clone().iabs();
      }, i.prototype._ishlnsubmul = function (e, t, r) {
        var i,
          o,
          a = e.length + r;
        this._expand(a);
        var s = 0;
        for (i = 0; i < e.length; i++) {
          o = (0 | this.words[i + r]) + s;
          var u = (0 | e.words[i]) * t;
          s = ((o -= 67108863 & u) >> 26) - (u / 67108864 | 0), this.words[i + r] = 67108863 & o;
        }
        for (; i < this.length - r; i++) s = (o = (0 | this.words[i + r]) + s) >> 26, this.words[i + r] = 67108863 & o;
        if (0 === s) return this._strip();
        for (n(-1 === s), s = 0, i = 0; i < this.length; i++) s = (o = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & o;
        return this.negative = 1, this._strip();
      }, i.prototype._wordDiv = function (e, t) {
        var n = (this.length, e.length),
          r = this.clone(),
          o = e,
          a = 0 | o.words[o.length - 1];
        0 !== (n = 26 - this._countBits(a)) && (o = o.ushln(n), r.iushln(n), a = 0 | o.words[o.length - 1]);
        var s,
          u = r.length - o.length;
        if ("mod" !== t) {
          (s = new i(null)).length = u + 1, s.words = new Array(s.length);
          for (var c = 0; c < s.length; c++) s.words[c] = 0;
        }
        var l = r.clone()._ishlnsubmul(o, 1, u);
        0 === l.negative && (r = l, s && (s.words[u] = 1));
        for (var d = u - 1; d >= 0; d--) {
          var f = 67108864 * (0 | r.words[o.length + d]) + (0 | r.words[o.length + d - 1]);
          for (f = Math.min(f / a | 0, 67108863), r._ishlnsubmul(o, f, d); 0 !== r.negative;) f--, r.negative = 0, r._ishlnsubmul(o, 1, d), r.isZero() || (r.negative ^= 1);
          s && (s.words[d] = f);
        }
        return s && s._strip(), r._strip(), "div" !== t && 0 !== n && r.iushrn(n), {
          div: s || null,
          mod: r
        };
      }, i.prototype.divmod = function (e, t, r) {
        return n(!e.isZero()), this.isZero() ? {
          div: new i(0),
          mod: new i(0)
        } : 0 !== this.negative && 0 === e.negative ? (s = this.neg().divmod(e, t), "mod" !== t && (o = s.div.neg()), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.iadd(e)), {
          div: o,
          mod: a
        }) : 0 === this.negative && 0 !== e.negative ? (s = this.divmod(e.neg(), t), "mod" !== t && (o = s.div.neg()), {
          div: o,
          mod: s.mod
        }) : 0 != (this.negative & e.negative) ? (s = this.neg().divmod(e.neg(), t), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.isub(e)), {
          div: s.div,
          mod: a
        }) : e.length > this.length || this.cmp(e) < 0 ? {
          div: new i(0),
          mod: this
        } : 1 === e.length ? "div" === t ? {
          div: this.divn(e.words[0]),
          mod: null
        } : "mod" === t ? {
          div: null,
          mod: new i(this.modrn(e.words[0]))
        } : {
          div: this.divn(e.words[0]),
          mod: new i(this.modrn(e.words[0]))
        } : this._wordDiv(e, t);
        var o, a, s;
      }, i.prototype.div = function (e) {
        return this.divmod(e, "div", !1).div;
      }, i.prototype.mod = function (e) {
        return this.divmod(e, "mod", !1).mod;
      }, i.prototype.umod = function (e) {
        return this.divmod(e, "mod", !0).mod;
      }, i.prototype.divRound = function (e) {
        var t = this.divmod(e);
        if (t.mod.isZero()) return t.div;
        var n = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
          r = e.ushrn(1),
          i = e.andln(1),
          o = n.cmp(r);
        return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
      }, i.prototype.modrn = function (e) {
        var t = e < 0;
        t && (e = -e), n(e <= 67108863);
        for (var r = (1 << 26) % e, i = 0, o = this.length - 1; o >= 0; o--) i = (r * i + (0 | this.words[o])) % e;
        return t ? -i : i;
      }, i.prototype.modn = function (e) {
        return this.modrn(e);
      }, i.prototype.idivn = function (e) {
        var t = e < 0;
        t && (e = -e), n(e <= 67108863);
        for (var r = 0, i = this.length - 1; i >= 0; i--) {
          var o = (0 | this.words[i]) + 67108864 * r;
          this.words[i] = o / e | 0, r = o % e;
        }
        return this._strip(), t ? this.ineg() : this;
      }, i.prototype.divn = function (e) {
        return this.clone().idivn(e);
      }, i.prototype.egcd = function (e) {
        n(0 === e.negative), n(!e.isZero());
        var t = this,
          r = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();
        for (var o = new i(1), a = new i(0), s = new i(0), u = new i(1), c = 0; t.isEven() && r.isEven();) t.iushrn(1), r.iushrn(1), ++c;
        for (var l = r.clone(), d = t.clone(); !t.isZero();) {
          for (var f = 0, h = 1; 0 == (t.words[0] & h) && f < 26; ++f, h <<= 1);
          if (f > 0) for (t.iushrn(f); f-- > 0;) (o.isOdd() || a.isOdd()) && (o.iadd(l), a.isub(d)), o.iushrn(1), a.iushrn(1);
          for (var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
          if (p > 0) for (r.iushrn(p); p-- > 0;) (s.isOdd() || u.isOdd()) && (s.iadd(l), u.isub(d)), s.iushrn(1), u.iushrn(1);
          t.cmp(r) >= 0 ? (t.isub(r), o.isub(s), a.isub(u)) : (r.isub(t), s.isub(o), u.isub(a));
        }
        return {
          a: s,
          b: u,
          gcd: r.iushln(c)
        };
      }, i.prototype._invmp = function (e) {
        n(0 === e.negative), n(!e.isZero());
        var t = this,
          r = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();
        for (var o, a = new i(1), s = new i(0), u = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;) {
          for (var c = 0, l = 1; 0 == (t.words[0] & l) && c < 26; ++c, l <<= 1);
          if (c > 0) for (t.iushrn(c); c-- > 0;) a.isOdd() && a.iadd(u), a.iushrn(1);
          for (var d = 0, f = 1; 0 == (r.words[0] & f) && d < 26; ++d, f <<= 1);
          if (d > 0) for (r.iushrn(d); d-- > 0;) s.isOdd() && s.iadd(u), s.iushrn(1);
          t.cmp(r) >= 0 ? (t.isub(r), a.isub(s)) : (r.isub(t), s.isub(a));
        }
        return (o = 0 === t.cmpn(1) ? a : s).cmpn(0) < 0 && o.iadd(e), o;
      }, i.prototype.gcd = function (e) {
        if (this.isZero()) return e.abs();
        if (e.isZero()) return this.abs();
        var t = this.clone(),
          n = e.clone();
        t.negative = 0, n.negative = 0;
        for (var r = 0; t.isEven() && n.isEven(); r++) t.iushrn(1), n.iushrn(1);
        for (;;) {
          for (; t.isEven();) t.iushrn(1);
          for (; n.isEven();) n.iushrn(1);
          var i = t.cmp(n);
          if (i < 0) {
            var o = t;
            t = n, n = o;
          } else if (0 === i || 0 === n.cmpn(1)) break;
          t.isub(n);
        }
        return n.iushln(r);
      }, i.prototype.invm = function (e) {
        return this.egcd(e).a.umod(e);
      }, i.prototype.isEven = function () {
        return 0 == (1 & this.words[0]);
      }, i.prototype.isOdd = function () {
        return 1 == (1 & this.words[0]);
      }, i.prototype.andln = function (e) {
        return this.words[0] & e;
      }, i.prototype.bincn = function (e) {
        n("number" == typeof e);
        var t = e % 26,
          r = (e - t) / 26,
          i = 1 << t;
        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
        for (var o = i, a = r; 0 !== o && a < this.length; a++) {
          var s = 0 | this.words[a];
          o = (s += o) >>> 26, s &= 67108863, this.words[a] = s;
        }
        return 0 !== o && (this.words[a] = o, this.length++), this;
      }, i.prototype.isZero = function () {
        return 1 === this.length && 0 === this.words[0];
      }, i.prototype.cmpn = function (e) {
        var t,
          r = e < 0;
        if (0 !== this.negative && !r) return -1;
        if (0 === this.negative && r) return 1;
        if (this._strip(), this.length > 1) t = 1;else {
          r && (e = -e), n(e <= 67108863, "Number is too big");
          var i = 0 | this.words[0];
          t = i === e ? 0 : i < e ? -1 : 1;
        }
        return 0 !== this.negative ? 0 | -t : t;
      }, i.prototype.cmp = function (e) {
        if (0 !== this.negative && 0 === e.negative) return -1;
        if (0 === this.negative && 0 !== e.negative) return 1;
        var t = this.ucmp(e);
        return 0 !== this.negative ? 0 | -t : t;
      }, i.prototype.ucmp = function (e) {
        if (this.length > e.length) return 1;
        if (this.length < e.length) return -1;
        for (var t = 0, n = this.length - 1; n >= 0; n--) {
          var r = 0 | this.words[n],
            i = 0 | e.words[n];
          if (r !== i) {
            r < i ? t = -1 : r > i && (t = 1);
            break;
          }
        }
        return t;
      }, i.prototype.gtn = function (e) {
        return 1 === this.cmpn(e);
      }, i.prototype.gt = function (e) {
        return 1 === this.cmp(e);
      }, i.prototype.gten = function (e) {
        return this.cmpn(e) >= 0;
      }, i.prototype.gte = function (e) {
        return this.cmp(e) >= 0;
      }, i.prototype.ltn = function (e) {
        return -1 === this.cmpn(e);
      }, i.prototype.lt = function (e) {
        return -1 === this.cmp(e);
      }, i.prototype.lten = function (e) {
        return this.cmpn(e) <= 0;
      }, i.prototype.lte = function (e) {
        return this.cmp(e) <= 0;
      }, i.prototype.eqn = function (e) {
        return 0 === this.cmpn(e);
      }, i.prototype.eq = function (e) {
        return 0 === this.cmp(e);
      }, i.red = function (e) {
        return new S(e);
      }, i.prototype.toRed = function (e) {
        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
      }, i.prototype.fromRed = function () {
        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, i.prototype._forceRed = function (e) {
        return this.red = e, this;
      }, i.prototype.forceRed = function (e) {
        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
      }, i.prototype.redAdd = function (e) {
        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
      }, i.prototype.redIAdd = function (e) {
        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
      }, i.prototype.redSub = function (e) {
        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
      }, i.prototype.redISub = function (e) {
        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
      }, i.prototype.redShl = function (e) {
        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
      }, i.prototype.redMul = function (e) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
      }, i.prototype.redIMul = function (e) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
      }, i.prototype.redSqr = function () {
        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, i.prototype.redISqr = function () {
        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, i.prototype.redSqrt = function () {
        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, i.prototype.redInvm = function () {
        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, i.prototype.redNeg = function () {
        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, i.prototype.redPow = function (e) {
        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
      };
      var b = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function y(e, t) {
        this.name = e, this.p = new i(t, 16), this.n = this.p.bitLength(), this.k = new i(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      function w() {
        y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
      }
      function A() {
        y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
      }
      function _() {
        y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
      }
      function E() {
        y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
      }
      function S(e) {
        if ("string" == typeof e) {
          var t = i._prime(e);
          this.m = t.p, this.prime = t;
        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
      }
      function k(e) {
        S.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new i(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      y.prototype._tmp = function () {
        var e = new i(null);
        return e.words = new Array(Math.ceil(this.n / 13)), e;
      }, y.prototype.ireduce = function (e) {
        var t,
          n = e;
        do {
          this.split(n, this.tmp), t = (n = (n = this.imulK(n)).iadd(this.tmp)).bitLength();
        } while (t > this.n);
        var r = t < this.n ? -1 : n.ucmp(this.p);
        return 0 === r ? (n.words[0] = 0, n.length = 1) : r > 0 ? n.isub(this.p) : void 0 !== n.strip ? n.strip() : n._strip(), n;
      }, y.prototype.split = function (e, t) {
        e.iushrn(this.n, 0, t);
      }, y.prototype.imulK = function (e) {
        return e.imul(this.k);
      }, r(w, y), w.prototype.split = function (e, t) {
        for (var n = 4194303, r = Math.min(e.length, 9), i = 0; i < r; i++) t.words[i] = e.words[i];
        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
        var o = e.words[9];
        for (t.words[t.length++] = o & n, i = 10; i < e.length; i++) {
          var a = 0 | e.words[i];
          e.words[i - 10] = (a & n) << 4 | o >>> 22, o = a;
        }
        o >>>= 22, e.words[i - 10] = o, 0 === o && e.length > 10 ? e.length -= 10 : e.length -= 9;
      }, w.prototype.imulK = function (e) {
        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
        for (var t = 0, n = 0; n < e.length; n++) {
          var r = 0 | e.words[n];
          t += 977 * r, e.words[n] = 67108863 & t, t = 64 * r + (t / 67108864 | 0);
        }
        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
      }, r(A, y), r(_, y), r(E, y), E.prototype.imulK = function (e) {
        for (var t = 0, n = 0; n < e.length; n++) {
          var r = 19 * (0 | e.words[n]) + t,
            i = 67108863 & r;
          r >>>= 26, e.words[n] = i, t = r;
        }
        return 0 !== t && (e.words[e.length++] = t), e;
      }, i._prime = function (e) {
        if (b[e]) return b[e];
        var t;
        if ("k256" === e) t = new w();else if ("p224" === e) t = new A();else if ("p192" === e) t = new _();else {
          if ("p25519" !== e) throw new Error("Unknown prime " + e);
          t = new E();
        }
        return b[e] = t, t;
      }, S.prototype._verify1 = function (e) {
        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
      }, S.prototype._verify2 = function (e, t) {
        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
      }, S.prototype.imod = function (e) {
        return this.prime ? this.prime.ireduce(e)._forceRed(this) : (c(e, e.umod(this.m)._forceRed(this)), e);
      }, S.prototype.neg = function (e) {
        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
      }, S.prototype.add = function (e, t) {
        this._verify2(e, t);
        var n = e.add(t);
        return n.cmp(this.m) >= 0 && n.isub(this.m), n._forceRed(this);
      }, S.prototype.iadd = function (e, t) {
        this._verify2(e, t);
        var n = e.iadd(t);
        return n.cmp(this.m) >= 0 && n.isub(this.m), n;
      }, S.prototype.sub = function (e, t) {
        this._verify2(e, t);
        var n = e.sub(t);
        return n.cmpn(0) < 0 && n.iadd(this.m), n._forceRed(this);
      }, S.prototype.isub = function (e, t) {
        this._verify2(e, t);
        var n = e.isub(t);
        return n.cmpn(0) < 0 && n.iadd(this.m), n;
      }, S.prototype.shl = function (e, t) {
        return this._verify1(e), this.imod(e.ushln(t));
      }, S.prototype.imul = function (e, t) {
        return this._verify2(e, t), this.imod(e.imul(t));
      }, S.prototype.mul = function (e, t) {
        return this._verify2(e, t), this.imod(e.mul(t));
      }, S.prototype.isqr = function (e) {
        return this.imul(e, e.clone());
      }, S.prototype.sqr = function (e) {
        return this.mul(e, e);
      }, S.prototype.sqrt = function (e) {
        if (e.isZero()) return e.clone();
        var t = this.m.andln(3);
        if (n(t % 2 == 1), 3 === t) {
          var r = this.m.add(new i(1)).iushrn(2);
          return this.pow(e, r);
        }
        for (var o = this.m.subn(1), a = 0; !o.isZero() && 0 === o.andln(1);) a++, o.iushrn(1);
        n(!o.isZero());
        var s = new i(1).toRed(this),
          u = s.redNeg(),
          c = this.m.subn(1).iushrn(1),
          l = this.m.bitLength();
        for (l = new i(2 * l * l).toRed(this); 0 !== this.pow(l, c).cmp(u);) l.redIAdd(u);
        for (var d = this.pow(l, o), f = this.pow(e, o.addn(1).iushrn(1)), h = this.pow(e, o), p = a; 0 !== h.cmp(s);) {
          for (var m = h, g = 0; 0 !== m.cmp(s); g++) m = m.redSqr();
          n(g < p);
          var v = this.pow(d, new i(1).iushln(p - g - 1));
          f = f.redMul(v), d = v.redSqr(), h = h.redMul(d), p = g;
        }
        return f;
      }, S.prototype.invm = function (e) {
        var t = e._invmp(this.m);
        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
      }, S.prototype.pow = function (e, t) {
        if (t.isZero()) return new i(1).toRed(this);
        if (0 === t.cmpn(1)) return e.clone();
        var n = new Array(16);
        n[0] = new i(1).toRed(this), n[1] = e;
        for (var r = 2; r < n.length; r++) n[r] = this.mul(n[r - 1], e);
        var o = n[0],
          a = 0,
          s = 0,
          u = t.bitLength() % 26;
        for (0 === u && (u = 26), r = t.length - 1; r >= 0; r--) {
          for (var c = t.words[r], l = u - 1; l >= 0; l--) {
            var d = c >> l & 1;
            o !== n[0] && (o = this.sqr(o)), 0 !== d || 0 !== a ? (a <<= 1, a |= d, (4 === ++s || 0 === r && 0 === l) && (o = this.mul(o, n[a]), s = 0, a = 0)) : s = 0;
          }
          u = 26;
        }
        return o;
      }, S.prototype.convertTo = function (e) {
        var t = e.umod(this.m);
        return t === e ? t.clone() : t;
      }, S.prototype.convertFrom = function (e) {
        var t = e.clone();
        return t.red = null, t;
      }, i.mont = function (e) {
        return new k(e);
      }, r(k, S), k.prototype.convertTo = function (e) {
        return this.imod(e.ushln(this.shift));
      }, k.prototype.convertFrom = function (e) {
        var t = this.imod(e.mul(this.rinv));
        return t.red = null, t;
      }, k.prototype.imul = function (e, t) {
        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
        var n = e.imul(t),
          r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          i = n.isub(r).iushrn(this.shift),
          o = i;
        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
      }, k.prototype.mul = function (e, t) {
        if (e.isZero() || t.isZero()) return new i(0)._forceRed(this);
        var n = e.mul(t),
          r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          o = n.isub(r).iushrn(this.shift),
          a = o;
        return o.cmp(this.m) >= 0 ? a = o.isub(this.m) : o.cmpn(0) < 0 && (a = o.iadd(this.m)), a._forceRed(this);
      }, k.prototype.invm = function (e) {
        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
      };
    }(e, n);
  }(th);
  var nh,
    rh = th.exports,
    ih = {},
    oh = {},
    ah = {},
    sh = {},
    uh = le,
    ch = uh.Buffer,
    lh = {};
  for (nh in uh) uh.hasOwnProperty(nh) && "SlowBuffer" !== nh && "Buffer" !== nh && (lh[nh] = uh[nh]);
  var dh = lh.Buffer = {};
  for (nh in ch) ch.hasOwnProperty(nh) && "allocUnsafe" !== nh && "allocUnsafeSlow" !== nh && (dh[nh] = ch[nh]);
  if (lh.Buffer.prototype = ch.prototype, dh.from && dh.from !== Uint8Array.from || (dh.from = function (e, t, n) {
    if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof e);
    if (e && void 0 === e.length) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
    return ch(e, t, n);
  }), dh.alloc || (dh.alloc = function (e, t, n) {
    if ("number" != typeof e) throw new TypeError('The "size" argument must be of type number. Received type ' + typeof e);
    if (e < 0 || e >= 2 * (1 << 30)) throw new RangeError('The value "' + e + '" is invalid for option "size"');
    var r = ch(e);
    return t && 0 !== t.length ? "string" == typeof n ? r.fill(t, n) : r.fill(t) : r.fill(0), r;
  }), !lh.kStringMaxLength) try {
    lh.kStringMaxLength = Be.binding("buffer").kStringMaxLength;
  } catch (a) {}
  lh.constants || (lh.constants = {
    MAX_LENGTH: lh.kMaxLength
  }, lh.kStringMaxLength && (lh.constants.MAX_STRING_LENGTH = lh.kStringMaxLength));
  var fh = lh,
    hh = {};
  const ph = We;
  function mh(e) {
    this._reporterState = {
      obj: null,
      path: [],
      options: e || {},
      errors: []
    };
  }
  function gh(e, t) {
    this.path = e, this.rethrow(t);
  }
  hh.Reporter = mh, mh.prototype.isError = function (e) {
    return e instanceof gh;
  }, mh.prototype.save = function () {
    const e = this._reporterState;
    return {
      obj: e.obj,
      pathLen: e.path.length
    };
  }, mh.prototype.restore = function (e) {
    const t = this._reporterState;
    t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
  }, mh.prototype.enterKey = function (e) {
    return this._reporterState.path.push(e);
  }, mh.prototype.exitKey = function (e) {
    const t = this._reporterState;
    t.path = t.path.slice(0, e - 1);
  }, mh.prototype.leaveKey = function (e, t, n) {
    const r = this._reporterState;
    this.exitKey(e), null !== r.obj && (r.obj[t] = n);
  }, mh.prototype.path = function () {
    return this._reporterState.path.join("/");
  }, mh.prototype.enterObject = function () {
    const e = this._reporterState,
      t = e.obj;
    return e.obj = {}, t;
  }, mh.prototype.leaveObject = function (e) {
    const t = this._reporterState,
      n = t.obj;
    return t.obj = e, n;
  }, mh.prototype.error = function (e) {
    let t;
    const n = this._reporterState,
      r = e instanceof gh;
    if (t = r ? e : new gh(n.path.map(function (e) {
      return "[" + JSON.stringify(e) + "]";
    }).join(""), e.message || e, e.stack), !n.options.partial) throw t;
    return r || n.errors.push(t), t;
  }, mh.prototype.wrapResult = function (e) {
    const t = this._reporterState;
    return t.options.partial ? {
      result: this.isError(e) ? null : e,
      errors: t.errors
    } : e;
  }, ph(gh, Error), gh.prototype.rethrow = function (e) {
    if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, gh), !this.stack) try {
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
    return this;
  };
  var vh = {};
  const bh = We,
    yh = hh.Reporter,
    wh = fh.Buffer;
  function Ah(e, t) {
    yh.call(this, t), wh.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
  }
  function _h(e, t) {
    if (Array.isArray(e)) this.length = 0, this.value = e.map(function (e) {
      return _h.isEncoderBuffer(e) || (e = new _h(e, t)), this.length += e.length, e;
    }, this);else if ("number" == typeof e) {
      if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
      this.value = e, this.length = 1;
    } else if ("string" == typeof e) this.value = e, this.length = wh.byteLength(e);else {
      if (!wh.isBuffer(e)) return t.error("Unsupported type: " + typeof e);
      this.value = e, this.length = e.length;
    }
  }
  bh(Ah, yh), vh.DecoderBuffer = Ah, Ah.isDecoderBuffer = function (e) {
    if (e instanceof Ah) return !0;
    return "object" == typeof e && wh.isBuffer(e.base) && "DecoderBuffer" === e.constructor.name && "number" == typeof e.offset && "number" == typeof e.length && "function" == typeof e.save && "function" == typeof e.restore && "function" == typeof e.isEmpty && "function" == typeof e.readUInt8 && "function" == typeof e.skip && "function" == typeof e.raw;
  }, Ah.prototype.save = function () {
    return {
      offset: this.offset,
      reporter: yh.prototype.save.call(this)
    };
  }, Ah.prototype.restore = function (e) {
    const t = new Ah(this.base);
    return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, yh.prototype.restore.call(this, e.reporter), t;
  }, Ah.prototype.isEmpty = function () {
    return this.offset === this.length;
  }, Ah.prototype.readUInt8 = function (e) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
  }, Ah.prototype.skip = function (e, t) {
    if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
    const n = new Ah(this.base);
    return n._reporterState = this._reporterState, n.offset = this.offset, n.length = this.offset + e, this.offset += e, n;
  }, Ah.prototype.raw = function (e) {
    return this.base.slice(e ? e.offset : this.offset, this.length);
  }, vh.EncoderBuffer = _h, _h.isEncoderBuffer = function (e) {
    if (e instanceof _h) return !0;
    return "object" == typeof e && "EncoderBuffer" === e.constructor.name && "number" == typeof e.length && "function" == typeof e.join;
  }, _h.prototype.join = function (e, t) {
    return e || (e = wh.alloc(this.length)), t || (t = 0), 0 === this.length || (Array.isArray(this.value) ? this.value.forEach(function (n) {
      n.join(e, t), t += n.length;
    }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : wh.isBuffer(this.value) && this.value.copy(e, t), t += this.length)), e;
  };
  const Eh = hh.Reporter,
    Sh = vh.EncoderBuffer,
    kh = vh.DecoderBuffer,
    Mh = Va,
    Ch = ["seq", "seqof", "set", "setof", "objid", "bool", "gentime", "utctime", "null_", "enum", "int", "objDesc", "bitstr", "bmpstr", "charstr", "genstr", "graphstr", "ia5str", "iso646str", "numstr", "octstr", "printstr", "t61str", "unistr", "utf8str", "videostr"],
    xh = ["key", "obj", "use", "optional", "explicit", "implicit", "def", "choice", "any", "contains"].concat(Ch);
  function Rh(e, t, n) {
    const r = {};
    this._baseState = r, r.name = n, r.enc = e, r.parent = t || null, r.children = null, r.tag = null, r.args = null, r.reverseArgs = null, r.choice = null, r.optional = !1, r.any = !1, r.obj = !1, r.use = null, r.useDecoder = null, r.key = null, r.default = null, r.explicit = null, r.implicit = null, r.contains = null, r.parent || (r.children = [], this._wrap());
  }
  var Ih = Rh;
  const Th = ["enc", "parent", "children", "tag", "args", "reverseArgs", "choice", "optional", "any", "obj", "use", "alteredUse", "key", "default", "explicit", "implicit", "contains"];
  Rh.prototype.clone = function () {
    const e = this._baseState,
      t = {};
    Th.forEach(function (n) {
      t[n] = e[n];
    });
    const n = new this.constructor(t.parent);
    return n._baseState = t, n;
  }, Rh.prototype._wrap = function () {
    const e = this._baseState;
    xh.forEach(function (t) {
      this[t] = function () {
        const n = new this.constructor(this);
        return e.children.push(n), n[t].apply(n, arguments);
      };
    }, this);
  }, Rh.prototype._init = function (e) {
    const t = this._baseState;
    Mh(null === t.parent), e.call(this), t.children = t.children.filter(function (e) {
      return e._baseState.parent === this;
    }, this), Mh.equal(t.children.length, 1, "Root node can have only one child");
  }, Rh.prototype._useArgs = function (e) {
    const t = this._baseState,
      n = e.filter(function (e) {
        return e instanceof this.constructor;
      }, this);
    e = e.filter(function (e) {
      return !(e instanceof this.constructor);
    }, this), 0 !== n.length && (Mh(null === t.children), t.children = n, n.forEach(function (e) {
      e._baseState.parent = this;
    }, this)), 0 !== e.length && (Mh(null === t.args), t.args = e, t.reverseArgs = e.map(function (e) {
      if ("object" != typeof e || e.constructor !== Object) return e;
      const t = {};
      return Object.keys(e).forEach(function (n) {
        n == (0 | n) && (n |= 0);
        const r = e[n];
        t[r] = n;
      }), t;
    }));
  }, ["_peekTag", "_decodeTag", "_use", "_decodeStr", "_decodeObjid", "_decodeTime", "_decodeNull", "_decodeInt", "_decodeBool", "_decodeList", "_encodeComposite", "_encodeStr", "_encodeObjid", "_encodeTime", "_encodeNull", "_encodeInt", "_encodeBool"].forEach(function (e) {
    Rh.prototype[e] = function () {
      const t = this._baseState;
      throw new Error(e + " not implemented for encoding: " + t.enc);
    };
  }), Ch.forEach(function (e) {
    Rh.prototype[e] = function () {
      const t = this._baseState,
        n = Array.prototype.slice.call(arguments);
      return Mh(null === t.tag), t.tag = e, this._useArgs(n), this;
    };
  }), Rh.prototype.use = function (e) {
    Mh(e);
    const t = this._baseState;
    return Mh(null === t.use), t.use = e, this;
  }, Rh.prototype.optional = function () {
    return this._baseState.optional = !0, this;
  }, Rh.prototype.def = function (e) {
    const t = this._baseState;
    return Mh(null === t.default), t.default = e, t.optional = !0, this;
  }, Rh.prototype.explicit = function (e) {
    const t = this._baseState;
    return Mh(null === t.explicit && null === t.implicit), t.explicit = e, this;
  }, Rh.prototype.implicit = function (e) {
    const t = this._baseState;
    return Mh(null === t.explicit && null === t.implicit), t.implicit = e, this;
  }, Rh.prototype.obj = function () {
    const e = this._baseState,
      t = Array.prototype.slice.call(arguments);
    return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
  }, Rh.prototype.key = function (e) {
    const t = this._baseState;
    return Mh(null === t.key), t.key = e, this;
  }, Rh.prototype.any = function () {
    return this._baseState.any = !0, this;
  }, Rh.prototype.choice = function (e) {
    const t = this._baseState;
    return Mh(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function (t) {
      return e[t];
    })), this;
  }, Rh.prototype.contains = function (e) {
    const t = this._baseState;
    return Mh(null === t.use), t.contains = e, this;
  }, Rh.prototype._decode = function (e, t) {
    const n = this._baseState;
    if (null === n.parent) return e.wrapResult(n.children[0]._decode(e, t));
    let r,
      i = n.default,
      o = !0,
      a = null;
    if (null !== n.key && (a = e.enterKey(n.key)), n.optional) {
      let r = null;
      if (null !== n.explicit ? r = n.explicit : null !== n.implicit ? r = n.implicit : null !== n.tag && (r = n.tag), null !== r || n.any) {
        if (o = this._peekTag(e, r, n.any), e.isError(o)) return o;
      } else {
        const r = e.save();
        try {
          null === n.choice ? this._decodeGeneric(n.tag, e, t) : this._decodeChoice(e, t), o = !0;
        } catch (e) {
          o = !1;
        }
        e.restore(r);
      }
    }
    if (n.obj && o && (r = e.enterObject()), o) {
      if (null !== n.explicit) {
        const t = this._decodeTag(e, n.explicit);
        if (e.isError(t)) return t;
        e = t;
      }
      const r = e.offset;
      if (null === n.use && null === n.choice) {
        let t;
        n.any && (t = e.save());
        const r = this._decodeTag(e, null !== n.implicit ? n.implicit : n.tag, n.any);
        if (e.isError(r)) return r;
        n.any ? i = e.raw(t) : e = r;
      }
      if (t && t.track && null !== n.tag && t.track(e.path(), r, e.length, "tagged"), t && t.track && null !== n.tag && t.track(e.path(), e.offset, e.length, "content"), n.any || (i = null === n.choice ? this._decodeGeneric(n.tag, e, t) : this._decodeChoice(e, t)), e.isError(i)) return i;
      if (n.any || null !== n.choice || null === n.children || n.children.forEach(function (n) {
        n._decode(e, t);
      }), n.contains && ("octstr" === n.tag || "bitstr" === n.tag)) {
        const r = new kh(i);
        i = this._getUse(n.contains, e._reporterState.obj)._decode(r, t);
      }
    }
    return n.obj && o && (i = e.leaveObject(r)), null === n.key || null === i && !0 !== o ? null !== a && e.exitKey(a) : e.leaveKey(a, n.key, i), i;
  }, Rh.prototype._decodeGeneric = function (e, t, n) {
    const r = this._baseState;
    return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, r.args[0], n) : /str$/.test(e) ? this._decodeStr(t, e, n) : "objid" === e && r.args ? this._decodeObjid(t, r.args[0], r.args[1], n) : "objid" === e ? this._decodeObjid(t, null, null, n) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, n) : "null_" === e ? this._decodeNull(t, n) : "bool" === e ? this._decodeBool(t, n) : "objDesc" === e ? this._decodeStr(t, e, n) : "int" === e || "enum" === e ? this._decodeInt(t, r.args && r.args[0], n) : null !== r.use ? this._getUse(r.use, t._reporterState.obj)._decode(t, n) : t.error("unknown tag: " + e);
  }, Rh.prototype._getUse = function (e, t) {
    const n = this._baseState;
    return n.useDecoder = this._use(e, t), Mh(null === n.useDecoder._baseState.parent), n.useDecoder = n.useDecoder._baseState.children[0], n.implicit !== n.useDecoder._baseState.implicit && (n.useDecoder = n.useDecoder.clone(), n.useDecoder._baseState.implicit = n.implicit), n.useDecoder;
  }, Rh.prototype._decodeChoice = function (e, t) {
    const n = this._baseState;
    let r = null,
      i = !1;
    return Object.keys(n.choice).some(function (o) {
      const a = e.save(),
        s = n.choice[o];
      try {
        const n = s._decode(e, t);
        if (e.isError(n)) return !1;
        r = {
          type: o,
          value: n
        }, i = !0;
      } catch (t) {
        return e.restore(a), !1;
      }
      return !0;
    }, this), i ? r : e.error("Choice not matched");
  }, Rh.prototype._createEncoderBuffer = function (e) {
    return new Sh(e, this.reporter);
  }, Rh.prototype._encode = function (e, t, n) {
    const r = this._baseState;
    if (null !== r.default && r.default === e) return;
    const i = this._encodeValue(e, t, n);
    return void 0 === i || this._skipDefault(i, t, n) ? void 0 : i;
  }, Rh.prototype._encodeValue = function (e, t, n) {
    const r = this._baseState;
    if (null === r.parent) return r.children[0]._encode(e, t || new Eh());
    let i = null;
    if (this.reporter = t, r.optional && void 0 === e) {
      if (null === r.default) return;
      e = r.default;
    }
    let o = null,
      a = !1;
    if (r.any) i = this._createEncoderBuffer(e);else if (r.choice) i = this._encodeChoice(e, t);else if (r.contains) o = this._getUse(r.contains, n)._encode(e, t), a = !0;else if (r.children) o = r.children.map(function (n) {
      if ("null_" === n._baseState.tag) return n._encode(null, t, e);
      if (null === n._baseState.key) return t.error("Child should have a key");
      const r = t.enterKey(n._baseState.key);
      if ("object" != typeof e) return t.error("Child expected, but input is not object");
      const i = n._encode(e[n._baseState.key], t, e);
      return t.leaveKey(r), i;
    }, this).filter(function (e) {
      return e;
    }), o = this._createEncoderBuffer(o);else if ("seqof" === r.tag || "setof" === r.tag) {
      if (!r.args || 1 !== r.args.length) return t.error("Too many args for : " + r.tag);
      if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
      const n = this.clone();
      n._baseState.implicit = null, o = this._createEncoderBuffer(e.map(function (n) {
        const r = this._baseState;
        return this._getUse(r.args[0], e)._encode(n, t);
      }, n));
    } else null !== r.use ? i = this._getUse(r.use, n)._encode(e, t) : (o = this._encodePrimitive(r.tag, e), a = !0);
    if (!r.any && null === r.choice) {
      const e = null !== r.implicit ? r.implicit : r.tag,
        n = null === r.implicit ? "universal" : "context";
      null === e ? null === r.use && t.error("Tag could be omitted only for .use()") : null === r.use && (i = this._encodeComposite(e, a, n, o));
    }
    return null !== r.explicit && (i = this._encodeComposite(r.explicit, !1, "context", i)), i;
  }, Rh.prototype._encodeChoice = function (e, t) {
    const n = this._baseState,
      r = n.choice[e.type];
    return r || Mh(!1, e.type + " not found in " + JSON.stringify(Object.keys(n.choice))), r._encode(e.value, t);
  }, Rh.prototype._encodePrimitive = function (e, t) {
    const n = this._baseState;
    if (/str$/.test(e)) return this._encodeStr(t, e);
    if ("objid" === e && n.args) return this._encodeObjid(t, n.reverseArgs[0], n.args[1]);
    if ("objid" === e) return this._encodeObjid(t, null, null);
    if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
    if ("null_" === e) return this._encodeNull();
    if ("int" === e || "enum" === e) return this._encodeInt(t, n.args && n.reverseArgs[0]);
    if ("bool" === e) return this._encodeBool(t);
    if ("objDesc" === e) return this._encodeStr(t, e);
    throw new Error("Unsupported tag: " + e);
  }, Rh.prototype._isNumstr = function (e) {
    return /^[0-9 ]*$/.test(e);
  }, Rh.prototype._isPrintstr = function (e) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(e);
  };
  var Ph = {};
  !function (e) {
    function t(e) {
      const t = {};
      return Object.keys(e).forEach(function (n) {
        (0 | n) == n && (n |= 0);
        const r = e[n];
        t[r] = n;
      }), t;
    }
    e.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, e.tagClassByName = t(e.tagClass), e.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, e.tagByName = t(e.tag);
  }(Ph);
  const Oh = We,
    Lh = fh.Buffer,
    Nh = Ih,
    Dh = Ph;
  function Bh(e) {
    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new Fh(), this.tree._init(e.body);
  }
  var jh = Bh;
  function Fh(e) {
    Nh.call(this, "der", e);
  }
  function zh(e) {
    return e < 10 ? "0" + e : e;
  }
  Bh.prototype.encode = function (e, t) {
    return this.tree._encode(e, t).join();
  }, Oh(Fh, Nh), Fh.prototype._encodeComposite = function (e, t, n, r) {
    const i = function (e, t, n, r) {
      let i;
      "seqof" === e ? e = "seq" : "setof" === e && (e = "set");
      if (Dh.tagByName.hasOwnProperty(e)) i = Dh.tagByName[e];else {
        if ("number" != typeof e || (0 | e) !== e) return r.error("Unknown tag: " + e);
        i = e;
      }
      if (i >= 31) return r.error("Multi-octet tag encoding unsupported");
      t || (i |= 32);
      return i |= Dh.tagClassByName[n || "universal"] << 6, i;
    }(e, t, n, this.reporter);
    if (r.length < 128) {
      const e = Lh.alloc(2);
      return e[0] = i, e[1] = r.length, this._createEncoderBuffer([e, r]);
    }
    let o = 1;
    for (let e = r.length; e >= 256; e >>= 8) o++;
    const a = Lh.alloc(2 + o);
    a[0] = i, a[1] = 128 | o;
    for (let e = 1 + o, t = r.length; t > 0; e--, t >>= 8) a[e] = 255 & t;
    return this._createEncoderBuffer([a, r]);
  }, Fh.prototype._encodeStr = function (e, t) {
    if ("bitstr" === t) return this._createEncoderBuffer([0 | e.unused, e.data]);
    if ("bmpstr" === t) {
      const t = Lh.alloc(2 * e.length);
      for (let n = 0; n < e.length; n++) t.writeUInt16BE(e.charCodeAt(n), 2 * n);
      return this._createEncoderBuffer(t);
    }
    return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) || "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
  }, Fh.prototype._encodeObjid = function (e, t, n) {
    if ("string" == typeof e) {
      if (!t) return this.reporter.error("string objid given, but no values map found");
      if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
      e = t[e].split(/[\s.]+/g);
      for (let t = 0; t < e.length; t++) e[t] |= 0;
    } else if (Array.isArray(e)) {
      e = e.slice();
      for (let t = 0; t < e.length; t++) e[t] |= 0;
    }
    if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));
    if (!n) {
      if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
      e.splice(0, 2, 40 * e[0] + e[1]);
    }
    let r = 0;
    for (let t = 0; t < e.length; t++) {
      let n = e[t];
      for (r++; n >= 128; n >>= 7) r++;
    }
    const i = Lh.alloc(r);
    let o = i.length - 1;
    for (let t = e.length - 1; t >= 0; t--) {
      let n = e[t];
      for (i[o--] = 127 & n; (n >>= 7) > 0;) i[o--] = 128 | 127 & n;
    }
    return this._createEncoderBuffer(i);
  }, Fh.prototype._encodeTime = function (e, t) {
    let n;
    const r = new Date(e);
    return "gentime" === t ? n = [zh(r.getUTCFullYear()), zh(r.getUTCMonth() + 1), zh(r.getUTCDate()), zh(r.getUTCHours()), zh(r.getUTCMinutes()), zh(r.getUTCSeconds()), "Z"].join("") : "utctime" === t ? n = [zh(r.getUTCFullYear() % 100), zh(r.getUTCMonth() + 1), zh(r.getUTCDate()), zh(r.getUTCHours()), zh(r.getUTCMinutes()), zh(r.getUTCSeconds()), "Z"].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(n, "octstr");
  }, Fh.prototype._encodeNull = function () {
    return this._createEncoderBuffer("");
  }, Fh.prototype._encodeInt = function (e, t) {
    if ("string" == typeof e) {
      if (!t) return this.reporter.error("String int or enum given, but no values map");
      if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
      e = t[e];
    }
    if ("number" != typeof e && !Lh.isBuffer(e)) {
      const t = e.toArray();
      !e.sign && 128 & t[0] && t.unshift(0), e = Lh.from(t);
    }
    if (Lh.isBuffer(e)) {
      let t = e.length;
      0 === e.length && t++;
      const n = Lh.alloc(t);
      return e.copy(n), 0 === e.length && (n[0] = 0), this._createEncoderBuffer(n);
    }
    if (e < 128) return this._createEncoderBuffer(e);
    if (e < 256) return this._createEncoderBuffer([0, e]);
    let n = 1;
    for (let t = e; t >= 256; t >>= 8) n++;
    const r = new Array(n);
    for (let t = r.length - 1; t >= 0; t--) r[t] = 255 & e, e >>= 8;
    return 128 & r[0] && r.unshift(0), this._createEncoderBuffer(Lh.from(r));
  }, Fh.prototype._encodeBool = function (e) {
    return this._createEncoderBuffer(e ? 255 : 0);
  }, Fh.prototype._use = function (e, t) {
    return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
  }, Fh.prototype._skipDefault = function (e, t, n) {
    const r = this._baseState;
    let i;
    if (null === r.default) return !1;
    const o = e.join();
    if (void 0 === r.defaultBuffer && (r.defaultBuffer = this._encodeValue(r.default, t, n).join()), o.length !== r.defaultBuffer.length) return !1;
    for (i = 0; i < o.length; i++) if (o[i] !== r.defaultBuffer[i]) return !1;
    return !0;
  };
  const Uh = jh;
  function qh(e) {
    Uh.call(this, e), this.enc = "pem";
  }
  We(qh, Uh);
  var Kh = qh;
  qh.prototype.encode = function (e, t) {
    const n = Uh.prototype.encode.call(this, e).toString("base64"),
      r = ["-----BEGIN " + t.label + "-----"];
    for (let e = 0; e < n.length; e += 64) r.push(n.slice(e, e + 64));
    return r.push("-----END " + t.label + "-----"), r.join("\n");
  }, function (e) {
    const t = e;
    t.der = jh, t.pem = Kh;
  }(sh);
  var Hh = {};
  const Vh = We,
    $h = hc,
    Wh = vh.DecoderBuffer,
    Yh = Ih,
    Gh = Ph;
  function Qh(e) {
    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new Jh(), this.tree._init(e.body);
  }
  var Zh = Qh;
  function Jh(e) {
    Yh.call(this, "der", e);
  }
  function Xh(e, t) {
    let n = e.readUInt8(t);
    if (e.isError(n)) return n;
    const r = Gh.tagClass[n >> 6],
      i = 0 == (32 & n);
    if (31 == (31 & n)) {
      let r = n;
      for (n = 0; 128 == (128 & r);) {
        if (r = e.readUInt8(t), e.isError(r)) return r;
        n <<= 7, n |= 127 & r;
      }
    } else n &= 31;
    return {
      cls: r,
      primitive: i,
      tag: n,
      tagStr: Gh.tag[n]
    };
  }
  function ep(e, t, n) {
    let r = e.readUInt8(n);
    if (e.isError(r)) return r;
    if (!t && 128 === r) return null;
    if (0 == (128 & r)) return r;
    const i = 127 & r;
    if (i > 4) return e.error("length octect is too long");
    r = 0;
    for (let t = 0; t < i; t++) {
      r <<= 8;
      const t = e.readUInt8(n);
      if (e.isError(t)) return t;
      r |= t;
    }
    return r;
  }
  Qh.prototype.decode = function (e, t) {
    return Wh.isDecoderBuffer(e) || (e = new Wh(e, t)), this.tree._decode(e, t);
  }, Vh(Jh, Yh), Jh.prototype._peekTag = function (e, t, n) {
    if (e.isEmpty()) return !1;
    const r = e.save(),
      i = Xh(e, 'Failed to peek tag: "' + t + '"');
    return e.isError(i) ? i : (e.restore(r), i.tag === t || i.tagStr === t || i.tagStr + "of" === t || n);
  }, Jh.prototype._decodeTag = function (e, t, n) {
    const r = Xh(e, 'Failed to decode tag of "' + t + '"');
    if (e.isError(r)) return r;
    let i = ep(e, r.primitive, 'Failed to get length of "' + t + '"');
    if (e.isError(i)) return i;
    if (!n && r.tag !== t && r.tagStr !== t && r.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
    if (r.primitive || null !== i) return e.skip(i, 'Failed to match body of: "' + t + '"');
    const o = e.save(),
      a = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');
    return e.isError(a) ? a : (i = e.offset - o.offset, e.restore(o), e.skip(i, 'Failed to match body of: "' + t + '"'));
  }, Jh.prototype._skipUntilEnd = function (e, t) {
    for (;;) {
      const n = Xh(e, t);
      if (e.isError(n)) return n;
      const r = ep(e, n.primitive, t);
      if (e.isError(r)) return r;
      let i;
      if (i = n.primitive || null !== r ? e.skip(r) : this._skipUntilEnd(e, t), e.isError(i)) return i;
      if ("end" === n.tagStr) break;
    }
  }, Jh.prototype._decodeList = function (e, t, n, r) {
    const i = [];
    for (; !e.isEmpty();) {
      const t = this._peekTag(e, "end");
      if (e.isError(t)) return t;
      const o = n.decode(e, "der", r);
      if (e.isError(o) && t) break;
      i.push(o);
    }
    return i;
  }, Jh.prototype._decodeStr = function (e, t) {
    if ("bitstr" === t) {
      const t = e.readUInt8();
      return e.isError(t) ? t : {
        unused: t,
        data: e.raw()
      };
    }
    if ("bmpstr" === t) {
      const t = e.raw();
      if (t.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");
      let n = "";
      for (let e = 0; e < t.length / 2; e++) n += String.fromCharCode(t.readUInt16BE(2 * e));
      return n;
    }
    if ("numstr" === t) {
      const t = e.raw().toString("ascii");
      return this._isNumstr(t) ? t : e.error("Decoding of string type: numstr unsupported characters");
    }
    if ("octstr" === t) return e.raw();
    if ("objDesc" === t) return e.raw();
    if ("printstr" === t) {
      const t = e.raw().toString("ascii");
      return this._isPrintstr(t) ? t : e.error("Decoding of string type: printstr unsupported characters");
    }
    return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
  }, Jh.prototype._decodeObjid = function (e, t, n) {
    let r;
    const i = [];
    let o = 0,
      a = 0;
    for (; !e.isEmpty();) a = e.readUInt8(), o <<= 7, o |= 127 & a, 0 == (128 & a) && (i.push(o), o = 0);
    128 & a && i.push(o);
    const s = i[0] / 40 | 0,
      u = i[0] % 40;
    if (r = n ? i : [s, u].concat(i.slice(1)), t) {
      let e = t[r.join(" ")];
      void 0 === e && (e = t[r.join(".")]), void 0 !== e && (r = e);
    }
    return r;
  }, Jh.prototype._decodeTime = function (e, t) {
    const n = e.raw().toString();
    let r, i, o, a, s, u;
    if ("gentime" === t) r = 0 | n.slice(0, 4), i = 0 | n.slice(4, 6), o = 0 | n.slice(6, 8), a = 0 | n.slice(8, 10), s = 0 | n.slice(10, 12), u = 0 | n.slice(12, 14);else {
      if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
      r = 0 | n.slice(0, 2), i = 0 | n.slice(2, 4), o = 0 | n.slice(4, 6), a = 0 | n.slice(6, 8), s = 0 | n.slice(8, 10), u = 0 | n.slice(10, 12), r = r < 70 ? 2e3 + r : 1900 + r;
    }
    return Date.UTC(r, i - 1, o, a, s, u, 0);
  }, Jh.prototype._decodeNull = function () {
    return null;
  }, Jh.prototype._decodeBool = function (e) {
    const t = e.readUInt8();
    return e.isError(t) ? t : 0 !== t;
  }, Jh.prototype._decodeInt = function (e, t) {
    const n = e.raw();
    let r = new $h(n);
    return t && (r = t[r.toString(10)] || r), r;
  }, Jh.prototype._use = function (e, t) {
    return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
  };
  const tp = We,
    np = fh.Buffer,
    rp = Zh;
  function ip(e) {
    rp.call(this, e), this.enc = "pem";
  }
  tp(ip, rp);
  var op = ip;
  ip.prototype.decode = function (e, t) {
    const n = e.toString().split(/[\r\n]+/g),
      r = t.label.toUpperCase(),
      i = /^-----(BEGIN|END) ([^-]+)-----$/;
    let o = -1,
      a = -1;
    for (let e = 0; e < n.length; e++) {
      const t = n[e].match(i);
      if (null !== t && t[2] === r) {
        if (-1 !== o) {
          if ("END" !== t[1]) break;
          a = e;
          break;
        }
        if ("BEGIN" !== t[1]) break;
        o = e;
      }
    }
    if (-1 === o || -1 === a) throw new Error("PEM section not found for: " + r);
    const s = n.slice(o + 1, a).join("");
    s.replace(/[^a-z0-9+/=]+/gi, "");
    const u = np.from(s, "base64");
    return rp.prototype.decode.call(this, u, t);
  }, function (e) {
    const t = e;
    t.der = Zh, t.pem = op;
  }(Hh), function (e) {
    const t = sh,
      n = Hh,
      r = We;
    function i(e, t) {
      this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
    }
    e.define = function (e, t) {
      return new i(e, t);
    }, i.prototype._createNamed = function (e) {
      const t = this.name;
      function n(e) {
        this._initNamed(e, t);
      }
      return r(n, e), n.prototype._initNamed = function (t, n) {
        e.call(this, t, n);
      }, new n(this);
    }, i.prototype._getDecoder = function (e) {
      return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(n[e])), this.decoders[e];
    }, i.prototype.decode = function (e, t, n) {
      return this._getDecoder(t).decode(e, n);
    }, i.prototype._getEncoder = function (e) {
      return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(t[e])), this.encoders[e];
    }, i.prototype.encode = function (e, t, n) {
      return this._getEncoder(t).encode(e, n);
    };
  }(ah);
  var ap = {};
  !function (e) {
    const t = e;
    t.Reporter = hh.Reporter, t.DecoderBuffer = vh.DecoderBuffer, t.EncoderBuffer = vh.EncoderBuffer, t.Node = Ih;
  }(ap);
  var sp = {};
  !function (e) {
    const t = e;
    t._reverse = function (e) {
      const t = {};
      return Object.keys(e).forEach(function (n) {
        (0 | n) == n && (n |= 0);
        const r = e[n];
        t[r] = n;
      }), t;
    }, t.der = Ph;
  }(sp), function (e) {
    const t = e;
    t.bignum = hc, t.define = ah.define, t.base = ap, t.constants = sp, t.decoders = Hh, t.encoders = sh;
  }(oh);
  var up = oh,
    cp = up.define("Time", function () {
      this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
      });
    }),
    lp = up.define("AttributeTypeValue", function () {
      this.seq().obj(this.key("type").objid(), this.key("value").any());
    }),
    dp = up.define("AlgorithmIdentifier", function () {
      this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
    }),
    fp = up.define("SubjectPublicKeyInfo", function () {
      this.seq().obj(this.key("algorithm").use(dp), this.key("subjectPublicKey").bitstr());
    }),
    hp = up.define("RelativeDistinguishedName", function () {
      this.setof(lp);
    }),
    pp = up.define("RDNSequence", function () {
      this.seqof(hp);
    }),
    mp = up.define("Name", function () {
      this.choice({
        rdnSequence: this.use(pp)
      });
    }),
    gp = up.define("Validity", function () {
      this.seq().obj(this.key("notBefore").use(cp), this.key("notAfter").use(cp));
    }),
    vp = up.define("Extension", function () {
      this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
    }),
    bp = up.define("TBSCertificate", function () {
      this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use(dp), this.key("issuer").use(mp), this.key("validity").use(gp), this.key("subject").use(mp), this.key("subjectPublicKeyInfo").use(fp), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(vp).optional());
    }),
    yp = up.define("X509Certificate", function () {
      this.seq().obj(this.key("tbsCertificate").use(bp), this.key("signatureAlgorithm").use(dp), this.key("signatureValue").bitstr());
    }),
    wp = oh;
  ih.certificate = yp;
  var Ap = wp.define("RSAPrivateKey", function () {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
  });
  ih.RSAPrivateKey = Ap;
  var _p = wp.define("RSAPublicKey", function () {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
  });
  ih.RSAPublicKey = _p;
  var Ep = wp.define("SubjectPublicKeyInfo", function () {
    this.seq().obj(this.key("algorithm").use(Sp), this.key("subjectPublicKey").bitstr());
  });
  ih.PublicKey = Ep;
  var Sp = wp.define("AlgorithmIdentifier", function () {
      this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
    }),
    kp = wp.define("PrivateKeyInfo", function () {
      this.seq().obj(this.key("version").int(), this.key("algorithm").use(Sp), this.key("subjectPrivateKey").octstr());
    });
  ih.PrivateKey = kp;
  var Mp = wp.define("EncryptedPrivateKeyInfo", function () {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
  });
  ih.EncryptedPrivateKey = Mp;
  var Cp = wp.define("DSAPrivateKey", function () {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
  });
  ih.DSAPrivateKey = Cp, ih.DSAparam = wp.define("DSAparam", function () {
    this.int();
  });
  var xp = wp.define("ECPrivateKey", function () {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(Rp), this.key("publicKey").optional().explicit(1).bitstr());
  });
  ih.ECPrivateKey = xp;
  var Rp = wp.define("ECParameters", function () {
    this.choice({
      namedCurve: this.objid()
    });
  });
  ih.signature = wp.define("signature", function () {
    this.seq().obj(this.key("r").int(), this.key("s").int());
  });
  var Ip = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m,
    Tp = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m,
    Pp = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m,
    Op = Mu,
    Lp = As,
    Np = ze().Buffer,
    Dp = ih,
    Bp = {
      "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
      "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
      "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
      "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
      "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
      "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
      "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
      "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
      "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
      "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
      "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
      "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
    },
    jp = function (e, t) {
      var n,
        r = e.toString(),
        i = r.match(Ip);
      if (i) {
        var o = "aes" + i[1],
          a = Np.from(i[2], "hex"),
          s = Np.from(i[3].replace(/[\r\n]/g, ""), "base64"),
          u = Op(t, a.slice(0, 8), parseInt(i[1], 10)).key,
          c = [],
          l = Lp.createDecipheriv(o, u, a);
        c.push(l.update(s)), c.push(l.final()), n = Np.concat(c);
      } else {
        var d = r.match(Pp);
        n = Np.from(d[2].replace(/[\r\n]/g, ""), "base64");
      }
      return {
        tag: r.match(Tp)[1],
        data: n
      };
    },
    Fp = As,
    zp = la,
    Up = ze().Buffer,
    qp = Kp;
  function Kp(e) {
    var t;
    "object" != typeof e || Up.isBuffer(e) || (t = e.passphrase, e = e.key), "string" == typeof e && (e = Up.from(e));
    var n,
      r,
      i = jp(e, t),
      o = i.tag,
      a = i.data;
    switch (o) {
      case "CERTIFICATE":
        r = Dp.certificate.decode(a, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (r || (r = Dp.PublicKey.decode(a, "der")), n = r.algorithm.algorithm.join(".")) {
          case "1.2.840.113549.1.1.1":
            return Dp.RSAPublicKey.decode(r.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return r.subjectPrivateKey = r.subjectPublicKey, {
              type: "ec",
              data: r
            };
          case "1.2.840.10040.4.1":
            return r.algorithm.params.pub_key = Dp.DSAparam.decode(r.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: r.algorithm.params
            };
          default:
            throw new Error("unknown key id " + n);
        }
      case "ENCRYPTED PRIVATE KEY":
        a = function (e, t) {
          var n = e.algorithm.decrypt.kde.kdeparams.salt,
            r = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10),
            i = Bp[e.algorithm.decrypt.cipher.algo.join(".")],
            o = e.algorithm.decrypt.cipher.iv,
            a = e.subjectPrivateKey,
            s = parseInt(i.split("-")[1], 10) / 8,
            u = zp.pbkdf2Sync(t, n, r, s, "sha1"),
            c = Fp.createDecipheriv(i, u, o),
            l = [];
          return l.push(c.update(a)), l.push(c.final()), Up.concat(l);
        }(a = Dp.EncryptedPrivateKey.decode(a, "der"), t);
      case "PRIVATE KEY":
        switch (n = (r = Dp.PrivateKey.decode(a, "der")).algorithm.algorithm.join(".")) {
          case "1.2.840.113549.1.1.1":
            return Dp.RSAPrivateKey.decode(r.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: r.algorithm.curve,
              privateKey: Dp.ECPrivateKey.decode(r.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return r.algorithm.params.priv_key = Dp.DSAparam.decode(r.subjectPrivateKey, "der"), {
              type: "dsa",
              params: r.algorithm.params
            };
          default:
            throw new Error("unknown key id " + n);
        }
      case "RSA PUBLIC KEY":
        return Dp.RSAPublicKey.decode(a, "der");
      case "RSA PRIVATE KEY":
        return Dp.RSAPrivateKey.decode(a, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: Dp.DSAPrivateKey.decode(a, "der")
        };
      case "EC PRIVATE KEY":
        return {
          curve: (a = Dp.ECPrivateKey.decode(a, "der")).parameters.value,
          privateKey: a.privateKey
        };
      default:
        throw new Error("unknown key type " + o);
    }
  }
  Kp.signature = Dp.signature;
  var Hp,
    Vp,
    $p,
    Wp,
    Yp,
    Gp,
    Qp,
    Zp = {
      "1.3.132.0.10": "secp256k1",
      "1.3.132.0.33": "p224",
      "1.2.840.10045.3.1.1": "p192",
      "1.2.840.10045.3.1.7": "p256",
      "1.3.132.0.34": "p384",
      "1.3.132.0.35": "p521"
    };
  function Jp() {
    if (Hp) return Ec.exports;
    Hp = 1;
    var e = ze().Buffer,
      t = sa,
      n = Rc,
      r = eh().ec,
      i = rh,
      o = qp,
      a = Zp;
    function s(n, r, i, o) {
      if ((n = e.from(n.toArray())).length < r.byteLength()) {
        var a = e.alloc(r.byteLength() - n.length);
        n = e.concat([a, n]);
      }
      var s = i.length,
        c = function (t, n) {
          t = u(t, n), t = t.mod(n);
          var r = e.from(t.toArray());
          if (r.length < n.byteLength()) {
            var i = e.alloc(n.byteLength() - r.length);
            r = e.concat([i, r]);
          }
          return r;
        }(i, r),
        l = e.alloc(s);
      l.fill(1);
      var d = e.alloc(s);
      return d = t(o, d).update(l).update(e.from([0])).update(n).update(c).digest(), l = t(o, d).update(l).digest(), {
        k: d = t(o, d).update(l).update(e.from([1])).update(n).update(c).digest(),
        v: l = t(o, d).update(l).digest()
      };
    }
    function u(e, t) {
      var n = new i(e),
        r = (e.length << 3) - t.bitLength();
      return r > 0 && n.ishrn(r), n;
    }
    function c(n, r, i) {
      var o, a;
      do {
        for (o = e.alloc(0); 8 * o.length < n.bitLength();) r.v = t(i, r.k).update(r.v).digest(), o = e.concat([o, r.v]);
        a = u(o, n), r.k = t(i, r.k).update(r.v).update(e.from([0])).digest(), r.v = t(i, r.k).update(r.v).digest();
      } while (-1 !== a.cmp(n));
      return a;
    }
    function l(e, t, n, r) {
      return e.toRed(i.mont(n)).redPow(t).fromRed().mod(r);
    }
    return Ec.exports = function (t, d, f, h, p) {
      var m = o(d);
      if (m.curve) {
        if ("ecdsa" !== h && "ecdsa/rsa" !== h) throw new Error("wrong private key type");
        return function (t, n) {
          var i = a[n.curve.join(".")];
          if (!i) throw new Error("unknown curve " + n.curve.join("."));
          var o = new r(i),
            s = o.keyFromPrivate(n.privateKey),
            u = s.sign(t);
          return e.from(u.toDER());
        }(t, m);
      }
      if ("dsa" === m.type) {
        if ("dsa" !== h) throw new Error("wrong private key type");
        return function (t, n, r) {
          var o,
            a = n.params.priv_key,
            d = n.params.p,
            f = n.params.q,
            h = n.params.g,
            p = new i(0),
            m = u(t, f).mod(f),
            g = !1,
            v = s(a, f, t, r);
          for (; !1 === g;) p = l(h, o = c(f, v, r), d, f), 0 === (g = o.invm(f).imul(m.add(a.mul(p))).mod(f)).cmpn(0) && (g = !1, p = new i(0));
          return function (t, n) {
            t = t.toArray(), n = n.toArray(), 128 & t[0] && (t = [0].concat(t));
            128 & n[0] && (n = [0].concat(n));
            var r = t.length + n.length + 4,
              i = [48, r, 2, t.length];
            return i = i.concat(t, [2, n.length], n), e.from(i);
          }(p, g);
        }(t, m, f);
      }
      if ("rsa" !== h && "ecdsa/rsa" !== h) throw new Error("wrong private key type");
      t = e.concat([p, t]);
      for (var g = m.modulus.byteLength(), v = [0, 1]; t.length + v.length + 1 < g;) v.push(255);
      v.push(0);
      for (var b = -1; ++b < t.length;) v.push(t[b]);
      return n(v, m);
    }, Ec.exports.getKey = s, Ec.exports.makeKey = c, Ec.exports;
  }
  function Xp() {
    if ($p) return Vp;
    $p = 1;
    var e = ze().Buffer,
      t = rh,
      n = eh().ec,
      r = qp,
      i = Zp;
    function o(e, t) {
      if (e.cmpn(0) <= 0) throw new Error("invalid sig");
      if (e.cmp(t) >= t) throw new Error("invalid sig");
    }
    return Vp = function (a, s, u, c, l) {
      var d = r(u);
      if ("ec" === d.type) {
        if ("ecdsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
        return function (e, t, r) {
          var o = i[r.data.algorithm.curve.join(".")];
          if (!o) throw new Error("unknown curve " + r.data.algorithm.curve.join("."));
          var a = new n(o),
            s = r.data.subjectPrivateKey.data;
          return a.verify(t, e, s);
        }(a, s, d);
      }
      if ("dsa" === d.type) {
        if ("dsa" !== c) throw new Error("wrong public key type");
        return function (e, n, i) {
          var a = i.data.p,
            s = i.data.q,
            u = i.data.g,
            c = i.data.pub_key,
            l = r.signature.decode(e, "der"),
            d = l.s,
            f = l.r;
          o(d, s), o(f, s);
          var h = t.mont(a),
            p = d.invm(s),
            m = u.toRed(h).redPow(new t(n).mul(p).mod(s)).fromRed().mul(c.toRed(h).redPow(f.mul(p).mod(s)).fromRed()).mod(a).mod(s);
          return 0 === m.cmp(f);
        }(a, s, d);
      }
      if ("rsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
      s = e.concat([l, s]);
      for (var f = d.modulus.byteLength(), h = [1], p = 0; s.length + h.length + 2 < f;) h.push(255), p++;
      h.push(0);
      for (var m = -1; ++m < s.length;) h.push(s[m]);
      h = e.from(h);
      var g = t.mont(d.modulus);
      a = (a = new t(a).toRed(g)).redPow(new t(d.publicExponent)), a = e.from(a.fromRed().toArray());
      var v = p < 8 ? 1 : 0;
      for (f = Math.min(a.length, h.length), a.length !== h.length && (v = 1), m = -1; ++m < f;) v |= a[m] ^ h[m];
      return 0 === v;
    }, Vp;
  }
  var em = {},
    tm = qo,
    nm = ze().Buffer,
    rm = function (e, t) {
      for (var n, r = nm.alloc(0), i = 0; r.length < t;) n = im(i++), r = nm.concat([r, tm("sha1").update(e).update(n).digest()]);
      return r.slice(0, t);
    };
  function im(e) {
    var t = nm.allocUnsafe(4);
    return t.writeUInt32BE(e, 0), t;
  }
  var om = function (e, t) {
      for (var n = e.length, r = -1; ++r < n;) e[r] ^= t[r];
      return e;
    },
    am = hc,
    sm = ze().Buffer;
  var um = function (e, t) {
      return sm.from(e.toRed(am.mont(t.modulus)).redPow(new am(t.publicExponent)).fromRed().toArray());
    },
    cm = qp,
    lm = Ve,
    dm = qo,
    fm = rm,
    hm = om,
    pm = hc,
    mm = um,
    gm = Rc,
    vm = ze().Buffer,
    bm = function (e, t, n) {
      var r;
      r = e.padding ? e.padding : n ? 1 : 4;
      var i,
        o = cm(e);
      if (4 === r) i = function (e, t) {
        var n = e.modulus.byteLength(),
          r = t.length,
          i = dm("sha1").update(vm.alloc(0)).digest(),
          o = i.length,
          a = 2 * o;
        if (r > n - a - 2) throw new Error("message too long");
        var s = vm.alloc(n - r - a - 2),
          u = n - o - 1,
          c = lm(o),
          l = hm(vm.concat([i, s, vm.alloc(1, 1), t], u), fm(c, u)),
          d = hm(c, fm(l, o));
        return new pm(vm.concat([vm.alloc(1), d, l], n));
      }(o, t);else if (1 === r) i = function (e, t, n) {
        var r,
          i = t.length,
          o = e.modulus.byteLength();
        if (i > o - 11) throw new Error("message too long");
        r = n ? vm.alloc(o - i - 3, 255) : function (e) {
          var t,
            n = vm.allocUnsafe(e),
            r = 0,
            i = lm(2 * e),
            o = 0;
          for (; r < e;) o === i.length && (i = lm(2 * e), o = 0), (t = i[o++]) && (n[r++] = t);
          return n;
        }(o - i - 3);
        return new pm(vm.concat([vm.from([0, n ? 1 : 2]), r, vm.alloc(1), t], o));
      }(o, t, n);else {
        if (3 !== r) throw new Error("unknown padding");
        if ((i = new pm(t)).cmp(o.modulus) >= 0) throw new Error("data too long for modulus");
      }
      return n ? gm(i, o) : mm(i, o);
    };
  var ym = qp,
    wm = rm,
    Am = om,
    _m = hc,
    Em = Rc,
    Sm = qo,
    km = um,
    Mm = ze().Buffer,
    Cm = function (e, t, n) {
      var r;
      r = e.padding ? e.padding : n ? 1 : 4;
      var i,
        o = ym(e),
        a = o.modulus.byteLength();
      if (t.length > a || new _m(t).cmp(o.modulus) >= 0) throw new Error("decryption error");
      i = n ? km(new _m(t), o) : Em(t, o);
      var s = Mm.alloc(a - i.length);
      if (i = Mm.concat([s, i], a), 4 === r) return function (e, t) {
        var n = e.modulus.byteLength(),
          r = Sm("sha1").update(Mm.alloc(0)).digest(),
          i = r.length;
        if (0 !== t[0]) throw new Error("decryption error");
        var o = t.slice(1, i + 1),
          a = t.slice(i + 1),
          s = Am(o, wm(a, i)),
          u = Am(a, wm(s, n - i - 1));
        if (function (e, t) {
          e = Mm.from(e), t = Mm.from(t);
          var n = 0,
            r = e.length;
          e.length !== t.length && (n++, r = Math.min(e.length, t.length));
          var i = -1;
          for (; ++i < r;) n += e[i] ^ t[i];
          return n;
        }(r, u.slice(0, i))) throw new Error("decryption error");
        var c = i;
        for (; 0 === u[c];) c++;
        if (1 !== u[c++]) throw new Error("decryption error");
        return u.slice(c);
      }(o, i);
      if (1 === r) return function (e, t, n) {
        var r = t.slice(0, 2),
          i = 2,
          o = 0;
        for (; 0 !== t[i++];) if (i >= t.length) {
          o++;
          break;
        }
        var a = t.slice(2, i - 1);
        ("0002" !== r.toString("hex") && !n || "0001" !== r.toString("hex") && n) && o++;
        a.length < 8 && o++;
        if (o) throw new Error("decryption error");
        return t.slice(i);
      }(0, i, n);
      if (3 === r) return i;
      throw new Error("unknown padding");
    };
  !function (e) {
    e.publicEncrypt = bm, e.privateDecrypt = Cm, e.privateEncrypt = function (t, n) {
      return e.publicEncrypt(t, n, !0);
    }, e.publicDecrypt = function (t, n) {
      return e.privateDecrypt(t, n, !0);
    };
  }(em);
  var xm = {};
  function Rm() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
  }
  var Im,
    Tm = ze(),
    Pm = Tm.Buffer,
    Om = Tm.kMaxLength,
    Lm = n.crypto || n.msCrypto,
    Nm = Math.pow(2, 32) - 1;
  function Dm(e, t) {
    if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
    if (e > Nm || e < 0) throw new TypeError("offset must be a uint32");
    if (e > Om || e > t) throw new RangeError("offset out of range");
  }
  function Bm(e, t, n) {
    if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
    if (e > Nm || e < 0) throw new TypeError("size must be a uint32");
    if (e + t > n || e > Om) throw new RangeError("buffer too small");
  }
  function jm(e, t, n, r) {
    var i = e.buffer,
      o = new Uint8Array(i, t, n);
    return Lm.getRandomValues(o), r ? void Ee(function () {
      r(null, e);
    }) : e;
  }
  function Fm() {
    if (Im) return de;
    Im = 1, de.randomBytes = de.rng = de.pseudoRandomBytes = de.prng = Ve, de.createHash = de.Hash = qo, de.createHmac = de.Hmac = sa;
    var e = ca,
      t = Object.keys(e),
      n = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(t);
    de.getHashes = function () {
      return n;
    };
    var r = la;
    de.pbkdf2 = r.pbkdf2, de.pbkdf2Sync = r.pbkdf2Sync;
    var i = Fa;
    de.Cipher = i.Cipher, de.createCipher = i.createCipher, de.Cipheriv = i.Cipheriv, de.createCipheriv = i.createCipheriv, de.Decipher = i.Decipher, de.createDecipher = i.createDecipher, de.Decipheriv = i.Decipheriv, de.createDecipheriv = i.createDecipheriv, de.getCiphers = i.getCiphers, de.listCiphers = i.listCiphers;
    var o = function () {
      if (wc) return ac;
      wc = 1;
      var e = vc(),
        t = Ac,
        n = _c(),
        r = {
          binary: !0,
          hex: !0,
          base64: !0
        };
      return ac.DiffieHellmanGroup = ac.createDiffieHellmanGroup = ac.getDiffieHellman = function (e) {
        var r = new A(t[e].prime, "hex"),
          i = new A(t[e].gen, "hex");
        return new n(r, i);
      }, ac.createDiffieHellman = ac.DiffieHellman = function t(i, o, a, s) {
        return ie(o) || void 0 === r[o] ? t(i, "binary", o, a) : (o = o || "binary", s = s || "binary", ie(a = a || new A([2])) || (a = new A(a, s)), "number" == typeof i ? new n(e(i, a), a, !0) : (ie(i) || (i = new A(i, o)), new n(i, a, !0)));
      }, ac;
    }();
    de.DiffieHellmanGroup = o.DiffieHellmanGroup, de.createDiffieHellmanGroup = o.createDiffieHellmanGroup, de.getDiffieHellman = o.getDiffieHellman, de.createDiffieHellman = o.createDiffieHellman, de.DiffieHellman = o.DiffieHellman;
    var a = function () {
      if (Yp) return Wp;
      Yp = 1;
      var e = ze().Buffer,
        t = qo,
        n = Hn,
        r = We,
        i = Jp(),
        o = Xp(),
        a = ua;
      function s(e) {
        n.Writable.call(this);
        var r = a[e];
        if (!r) throw new Error("Unknown message digest");
        this._hashType = r.hash, this._hash = t(r.hash), this._tag = r.id, this._signType = r.sign;
      }
      function u(e) {
        n.Writable.call(this);
        var r = a[e];
        if (!r) throw new Error("Unknown message digest");
        this._hash = t(r.hash), this._tag = r.id, this._signType = r.sign;
      }
      function c(e) {
        return new s(e);
      }
      function l(e) {
        return new u(e);
      }
      return Object.keys(a).forEach(function (t) {
        a[t].id = e.from(a[t].id, "hex"), a[t.toLowerCase()] = a[t];
      }), r(s, n.Writable), s.prototype._write = function (e, t, n) {
        this._hash.update(e), n();
      }, s.prototype.update = function (t, n) {
        return "string" == typeof t && (t = e.from(t, n)), this._hash.update(t), this;
      }, s.prototype.sign = function (e, t) {
        this.end();
        var n = this._hash.digest(),
          r = i(n, e, this._hashType, this._signType, this._tag);
        return t ? r.toString(t) : r;
      }, r(u, n.Writable), u.prototype._write = function (e, t, n) {
        this._hash.update(e), n();
      }, u.prototype.update = function (t, n) {
        return "string" == typeof t && (t = e.from(t, n)), this._hash.update(t), this;
      }, u.prototype.verify = function (t, n, r) {
        "string" == typeof n && (n = e.from(n, r)), this.end();
        var i = this._hash.digest();
        return o(n, i, t, this._signType, this._tag);
      }, Wp = {
        Sign: c,
        Verify: l,
        createSign: c,
        createVerify: l
      };
    }();
    de.createSign = a.createSign, de.Sign = a.Sign, de.createVerify = a.createVerify, de.Verify = a.Verify, de.createECDH = function () {
      if (Qp) return Gp;
      Qp = 1;
      var e = eh(),
        t = hc;
      Gp = function (e) {
        return new r(e);
      };
      var n = {
        secp256k1: {
          name: "secp256k1",
          byteLength: 32
        },
        secp224r1: {
          name: "p224",
          byteLength: 28
        },
        prime256v1: {
          name: "p256",
          byteLength: 32
        },
        prime192v1: {
          name: "p192",
          byteLength: 24
        },
        ed25519: {
          name: "ed25519",
          byteLength: 32
        },
        secp384r1: {
          name: "p384",
          byteLength: 48
        },
        secp521r1: {
          name: "p521",
          byteLength: 66
        }
      };
      function r(t) {
        this.curveType = n[t], this.curveType || (this.curveType = {
          name: t
        }), this.curve = new e.ec(this.curveType.name), this.keys = void 0;
      }
      function i(e, t, n) {
        Array.isArray(e) || (e = e.toArray());
        var r = new A(e);
        if (n && r.length < n) {
          var i = new A(n - r.length);
          i.fill(0), r = A.concat([i, r]);
        }
        return t ? r.toString(t) : r;
      }
      return n.p224 = n.secp224r1, n.p256 = n.secp256r1 = n.prime256v1, n.p192 = n.secp192r1 = n.prime192v1, n.p384 = n.secp384r1, n.p521 = n.secp521r1, r.prototype.generateKeys = function (e, t) {
        return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
      }, r.prototype.computeSecret = function (e, t, n) {
        return t = t || "utf8", ie(e) || (e = new A(e, t)), i(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), n, this.curveType.byteLength);
      }, r.prototype.getPublicKey = function (e, t) {
        var n = this.keys.getPublic("compressed" === t, !0);
        return "hybrid" === t && (n[n.length - 1] % 2 ? n[0] = 7 : n[0] = 6), i(n, e);
      }, r.prototype.getPrivateKey = function (e) {
        return i(this.keys.getPrivate(), e);
      }, r.prototype.setPublicKey = function (e, t) {
        return t = t || "utf8", ie(e) || (e = new A(e, t)), this.keys._importPublic(e), this;
      }, r.prototype.setPrivateKey = function (e, n) {
        n = n || "utf8", ie(e) || (e = new A(e, n));
        var r = new t(e);
        return r = r.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(r), this;
      }, Gp;
    }();
    var s = em;
    de.publicEncrypt = s.publicEncrypt, de.privateEncrypt = s.privateEncrypt, de.publicDecrypt = s.publicDecrypt, de.privateDecrypt = s.privateDecrypt;
    var u = xm;
    return de.randomFill = u.randomFill, de.randomFillSync = u.randomFillSync, de.createCredentials = function () {
      throw new Error(["sorry, createCredentials is not implemented yet", "we accept pull requests", "https://github.com/crypto-browserify/crypto-browserify"].join("\n"));
    }, de.constants = {
      DH_CHECK_P_NOT_SAFE_PRIME: 2,
      DH_CHECK_P_NOT_PRIME: 1,
      DH_UNABLE_TO_CHECK_GENERATOR: 4,
      DH_NOT_SUITABLE_GENERATOR: 8,
      NPN_ENABLED: 1,
      ALPN_ENABLED: 1,
      RSA_PKCS1_PADDING: 1,
      RSA_SSLV23_PADDING: 2,
      RSA_NO_PADDING: 3,
      RSA_PKCS1_OAEP_PADDING: 4,
      RSA_X931_PADDING: 5,
      RSA_PKCS1_PSS_PADDING: 6,
      POINT_CONVERSION_COMPRESSED: 2,
      POINT_CONVERSION_UNCOMPRESSED: 4,
      POINT_CONVERSION_HYBRID: 6
    }, de;
  }
  Lm && Lm.getRandomValues ? (xm.randomFill = function (e, t, r, i) {
    if (!(Pm.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if ("function" == typeof t) i = t, t = 0, r = e.length;else if ("function" == typeof r) i = r, r = e.length - t;else if ("function" != typeof i) throw new TypeError('"cb" argument must be a function');
    return Dm(t, e.length), Bm(r, t, e.length), jm(e, t, r, i);
  }, xm.randomFillSync = function (e, t, r) {
    void 0 === t && (t = 0);
    if (!(Pm.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    Dm(t, e.length), void 0 === r && (r = e.length - t);
    return Bm(r, t, e.length), jm(e, t, r);
  }) : (xm.randomFill = Rm, xm.randomFillSync = Rm);
  const {
      Buffer: zm
    } = le,
    {
      createHash: Um,
      createHmac: qm
    } = Fm(),
    Km = {},
    Hm = e => {
      switch (e) {
        case "sha256":
        case "sha3-256":
        case "blake2s256":
          return 32;
        case "sha512":
        case "sha3-512":
        case "blake2b512":
          return 64;
        case "sha224":
        case "sha3-224":
          return 28;
        case "sha384":
        case "sha3-384":
          return 48;
        case "sha1":
          return 20;
        case "md5":
          return 16;
        default:
          {
            let t = Km[e];
            return void 0 === t && (t = Um(e).digest().length, Km[e] = t), t;
          }
      }
    },
    Vm = (e, t, n, r) => {
      const i = zm.isBuffer(n) ? n : zm.from(n),
        o = r && r.length ? zm.from(r) : zm.alloc(t, 0);
      return qm(e, o).update(i).digest();
    },
    $m = (e, t, n, r, i) => {
      const o = zm.isBuffer(i) ? i : zm.from(i || ""),
        a = o.length,
        s = Math.ceil(r / t);
      if (s > 255) throw new Error(`OKM length ${r} is too long for ${e} hash`);
      const u = zm.alloc(t * s + a + 1);
      for (let r = 1, i = 0, c = 0; r <= s; ++r) o.copy(u, c), u[c + a] = r, qm(e, n).update(u.slice(i, c + a + 1)).digest().copy(u, c), i = c, c += t;
      return u.slice(0, r);
    };
  function Wm(e, t, {
    salt: n = "",
    info: r = "",
    hash: i = "SHA-256"
  } = {}) {
    i = i.toLowerCase().replace("-", "");
    const o = Hm(i),
      a = Vm(i, o, e, n);
    return $m(i, o, a, t, r);
  }
  Object.defineProperties(Wm, {
    hash_length: {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: Hm
    },
    extract: {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: Vm
    },
    expand: {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: $m
    }
  });
  var Ym = Wm;
  const Gm = "Impossible case. Please create issue.",
    Qm = "The tweak was out of range or the resulted private key is invalid",
    Zm = "The tweak was out of range or equal to zero",
    Jm = "Unknow error on context randomization",
    Xm = "Private Key is invalid",
    eg = "Public Key could not be parsed",
    tg = "Public Key serialization error",
    ng = "The sum of the public keys is not valid",
    rg = "Signature could not be parsed",
    ig = "The nonce generation function failed, or the private key was invalid",
    og = "Public key could not be recover",
    ag = "Scalar was invalid (zero or overflow)";
  function sg(e, t) {
    if (!e) throw new Error(t);
  }
  function ug(e, t, n) {
    if (sg(t instanceof Uint8Array, `Expected ${e} to be an Uint8Array`), void 0 !== n) if (Array.isArray(n)) {
      const r = `Expected ${e} to be an Uint8Array with length [${n.join(", ")}]`;
      sg(n.includes(t.length), r);
    } else {
      const r = `Expected ${e} to be an Uint8Array with length ${n}`;
      sg(t.length === n, r);
    }
  }
  function cg(e) {
    sg("Boolean" === dg(e), "Expected compressed to be a Boolean");
  }
  function lg(e = e => new Uint8Array(e), t) {
    return "function" == typeof e && (e = e(t)), ug("output", e, t), e;
  }
  function dg(e) {
    return Object.prototype.toString.call(e).slice(8, -1);
  }
  var fg = {},
    hg = "6.5.4",
    pg = {},
    mg = {
      exports: {}
    };
  !function (e) {
    !function (e, t) {
      function n(e, t) {
        if (!e) throw new Error(t || "Assertion failed");
      }
      function r(e, t) {
        e.super_ = t;
        var n = function () {};
        n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
      }
      function i(e, t, n) {
        if (i.isBN(e)) return e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (n = t, t = 10), this._init(e || 0, t || 10, n || "be"));
      }
      var o;
      "object" == typeof e ? e.exports = i : t.BN = i, i.BN = i, i.wordSize = 26;
      try {
        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : le.Buffer;
      } catch (e) {}
      function a(e, t) {
        var n = e.charCodeAt(t);
        return n >= 65 && n <= 70 ? n - 55 : n >= 97 && n <= 102 ? n - 87 : n - 48 & 15;
      }
      function s(e, t, n) {
        var r = a(e, n);
        return n - 1 >= t && (r |= a(e, n - 1) << 4), r;
      }
      function u(e, t, n, r) {
        for (var i = 0, o = Math.min(e.length, n), a = t; a < o; a++) {
          var s = e.charCodeAt(a) - 48;
          i *= r, i += s >= 49 ? s - 49 + 10 : s >= 17 ? s - 17 + 10 : s;
        }
        return i;
      }
      i.isBN = function (e) {
        return e instanceof i || null !== e && "object" == typeof e && e.constructor.wordSize === i.wordSize && Array.isArray(e.words);
      }, i.max = function (e, t) {
        return e.cmp(t) > 0 ? e : t;
      }, i.min = function (e, t) {
        return e.cmp(t) < 0 ? e : t;
      }, i.prototype._init = function (e, t, r) {
        if ("number" == typeof e) return this._initNumber(e, t, r);
        if ("object" == typeof e) return this._initArray(e, t, r);
        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
        var i = 0;
        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
      }, i.prototype._initNumber = function (e, t, r) {
        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (n(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
      }, i.prototype._initArray = function (e, t, r) {
        if (n("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) this.words[i] = 0;
        var o,
          a,
          s = 0;
        if ("be" === r) for (i = e.length - 1, o = 0; i >= 0; i -= 3) a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);else if ("le" === r) for (i = 0, o = 0; i < e.length; i += 3) a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
        return this.strip();
      }, i.prototype._parseHex = function (e, t, n) {
        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
        for (var r = 0; r < this.length; r++) this.words[r] = 0;
        var i,
          o = 0,
          a = 0;
        if ("be" === n) for (r = e.length - 1; r >= t; r -= 2) i = s(e, t, r) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;else for (r = (e.length - t) % 2 == 0 ? t + 1 : t; r < e.length; r += 2) i = s(e, t, r) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
        this.strip();
      }, i.prototype._parseBase = function (e, t, n) {
        this.words = [0], this.length = 1;
        for (var r = 0, i = 1; i <= 67108863; i *= t) r++;
        r--, i = i / t | 0;
        for (var o = e.length - n, a = o % r, s = Math.min(o, o - a) + n, c = 0, l = n; l < s; l += r) c = u(e, l, l + r, t), this.imuln(i), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
        if (0 !== a) {
          var d = 1;
          for (c = u(e, l, e.length, t), l = 0; l < a; l++) d *= t;
          this.imuln(d), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
        }
        this.strip();
      }, i.prototype.copy = function (e) {
        e.words = new Array(this.length);
        for (var t = 0; t < this.length; t++) e.words[t] = this.words[t];
        e.length = this.length, e.negative = this.negative, e.red = this.red;
      }, i.prototype.clone = function () {
        var e = new i(null);
        return this.copy(e), e;
      }, i.prototype._expand = function (e) {
        for (; this.length < e;) this.words[this.length++] = 0;
        return this;
      }, i.prototype.strip = function () {
        for (; this.length > 1 && 0 === this.words[this.length - 1];) this.length--;
        return this._normSign();
      }, i.prototype._normSign = function () {
        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
      }, i.prototype.inspect = function () {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var c = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
        l = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
        d = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
      function f(e, t, n) {
        n.negative = t.negative ^ e.negative;
        var r = e.length + t.length | 0;
        n.length = r, r = r - 1 | 0;
        var i = 0 | e.words[0],
          o = 0 | t.words[0],
          a = i * o,
          s = 67108863 & a,
          u = a / 67108864 | 0;
        n.words[0] = s;
        for (var c = 1; c < r; c++) {
          for (var l = u >>> 26, d = 67108863 & u, f = Math.min(c, t.length - 1), h = Math.max(0, c - e.length + 1); h <= f; h++) {
            var p = c - h | 0;
            l += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[h]) + d) / 67108864 | 0, d = 67108863 & a;
          }
          n.words[c] = 0 | d, u = 0 | l;
        }
        return 0 !== u ? n.words[c] = 0 | u : n.length--, n.strip();
      }
      i.prototype.toString = function (e, t) {
        var r;
        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
          r = "";
          for (var i = 0, o = 0, a = 0; a < this.length; a++) {
            var s = this.words[a],
              u = (16777215 & (s << i | o)).toString(16);
            r = 0 !== (o = s >>> 24 - i & 16777215) || a !== this.length - 1 ? c[6 - u.length] + u + r : u + r, (i += 2) >= 26 && (i -= 26, a--);
          }
          for (0 !== o && (r = o.toString(16) + r); r.length % t != 0;) r = "0" + r;
          return 0 !== this.negative && (r = "-" + r), r;
        }
        if (e === (0 | e) && e >= 2 && e <= 36) {
          var f = l[e],
            h = d[e];
          r = "";
          var p = this.clone();
          for (p.negative = 0; !p.isZero();) {
            var m = p.modn(h).toString(e);
            r = (p = p.idivn(h)).isZero() ? m + r : c[f - m.length] + m + r;
          }
          for (this.isZero() && (r = "0" + r); r.length % t != 0;) r = "0" + r;
          return 0 !== this.negative && (r = "-" + r), r;
        }
        n(!1, "Base should be between 2 and 36");
      }, i.prototype.toNumber = function () {
        var e = this.words[0];
        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
      }, i.prototype.toJSON = function () {
        return this.toString(16);
      }, i.prototype.toBuffer = function (e, t) {
        return n(void 0 !== o), this.toArrayLike(o, e, t);
      }, i.prototype.toArray = function (e, t) {
        return this.toArrayLike(Array, e, t);
      }, i.prototype.toArrayLike = function (e, t, r) {
        var i = this.byteLength(),
          o = r || Math.max(1, i);
        n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0"), this.strip();
        var a,
          s,
          u = "le" === t,
          c = new e(o),
          l = this.clone();
        if (u) {
          for (s = 0; !l.isZero(); s++) a = l.andln(255), l.iushrn(8), c[s] = a;
          for (; s < o; s++) c[s] = 0;
        } else {
          for (s = 0; s < o - i; s++) c[s] = 0;
          for (s = 0; !l.isZero(); s++) a = l.andln(255), l.iushrn(8), c[o - s - 1] = a;
        }
        return c;
      }, Math.clz32 ? i.prototype._countBits = function (e) {
        return 32 - Math.clz32(e);
      } : i.prototype._countBits = function (e) {
        var t = e,
          n = 0;
        return t >= 4096 && (n += 13, t >>>= 13), t >= 64 && (n += 7, t >>>= 7), t >= 8 && (n += 4, t >>>= 4), t >= 2 && (n += 2, t >>>= 2), n + t;
      }, i.prototype._zeroBits = function (e) {
        if (0 === e) return 26;
        var t = e,
          n = 0;
        return 0 == (8191 & t) && (n += 13, t >>>= 13), 0 == (127 & t) && (n += 7, t >>>= 7), 0 == (15 & t) && (n += 4, t >>>= 4), 0 == (3 & t) && (n += 2, t >>>= 2), 0 == (1 & t) && n++, n;
      }, i.prototype.bitLength = function () {
        var e = this.words[this.length - 1],
          t = this._countBits(e);
        return 26 * (this.length - 1) + t;
      }, i.prototype.zeroBits = function () {
        if (this.isZero()) return 0;
        for (var e = 0, t = 0; t < this.length; t++) {
          var n = this._zeroBits(this.words[t]);
          if (e += n, 26 !== n) break;
        }
        return e;
      }, i.prototype.byteLength = function () {
        return Math.ceil(this.bitLength() / 8);
      }, i.prototype.toTwos = function (e) {
        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
      }, i.prototype.fromTwos = function (e) {
        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
      }, i.prototype.isNeg = function () {
        return 0 !== this.negative;
      }, i.prototype.neg = function () {
        return this.clone().ineg();
      }, i.prototype.ineg = function () {
        return this.isZero() || (this.negative ^= 1), this;
      }, i.prototype.iuor = function (e) {
        for (; this.length < e.length;) this.words[this.length++] = 0;
        for (var t = 0; t < e.length; t++) this.words[t] = this.words[t] | e.words[t];
        return this.strip();
      }, i.prototype.ior = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuor(e);
      }, i.prototype.or = function (e) {
        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
      }, i.prototype.uor = function (e) {
        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
      }, i.prototype.iuand = function (e) {
        var t;
        t = this.length > e.length ? e : this;
        for (var n = 0; n < t.length; n++) this.words[n] = this.words[n] & e.words[n];
        return this.length = t.length, this.strip();
      }, i.prototype.iand = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuand(e);
      }, i.prototype.and = function (e) {
        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
      }, i.prototype.uand = function (e) {
        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
      }, i.prototype.iuxor = function (e) {
        var t, n;
        this.length > e.length ? (t = this, n = e) : (t = e, n = this);
        for (var r = 0; r < n.length; r++) this.words[r] = t.words[r] ^ n.words[r];
        if (this !== t) for (; r < t.length; r++) this.words[r] = t.words[r];
        return this.length = t.length, this.strip();
      }, i.prototype.ixor = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuxor(e);
      }, i.prototype.xor = function (e) {
        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
      }, i.prototype.uxor = function (e) {
        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
      }, i.prototype.inotn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = 0 | Math.ceil(e / 26),
          r = e % 26;
        this._expand(t), r > 0 && t--;
        for (var i = 0; i < t; i++) this.words[i] = 67108863 & ~this.words[i];
        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
      }, i.prototype.notn = function (e) {
        return this.clone().inotn(e);
      }, i.prototype.setn = function (e, t) {
        n("number" == typeof e && e >= 0);
        var r = e / 26 | 0,
          i = e % 26;
        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
      }, i.prototype.iadd = function (e) {
        var t, n, r;
        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
        this.length > e.length ? (n = this, r = e) : (n = e, r = this);
        for (var i = 0, o = 0; o < r.length; o++) t = (0 | n.words[o]) + (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
        for (; 0 !== i && o < n.length; o++) t = (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
        if (this.length = n.length, 0 !== i) this.words[this.length] = i, this.length++;else if (n !== this) for (; o < n.length; o++) this.words[o] = n.words[o];
        return this;
      }, i.prototype.add = function (e) {
        var t;
        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
      }, i.prototype.isub = function (e) {
        if (0 !== e.negative) {
          e.negative = 0;
          var t = this.iadd(e);
          return e.negative = 1, t._normSign();
        }
        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
        var n,
          r,
          i = this.cmp(e);
        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        i > 0 ? (n = this, r = e) : (n = e, r = this);
        for (var o = 0, a = 0; a < r.length; a++) o = (t = (0 | n.words[a]) - (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
        for (; 0 !== o && a < n.length; a++) o = (t = (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
        if (0 === o && a < n.length && n !== this) for (; a < n.length; a++) this.words[a] = n.words[a];
        return this.length = Math.max(this.length, a), n !== this && (this.negative = 1), this.strip();
      }, i.prototype.sub = function (e) {
        return this.clone().isub(e);
      };
      var h = function (e, t, n) {
        var r,
          i,
          o,
          a = e.words,
          s = t.words,
          u = n.words,
          c = 0,
          l = 0 | a[0],
          d = 8191 & l,
          f = l >>> 13,
          h = 0 | a[1],
          p = 8191 & h,
          m = h >>> 13,
          g = 0 | a[2],
          v = 8191 & g,
          b = g >>> 13,
          y = 0 | a[3],
          w = 8191 & y,
          A = y >>> 13,
          _ = 0 | a[4],
          E = 8191 & _,
          S = _ >>> 13,
          k = 0 | a[5],
          M = 8191 & k,
          C = k >>> 13,
          x = 0 | a[6],
          R = 8191 & x,
          I = x >>> 13,
          T = 0 | a[7],
          P = 8191 & T,
          O = T >>> 13,
          L = 0 | a[8],
          N = 8191 & L,
          D = L >>> 13,
          B = 0 | a[9],
          j = 8191 & B,
          F = B >>> 13,
          z = 0 | s[0],
          U = 8191 & z,
          q = z >>> 13,
          K = 0 | s[1],
          H = 8191 & K,
          V = K >>> 13,
          $ = 0 | s[2],
          W = 8191 & $,
          Y = $ >>> 13,
          G = 0 | s[3],
          Q = 8191 & G,
          Z = G >>> 13,
          J = 0 | s[4],
          X = 8191 & J,
          ee = J >>> 13,
          te = 0 | s[5],
          ne = 8191 & te,
          re = te >>> 13,
          ie = 0 | s[6],
          oe = 8191 & ie,
          ae = ie >>> 13,
          se = 0 | s[7],
          ue = 8191 & se,
          ce = se >>> 13,
          le = 0 | s[8],
          de = 8191 & le,
          fe = le >>> 13,
          he = 0 | s[9],
          pe = 8191 & he,
          me = he >>> 13;
        n.negative = e.negative ^ t.negative, n.length = 19;
        var ge = (c + (r = Math.imul(d, U)) | 0) + ((8191 & (i = (i = Math.imul(d, q)) + Math.imul(f, U) | 0)) << 13) | 0;
        c = ((o = Math.imul(f, q)) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, r = Math.imul(p, U), i = (i = Math.imul(p, q)) + Math.imul(m, U) | 0, o = Math.imul(m, q);
        var ve = (c + (r = r + Math.imul(d, H) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, V) | 0) + Math.imul(f, H) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, V) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, r = Math.imul(v, U), i = (i = Math.imul(v, q)) + Math.imul(b, U) | 0, o = Math.imul(b, q), r = r + Math.imul(p, H) | 0, i = (i = i + Math.imul(p, V) | 0) + Math.imul(m, H) | 0, o = o + Math.imul(m, V) | 0;
        var be = (c + (r = r + Math.imul(d, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Y) | 0) + Math.imul(f, W) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, Y) | 0) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, r = Math.imul(w, U), i = (i = Math.imul(w, q)) + Math.imul(A, U) | 0, o = Math.imul(A, q), r = r + Math.imul(v, H) | 0, i = (i = i + Math.imul(v, V) | 0) + Math.imul(b, H) | 0, o = o + Math.imul(b, V) | 0, r = r + Math.imul(p, W) | 0, i = (i = i + Math.imul(p, Y) | 0) + Math.imul(m, W) | 0, o = o + Math.imul(m, Y) | 0;
        var ye = (c + (r = r + Math.imul(d, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Z) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, Z) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, r = Math.imul(E, U), i = (i = Math.imul(E, q)) + Math.imul(S, U) | 0, o = Math.imul(S, q), r = r + Math.imul(w, H) | 0, i = (i = i + Math.imul(w, V) | 0) + Math.imul(A, H) | 0, o = o + Math.imul(A, V) | 0, r = r + Math.imul(v, W) | 0, i = (i = i + Math.imul(v, Y) | 0) + Math.imul(b, W) | 0, o = o + Math.imul(b, Y) | 0, r = r + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, Z) | 0) + Math.imul(m, Q) | 0, o = o + Math.imul(m, Z) | 0;
        var we = (c + (r = r + Math.imul(d, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, r = Math.imul(M, U), i = (i = Math.imul(M, q)) + Math.imul(C, U) | 0, o = Math.imul(C, q), r = r + Math.imul(E, H) | 0, i = (i = i + Math.imul(E, V) | 0) + Math.imul(S, H) | 0, o = o + Math.imul(S, V) | 0, r = r + Math.imul(w, W) | 0, i = (i = i + Math.imul(w, Y) | 0) + Math.imul(A, W) | 0, o = o + Math.imul(A, Y) | 0, r = r + Math.imul(v, Q) | 0, i = (i = i + Math.imul(v, Z) | 0) + Math.imul(b, Q) | 0, o = o + Math.imul(b, Z) | 0, r = r + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, X) | 0, o = o + Math.imul(m, ee) | 0;
        var Ae = (c + (r = r + Math.imul(d, ne) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, re) | 0) + Math.imul(f, ne) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, re) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, r = Math.imul(R, U), i = (i = Math.imul(R, q)) + Math.imul(I, U) | 0, o = Math.imul(I, q), r = r + Math.imul(M, H) | 0, i = (i = i + Math.imul(M, V) | 0) + Math.imul(C, H) | 0, o = o + Math.imul(C, V) | 0, r = r + Math.imul(E, W) | 0, i = (i = i + Math.imul(E, Y) | 0) + Math.imul(S, W) | 0, o = o + Math.imul(S, Y) | 0, r = r + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, Z) | 0) + Math.imul(A, Q) | 0, o = o + Math.imul(A, Z) | 0, r = r + Math.imul(v, X) | 0, i = (i = i + Math.imul(v, ee) | 0) + Math.imul(b, X) | 0, o = o + Math.imul(b, ee) | 0, r = r + Math.imul(p, ne) | 0, i = (i = i + Math.imul(p, re) | 0) + Math.imul(m, ne) | 0, o = o + Math.imul(m, re) | 0;
        var _e = (c + (r = r + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ae) | 0) + Math.imul(f, oe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ae) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, r = Math.imul(P, U), i = (i = Math.imul(P, q)) + Math.imul(O, U) | 0, o = Math.imul(O, q), r = r + Math.imul(R, H) | 0, i = (i = i + Math.imul(R, V) | 0) + Math.imul(I, H) | 0, o = o + Math.imul(I, V) | 0, r = r + Math.imul(M, W) | 0, i = (i = i + Math.imul(M, Y) | 0) + Math.imul(C, W) | 0, o = o + Math.imul(C, Y) | 0, r = r + Math.imul(E, Q) | 0, i = (i = i + Math.imul(E, Z) | 0) + Math.imul(S, Q) | 0, o = o + Math.imul(S, Z) | 0, r = r + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(A, X) | 0, o = o + Math.imul(A, ee) | 0, r = r + Math.imul(v, ne) | 0, i = (i = i + Math.imul(v, re) | 0) + Math.imul(b, ne) | 0, o = o + Math.imul(b, re) | 0, r = r + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, ae) | 0;
        var Ee = (c + (r = r + Math.imul(d, ue) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ce) | 0) + Math.imul(f, ue) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, r = Math.imul(N, U), i = (i = Math.imul(N, q)) + Math.imul(D, U) | 0, o = Math.imul(D, q), r = r + Math.imul(P, H) | 0, i = (i = i + Math.imul(P, V) | 0) + Math.imul(O, H) | 0, o = o + Math.imul(O, V) | 0, r = r + Math.imul(R, W) | 0, i = (i = i + Math.imul(R, Y) | 0) + Math.imul(I, W) | 0, o = o + Math.imul(I, Y) | 0, r = r + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, Z) | 0) + Math.imul(C, Q) | 0, o = o + Math.imul(C, Z) | 0, r = r + Math.imul(E, X) | 0, i = (i = i + Math.imul(E, ee) | 0) + Math.imul(S, X) | 0, o = o + Math.imul(S, ee) | 0, r = r + Math.imul(w, ne) | 0, i = (i = i + Math.imul(w, re) | 0) + Math.imul(A, ne) | 0, o = o + Math.imul(A, re) | 0, r = r + Math.imul(v, oe) | 0, i = (i = i + Math.imul(v, ae) | 0) + Math.imul(b, oe) | 0, o = o + Math.imul(b, ae) | 0, r = r + Math.imul(p, ue) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, ue) | 0, o = o + Math.imul(m, ce) | 0;
        var Se = (c + (r = r + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, fe) | 0) + Math.imul(f, de) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, r = Math.imul(j, U), i = (i = Math.imul(j, q)) + Math.imul(F, U) | 0, o = Math.imul(F, q), r = r + Math.imul(N, H) | 0, i = (i = i + Math.imul(N, V) | 0) + Math.imul(D, H) | 0, o = o + Math.imul(D, V) | 0, r = r + Math.imul(P, W) | 0, i = (i = i + Math.imul(P, Y) | 0) + Math.imul(O, W) | 0, o = o + Math.imul(O, Y) | 0, r = r + Math.imul(R, Q) | 0, i = (i = i + Math.imul(R, Z) | 0) + Math.imul(I, Q) | 0, o = o + Math.imul(I, Z) | 0, r = r + Math.imul(M, X) | 0, i = (i = i + Math.imul(M, ee) | 0) + Math.imul(C, X) | 0, o = o + Math.imul(C, ee) | 0, r = r + Math.imul(E, ne) | 0, i = (i = i + Math.imul(E, re) | 0) + Math.imul(S, ne) | 0, o = o + Math.imul(S, re) | 0, r = r + Math.imul(w, oe) | 0, i = (i = i + Math.imul(w, ae) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, ae) | 0, r = r + Math.imul(v, ue) | 0, i = (i = i + Math.imul(v, ce) | 0) + Math.imul(b, ue) | 0, o = o + Math.imul(b, ce) | 0, r = r + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, de) | 0, o = o + Math.imul(m, fe) | 0;
        var ke = (c + (r = r + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, r = Math.imul(j, H), i = (i = Math.imul(j, V)) + Math.imul(F, H) | 0, o = Math.imul(F, V), r = r + Math.imul(N, W) | 0, i = (i = i + Math.imul(N, Y) | 0) + Math.imul(D, W) | 0, o = o + Math.imul(D, Y) | 0, r = r + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, Z) | 0) + Math.imul(O, Q) | 0, o = o + Math.imul(O, Z) | 0, r = r + Math.imul(R, X) | 0, i = (i = i + Math.imul(R, ee) | 0) + Math.imul(I, X) | 0, o = o + Math.imul(I, ee) | 0, r = r + Math.imul(M, ne) | 0, i = (i = i + Math.imul(M, re) | 0) + Math.imul(C, ne) | 0, o = o + Math.imul(C, re) | 0, r = r + Math.imul(E, oe) | 0, i = (i = i + Math.imul(E, ae) | 0) + Math.imul(S, oe) | 0, o = o + Math.imul(S, ae) | 0, r = r + Math.imul(w, ue) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(A, ue) | 0, o = o + Math.imul(A, ce) | 0, r = r + Math.imul(v, de) | 0, i = (i = i + Math.imul(v, fe) | 0) + Math.imul(b, de) | 0, o = o + Math.imul(b, fe) | 0;
        var Me = (c + (r = r + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, r = Math.imul(j, W), i = (i = Math.imul(j, Y)) + Math.imul(F, W) | 0, o = Math.imul(F, Y), r = r + Math.imul(N, Q) | 0, i = (i = i + Math.imul(N, Z) | 0) + Math.imul(D, Q) | 0, o = o + Math.imul(D, Z) | 0, r = r + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(O, X) | 0, o = o + Math.imul(O, ee) | 0, r = r + Math.imul(R, ne) | 0, i = (i = i + Math.imul(R, re) | 0) + Math.imul(I, ne) | 0, o = o + Math.imul(I, re) | 0, r = r + Math.imul(M, oe) | 0, i = (i = i + Math.imul(M, ae) | 0) + Math.imul(C, oe) | 0, o = o + Math.imul(C, ae) | 0, r = r + Math.imul(E, ue) | 0, i = (i = i + Math.imul(E, ce) | 0) + Math.imul(S, ue) | 0, o = o + Math.imul(S, ce) | 0, r = r + Math.imul(w, de) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(A, de) | 0, o = o + Math.imul(A, fe) | 0;
        var Ce = (c + (r = r + Math.imul(v, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(v, me) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(b, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, r = Math.imul(j, Q), i = (i = Math.imul(j, Z)) + Math.imul(F, Q) | 0, o = Math.imul(F, Z), r = r + Math.imul(N, X) | 0, i = (i = i + Math.imul(N, ee) | 0) + Math.imul(D, X) | 0, o = o + Math.imul(D, ee) | 0, r = r + Math.imul(P, ne) | 0, i = (i = i + Math.imul(P, re) | 0) + Math.imul(O, ne) | 0, o = o + Math.imul(O, re) | 0, r = r + Math.imul(R, oe) | 0, i = (i = i + Math.imul(R, ae) | 0) + Math.imul(I, oe) | 0, o = o + Math.imul(I, ae) | 0, r = r + Math.imul(M, ue) | 0, i = (i = i + Math.imul(M, ce) | 0) + Math.imul(C, ue) | 0, o = o + Math.imul(C, ce) | 0, r = r + Math.imul(E, de) | 0, i = (i = i + Math.imul(E, fe) | 0) + Math.imul(S, de) | 0, o = o + Math.imul(S, fe) | 0;
        var xe = (c + (r = r + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(A, me) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, r = Math.imul(j, X), i = (i = Math.imul(j, ee)) + Math.imul(F, X) | 0, o = Math.imul(F, ee), r = r + Math.imul(N, ne) | 0, i = (i = i + Math.imul(N, re) | 0) + Math.imul(D, ne) | 0, o = o + Math.imul(D, re) | 0, r = r + Math.imul(P, oe) | 0, i = (i = i + Math.imul(P, ae) | 0) + Math.imul(O, oe) | 0, o = o + Math.imul(O, ae) | 0, r = r + Math.imul(R, ue) | 0, i = (i = i + Math.imul(R, ce) | 0) + Math.imul(I, ue) | 0, o = o + Math.imul(I, ce) | 0, r = r + Math.imul(M, de) | 0, i = (i = i + Math.imul(M, fe) | 0) + Math.imul(C, de) | 0, o = o + Math.imul(C, fe) | 0;
        var Re = (c + (r = r + Math.imul(E, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(E, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, r = Math.imul(j, ne), i = (i = Math.imul(j, re)) + Math.imul(F, ne) | 0, o = Math.imul(F, re), r = r + Math.imul(N, oe) | 0, i = (i = i + Math.imul(N, ae) | 0) + Math.imul(D, oe) | 0, o = o + Math.imul(D, ae) | 0, r = r + Math.imul(P, ue) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(O, ue) | 0, o = o + Math.imul(O, ce) | 0, r = r + Math.imul(R, de) | 0, i = (i = i + Math.imul(R, fe) | 0) + Math.imul(I, de) | 0, o = o + Math.imul(I, fe) | 0;
        var Ie = (c + (r = r + Math.imul(M, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, me) | 0) + Math.imul(C, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(C, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, r = Math.imul(j, oe), i = (i = Math.imul(j, ae)) + Math.imul(F, oe) | 0, o = Math.imul(F, ae), r = r + Math.imul(N, ue) | 0, i = (i = i + Math.imul(N, ce) | 0) + Math.imul(D, ue) | 0, o = o + Math.imul(D, ce) | 0, r = r + Math.imul(P, de) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(O, de) | 0, o = o + Math.imul(O, fe) | 0;
        var Te = (c + (r = r + Math.imul(R, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(R, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, r = Math.imul(j, ue), i = (i = Math.imul(j, ce)) + Math.imul(F, ue) | 0, o = Math.imul(F, ce), r = r + Math.imul(N, de) | 0, i = (i = i + Math.imul(N, fe) | 0) + Math.imul(D, de) | 0, o = o + Math.imul(D, fe) | 0;
        var Pe = (c + (r = r + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(O, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(O, me) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, r = Math.imul(j, de), i = (i = Math.imul(j, fe)) + Math.imul(F, de) | 0, o = Math.imul(F, fe);
        var Oe = (c + (r = r + Math.imul(N, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(N, me) | 0) + Math.imul(D, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(D, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863;
        var Le = (c + (r = Math.imul(j, pe)) | 0) + ((8191 & (i = (i = Math.imul(j, me)) + Math.imul(F, pe) | 0)) << 13) | 0;
        return c = ((o = Math.imul(F, me)) + (i >>> 13) | 0) + (Le >>> 26) | 0, Le &= 67108863, u[0] = ge, u[1] = ve, u[2] = be, u[3] = ye, u[4] = we, u[5] = Ae, u[6] = _e, u[7] = Ee, u[8] = Se, u[9] = ke, u[10] = Me, u[11] = Ce, u[12] = xe, u[13] = Re, u[14] = Ie, u[15] = Te, u[16] = Pe, u[17] = Oe, u[18] = Le, 0 !== c && (u[19] = c, n.length++), n;
      };
      function p(e, t, n) {
        return new m().mulp(e, t, n);
      }
      function m(e, t) {
        this.x = e, this.y = t;
      }
      Math.imul || (h = f), i.prototype.mulTo = function (e, t) {
        var n,
          r = this.length + e.length;
        return n = 10 === this.length && 10 === e.length ? h(this, e, t) : r < 63 ? f(this, e, t) : r < 1024 ? function (e, t, n) {
          n.negative = t.negative ^ e.negative, n.length = e.length + t.length;
          for (var r = 0, i = 0, o = 0; o < n.length - 1; o++) {
            var a = i;
            i = 0;
            for (var s = 67108863 & r, u = Math.min(o, t.length - 1), c = Math.max(0, o - e.length + 1); c <= u; c++) {
              var l = o - c,
                d = (0 | e.words[l]) * (0 | t.words[c]),
                f = 67108863 & d;
              s = 67108863 & (f = f + s | 0), i += (a = (a = a + (d / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, a &= 67108863;
            }
            n.words[o] = s, r = a, a = i;
          }
          return 0 !== r ? n.words[o] = r : n.length--, n.strip();
        }(this, e, t) : p(this, e, t), n;
      }, m.prototype.makeRBT = function (e) {
        for (var t = new Array(e), n = i.prototype._countBits(e) - 1, r = 0; r < e; r++) t[r] = this.revBin(r, n, e);
        return t;
      }, m.prototype.revBin = function (e, t, n) {
        if (0 === e || e === n - 1) return e;
        for (var r = 0, i = 0; i < t; i++) r |= (1 & e) << t - i - 1, e >>= 1;
        return r;
      }, m.prototype.permute = function (e, t, n, r, i, o) {
        for (var a = 0; a < o; a++) r[a] = t[e[a]], i[a] = n[e[a]];
      }, m.prototype.transform = function (e, t, n, r, i, o) {
        this.permute(o, e, t, n, r, i);
        for (var a = 1; a < i; a <<= 1) for (var s = a << 1, u = Math.cos(2 * Math.PI / s), c = Math.sin(2 * Math.PI / s), l = 0; l < i; l += s) for (var d = u, f = c, h = 0; h < a; h++) {
          var p = n[l + h],
            m = r[l + h],
            g = n[l + h + a],
            v = r[l + h + a],
            b = d * g - f * v;
          v = d * v + f * g, g = b, n[l + h] = p + g, r[l + h] = m + v, n[l + h + a] = p - g, r[l + h + a] = m - v, h !== s && (b = u * d - c * f, f = u * f + c * d, d = b);
        }
      }, m.prototype.guessLen13b = function (e, t) {
        var n = 1 | Math.max(t, e),
          r = 1 & n,
          i = 0;
        for (n = n / 2 | 0; n; n >>>= 1) i++;
        return 1 << i + 1 + r;
      }, m.prototype.conjugate = function (e, t, n) {
        if (!(n <= 1)) for (var r = 0; r < n / 2; r++) {
          var i = e[r];
          e[r] = e[n - r - 1], e[n - r - 1] = i, i = t[r], t[r] = -t[n - r - 1], t[n - r - 1] = -i;
        }
      }, m.prototype.normalize13b = function (e, t) {
        for (var n = 0, r = 0; r < t / 2; r++) {
          var i = 8192 * Math.round(e[2 * r + 1] / t) + Math.round(e[2 * r] / t) + n;
          e[r] = 67108863 & i, n = i < 67108864 ? 0 : i / 67108864 | 0;
        }
        return e;
      }, m.prototype.convert13b = function (e, t, r, i) {
        for (var o = 0, a = 0; a < t; a++) o += 0 | e[a], r[2 * a] = 8191 & o, o >>>= 13, r[2 * a + 1] = 8191 & o, o >>>= 13;
        for (a = 2 * t; a < i; ++a) r[a] = 0;
        n(0 === o), n(0 == (-8192 & o));
      }, m.prototype.stub = function (e) {
        for (var t = new Array(e), n = 0; n < e; n++) t[n] = 0;
        return t;
      }, m.prototype.mulp = function (e, t, n) {
        var r = 2 * this.guessLen13b(e.length, t.length),
          i = this.makeRBT(r),
          o = this.stub(r),
          a = new Array(r),
          s = new Array(r),
          u = new Array(r),
          c = new Array(r),
          l = new Array(r),
          d = new Array(r),
          f = n.words;
        f.length = r, this.convert13b(e.words, e.length, a, r), this.convert13b(t.words, t.length, c, r), this.transform(a, o, s, u, r, i), this.transform(c, o, l, d, r, i);
        for (var h = 0; h < r; h++) {
          var p = s[h] * l[h] - u[h] * d[h];
          u[h] = s[h] * d[h] + u[h] * l[h], s[h] = p;
        }
        return this.conjugate(s, u, r), this.transform(s, u, f, o, r, i), this.conjugate(f, o, r), this.normalize13b(f, r), n.negative = e.negative ^ t.negative, n.length = e.length + t.length, n.strip();
      }, i.prototype.mul = function (e) {
        var t = new i(null);
        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
      }, i.prototype.mulf = function (e) {
        var t = new i(null);
        return t.words = new Array(this.length + e.length), p(this, e, t);
      }, i.prototype.imul = function (e) {
        return this.clone().mulTo(e, this);
      }, i.prototype.imuln = function (e) {
        n("number" == typeof e), n(e < 67108864);
        for (var t = 0, r = 0; r < this.length; r++) {
          var i = (0 | this.words[r]) * e,
            o = (67108863 & i) + (67108863 & t);
          t >>= 26, t += i / 67108864 | 0, t += o >>> 26, this.words[r] = 67108863 & o;
        }
        return 0 !== t && (this.words[r] = t, this.length++), this;
      }, i.prototype.muln = function (e) {
        return this.clone().imuln(e);
      }, i.prototype.sqr = function () {
        return this.mul(this);
      }, i.prototype.isqr = function () {
        return this.imul(this.clone());
      }, i.prototype.pow = function (e) {
        var t = function (e) {
          for (var t = new Array(e.bitLength()), n = 0; n < t.length; n++) {
            var r = n / 26 | 0,
              i = n % 26;
            t[n] = (e.words[r] & 1 << i) >>> i;
          }
          return t;
        }(e);
        if (0 === t.length) return new i(1);
        for (var n = this, r = 0; r < t.length && 0 === t[r]; r++, n = n.sqr());
        if (++r < t.length) for (var o = n.sqr(); r < t.length; r++, o = o.sqr()) 0 !== t[r] && (n = n.mul(o));
        return n;
      }, i.prototype.iushln = function (e) {
        n("number" == typeof e && e >= 0);
        var t,
          r = e % 26,
          i = (e - r) / 26,
          o = 67108863 >>> 26 - r << 26 - r;
        if (0 !== r) {
          var a = 0;
          for (t = 0; t < this.length; t++) {
            var s = this.words[t] & o,
              u = (0 | this.words[t]) - s << r;
            this.words[t] = u | a, a = s >>> 26 - r;
          }
          a && (this.words[t] = a, this.length++);
        }
        if (0 !== i) {
          for (t = this.length - 1; t >= 0; t--) this.words[t + i] = this.words[t];
          for (t = 0; t < i; t++) this.words[t] = 0;
          this.length += i;
        }
        return this.strip();
      }, i.prototype.ishln = function (e) {
        return n(0 === this.negative), this.iushln(e);
      }, i.prototype.iushrn = function (e, t, r) {
        var i;
        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
        var o = e % 26,
          a = Math.min((e - o) / 26, this.length),
          s = 67108863 ^ 67108863 >>> o << o,
          u = r;
        if (i -= a, i = Math.max(0, i), u) {
          for (var c = 0; c < a; c++) u.words[c] = this.words[c];
          u.length = a;
        }
        if (0 === a) ;else if (this.length > a) for (this.length -= a, c = 0; c < this.length; c++) this.words[c] = this.words[c + a];else this.words[0] = 0, this.length = 1;
        var l = 0;
        for (c = this.length - 1; c >= 0 && (0 !== l || c >= i); c--) {
          var d = 0 | this.words[c];
          this.words[c] = l << 26 - o | d >>> o, l = d & s;
        }
        return u && 0 !== l && (u.words[u.length++] = l), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
      }, i.prototype.ishrn = function (e, t, r) {
        return n(0 === this.negative), this.iushrn(e, t, r);
      }, i.prototype.shln = function (e) {
        return this.clone().ishln(e);
      }, i.prototype.ushln = function (e) {
        return this.clone().iushln(e);
      }, i.prototype.shrn = function (e) {
        return this.clone().ishrn(e);
      }, i.prototype.ushrn = function (e) {
        return this.clone().iushrn(e);
      }, i.prototype.testn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = e % 26,
          r = (e - t) / 26,
          i = 1 << t;
        return !(this.length <= r) && !!(this.words[r] & i);
      }, i.prototype.imaskn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = e % 26,
          r = (e - t) / 26;
        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
          var i = 67108863 ^ 67108863 >>> t << t;
          this.words[this.length - 1] &= i;
        }
        return this.strip();
      }, i.prototype.maskn = function (e) {
        return this.clone().imaskn(e);
      }, i.prototype.iaddn = function (e) {
        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
      }, i.prototype._iaddn = function (e) {
        this.words[0] += e;
        for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
        return this.length = Math.max(this.length, t + 1), this;
      }, i.prototype.isubn = function (e) {
        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) this.words[t] += 67108864, this.words[t + 1] -= 1;
        return this.strip();
      }, i.prototype.addn = function (e) {
        return this.clone().iaddn(e);
      }, i.prototype.subn = function (e) {
        return this.clone().isubn(e);
      }, i.prototype.iabs = function () {
        return this.negative = 0, this;
      }, i.prototype.abs = function () {
        return this.clone().iabs();
      }, i.prototype._ishlnsubmul = function (e, t, r) {
        var i,
          o,
          a = e.length + r;
        this._expand(a);
        var s = 0;
        for (i = 0; i < e.length; i++) {
          o = (0 | this.words[i + r]) + s;
          var u = (0 | e.words[i]) * t;
          s = ((o -= 67108863 & u) >> 26) - (u / 67108864 | 0), this.words[i + r] = 67108863 & o;
        }
        for (; i < this.length - r; i++) s = (o = (0 | this.words[i + r]) + s) >> 26, this.words[i + r] = 67108863 & o;
        if (0 === s) return this.strip();
        for (n(-1 === s), s = 0, i = 0; i < this.length; i++) s = (o = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & o;
        return this.negative = 1, this.strip();
      }, i.prototype._wordDiv = function (e, t) {
        var n = (this.length, e.length),
          r = this.clone(),
          o = e,
          a = 0 | o.words[o.length - 1];
        0 !== (n = 26 - this._countBits(a)) && (o = o.ushln(n), r.iushln(n), a = 0 | o.words[o.length - 1]);
        var s,
          u = r.length - o.length;
        if ("mod" !== t) {
          (s = new i(null)).length = u + 1, s.words = new Array(s.length);
          for (var c = 0; c < s.length; c++) s.words[c] = 0;
        }
        var l = r.clone()._ishlnsubmul(o, 1, u);
        0 === l.negative && (r = l, s && (s.words[u] = 1));
        for (var d = u - 1; d >= 0; d--) {
          var f = 67108864 * (0 | r.words[o.length + d]) + (0 | r.words[o.length + d - 1]);
          for (f = Math.min(f / a | 0, 67108863), r._ishlnsubmul(o, f, d); 0 !== r.negative;) f--, r.negative = 0, r._ishlnsubmul(o, 1, d), r.isZero() || (r.negative ^= 1);
          s && (s.words[d] = f);
        }
        return s && s.strip(), r.strip(), "div" !== t && 0 !== n && r.iushrn(n), {
          div: s || null,
          mod: r
        };
      }, i.prototype.divmod = function (e, t, r) {
        return n(!e.isZero()), this.isZero() ? {
          div: new i(0),
          mod: new i(0)
        } : 0 !== this.negative && 0 === e.negative ? (s = this.neg().divmod(e, t), "mod" !== t && (o = s.div.neg()), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.iadd(e)), {
          div: o,
          mod: a
        }) : 0 === this.negative && 0 !== e.negative ? (s = this.divmod(e.neg(), t), "mod" !== t && (o = s.div.neg()), {
          div: o,
          mod: s.mod
        }) : 0 != (this.negative & e.negative) ? (s = this.neg().divmod(e.neg(), t), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.isub(e)), {
          div: s.div,
          mod: a
        }) : e.length > this.length || this.cmp(e) < 0 ? {
          div: new i(0),
          mod: this
        } : 1 === e.length ? "div" === t ? {
          div: this.divn(e.words[0]),
          mod: null
        } : "mod" === t ? {
          div: null,
          mod: new i(this.modn(e.words[0]))
        } : {
          div: this.divn(e.words[0]),
          mod: new i(this.modn(e.words[0]))
        } : this._wordDiv(e, t);
        var o, a, s;
      }, i.prototype.div = function (e) {
        return this.divmod(e, "div", !1).div;
      }, i.prototype.mod = function (e) {
        return this.divmod(e, "mod", !1).mod;
      }, i.prototype.umod = function (e) {
        return this.divmod(e, "mod", !0).mod;
      }, i.prototype.divRound = function (e) {
        var t = this.divmod(e);
        if (t.mod.isZero()) return t.div;
        var n = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
          r = e.ushrn(1),
          i = e.andln(1),
          o = n.cmp(r);
        return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
      }, i.prototype.modn = function (e) {
        n(e <= 67108863);
        for (var t = (1 << 26) % e, r = 0, i = this.length - 1; i >= 0; i--) r = (t * r + (0 | this.words[i])) % e;
        return r;
      }, i.prototype.idivn = function (e) {
        n(e <= 67108863);
        for (var t = 0, r = this.length - 1; r >= 0; r--) {
          var i = (0 | this.words[r]) + 67108864 * t;
          this.words[r] = i / e | 0, t = i % e;
        }
        return this.strip();
      }, i.prototype.divn = function (e) {
        return this.clone().idivn(e);
      }, i.prototype.egcd = function (e) {
        n(0 === e.negative), n(!e.isZero());
        var t = this,
          r = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();
        for (var o = new i(1), a = new i(0), s = new i(0), u = new i(1), c = 0; t.isEven() && r.isEven();) t.iushrn(1), r.iushrn(1), ++c;
        for (var l = r.clone(), d = t.clone(); !t.isZero();) {
          for (var f = 0, h = 1; 0 == (t.words[0] & h) && f < 26; ++f, h <<= 1);
          if (f > 0) for (t.iushrn(f); f-- > 0;) (o.isOdd() || a.isOdd()) && (o.iadd(l), a.isub(d)), o.iushrn(1), a.iushrn(1);
          for (var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
          if (p > 0) for (r.iushrn(p); p-- > 0;) (s.isOdd() || u.isOdd()) && (s.iadd(l), u.isub(d)), s.iushrn(1), u.iushrn(1);
          t.cmp(r) >= 0 ? (t.isub(r), o.isub(s), a.isub(u)) : (r.isub(t), s.isub(o), u.isub(a));
        }
        return {
          a: s,
          b: u,
          gcd: r.iushln(c)
        };
      }, i.prototype._invmp = function (e) {
        n(0 === e.negative), n(!e.isZero());
        var t = this,
          r = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();
        for (var o, a = new i(1), s = new i(0), u = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;) {
          for (var c = 0, l = 1; 0 == (t.words[0] & l) && c < 26; ++c, l <<= 1);
          if (c > 0) for (t.iushrn(c); c-- > 0;) a.isOdd() && a.iadd(u), a.iushrn(1);
          for (var d = 0, f = 1; 0 == (r.words[0] & f) && d < 26; ++d, f <<= 1);
          if (d > 0) for (r.iushrn(d); d-- > 0;) s.isOdd() && s.iadd(u), s.iushrn(1);
          t.cmp(r) >= 0 ? (t.isub(r), a.isub(s)) : (r.isub(t), s.isub(a));
        }
        return (o = 0 === t.cmpn(1) ? a : s).cmpn(0) < 0 && o.iadd(e), o;
      }, i.prototype.gcd = function (e) {
        if (this.isZero()) return e.abs();
        if (e.isZero()) return this.abs();
        var t = this.clone(),
          n = e.clone();
        t.negative = 0, n.negative = 0;
        for (var r = 0; t.isEven() && n.isEven(); r++) t.iushrn(1), n.iushrn(1);
        for (;;) {
          for (; t.isEven();) t.iushrn(1);
          for (; n.isEven();) n.iushrn(1);
          var i = t.cmp(n);
          if (i < 0) {
            var o = t;
            t = n, n = o;
          } else if (0 === i || 0 === n.cmpn(1)) break;
          t.isub(n);
        }
        return n.iushln(r);
      }, i.prototype.invm = function (e) {
        return this.egcd(e).a.umod(e);
      }, i.prototype.isEven = function () {
        return 0 == (1 & this.words[0]);
      }, i.prototype.isOdd = function () {
        return 1 == (1 & this.words[0]);
      }, i.prototype.andln = function (e) {
        return this.words[0] & e;
      }, i.prototype.bincn = function (e) {
        n("number" == typeof e);
        var t = e % 26,
          r = (e - t) / 26,
          i = 1 << t;
        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
        for (var o = i, a = r; 0 !== o && a < this.length; a++) {
          var s = 0 | this.words[a];
          o = (s += o) >>> 26, s &= 67108863, this.words[a] = s;
        }
        return 0 !== o && (this.words[a] = o, this.length++), this;
      }, i.prototype.isZero = function () {
        return 1 === this.length && 0 === this.words[0];
      }, i.prototype.cmpn = function (e) {
        var t,
          r = e < 0;
        if (0 !== this.negative && !r) return -1;
        if (0 === this.negative && r) return 1;
        if (this.strip(), this.length > 1) t = 1;else {
          r && (e = -e), n(e <= 67108863, "Number is too big");
          var i = 0 | this.words[0];
          t = i === e ? 0 : i < e ? -1 : 1;
        }
        return 0 !== this.negative ? 0 | -t : t;
      }, i.prototype.cmp = function (e) {
        if (0 !== this.negative && 0 === e.negative) return -1;
        if (0 === this.negative && 0 !== e.negative) return 1;
        var t = this.ucmp(e);
        return 0 !== this.negative ? 0 | -t : t;
      }, i.prototype.ucmp = function (e) {
        if (this.length > e.length) return 1;
        if (this.length < e.length) return -1;
        for (var t = 0, n = this.length - 1; n >= 0; n--) {
          var r = 0 | this.words[n],
            i = 0 | e.words[n];
          if (r !== i) {
            r < i ? t = -1 : r > i && (t = 1);
            break;
          }
        }
        return t;
      }, i.prototype.gtn = function (e) {
        return 1 === this.cmpn(e);
      }, i.prototype.gt = function (e) {
        return 1 === this.cmp(e);
      }, i.prototype.gten = function (e) {
        return this.cmpn(e) >= 0;
      }, i.prototype.gte = function (e) {
        return this.cmp(e) >= 0;
      }, i.prototype.ltn = function (e) {
        return -1 === this.cmpn(e);
      }, i.prototype.lt = function (e) {
        return -1 === this.cmp(e);
      }, i.prototype.lten = function (e) {
        return this.cmpn(e) <= 0;
      }, i.prototype.lte = function (e) {
        return this.cmp(e) <= 0;
      }, i.prototype.eqn = function (e) {
        return 0 === this.cmpn(e);
      }, i.prototype.eq = function (e) {
        return 0 === this.cmp(e);
      }, i.red = function (e) {
        return new _(e);
      }, i.prototype.toRed = function (e) {
        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
      }, i.prototype.fromRed = function () {
        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, i.prototype._forceRed = function (e) {
        return this.red = e, this;
      }, i.prototype.forceRed = function (e) {
        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
      }, i.prototype.redAdd = function (e) {
        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
      }, i.prototype.redIAdd = function (e) {
        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
      }, i.prototype.redSub = function (e) {
        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
      }, i.prototype.redISub = function (e) {
        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
      }, i.prototype.redShl = function (e) {
        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
      }, i.prototype.redMul = function (e) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
      }, i.prototype.redIMul = function (e) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
      }, i.prototype.redSqr = function () {
        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, i.prototype.redISqr = function () {
        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, i.prototype.redSqrt = function () {
        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, i.prototype.redInvm = function () {
        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, i.prototype.redNeg = function () {
        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, i.prototype.redPow = function (e) {
        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
      };
      var g = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function v(e, t) {
        this.name = e, this.p = new i(t, 16), this.n = this.p.bitLength(), this.k = new i(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      function b() {
        v.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
      }
      function y() {
        v.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
      }
      function w() {
        v.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
      }
      function A() {
        v.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
      }
      function _(e) {
        if ("string" == typeof e) {
          var t = i._prime(e);
          this.m = t.p, this.prime = t;
        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
      }
      function E(e) {
        _.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new i(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      v.prototype._tmp = function () {
        var e = new i(null);
        return e.words = new Array(Math.ceil(this.n / 13)), e;
      }, v.prototype.ireduce = function (e) {
        var t,
          n = e;
        do {
          this.split(n, this.tmp), t = (n = (n = this.imulK(n)).iadd(this.tmp)).bitLength();
        } while (t > this.n);
        var r = t < this.n ? -1 : n.ucmp(this.p);
        return 0 === r ? (n.words[0] = 0, n.length = 1) : r > 0 ? n.isub(this.p) : void 0 !== n.strip ? n.strip() : n._strip(), n;
      }, v.prototype.split = function (e, t) {
        e.iushrn(this.n, 0, t);
      }, v.prototype.imulK = function (e) {
        return e.imul(this.k);
      }, r(b, v), b.prototype.split = function (e, t) {
        for (var n = 4194303, r = Math.min(e.length, 9), i = 0; i < r; i++) t.words[i] = e.words[i];
        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
        var o = e.words[9];
        for (t.words[t.length++] = o & n, i = 10; i < e.length; i++) {
          var a = 0 | e.words[i];
          e.words[i - 10] = (a & n) << 4 | o >>> 22, o = a;
        }
        o >>>= 22, e.words[i - 10] = o, 0 === o && e.length > 10 ? e.length -= 10 : e.length -= 9;
      }, b.prototype.imulK = function (e) {
        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
        for (var t = 0, n = 0; n < e.length; n++) {
          var r = 0 | e.words[n];
          t += 977 * r, e.words[n] = 67108863 & t, t = 64 * r + (t / 67108864 | 0);
        }
        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
      }, r(y, v), r(w, v), r(A, v), A.prototype.imulK = function (e) {
        for (var t = 0, n = 0; n < e.length; n++) {
          var r = 19 * (0 | e.words[n]) + t,
            i = 67108863 & r;
          r >>>= 26, e.words[n] = i, t = r;
        }
        return 0 !== t && (e.words[e.length++] = t), e;
      }, i._prime = function (e) {
        if (g[e]) return g[e];
        var t;
        if ("k256" === e) t = new b();else if ("p224" === e) t = new y();else if ("p192" === e) t = new w();else {
          if ("p25519" !== e) throw new Error("Unknown prime " + e);
          t = new A();
        }
        return g[e] = t, t;
      }, _.prototype._verify1 = function (e) {
        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
      }, _.prototype._verify2 = function (e, t) {
        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
      }, _.prototype.imod = function (e) {
        return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
      }, _.prototype.neg = function (e) {
        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
      }, _.prototype.add = function (e, t) {
        this._verify2(e, t);
        var n = e.add(t);
        return n.cmp(this.m) >= 0 && n.isub(this.m), n._forceRed(this);
      }, _.prototype.iadd = function (e, t) {
        this._verify2(e, t);
        var n = e.iadd(t);
        return n.cmp(this.m) >= 0 && n.isub(this.m), n;
      }, _.prototype.sub = function (e, t) {
        this._verify2(e, t);
        var n = e.sub(t);
        return n.cmpn(0) < 0 && n.iadd(this.m), n._forceRed(this);
      }, _.prototype.isub = function (e, t) {
        this._verify2(e, t);
        var n = e.isub(t);
        return n.cmpn(0) < 0 && n.iadd(this.m), n;
      }, _.prototype.shl = function (e, t) {
        return this._verify1(e), this.imod(e.ushln(t));
      }, _.prototype.imul = function (e, t) {
        return this._verify2(e, t), this.imod(e.imul(t));
      }, _.prototype.mul = function (e, t) {
        return this._verify2(e, t), this.imod(e.mul(t));
      }, _.prototype.isqr = function (e) {
        return this.imul(e, e.clone());
      }, _.prototype.sqr = function (e) {
        return this.mul(e, e);
      }, _.prototype.sqrt = function (e) {
        if (e.isZero()) return e.clone();
        var t = this.m.andln(3);
        if (n(t % 2 == 1), 3 === t) {
          var r = this.m.add(new i(1)).iushrn(2);
          return this.pow(e, r);
        }
        for (var o = this.m.subn(1), a = 0; !o.isZero() && 0 === o.andln(1);) a++, o.iushrn(1);
        n(!o.isZero());
        var s = new i(1).toRed(this),
          u = s.redNeg(),
          c = this.m.subn(1).iushrn(1),
          l = this.m.bitLength();
        for (l = new i(2 * l * l).toRed(this); 0 !== this.pow(l, c).cmp(u);) l.redIAdd(u);
        for (var d = this.pow(l, o), f = this.pow(e, o.addn(1).iushrn(1)), h = this.pow(e, o), p = a; 0 !== h.cmp(s);) {
          for (var m = h, g = 0; 0 !== m.cmp(s); g++) m = m.redSqr();
          n(g < p);
          var v = this.pow(d, new i(1).iushln(p - g - 1));
          f = f.redMul(v), d = v.redSqr(), h = h.redMul(d), p = g;
        }
        return f;
      }, _.prototype.invm = function (e) {
        var t = e._invmp(this.m);
        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
      }, _.prototype.pow = function (e, t) {
        if (t.isZero()) return new i(1).toRed(this);
        if (0 === t.cmpn(1)) return e.clone();
        var n = new Array(16);
        n[0] = new i(1).toRed(this), n[1] = e;
        for (var r = 2; r < n.length; r++) n[r] = this.mul(n[r - 1], e);
        var o = n[0],
          a = 0,
          s = 0,
          u = t.bitLength() % 26;
        for (0 === u && (u = 26), r = t.length - 1; r >= 0; r--) {
          for (var c = t.words[r], l = u - 1; l >= 0; l--) {
            var d = c >> l & 1;
            o !== n[0] && (o = this.sqr(o)), 0 !== d || 0 !== a ? (a <<= 1, a |= d, (4 === ++s || 0 === r && 0 === l) && (o = this.mul(o, n[a]), s = 0, a = 0)) : s = 0;
          }
          u = 26;
        }
        return o;
      }, _.prototype.convertTo = function (e) {
        var t = e.umod(this.m);
        return t === e ? t.clone() : t;
      }, _.prototype.convertFrom = function (e) {
        var t = e.clone();
        return t.red = null, t;
      }, i.mont = function (e) {
        return new E(e);
      }, r(E, _), E.prototype.convertTo = function (e) {
        return this.imod(e.ushln(this.shift));
      }, E.prototype.convertFrom = function (e) {
        var t = this.imod(e.mul(this.rinv));
        return t.red = null, t;
      }, E.prototype.imul = function (e, t) {
        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
        var n = e.imul(t),
          r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          i = n.isub(r).iushrn(this.shift),
          o = i;
        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
      }, E.prototype.mul = function (e, t) {
        if (e.isZero() || t.isZero()) return new i(0)._forceRed(this);
        var n = e.mul(t),
          r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          o = n.isub(r).iushrn(this.shift),
          a = o;
        return o.cmp(this.m) >= 0 ? a = o.isub(this.m) : o.cmpn(0) < 0 && (a = o.iadd(this.m)), a._forceRed(this);
      }, E.prototype.invm = function (e) {
        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
      };
    }(e, n);
  }(mg);
  var gg = mg.exports,
    vg = bg;
  function bg(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
  }
  bg.equal = function (e, t, n) {
    if (e != t) throw new Error(n || "Assertion failed: " + e + " != " + t);
  };
  var yg = {};
  !function (e) {
    var t = e;
    function n(e) {
      return 1 === e.length ? "0" + e : e;
    }
    function r(e) {
      for (var t = "", r = 0; r < e.length; r++) t += n(e[r].toString(16));
      return t;
    }
    t.toArray = function (e, t) {
      if (Array.isArray(e)) return e.slice();
      if (!e) return [];
      var n = [];
      if ("string" != typeof e) {
        for (var r = 0; r < e.length; r++) n[r] = 0 | e[r];
        return n;
      }
      if ("hex" === t) {
        (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);
        for (r = 0; r < e.length; r += 2) n.push(parseInt(e[r] + e[r + 1], 16));
      } else for (r = 0; r < e.length; r++) {
        var i = e.charCodeAt(r),
          o = i >> 8,
          a = 255 & i;
        o ? n.push(o, a) : n.push(a);
      }
      return n;
    }, t.zero2 = n, t.toHex = r, t.encode = function (e, t) {
      return "hex" === t ? r(e) : e;
    };
  }(yg), function (e) {
    var t = e,
      n = gg,
      r = vg,
      i = yg;
    t.assert = r, t.toArray = i.toArray, t.zero2 = i.zero2, t.toHex = i.toHex, t.encode = i.encode, t.getNAF = function (e, t, n) {
      var r = new Array(Math.max(e.bitLength(), n) + 1);
      r.fill(0);
      for (var i = 1 << t + 1, o = e.clone(), a = 0; a < r.length; a++) {
        var s,
          u = o.andln(i - 1);
        o.isOdd() ? (s = u > (i >> 1) - 1 ? (i >> 1) - u : u, o.isubn(s)) : s = 0, r[a] = s, o.iushrn(1);
      }
      return r;
    }, t.getJSF = function (e, t) {
      var n = [[], []];
      e = e.clone(), t = t.clone();
      for (var r, i = 0, o = 0; e.cmpn(-i) > 0 || t.cmpn(-o) > 0;) {
        var a,
          s,
          u = e.andln(3) + i & 3,
          c = t.andln(3) + o & 3;
        3 === u && (u = -1), 3 === c && (c = -1), a = 0 == (1 & u) ? 0 : 3 !== (r = e.andln(7) + i & 7) && 5 !== r || 2 !== c ? u : -u, n[0].push(a), s = 0 == (1 & c) ? 0 : 3 !== (r = t.andln(7) + o & 7) && 5 !== r || 2 !== u ? c : -c, n[1].push(s), 2 * i === a + 1 && (i = 1 - i), 2 * o === s + 1 && (o = 1 - o), e.iushrn(1), t.iushrn(1);
      }
      return n;
    }, t.cachedProperty = function (e, t, n) {
      var r = "_" + t;
      e.prototype[t] = function () {
        return void 0 !== this[r] ? this[r] : this[r] = n.call(this);
      };
    }, t.parseBytes = function (e) {
      return "string" == typeof e ? t.toArray(e, "hex") : e;
    }, t.intFromLE = function (e) {
      return new n(e, "hex", "le");
    };
  }(pg);
  var wg,
    Ag = {
      exports: {}
    };
  function _g(e) {
    this.rand = e;
  }
  if (Ag.exports = function (e) {
    return wg || (wg = new _g(null)), wg.generate(e);
  }, Ag.exports.Rand = _g, _g.prototype.generate = function (e) {
    return this._rand(e);
  }, _g.prototype._rand = function (e) {
    if (this.rand.getBytes) return this.rand.getBytes(e);
    for (var t = new Uint8Array(e), n = 0; n < t.length; n++) t[n] = this.rand.getByte();
    return t;
  }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? _g.prototype._rand = function (e) {
    var t = new Uint8Array(e);
    return self.crypto.getRandomValues(t), t;
  } : self.msCrypto && self.msCrypto.getRandomValues ? _g.prototype._rand = function (e) {
    var t = new Uint8Array(e);
    return self.msCrypto.getRandomValues(t), t;
  } : "object" == typeof window && (_g.prototype._rand = function () {
    throw new Error("Not implemented yet");
  });else try {
    var Eg = Fm();
    if ("function" != typeof Eg.randomBytes) throw new Error("Not supported");
    _g.prototype._rand = function (e) {
      return Eg.randomBytes(e);
    };
  } catch (a) {}
  var Sg = Ag.exports,
    kg = {},
    Mg = gg,
    Cg = pg,
    xg = Cg.getNAF,
    Rg = Cg.getJSF,
    Ig = Cg.assert;
  function Tg(e, t) {
    this.type = e, this.p = new Mg(t.p, 16), this.red = t.prime ? Mg.red(t.prime) : Mg.mont(this.p), this.zero = new Mg(0).toRed(this.red), this.one = new Mg(1).toRed(this.red), this.two = new Mg(2).toRed(this.red), this.n = t.n && new Mg(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var n = this.n && this.p.div(this.n);
    !n || n.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  var Pg = Tg;
  function Og(e, t) {
    this.curve = e, this.type = t, this.precomputed = null;
  }
  Tg.prototype.point = function () {
    throw new Error("Not implemented");
  }, Tg.prototype.validate = function () {
    throw new Error("Not implemented");
  }, Tg.prototype._fixedNafMul = function (e, t) {
    Ig(e.precomputed);
    var n = e._getDoubles(),
      r = xg(t, 1, this._bitLength),
      i = (1 << n.step + 1) - (n.step % 2 == 0 ? 2 : 1);
    i /= 3;
    var o,
      a,
      s = [];
    for (o = 0; o < r.length; o += n.step) {
      a = 0;
      for (var u = o + n.step - 1; u >= o; u--) a = (a << 1) + r[u];
      s.push(a);
    }
    for (var c = this.jpoint(null, null, null), l = this.jpoint(null, null, null), d = i; d > 0; d--) {
      for (o = 0; o < s.length; o++) (a = s[o]) === d ? l = l.mixedAdd(n.points[o]) : a === -d && (l = l.mixedAdd(n.points[o].neg()));
      c = c.add(l);
    }
    return c.toP();
  }, Tg.prototype._wnafMul = function (e, t) {
    var n = 4,
      r = e._getNAFPoints(n);
    n = r.wnd;
    for (var i = r.points, o = xg(t, n, this._bitLength), a = this.jpoint(null, null, null), s = o.length - 1; s >= 0; s--) {
      for (var u = 0; s >= 0 && 0 === o[s]; s--) u++;
      if (s >= 0 && u++, a = a.dblp(u), s < 0) break;
      var c = o[s];
      Ig(0 !== c), a = "affine" === e.type ? c > 0 ? a.mixedAdd(i[c - 1 >> 1]) : a.mixedAdd(i[-c - 1 >> 1].neg()) : c > 0 ? a.add(i[c - 1 >> 1]) : a.add(i[-c - 1 >> 1].neg());
    }
    return "affine" === e.type ? a.toP() : a;
  }, Tg.prototype._wnafMulAdd = function (e, t, n, r, i) {
    var o,
      a,
      s,
      u = this._wnafT1,
      c = this._wnafT2,
      l = this._wnafT3,
      d = 0;
    for (o = 0; o < r; o++) {
      var f = (s = t[o])._getNAFPoints(e);
      u[o] = f.wnd, c[o] = f.points;
    }
    for (o = r - 1; o >= 1; o -= 2) {
      var h = o - 1,
        p = o;
      if (1 === u[h] && 1 === u[p]) {
        var m = [t[h], null, null, t[p]];
        0 === t[h].y.cmp(t[p].y) ? (m[1] = t[h].add(t[p]), m[2] = t[h].toJ().mixedAdd(t[p].neg())) : 0 === t[h].y.cmp(t[p].y.redNeg()) ? (m[1] = t[h].toJ().mixedAdd(t[p]), m[2] = t[h].add(t[p].neg())) : (m[1] = t[h].toJ().mixedAdd(t[p]), m[2] = t[h].toJ().mixedAdd(t[p].neg()));
        var g = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
          v = Rg(n[h], n[p]);
        for (d = Math.max(v[0].length, d), l[h] = new Array(d), l[p] = new Array(d), a = 0; a < d; a++) {
          var b = 0 | v[0][a],
            y = 0 | v[1][a];
          l[h][a] = g[3 * (b + 1) + (y + 1)], l[p][a] = 0, c[h] = m;
        }
      } else l[h] = xg(n[h], u[h], this._bitLength), l[p] = xg(n[p], u[p], this._bitLength), d = Math.max(l[h].length, d), d = Math.max(l[p].length, d);
    }
    var w = this.jpoint(null, null, null),
      A = this._wnafT4;
    for (o = d; o >= 0; o--) {
      for (var _ = 0; o >= 0;) {
        var E = !0;
        for (a = 0; a < r; a++) A[a] = 0 | l[a][o], 0 !== A[a] && (E = !1);
        if (!E) break;
        _++, o--;
      }
      if (o >= 0 && _++, w = w.dblp(_), o < 0) break;
      for (a = 0; a < r; a++) {
        var S = A[a];
        0 !== S && (S > 0 ? s = c[a][S - 1 >> 1] : S < 0 && (s = c[a][-S - 1 >> 1].neg()), w = "affine" === s.type ? w.mixedAdd(s) : w.add(s));
      }
    }
    for (o = 0; o < r; o++) c[o] = null;
    return i ? w : w.toP();
  }, Tg.BasePoint = Og, Og.prototype.eq = function () {
    throw new Error("Not implemented");
  }, Og.prototype.validate = function () {
    return this.curve.validate(this);
  }, Tg.prototype.decodePoint = function (e, t) {
    e = Cg.toArray(e, t);
    var n = this.p.byteLength();
    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * n) return 6 === e[0] ? Ig(e[e.length - 1] % 2 == 0) : 7 === e[0] && Ig(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + n), e.slice(1 + n, 1 + 2 * n));
    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === n) return this.pointFromX(e.slice(1, 1 + n), 3 === e[0]);
    throw new Error("Unknown point format");
  }, Og.prototype.encodeCompressed = function (e) {
    return this.encode(e, !0);
  }, Og.prototype._encode = function (e) {
    var t = this.curve.p.byteLength(),
      n = this.getX().toArray("be", t);
    return e ? [this.getY().isEven() ? 2 : 3].concat(n) : [4].concat(n, this.getY().toArray("be", t));
  }, Og.prototype.encode = function (e, t) {
    return Cg.encode(this._encode(t), e);
  }, Og.prototype.precompute = function (e) {
    if (this.precomputed) return this;
    var t = {
      doubles: null,
      naf: null,
      beta: null
    };
    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
  }, Og.prototype._hasDoubles = function (e) {
    if (!this.precomputed) return !1;
    var t = this.precomputed.doubles;
    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
  }, Og.prototype._getDoubles = function (e, t) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    for (var n = [this], r = this, i = 0; i < t; i += e) {
      for (var o = 0; o < e; o++) r = r.dbl();
      n.push(r);
    }
    return {
      step: e,
      points: n
    };
  }, Og.prototype._getNAFPoints = function (e) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    for (var t = [this], n = (1 << e) - 1, r = 1 === n ? null : this.dbl(), i = 1; i < n; i++) t[i] = t[i - 1].add(r);
    return {
      wnd: e,
      points: t
    };
  }, Og.prototype._getBeta = function () {
    return null;
  }, Og.prototype.dblp = function (e) {
    for (var t = this, n = 0; n < e; n++) t = t.dbl();
    return t;
  };
  var Lg = {
    exports: {}
  };
  "function" == typeof Object.create ? Lg.exports = function (e, t) {
    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : Lg.exports = function (e, t) {
    if (t) {
      e.super_ = t;
      var n = function () {};
      n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
    }
  };
  var Ng = Lg.exports,
    Dg = gg,
    Bg = Ng,
    jg = Pg,
    Fg = pg.assert;
  function zg(e) {
    jg.call(this, "short", e), this.a = new Dg(e.a, 16).toRed(this.red), this.b = new Dg(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  Bg(zg, jg);
  var Ug = zg;
  function qg(e, t, n, r) {
    jg.BasePoint.call(this, e, "affine"), null === t && null === n ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new Dg(t, 16), this.y = new Dg(n, 16), r && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  function Kg(e, t, n, r) {
    jg.BasePoint.call(this, e, "jacobian"), null === t && null === n && null === r ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new Dg(0)) : (this.x = new Dg(t, 16), this.y = new Dg(n, 16), this.z = new Dg(r, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  zg.prototype._getEndomorphism = function (e) {
    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
      var t, n;
      if (e.beta) t = new Dg(e.beta, 16).toRed(this.red);else {
        var r = this._getEndoRoots(this.p);
        t = (t = r[0].cmp(r[1]) < 0 ? r[0] : r[1]).toRed(this.red);
      }
      if (e.lambda) n = new Dg(e.lambda, 16);else {
        var i = this._getEndoRoots(this.n);
        0 === this.g.mul(i[0]).x.cmp(this.g.x.redMul(t)) ? n = i[0] : (n = i[1], Fg(0 === this.g.mul(n).x.cmp(this.g.x.redMul(t))));
      }
      return {
        beta: t,
        lambda: n,
        basis: e.basis ? e.basis.map(function (e) {
          return {
            a: new Dg(e.a, 16),
            b: new Dg(e.b, 16)
          };
        }) : this._getEndoBasis(n)
      };
    }
  }, zg.prototype._getEndoRoots = function (e) {
    var t = e === this.p ? this.red : Dg.mont(e),
      n = new Dg(2).toRed(t).redInvm(),
      r = n.redNeg(),
      i = new Dg(3).toRed(t).redNeg().redSqrt().redMul(n);
    return [r.redAdd(i).fromRed(), r.redSub(i).fromRed()];
  }, zg.prototype._getEndoBasis = function (e) {
    for (var t, n, r, i, o, a, s, u, c, l = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), d = e, f = this.n.clone(), h = new Dg(1), p = new Dg(0), m = new Dg(0), g = new Dg(1), v = 0; 0 !== d.cmpn(0);) {
      var b = f.div(d);
      u = f.sub(b.mul(d)), c = m.sub(b.mul(h));
      var y = g.sub(b.mul(p));
      if (!r && u.cmp(l) < 0) t = s.neg(), n = h, r = u.neg(), i = c;else if (r && 2 == ++v) break;
      s = u, f = d, d = u, m = h, h = c, g = p, p = y;
    }
    o = u.neg(), a = c;
    var w = r.sqr().add(i.sqr());
    return o.sqr().add(a.sqr()).cmp(w) >= 0 && (o = t, a = n), r.negative && (r = r.neg(), i = i.neg()), o.negative && (o = o.neg(), a = a.neg()), [{
      a: r,
      b: i
    }, {
      a: o,
      b: a
    }];
  }, zg.prototype._endoSplit = function (e) {
    var t = this.endo.basis,
      n = t[0],
      r = t[1],
      i = r.b.mul(e).divRound(this.n),
      o = n.b.neg().mul(e).divRound(this.n),
      a = i.mul(n.a),
      s = o.mul(r.a),
      u = i.mul(n.b),
      c = o.mul(r.b);
    return {
      k1: e.sub(a).sub(s),
      k2: u.add(c).neg()
    };
  }, zg.prototype.pointFromX = function (e, t) {
    (e = new Dg(e, 16)).red || (e = e.toRed(this.red));
    var n = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),
      r = n.redSqrt();
    if (0 !== r.redSqr().redSub(n).cmp(this.zero)) throw new Error("invalid point");
    var i = r.fromRed().isOdd();
    return (t && !i || !t && i) && (r = r.redNeg()), this.point(e, r);
  }, zg.prototype.validate = function (e) {
    if (e.inf) return !0;
    var t = e.x,
      n = e.y,
      r = this.a.redMul(t),
      i = t.redSqr().redMul(t).redIAdd(r).redIAdd(this.b);
    return 0 === n.redSqr().redISub(i).cmpn(0);
  }, zg.prototype._endoWnafMulAdd = function (e, t, n) {
    for (var r = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < e.length; o++) {
      var a = this._endoSplit(t[o]),
        s = e[o],
        u = s._getBeta();
      a.k1.negative && (a.k1.ineg(), s = s.neg(!0)), a.k2.negative && (a.k2.ineg(), u = u.neg(!0)), r[2 * o] = s, r[2 * o + 1] = u, i[2 * o] = a.k1, i[2 * o + 1] = a.k2;
    }
    for (var c = this._wnafMulAdd(1, r, i, 2 * o, n), l = 0; l < 2 * o; l++) r[l] = null, i[l] = null;
    return c;
  }, Bg(qg, jg.BasePoint), zg.prototype.point = function (e, t, n) {
    return new qg(this, e, t, n);
  }, zg.prototype.pointFromJSON = function (e, t) {
    return qg.fromJSON(this, e, t);
  }, qg.prototype._getBeta = function () {
    if (this.curve.endo) {
      var e = this.precomputed;
      if (e && e.beta) return e.beta;
      var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (e) {
        var n = this.curve,
          r = function (e) {
            return n.point(e.x.redMul(n.endo.beta), e.y);
          };
        e.beta = t, t.precomputed = {
          beta: null,
          naf: e.naf && {
            wnd: e.naf.wnd,
            points: e.naf.points.map(r)
          },
          doubles: e.doubles && {
            step: e.doubles.step,
            points: e.doubles.points.map(r)
          }
        };
      }
      return t;
    }
  }, qg.prototype.toJSON = function () {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, qg.fromJSON = function (e, t, n) {
    "string" == typeof t && (t = JSON.parse(t));
    var r = e.point(t[0], t[1], n);
    if (!t[2]) return r;
    function i(t) {
      return e.point(t[0], t[1], n);
    }
    var o = t[2];
    return r.precomputed = {
      beta: null,
      doubles: o.doubles && {
        step: o.doubles.step,
        points: [r].concat(o.doubles.points.map(i))
      },
      naf: o.naf && {
        wnd: o.naf.wnd,
        points: [r].concat(o.naf.points.map(i))
      }
    }, r;
  }, qg.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, qg.prototype.isInfinity = function () {
    return this.inf;
  }, qg.prototype.add = function (e) {
    if (this.inf) return e;
    if (e.inf) return this;
    if (this.eq(e)) return this.dbl();
    if (this.neg().eq(e)) return this.curve.point(null, null);
    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
    var t = this.y.redSub(e.y);
    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
    var n = t.redSqr().redISub(this.x).redISub(e.x),
      r = t.redMul(this.x.redSub(n)).redISub(this.y);
    return this.curve.point(n, r);
  }, qg.prototype.dbl = function () {
    if (this.inf) return this;
    var e = this.y.redAdd(this.y);
    if (0 === e.cmpn(0)) return this.curve.point(null, null);
    var t = this.curve.a,
      n = this.x.redSqr(),
      r = e.redInvm(),
      i = n.redAdd(n).redIAdd(n).redIAdd(t).redMul(r),
      o = i.redSqr().redISub(this.x.redAdd(this.x)),
      a = i.redMul(this.x.redSub(o)).redISub(this.y);
    return this.curve.point(o, a);
  }, qg.prototype.getX = function () {
    return this.x.fromRed();
  }, qg.prototype.getY = function () {
    return this.y.fromRed();
  }, qg.prototype.mul = function (e) {
    return e = new Dg(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
  }, qg.prototype.mulAdd = function (e, t, n) {
    var r = [this, t],
      i = [e, n];
    return this.curve.endo ? this.curve._endoWnafMulAdd(r, i) : this.curve._wnafMulAdd(1, r, i, 2);
  }, qg.prototype.jmulAdd = function (e, t, n) {
    var r = [this, t],
      i = [e, n];
    return this.curve.endo ? this.curve._endoWnafMulAdd(r, i, !0) : this.curve._wnafMulAdd(1, r, i, 2, !0);
  }, qg.prototype.eq = function (e) {
    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
  }, qg.prototype.neg = function (e) {
    if (this.inf) return this;
    var t = this.curve.point(this.x, this.y.redNeg());
    if (e && this.precomputed) {
      var n = this.precomputed,
        r = function (e) {
          return e.neg();
        };
      t.precomputed = {
        naf: n.naf && {
          wnd: n.naf.wnd,
          points: n.naf.points.map(r)
        },
        doubles: n.doubles && {
          step: n.doubles.step,
          points: n.doubles.points.map(r)
        }
      };
    }
    return t;
  }, qg.prototype.toJ = function () {
    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
  }, Bg(Kg, jg.BasePoint), zg.prototype.jpoint = function (e, t, n) {
    return new Kg(this, e, t, n);
  }, Kg.prototype.toP = function () {
    if (this.isInfinity()) return this.curve.point(null, null);
    var e = this.z.redInvm(),
      t = e.redSqr(),
      n = this.x.redMul(t),
      r = this.y.redMul(t).redMul(e);
    return this.curve.point(n, r);
  }, Kg.prototype.neg = function () {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, Kg.prototype.add = function (e) {
    if (this.isInfinity()) return e;
    if (e.isInfinity()) return this;
    var t = e.z.redSqr(),
      n = this.z.redSqr(),
      r = this.x.redMul(t),
      i = e.x.redMul(n),
      o = this.y.redMul(t.redMul(e.z)),
      a = e.y.redMul(n.redMul(this.z)),
      s = r.redSub(i),
      u = o.redSub(a);
    if (0 === s.cmpn(0)) return 0 !== u.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
    var c = s.redSqr(),
      l = c.redMul(s),
      d = r.redMul(c),
      f = u.redSqr().redIAdd(l).redISub(d).redISub(d),
      h = u.redMul(d.redISub(f)).redISub(o.redMul(l)),
      p = this.z.redMul(e.z).redMul(s);
    return this.curve.jpoint(f, h, p);
  }, Kg.prototype.mixedAdd = function (e) {
    if (this.isInfinity()) return e.toJ();
    if (e.isInfinity()) return this;
    var t = this.z.redSqr(),
      n = this.x,
      r = e.x.redMul(t),
      i = this.y,
      o = e.y.redMul(t).redMul(this.z),
      a = n.redSub(r),
      s = i.redSub(o);
    if (0 === a.cmpn(0)) return 0 !== s.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
    var u = a.redSqr(),
      c = u.redMul(a),
      l = n.redMul(u),
      d = s.redSqr().redIAdd(c).redISub(l).redISub(l),
      f = s.redMul(l.redISub(d)).redISub(i.redMul(c)),
      h = this.z.redMul(a);
    return this.curve.jpoint(d, f, h);
  }, Kg.prototype.dblp = function (e) {
    if (0 === e) return this;
    if (this.isInfinity()) return this;
    if (!e) return this.dbl();
    var t;
    if (this.curve.zeroA || this.curve.threeA) {
      var n = this;
      for (t = 0; t < e; t++) n = n.dbl();
      return n;
    }
    var r = this.curve.a,
      i = this.curve.tinv,
      o = this.x,
      a = this.y,
      s = this.z,
      u = s.redSqr().redSqr(),
      c = a.redAdd(a);
    for (t = 0; t < e; t++) {
      var l = o.redSqr(),
        d = c.redSqr(),
        f = d.redSqr(),
        h = l.redAdd(l).redIAdd(l).redIAdd(r.redMul(u)),
        p = o.redMul(d),
        m = h.redSqr().redISub(p.redAdd(p)),
        g = p.redISub(m),
        v = h.redMul(g);
      v = v.redIAdd(v).redISub(f);
      var b = c.redMul(s);
      t + 1 < e && (u = u.redMul(f)), o = m, s = b, c = v;
    }
    return this.curve.jpoint(o, c.redMul(i), s);
  }, Kg.prototype.dbl = function () {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, Kg.prototype._zeroDbl = function () {
    var e, t, n;
    if (this.zOne) {
      var r = this.x.redSqr(),
        i = this.y.redSqr(),
        o = i.redSqr(),
        a = this.x.redAdd(i).redSqr().redISub(r).redISub(o);
      a = a.redIAdd(a);
      var s = r.redAdd(r).redIAdd(r),
        u = s.redSqr().redISub(a).redISub(a),
        c = o.redIAdd(o);
      c = (c = c.redIAdd(c)).redIAdd(c), e = u, t = s.redMul(a.redISub(u)).redISub(c), n = this.y.redAdd(this.y);
    } else {
      var l = this.x.redSqr(),
        d = this.y.redSqr(),
        f = d.redSqr(),
        h = this.x.redAdd(d).redSqr().redISub(l).redISub(f);
      h = h.redIAdd(h);
      var p = l.redAdd(l).redIAdd(l),
        m = p.redSqr(),
        g = f.redIAdd(f);
      g = (g = g.redIAdd(g)).redIAdd(g), e = m.redISub(h).redISub(h), t = p.redMul(h.redISub(e)).redISub(g), n = (n = this.y.redMul(this.z)).redIAdd(n);
    }
    return this.curve.jpoint(e, t, n);
  }, Kg.prototype._threeDbl = function () {
    var e, t, n;
    if (this.zOne) {
      var r = this.x.redSqr(),
        i = this.y.redSqr(),
        o = i.redSqr(),
        a = this.x.redAdd(i).redSqr().redISub(r).redISub(o);
      a = a.redIAdd(a);
      var s = r.redAdd(r).redIAdd(r).redIAdd(this.curve.a),
        u = s.redSqr().redISub(a).redISub(a);
      e = u;
      var c = o.redIAdd(o);
      c = (c = c.redIAdd(c)).redIAdd(c), t = s.redMul(a.redISub(u)).redISub(c), n = this.y.redAdd(this.y);
    } else {
      var l = this.z.redSqr(),
        d = this.y.redSqr(),
        f = this.x.redMul(d),
        h = this.x.redSub(l).redMul(this.x.redAdd(l));
      h = h.redAdd(h).redIAdd(h);
      var p = f.redIAdd(f),
        m = (p = p.redIAdd(p)).redAdd(p);
      e = h.redSqr().redISub(m), n = this.y.redAdd(this.z).redSqr().redISub(d).redISub(l);
      var g = d.redSqr();
      g = (g = (g = g.redIAdd(g)).redIAdd(g)).redIAdd(g), t = h.redMul(p.redISub(e)).redISub(g);
    }
    return this.curve.jpoint(e, t, n);
  }, Kg.prototype._dbl = function () {
    var e = this.curve.a,
      t = this.x,
      n = this.y,
      r = this.z,
      i = r.redSqr().redSqr(),
      o = t.redSqr(),
      a = n.redSqr(),
      s = o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)),
      u = t.redAdd(t),
      c = (u = u.redIAdd(u)).redMul(a),
      l = s.redSqr().redISub(c.redAdd(c)),
      d = c.redISub(l),
      f = a.redSqr();
    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
    var h = s.redMul(d).redISub(f),
      p = n.redAdd(n).redMul(r);
    return this.curve.jpoint(l, h, p);
  }, Kg.prototype.trpl = function () {
    if (!this.curve.zeroA) return this.dbl().add(this);
    var e = this.x.redSqr(),
      t = this.y.redSqr(),
      n = this.z.redSqr(),
      r = t.redSqr(),
      i = e.redAdd(e).redIAdd(e),
      o = i.redSqr(),
      a = this.x.redAdd(t).redSqr().redISub(e).redISub(r),
      s = (a = (a = (a = a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(),
      u = r.redIAdd(r);
    u = (u = (u = u.redIAdd(u)).redIAdd(u)).redIAdd(u);
    var c = i.redIAdd(a).redSqr().redISub(o).redISub(s).redISub(u),
      l = t.redMul(c);
    l = (l = l.redIAdd(l)).redIAdd(l);
    var d = this.x.redMul(s).redISub(l);
    d = (d = d.redIAdd(d)).redIAdd(d);
    var f = this.y.redMul(c.redMul(u.redISub(c)).redISub(a.redMul(s)));
    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
    var h = this.z.redAdd(a).redSqr().redISub(n).redISub(s);
    return this.curve.jpoint(d, f, h);
  }, Kg.prototype.mul = function (e, t) {
    return e = new Dg(e, t), this.curve._wnafMul(this, e);
  }, Kg.prototype.eq = function (e) {
    if ("affine" === e.type) return this.eq(e.toJ());
    if (this === e) return !0;
    var t = this.z.redSqr(),
      n = e.z.redSqr();
    if (0 !== this.x.redMul(n).redISub(e.x.redMul(t)).cmpn(0)) return !1;
    var r = t.redMul(this.z),
      i = n.redMul(e.z);
    return 0 === this.y.redMul(i).redISub(e.y.redMul(r)).cmpn(0);
  }, Kg.prototype.eqXToP = function (e) {
    var t = this.z.redSqr(),
      n = e.toRed(this.curve.red).redMul(t);
    if (0 === this.x.cmp(n)) return !0;
    for (var r = e.clone(), i = this.curve.redN.redMul(t);;) {
      if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
      if (n.redIAdd(i), 0 === this.x.cmp(n)) return !0;
    }
  }, Kg.prototype.inspect = function () {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, Kg.prototype.isInfinity = function () {
    return 0 === this.z.cmpn(0);
  };
  var Hg = gg,
    Vg = Ng,
    $g = Pg,
    Wg = pg;
  function Yg(e) {
    $g.call(this, "mont", e), this.a = new Hg(e.a, 16).toRed(this.red), this.b = new Hg(e.b, 16).toRed(this.red), this.i4 = new Hg(4).toRed(this.red).redInvm(), this.two = new Hg(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  Vg(Yg, $g);
  var Gg = Yg;
  function Qg(e, t, n) {
    $g.BasePoint.call(this, e, "projective"), null === t && null === n ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new Hg(t, 16), this.z = new Hg(n, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  Yg.prototype.validate = function (e) {
    var t = e.normalize().x,
      n = t.redSqr(),
      r = n.redMul(t).redAdd(n.redMul(this.a)).redAdd(t);
    return 0 === r.redSqrt().redSqr().cmp(r);
  }, Vg(Qg, $g.BasePoint), Yg.prototype.decodePoint = function (e, t) {
    return this.point(Wg.toArray(e, t), 1);
  }, Yg.prototype.point = function (e, t) {
    return new Qg(this, e, t);
  }, Yg.prototype.pointFromJSON = function (e) {
    return Qg.fromJSON(this, e);
  }, Qg.prototype.precompute = function () {}, Qg.prototype._encode = function () {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, Qg.fromJSON = function (e, t) {
    return new Qg(e, t[0], t[1] || e.one);
  }, Qg.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, Qg.prototype.isInfinity = function () {
    return 0 === this.z.cmpn(0);
  }, Qg.prototype.dbl = function () {
    var e = this.x.redAdd(this.z).redSqr(),
      t = this.x.redSub(this.z).redSqr(),
      n = e.redSub(t),
      r = e.redMul(t),
      i = n.redMul(t.redAdd(this.curve.a24.redMul(n)));
    return this.curve.point(r, i);
  }, Qg.prototype.add = function () {
    throw new Error("Not supported on Montgomery curve");
  }, Qg.prototype.diffAdd = function (e, t) {
    var n = this.x.redAdd(this.z),
      r = this.x.redSub(this.z),
      i = e.x.redAdd(e.z),
      o = e.x.redSub(e.z).redMul(n),
      a = i.redMul(r),
      s = t.z.redMul(o.redAdd(a).redSqr()),
      u = t.x.redMul(o.redISub(a).redSqr());
    return this.curve.point(s, u);
  }, Qg.prototype.mul = function (e) {
    for (var t = e.clone(), n = this, r = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1)) i.push(t.andln(1));
    for (var o = i.length - 1; o >= 0; o--) 0 === i[o] ? (n = n.diffAdd(r, this), r = r.dbl()) : (r = n.diffAdd(r, this), n = n.dbl());
    return r;
  }, Qg.prototype.mulAdd = function () {
    throw new Error("Not supported on Montgomery curve");
  }, Qg.prototype.jumlAdd = function () {
    throw new Error("Not supported on Montgomery curve");
  }, Qg.prototype.eq = function (e) {
    return 0 === this.getX().cmp(e.getX());
  }, Qg.prototype.normalize = function () {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, Qg.prototype.getX = function () {
    return this.normalize(), this.x.fromRed();
  };
  var Zg = gg,
    Jg = Ng,
    Xg = Pg,
    ev = pg.assert;
  function tv(e) {
    this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, Xg.call(this, "edwards", e), this.a = new Zg(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new Zg(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new Zg(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), ev(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
  }
  Jg(tv, Xg);
  var nv = tv;
  function rv(e, t, n, r, i) {
    Xg.BasePoint.call(this, e, "projective"), null === t && null === n && null === r ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new Zg(t, 16), this.y = new Zg(n, 16), this.z = r ? new Zg(r, 16) : this.curve.one, this.t = i && new Zg(i, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  tv.prototype._mulA = function (e) {
    return this.mOneA ? e.redNeg() : this.a.redMul(e);
  }, tv.prototype._mulC = function (e) {
    return this.oneC ? e : this.c.redMul(e);
  }, tv.prototype.jpoint = function (e, t, n, r) {
    return this.point(e, t, n, r);
  }, tv.prototype.pointFromX = function (e, t) {
    (e = new Zg(e, 16)).red || (e = e.toRed(this.red));
    var n = e.redSqr(),
      r = this.c2.redSub(this.a.redMul(n)),
      i = this.one.redSub(this.c2.redMul(this.d).redMul(n)),
      o = r.redMul(i.redInvm()),
      a = o.redSqrt();
    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
    var s = a.fromRed().isOdd();
    return (t && !s || !t && s) && (a = a.redNeg()), this.point(e, a);
  }, tv.prototype.pointFromY = function (e, t) {
    (e = new Zg(e, 16)).red || (e = e.toRed(this.red));
    var n = e.redSqr(),
      r = n.redSub(this.c2),
      i = n.redMul(this.d).redMul(this.c2).redSub(this.a),
      o = r.redMul(i.redInvm());
    if (0 === o.cmp(this.zero)) {
      if (t) throw new Error("invalid point");
      return this.point(this.zero, e);
    }
    var a = o.redSqrt();
    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
    return a.fromRed().isOdd() !== t && (a = a.redNeg()), this.point(a, e);
  }, tv.prototype.validate = function (e) {
    if (e.isInfinity()) return !0;
    e.normalize();
    var t = e.x.redSqr(),
      n = e.y.redSqr(),
      r = t.redMul(this.a).redAdd(n),
      i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(n)));
    return 0 === r.cmp(i);
  }, Jg(rv, Xg.BasePoint), tv.prototype.pointFromJSON = function (e) {
    return rv.fromJSON(this, e);
  }, tv.prototype.point = function (e, t, n, r) {
    return new rv(this, e, t, n, r);
  }, rv.fromJSON = function (e, t) {
    return new rv(e, t[0], t[1], t[2]);
  }, rv.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, rv.prototype.isInfinity = function () {
    return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
  }, rv.prototype._extDbl = function () {
    var e = this.x.redSqr(),
      t = this.y.redSqr(),
      n = this.z.redSqr();
    n = n.redIAdd(n);
    var r = this.curve._mulA(e),
      i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t),
      o = r.redAdd(t),
      a = o.redSub(n),
      s = r.redSub(t),
      u = i.redMul(a),
      c = o.redMul(s),
      l = i.redMul(s),
      d = a.redMul(o);
    return this.curve.point(u, c, d, l);
  }, rv.prototype._projDbl = function () {
    var e,
      t,
      n,
      r,
      i,
      o,
      a = this.x.redAdd(this.y).redSqr(),
      s = this.x.redSqr(),
      u = this.y.redSqr();
    if (this.curve.twisted) {
      var c = (r = this.curve._mulA(s)).redAdd(u);
      this.zOne ? (e = a.redSub(s).redSub(u).redMul(c.redSub(this.curve.two)), t = c.redMul(r.redSub(u)), n = c.redSqr().redSub(c).redSub(c)) : (i = this.z.redSqr(), o = c.redSub(i).redISub(i), e = a.redSub(s).redISub(u).redMul(o), t = c.redMul(r.redSub(u)), n = c.redMul(o));
    } else r = s.redAdd(u), i = this.curve._mulC(this.z).redSqr(), o = r.redSub(i).redSub(i), e = this.curve._mulC(a.redISub(r)).redMul(o), t = this.curve._mulC(r).redMul(s.redISub(u)), n = r.redMul(o);
    return this.curve.point(e, t, n);
  }, rv.prototype.dbl = function () {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, rv.prototype._extAdd = function (e) {
    var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)),
      n = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),
      r = this.t.redMul(this.curve.dd).redMul(e.t),
      i = this.z.redMul(e.z.redAdd(e.z)),
      o = n.redSub(t),
      a = i.redSub(r),
      s = i.redAdd(r),
      u = n.redAdd(t),
      c = o.redMul(a),
      l = s.redMul(u),
      d = o.redMul(u),
      f = a.redMul(s);
    return this.curve.point(c, l, f, d);
  }, rv.prototype._projAdd = function (e) {
    var t,
      n,
      r = this.z.redMul(e.z),
      i = r.redSqr(),
      o = this.x.redMul(e.x),
      a = this.y.redMul(e.y),
      s = this.curve.d.redMul(o).redMul(a),
      u = i.redSub(s),
      c = i.redAdd(s),
      l = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(o).redISub(a),
      d = r.redMul(u).redMul(l);
    return this.curve.twisted ? (t = r.redMul(c).redMul(a.redSub(this.curve._mulA(o))), n = u.redMul(c)) : (t = r.redMul(c).redMul(a.redSub(o)), n = this.curve._mulC(u).redMul(c)), this.curve.point(d, t, n);
  }, rv.prototype.add = function (e) {
    return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
  }, rv.prototype.mul = function (e) {
    return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
  }, rv.prototype.mulAdd = function (e, t, n) {
    return this.curve._wnafMulAdd(1, [this, t], [e, n], 2, !1);
  }, rv.prototype.jmulAdd = function (e, t, n) {
    return this.curve._wnafMulAdd(1, [this, t], [e, n], 2, !0);
  }, rv.prototype.normalize = function () {
    if (this.zOne) return this;
    var e = this.z.redInvm();
    return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
  }, rv.prototype.neg = function () {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
  }, rv.prototype.getX = function () {
    return this.normalize(), this.x.fromRed();
  }, rv.prototype.getY = function () {
    return this.normalize(), this.y.fromRed();
  }, rv.prototype.eq = function (e) {
    return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
  }, rv.prototype.eqXToP = function (e) {
    var t = e.toRed(this.curve.red).redMul(this.z);
    if (0 === this.x.cmp(t)) return !0;
    for (var n = e.clone(), r = this.curve.redN.redMul(this.z);;) {
      if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
      if (t.redIAdd(r), 0 === this.x.cmp(t)) return !0;
    }
  }, rv.prototype.toP = rv.prototype.normalize, rv.prototype.mixedAdd = rv.prototype.add, function (e) {
    var t = e;
    t.base = Pg, t.short = Ug, t.mont = Gg, t.edwards = nv;
  }(kg);
  var iv = {},
    ov = {},
    av = {},
    sv = vg,
    uv = Ng;
  function cv(e, t) {
    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
  }
  function lv(e) {
    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
  }
  function dv(e) {
    return 1 === e.length ? "0" + e : e;
  }
  function fv(e) {
    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
  }
  av.inherits = uv, av.toArray = function (e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var n = [];
    if ("string" == typeof e) {
      if (t) {
        if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2) n.push(parseInt(e[i] + e[i + 1], 16));
      } else for (var r = 0, i = 0; i < e.length; i++) {
        var o = e.charCodeAt(i);
        o < 128 ? n[r++] = o : o < 2048 ? (n[r++] = o >> 6 | 192, n[r++] = 63 & o | 128) : cv(e, i) ? (o = 65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++i)), n[r++] = o >> 18 | 240, n[r++] = o >> 12 & 63 | 128, n[r++] = o >> 6 & 63 | 128, n[r++] = 63 & o | 128) : (n[r++] = o >> 12 | 224, n[r++] = o >> 6 & 63 | 128, n[r++] = 63 & o | 128);
      }
    } else for (i = 0; i < e.length; i++) n[i] = 0 | e[i];
    return n;
  }, av.toHex = function (e) {
    for (var t = "", n = 0; n < e.length; n++) t += dv(e[n].toString(16));
    return t;
  }, av.htonl = lv, av.toHex32 = function (e, t) {
    for (var n = "", r = 0; r < e.length; r++) {
      var i = e[r];
      "little" === t && (i = lv(i)), n += fv(i.toString(16));
    }
    return n;
  }, av.zero2 = dv, av.zero8 = fv, av.join32 = function (e, t, n, r) {
    var i = n - t;
    sv(i % 4 == 0);
    for (var o = new Array(i / 4), a = 0, s = t; a < o.length; a++, s += 4) {
      var u;
      u = "big" === r ? e[s] << 24 | e[s + 1] << 16 | e[s + 2] << 8 | e[s + 3] : e[s + 3] << 24 | e[s + 2] << 16 | e[s + 1] << 8 | e[s], o[a] = u >>> 0;
    }
    return o;
  }, av.split32 = function (e, t) {
    for (var n = new Array(4 * e.length), r = 0, i = 0; r < e.length; r++, i += 4) {
      var o = e[r];
      "big" === t ? (n[i] = o >>> 24, n[i + 1] = o >>> 16 & 255, n[i + 2] = o >>> 8 & 255, n[i + 3] = 255 & o) : (n[i + 3] = o >>> 24, n[i + 2] = o >>> 16 & 255, n[i + 1] = o >>> 8 & 255, n[i] = 255 & o);
    }
    return n;
  }, av.rotr32 = function (e, t) {
    return e >>> t | e << 32 - t;
  }, av.rotl32 = function (e, t) {
    return e << t | e >>> 32 - t;
  }, av.sum32 = function (e, t) {
    return e + t >>> 0;
  }, av.sum32_3 = function (e, t, n) {
    return e + t + n >>> 0;
  }, av.sum32_4 = function (e, t, n, r) {
    return e + t + n + r >>> 0;
  }, av.sum32_5 = function (e, t, n, r, i) {
    return e + t + n + r + i >>> 0;
  }, av.sum64 = function (e, t, n, r) {
    var i = e[t],
      o = r + e[t + 1] >>> 0,
      a = (o < r ? 1 : 0) + n + i;
    e[t] = a >>> 0, e[t + 1] = o;
  }, av.sum64_hi = function (e, t, n, r) {
    return (t + r >>> 0 < t ? 1 : 0) + e + n >>> 0;
  }, av.sum64_lo = function (e, t, n, r) {
    return t + r >>> 0;
  }, av.sum64_4_hi = function (e, t, n, r, i, o, a, s) {
    var u = 0,
      c = t;
    return u += (c = c + r >>> 0) < t ? 1 : 0, u += (c = c + o >>> 0) < o ? 1 : 0, e + n + i + a + (u += (c = c + s >>> 0) < s ? 1 : 0) >>> 0;
  }, av.sum64_4_lo = function (e, t, n, r, i, o, a, s) {
    return t + r + o + s >>> 0;
  }, av.sum64_5_hi = function (e, t, n, r, i, o, a, s, u, c) {
    var l = 0,
      d = t;
    return l += (d = d + r >>> 0) < t ? 1 : 0, l += (d = d + o >>> 0) < o ? 1 : 0, l += (d = d + s >>> 0) < s ? 1 : 0, e + n + i + a + u + (l += (d = d + c >>> 0) < c ? 1 : 0) >>> 0;
  }, av.sum64_5_lo = function (e, t, n, r, i, o, a, s, u, c) {
    return t + r + o + s + c >>> 0;
  }, av.rotr64_hi = function (e, t, n) {
    return (t << 32 - n | e >>> n) >>> 0;
  }, av.rotr64_lo = function (e, t, n) {
    return (e << 32 - n | t >>> n) >>> 0;
  }, av.shr64_hi = function (e, t, n) {
    return e >>> n;
  }, av.shr64_lo = function (e, t, n) {
    return (e << 32 - n | t >>> n) >>> 0;
  };
  var hv = {},
    pv = av,
    mv = vg;
  function gv() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  hv.BlockHash = gv, gv.prototype.update = function (e, t) {
    if (e = pv.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
      var n = (e = this.pending).length % this._delta8;
      this.pending = e.slice(e.length - n, e.length), 0 === this.pending.length && (this.pending = null), e = pv.join32(e, 0, e.length - n, this.endian);
      for (var r = 0; r < e.length; r += this._delta32) this._update(e, r, r + this._delta32);
    }
    return this;
  }, gv.prototype.digest = function (e) {
    return this.update(this._pad()), mv(null === this.pending), this._digest(e);
  }, gv.prototype._pad = function () {
    var e = this.pendingTotal,
      t = this._delta8,
      n = t - (e + this.padLength) % t,
      r = new Array(n + this.padLength);
    r[0] = 128;
    for (var i = 1; i < n; i++) r[i] = 0;
    if (e <<= 3, "big" === this.endian) {
      for (var o = 8; o < this.padLength; o++) r[i++] = 0;
      r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = e >>> 24 & 255, r[i++] = e >>> 16 & 255, r[i++] = e >>> 8 & 255, r[i++] = 255 & e;
    } else for (r[i++] = 255 & e, r[i++] = e >>> 8 & 255, r[i++] = e >>> 16 & 255, r[i++] = e >>> 24 & 255, r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = 0, o = 8; o < this.padLength; o++) r[i++] = 0;
    return r;
  };
  var vv = {},
    bv = {},
    yv = av.rotr32;
  function wv(e, t, n) {
    return e & t ^ ~e & n;
  }
  function Av(e, t, n) {
    return e & t ^ e & n ^ t & n;
  }
  function _v(e, t, n) {
    return e ^ t ^ n;
  }
  bv.ft_1 = function (e, t, n, r) {
    return 0 === e ? wv(t, n, r) : 1 === e || 3 === e ? _v(t, n, r) : 2 === e ? Av(t, n, r) : void 0;
  }, bv.ch32 = wv, bv.maj32 = Av, bv.p32 = _v, bv.s0_256 = function (e) {
    return yv(e, 2) ^ yv(e, 13) ^ yv(e, 22);
  }, bv.s1_256 = function (e) {
    return yv(e, 6) ^ yv(e, 11) ^ yv(e, 25);
  }, bv.g0_256 = function (e) {
    return yv(e, 7) ^ yv(e, 18) ^ e >>> 3;
  }, bv.g1_256 = function (e) {
    return yv(e, 17) ^ yv(e, 19) ^ e >>> 10;
  };
  var Ev = av,
    Sv = hv,
    kv = bv,
    Mv = Ev.rotl32,
    Cv = Ev.sum32,
    xv = Ev.sum32_5,
    Rv = kv.ft_1,
    Iv = Sv.BlockHash,
    Tv = [1518500249, 1859775393, 2400959708, 3395469782];
  function Pv() {
    if (!(this instanceof Pv)) return new Pv();
    Iv.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
  }
  Ev.inherits(Pv, Iv);
  var Ov = Pv;
  Pv.blockSize = 512, Pv.outSize = 160, Pv.hmacStrength = 80, Pv.padLength = 64, Pv.prototype._update = function (e, t) {
    for (var n = this.W, r = 0; r < 16; r++) n[r] = e[t + r];
    for (; r < n.length; r++) n[r] = Mv(n[r - 3] ^ n[r - 8] ^ n[r - 14] ^ n[r - 16], 1);
    var i = this.h[0],
      o = this.h[1],
      a = this.h[2],
      s = this.h[3],
      u = this.h[4];
    for (r = 0; r < n.length; r++) {
      var c = ~~(r / 20),
        l = xv(Mv(i, 5), Rv(c, o, a, s), u, n[r], Tv[c]);
      u = s, s = a, a = Mv(o, 30), o = i, i = l;
    }
    this.h[0] = Cv(this.h[0], i), this.h[1] = Cv(this.h[1], o), this.h[2] = Cv(this.h[2], a), this.h[3] = Cv(this.h[3], s), this.h[4] = Cv(this.h[4], u);
  }, Pv.prototype._digest = function (e) {
    return "hex" === e ? Ev.toHex32(this.h, "big") : Ev.split32(this.h, "big");
  };
  var Lv = av,
    Nv = hv,
    Dv = bv,
    Bv = vg,
    jv = Lv.sum32,
    Fv = Lv.sum32_4,
    zv = Lv.sum32_5,
    Uv = Dv.ch32,
    qv = Dv.maj32,
    Kv = Dv.s0_256,
    Hv = Dv.s1_256,
    Vv = Dv.g0_256,
    $v = Dv.g1_256,
    Wv = Nv.BlockHash,
    Yv = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
  function Gv() {
    if (!(this instanceof Gv)) return new Gv();
    Wv.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = Yv, this.W = new Array(64);
  }
  Lv.inherits(Gv, Wv);
  var Qv = Gv;
  Gv.blockSize = 512, Gv.outSize = 256, Gv.hmacStrength = 192, Gv.padLength = 64, Gv.prototype._update = function (e, t) {
    for (var n = this.W, r = 0; r < 16; r++) n[r] = e[t + r];
    for (; r < n.length; r++) n[r] = Fv($v(n[r - 2]), n[r - 7], Vv(n[r - 15]), n[r - 16]);
    var i = this.h[0],
      o = this.h[1],
      a = this.h[2],
      s = this.h[3],
      u = this.h[4],
      c = this.h[5],
      l = this.h[6],
      d = this.h[7];
    for (Bv(this.k.length === n.length), r = 0; r < n.length; r++) {
      var f = zv(d, Hv(u), Uv(u, c, l), this.k[r], n[r]),
        h = jv(Kv(i), qv(i, o, a));
      d = l, l = c, c = u, u = jv(s, f), s = a, a = o, o = i, i = jv(f, h);
    }
    this.h[0] = jv(this.h[0], i), this.h[1] = jv(this.h[1], o), this.h[2] = jv(this.h[2], a), this.h[3] = jv(this.h[3], s), this.h[4] = jv(this.h[4], u), this.h[5] = jv(this.h[5], c), this.h[6] = jv(this.h[6], l), this.h[7] = jv(this.h[7], d);
  }, Gv.prototype._digest = function (e) {
    return "hex" === e ? Lv.toHex32(this.h, "big") : Lv.split32(this.h, "big");
  };
  var Zv = av,
    Jv = Qv;
  function Xv() {
    if (!(this instanceof Xv)) return new Xv();
    Jv.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
  }
  Zv.inherits(Xv, Jv);
  var eb = Xv;
  Xv.blockSize = 512, Xv.outSize = 224, Xv.hmacStrength = 192, Xv.padLength = 64, Xv.prototype._digest = function (e) {
    return "hex" === e ? Zv.toHex32(this.h.slice(0, 7), "big") : Zv.split32(this.h.slice(0, 7), "big");
  };
  var tb = av,
    nb = hv,
    rb = vg,
    ib = tb.rotr64_hi,
    ob = tb.rotr64_lo,
    ab = tb.shr64_hi,
    sb = tb.shr64_lo,
    ub = tb.sum64,
    cb = tb.sum64_hi,
    lb = tb.sum64_lo,
    db = tb.sum64_4_hi,
    fb = tb.sum64_4_lo,
    hb = tb.sum64_5_hi,
    pb = tb.sum64_5_lo,
    mb = nb.BlockHash,
    gb = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];
  function vb() {
    if (!(this instanceof vb)) return new vb();
    mb.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = gb, this.W = new Array(160);
  }
  tb.inherits(vb, mb);
  var bb = vb;
  function yb(e, t, n, r, i) {
    var o = e & n ^ ~e & i;
    return o < 0 && (o += 4294967296), o;
  }
  function wb(e, t, n, r, i, o) {
    var a = t & r ^ ~t & o;
    return a < 0 && (a += 4294967296), a;
  }
  function Ab(e, t, n, r, i) {
    var o = e & n ^ e & i ^ n & i;
    return o < 0 && (o += 4294967296), o;
  }
  function _b(e, t, n, r, i, o) {
    var a = t & r ^ t & o ^ r & o;
    return a < 0 && (a += 4294967296), a;
  }
  function Eb(e, t) {
    var n = ib(e, t, 28) ^ ib(t, e, 2) ^ ib(t, e, 7);
    return n < 0 && (n += 4294967296), n;
  }
  function Sb(e, t) {
    var n = ob(e, t, 28) ^ ob(t, e, 2) ^ ob(t, e, 7);
    return n < 0 && (n += 4294967296), n;
  }
  function kb(e, t) {
    var n = ib(e, t, 14) ^ ib(e, t, 18) ^ ib(t, e, 9);
    return n < 0 && (n += 4294967296), n;
  }
  function Mb(e, t) {
    var n = ob(e, t, 14) ^ ob(e, t, 18) ^ ob(t, e, 9);
    return n < 0 && (n += 4294967296), n;
  }
  function Cb(e, t) {
    var n = ib(e, t, 1) ^ ib(e, t, 8) ^ ab(e, t, 7);
    return n < 0 && (n += 4294967296), n;
  }
  function xb(e, t) {
    var n = ob(e, t, 1) ^ ob(e, t, 8) ^ sb(e, t, 7);
    return n < 0 && (n += 4294967296), n;
  }
  function Rb(e, t) {
    var n = ib(e, t, 19) ^ ib(t, e, 29) ^ ab(e, t, 6);
    return n < 0 && (n += 4294967296), n;
  }
  function Ib(e, t) {
    var n = ob(e, t, 19) ^ ob(t, e, 29) ^ sb(e, t, 6);
    return n < 0 && (n += 4294967296), n;
  }
  vb.blockSize = 1024, vb.outSize = 512, vb.hmacStrength = 192, vb.padLength = 128, vb.prototype._prepareBlock = function (e, t) {
    for (var n = this.W, r = 0; r < 32; r++) n[r] = e[t + r];
    for (; r < n.length; r += 2) {
      var i = Rb(n[r - 4], n[r - 3]),
        o = Ib(n[r - 4], n[r - 3]),
        a = n[r - 14],
        s = n[r - 13],
        u = Cb(n[r - 30], n[r - 29]),
        c = xb(n[r - 30], n[r - 29]),
        l = n[r - 32],
        d = n[r - 31];
      n[r] = db(i, o, a, s, u, c, l, d), n[r + 1] = fb(i, o, a, s, u, c, l, d);
    }
  }, vb.prototype._update = function (e, t) {
    this._prepareBlock(e, t);
    var n = this.W,
      r = this.h[0],
      i = this.h[1],
      o = this.h[2],
      a = this.h[3],
      s = this.h[4],
      u = this.h[5],
      c = this.h[6],
      l = this.h[7],
      d = this.h[8],
      f = this.h[9],
      h = this.h[10],
      p = this.h[11],
      m = this.h[12],
      g = this.h[13],
      v = this.h[14],
      b = this.h[15];
    rb(this.k.length === n.length);
    for (var y = 0; y < n.length; y += 2) {
      var w = v,
        A = b,
        _ = kb(d, f),
        E = Mb(d, f),
        S = yb(d, f, h, p, m),
        k = wb(d, f, h, p, m, g),
        M = this.k[y],
        C = this.k[y + 1],
        x = n[y],
        R = n[y + 1],
        I = hb(w, A, _, E, S, k, M, C, x, R),
        T = pb(w, A, _, E, S, k, M, C, x, R);
      w = Eb(r, i), A = Sb(r, i), _ = Ab(r, i, o, a, s), E = _b(r, i, o, a, s, u);
      var P = cb(w, A, _, E),
        O = lb(w, A, _, E);
      v = m, b = g, m = h, g = p, h = d, p = f, d = cb(c, l, I, T), f = lb(l, l, I, T), c = s, l = u, s = o, u = a, o = r, a = i, r = cb(I, T, P, O), i = lb(I, T, P, O);
    }
    ub(this.h, 0, r, i), ub(this.h, 2, o, a), ub(this.h, 4, s, u), ub(this.h, 6, c, l), ub(this.h, 8, d, f), ub(this.h, 10, h, p), ub(this.h, 12, m, g), ub(this.h, 14, v, b);
  }, vb.prototype._digest = function (e) {
    return "hex" === e ? tb.toHex32(this.h, "big") : tb.split32(this.h, "big");
  };
  var Tb = av,
    Pb = bb;
  function Ob() {
    if (!(this instanceof Ob)) return new Ob();
    Pb.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
  }
  Tb.inherits(Ob, Pb);
  var Lb = Ob;
  Ob.blockSize = 1024, Ob.outSize = 384, Ob.hmacStrength = 192, Ob.padLength = 128, Ob.prototype._digest = function (e) {
    return "hex" === e ? Tb.toHex32(this.h.slice(0, 12), "big") : Tb.split32(this.h.slice(0, 12), "big");
  }, vv.sha1 = Ov, vv.sha224 = eb, vv.sha256 = Qv, vv.sha384 = Lb, vv.sha512 = bb;
  var Nb = {},
    Db = av,
    Bb = hv,
    jb = Db.rotl32,
    Fb = Db.sum32,
    zb = Db.sum32_3,
    Ub = Db.sum32_4,
    qb = Bb.BlockHash;
  function Kb() {
    if (!(this instanceof Kb)) return new Kb();
    qb.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  function Hb(e, t, n, r) {
    return e <= 15 ? t ^ n ^ r : e <= 31 ? t & n | ~t & r : e <= 47 ? (t | ~n) ^ r : e <= 63 ? t & r | n & ~r : t ^ (n | ~r);
  }
  function Vb(e) {
    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
  }
  function $b(e) {
    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
  }
  Db.inherits(Kb, qb), Nb.ripemd160 = Kb, Kb.blockSize = 512, Kb.outSize = 160, Kb.hmacStrength = 192, Kb.padLength = 64, Kb.prototype._update = function (e, t) {
    for (var n = this.h[0], r = this.h[1], i = this.h[2], o = this.h[3], a = this.h[4], s = n, u = r, c = i, l = o, d = a, f = 0; f < 80; f++) {
      var h = Fb(jb(Ub(n, Hb(f, r, i, o), e[Wb[f] + t], Vb(f)), Gb[f]), a);
      n = a, a = o, o = jb(i, 10), i = r, r = h, h = Fb(jb(Ub(s, Hb(79 - f, u, c, l), e[Yb[f] + t], $b(f)), Qb[f]), d), s = d, d = l, l = jb(c, 10), c = u, u = h;
    }
    h = zb(this.h[1], i, l), this.h[1] = zb(this.h[2], o, d), this.h[2] = zb(this.h[3], a, s), this.h[3] = zb(this.h[4], n, u), this.h[4] = zb(this.h[0], r, c), this.h[0] = h;
  }, Kb.prototype._digest = function (e) {
    return "hex" === e ? Db.toHex32(this.h, "little") : Db.split32(this.h, "little");
  };
  var Wb = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
    Yb = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
    Gb = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
    Qb = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11],
    Zb = av,
    Jb = vg;
  function Xb(e, t, n) {
    if (!(this instanceof Xb)) return new Xb(e, t, n);
    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(Zb.toArray(t, n));
  }
  var ey,
    ty,
    ny = Xb;
  Xb.prototype._init = function (e) {
    e.length > this.blockSize && (e = new this.Hash().update(e).digest()), Jb(e.length <= this.blockSize);
    for (var t = e.length; t < this.blockSize; t++) e.push(0);
    for (t = 0; t < e.length; t++) e[t] ^= 54;
    for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) e[t] ^= 106;
    this.outer = new this.Hash().update(e);
  }, Xb.prototype.update = function (e, t) {
    return this.inner.update(e, t), this;
  }, Xb.prototype.digest = function (e) {
    return this.outer.update(this.inner.digest()), this.outer.digest(e);
  }, function (e) {
    var t = e;
    t.utils = av, t.common = hv, t.sha = vv, t.ripemd = Nb, t.hmac = ny, t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
  }(ov), function (e) {
    var t,
      n = e,
      r = ov,
      i = kg,
      o = pg.assert;
    function a(e) {
      "short" === e.type ? this.curve = new i.short(e) : "edwards" === e.type ? this.curve = new i.edwards(e) : this.curve = new i.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, o(this.g.validate(), "Invalid curve"), o(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    function s(e, t) {
      Object.defineProperty(n, e, {
        configurable: !0,
        enumerable: !0,
        get: function () {
          var r = new a(t);
          return Object.defineProperty(n, e, {
            configurable: !0,
            enumerable: !0,
            value: r
          }), r;
        }
      });
    }
    n.PresetCurve = a, s("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: r.sha256,
      gRed: !1,
      g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
    }), s("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: r.sha256,
      gRed: !1,
      g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
    }), s("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: r.sha256,
      gRed: !1,
      g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
    }), s("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: r.sha384,
      gRed: !1,
      g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
    }), s("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: r.sha512,
      gRed: !1,
      g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
    }), s("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: ["9"]
    }), s("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
    });
    try {
      t = ty ? ey : (ty = 1, ey = {
        doubles: {
          step: 4,
          points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]
        },
        naf: {
          wnd: 7,
          points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]
        }
      });
    } catch (e) {
      t = void 0;
    }
    s("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: r.sha256,
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [{
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      }, {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }],
      gRed: !1,
      g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", t]
    });
  }(iv);
  var ry = ov,
    iy = yg,
    oy = vg;
  function ay(e) {
    if (!(this instanceof ay)) return new ay(e);
    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var t = iy.toArray(e.entropy, e.entropyEnc || "hex"),
      n = iy.toArray(e.nonce, e.nonceEnc || "hex"),
      r = iy.toArray(e.pers, e.persEnc || "hex");
    oy(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, n, r);
  }
  var sy = ay;
  ay.prototype._init = function (e, t, n) {
    var r = e.concat(t).concat(n);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var i = 0; i < this.V.length; i++) this.K[i] = 0, this.V[i] = 1;
    this._update(r), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, ay.prototype._hmac = function () {
    return new ry.hmac(this.hash, this.K);
  }, ay.prototype._update = function (e) {
    var t = this._hmac().update(this.V).update([0]);
    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
  }, ay.prototype.reseed = function (e, t, n, r) {
    "string" != typeof t && (r = n, n = t, t = null), e = iy.toArray(e, t), n = iy.toArray(n, r), oy(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(n || [])), this._reseed = 1;
  }, ay.prototype.generate = function (e, t, n, r) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    "string" != typeof t && (r = n, n = t, t = null), n && (n = iy.toArray(n, r || "hex"), this._update(n));
    for (var i = []; i.length < e;) this.V = this._hmac().update(this.V).digest(), i = i.concat(this.V);
    var o = i.slice(0, e);
    return this._update(n), this._reseed++, iy.encode(o, t);
  };
  var uy = gg,
    cy = pg.assert;
  function ly(e, t) {
    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
  }
  var dy = ly;
  ly.fromPublic = function (e, t, n) {
    return t instanceof ly ? t : new ly(e, {
      pub: t,
      pubEnc: n
    });
  }, ly.fromPrivate = function (e, t, n) {
    return t instanceof ly ? t : new ly(e, {
      priv: t,
      privEnc: n
    });
  }, ly.prototype.validate = function () {
    var e = this.getPublic();
    return e.isInfinity() ? {
      result: !1,
      reason: "Invalid public key"
    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
      result: !0,
      reason: null
    } : {
      result: !1,
      reason: "Public key * N != O"
    } : {
      result: !1,
      reason: "Public key is not a point"
    };
  }, ly.prototype.getPublic = function (e, t) {
    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
  }, ly.prototype.getPrivate = function (e) {
    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
  }, ly.prototype._importPrivate = function (e, t) {
    this.priv = new uy(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, ly.prototype._importPublic = function (e, t) {
    if (e.x || e.y) return "mont" === this.ec.curve.type ? cy(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || cy(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
    this.pub = this.ec.curve.decodePoint(e, t);
  }, ly.prototype.derive = function (e) {
    return e.validate() || cy(e.validate(), "public point not validated"), e.mul(this.priv).getX();
  }, ly.prototype.sign = function (e, t, n) {
    return this.ec.sign(e, this, t, n);
  }, ly.prototype.verify = function (e, t) {
    return this.ec.verify(e, t, this);
  }, ly.prototype.inspect = function () {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  };
  var fy = gg,
    hy = pg,
    py = hy.assert;
  function my(e, t) {
    if (e instanceof my) return e;
    this._importDER(e, t) || (py(e.r && e.s, "Signature without r or s"), this.r = new fy(e.r, 16), this.s = new fy(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
  }
  var gy = my;
  function vy() {
    this.place = 0;
  }
  function by(e, t) {
    var n = e[t.place++];
    if (!(128 & n)) return n;
    var r = 15 & n;
    if (0 === r || r > 4) return !1;
    for (var i = 0, o = 0, a = t.place; o < r; o++, a++) i <<= 8, i |= e[a], i >>>= 0;
    return !(i <= 127) && (t.place = a, i);
  }
  function yy(e) {
    for (var t = 0, n = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < n;) t++;
    return 0 === t ? e : e.slice(t);
  }
  function wy(e, t) {
    if (t < 128) e.push(t);else {
      var n = 1 + (Math.log(t) / Math.LN2 >>> 3);
      for (e.push(128 | n); --n;) e.push(t >>> (n << 3) & 255);
      e.push(t);
    }
  }
  my.prototype._importDER = function (e, t) {
    e = hy.toArray(e, t);
    var n = new vy();
    if (48 !== e[n.place++]) return !1;
    var r = by(e, n);
    if (!1 === r) return !1;
    if (r + n.place !== e.length) return !1;
    if (2 !== e[n.place++]) return !1;
    var i = by(e, n);
    if (!1 === i) return !1;
    var o = e.slice(n.place, i + n.place);
    if (n.place += i, 2 !== e[n.place++]) return !1;
    var a = by(e, n);
    if (!1 === a) return !1;
    if (e.length !== a + n.place) return !1;
    var s = e.slice(n.place, a + n.place);
    if (0 === o[0]) {
      if (!(128 & o[1])) return !1;
      o = o.slice(1);
    }
    if (0 === s[0]) {
      if (!(128 & s[1])) return !1;
      s = s.slice(1);
    }
    return this.r = new fy(o), this.s = new fy(s), this.recoveryParam = null, !0;
  }, my.prototype.toDER = function (e) {
    var t = this.r.toArray(),
      n = this.s.toArray();
    for (128 & t[0] && (t = [0].concat(t)), 128 & n[0] && (n = [0].concat(n)), t = yy(t), n = yy(n); !(n[0] || 128 & n[1]);) n = n.slice(1);
    var r = [2];
    wy(r, t.length), (r = r.concat(t)).push(2), wy(r, n.length);
    var i = r.concat(n),
      o = [48];
    return wy(o, i.length), o = o.concat(i), hy.encode(o, e);
  };
  var Ay = gg,
    _y = sy,
    Ey = iv,
    Sy = Sg,
    ky = pg.assert,
    My = dy,
    Cy = gy;
  function xy(e) {
    if (!(this instanceof xy)) return new xy(e);
    "string" == typeof e && (ky(Object.prototype.hasOwnProperty.call(Ey, e), "Unknown curve " + e), e = Ey[e]), e instanceof Ey.PresetCurve && (e = {
      curve: e
    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
  }
  var Ry = xy;
  xy.prototype.keyPair = function (e) {
    return new My(this, e);
  }, xy.prototype.keyFromPrivate = function (e, t) {
    return My.fromPrivate(this, e, t);
  }, xy.prototype.keyFromPublic = function (e, t) {
    return My.fromPublic(this, e, t);
  }, xy.prototype.genKeyPair = function (e) {
    e || (e = {});
    for (var t = new _y({
        hash: this.hash,
        pers: e.pers,
        persEnc: e.persEnc || "utf8",
        entropy: e.entropy || Sy(this.hash.hmacStrength),
        entropyEnc: e.entropy && e.entropyEnc || "utf8",
        nonce: this.n.toArray()
      }), n = this.n.byteLength(), r = this.n.sub(new Ay(2));;) {
      var i = new Ay(t.generate(n));
      if (!(i.cmp(r) > 0)) return i.iaddn(1), this.keyFromPrivate(i);
    }
  }, xy.prototype._truncateToN = function (e, t) {
    var n = 8 * e.byteLength() - this.n.bitLength();
    return n > 0 && (e = e.ushrn(n)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
  }, xy.prototype.sign = function (e, t, n, r) {
    "object" == typeof n && (r = n, n = null), r || (r = {}), t = this.keyFromPrivate(t, n), e = this._truncateToN(new Ay(e, 16));
    for (var i = this.n.byteLength(), o = t.getPrivate().toArray("be", i), a = e.toArray("be", i), s = new _y({
        hash: this.hash,
        entropy: o,
        nonce: a,
        pers: r.pers,
        persEnc: r.persEnc || "utf8"
      }), u = this.n.sub(new Ay(1)), c = 0;; c++) {
      var l = r.k ? r.k(c) : new Ay(s.generate(this.n.byteLength()));
      if (!((l = this._truncateToN(l, !0)).cmpn(1) <= 0 || l.cmp(u) >= 0)) {
        var d = this.g.mul(l);
        if (!d.isInfinity()) {
          var f = d.getX(),
            h = f.umod(this.n);
          if (0 !== h.cmpn(0)) {
            var p = l.invm(this.n).mul(h.mul(t.getPrivate()).iadd(e));
            if (0 !== (p = p.umod(this.n)).cmpn(0)) {
              var m = (d.getY().isOdd() ? 1 : 0) | (0 !== f.cmp(h) ? 2 : 0);
              return r.canonical && p.cmp(this.nh) > 0 && (p = this.n.sub(p), m ^= 1), new Cy({
                r: h,
                s: p,
                recoveryParam: m
              });
            }
          }
        }
      }
    }
  }, xy.prototype.verify = function (e, t, n, r) {
    e = this._truncateToN(new Ay(e, 16)), n = this.keyFromPublic(n, r);
    var i = (t = new Cy(t, "hex")).r,
      o = t.s;
    if (i.cmpn(1) < 0 || i.cmp(this.n) >= 0) return !1;
    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
    var a,
      s = o.invm(this.n),
      u = s.mul(e).umod(this.n),
      c = s.mul(i).umod(this.n);
    return this.curve._maxwellTrick ? !(a = this.g.jmulAdd(u, n.getPublic(), c)).isInfinity() && a.eqXToP(i) : !(a = this.g.mulAdd(u, n.getPublic(), c)).isInfinity() && 0 === a.getX().umod(this.n).cmp(i);
  }, xy.prototype.recoverPubKey = function (e, t, n, r) {
    ky((3 & n) === n, "The recovery param is more than two bits"), t = new Cy(t, r);
    var i = this.n,
      o = new Ay(e),
      a = t.r,
      s = t.s,
      u = 1 & n,
      c = n >> 1;
    if (a.cmp(this.curve.p.umod(this.curve.n)) >= 0 && c) throw new Error("Unable to find sencond key candinate");
    a = c ? this.curve.pointFromX(a.add(this.curve.n), u) : this.curve.pointFromX(a, u);
    var l = t.r.invm(i),
      d = i.sub(o).mul(l).umod(i),
      f = s.mul(l).umod(i);
    return this.g.mulAdd(d, a, f);
  }, xy.prototype.getKeyRecoveryParam = function (e, t, n, r) {
    if (null !== (t = new Cy(t, r)).recoveryParam) return t.recoveryParam;
    for (var i = 0; i < 4; i++) {
      var o;
      try {
        o = this.recoverPubKey(e, t, i);
      } catch (e) {
        continue;
      }
      if (o.eq(n)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
  };
  var Iy = pg,
    Ty = Iy.assert,
    Py = Iy.parseBytes,
    Oy = Iy.cachedProperty;
  function Ly(e, t) {
    this.eddsa = e, this._secret = Py(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = Py(t.pub);
  }
  Ly.fromPublic = function (e, t) {
    return t instanceof Ly ? t : new Ly(e, {
      pub: t
    });
  }, Ly.fromSecret = function (e, t) {
    return t instanceof Ly ? t : new Ly(e, {
      secret: t
    });
  }, Ly.prototype.secret = function () {
    return this._secret;
  }, Oy(Ly, "pubBytes", function () {
    return this.eddsa.encodePoint(this.pub());
  }), Oy(Ly, "pub", function () {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), Oy(Ly, "privBytes", function () {
    var e = this.eddsa,
      t = this.hash(),
      n = e.encodingLength - 1,
      r = t.slice(0, e.encodingLength);
    return r[0] &= 248, r[n] &= 127, r[n] |= 64, r;
  }), Oy(Ly, "priv", function () {
    return this.eddsa.decodeInt(this.privBytes());
  }), Oy(Ly, "hash", function () {
    return this.eddsa.hash().update(this.secret()).digest();
  }), Oy(Ly, "messagePrefix", function () {
    return this.hash().slice(this.eddsa.encodingLength);
  }), Ly.prototype.sign = function (e) {
    return Ty(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
  }, Ly.prototype.verify = function (e, t) {
    return this.eddsa.verify(e, t, this);
  }, Ly.prototype.getSecret = function (e) {
    return Ty(this._secret, "KeyPair is public only"), Iy.encode(this.secret(), e);
  }, Ly.prototype.getPublic = function (e) {
    return Iy.encode(this.pubBytes(), e);
  };
  var Ny = Ly,
    Dy = gg,
    By = pg,
    jy = By.assert,
    Fy = By.cachedProperty,
    zy = By.parseBytes;
  function Uy(e, t) {
    this.eddsa = e, "object" != typeof t && (t = zy(t)), Array.isArray(t) && (t = {
      R: t.slice(0, e.encodingLength),
      S: t.slice(e.encodingLength)
    }), jy(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof Dy && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
  }
  Fy(Uy, "S", function () {
    return this.eddsa.decodeInt(this.Sencoded());
  }), Fy(Uy, "R", function () {
    return this.eddsa.decodePoint(this.Rencoded());
  }), Fy(Uy, "Rencoded", function () {
    return this.eddsa.encodePoint(this.R());
  }), Fy(Uy, "Sencoded", function () {
    return this.eddsa.encodeInt(this.S());
  }), Uy.prototype.toBytes = function () {
    return this.Rencoded().concat(this.Sencoded());
  }, Uy.prototype.toHex = function () {
    return By.encode(this.toBytes(), "hex").toUpperCase();
  };
  var qy = Uy,
    Ky = ov,
    Hy = iv,
    Vy = pg,
    $y = Vy.assert,
    Wy = Vy.parseBytes,
    Yy = Ny,
    Gy = qy;
  function Qy(e) {
    if ($y("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof Qy)) return new Qy(e);
    e = Hy[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = Ky.sha512;
  }
  var Zy = Qy;
  Qy.prototype.sign = function (e, t) {
    e = Wy(e);
    var n = this.keyFromSecret(t),
      r = this.hashInt(n.messagePrefix(), e),
      i = this.g.mul(r),
      o = this.encodePoint(i),
      a = this.hashInt(o, n.pubBytes(), e).mul(n.priv()),
      s = r.add(a).umod(this.curve.n);
    return this.makeSignature({
      R: i,
      S: s,
      Rencoded: o
    });
  }, Qy.prototype.verify = function (e, t, n) {
    e = Wy(e), t = this.makeSignature(t);
    var r = this.keyFromPublic(n),
      i = this.hashInt(t.Rencoded(), r.pubBytes(), e),
      o = this.g.mul(t.S());
    return t.R().add(r.pub().mul(i)).eq(o);
  }, Qy.prototype.hashInt = function () {
    for (var e = this.hash(), t = 0; t < arguments.length; t++) e.update(arguments[t]);
    return Vy.intFromLE(e.digest()).umod(this.curve.n);
  }, Qy.prototype.keyFromPublic = function (e) {
    return Yy.fromPublic(this, e);
  }, Qy.prototype.keyFromSecret = function (e) {
    return Yy.fromSecret(this, e);
  }, Qy.prototype.makeSignature = function (e) {
    return e instanceof Gy ? e : new Gy(this, e);
  }, Qy.prototype.encodePoint = function (e) {
    var t = e.getY().toArray("le", this.encodingLength);
    return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
  }, Qy.prototype.decodePoint = function (e) {
    var t = (e = Vy.parseBytes(e)).length - 1,
      n = e.slice(0, t).concat(-129 & e[t]),
      r = 0 != (128 & e[t]),
      i = Vy.intFromLE(n);
    return this.curve.pointFromY(i, r);
  }, Qy.prototype.encodeInt = function (e) {
    return e.toArray("le", this.encodingLength);
  }, Qy.prototype.decodeInt = function (e) {
    return Vy.intFromLE(e);
  }, Qy.prototype.isPoint = function (e) {
    return e instanceof this.pointClass;
  }, function (e) {
    var t = e;
    t.version = hg, t.utils = pg, t.rand = Sg, t.curve = kg, t.curves = iv, t.ec = Ry, t.eddsa = Zy;
  }(fg);
  const Jy = new (0, fg.ec)("secp256k1"),
    Xy = Jy.curve,
    ew = Xy.n.constructor;
  function tw(e) {
    const t = e[0];
    switch (t) {
      case 2:
      case 3:
        return 33 !== e.length ? null : function (e, t) {
          let n = new ew(t);
          if (n.cmp(Xy.p) >= 0) return null;
          n = n.toRed(Xy.red);
          let r = n.redSqr().redIMul(n).redIAdd(Xy.b).redSqrt();
          return 3 === e !== r.isOdd() && (r = r.redNeg()), Jy.keyPair({
            pub: {
              x: n,
              y: r
            }
          });
        }(t, e.subarray(1, 33));
      case 4:
      case 6:
      case 7:
        return 65 !== e.length ? null : function (e, t, n) {
          let r = new ew(t),
            i = new ew(n);
          if (r.cmp(Xy.p) >= 0 || i.cmp(Xy.p) >= 0) return null;
          if (r = r.toRed(Xy.red), i = i.toRed(Xy.red), (6 === e || 7 === e) && i.isOdd() !== (7 === e)) return null;
          const o = r.redSqr().redIMul(r);
          return i.redSqr().redISub(o.redIAdd(Xy.b)).isZero() ? Jy.keyPair({
            pub: {
              x: r,
              y: i
            }
          }) : null;
        }(t, e.subarray(1, 33), e.subarray(33, 65));
      default:
        return null;
    }
  }
  function nw(e, t) {
    const n = t.encode(null, 33 === e.length);
    for (let t = 0; t < e.length; ++t) e[t] = n[t];
  }
  var rw = {
      contextRandomize: () => 0,
      privateKeyVerify(e) {
        const t = new ew(e);
        return t.cmp(Xy.n) < 0 && !t.isZero() ? 0 : 1;
      },
      privateKeyNegate(e) {
        const t = new ew(e),
          n = Xy.n.sub(t).umod(Xy.n).toArrayLike(Uint8Array, "be", 32);
        return e.set(n), 0;
      },
      privateKeyTweakAdd(e, t) {
        const n = new ew(t);
        if (n.cmp(Xy.n) >= 0) return 1;
        if (n.iadd(new ew(e)), n.cmp(Xy.n) >= 0 && n.isub(Xy.n), n.isZero()) return 1;
        const r = n.toArrayLike(Uint8Array, "be", 32);
        return e.set(r), 0;
      },
      privateKeyTweakMul(e, t) {
        let n = new ew(t);
        if (n.cmp(Xy.n) >= 0 || n.isZero()) return 1;
        n.imul(new ew(e)), n.cmp(Xy.n) >= 0 && (n = n.umod(Xy.n));
        const r = n.toArrayLike(Uint8Array, "be", 32);
        return e.set(r), 0;
      },
      publicKeyVerify: e => null === tw(e) ? 1 : 0,
      publicKeyCreate(e, t) {
        const n = new ew(t);
        if (n.cmp(Xy.n) >= 0 || n.isZero()) return 1;
        return nw(e, Jy.keyFromPrivate(t).getPublic()), 0;
      },
      publicKeyConvert(e, t) {
        const n = tw(t);
        if (null === n) return 1;
        return nw(e, n.getPublic()), 0;
      },
      publicKeyNegate(e, t) {
        const n = tw(t);
        if (null === n) return 1;
        const r = n.getPublic();
        return r.y = r.y.redNeg(), nw(e, r), 0;
      },
      publicKeyCombine(e, t) {
        const n = new Array(t.length);
        for (let e = 0; e < t.length; ++e) if (n[e] = tw(t[e]), null === n[e]) return 1;
        let r = n[0].getPublic();
        for (let e = 1; e < n.length; ++e) r = r.add(n[e].pub);
        return r.isInfinity() ? 2 : (nw(e, r), 0);
      },
      publicKeyTweakAdd(e, t, n) {
        const r = tw(t);
        if (null === r) return 1;
        if ((n = new ew(n)).cmp(Xy.n) >= 0) return 2;
        const i = r.getPublic().add(Xy.g.mul(n));
        return i.isInfinity() ? 2 : (nw(e, i), 0);
      },
      publicKeyTweakMul(e, t, n) {
        const r = tw(t);
        if (null === r) return 1;
        if ((n = new ew(n)).cmp(Xy.n) >= 0 || n.isZero()) return 2;
        return nw(e, r.getPublic().mul(n)), 0;
      },
      signatureNormalize(e) {
        const t = new ew(e.subarray(0, 32)),
          n = new ew(e.subarray(32, 64));
        return t.cmp(Xy.n) >= 0 || n.cmp(Xy.n) >= 0 ? 1 : (1 === n.cmp(Jy.nh) && e.set(Xy.n.sub(n).toArrayLike(Uint8Array, "be", 32), 32), 0);
      },
      signatureExport(e, t) {
        const n = t.subarray(0, 32),
          r = t.subarray(32, 64);
        if (new ew(n).cmp(Xy.n) >= 0) return 1;
        if (new ew(r).cmp(Xy.n) >= 0) return 1;
        const {
          output: i
        } = e;
        let o = i.subarray(4, 37);
        o[0] = 0, o.set(n, 1);
        let a = 33,
          s = 0;
        for (; a > 1 && 0 === o[s] && !(128 & o[s + 1]); --a, ++s);
        if (o = o.subarray(s), 128 & o[0]) return 1;
        if (a > 1 && 0 === o[0] && !(128 & o[1])) return 1;
        let u = i.subarray(39, 72);
        u[0] = 0, u.set(r, 1);
        let c = 33,
          l = 0;
        for (; c > 1 && 0 === u[l] && !(128 & u[l + 1]); --c, ++l);
        return u = u.subarray(l), 128 & u[0] || c > 1 && 0 === u[0] && !(128 & u[1]) ? 1 : (e.outputlen = 6 + a + c, i[0] = 48, i[1] = e.outputlen - 2, i[2] = 2, i[3] = o.length, i.set(o, 4), i[4 + a] = 2, i[5 + a] = u.length, i.set(u, 6 + a), 0);
      },
      signatureImport(e, t) {
        if (t.length < 8) return 1;
        if (t.length > 72) return 1;
        if (48 !== t[0]) return 1;
        if (t[1] !== t.length - 2) return 1;
        if (2 !== t[2]) return 1;
        const n = t[3];
        if (0 === n) return 1;
        if (5 + n >= t.length) return 1;
        if (2 !== t[4 + n]) return 1;
        const r = t[5 + n];
        if (0 === r) return 1;
        if (6 + n + r !== t.length) return 1;
        if (128 & t[4]) return 1;
        if (n > 1 && 0 === t[4] && !(128 & t[5])) return 1;
        if (128 & t[n + 6]) return 1;
        if (r > 1 && 0 === t[n + 6] && !(128 & t[n + 7])) return 1;
        let i = t.subarray(4, 4 + n);
        if (33 === i.length && 0 === i[0] && (i = i.subarray(1)), i.length > 32) return 1;
        let o = t.subarray(6 + n);
        if (33 === o.length && 0 === o[0] && (o = o.slice(1)), o.length > 32) throw new Error("S length is too long");
        let a = new ew(i);
        a.cmp(Xy.n) >= 0 && (a = new ew(0));
        let s = new ew(t.subarray(6 + n));
        return s.cmp(Xy.n) >= 0 && (s = new ew(0)), e.set(a.toArrayLike(Uint8Array, "be", 32), 0), e.set(s.toArrayLike(Uint8Array, "be", 32), 32), 0;
      },
      ecdsaSign(e, t, n, r, i) {
        if (i) {
          const e = i;
          i = i => {
            const o = e(t, n, null, r, i);
            if (!(o instanceof Uint8Array && 32 === o.length)) throw new Error("This is the way");
            return new ew(o);
          };
        }
        const o = new ew(n);
        if (o.cmp(Xy.n) >= 0 || o.isZero()) return 1;
        let a;
        try {
          a = Jy.sign(t, n, {
            canonical: !0,
            k: i,
            pers: r
          });
        } catch (e) {
          return 1;
        }
        return e.signature.set(a.r.toArrayLike(Uint8Array, "be", 32), 0), e.signature.set(a.s.toArrayLike(Uint8Array, "be", 32), 32), e.recid = a.recoveryParam, 0;
      },
      ecdsaVerify(e, t, n) {
        const r = {
            r: e.subarray(0, 32),
            s: e.subarray(32, 64)
          },
          i = new ew(r.r),
          o = new ew(r.s);
        if (i.cmp(Xy.n) >= 0 || o.cmp(Xy.n) >= 0) return 1;
        if (1 === o.cmp(Jy.nh) || i.isZero() || o.isZero()) return 3;
        const a = tw(n);
        if (null === a) return 2;
        const s = a.getPublic();
        return Jy.verify(t, r, s) ? 0 : 3;
      },
      ecdsaRecover(e, t, n, r) {
        const i = {
            r: t.slice(0, 32),
            s: t.slice(32, 64)
          },
          o = new ew(i.r),
          a = new ew(i.s);
        if (o.cmp(Xy.n) >= 0 || a.cmp(Xy.n) >= 0) return 1;
        if (o.isZero() || a.isZero()) return 2;
        let s;
        try {
          s = Jy.recoverPubKey(r, i, n);
        } catch (e) {
          return 2;
        }
        return nw(e, s), 0;
      },
      ecdh(e, t, n, r, i, o, a) {
        const s = tw(t);
        if (null === s) return 1;
        const u = new ew(n);
        if (u.cmp(Xy.n) >= 0 || u.isZero()) return 2;
        const c = s.getPublic().mul(u);
        if (void 0 === i) {
          const t = c.encode(null, !0),
            n = Jy.hash().update(t).digest();
          for (let t = 0; t < 32; ++t) e[t] = n[t];
        } else {
          o || (o = new Uint8Array(32));
          const t = c.getX().toArray("be", 32);
          for (let e = 0; e < 32; ++e) o[e] = t[e];
          a || (a = new Uint8Array(32));
          const n = c.getY().toArray("be", 32);
          for (let e = 0; e < 32; ++e) a[e] = n[e];
          const s = i(o, a, r);
          if (!(s instanceof Uint8Array && s.length === e.length)) return 2;
          e.set(s);
        }
        return 0;
      }
    },
    iw = (e => ({
      contextRandomize(t) {
        if (sg(null === t || t instanceof Uint8Array, "Expected seed to be an Uint8Array or null"), null !== t && ug("seed", t, 32), 1 === e.contextRandomize(t)) throw new Error(Jm);
      },
      privateKeyVerify: t => (ug("private key", t, 32), 0 === e.privateKeyVerify(t)),
      privateKeyNegate(t) {
        switch (ug("private key", t, 32), e.privateKeyNegate(t)) {
          case 0:
            return t;
          case 1:
            throw new Error(Gm);
        }
      },
      privateKeyTweakAdd(t, n) {
        switch (ug("private key", t, 32), ug("tweak", n, 32), e.privateKeyTweakAdd(t, n)) {
          case 0:
            return t;
          case 1:
            throw new Error(Qm);
        }
      },
      privateKeyTweakMul(t, n) {
        switch (ug("private key", t, 32), ug("tweak", n, 32), e.privateKeyTweakMul(t, n)) {
          case 0:
            return t;
          case 1:
            throw new Error(Zm);
        }
      },
      publicKeyVerify: t => (ug("public key", t, [33, 65]), 0 === e.publicKeyVerify(t)),
      publicKeyCreate(t, n = !0, r) {
        switch (ug("private key", t, 32), cg(n), r = lg(r, n ? 33 : 65), e.publicKeyCreate(r, t)) {
          case 0:
            return r;
          case 1:
            throw new Error(Xm);
          case 2:
            throw new Error(tg);
        }
      },
      publicKeyConvert(t, n = !0, r) {
        switch (ug("public key", t, [33, 65]), cg(n), r = lg(r, n ? 33 : 65), e.publicKeyConvert(r, t)) {
          case 0:
            return r;
          case 1:
            throw new Error(eg);
          case 2:
            throw new Error(tg);
        }
      },
      publicKeyNegate(t, n = !0, r) {
        switch (ug("public key", t, [33, 65]), cg(n), r = lg(r, n ? 33 : 65), e.publicKeyNegate(r, t)) {
          case 0:
            return r;
          case 1:
            throw new Error(eg);
          case 2:
            throw new Error(Gm);
          case 3:
            throw new Error(tg);
        }
      },
      publicKeyCombine(t, n = !0, r) {
        sg(Array.isArray(t), "Expected public keys to be an Array"), sg(t.length > 0, "Expected public keys array will have more than zero items");
        for (const e of t) ug("public key", e, [33, 65]);
        switch (cg(n), r = lg(r, n ? 33 : 65), e.publicKeyCombine(r, t)) {
          case 0:
            return r;
          case 1:
            throw new Error(eg);
          case 2:
            throw new Error(ng);
          case 3:
            throw new Error(tg);
        }
      },
      publicKeyTweakAdd(t, n, r = !0, i) {
        switch (ug("public key", t, [33, 65]), ug("tweak", n, 32), cg(r), i = lg(i, r ? 33 : 65), e.publicKeyTweakAdd(i, t, n)) {
          case 0:
            return i;
          case 1:
            throw new Error(eg);
          case 2:
            throw new Error(Qm);
        }
      },
      publicKeyTweakMul(t, n, r = !0, i) {
        switch (ug("public key", t, [33, 65]), ug("tweak", n, 32), cg(r), i = lg(i, r ? 33 : 65), e.publicKeyTweakMul(i, t, n)) {
          case 0:
            return i;
          case 1:
            throw new Error(eg);
          case 2:
            throw new Error(Zm);
        }
      },
      signatureNormalize(t) {
        switch (ug("signature", t, 64), e.signatureNormalize(t)) {
          case 0:
            return t;
          case 1:
            throw new Error(rg);
        }
      },
      signatureExport(t, n) {
        ug("signature", t, 64);
        const r = {
          output: n = lg(n, 72),
          outputlen: 72
        };
        switch (e.signatureExport(r, t)) {
          case 0:
            return n.slice(0, r.outputlen);
          case 1:
            throw new Error(rg);
          case 2:
            throw new Error(Gm);
        }
      },
      signatureImport(t, n) {
        switch (ug("signature", t), n = lg(n, 64), e.signatureImport(n, t)) {
          case 0:
            return n;
          case 1:
            throw new Error(rg);
          case 2:
            throw new Error(Gm);
        }
      },
      ecdsaSign(t, n, r = {}, i) {
        ug("message", t, 32), ug("private key", n, 32), sg("Object" === dg(r), "Expected options to be an Object"), void 0 !== r.data && ug("options.data", r.data), void 0 !== r.noncefn && sg("Function" === dg(r.noncefn), "Expected options.noncefn to be a Function");
        const o = {
          signature: i = lg(i, 64),
          recid: null
        };
        switch (e.ecdsaSign(o, t, n, r.data, r.noncefn)) {
          case 0:
            return o;
          case 1:
            throw new Error(ig);
          case 2:
            throw new Error(Gm);
        }
      },
      ecdsaVerify(t, n, r) {
        switch (ug("signature", t, 64), ug("message", n, 32), ug("public key", r, [33, 65]), e.ecdsaVerify(t, n, r)) {
          case 0:
            return !0;
          case 3:
            return !1;
          case 1:
            throw new Error(rg);
          case 2:
            throw new Error(eg);
        }
      },
      ecdsaRecover(t, n, r, i = !0, o) {
        switch (ug("signature", t, 64), sg("Number" === dg(n) && n >= 0 && n <= 3, "Expected recovery id to be a Number within interval [0, 3]"), ug("message", r, 32), cg(i), o = lg(o, i ? 33 : 65), e.ecdsaRecover(o, t, n, r)) {
          case 0:
            return o;
          case 1:
            throw new Error(rg);
          case 2:
            throw new Error(og);
          case 3:
            throw new Error(Gm);
        }
      },
      ecdh(t, n, r = {}, i) {
        switch (ug("public key", t, [33, 65]), ug("private key", n, 32), sg("Object" === dg(r), "Expected options to be an Object"), void 0 !== r.data && ug("options.data", r.data), void 0 !== r.hashfn ? (sg("Function" === dg(r.hashfn), "Expected options.hashfn to be a Function"), void 0 !== r.xbuf && ug("options.xbuf", r.xbuf, 32), void 0 !== r.ybuf && ug("options.ybuf", r.ybuf, 32), ug("output", i)) : i = lg(i, 32), e.ecdh(i, t, n, r.data, r.hashfn, r.xbuf, r.ybuf)) {
          case 0:
            return i;
          case 1:
            throw new Error(eg);
          case 2:
            throw new Error(ag);
        }
      }
    }))(rw),
    ow = {},
    aw = {};
  !function (e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.SECRET_KEY_LENGTH = e.AES_IV_PLUS_TAG_LENGTH = e.AES_TAG_LENGTH = e.AES_IV_LENGTH = e.UNCOMPRESSED_PUBLIC_KEY_SIZE = void 0, e.UNCOMPRESSED_PUBLIC_KEY_SIZE = 65, e.AES_IV_LENGTH = 16, e.AES_TAG_LENGTH = 16, e.AES_IV_PLUS_TAG_LENGTH = e.AES_IV_LENGTH + e.AES_TAG_LENGTH, e.SECRET_KEY_LENGTH = 32;
  }(aw);
  var sw = n && n.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };
  Object.defineProperty(ow, "__esModule", {
    value: !0
  }), ow.aesDecrypt = ow.aesEncrypt = ow.getValidSecret = ow.decodeHex = ow.remove0x = void 0;
  var uw = Fm(),
    cw = sw(iw),
    lw = aw;
  function dw(e) {
    return e.startsWith("0x") || e.startsWith("0X") ? e.slice(2) : e;
  }
  ow.remove0x = dw, ow.decodeHex = function (e) {
    return A.from(dw(e), "hex");
  }, ow.getValidSecret = function () {
    var e;
    do {
      e = (0, uw.randomBytes)(lw.SECRET_KEY_LENGTH);
    } while (!cw.default.privateKeyVerify(e));
    return e;
  }, ow.aesEncrypt = function (e, t) {
    var n = (0, uw.randomBytes)(lw.AES_IV_LENGTH),
      r = (0, uw.createCipheriv)("aes-256-gcm", e, n),
      i = A.concat([r.update(t), r.final()]),
      o = r.getAuthTag();
    return A.concat([n, o, i]);
  }, ow.aesDecrypt = function (e, t) {
    var n = t.slice(0, lw.AES_IV_LENGTH),
      r = t.slice(lw.AES_IV_LENGTH, lw.AES_IV_PLUS_TAG_LENGTH),
      i = t.slice(lw.AES_IV_PLUS_TAG_LENGTH),
      o = (0, uw.createDecipheriv)("aes-256-gcm", e, n);
    return o.setAuthTag(r), A.concat([o.update(i), o.final()]);
  };
  var fw = {},
    hw = n && n.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
  Object.defineProperty(fw, "__esModule", {
    value: !0
  });
  var pw = hw(Ym),
    mw = hw(iw),
    gw = ow,
    vw = aw,
    bw = function () {
      function e(e) {
        this.uncompressed = A.from(mw.default.publicKeyConvert(e, !1)), this.compressed = A.from(mw.default.publicKeyConvert(e, !0));
      }
      return e.fromHex = function (t) {
        var n = (0, gw.decodeHex)(t);
        if (n.length === vw.UNCOMPRESSED_PUBLIC_KEY_SIZE - 1) {
          var r = A.from([4]);
          return new e(A.concat([r, n]));
        }
        return new e(n);
      }, e.prototype.toHex = function (e) {
        return void 0 === e && (e = !0), e ? this.compressed.toString("hex") : this.uncompressed.toString("hex");
      }, e.prototype.decapsulate = function (e) {
        var t = A.concat([this.uncompressed, e.multiply(this)]);
        return (0, pw.default)(t, 32, {
          hash: "SHA-256"
        });
      }, e.prototype.equals = function (e) {
        return this.uncompressed.equals(e.uncompressed);
      }, e;
    }();
  fw.default = bw;
  var yw = n && n.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };
  Object.defineProperty(ce, "__esModule", {
    value: !0
  });
  var ww = yw(Ym),
    Aw = yw(iw),
    _w = ow,
    Ew = yw(fw),
    Sw = function () {
      function e(e) {
        if (this.secret = e || (0, _w.getValidSecret)(), !Aw.default.privateKeyVerify(this.secret)) throw new Error("Invalid private key");
        this.publicKey = new Ew.default(A.from(Aw.default.publicKeyCreate(this.secret)));
      }
      return e.fromHex = function (t) {
        return new e((0, _w.decodeHex)(t));
      }, e.prototype.toHex = function () {
        return "0x".concat(this.secret.toString("hex"));
      }, e.prototype.encapsulate = function (e) {
        var t = A.concat([this.publicKey.uncompressed, this.multiply(e)]);
        return (0, ww.default)(t, 32, {
          hash: "SHA-256"
        });
      }, e.prototype.multiply = function (e) {
        return A.from(Aw.default.publicKeyTweakMul(e.compressed, this.secret, !1));
      }, e.prototype.equals = function (e) {
        return this.secret.equals(e.secret);
      }, e;
    }();
  ce.default = Sw, function (e) {
    var t = n && n.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.PublicKey = e.PrivateKey = void 0;
    var r = ce;
    Object.defineProperty(e, "PrivateKey", {
      enumerable: !0,
      get: function () {
        return t(r).default;
      }
    });
    var i = fw;
    Object.defineProperty(e, "PublicKey", {
      enumerable: !0,
      get: function () {
        return t(i).default;
      }
    });
  }(ue), function (e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.utils = e.PublicKey = e.PrivateKey = e.decrypt = e.encrypt = void 0;
    var t = ue,
      n = ow,
      r = aw;
    e.encrypt = function (e, r) {
      var i = new t.PrivateKey(),
        o = e instanceof A ? new t.PublicKey(e) : t.PublicKey.fromHex(e),
        a = i.encapsulate(o),
        s = (0, n.aesEncrypt)(a, r);
      return A.concat([i.publicKey.uncompressed, s]);
    }, e.decrypt = function (e, i) {
      var o = e instanceof A ? new t.PrivateKey(e) : t.PrivateKey.fromHex(e),
        a = new t.PublicKey(i.slice(0, r.UNCOMPRESSED_PUBLIC_KEY_SIZE)),
        s = i.slice(r.UNCOMPRESSED_PUBLIC_KEY_SIZE),
        u = a.decapsulate(o);
      return (0, n.aesDecrypt)(u, s);
    };
    var i = ue;
    Object.defineProperty(e, "PrivateKey", {
      enumerable: !0,
      get: function () {
        return i.PrivateKey;
      }
    }), Object.defineProperty(e, "PublicKey", {
      enumerable: !0,
      get: function () {
        return i.PublicKey;
      }
    }), e.utils = {
      aesDecrypt: n.aesDecrypt,
      aesEncrypt: n.aesEncrypt,
      decodeHex: n.decodeHex,
      getValidSecret: n.getValidSecret,
      remove0x: n.remove0x
    };
  }(se);
  var kw = {
    exports: {}
  };
  !function (e, t) {
    !function (t) {
      var n = Object.hasOwnProperty,
        r = Array.isArray ? Array.isArray : function (e) {
          return "[object Array]" === Object.prototype.toString.call(e);
        },
        i = "object" == typeof Be && !0,
        o = "function" == typeof Symbol,
        a = "object" == typeof Reflect,
        s = "function" == typeof setImmediate ? setImmediate : setTimeout,
        u = o ? a && "function" == typeof Reflect.ownKeys ? Reflect.ownKeys : function (e) {
          var t = Object.getOwnPropertyNames(e);
          return t.push.apply(t, Object.getOwnPropertySymbols(e)), t;
        } : Object.keys;
      function c() {
        this._events = {}, this._conf && l.call(this, this._conf);
      }
      function l(e) {
        e && (this._conf = e, e.delimiter && (this.delimiter = e.delimiter), e.maxListeners !== t && (this._maxListeners = e.maxListeners), e.wildcard && (this.wildcard = e.wildcard), e.newListener && (this._newListener = e.newListener), e.removeListener && (this._removeListener = e.removeListener), e.verboseMemoryLeak && (this.verboseMemoryLeak = e.verboseMemoryLeak), e.ignoreErrors && (this.ignoreErrors = e.ignoreErrors), this.wildcard && (this.listenerTree = {}));
      }
      function d(e, t) {
        var n = "(node) warning: possible EventEmitter memory leak detected. " + e + " listeners added. Use emitter.setMaxListeners() to increase limit.";
        if (this.verboseMemoryLeak && (n += " Event name: " + t + "."), void 0 !== Be && Be.emitWarning) {
          var r = new Error(n);
          r.name = "MaxListenersExceededWarning", r.emitter = this, r.count = e, Be.emitWarning(r);
        } else console.error(n), console.trace && console.trace();
      }
      var f = function (e, t, n) {
        var r = arguments.length;
        switch (r) {
          case 0:
            return [];
          case 1:
            return [e];
          case 2:
            return [e, t];
          case 3:
            return [e, t, n];
          default:
            for (var i = new Array(r); r--;) i[r] = arguments[r];
            return i;
        }
      };
      function h(e, n) {
        for (var r = {}, i = e.length, o = n ? n.length : 0, a = 0; a < i; a++) r[e[a]] = a < o ? n[a] : t;
        return r;
      }
      function p(e, t, n) {
        var r, i;
        if (this._emitter = e, this._target = t, this._listeners = {}, this._listenersCount = 0, (n.on || n.off) && (r = n.on, i = n.off), t.addEventListener ? (r = t.addEventListener, i = t.removeEventListener) : t.addListener ? (r = t.addListener, i = t.removeListener) : t.on && (r = t.on, i = t.off), !r && !i) throw Error("target does not implement any known event API");
        if ("function" != typeof r) throw TypeError("on method must be a function");
        if ("function" != typeof i) throw TypeError("off method must be a function");
        this._on = r, this._off = i;
        var o = e._observers;
        o ? o.push(this) : e._observers = [this];
      }
      function m(e, r, i, o) {
        var a = Object.assign({}, r);
        if (!e) return a;
        if ("object" != typeof e) throw TypeError("options must be an object");
        var s,
          u,
          c,
          l = Object.keys(e),
          d = l.length;
        function f(e) {
          throw Error('Invalid "' + s + '" option value' + (e ? ". Reason: " + e : ""));
        }
        for (var h = 0; h < d; h++) {
          if (s = l[h], !o && !n.call(r, s)) throw Error('Unknown "' + s + '" option');
          (u = e[s]) !== t && (c = i[s], a[s] = c ? c(u, f) : u);
        }
        return a;
      }
      function g(e, t) {
        return "function" == typeof e && e.hasOwnProperty("prototype") || t("value must be a constructor"), e;
      }
      function v(e) {
        var t = "value must be type of " + e.join("|"),
          n = e.length,
          r = e[0],
          i = e[1];
        return 1 === n ? function (e, n) {
          if (typeof e === r) return e;
          n(t);
        } : 2 === n ? function (e, n) {
          var o = typeof e;
          if (o === r || o === i) return e;
          n(t);
        } : function (r, i) {
          for (var o = typeof r, a = n; a-- > 0;) if (o === e[a]) return r;
          i(t);
        };
      }
      Object.assign(p.prototype, {
        subscribe: function (e, t, n) {
          var r = this,
            i = this._target,
            o = this._emitter,
            a = this._listeners,
            s = function () {
              var r = f.apply(null, arguments),
                a = {
                  data: r,
                  name: t,
                  original: e
                };
              n ? !1 !== n.call(i, a) && o.emit.apply(o, [a.name].concat(r)) : o.emit.apply(o, [t].concat(r));
            };
          if (a[e]) throw Error("Event '" + e + "' is already listening");
          this._listenersCount++, o._newListener && o._removeListener && !r._onNewListener ? (this._onNewListener = function (n) {
            n === t && null === a[e] && (a[e] = s, r._on.call(i, e, s));
          }, o.on("newListener", this._onNewListener), this._onRemoveListener = function (n) {
            n === t && !o.hasListeners(n) && a[e] && (a[e] = null, r._off.call(i, e, s));
          }, a[e] = null, o.on("removeListener", this._onRemoveListener)) : (a[e] = s, r._on.call(i, e, s));
        },
        unsubscribe: function (e) {
          var t,
            n,
            r,
            i = this,
            o = this._listeners,
            a = this._emitter,
            s = this._off,
            c = this._target;
          if (e && "string" != typeof e) throw TypeError("event must be a string");
          function l() {
            i._onNewListener && (a.off("newListener", i._onNewListener), a.off("removeListener", i._onRemoveListener), i._onNewListener = null, i._onRemoveListener = null);
            var e = A.call(a, i);
            a._observers.splice(e, 1);
          }
          if (e) {
            if (!(t = o[e])) return;
            s.call(c, e, t), delete o[e], --this._listenersCount || l();
          } else {
            for (r = (n = u(o)).length; r-- > 0;) e = n[r], s.call(c, e, o[e]);
            this._listeners = {}, this._listenersCount = 0, l();
          }
        }
      });
      var b = v(["function"]),
        y = v(["object", "function"]);
      function w(e, t, n) {
        var r,
          i,
          o,
          a = 0,
          s = new e(function (u, c, l) {
            function d() {
              i && (i = null), a && (clearTimeout(a), a = 0);
            }
            n = m(n, {
              timeout: 0,
              overload: !1
            }, {
              timeout: function (e, t) {
                return ("number" != typeof (e *= 1) || e < 0 || !Number.isFinite(e)) && t("timeout must be a positive number"), e;
              }
            }), r = !n.overload && "function" == typeof e.prototype.cancel && "function" == typeof l;
            var f = function (e) {
                d(), u(e);
              },
              h = function (e) {
                d(), c(e);
              };
            r ? t(f, h, l) : (i = [function (e) {
              h(e || Error("canceled"));
            }], t(f, h, function (e) {
              if (o) throw Error("Unable to subscribe on cancel event asynchronously");
              if ("function" != typeof e) throw TypeError("onCancel callback must be a function");
              i.push(e);
            }), o = !0), n.timeout > 0 && (a = setTimeout(function () {
              var e = Error("timeout");
              e.code = "ETIMEDOUT", a = 0, s.cancel(e), c(e);
            }, n.timeout));
          });
        return r || (s.cancel = function (e) {
          if (i) {
            for (var t = i.length, n = 1; n < t; n++) i[n](e);
            i[0](e), i = null;
          }
        }), s;
      }
      function A(e) {
        var t = this._observers;
        if (!t) return -1;
        for (var n = t.length, r = 0; r < n; r++) if (t[r]._target === e) return r;
        return -1;
      }
      function _(e, t, n, r, i) {
        if (!n) return null;
        if (0 === r) {
          var o = typeof t;
          if ("string" === o) {
            var a,
              s,
              c = 0,
              l = 0,
              d = this.delimiter,
              f = d.length;
            if (-1 !== (s = t.indexOf(d))) {
              a = new Array(5);
              do {
                a[c++] = t.slice(l, s), l = s + f;
              } while (-1 !== (s = t.indexOf(d, l)));
              a[c++] = t.slice(l), t = a, i = c;
            } else t = [t], i = 1;
          } else "object" === o ? i = t.length : (t = [t], i = 1);
        }
        var h,
          p,
          m,
          g,
          v,
          b,
          y,
          w = null,
          A = t[r],
          E = t[r + 1];
        if (r === i) n._listeners && ("function" == typeof n._listeners ? (e && e.push(n._listeners), w = [n]) : (e && e.push.apply(e, n._listeners), w = [n]));else {
          if ("*" === A) {
            for (s = (b = u(n)).length; s-- > 0;) "_listeners" !== (h = b[s]) && (y = _(e, t, n[h], r + 1, i)) && (w ? w.push.apply(w, y) : w = y);
            return w;
          }
          if ("**" === A) {
            for ((v = r + 1 === i || r + 2 === i && "*" === E) && n._listeners && (w = _(e, t, n, i, i)), s = (b = u(n)).length; s-- > 0;) "_listeners" !== (h = b[s]) && ("*" === h || "**" === h ? (n[h]._listeners && !v && (y = _(e, t, n[h], i, i)) && (w ? w.push.apply(w, y) : w = y), y = _(e, t, n[h], r, i)) : y = _(e, t, n[h], h === E ? r + 2 : r, i), y && (w ? w.push.apply(w, y) : w = y));
            return w;
          }
          n[A] && (w = _(e, t, n[A], r + 1, i));
        }
        if ((p = n["*"]) && _(e, t, p, r + 1, i), m = n["**"]) if (r < i) for (m._listeners && _(e, t, m, i, i), s = (b = u(m)).length; s-- > 0;) "_listeners" !== (h = b[s]) && (h === E ? _(e, t, m[h], r + 2, i) : h === A ? _(e, t, m[h], r + 1, i) : ((g = {})[h] = m[h], _(e, t, {
          "**": g
        }, r + 1, i)));else m._listeners ? _(e, t, m, i, i) : m["*"] && m["*"]._listeners && _(e, t, m["*"], i, i);
        return w;
      }
      function E(e, t, n) {
        var r,
          i,
          o = 0,
          a = 0,
          s = this.delimiter,
          u = s.length;
        if ("string" == typeof e) {
          if (-1 !== (r = e.indexOf(s))) {
            i = new Array(5);
            do {
              i[o++] = e.slice(a, r), a = r + u;
            } while (-1 !== (r = e.indexOf(s, a)));
            i[o++] = e.slice(a);
          } else i = [e], o = 1;
        } else i = e, o = e.length;
        if (o > 1) for (r = 0; r + 1 < o; r++) if ("**" === i[r] && "**" === i[r + 1]) return;
        var c,
          l = this.listenerTree;
        for (r = 0; r < o; r++) if (l = l[c = i[r]] || (l[c] = {}), r === o - 1) return l._listeners ? ("function" == typeof l._listeners && (l._listeners = [l._listeners]), n ? l._listeners.unshift(t) : l._listeners.push(t), !l._listeners.warned && this._maxListeners > 0 && l._listeners.length > this._maxListeners && (l._listeners.warned = !0, d.call(this, l._listeners.length, c))) : l._listeners = t, !0;
        return !0;
      }
      function S(e, t, n, r) {
        for (var i, o, a, s, c = u(e), l = c.length, d = e._listeners; l-- > 0;) i = e[o = c[l]], a = "_listeners" === o ? n : n ? n.concat(o) : [o], s = r || "symbol" == typeof o, d && t.push(s ? a : a.join(this.delimiter)), "object" == typeof i && S.call(this, i, t, a, s);
        return t;
      }
      function k(e) {
        for (var t, n, r, i = u(e), o = i.length; o-- > 0;) (t = e[n = i[o]]) && (r = !0, "_listeners" === n || k(t) || delete e[n]);
        return r;
      }
      function M(e, t, n) {
        this.emitter = e, this.event = t, this.listener = n;
      }
      function C(e, n, r) {
        if (!0 === r) a = !0;else if (!1 === r) o = !0;else {
          if (!r || "object" != typeof r) throw TypeError("options should be an object or true");
          var o = r.async,
            a = r.promisify,
            u = r.nextTick,
            c = r.objectify;
        }
        if (o || u || a) {
          var l = n,
            d = n._origin || n;
          if (u && !i) throw Error("process.nextTick is not supported");
          a === t && (a = "AsyncFunction" === n.constructor.name), n = function () {
            var e = arguments,
              t = this,
              n = this.event;
            return a ? u ? Promise.resolve() : new Promise(function (e) {
              s(e);
            }).then(function () {
              return t.event = n, l.apply(t, e);
            }) : (u ? Ee : s)(function () {
              t.event = n, l.apply(t, e);
            });
          }, n._async = !0, n._origin = d;
        }
        return [n, c ? new M(this, e, n) : this];
      }
      function x(e) {
        this._events = {}, this._newListener = !1, this._removeListener = !1, this.verboseMemoryLeak = !1, l.call(this, e);
      }
      M.prototype.off = function () {
        return this.emitter.off(this.event, this.listener), this;
      }, x.EventEmitter2 = x, x.prototype.listenTo = function (e, n, i) {
        if ("object" != typeof e) throw TypeError("target musts be an object");
        var o = this;
        function a(t) {
          if ("object" != typeof t) throw TypeError("events must be an object");
          var n,
            r = i.reducers,
            a = A.call(o, e);
          n = -1 === a ? new p(o, e, i) : o._observers[a];
          for (var s, c = u(t), l = c.length, d = "function" == typeof r, f = 0; f < l; f++) s = c[f], n.subscribe(s, t[s] || s, d ? r : r && r[s]);
        }
        return i = m(i, {
          on: t,
          off: t,
          reducers: t
        }, {
          on: b,
          off: b,
          reducers: y
        }), r(n) ? a(h(n)) : a("string" == typeof n ? h(n.split(/\s+/)) : n), this;
      }, x.prototype.stopListeningTo = function (e, t) {
        var n = this._observers;
        if (!n) return !1;
        var r,
          i = n.length,
          o = !1;
        if (e && "object" != typeof e) throw TypeError("target should be an object");
        for (; i-- > 0;) r = n[i], e && r._target !== e || (r.unsubscribe(t), o = !0);
        return o;
      }, x.prototype.delimiter = ".", x.prototype.setMaxListeners = function (e) {
        e !== t && (this._maxListeners = e, this._conf || (this._conf = {}), this._conf.maxListeners = e);
      }, x.prototype.getMaxListeners = function () {
        return this._maxListeners;
      }, x.prototype.event = "", x.prototype.once = function (e, t, n) {
        return this._once(e, t, !1, n);
      }, x.prototype.prependOnceListener = function (e, t, n) {
        return this._once(e, t, !0, n);
      }, x.prototype._once = function (e, t, n, r) {
        return this._many(e, 1, t, n, r);
      }, x.prototype.many = function (e, t, n, r) {
        return this._many(e, t, n, !1, r);
      }, x.prototype.prependMany = function (e, t, n, r) {
        return this._many(e, t, n, !0, r);
      }, x.prototype._many = function (e, t, n, r, i) {
        var o = this;
        if ("function" != typeof n) throw new Error("many only accepts instances of Function");
        function a() {
          return 0 == --t && o.off(e, a), n.apply(this, arguments);
        }
        return a._origin = n, this._on(e, a, r, i);
      }, x.prototype.emit = function () {
        if (!this._events && !this._all) return !1;
        this._events || c.call(this);
        var e,
          t,
          n,
          r,
          i,
          a,
          s = arguments[0],
          u = this.wildcard;
        if ("newListener" === s && !this._newListener && !this._events.newListener) return !1;
        if (u && (e = s, "newListener" !== s && "removeListener" !== s && "object" == typeof s)) {
          if (n = s.length, o) for (r = 0; r < n; r++) if ("symbol" == typeof s[r]) {
            a = !0;
            break;
          }
          a || (s = s.join(this.delimiter));
        }
        var l,
          d = arguments.length;
        if (this._all && this._all.length) for (r = 0, n = (l = this._all.slice()).length; r < n; r++) switch (this.event = s, d) {
          case 1:
            l[r].call(this, s);
            break;
          case 2:
            l[r].call(this, s, arguments[1]);
            break;
          case 3:
            l[r].call(this, s, arguments[1], arguments[2]);
            break;
          default:
            l[r].apply(this, arguments);
        }
        if (u) l = [], _.call(this, l, e, this.listenerTree, 0, n);else {
          if ("function" == typeof (l = this._events[s])) {
            switch (this.event = s, d) {
              case 1:
                l.call(this);
                break;
              case 2:
                l.call(this, arguments[1]);
                break;
              case 3:
                l.call(this, arguments[1], arguments[2]);
                break;
              default:
                for (t = new Array(d - 1), i = 1; i < d; i++) t[i - 1] = arguments[i];
                l.apply(this, t);
            }
            return !0;
          }
          l && (l = l.slice());
        }
        if (l && l.length) {
          if (d > 3) for (t = new Array(d - 1), i = 1; i < d; i++) t[i - 1] = arguments[i];
          for (r = 0, n = l.length; r < n; r++) switch (this.event = s, d) {
            case 1:
              l[r].call(this);
              break;
            case 2:
              l[r].call(this, arguments[1]);
              break;
            case 3:
              l[r].call(this, arguments[1], arguments[2]);
              break;
            default:
              l[r].apply(this, t);
          }
          return !0;
        }
        if (!this.ignoreErrors && !this._all && "error" === s) throw arguments[1] instanceof Error ? arguments[1] : new Error("Uncaught, unspecified 'error' event.");
        return !!this._all;
      }, x.prototype.emitAsync = function () {
        if (!this._events && !this._all) return !1;
        this._events || c.call(this);
        var e,
          t,
          n,
          r,
          i,
          a,
          s = arguments[0],
          u = this.wildcard;
        if ("newListener" === s && !this._newListener && !this._events.newListener) return Promise.resolve([!1]);
        if (u && (e = s, "newListener" !== s && "removeListener" !== s && "object" == typeof s)) {
          if (r = s.length, o) for (i = 0; i < r; i++) if ("symbol" == typeof s[i]) {
            t = !0;
            break;
          }
          t || (s = s.join(this.delimiter));
        }
        var l,
          d = [],
          f = arguments.length;
        if (this._all) for (i = 0, r = this._all.length; i < r; i++) switch (this.event = s, f) {
          case 1:
            d.push(this._all[i].call(this, s));
            break;
          case 2:
            d.push(this._all[i].call(this, s, arguments[1]));
            break;
          case 3:
            d.push(this._all[i].call(this, s, arguments[1], arguments[2]));
            break;
          default:
            d.push(this._all[i].apply(this, arguments));
        }
        if (u ? (l = [], _.call(this, l, e, this.listenerTree, 0)) : l = this._events[s], "function" == typeof l) switch (this.event = s, f) {
          case 1:
            d.push(l.call(this));
            break;
          case 2:
            d.push(l.call(this, arguments[1]));
            break;
          case 3:
            d.push(l.call(this, arguments[1], arguments[2]));
            break;
          default:
            for (n = new Array(f - 1), a = 1; a < f; a++) n[a - 1] = arguments[a];
            d.push(l.apply(this, n));
        } else if (l && l.length) {
          if (l = l.slice(), f > 3) for (n = new Array(f - 1), a = 1; a < f; a++) n[a - 1] = arguments[a];
          for (i = 0, r = l.length; i < r; i++) switch (this.event = s, f) {
            case 1:
              d.push(l[i].call(this));
              break;
            case 2:
              d.push(l[i].call(this, arguments[1]));
              break;
            case 3:
              d.push(l[i].call(this, arguments[1], arguments[2]));
              break;
            default:
              d.push(l[i].apply(this, n));
          }
        } else if (!this.ignoreErrors && !this._all && "error" === s) return arguments[1] instanceof Error ? Promise.reject(arguments[1]) : Promise.reject("Uncaught, unspecified 'error' event.");
        return Promise.all(d);
      }, x.prototype.on = function (e, t, n) {
        return this._on(e, t, !1, n);
      }, x.prototype.prependListener = function (e, t, n) {
        return this._on(e, t, !0, n);
      }, x.prototype.onAny = function (e) {
        return this._onAny(e, !1);
      }, x.prototype.prependAny = function (e) {
        return this._onAny(e, !0);
      }, x.prototype.addListener = x.prototype.on, x.prototype._onAny = function (e, t) {
        if ("function" != typeof e) throw new Error("onAny only accepts instances of Function");
        return this._all || (this._all = []), t ? this._all.unshift(e) : this._all.push(e), this;
      }, x.prototype._on = function (e, n, r, i) {
        if ("function" == typeof e) return this._onAny(e, n), this;
        if ("function" != typeof n) throw new Error("on only accepts instances of Function");
        this._events || c.call(this);
        var o,
          a = this;
        return i !== t && (n = (o = C.call(this, e, n, i))[0], a = o[1]), this._newListener && this.emit("newListener", e, n), this.wildcard ? (E.call(this, e, n, r), a) : (this._events[e] ? ("function" == typeof this._events[e] && (this._events[e] = [this._events[e]]), r ? this._events[e].unshift(n) : this._events[e].push(n), !this._events[e].warned && this._maxListeners > 0 && this._events[e].length > this._maxListeners && (this._events[e].warned = !0, d.call(this, this._events[e].length, e))) : this._events[e] = n, a);
      }, x.prototype.off = function (e, t) {
        if ("function" != typeof t) throw new Error("removeListener only takes instances of Function");
        var n,
          i = [];
        if (this.wildcard) {
          var o = "string" == typeof e ? e.split(this.delimiter) : e.slice();
          if (!(i = _.call(this, null, o, this.listenerTree, 0))) return this;
        } else {
          if (!this._events[e]) return this;
          n = this._events[e], i.push({
            _listeners: n
          });
        }
        for (var a = 0; a < i.length; a++) {
          var s = i[a];
          if (n = s._listeners, r(n)) {
            for (var u = -1, c = 0, l = n.length; c < l; c++) if (n[c] === t || n[c].listener && n[c].listener === t || n[c]._origin && n[c]._origin === t) {
              u = c;
              break;
            }
            if (u < 0) continue;
            return this.wildcard ? s._listeners.splice(u, 1) : this._events[e].splice(u, 1), 0 === n.length && (this.wildcard ? delete s._listeners : delete this._events[e]), this._removeListener && this.emit("removeListener", e, t), this;
          }
          (n === t || n.listener && n.listener === t || n._origin && n._origin === t) && (this.wildcard ? delete s._listeners : delete this._events[e], this._removeListener && this.emit("removeListener", e, t));
        }
        return this.listenerTree && k(this.listenerTree), this;
      }, x.prototype.offAny = function (e) {
        var t,
          n = 0,
          r = 0;
        if (e && this._all && this._all.length > 0) {
          for (n = 0, r = (t = this._all).length; n < r; n++) if (e === t[n]) return t.splice(n, 1), this._removeListener && this.emit("removeListenerAny", e), this;
        } else {
          if (t = this._all, this._removeListener) for (n = 0, r = t.length; n < r; n++) this.emit("removeListenerAny", t[n]);
          this._all = [];
        }
        return this;
      }, x.prototype.removeListener = x.prototype.off, x.prototype.removeAllListeners = function (e) {
        if (e === t) return !this._events || c.call(this), this;
        if (this.wildcard) {
          var n,
            r = _.call(this, null, e, this.listenerTree, 0);
          if (!r) return this;
          for (n = 0; n < r.length; n++) r[n]._listeners = null;
          this.listenerTree && k(this.listenerTree);
        } else this._events && (this._events[e] = null);
        return this;
      }, x.prototype.listeners = function (e) {
        var n,
          r,
          i,
          o,
          a,
          s = this._events;
        if (e === t) {
          if (this.wildcard) throw Error("event name required for wildcard emitter");
          if (!s) return [];
          for (o = (n = u(s)).length, i = []; o-- > 0;) "function" == typeof (r = s[n[o]]) ? i.push(r) : i.push.apply(i, r);
          return i;
        }
        if (this.wildcard) {
          if (!(a = this.listenerTree)) return [];
          var c = [],
            l = "string" == typeof e ? e.split(this.delimiter) : e.slice();
          return _.call(this, c, l, a, 0), c;
        }
        return s && (r = s[e]) ? "function" == typeof r ? [r] : r : [];
      }, x.prototype.eventNames = function (e) {
        var t = this._events;
        return this.wildcard ? S.call(this, this.listenerTree, [], null, e) : t ? u(t) : [];
      }, x.prototype.listenerCount = function (e) {
        return this.listeners(e).length;
      }, x.prototype.hasListeners = function (e) {
        if (this.wildcard) {
          var n = [],
            r = "string" == typeof e ? e.split(this.delimiter) : e.slice();
          return _.call(this, n, r, this.listenerTree, 0), n.length > 0;
        }
        var i = this._events,
          o = this._all;
        return !!(o && o.length || i && (e === t ? u(i).length : i[e]));
      }, x.prototype.listenersAny = function () {
        return this._all ? this._all : [];
      }, x.prototype.waitFor = function (e, n) {
        var r = this,
          i = typeof n;
        return "number" === i ? n = {
          timeout: n
        } : "function" === i && (n = {
          filter: n
        }), w((n = m(n, {
          timeout: 0,
          filter: t,
          handleError: !1,
          Promise: Promise,
          overload: !1
        }, {
          filter: b,
          Promise: g
        })).Promise, function (t, i, o) {
          function a() {
            var o = n.filter;
            if (!o || o.apply(r, arguments)) if (r.off(e, a), n.handleError) {
              var s = arguments[0];
              s ? i(s) : t(f.apply(null, arguments).slice(1));
            } else t(f.apply(null, arguments));
          }
          o(function () {
            r.off(e, a);
          }), r._on(e, a, !1);
        }, {
          timeout: n.timeout,
          overload: n.overload
        });
      };
      var R = x.prototype;
      Object.defineProperties(x, {
        defaultMaxListeners: {
          get: function () {
            return R._maxListeners;
          },
          set: function (e) {
            if ("number" != typeof e || e < 0 || Number.isNaN(e)) throw TypeError("n must be a non-negative number");
            R._maxListeners = e;
          },
          enumerable: !0
        },
        once: {
          value: function (e, t, n) {
            return w((n = m(n, {
              Promise: Promise,
              timeout: 0,
              overload: !1
            }, {
              Promise: g
            })).Promise, function (n, r, i) {
              var o;
              if ("function" == typeof e.addEventListener) return o = function () {
                n(f.apply(null, arguments));
              }, i(function () {
                e.removeEventListener(t, o);
              }), void e.addEventListener(t, o, {
                once: !0
              });
              var a,
                s = function () {
                  a && e.removeListener("error", a), n(f.apply(null, arguments));
                };
              "error" !== t && (a = function (n) {
                e.removeListener(t, s), r(n);
              }, e.once("error", a)), i(function () {
                a && e.removeListener("error", a), e.removeListener(t, s);
              }), e.once(t, s);
            }, {
              timeout: n.timeout,
              overload: n.overload
            });
          },
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperties(R, {
        _maxListeners: {
          value: 10,
          writable: !0,
          configurable: !0
        },
        _observers: {
          value: null,
          writable: !0,
          configurable: !0
        }
      }), "function" == typeof t && t.amd ? t(function () {
        return x;
      }) : e.exports = x;
    }();
  }(kw);
  var Mw,
    Cw = kw.exports,
    xw = new Uint8Array(16);
  function Rw() {
    if (!Mw && !(Mw = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return Mw(xw);
  }
  var Iw = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
  function Tw(e) {
    return "string" == typeof e && Iw.test(e);
  }
  for (var Pw = [], Ow = 0; Ow < 256; ++Ow) Pw.push((Ow + 256).toString(16).substr(1));
  function Lw(e, t, n) {
    var r = (e = e || {}).random || (e.rng || Rw)();
    if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
      n = n || 0;
      for (var i = 0; i < 16; ++i) t[n + i] = r[i];
      return t;
    }
    return function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = (Pw[e[t + 0]] + Pw[e[t + 1]] + Pw[e[t + 2]] + Pw[e[t + 3]] + "-" + Pw[e[t + 4]] + Pw[e[t + 5]] + "-" + Pw[e[t + 6]] + Pw[e[t + 7]] + "-" + Pw[e[t + 8]] + Pw[e[t + 9]] + "-" + Pw[e[t + 10]] + Pw[e[t + 11]] + Pw[e[t + 12]] + Pw[e[t + 13]] + Pw[e[t + 14]] + Pw[e[t + 15]]).toLowerCase();
      if (!Tw(n)) throw TypeError("Stringified UUID is invalid");
      return n;
    }(r);
  }
  const Nw = Object.create(null);
  Nw.open = "0", Nw.close = "1", Nw.ping = "2", Nw.pong = "3", Nw.message = "4", Nw.upgrade = "5", Nw.noop = "6";
  const Dw = Object.create(null);
  Object.keys(Nw).forEach(e => {
    Dw[Nw[e]] = e;
  });
  const Bw = {
      type: "error",
      data: "parser error"
    },
    jw = "function" == typeof Blob || "undefined" != typeof Blob && "[object BlobConstructor]" === Object.prototype.toString.call(Blob),
    Fw = "function" == typeof ArrayBuffer,
    zw = e => "function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer,
    Uw = ({
      type: e,
      data: t
    }, n, r) => jw && t instanceof Blob ? n ? r(t) : qw(t, r) : Fw && (t instanceof ArrayBuffer || zw(t)) ? n ? r(t) : qw(new Blob([t]), r) : r(Nw[e] + (t || "")),
    qw = (e, t) => {
      const n = new FileReader();
      return n.onload = function () {
        const e = n.result.split(",")[1];
        t("b" + (e || ""));
      }, n.readAsDataURL(e);
    };
  function Kw(e) {
    return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  }
  let Hw;
  function Vw(e, t) {
    return jw && e.data instanceof Blob ? e.data.arrayBuffer().then(Kw).then(t) : Fw && (e.data instanceof ArrayBuffer || zw(e.data)) ? t(Kw(e.data)) : void Uw(e, !1, e => {
      Hw || (Hw = new TextEncoder()), t(Hw.encode(e));
    });
  }
  const $w = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    Ww = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256);
  for (let e = 0; e < 64; e++) Ww[$w.charCodeAt(e)] = e;
  const Yw = "function" == typeof ArrayBuffer,
    Gw = (e, t) => {
      if ("string" != typeof e) return {
        type: "message",
        data: Zw(e, t)
      };
      const n = e.charAt(0);
      if ("b" === n) return {
        type: "message",
        data: Qw(e.substring(1), t)
      };
      return Dw[n] ? e.length > 1 ? {
        type: Dw[n],
        data: e.substring(1)
      } : {
        type: Dw[n]
      } : Bw;
    },
    Qw = (e, t) => {
      if (Yw) {
        const n = (e => {
          let t,
            n,
            r,
            i,
            o,
            a = .75 * e.length,
            s = e.length,
            u = 0;
          "=" === e[e.length - 1] && (a--, "=" === e[e.length - 2] && a--);
          const c = new ArrayBuffer(a),
            l = new Uint8Array(c);
          for (t = 0; t < s; t += 4) n = Ww[e.charCodeAt(t)], r = Ww[e.charCodeAt(t + 1)], i = Ww[e.charCodeAt(t + 2)], o = Ww[e.charCodeAt(t + 3)], l[u++] = n << 2 | r >> 4, l[u++] = (15 & r) << 4 | i >> 2, l[u++] = (3 & i) << 6 | 63 & o;
          return c;
        })(e);
        return Zw(n, t);
      }
      return {
        base64: !0,
        data: e
      };
    },
    Zw = (e, t) => "blob" === t ? e instanceof Blob ? e : new Blob([e]) : e instanceof ArrayBuffer ? e : e.buffer,
    Jw = String.fromCharCode(30);
  let Xw;
  function eA(e) {
    if (e) return function (e) {
      for (var t in eA.prototype) e[t] = eA.prototype[t];
      return e;
    }(e);
  }
  eA.prototype.on = eA.prototype.addEventListener = function (e, t) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
  }, eA.prototype.once = function (e, t) {
    function n() {
      this.off(e, n), t.apply(this, arguments);
    }
    return n.fn = t, this.on(e, n), this;
  }, eA.prototype.off = eA.prototype.removeListener = eA.prototype.removeAllListeners = eA.prototype.removeEventListener = function (e, t) {
    if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
    var n,
      r = this._callbacks["$" + e];
    if (!r) return this;
    if (1 == arguments.length) return delete this._callbacks["$" + e], this;
    for (var i = 0; i < r.length; i++) if ((n = r[i]) === t || n.fn === t) {
      r.splice(i, 1);
      break;
    }
    return 0 === r.length && delete this._callbacks["$" + e], this;
  }, eA.prototype.emit = function (e) {
    this._callbacks = this._callbacks || {};
    for (var t = new Array(arguments.length - 1), n = this._callbacks["$" + e], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
    if (n) {
      r = 0;
      for (var i = (n = n.slice(0)).length; r < i; ++r) n[r].apply(this, t);
    }
    return this;
  }, eA.prototype.emitReserved = eA.prototype.emit, eA.prototype.listeners = function (e) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
  }, eA.prototype.hasListeners = function (e) {
    return !!this.listeners(e).length;
  };
  const tA = "undefined" != typeof self ? self : "undefined" != typeof window ? window : Function("return this")();
  function nA(e, ...t) {
    return t.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {});
  }
  const rA = tA.setTimeout,
    iA = tA.clearTimeout;
  function oA(e, t) {
    t.useNativeTimers ? (e.setTimeoutFn = rA.bind(tA), e.clearTimeoutFn = iA.bind(tA)) : (e.setTimeoutFn = tA.setTimeout.bind(tA), e.clearTimeoutFn = tA.clearTimeout.bind(tA));
  }
  class aA extends Error {
    constructor(e, t, n) {
      super(e), this.description = t, this.context = n, this.type = "TransportError";
    }
  }
  class sA extends eA {
    constructor(e) {
      super(), this.writable = !1, oA(this, e), this.opts = e, this.query = e.query, this.socket = e.socket;
    }
    onError(e, t, n) {
      return super.emitReserved("error", new aA(e, t, n)), this;
    }
    open() {
      return this.readyState = "opening", this.doOpen(), this;
    }
    close() {
      return "opening" !== this.readyState && "open" !== this.readyState || (this.doClose(), this.onClose()), this;
    }
    send(e) {
      "open" === this.readyState && this.write(e);
    }
    onOpen() {
      this.readyState = "open", this.writable = !0, super.emitReserved("open");
    }
    onData(e) {
      const t = Gw(e, this.socket.binaryType);
      this.onPacket(t);
    }
    onPacket(e) {
      super.emitReserved("packet", e);
    }
    onClose(e) {
      this.readyState = "closed", super.emitReserved("close", e);
    }
    pause(e) {}
    createUri(e, t = {}) {
      return e + "://" + this._hostname() + this._port() + this.opts.path + this._query(t);
    }
    _hostname() {
      const e = this.opts.hostname;
      return -1 === e.indexOf(":") ? e : "[" + e + "]";
    }
    _port() {
      return this.opts.port && (this.opts.secure && Number(443 !== this.opts.port) || !this.opts.secure && 80 !== Number(this.opts.port)) ? ":" + this.opts.port : "";
    }
    _query(e) {
      const t = function (e) {
        let t = "";
        for (let n in e) e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
        return t;
      }(e);
      return t.length ? "?" + t : "";
    }
  }
  const uA = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""),
    cA = 64,
    lA = {};
  let dA,
    fA = 0,
    hA = 0;
  function pA(e) {
    let t = "";
    do {
      t = uA[e % cA] + t, e = Math.floor(e / cA);
    } while (e > 0);
    return t;
  }
  function mA() {
    const e = pA(+new Date());
    return e !== dA ? (fA = 0, dA = e) : e + "." + pA(fA++);
  }
  for (; hA < cA; hA++) lA[uA[hA]] = hA;
  let gA = !1;
  try {
    gA = "undefined" != typeof XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
  } catch (e) {}
  const vA = gA;
  function bA(e) {
    const t = e.xdomain;
    try {
      if ("undefined" != typeof XMLHttpRequest && (!t || vA)) return new XMLHttpRequest();
    } catch (e) {}
    if (!t) try {
      return new tA[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
  }
  function yA() {}
  const wA = null != new bA({
    xdomain: !1
  }).responseType;
  class AA extends eA {
    constructor(e, t) {
      super(), oA(this, t), this.opts = t, this.method = t.method || "GET", this.uri = e, this.data = void 0 !== t.data ? t.data : null, this.create();
    }
    create() {
      var e;
      const t = nA(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
      t.xdomain = !!this.opts.xd;
      const n = this.xhr = new bA(t);
      try {
        n.open(this.method, this.uri, !0);
        try {
          if (this.opts.extraHeaders) {
            n.setDisableHeaderCheck && n.setDisableHeaderCheck(!0);
            for (let e in this.opts.extraHeaders) this.opts.extraHeaders.hasOwnProperty(e) && n.setRequestHeader(e, this.opts.extraHeaders[e]);
          }
        } catch (e) {}
        if ("POST" === this.method) try {
          n.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch (e) {}
        try {
          n.setRequestHeader("Accept", "*/*");
        } catch (e) {}
        null === (e = this.opts.cookieJar) || void 0 === e || e.addCookies(n), "withCredentials" in n && (n.withCredentials = this.opts.withCredentials), this.opts.requestTimeout && (n.timeout = this.opts.requestTimeout), n.onreadystatechange = () => {
          var e;
          3 === n.readyState && (null === (e = this.opts.cookieJar) || void 0 === e || e.parseCookies(n)), 4 === n.readyState && (200 === n.status || 1223 === n.status ? this.onLoad() : this.setTimeoutFn(() => {
            this.onError("number" == typeof n.status ? n.status : 0);
          }, 0));
        }, n.send(this.data);
      } catch (e) {
        return void this.setTimeoutFn(() => {
          this.onError(e);
        }, 0);
      }
      "undefined" != typeof document && (this.index = AA.requestsCount++, AA.requests[this.index] = this);
    }
    onError(e) {
      this.emitReserved("error", e, this.xhr), this.cleanup(!0);
    }
    cleanup(e) {
      if (void 0 !== this.xhr && null !== this.xhr) {
        if (this.xhr.onreadystatechange = yA, e) try {
          this.xhr.abort();
        } catch (e) {}
        "undefined" != typeof document && delete AA.requests[this.index], this.xhr = null;
      }
    }
    onLoad() {
      const e = this.xhr.responseText;
      null !== e && (this.emitReserved("data", e), this.emitReserved("success"), this.cleanup());
    }
    abort() {
      this.cleanup();
    }
  }
  if (AA.requestsCount = 0, AA.requests = {}, "undefined" != typeof document) if ("function" == typeof attachEvent) attachEvent("onunload", _A);else if ("function" == typeof addEventListener) {
    addEventListener("onpagehide" in tA ? "pagehide" : "unload", _A, !1);
  }
  function _A() {
    for (let e in AA.requests) AA.requests.hasOwnProperty(e) && AA.requests[e].abort();
  }
  const EA = "function" == typeof Promise && "function" == typeof Promise.resolve ? e => Promise.resolve().then(e) : (e, t) => t(e, 0),
    SA = tA.WebSocket || tA.MozWebSocket,
    kA = "undefined" != typeof navigator && "string" == typeof navigator.product && "reactnative" === navigator.product.toLowerCase();
  function MA(e, t) {
    return "message" === e.type && "string" != typeof e.data && t[0] >= 48 && t[0] <= 54;
  }
  const CA = {
      websocket: class extends sA {
        constructor(e) {
          super(e), this.supportsBinary = !e.forceBase64;
        }
        get name() {
          return "websocket";
        }
        doOpen() {
          if (!this.check()) return;
          const e = this.uri(),
            t = this.opts.protocols,
            n = kA ? {} : nA(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
          this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
          try {
            this.ws = kA ? new SA(e, t, n) : t ? new SA(e, t) : new SA(e);
          } catch (e) {
            return this.emitReserved("error", e);
          }
          this.ws.binaryType = this.socket.binaryType || "arraybuffer", this.addEventListeners();
        }
        addEventListeners() {
          this.ws.onopen = () => {
            this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
          }, this.ws.onclose = e => this.onClose({
            description: "websocket connection closed",
            context: e
          }), this.ws.onmessage = e => this.onData(e.data), this.ws.onerror = e => this.onError("websocket error", e);
        }
        write(e) {
          this.writable = !1;
          for (let t = 0; t < e.length; t++) {
            const n = e[t],
              r = t === e.length - 1;
            Uw(n, this.supportsBinary, e => {
              try {
                this.ws.send(e);
              } catch (e) {}
              r && EA(() => {
                this.writable = !0, this.emitReserved("drain");
              }, this.setTimeoutFn);
            });
          }
        }
        doClose() {
          void 0 !== this.ws && (this.ws.close(), this.ws = null);
        }
        uri() {
          const e = this.opts.secure ? "wss" : "ws",
            t = this.query || {};
          return this.opts.timestampRequests && (t[this.opts.timestampParam] = mA()), this.supportsBinary || (t.b64 = 1), this.createUri(e, t);
        }
        check() {
          return !!SA;
        }
      },
      webtransport: class extends sA {
        get name() {
          return "webtransport";
        }
        doOpen() {
          "function" == typeof WebTransport && (this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]), this.transport.closed.then(() => {
            this.onClose();
          }).catch(e => {
            this.onError("webtransport error", e);
          }), this.transport.ready.then(() => {
            this.transport.createBidirectionalStream().then(e => {
              const t = e.readable.getReader();
              let n;
              this.writer = e.writable.getWriter();
              const r = () => {
                t.read().then(({
                  done: e,
                  value: t
                }) => {
                  e || (n || 1 !== t.byteLength || 54 !== t[0] ? (this.onPacket(function (e, t, n) {
                    Xw || (Xw = new TextDecoder());
                    const r = t || e[0] < 48 || e[0] > 54;
                    return Gw(r ? e : Xw.decode(e), n);
                  }(t, n, "arraybuffer")), n = !1) : n = !0, r());
                }).catch(e => {});
              };
              r();
              const i = this.query.sid ? `0{"sid":"${this.query.sid}"}` : "0";
              this.writer.write(new TextEncoder().encode(i)).then(() => this.onOpen());
            });
          }));
        }
        write(e) {
          this.writable = !1;
          for (let t = 0; t < e.length; t++) {
            const n = e[t],
              r = t === e.length - 1;
            Vw(n, e => {
              MA(n, e) && this.writer.write(Uint8Array.of(54)), this.writer.write(e).then(() => {
                r && EA(() => {
                  this.writable = !0, this.emitReserved("drain");
                }, this.setTimeoutFn);
              });
            });
          }
        }
        doClose() {
          var e;
          null === (e = this.transport) || void 0 === e || e.close();
        }
      },
      polling: class extends sA {
        constructor(e) {
          if (super(e), this.polling = !1, "undefined" != typeof location) {
            const t = "https:" === location.protocol;
            let n = location.port;
            n || (n = t ? "443" : "80"), this.xd = "undefined" != typeof location && e.hostname !== location.hostname || n !== e.port;
          }
          const t = e && e.forceBase64;
          this.supportsBinary = wA && !t, this.opts.withCredentials && (this.cookieJar = void 0);
        }
        get name() {
          return "polling";
        }
        doOpen() {
          this.poll();
        }
        pause(e) {
          this.readyState = "pausing";
          const t = () => {
            this.readyState = "paused", e();
          };
          if (this.polling || !this.writable) {
            let e = 0;
            this.polling && (e++, this.once("pollComplete", function () {
              --e || t();
            })), this.writable || (e++, this.once("drain", function () {
              --e || t();
            }));
          } else t();
        }
        poll() {
          this.polling = !0, this.doPoll(), this.emitReserved("poll");
        }
        onData(e) {
          ((e, t) => {
            const n = e.split(Jw),
              r = [];
            for (let e = 0; e < n.length; e++) {
              const i = Gw(n[e], t);
              if (r.push(i), "error" === i.type) break;
            }
            return r;
          })(e, this.socket.binaryType).forEach(e => {
            if ("opening" === this.readyState && "open" === e.type && this.onOpen(), "close" === e.type) return this.onClose({
              description: "transport closed by the server"
            }), !1;
            this.onPacket(e);
          }), "closed" !== this.readyState && (this.polling = !1, this.emitReserved("pollComplete"), "open" === this.readyState && this.poll());
        }
        doClose() {
          const e = () => {
            this.write([{
              type: "close"
            }]);
          };
          "open" === this.readyState ? e() : this.once("open", e);
        }
        write(e) {
          this.writable = !1, ((e, t) => {
            const n = e.length,
              r = new Array(n);
            let i = 0;
            e.forEach((e, o) => {
              Uw(e, !1, e => {
                r[o] = e, ++i === n && t(r.join(Jw));
              });
            });
          })(e, e => {
            this.doWrite(e, () => {
              this.writable = !0, this.emitReserved("drain");
            });
          });
        }
        uri() {
          const e = this.opts.secure ? "https" : "http",
            t = this.query || {};
          return !1 !== this.opts.timestampRequests && (t[this.opts.timestampParam] = mA()), this.supportsBinary || t.sid || (t.b64 = 1), this.createUri(e, t);
        }
        request(e = {}) {
          return Object.assign(e, {
            xd: this.xd,
            cookieJar: this.cookieJar
          }, this.opts), new AA(this.uri(), e);
        }
        doWrite(e, t) {
          const n = this.request({
            method: "POST",
            data: e
          });
          n.on("success", t), n.on("error", (e, t) => {
            this.onError("xhr post error", e, t);
          });
        }
        doPoll() {
          const e = this.request();
          e.on("data", this.onData.bind(this)), e.on("error", (e, t) => {
            this.onError("xhr poll error", e, t);
          }), this.pollXhr = e;
        }
      }
    },
    xA = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
    RA = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"];
  function IA(e) {
    const t = e,
      n = e.indexOf("["),
      r = e.indexOf("]");
    -1 != n && -1 != r && (e = e.substring(0, n) + e.substring(n, r).replace(/:/g, ";") + e.substring(r, e.length));
    let i = xA.exec(e || ""),
      o = {},
      a = 14;
    for (; a--;) o[RA[a]] = i[a] || "";
    return -1 != n && -1 != r && (o.source = t, o.host = o.host.substring(1, o.host.length - 1).replace(/;/g, ":"), o.authority = o.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), o.ipv6uri = !0), o.pathNames = function (e, t) {
      const n = /\/{2,9}/g,
        r = t.replace(n, "/").split("/");
      "/" != t.slice(0, 1) && 0 !== t.length || r.splice(0, 1);
      "/" == t.slice(-1) && r.splice(r.length - 1, 1);
      return r;
    }(0, o.path), o.queryKey = function (e, t) {
      const n = {};
      return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function (e, t, r) {
        t && (n[t] = r);
      }), n;
    }(0, o.query), o;
  }
  let TA = class e extends eA {
    constructor(e, t = {}) {
      super(), this.writeBuffer = [], e && "object" == typeof e && (t = e, e = null), e ? (e = IA(e), t.hostname = e.host, t.secure = "https" === e.protocol || "wss" === e.protocol, t.port = e.port, e.query && (t.query = e.query)) : t.host && (t.hostname = IA(t.host).host), oA(this, t), this.secure = null != t.secure ? t.secure : "undefined" != typeof location && "https:" === location.protocol, t.hostname && !t.port && (t.port = this.secure ? "443" : "80"), this.hostname = t.hostname || ("undefined" != typeof location ? location.hostname : "localhost"), this.port = t.port || ("undefined" != typeof location && location.port ? location.port : this.secure ? "443" : "80"), this.transports = t.transports || ["polling", "websocket", "webtransport"], this.writeBuffer = [], this.prevBufferLen = 0, this.opts = Object.assign({
        path: "/engine.io",
        agent: !1,
        withCredentials: !1,
        upgrade: !0,
        timestampParam: "t",
        rememberUpgrade: !1,
        addTrailingSlash: !0,
        rejectUnauthorized: !0,
        perMessageDeflate: {
          threshold: 1024
        },
        transportOptions: {},
        closeOnBeforeunload: !1
      }, t), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), "string" == typeof this.opts.query && (this.opts.query = function (e) {
        let t = {},
          n = e.split("&");
        for (let e = 0, r = n.length; e < r; e++) {
          let r = n[e].split("=");
          t[decodeURIComponent(r[0])] = decodeURIComponent(r[1]);
        }
        return t;
      }(this.opts.query)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingTimeoutTimer = null, "function" == typeof addEventListener && (this.opts.closeOnBeforeunload && (this.beforeunloadEventListener = () => {
        this.transport && (this.transport.removeAllListeners(), this.transport.close());
      }, addEventListener("beforeunload", this.beforeunloadEventListener, !1)), "localhost" !== this.hostname && (this.offlineEventListener = () => {
        this.onClose("transport close", {
          description: "network connection lost"
        });
      }, addEventListener("offline", this.offlineEventListener, !1))), this.open();
    }
    createTransport(e) {
      const t = Object.assign({}, this.opts.query);
      t.EIO = 4, t.transport = e, this.id && (t.sid = this.id);
      const n = Object.assign({}, this.opts, {
        query: t,
        socket: this,
        hostname: this.hostname,
        secure: this.secure,
        port: this.port
      }, this.opts.transportOptions[e]);
      return new CA[e](n);
    }
    open() {
      let t;
      if (this.opts.rememberUpgrade && e.priorWebsocketSuccess && -1 !== this.transports.indexOf("websocket")) t = "websocket";else {
        if (0 === this.transports.length) return void this.setTimeoutFn(() => {
          this.emitReserved("error", "No transports available");
        }, 0);
        t = this.transports[0];
      }
      this.readyState = "opening";
      try {
        t = this.createTransport(t);
      } catch (e) {
        return this.transports.shift(), void this.open();
      }
      t.open(), this.setTransport(t);
    }
    setTransport(e) {
      this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", e => this.onClose("transport close", e));
    }
    probe(t) {
      let n = this.createTransport(t),
        r = !1;
      e.priorWebsocketSuccess = !1;
      const i = () => {
        r || (n.send([{
          type: "ping",
          data: "probe"
        }]), n.once("packet", t => {
          if (!r) if ("pong" === t.type && "probe" === t.data) {
            if (this.upgrading = !0, this.emitReserved("upgrading", n), !n) return;
            e.priorWebsocketSuccess = "websocket" === n.name, this.transport.pause(() => {
              r || "closed" !== this.readyState && (l(), this.setTransport(n), n.send([{
                type: "upgrade"
              }]), this.emitReserved("upgrade", n), n = null, this.upgrading = !1, this.flush());
            });
          } else {
            const e = new Error("probe error");
            e.transport = n.name, this.emitReserved("upgradeError", e);
          }
        }));
      };
      function o() {
        r || (r = !0, l(), n.close(), n = null);
      }
      const a = e => {
        const t = new Error("probe error: " + e);
        t.transport = n.name, o(), this.emitReserved("upgradeError", t);
      };
      function s() {
        a("transport closed");
      }
      function u() {
        a("socket closed");
      }
      function c(e) {
        n && e.name !== n.name && o();
      }
      const l = () => {
        n.removeListener("open", i), n.removeListener("error", a), n.removeListener("close", s), this.off("close", u), this.off("upgrading", c);
      };
      n.once("open", i), n.once("error", a), n.once("close", s), this.once("close", u), this.once("upgrading", c), -1 !== this.upgrades.indexOf("webtransport") && "webtransport" !== t ? this.setTimeoutFn(() => {
        r || n.open();
      }, 200) : n.open();
    }
    onOpen() {
      if (this.readyState = "open", e.priorWebsocketSuccess = "websocket" === this.transport.name, this.emitReserved("open"), this.flush(), "open" === this.readyState && this.opts.upgrade) {
        let e = 0;
        const t = this.upgrades.length;
        for (; e < t; e++) this.probe(this.upgrades[e]);
      }
    }
    onPacket(e) {
      if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) switch (this.emitReserved("packet", e), this.emitReserved("heartbeat"), e.type) {
        case "open":
          this.onHandshake(JSON.parse(e.data));
          break;
        case "ping":
          this.resetPingTimeout(), this.sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong");
          break;
        case "error":
          const t = new Error("server error");
          t.code = e.data, this.onError(t);
          break;
        case "message":
          this.emitReserved("data", e.data), this.emitReserved("message", e.data);
      }
    }
    onHandshake(e) {
      this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this.upgrades = this.filterUpgrades(e.upgrades), this.pingInterval = e.pingInterval, this.pingTimeout = e.pingTimeout, this.maxPayload = e.maxPayload, this.onOpen(), "closed" !== this.readyState && this.resetPingTimeout();
    }
    resetPingTimeout() {
      this.clearTimeoutFn(this.pingTimeoutTimer), this.pingTimeoutTimer = this.setTimeoutFn(() => {
        this.onClose("ping timeout");
      }, this.pingInterval + this.pingTimeout), this.opts.autoUnref && this.pingTimeoutTimer.unref();
    }
    onDrain() {
      this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, 0 === this.writeBuffer.length ? this.emitReserved("drain") : this.flush();
    }
    flush() {
      if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
        const e = this.getWritablePackets();
        this.transport.send(e), this.prevBufferLen = e.length, this.emitReserved("flush");
      }
    }
    getWritablePackets() {
      if (!(this.maxPayload && "polling" === this.transport.name && this.writeBuffer.length > 1)) return this.writeBuffer;
      let e = 1;
      for (let n = 0; n < this.writeBuffer.length; n++) {
        const r = this.writeBuffer[n].data;
        if (r && (e += "string" == typeof (t = r) ? function (e) {
          let t = 0,
            n = 0;
          for (let r = 0, i = e.length; r < i; r++) t = e.charCodeAt(r), t < 128 ? n += 1 : t < 2048 ? n += 2 : t < 55296 || t >= 57344 ? n += 3 : (r++, n += 4);
          return n;
        }(t) : Math.ceil(1.33 * (t.byteLength || t.size))), n > 0 && e > this.maxPayload) return this.writeBuffer.slice(0, n);
        e += 2;
      }
      var t;
      return this.writeBuffer;
    }
    write(e, t, n) {
      return this.sendPacket("message", e, t, n), this;
    }
    send(e, t, n) {
      return this.sendPacket("message", e, t, n), this;
    }
    sendPacket(e, t, n, r) {
      if ("function" == typeof t && (r = t, t = void 0), "function" == typeof n && (r = n, n = null), "closing" === this.readyState || "closed" === this.readyState) return;
      (n = n || {}).compress = !1 !== n.compress;
      const i = {
        type: e,
        data: t,
        options: n
      };
      this.emitReserved("packetCreate", i), this.writeBuffer.push(i), r && this.once("flush", r), this.flush();
    }
    close() {
      const e = () => {
          this.onClose("forced close"), this.transport.close();
        },
        t = () => {
          this.off("upgrade", t), this.off("upgradeError", t), e();
        },
        n = () => {
          this.once("upgrade", t), this.once("upgradeError", t);
        };
      return "opening" !== this.readyState && "open" !== this.readyState || (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
        this.upgrading ? n() : e();
      }) : this.upgrading ? n() : e()), this;
    }
    onError(t) {
      e.priorWebsocketSuccess = !1, this.emitReserved("error", t), this.onClose("transport error", t);
    }
    onClose(e, t) {
      "opening" !== this.readyState && "open" !== this.readyState && "closing" !== this.readyState || (this.clearTimeoutFn(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), "function" == typeof removeEventListener && (removeEventListener("beforeunload", this.beforeunloadEventListener, !1), removeEventListener("offline", this.offlineEventListener, !1)), this.readyState = "closed", this.id = null, this.emitReserved("close", e, t), this.writeBuffer = [], this.prevBufferLen = 0);
    }
    filterUpgrades(e) {
      const t = [];
      let n = 0;
      const r = e.length;
      for (; n < r; n++) ~this.transports.indexOf(e[n]) && t.push(e[n]);
      return t;
    }
  };
  TA.protocol = 4;
  const PA = "function" == typeof ArrayBuffer,
    OA = e => "function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer,
    LA = Object.prototype.toString,
    NA = "function" == typeof Blob || "undefined" != typeof Blob && "[object BlobConstructor]" === LA.call(Blob),
    DA = "function" == typeof File || "undefined" != typeof File && "[object FileConstructor]" === LA.call(File);
  function BA(e) {
    return PA && (e instanceof ArrayBuffer || OA(e)) || NA && e instanceof Blob || DA && e instanceof File;
  }
  function jA(e, t) {
    if (!e || "object" != typeof e) return !1;
    if (Array.isArray(e)) {
      for (let t = 0, n = e.length; t < n; t++) if (jA(e[t])) return !0;
      return !1;
    }
    if (BA(e)) return !0;
    if (e.toJSON && "function" == typeof e.toJSON && 1 === arguments.length) return jA(e.toJSON(), !0);
    for (const t in e) if (Object.prototype.hasOwnProperty.call(e, t) && jA(e[t])) return !0;
    return !1;
  }
  function FA(e) {
    const t = [],
      n = e.data,
      r = e;
    return r.data = zA(n, t), r.attachments = t.length, {
      packet: r,
      buffers: t
    };
  }
  function zA(e, t) {
    if (!e) return e;
    if (BA(e)) {
      const n = {
        _placeholder: !0,
        num: t.length
      };
      return t.push(e), n;
    }
    if (Array.isArray(e)) {
      const n = new Array(e.length);
      for (let r = 0; r < e.length; r++) n[r] = zA(e[r], t);
      return n;
    }
    if ("object" == typeof e && !(e instanceof Date)) {
      const n = {};
      for (const r in e) Object.prototype.hasOwnProperty.call(e, r) && (n[r] = zA(e[r], t));
      return n;
    }
    return e;
  }
  function UA(e, t) {
    return e.data = qA(e.data, t), delete e.attachments, e;
  }
  function qA(e, t) {
    if (!e) return e;
    if (e && !0 === e._placeholder) {
      if ("number" == typeof e.num && e.num >= 0 && e.num < t.length) return t[e.num];
      throw new Error("illegal attachments");
    }
    if (Array.isArray(e)) for (let n = 0; n < e.length; n++) e[n] = qA(e[n], t);else if ("object" == typeof e) for (const n in e) Object.prototype.hasOwnProperty.call(e, n) && (e[n] = qA(e[n], t));
    return e;
  }
  const KA = ["connect", "connect_error", "disconnect", "disconnecting", "newListener", "removeListener"];
  var HA;
  !function (e) {
    e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
  }(HA || (HA = {}));
  function VA(e) {
    return "[object Object]" === Object.prototype.toString.call(e);
  }
  class $A extends eA {
    constructor(e) {
      super(), this.reviver = e;
    }
    add(e) {
      let t;
      if ("string" == typeof e) {
        if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
        t = this.decodeString(e);
        const n = t.type === HA.BINARY_EVENT;
        n || t.type === HA.BINARY_ACK ? (t.type = n ? HA.EVENT : HA.ACK, this.reconstructor = new WA(t), 0 === t.attachments && super.emitReserved("decoded", t)) : super.emitReserved("decoded", t);
      } else {
        if (!BA(e) && !e.base64) throw new Error("Unknown type: " + e);
        if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
        t = this.reconstructor.takeBinaryData(e), t && (this.reconstructor = null, super.emitReserved("decoded", t));
      }
    }
    decodeString(e) {
      let t = 0;
      const n = {
        type: Number(e.charAt(0))
      };
      if (void 0 === HA[n.type]) throw new Error("unknown packet type " + n.type);
      if (n.type === HA.BINARY_EVENT || n.type === HA.BINARY_ACK) {
        const r = t + 1;
        for (; "-" !== e.charAt(++t) && t != e.length;);
        const i = e.substring(r, t);
        if (i != Number(i) || "-" !== e.charAt(t)) throw new Error("Illegal attachments");
        n.attachments = Number(i);
      }
      if ("/" === e.charAt(t + 1)) {
        const r = t + 1;
        for (; ++t;) {
          if ("," === e.charAt(t)) break;
          if (t === e.length) break;
        }
        n.nsp = e.substring(r, t);
      } else n.nsp = "/";
      const r = e.charAt(t + 1);
      if ("" !== r && Number(r) == r) {
        const r = t + 1;
        for (; ++t;) {
          const n = e.charAt(t);
          if (null == n || Number(n) != n) {
            --t;
            break;
          }
          if (t === e.length) break;
        }
        n.id = Number(e.substring(r, t + 1));
      }
      if (e.charAt(++t)) {
        const r = this.tryParse(e.substr(t));
        if (!$A.isPayloadValid(n.type, r)) throw new Error("invalid payload");
        n.data = r;
      }
      return n;
    }
    tryParse(e) {
      try {
        return JSON.parse(e, this.reviver);
      } catch (e) {
        return !1;
      }
    }
    static isPayloadValid(e, t) {
      switch (e) {
        case HA.CONNECT:
          return VA(t);
        case HA.DISCONNECT:
          return void 0 === t;
        case HA.CONNECT_ERROR:
          return "string" == typeof t || VA(t);
        case HA.EVENT:
        case HA.BINARY_EVENT:
          return Array.isArray(t) && ("number" == typeof t[0] || "string" == typeof t[0] && -1 === KA.indexOf(t[0]));
        case HA.ACK:
        case HA.BINARY_ACK:
          return Array.isArray(t);
      }
    }
    destroy() {
      this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
    }
  }
  class WA {
    constructor(e) {
      this.packet = e, this.buffers = [], this.reconPack = e;
    }
    takeBinaryData(e) {
      if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
        const e = UA(this.reconPack, this.buffers);
        return this.finishedReconstruction(), e;
      }
      return null;
    }
    finishedReconstruction() {
      this.reconPack = null, this.buffers = [];
    }
  }
  var YA = Object.freeze({
    __proto__: null,
    Decoder: $A,
    Encoder: class {
      constructor(e) {
        this.replacer = e;
      }
      encode(e) {
        return e.type !== HA.EVENT && e.type !== HA.ACK || !jA(e) ? [this.encodeAsString(e)] : this.encodeAsBinary({
          type: e.type === HA.EVENT ? HA.BINARY_EVENT : HA.BINARY_ACK,
          nsp: e.nsp,
          data: e.data,
          id: e.id
        });
      }
      encodeAsString(e) {
        let t = "" + e.type;
        return e.type !== HA.BINARY_EVENT && e.type !== HA.BINARY_ACK || (t += e.attachments + "-"), e.nsp && "/" !== e.nsp && (t += e.nsp + ","), null != e.id && (t += e.id), null != e.data && (t += JSON.stringify(e.data, this.replacer)), t;
      }
      encodeAsBinary(e) {
        const t = FA(e),
          n = this.encodeAsString(t.packet),
          r = t.buffers;
        return r.unshift(n), r;
      }
    },
    get PacketType() {
      return HA;
    },
    protocol: 5
  });
  function GA(e, t, n) {
    return e.on(t, n), function () {
      e.off(t, n);
    };
  }
  const QA = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    newListener: 1,
    removeListener: 1
  });
  class ZA extends eA {
    constructor(e, t, n) {
      super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = t, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
    }
    get disconnected() {
      return !this.connected;
    }
    subEvents() {
      if (this.subs) return;
      const e = this.io;
      this.subs = [GA(e, "open", this.onopen.bind(this)), GA(e, "packet", this.onpacket.bind(this)), GA(e, "error", this.onerror.bind(this)), GA(e, "close", this.onclose.bind(this))];
    }
    get active() {
      return !!this.subs;
    }
    connect() {
      return this.connected || (this.subEvents(), this.io._reconnecting || this.io.open(), "open" === this.io._readyState && this.onopen()), this;
    }
    open() {
      return this.connect();
    }
    send(...e) {
      return e.unshift("message"), this.emit.apply(this, e), this;
    }
    emit(e, ...t) {
      if (QA.hasOwnProperty(e)) throw new Error('"' + e.toString() + '" is a reserved event name');
      if (t.unshift(e), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) return this._addToQueue(t), this;
      const n = {
        type: HA.EVENT,
        data: t,
        options: {}
      };
      if (n.options.compress = !1 !== this.flags.compress, "function" == typeof t[t.length - 1]) {
        const e = this.ids++,
          r = t.pop();
        this._registerAckCallback(e, r), n.id = e;
      }
      const r = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
      return this.flags.volatile && (!r || !this.connected) || (this.connected ? (this.notifyOutgoingListeners(n), this.packet(n)) : this.sendBuffer.push(n)), this.flags = {}, this;
    }
    _registerAckCallback(e, t) {
      var n;
      const r = null !== (n = this.flags.timeout) && void 0 !== n ? n : this._opts.ackTimeout;
      if (void 0 === r) return void (this.acks[e] = t);
      const i = this.io.setTimeoutFn(() => {
        delete this.acks[e];
        for (let t = 0; t < this.sendBuffer.length; t++) this.sendBuffer[t].id === e && this.sendBuffer.splice(t, 1);
        t.call(this, new Error("operation has timed out"));
      }, r);
      this.acks[e] = (...e) => {
        this.io.clearTimeoutFn(i), t.apply(this, [null, ...e]);
      };
    }
    emitWithAck(e, ...t) {
      const n = void 0 !== this.flags.timeout || void 0 !== this._opts.ackTimeout;
      return new Promise((r, i) => {
        t.push((e, t) => n ? e ? i(e) : r(t) : r(e)), this.emit(e, ...t);
      });
    }
    _addToQueue(e) {
      let t;
      "function" == typeof e[e.length - 1] && (t = e.pop());
      const n = {
        id: this._queueSeq++,
        tryCount: 0,
        pending: !1,
        args: e,
        flags: Object.assign({
          fromQueue: !0
        }, this.flags)
      };
      e.push((e, ...r) => {
        if (n !== this._queue[0]) return;
        return null !== e ? n.tryCount > this._opts.retries && (this._queue.shift(), t && t(e)) : (this._queue.shift(), t && t(null, ...r)), n.pending = !1, this._drainQueue();
      }), this._queue.push(n), this._drainQueue();
    }
    _drainQueue(e = !1) {
      if (!this.connected || 0 === this._queue.length) return;
      const t = this._queue[0];
      t.pending && !e || (t.pending = !0, t.tryCount++, this.flags = t.flags, this.emit.apply(this, t.args));
    }
    packet(e) {
      e.nsp = this.nsp, this.io._packet(e);
    }
    onopen() {
      "function" == typeof this.auth ? this.auth(e => {
        this._sendConnectPacket(e);
      }) : this._sendConnectPacket(this.auth);
    }
    _sendConnectPacket(e) {
      this.packet({
        type: HA.CONNECT,
        data: this._pid ? Object.assign({
          pid: this._pid,
          offset: this._lastOffset
        }, e) : e
      });
    }
    onerror(e) {
      this.connected || this.emitReserved("connect_error", e);
    }
    onclose(e, t) {
      this.connected = !1, delete this.id, this.emitReserved("disconnect", e, t);
    }
    onpacket(e) {
      if (e.nsp === this.nsp) switch (e.type) {
        case HA.CONNECT:
          e.data && e.data.sid ? this.onconnect(e.data.sid, e.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case HA.EVENT:
        case HA.BINARY_EVENT:
          this.onevent(e);
          break;
        case HA.ACK:
        case HA.BINARY_ACK:
          this.onack(e);
          break;
        case HA.DISCONNECT:
          this.ondisconnect();
          break;
        case HA.CONNECT_ERROR:
          this.destroy();
          const t = new Error(e.data.message);
          t.data = e.data.data, this.emitReserved("connect_error", t);
      }
    }
    onevent(e) {
      const t = e.data || [];
      null != e.id && t.push(this.ack(e.id)), this.connected ? this.emitEvent(t) : this.receiveBuffer.push(Object.freeze(t));
    }
    emitEvent(e) {
      if (this._anyListeners && this._anyListeners.length) {
        const t = this._anyListeners.slice();
        for (const n of t) n.apply(this, e);
      }
      super.emit.apply(this, e), this._pid && e.length && "string" == typeof e[e.length - 1] && (this._lastOffset = e[e.length - 1]);
    }
    ack(e) {
      const t = this;
      let n = !1;
      return function (...r) {
        n || (n = !0, t.packet({
          type: HA.ACK,
          id: e,
          data: r
        }));
      };
    }
    onack(e) {
      const t = this.acks[e.id];
      "function" == typeof t && (t.apply(this, e.data), delete this.acks[e.id]);
    }
    onconnect(e, t) {
      this.id = e, this.recovered = t && this._pid === t, this._pid = t, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
    }
    emitBuffered() {
      this.receiveBuffer.forEach(e => this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach(e => {
        this.notifyOutgoingListeners(e), this.packet(e);
      }), this.sendBuffer = [];
    }
    ondisconnect() {
      this.destroy(), this.onclose("io server disconnect");
    }
    destroy() {
      this.subs && (this.subs.forEach(e => e()), this.subs = void 0), this.io._destroy(this);
    }
    disconnect() {
      return this.connected && this.packet({
        type: HA.DISCONNECT
      }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
    }
    close() {
      return this.disconnect();
    }
    compress(e) {
      return this.flags.compress = e, this;
    }
    get volatile() {
      return this.flags.volatile = !0, this;
    }
    timeout(e) {
      return this.flags.timeout = e, this;
    }
    onAny(e) {
      return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
    }
    prependAny(e) {
      return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
    }
    offAny(e) {
      if (!this._anyListeners) return this;
      if (e) {
        const t = this._anyListeners;
        for (let n = 0; n < t.length; n++) if (e === t[n]) return t.splice(n, 1), this;
      } else this._anyListeners = [];
      return this;
    }
    listenersAny() {
      return this._anyListeners || [];
    }
    onAnyOutgoing(e) {
      return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
    }
    prependAnyOutgoing(e) {
      return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
    }
    offAnyOutgoing(e) {
      if (!this._anyOutgoingListeners) return this;
      if (e) {
        const t = this._anyOutgoingListeners;
        for (let n = 0; n < t.length; n++) if (e === t[n]) return t.splice(n, 1), this;
      } else this._anyOutgoingListeners = [];
      return this;
    }
    listenersAnyOutgoing() {
      return this._anyOutgoingListeners || [];
    }
    notifyOutgoingListeners(e) {
      if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
        const t = this._anyOutgoingListeners.slice();
        for (const n of t) n.apply(this, e.data);
      }
    }
  }
  function JA(e) {
    e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
  }
  JA.prototype.duration = function () {
    var e = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
      var t = Math.random(),
        n = Math.floor(t * this.jitter * e);
      e = 0 == (1 & Math.floor(10 * t)) ? e - n : e + n;
    }
    return 0 | Math.min(e, this.max);
  }, JA.prototype.reset = function () {
    this.attempts = 0;
  }, JA.prototype.setMin = function (e) {
    this.ms = e;
  }, JA.prototype.setMax = function (e) {
    this.max = e;
  }, JA.prototype.setJitter = function (e) {
    this.jitter = e;
  };
  class XA extends eA {
    constructor(e, t) {
      var n;
      super(), this.nsps = {}, this.subs = [], e && "object" == typeof e && (t = e, e = void 0), (t = t || {}).path = t.path || "/socket.io", this.opts = t, oA(this, t), this.reconnection(!1 !== t.reconnection), this.reconnectionAttempts(t.reconnectionAttempts || 1 / 0), this.reconnectionDelay(t.reconnectionDelay || 1e3), this.reconnectionDelayMax(t.reconnectionDelayMax || 5e3), this.randomizationFactor(null !== (n = t.randomizationFactor) && void 0 !== n ? n : .5), this.backoff = new JA({
        min: this.reconnectionDelay(),
        max: this.reconnectionDelayMax(),
        jitter: this.randomizationFactor()
      }), this.timeout(null == t.timeout ? 2e4 : t.timeout), this._readyState = "closed", this.uri = e;
      const r = t.parser || YA;
      this.encoder = new r.Encoder(), this.decoder = new r.Decoder(), this._autoConnect = !1 !== t.autoConnect, this._autoConnect && this.open();
    }
    reconnection(e) {
      return arguments.length ? (this._reconnection = !!e, this) : this._reconnection;
    }
    reconnectionAttempts(e) {
      return void 0 === e ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
    }
    reconnectionDelay(e) {
      var t;
      return void 0 === e ? this._reconnectionDelay : (this._reconnectionDelay = e, null === (t = this.backoff) || void 0 === t || t.setMin(e), this);
    }
    randomizationFactor(e) {
      var t;
      return void 0 === e ? this._randomizationFactor : (this._randomizationFactor = e, null === (t = this.backoff) || void 0 === t || t.setJitter(e), this);
    }
    reconnectionDelayMax(e) {
      var t;
      return void 0 === e ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, null === (t = this.backoff) || void 0 === t || t.setMax(e), this);
    }
    timeout(e) {
      return arguments.length ? (this._timeout = e, this) : this._timeout;
    }
    maybeReconnectOnOpen() {
      !this._reconnecting && this._reconnection && 0 === this.backoff.attempts && this.reconnect();
    }
    open(e) {
      if (~this._readyState.indexOf("open")) return this;
      this.engine = new TA(this.uri, this.opts);
      const t = this.engine,
        n = this;
      this._readyState = "opening", this.skipReconnect = !1;
      const r = GA(t, "open", function () {
          n.onopen(), e && e();
        }),
        i = t => {
          this.cleanup(), this._readyState = "closed", this.emitReserved("error", t), e ? e(t) : this.maybeReconnectOnOpen();
        },
        o = GA(t, "error", i);
      if (!1 !== this._timeout) {
        const e = this._timeout,
          n = this.setTimeoutFn(() => {
            r(), i(new Error("timeout")), t.close();
          }, e);
        this.opts.autoUnref && n.unref(), this.subs.push(() => {
          this.clearTimeoutFn(n);
        });
      }
      return this.subs.push(r), this.subs.push(o), this;
    }
    connect(e) {
      return this.open(e);
    }
    onopen() {
      this.cleanup(), this._readyState = "open", this.emitReserved("open");
      const e = this.engine;
      this.subs.push(GA(e, "ping", this.onping.bind(this)), GA(e, "data", this.ondata.bind(this)), GA(e, "error", this.onerror.bind(this)), GA(e, "close", this.onclose.bind(this)), GA(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    onping() {
      this.emitReserved("ping");
    }
    ondata(e) {
      try {
        this.decoder.add(e);
      } catch (e) {
        this.onclose("parse error", e);
      }
    }
    ondecoded(e) {
      EA(() => {
        this.emitReserved("packet", e);
      }, this.setTimeoutFn);
    }
    onerror(e) {
      this.emitReserved("error", e);
    }
    socket(e, t) {
      let n = this.nsps[e];
      return n ? this._autoConnect && !n.active && n.connect() : (n = new ZA(this, e, t), this.nsps[e] = n), n;
    }
    _destroy(e) {
      const t = Object.keys(this.nsps);
      for (const e of t) {
        if (this.nsps[e].active) return;
      }
      this._close();
    }
    _packet(e) {
      const t = this.encoder.encode(e);
      for (let n = 0; n < t.length; n++) this.engine.write(t[n], e.options);
    }
    cleanup() {
      this.subs.forEach(e => e()), this.subs.length = 0, this.decoder.destroy();
    }
    _close() {
      this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close"), this.engine && this.engine.close();
    }
    disconnect() {
      return this._close();
    }
    onclose(e, t) {
      this.cleanup(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, t), this._reconnection && !this.skipReconnect && this.reconnect();
    }
    reconnect() {
      if (this._reconnecting || this.skipReconnect) return this;
      const e = this;
      if (this.backoff.attempts >= this._reconnectionAttempts) this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;else {
        const t = this.backoff.duration();
        this._reconnecting = !0;
        const n = this.setTimeoutFn(() => {
          e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), e.skipReconnect || e.open(t => {
            t ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", t)) : e.onreconnect();
          }));
        }, t);
        this.opts.autoUnref && n.unref(), this.subs.push(() => {
          this.clearTimeoutFn(n);
        });
      }
    }
    onreconnect() {
      const e = this.backoff.attempts;
      this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
    }
  }
  const e_ = {};
  function t_(e, t) {
    "object" == typeof e && (t = e, e = void 0);
    const n = function (e, t = "", n) {
        let r = e;
        n = n || "undefined" != typeof location && location, null == e && (e = n.protocol + "//" + n.host), "string" == typeof e && ("/" === e.charAt(0) && (e = "/" === e.charAt(1) ? n.protocol + e : n.host + e), /^(https?|wss?):\/\//.test(e) || (e = void 0 !== n ? n.protocol + "//" + e : "https://" + e), r = IA(e)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
        const i = -1 !== r.host.indexOf(":") ? "[" + r.host + "]" : r.host;
        return r.id = r.protocol + "://" + i + ":" + r.port + t, r.href = r.protocol + "://" + i + (n && n.port === r.port ? "" : ":" + r.port), r;
      }(e, (t = t || {}).path || "/socket.io"),
      r = n.source,
      i = n.id,
      o = n.path,
      a = e_[i] && o in e_[i].nsps;
    let s;
    return t.forceNew || t["force new connection"] || !1 === t.multiplex || a ? s = new XA(r, t) : (e_[i] || (e_[i] = new XA(r, t)), s = e_[i]), n.query && !t.query && (t.query = n.queryKey), s.socket(n.path, t);
  }
  function n_(e, t, n, r) {
    return new (n || (n = Promise))(function (i, o) {
      function a(e) {
        try {
          u(r.next(e));
        } catch (e) {
          o(e);
        }
      }
      function s(e) {
        try {
          u(r.throw(e));
        } catch (e) {
          o(e);
        }
      }
      function u(e) {
        var t;
        e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
          e(t);
        })).then(a, s);
      }
      u((r = r.apply(e, t || [])).next());
    });
  }
  Object.assign(t_, {
    Manager: XA,
    Socket: ZA,
    io: t_,
    connect: t_
  }), "function" == typeof SuppressedError && SuppressedError;
  var r_ = void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};
  function i_() {
    throw new Error("setTimeout has not been defined");
  }
  function o_() {
    throw new Error("clearTimeout has not been defined");
  }
  var a_ = i_,
    s_ = o_;
  function u_(e) {
    if (a_ === setTimeout) return setTimeout(e, 0);
    if ((a_ === i_ || !a_) && setTimeout) return a_ = setTimeout, setTimeout(e, 0);
    try {
      return a_(e, 0);
    } catch (t) {
      try {
        return a_.call(null, e, 0);
      } catch (t) {
        return a_.call(this, e, 0);
      }
    }
  }
  "function" == typeof r_.setTimeout && (a_ = setTimeout), "function" == typeof r_.clearTimeout && (s_ = clearTimeout);
  var c_,
    l_ = [],
    d_ = !1,
    f_ = -1;
  function h_() {
    d_ && c_ && (d_ = !1, c_.length ? l_ = c_.concat(l_) : f_ = -1, l_.length && p_());
  }
  function p_() {
    if (!d_) {
      var e = u_(h_);
      d_ = !0;
      for (var t = l_.length; t;) {
        for (c_ = l_, l_ = []; ++f_ < t;) c_ && c_[f_].run();
        f_ = -1, t = l_.length;
      }
      c_ = null, d_ = !1, function (e) {
        if (s_ === clearTimeout) return clearTimeout(e);
        if ((s_ === o_ || !s_) && clearTimeout) return s_ = clearTimeout, clearTimeout(e);
        try {
          return s_(e);
        } catch (t) {
          try {
            return s_.call(null, e);
          } catch (t) {
            return s_.call(this, e);
          }
        }
      }(e);
    }
  }
  function m_(e, t) {
    this.fun = e, this.array = t;
  }
  function g_() {}
  m_.prototype.run = function () {
    this.fun.apply(null, this.array);
  };
  var v_ = g_,
    b_ = g_,
    y_ = g_,
    w_ = g_,
    A_ = g_,
    __ = g_,
    E_ = g_,
    S_ = r_.performance || {},
    k_ = S_.now || S_.mozNow || S_.msNow || S_.oNow || S_.webkitNow || function () {
      return new Date().getTime();
    },
    M_ = new Date(),
    C_ = {
      nextTick: function (e) {
        var t = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
        l_.push(new m_(e, t)), 1 !== l_.length || d_ || u_(p_);
      },
      title: "browser",
      browser: !0,
      env: {},
      argv: [],
      version: "",
      versions: {},
      on: v_,
      addListener: b_,
      once: y_,
      off: w_,
      removeListener: A_,
      removeAllListeners: __,
      emit: E_,
      binding: function (e) {
        throw new Error("process.binding is not supported");
      },
      cwd: function () {
        return "/";
      },
      chdir: function (e) {
        throw new Error("process.chdir is not supported");
      },
      umask: function () {
        return 0;
      },
      hrtime: function (e) {
        var t = .001 * k_.call(S_),
          n = Math.floor(t),
          r = Math.floor(t % 1 * 1e9);
        return e && (n -= e[0], (r -= e[1]) < 0 && (n--, r += 1e9)), [n, r];
      },
      platform: "browser",
      release: {},
      config: {},
      uptime: function () {
        return (new Date() - M_) / 1e3;
      }
    };
  var x_,
    R_,
    I_ = {
      exports: {}
    };
  var T_ = function (e) {
    function t(e) {
      let r,
        i,
        o,
        a = null;
      function s(...e) {
        if (!s.enabled) return;
        const n = s,
          i = Number(new Date()),
          o = i - (r || i);
        n.diff = o, n.prev = r, n.curr = i, r = i, e[0] = t.coerce(e[0]), "string" != typeof e[0] && e.unshift("%O");
        let a = 0;
        e[0] = e[0].replace(/%([a-zA-Z%])/g, (r, i) => {
          if ("%%" === r) return "%";
          a++;
          const o = t.formatters[i];
          if ("function" == typeof o) {
            const t = e[a];
            r = o.call(n, t), e.splice(a, 1), a--;
          }
          return r;
        }), t.formatArgs.call(n, e), (n.log || t.log).apply(n, e);
      }
      return s.namespace = e, s.useColors = t.useColors(), s.color = t.selectColor(e), s.extend = n, s.destroy = t.destroy, Object.defineProperty(s, "enabled", {
        enumerable: !0,
        configurable: !1,
        get: () => null !== a ? a : (i !== t.namespaces && (i = t.namespaces, o = t.enabled(e)), o),
        set: e => {
          a = e;
        }
      }), "function" == typeof t.init && t.init(s), s;
    }
    function n(e, n) {
      const r = t(this.namespace + (void 0 === n ? ":" : n) + e);
      return r.log = this.log, r;
    }
    function r(e) {
      return e.toString().substring(2, e.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    return t.debug = t, t.default = t, t.coerce = function (e) {
      return e instanceof Error ? e.stack || e.message : e;
    }, t.disable = function () {
      const e = [...t.names.map(r), ...t.skips.map(r).map(e => "-" + e)].join(",");
      return t.enable(""), e;
    }, t.enable = function (e) {
      let n;
      t.save(e), t.namespaces = e, t.names = [], t.skips = [];
      const r = ("string" == typeof e ? e : "").split(/[\s,]+/),
        i = r.length;
      for (n = 0; n < i; n++) r[n] && ("-" === (e = r[n].replace(/\*/g, ".*?"))[0] ? t.skips.push(new RegExp("^" + e.slice(1) + "$")) : t.names.push(new RegExp("^" + e + "$")));
    }, t.enabled = function (e) {
      if ("*" === e[e.length - 1]) return !0;
      let n, r;
      for (n = 0, r = t.skips.length; n < r; n++) if (t.skips[n].test(e)) return !1;
      for (n = 0, r = t.names.length; n < r; n++) if (t.names[n].test(e)) return !0;
      return !1;
    }, t.humanize = function () {
      if (R_) return x_;
      R_ = 1;
      var e = 1e3,
        t = 60 * e,
        n = 60 * t,
        r = 24 * n;
      function i(e, t, n, r) {
        var i = t >= 1.5 * n;
        return Math.round(e / n) + " " + r + (i ? "s" : "");
      }
      return x_ = function (o, a) {
        a = a || {};
        var s = typeof o;
        if ("string" === s && o.length > 0) return function (i) {
          if (!((i = String(i)).length > 100)) {
            var o = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(i);
            if (o) {
              var a = parseFloat(o[1]);
              switch ((o[2] || "ms").toLowerCase()) {
                case "years":
                case "year":
                case "yrs":
                case "yr":
                case "y":
                  return 315576e5 * a;
                case "weeks":
                case "week":
                case "w":
                  return 6048e5 * a;
                case "days":
                case "day":
                case "d":
                  return a * r;
                case "hours":
                case "hour":
                case "hrs":
                case "hr":
                case "h":
                  return a * n;
                case "minutes":
                case "minute":
                case "mins":
                case "min":
                case "m":
                  return a * t;
                case "seconds":
                case "second":
                case "secs":
                case "sec":
                case "s":
                  return a * e;
                case "milliseconds":
                case "millisecond":
                case "msecs":
                case "msec":
                case "ms":
                  return a;
                default:
                  return;
              }
            }
          }
        }(o);
        if ("number" === s && isFinite(o)) return a.long ? function (o) {
          var a = Math.abs(o);
          return a >= r ? i(o, a, r, "day") : a >= n ? i(o, a, n, "hour") : a >= t ? i(o, a, t, "minute") : a >= e ? i(o, a, e, "second") : o + " ms";
        }(o) : function (i) {
          var o = Math.abs(i);
          return o >= r ? Math.round(i / r) + "d" : o >= n ? Math.round(i / n) + "h" : o >= t ? Math.round(i / t) + "m" : o >= e ? Math.round(i / e) + "s" : i + "ms";
        }(o);
        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(o));
      };
    }(), t.destroy = function () {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }, Object.keys(e).forEach(n => {
      t[n] = e[n];
    }), t.names = [], t.skips = [], t.formatters = {}, t.selectColor = function (e) {
      let n = 0;
      for (let t = 0; t < e.length; t++) n = (n << 5) - n + e.charCodeAt(t), n |= 0;
      return t.colors[Math.abs(n) % t.colors.length];
    }, t.enable(t.load()), t;
  };
  !function (e, t) {
    t.formatArgs = function (t) {
      if (t[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + t[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors) return;
      const n = "color: " + this.color;
      t.splice(1, 0, n, "color: inherit");
      let r = 0,
        i = 0;
      t[0].replace(/%[a-zA-Z%]/g, e => {
        "%%" !== e && (r++, "%c" === e && (i = r));
      }), t.splice(i, 0, n);
    }, t.save = function (e) {
      try {
        e ? t.storage.setItem("debug", e) : t.storage.removeItem("debug");
      } catch (e) {}
    }, t.load = function () {
      let e;
      try {
        e = t.storage.getItem("debug");
      } catch (e) {}
      return !e && void 0 !== C_ && "env" in C_ && (e = C_.env.DEBUG), e;
    }, t.useColors = function () {
      return !("undefined" == typeof window || !window.process || "renderer" !== window.process.type && !window.process.__nwjs) || ("undefined" == typeof navigator || !navigator.userAgent || !navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && ("undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
    }, t.storage = function () {
      try {
        return localStorage;
      } catch (e) {}
    }(), t.destroy = (() => {
      let e = !1;
      return () => {
        e || (e = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
      };
    })(), t.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], t.log = console.debug || console.log || (() => {}), e.exports = T_(t);
    const {
      formatters: n
    } = e.exports;
    n.j = function (e) {
      try {
        return JSON.stringify(e);
      } catch (e) {
        return "[UnexpectedJSONParseError]: " + e.message;
      }
    };
  }(I_, I_.exports);
  var P_ = function (e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }(I_.exports);
  const O_ = P_("KeyExchange:Layer"),
    L_ = P_("SocketService:Layer"),
    N_ = P_("Ecies:Layer"),
    D_ = P_("RemoteCommunication:Layer");
  O_.color = "##95c44e", L_.color = "#f638d7", N_.color = "#465b9c", D_.color = "#47a2be";
  const B_ = {
    KeyExchange: O_,
    SocketService: L_,
    Ecies: N_,
    RemoteCommunication: D_
  };
  let j_,
    F_ = [],
    z_ = [];
  function U_(e) {
    return n_(this, void 0, void 0, function* () {
      if (!j_ || !e) return;
      !function () {
        const e = z_;
        z_ = F_, F_ = e;
      }();
      const t = j_.endsWith("/") ? `${j_}debug` : `${j_}/debug`,
        n = Object.assign({}, e);
      if (delete n.params, e.params) for (const [t, r] of Object.entries(e.params)) n[t] = r;
      const r = JSON.stringify(n);
      B_.RemoteCommunication(`[sendBufferedEvents] Sending ${F_.length} analytics events to ${t}`);
      try {
        const e = yield a(t, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            body: r
          }),
          n = yield e.text();
        B_.RemoteCommunication(`[sendBufferedEvents] Response: ${n}`), F_.length = 0;
      } catch (e) {
        console.warn("Error sending analytics", e);
      }
    });
  }
  const q_ = (e, t) => n_(void 0, void 0, void 0, function* () {
    var n;
    j_ = t, n = e, z_.push(n), U_(e).catch(() => {});
  });
  var K_ = [],
    H_ = [],
    V_ = "undefined" != typeof Uint8Array ? Uint8Array : Array,
    $_ = !1;
  function W_() {
    $_ = !0;
    for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0; t < 64; ++t) K_[t] = e[t], H_[e.charCodeAt(t)] = t;
    H_["-".charCodeAt(0)] = 62, H_["_".charCodeAt(0)] = 63;
  }
  function Y_(e, t, n) {
    for (var r, i, o = [], a = t; a < n; a += 3) r = (e[a] << 16) + (e[a + 1] << 8) + e[a + 2], o.push(K_[(i = r) >> 18 & 63] + K_[i >> 12 & 63] + K_[i >> 6 & 63] + K_[63 & i]);
    return o.join("");
  }
  function G_(e) {
    var t;
    $_ || W_();
    for (var n = e.length, r = n % 3, i = "", o = [], a = 16383, s = 0, u = n - r; s < u; s += a) o.push(Y_(e, s, s + a > u ? u : s + a));
    return 1 === r ? (t = e[n - 1], i += K_[t >> 2], i += K_[t << 4 & 63], i += "==") : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], i += K_[t >> 10], i += K_[t >> 4 & 63], i += K_[t << 2 & 63], i += "="), o.push(i), o.join("");
  }
  function Q_(e, t, n, r, i) {
    var o,
      a,
      s = 8 * i - r - 1,
      u = (1 << s) - 1,
      c = u >> 1,
      l = -7,
      d = n ? i - 1 : 0,
      f = n ? -1 : 1,
      h = e[t + d];
    for (d += f, o = h & (1 << -l) - 1, h >>= -l, l += s; l > 0; o = 256 * o + e[t + d], d += f, l -= 8);
    for (a = o & (1 << -l) - 1, o >>= -l, l += r; l > 0; a = 256 * a + e[t + d], d += f, l -= 8);
    if (0 === o) o = 1 - c;else {
      if (o === u) return a ? NaN : 1 / 0 * (h ? -1 : 1);
      a += Math.pow(2, r), o -= c;
    }
    return (h ? -1 : 1) * a * Math.pow(2, o - r);
  }
  function Z_(e, t, n, r, i, o) {
    var a,
      s,
      u,
      c = 8 * o - i - 1,
      l = (1 << c) - 1,
      d = l >> 1,
      f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
      h = r ? 0 : o - 1,
      p = r ? 1 : -1,
      m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = l) : (a = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), (t += a + d >= 1 ? f / u : f * Math.pow(2, 1 - d)) * u >= 2 && (a++, u /= 2), a + d >= l ? (s = 0, a = l) : a + d >= 1 ? (s = (t * u - 1) * Math.pow(2, i), a += d) : (s = t * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; e[n + h] = 255 & s, h += p, s /= 256, i -= 8);
    for (a = a << i | s, c += i; c > 0; e[n + h] = 255 & a, h += p, a /= 256, c -= 8);
    e[n + h - p] |= 128 * m;
  }
  var J_ = {}.toString,
    X_ = Array.isArray || function (e) {
      return "[object Array]" == J_.call(e);
    };
  function eE() {
    return nE.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
  }
  function tE(e, t) {
    if (eE() < t) throw new RangeError("Invalid typed array length");
    return nE.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = nE.prototype : (null === e && (e = new nE(t)), e.length = t), e;
  }
  function nE(e, t, n) {
    if (!(nE.TYPED_ARRAY_SUPPORT || this instanceof nE)) return new nE(e, t, n);
    if ("number" == typeof e) {
      if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
      return oE(this, e);
    }
    return rE(this, e, t, n);
  }
  function rE(e, t, n, r) {
    if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
    return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, n, r) {
      if (t.byteLength, n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");
      if (t.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
      return t = void 0 === n && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, n) : new Uint8Array(t, n, r), nE.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = nE.prototype : e = aE(e, t), e;
    }(e, t, n, r) : "string" == typeof t ? function (e, t, n) {
      if ("string" == typeof n && "" !== n || (n = "utf8"), !nE.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
      var r = 0 | cE(t, n),
        i = (e = tE(e, r)).write(t, n);
      return i !== r && (e = e.slice(0, i)), e;
    }(e, t, n) : function (e, t) {
      if (uE(t)) {
        var n = 0 | sE(t.length);
        return 0 === (e = tE(e, n)).length || t.copy(e, 0, 0, n), e;
      }
      if (t) {
        if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (r = t.length) != r ? tE(e, 0) : aE(e, t);
        if ("Buffer" === t.type && X_(t.data)) return aE(e, t.data);
      }
      var r;
      throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
    }(e, t);
  }
  function iE(e) {
    if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
    if (e < 0) throw new RangeError('"size" argument must not be negative');
  }
  function oE(e, t) {
    if (iE(t), e = tE(e, t < 0 ? 0 : 0 | sE(t)), !nE.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) e[n] = 0;
    return e;
  }
  function aE(e, t) {
    var n = t.length < 0 ? 0 : 0 | sE(t.length);
    e = tE(e, n);
    for (var r = 0; r < n; r += 1) e[r] = 255 & t[r];
    return e;
  }
  function sE(e) {
    if (e >= eE()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + eE().toString(16) + " bytes");
    return 0 | e;
  }
  function uE(e) {
    return !(null == e || !e._isBuffer);
  }
  function cE(e, t) {
    if (uE(e)) return e.length;
    if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
    "string" != typeof e && (e = "" + e);
    var n = e.length;
    if (0 === n) return 0;
    for (var r = !1;;) switch (t) {
      case "ascii":
      case "latin1":
      case "binary":
        return n;
      case "utf8":
      case "utf-8":
      case void 0:
        return DE(e).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return 2 * n;
      case "hex":
        return n >>> 1;
      case "base64":
        return BE(e).length;
      default:
        if (r) return DE(e).length;
        t = ("" + t).toLowerCase(), r = !0;
    }
  }
  function lE(e, t, n) {
    var r = !1;
    if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
    if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
    if ((n >>>= 0) <= (t >>>= 0)) return "";
    for (e || (e = "utf8");;) switch (e) {
      case "hex":
        return kE(this, t, n);
      case "utf8":
      case "utf-8":
        return AE(this, t, n);
      case "ascii":
        return EE(this, t, n);
      case "latin1":
      case "binary":
        return SE(this, t, n);
      case "base64":
        return wE(this, t, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return ME(this, t, n);
      default:
        if (r) throw new TypeError("Unknown encoding: " + e);
        e = (e + "").toLowerCase(), r = !0;
    }
  }
  function dE(e, t, n) {
    var r = e[t];
    e[t] = e[n], e[n] = r;
  }
  function fE(e, t, n, r, i) {
    if (0 === e.length) return -1;
    if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
      if (i) return -1;
      n = e.length - 1;
    } else if (n < 0) {
      if (!i) return -1;
      n = 0;
    }
    if ("string" == typeof t && (t = nE.from(t, r)), uE(t)) return 0 === t.length ? -1 : hE(e, t, n, r, i);
    if ("number" == typeof t) return t &= 255, nE.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : hE(e, [t], n, r, i);
    throw new TypeError("val must be string, number or Buffer");
  }
  function hE(e, t, n, r, i) {
    var o,
      a = 1,
      s = e.length,
      u = t.length;
    if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
      if (e.length < 2 || t.length < 2) return -1;
      a = 2, s /= 2, u /= 2, n /= 2;
    }
    function c(e, t) {
      return 1 === a ? e[t] : e.readUInt16BE(t * a);
    }
    if (i) {
      var l = -1;
      for (o = n; o < s; o++) if (c(e, o) === c(t, -1 === l ? 0 : o - l)) {
        if (-1 === l && (l = o), o - l + 1 === u) return l * a;
      } else -1 !== l && (o -= o - l), l = -1;
    } else for (n + u > s && (n = s - u), o = n; o >= 0; o--) {
      for (var d = !0, f = 0; f < u; f++) if (c(e, o + f) !== c(t, f)) {
        d = !1;
        break;
      }
      if (d) return o;
    }
    return -1;
  }
  function pE(e, t, n, r) {
    n = Number(n) || 0;
    var i = e.length - n;
    r ? (r = Number(r)) > i && (r = i) : r = i;
    var o = t.length;
    if (o % 2 != 0) throw new TypeError("Invalid hex string");
    r > o / 2 && (r = o / 2);
    for (var a = 0; a < r; ++a) {
      var s = parseInt(t.substr(2 * a, 2), 16);
      if (isNaN(s)) return a;
      e[n + a] = s;
    }
    return a;
  }
  function mE(e, t, n, r) {
    return jE(DE(t, e.length - n), e, n, r);
  }
  function gE(e, t, n, r) {
    return jE(function (e) {
      for (var t = [], n = 0; n < e.length; ++n) t.push(255 & e.charCodeAt(n));
      return t;
    }(t), e, n, r);
  }
  function vE(e, t, n, r) {
    return gE(e, t, n, r);
  }
  function bE(e, t, n, r) {
    return jE(BE(t), e, n, r);
  }
  function yE(e, t, n, r) {
    return jE(function (e, t) {
      for (var n, r, i, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) r = (n = e.charCodeAt(a)) >> 8, i = n % 256, o.push(i), o.push(r);
      return o;
    }(t, e.length - n), e, n, r);
  }
  function wE(e, t, n) {
    return 0 === t && n === e.length ? G_(e) : G_(e.slice(t, n));
  }
  function AE(e, t, n) {
    n = Math.min(e.length, n);
    for (var r = [], i = t; i < n;) {
      var o,
        a,
        s,
        u,
        c = e[i],
        l = null,
        d = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
      if (i + d <= n) switch (d) {
        case 1:
          c < 128 && (l = c);
          break;
        case 2:
          128 == (192 & (o = e[i + 1])) && (u = (31 & c) << 6 | 63 & o) > 127 && (l = u);
          break;
        case 3:
          o = e[i + 1], a = e[i + 2], 128 == (192 & o) && 128 == (192 & a) && (u = (15 & c) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (u < 55296 || u > 57343) && (l = u);
          break;
        case 4:
          o = e[i + 1], a = e[i + 2], s = e[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (u = (15 & c) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && u < 1114112 && (l = u);
      }
      null === l ? (l = 65533, d = 1) : l > 65535 && (l -= 65536, r.push(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), r.push(l), i += d;
    }
    return function (e) {
      var t = e.length;
      if (t <= _E) return String.fromCharCode.apply(String, e);
      for (var n = "", r = 0; r < t;) n += String.fromCharCode.apply(String, e.slice(r, r += _E));
      return n;
    }(r);
  }
  nE.TYPED_ARRAY_SUPPORT = void 0 === r_.TYPED_ARRAY_SUPPORT || r_.TYPED_ARRAY_SUPPORT, eE(), nE.poolSize = 8192, nE._augment = function (e) {
    return e.__proto__ = nE.prototype, e;
  }, nE.from = function (e, t, n) {
    return rE(null, e, t, n);
  }, nE.TYPED_ARRAY_SUPPORT && (nE.prototype.__proto__ = Uint8Array.prototype, nE.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && nE[Symbol.species]), nE.alloc = function (e, t, n) {
    return function (e, t, n, r) {
      return iE(t), t <= 0 ? tE(e, t) : void 0 !== n ? "string" == typeof r ? tE(e, t).fill(n, r) : tE(e, t).fill(n) : tE(e, t);
    }(null, e, t, n);
  }, nE.allocUnsafe = function (e) {
    return oE(null, e);
  }, nE.allocUnsafeSlow = function (e) {
    return oE(null, e);
  }, nE.isBuffer = function (e) {
    return null != e && (!!e._isBuffer || FE(e) || function (e) {
      return "function" == typeof e.readFloatLE && "function" == typeof e.slice && FE(e.slice(0, 0));
    }(e));
  }, nE.compare = function (e, t) {
    if (!uE(e) || !uE(t)) throw new TypeError("Arguments must be Buffers");
    if (e === t) return 0;
    for (var n = e.length, r = t.length, i = 0, o = Math.min(n, r); i < o; ++i) if (e[i] !== t[i]) {
      n = e[i], r = t[i];
      break;
    }
    return n < r ? -1 : r < n ? 1 : 0;
  }, nE.isEncoding = function (e) {
    switch (String(e).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, nE.concat = function (e, t) {
    if (!X_(e)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (0 === e.length) return nE.alloc(0);
    var n;
    if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) t += e[n].length;
    var r = nE.allocUnsafe(t),
      i = 0;
    for (n = 0; n < e.length; ++n) {
      var o = e[n];
      if (!uE(o)) throw new TypeError('"list" argument must be an Array of Buffers');
      o.copy(r, i), i += o.length;
    }
    return r;
  }, nE.byteLength = cE, nE.prototype._isBuffer = !0, nE.prototype.swap16 = function () {
    var e = this.length;
    if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var t = 0; t < e; t += 2) dE(this, t, t + 1);
    return this;
  }, nE.prototype.swap32 = function () {
    var e = this.length;
    if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var t = 0; t < e; t += 4) dE(this, t, t + 3), dE(this, t + 1, t + 2);
    return this;
  }, nE.prototype.swap64 = function () {
    var e = this.length;
    if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var t = 0; t < e; t += 8) dE(this, t, t + 7), dE(this, t + 1, t + 6), dE(this, t + 2, t + 5), dE(this, t + 3, t + 4);
    return this;
  }, nE.prototype.toString = function () {
    var e = 0 | this.length;
    return 0 === e ? "" : 0 === arguments.length ? AE(this, 0, e) : lE.apply(this, arguments);
  }, nE.prototype.equals = function (e) {
    if (!uE(e)) throw new TypeError("Argument must be a Buffer");
    return this === e || 0 === nE.compare(this, e);
  }, nE.prototype.inspect = function () {
    var e = "";
    return this.length > 0 && (e = this.toString("hex", 0, 50).match(/.{2}/g).join(" "), this.length > 50 && (e += " ... ")), "<Buffer " + e + ">";
  }, nE.prototype.compare = function (e, t, n, r, i) {
    if (!uE(e)) throw new TypeError("Argument must be a Buffer");
    if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw new RangeError("out of range index");
    if (r >= i && t >= n) return 0;
    if (r >= i) return -1;
    if (t >= n) return 1;
    if (this === e) return 0;
    for (var o = (i >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (t >>>= 0), s = Math.min(o, a), u = this.slice(r, i), c = e.slice(t, n), l = 0; l < s; ++l) if (u[l] !== c[l]) {
      o = u[l], a = c[l];
      break;
    }
    return o < a ? -1 : a < o ? 1 : 0;
  }, nE.prototype.includes = function (e, t, n) {
    return -1 !== this.indexOf(e, t, n);
  }, nE.prototype.indexOf = function (e, t, n) {
    return fE(this, e, t, n, !0);
  }, nE.prototype.lastIndexOf = function (e, t, n) {
    return fE(this, e, t, n, !1);
  }, nE.prototype.write = function (e, t, n, r) {
    if (void 0 === t) r = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;else {
      if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
      t |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
    }
    var i = this.length - t;
    if ((void 0 === n || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    r || (r = "utf8");
    for (var o = !1;;) switch (r) {
      case "hex":
        return pE(this, e, t, n);
      case "utf8":
      case "utf-8":
        return mE(this, e, t, n);
      case "ascii":
        return gE(this, e, t, n);
      case "latin1":
      case "binary":
        return vE(this, e, t, n);
      case "base64":
        return bE(this, e, t, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return yE(this, e, t, n);
      default:
        if (o) throw new TypeError("Unknown encoding: " + r);
        r = ("" + r).toLowerCase(), o = !0;
    }
  }, nE.prototype.toJSON = function () {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  var _E = 4096;
  function EE(e, t, n) {
    var r = "";
    n = Math.min(e.length, n);
    for (var i = t; i < n; ++i) r += String.fromCharCode(127 & e[i]);
    return r;
  }
  function SE(e, t, n) {
    var r = "";
    n = Math.min(e.length, n);
    for (var i = t; i < n; ++i) r += String.fromCharCode(e[i]);
    return r;
  }
  function kE(e, t, n) {
    var r = e.length;
    (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
    for (var i = "", o = t; o < n; ++o) i += NE(e[o]);
    return i;
  }
  function ME(e, t, n) {
    for (var r = e.slice(t, n), i = "", o = 0; o < r.length; o += 2) i += String.fromCharCode(r[o] + 256 * r[o + 1]);
    return i;
  }
  function CE(e, t, n) {
    if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
    if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
  }
  function xE(e, t, n, r, i, o) {
    if (!uE(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
    if (n + r > e.length) throw new RangeError("Index out of range");
  }
  function RE(e, t, n, r) {
    t < 0 && (t = 65535 + t + 1);
    for (var i = 0, o = Math.min(e.length - n, 2); i < o; ++i) e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
  }
  function IE(e, t, n, r) {
    t < 0 && (t = 4294967295 + t + 1);
    for (var i = 0, o = Math.min(e.length - n, 4); i < o; ++i) e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
  }
  function TE(e, t, n, r, i, o) {
    if (n + r > e.length) throw new RangeError("Index out of range");
    if (n < 0) throw new RangeError("Index out of range");
  }
  function PE(e, t, n, r, i) {
    return i || TE(e, 0, n, 4), Z_(e, t, n, r, 23, 4), n + 4;
  }
  function OE(e, t, n, r, i) {
    return i || TE(e, 0, n, 8), Z_(e, t, n, r, 52, 8), n + 8;
  }
  nE.prototype.slice = function (e, t) {
    var n,
      r = this.length;
    if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), nE.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = nE.prototype;else {
      var i = t - e;
      n = new nE(i, void 0);
      for (var o = 0; o < i; ++o) n[o] = this[o + e];
    }
    return n;
  }, nE.prototype.readUIntLE = function (e, t, n) {
    e |= 0, t |= 0, n || CE(e, t, this.length);
    for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) r += this[e + o] * i;
    return r;
  }, nE.prototype.readUIntBE = function (e, t, n) {
    e |= 0, t |= 0, n || CE(e, t, this.length);
    for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) r += this[e + --t] * i;
    return r;
  }, nE.prototype.readUInt8 = function (e, t) {
    return t || CE(e, 1, this.length), this[e];
  }, nE.prototype.readUInt16LE = function (e, t) {
    return t || CE(e, 2, this.length), this[e] | this[e + 1] << 8;
  }, nE.prototype.readUInt16BE = function (e, t) {
    return t || CE(e, 2, this.length), this[e] << 8 | this[e + 1];
  }, nE.prototype.readUInt32LE = function (e, t) {
    return t || CE(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
  }, nE.prototype.readUInt32BE = function (e, t) {
    return t || CE(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
  }, nE.prototype.readIntLE = function (e, t, n) {
    e |= 0, t |= 0, n || CE(e, t, this.length);
    for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) r += this[e + o] * i;
    return r >= (i *= 128) && (r -= Math.pow(2, 8 * t)), r;
  }, nE.prototype.readIntBE = function (e, t, n) {
    e |= 0, t |= 0, n || CE(e, t, this.length);
    for (var r = t, i = 1, o = this[e + --r]; r > 0 && (i *= 256);) o += this[e + --r] * i;
    return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
  }, nE.prototype.readInt8 = function (e, t) {
    return t || CE(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
  }, nE.prototype.readInt16LE = function (e, t) {
    t || CE(e, 2, this.length);
    var n = this[e] | this[e + 1] << 8;
    return 32768 & n ? 4294901760 | n : n;
  }, nE.prototype.readInt16BE = function (e, t) {
    t || CE(e, 2, this.length);
    var n = this[e + 1] | this[e] << 8;
    return 32768 & n ? 4294901760 | n : n;
  }, nE.prototype.readInt32LE = function (e, t) {
    return t || CE(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
  }, nE.prototype.readInt32BE = function (e, t) {
    return t || CE(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
  }, nE.prototype.readFloatLE = function (e, t) {
    return t || CE(e, 4, this.length), Q_(this, e, !0, 23, 4);
  }, nE.prototype.readFloatBE = function (e, t) {
    return t || CE(e, 4, this.length), Q_(this, e, !1, 23, 4);
  }, nE.prototype.readDoubleLE = function (e, t) {
    return t || CE(e, 8, this.length), Q_(this, e, !0, 52, 8);
  }, nE.prototype.readDoubleBE = function (e, t) {
    return t || CE(e, 8, this.length), Q_(this, e, !1, 52, 8);
  }, nE.prototype.writeUIntLE = function (e, t, n, r) {
    e = +e, t |= 0, n |= 0, r || xE(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
    var i = 1,
      o = 0;
    for (this[t] = 255 & e; ++o < n && (i *= 256);) this[t + o] = e / i & 255;
    return t + n;
  }, nE.prototype.writeUIntBE = function (e, t, n, r) {
    e = +e, t |= 0, n |= 0, r || xE(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
    var i = n - 1,
      o = 1;
    for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) this[t + i] = e / o & 255;
    return t + n;
  }, nE.prototype.writeUInt8 = function (e, t, n) {
    return e = +e, t |= 0, n || xE(this, e, t, 1, 255, 0), nE.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
  }, nE.prototype.writeUInt16LE = function (e, t, n) {
    return e = +e, t |= 0, n || xE(this, e, t, 2, 65535, 0), nE.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : RE(this, e, t, !0), t + 2;
  }, nE.prototype.writeUInt16BE = function (e, t, n) {
    return e = +e, t |= 0, n || xE(this, e, t, 2, 65535, 0), nE.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : RE(this, e, t, !1), t + 2;
  }, nE.prototype.writeUInt32LE = function (e, t, n) {
    return e = +e, t |= 0, n || xE(this, e, t, 4, 4294967295, 0), nE.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : IE(this, e, t, !0), t + 4;
  }, nE.prototype.writeUInt32BE = function (e, t, n) {
    return e = +e, t |= 0, n || xE(this, e, t, 4, 4294967295, 0), nE.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : IE(this, e, t, !1), t + 4;
  }, nE.prototype.writeIntLE = function (e, t, n, r) {
    if (e = +e, t |= 0, !r) {
      var i = Math.pow(2, 8 * n - 1);
      xE(this, e, t, n, i - 1, -i);
    }
    var o = 0,
      a = 1,
      s = 0;
    for (this[t] = 255 & e; ++o < n && (a *= 256);) e < 0 && 0 === s && 0 !== this[t + o - 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
    return t + n;
  }, nE.prototype.writeIntBE = function (e, t, n, r) {
    if (e = +e, t |= 0, !r) {
      var i = Math.pow(2, 8 * n - 1);
      xE(this, e, t, n, i - 1, -i);
    }
    var o = n - 1,
      a = 1,
      s = 0;
    for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) e < 0 && 0 === s && 0 !== this[t + o + 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
    return t + n;
  }, nE.prototype.writeInt8 = function (e, t, n) {
    return e = +e, t |= 0, n || xE(this, e, t, 1, 127, -128), nE.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
  }, nE.prototype.writeInt16LE = function (e, t, n) {
    return e = +e, t |= 0, n || xE(this, e, t, 2, 32767, -32768), nE.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : RE(this, e, t, !0), t + 2;
  }, nE.prototype.writeInt16BE = function (e, t, n) {
    return e = +e, t |= 0, n || xE(this, e, t, 2, 32767, -32768), nE.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : RE(this, e, t, !1), t + 2;
  }, nE.prototype.writeInt32LE = function (e, t, n) {
    return e = +e, t |= 0, n || xE(this, e, t, 4, 2147483647, -2147483648), nE.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : IE(this, e, t, !0), t + 4;
  }, nE.prototype.writeInt32BE = function (e, t, n) {
    return e = +e, t |= 0, n || xE(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), nE.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : IE(this, e, t, !1), t + 4;
  }, nE.prototype.writeFloatLE = function (e, t, n) {
    return PE(this, e, t, !0, n);
  }, nE.prototype.writeFloatBE = function (e, t, n) {
    return PE(this, e, t, !1, n);
  }, nE.prototype.writeDoubleLE = function (e, t, n) {
    return OE(this, e, t, !0, n);
  }, nE.prototype.writeDoubleBE = function (e, t, n) {
    return OE(this, e, t, !1, n);
  }, nE.prototype.copy = function (e, t, n, r) {
    if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;
    if (0 === e.length || 0 === this.length) return 0;
    if (t < 0) throw new RangeError("targetStart out of bounds");
    if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
    if (r < 0) throw new RangeError("sourceEnd out of bounds");
    r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
    var i,
      o = r - n;
    if (this === e && n < t && t < r) for (i = o - 1; i >= 0; --i) e[i + t] = this[i + n];else if (o < 1e3 || !nE.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) e[i + t] = this[i + n];else Uint8Array.prototype.set.call(e, this.subarray(n, n + o), t);
    return o;
  }, nE.prototype.fill = function (e, t, n, r) {
    if ("string" == typeof e) {
      if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === e.length) {
        var i = e.charCodeAt(0);
        i < 256 && (e = i);
      }
      if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
      if ("string" == typeof r && !nE.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
    } else "number" == typeof e && (e &= 255);
    if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
    if (n <= t) return this;
    var o;
    if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < n; ++o) this[o] = e;else {
      var a = uE(e) ? e : DE(new nE(e, r).toString()),
        s = a.length;
      for (o = 0; o < n - t; ++o) this[o + t] = a[o % s];
    }
    return this;
  };
  var LE = /[^+\/0-9A-Za-z-_]/g;
  function NE(e) {
    return e < 16 ? "0" + e.toString(16) : e.toString(16);
  }
  function DE(e, t) {
    var n;
    t = t || 1 / 0;
    for (var r = e.length, i = null, o = [], a = 0; a < r; ++a) {
      if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
        if (!i) {
          if (n > 56319) {
            (t -= 3) > -1 && o.push(239, 191, 189);
            continue;
          }
          if (a + 1 === r) {
            (t -= 3) > -1 && o.push(239, 191, 189);
            continue;
          }
          i = n;
          continue;
        }
        if (n < 56320) {
          (t -= 3) > -1 && o.push(239, 191, 189), i = n;
          continue;
        }
        n = 65536 + (i - 55296 << 10 | n - 56320);
      } else i && (t -= 3) > -1 && o.push(239, 191, 189);
      if (i = null, n < 128) {
        if ((t -= 1) < 0) break;
        o.push(n);
      } else if (n < 2048) {
        if ((t -= 2) < 0) break;
        o.push(n >> 6 | 192, 63 & n | 128);
      } else if (n < 65536) {
        if ((t -= 3) < 0) break;
        o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
      } else {
        if (!(n < 1114112)) throw new Error("Invalid code point");
        if ((t -= 4) < 0) break;
        o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
      }
    }
    return o;
  }
  function BE(e) {
    return function (e) {
      var t, n, r, i, o, a;
      $_ || W_();
      var s = e.length;
      if (s % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      o = "=" === e[s - 2] ? 2 : "=" === e[s - 1] ? 1 : 0, a = new V_(3 * s / 4 - o), r = o > 0 ? s - 4 : s;
      var u = 0;
      for (t = 0, n = 0; t < r; t += 4, n += 3) i = H_[e.charCodeAt(t)] << 18 | H_[e.charCodeAt(t + 1)] << 12 | H_[e.charCodeAt(t + 2)] << 6 | H_[e.charCodeAt(t + 3)], a[u++] = i >> 16 & 255, a[u++] = i >> 8 & 255, a[u++] = 255 & i;
      return 2 === o ? (i = H_[e.charCodeAt(t)] << 2 | H_[e.charCodeAt(t + 1)] >> 4, a[u++] = 255 & i) : 1 === o && (i = H_[e.charCodeAt(t)] << 10 | H_[e.charCodeAt(t + 1)] << 4 | H_[e.charCodeAt(t + 2)] >> 2, a[u++] = i >> 8 & 255, a[u++] = 255 & i), a;
    }(function (e) {
      if ((e = function (e) {
        return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
      }(e).replace(LE, "")).length < 2) return "";
      for (; e.length % 4 != 0;) e += "=";
      return e;
    }(e));
  }
  function jE(e, t, n, r) {
    for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) t[i + n] = e[i];
    return i;
  }
  function FE(e) {
    return !!e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
  }
  class zE {
    constructor(e) {
      this.enabled = !0, (null == e ? void 0 : e.debug) && P_.enable("Ecies:Layer"), (null == e ? void 0 : e.privateKey) ? this.ecies = se.PrivateKey.fromHex(e.privateKey) : this.ecies = new se.PrivateKey(), B_.Ecies("[ECIES constructor()] initialized secret: ", this.ecies.toHex()), B_.Ecies("[ECIES constructor()] initialized public: ", this.ecies.publicKey.toHex()), B_.Ecies("[ECIES constructor()] init with", this);
    }
    generateECIES() {
      this.ecies = new se.PrivateKey();
    }
    getPublicKey() {
      return this.ecies.publicKey.toHex();
    }
    encrypt(e, t) {
      let n = e;
      if (this.enabled) try {
        B_.Ecies("[ECIES: encrypt()] using otherPublicKey", t);
        const r = nE.from(e),
          i = se.encrypt(t, r);
        n = nE.from(i).toString("base64");
      } catch (n) {
        throw B_.Ecies("[ECIES: encrypt()] error encrypt:", n), B_.Ecies("[ECIES: encrypt()] private: ", this.ecies.toHex()), B_.Ecies("[ECIES: encrypt()] data: ", e), B_.Ecies("[ECIES: encrypt()] otherkey: ", t), n;
      }
      return n;
    }
    decrypt(e) {
      let t = e;
      if (this.enabled) try {
        B_.Ecies("[ECIES: decrypt()] using privateKey", this.ecies.toHex());
        const n = nE.from(e.toString(), "base64");
        t = se.decrypt(this.ecies.toHex(), n).toString();
      } catch (t) {
        throw B_.Ecies("[ECIES: decrypt()] error decrypt", t), B_.Ecies("[ECIES: decrypt()] private: ", this.ecies.toHex()), B_.Ecies("[ECIES: decrypt()] encryptedData: ", e), t;
      }
      return t;
    }
    getKeyInfo() {
      return {
        private: this.ecies.toHex(),
        public: this.ecies.publicKey.toHex()
      };
    }
    toString() {
      B_.Ecies("[ECIES: toString()]", this.getKeyInfo());
    }
  }
  var UE = "0.20.2";
  const qE = "https://metamask-sdk.api.cx.metamask.io/",
    KE = ["websocket"],
    HE = 6048e5,
    VE = {
      METAMASK_GETPROVIDERSTATE: "metamask_getProviderState",
      ETH_REQUESTACCOUNTS: "eth_requestAccounts"
    };
  function $E(e) {
    const {
      context: t
    } = e;
    B_.RemoteCommunication(`[RemoteCommunication: clean()] context=${t}`), e.channelConfig = void 0, e.ready = !1, e.originatorConnectStarted = !1;
  }
  var WE, YE;
  e.ConnectionStatus = void 0, e.EventType = void 0, e.MessageType = void 0, function (e) {
    e.DISCONNECTED = "disconnected", e.WAITING = "waiting", e.TIMEOUT = "timeout", e.LINKED = "linked", e.PAUSED = "paused", e.TERMINATED = "terminated";
  }(e.ConnectionStatus || (e.ConnectionStatus = {})), function (e) {
    e.KEY_INFO = "key_info", e.SERVICE_STATUS = "service_status", e.PROVIDER_UPDATE = "provider_update", e.RPC_UPDATE = "rpc_update", e.KEYS_EXCHANGED = "keys_exchanged", e.JOIN_CHANNEL = "join_channel", e.CHANNEL_CREATED = "channel_created", e.CLIENTS_CONNECTED = "clients_connected", e.CLIENTS_DISCONNECTED = "clients_disconnected", e.CLIENTS_WAITING = "clients_waiting", e.CLIENTS_READY = "clients_ready", e.CHANNEL_PERSISTENCE = "channel_persistence", e.MESSAGE_ACK = "ack", e.SOCKET_DISCONNECTED = "socket_disconnected", e.SOCKET_RECONNECT = "socket_reconnect", e.OTP = "otp", e.SDK_RPC_CALL = "sdk_rpc_call", e.AUTHORIZED = "authorized", e.CONNECTION_STATUS = "connection_status", e.MESSAGE = "message", e.TERMINATE = "terminate";
  }(e.EventType || (e.EventType = {})), function (e) {
    e.KEY_EXCHANGE = "key_exchange";
  }(WE || (WE = {})), function (e) {
    e.KEY_HANDSHAKE_START = "key_handshake_start", e.KEY_HANDSHAKE_CHECK = "key_handshake_check", e.KEY_HANDSHAKE_SYN = "key_handshake_SYN", e.KEY_HANDSHAKE_SYNACK = "key_handshake_SYNACK", e.KEY_HANDSHAKE_ACK = "key_handshake_ACK", e.KEY_HANDSHAKE_NONE = "none";
  }(YE || (YE = {}));
  class GE extends Cw.EventEmitter2 {
    constructor({
      communicationLayer: e,
      otherPublicKey: t,
      context: n,
      ecies: r,
      logging: i
    }) {
      super(), this.keysExchanged = !1, this.step = YE.KEY_HANDSHAKE_NONE, this.debug = !1, this.context = n, this.communicationLayer = e, (null == r ? void 0 : r.privateKey) && t && (B_.KeyExchange(`[KeyExchange: constructor()] otherPubKey=${t} set keysExchanged to true!`, r), this.keysExchanged = !0), this.myECIES = new zE(Object.assign(Object.assign({}, r), {
        debug: null == i ? void 0 : i.eciesLayer
      })), this.myPublicKey = this.myECIES.getPublicKey(), this.debug = !0 === (null == i ? void 0 : i.keyExchangeLayer), t && this.setOtherPublicKey(t), this.communicationLayer.on(WE.KEY_EXCHANGE, this.onKeyExchangeMessage.bind(this));
    }
    onKeyExchangeMessage(t) {
      const {
        relayPersistence: n
      } = this.communicationLayer.remote.state;
      if (B_.KeyExchange(`[KeyExchange: onKeyExchangeMessage()] context=${this.context} keysExchanged=${this.keysExchanged} relayPersistence=${n}`, t), n) return void B_.KeyExchange("[KeyExchange: onKeyExchangeMessage()] Ignoring key exchange message because relay persistence is activated");
      const {
        message: r
      } = t;
      this.keysExchanged && B_.KeyExchange(`[KeyExchange: onKeyExchangeMessage()] context=${this.context} received handshake while already exchanged. step=${this.step} otherPubKey=${this.otherPublicKey}`), this.emit(e.EventType.KEY_INFO, r.type), r.type === YE.KEY_HANDSHAKE_SYN ? (this.checkStep([YE.KEY_HANDSHAKE_NONE, YE.KEY_HANDSHAKE_ACK]), B_.KeyExchange("[KeyExchange: onKeyExchangeMessage()] KEY_HANDSHAKE_SYN", r), r.pubkey && this.setOtherPublicKey(r.pubkey), this.communicationLayer.sendMessage({
        type: YE.KEY_HANDSHAKE_SYNACK,
        pubkey: this.myPublicKey
      }), this.setStep(YE.KEY_HANDSHAKE_ACK)) : r.type === YE.KEY_HANDSHAKE_SYNACK ? (this.checkStep([YE.KEY_HANDSHAKE_SYNACK, YE.KEY_HANDSHAKE_ACK, YE.KEY_HANDSHAKE_NONE]), B_.KeyExchange("[KeyExchange: onKeyExchangeMessage()] KEY_HANDSHAKE_SYNACK"), r.pubkey && this.setOtherPublicKey(r.pubkey), this.communicationLayer.sendMessage({
        type: YE.KEY_HANDSHAKE_ACK
      }), this.keysExchanged = !0, this.setStep(YE.KEY_HANDSHAKE_ACK), this.emit(e.EventType.KEYS_EXCHANGED)) : r.type === YE.KEY_HANDSHAKE_ACK && (B_.KeyExchange("[KeyExchange: onKeyExchangeMessage()] KEY_HANDSHAKE_ACK set keysExchanged to true!"), this.checkStep([YE.KEY_HANDSHAKE_ACK, YE.KEY_HANDSHAKE_NONE]), this.keysExchanged = !0, this.setStep(YE.KEY_HANDSHAKE_ACK), this.emit(e.EventType.KEYS_EXCHANGED));
    }
    resetKeys(e) {
      this.clean(), this.myECIES = new zE(e);
    }
    clean() {
      B_.KeyExchange(`[KeyExchange: clean()] context=${this.context} reset handshake state`), this.setStep(YE.KEY_HANDSHAKE_NONE), this.emit(e.EventType.KEY_INFO, this.step), this.keysExchanged = !1;
    }
    start({
      isOriginator: e,
      force: t
    }) {
      const {
          relayPersistence: n,
          protocolVersion: r
        } = this.communicationLayer.remote.state,
        i = r >= 2;
      if (n) return B_.KeyExchange("[KeyExchange: start()] Ignoring key exchange message because relay persistence is activated"), void console.log(`[KeyExchange: start()] relayPersistence=${n}`);
      B_.KeyExchange(`[KeyExchange: start()] context=${this.context} protocolVersion=${r} isOriginator=${e} step=${this.step} force=${t} relayPersistence=${n} keysExchanged=${this.keysExchanged}`), e ? !(this.keysExchanged || this.step !== YE.KEY_HANDSHAKE_NONE && this.step !== YE.KEY_HANDSHAKE_SYNACK) || t ? (B_.KeyExchange(`[KeyExchange: start()] context=${this.context} -- start key exchange (force=${t}) -- step=${this.step}`, this.step), this.clean(), this.setStep(YE.KEY_HANDSHAKE_SYNACK), this.communicationLayer.sendMessage({
        type: YE.KEY_HANDSHAKE_SYN,
        pubkey: this.myPublicKey,
        v: 2
      })) : B_.KeyExchange(`[KeyExchange: start()] context=${this.context} -- key exchange already ${this.keysExchanged ? "done" : "in progress"} -- aborted.`, this.step) : this.keysExchanged && !0 !== t ? B_.KeyExchange("[KeyExchange: start()] don't send KEY_HANDSHAKE_START -- exchange already done.") : i ? this.communicationLayer.sendMessage({
        type: YE.KEY_HANDSHAKE_SYNACK,
        pubkey: this.myPublicKey,
        v: 2
      }) : (this.communicationLayer.sendMessage({
        type: YE.KEY_HANDSHAKE_START
      }), this.clean());
    }
    setStep(t) {
      this.step = t, this.emit(e.EventType.KEY_INFO, t);
    }
    checkStep(e) {
      e.length > 0 && -1 === e.indexOf(this.step.toString()) && console.warn(`[KeyExchange: checkStep()]  Wrong Step "${this.step}" not within ${e}`);
    }
    setRelayPersistence({
      localKey: e,
      otherKey: t
    }) {
      this.otherPublicKey = t, this.myECIES = new zE({
        privateKey: e,
        debug: this.debug
      }), this.keysExchanged = !0;
    }
    setKeysExchanged(e) {
      this.keysExchanged = e;
    }
    areKeysExchanged() {
      return this.keysExchanged;
    }
    getMyPublicKey() {
      return this.myPublicKey;
    }
    getOtherPublicKey() {
      return this.otherPublicKey;
    }
    setOtherPublicKey(e) {
      B_.KeyExchange("[KeyExchange: setOtherPubKey()]", e), this.otherPublicKey = e;
    }
    encryptMessage(e) {
      if (!this.otherPublicKey) throw new Error("encryptMessage: Keys not exchanged - missing otherPubKey");
      return this.myECIES.encrypt(e, this.otherPublicKey);
    }
    decryptMessage(e) {
      if (!this.otherPublicKey) throw new Error("decryptMessage: Keys not exchanged - missing otherPubKey");
      return this.myECIES.decrypt(e);
    }
    getKeyInfo() {
      return {
        ecies: Object.assign(Object.assign({}, this.myECIES.getKeyInfo()), {
          otherPubKey: this.otherPublicKey
        }),
        step: this.step,
        keysExchanged: this.areKeysExchanged()
      };
    }
    toString() {
      const e = {
        keyInfo: this.getKeyInfo(),
        keysExchanged: this.keysExchanged,
        step: this.step
      };
      return JSON.stringify(e);
    }
  }
  !function (e) {
    e.TERMINATE = "terminate", e.ANSWER = "answer", e.OFFER = "offer", e.CANDIDATE = "candidate", e.JSONRPC = "jsonrpc", e.WALLET_INFO = "wallet_info", e.ORIGINATOR_INFO = "originator_info", e.PAUSE = "pause", e.OTP = "otp", e.AUTHORIZED = "authorized", e.PING = "ping", e.READY = "ready";
  }(e.MessageType || (e.MessageType = {}));
  const QE = e => new Promise(t => {
      setTimeout(t, e);
    }),
    ZE = (e, t, n = 200) => n_(void 0, void 0, void 0, function* () {
      let r;
      const i = Date.now();
      let o = !1;
      for (; !o;) {
        if (o = Date.now() - i > 3e5, r = t[e], void 0 !== r.elapsedTime) return r;
        yield QE(n);
      }
      throw new Error(`RPC ${e} timed out`);
    }),
    JE = t => n_(void 0, void 0, void 0, function* () {
      var n, r, i, o, a;
      return t.remote.state.terminated ? (B_.SocketService(`[SocketService: reconnectSocket()] instance.remote.state.terminated=${t.remote.state.terminated} socket already terminated`, t), !1) : (B_.SocketService(`[SocketService: reconnectSocket()] instance.state.socket?.connected=${null === (n = t.state.socket) || void 0 === n ? void 0 : n.connected} trying to reconnect after socketio disconnection`, t), yield QE(200), (null === (r = t.state.socket) || void 0 === r ? void 0 : r.connected) || (t.state.resumed = !0, null === (i = t.state.socket) || void 0 === i || i.connect(), t.emit(e.EventType.SOCKET_RECONNECT), null === (o = t.state.socket) || void 0 === o || o.emit(e.EventType.JOIN_CHANNEL, {
        channelId: t.state.channelId,
        context: `${t.state.context}connect_again`,
        clientType: t.state.isOriginator ? "dapp" : "wallet"
      })), yield QE(100), null === (a = t.state.socket) || void 0 === a ? void 0 : a.connected);
    });
  var XE;
  !function (e) {
    e.REQUEST = "sdk_connect_request_started", e.REQUEST_MOBILE = "sdk_connect_request_started_mobile", e.RECONNECT = "sdk_reconnect_request_started", e.CONNECTED = "sdk_connection_established", e.CONNECTED_MOBILE = "sdk_connection_established_mobile", e.AUTHORIZED = "sdk_connection_authorized", e.REJECTED = "sdk_connection_rejected", e.TERMINATED = "sdk_connection_terminated", e.DISCONNECTED = "sdk_disconnected", e.SDK_USE_EXTENSION = "sdk_use_extension", e.SDK_RPC_REQUEST = "sdk_rpc_request", e.SDK_RPC_REQUEST_RECEIVED = "sdk_rpc_request_received", e.SDK_RPC_REQUEST_DONE = "sdk_rpc_request_done", e.SDK_EXTENSION_UTILIZED = "sdk_extension_utilized", e.SDK_USE_INAPP_BROWSER = "sdk_use_inapp_browser";
  }(XE || (XE = {}));
  var eS;
  !function (e) {
    e.RPC_CHECK = "rpcCheck", e.SKIPPED_RPC = "skippedRpc";
  }(eS || (eS = {}));
  const tS = ["eth_sendTransaction", "eth_signTypedData", "eth_signTransaction", "personal_sign", "wallet_requestPermissions", "wallet_switchEthereumChain", "eth_signTypedData_v3", "eth_signTypedData_v4", "metamask_connectSign", "metamask_connectWith", "metamask_batch"].map(e => e.toLowerCase());
  function nS(t, n) {
    var r, i, o, a;
    if (!t.state.channelId) throw new Error("Create a channel first");
    B_.SocketService(`[SocketService: handleSendMessage()] context=${t.state.context} areKeysExchanged=${null === (r = t.state.keyExchange) || void 0 === r ? void 0 : r.areKeysExchanged()}`, n), (null === (i = null == n ? void 0 : n.type) || void 0 === i ? void 0 : i.startsWith("key_handshake")) ? function (t, n) {
      var r;
      B_.SocketService(`[SocketService: handleKeyHandshake()] context=${t.state.context}`, n), null === (r = t.state.socket) || void 0 === r || r.emit(e.EventType.MESSAGE, {
        id: t.state.channelId,
        context: t.state.context,
        clientType: t.state.isOriginator ? "dapp" : "wallet",
        message: n
      });
    }(t, n) : (function (e, t) {
      var n;
      if (!(null === (n = e.state.keyExchange) || void 0 === n ? void 0 : n.areKeysExchanged()) && !e.remote.state.relayPersistence) throw B_.SocketService(`[SocketService: validateKeyExchange()] context=${e.state.context} ERROR keys not exchanged`, t), console.error("[SocketService: validateKeyExchange()] ERROR keys not exchanged", t), new Error("Keys not exchanged BBB");
    }(t, n), function (t, n) {
      var r;
      const i = null !== (r = null == n ? void 0 : n.method) && void 0 !== r ? r : "",
        o = null == n ? void 0 : n.id;
      t.state.isOriginator && o && (t.state.rpcMethodTracker[o] = {
        id: o,
        timestamp: Date.now(),
        method: i
      }, t.emit(e.EventType.RPC_UPDATE, t.state.rpcMethodTracker[o]));
    }(t, n), function (t, n) {
      var r, i;
      const o = null === (r = t.state.keyExchange) || void 0 === r ? void 0 : r.encryptMessage(JSON.stringify(n)),
        a = {
          id: t.state.channelId,
          context: t.state.context,
          clientType: t.state.isOriginator ? "dapp" : "wallet",
          message: o,
          plaintext: t.state.hasPlaintext ? JSON.stringify(n) : void 0
        };
      B_.SocketService(`[SocketService: encryptAndSendMessage()] context=${t.state.context}`, a), n.type === e.MessageType.TERMINATE && (t.state.manualDisconnect = !0), null === (i = t.state.socket) || void 0 === i || i.emit(e.EventType.MESSAGE, a);
    }(t, n), t.remote.state.analytics && t.remote.state.isOriginator && n.method && tS.includes(n.method.toLowerCase()) && q_({
      id: null !== (o = t.remote.state.channelId) && void 0 !== o ? o : "",
      event: XE.SDK_RPC_REQUEST,
      sdkVersion: t.remote.state.sdkVersion,
      commLayerVersion: UE,
      walletVersion: null === (a = t.remote.state.walletInfo) || void 0 === a ? void 0 : a.version,
      params: {
        method: n.method,
        from: "mobile"
      }
    }, t.remote.state.communicationServerUrl).catch(e => {
      console.error("Cannot send analytics", e);
    }), function (t, n) {
      var r;
      return n_(this, void 0, void 0, function* () {
        const i = null == n ? void 0 : n.id,
          o = null !== (r = null == n ? void 0 : n.method) && void 0 !== r ? r : "";
        if (t.state.isOriginator && i) try {
          const r = ZE(i, t.state.rpcMethodTracker, 200).then(e => ({
              type: eS.RPC_CHECK,
              result: e
            })),
            a = (() => n_(this, void 0, void 0, function* () {
              const e = yield (({
                  rpcId: e,
                  instance: t
                }) => n_(void 0, void 0, void 0, function* () {
                  for (; t.state.lastRpcId === e || void 0 === t.state.lastRpcId;) yield QE(200);
                  return t.state.lastRpcId;
                }))({
                  instance: t,
                  rpcId: i
                }),
                n = yield ZE(e, t.state.rpcMethodTracker, 200);
              return {
                type: eS.SKIPPED_RPC,
                result: n
              };
            }))(),
            s = yield Promise.race([r, a]);
          if (s.type === eS.RPC_CHECK) {
            const e = s.result;
            B_.SocketService(`[SocketService:handleRpcReplies()] id=${n.id} ${o} ( ${e.elapsedTime} ms)`, e.result);
          } else {
            if (s.type !== eS.SKIPPED_RPC) throw new Error(`Error handling RPC replies for ${i}`);
            {
              const {
                result: n
              } = s;
              console.warn(`[SocketService handleRpcReplies()] RPC METHOD HAS BEEN SKIPPED rpcid=${i} method=${o}`, n);
              const r = Object.assign(Object.assign({}, t.state.rpcMethodTracker[i]), {
                error: new Error("SDK_CONNECTION_ISSUE")
              });
              t.emit(e.EventType.RPC_UPDATE, r);
              const a = {
                data: Object.assign(Object.assign({}, r), {
                  jsonrpc: "2.0"
                }),
                name: "metamask-provider"
              };
              t.emit(e.EventType.MESSAGE, {
                message: a
              });
            }
          }
        } catch (e) {
          throw console.warn(`[SocketService handleRpcReplies()] Error rpcId=${n.id} ${o}`, e), e;
        }
      });
    }(t, n).catch(e => {
      console.warn("Error handleRpcReplies", e);
    }));
  }
  const rS = [{
      event: "clients_connected",
      handler: function (t, n) {
        return r => n_(this, void 0, void 0, function* () {
          var r, i, o, a, s, u, c, l, d, f, h;
          const p = null !== (i = null === (r = t.remote.state.channelConfig) || void 0 === r ? void 0 : r.relayPersistence) && void 0 !== i && i;
          if (B_.SocketService(`[SocketService: handleClientsConnected()] context=${t.state.context} on 'clients_connected-${n}' relayPersistence=${p} resumed=${t.state.resumed}  clientsPaused=${t.state.clientsPaused} keysExchanged=${null === (o = t.state.keyExchange) || void 0 === o ? void 0 : o.areKeysExchanged()} isOriginator=${t.state.isOriginator}`), t.emit(e.EventType.CLIENTS_CONNECTED, {
            isOriginator: t.state.isOriginator,
            keysExchanged: null === (a = t.state.keyExchange) || void 0 === a ? void 0 : a.areKeysExchanged(),
            context: t.state.context
          }), t.state.resumed) t.state.isOriginator || (B_.SocketService(`[SocketService: handleClientsConnected()] context=${t.state.context} 'clients_connected' / keysExchanged=${null === (s = t.state.keyExchange) || void 0 === s ? void 0 : s.areKeysExchanged()} -- backward compatibility`), null === (u = t.state.keyExchange) || void 0 === u || u.start({
            isOriginator: null !== (c = t.state.isOriginator) && void 0 !== c && c
          })), t.state.resumed = !1;else if (t.state.clientsPaused) B_.SocketService("[SocketService: handleClientsConnected()] 'clients_connected' skip sending originatorInfo on pause");else if (!t.state.isOriginator) {
            const e = !p;
            console.log(`[SocketService: handleClientsConnected()] context=${t.state.context} on 'clients_connected' / keysExchanged=${null === (l = t.state.keyExchange) || void 0 === l ? void 0 : l.areKeysExchanged()} -- force=${e} -- backward compatibility`), B_.SocketService(`[SocketService: handleClientsConnected()] context=${t.state.context} on 'clients_connected' / keysExchanged=${null === (d = t.state.keyExchange) || void 0 === d ? void 0 : d.areKeysExchanged()} -- force=${e} -- backward compatibility`), null === (f = t.state.keyExchange) || void 0 === f || f.start({
              isOriginator: null !== (h = t.state.isOriginator) && void 0 !== h && h,
              force: e
            });
          }
          t.state.clientsConnected = !0, t.state.clientsPaused = !1;
        });
      }
    }, {
      event: "channel_created",
      handler: function (t, n) {
        return r => {
          B_.SocketService(`[SocketService: handleChannelCreated()] context=${t.state.context} on 'channel_created-${n}'`, r), t.emit(e.EventType.CHANNEL_CREATED, r);
        };
      }
    }, {
      event: "clients_disconnected",
      handler: function (t, n) {
        return () => {
          var r;
          t.state.clientsConnected = !1, B_.SocketService(`[SocketService: handlesClientsDisconnected()] context=${t.state.context} on 'clients_disconnected-${n}'`), t.remote.state.relayPersistence ? B_.SocketService(`[SocketService: handlesClientsDisconnected()] context=${t.state.context} on 'clients_disconnected-${n}' - relayPersistence enabled, skipping key exchange cleanup.`) : (t.state.isOriginator && !t.state.clientsPaused && (null === (r = t.state.keyExchange) || void 0 === r || r.clean()), t.emit(e.EventType.CLIENTS_DISCONNECTED, n));
        };
      }
    }, {
      event: "config",
      handler: function (t, n) {
        return r => n_(this, void 0, void 0, function* () {
          var i, o;
          B_.SocketService(`[SocketService: handleChannelConfig()] update relayPersistence on 'config-${n}'`, r), t.remote.state.relayPersistence = !0, t.remote.emit(e.EventType.CHANNEL_PERSISTENCE), null === (i = t.state.keyExchange) || void 0 === i || i.setKeysExchanged(!0), t.state.isOriginator && t.remote.state.channelConfig && !t.remote.state.channelConfig.relayPersistence && (t.remote.state.channelConfig.relayPersistence = !0, null === (o = t.remote.state.storageManager) || void 0 === o || o.persistChannelConfig(t.remote.state.channelConfig));
        });
      }
    }, {
      event: "message",
      handler: function (t, n) {
        return r => {
          var i, o, a, s, u, c, l, d, f, h, p, m, g, v, b, y, w, A;
          const {
              id: _,
              ackId: E,
              message: S,
              error: k
            } = r,
            M = null !== (i = t.remote.state.relayPersistence) && void 0 !== i && i;
          if (B_.SocketService(`[SocketService handleMessage()]  relayPersistence=${M}  context=${t.state.context} on 'message' ${n} keysExchanged=${null === (o = t.state.keyExchange) || void 0 === o ? void 0 : o.areKeysExchanged()}`, r), k) throw B_.SocketService(`\n      [SocketService handleMessage()] context=${t.state.context}::on 'message' error=${k}`), new Error(k);
          try {
            !function (e, t) {
              if (t !== e.channelId) throw e.debug && console.error(`Wrong id ${t} - should be ${e.channelId}`), new Error("Wrong id");
            }(t.state, _);
          } catch (e) {
            return void console.error("ignore message --- wrong id ", S);
          }
          const C = "string" == typeof S;
          if (!C && (null == S ? void 0 : S.type) === YE.KEY_HANDSHAKE_START) return M ? void console.warn("[SocketService handleMessage()] Ignoring key exchange message because relay persistence is activated", S) : (B_.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' received HANDSHAKE_START isOriginator=${t.state.isOriginator}`, S), void (null === (a = t.state.keyExchange) || void 0 === a || a.start({
            isOriginator: null !== (s = t.state.isOriginator) && void 0 !== s && s,
            force: !0
          })));
          if (!C && (null === (u = null == S ? void 0 : S.type) || void 0 === u ? void 0 : u.startsWith("key_handshake"))) return M ? void console.warn("[SocketService handleMessage()] Ignoring key exchange message because relay persistence is activated", S) : (B_.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' emit KEY_EXCHANGE`, S), void t.emit(WE.KEY_EXCHANGE, {
            message: S,
            context: t.state.context
          }));
          if (C && !(null === (c = t.state.keyExchange) || void 0 === c ? void 0 : c.areKeysExchanged())) {
            let e = !1;
            try {
              B_.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' trying to decrypt message`), null === (l = t.state.keyExchange) || void 0 === l || l.decryptMessage(S), e = !0;
            } catch (e) {
              B_.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' error`, e);
            }
            if (!e) return t.state.isOriginator ? null === (f = t.state.keyExchange) || void 0 === f || f.start({
              isOriginator: null !== (h = t.state.isOriginator) && void 0 !== h && h
            }) : t.sendMessage({
              type: YE.KEY_HANDSHAKE_START
            }), void B_.SocketService(`Message ignored because invalid key exchange status. step=${null === (p = t.state.keyExchange) || void 0 === p ? void 0 : p.getKeyInfo().step}`, null === (m = t.state.keyExchange) || void 0 === m ? void 0 : m.getKeyInfo(), S);
            B_.SocketService("Invalid key exchange status detected --- updating it."), null === (d = t.state.keyExchange) || void 0 === d || d.setKeysExchanged(!0);
          } else if (!C && (null == S ? void 0 : S.type)) return console.warn("[SocketService handleMessage() ::on 'message' received non encrypted unkwown message"), void t.emit(e.EventType.MESSAGE, S);
          if (!C) return console.warn("[SocketService handleMessage() ::on 'message' received unkwown message", S), void t.emit(e.EventType.MESSAGE, S);
          const x = null === (g = t.state.keyExchange) || void 0 === g ? void 0 : g.decryptMessage(S),
            R = JSON.parse(null != x ? x : "{}");
          if (E && (null == E ? void 0 : E.length) > 0 && (B_.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' ackid=${E} channelId=${_}`), null === (v = t.state.socket) || void 0 === v || v.emit(e.EventType.MESSAGE_ACK, {
            ackId: E,
            channelId: _,
            clientType: t.state.isOriginator ? "dapp" : "wallet"
          })), (null == R ? void 0 : R.type) === e.MessageType.PAUSE ? t.state.clientsPaused = !0 : t.state.clientsPaused = !1, t.state.isOriginator && R.data) {
            const n = R.data,
              r = t.state.rpcMethodTracker[n.id];
            if (r) {
              const i = Date.now() - r.timestamp;
              B_.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' received answer for id=${n.id} method=${r.method} responseTime=${i}`, R), t.remote.state.analytics && tS.includes(r.method.toLowerCase()) && q_({
                id: null !== (b = t.remote.state.channelId) && void 0 !== b ? b : "",
                event: XE.SDK_RPC_REQUEST_DONE,
                sdkVersion: t.remote.state.sdkVersion,
                commLayerVersion: UE,
                walletVersion: null === (y = t.remote.state.walletInfo) || void 0 === y ? void 0 : y.version,
                params: {
                  method: r.method,
                  from: "mobile"
                }
              }, t.remote.state.communicationServerUrl).catch(e => {
                console.error("Cannot send analytics", e);
              });
              const o = Object.assign(Object.assign({}, r), {
                result: n.result,
                error: n.error ? {
                  code: null === (w = n.error) || void 0 === w ? void 0 : w.code,
                  message: null === (A = n.error) || void 0 === A ? void 0 : A.message
                } : void 0,
                elapsedTime: i
              });
              t.state.rpcMethodTracker[n.id] = o, t.emit(e.EventType.RPC_UPDATE, o);
            }
          }
          t.emit(e.EventType.MESSAGE, {
            message: R
          });
        };
      }
    }, {
      event: "clients_waiting_to_join",
      handler: function (t, n) {
        return r => {
          B_.SocketService(`[SocketService: handleClientsWaitingToJoin()] context=${t.state.context} on 'clients_waiting_to_join-${n}'`, r), t.emit(e.EventType.CLIENTS_WAITING, r);
        };
      }
    }],
    iS = [{
      event: e.EventType.KEY_INFO,
      handler: function (t) {
        return n => {
          B_.SocketService("[SocketService: handleKeyInfo()] on 'KEY_INFO'", n), t.emit(e.EventType.KEY_INFO, n);
        };
      }
    }, {
      event: e.EventType.KEYS_EXCHANGED,
      handler: function (t) {
        return () => {
          var n, r, i;
          B_.SocketService(`[SocketService: handleKeysExchanged()] on 'keys_exchanged' keyschanged=${null === (n = t.state.keyExchange) || void 0 === n ? void 0 : n.areKeysExchanged()}`);
          const {
            channelConfig: o
          } = t.remote.state;
          if (o) {
            const e = t.getKeyExchange().getKeyInfo().ecies;
            o.localKey = e.private, o.otherKey = e.otherPubKey, t.remote.state.channelConfig = o, null === (r = t.remote.state.storageManager) || void 0 === r || r.persistChannelConfig(o).catch(e => {
              console.error("Error persisting channel config", e);
            });
          }
          t.emit(e.EventType.KEYS_EXCHANGED, {
            keysExchanged: null === (i = t.state.keyExchange) || void 0 === i ? void 0 : i.areKeysExchanged(),
            isOriginator: t.state.isOriginator
          });
          const a = {
            keyInfo: t.getKeyInfo()
          };
          t.emit(e.EventType.SERVICE_STATUS, a);
        };
      }
    }];
  function oS(t, n) {
    B_.SocketService(`[SocketService: setupChannelListener()] context=${t.state.context} setting socket listeners for channel ${n}...`);
    const {
        socket: r
      } = t.state,
      {
        keyExchange: i
      } = t.state;
    t.state.setupChannelListeners && console.warn(`[SocketService: setupChannelListener()] context=${t.state.context} socket listeners already set up for channel ${n}`), r && t.state.isOriginator && (t.state.debug && (null == r || r.io.on("error", e => {
      B_.SocketService(`[SocketService: setupChannelListener()] context=${t.state.context} socket event=error`, e);
    }), null == r || r.io.on("reconnect", e => {
      B_.SocketService(`[SocketService: setupChannelListener()] context=${t.state.context} socket event=reconnect`, e);
    }), null == r || r.io.on("reconnect_error", e => {
      B_.SocketService(`[SocketService: setupChannelListener()] context=${t.state.context} socket event=reconnect_error`, e);
    }), null == r || r.io.on("reconnect_failed", () => {
      B_.SocketService(`[SocketService: setupChannelListener()] context=${t.state.context} socket event=reconnect_failed`);
    }), null == r || r.io.on("ping", () => {
      B_.SocketService(`[SocketService: setupChannelListener()] context=${t.state.context} socket`);
    })), null == r || r.on("disconnect", n => (B_.SocketService(`[SocketService: setupChannelListener()] on 'disconnect' -- MetaMaskSDK socket disconnected '${n}' begin recovery...`), function (t) {
      return n => {
        B_.SocketService(`[SocketService: handleDisconnect()] on 'disconnect' manualDisconnect=${t.state.manualDisconnect}`, n), t.state.manualDisconnect || (t.emit(e.EventType.SOCKET_DISCONNECTED), function (e) {
          "undefined" != typeof window && "undefined" != typeof document && (B_.SocketService(`[SocketService: checkFocusAndReconnect()] hasFocus=${document.hasFocus()}`, e), document.hasFocus() ? JE(e).then(t => {
            B_.SocketService(`SocketService::checkFocus reconnectSocket success=${t}`, e);
          }).catch(e => {
            console.error("SocketService::checkFocus Error reconnecting socket", e);
          }) : window.addEventListener("focus", () => {
            JE(e).catch(e => {
              console.error("SocketService::checkFocus Error reconnecting socket", e);
            });
          }, {
            once: !0
          }));
        }(t));
      };
    }(t)(n)))), rS.forEach(({
      event: e,
      handler: i
    }) => {
      const o = `${e}-${n}`;
      null == r || r.on(o, i(t, n));
    }), iS.forEach(({
      event: e,
      handler: n
    }) => {
      null == i || i.on(e, n(t));
    }), t.state.setupChannelListeners = !0;
  }
  class aS extends Cw.EventEmitter2 {
    constructor({
      otherPublicKey: e,
      reconnect: t,
      communicationLayerPreference: n,
      transports: r,
      communicationServerUrl: i,
      context: o,
      ecies: a,
      remote: s,
      logging: u
    }) {
      super(), this.state = {
        clientsConnected: !1,
        clientsPaused: !1,
        manualDisconnect: !1,
        lastRpcId: void 0,
        rpcMethodTracker: {},
        hasPlaintext: !1,
        communicationServerUrl: ""
      }, this.state.resumed = t, this.state.context = o, this.state.isOriginator = s.state.isOriginator, this.state.communicationLayerPreference = n, this.state.debug = !0 === (null == u ? void 0 : u.serviceLayer), this.remote = s, !0 === (null == u ? void 0 : u.serviceLayer) && P_.enable("SocketService:Layer"), this.state.communicationServerUrl = i, this.state.hasPlaintext = this.state.communicationServerUrl !== qE && !0 === (null == u ? void 0 : u.plaintext);
      const c = {
        autoConnect: !1,
        transports: KE,
        withCredentials: !0
      };
      r && (c.transports = r), B_.SocketService(`[SocketService: constructor()] Socket IO url: ${this.state.communicationServerUrl}`), this.state.socket = t_(i, c);
      const l = {
        communicationLayer: this,
        otherPublicKey: e,
        sendPublicKey: !1,
        context: this.state.context,
        ecies: a,
        logging: u
      };
      this.state.keyExchange = new GE(l);
    }
    resetKeys() {
      return this, B_.SocketService("[SocketService: resetKeys()] Resetting keys."), void (null === (e = this.state.keyExchange) || void 0 === e || e.resetKeys());
      var e;
    }
    createChannel() {
      return function (t) {
        var n, r, i, o;
        if (B_.SocketService(`[SocketService: createChannel()] context=${t.state.context}`), null === (n = t.state.socket) || void 0 === n ? void 0 : n.connected) throw console.error("[SocketService: createChannel()] socket already connected"), new Error("socket already connected");
        console.log("create channel", t.state.socket), null === (r = t.state.socket) || void 0 === r || r.connect(), t.state.manualDisconnect = !1, t.state.isOriginator = !0;
        const a = Lw();
        return t.state.channelId = a, oS(t, a), null === (i = t.state.socket) || void 0 === i || i.emit(e.EventType.JOIN_CHANNEL, {
          channelId: a,
          context: `${t.state.context}createChannel`,
          clientType: "dapp"
        }), {
          channelId: a,
          pubKey: (null === (o = t.state.keyExchange) || void 0 === o ? void 0 : o.getMyPublicKey()) || ""
        };
      }(this);
    }
    connectToChannel({
      channelId: t,
      withKeyExchange: n = !1
    }) {
      return function ({
        options: t,
        instance: n
      }) {
        var r, i, o, a, s, u, c, l;
        const {
            channelId: d,
            withKeyExchange: f
          } = t,
          h = null !== (r = n.state.isOriginator) && void 0 !== r && r;
        if (B_.SocketService(`[SocketService: connectToChannel()] context=${n.state.context} channelId=${d} isOriginator=${h}`, null === (i = n.state.keyExchange) || void 0 === i ? void 0 : i.toString()), null === (o = n.state.socket) || void 0 === o ? void 0 : o.connected) throw console.error("[SocketService: connectToChannel()] socket already connected"), new Error("socket already connected");
        const {
          channelConfig: p
        } = n.remote.state;
        h && (null == p ? void 0 : p.relayPersistence) && (p.localKey && (null === (a = null == p ? void 0 : p.localKey) || void 0 === a ? void 0 : a.length) > 0 && p.otherKey && (null === (s = null == p ? void 0 : p.otherKey) || void 0 === s ? void 0 : s.length) > 0 ? null === (u = n.state.keyExchange) || void 0 === u || u.setRelayPersistence({
          localKey: p.localKey,
          otherKey: p.otherKey
        }) : console.warn("Missing keys in relay persistence", p)), n.state.manualDisconnect = !1, null === (c = n.state.socket) || void 0 === c || c.connect(), n.state.withKeyExchange = f, n.state.isOriginator = h, n.state.channelId = d, oS(n, d), null === (l = n.state.socket) || void 0 === l || l.emit(e.EventType.JOIN_CHANNEL, {
          channelId: d,
          context: `${n.state.context}_connectToChannel`,
          clientType: h ? "dapp" : "wallet"
        }, (t, r) => {
          "error_terminated" === t ? n.emit(e.EventType.TERMINATE) : "object" == typeof r && r.persistence && n.emit(e.EventType.CHANNEL_PERSISTENCE);
        });
      }({
        options: {
          channelId: t,
          withKeyExchange: n
        },
        instance: this
      });
    }
    getKeyInfo() {
      return this.state.keyExchange.getKeyInfo();
    }
    keyCheck() {
      var t, n;
      null === (n = (t = this).state.socket) || void 0 === n || n.emit(e.EventType.MESSAGE, {
        id: t.state.channelId,
        context: t.state.context,
        message: {
          type: YE.KEY_HANDSHAKE_CHECK,
          pubkey: t.getKeyInfo().ecies.otherPubKey
        }
      });
    }
    getKeyExchange() {
      return this.state.keyExchange;
    }
    sendMessage(e) {
      return nS(this, e);
    }
    ping() {
      return t = this, B_.SocketService(`[SocketService: ping()] context=${t.state.context} originator=${t.state.isOriginator} keysExchanged=${null === (n = t.state.keyExchange) || void 0 === n ? void 0 : n.areKeysExchanged()}`), t.state.isOriginator && ((null === (r = t.state.keyExchange) || void 0 === r ? void 0 : r.areKeysExchanged()) ? (console.warn(`[SocketService:ping()] context=${t.state.context} sending READY message`), t.sendMessage({
        type: e.MessageType.READY
      })) : (console.warn(`[SocketService: ping()] context=${t.state.context} starting key exchange`), null === (i = t.state.keyExchange) || void 0 === i || i.start({
        isOriginator: null !== (o = t.state.isOriginator) && void 0 !== o && o
      }))), void (null === (a = t.state.socket) || void 0 === a || a.emit(e.EventType.MESSAGE, {
        id: t.state.channelId,
        context: t.state.context,
        clientType: t.remote.state.isOriginator ? "dapp" : "wallet",
        message: {
          type: e.MessageType.PING
        }
      }));
      var t, n, r, i, o, a;
    }
    pause() {
      return t = this, B_.SocketService(`[SocketService: pause()] context=${t.state.context}`), t.state.manualDisconnect = !0, (null === (n = t.state.keyExchange) || void 0 === n ? void 0 : n.areKeysExchanged()) && t.sendMessage({
        type: e.MessageType.PAUSE
      }), void (null === (r = t.state.socket) || void 0 === r || r.disconnect());
      var t, n, r;
    }
    isConnected() {
      var e;
      return null === (e = this.state.socket) || void 0 === e ? void 0 : e.connected;
    }
    resume() {
      return t = this, B_.SocketService(`[SocketService: resume()] context=${t.state.context} connected=${null === (n = t.state.socket) || void 0 === n ? void 0 : n.connected} manualDisconnect=${t.state.manualDisconnect} resumed=${t.state.resumed} keysExchanged=${null === (r = t.state.keyExchange) || void 0 === r ? void 0 : r.areKeysExchanged()}`), (null === (i = t.state.socket) || void 0 === i ? void 0 : i.connected) ? B_.SocketService("[SocketService: resume()] already connected.") : (null === (o = t.state.socket) || void 0 === o || o.connect(), B_.SocketService(`[SocketService: resume()] after connecting socket --\x3e connected=${null === (a = t.state.socket) || void 0 === a ? void 0 : a.connected}`), null === (s = t.state.socket) || void 0 === s || s.emit(e.EventType.JOIN_CHANNEL, {
        channelId: t.state.channelId,
        context: `${t.state.context}_resume`,
        clientType: t.remote.state.isOriginator ? "dapp" : "wallet"
      })), (null === (u = t.state.keyExchange) || void 0 === u ? void 0 : u.areKeysExchanged()) ? t.state.isOriginator || t.sendMessage({
        type: e.MessageType.READY
      }) : t.state.isOriginator || null === (c = t.state.keyExchange) || void 0 === c || c.start({
        isOriginator: null !== (l = t.state.isOriginator) && void 0 !== l && l
      }), t.state.manualDisconnect = !1, void (t.state.resumed = !0);
      var t, n, r, i, o, a, s, u, c, l;
    }
    getRPCMethodTracker() {
      return this.state.rpcMethodTracker;
    }
    disconnect(e) {
      return function (e, t) {
        var n, r;
        B_.SocketService(`[SocketService: disconnect()] context=${e.state.context}`, t), (null == t ? void 0 : t.terminate) && (e.state.channelId = t.channelId, null === (n = e.state.keyExchange) || void 0 === n || n.clean(), e.state.rpcMethodTracker = {}), e.state.manualDisconnect = !0, null === (r = e.state.socket) || void 0 === r || r.disconnect();
      }(this, e);
    }
  }
  var sS;
  function uS(t) {
    return () => n_(this, void 0, void 0, function* () {
      var n, r, i;
      const {
        state: o
      } = t;
      if (o.authorized) return;
      yield (() => n_(this, void 0, void 0, function* () {
        for (; !o.walletInfo;) yield QE(500);
      }))();
      const a = "7.3".localeCompare((null === (n = o.walletInfo) || void 0 === n ? void 0 : n.version) || "");
      if (B_.RemoteCommunication(`[RemoteCommunication: handleAuthorizedEvent()] HACK 'authorized' version=${null === (r = o.walletInfo) || void 0 === r ? void 0 : r.version} compareValue=${a}`), 1 !== a) return;
      const s = o.platformType === e.PlatformType.MobileWeb || o.platformType === e.PlatformType.ReactNative || o.platformType === e.PlatformType.MetaMaskMobileWebview;
      B_.RemoteCommunication(`[RemoteCommunication: handleAuthorizedEvent()] HACK 'authorized' platform=${o.platformType} secure=${s} channel=${o.channelId} walletVersion=${null === (i = o.walletInfo) || void 0 === i ? void 0 : i.version}`), s && (o.authorized = !0, t.emit(e.EventType.AUTHORIZED));
    });
  }
  function cS(t) {
    return n => {
      const {
        state: r
      } = t;
      B_.RemoteCommunication(`[RemoteCommunication: handleChannelCreatedEvent()] context=${r.context} on 'channel_created' channelId=${n}`), t.emit(e.EventType.CHANNEL_CREATED, n);
    };
  }
  function lS(t, n) {
    return () => {
      var r, i, o, a;
      const {
        state: s
      } = t;
      if (B_.RemoteCommunication(`[RemoteCommunication: handleClientsConnectedEvent()] on 'clients_connected' channel=${s.channelId} keysExchanged=${null === (i = null === (r = s.communicationLayer) || void 0 === r ? void 0 : r.getKeyInfo()) || void 0 === i ? void 0 : i.keysExchanged}`), s.analytics) {
        const e = s.isOriginator ? XE.REQUEST : XE.REQUEST_MOBILE;
        q_(Object.assign(Object.assign({
          id: null !== (o = s.channelId) && void 0 !== o ? o : "",
          event: s.reconnection ? XE.RECONNECT : e
        }, s.originatorInfo), {
          commLayer: n,
          sdkVersion: s.sdkVersion,
          walletVersion: null === (a = s.walletInfo) || void 0 === a ? void 0 : a.version,
          commLayerVersion: UE
        }), s.communicationServerUrl).catch(e => {
          console.error("Cannot send analytics", e);
        });
      }
      s.clientsConnected = !0, s.originatorInfoSent = !1, t.emit(e.EventType.CLIENTS_CONNECTED);
    };
  }
  function dS(t, n) {
    return r => {
      var i;
      const {
        state: o
      } = t;
      B_.RemoteCommunication(`[RemoteCommunication: handleClientsDisconnectedEvent()] context=${o.context} on 'clients_disconnected' channelId=${r}`), o.relayPersistence || (o.clientsConnected = !1, o.ready = !1, o.authorized = !1), t.emit(e.EventType.CLIENTS_DISCONNECTED, o.channelId), t.setConnectionStatus(e.ConnectionStatus.DISCONNECTED), o.analytics && o.channelId && q_({
        id: o.channelId,
        event: XE.DISCONNECTED,
        sdkVersion: o.sdkVersion,
        commLayer: n,
        commLayerVersion: UE,
        walletVersion: null === (i = o.walletInfo) || void 0 === i ? void 0 : i.version
      }, o.communicationServerUrl).catch(e => {
        console.error("Cannot send analytics", e);
      });
    };
  }
  function fS(t) {
    return n => {
      var r;
      const {
        state: i
      } = t;
      if (B_.RemoteCommunication(`[RemoteCommunication: handleClientsWaitingEvent()] context=${i.context} on 'clients_waiting' numberUsers=${n} ready=${i.ready} autoStarted=${i.originatorConnectStarted}`), t.setConnectionStatus(e.ConnectionStatus.WAITING), t.emit(e.EventType.CLIENTS_WAITING, n), i.originatorConnectStarted) {
        B_.RemoteCommunication(`[RemoteCommunication: handleClientsWaitingEvent()] on 'clients_waiting' watch autoStarted=${i.originatorConnectStarted} timeout`, i.autoConnectOptions);
        const n = (null === (r = i.autoConnectOptions) || void 0 === r ? void 0 : r.timeout) || 3e3,
          o = setTimeout(() => {
            B_.RemoteCommunication(`[RemoteCommunication: handleClientsWaitingEvent()] setTimeout(${n}) terminate channelConfig`, i.autoConnectOptions), i.originatorConnectStarted = !1, i.ready || t.setConnectionStatus(e.ConnectionStatus.TIMEOUT), clearTimeout(o);
          }, n);
      }
    };
  }
  function hS(t, n) {
    return r => {
      var i, o, a, s, u, c, l, d;
      const {
        state: f
      } = t;
      if (B_.RemoteCommunication(`[RemoteCommunication: handleKeysExchangedEvent()] context=${f.context} on commLayer.'keys_exchanged' channel=${f.channelId}`, r), null === (o = null === (i = f.communicationLayer) || void 0 === i ? void 0 : i.getKeyInfo()) || void 0 === o ? void 0 : o.keysExchanged) {
        const n = Object.assign(Object.assign({}, f.channelConfig), {
          channelId: null !== (a = f.channelId) && void 0 !== a ? a : "",
          validUntil: (null === (s = f.channelConfig) || void 0 === s ? void 0 : s.validUntil) || HE,
          localKey: f.communicationLayer.getKeyInfo().ecies.private,
          otherKey: f.communicationLayer.getKeyInfo().ecies.otherPubKey
        });
        null === (u = f.storageManager) || void 0 === u || u.persistChannelConfig(n).catch(e => {
          console.error("Error persisting channel config", e);
        }), t.setConnectionStatus(e.ConnectionStatus.LINKED);
      }
      !function (e, t) {
        var n, r, i, o, a, s, u, c;
        const {
          state: l
        } = e;
        B_.RemoteCommunication(`[RemoteCommunication: setLastActiveDate()] channel=${l.channelId}`, t);
        const d = Object.assign(Object.assign({}, l.channelConfig), {
          channelId: null !== (n = l.channelId) && void 0 !== n ? n : "",
          validUntil: null !== (i = null === (r = l.channelConfig) || void 0 === r ? void 0 : r.validUntil) && void 0 !== i ? i : 0,
          relayPersistence: l.relayPersistence,
          localKey: null === (a = null === (o = l.communicationLayer) || void 0 === o ? void 0 : o.state.keyExchange) || void 0 === a ? void 0 : a.getKeyInfo().ecies.private,
          otherKey: null === (u = null === (s = l.communicationLayer) || void 0 === s ? void 0 : s.state.keyExchange) || void 0 === u ? void 0 : u.getKeyInfo().ecies.otherPubKey,
          lastActive: t.getTime()
        });
        null === (c = l.storageManager) || void 0 === c || c.persistChannelConfig(d);
      }(t, new Date()), f.analytics && f.channelId && q_({
        id: f.channelId,
        event: r.isOriginator ? XE.CONNECTED : XE.CONNECTED_MOBILE,
        sdkVersion: f.sdkVersion,
        commLayer: n,
        commLayerVersion: UE,
        walletVersion: null === (c = f.walletInfo) || void 0 === c ? void 0 : c.version
      }, f.communicationServerUrl).catch(e => {
        console.error("Cannot send analytics", e);
      }), f.isOriginator = r.isOriginator, r.isOriginator || (null === (l = f.communicationLayer) || void 0 === l || l.sendMessage({
        type: e.MessageType.READY
      }), f.ready = !0, f.paused = !1), r.isOriginator && !f.originatorInfoSent && (null === (d = f.communicationLayer) || void 0 === d || d.sendMessage({
        type: e.MessageType.ORIGINATOR_INFO,
        originatorInfo: f.originatorInfo,
        originator: f.originatorInfo
      }), f.originatorInfoSent = !0);
    };
  }
  function pS(t) {
    return n => {
      let r = n;
      n.message && (r = r.message), function (t, n) {
        const {
          state: r
        } = n;
        if (B_.RemoteCommunication(`[RemoteCommunication: onCommunicationLayerMessage()] context=${r.context} on 'message' typeof=${typeof t}`, t), n.state.ready = !0, r.isOriginator || t.type !== e.MessageType.ORIGINATOR_INFO) {
          if (r.isOriginator && t.type === e.MessageType.WALLET_INFO) !function (e, t) {
            const {
              state: n
            } = e;
            n.walletInfo = t.walletInfo, n.paused = !1;
          }(n, t);else {
            if (t.type === e.MessageType.TERMINATE) !function (t) {
              const {
                state: n
              } = t;
              n.isOriginator && (bS({
                options: {
                  terminate: !0,
                  sendMessage: !1
                },
                instance: t
              }), console.debug(), t.emit(e.EventType.TERMINATE));
            }(n);else if (t.type === e.MessageType.PAUSE) !function (t) {
              const {
                state: n
              } = t;
              n.paused = !0, t.setConnectionStatus(e.ConnectionStatus.PAUSED);
            }(n);else if (t.type === e.MessageType.READY && r.isOriginator) !function (t) {
              const {
                state: n
              } = t;
              t.setConnectionStatus(e.ConnectionStatus.LINKED);
              const r = n.paused;
              n.paused = !1, t.emit(e.EventType.CLIENTS_READY, {
                isOriginator: n.isOriginator,
                walletInfo: n.walletInfo
              }), r && (n.authorized = !0, t.emit(e.EventType.AUTHORIZED));
            }(n);else {
              if (t.type === e.MessageType.OTP && r.isOriginator) return void function (t, n) {
                var r;
                const {
                  state: i
                } = t;
                t.emit(e.EventType.OTP, n.otpAnswer), 1 === "6.6".localeCompare((null === (r = i.walletInfo) || void 0 === r ? void 0 : r.version) || "") && (console.warn("RemoteCommunication::on 'otp' -- backward compatibility <6.6 -- triger eth_requestAccounts"), t.emit(e.EventType.SDK_RPC_CALL, {
                  method: VE.ETH_REQUESTACCOUNTS,
                  params: []
                }));
              }(n, t);
              t.type === e.MessageType.AUTHORIZED && r.isOriginator && function (t) {
                const {
                  state: n
                } = t;
                n.authorized = !0, t.emit(e.EventType.AUTHORIZED);
              }(n);
            }
            n.emit(e.EventType.MESSAGE, t);
          }
        } else !function (t, n) {
          var r;
          const {
            state: i
          } = t;
          null === (r = i.communicationLayer) || void 0 === r || r.sendMessage({
            type: e.MessageType.WALLET_INFO,
            walletInfo: i.walletInfo
          }), i.originatorInfo = n.originatorInfo || n.originator, t.emit(e.EventType.CLIENTS_READY, {
            isOriginator: i.isOriginator,
            originatorInfo: i.originatorInfo
          }), i.paused = !1;
        }(n, t);
      }(r, t);
    };
  }
  function mS(e) {
    return () => {
      const {
        state: t
      } = e;
      B_.RemoteCommunication("[RemoteCommunication: handleSocketReconnectEvent()] on 'socket_reconnect' -- reset key exchange status / set ready to false"), t.ready = !1, t.authorized = !1, $E(t), e.emitServiceStatusEvent({
        context: "socket_reconnect"
      });
    };
  }
  function gS(e) {
    return () => {
      const {
        state: t
      } = e;
      B_.RemoteCommunication("[RemoteCommunication: handleSocketDisconnectedEvent()] on 'socket_Disconnected' set ready to false"), t.ready = !1;
    };
  }
  function vS(t) {
    return () => n_(this, void 0, void 0, function* () {
      var n, r, i, o, a, s, u;
      const {
        state: c
      } = t;
      B_.RemoteCommunication(`[RemoteCommunication: handleFullPersistenceEvent()] context=${c.context}`), t.state.ready = !0, t.state.clientsConnected = !0, t.state.authorized = !0, t.state.relayPersistence = !0, null === (n = t.state.communicationLayer) || void 0 === n || n.getKeyExchange().setKeysExchanged(!0), t.emit(e.EventType.KEYS_EXCHANGED, {
        keysExchanged: !0,
        isOriginator: !0
      }), t.emit(e.EventType.AUTHORIZED), t.emit(e.EventType.CLIENTS_READY), t.emit(e.EventType.CHANNEL_PERSISTENCE);
      try {
        c.channelConfig = Object.assign(Object.assign({}, c.channelConfig), {
          localKey: null === (r = c.communicationLayer) || void 0 === r ? void 0 : r.getKeyExchange().getKeyInfo().ecies.private,
          otherKey: null === (i = c.communicationLayer) || void 0 === i ? void 0 : i.getKeyExchange().getOtherPublicKey(),
          channelId: null !== (o = c.channelId) && void 0 !== o ? o : "",
          validUntil: null !== (s = null === (a = c.channelConfig) || void 0 === a ? void 0 : a.validUntil) && void 0 !== s ? s : HE,
          relayPersistence: !0
        }), yield null === (u = c.storageManager) || void 0 === u ? void 0 : u.persistChannelConfig(c.channelConfig);
      } catch (e) {
        console.error("Error persisting channel config", e);
      }
    });
  }
  function bS({
    options: t,
    instance: n
  }) {
    var r, i, o, a, s, u;
    const {
      state: c
    } = n;
    B_.RemoteCommunication(`[RemoteCommunication: disconnect()] channel=${c.channelId}`, t), c.ready = !1, c.paused = !1, (null == t ? void 0 : t.terminate) ? (null === (r = c.storageManager) || void 0 === r || r.terminate(null !== (i = c.channelId) && void 0 !== i ? i : ""), n.state.terminated = !0, t.sendMessage && (null === (o = c.communicationLayer) || void 0 === o ? void 0 : o.getKeyInfo().keysExchanged) && (null === (a = c.communicationLayer) || void 0 === a || a.sendMessage({
      type: e.MessageType.TERMINATE
    })), c.relayPersistence = !1, c.channelId = Lw(), t.channelId = c.channelId, c.channelConfig = void 0, c.originatorConnectStarted = !1, null === (s = c.communicationLayer) || void 0 === s || s.disconnect(t), n.setConnectionStatus(e.ConnectionStatus.TERMINATED)) : (null === (u = c.communicationLayer) || void 0 === u || u.disconnect(t), n.setConnectionStatus(e.ConnectionStatus.DISCONNECTED));
  }
  e.CommunicationLayerPreference = void 0, e.PlatformType = void 0, function (e) {
    e.SOCKET = "socket";
  }(e.CommunicationLayerPreference || (e.CommunicationLayerPreference = {})), function (e) {
    e.NonBrowser = "nodejs", e.MetaMaskMobileWebview = "in-app-browser", e.DesktopWeb = "web-desktop", e.MobileWeb = "web-mobile", e.ReactNative = "react-native";
  }(e.PlatformType || (e.PlatformType = {}));
  class yS extends Cw.EventEmitter2 {
    constructor({
      platformType: t,
      communicationLayerPreference: n,
      otherPublicKey: r,
      reconnect: i,
      walletInfo: o,
      dappMetadata: a,
      protocolVersion: s,
      transports: u,
      context: c,
      relayPersistence: l,
      ecies: d,
      analytics: f = !1,
      storage: h,
      sdkVersion: p,
      communicationServerUrl: m = qE,
      logging: g,
      autoConnect: v = {
        timeout: 3e3
      }
    }) {
      super(), this.state = {
        ready: !1,
        authorized: !1,
        isOriginator: !1,
        terminated: !1,
        protocolVersion: 1,
        paused: !1,
        platformType: "metamask-mobile",
        analytics: !1,
        reconnection: !1,
        originatorInfoSent: !1,
        communicationServerUrl: qE,
        context: "",
        persist: !1,
        clientsConnected: !1,
        sessionDuration: HE,
        originatorConnectStarted: !1,
        debug: !1,
        _connectionStatus: e.ConnectionStatus.DISCONNECTED
      }, this.state.otherPublicKey = r, this.state.dappMetadata = a, this.state.walletInfo = o, this.state.transports = u, this.state.platformType = t, this.state.analytics = f, this.state.protocolVersion = null != s ? s : 1, this.state.isOriginator = !r, this.state.relayPersistence = l, this.state.communicationServerUrl = m, this.state.context = c, this.state.terminated = !1, this.state.sdkVersion = p, this.setMaxListeners(50), this.setConnectionStatus(e.ConnectionStatus.DISCONNECTED), (null == h ? void 0 : h.duration) && (this.state.sessionDuration = HE), this.state.storageOptions = h, this.state.autoConnectOptions = v, this.state.debug = !0 === (null == g ? void 0 : g.remoteLayer), !0 === (null == g ? void 0 : g.remoteLayer) && P_.enable("RemoteCommunication:Layer"), !0 === (null == g ? void 0 : g.serviceLayer) && P_.enable("SocketService:Layer"), !0 === (null == g ? void 0 : g.eciesLayer) && P_.enable("ECIES:Layer"), !0 === (null == g ? void 0 : g.keyExchangeLayer) && P_.enable("KeyExchange:Layer"), this.state.logging = g, (null == h ? void 0 : h.storageManager) && (this.state.storageManager = h.storageManager), B_.RemoteCommunication(`[RemoteCommunication: constructor()] protocolVersion=${s} relayPersistence=${l} isOriginator=${this.state.isOriginator} communicationLayerPreference=${n} otherPublicKey=${r} reconnect=${i}`), this.initCommunicationLayer({
        communicationLayerPreference: n,
        otherPublicKey: r,
        reconnect: i,
        ecies: d,
        communicationServerUrl: m
      }), this.emitServiceStatusEvent({
        context: "constructor"
      });
    }
    initCommunicationLayer({
      communicationLayerPreference: t,
      otherPublicKey: n,
      reconnect: r,
      ecies: i,
      communicationServerUrl: o = qE
    }) {
      return function ({
        communicationLayerPreference: t,
        otherPublicKey: n,
        reconnect: r,
        ecies: i,
        communicationServerUrl: o = qE,
        instance: a
      }) {
        var s, u, c, l, d, f, h, p, m;
        const {
          state: g
        } = a;
        if (B_.RemoteCommunication("[initCommunicationLayer()] ", JSON.stringify(g, null, 2)), t !== e.CommunicationLayerPreference.SOCKET) throw new Error("Invalid communication protocol");
        g.communicationLayer = new aS({
          communicationLayerPreference: t,
          otherPublicKey: n,
          reconnect: r,
          transports: g.transports,
          communicationServerUrl: o,
          context: g.context,
          ecies: i,
          logging: g.logging,
          remote: a
        });
        let v = "undefined" != typeof document && document.URL || "",
          b = "undefined" != typeof document && document.title || "";
        (null === (s = g.dappMetadata) || void 0 === s ? void 0 : s.url) && (v = g.dappMetadata.url), (null === (u = g.dappMetadata) || void 0 === u ? void 0 : u.name) && (b = g.dappMetadata.name);
        const y = "undefined" != typeof window && void 0 !== window.location ? window.location.hostname : null !== (f = null !== (l = null === (c = g.dappMetadata) || void 0 === c ? void 0 : c.name) && void 0 !== l ? l : null === (d = g.dappMetadata) || void 0 === d ? void 0 : d.url) && void 0 !== f ? f : "unkown",
          w = {
            url: v,
            title: b,
            source: null === (h = g.dappMetadata) || void 0 === h ? void 0 : h.source,
            dappId: y,
            icon: (null === (p = g.dappMetadata) || void 0 === p ? void 0 : p.iconUrl) || (null === (m = g.dappMetadata) || void 0 === m ? void 0 : m.base64Icon),
            platform: g.platformType,
            apiVersion: UE
          };
        g.originatorInfo = w;
        const A = {
          [e.EventType.AUTHORIZED]: uS(a),
          [e.EventType.MESSAGE]: pS(a),
          [e.EventType.CHANNEL_PERSISTENCE]: vS(a),
          [e.EventType.CLIENTS_CONNECTED]: lS(a, t),
          [e.EventType.KEYS_EXCHANGED]: hS(a, t),
          [e.EventType.SOCKET_DISCONNECTED]: gS(a),
          [e.EventType.SOCKET_RECONNECT]: mS(a),
          [e.EventType.CLIENTS_DISCONNECTED]: dS(a, t),
          [e.EventType.KEY_INFO]: () => {},
          [e.EventType.CHANNEL_CREATED]: cS(a),
          [e.EventType.CLIENTS_WAITING]: fS(a),
          [e.EventType.RPC_UPDATE]: t => {
            a.emit(e.EventType.RPC_UPDATE, t);
          }
        };
        for (const [e, t] of Object.entries(A)) try {
          g.communicationLayer.on(e, t);
        } catch (n) {
          console.error(`Error registering handler for ${e}:`, n);
        }
      }({
        communicationLayerPreference: t,
        otherPublicKey: n,
        reconnect: r,
        ecies: i,
        communicationServerUrl: o,
        instance: this
      });
    }
    originatorSessionConnect() {
      return n_(this, void 0, void 0, function* () {
        return yield function (e) {
          var t;
          return n_(this, void 0, void 0, function* () {
            const {
              state: n
            } = e;
            if (!n.storageManager) return void B_.RemoteCommunication("[RemoteCommunication: originatorSessionConnect()] no storage manager defined - skip");
            const r = yield n.storageManager.getPersistedChannelConfig();
            if (B_.RemoteCommunication(`[RemoteCommunication: originatorSessionConnect()] autoStarted=${n.originatorConnectStarted} channelConfig`, r), null === (t = n.communicationLayer) || void 0 === t ? void 0 : t.isConnected()) return B_.RemoteCommunication("[RemoteCommunication: originatorSessionConnect()] socket already connected - skip"), r;
            if (r) {
              if (r.validUntil > Date.now()) return n.channelConfig = r, n.originatorConnectStarted = !0, n.channelId = null == r ? void 0 : r.channelId, n.reconnection = !0, r;
              B_.RemoteCommunication("[RemoteCommunication: autoConnect()] Session has expired");
            }
            n.originatorConnectStarted = !1;
          });
        }(this);
      });
    }
    generateChannelIdConnect() {
      return n_(this, void 0, void 0, function* () {
        return function (e) {
          var t, n, r, i;
          if (!e.communicationLayer) throw new Error("communication layer not initialized");
          if (e.ready) throw new Error("Channel already connected");
          if (e.channelId && (null === (t = e.communicationLayer) || void 0 === t ? void 0 : t.isConnected())) return console.warn("Channel already exists -- interrupt generateChannelId", e.channelConfig), e.channelConfig = Object.assign(Object.assign({}, e.channelConfig), {
            channelId: e.channelId,
            validUntil: Date.now() + e.sessionDuration
          }), null === (n = e.storageManager) || void 0 === n || n.persistChannelConfig(e.channelConfig), {
            channelId: e.channelId,
            pubKey: null === (i = null === (r = e.communicationLayer) || void 0 === r ? void 0 : r.getKeyInfo()) || void 0 === i ? void 0 : i.ecies.public
          };
          B_.RemoteCommunication("[RemoteCommunication: generateChannelId()]");
          const o = e.communicationLayer.createChannel();
          B_.RemoteCommunication("[RemoteCommunication: generateChannelId()] channel created", o);
          const a = Object.assign(Object.assign({}, e.channelConfig), {
            channelId: o.channelId,
            validUntil: Date.now() + e.sessionDuration
          });
          return e.channelId = o.channelId, e.channelConfig = a, {
            channelId: e.channelId,
            pubKey: o.pubKey
          };
        }(this.state);
      });
    }
    clean() {
      return $E(this.state);
    }
    connectToChannel({
      channelId: e,
      withKeyExchange: t
    }) {
      return function ({
        channelId: e,
        withKeyExchange: t,
        state: n
      }) {
        var r, i, o;
        if (!Tw(e)) throw B_.RemoteCommunication(`[RemoteCommunication: connectToChannel()] context=${n.context} invalid channel channelId=${e}`), new Error(`Invalid channel ${e}`);
        if (B_.RemoteCommunication(`[RemoteCommunication: connectToChannel()] context=${n.context} channelId=${e} withKeyExchange=${t}`), null === (r = n.communicationLayer) || void 0 === r ? void 0 : r.isConnected()) return void B_.RemoteCommunication(`[RemoteCommunication: connectToChannel()] context=${n.context} already connected - interrupt connection.`);
        n.channelId = e, null === (i = n.communicationLayer) || void 0 === i || i.connectToChannel({
          channelId: e,
          withKeyExchange: t
        });
        const a = Object.assign(Object.assign({}, n.channelConfig), {
          channelId: e,
          validUntil: Date.now() + n.sessionDuration
        });
        n.channelConfig = a, null === (o = n.storageManager) || void 0 === o || o.persistChannelConfig(a);
      }({
        channelId: e,
        withKeyExchange: t,
        state: this.state
      });
    }
    sendMessage(t) {
      return function (t, n) {
        var r, i;
        return n_(this, void 0, void 0, function* () {
          const {
            state: o
          } = t;
          B_.RemoteCommunication(`[RemoteCommunication: sendMessage()] context=${o.context} paused=${o.paused} ready=${o.ready} relayPersistence=${o.relayPersistence} authorized=${o.authorized} socket=${null === (r = o.communicationLayer) || void 0 === r ? void 0 : r.isConnected()} clientsConnected=${o.clientsConnected} status=${o._connectionStatus}`, n), o.relayPersistence || o.ready && (null === (i = o.communicationLayer) || void 0 === i ? void 0 : i.isConnected()) && o.clientsConnected || (B_.RemoteCommunication(`[RemoteCommunication: sendMessage()] context=${o.context}  SKIP message waiting for MM mobile readiness.`), yield new Promise(n => {
            t.once(e.EventType.CLIENTS_READY, n);
          }), B_.RemoteCommunication(`[RemoteCommunication: sendMessage()] context=${o.context}  AFTER SKIP / READY -- sending pending message`));
          try {
            yield function (t, n) {
              return n_(this, void 0, void 0, function* () {
                return new Promise(r => {
                  var i, o, a, s;
                  const {
                    state: u
                  } = t;
                  if (B_.RemoteCommunication(`[RemoteCommunication: handleAuthorization()] context=${u.context} ready=${u.ready} authorized=${u.authorized} method=${n.method}`), 1 === "7.3".localeCompare((null === (i = u.walletInfo) || void 0 === i ? void 0 : i.version) || "")) return B_.RemoteCommunication(`[RemoteCommunication: handleAuthorization()] compatibility hack wallet version > ${null === (o = u.walletInfo) || void 0 === o ? void 0 : o.version}`), null === (a = u.communicationLayer) || void 0 === a || a.sendMessage(n), void r();
                  !u.isOriginator || u.authorized || u.relayPersistence ? (null === (s = u.communicationLayer) || void 0 === s || s.sendMessage(n), r()) : t.once(e.EventType.AUTHORIZED, () => {
                    var e;
                    B_.RemoteCommunication(`[RemoteCommunication: handleAuthorization()] context=${u.context}  AFTER SKIP / AUTHORIZED -- sending pending message`), null === (e = u.communicationLayer) || void 0 === e || e.sendMessage(n), r();
                  });
                });
              });
            }(t, n);
          } catch (e) {
            throw console.error(`[RemoteCommunication: sendMessage()] context=${o.context}  ERROR`, e), e;
          }
        });
      }(this, t);
    }
    testStorage() {
      return n_(this, void 0, void 0, function* () {
        return function (e) {
          var t;
          return n_(this, void 0, void 0, function* () {
            const n = yield null === (t = e.storageManager) || void 0 === t ? void 0 : t.getPersistedChannelConfig();
            B_.RemoteCommunication("[RemoteCommunication: testStorage()] res", n);
          });
        }(this.state);
      });
    }
    getChannelConfig() {
      return this.state.channelConfig;
    }
    isReady() {
      return this.state.ready;
    }
    isConnected() {
      var e;
      return null === (e = this.state.communicationLayer) || void 0 === e ? void 0 : e.isConnected();
    }
    isAuthorized() {
      return this.state.authorized;
    }
    isPaused() {
      return this.state.paused;
    }
    getCommunicationLayer() {
      return this.state.communicationLayer;
    }
    ping() {
      var e;
      B_.RemoteCommunication(`[RemoteCommunication: ping()] channel=${this.state.channelId}`), null === (e = this.state.communicationLayer) || void 0 === e || e.ping();
    }
    testLogger() {
      B_.RemoteCommunication(`testLogger() channel=${this.state.channelId}`), B_.SocketService(`testLogger() channel=${this.state.channelId}`), B_.Ecies(`testLogger() channel=${this.state.channelId}`), B_.KeyExchange(`testLogger() channel=${this.state.channelId}`);
    }
    keyCheck() {
      var e;
      B_.RemoteCommunication(`[RemoteCommunication: keyCheck()] channel=${this.state.channelId}`), null === (e = this.state.communicationLayer) || void 0 === e || e.keyCheck();
    }
    setConnectionStatus(t) {
      this.state._connectionStatus !== t && (this.state._connectionStatus = t, this.emit(e.EventType.CONNECTION_STATUS, t), this.emitServiceStatusEvent({
        context: "setConnectionStatus"
      }));
    }
    emitServiceStatusEvent(t = {}) {
      this.emit(e.EventType.SERVICE_STATUS, this.getServiceStatus());
    }
    getConnectionStatus() {
      return this.state._connectionStatus;
    }
    getServiceStatus() {
      return {
        originatorInfo: this.state.originatorInfo,
        keyInfo: this.getKeyInfo(),
        connectionStatus: this.state._connectionStatus,
        channelConfig: this.state.channelConfig,
        channelId: this.state.channelId
      };
    }
    getKeyInfo() {
      var e;
      return null === (e = this.state.communicationLayer) || void 0 === e ? void 0 : e.getKeyInfo();
    }
    resetKeys() {
      var e;
      null === (e = this.state.communicationLayer) || void 0 === e || e.resetKeys();
    }
    setOtherPublicKey(e) {
      var t;
      const n = null === (t = this.state.communicationLayer) || void 0 === t ? void 0 : t.getKeyExchange();
      if (!n) throw new Error("KeyExchange is not initialized.");
      n.getOtherPublicKey() !== e && n.setOtherPublicKey(e);
    }
    pause() {
      var t;
      B_.RemoteCommunication(`[RemoteCommunication: pause()] channel=${this.state.channelId}`), null === (t = this.state.communicationLayer) || void 0 === t || t.pause(), this.setConnectionStatus(e.ConnectionStatus.PAUSED);
    }
    getVersion() {
      return UE;
    }
    hasRelayPersistence() {
      var e;
      return null !== (e = this.state.relayPersistence) && void 0 !== e && e;
    }
    resume() {
      return function (t) {
        var n;
        const {
          state: r
        } = t;
        B_.RemoteCommunication(`[RemoteCommunication: resume()] channel=${r.channelId}`), null === (n = r.communicationLayer) || void 0 === n || n.resume(), t.setConnectionStatus(e.ConnectionStatus.LINKED);
      }(this);
    }
    getChannelId() {
      return this.state.channelId;
    }
    getRPCMethodTracker() {
      var e;
      return null === (e = this.state.communicationLayer) || void 0 === e ? void 0 : e.getRPCMethodTracker();
    }
    disconnect(e) {
      return bS({
        options: e,
        instance: this
      });
    }
  }
  function wS(e, t, n, r) {
    return new (n || (n = Promise))(function (i, o) {
      function a(e) {
        try {
          u(r.next(e));
        } catch (e) {
          o(e);
        }
      }
      function s(e) {
        try {
          u(r.throw(e));
        } catch (e) {
          o(e);
        }
      }
      function u(e) {
        e.done ? i(e.value) : function (e) {
          return e instanceof n ? e : new n(function (t) {
            t(e);
          });
        }(e.value).then(a, s);
      }
      u((r = r.apply(e, t || [])).next());
    });
  }
  function AS(e, t, n, r) {
    if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
  }
  function _S(e, t, n, r, i) {
    if ("m" === r) throw new TypeError("Private method is not writable");
    if ("a" === r && !i) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === r ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
  }
  !function (e) {
    e.RENEW = "renew", e.LINK = "link";
  }(sS || (sS = {})), "function" == typeof SuppressedError && SuppressedError;
  var ES = "ERC721",
    SS = "ERC1155",
    kS = {
      errors: {
        disconnected: () => "MetaMask: Disconnected from chain. Attempting to connect.",
        permanentlyDisconnected: () => "MetaMask: Disconnected from MetaMask background. Page reload required.",
        sendSiteMetadata: () => "MetaMask: Failed to send site metadata. This is an internal error, please report this bug.",
        unsupportedSync: e => `MetaMask: The MetaMask Ethereum provider does not support synchronous methods like ${e} without a callback parameter.`,
        invalidDuplexStream: () => "Must provide a Node.js-style duplex stream.",
        invalidNetworkParams: () => "MetaMask: Received invalid network parameters. Please report this bug.",
        invalidRequestArgs: () => "Expected a single, non-array, object argument.",
        invalidRequestMethod: () => "'args.method' must be a non-empty string.",
        invalidRequestParams: () => "'args.params' must be an object or array if provided.",
        invalidLoggerObject: () => "'args.logger' must be an object if provided.",
        invalidLoggerMethod: e => `'args.logger' must include required method '${e}'.`
      },
      info: {
        connected: e => `MetaMask: Connected to chain with ID "${e}".`
      },
      warnings: {
        chainIdDeprecation: "MetaMask: 'ethereum.chainId' is deprecated and may be removed in the future. Please use the 'eth_chainId' RPC method instead.\nFor more information, see: https://github.com/MetaMask/metamask-improvement-proposals/discussions/23",
        networkVersionDeprecation: "MetaMask: 'ethereum.networkVersion' is deprecated and may be removed in the future. Please use the 'net_version' RPC method instead.\nFor more information, see: https://github.com/MetaMask/metamask-improvement-proposals/discussions/23",
        selectedAddressDeprecation: "MetaMask: 'ethereum.selectedAddress' is deprecated and may be removed in the future. Please use the 'eth_accounts' RPC method instead.\nFor more information, see: https://github.com/MetaMask/metamask-improvement-proposals/discussions/23",
        enableDeprecation: "MetaMask: 'ethereum.enable()' is deprecated and may be removed in the future. Please use the 'eth_requestAccounts' RPC method instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1102",
        sendDeprecation: "MetaMask: 'ethereum.send(...)' is deprecated and may be removed in the future. Please use 'ethereum.sendAsync(...)' or 'ethereum.request(...)' instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1193",
        events: {
          close: "MetaMask: The event 'close' is deprecated and may be removed in the future. Please use 'disconnect' instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1193#disconnect",
          data: "MetaMask: The event 'data' is deprecated and will be removed in the future. Use 'message' instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1193#message",
          networkChanged: "MetaMask: The event 'networkChanged' is deprecated and may be removed in the future. Use 'chainChanged' instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1193#chainchanged",
          notification: "MetaMask: The event 'notification' is deprecated and may be removed in the future. Use 'message' instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1193#message"
        },
        rpc: {
          ethDecryptDeprecation: "MetaMask: The RPC method 'eth_decrypt' is deprecated and may be removed in the future.\nFor more information, see: https://medium.com/metamask/metamask-api-method-deprecation-2b0564a84686",
          ethGetEncryptionPublicKeyDeprecation: "MetaMask: The RPC method 'eth_getEncryptionPublicKey' is deprecated and may be removed in the future.\nFor more information, see: https://medium.com/metamask/metamask-api-method-deprecation-2b0564a84686",
          walletWatchAssetNFTExperimental: "MetaMask: The RPC method 'wallet_watchAsset' is experimental for ERC721/ERC1155 assets and may change in the future.\nFor more information, see: https://github.com/MetaMask/metamask-improvement-proposals/blob/main/MIPs/mip-1.md and https://github.com/MetaMask/metamask-improvement-proposals/blob/main/PROCESS-GUIDE.md#proposal-lifecycle"
        },
        experimentalMethods: "MetaMask: 'ethereum._metamask' exposes non-standard, experimental methods. They may be removed or changed without warning."
      }
    },
    MS = kS;
  function CS(e) {
    const t = {
      ethDecryptDeprecation: !1,
      ethGetEncryptionPublicKeyDeprecation: !1,
      walletWatchAssetNFTExperimental: !1
    };
    return (n, r, i) => {
      t.ethDecryptDeprecation || "eth_decrypt" !== n.method ? t.ethGetEncryptionPublicKeyDeprecation || "eth_getEncryptionPublicKey" !== n.method ? !t.walletWatchAssetNFTExperimental && "wallet_watchAsset" === n.method && [ES, SS].includes(n.params?.type || "") && (e.warn(MS.warnings.rpc.walletWatchAssetNFTExperimental), t.walletWatchAssetNFTExperimental = !0) : (e.warn(MS.warnings.rpc.ethGetEncryptionPublicKeyDeprecation), t.ethGetEncryptionPublicKeyDeprecation = !0) : (e.warn(MS.warnings.rpc.ethDecryptDeprecation), t.ethDecryptDeprecation = !0), i();
    };
  }
  var xS = {},
    RS = {},
    IS = n && n.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }
        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            o(e);
          }
        }
        function u(e) {
          e.done ? i(e.value) : function (e) {
            return e instanceof n ? e : new n(function (t) {
              t(e);
            });
          }(e.value).then(a, s);
        }
        u((r = r.apply(e, t || [])).next());
      });
    };
  Object.defineProperty(RS, "__esModule", {
    value: !0
  }), RS.createAsyncMiddleware = void 0, RS.createAsyncMiddleware = function (e) {
    return (t, n, r, i) => IS(this, void 0, void 0, function* () {
      let o;
      const a = new Promise(e => {
        o = e;
      });
      let s = null,
        u = !1;
      const c = () => IS(this, void 0, void 0, function* () {
        return u = !0, r(e => {
          s = e, o();
        }), a;
      });
      try {
        yield e(t, n, c), u ? (yield a, s(null)) : i(null);
      } catch (e) {
        s ? s(e) : i(e);
      }
    });
  };
  var TS = {};
  Object.defineProperty(TS, "__esModule", {
    value: !0
  }), TS.createScaffoldMiddleware = void 0, TS.createScaffoldMiddleware = function (e) {
    return (t, n, r, i) => {
      const o = e[t.method];
      return void 0 === o ? r() : "function" == typeof o ? o(t, n, r, i) : (n.result = o, i());
    };
  };
  var PS = {};
  Object.defineProperty(PS, "__esModule", {
    value: !0
  }), PS.getUniqueId = void 0;
  const OS = 4294967295;
  let LS = Math.floor(Math.random() * OS);
  PS.getUniqueId = function () {
    return LS = (LS + 1) % OS, LS;
  };
  var NS = {};
  Object.defineProperty(NS, "__esModule", {
    value: !0
  }), NS.createIdRemapMiddleware = void 0;
  const DS = PS;
  NS.createIdRemapMiddleware = function () {
    return (e, t, n, r) => {
      const i = e.id,
        o = (0, DS.getUniqueId)();
      e.id = o, t.id = o, n(n => {
        e.id = i, t.id = i, n();
      });
    };
  };
  var BS = {},
    jS = {},
    FS = {},
    zS = {},
    US = {},
    qS = {};
  Object.defineProperty(qS, "__esModule", {
    value: !0
  });
  qS.errorCodes = {
    rpc: {
      invalidInput: -32e3,
      resourceNotFound: -32001,
      resourceUnavailable: -32002,
      transactionRejected: -32003,
      methodNotSupported: -32004,
      limitExceeded: -32005,
      parse: -32700,
      invalidRequest: -32600,
      methodNotFound: -32601,
      invalidParams: -32602,
      internal: -32603
    },
    provider: {
      userRejectedRequest: 4001,
      unauthorized: 4100,
      unsupportedMethod: 4200,
      disconnected: 4900,
      chainDisconnected: 4901
    }
  }, qS.errorValues = {
    "-32700": {
      standard: "JSON RPC 2.0",
      message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    },
    "-32600": {
      standard: "JSON RPC 2.0",
      message: "The JSON sent is not a valid Request object."
    },
    "-32601": {
      standard: "JSON RPC 2.0",
      message: "The method does not exist / is not available."
    },
    "-32602": {
      standard: "JSON RPC 2.0",
      message: "Invalid method parameter(s)."
    },
    "-32603": {
      standard: "JSON RPC 2.0",
      message: "Internal JSON-RPC error."
    },
    "-32000": {
      standard: "EIP-1474",
      message: "Invalid input."
    },
    "-32001": {
      standard: "EIP-1474",
      message: "Resource not found."
    },
    "-32002": {
      standard: "EIP-1474",
      message: "Resource unavailable."
    },
    "-32003": {
      standard: "EIP-1474",
      message: "Transaction rejected."
    },
    "-32004": {
      standard: "EIP-1474",
      message: "Method not supported."
    },
    "-32005": {
      standard: "EIP-1474",
      message: "Request limit exceeded."
    },
    4001: {
      standard: "EIP-1193",
      message: "User rejected the request."
    },
    4100: {
      standard: "EIP-1193",
      message: "The requested account and/or method has not been authorized by the user."
    },
    4200: {
      standard: "EIP-1193",
      message: "The requested method is not supported by this Ethereum provider."
    },
    4900: {
      standard: "EIP-1193",
      message: "The provider is disconnected from all chains."
    },
    4901: {
      standard: "EIP-1193",
      message: "The provider is disconnected from the specified chain."
    }
  };
  var KS = {},
    HS = {},
    VS = {},
    $S = {},
    WS = {},
    YS = {};
  Object.defineProperty(YS, "__esModule", {
    value: !0
  });
  var GS = (e => (e[e.Null = 4] = "Null", e[e.Comma = 1] = "Comma", e[e.Wrapper = 1] = "Wrapper", e[e.True = 4] = "True", e[e.False = 5] = "False", e[e.Quote = 1] = "Quote", e[e.Colon = 1] = "Colon", e[e.Date = 24] = "Date", e))(GS || {}),
    QS = /"|\\|\n|\r|\t/gu;
  function ZS(e) {
    return e.charCodeAt(0) <= 127;
  }
  YS.isNonEmptyArray = function (e) {
    return Array.isArray(e) && e.length > 0;
  }, YS.isNullOrUndefined = function (e) {
    return null == e;
  }, YS.isObject = function (e) {
    return Boolean(e) && "object" == typeof e && !Array.isArray(e);
  }, YS.hasProperty = (e, t) => Object.hasOwnProperty.call(e, t), YS.getKnownPropertyNames = function (e) {
    return Object.getOwnPropertyNames(e);
  }, YS.JsonSize = GS, YS.ESCAPE_CHARACTERS_REGEXP = QS, YS.isPlainObject = function (e) {
    if ("object" != typeof e || null === e) return !1;
    try {
      let t = e;
      for (; null !== Object.getPrototypeOf(t);) t = Object.getPrototypeOf(t);
      return Object.getPrototypeOf(e) === t;
    } catch (e) {
      return !1;
    }
  }, YS.isASCII = ZS, YS.calculateStringSize = function (e) {
    return e.split("").reduce((e, t) => ZS(t) ? e + 1 : e + 2, 0) + (t = e.match(QS), n = () => [], null != t ? t : n()).length;
    var t, n;
  }, YS.calculateNumberSize = function (e) {
    return e.toString().length;
  };
  let JS = class e extends Error {
    constructor(t, {
      cause: n
    } = {}) {
      super(t), this.name = e.name, n && (this.cause = n), this.message = t;
    }
  };
  var XS = i(Object.freeze({
    __proto__: null,
    ErrorWithCause: JS
  }));
  const ek = e => {
      if (e && "object" == typeof e && "cause" in e) {
        if ("function" == typeof e.cause) {
          const t = e.cause();
          return t instanceof Error ? t : void 0;
        }
        return e.cause instanceof Error ? e.cause : void 0;
      }
    },
    tk = (e, t) => {
      if (!(e instanceof Error)) return "";
      const n = e.stack || "";
      if (t.has(e)) return n + "\ncauses have become circular...";
      const r = ek(e);
      return r ? (t.add(e), n + "\ncaused by: " + tk(r, t)) : n;
    },
    nk = (e, t, n) => {
      if (!(e instanceof Error)) return "";
      const r = n ? "" : e.message || "";
      if (t.has(e)) return r + ": ...";
      const i = ek(e);
      if (i) {
        t.add(e);
        const n = "cause" in e && "function" == typeof e.cause;
        return r + (n ? "" : ": ") + nk(i, t, n);
      }
      return r;
    };
  var rk = i(Object.freeze({
    __proto__: null,
    findCauseByReference: (e, t) => {
      if (!e || !t) return;
      if (!(e instanceof Error)) return;
      if (!(t.prototype instanceof Error) && t !== Error) return;
      const n = new Set();
      let r = e;
      for (; r && !n.has(r);) {
        if (n.add(r), r instanceof t) return r;
        r = ek(r);
      }
    },
    getErrorCause: ek,
    messageWithCauses: e => nk(e, new Set()),
    stackWithCauses: e => tk(e, new Set())
  }));
  const {
      ErrorWithCause: ik
    } = XS,
    {
      findCauseByReference: ok,
      getErrorCause: ak,
      messageWithCauses: sk,
      stackWithCauses: uk
    } = rk;
  var ck = {
    ErrorWithCause: ik,
    findCauseByReference: ok,
    getErrorCause: ak,
    stackWithCauses: uk,
    messageWithCauses: sk
  };
  Object.defineProperty(WS, "__esModule", {
    value: !0
  });
  var lk = YS,
    dk = ck;
  function fk(e) {
    return "object" == typeof e && null !== e && "code" in e;
  }
  function hk(e) {
    return "object" == typeof e && null !== e && "message" in e;
  }
  WS.isErrorWithCode = fk, WS.isErrorWithMessage = hk, WS.isErrorWithStack = function (e) {
    return "object" == typeof e && null !== e && "stack" in e;
  }, WS.getErrorMessage = function (e) {
    return hk(e) && "string" == typeof e.message ? e.message : lk.isNullOrUndefined.call(void 0, e) ? "" : String(e);
  }, WS.wrapError = function (e, t) {
    if ((n = e) instanceof Error || lk.isObject.call(void 0, n) && "Error" === n.constructor.name) {
      let n;
      return n = 2 === Error.length ? new Error(t, {
        cause: e
      }) : new dk.ErrorWithCause(t, {
        cause: e
      }), fk(e) && (n.code = e.code), n;
    }
    var n;
    return t.length > 0 ? new Error(`${String(e)}: ${t}`) : new Error(String(e));
  };
  class pk extends TypeError {
    constructor(e, t) {
      let n;
      const {
          message: r,
          explanation: i,
          ...o
        } = e,
        {
          path: a
        } = e,
        s = 0 === a.length ? r : `At path: ${a.join(".")} -- ${r}`;
      super(i ?? s), null != i && (this.cause = s), Object.assign(this, o), this.name = this.constructor.name, this.failures = () => n ?? (n = [e, ...t()]);
    }
  }
  function mk(e) {
    return "object" == typeof e && null != e;
  }
  function gk(e) {
    if ("[object Object]" !== Object.prototype.toString.call(e)) return !1;
    const t = Object.getPrototypeOf(e);
    return null === t || t === Object.prototype;
  }
  function vk(e) {
    return "symbol" == typeof e ? e.toString() : "string" == typeof e ? JSON.stringify(e) : `${e}`;
  }
  function bk(e, t, n, r) {
    if (!0 === e) return;
    !1 === e ? e = {} : "string" == typeof e && (e = {
      message: e
    });
    const {
        path: i,
        branch: o
      } = t,
      {
        type: a
      } = n,
      {
        refinement: s,
        message: u = `Expected a value of type \`${a}\`${s ? ` with refinement \`${s}\`` : ""}, but received: \`${vk(r)}\``
      } = e;
    return {
      value: r,
      type: a,
      refinement: s,
      key: i[i.length - 1],
      path: i,
      branch: o,
      ...e,
      message: u
    };
  }
  function* yk(e, t, n, r) {
    (function (e) {
      return mk(e) && "function" == typeof e[Symbol.iterator];
    })(e) || (e = [e]);
    for (const i of e) {
      const e = bk(i, t, n, r);
      e && (yield e);
    }
  }
  function* wk(e, t, n = {}) {
    const {
        path: r = [],
        branch: i = [e],
        coerce: o = !1,
        mask: a = !1
      } = n,
      s = {
        path: r,
        branch: i
      };
    if (o && (e = t.coercer(e, s), a && "type" !== t.type && mk(t.schema) && mk(e) && !Array.isArray(e))) for (const n in e) void 0 === t.schema[n] && delete e[n];
    let u = "valid";
    for (const r of t.validator(e, s)) r.explanation = n.message, u = "not_valid", yield [r, void 0];
    for (let [c, l, d] of t.entries(e, s)) {
      const t = wk(l, d, {
        path: void 0 === c ? r : [...r, c],
        branch: void 0 === c ? i : [...i, l],
        coerce: o,
        mask: a,
        message: n.message
      });
      for (const n of t) n[0] ? (u = null != n[0].refinement ? "not_refined" : "not_valid", yield [n[0], void 0]) : o && (l = n[1], void 0 === c ? e = l : e instanceof Map ? e.set(c, l) : e instanceof Set ? e.add(l) : mk(e) && (void 0 !== l || c in e) && (e[c] = l));
    }
    if ("not_valid" !== u) for (const r of t.refiner(e, s)) r.explanation = n.message, u = "not_refined", yield [r, void 0];
    "valid" === u && (yield [void 0, e]);
  }
  class Ak {
    constructor(e) {
      const {
        type: t,
        schema: n,
        validator: r,
        refiner: i,
        coercer: o = e => e,
        entries: a = function* () {}
      } = e;
      this.type = t, this.schema = n, this.entries = a, this.coercer = o, this.validator = r ? (e, t) => yk(r(e, t), t, this, e) : () => [], this.refiner = i ? (e, t) => yk(i(e, t), t, this, e) : () => [];
    }
    assert(e, t) {
      return _k(e, this, t);
    }
    create(e, t) {
      return Ek(e, this, t);
    }
    is(e) {
      return kk(e, this);
    }
    mask(e, t) {
      return Sk(e, this, t);
    }
    validate(e, t = {}) {
      return Mk(e, this, t);
    }
  }
  function _k(e, t, n) {
    const r = Mk(e, t, {
      message: n
    });
    if (r[0]) throw r[0];
  }
  function Ek(e, t, n) {
    const r = Mk(e, t, {
      coerce: !0,
      message: n
    });
    if (r[0]) throw r[0];
    return r[1];
  }
  function Sk(e, t, n) {
    const r = Mk(e, t, {
      coerce: !0,
      mask: !0,
      message: n
    });
    if (r[0]) throw r[0];
    return r[1];
  }
  function kk(e, t) {
    return !Mk(e, t)[0];
  }
  function Mk(e, t, n = {}) {
    const r = wk(e, t, n),
      i = function (e) {
        const {
          done: t,
          value: n
        } = e.next();
        return t ? void 0 : n;
      }(r);
    if (i[0]) {
      const e = new pk(i[0], function* () {
        for (const e of r) e[0] && (yield e[0]);
      });
      return [e, void 0];
    }
    return [void 0, i[1]];
  }
  function Ck(e, t) {
    return new Ak({
      type: e,
      schema: null,
      validator: t
    });
  }
  function xk(e) {
    let t;
    return new Ak({
      type: "lazy",
      schema: null,
      *entries(n, r) {
        t ?? (t = e()), yield* t.entries(n, r);
      },
      validator: (n, r) => (t ?? (t = e()), t.validator(n, r)),
      coercer: (n, r) => (t ?? (t = e()), t.coercer(n, r)),
      refiner: (n, r) => (t ?? (t = e()), t.refiner(n, r))
    });
  }
  function Rk() {
    return Ck("any", () => !0);
  }
  function Ik(e) {
    return new Ak({
      type: "array",
      schema: e,
      *entries(t) {
        if (e && Array.isArray(t)) for (const [n, r] of t.entries()) yield [n, r, e];
      },
      coercer: e => Array.isArray(e) ? e.slice() : e,
      validator: e => Array.isArray(e) || `Expected an array value, but received: ${vk(e)}`
    });
  }
  function Tk() {
    return Ck("boolean", e => "boolean" == typeof e);
  }
  function Pk() {
    return Ck("integer", e => "number" == typeof e && !isNaN(e) && Number.isInteger(e) || `Expected an integer, but received: ${vk(e)}`);
  }
  function Ok(e) {
    const t = vk(e),
      n = typeof e;
    return new Ak({
      type: "literal",
      schema: "string" === n || "number" === n || "boolean" === n ? e : null,
      validator: n => n === e || `Expected the literal \`${t}\`, but received: ${vk(n)}`
    });
  }
  function Lk() {
    return Ck("never", () => !1);
  }
  function Nk(e) {
    return new Ak({
      ...e,
      validator: (t, n) => null === t || e.validator(t, n),
      refiner: (t, n) => null === t || e.refiner(t, n)
    });
  }
  function Dk() {
    return Ck("number", e => "number" == typeof e && !isNaN(e) || `Expected a number, but received: ${vk(e)}`);
  }
  function Bk(e) {
    const t = e ? Object.keys(e) : [],
      n = Lk();
    return new Ak({
      type: "object",
      schema: e || null,
      *entries(r) {
        if (e && mk(r)) {
          const i = new Set(Object.keys(r));
          for (const n of t) i.delete(n), yield [n, r[n], e[n]];
          for (const e of i) yield [e, r[e], n];
        }
      },
      validator: e => mk(e) || `Expected an object, but received: ${vk(e)}`,
      coercer: e => mk(e) ? {
        ...e
      } : e
    });
  }
  function jk(e) {
    return new Ak({
      ...e,
      validator: (t, n) => void 0 === t || e.validator(t, n),
      refiner: (t, n) => void 0 === t || e.refiner(t, n)
    });
  }
  function Fk(e, t) {
    return new Ak({
      type: "record",
      schema: null,
      *entries(n) {
        if (mk(n)) for (const r in n) {
          const i = n[r];
          yield [r, r, e], yield [r, i, t];
        }
      },
      validator: e => mk(e) || `Expected an object, but received: ${vk(e)}`
    });
  }
  function zk() {
    return Ck("string", e => "string" == typeof e || `Expected a string, but received: ${vk(e)}`);
  }
  function Uk(e) {
    const t = Object.keys(e);
    return new Ak({
      type: "type",
      schema: e,
      *entries(n) {
        if (mk(n)) for (const r of t) yield [r, n[r], e[r]];
      },
      validator: e => mk(e) || `Expected an object, but received: ${vk(e)}`,
      coercer: e => mk(e) ? {
        ...e
      } : e
    });
  }
  function qk(e) {
    const t = e.map(e => e.type).join(" | ");
    return new Ak({
      type: "union",
      schema: null,
      coercer(t) {
        for (const n of e) {
          const [e, r] = n.validate(t, {
            coerce: !0
          });
          if (!e) return r;
        }
        return t;
      },
      validator(n, r) {
        const i = [];
        for (const t of e) {
          const [...e] = wk(n, t, r),
            [o] = e;
          if (!o[0]) return [];
          for (const [t] of e) t && i.push(t);
        }
        return [`Expected the value to satisfy a union of \`${t}\`, but received: ${vk(n)}`, ...i];
      }
    });
  }
  function Kk() {
    return Ck("unknown", () => !0);
  }
  function Hk(e, t, n) {
    return new Ak({
      ...e,
      coercer: (r, i) => kk(r, t) ? e.coercer(n(r, i), i) : e.coercer(r, i)
    });
  }
  function Vk(e) {
    return e instanceof Map || e instanceof Set ? e.size : e.length;
  }
  function $k(e, t, n) {
    return new Ak({
      ...e,
      *refiner(r, i) {
        yield* e.refiner(r, i);
        const o = yk(n(r, i), i, e, r);
        for (const e of o) yield {
          ...e,
          refinement: t
        };
      }
    });
  }
  var Wk = Object.freeze({
      __proto__: null,
      Struct: Ak,
      StructError: pk,
      any: Rk,
      array: Ik,
      assert: _k,
      assign: function (...e) {
        const t = "type" === e[0].type,
          n = e.map(e => e.schema),
          r = Object.assign({}, ...n);
        return t ? Uk(r) : Bk(r);
      },
      bigint: function () {
        return Ck("bigint", e => "bigint" == typeof e);
      },
      boolean: Tk,
      coerce: Hk,
      create: Ek,
      date: function () {
        return Ck("date", e => e instanceof Date && !isNaN(e.getTime()) || `Expected a valid \`Date\` object, but received: ${vk(e)}`);
      },
      defaulted: function (e, t, n = {}) {
        return Hk(e, Kk(), e => {
          const r = "function" == typeof t ? t() : t;
          if (void 0 === e) return r;
          if (!n.strict && gk(e) && gk(r)) {
            const t = {
              ...e
            };
            let n = !1;
            for (const e in r) void 0 === t[e] && (t[e] = r[e], n = !0);
            if (n) return t;
          }
          return e;
        });
      },
      define: Ck,
      deprecated: function (e, t) {
        return new Ak({
          ...e,
          refiner: (t, n) => void 0 === t || e.refiner(t, n),
          validator: (n, r) => void 0 === n || (t(n, r), e.validator(n, r))
        });
      },
      dynamic: function (e) {
        return new Ak({
          type: "dynamic",
          schema: null,
          *entries(t, n) {
            const r = e(t, n);
            yield* r.entries(t, n);
          },
          validator: (t, n) => e(t, n).validator(t, n),
          coercer: (t, n) => e(t, n).coercer(t, n),
          refiner: (t, n) => e(t, n).refiner(t, n)
        });
      },
      empty: function (e) {
        return $k(e, "empty", t => {
          const n = Vk(t);
          return 0 === n || `Expected an empty ${e.type} but received one with a size of \`${n}\``;
        });
      },
      enums: function (e) {
        const t = {},
          n = e.map(e => vk(e)).join();
        for (const n of e) t[n] = n;
        return new Ak({
          type: "enums",
          schema: t,
          validator: t => e.includes(t) || `Expected one of \`${n}\`, but received: ${vk(t)}`
        });
      },
      func: function () {
        return Ck("func", e => "function" == typeof e || `Expected a function, but received: ${vk(e)}`);
      },
      instance: function (e) {
        return Ck("instance", t => t instanceof e || `Expected a \`${e.name}\` instance, but received: ${vk(t)}`);
      },
      integer: Pk,
      intersection: function (e) {
        return new Ak({
          type: "intersection",
          schema: null,
          *entries(t, n) {
            for (const r of e) yield* r.entries(t, n);
          },
          *validator(t, n) {
            for (const r of e) yield* r.validator(t, n);
          },
          *refiner(t, n) {
            for (const r of e) yield* r.refiner(t, n);
          }
        });
      },
      is: kk,
      lazy: xk,
      literal: Ok,
      map: function (e, t) {
        return new Ak({
          type: "map",
          schema: null,
          *entries(n) {
            if (e && t && n instanceof Map) for (const [r, i] of n.entries()) yield [r, r, e], yield [r, i, t];
          },
          coercer: e => e instanceof Map ? new Map(e) : e,
          validator: e => e instanceof Map || `Expected a \`Map\` object, but received: ${vk(e)}`
        });
      },
      mask: Sk,
      max: function (e, t, n = {}) {
        const {
          exclusive: r
        } = n;
        return $k(e, "max", n => r ? n < t : n <= t || `Expected a ${e.type} less than ${r ? "" : "or equal to "}${t} but received \`${n}\``);
      },
      min: function (e, t, n = {}) {
        const {
          exclusive: r
        } = n;
        return $k(e, "min", n => r ? n > t : n >= t || `Expected a ${e.type} greater than ${r ? "" : "or equal to "}${t} but received \`${n}\``);
      },
      never: Lk,
      nonempty: function (e) {
        return $k(e, "nonempty", t => Vk(t) > 0 || `Expected a nonempty ${e.type} but received an empty one`);
      },
      nullable: Nk,
      number: Dk,
      object: Bk,
      omit: function (e, t) {
        const {
            schema: n
          } = e,
          r = {
            ...n
          };
        for (const e of t) delete r[e];
        return "type" === e.type ? Uk(r) : Bk(r);
      },
      optional: jk,
      partial: function (e) {
        const t = e instanceof Ak ? {
          ...e.schema
        } : {
          ...e
        };
        for (const e in t) t[e] = jk(t[e]);
        return Bk(t);
      },
      pattern: function (e, t) {
        return $k(e, "pattern", n => t.test(n) || `Expected a ${e.type} matching \`/${t.source}/\` but received "${n}"`);
      },
      pick: function (e, t) {
        const {
            schema: n
          } = e,
          r = {};
        for (const e of t) r[e] = n[e];
        return Bk(r);
      },
      record: Fk,
      refine: $k,
      regexp: function () {
        return Ck("regexp", e => e instanceof RegExp);
      },
      set: function (e) {
        return new Ak({
          type: "set",
          schema: null,
          *entries(t) {
            if (e && t instanceof Set) for (const n of t) yield [n, n, e];
          },
          coercer: e => e instanceof Set ? new Set(e) : e,
          validator: e => e instanceof Set || `Expected a \`Set\` object, but received: ${vk(e)}`
        });
      },
      size: function (e, t, n = t) {
        const r = `Expected a ${e.type}`,
          i = t === n ? `of \`${t}\`` : `between \`${t}\` and \`${n}\``;
        return $k(e, "size", e => {
          if ("number" == typeof e || e instanceof Date) return t <= e && e <= n || `${r} ${i} but received \`${e}\``;
          if (e instanceof Map || e instanceof Set) {
            const {
              size: o
            } = e;
            return t <= o && o <= n || `${r} with a size ${i} but received one with a size of \`${o}\``;
          }
          {
            const {
              length: o
            } = e;
            return t <= o && o <= n || `${r} with a length ${i} but received one with a length of \`${o}\``;
          }
        });
      },
      string: zk,
      struct: function (e, t) {
        return console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`."), Ck(e, t);
      },
      trimmed: function (e) {
        return Hk(e, zk(), e => e.trim());
      },
      tuple: function (e) {
        const t = Lk();
        return new Ak({
          type: "tuple",
          schema: null,
          *entries(n) {
            if (Array.isArray(n)) {
              const r = Math.max(e.length, n.length);
              for (let i = 0; i < r; i++) yield [i, n[i], e[i] || t];
            }
          },
          validator: e => Array.isArray(e) || `Expected an array, but received: ${vk(e)}`
        });
      },
      type: Uk,
      union: qk,
      unknown: Kk,
      validate: Mk
    }),
    Yk = i(Wk);
  Object.defineProperty($S, "__esModule", {
    value: !0
  });
  var Gk = WS,
    Qk = Yk;
  function Zk(e, t) {
    return Boolean("string" == typeof function (e) {
      let t,
        n = e[0],
        r = 1;
      for (; r < e.length;) {
        const i = e[r],
          o = e[r + 1];
        if (r += 2, ("optionalAccess" === i || "optionalCall" === i) && null == n) return;
        "access" === i || "optionalAccess" === i ? (t = n, n = o(n)) : "call" !== i && "optionalCall" !== i || (n = o((...e) => n.call(t, ...e)), t = void 0);
      }
      return n;
    }([e, "optionalAccess", e => e.prototype, "optionalAccess", e => e.constructor, "optionalAccess", e => e.name])) ? new e({
      message: t
    }) : e({
      message: t
    });
  }
  var Jk = class extends Error {
    constructor(e) {
      super(e.message), this.code = "ERR_ASSERTION";
    }
  };
  $S.AssertionError = Jk, $S.assert = function (e, t = "Assertion failed.", n = Jk) {
    if (!e) {
      if (t instanceof Error) throw t;
      throw Zk(n, t);
    }
  }, $S.assertStruct = function (e, t, n = "Assertion failed", r = Jk) {
    try {
      Qk.assert.call(void 0, e, t);
    } catch (e) {
      throw Zk(r, `${n}: ${function (e) {
        return Gk.getErrorMessage.call(void 0, e).replace(/\.$/u, "");
      }(e)}.`);
    }
  }, $S.assertExhaustive = function (e) {
    throw new Error("Invalid branch reached. Should be detected during compilation.");
  };
  var Xk = {},
    eM = {};
  function tM(e) {
    if (!Number.isSafeInteger(e) || e < 0) throw new Error(`Wrong positive integer: ${e}`);
  }
  function nM(e) {
    if ("boolean" != typeof e) throw new Error(`Expected boolean, not ${e}`);
  }
  function rM(e, ...t) {
    if (!(e instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (t.length > 0 && !t.includes(e.length)) throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
  }
  function iM(e) {
    if ("function" != typeof e || "function" != typeof e.create) throw new Error("Hash should be wrapped by utils.wrapConstructor");
    tM(e.outputLen), tM(e.blockLen);
  }
  function oM(e, t = !0) {
    if (e.destroyed) throw new Error("Hash instance has been destroyed");
    if (t && e.finished) throw new Error("Hash#digest() has already been called");
  }
  function aM(e, t) {
    rM(e);
    const n = t.outputLen;
    if (e.length < n) throw new Error(`digestInto() expects output buffer of length at least ${n}`);
  }
  Object.defineProperty(eM, "__esModule", {
    value: !0
  }), eM.output = eM.exists = eM.hash = eM.bytes = eM.bool = eM.number = void 0, eM.number = tM, eM.bool = nM, eM.bytes = rM, eM.hash = iM, eM.exists = oM, eM.output = aM;
  const sM = {
    number: tM,
    bool: nM,
    bytes: rM,
    hash: iM,
    exists: oM,
    output: aM
  };
  eM.default = sM;
  var uM = {};
  Object.defineProperty(uM, "__esModule", {
    value: !0
  }), uM.add5L = uM.add5H = uM.add4H = uM.add4L = uM.add3H = uM.add3L = uM.add = uM.rotlBL = uM.rotlBH = uM.rotlSL = uM.rotlSH = uM.rotr32L = uM.rotr32H = uM.rotrBL = uM.rotrBH = uM.rotrSL = uM.rotrSH = uM.shrSL = uM.shrSH = uM.toBig = uM.split = uM.fromBig = void 0;
  const cM = BigInt(2 ** 32 - 1),
    lM = BigInt(32);
  function dM(e, t = !1) {
    return t ? {
      h: Number(e & cM),
      l: Number(e >> lM & cM)
    } : {
      h: 0 | Number(e >> lM & cM),
      l: 0 | Number(e & cM)
    };
  }
  function fM(e, t = !1) {
    let n = new Uint32Array(e.length),
      r = new Uint32Array(e.length);
    for (let i = 0; i < e.length; i++) {
      const {
        h: o,
        l: a
      } = dM(e[i], t);
      [n[i], r[i]] = [o, a];
    }
    return [n, r];
  }
  uM.fromBig = dM, uM.split = fM;
  const hM = (e, t) => BigInt(e >>> 0) << lM | BigInt(t >>> 0);
  uM.toBig = hM;
  const pM = (e, t, n) => e >>> n;
  uM.shrSH = pM;
  const mM = (e, t, n) => e << 32 - n | t >>> n;
  uM.shrSL = mM;
  const gM = (e, t, n) => e >>> n | t << 32 - n;
  uM.rotrSH = gM;
  const vM = (e, t, n) => e << 32 - n | t >>> n;
  uM.rotrSL = vM;
  const bM = (e, t, n) => e << 64 - n | t >>> n - 32;
  uM.rotrBH = bM;
  const yM = (e, t, n) => e >>> n - 32 | t << 64 - n;
  uM.rotrBL = yM;
  const wM = (e, t) => t;
  uM.rotr32H = wM;
  const AM = (e, t) => e;
  uM.rotr32L = AM;
  const _M = (e, t, n) => e << n | t >>> 32 - n;
  uM.rotlSH = _M;
  const EM = (e, t, n) => t << n | e >>> 32 - n;
  uM.rotlSL = EM;
  const SM = (e, t, n) => t << n - 32 | e >>> 64 - n;
  uM.rotlBH = SM;
  const kM = (e, t, n) => e << n - 32 | t >>> 64 - n;
  function MM(e, t, n, r) {
    const i = (t >>> 0) + (r >>> 0);
    return {
      h: e + n + (i / 2 ** 32 | 0) | 0,
      l: 0 | i
    };
  }
  uM.rotlBL = kM, uM.add = MM;
  const CM = (e, t, n) => (e >>> 0) + (t >>> 0) + (n >>> 0);
  uM.add3L = CM;
  const xM = (e, t, n, r) => t + n + r + (e / 2 ** 32 | 0) | 0;
  uM.add3H = xM;
  const RM = (e, t, n, r) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0);
  uM.add4L = RM;
  const IM = (e, t, n, r, i) => t + n + r + i + (e / 2 ** 32 | 0) | 0;
  uM.add4H = IM;
  const TM = (e, t, n, r, i) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0) + (i >>> 0);
  uM.add5L = TM;
  const PM = (e, t, n, r, i, o) => t + n + r + i + o + (e / 2 ** 32 | 0) | 0;
  uM.add5H = PM;
  const OM = {
    fromBig: dM,
    split: fM,
    toBig: hM,
    shrSH: pM,
    shrSL: mM,
    rotrSH: gM,
    rotrSL: vM,
    rotrBH: bM,
    rotrBL: yM,
    rotr32H: wM,
    rotr32L: AM,
    rotlSH: _M,
    rotlSL: EM,
    rotlBH: SM,
    rotlBL: kM,
    add: MM,
    add3L: CM,
    add3H: xM,
    add4L: RM,
    add4H: IM,
    add5H: PM,
    add5L: TM
  };
  uM.default = OM;
  var LM = {},
    NM = {};
  Object.defineProperty(NM, "__esModule", {
    value: !0
  }), NM.crypto = void 0, NM.crypto = "object" == typeof globalThis && "crypto" in globalThis ? globalThis.crypto : void 0, function (e) {
    /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.randomBytes = e.wrapXOFConstructorWithOpts = e.wrapConstructorWithOpts = e.wrapConstructor = e.checkOpts = e.Hash = e.concatBytes = e.toBytes = e.utf8ToBytes = e.asyncLoop = e.nextTick = e.hexToBytes = e.bytesToHex = e.isLE = e.rotr = e.createView = e.u32 = e.u8 = void 0;
    const t = NM,
      n = e => e instanceof Uint8Array;
    e.u8 = e => new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
    e.u32 = e => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4));
    e.createView = e => new DataView(e.buffer, e.byteOffset, e.byteLength);
    if (e.rotr = (e, t) => e << 32 - t | e >>> t, e.isLE = 68 === new Uint8Array(new Uint32Array([287454020]).buffer)[0], !e.isLE) throw new Error("Non little-endian hardware is not supported");
    const r = Array.from({
      length: 256
    }, (e, t) => t.toString(16).padStart(2, "0"));
    e.bytesToHex = function (e) {
      if (!n(e)) throw new Error("Uint8Array expected");
      let t = "";
      for (let n = 0; n < e.length; n++) t += r[e[n]];
      return t;
    }, e.hexToBytes = function (e) {
      if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
      const t = e.length;
      if (t % 2) throw new Error("padded hex string expected, got unpadded hex of length " + t);
      const n = new Uint8Array(t / 2);
      for (let t = 0; t < n.length; t++) {
        const r = 2 * t,
          i = e.slice(r, r + 2),
          o = Number.parseInt(i, 16);
        if (Number.isNaN(o) || o < 0) throw new Error("Invalid byte sequence");
        n[t] = o;
      }
      return n;
    };
    function i(e) {
      if ("string" != typeof e) throw new Error("utf8ToBytes expected string, got " + typeof e);
      return new Uint8Array(new TextEncoder().encode(e));
    }
    function o(e) {
      if ("string" == typeof e && (e = i(e)), !n(e)) throw new Error("expected Uint8Array, got " + typeof e);
      return e;
    }
    e.nextTick = async () => {}, e.asyncLoop = async function (t, n, r) {
      let i = Date.now();
      for (let o = 0; o < t; o++) {
        r(o);
        const t = Date.now() - i;
        t >= 0 && t < n || (await (0, e.nextTick)(), i += t);
      }
    }, e.utf8ToBytes = i, e.toBytes = o, e.concatBytes = function (...e) {
      const t = new Uint8Array(e.reduce((e, t) => e + t.length, 0));
      let r = 0;
      return e.forEach(e => {
        if (!n(e)) throw new Error("Uint8Array expected");
        t.set(e, r), r += e.length;
      }), t;
    };
    e.Hash = class {
      clone() {
        return this._cloneInto();
      }
    };
    const a = {}.toString;
    e.checkOpts = function (e, t) {
      if (void 0 !== t && "[object Object]" !== a.call(t)) throw new Error("Options should be object or undefined");
      return Object.assign(e, t);
    }, e.wrapConstructor = function (e) {
      const t = t => e().update(o(t)).digest(),
        n = e();
      return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
    }, e.wrapConstructorWithOpts = function (e) {
      const t = (t, n) => e(n).update(o(t)).digest(),
        n = e({});
      return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = t => e(t), t;
    }, e.wrapXOFConstructorWithOpts = function (e) {
      const t = (t, n) => e(n).update(o(t)).digest(),
        n = e({});
      return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = t => e(t), t;
    }, e.randomBytes = function (e = 32) {
      if (t.crypto && "function" == typeof t.crypto.getRandomValues) return t.crypto.getRandomValues(new Uint8Array(e));
      throw new Error("crypto.getRandomValues must be defined");
    };
  }(LM), Object.defineProperty(Xk, "__esModule", {
    value: !0
  }), Xk.shake256 = Xk.shake128 = Xk.keccak_512 = Xk.keccak_384 = Xk.keccak_256 = Xk.keccak_224 = Xk.sha3_512 = Xk.sha3_384 = Xk.sha3_256 = Xk.sha3_224 = Xk.Keccak = Xk.keccakP = void 0;
  const DM = eM,
    BM = uM,
    jM = LM,
    [FM, zM, UM] = [[], [], []],
    qM = BigInt(0),
    KM = BigInt(1),
    HM = BigInt(2),
    VM = BigInt(7),
    $M = BigInt(256),
    WM = BigInt(113);
  for (let e = 0, t = KM, n = 1, r = 0; e < 24; e++) {
    [n, r] = [r, (2 * n + 3 * r) % 5], FM.push(2 * (5 * r + n)), zM.push((e + 1) * (e + 2) / 2 % 64);
    let i = qM;
    for (let e = 0; e < 7; e++) t = (t << KM ^ (t >> VM) * WM) % $M, t & HM && (i ^= KM << (KM << BigInt(e)) - KM);
    UM.push(i);
  }
  const [YM, GM] = (0, BM.split)(UM, !0),
    QM = (e, t, n) => n > 32 ? (0, BM.rotlBH)(e, t, n) : (0, BM.rotlSH)(e, t, n),
    ZM = (e, t, n) => n > 32 ? (0, BM.rotlBL)(e, t, n) : (0, BM.rotlSL)(e, t, n);
  function JM(e, t = 24) {
    const n = new Uint32Array(10);
    for (let r = 24 - t; r < 24; r++) {
      for (let t = 0; t < 10; t++) n[t] = e[t] ^ e[t + 10] ^ e[t + 20] ^ e[t + 30] ^ e[t + 40];
      for (let t = 0; t < 10; t += 2) {
        const r = (t + 8) % 10,
          i = (t + 2) % 10,
          o = n[i],
          a = n[i + 1],
          s = QM(o, a, 1) ^ n[r],
          u = ZM(o, a, 1) ^ n[r + 1];
        for (let n = 0; n < 50; n += 10) e[t + n] ^= s, e[t + n + 1] ^= u;
      }
      let t = e[2],
        i = e[3];
      for (let n = 0; n < 24; n++) {
        const r = zM[n],
          o = QM(t, i, r),
          a = ZM(t, i, r),
          s = FM[n];
        t = e[s], i = e[s + 1], e[s] = o, e[s + 1] = a;
      }
      for (let t = 0; t < 50; t += 10) {
        for (let r = 0; r < 10; r++) n[r] = e[t + r];
        for (let r = 0; r < 10; r++) e[t + r] ^= ~n[(r + 2) % 10] & n[(r + 4) % 10];
      }
      e[0] ^= YM[r], e[1] ^= GM[r];
    }
    n.fill(0);
  }
  Xk.keccakP = JM;
  class XM extends jM.Hash {
    constructor(e, t, n, r = !1, i = 24) {
      if (super(), this.blockLen = e, this.suffix = t, this.outputLen = n, this.enableXOF = r, this.rounds = i, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, (0, DM.number)(n), 0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
      this.state = new Uint8Array(200), this.state32 = (0, jM.u32)(this.state);
    }
    keccak() {
      JM(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
    }
    update(e) {
      (0, DM.exists)(this);
      const {
          blockLen: t,
          state: n
        } = this,
        r = (e = (0, jM.toBytes)(e)).length;
      for (let i = 0; i < r;) {
        const o = Math.min(t - this.pos, r - i);
        for (let t = 0; t < o; t++) n[this.pos++] ^= e[i++];
        this.pos === t && this.keccak();
      }
      return this;
    }
    finish() {
      if (this.finished) return;
      this.finished = !0;
      const {
        state: e,
        suffix: t,
        pos: n,
        blockLen: r
      } = this;
      e[n] ^= t, 0 != (128 & t) && n === r - 1 && this.keccak(), e[r - 1] ^= 128, this.keccak();
    }
    writeInto(e) {
      (0, DM.exists)(this, !1), (0, DM.bytes)(e), this.finish();
      const t = this.state,
        {
          blockLen: n
        } = this;
      for (let r = 0, i = e.length; r < i;) {
        this.posOut >= n && this.keccak();
        const o = Math.min(n - this.posOut, i - r);
        e.set(t.subarray(this.posOut, this.posOut + o), r), this.posOut += o, r += o;
      }
      return e;
    }
    xofInto(e) {
      if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
      return this.writeInto(e);
    }
    xof(e) {
      return (0, DM.number)(e), this.xofInto(new Uint8Array(e));
    }
    digestInto(e) {
      if ((0, DM.output)(e, this), this.finished) throw new Error("digest() was already called");
      return this.writeInto(e), this.destroy(), e;
    }
    digest() {
      return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
      this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(e) {
      const {
        blockLen: t,
        suffix: n,
        outputLen: r,
        rounds: i,
        enableXOF: o
      } = this;
      return e || (e = new XM(t, n, r, o, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = n, e.outputLen = r, e.enableXOF = o, e.destroyed = this.destroyed, e;
    }
  }
  Xk.Keccak = XM;
  const eC = (e, t, n) => (0, jM.wrapConstructor)(() => new XM(t, e, n));
  Xk.sha3_224 = eC(6, 144, 28), Xk.sha3_256 = eC(6, 136, 32), Xk.sha3_384 = eC(6, 104, 48), Xk.sha3_512 = eC(6, 72, 64), Xk.keccak_224 = eC(1, 144, 28), Xk.keccak_256 = eC(1, 136, 32), Xk.keccak_384 = eC(1, 104, 48), Xk.keccak_512 = eC(1, 72, 64);
  const tC = (e, t, n) => (0, jM.wrapXOFConstructorWithOpts)((r = {}) => new XM(t, e, void 0 === r.dkLen ? n : r.dkLen, !0));
  Xk.shake128 = tC(31, 168, 16), Xk.shake256 = tC(31, 136, 32);
  var nC = {};
  !function (e) {
    function t(...e) {
      const t = (e, t) => n => e(t(n)),
        n = Array.from(e).reverse().reduce((e, n) => e ? t(e, n.encode) : n.encode, void 0),
        r = e.reduce((e, n) => e ? t(e, n.decode) : n.decode, void 0);
      return {
        encode: n,
        decode: r
      };
    }
    function n(e) {
      return {
        encode: t => {
          if (!Array.isArray(t) || t.length && "number" != typeof t[0]) throw new Error("alphabet.encode input should be an array of numbers");
          return t.map(t => {
            if (t < 0 || t >= e.length) throw new Error(`Digit index outside alphabet: ${t} (alphabet: ${e.length})`);
            return e[t];
          });
        },
        decode: t => {
          if (!Array.isArray(t) || t.length && "string" != typeof t[0]) throw new Error("alphabet.decode input should be array of strings");
          return t.map(t => {
            if ("string" != typeof t) throw new Error(`alphabet.decode: not string element=${t}`);
            const n = e.indexOf(t);
            if (-1 === n) throw new Error(`Unknown letter: "${t}". Allowed: ${e}`);
            return n;
          });
        }
      };
    }
    function r(e = "") {
      if ("string" != typeof e) throw new Error("join separator should be string");
      return {
        encode: t => {
          if (!Array.isArray(t) || t.length && "string" != typeof t[0]) throw new Error("join.encode input should be array of strings");
          for (let e of t) if ("string" != typeof e) throw new Error(`join.encode: non-string input=${e}`);
          return t.join(e);
        },
        decode: t => {
          if ("string" != typeof t) throw new Error("join.decode input should be string");
          return t.split(e);
        }
      };
    }
    function i(e, t = "=") {
      if ("string" != typeof t) throw new Error("padding chr should be string");
      return {
        encode(n) {
          if (!Array.isArray(n) || n.length && "string" != typeof n[0]) throw new Error("padding.encode input should be array of strings");
          for (let e of n) if ("string" != typeof e) throw new Error(`padding.encode: non-string input=${e}`);
          for (; n.length * e % 8;) n.push(t);
          return n;
        },
        decode(n) {
          if (!Array.isArray(n) || n.length && "string" != typeof n[0]) throw new Error("padding.encode input should be array of strings");
          for (let e of n) if ("string" != typeof e) throw new Error(`padding.decode: non-string input=${e}`);
          let r = n.length;
          if (r * e % 8) throw new Error("Invalid padding: string should have whole number of bytes");
          for (; r > 0 && n[r - 1] === t; r--) if (!((r - 1) * e % 8)) throw new Error("Invalid padding: string has too much padding");
          return n.slice(0, r);
        }
      };
    }
    function o(e) {
      if ("function" != typeof e) throw new Error("normalize fn should be function");
      return {
        encode: e => e,
        decode: t => e(t)
      };
    }
    function a(e, t, n) {
      if (t < 2) throw new Error(`convertRadix: wrong from=${t}, base cannot be less than 2`);
      if (n < 2) throw new Error(`convertRadix: wrong to=${n}, base cannot be less than 2`);
      if (!Array.isArray(e)) throw new Error("convertRadix: data should be array");
      if (!e.length) return [];
      let r = 0;
      const i = [],
        o = Array.from(e);
      for (o.forEach(e => {
        if (e < 0 || e >= t) throw new Error(`Wrong integer: ${e}`);
      });;) {
        let e = 0,
          a = !0;
        for (let i = r; i < o.length; i++) {
          const s = o[i],
            u = t * e + s;
          if (!Number.isSafeInteger(u) || t * e / t !== e || u - s != t * e) throw new Error("convertRadix: carry overflow");
          e = u % n;
          const c = Math.floor(u / n);
          if (o[i] = c, !Number.isSafeInteger(c) || c * n + e !== u) throw new Error("convertRadix: carry overflow");
          a && (c ? a = !1 : r = i);
        }
        if (i.push(e), a) break;
      }
      for (let t = 0; t < e.length - 1 && 0 === e[t]; t++) i.push(0);
      return i.reverse();
    }
    /*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.bytes = e.stringToBytes = e.str = e.bytesToString = e.hex = e.utf8 = e.bech32m = e.bech32 = e.base58check = e.base58xmr = e.base58xrp = e.base58flickr = e.base58 = e.base64urlnopad = e.base64url = e.base64 = e.base32crockford = e.base32hex = e.base32 = e.base16 = e.utils = e.assertNumber = void 0, e.assertNumber = function (e) {
      if (!Number.isSafeInteger(e)) throw new Error(`Wrong integer: ${e}`);
    };
    const s = (e, t) => t ? s(t, e % t) : e,
      u = (e, t) => e + (t - s(e, t));
    function c(e, t, n, r) {
      if (!Array.isArray(e)) throw new Error("convertRadix2: data should be array");
      if (t <= 0 || t > 32) throw new Error(`convertRadix2: wrong from=${t}`);
      if (n <= 0 || n > 32) throw new Error(`convertRadix2: wrong to=${n}`);
      if (u(t, n) > 32) throw new Error(`convertRadix2: carry overflow from=${t} to=${n} carryBits=${u(t, n)}`);
      let i = 0,
        o = 0;
      const a = 2 ** n - 1,
        s = [];
      for (const r of e) {
        if (r >= 2 ** t) throw new Error(`convertRadix2: invalid data word=${r} from=${t}`);
        if (i = i << t | r, o + t > 32) throw new Error(`convertRadix2: carry overflow pos=${o} from=${t}`);
        for (o += t; o >= n; o -= n) s.push((i >> o - n & a) >>> 0);
        i &= 2 ** o - 1;
      }
      if (i = i << n - o & a, !r && o >= t) throw new Error("Excess padding");
      if (!r && i) throw new Error(`Non-zero padding: ${i}`);
      return r && o > 0 && s.push(i >>> 0), s;
    }
    function l(e) {
      return {
        encode: t => {
          if (!(t instanceof Uint8Array)) throw new Error("radix.encode input should be Uint8Array");
          return a(Array.from(t), 256, e);
        },
        decode: t => {
          if (!Array.isArray(t) || t.length && "number" != typeof t[0]) throw new Error("radix.decode input should be array of strings");
          return Uint8Array.from(a(t, e, 256));
        }
      };
    }
    function d(e, t = !1) {
      if (e <= 0 || e > 32) throw new Error("radix2: bits should be in (0..32]");
      if (u(8, e) > 32 || u(e, 8) > 32) throw new Error("radix2: carry overflow");
      return {
        encode: n => {
          if (!(n instanceof Uint8Array)) throw new Error("radix2.encode input should be Uint8Array");
          return c(Array.from(n), 8, e, !t);
        },
        decode: n => {
          if (!Array.isArray(n) || n.length && "number" != typeof n[0]) throw new Error("radix2.decode input should be array of strings");
          return Uint8Array.from(c(n, e, 8, t));
        }
      };
    }
    function f(e) {
      if ("function" != typeof e) throw new Error("unsafeWrapper fn should be function");
      return function (...t) {
        try {
          return e.apply(null, t);
        } catch (e) {}
      };
    }
    function h(e, t) {
      if ("function" != typeof t) throw new Error("checksum fn should be function");
      return {
        encode(n) {
          if (!(n instanceof Uint8Array)) throw new Error("checksum.encode: input should be Uint8Array");
          const r = t(n).slice(0, e),
            i = new Uint8Array(n.length + e);
          return i.set(n), i.set(r, n.length), i;
        },
        decode(n) {
          if (!(n instanceof Uint8Array)) throw new Error("checksum.decode: input should be Uint8Array");
          const r = n.slice(0, -e),
            i = t(r).slice(0, e),
            o = n.slice(-e);
          for (let t = 0; t < e; t++) if (i[t] !== o[t]) throw new Error("Invalid checksum");
          return r;
        }
      };
    }
    e.utils = {
      alphabet: n,
      chain: t,
      checksum: h,
      radix: l,
      radix2: d,
      join: r,
      padding: i
    }, e.base16 = t(d(4), n("0123456789ABCDEF"), r("")), e.base32 = t(d(5), n("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), i(5), r("")), e.base32hex = t(d(5), n("0123456789ABCDEFGHIJKLMNOPQRSTUV"), i(5), r("")), e.base32crockford = t(d(5), n("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), r(""), o(e => e.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1"))), e.base64 = t(d(6), n("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), i(6), r("")), e.base64url = t(d(6), n("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), i(6), r("")), e.base64urlnopad = t(d(6), n("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), r(""));
    const p = e => t(l(58), n(e), r(""));
    e.base58 = p("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), e.base58flickr = p("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"), e.base58xrp = p("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
    const m = [0, 2, 3, 5, 6, 7, 9, 10, 11];
    e.base58xmr = {
      encode(t) {
        let n = "";
        for (let r = 0; r < t.length; r += 8) {
          const i = t.subarray(r, r + 8);
          n += e.base58.encode(i).padStart(m[i.length], "1");
        }
        return n;
      },
      decode(t) {
        let n = [];
        for (let r = 0; r < t.length; r += 11) {
          const i = t.slice(r, r + 11),
            o = m.indexOf(i.length),
            a = e.base58.decode(i);
          for (let e = 0; e < a.length - o; e++) if (0 !== a[e]) throw new Error("base58xmr: wrong padding");
          n = n.concat(Array.from(a.slice(a.length - o)));
        }
        return Uint8Array.from(n);
      }
    };
    e.base58check = n => t(h(4, e => n(n(e))), e.base58);
    const g = t(n("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), r("")),
      v = [996825010, 642813549, 513874426, 1027748829, 705979059];
    function b(e) {
      const t = e >> 25;
      let n = (33554431 & e) << 5;
      for (let e = 0; e < v.length; e++) 1 == (t >> e & 1) && (n ^= v[e]);
      return n;
    }
    function y(e, t, n = 1) {
      const r = e.length;
      let i = 1;
      for (let t = 0; t < r; t++) {
        const n = e.charCodeAt(t);
        if (n < 33 || n > 126) throw new Error(`Invalid prefix (${e})`);
        i = b(i) ^ n >> 5;
      }
      i = b(i);
      for (let t = 0; t < r; t++) i = b(i) ^ 31 & e.charCodeAt(t);
      for (let e of t) i = b(i) ^ e;
      for (let e = 0; e < 6; e++) i = b(i);
      return i ^= n, g.encode(c([i % 2 ** 30], 30, 5, !1));
    }
    function w(e) {
      const t = "bech32" === e ? 1 : 734539939,
        n = d(5),
        r = n.decode,
        i = n.encode,
        o = f(r);
      function a(e, n = 90) {
        if ("string" != typeof e) throw new Error("bech32.decode input should be string, not " + typeof e);
        if (e.length < 8 || !1 !== n && e.length > n) throw new TypeError(`Wrong string length: ${e.length} (${e}). Expected (8..${n})`);
        const r = e.toLowerCase();
        if (e !== r && e !== e.toUpperCase()) throw new Error("String must be lowercase or uppercase");
        const i = (e = r).lastIndexOf("1");
        if (0 === i || -1 === i) throw new Error('Letter "1" must be present between prefix and data only');
        const o = e.slice(0, i),
          a = e.slice(i + 1);
        if (a.length < 6) throw new Error("Data must be at least 6 characters long");
        const s = g.decode(a).slice(0, -6),
          u = y(o, s, t);
        if (!a.endsWith(u)) throw new Error(`Invalid checksum in ${e}: expected "${u}"`);
        return {
          prefix: o,
          words: s
        };
      }
      return {
        encode: function (e, n, r = 90) {
          if ("string" != typeof e) throw new Error("bech32.encode prefix should be string, not " + typeof e);
          if (!Array.isArray(n) || n.length && "number" != typeof n[0]) throw new Error("bech32.encode words should be array of numbers, not " + typeof n);
          const i = e.length + 7 + n.length;
          if (!1 !== r && i > r) throw new TypeError(`Length ${i} exceeds limit ${r}`);
          const o = e.toLowerCase(),
            a = y(o, n, t);
          return `${o}1${g.encode(n)}${a}`;
        },
        decode: a,
        decodeToBytes: function (e) {
          const {
            prefix: t,
            words: n
          } = a(e, !1);
          return {
            prefix: t,
            words: n,
            bytes: r(n)
          };
        },
        decodeUnsafe: f(a),
        fromWords: r,
        fromWordsUnsafe: o,
        toWords: i
      };
    }
    e.bech32 = w("bech32"), e.bech32m = w("bech32m"), e.utf8 = {
      encode: e => new TextDecoder().decode(e),
      decode: e => new TextEncoder().encode(e)
    }, e.hex = t(d(4), n("0123456789abcdef"), r(""), o(e => {
      if ("string" != typeof e || e.length % 2) throw new TypeError(`hex.decode: expected string, got ${typeof e} with length ${e.length}`);
      return e.toLowerCase();
    }));
    const A = {
        utf8: e.utf8,
        hex: e.hex,
        base16: e.base16,
        base32: e.base32,
        base64: e.base64,
        base64url: e.base64url,
        base58: e.base58,
        base58xmr: e.base58xmr
      },
      _ = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr";
    e.bytesToString = (e, t) => {
      if ("string" != typeof e || !A.hasOwnProperty(e)) throw new TypeError(_);
      if (!(t instanceof Uint8Array)) throw new TypeError("bytesToString() expects Uint8Array");
      return A[e].encode(t);
    }, e.str = e.bytesToString;
    e.stringToBytes = (e, t) => {
      if (!A.hasOwnProperty(e)) throw new TypeError(_);
      if ("string" != typeof t) throw new TypeError("stringToBytes() expects string");
      return A[e].decode(t);
    }, e.bytes = e.stringToBytes;
  }(nC), Object.defineProperty(VS, "__esModule", {
    value: !0
  });
  var rC = $S,
    iC = Xk,
    oC = Yk,
    aC = nC,
    sC = 48,
    uC = 58,
    cC = 87;
  var lC = function () {
    const e = [];
    return () => {
      if (0 === e.length) for (let t = 0; t < 256; t++) e.push(t.toString(16).padStart(2, "0"));
      return e;
    };
  }();
  function dC(e) {
    return e instanceof Uint8Array;
  }
  function fC(e) {
    rC.assert.call(void 0, dC(e), "Value must be a Uint8Array.");
  }
  function hC(e) {
    if (fC(e), 0 === e.length) return "0x";
    const t = lC(),
      n = new Array(e.length);
    for (let r = 0; r < e.length; r++) n[r] = t[e[r]];
    return RC(n.join(""));
  }
  function pC(e) {
    fC(e);
    const t = hC(e);
    return BigInt(t);
  }
  function mC(e) {
    if ("0x" === function (e) {
      let t,
        n = e[0],
        r = 1;
      for (; r < e.length;) {
        const i = e[r],
          o = e[r + 1];
        if (r += 2, ("optionalAccess" === i || "optionalCall" === i) && null == n) return;
        "access" === i || "optionalAccess" === i ? (t = n, n = o(n)) : "call" !== i && "optionalCall" !== i || (n = o((...e) => n.call(t, ...e)), t = void 0);
      }
      return n;
    }([e, "optionalAccess", e => e.toLowerCase, "optionalCall", e => e()])) return new Uint8Array();
    MC(e);
    const t = IC(e).toLowerCase(),
      n = t.length % 2 == 0 ? t : `0${t}`,
      r = new Uint8Array(n.length / 2);
    for (let e = 0; e < r.length; e++) {
      const t = n.charCodeAt(2 * e),
        i = n.charCodeAt(2 * e + 1),
        o = t - (t < uC ? sC : cC),
        a = i - (i < uC ? sC : cC);
      r[e] = 16 * o + a;
    }
    return r;
  }
  function gC(e) {
    rC.assert.call(void 0, "bigint" == typeof e, "Value must be a bigint."), rC.assert.call(void 0, e >= BigInt(0), "Value must be a non-negative bigint.");
    return mC(e.toString(16));
  }
  function vC(e) {
    rC.assert.call(void 0, "number" == typeof e, "Value must be a number."), rC.assert.call(void 0, e >= 0, "Value must be a non-negative number."), rC.assert.call(void 0, Number.isSafeInteger(e), "Value is not a safe integer. Use `bigIntToBytes` instead.");
    return mC(e.toString(16));
  }
  function bC(e) {
    return rC.assert.call(void 0, "string" == typeof e, "Value must be a string."), new TextEncoder().encode(e);
  }
  function yC(e) {
    if ("bigint" == typeof e) return gC(e);
    if ("number" == typeof e) return vC(e);
    if ("string" == typeof e) return e.startsWith("0x") ? mC(e) : bC(e);
    if (dC(e)) return e;
    throw new TypeError(`Unsupported value type: "${typeof e}".`);
  }
  var wC = oC.pattern.call(void 0, oC.string.call(void 0), /^(?:0x)?[0-9a-f]+$/iu),
    AC = oC.pattern.call(void 0, oC.string.call(void 0), /^0x[0-9a-f]+$/iu),
    _C = oC.pattern.call(void 0, oC.string.call(void 0), /^0x[0-9a-f]{40}$/u),
    EC = oC.pattern.call(void 0, oC.string.call(void 0), /^0x[0-9a-fA-F]{40}$/u);
  function SC(e) {
    return oC.is.call(void 0, e, wC);
  }
  function kC(e) {
    return oC.is.call(void 0, e, AC);
  }
  function MC(e) {
    rC.assert.call(void 0, SC(e), "Value must be a hexadecimal string.");
  }
  function CC(e) {
    rC.assert.call(void 0, oC.is.call(void 0, e, EC), "Invalid hex address.");
    const t = IC(e.toLowerCase()),
      n = IC(hC(iC.keccak_256.call(void 0, t)));
    return `0x${t.split("").map((e, t) => {
      const r = n[t];
      return rC.assert.call(void 0, oC.is.call(void 0, r, oC.string.call(void 0)), "Hash shorter than address."), parseInt(r, 16) > 7 ? e.toUpperCase() : e;
    }).join("")}`;
  }
  function xC(e) {
    return !!oC.is.call(void 0, e, EC) && CC(e) === e;
  }
  function RC(e) {
    return e.startsWith("0x") ? e : e.startsWith("0X") ? `0x${e.substring(2)}` : `0x${e}`;
  }
  function IC(e) {
    return e.startsWith("0x") || e.startsWith("0X") ? e.substring(2) : e;
  }
  VS.HexStruct = wC, VS.StrictHexStruct = AC, VS.HexAddressStruct = _C, VS.HexChecksumAddressStruct = EC, VS.isHexString = SC, VS.isStrictHexString = kC, VS.assertIsHexString = MC, VS.assertIsStrictHexString = function (e) {
    rC.assert.call(void 0, kC(e), 'Value must be a hexadecimal string, starting with "0x".');
  }, VS.isValidHexAddress = function (e) {
    return oC.is.call(void 0, e, _C) || xC(e);
  }, VS.getChecksumAddress = CC, VS.isValidChecksumAddress = xC, VS.add0x = RC, VS.remove0x = IC, VS.isBytes = dC, VS.assertIsBytes = fC, VS.bytesToHex = hC, VS.bytesToBigInt = pC, VS.bytesToSignedBigInt = function (e) {
    fC(e);
    let t = BigInt(0);
    for (const n of e) t = (t << BigInt(8)) + BigInt(n);
    return BigInt.asIntN(8 * e.length, t);
  }, VS.bytesToNumber = function (e) {
    fC(e);
    const t = pC(e);
    return rC.assert.call(void 0, t <= BigInt(Number.MAX_SAFE_INTEGER), "Number is not a safe integer. Use `bytesToBigInt` instead."), Number(t);
  }, VS.bytesToString = function (e) {
    return fC(e), new TextDecoder().decode(e);
  }, VS.bytesToBase64 = function (e) {
    return fC(e), aC.base64.encode(e);
  }, VS.hexToBytes = mC, VS.bigIntToBytes = gC, VS.signedBigIntToBytes = function (e, t) {
    rC.assert.call(void 0, "bigint" == typeof e, "Value must be a bigint."), rC.assert.call(void 0, "number" == typeof t, "Byte length must be a number."), rC.assert.call(void 0, t > 0, "Byte length must be greater than 0."), rC.assert.call(void 0, function (e, t) {
      rC.assert.call(void 0, t > 0);
      const n = e >> BigInt(31);
      return !((~e & n) + (e & ~n) >> BigInt(8 * t - 1));
    }(e, t), "Byte length is too small to represent the given value.");
    let n = e;
    const r = new Uint8Array(t);
    for (let e = 0; e < r.length; e++) r[e] = Number(BigInt.asUintN(8, n)), n >>= BigInt(8);
    return r.reverse();
  }, VS.numberToBytes = vC, VS.stringToBytes = bC, VS.base64ToBytes = function (e) {
    return rC.assert.call(void 0, "string" == typeof e, "Value must be a string."), aC.base64.decode(e);
  }, VS.valueToBytes = yC, VS.concatBytes = function (e) {
    const t = new Array(e.length);
    let n = 0;
    for (let r = 0; r < e.length; r++) {
      const i = yC(e[r]);
      t[r] = i, n += i.length;
    }
    const r = new Uint8Array(n);
    for (let e = 0, n = 0; e < t.length; e++) r.set(t[e], n), n += t[e].length;
    return r;
  }, VS.createDataView = function (e) {
    if (void 0 !== A && e instanceof A) {
      const t = e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength);
      return new DataView(t);
    }
    return new DataView(e.buffer, e.byteOffset, e.byteLength);
  }, Object.defineProperty(HS, "__esModule", {
    value: !0
  });
  var TC = VS,
    PC = $S;
  HS.numberToHex = e => (PC.assert.call(void 0, "number" == typeof e, "Value must be a number."), PC.assert.call(void 0, e >= 0, "Value must be a non-negative number."), PC.assert.call(void 0, Number.isSafeInteger(e), "Value is not a safe integer. Use `bigIntToHex` instead."), TC.add0x.call(void 0, e.toString(16))), HS.bigIntToHex = e => (PC.assert.call(void 0, "bigint" == typeof e, "Value must be a bigint."), PC.assert.call(void 0, e >= 0, "Value must be a non-negative bigint."), TC.add0x.call(void 0, e.toString(16))), HS.hexToNumber = e => {
    TC.assertIsHexString.call(void 0, e);
    const t = parseInt(e, 16);
    return PC.assert.call(void 0, Number.isSafeInteger(t), "Value is not a safe integer. Use `hexToBigInt` instead."), t;
  }, HS.hexToBigInt = e => (TC.assertIsHexString.call(void 0, e), BigInt(TC.add0x.call(void 0, e)));
  var OC = {};
  Object.defineProperty(OC, "__esModule", {
    value: !0
  }), OC.createDeferredPromise = function ({
    suppressUnhandledRejection: e = !1
  } = {}) {
    let t, n;
    const r = new Promise((e, r) => {
      t = e, n = r;
    });
    return e && r.catch(e => {}), {
      promise: r,
      resolve: t,
      reject: n
    };
  };
  var LC = {};
  Object.defineProperty(LC, "__esModule", {
    value: !0
  });
  var NC = (e => (e[e.Millisecond = 1] = "Millisecond", e[e.Second = 1e3] = "Second", e[e.Minute = 6e4] = "Minute", e[e.Hour = 36e5] = "Hour", e[e.Day = 864e5] = "Day", e[e.Week = 6048e5] = "Week", e[e.Year = 31536e6] = "Year", e))(NC || {}),
    DC = (e, t) => {
      if (!(e => Number.isInteger(e) && e >= 0)(e)) throw new Error(`"${t}" must be a non-negative integer. Received: "${e}".`);
    };
  LC.Duration = NC, LC.inMilliseconds = function (e, t) {
    return DC(e, "count"), e * t;
  }, LC.timeSince = function (e) {
    return DC(e, "timestamp"), Date.now() - e;
  };
  var BC = {},
    jC = {
      exports: {}
    };
  var FC = {
    MAX_LENGTH: 256,
    MAX_SAFE_COMPONENT_LENGTH: 16,
    MAX_SAFE_BUILD_LENGTH: 250,
    MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER || 9007199254740991,
    RELEASE_TYPES: ["major", "premajor", "minor", "preminor", "patch", "prepatch", "prerelease"],
    SEMVER_SPEC_VERSION: "2.0.0",
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
  };
  var zC = "object" == typeof Be && Be.env && Be.env.NODE_DEBUG && /\bsemver\b/i.test(Be.env.NODE_DEBUG) ? (...e) => console.error("SEMVER", ...e) : () => {};
  !function (e, t) {
    const {
        MAX_SAFE_COMPONENT_LENGTH: n,
        MAX_SAFE_BUILD_LENGTH: r,
        MAX_LENGTH: i
      } = FC,
      o = zC,
      a = (t = e.exports = {}).re = [],
      s = t.safeRe = [],
      u = t.src = [],
      c = t.t = {};
    let l = 0;
    const d = "[a-zA-Z0-9-]",
      f = [["\\s", 1], ["\\d", i], [d, r]],
      h = (e, t, n) => {
        const r = (e => {
            for (const [t, n] of f) e = e.split(`${t}*`).join(`${t}{0,${n}}`).split(`${t}+`).join(`${t}{1,${n}}`);
            return e;
          })(t),
          i = l++;
        o(e, i, t), c[e] = i, u[i] = t, a[i] = new RegExp(t, n ? "g" : void 0), s[i] = new RegExp(r, n ? "g" : void 0);
      };
    h("NUMERICIDENTIFIER", "0|[1-9]\\d*"), h("NUMERICIDENTIFIERLOOSE", "\\d+"), h("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${d}*`), h("MAINVERSION", `(${u[c.NUMERICIDENTIFIER]})\\.(${u[c.NUMERICIDENTIFIER]})\\.(${u[c.NUMERICIDENTIFIER]})`), h("MAINVERSIONLOOSE", `(${u[c.NUMERICIDENTIFIERLOOSE]})\\.(${u[c.NUMERICIDENTIFIERLOOSE]})\\.(${u[c.NUMERICIDENTIFIERLOOSE]})`), h("PRERELEASEIDENTIFIER", `(?:${u[c.NUMERICIDENTIFIER]}|${u[c.NONNUMERICIDENTIFIER]})`), h("PRERELEASEIDENTIFIERLOOSE", `(?:${u[c.NUMERICIDENTIFIERLOOSE]}|${u[c.NONNUMERICIDENTIFIER]})`), h("PRERELEASE", `(?:-(${u[c.PRERELEASEIDENTIFIER]}(?:\\.${u[c.PRERELEASEIDENTIFIER]})*))`), h("PRERELEASELOOSE", `(?:-?(${u[c.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${u[c.PRERELEASEIDENTIFIERLOOSE]})*))`), h("BUILDIDENTIFIER", `${d}+`), h("BUILD", `(?:\\+(${u[c.BUILDIDENTIFIER]}(?:\\.${u[c.BUILDIDENTIFIER]})*))`), h("FULLPLAIN", `v?${u[c.MAINVERSION]}${u[c.PRERELEASE]}?${u[c.BUILD]}?`), h("FULL", `^${u[c.FULLPLAIN]}$`), h("LOOSEPLAIN", `[v=\\s]*${u[c.MAINVERSIONLOOSE]}${u[c.PRERELEASELOOSE]}?${u[c.BUILD]}?`), h("LOOSE", `^${u[c.LOOSEPLAIN]}$`), h("GTLT", "((?:<|>)?=?)"), h("XRANGEIDENTIFIERLOOSE", `${u[c.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), h("XRANGEIDENTIFIER", `${u[c.NUMERICIDENTIFIER]}|x|X|\\*`), h("XRANGEPLAIN", `[v=\\s]*(${u[c.XRANGEIDENTIFIER]})(?:\\.(${u[c.XRANGEIDENTIFIER]})(?:\\.(${u[c.XRANGEIDENTIFIER]})(?:${u[c.PRERELEASE]})?${u[c.BUILD]}?)?)?`), h("XRANGEPLAINLOOSE", `[v=\\s]*(${u[c.XRANGEIDENTIFIERLOOSE]})(?:\\.(${u[c.XRANGEIDENTIFIERLOOSE]})(?:\\.(${u[c.XRANGEIDENTIFIERLOOSE]})(?:${u[c.PRERELEASELOOSE]})?${u[c.BUILD]}?)?)?`), h("XRANGE", `^${u[c.GTLT]}\\s*${u[c.XRANGEPLAIN]}$`), h("XRANGELOOSE", `^${u[c.GTLT]}\\s*${u[c.XRANGEPLAINLOOSE]}$`), h("COERCE", `(^|[^\\d])(\\d{1,${n}})(?:\\.(\\d{1,${n}}))?(?:\\.(\\d{1,${n}}))?(?:$|[^\\d])`), h("COERCERTL", u[c.COERCE], !0), h("LONETILDE", "(?:~>?)"), h("TILDETRIM", `(\\s*)${u[c.LONETILDE]}\\s+`, !0), t.tildeTrimReplace = "$1~", h("TILDE", `^${u[c.LONETILDE]}${u[c.XRANGEPLAIN]}$`), h("TILDELOOSE", `^${u[c.LONETILDE]}${u[c.XRANGEPLAINLOOSE]}$`), h("LONECARET", "(?:\\^)"), h("CARETTRIM", `(\\s*)${u[c.LONECARET]}\\s+`, !0), t.caretTrimReplace = "$1^", h("CARET", `^${u[c.LONECARET]}${u[c.XRANGEPLAIN]}$`), h("CARETLOOSE", `^${u[c.LONECARET]}${u[c.XRANGEPLAINLOOSE]}$`), h("COMPARATORLOOSE", `^${u[c.GTLT]}\\s*(${u[c.LOOSEPLAIN]})$|^$`), h("COMPARATOR", `^${u[c.GTLT]}\\s*(${u[c.FULLPLAIN]})$|^$`), h("COMPARATORTRIM", `(\\s*)${u[c.GTLT]}\\s*(${u[c.LOOSEPLAIN]}|${u[c.XRANGEPLAIN]})`, !0), t.comparatorTrimReplace = "$1$2$3", h("HYPHENRANGE", `^\\s*(${u[c.XRANGEPLAIN]})\\s+-\\s+(${u[c.XRANGEPLAIN]})\\s*$`), h("HYPHENRANGELOOSE", `^\\s*(${u[c.XRANGEPLAINLOOSE]})\\s+-\\s+(${u[c.XRANGEPLAINLOOSE]})\\s*$`), h("STAR", "(<|>)?=?\\s*\\*"), h("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), h("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
  }(jC, jC.exports);
  var UC = jC.exports;
  const qC = Object.freeze({
      loose: !0
    }),
    KC = Object.freeze({});
  var HC = e => e ? "object" != typeof e ? qC : e : KC;
  const VC = /^[0-9]+$/,
    $C = (e, t) => {
      const n = VC.test(e),
        r = VC.test(t);
      return n && r && (e = +e, t = +t), e === t ? 0 : n && !r ? -1 : r && !n ? 1 : e < t ? -1 : 1;
    };
  var WC = {
    compareIdentifiers: $C,
    rcompareIdentifiers: (e, t) => $C(t, e)
  };
  const YC = zC,
    {
      MAX_LENGTH: GC,
      MAX_SAFE_INTEGER: QC
    } = FC,
    {
      safeRe: ZC,
      t: JC
    } = UC,
    XC = HC,
    {
      compareIdentifiers: ex
    } = WC;
  var tx = class e {
    constructor(t, n) {
      if (n = XC(n), t instanceof e) {
        if (t.loose === !!n.loose && t.includePrerelease === !!n.includePrerelease) return t;
        t = t.version;
      } else if ("string" != typeof t) throw new TypeError(`Invalid version. Must be a string. Got type "${typeof t}".`);
      if (t.length > GC) throw new TypeError(`version is longer than ${GC} characters`);
      YC("SemVer", t, n), this.options = n, this.loose = !!n.loose, this.includePrerelease = !!n.includePrerelease;
      const r = t.trim().match(n.loose ? ZC[JC.LOOSE] : ZC[JC.FULL]);
      if (!r) throw new TypeError(`Invalid Version: ${t}`);
      if (this.raw = t, this.major = +r[1], this.minor = +r[2], this.patch = +r[3], this.major > QC || this.major < 0) throw new TypeError("Invalid major version");
      if (this.minor > QC || this.minor < 0) throw new TypeError("Invalid minor version");
      if (this.patch > QC || this.patch < 0) throw new TypeError("Invalid patch version");
      r[4] ? this.prerelease = r[4].split(".").map(e => {
        if (/^[0-9]+$/.test(e)) {
          const t = +e;
          if (t >= 0 && t < QC) return t;
        }
        return e;
      }) : this.prerelease = [], this.build = r[5] ? r[5].split(".") : [], this.format();
    }
    format() {
      return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
    }
    toString() {
      return this.version;
    }
    compare(t) {
      if (YC("SemVer.compare", this.version, this.options, t), !(t instanceof e)) {
        if ("string" == typeof t && t === this.version) return 0;
        t = new e(t, this.options);
      }
      return t.version === this.version ? 0 : this.compareMain(t) || this.comparePre(t);
    }
    compareMain(t) {
      return t instanceof e || (t = new e(t, this.options)), ex(this.major, t.major) || ex(this.minor, t.minor) || ex(this.patch, t.patch);
    }
    comparePre(t) {
      if (t instanceof e || (t = new e(t, this.options)), this.prerelease.length && !t.prerelease.length) return -1;
      if (!this.prerelease.length && t.prerelease.length) return 1;
      if (!this.prerelease.length && !t.prerelease.length) return 0;
      let n = 0;
      do {
        const e = this.prerelease[n],
          r = t.prerelease[n];
        if (YC("prerelease compare", n, e, r), void 0 === e && void 0 === r) return 0;
        if (void 0 === r) return 1;
        if (void 0 === e) return -1;
        if (e !== r) return ex(e, r);
      } while (++n);
    }
    compareBuild(t) {
      t instanceof e || (t = new e(t, this.options));
      let n = 0;
      do {
        const e = this.build[n],
          r = t.build[n];
        if (YC("prerelease compare", n, e, r), void 0 === e && void 0 === r) return 0;
        if (void 0 === r) return 1;
        if (void 0 === e) return -1;
        if (e !== r) return ex(e, r);
      } while (++n);
    }
    inc(e, t, n) {
      switch (e) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", t, n);
          break;
        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", t, n);
          break;
        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", t, n), this.inc("pre", t, n);
          break;
        case "prerelease":
          0 === this.prerelease.length && this.inc("patch", t, n), this.inc("pre", t, n);
          break;
        case "major":
          0 === this.minor && 0 === this.patch && 0 !== this.prerelease.length || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;
        case "minor":
          0 === this.patch && 0 !== this.prerelease.length || this.minor++, this.patch = 0, this.prerelease = [];
          break;
        case "patch":
          0 === this.prerelease.length && this.patch++, this.prerelease = [];
          break;
        case "pre":
          {
            const e = Number(n) ? 1 : 0;
            if (!t && !1 === n) throw new Error("invalid increment argument: identifier is empty");
            if (0 === this.prerelease.length) this.prerelease = [e];else {
              let r = this.prerelease.length;
              for (; --r >= 0;) "number" == typeof this.prerelease[r] && (this.prerelease[r]++, r = -2);
              if (-1 === r) {
                if (t === this.prerelease.join(".") && !1 === n) throw new Error("invalid increment argument: identifier already exists");
                this.prerelease.push(e);
              }
            }
            if (t) {
              let r = [t, e];
              !1 === n && (r = [t]), 0 === ex(this.prerelease[0], t) ? isNaN(this.prerelease[1]) && (this.prerelease = r) : this.prerelease = r;
            }
            break;
          }
        default:
          throw new Error(`invalid increment argument: ${e}`);
      }
      return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
    }
  };
  const nx = tx;
  var rx = (e, t, n = !1) => {
    if (e instanceof nx) return e;
    try {
      return new nx(e, t);
    } catch (e) {
      if (!n) return null;
      throw e;
    }
  };
  const ix = rx;
  var ox = (e, t) => {
    const n = ix(e, t);
    return n ? n.version : null;
  };
  const ax = rx;
  var sx = (e, t) => {
    const n = ax(e.trim().replace(/^[=v]+/, ""), t);
    return n ? n.version : null;
  };
  const ux = tx;
  var cx = (e, t, n, r, i) => {
    "string" == typeof n && (i = r, r = n, n = void 0);
    try {
      return new ux(e instanceof ux ? e.version : e, n).inc(t, r, i).version;
    } catch (e) {
      return null;
    }
  };
  const lx = rx;
  var dx = (e, t) => {
    const n = lx(e, null, !0),
      r = lx(t, null, !0),
      i = n.compare(r);
    if (0 === i) return null;
    const o = i > 0,
      a = o ? n : r,
      s = o ? r : n,
      u = !!a.prerelease.length;
    if (!!s.prerelease.length && !u) return s.patch || s.minor ? a.patch ? "patch" : a.minor ? "minor" : "major" : "major";
    const c = u ? "pre" : "";
    return n.major !== r.major ? c + "major" : n.minor !== r.minor ? c + "minor" : n.patch !== r.patch ? c + "patch" : "prerelease";
  };
  const fx = tx;
  var hx = (e, t) => new fx(e, t).major;
  const px = tx;
  var mx = (e, t) => new px(e, t).minor;
  const gx = tx;
  var vx = (e, t) => new gx(e, t).patch;
  const bx = rx;
  var yx = (e, t) => {
    const n = bx(e, t);
    return n && n.prerelease.length ? n.prerelease : null;
  };
  const wx = tx;
  var Ax = (e, t, n) => new wx(e, n).compare(new wx(t, n));
  const _x = Ax;
  var Ex = (e, t, n) => _x(t, e, n);
  const Sx = Ax;
  var kx = (e, t) => Sx(e, t, !0);
  const Mx = tx;
  var Cx = (e, t, n) => {
    const r = new Mx(e, n),
      i = new Mx(t, n);
    return r.compare(i) || r.compareBuild(i);
  };
  const xx = Cx;
  var Rx = (e, t) => e.sort((e, n) => xx(e, n, t));
  const Ix = Cx;
  var Tx = (e, t) => e.sort((e, n) => Ix(n, e, t));
  const Px = Ax;
  var Ox = (e, t, n) => Px(e, t, n) > 0;
  const Lx = Ax;
  var Nx = (e, t, n) => Lx(e, t, n) < 0;
  const Dx = Ax;
  var Bx = (e, t, n) => 0 === Dx(e, t, n);
  const jx = Ax;
  var Fx = (e, t, n) => 0 !== jx(e, t, n);
  const zx = Ax;
  var Ux = (e, t, n) => zx(e, t, n) >= 0;
  const qx = Ax;
  var Kx = (e, t, n) => qx(e, t, n) <= 0;
  const Hx = Bx,
    Vx = Fx,
    $x = Ox,
    Wx = Ux,
    Yx = Nx,
    Gx = Kx;
  var Qx = (e, t, n, r) => {
    switch (t) {
      case "===":
        return "object" == typeof e && (e = e.version), "object" == typeof n && (n = n.version), e === n;
      case "!==":
        return "object" == typeof e && (e = e.version), "object" == typeof n && (n = n.version), e !== n;
      case "":
      case "=":
      case "==":
        return Hx(e, n, r);
      case "!=":
        return Vx(e, n, r);
      case ">":
        return $x(e, n, r);
      case ">=":
        return Wx(e, n, r);
      case "<":
        return Yx(e, n, r);
      case "<=":
        return Gx(e, n, r);
      default:
        throw new TypeError(`Invalid operator: ${t}`);
    }
  };
  const Zx = tx,
    Jx = rx,
    {
      safeRe: Xx,
      t: eR
    } = UC;
  var tR,
    nR,
    rR,
    iR,
    oR,
    aR,
    sR,
    uR,
    cR,
    lR,
    dR = (e, t) => {
      if (e instanceof Zx) return e;
      if ("number" == typeof e && (e = String(e)), "string" != typeof e) return null;
      let n = null;
      if ((t = t || {}).rtl) {
        let t;
        for (; (t = Xx[eR.COERCERTL].exec(e)) && (!n || n.index + n[0].length !== e.length);) n && t.index + t[0].length === n.index + n[0].length || (n = t), Xx[eR.COERCERTL].lastIndex = t.index + t[1].length + t[2].length;
        Xx[eR.COERCERTL].lastIndex = -1;
      } else n = e.match(Xx[eR.COERCE]);
      return null === n ? null : Jx(`${n[2]}.${n[3] || "0"}.${n[4] || "0"}`, t);
    };
  function fR() {
    if (iR) return rR;
    function e(t) {
      var n = this;
      if (n instanceof e || (n = new e()), n.tail = null, n.head = null, n.length = 0, t && "function" == typeof t.forEach) t.forEach(function (e) {
        n.push(e);
      });else if (arguments.length > 0) for (var r = 0, i = arguments.length; r < i; r++) n.push(arguments[r]);
      return n;
    }
    function t(e, t, n) {
      var r = t === e.head ? new i(n, null, t, e) : new i(n, t, t.next, e);
      return null === r.next && (e.tail = r), null === r.prev && (e.head = r), e.length++, r;
    }
    function n(e, t) {
      e.tail = new i(t, e.tail, null, e), e.head || (e.head = e.tail), e.length++;
    }
    function r(e, t) {
      e.head = new i(t, null, e.head, e), e.tail || (e.tail = e.head), e.length++;
    }
    function i(e, t, n, r) {
      if (!(this instanceof i)) return new i(e, t, n, r);
      this.list = r, this.value = e, t ? (t.next = this, this.prev = t) : this.prev = null, n ? (n.prev = this, this.next = n) : this.next = null;
    }
    iR = 1, rR = e, e.Node = i, e.create = e, e.prototype.removeNode = function (e) {
      if (e.list !== this) throw new Error("removing node which does not belong to this list");
      var t = e.next,
        n = e.prev;
      return t && (t.prev = n), n && (n.next = t), e === this.head && (this.head = t), e === this.tail && (this.tail = n), e.list.length--, e.next = null, e.prev = null, e.list = null, t;
    }, e.prototype.unshiftNode = function (e) {
      if (e !== this.head) {
        e.list && e.list.removeNode(e);
        var t = this.head;
        e.list = this, e.next = t, t && (t.prev = e), this.head = e, this.tail || (this.tail = e), this.length++;
      }
    }, e.prototype.pushNode = function (e) {
      if (e !== this.tail) {
        e.list && e.list.removeNode(e);
        var t = this.tail;
        e.list = this, e.prev = t, t && (t.next = e), this.tail = e, this.head || (this.head = e), this.length++;
      }
    }, e.prototype.push = function () {
      for (var e = 0, t = arguments.length; e < t; e++) n(this, arguments[e]);
      return this.length;
    }, e.prototype.unshift = function () {
      for (var e = 0, t = arguments.length; e < t; e++) r(this, arguments[e]);
      return this.length;
    }, e.prototype.pop = function () {
      if (this.tail) {
        var e = this.tail.value;
        return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, e;
      }
    }, e.prototype.shift = function () {
      if (this.head) {
        var e = this.head.value;
        return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, e;
      }
    }, e.prototype.forEach = function (e, t) {
      t = t || this;
      for (var n = this.head, r = 0; null !== n; r++) e.call(t, n.value, r, this), n = n.next;
    }, e.prototype.forEachReverse = function (e, t) {
      t = t || this;
      for (var n = this.tail, r = this.length - 1; null !== n; r--) e.call(t, n.value, r, this), n = n.prev;
    }, e.prototype.get = function (e) {
      for (var t = 0, n = this.head; null !== n && t < e; t++) n = n.next;
      if (t === e && null !== n) return n.value;
    }, e.prototype.getReverse = function (e) {
      for (var t = 0, n = this.tail; null !== n && t < e; t++) n = n.prev;
      if (t === e && null !== n) return n.value;
    }, e.prototype.map = function (t, n) {
      n = n || this;
      for (var r = new e(), i = this.head; null !== i;) r.push(t.call(n, i.value, this)), i = i.next;
      return r;
    }, e.prototype.mapReverse = function (t, n) {
      n = n || this;
      for (var r = new e(), i = this.tail; null !== i;) r.push(t.call(n, i.value, this)), i = i.prev;
      return r;
    }, e.prototype.reduce = function (e, t) {
      var n,
        r = this.head;
      if (arguments.length > 1) n = t;else {
        if (!this.head) throw new TypeError("Reduce of empty list with no initial value");
        r = this.head.next, n = this.head.value;
      }
      for (var i = 0; null !== r; i++) n = e(n, r.value, i), r = r.next;
      return n;
    }, e.prototype.reduceReverse = function (e, t) {
      var n,
        r = this.tail;
      if (arguments.length > 1) n = t;else {
        if (!this.tail) throw new TypeError("Reduce of empty list with no initial value");
        r = this.tail.prev, n = this.tail.value;
      }
      for (var i = this.length - 1; null !== r; i--) n = e(n, r.value, i), r = r.prev;
      return n;
    }, e.prototype.toArray = function () {
      for (var e = new Array(this.length), t = 0, n = this.head; null !== n; t++) e[t] = n.value, n = n.next;
      return e;
    }, e.prototype.toArrayReverse = function () {
      for (var e = new Array(this.length), t = 0, n = this.tail; null !== n; t++) e[t] = n.value, n = n.prev;
      return e;
    }, e.prototype.slice = function (t, n) {
      (n = n || this.length) < 0 && (n += this.length), (t = t || 0) < 0 && (t += this.length);
      var r = new e();
      if (n < t || n < 0) return r;
      t < 0 && (t = 0), n > this.length && (n = this.length);
      for (var i = 0, o = this.head; null !== o && i < t; i++) o = o.next;
      for (; null !== o && i < n; i++, o = o.next) r.push(o.value);
      return r;
    }, e.prototype.sliceReverse = function (t, n) {
      (n = n || this.length) < 0 && (n += this.length), (t = t || 0) < 0 && (t += this.length);
      var r = new e();
      if (n < t || n < 0) return r;
      t < 0 && (t = 0), n > this.length && (n = this.length);
      for (var i = this.length, o = this.tail; null !== o && i > n; i--) o = o.prev;
      for (; null !== o && i > t; i--, o = o.prev) r.push(o.value);
      return r;
    }, e.prototype.splice = function (e, n, ...r) {
      e > this.length && (e = this.length - 1), e < 0 && (e = this.length + e);
      for (var i = 0, o = this.head; null !== o && i < e; i++) o = o.next;
      var a = [];
      for (i = 0; o && i < n; i++) a.push(o.value), o = this.removeNode(o);
      null === o && (o = this.tail), o !== this.head && o !== this.tail && (o = o.prev);
      for (i = 0; i < r.length; i++) o = t(this, o, r[i]);
      return a;
    }, e.prototype.reverse = function () {
      for (var e = this.head, t = this.tail, n = e; null !== n; n = n.prev) {
        var r = n.prev;
        n.prev = n.next, n.next = r;
      }
      return this.head = t, this.tail = e, this;
    };
    try {
      (nR ? tR : (nR = 1, tR = function (e) {
        e.prototype[Symbol.iterator] = function* () {
          for (let e = this.head; e; e = e.next) yield e.value;
        };
      }))(e);
    } catch (e) {}
    return rR;
  }
  function hR() {
    if (uR) return sR;
    uR = 1;
    class e {
      constructor(t, n) {
        if (n = r(n), t instanceof e) return t.loose === !!n.loose && t.includePrerelease === !!n.includePrerelease ? t : new e(t.raw, n);
        if (t instanceof i) return this.raw = t.value, this.set = [[t]], this.format(), this;
        if (this.options = n, this.loose = !!n.loose, this.includePrerelease = !!n.includePrerelease, this.raw = t.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map(e => this.parseRange(e.trim())).filter(e => e.length), !this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        if (this.set.length > 1) {
          const e = this.set[0];
          if (this.set = this.set.filter(e => !p(e[0])), 0 === this.set.length) this.set = [e];else if (this.set.length > 1) for (const e of this.set) if (1 === e.length && m(e[0])) {
            this.set = [e];
            break;
          }
        }
        this.format();
      }
      format() {
        return this.range = this.set.map(e => e.join(" ").trim()).join("||").trim(), this.range;
      }
      toString() {
        return this.range;
      }
      parseRange(e) {
        const t = ((this.options.includePrerelease && f) | (this.options.loose && h)) + ":" + e,
          r = n.get(t);
        if (r) return r;
        const a = this.options.loose,
          m = a ? s[u.HYPHENRANGELOOSE] : s[u.HYPHENRANGE];
        e = e.replace(m, C(this.options.includePrerelease)), o("hyphen replace", e), e = e.replace(s[u.COMPARATORTRIM], c), o("comparator trim", e), e = e.replace(s[u.TILDETRIM], l), o("tilde trim", e), e = e.replace(s[u.CARETTRIM], d), o("caret trim", e);
        let g = e.split(" ").map(e => v(e, this.options)).join(" ").split(/\s+/).map(e => M(e, this.options));
        a && (g = g.filter(e => (o("loose invalid filter", e, this.options), !!e.match(s[u.COMPARATORLOOSE])))), o("range list", g);
        const b = new Map(),
          y = g.map(e => new i(e, this.options));
        for (const e of y) {
          if (p(e)) return [e];
          b.set(e.value, e);
        }
        b.size > 1 && b.has("") && b.delete("");
        const w = [...b.values()];
        return n.set(t, w), w;
      }
      intersects(t, n) {
        if (!(t instanceof e)) throw new TypeError("a Range is required");
        return this.set.some(e => g(e, n) && t.set.some(t => g(t, n) && e.every(e => t.every(t => e.intersects(t, n)))));
      }
      test(e) {
        if (!e) return !1;
        if ("string" == typeof e) try {
          e = new a(e, this.options);
        } catch (e) {
          return !1;
        }
        for (let t = 0; t < this.set.length; t++) if (x(this.set[t], e, this.options)) return !0;
        return !1;
      }
    }
    sR = e;
    const t = function () {
        if (aR) return oR;
        aR = 1;
        const e = fR(),
          t = Symbol("max"),
          n = Symbol("length"),
          r = Symbol("lengthCalculator"),
          i = Symbol("allowStale"),
          o = Symbol("maxAge"),
          a = Symbol("dispose"),
          s = Symbol("noDisposeOnSet"),
          u = Symbol("lruList"),
          c = Symbol("cache"),
          l = Symbol("updateAgeOnGet"),
          d = () => 1,
          f = (e, t, n) => {
            const r = e[c].get(t);
            if (r) {
              const t = r.value;
              if (h(e, t)) {
                if (m(e, r), !e[i]) return;
              } else n && (e[l] && (r.value.now = Date.now()), e[u].unshiftNode(r));
              return t.value;
            }
          },
          h = (e, t) => {
            if (!t || !t.maxAge && !e[o]) return !1;
            const n = Date.now() - t.now;
            return t.maxAge ? n > t.maxAge : e[o] && n > e[o];
          },
          p = e => {
            if (e[n] > e[t]) for (let r = e[u].tail; e[n] > e[t] && null !== r;) {
              const t = r.prev;
              m(e, r), r = t;
            }
          },
          m = (e, t) => {
            if (t) {
              const r = t.value;
              e[a] && e[a](r.key, r.value), e[n] -= r.length, e[c].delete(r.key), e[u].removeNode(t);
            }
          };
        class g {
          constructor(e, t, n, r, i) {
            this.key = e, this.value = t, this.length = n, this.now = r, this.maxAge = i || 0;
          }
        }
        const v = (e, t, n, r) => {
          let o = n.value;
          h(e, o) && (m(e, n), e[i] || (o = void 0)), o && t.call(r, o.value, o.key, e);
        };
        return oR = class {
          constructor(e) {
            if ("number" == typeof e && (e = {
              max: e
            }), e || (e = {}), e.max && ("number" != typeof e.max || e.max < 0)) throw new TypeError("max must be a non-negative number");
            this[t] = e.max || 1 / 0;
            const n = e.length || d;
            if (this[r] = "function" != typeof n ? d : n, this[i] = e.stale || !1, e.maxAge && "number" != typeof e.maxAge) throw new TypeError("maxAge must be a number");
            this[o] = e.maxAge || 0, this[a] = e.dispose, this[s] = e.noDisposeOnSet || !1, this[l] = e.updateAgeOnGet || !1, this.reset();
          }
          set max(e) {
            if ("number" != typeof e || e < 0) throw new TypeError("max must be a non-negative number");
            this[t] = e || 1 / 0, p(this);
          }
          get max() {
            return this[t];
          }
          set allowStale(e) {
            this[i] = !!e;
          }
          get allowStale() {
            return this[i];
          }
          set maxAge(e) {
            if ("number" != typeof e) throw new TypeError("maxAge must be a non-negative number");
            this[o] = e, p(this);
          }
          get maxAge() {
            return this[o];
          }
          set lengthCalculator(e) {
            "function" != typeof e && (e = d), e !== this[r] && (this[r] = e, this[n] = 0, this[u].forEach(e => {
              e.length = this[r](e.value, e.key), this[n] += e.length;
            })), p(this);
          }
          get lengthCalculator() {
            return this[r];
          }
          get length() {
            return this[n];
          }
          get itemCount() {
            return this[u].length;
          }
          rforEach(e, t) {
            t = t || this;
            for (let n = this[u].tail; null !== n;) {
              const r = n.prev;
              v(this, e, n, t), n = r;
            }
          }
          forEach(e, t) {
            t = t || this;
            for (let n = this[u].head; null !== n;) {
              const r = n.next;
              v(this, e, n, t), n = r;
            }
          }
          keys() {
            return this[u].toArray().map(e => e.key);
          }
          values() {
            return this[u].toArray().map(e => e.value);
          }
          reset() {
            this[a] && this[u] && this[u].length && this[u].forEach(e => this[a](e.key, e.value)), this[c] = new Map(), this[u] = new e(), this[n] = 0;
          }
          dump() {
            return this[u].map(e => !h(this, e) && {
              k: e.key,
              v: e.value,
              e: e.now + (e.maxAge || 0)
            }).toArray().filter(e => e);
          }
          dumpLru() {
            return this[u];
          }
          set(e, i, l) {
            if ((l = l || this[o]) && "number" != typeof l) throw new TypeError("maxAge must be a number");
            const d = l ? Date.now() : 0,
              f = this[r](i, e);
            if (this[c].has(e)) {
              if (f > this[t]) return m(this, this[c].get(e)), !1;
              const r = this[c].get(e).value;
              return this[a] && (this[s] || this[a](e, r.value)), r.now = d, r.maxAge = l, r.value = i, this[n] += f - r.length, r.length = f, this.get(e), p(this), !0;
            }
            const h = new g(e, i, f, d, l);
            return h.length > this[t] ? (this[a] && this[a](e, i), !1) : (this[n] += h.length, this[u].unshift(h), this[c].set(e, this[u].head), p(this), !0);
          }
          has(e) {
            if (!this[c].has(e)) return !1;
            const t = this[c].get(e).value;
            return !h(this, t);
          }
          get(e) {
            return f(this, e, !0);
          }
          peek(e) {
            return f(this, e, !1);
          }
          pop() {
            const e = this[u].tail;
            return e ? (m(this, e), e.value) : null;
          }
          del(e) {
            m(this, this[c].get(e));
          }
          load(e) {
            this.reset();
            const t = Date.now();
            for (let n = e.length - 1; n >= 0; n--) {
              const r = e[n],
                i = r.e || 0;
              if (0 === i) this.set(r.k, r.v);else {
                const e = i - t;
                e > 0 && this.set(r.k, r.v, e);
              }
            }
          }
          prune() {
            this[c].forEach((e, t) => f(this, t, !1));
          }
        }, oR;
      }(),
      n = new t({
        max: 1e3
      }),
      r = HC,
      i = pR(),
      o = zC,
      a = tx,
      {
        safeRe: s,
        t: u,
        comparatorTrimReplace: c,
        tildeTrimReplace: l,
        caretTrimReplace: d
      } = UC,
      {
        FLAG_INCLUDE_PRERELEASE: f,
        FLAG_LOOSE: h
      } = FC,
      p = e => "<0.0.0-0" === e.value,
      m = e => "" === e.value,
      g = (e, t) => {
        let n = !0;
        const r = e.slice();
        let i = r.pop();
        for (; n && r.length;) n = r.every(e => i.intersects(e, t)), i = r.pop();
        return n;
      },
      v = (e, t) => (o("comp", e, t), e = A(e, t), o("caret", e), e = y(e, t), o("tildes", e), e = E(e, t), o("xrange", e), e = k(e, t), o("stars", e), e),
      b = e => !e || "x" === e.toLowerCase() || "*" === e,
      y = (e, t) => e.trim().split(/\s+/).map(e => w(e, t)).join(" "),
      w = (e, t) => {
        const n = t.loose ? s[u.TILDELOOSE] : s[u.TILDE];
        return e.replace(n, (t, n, r, i, a) => {
          let s;
          return o("tilde", e, t, n, r, i, a), b(n) ? s = "" : b(r) ? s = `>=${n}.0.0 <${+n + 1}.0.0-0` : b(i) ? s = `>=${n}.${r}.0 <${n}.${+r + 1}.0-0` : a ? (o("replaceTilde pr", a), s = `>=${n}.${r}.${i}-${a} <${n}.${+r + 1}.0-0`) : s = `>=${n}.${r}.${i} <${n}.${+r + 1}.0-0`, o("tilde return", s), s;
        });
      },
      A = (e, t) => e.trim().split(/\s+/).map(e => _(e, t)).join(" "),
      _ = (e, t) => {
        o("caret", e, t);
        const n = t.loose ? s[u.CARETLOOSE] : s[u.CARET],
          r = t.includePrerelease ? "-0" : "";
        return e.replace(n, (t, n, i, a, s) => {
          let u;
          return o("caret", e, t, n, i, a, s), b(n) ? u = "" : b(i) ? u = `>=${n}.0.0${r} <${+n + 1}.0.0-0` : b(a) ? u = "0" === n ? `>=${n}.${i}.0${r} <${n}.${+i + 1}.0-0` : `>=${n}.${i}.0${r} <${+n + 1}.0.0-0` : s ? (o("replaceCaret pr", s), u = "0" === n ? "0" === i ? `>=${n}.${i}.${a}-${s} <${n}.${i}.${+a + 1}-0` : `>=${n}.${i}.${a}-${s} <${n}.${+i + 1}.0-0` : `>=${n}.${i}.${a}-${s} <${+n + 1}.0.0-0`) : (o("no pr"), u = "0" === n ? "0" === i ? `>=${n}.${i}.${a}${r} <${n}.${i}.${+a + 1}-0` : `>=${n}.${i}.${a}${r} <${n}.${+i + 1}.0-0` : `>=${n}.${i}.${a} <${+n + 1}.0.0-0`), o("caret return", u), u;
        });
      },
      E = (e, t) => (o("replaceXRanges", e, t), e.split(/\s+/).map(e => S(e, t)).join(" ")),
      S = (e, t) => {
        e = e.trim();
        const n = t.loose ? s[u.XRANGELOOSE] : s[u.XRANGE];
        return e.replace(n, (n, r, i, a, s, u) => {
          o("xRange", e, n, r, i, a, s, u);
          const c = b(i),
            l = c || b(a),
            d = l || b(s),
            f = d;
          return "=" === r && f && (r = ""), u = t.includePrerelease ? "-0" : "", c ? n = ">" === r || "<" === r ? "<0.0.0-0" : "*" : r && f ? (l && (a = 0), s = 0, ">" === r ? (r = ">=", l ? (i = +i + 1, a = 0, s = 0) : (a = +a + 1, s = 0)) : "<=" === r && (r = "<", l ? i = +i + 1 : a = +a + 1), "<" === r && (u = "-0"), n = `${r + i}.${a}.${s}${u}`) : l ? n = `>=${i}.0.0${u} <${+i + 1}.0.0-0` : d && (n = `>=${i}.${a}.0${u} <${i}.${+a + 1}.0-0`), o("xRange return", n), n;
        });
      },
      k = (e, t) => (o("replaceStars", e, t), e.trim().replace(s[u.STAR], "")),
      M = (e, t) => (o("replaceGTE0", e, t), e.trim().replace(s[t.includePrerelease ? u.GTE0PRE : u.GTE0], "")),
      C = e => (t, n, r, i, o, a, s, u, c, l, d, f, h) => `${n = b(r) ? "" : b(i) ? `>=${r}.0.0${e ? "-0" : ""}` : b(o) ? `>=${r}.${i}.0${e ? "-0" : ""}` : a ? `>=${n}` : `>=${n}${e ? "-0" : ""}`} ${u = b(c) ? "" : b(l) ? `<${+c + 1}.0.0-0` : b(d) ? `<${c}.${+l + 1}.0-0` : f ? `<=${c}.${l}.${d}-${f}` : e ? `<${c}.${l}.${+d + 1}-0` : `<=${u}`}`.trim(),
      x = (e, t, n) => {
        for (let n = 0; n < e.length; n++) if (!e[n].test(t)) return !1;
        if (t.prerelease.length && !n.includePrerelease) {
          for (let n = 0; n < e.length; n++) if (o(e[n].semver), e[n].semver !== i.ANY && e[n].semver.prerelease.length > 0) {
            const r = e[n].semver;
            if (r.major === t.major && r.minor === t.minor && r.patch === t.patch) return !0;
          }
          return !1;
        }
        return !0;
      };
    return sR;
  }
  function pR() {
    if (lR) return cR;
    lR = 1;
    const e = Symbol("SemVer ANY");
    class t {
      static get ANY() {
        return e;
      }
      constructor(r, i) {
        if (i = n(i), r instanceof t) {
          if (r.loose === !!i.loose) return r;
          r = r.value;
        }
        r = r.trim().split(/\s+/).join(" "), a("comparator", r, i), this.options = i, this.loose = !!i.loose, this.parse(r), this.semver === e ? this.value = "" : this.value = this.operator + this.semver.version, a("comp", this);
      }
      parse(t) {
        const n = this.options.loose ? r[i.COMPARATORLOOSE] : r[i.COMPARATOR],
          o = t.match(n);
        if (!o) throw new TypeError(`Invalid comparator: ${t}`);
        this.operator = void 0 !== o[1] ? o[1] : "", "=" === this.operator && (this.operator = ""), o[2] ? this.semver = new s(o[2], this.options.loose) : this.semver = e;
      }
      toString() {
        return this.value;
      }
      test(t) {
        if (a("Comparator.test", t, this.options.loose), this.semver === e || t === e) return !0;
        if ("string" == typeof t) try {
          t = new s(t, this.options);
        } catch (e) {
          return !1;
        }
        return o(t, this.operator, this.semver, this.options);
      }
      intersects(e, r) {
        if (!(e instanceof t)) throw new TypeError("a Comparator is required");
        return "" === this.operator ? "" === this.value || new u(e.value, r).test(this.value) : "" === e.operator ? "" === e.value || new u(this.value, r).test(e.semver) : (!(r = n(r)).includePrerelease || "<0.0.0-0" !== this.value && "<0.0.0-0" !== e.value) && !(!r.includePrerelease && (this.value.startsWith("<0.0.0") || e.value.startsWith("<0.0.0"))) && (!(!this.operator.startsWith(">") || !e.operator.startsWith(">")) || !(!this.operator.startsWith("<") || !e.operator.startsWith("<")) || !(this.semver.version !== e.semver.version || !this.operator.includes("=") || !e.operator.includes("=")) || !!(o(this.semver, "<", e.semver, r) && this.operator.startsWith(">") && e.operator.startsWith("<")) || !!(o(this.semver, ">", e.semver, r) && this.operator.startsWith("<") && e.operator.startsWith(">")));
      }
    }
    cR = t;
    const n = HC,
      {
        safeRe: r,
        t: i
      } = UC,
      o = Qx,
      a = zC,
      s = tx,
      u = hR();
    return cR;
  }
  const mR = hR();
  var gR = (e, t, n) => {
    try {
      t = new mR(t, n);
    } catch (e) {
      return !1;
    }
    return t.test(e);
  };
  const vR = hR();
  var bR = (e, t) => new vR(e, t).set.map(e => e.map(e => e.value).join(" ").trim().split(" "));
  const yR = tx,
    wR = hR();
  var AR = (e, t, n) => {
    let r = null,
      i = null,
      o = null;
    try {
      o = new wR(t, n);
    } catch (e) {
      return null;
    }
    return e.forEach(e => {
      o.test(e) && (r && -1 !== i.compare(e) || (r = e, i = new yR(r, n)));
    }), r;
  };
  const _R = tx,
    ER = hR();
  var SR = (e, t, n) => {
    let r = null,
      i = null,
      o = null;
    try {
      o = new ER(t, n);
    } catch (e) {
      return null;
    }
    return e.forEach(e => {
      o.test(e) && (r && 1 !== i.compare(e) || (r = e, i = new _R(r, n)));
    }), r;
  };
  const kR = tx,
    MR = hR(),
    CR = Ox;
  var xR = (e, t) => {
    e = new MR(e, t);
    let n = new kR("0.0.0");
    if (e.test(n)) return n;
    if (n = new kR("0.0.0-0"), e.test(n)) return n;
    n = null;
    for (let t = 0; t < e.set.length; ++t) {
      const r = e.set[t];
      let i = null;
      r.forEach(e => {
        const t = new kR(e.semver.version);
        switch (e.operator) {
          case ">":
            0 === t.prerelease.length ? t.patch++ : t.prerelease.push(0), t.raw = t.format();
          case "":
          case ">=":
            i && !CR(t, i) || (i = t);
            break;
          case "<":
          case "<=":
            break;
          default:
            throw new Error(`Unexpected operation: ${e.operator}`);
        }
      }), !i || n && !CR(n, i) || (n = i);
    }
    return n && e.test(n) ? n : null;
  };
  const RR = hR();
  var IR = (e, t) => {
    try {
      return new RR(e, t).range || "*";
    } catch (e) {
      return null;
    }
  };
  const TR = tx,
    PR = pR(),
    {
      ANY: OR
    } = PR,
    LR = hR(),
    NR = gR,
    DR = Ox,
    BR = Nx,
    jR = Kx,
    FR = Ux;
  var zR = (e, t, n, r) => {
    let i, o, a, s, u;
    switch (e = new TR(e, r), t = new LR(t, r), n) {
      case ">":
        i = DR, o = jR, a = BR, s = ">", u = ">=";
        break;
      case "<":
        i = BR, o = FR, a = DR, s = "<", u = "<=";
        break;
      default:
        throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    if (NR(e, t, r)) return !1;
    for (let n = 0; n < t.set.length; ++n) {
      const c = t.set[n];
      let l = null,
        d = null;
      if (c.forEach(e => {
        e.semver === OR && (e = new PR(">=0.0.0")), l = l || e, d = d || e, i(e.semver, l.semver, r) ? l = e : a(e.semver, d.semver, r) && (d = e);
      }), l.operator === s || l.operator === u) return !1;
      if ((!d.operator || d.operator === s) && o(e, d.semver)) return !1;
      if (d.operator === u && a(e, d.semver)) return !1;
    }
    return !0;
  };
  const UR = zR;
  var qR = (e, t, n) => UR(e, t, ">", n);
  const KR = zR;
  var HR = (e, t, n) => KR(e, t, "<", n);
  const VR = hR();
  var $R = (e, t, n) => (e = new VR(e, n), t = new VR(t, n), e.intersects(t, n));
  const WR = gR,
    YR = Ax;
  const GR = hR(),
    QR = pR(),
    {
      ANY: ZR
    } = QR,
    JR = gR,
    XR = Ax,
    eI = [new QR(">=0.0.0-0")],
    tI = [new QR(">=0.0.0")],
    nI = (e, t, n) => {
      if (e === t) return !0;
      if (1 === e.length && e[0].semver === ZR) {
        if (1 === t.length && t[0].semver === ZR) return !0;
        e = n.includePrerelease ? eI : tI;
      }
      if (1 === t.length && t[0].semver === ZR) {
        if (n.includePrerelease) return !0;
        t = tI;
      }
      const r = new Set();
      let i, o, a, s, u, c, l;
      for (const t of e) ">" === t.operator || ">=" === t.operator ? i = rI(i, t, n) : "<" === t.operator || "<=" === t.operator ? o = iI(o, t, n) : r.add(t.semver);
      if (r.size > 1) return null;
      if (i && o) {
        if (a = XR(i.semver, o.semver, n), a > 0) return null;
        if (0 === a && (">=" !== i.operator || "<=" !== o.operator)) return null;
      }
      for (const e of r) {
        if (i && !JR(e, String(i), n)) return null;
        if (o && !JR(e, String(o), n)) return null;
        for (const r of t) if (!JR(e, String(r), n)) return !1;
        return !0;
      }
      let d = !(!o || n.includePrerelease || !o.semver.prerelease.length) && o.semver,
        f = !(!i || n.includePrerelease || !i.semver.prerelease.length) && i.semver;
      d && 1 === d.prerelease.length && "<" === o.operator && 0 === d.prerelease[0] && (d = !1);
      for (const e of t) {
        if (l = l || ">" === e.operator || ">=" === e.operator, c = c || "<" === e.operator || "<=" === e.operator, i) if (f && e.semver.prerelease && e.semver.prerelease.length && e.semver.major === f.major && e.semver.minor === f.minor && e.semver.patch === f.patch && (f = !1), ">" === e.operator || ">=" === e.operator) {
          if (s = rI(i, e, n), s === e && s !== i) return !1;
        } else if (">=" === i.operator && !JR(i.semver, String(e), n)) return !1;
        if (o) if (d && e.semver.prerelease && e.semver.prerelease.length && e.semver.major === d.major && e.semver.minor === d.minor && e.semver.patch === d.patch && (d = !1), "<" === e.operator || "<=" === e.operator) {
          if (u = iI(o, e, n), u === e && u !== o) return !1;
        } else if ("<=" === o.operator && !JR(o.semver, String(e), n)) return !1;
        if (!e.operator && (o || i) && 0 !== a) return !1;
      }
      return !(i && c && !o && 0 !== a) && !(o && l && !i && 0 !== a) && !f && !d;
    },
    rI = (e, t, n) => {
      if (!e) return t;
      const r = XR(e.semver, t.semver, n);
      return r > 0 ? e : r < 0 || ">" === t.operator && ">=" === e.operator ? t : e;
    },
    iI = (e, t, n) => {
      if (!e) return t;
      const r = XR(e.semver, t.semver, n);
      return r < 0 ? e : r > 0 || "<" === t.operator && "<=" === e.operator ? t : e;
    };
  var oI = (e, t, n = {}) => {
    if (e === t) return !0;
    e = new GR(e, n), t = new GR(t, n);
    let r = !1;
    e: for (const i of e.set) {
      for (const e of t.set) {
        const t = nI(i, e, n);
        if (r = r || null !== t, t) continue e;
      }
      if (r) return !1;
    }
    return !0;
  };
  const aI = UC,
    sI = FC,
    uI = tx,
    cI = WC,
    lI = (e, t, n) => {
      const r = [];
      let i = null,
        o = null;
      const a = e.sort((e, t) => YR(e, t, n));
      for (const e of a) {
        WR(e, t, n) ? (o = e, i || (i = e)) : (o && r.push([i, o]), o = null, i = null);
      }
      i && r.push([i, null]);
      const s = [];
      for (const [e, t] of r) e === t ? s.push(e) : t || e !== a[0] ? t ? e === a[0] ? s.push(`<=${t}`) : s.push(`${e} - ${t}`) : s.push(`>=${e}`) : s.push("*");
      const u = s.join(" || "),
        c = "string" == typeof t.raw ? t.raw : String(t);
      return u.length < c.length ? u : t;
    };
  var dI = {
    parse: rx,
    valid: ox,
    clean: sx,
    inc: cx,
    diff: dx,
    major: hx,
    minor: mx,
    patch: vx,
    prerelease: yx,
    compare: Ax,
    rcompare: Ex,
    compareLoose: kx,
    compareBuild: Cx,
    sort: Rx,
    rsort: Tx,
    gt: Ox,
    lt: Nx,
    eq: Bx,
    neq: Fx,
    gte: Ux,
    lte: Kx,
    cmp: Qx,
    coerce: dR,
    Comparator: pR(),
    Range: hR(),
    satisfies: gR,
    toComparators: bR,
    maxSatisfying: AR,
    minSatisfying: SR,
    minVersion: xR,
    validRange: IR,
    outside: zR,
    gtr: qR,
    ltr: HR,
    intersects: $R,
    simplifyRange: lI,
    subset: oI,
    SemVer: uI,
    re: aI.re,
    src: aI.src,
    tokens: aI.t,
    SEMVER_SPEC_VERSION: sI.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: sI.RELEASE_TYPES,
    compareIdentifiers: cI.compareIdentifiers,
    rcompareIdentifiers: cI.rcompareIdentifiers
  };
  Object.defineProperty(BC, "__esModule", {
    value: !0
  });
  var fI = $S,
    hI = dI,
    pI = Yk,
    mI = pI.refine.call(void 0, pI.string.call(void 0), "Version", e => null !== hI.valid.call(void 0, e) || `Expected SemVer version, got "${e}"`),
    gI = pI.refine.call(void 0, pI.string.call(void 0), "Version range", e => null !== hI.validRange.call(void 0, e) || `Expected SemVer range, got "${e}"`);
  BC.VersionStruct = mI, BC.VersionRangeStruct = gI, BC.isValidSemVerVersion = function (e) {
    return pI.is.call(void 0, e, mI);
  }, BC.isValidSemVerRange = function (e) {
    return pI.is.call(void 0, e, gI);
  }, BC.assertIsSemVerVersion = function (e) {
    fI.assertStruct.call(void 0, e, mI);
  }, BC.assertIsSemVerRange = function (e) {
    fI.assertStruct.call(void 0, e, gI);
  }, BC.gtVersion = function (e, t) {
    return hI.gt.call(void 0, e, t);
  }, BC.gtRange = function (e, t) {
    return hI.gtr.call(void 0, e, t);
  }, BC.satisfiesVersionRange = function (e, t) {
    return hI.satisfies.call(void 0, e, t, {
      includePrerelease: !0
    });
  };
  var vI = {};
  Object.defineProperty(vI, "__esModule", {
    value: !0
  });
  var bI = $S,
    yI = YS,
    wI = Yk,
    AI = e => wI.object.call(void 0, e);
  function _I({
    path: e,
    branch: t
  }) {
    const n = e[e.length - 1];
    return yI.hasProperty.call(void 0, t[t.length - 2], n);
  }
  function EI(e) {
    return new wI.Struct({
      ...e,
      type: `optional ${e.type}`,
      validator: (t, n) => !_I(n) || e.validator(t, n),
      refiner: (t, n) => !_I(n) || e.refiner(t, n)
    });
  }
  var SI = wI.union.call(void 0, [wI.literal.call(void 0, null), wI.boolean.call(void 0), wI.define.call(void 0, "finite number", e => wI.is.call(void 0, e, wI.number.call(void 0)) && Number.isFinite(e)), wI.string.call(void 0), wI.array.call(void 0, wI.lazy.call(void 0, () => SI)), wI.record.call(void 0, wI.string.call(void 0), wI.lazy.call(void 0, () => SI))]),
    kI = wI.coerce.call(void 0, SI, wI.any.call(void 0), e => (bI.assertStruct.call(void 0, e, SI), JSON.parse(JSON.stringify(e, (e, t) => {
      if ("__proto__" !== e && "constructor" !== e) return t;
    }))));
  function MI(e) {
    return wI.create.call(void 0, e, kI);
  }
  var CI = wI.literal.call(void 0, "2.0"),
    xI = wI.nullable.call(void 0, wI.union.call(void 0, [wI.number.call(void 0), wI.string.call(void 0)])),
    RI = AI({
      code: wI.integer.call(void 0),
      message: wI.string.call(void 0),
      data: EI(kI),
      stack: EI(wI.string.call(void 0))
    }),
    II = wI.union.call(void 0, [wI.record.call(void 0, wI.string.call(void 0), kI), wI.array.call(void 0, kI)]),
    TI = AI({
      id: xI,
      jsonrpc: CI,
      method: wI.string.call(void 0),
      params: EI(II)
    }),
    PI = AI({
      jsonrpc: CI,
      method: wI.string.call(void 0),
      params: EI(II)
    });
  var OI = wI.object.call(void 0, {
      id: xI,
      jsonrpc: CI,
      result: wI.optional.call(void 0, wI.unknown.call(void 0)),
      error: wI.optional.call(void 0, RI)
    }),
    LI = AI({
      id: xI,
      jsonrpc: CI,
      result: kI
    }),
    NI = AI({
      id: xI,
      jsonrpc: CI,
      error: RI
    }),
    DI = wI.union.call(void 0, [LI, NI]);
  vI.object = AI, vI.exactOptional = EI, vI.UnsafeJsonStruct = SI, vI.JsonStruct = kI, vI.isValidJson = function (e) {
    try {
      return MI(e), !0;
    } catch (e) {
      return !1;
    }
  }, vI.getSafeJson = MI, vI.getJsonSize = function (e) {
    bI.assertStruct.call(void 0, e, kI, "Invalid JSON value");
    const t = JSON.stringify(e);
    return new TextEncoder().encode(t).byteLength;
  }, vI.jsonrpc2 = "2.0", vI.JsonRpcVersionStruct = CI, vI.JsonRpcIdStruct = xI, vI.JsonRpcErrorStruct = RI, vI.JsonRpcParamsStruct = II, vI.JsonRpcRequestStruct = TI, vI.JsonRpcNotificationStruct = PI, vI.isJsonRpcNotification = function (e) {
    return wI.is.call(void 0, e, PI);
  }, vI.assertIsJsonRpcNotification = function (e, t) {
    bI.assertStruct.call(void 0, e, PI, "Invalid JSON-RPC notification", t);
  }, vI.isJsonRpcRequest = function (e) {
    return wI.is.call(void 0, e, TI);
  }, vI.assertIsJsonRpcRequest = function (e, t) {
    bI.assertStruct.call(void 0, e, TI, "Invalid JSON-RPC request", t);
  }, vI.PendingJsonRpcResponseStruct = OI, vI.JsonRpcSuccessStruct = LI, vI.JsonRpcFailureStruct = NI, vI.JsonRpcResponseStruct = DI, vI.isPendingJsonRpcResponse = function (e) {
    return wI.is.call(void 0, e, OI);
  }, vI.assertIsPendingJsonRpcResponse = function (e, t) {
    bI.assertStruct.call(void 0, e, OI, "Invalid pending JSON-RPC response", t);
  }, vI.isJsonRpcResponse = function (e) {
    return wI.is.call(void 0, e, DI);
  }, vI.assertIsJsonRpcResponse = function (e, t) {
    bI.assertStruct.call(void 0, e, DI, "Invalid JSON-RPC response", t);
  }, vI.isJsonRpcSuccess = function (e) {
    return wI.is.call(void 0, e, LI);
  }, vI.assertIsJsonRpcSuccess = function (e, t) {
    bI.assertStruct.call(void 0, e, LI, "Invalid JSON-RPC success response", t);
  }, vI.isJsonRpcFailure = function (e) {
    return wI.is.call(void 0, e, NI);
  }, vI.assertIsJsonRpcFailure = function (e, t) {
    bI.assertStruct.call(void 0, e, NI, "Invalid JSON-RPC failure response", t);
  }, vI.isJsonRpcError = function (e) {
    return wI.is.call(void 0, e, RI);
  }, vI.assertIsJsonRpcError = function (e, t) {
    bI.assertStruct.call(void 0, e, RI, "Invalid JSON-RPC error", t);
  }, vI.getJsonRpcIdValidator = function (e) {
    const {
      permitEmptyString: t,
      permitFractions: n,
      permitNull: r
    } = {
      permitEmptyString: !0,
      permitFractions: !1,
      permitNull: !0,
      ...e
    };
    return e => Boolean("number" == typeof e && (n || Number.isInteger(e)) || "string" == typeof e && (t || e.length > 0) || r && null === e);
  };
  var BI,
    jI,
    FI = {},
    zI = {
      exports: {}
    };
  function UI() {
    if (jI) return BI;
    jI = 1;
    var e = 1e3,
      t = 60 * e,
      n = 60 * t,
      r = 24 * n,
      i = 7 * r,
      o = 365.25 * r;
    function a(e, t, n, r) {
      var i = t >= 1.5 * n;
      return Math.round(e / n) + " " + r + (i ? "s" : "");
    }
    return BI = function (s, u) {
      u = u || {};
      var c = typeof s;
      if ("string" === c && s.length > 0) return function (a) {
        if ((a = String(a)).length > 100) return;
        var s = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(a);
        if (!s) return;
        var u = parseFloat(s[1]);
        switch ((s[2] || "ms").toLowerCase()) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return u * o;
          case "weeks":
          case "week":
          case "w":
            return u * i;
          case "days":
          case "day":
          case "d":
            return u * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return u * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return u * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return u * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return u;
          default:
            return;
        }
      }(s);
      if ("number" === c && isFinite(s)) return u.long ? function (i) {
        var o = Math.abs(i);
        if (o >= r) return a(i, o, r, "day");
        if (o >= n) return a(i, o, n, "hour");
        if (o >= t) return a(i, o, t, "minute");
        if (o >= e) return a(i, o, e, "second");
        return i + " ms";
      }(s) : function (i) {
        var o = Math.abs(i);
        if (o >= r) return Math.round(i / r) + "d";
        if (o >= n) return Math.round(i / n) + "h";
        if (o >= t) return Math.round(i / t) + "m";
        if (o >= e) return Math.round(i / e) + "s";
        return i + "ms";
      }(s);
      throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(s));
    }, BI;
  }
  var qI = function (e) {
    function t(e) {
      let r,
        i,
        o,
        a = null;
      function s(...e) {
        if (!s.enabled) return;
        const n = s,
          i = Number(new Date()),
          o = i - (r || i);
        n.diff = o, n.prev = r, n.curr = i, r = i, e[0] = t.coerce(e[0]), "string" != typeof e[0] && e.unshift("%O");
        let a = 0;
        e[0] = e[0].replace(/%([a-zA-Z%])/g, (r, i) => {
          if ("%%" === r) return "%";
          a++;
          const o = t.formatters[i];
          if ("function" == typeof o) {
            const t = e[a];
            r = o.call(n, t), e.splice(a, 1), a--;
          }
          return r;
        }), t.formatArgs.call(n, e);
        (n.log || t.log).apply(n, e);
      }
      return s.namespace = e, s.useColors = t.useColors(), s.color = t.selectColor(e), s.extend = n, s.destroy = t.destroy, Object.defineProperty(s, "enabled", {
        enumerable: !0,
        configurable: !1,
        get: () => null !== a ? a : (i !== t.namespaces && (i = t.namespaces, o = t.enabled(e)), o),
        set: e => {
          a = e;
        }
      }), "function" == typeof t.init && t.init(s), s;
    }
    function n(e, n) {
      const r = t(this.namespace + (void 0 === n ? ":" : n) + e);
      return r.log = this.log, r;
    }
    function r(e) {
      return e.toString().substring(2, e.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    return t.debug = t, t.default = t, t.coerce = function (e) {
      if (e instanceof Error) return e.stack || e.message;
      return e;
    }, t.disable = function () {
      const e = [...t.names.map(r), ...t.skips.map(r).map(e => "-" + e)].join(",");
      return t.enable(""), e;
    }, t.enable = function (e) {
      let n;
      t.save(e), t.namespaces = e, t.names = [], t.skips = [];
      const r = ("string" == typeof e ? e : "").split(/[\s,]+/),
        i = r.length;
      for (n = 0; n < i; n++) r[n] && ("-" === (e = r[n].replace(/\*/g, ".*?"))[0] ? t.skips.push(new RegExp("^" + e.slice(1) + "$")) : t.names.push(new RegExp("^" + e + "$")));
    }, t.enabled = function (e) {
      if ("*" === e[e.length - 1]) return !0;
      let n, r;
      for (n = 0, r = t.skips.length; n < r; n++) if (t.skips[n].test(e)) return !1;
      for (n = 0, r = t.names.length; n < r; n++) if (t.names[n].test(e)) return !0;
      return !1;
    }, t.humanize = UI(), t.destroy = function () {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }, Object.keys(e).forEach(n => {
      t[n] = e[n];
    }), t.names = [], t.skips = [], t.formatters = {}, t.selectColor = function (e) {
      let n = 0;
      for (let t = 0; t < e.length; t++) n = (n << 5) - n + e.charCodeAt(t), n |= 0;
      return t.colors[Math.abs(n) % t.colors.length];
    }, t.enable(t.load()), t;
  };
  !function (e, t) {
    t.formatArgs = function (t) {
      if (t[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + t[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors) return;
      const n = "color: " + this.color;
      t.splice(1, 0, n, "color: inherit");
      let r = 0,
        i = 0;
      t[0].replace(/%[a-zA-Z%]/g, e => {
        "%%" !== e && (r++, "%c" === e && (i = r));
      }), t.splice(i, 0, n);
    }, t.save = function (e) {
      try {
        e ? t.storage.setItem("debug", e) : t.storage.removeItem("debug");
      } catch (e) {}
    }, t.load = function () {
      let e;
      try {
        e = t.storage.getItem("debug");
      } catch (e) {}
      !e && void 0 !== Be && "env" in Be && (e = Be.env.DEBUG);
      return e;
    }, t.useColors = function () {
      if ("undefined" != typeof window && window.process && ("renderer" === window.process.type || window.process.__nwjs)) return !0;
      if ("undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
      return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }, t.storage = function () {
      try {
        return localStorage;
      } catch (e) {}
    }(), t.destroy = (() => {
      let e = !1;
      return () => {
        e || (e = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
      };
    })(), t.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], t.log = console.debug || console.log || (() => {}), e.exports = qI(t);
    const {
      formatters: n
    } = e.exports;
    n.j = function (e) {
      try {
        return JSON.stringify(e);
      } catch (e) {
        return "[UnexpectedJSONParseError]: " + e.message;
      }
    };
  }(zI, zI.exports);
  var KI = zI.exports,
    HI = r(KI);
  Object.defineProperty(FI, "__esModule", {
    value: !0
  });
  var VI,
    $I = ((VI = KI) && VI.__esModule ? VI : {
      default: VI
    }).default.call(void 0, "metamask");
  FI.createProjectLogger = function (e) {
    return $I.extend(e);
  }, FI.createModuleLogger = function (e, t) {
    return e.extend(t);
  };
  var WI = {};
  function YI(e) {
    let t,
      n = e[0],
      r = 1;
    for (; r < e.length;) {
      const i = e[r],
        o = e[r + 1];
      if (r += 2, ("optionalAccess" === i || "optionalCall" === i) && null == n) return;
      "access" === i || "optionalAccess" === i ? (t = n, n = o(n)) : "call" !== i && "optionalCall" !== i || (n = o((...e) => n.call(t, ...e)), t = void 0);
    }
    return n;
  }
  Object.defineProperty(WI, "__esModule", {
    value: !0
  });
  var GI = Yk,
    QI = /^(?<namespace>[-a-z0-9]{3,8}):(?<reference>[-_a-zA-Z0-9]{1,32})$/u,
    ZI = /^[-a-z0-9]{3,8}$/u,
    JI = /^[-_a-zA-Z0-9]{1,32}$/u,
    XI = /^(?<chainId>(?<namespace>[-a-z0-9]{3,8}):(?<reference>[-_a-zA-Z0-9]{1,32})):(?<accountAddress>[-.%a-zA-Z0-9]{1,128})$/u,
    eT = /^[-.%a-zA-Z0-9]{1,128}$/u,
    tT = GI.pattern.call(void 0, GI.string.call(void 0), QI),
    nT = GI.pattern.call(void 0, GI.string.call(void 0), ZI),
    rT = GI.pattern.call(void 0, GI.string.call(void 0), JI),
    iT = GI.pattern.call(void 0, GI.string.call(void 0), XI),
    oT = GI.pattern.call(void 0, GI.string.call(void 0), eT);
  WI.CAIP_CHAIN_ID_REGEX = QI, WI.CAIP_NAMESPACE_REGEX = ZI, WI.CAIP_REFERENCE_REGEX = JI, WI.CAIP_ACCOUNT_ID_REGEX = XI, WI.CAIP_ACCOUNT_ADDRESS_REGEX = eT, WI.CaipChainIdStruct = tT, WI.CaipNamespaceStruct = nT, WI.CaipReferenceStruct = rT, WI.CaipAccountIdStruct = iT, WI.CaipAccountAddressStruct = oT, WI.isCaipChainId = function (e) {
    return GI.is.call(void 0, e, tT);
  }, WI.isCaipNamespace = function (e) {
    return GI.is.call(void 0, e, nT);
  }, WI.isCaipReference = function (e) {
    return GI.is.call(void 0, e, rT);
  }, WI.isCaipAccountId = function (e) {
    return GI.is.call(void 0, e, iT);
  }, WI.isCaipAccountAddress = function (e) {
    return GI.is.call(void 0, e, oT);
  }, WI.parseCaipChainId = function (e) {
    const t = QI.exec(e);
    if (!YI([t, "optionalAccess", e => e.groups])) throw new Error("Invalid CAIP chain ID.");
    return {
      namespace: t.groups.namespace,
      reference: t.groups.reference
    };
  }, WI.parseCaipAccountId = function (e) {
    const t = XI.exec(e);
    if (!YI([t, "optionalAccess", e => e.groups])) throw new Error("Invalid CAIP account ID.");
    return {
      address: t.groups.accountAddress,
      chainId: t.groups.chainId,
      chain: {
        namespace: t.groups.namespace,
        reference: t.groups.reference
      }
    };
  };
  var aT = {},
    sT = {};
  function uT(e, t) {
    return null != e ? e : t();
  }
  Object.defineProperty(sT, "__esModule", {
    value: !0
  });
  var cT = $S,
    lT = Yk;
  sT.base64 = (e, t = {}) => {
    const n = uT(t.paddingRequired, () => !1),
      r = uT(t.characterSet, () => "base64");
    let i, o;
    return "base64" === r ? i = String.raw`[A-Za-z0-9+\/]` : (cT.assert.call(void 0, "base64url" === r), i = String.raw`[-_A-Za-z0-9]`), o = n ? new RegExp(`^(?:${i}{4})*(?:${i}{3}=|${i}{2}==)?$`, "u") : new RegExp(`^(?:${i}{4})*(?:${i}{2,3}|${i}{3}=|${i}{2}==)?$`, "u"), lT.pattern.call(void 0, e, o);
  }, Object.defineProperty(aT, "__esModule", {
    value: !0
  });
  var dT = sT,
    fT = Yk,
    hT = fT.size.call(void 0, dT.base64.call(void 0, fT.string.call(void 0), {
      paddingRequired: !0
    }), 44, 44);
  aT.ChecksumStruct = hT;
  var pT = {};
  Object.defineProperty(pT, "__esModule", {
    value: !0
  });
  var mT = VS,
    gT = $S,
    vT = Yk,
    bT = vT.union.call(void 0, [vT.number.call(void 0), vT.bigint.call(void 0), vT.string.call(void 0), mT.StrictHexStruct]),
    yT = vT.coerce.call(void 0, vT.number.call(void 0), bT, Number),
    wT = vT.coerce.call(void 0, vT.bigint.call(void 0), bT, BigInt);
  vT.union.call(void 0, [mT.StrictHexStruct, vT.instance.call(void 0, Uint8Array)]);
  var AT = vT.coerce.call(void 0, vT.instance.call(void 0, Uint8Array), vT.union.call(void 0, [mT.StrictHexStruct]), mT.hexToBytes),
    _T = vT.coerce.call(void 0, mT.StrictHexStruct, vT.instance.call(void 0, Uint8Array), mT.bytesToHex);
  pT.createNumber = function (e) {
    try {
      const t = vT.create.call(void 0, e, yT);
      return gT.assert.call(void 0, Number.isFinite(t), `Expected a number-like value, got "${e}".`), t;
    } catch (t) {
      if (t instanceof vT.StructError) throw new Error(`Expected a number-like value, got "${e}".`);
      throw t;
    }
  }, pT.createBigInt = function (e) {
    try {
      return vT.create.call(void 0, e, wT);
    } catch (e) {
      if (e instanceof vT.StructError) throw new Error(`Expected a number-like value, got "${String(e.value)}".`);
      throw e;
    }
  }, pT.createBytes = function (e) {
    if ("string" == typeof e && "0x" === e.toLowerCase()) return new Uint8Array();
    try {
      return vT.create.call(void 0, e, AT);
    } catch (e) {
      if (e instanceof vT.StructError) throw new Error(`Expected a bytes-like value, got "${String(e.value)}".`);
      throw e;
    }
  }, pT.createHex = function (e) {
    if (e instanceof Uint8Array && 0 === e.length || "string" == typeof e && "0x" === e.toLowerCase()) return "0x";
    try {
      return vT.create.call(void 0, e, _T);
    } catch (e) {
      if (e instanceof vT.StructError) throw new Error(`Expected a bytes-like value, got "${String(e.value)}".`);
      throw e;
    }
  };
  var ET = {},
    ST = {};
  Object.defineProperty(ST, "__esModule", {
    value: !0
  });
  var kT = (e, t, n) => {
    if (!t.has(e)) throw TypeError("Cannot " + n);
  };
  ST.__privateGet = (e, t, n) => (kT(e, t, "read from private field"), n ? n.call(e) : t.get(e)), ST.__privateAdd = (e, t, n) => {
    if (t.has(e)) throw TypeError("Cannot add the same private member more than once");
    t instanceof WeakSet ? t.add(e) : t.set(e, n);
  }, ST.__privateSet = (e, t, n, r) => (kT(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), Object.defineProperty(ET, "__esModule", {
    value: !0
  });
  var MT,
    CT,
    xT = ST,
    RT = class {
      constructor(e) {
        xT.__privateAdd.call(void 0, this, MT, void 0), xT.__privateSet.call(void 0, this, MT, new Map(e)), Object.freeze(this);
      }
      get size() {
        return xT.__privateGet.call(void 0, this, MT).size;
      }
      [Symbol.iterator]() {
        return xT.__privateGet.call(void 0, this, MT)[Symbol.iterator]();
      }
      entries() {
        return xT.__privateGet.call(void 0, this, MT).entries();
      }
      forEach(e, t) {
        return xT.__privateGet.call(void 0, this, MT).forEach((n, r, i) => e.call(t, n, r, this));
      }
      get(e) {
        return xT.__privateGet.call(void 0, this, MT).get(e);
      }
      has(e) {
        return xT.__privateGet.call(void 0, this, MT).has(e);
      }
      keys() {
        return xT.__privateGet.call(void 0, this, MT).keys();
      }
      values() {
        return xT.__privateGet.call(void 0, this, MT).values();
      }
      toString() {
        return `FrozenMap(${this.size}) {${this.size > 0 ? ` ${[...this.entries()].map(([e, t]) => `${String(e)} => ${String(t)}`).join(", ")} ` : ""}}`;
      }
    };
  MT = new WeakMap();
  var IT = class {
    constructor(e) {
      xT.__privateAdd.call(void 0, this, CT, void 0), xT.__privateSet.call(void 0, this, CT, new Set(e)), Object.freeze(this);
    }
    get size() {
      return xT.__privateGet.call(void 0, this, CT).size;
    }
    [Symbol.iterator]() {
      return xT.__privateGet.call(void 0, this, CT)[Symbol.iterator]();
    }
    entries() {
      return xT.__privateGet.call(void 0, this, CT).entries();
    }
    forEach(e, t) {
      return xT.__privateGet.call(void 0, this, CT).forEach((n, r, i) => e.call(t, n, r, this));
    }
    has(e) {
      return xT.__privateGet.call(void 0, this, CT).has(e);
    }
    keys() {
      return xT.__privateGet.call(void 0, this, CT).keys();
    }
    values() {
      return xT.__privateGet.call(void 0, this, CT).values();
    }
    toString() {
      return `FrozenSet(${this.size}) {${this.size > 0 ? ` ${[...this.values()].map(e => String(e)).join(", ")} ` : ""}}`;
    }
  };
  CT = new WeakMap(), Object.freeze(RT), Object.freeze(RT.prototype), Object.freeze(IT), Object.freeze(IT.prototype), ET.FrozenMap = RT, ET.FrozenSet = IT, Object.defineProperty(KS, "__esModule", {
    value: !0
  });
  var TT = HS,
    PT = OC,
    OT = LC,
    LT = BC,
    NT = vI,
    DT = FI,
    BT = WI,
    jT = aT,
    FT = sT,
    zT = pT,
    UT = VS,
    qT = $S,
    KT = WS,
    HT = YS,
    VT = ET;
  KS.AssertionError = qT.AssertionError, KS.CAIP_ACCOUNT_ADDRESS_REGEX = BT.CAIP_ACCOUNT_ADDRESS_REGEX, KS.CAIP_ACCOUNT_ID_REGEX = BT.CAIP_ACCOUNT_ID_REGEX, KS.CAIP_CHAIN_ID_REGEX = BT.CAIP_CHAIN_ID_REGEX, KS.CAIP_NAMESPACE_REGEX = BT.CAIP_NAMESPACE_REGEX, KS.CAIP_REFERENCE_REGEX = BT.CAIP_REFERENCE_REGEX, KS.CaipAccountAddressStruct = BT.CaipAccountAddressStruct, KS.CaipAccountIdStruct = BT.CaipAccountIdStruct, KS.CaipChainIdStruct = BT.CaipChainIdStruct, KS.CaipNamespaceStruct = BT.CaipNamespaceStruct, KS.CaipReferenceStruct = BT.CaipReferenceStruct, KS.ChecksumStruct = jT.ChecksumStruct, KS.Duration = OT.Duration, KS.ESCAPE_CHARACTERS_REGEXP = HT.ESCAPE_CHARACTERS_REGEXP, KS.FrozenMap = VT.FrozenMap, KS.FrozenSet = VT.FrozenSet, KS.HexAddressStruct = UT.HexAddressStruct, KS.HexChecksumAddressStruct = UT.HexChecksumAddressStruct, KS.HexStruct = UT.HexStruct, KS.JsonRpcErrorStruct = NT.JsonRpcErrorStruct, KS.JsonRpcFailureStruct = NT.JsonRpcFailureStruct, KS.JsonRpcIdStruct = NT.JsonRpcIdStruct, KS.JsonRpcNotificationStruct = NT.JsonRpcNotificationStruct, KS.JsonRpcParamsStruct = NT.JsonRpcParamsStruct, KS.JsonRpcRequestStruct = NT.JsonRpcRequestStruct, KS.JsonRpcResponseStruct = NT.JsonRpcResponseStruct, KS.JsonRpcSuccessStruct = NT.JsonRpcSuccessStruct, KS.JsonRpcVersionStruct = NT.JsonRpcVersionStruct, KS.JsonSize = HT.JsonSize, KS.JsonStruct = NT.JsonStruct, KS.PendingJsonRpcResponseStruct = NT.PendingJsonRpcResponseStruct, KS.StrictHexStruct = UT.StrictHexStruct, KS.UnsafeJsonStruct = NT.UnsafeJsonStruct, KS.VersionRangeStruct = LT.VersionRangeStruct, KS.VersionStruct = LT.VersionStruct, KS.add0x = UT.add0x, KS.assert = qT.assert, KS.assertExhaustive = qT.assertExhaustive, KS.assertIsBytes = UT.assertIsBytes, KS.assertIsHexString = UT.assertIsHexString, KS.assertIsJsonRpcError = NT.assertIsJsonRpcError, KS.assertIsJsonRpcFailure = NT.assertIsJsonRpcFailure, KS.assertIsJsonRpcNotification = NT.assertIsJsonRpcNotification, KS.assertIsJsonRpcRequest = NT.assertIsJsonRpcRequest, KS.assertIsJsonRpcResponse = NT.assertIsJsonRpcResponse, KS.assertIsJsonRpcSuccess = NT.assertIsJsonRpcSuccess, KS.assertIsPendingJsonRpcResponse = NT.assertIsPendingJsonRpcResponse, KS.assertIsSemVerRange = LT.assertIsSemVerRange, KS.assertIsSemVerVersion = LT.assertIsSemVerVersion, KS.assertIsStrictHexString = UT.assertIsStrictHexString, KS.assertStruct = qT.assertStruct, KS.base64 = FT.base64, KS.base64ToBytes = UT.base64ToBytes, KS.bigIntToBytes = UT.bigIntToBytes, KS.bigIntToHex = TT.bigIntToHex, KS.bytesToBase64 = UT.bytesToBase64, KS.bytesToBigInt = UT.bytesToBigInt, KS.bytesToHex = UT.bytesToHex, KS.bytesToNumber = UT.bytesToNumber, KS.bytesToSignedBigInt = UT.bytesToSignedBigInt, KS.bytesToString = UT.bytesToString, KS.calculateNumberSize = HT.calculateNumberSize, KS.calculateStringSize = HT.calculateStringSize, KS.concatBytes = UT.concatBytes, KS.createBigInt = zT.createBigInt, KS.createBytes = zT.createBytes, KS.createDataView = UT.createDataView, KS.createDeferredPromise = PT.createDeferredPromise, KS.createHex = zT.createHex, KS.createModuleLogger = DT.createModuleLogger, KS.createNumber = zT.createNumber, KS.createProjectLogger = DT.createProjectLogger, KS.exactOptional = NT.exactOptional, KS.getChecksumAddress = UT.getChecksumAddress, KS.getErrorMessage = KT.getErrorMessage, KS.getJsonRpcIdValidator = NT.getJsonRpcIdValidator, KS.getJsonSize = NT.getJsonSize, KS.getKnownPropertyNames = HT.getKnownPropertyNames, KS.getSafeJson = NT.getSafeJson, KS.gtRange = LT.gtRange, KS.gtVersion = LT.gtVersion, KS.hasProperty = HT.hasProperty, KS.hexToBigInt = TT.hexToBigInt, KS.hexToBytes = UT.hexToBytes, KS.hexToNumber = TT.hexToNumber, KS.inMilliseconds = OT.inMilliseconds, KS.isASCII = HT.isASCII, KS.isBytes = UT.isBytes, KS.isCaipAccountAddress = BT.isCaipAccountAddress, KS.isCaipAccountId = BT.isCaipAccountId, KS.isCaipChainId = BT.isCaipChainId, KS.isCaipNamespace = BT.isCaipNamespace, KS.isCaipReference = BT.isCaipReference, KS.isErrorWithCode = KT.isErrorWithCode, KS.isErrorWithMessage = KT.isErrorWithMessage, KS.isErrorWithStack = KT.isErrorWithStack, KS.isHexString = UT.isHexString, KS.isJsonRpcError = NT.isJsonRpcError, KS.isJsonRpcFailure = NT.isJsonRpcFailure, KS.isJsonRpcNotification = NT.isJsonRpcNotification, KS.isJsonRpcRequest = NT.isJsonRpcRequest, KS.isJsonRpcResponse = NT.isJsonRpcResponse, KS.isJsonRpcSuccess = NT.isJsonRpcSuccess, KS.isNonEmptyArray = HT.isNonEmptyArray, KS.isNullOrUndefined = HT.isNullOrUndefined, KS.isObject = HT.isObject, KS.isPendingJsonRpcResponse = NT.isPendingJsonRpcResponse, KS.isPlainObject = HT.isPlainObject, KS.isStrictHexString = UT.isStrictHexString, KS.isValidChecksumAddress = UT.isValidChecksumAddress, KS.isValidHexAddress = UT.isValidHexAddress, KS.isValidJson = NT.isValidJson, KS.isValidSemVerRange = LT.isValidSemVerRange, KS.isValidSemVerVersion = LT.isValidSemVerVersion, KS.jsonrpc2 = NT.jsonrpc2, KS.numberToBytes = UT.numberToBytes, KS.numberToHex = TT.numberToHex, KS.object = NT.object, KS.parseCaipAccountId = BT.parseCaipAccountId, KS.parseCaipChainId = BT.parseCaipChainId, KS.remove0x = UT.remove0x, KS.satisfiesVersionRange = LT.satisfiesVersionRange, KS.signedBigIntToBytes = UT.signedBigIntToBytes, KS.stringToBytes = UT.stringToBytes, KS.timeSince = OT.timeSince, KS.valueToBytes = UT.valueToBytes, KS.wrapError = KT.wrapError, Object.defineProperty(US, "__esModule", {
    value: !0
  });
  var $T = qS,
    WT = KS,
    YT = $T.errorCodes.rpc.internal,
    GT = {
      code: YT,
      message: ZT(YT)
    },
    QT = "Unspecified server error.";
  function ZT(e, t = "Unspecified error message. This is a bug, please report it.") {
    if (JT(e)) {
      const t = e.toString();
      if (WT.hasProperty.call(void 0, $T.errorValues, t)) return $T.errorValues[t].message;
      if (function (e) {
        return e >= -32099 && e <= -32e3;
      }(e)) return QT;
    }
    return t;
  }
  function JT(e) {
    return Number.isInteger(e);
  }
  function XT(e) {
    return Array.isArray(e) ? e.map(e => WT.isValidJson.call(void 0, e) ? e : WT.isObject.call(void 0, e) ? eP(e) : null) : WT.isObject.call(void 0, e) ? eP(e) : WT.isValidJson.call(void 0, e) ? e : null;
  }
  function eP(e) {
    return Object.getOwnPropertyNames(e).reduce((t, n) => {
      const r = e[n];
      return WT.isValidJson.call(void 0, r) && (t[n] = r), t;
    }, {});
  }
  US.JSON_RPC_SERVER_ERROR_MESSAGE = QT, US.getMessageFromCode = ZT, US.isValidCode = JT, US.serializeError = function (e, {
    fallbackError: t = GT,
    shouldIncludeStack: n = !0
  } = {}) {
    if (!WT.isJsonRpcError.call(void 0, t)) throw new Error("Must provide fallback error with integer number code and string message.");
    const r = function (e, t) {
      if (e && "object" == typeof e && "serialize" in e && "function" == typeof e.serialize) return e.serialize();
      if (WT.isJsonRpcError.call(void 0, e)) return e;
      const n = XT(e),
        r = {
          ...t,
          data: {
            cause: n
          }
        };
      return r;
    }(e, t);
    return n || delete r.stack, r;
  }, US.serializeCause = XT;
  var tP = sP;
  sP.default = sP, sP.stable = dP, sP.stableStringify = dP;
  var nP = "[...]",
    rP = "[Circular]",
    iP = [],
    oP = [];
  function aP() {
    return {
      depthLimit: Number.MAX_SAFE_INTEGER,
      edgesLimit: Number.MAX_SAFE_INTEGER
    };
  }
  function sP(e, t, n, r) {
    var i;
    void 0 === r && (r = aP()), cP(e, "", 0, [], void 0, 0, r);
    try {
      i = 0 === oP.length ? JSON.stringify(e, t, n) : JSON.stringify(e, hP(t), n);
    } catch (e) {
      return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally {
      for (; 0 !== iP.length;) {
        var o = iP.pop();
        4 === o.length ? Object.defineProperty(o[0], o[1], o[3]) : o[0][o[1]] = o[2];
      }
    }
    return i;
  }
  function uP(e, t, n, r) {
    var i = Object.getOwnPropertyDescriptor(r, n);
    void 0 !== i.get ? i.configurable ? (Object.defineProperty(r, n, {
      value: e
    }), iP.push([r, n, t, i])) : oP.push([t, n, e]) : (r[n] = e, iP.push([r, n, t]));
  }
  function cP(e, t, n, r, i, o, a) {
    var s;
    if (o += 1, "object" == typeof e && null !== e) {
      for (s = 0; s < r.length; s++) if (r[s] === e) return void uP(rP, e, t, i);
      if (void 0 !== a.depthLimit && o > a.depthLimit) return void uP(nP, e, t, i);
      if (void 0 !== a.edgesLimit && n + 1 > a.edgesLimit) return void uP(nP, e, t, i);
      if (r.push(e), Array.isArray(e)) for (s = 0; s < e.length; s++) cP(e[s], s, s, r, e, o, a);else {
        var u = Object.keys(e);
        for (s = 0; s < u.length; s++) {
          var c = u[s];
          cP(e[c], c, s, r, e, o, a);
        }
      }
      r.pop();
    }
  }
  function lP(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
  }
  function dP(e, t, n, r) {
    void 0 === r && (r = aP());
    var i,
      o = fP(e, "", 0, [], void 0, 0, r) || e;
    try {
      i = 0 === oP.length ? JSON.stringify(o, t, n) : JSON.stringify(o, hP(t), n);
    } catch (e) {
      return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally {
      for (; 0 !== iP.length;) {
        var a = iP.pop();
        4 === a.length ? Object.defineProperty(a[0], a[1], a[3]) : a[0][a[1]] = a[2];
      }
    }
    return i;
  }
  function fP(e, t, n, r, i, o, a) {
    var s;
    if (o += 1, "object" == typeof e && null !== e) {
      for (s = 0; s < r.length; s++) if (r[s] === e) return void uP(rP, e, t, i);
      try {
        if ("function" == typeof e.toJSON) return;
      } catch (e) {
        return;
      }
      if (void 0 !== a.depthLimit && o > a.depthLimit) return void uP(nP, e, t, i);
      if (void 0 !== a.edgesLimit && n + 1 > a.edgesLimit) return void uP(nP, e, t, i);
      if (r.push(e), Array.isArray(e)) for (s = 0; s < e.length; s++) fP(e[s], s, s, r, e, o, a);else {
        var u = {},
          c = Object.keys(e).sort(lP);
        for (s = 0; s < c.length; s++) {
          var l = c[s];
          fP(e[l], l, s, r, e, o, a), u[l] = e[l];
        }
        if (void 0 === i) return u;
        iP.push([i, t, e]), i[t] = u;
      }
      r.pop();
    }
  }
  function hP(e) {
    return e = void 0 !== e ? e : function (e, t) {
      return t;
    }, function (t, n) {
      if (oP.length > 0) for (var r = 0; r < oP.length; r++) {
        var i = oP[r];
        if (i[1] === t && i[0] === n) {
          n = i[2], oP.splice(r, 1);
          break;
        }
      }
      return e.call(this, t, n);
    };
  }
  var pP = r(tP);
  Object.defineProperty(zS, "__esModule", {
    value: !0
  });
  var mP = US,
    gP = KS,
    vP = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(tP),
    bP = class extends Error {
      constructor(e, t, n) {
        if (!Number.isInteger(e)) throw new Error('"code" must be an integer.');
        if (!t || "string" != typeof t) throw new Error('"message" must be a non-empty string.');
        super(t), this.code = e, void 0 !== n && (this.data = n);
      }
      serialize() {
        const e = {
          code: this.code,
          message: this.message
        };
        return void 0 !== this.data && (e.data = this.data, gP.isPlainObject.call(void 0, this.data) && (e.data.cause = mP.serializeCause.call(void 0, this.data.cause))), this.stack && (e.stack = this.stack), e;
      }
      toString() {
        return vP.default.call(void 0, this.serialize(), yP, 2);
      }
    };
  function yP(e, t) {
    if ("[Circular]" !== t) return t;
  }
  function wP(e, t) {
    return null != e ? e : t();
  }
  zS.JsonRpcError = bP, zS.EthereumProviderError = class extends bP {
    constructor(e, t, n) {
      if (!function (e) {
        return Number.isInteger(e) && e >= 1e3 && e <= 4999;
      }(e)) throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
      super(e, t, n);
    }
  }, Object.defineProperty(FS, "__esModule", {
    value: !0
  });
  var AP = zS,
    _P = US,
    EP = qS,
    SP = {
      parse: e => MP(EP.errorCodes.rpc.parse, e),
      invalidRequest: e => MP(EP.errorCodes.rpc.invalidRequest, e),
      invalidParams: e => MP(EP.errorCodes.rpc.invalidParams, e),
      methodNotFound: e => MP(EP.errorCodes.rpc.methodNotFound, e),
      internal: e => MP(EP.errorCodes.rpc.internal, e),
      server: e => {
        if (!e || "object" != typeof e || Array.isArray(e)) throw new Error("Ethereum RPC Server errors must provide single object argument.");
        const {
          code: t
        } = e;
        if (!Number.isInteger(t) || t > -32005 || t < -32099) throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
        return MP(t, e);
      },
      invalidInput: e => MP(EP.errorCodes.rpc.invalidInput, e),
      resourceNotFound: e => MP(EP.errorCodes.rpc.resourceNotFound, e),
      resourceUnavailable: e => MP(EP.errorCodes.rpc.resourceUnavailable, e),
      transactionRejected: e => MP(EP.errorCodes.rpc.transactionRejected, e),
      methodNotSupported: e => MP(EP.errorCodes.rpc.methodNotSupported, e),
      limitExceeded: e => MP(EP.errorCodes.rpc.limitExceeded, e)
    },
    kP = {
      userRejectedRequest: e => CP(EP.errorCodes.provider.userRejectedRequest, e),
      unauthorized: e => CP(EP.errorCodes.provider.unauthorized, e),
      unsupportedMethod: e => CP(EP.errorCodes.provider.unsupportedMethod, e),
      disconnected: e => CP(EP.errorCodes.provider.disconnected, e),
      chainDisconnected: e => CP(EP.errorCodes.provider.chainDisconnected, e),
      custom: e => {
        if (!e || "object" != typeof e || Array.isArray(e)) throw new Error("Ethereum Provider custom errors must provide single object argument.");
        const {
          code: t,
          message: n,
          data: r
        } = e;
        if (!n || "string" != typeof n) throw new Error('"message" must be a nonempty string');
        return new AP.EthereumProviderError(t, n, r);
      }
    };
  function MP(e, t) {
    const [n, r] = xP(t);
    return new AP.JsonRpcError(e, wP(n, () => _P.getMessageFromCode.call(void 0, e)), r);
  }
  function CP(e, t) {
    const [n, r] = xP(t);
    return new AP.EthereumProviderError(e, wP(n, () => _P.getMessageFromCode.call(void 0, e)), r);
  }
  function xP(e) {
    if (e) {
      if ("string" == typeof e) return [e];
      if ("object" == typeof e && !Array.isArray(e)) {
        const {
          message: t,
          data: n
        } = e;
        if (t && "string" != typeof t) throw new Error("Must specify string message.");
        return [wP(t, () => {}), n];
      }
    }
    return [];
  }
  FS.rpcErrors = SP, FS.providerErrors = kP, Object.defineProperty(jS, "__esModule", {
    value: !0
  });
  var RP = FS,
    IP = zS,
    TP = US,
    PP = qS;
  jS.EthereumProviderError = IP.EthereumProviderError, jS.JsonRpcError = IP.JsonRpcError, jS.errorCodes = PP.errorCodes, jS.getMessageFromCode = TP.getMessageFromCode, jS.providerErrors = RP.providerErrors, jS.rpcErrors = RP.rpcErrors, jS.serializeCause = TP.serializeCause, jS.serializeError = TP.serializeError;
  var OP = {};
  Object.defineProperty(OP, "__esModule", {
    value: !0
  });
  const LP = nt;
  function NP(e, t, n) {
    try {
      Reflect.apply(e, t, n);
    } catch (e) {
      setTimeout(() => {
        throw e;
      });
    }
  }
  class DP extends LP.EventEmitter {
    emit(e, ...t) {
      let n = "error" === e;
      const r = this._events;
      if (void 0 !== r) n = n && void 0 === r.error;else if (!n) return !1;
      if (n) {
        let e;
        if (t.length > 0 && ([e] = t), e instanceof Error) throw e;
        const n = new Error("Unhandled error." + (e ? ` (${e.message})` : ""));
        throw n.context = e, n;
      }
      const i = r[e];
      if (void 0 === i) return !1;
      if ("function" == typeof i) NP(i, this, t);else {
        const e = i.length,
          n = function (e) {
            const t = e.length,
              n = new Array(t);
            for (let r = 0; r < t; r += 1) n[r] = e[r];
            return n;
          }(i);
        for (let r = 0; r < e; r += 1) NP(n[r], this, t);
      }
      return !0;
    }
  }
  var BP,
    jP,
    FP,
    zP,
    UP,
    qP,
    KP,
    HP,
    VP,
    $P,
    WP,
    YP,
    GP,
    QP = OP.default = DP,
    ZP = n && n.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }
        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            o(e);
          }
        }
        function u(e) {
          e.done ? i(e.value) : function (e) {
            return e instanceof n ? e : new n(function (t) {
              t(e);
            });
          }(e.value).then(a, s);
        }
        u((r = r.apply(e, t || [])).next());
      });
    },
    JP = n && n.__classPrivateFieldSet || function (e, t, n, r, i) {
      if ("m" === r) throw new TypeError("Private method is not writable");
      if ("a" === r && !i) throw new TypeError("Private accessor was defined without a setter");
      if ("function" == typeof t ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
      return "a" === r ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
    },
    XP = n && n.__classPrivateFieldGet || function (e, t, n, r) {
      if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
      if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
    },
    eO = n && n.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
  Object.defineProperty(BS, "__esModule", {
    value: !0
  }), BS.JsonRpcEngine = void 0;
  const tO = jS,
    nO = eO(OP),
    rO = KS;
  class iO extends nO.default {
    constructor({
      notificationHandler: e
    } = {}) {
      super(), BP.add(this), FP.set(this, !1), zP.set(this, void 0), UP.set(this, void 0), JP(this, zP, [], "f"), JP(this, UP, e, "f");
    }
    destroy() {
      XP(this, zP, "f").forEach(e => {
        "destroy" in e && "function" == typeof e.destroy && e.destroy();
      }), JP(this, zP, [], "f"), JP(this, FP, !0, "f");
    }
    push(e) {
      XP(this, BP, "m", qP).call(this), XP(this, zP, "f").push(e);
    }
    handle(e, t) {
      if (XP(this, BP, "m", qP).call(this), t && "function" != typeof t) throw new Error('"callback" must be a function if provided.');
      return Array.isArray(e) ? t ? XP(this, BP, "m", KP).call(this, e, t) : XP(this, BP, "m", KP).call(this, e) : t ? XP(this, BP, "m", HP).call(this, e, t) : this._promiseHandle(e);
    }
    asMiddleware() {
      return XP(this, BP, "m", qP).call(this), (e, t, n, r) => ZP(this, void 0, void 0, function* () {
        try {
          const [i, o, a] = yield XP(iO, jP, "m", $P).call(iO, e, t, XP(this, zP, "f"));
          return o ? (yield XP(iO, jP, "m", YP).call(iO, a), r(i)) : n(e => ZP(this, void 0, void 0, function* () {
            try {
              yield XP(iO, jP, "m", YP).call(iO, a);
            } catch (t) {
              return e(t);
            }
            return e();
          }));
        } catch (e) {
          return r(e);
        }
      });
    }
    _promiseHandle(e) {
      return ZP(this, void 0, void 0, function* () {
        return new Promise((t, n) => {
          XP(this, BP, "m", HP).call(this, e, (e, r) => {
            e && void 0 === r ? n(e) : t(r);
          }).catch(n);
        });
      });
    }
  }
  function oO(e) {
    return JSON.stringify(e, null, 2);
  }
  BS.JsonRpcEngine = iO, jP = iO, FP = new WeakMap(), zP = new WeakMap(), UP = new WeakMap(), BP = new WeakSet(), qP = function () {
    if (XP(this, FP, "f")) throw new Error("This engine is destroyed and can no longer be used.");
  }, KP = function (e, t) {
    return ZP(this, void 0, void 0, function* () {
      try {
        if (0 === e.length) {
          const e = [{
            id: null,
            jsonrpc: "2.0",
            error: new tO.JsonRpcError(tO.errorCodes.rpc.invalidRequest, "Request batch must contain plain objects. Received an empty array")
          }];
          return t ? t(null, e) : e;
        }
        const n = (yield Promise.all(e.map(this._promiseHandle.bind(this)))).filter(e => void 0 !== e);
        return t ? t(null, n) : n;
      } catch (e) {
        if (t) return t(e);
        throw e;
      }
    });
  }, HP = function (e, t) {
    var n;
    return ZP(this, void 0, void 0, function* () {
      if (!e || Array.isArray(e) || "object" != typeof e) {
        const n = new tO.JsonRpcError(tO.errorCodes.rpc.invalidRequest, "Requests must be plain objects. Received: " + typeof e, {
          request: e
        });
        return t(n, {
          id: null,
          jsonrpc: "2.0",
          error: n
        });
      }
      if ("string" != typeof e.method) {
        const r = new tO.JsonRpcError(tO.errorCodes.rpc.invalidRequest, "Must specify a string method. Received: " + typeof e.method, {
          request: e
        });
        return XP(this, UP, "f") && !(0, rO.isJsonRpcRequest)(e) ? t(null) : t(r, {
          id: null !== (n = e.id) && void 0 !== n ? n : null,
          jsonrpc: "2.0",
          error: r
        });
      }
      if (XP(this, UP, "f") && !(0, rO.isJsonRpcRequest)(e)) {
        try {
          yield XP(this, UP, "f").call(this, e);
        } catch (r) {
          return t(r);
        }
        return t(null);
      }
      let r = null;
      const i = Object.assign({}, e),
        o = {
          id: i.id,
          jsonrpc: i.jsonrpc
        };
      try {
        yield XP(iO, jP, "m", VP).call(iO, i, o, XP(this, zP, "f"));
      } catch (e) {
        r = e;
      }
      return r && (delete o.result, o.error || (o.error = (0, tO.serializeError)(r))), t(r, o);
    });
  }, VP = function (e, t, n) {
    return ZP(this, void 0, void 0, function* () {
      const [r, i, o] = yield XP(iO, jP, "m", $P).call(iO, e, t, n);
      if (XP(iO, jP, "m", GP).call(iO, e, t, i), yield XP(iO, jP, "m", YP).call(iO, o), r) throw r;
    });
  }, $P = function (e, t, n) {
    return ZP(this, void 0, void 0, function* () {
      const r = [];
      let i = null,
        o = !1;
      for (const a of n) if ([i, o] = yield XP(iO, jP, "m", WP).call(iO, e, t, a, r), o) break;
      return [i, o, r.reverse()];
    });
  }, WP = function (e, t, n, r) {
    return ZP(this, void 0, void 0, function* () {
      return new Promise(i => {
        const o = e => {
            const n = e || t.error;
            n && (t.error = (0, tO.serializeError)(n)), i([n, !0]);
          },
          a = n => {
            t.error ? o(t.error) : (n && ("function" != typeof n && o(new tO.JsonRpcError(tO.errorCodes.rpc.internal, `JsonRpcEngine: "next" return handlers must be functions. Received "${typeof n}" for request:\n${oO(e)}`, {
              request: e
            })), r.push(n)), i([null, !1]));
          };
        try {
          n(e, t, a, o);
        } catch (e) {
          o(e);
        }
      });
    });
  }, YP = function (e) {
    return ZP(this, void 0, void 0, function* () {
      for (const t of e) yield new Promise((e, n) => {
        t(t => t ? n(t) : e());
      });
    });
  }, GP = function (e, t, n) {
    if (!(0, rO.hasProperty)(t, "result") && !(0, rO.hasProperty)(t, "error")) throw new tO.JsonRpcError(tO.errorCodes.rpc.internal, `JsonRpcEngine: Response has no error or result for request:\n${oO(e)}`, {
      request: e
    });
    if (!n) throw new tO.JsonRpcError(tO.errorCodes.rpc.internal, `JsonRpcEngine: Nothing ended request:\n${oO(e)}`, {
      request: e
    });
  };
  var aO = {};
  Object.defineProperty(aO, "__esModule", {
    value: !0
  }), aO.mergeMiddleware = void 0;
  const sO = BS;
  aO.mergeMiddleware = function (e) {
    const t = new sO.JsonRpcEngine();
    return e.forEach(e => t.push(e)), t.asMiddleware();
  }, function (e) {
    var t = n && n.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n);
        var i = Object.getOwnPropertyDescriptor(t, n);
        i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        }), Object.defineProperty(e, r, i);
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      r = n && n.__exportStar || function (e, n) {
        for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(n, r) || t(n, e, r);
      };
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), r(RS, e), r(TS, e), r(PS, e), r(NS, e), r(BS, e), r(aO, e);
  }(xS);
  var uO = {
      invalidInput: -32e3,
      resourceNotFound: -32001,
      resourceUnavailable: -32002,
      transactionRejected: -32003,
      methodNotSupported: -32004,
      limitExceeded: -32005,
      parse: -32700,
      invalidRequest: -32600,
      methodNotFound: -32601,
      invalidParams: -32602,
      internal: -32603
    },
    cO = {
      "-32700": {
        standard: "JSON RPC 2.0",
        message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
      },
      "-32600": {
        standard: "JSON RPC 2.0",
        message: "The JSON sent is not a valid Request object."
      },
      "-32601": {
        standard: "JSON RPC 2.0",
        message: "The method does not exist / is not available."
      },
      "-32602": {
        standard: "JSON RPC 2.0",
        message: "Invalid method parameter(s)."
      },
      "-32603": {
        standard: "JSON RPC 2.0",
        message: "Internal JSON-RPC error."
      },
      "-32000": {
        standard: "EIP-1474",
        message: "Invalid input."
      },
      "-32001": {
        standard: "EIP-1474",
        message: "Resource not found."
      },
      "-32002": {
        standard: "EIP-1474",
        message: "Resource unavailable."
      },
      "-32003": {
        standard: "EIP-1474",
        message: "Transaction rejected."
      },
      "-32004": {
        standard: "EIP-1474",
        message: "Method not supported."
      },
      "-32005": {
        standard: "EIP-1474",
        message: "Request limit exceeded."
      },
      4001: {
        standard: "EIP-1193",
        message: "User rejected the request."
      },
      4100: {
        standard: "EIP-1193",
        message: "The requested account and/or method has not been authorized by the user."
      },
      4200: {
        standard: "EIP-1193",
        message: "The requested method is not supported by this Ethereum provider."
      },
      4900: {
        standard: "EIP-1193",
        message: "The provider is disconnected from all chains."
      },
      4901: {
        standard: "EIP-1193",
        message: "The provider is disconnected from the specified chain."
      }
    };
  function lO(e) {
    return Boolean(e) && "object" == typeof e && !Array.isArray(e);
  }
  var dO = (e, t) => Object.hasOwnProperty.call(e, t);
  function fO(e) {
    return function (e) {
      return function (e) {
        return "object" == typeof e && null !== e && "message" in e;
      }(e) && "string" == typeof e.message ? e.message : function (e) {
        return null == e;
      }(e) ? "" : String(e);
    }(e).replace(/\.$/u, "");
  }
  function hO(e, t) {
    return n = e, Boolean("string" == typeof n?.prototype?.constructor?.name) ? new e({
      message: t
    }) : e({
      message: t
    });
    var n;
  }
  var pO = class extends Error {
    constructor(e) {
      super(e.message), this.code = "ERR_ASSERTION";
    }
  };
  var mO = e => Bk(e);
  function gO({
    path: e,
    branch: t
  }) {
    const n = e[e.length - 1];
    return dO(t[t.length - 2], n);
  }
  function vO(e) {
    return new Ak({
      ...e,
      type: `optional ${e.type}`,
      validator: (t, n) => !gO(n) || e.validator(t, n),
      refiner: (t, n) => !gO(n) || e.refiner(t, n)
    });
  }
  var bO = qk([Ok(null), Tk(), Ck("finite number", e => kk(e, Dk()) && Number.isFinite(e)), zk(), Ik(xk(() => bO)), Fk(zk(), xk(() => bO))]),
    yO = Hk(bO, Rk(), e => (function (e, t, n = "Assertion failed", r = pO) {
      try {
        _k(e, t);
      } catch (e) {
        throw hO(r, `${n}: ${fO(e)}.`);
      }
    }(e, bO), JSON.parse(JSON.stringify(e, (e, t) => {
      if ("__proto__" !== e && "constructor" !== e) return t;
    }))));
  function wO(e) {
    try {
      return function (e) {
        Ek(e, yO);
      }(e), !0;
    } catch {
      return !1;
    }
  }
  var AO = Ok("2.0"),
    _O = Nk(qk([Dk(), zk()])),
    EO = mO({
      code: Pk(),
      message: zk(),
      data: vO(yO),
      stack: vO(zk())
    }),
    SO = qk([Fk(zk(), yO), Ik(yO)]);
  mO({
    id: _O,
    jsonrpc: AO,
    method: zk(),
    params: vO(SO)
  }), mO({
    jsonrpc: AO,
    method: zk(),
    params: vO(SO)
  }), Bk({
    id: _O,
    jsonrpc: AO,
    result: jk(Kk()),
    error: jk(EO)
  }), qk([mO({
    id: _O,
    jsonrpc: AO,
    result: yO
  }), mO({
    id: _O,
    jsonrpc: AO,
    error: EO
  })]);
  var kO = uO.internal,
    MO = "Unspecified error message. This is a bug, please report it.";
  xO(kO);
  var CO = "Unspecified server error.";
  function xO(e, t = MO) {
    if (function (e) {
      return Number.isInteger(e);
    }(e)) {
      const t = e.toString();
      if (dO(cO, t)) return cO[t].message;
      if (function (e) {
        return e >= -32099 && e <= -32e3;
      }(e)) return CO;
    }
    return t;
  }
  function RO(e) {
    return Object.getOwnPropertyNames(e).reduce((t, n) => {
      const r = e[n];
      return wO(r) && (t[n] = r), t;
    }, {});
  }
  var IO = class extends Error {
    constructor(e, t, n) {
      if (!Number.isInteger(e)) throw new Error('"code" must be an integer.');
      if (!t || "string" != typeof t) throw new Error('"message" must be a non-empty string.');
      super(t), this.code = e, void 0 !== n && (this.data = n);
    }
    serialize() {
      const e = {
        code: this.code,
        message: this.message
      };
      var t;
      return void 0 !== this.data && (e.data = this.data, function (e) {
        if ("object" != typeof e || null === e) return !1;
        try {
          let t = e;
          for (; null !== Object.getPrototypeOf(t);) t = Object.getPrototypeOf(t);
          return Object.getPrototypeOf(e) === t;
        } catch (e) {
          return !1;
        }
      }(this.data) && (e.data.cause = (t = this.data.cause, Array.isArray(t) ? t.map(e => wO(e) ? e : lO(e) ? RO(e) : null) : lO(t) ? RO(t) : wO(t) ? t : null))), this.stack && (e.stack = this.stack), e;
    }
    toString() {
      return pP(this.serialize(), TO, 2);
    }
  };
  function TO(e, t) {
    if ("[Circular]" !== t) return t;
  }
  var PO = e => OO(uO.invalidRequest, e);
  function OO(e, t) {
    const [n, r] = function (e) {
      if (e) {
        if ("string" == typeof e) return [e];
        if ("object" == typeof e && !Array.isArray(e)) {
          const {
            message: t,
            data: n
          } = e;
          if (t && "string" != typeof t) throw new Error("Must specify string message.");
          return [t ?? void 0, n];
        }
      }
      return [];
    }(t);
    return new IO(e, n ?? xO(e), r);
  }
  var LO = Object.freeze(["eth_subscription"]),
    NO = (e = console) => [xS.createIdRemapMiddleware(), DO(e), CS(e)];
  function DO(e) {
    return (t, n, r) => {
      "string" == typeof t.method && t.method || (n.error = PO({
        message: "The request 'method' must be a non-empty string.",
        data: t
      })), r(t => {
        const {
          error: r
        } = n;
        return r ? (e.error(`MetaMask - RPC Error: ${r.message}`, r), t()) : t();
      });
    };
  }
  var BO = (e, t, n = !0) => (r, i) => {
      r || i.error ? t(r || i.error) : !n || Array.isArray(i) ? e(i) : e(i.result);
    },
    jO = e => Boolean(e) && "string" == typeof e && e.startsWith("0x"),
    FO = () => {};
  async function zO(e, t) {
    try {
      const t = await async function () {
        return {
          name: UO(window),
          icon: await qO(window)
        };
      }();
      e.handle({
        jsonrpc: "2.0",
        id: 1,
        method: "metamask_sendDomainMetadata",
        params: t
      }, FO);
    } catch (e) {
      t.error({
        message: MS.errors.sendSiteMetadata(),
        originalError: e
      });
    }
  }
  function UO(e) {
    const {
        document: t
      } = e,
      n = t.querySelector('head > meta[property="og:site_name"]');
    if (n) return n.content;
    const r = t.querySelector('head > meta[name="title"]');
    return r ? r.content : t.title && t.title.length > 0 ? t.title : window.location.hostname;
  }
  async function qO(e) {
    const {
        document: t
      } = e,
      n = t.querySelectorAll('head > link[rel~="icon"]');
    for (const e of Array.from(n)) if (e && (await KO(e.href))) return e.href;
    return null;
  }
  async function KO(e) {
    return new Promise((t, n) => {
      try {
        const n = document.createElement("img");
        n.onload = () => t(!0), n.onerror = () => t(!1), n.src = e;
      } catch (e) {
        n(e);
      }
    });
  }
  var HO,
    VO,
    $O = (e, t, n) => {
      if (!t.has(e)) throw TypeError("Cannot " + n);
    },
    WO = (e, t, n) => ($O(e, t, "read from private field"), n ? n.call(e) : t.get(e)),
    YO = (e, t, n) => {
      if (t.has(e)) throw TypeError("Cannot add the same private member more than once");
      t instanceof WeakSet ? t.add(e) : t.set(e, n);
    },
    GO = (e, t, n, r) => ($O(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n),
    QO = function e(t, n) {
      if (t === n) return !0;
      if (t && n && "object" == typeof t && "object" == typeof n) {
        if (t.constructor !== n.constructor) return !1;
        var r, i, o;
        if (Array.isArray(t)) {
          if ((r = t.length) != n.length) return !1;
          for (i = r; 0 != i--;) if (!e(t[i], n[i])) return !1;
          return !0;
        }
        if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
        if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
        if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
        if ((r = (o = Object.keys(t)).length) !== Object.keys(n).length) return !1;
        for (i = r; 0 != i--;) if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
        for (i = r; 0 != i--;) {
          var a = o[i];
          if (!e(t[a], n[a])) return !1;
        }
        return !0;
      }
      return t != t && n != n;
    },
    ZO = r(QO),
    JO = class e extends QP {
      constructor({
        logger: t = console,
        maxEventListeners: n = 100,
        rpcMiddleware: r = []
      } = {}) {
        super(), YO(this, HO, void 0), YO(this, VO, void 0), this._log = t, this.setMaxListeners(n), this._state = {
          ...e._defaultState
        }, GO(this, VO, null), GO(this, HO, null), this._handleAccountsChanged = this._handleAccountsChanged.bind(this), this._handleConnect = this._handleConnect.bind(this), this._handleChainChanged = this._handleChainChanged.bind(this), this._handleDisconnect = this._handleDisconnect.bind(this), this._handleUnlockStateChanged = this._handleUnlockStateChanged.bind(this), this._rpcRequest = this._rpcRequest.bind(this), this.request = this.request.bind(this);
        const i = new xS.JsonRpcEngine();
        r.forEach(e => i.push(e)), this._rpcEngine = i;
      }
      get chainId() {
        return WO(this, HO);
      }
      get selectedAddress() {
        return WO(this, VO);
      }
      isConnected() {
        return this._state.isConnected;
      }
      async request(e) {
        if (!e || "object" != typeof e || Array.isArray(e)) throw PO({
          message: MS.errors.invalidRequestArgs(),
          data: e
        });
        const {
          method: t,
          params: n
        } = e;
        if ("string" != typeof t || 0 === t.length) throw PO({
          message: MS.errors.invalidRequestMethod(),
          data: e
        });
        if (void 0 !== n && !Array.isArray(n) && ("object" != typeof n || null === n)) throw PO({
          message: MS.errors.invalidRequestParams(),
          data: e
        });
        const r = null == n ? {
          method: t
        } : {
          method: t,
          params: n
        };
        return new Promise((e, t) => {
          this._rpcRequest(r, BO(e, t));
        });
      }
      _initializeState(e) {
        if (this._state.initialized) throw new Error("Provider already initialized.");
        if (e) {
          const {
            accounts: t,
            chainId: n,
            isUnlocked: r,
            networkVersion: i
          } = e;
          this._handleConnect(n), this._handleChainChanged({
            chainId: n,
            networkVersion: i
          }), this._handleUnlockStateChanged({
            accounts: t,
            isUnlocked: r
          }), this._handleAccountsChanged(t);
        }
        this._state.initialized = !0, this.emit("_initialized");
      }
      _rpcRequest(e, t) {
        let n = t;
        return Array.isArray(e) || (e.jsonrpc || (e.jsonrpc = "2.0"), "eth_accounts" !== e.method && "eth_requestAccounts" !== e.method || (n = (n, r) => {
          this._handleAccountsChanged(r.result ?? [], "eth_accounts" === e.method), t(n, r);
        })), this._rpcEngine.handle(e, n);
      }
      _handleConnect(e) {
        this._state.isConnected || (this._state.isConnected = !0, this.emit("connect", {
          chainId: e
        }), this._log.debug(MS.info.connected(e)));
      }
      _handleDisconnect(e, t) {
        if (this._state.isConnected || !this._state.isPermanentlyDisconnected && !e) {
          let n;
          this._state.isConnected = !1, e ? (n = new IO(1013, t ?? MS.errors.disconnected()), this._log.debug(n)) : (n = new IO(1011, t ?? MS.errors.permanentlyDisconnected()), this._log.error(n), GO(this, HO, null), this._state.accounts = null, GO(this, VO, null), this._state.isUnlocked = !1, this._state.isPermanentlyDisconnected = !0), this.emit("disconnect", n);
        }
      }
      _handleChainChanged({
        chainId: e
      } = {}) {
        jO(e) ? (this._handleConnect(e), e !== WO(this, HO) && (GO(this, HO, e), this._state.initialized && this.emit("chainChanged", WO(this, HO)))) : this._log.error(MS.errors.invalidNetworkParams(), {
          chainId: e
        });
      }
      _handleAccountsChanged(e, t = !1) {
        let n = e;
        Array.isArray(e) || (this._log.error("MetaMask: Received invalid accounts parameter. Please report this bug.", e), n = []);
        for (const t of e) if ("string" != typeof t) {
          this._log.error("MetaMask: Received non-string account. Please report this bug.", e), n = [];
          break;
        }
        if (!ZO(this._state.accounts, n) && (t && null !== this._state.accounts && this._log.error("MetaMask: 'eth_accounts' unexpectedly updated accounts. Please report this bug.", n), this._state.accounts = n, WO(this, VO) !== n[0] && GO(this, VO, n[0] || null), this._state.initialized)) {
          const e = [...n];
          this.emit("accountsChanged", e);
        }
      }
      _handleUnlockStateChanged({
        accounts: e,
        isUnlocked: t
      } = {}) {
        "boolean" == typeof t ? t !== this._state.isUnlocked && (this._state.isUnlocked = t, this._handleAccountsChanged(e ?? [])) : this._log.error("MetaMask: Received invalid isUnlocked parameter. Please report this bug.");
      }
    };
  HO = new WeakMap(), VO = new WeakMap(), JO._defaultState = {
    accounts: null,
    isConnected: !1,
    isUnlocked: !1,
    initialized: !1,
    isPermanentlyDisconnected: !1
  };
  var XO = JO,
    eL = {},
    tL = {};
  Object.defineProperty(tL, "__esModule", {
    value: !0
  });
  const nL = Hn;
  tL.default = function (e) {
    if (!(null == e ? void 0 : e.engine)) throw new Error("Missing engine parameter!");
    const {
        engine: t
      } = e,
      n = new nL.Duplex({
        objectMode: !0,
        read: () => {},
        write: function (e, r, i) {
          t.handle(e, (e, t) => {
            n.push(t);
          }), i();
        }
      });
    return t.on && t.on("notification", e => {
      n.push(e);
    }), n;
  };
  var rL = {},
    iL = n && n.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
  Object.defineProperty(rL, "__esModule", {
    value: !0
  });
  const oL = iL(OP),
    aL = Hn;
  rL.default = function (e = {}) {
    const t = {},
      n = new aL.Duplex({
        objectMode: !0,
        read: () => {},
        write: function (n, o, a) {
          let s = null;
          try {
            !n.id ? function (n) {
              (null == e ? void 0 : e.retryOnMessage) && n.method === e.retryOnMessage && Object.values(t).forEach(({
                req: e,
                retryCount: n = 0
              }) => {
                if (!e.id) return;
                if (n >= 3) throw new Error(`StreamMiddleware - Retry limit exceeded for request id "${e.id}"`);
                const r = t[e.id];
                r && (r.retryCount = n + 1), i(e);
              });
              r.emit("notification", n);
            }(n) : function (e) {
              const {
                id: n
              } = e;
              if (null === n) return;
              const r = t[n];
              if (!r) return void console.warn(`StreamMiddleware - Unknown response id "${n}"`);
              delete t[n], Object.assign(r.res, e), setTimeout(r.end);
            }(n);
          } catch (e) {
            s = e;
          }
          a(s);
        }
      }),
      r = new oL.default();
    return {
      events: r,
      middleware: (e, n, r, o) => {
        t[e.id] = {
          req: e,
          res: n,
          next: r,
          end: o
        }, i(e);
      },
      stream: n
    };
    function i(e) {
      n.push(e);
    }
  };
  var sL = n && n.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };
  Object.defineProperty(eL, "__esModule", {
    value: !0
  });
  var uL = eL.createStreamMiddleware = eL.createEngineStream = void 0;
  const cL = sL(tL);
  eL.createEngineStream = cL.default;
  const lL = sL(rL);
  uL = eL.createStreamMiddleware = lL.default;
  var dL = {},
    fL = {
      exports: {}
    },
    hL = function e(t, n) {
      if (t && n) return e(t)(n);
      if ("function" != typeof t) throw new TypeError("need wrapper function");
      return Object.keys(t).forEach(function (e) {
        r[e] = t[e];
      }), r;
      function r() {
        for (var e = new Array(arguments.length), n = 0; n < e.length; n++) e[n] = arguments[n];
        var r = t.apply(this, e),
          i = e[e.length - 1];
        return "function" == typeof r && r !== i && Object.keys(i).forEach(function (e) {
          r[e] = i[e];
        }), r;
      }
    };
  var pL = hL;
  function mL(e) {
    var t = function () {
      return t.called ? t.value : (t.called = !0, t.value = e.apply(this, arguments));
    };
    return t.called = !1, t;
  }
  function gL(e) {
    var t = function () {
        if (t.called) throw new Error(t.onceError);
        return t.called = !0, t.value = e.apply(this, arguments);
      },
      n = e.name || "Function wrapped with `once`";
    return t.onceError = n + " shouldn't be called more than once", t.called = !1, t;
  }
  fL.exports = pL(mL), fL.exports.strict = pL(gL), mL.proto = mL(function () {
    Object.defineProperty(Function.prototype, "once", {
      value: function () {
        return mL(this);
      },
      configurable: !0
    }), Object.defineProperty(Function.prototype, "onceStrict", {
      value: function () {
        return gL(this);
      },
      configurable: !0
    });
  });
  var vL = fL.exports,
    bL = {};
  Object.defineProperty(bL, "__esModule", {
    value: !0
  }), bL.Substream = void 0;
  const yL = Hn;
  class wL extends yL.Duplex {
    constructor({
      parent: e,
      name: t
    }) {
      super({
        objectMode: !0
      }), this._parent = e, this._name = t;
    }
    _read() {}
    _write(e, t, n) {
      this._parent.push({
        name: this._name,
        data: e
      }), n();
    }
  }
  bL.Substream = wL;
  var AL = n && n.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };
  Object.defineProperty(dL, "__esModule", {
    value: !0
  }), dL.ObjectMultiplex = void 0;
  const _L = Hn,
    EL = AL(vL),
    SL = bL,
    kL = Symbol("IGNORE_SUBSTREAM");
  let ML = class extends _L.Duplex {
    constructor(e = {}) {
      super(Object.assign(Object.assign({}, e), {
        objectMode: !0
      })), this._substreams = {};
    }
    createStream(e) {
      if (this.destroyed) throw new Error(`ObjectMultiplex - parent stream for name "${e}" already destroyed`);
      if (this._readableState.ended || this._writableState.ended) throw new Error(`ObjectMultiplex - parent stream for name "${e}" already ended`);
      if (!e) throw new Error("ObjectMultiplex - name must not be empty");
      if (this._substreams[e]) throw new Error(`ObjectMultiplex - Substream for name "${e}" already exists`);
      const t = new SL.Substream({
        parent: this,
        name: e
      });
      return this._substreams[e] = t, function (e, t) {
        const n = (0, EL.default)(t);
        (0, _L.finished)(e, {
          readable: !1
        }, n), (0, _L.finished)(e, {
          writable: !1
        }, n);
      }(this, e => t.destroy(e || void 0)), t;
    }
    ignoreStream(e) {
      if (!e) throw new Error("ObjectMultiplex - name must not be empty");
      if (this._substreams[e]) throw new Error(`ObjectMultiplex - Substream for name "${e}" already exists`);
      this._substreams[e] = kL;
    }
    _read() {}
    _write(e, t, n) {
      const {
        name: r,
        data: i
      } = e;
      if (!r) return console.warn(`ObjectMultiplex - malformed chunk without name "${e}"`), n();
      const o = this._substreams[r];
      return o ? (o !== kL && o.push(i), n()) : (console.warn(`ObjectMultiplex - orphaned data for stream "${r}"`), n());
    }
  };
  dL.ObjectMultiplex = ML;
  var CL = r(dL.ObjectMultiplex);
  const xL = e => null !== e && "object" == typeof e && "function" == typeof e.pipe;
  xL.writable = e => xL(e) && !1 !== e.writable && "function" == typeof e._write && "object" == typeof e._writableState, xL.readable = e => xL(e) && !1 !== e.readable && "function" == typeof e._read && "object" == typeof e._readableState, xL.duplex = e => xL.writable(e) && xL.readable(e), xL.transform = e => xL.duplex(e) && "function" == typeof e._transform;
  var RL,
    IL = xL,
    TL = class extends XO {
      constructor(e, {
        jsonRpcStreamName: t,
        logger: n = console,
        maxEventListeners: r = 100,
        rpcMiddleware: i = []
      }) {
        if (super({
          logger: n,
          maxEventListeners: r,
          rpcMiddleware: i
        }), !IL.duplex(e)) throw new Error(MS.errors.invalidDuplexStream());
        this._handleStreamDisconnect = this._handleStreamDisconnect.bind(this);
        const o = new CL();
        Hn.pipeline(e, o, e, this._handleStreamDisconnect.bind(this, "MetaMask")), this._jsonRpcConnection = uL({
          retryOnMessage: "METAMASK_EXTENSION_CONNECT_CAN_RETRY"
        }), Hn.pipeline(this._jsonRpcConnection.stream, o.createStream(t), this._jsonRpcConnection.stream, this._handleStreamDisconnect.bind(this, "MetaMask RpcProvider")), this._rpcEngine.push(this._jsonRpcConnection.middleware), this._jsonRpcConnection.events.on("notification", t => {
          const {
            method: n,
            params: r
          } = t;
          "metamask_accountsChanged" === n ? this._handleAccountsChanged(r) : "metamask_unlockStateChanged" === n ? this._handleUnlockStateChanged(r) : "metamask_chainChanged" === n ? this._handleChainChanged(r) : LO.includes(n) ? this.emit("message", {
            type: n,
            data: r
          }) : "METAMASK_STREAM_FAILURE" === n && e.destroy(new Error(MS.errors.permanentlyDisconnected()));
        });
      }
      async _initializeStateAsync() {
        let e;
        try {
          e = await this.request({
            method: "metamask_getProviderState"
          });
        } catch (e) {
          this._log.error("MetaMask: Failed to get initial state. Please report this bug.", e);
        }
        this._initializeState(e);
      }
      _handleStreamDisconnect(e, t) {
        let n = `MetaMask: Lost connection to "${e}".`;
        t?.stack && (n += `\n${t.stack}`), this._log.warn(n), this.listenerCount("error") > 0 && this.emit("error", n), this._handleDisconnect(!1, t ? t.message : void 0);
      }
      _handleChainChanged({
        chainId: e,
        networkVersion: t
      } = {}) {
        jO(e) && (e => Boolean(e) && "string" == typeof e)(t) ? "loading" === t ? this._handleDisconnect(!0) : super._handleChainChanged({
          chainId: e
        }) : this._log.error(MS.errors.invalidNetworkParams(), {
          chainId: e,
          networkVersion: t
        });
      }
    },
    PL = class extends TL {
      constructor(e, {
        jsonRpcStreamName: t = "metamask-provider",
        logger: n = console,
        maxEventListeners: r = 100,
        shouldSendMetadata: i
      } = {}) {
        if (super(e, {
          jsonRpcStreamName: t,
          logger: n,
          maxEventListeners: r,
          rpcMiddleware: NO(n)
        }), this._sentWarnings = {
          chainId: !1,
          networkVersion: !1,
          selectedAddress: !1,
          enable: !1,
          experimentalMethods: !1,
          send: !1,
          events: {
            close: !1,
            data: !1,
            networkChanged: !1,
            notification: !1
          }
        }, YO(this, RL, void 0), this._initializeStateAsync(), GO(this, RL, null), this.isMetaMask = !0, this._sendSync = this._sendSync.bind(this), this.enable = this.enable.bind(this), this.send = this.send.bind(this), this.sendAsync = this.sendAsync.bind(this), this._warnOfDeprecation = this._warnOfDeprecation.bind(this), this._metamask = this._getExperimentalApi(), this._jsonRpcConnection.events.on("notification", e => {
          const {
            method: t
          } = e;
          LO.includes(t) && (this.emit("data", e), this.emit("notification", e.params.result));
        }), i) if ("complete" === document.readyState) zO(this._rpcEngine, this._log);else {
          const e = () => {
            zO(this._rpcEngine, this._log), window.removeEventListener("DOMContentLoaded", e);
          };
          window.addEventListener("DOMContentLoaded", e);
        }
      }
      get chainId() {
        return this._sentWarnings.chainId || (this._log.warn(MS.warnings.chainIdDeprecation), this._sentWarnings.chainId = !0), super.chainId;
      }
      get networkVersion() {
        return this._sentWarnings.networkVersion || (this._log.warn(MS.warnings.networkVersionDeprecation), this._sentWarnings.networkVersion = !0), WO(this, RL);
      }
      get selectedAddress() {
        return this._sentWarnings.selectedAddress || (this._log.warn(MS.warnings.selectedAddressDeprecation), this._sentWarnings.selectedAddress = !0), super.selectedAddress;
      }
      sendAsync(e, t) {
        this._rpcRequest(e, t);
      }
      addListener(e, t) {
        return this._warnOfDeprecation(e), super.addListener(e, t);
      }
      on(e, t) {
        return this._warnOfDeprecation(e), super.on(e, t);
      }
      once(e, t) {
        return this._warnOfDeprecation(e), super.once(e, t);
      }
      prependListener(e, t) {
        return this._warnOfDeprecation(e), super.prependListener(e, t);
      }
      prependOnceListener(e, t) {
        return this._warnOfDeprecation(e), super.prependOnceListener(e, t);
      }
      _handleDisconnect(e, t) {
        super._handleDisconnect(e, t), WO(this, RL) && !e && GO(this, RL, null);
      }
      _warnOfDeprecation(e) {
        !1 === this._sentWarnings?.events[e] && (this._log.warn(MS.warnings.events[e]), this._sentWarnings.events[e] = !0);
      }
      async enable() {
        return this._sentWarnings.enable || (this._log.warn(MS.warnings.enableDeprecation), this._sentWarnings.enable = !0), new Promise((e, t) => {
          try {
            this._rpcRequest({
              method: "eth_requestAccounts",
              params: []
            }, BO(e, t));
          } catch (e) {
            t(e);
          }
        });
      }
      send(e, t) {
        return this._sentWarnings.send || (this._log.warn(MS.warnings.sendDeprecation), this._sentWarnings.send = !0), "string" != typeof e || t && !Array.isArray(t) ? e && "object" == typeof e && "function" == typeof t ? this._rpcRequest(e, t) : this._sendSync(e) : new Promise((n, r) => {
          try {
            this._rpcRequest({
              method: e,
              params: t
            }, BO(n, r, !1));
          } catch (e) {
            r(e);
          }
        });
      }
      _sendSync(e) {
        let t;
        switch (e.method) {
          case "eth_accounts":
            t = this.selectedAddress ? [this.selectedAddress] : [];
            break;
          case "eth_coinbase":
            t = this.selectedAddress ?? null;
            break;
          case "eth_uninstallFilter":
            this._rpcRequest(e, FO), t = !0;
            break;
          case "net_version":
            t = WO(this, RL) ?? null;
            break;
          default:
            throw new Error(MS.errors.unsupportedSync(e.method));
        }
        return {
          id: e.id,
          jsonrpc: e.jsonrpc,
          result: t
        };
      }
      _getExperimentalApi() {
        return new Proxy({
          isUnlocked: async () => (this._state.initialized || (await new Promise(e => {
            this.on("_initialized", () => e());
          })), this._state.isUnlocked),
          requestBatch: async e => {
            if (!Array.isArray(e)) throw PO({
              message: "Batch requests must be made with an array of request objects.",
              data: e
            });
            return new Promise((t, n) => {
              this._rpcRequest(e, BO(t, n));
            });
          }
        }, {
          get: (e, t, ...n) => (this._sentWarnings.experimentalMethods || (this._log.warn(MS.warnings.experimentalMethods), this._sentWarnings.experimentalMethods = !0), Reflect.get(e, t, ...n))
        });
      }
      _handleChainChanged({
        chainId: e,
        networkVersion: t
      } = {}) {
        super._handleChainChanged({
          chainId: e,
          networkVersion: t
        }), this._state.isConnected && t !== WO(this, RL) && (GO(this, RL, t), this._state.initialized && this.emit("networkChanged", WO(this, RL)));
      }
    };
  RL = new WeakMap();
  const OL = HI("MM_SDK");
  OL.color = "#FFAC1C";
  var LL = {},
    NL = {};
  Object.defineProperty(NL, "__esModule", {
    value: !0
  }), NL.EthereumProviderError = NL.EthereumRpcError = void 0;
  const DL = tP;
  class BL extends Error {
    constructor(e, t, n) {
      if (!Number.isInteger(e)) throw new Error('"code" must be an integer.');
      if (!t || "string" != typeof t) throw new Error('"message" must be a nonempty string.');
      super(t), this.code = e, void 0 !== n && (this.data = n);
    }
    serialize() {
      const e = {
        code: this.code,
        message: this.message
      };
      return void 0 !== this.data && (e.data = this.data), this.stack && (e.stack = this.stack), e;
    }
    toString() {
      return DL.default(this.serialize(), jL, 2);
    }
  }
  NL.EthereumRpcError = BL;
  function jL(e, t) {
    if ("[Circular]" !== t) return t;
  }
  NL.EthereumProviderError = class extends BL {
    constructor(e, t, n) {
      if (!function (e) {
        return Number.isInteger(e) && e >= 1e3 && e <= 4999;
      }(e)) throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
      super(e, t, n);
    }
  };
  var FL = {},
    zL = {};
  Object.defineProperty(zL, "__esModule", {
    value: !0
  }), zL.errorValues = zL.errorCodes = void 0, zL.errorCodes = {
    rpc: {
      invalidInput: -32e3,
      resourceNotFound: -32001,
      resourceUnavailable: -32002,
      transactionRejected: -32003,
      methodNotSupported: -32004,
      limitExceeded: -32005,
      parse: -32700,
      invalidRequest: -32600,
      methodNotFound: -32601,
      invalidParams: -32602,
      internal: -32603
    },
    provider: {
      userRejectedRequest: 4001,
      unauthorized: 4100,
      unsupportedMethod: 4200,
      disconnected: 4900,
      chainDisconnected: 4901
    }
  }, zL.errorValues = {
    "-32700": {
      standard: "JSON RPC 2.0",
      message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    },
    "-32600": {
      standard: "JSON RPC 2.0",
      message: "The JSON sent is not a valid Request object."
    },
    "-32601": {
      standard: "JSON RPC 2.0",
      message: "The method does not exist / is not available."
    },
    "-32602": {
      standard: "JSON RPC 2.0",
      message: "Invalid method parameter(s)."
    },
    "-32603": {
      standard: "JSON RPC 2.0",
      message: "Internal JSON-RPC error."
    },
    "-32000": {
      standard: "EIP-1474",
      message: "Invalid input."
    },
    "-32001": {
      standard: "EIP-1474",
      message: "Resource not found."
    },
    "-32002": {
      standard: "EIP-1474",
      message: "Resource unavailable."
    },
    "-32003": {
      standard: "EIP-1474",
      message: "Transaction rejected."
    },
    "-32004": {
      standard: "EIP-1474",
      message: "Method not supported."
    },
    "-32005": {
      standard: "EIP-1474",
      message: "Request limit exceeded."
    },
    4001: {
      standard: "EIP-1193",
      message: "User rejected the request."
    },
    4100: {
      standard: "EIP-1193",
      message: "The requested account and/or method has not been authorized by the user."
    },
    4200: {
      standard: "EIP-1193",
      message: "The requested method is not supported by this Ethereum provider."
    },
    4900: {
      standard: "EIP-1193",
      message: "The provider is disconnected from all chains."
    },
    4901: {
      standard: "EIP-1193",
      message: "The provider is disconnected from the specified chain."
    }
  }, function (e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.serializeError = e.isValidCode = e.getMessageFromCode = e.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
    const t = zL,
      n = NL,
      r = t.errorCodes.rpc.internal,
      i = "Unspecified error message. This is a bug, please report it.",
      o = {
        code: r,
        message: a(r)
      };
    function a(n, r = i) {
      if (Number.isInteger(n)) {
        const r = n.toString();
        if (l(t.errorValues, r)) return t.errorValues[r].message;
        if (u(n)) return e.JSON_RPC_SERVER_ERROR_MESSAGE;
      }
      return r;
    }
    function s(e) {
      if (!Number.isInteger(e)) return !1;
      const n = e.toString();
      return !!t.errorValues[n] || !!u(e);
    }
    function u(e) {
      return e >= -32099 && e <= -32e3;
    }
    function c(e) {
      return e && "object" == typeof e && !Array.isArray(e) ? Object.assign({}, e) : e;
    }
    function l(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }
    e.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.", e.getMessageFromCode = a, e.isValidCode = s, e.serializeError = function (e, {
      fallbackError: t = o,
      shouldIncludeStack: r = !1
    } = {}) {
      var i, u;
      if (!t || !Number.isInteger(t.code) || "string" != typeof t.message) throw new Error("Must provide fallback error with integer number code and string message.");
      if (e instanceof n.EthereumRpcError) return e.serialize();
      const d = {};
      if (e && "object" == typeof e && !Array.isArray(e) && l(e, "code") && s(e.code)) {
        const t = e;
        d.code = t.code, t.message && "string" == typeof t.message ? (d.message = t.message, l(t, "data") && (d.data = t.data)) : (d.message = a(d.code), d.data = {
          originalError: c(e)
        });
      } else {
        d.code = t.code;
        const n = null === (i = e) || void 0 === i ? void 0 : i.message;
        d.message = n && "string" == typeof n ? n : t.message, d.data = {
          originalError: c(e)
        };
      }
      const f = null === (u = e) || void 0 === u ? void 0 : u.stack;
      return r && e && f && "string" == typeof f && (d.stack = f), d;
    };
  }(FL);
  var UL = {};
  Object.defineProperty(UL, "__esModule", {
    value: !0
  }), UL.ethErrors = void 0;
  const qL = NL,
    KL = FL,
    HL = zL;
  function VL(e, t) {
    const [n, r] = WL(t);
    return new qL.EthereumRpcError(e, n || KL.getMessageFromCode(e), r);
  }
  function $L(e, t) {
    const [n, r] = WL(t);
    return new qL.EthereumProviderError(e, n || KL.getMessageFromCode(e), r);
  }
  function WL(e) {
    if (e) {
      if ("string" == typeof e) return [e];
      if ("object" == typeof e && !Array.isArray(e)) {
        const {
          message: t,
          data: n
        } = e;
        if (t && "string" != typeof t) throw new Error("Must specify string message.");
        return [t || void 0, n];
      }
    }
    return [];
  }
  UL.ethErrors = {
    rpc: {
      parse: e => VL(HL.errorCodes.rpc.parse, e),
      invalidRequest: e => VL(HL.errorCodes.rpc.invalidRequest, e),
      invalidParams: e => VL(HL.errorCodes.rpc.invalidParams, e),
      methodNotFound: e => VL(HL.errorCodes.rpc.methodNotFound, e),
      internal: e => VL(HL.errorCodes.rpc.internal, e),
      server: e => {
        if (!e || "object" != typeof e || Array.isArray(e)) throw new Error("Ethereum RPC Server errors must provide single object argument.");
        const {
          code: t
        } = e;
        if (!Number.isInteger(t) || t > -32005 || t < -32099) throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
        return VL(t, e);
      },
      invalidInput: e => VL(HL.errorCodes.rpc.invalidInput, e),
      resourceNotFound: e => VL(HL.errorCodes.rpc.resourceNotFound, e),
      resourceUnavailable: e => VL(HL.errorCodes.rpc.resourceUnavailable, e),
      transactionRejected: e => VL(HL.errorCodes.rpc.transactionRejected, e),
      methodNotSupported: e => VL(HL.errorCodes.rpc.methodNotSupported, e),
      limitExceeded: e => VL(HL.errorCodes.rpc.limitExceeded, e)
    },
    provider: {
      userRejectedRequest: e => $L(HL.errorCodes.provider.userRejectedRequest, e),
      unauthorized: e => $L(HL.errorCodes.provider.unauthorized, e),
      unsupportedMethod: e => $L(HL.errorCodes.provider.unsupportedMethod, e),
      disconnected: e => $L(HL.errorCodes.provider.disconnected, e),
      chainDisconnected: e => $L(HL.errorCodes.provider.chainDisconnected, e),
      custom: e => {
        if (!e || "object" != typeof e || Array.isArray(e)) throw new Error("Ethereum Provider custom errors must provide single object argument.");
        const {
          code: t,
          message: n,
          data: r
        } = e;
        if (!n || "string" != typeof n) throw new Error('"message" must be a nonempty string');
        return new qL.EthereumProviderError(t, n, r);
      }
    }
  }, function (e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getMessageFromCode = e.serializeError = e.EthereumProviderError = e.EthereumRpcError = e.ethErrors = e.errorCodes = void 0;
    const t = NL;
    Object.defineProperty(e, "EthereumRpcError", {
      enumerable: !0,
      get: function () {
        return t.EthereumRpcError;
      }
    }), Object.defineProperty(e, "EthereumProviderError", {
      enumerable: !0,
      get: function () {
        return t.EthereumProviderError;
      }
    });
    const n = FL;
    Object.defineProperty(e, "serializeError", {
      enumerable: !0,
      get: function () {
        return n.serializeError;
      }
    }), Object.defineProperty(e, "getMessageFromCode", {
      enumerable: !0,
      get: function () {
        return n.getMessageFromCode;
      }
    });
    const r = UL;
    Object.defineProperty(e, "ethErrors", {
      enumerable: !0,
      get: function () {
        return r.ethErrors;
      }
    });
    const i = zL;
    Object.defineProperty(e, "errorCodes", {
      enumerable: !0,
      get: function () {
        return i.errorCodes;
      }
    });
  }(LL);
  const YL = {
      METAMASK_GETPROVIDERSTATE: "metamask_getProviderState",
      METAMASK_CONNECTSIGN: "metamask_connectSign",
      METAMASK_CONNECTWITH: "metamask_connectWith",
      METAMASK_OPEN: "metamask_open",
      METAMASK_BATCH: "metamask_batch",
      PERSONAL_SIGN: "personal_sign",
      WALLET_REQUESTPERMISSIONS: "wallet_requestPermissions",
      WALLET_GETPERMISSIONS: "wallet_getPermissions",
      WALLET_WATCHASSET: "wallet_watchAsset",
      WALLET_ADDETHEREUMCHAIN: "wallet_addEthereumChain",
      WALLET_SWITCHETHETHEREUMCHAIN: "wallet_switchEthereumChain",
      ETH_REQUESTACCOUNTS: "eth_requestAccounts",
      ETH_ACCOUNTS: "eth_accounts",
      ETH_CHAINID: "eth_chainId",
      ETH_SENDTRANSACTION: "eth_sendTransaction",
      ETH_SIGNTYPEDDATA: "eth_signTypedData",
      ETH_SIGNTYPEDDATA_V3: "eth_signTypedData_v3",
      ETH_SIGNTYPEDDATA_V4: "eth_signTypedData_v4",
      ETH_SIGNTRANSACTION: "eth_signTransaction",
      ETH_SIGN: "eth_sign",
      PERSONAL_EC_RECOVER: "personal_ecRecover"
    },
    GL = {
      [YL.ETH_REQUESTACCOUNTS]: !0,
      [YL.ETH_SENDTRANSACTION]: !0,
      [YL.ETH_SIGNTRANSACTION]: !0,
      [YL.ETH_SIGN]: !0,
      [YL.ETH_ACCOUNTS]: !0,
      [YL.PERSONAL_SIGN]: !0,
      [YL.ETH_SIGNTYPEDDATA]: !0,
      [YL.ETH_SIGNTYPEDDATA_V3]: !0,
      [YL.ETH_SIGNTYPEDDATA_V4]: !0,
      [YL.WALLET_REQUESTPERMISSIONS]: !0,
      [YL.WALLET_GETPERMISSIONS]: !0,
      [YL.WALLET_WATCHASSET]: !0,
      [YL.WALLET_ADDETHEREUMCHAIN]: !0,
      [YL.WALLET_SWITCHETHETHEREUMCHAIN]: !0,
      [YL.METAMASK_CONNECTSIGN]: !0,
      [YL.METAMASK_CONNECTWITH]: !0,
      [YL.PERSONAL_EC_RECOVER]: !0,
      [YL.METAMASK_BATCH]: !0,
      [YL.METAMASK_OPEN]: !0
    },
    QL = Object.keys(GL).map(e => e.toLowerCase()),
    ZL = ["eth_signTypedData", "eth_signTypedData_v3", "eth_signTypedData_v4", "eth_sign"].map(e => e.toLowerCase()),
    JL = ".sdk-comm",
    XL = "providerType",
    eN = ".MMSDK_cached_address",
    tN = ".MMSDK_cached_chainId",
    nN = {
      CHAIN_CHANGED: "chainChanged",
      ACCOUNTS_CHANGED: "accountsChanged",
      DISCONNECT: "disconnect",
      CONNECT: "connect",
      CONNECTED: "connected"
    };
  class rN {
    constructor({
      enabled: e
    } = {
      enabled: !1
    }) {
      this.enabled = !1, this.enabled = e;
    }
    persistChannelConfig(e) {
      return wS(this, void 0, void 0, function* () {
        const t = JSON.stringify(e);
        OL(`[StorageManagerWeb: persistChannelConfig()] enabled=${this.enabled}`, e), localStorage.setItem(JL, t);
      });
    }
    getPersistedChannelConfig() {
      return wS(this, void 0, void 0, function* () {
        let e;
        try {
          if (OL(`[StorageManagerWeb: getPersistedChannelConfig()] enabled=${this.enabled}`), e = localStorage.getItem(JL), OL("[StorageManagerWeb: getPersistedChannelConfig()]", e), !e) return;
          const t = JSON.parse(e);
          return OL("[StorageManagerWeb: getPersistedChannelConfig()] channelConfig", t), t;
        } catch (e) {
          return void console.error("[StorageManagerWeb: getPersistedChannelConfig()] Can't find existing channel config", e);
        }
      });
    }
    persistAccounts(e) {
      return wS(this, void 0, void 0, function* () {
        OL(`[StorageManagerWeb: persistAccounts()] enabled=${this.enabled}`, e);
        const t = JSON.stringify(e);
        localStorage.setItem(eN, t);
      });
    }
    getCachedAccounts() {
      return wS(this, void 0, void 0, function* () {
        try {
          const e = localStorage.getItem(eN);
          return e ? JSON.parse(e) : [];
        } catch (e) {
          throw console.error("[StorageManagerWeb: getCachedAccounts()] Error reading cached accounts", e), e;
        }
      });
    }
    persistChainId(e) {
      return wS(this, void 0, void 0, function* () {
        OL(`[StorageManagerWeb: persistChainId()] enabled=${this.enabled}`, e), localStorage.setItem(tN, e);
      });
    }
    getCachedChainId() {
      return wS(this, void 0, void 0, function* () {
        try {
          const e = localStorage.getItem(tN);
          return null != e ? e : void 0;
        } catch (e) {
          throw console.error("[StorageManagerWeb: getCachedChainId()] Error reading cached chainId", e), e;
        }
      });
    }
    terminate() {
      return wS(this, void 0, void 0, function* () {
        OL(`[StorageManagerWeb: terminate()] enabled=${this.enabled}`), localStorage.removeItem(JL);
      });
    }
  }
  const iN = e => new rN(e);
  class oN extends PL {
    constructor({
      connectionStream: e,
      shouldSendMetadata: t,
      autoRequestAccounts: n = !1
    }) {
      super(e, {
        logger: console,
        maxEventListeners: 100,
        shouldSendMetadata: t
      }), this.state = {
        autoRequestAccounts: !1,
        providerStateRequested: !1,
        chainId: "",
        networkVersion: ""
      }, OL(`[SDKProvider: constructor()] autoRequestAccounts=${n}`), this.state.autoRequestAccounts = n;
    }
    forceInitializeState() {
      return wS(this, void 0, void 0, function* () {
        return OL(`[SDKProvider: forceInitializeState()] autoRequestAccounts=${this.state.autoRequestAccounts}`), this._initializeStateAsync();
      });
    }
    _setConnected() {
      OL("[SDKProvider: _setConnected()] Setting connected state"), this._state.isConnected = !0;
    }
    getState() {
      return this._state;
    }
    getSDKProviderState() {
      return this.state;
    }
    getSelectedAddress() {
      var e;
      const {
        accounts: t
      } = this._state;
      return t && 0 !== t.length ? (null === (e = t[0]) || void 0 === e ? void 0 : e.toLowerCase()) || "" : (OL("[SDKProvider: getSelectedAddress] No accounts found"), null);
    }
    getChainId() {
      return this.state.chainId;
    }
    getNetworkVersion() {
      return this.state.networkVersion;
    }
    setSDKProviderState(e) {
      this.state = Object.assign(Object.assign({}, this.state), e);
    }
    handleDisconnect({
      terminate: e = !1
    }) {
      !function ({
        terminate: e = !1,
        instance: t
      }) {
        const {
          state: n
        } = t;
        t.isConnected() ? (OL(`[SDKProvider: handleDisconnect()] cleaning up provider state terminate=${e}`, t), e && (t._state.accounts = null, t._state.isUnlocked = !1, t._state.isPermanentlyDisconnected = !0, t._state.initialized = !1), t._handleAccountsChanged([]), t._state.isConnected = !1, t.emit("disconnect", LL.ethErrors.provider.disconnected()), n.providerStateRequested = !1) : OL("[SDKProvider: handleDisconnect()] not connected --- interrupt disconnection");
      }({
        terminate: e,
        instance: this
      });
    }
    _initializeStateAsync() {
      return wS(this, void 0, void 0, function* () {
        return function (e) {
          var t, n;
          return wS(this, void 0, void 0, function* () {
            void 0 === e.state && (e.state = {
              autoRequestAccounts: !1,
              providerStateRequested: !1,
              chainId: ""
            });
            const {
              state: r
            } = e;
            let i;
            if (r.providerStateRequested) OL("[SDKProvider: initializeStateAsync()] initialization already in progress");else {
              let o;
              r.providerStateRequested = !0;
              let a = null,
                s = !1,
                u = !1;
              const c = iN({
                enabled: !0
              });
              if (c) {
                const e = yield c.getPersistedChannelConfig();
                s = null !== (t = null == e ? void 0 : e.relayPersistence) && void 0 !== t && t, o = yield c.getCachedChainId();
                const n = yield c.getCachedAccounts();
                n.length > 0 && (a = n[0]);
              }
              if (OL(`[SDKProvider: initializeStateAsync()] relayPersistence=${s}`, {
                relayPersistence: s,
                cachedChainId: o,
                cachedSelectedAddress: a
              }), s) if (o && a) i = {
                accounts: [a],
                chainId: o,
                isUnlocked: !1
              }, u = !0;else try {
                i = yield e.request({
                  method: "metamask_getProviderState"
                });
              } catch (t) {
                return e._log.error("MetaMask: Failed to get initial state. Please report this bug.", t), void (r.providerStateRequested = !1);
              }
              if (0 === (null === (n = null == i ? void 0 : i.accounts) || void 0 === n ? void 0 : n.length)) if (e.getSelectedAddress()) i.accounts = [e.getSelectedAddress()];else {
                OL("[SDKProvider: initializeStateAsync()] Fetch accounts remotely.");
                const t = yield e.request({
                  method: "eth_requestAccounts",
                  params: []
                });
                i.accounts = t;
              }
              e._initializeState(i), r.providerStateRequested = !1, u && (e._state.isConnected = !0, e.emit("connect", {
                chainId: null == i ? void 0 : i.chainId
              }));
            }
          });
        }(this);
      });
    }
    _initializeState(e) {
      return OL("[SDKProvider: _initializeState()]", e), function (e, t, n) {
        return OL("[SDKProvider: initializeState()] set state._initialized to false"), e._state.initialized = !1, t(n);
      }(this, super._initializeState.bind(this), e);
    }
    _handleChainChanged({
      chainId: e,
      networkVersion: t
    } = {}) {
      this.state.chainId = e, this.state.networkVersion = t, function ({
        instance: e,
        chainId: t,
        networkVersion: n,
        superHandleChainChanged: r
      }) {
        OL(`[SDKProvider: handleChainChanged()] chainId=${t} networkVersion=${n}`);
        let i = n;
        n || (OL("[SDKProvider: handleChainChanged()] forced network version to prevent provider error"), i = "1"), e._state.isConnected = !0, e.emit("connect", {
          chainId: t
        }), r({
          chainId: t,
          networkVersion: i
        });
      }({
        instance: this,
        chainId: e,
        networkVersion: t,
        superHandleChainChanged: super._handleChainChanged.bind(this)
      });
    }
  }
  var aN = {
    exports: {}
  };
  !function (e, t) {
    !function (t) {
      var n = Object.hasOwnProperty,
        r = Array.isArray ? Array.isArray : function (e) {
          return "[object Array]" === Object.prototype.toString.call(e);
        },
        i = "object" == typeof Be && !0,
        o = "function" == typeof Symbol,
        a = "object" == typeof Reflect,
        s = "function" == typeof setImmediate ? setImmediate : setTimeout,
        u = o ? a && "function" == typeof Reflect.ownKeys ? Reflect.ownKeys : function (e) {
          var t = Object.getOwnPropertyNames(e);
          return t.push.apply(t, Object.getOwnPropertySymbols(e)), t;
        } : Object.keys;
      function c() {
        this._events = {}, this._conf && l.call(this, this._conf);
      }
      function l(e) {
        e && (this._conf = e, e.delimiter && (this.delimiter = e.delimiter), e.maxListeners !== t && (this._maxListeners = e.maxListeners), e.wildcard && (this.wildcard = e.wildcard), e.newListener && (this._newListener = e.newListener), e.removeListener && (this._removeListener = e.removeListener), e.verboseMemoryLeak && (this.verboseMemoryLeak = e.verboseMemoryLeak), e.ignoreErrors && (this.ignoreErrors = e.ignoreErrors), this.wildcard && (this.listenerTree = {}));
      }
      function d(e, t) {
        var n = "(node) warning: possible EventEmitter memory leak detected. " + e + " listeners added. Use emitter.setMaxListeners() to increase limit.";
        if (this.verboseMemoryLeak && (n += " Event name: " + t + "."), void 0 !== Be && Be.emitWarning) {
          var r = new Error(n);
          r.name = "MaxListenersExceededWarning", r.emitter = this, r.count = e, Be.emitWarning(r);
        } else console.error(n), console.trace && console.trace();
      }
      var f = function (e, t, n) {
        var r = arguments.length;
        switch (r) {
          case 0:
            return [];
          case 1:
            return [e];
          case 2:
            return [e, t];
          case 3:
            return [e, t, n];
          default:
            for (var i = new Array(r); r--;) i[r] = arguments[r];
            return i;
        }
      };
      function h(e, n) {
        for (var r = {}, i = e.length, o = n ? n.length : 0, a = 0; a < i; a++) r[e[a]] = a < o ? n[a] : t;
        return r;
      }
      function p(e, t, n) {
        var r, i;
        if (this._emitter = e, this._target = t, this._listeners = {}, this._listenersCount = 0, (n.on || n.off) && (r = n.on, i = n.off), t.addEventListener ? (r = t.addEventListener, i = t.removeEventListener) : t.addListener ? (r = t.addListener, i = t.removeListener) : t.on && (r = t.on, i = t.off), !r && !i) throw Error("target does not implement any known event API");
        if ("function" != typeof r) throw TypeError("on method must be a function");
        if ("function" != typeof i) throw TypeError("off method must be a function");
        this._on = r, this._off = i;
        var o = e._observers;
        o ? o.push(this) : e._observers = [this];
      }
      function m(e, r, i, o) {
        var a = Object.assign({}, r);
        if (!e) return a;
        if ("object" != typeof e) throw TypeError("options must be an object");
        var s,
          u,
          c,
          l = Object.keys(e),
          d = l.length;
        function f(e) {
          throw Error('Invalid "' + s + '" option value' + (e ? ". Reason: " + e : ""));
        }
        for (var h = 0; h < d; h++) {
          if (s = l[h], !o && !n.call(r, s)) throw Error('Unknown "' + s + '" option');
          (u = e[s]) !== t && (c = i[s], a[s] = c ? c(u, f) : u);
        }
        return a;
      }
      function g(e, t) {
        return "function" == typeof e && e.hasOwnProperty("prototype") || t("value must be a constructor"), e;
      }
      function v(e) {
        var t = "value must be type of " + e.join("|"),
          n = e.length,
          r = e[0],
          i = e[1];
        return 1 === n ? function (e, n) {
          if (typeof e === r) return e;
          n(t);
        } : 2 === n ? function (e, n) {
          var o = typeof e;
          if (o === r || o === i) return e;
          n(t);
        } : function (r, i) {
          for (var o = typeof r, a = n; a-- > 0;) if (o === e[a]) return r;
          i(t);
        };
      }
      Object.assign(p.prototype, {
        subscribe: function (e, t, n) {
          var r = this,
            i = this._target,
            o = this._emitter,
            a = this._listeners,
            s = function () {
              var r = f.apply(null, arguments),
                a = {
                  data: r,
                  name: t,
                  original: e
                };
              n ? !1 !== n.call(i, a) && o.emit.apply(o, [a.name].concat(r)) : o.emit.apply(o, [t].concat(r));
            };
          if (a[e]) throw Error("Event '" + e + "' is already listening");
          this._listenersCount++, o._newListener && o._removeListener && !r._onNewListener ? (this._onNewListener = function (n) {
            n === t && null === a[e] && (a[e] = s, r._on.call(i, e, s));
          }, o.on("newListener", this._onNewListener), this._onRemoveListener = function (n) {
            n === t && !o.hasListeners(n) && a[e] && (a[e] = null, r._off.call(i, e, s));
          }, a[e] = null, o.on("removeListener", this._onRemoveListener)) : (a[e] = s, r._on.call(i, e, s));
        },
        unsubscribe: function (e) {
          var t,
            n,
            r,
            i = this,
            o = this._listeners,
            a = this._emitter,
            s = this._off,
            c = this._target;
          if (e && "string" != typeof e) throw TypeError("event must be a string");
          function l() {
            i._onNewListener && (a.off("newListener", i._onNewListener), a.off("removeListener", i._onRemoveListener), i._onNewListener = null, i._onRemoveListener = null);
            var e = A.call(a, i);
            a._observers.splice(e, 1);
          }
          if (e) {
            if (!(t = o[e])) return;
            s.call(c, e, t), delete o[e], --this._listenersCount || l();
          } else {
            for (r = (n = u(o)).length; r-- > 0;) e = n[r], s.call(c, e, o[e]);
            this._listeners = {}, this._listenersCount = 0, l();
          }
        }
      });
      var b = v(["function"]),
        y = v(["object", "function"]);
      function w(e, t, n) {
        var r,
          i,
          o,
          a = 0,
          s = new e(function (u, c, l) {
            function d() {
              i && (i = null), a && (clearTimeout(a), a = 0);
            }
            n = m(n, {
              timeout: 0,
              overload: !1
            }, {
              timeout: function (e, t) {
                return ("number" != typeof (e *= 1) || e < 0 || !Number.isFinite(e)) && t("timeout must be a positive number"), e;
              }
            }), r = !n.overload && "function" == typeof e.prototype.cancel && "function" == typeof l;
            var f = function (e) {
                d(), u(e);
              },
              h = function (e) {
                d(), c(e);
              };
            r ? t(f, h, l) : (i = [function (e) {
              h(e || Error("canceled"));
            }], t(f, h, function (e) {
              if (o) throw Error("Unable to subscribe on cancel event asynchronously");
              if ("function" != typeof e) throw TypeError("onCancel callback must be a function");
              i.push(e);
            }), o = !0), n.timeout > 0 && (a = setTimeout(function () {
              var e = Error("timeout");
              e.code = "ETIMEDOUT", a = 0, s.cancel(e), c(e);
            }, n.timeout));
          });
        return r || (s.cancel = function (e) {
          if (i) {
            for (var t = i.length, n = 1; n < t; n++) i[n](e);
            i[0](e), i = null;
          }
        }), s;
      }
      function A(e) {
        var t = this._observers;
        if (!t) return -1;
        for (var n = t.length, r = 0; r < n; r++) if (t[r]._target === e) return r;
        return -1;
      }
      function _(e, t, n, r, i) {
        if (!n) return null;
        if (0 === r) {
          var o = typeof t;
          if ("string" === o) {
            var a,
              s,
              c = 0,
              l = 0,
              d = this.delimiter,
              f = d.length;
            if (-1 !== (s = t.indexOf(d))) {
              a = new Array(5);
              do {
                a[c++] = t.slice(l, s), l = s + f;
              } while (-1 !== (s = t.indexOf(d, l)));
              a[c++] = t.slice(l), t = a, i = c;
            } else t = [t], i = 1;
          } else "object" === o ? i = t.length : (t = [t], i = 1);
        }
        var h,
          p,
          m,
          g,
          v,
          b,
          y,
          w = null,
          A = t[r],
          E = t[r + 1];
        if (r === i) n._listeners && ("function" == typeof n._listeners ? (e && e.push(n._listeners), w = [n]) : (e && e.push.apply(e, n._listeners), w = [n]));else {
          if ("*" === A) {
            for (s = (b = u(n)).length; s-- > 0;) "_listeners" !== (h = b[s]) && (y = _(e, t, n[h], r + 1, i)) && (w ? w.push.apply(w, y) : w = y);
            return w;
          }
          if ("**" === A) {
            for ((v = r + 1 === i || r + 2 === i && "*" === E) && n._listeners && (w = _(e, t, n, i, i)), s = (b = u(n)).length; s-- > 0;) "_listeners" !== (h = b[s]) && ("*" === h || "**" === h ? (n[h]._listeners && !v && (y = _(e, t, n[h], i, i)) && (w ? w.push.apply(w, y) : w = y), y = _(e, t, n[h], r, i)) : y = _(e, t, n[h], h === E ? r + 2 : r, i), y && (w ? w.push.apply(w, y) : w = y));
            return w;
          }
          n[A] && (w = _(e, t, n[A], r + 1, i));
        }
        if ((p = n["*"]) && _(e, t, p, r + 1, i), m = n["**"]) if (r < i) for (m._listeners && _(e, t, m, i, i), s = (b = u(m)).length; s-- > 0;) "_listeners" !== (h = b[s]) && (h === E ? _(e, t, m[h], r + 2, i) : h === A ? _(e, t, m[h], r + 1, i) : ((g = {})[h] = m[h], _(e, t, {
          "**": g
        }, r + 1, i)));else m._listeners ? _(e, t, m, i, i) : m["*"] && m["*"]._listeners && _(e, t, m["*"], i, i);
        return w;
      }
      function E(e, t, n) {
        var r,
          i,
          o = 0,
          a = 0,
          s = this.delimiter,
          u = s.length;
        if ("string" == typeof e) {
          if (-1 !== (r = e.indexOf(s))) {
            i = new Array(5);
            do {
              i[o++] = e.slice(a, r), a = r + u;
            } while (-1 !== (r = e.indexOf(s, a)));
            i[o++] = e.slice(a);
          } else i = [e], o = 1;
        } else i = e, o = e.length;
        if (o > 1) for (r = 0; r + 1 < o; r++) if ("**" === i[r] && "**" === i[r + 1]) return;
        var c,
          l = this.listenerTree;
        for (r = 0; r < o; r++) if (l = l[c = i[r]] || (l[c] = {}), r === o - 1) return l._listeners ? ("function" == typeof l._listeners && (l._listeners = [l._listeners]), n ? l._listeners.unshift(t) : l._listeners.push(t), !l._listeners.warned && this._maxListeners > 0 && l._listeners.length > this._maxListeners && (l._listeners.warned = !0, d.call(this, l._listeners.length, c))) : l._listeners = t, !0;
        return !0;
      }
      function S(e, t, n, r) {
        for (var i, o, a, s, c = u(e), l = c.length, d = e._listeners; l-- > 0;) i = e[o = c[l]], a = "_listeners" === o ? n : n ? n.concat(o) : [o], s = r || "symbol" == typeof o, d && t.push(s ? a : a.join(this.delimiter)), "object" == typeof i && S.call(this, i, t, a, s);
        return t;
      }
      function k(e) {
        for (var t, n, r, i = u(e), o = i.length; o-- > 0;) (t = e[n = i[o]]) && (r = !0, "_listeners" === n || k(t) || delete e[n]);
        return r;
      }
      function M(e, t, n) {
        this.emitter = e, this.event = t, this.listener = n;
      }
      function C(e, n, r) {
        if (!0 === r) a = !0;else if (!1 === r) o = !0;else {
          if (!r || "object" != typeof r) throw TypeError("options should be an object or true");
          var o = r.async,
            a = r.promisify,
            u = r.nextTick,
            c = r.objectify;
        }
        if (o || u || a) {
          var l = n,
            d = n._origin || n;
          if (u && !i) throw Error("process.nextTick is not supported");
          a === t && (a = "AsyncFunction" === n.constructor.name), n = function () {
            var e = arguments,
              t = this,
              n = this.event;
            return a ? u ? Promise.resolve() : new Promise(function (e) {
              s(e);
            }).then(function () {
              return t.event = n, l.apply(t, e);
            }) : (u ? Ee : s)(function () {
              t.event = n, l.apply(t, e);
            });
          }, n._async = !0, n._origin = d;
        }
        return [n, c ? new M(this, e, n) : this];
      }
      function x(e) {
        this._events = {}, this._newListener = !1, this._removeListener = !1, this.verboseMemoryLeak = !1, l.call(this, e);
      }
      M.prototype.off = function () {
        return this.emitter.off(this.event, this.listener), this;
      }, x.EventEmitter2 = x, x.prototype.listenTo = function (e, n, i) {
        if ("object" != typeof e) throw TypeError("target musts be an object");
        var o = this;
        function a(t) {
          if ("object" != typeof t) throw TypeError("events must be an object");
          var n,
            r = i.reducers,
            a = A.call(o, e);
          n = -1 === a ? new p(o, e, i) : o._observers[a];
          for (var s, c = u(t), l = c.length, d = "function" == typeof r, f = 0; f < l; f++) s = c[f], n.subscribe(s, t[s] || s, d ? r : r && r[s]);
        }
        return i = m(i, {
          on: t,
          off: t,
          reducers: t
        }, {
          on: b,
          off: b,
          reducers: y
        }), r(n) ? a(h(n)) : a("string" == typeof n ? h(n.split(/\s+/)) : n), this;
      }, x.prototype.stopListeningTo = function (e, t) {
        var n = this._observers;
        if (!n) return !1;
        var r,
          i = n.length,
          o = !1;
        if (e && "object" != typeof e) throw TypeError("target should be an object");
        for (; i-- > 0;) r = n[i], e && r._target !== e || (r.unsubscribe(t), o = !0);
        return o;
      }, x.prototype.delimiter = ".", x.prototype.setMaxListeners = function (e) {
        e !== t && (this._maxListeners = e, this._conf || (this._conf = {}), this._conf.maxListeners = e);
      }, x.prototype.getMaxListeners = function () {
        return this._maxListeners;
      }, x.prototype.event = "", x.prototype.once = function (e, t, n) {
        return this._once(e, t, !1, n);
      }, x.prototype.prependOnceListener = function (e, t, n) {
        return this._once(e, t, !0, n);
      }, x.prototype._once = function (e, t, n, r) {
        return this._many(e, 1, t, n, r);
      }, x.prototype.many = function (e, t, n, r) {
        return this._many(e, t, n, !1, r);
      }, x.prototype.prependMany = function (e, t, n, r) {
        return this._many(e, t, n, !0, r);
      }, x.prototype._many = function (e, t, n, r, i) {
        var o = this;
        if ("function" != typeof n) throw new Error("many only accepts instances of Function");
        function a() {
          return 0 == --t && o.off(e, a), n.apply(this, arguments);
        }
        return a._origin = n, this._on(e, a, r, i);
      }, x.prototype.emit = function () {
        if (!this._events && !this._all) return !1;
        this._events || c.call(this);
        var e,
          t,
          n,
          r,
          i,
          a,
          s = arguments[0],
          u = this.wildcard;
        if ("newListener" === s && !this._newListener && !this._events.newListener) return !1;
        if (u && (e = s, "newListener" !== s && "removeListener" !== s && "object" == typeof s)) {
          if (n = s.length, o) for (r = 0; r < n; r++) if ("symbol" == typeof s[r]) {
            a = !0;
            break;
          }
          a || (s = s.join(this.delimiter));
        }
        var l,
          d = arguments.length;
        if (this._all && this._all.length) for (r = 0, n = (l = this._all.slice()).length; r < n; r++) switch (this.event = s, d) {
          case 1:
            l[r].call(this, s);
            break;
          case 2:
            l[r].call(this, s, arguments[1]);
            break;
          case 3:
            l[r].call(this, s, arguments[1], arguments[2]);
            break;
          default:
            l[r].apply(this, arguments);
        }
        if (u) l = [], _.call(this, l, e, this.listenerTree, 0, n);else {
          if ("function" == typeof (l = this._events[s])) {
            switch (this.event = s, d) {
              case 1:
                l.call(this);
                break;
              case 2:
                l.call(this, arguments[1]);
                break;
              case 3:
                l.call(this, arguments[1], arguments[2]);
                break;
              default:
                for (t = new Array(d - 1), i = 1; i < d; i++) t[i - 1] = arguments[i];
                l.apply(this, t);
            }
            return !0;
          }
          l && (l = l.slice());
        }
        if (l && l.length) {
          if (d > 3) for (t = new Array(d - 1), i = 1; i < d; i++) t[i - 1] = arguments[i];
          for (r = 0, n = l.length; r < n; r++) switch (this.event = s, d) {
            case 1:
              l[r].call(this);
              break;
            case 2:
              l[r].call(this, arguments[1]);
              break;
            case 3:
              l[r].call(this, arguments[1], arguments[2]);
              break;
            default:
              l[r].apply(this, t);
          }
          return !0;
        }
        if (!this.ignoreErrors && !this._all && "error" === s) throw arguments[1] instanceof Error ? arguments[1] : new Error("Uncaught, unspecified 'error' event.");
        return !!this._all;
      }, x.prototype.emitAsync = function () {
        if (!this._events && !this._all) return !1;
        this._events || c.call(this);
        var e,
          t,
          n,
          r,
          i,
          a,
          s = arguments[0],
          u = this.wildcard;
        if ("newListener" === s && !this._newListener && !this._events.newListener) return Promise.resolve([!1]);
        if (u && (e = s, "newListener" !== s && "removeListener" !== s && "object" == typeof s)) {
          if (r = s.length, o) for (i = 0; i < r; i++) if ("symbol" == typeof s[i]) {
            t = !0;
            break;
          }
          t || (s = s.join(this.delimiter));
        }
        var l,
          d = [],
          f = arguments.length;
        if (this._all) for (i = 0, r = this._all.length; i < r; i++) switch (this.event = s, f) {
          case 1:
            d.push(this._all[i].call(this, s));
            break;
          case 2:
            d.push(this._all[i].call(this, s, arguments[1]));
            break;
          case 3:
            d.push(this._all[i].call(this, s, arguments[1], arguments[2]));
            break;
          default:
            d.push(this._all[i].apply(this, arguments));
        }
        if (u ? (l = [], _.call(this, l, e, this.listenerTree, 0)) : l = this._events[s], "function" == typeof l) switch (this.event = s, f) {
          case 1:
            d.push(l.call(this));
            break;
          case 2:
            d.push(l.call(this, arguments[1]));
            break;
          case 3:
            d.push(l.call(this, arguments[1], arguments[2]));
            break;
          default:
            for (n = new Array(f - 1), a = 1; a < f; a++) n[a - 1] = arguments[a];
            d.push(l.apply(this, n));
        } else if (l && l.length) {
          if (l = l.slice(), f > 3) for (n = new Array(f - 1), a = 1; a < f; a++) n[a - 1] = arguments[a];
          for (i = 0, r = l.length; i < r; i++) switch (this.event = s, f) {
            case 1:
              d.push(l[i].call(this));
              break;
            case 2:
              d.push(l[i].call(this, arguments[1]));
              break;
            case 3:
              d.push(l[i].call(this, arguments[1], arguments[2]));
              break;
            default:
              d.push(l[i].apply(this, n));
          }
        } else if (!this.ignoreErrors && !this._all && "error" === s) return arguments[1] instanceof Error ? Promise.reject(arguments[1]) : Promise.reject("Uncaught, unspecified 'error' event.");
        return Promise.all(d);
      }, x.prototype.on = function (e, t, n) {
        return this._on(e, t, !1, n);
      }, x.prototype.prependListener = function (e, t, n) {
        return this._on(e, t, !0, n);
      }, x.prototype.onAny = function (e) {
        return this._onAny(e, !1);
      }, x.prototype.prependAny = function (e) {
        return this._onAny(e, !0);
      }, x.prototype.addListener = x.prototype.on, x.prototype._onAny = function (e, t) {
        if ("function" != typeof e) throw new Error("onAny only accepts instances of Function");
        return this._all || (this._all = []), t ? this._all.unshift(e) : this._all.push(e), this;
      }, x.prototype._on = function (e, n, r, i) {
        if ("function" == typeof e) return this._onAny(e, n), this;
        if ("function" != typeof n) throw new Error("on only accepts instances of Function");
        this._events || c.call(this);
        var o,
          a = this;
        return i !== t && (n = (o = C.call(this, e, n, i))[0], a = o[1]), this._newListener && this.emit("newListener", e, n), this.wildcard ? (E.call(this, e, n, r), a) : (this._events[e] ? ("function" == typeof this._events[e] && (this._events[e] = [this._events[e]]), r ? this._events[e].unshift(n) : this._events[e].push(n), !this._events[e].warned && this._maxListeners > 0 && this._events[e].length > this._maxListeners && (this._events[e].warned = !0, d.call(this, this._events[e].length, e))) : this._events[e] = n, a);
      }, x.prototype.off = function (e, t) {
        if ("function" != typeof t) throw new Error("removeListener only takes instances of Function");
        var n,
          i = [];
        if (this.wildcard) {
          var o = "string" == typeof e ? e.split(this.delimiter) : e.slice();
          if (!(i = _.call(this, null, o, this.listenerTree, 0))) return this;
        } else {
          if (!this._events[e]) return this;
          n = this._events[e], i.push({
            _listeners: n
          });
        }
        for (var a = 0; a < i.length; a++) {
          var s = i[a];
          if (n = s._listeners, r(n)) {
            for (var u = -1, c = 0, l = n.length; c < l; c++) if (n[c] === t || n[c].listener && n[c].listener === t || n[c]._origin && n[c]._origin === t) {
              u = c;
              break;
            }
            if (u < 0) continue;
            return this.wildcard ? s._listeners.splice(u, 1) : this._events[e].splice(u, 1), 0 === n.length && (this.wildcard ? delete s._listeners : delete this._events[e]), this._removeListener && this.emit("removeListener", e, t), this;
          }
          (n === t || n.listener && n.listener === t || n._origin && n._origin === t) && (this.wildcard ? delete s._listeners : delete this._events[e], this._removeListener && this.emit("removeListener", e, t));
        }
        return this.listenerTree && k(this.listenerTree), this;
      }, x.prototype.offAny = function (e) {
        var t,
          n = 0,
          r = 0;
        if (e && this._all && this._all.length > 0) {
          for (n = 0, r = (t = this._all).length; n < r; n++) if (e === t[n]) return t.splice(n, 1), this._removeListener && this.emit("removeListenerAny", e), this;
        } else {
          if (t = this._all, this._removeListener) for (n = 0, r = t.length; n < r; n++) this.emit("removeListenerAny", t[n]);
          this._all = [];
        }
        return this;
      }, x.prototype.removeListener = x.prototype.off, x.prototype.removeAllListeners = function (e) {
        if (e === t) return !this._events || c.call(this), this;
        if (this.wildcard) {
          var n,
            r = _.call(this, null, e, this.listenerTree, 0);
          if (!r) return this;
          for (n = 0; n < r.length; n++) r[n]._listeners = null;
          this.listenerTree && k(this.listenerTree);
        } else this._events && (this._events[e] = null);
        return this;
      }, x.prototype.listeners = function (e) {
        var n,
          r,
          i,
          o,
          a,
          s = this._events;
        if (e === t) {
          if (this.wildcard) throw Error("event name required for wildcard emitter");
          if (!s) return [];
          for (o = (n = u(s)).length, i = []; o-- > 0;) "function" == typeof (r = s[n[o]]) ? i.push(r) : i.push.apply(i, r);
          return i;
        }
        if (this.wildcard) {
          if (!(a = this.listenerTree)) return [];
          var c = [],
            l = "string" == typeof e ? e.split(this.delimiter) : e.slice();
          return _.call(this, c, l, a, 0), c;
        }
        return s && (r = s[e]) ? "function" == typeof r ? [r] : r : [];
      }, x.prototype.eventNames = function (e) {
        var t = this._events;
        return this.wildcard ? S.call(this, this.listenerTree, [], null, e) : t ? u(t) : [];
      }, x.prototype.listenerCount = function (e) {
        return this.listeners(e).length;
      }, x.prototype.hasListeners = function (e) {
        if (this.wildcard) {
          var n = [],
            r = "string" == typeof e ? e.split(this.delimiter) : e.slice();
          return _.call(this, n, r, this.listenerTree, 0), n.length > 0;
        }
        var i = this._events,
          o = this._all;
        return !!(o && o.length || i && (e === t ? u(i).length : i[e]));
      }, x.prototype.listenersAny = function () {
        return this._all ? this._all : [];
      }, x.prototype.waitFor = function (e, n) {
        var r = this,
          i = typeof n;
        return "number" === i ? n = {
          timeout: n
        } : "function" === i && (n = {
          filter: n
        }), w((n = m(n, {
          timeout: 0,
          filter: t,
          handleError: !1,
          Promise: Promise,
          overload: !1
        }, {
          filter: b,
          Promise: g
        })).Promise, function (t, i, o) {
          function a() {
            var o = n.filter;
            if (!o || o.apply(r, arguments)) if (r.off(e, a), n.handleError) {
              var s = arguments[0];
              s ? i(s) : t(f.apply(null, arguments).slice(1));
            } else t(f.apply(null, arguments));
          }
          o(function () {
            r.off(e, a);
          }), r._on(e, a, !1);
        }, {
          timeout: n.timeout,
          overload: n.overload
        });
      };
      var R = x.prototype;
      Object.defineProperties(x, {
        defaultMaxListeners: {
          get: function () {
            return R._maxListeners;
          },
          set: function (e) {
            if ("number" != typeof e || e < 0 || Number.isNaN(e)) throw TypeError("n must be a non-negative number");
            R._maxListeners = e;
          },
          enumerable: !0
        },
        once: {
          value: function (e, t, n) {
            return w((n = m(n, {
              Promise: Promise,
              timeout: 0,
              overload: !1
            }, {
              Promise: g
            })).Promise, function (n, r, i) {
              var o;
              if ("function" == typeof e.addEventListener) return o = function () {
                n(f.apply(null, arguments));
              }, i(function () {
                e.removeEventListener(t, o);
              }), void e.addEventListener(t, o, {
                once: !0
              });
              var a,
                s = function () {
                  a && e.removeListener("error", a), n(f.apply(null, arguments));
                };
              "error" !== t && (a = function (n) {
                e.removeListener(t, s), r(n);
              }, e.once("error", a)), i(function () {
                a && e.removeListener("error", a), e.removeListener(t, s);
              }), e.once(t, s);
            }, {
              timeout: n.timeout,
              overload: n.overload
            });
          },
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperties(R, {
        _maxListeners: {
          value: 10,
          writable: !0,
          configurable: !0
        },
        _observers: {
          value: null,
          writable: !0,
          configurable: !0
        }
      }), "function" == typeof t && t.amd ? t(function () {
        return x;
      }) : e.exports = x;
    }();
  }(aN);
  var sN = r(aN.exports);
  function uN(e) {
    return uN = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, uN(e);
  }
  function cN(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function lN(e) {
    var t = function (e, t) {
      if ("object" !== uN(e) || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t || "default");
        if ("object" !== uN(r)) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === uN(t) ? t : String(t);
  }
  function dN(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, lN(r.key), r);
    }
  }
  function fN(e, t, n) {
    return t && dN(e.prototype, t), n && dN(e, n), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function hN(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function pN(e, t) {
    return pN = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e;
    }, pN(e, t);
  }
  function mN(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && pN(e, t);
  }
  function gN(e, t) {
    if (t && ("object" === uN(t) || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return hN(e);
  }
  function vN(e) {
    return vN = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, vN(e);
  }
  function bN(e, t, n) {
    return (t = lN(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function yN(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function wN(e) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return yN(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? yN(e, t) : void 0;
      }
    }(e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function AN(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function _N(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? AN(Object(n), !0).forEach(function (t) {
        bN(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : AN(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  var EN = {
      type: "logger",
      log: function (e) {
        this.output("log", e);
      },
      warn: function (e) {
        this.output("warn", e);
      },
      error: function (e) {
        this.output("error", e);
      },
      output: function (e, t) {
        console && console[e] && console[e].apply(console, t);
      }
    },
    SN = function () {
      function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        cN(this, e), this.init(t, n);
      }
      return fN(e, [{
        key: "init",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.prefix = t.prefix || "i18next:", this.logger = e || EN, this.options = t, this.debug = t.debug;
        }
      }, {
        key: "setDebug",
        value: function (e) {
          this.debug = e;
        }
      }, {
        key: "log",
        value: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return this.forward(t, "log", "", !0);
        }
      }, {
        key: "warn",
        value: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return this.forward(t, "warn", "", !0);
        }
      }, {
        key: "error",
        value: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return this.forward(t, "error", "");
        }
      }, {
        key: "deprecate",
        value: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
        }
      }, {
        key: "forward",
        value: function (e, t, n, r) {
          return r && !this.debug ? null : ("string" == typeof e[0] && (e[0] = "".concat(n).concat(this.prefix, " ").concat(e[0])), this.logger[t](e));
        }
      }, {
        key: "create",
        value: function (t) {
          return new e(this.logger, _N(_N({}, {
            prefix: "".concat(this.prefix, ":").concat(t, ":")
          }), this.options));
        }
      }, {
        key: "clone",
        value: function (t) {
          return (t = t || this.options).prefix = t.prefix || this.prefix, new e(this.logger, t);
        }
      }]), e;
    }(),
    kN = new SN(),
    MN = function () {
      function e() {
        cN(this, e), this.observers = {};
      }
      return fN(e, [{
        key: "on",
        value: function (e, t) {
          var n = this;
          return e.split(" ").forEach(function (e) {
            n.observers[e] = n.observers[e] || [], n.observers[e].push(t);
          }), this;
        }
      }, {
        key: "off",
        value: function (e, t) {
          this.observers[e] && (t ? this.observers[e] = this.observers[e].filter(function (e) {
            return e !== t;
          }) : delete this.observers[e]);
        }
      }, {
        key: "emit",
        value: function (e) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          this.observers[e] && [].concat(this.observers[e]).forEach(function (e) {
            e.apply(void 0, n);
          });
          this.observers["*"] && [].concat(this.observers["*"]).forEach(function (t) {
            t.apply(t, [e].concat(n));
          });
        }
      }]), e;
    }();
  function CN() {
    var e,
      t,
      n = new Promise(function (n, r) {
        e = n, t = r;
      });
    return n.resolve = e, n.reject = t, n;
  }
  function xN(e) {
    return null == e ? "" : "" + e;
  }
  function RN(e, t, n) {
    function r(e) {
      return e && e.indexOf("###") > -1 ? e.replace(/###/g, ".") : e;
    }
    function i() {
      return !e || "string" == typeof e;
    }
    for (var o = "string" != typeof t ? [].concat(t) : t.split("."); o.length > 1;) {
      if (i()) return {};
      var a = r(o.shift());
      !e[a] && n && (e[a] = new n()), e = Object.prototype.hasOwnProperty.call(e, a) ? e[a] : {};
    }
    return i() ? {} : {
      obj: e,
      k: r(o.shift())
    };
  }
  function IN(e, t, n) {
    var r = RN(e, t, Object);
    r.obj[r.k] = n;
  }
  function TN(e, t) {
    var n = RN(e, t),
      r = n.obj,
      i = n.k;
    if (r) return r[i];
  }
  function PN(e, t, n) {
    for (var r in t) "__proto__" !== r && "constructor" !== r && (r in e ? "string" == typeof e[r] || e[r] instanceof String || "string" == typeof t[r] || t[r] instanceof String ? n && (e[r] = t[r]) : PN(e[r], t[r], n) : e[r] = t[r]);
    return e;
  }
  function ON(e) {
    return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  }
  var LN = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
  };
  function NN(e) {
    return "string" == typeof e ? e.replace(/[&<>"'\/]/g, function (e) {
      return LN[e];
    }) : e;
  }
  var DN = "undefined" != typeof window && window.navigator && void 0 === window.navigator.userAgentData && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1,
    BN = [" ", ",", "?", "!", ";"];
  function jN(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ".";
    if (e) {
      if (e[t]) return e[t];
      for (var r = t.split(n), i = e, o = 0; o < r.length; ++o) {
        if (!i) return;
        if ("string" == typeof i[r[o]] && o + 1 < r.length) return;
        if (void 0 === i[r[o]]) {
          for (var a = 2, s = r.slice(o, o + a).join(n), u = i[s]; void 0 === u && r.length > o + a;) a++, u = i[s = r.slice(o, o + a).join(n)];
          if (void 0 === u) return;
          if (null === u) return null;
          if (t.endsWith(s)) {
            if ("string" == typeof u) return u;
            if (s && "string" == typeof u[s]) return u[s];
          }
          var c = r.slice(o + a).join(n);
          return c ? jN(u, c, n) : void 0;
        }
        i = i[r[o]];
      }
      return i;
    }
  }
  function FN(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function zN(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? FN(Object(n), !0).forEach(function (t) {
        bN(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : FN(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function UN(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = vN(e);
      if (t) {
        var i = vN(this).constructor;
        n = Reflect.construct(r, arguments, i);
      } else n = r.apply(this, arguments);
      return gN(this, n);
    };
  }
  var qN = function (e) {
      mN(n, e);
      var t = UN(n);
      function n(e) {
        var r,
          i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            ns: ["translation"],
            defaultNS: "translation"
          };
        return cN(this, n), r = t.call(this), DN && MN.call(hN(r)), r.data = e || {}, r.options = i, void 0 === r.options.keySeparator && (r.options.keySeparator = "."), void 0 === r.options.ignoreJSONStructure && (r.options.ignoreJSONStructure = !0), r;
      }
      return fN(n, [{
        key: "addNamespaces",
        value: function (e) {
          this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
        }
      }, {
        key: "removeNamespaces",
        value: function (e) {
          var t = this.options.ns.indexOf(e);
          t > -1 && this.options.ns.splice(t, 1);
        }
      }, {
        key: "getResource",
        value: function (e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            i = void 0 !== r.keySeparator ? r.keySeparator : this.options.keySeparator,
            o = void 0 !== r.ignoreJSONStructure ? r.ignoreJSONStructure : this.options.ignoreJSONStructure,
            a = [e, t];
          n && "string" != typeof n && (a = a.concat(n)), n && "string" == typeof n && (a = a.concat(i ? n.split(i) : n)), e.indexOf(".") > -1 && (a = e.split("."));
          var s = TN(this.data, a);
          return s || !o || "string" != typeof n ? s : jN(this.data && this.data[e] && this.data[e][t], n, i);
        }
      }, {
        key: "addResource",
        value: function (e, t, n, r) {
          var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {
              silent: !1
            },
            o = void 0 !== i.keySeparator ? i.keySeparator : this.options.keySeparator,
            a = [e, t];
          n && (a = a.concat(o ? n.split(o) : n)), e.indexOf(".") > -1 && (r = t, t = (a = e.split("."))[1]), this.addNamespaces(t), IN(this.data, a, r), i.silent || this.emit("added", e, t, n, r);
        }
      }, {
        key: "addResources",
        value: function (e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
            silent: !1
          };
          for (var i in n) "string" != typeof n[i] && "[object Array]" !== Object.prototype.toString.apply(n[i]) || this.addResource(e, t, i, n[i], {
            silent: !0
          });
          r.silent || this.emit("added", e, t, n);
        }
      }, {
        key: "addResourceBundle",
        value: function (e, t, n, r, i) {
          var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {
              silent: !1
            },
            a = [e, t];
          e.indexOf(".") > -1 && (r = n, n = t, t = (a = e.split("."))[1]), this.addNamespaces(t);
          var s = TN(this.data, a) || {};
          r ? PN(s, n, i) : s = zN(zN({}, s), n), IN(this.data, a, s), o.silent || this.emit("added", e, t, n);
        }
      }, {
        key: "removeResourceBundle",
        value: function (e, t) {
          this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
        }
      }, {
        key: "hasResourceBundle",
        value: function (e, t) {
          return void 0 !== this.getResource(e, t);
        }
      }, {
        key: "getResourceBundle",
        value: function (e, t) {
          return t || (t = this.options.defaultNS), "v1" === this.options.compatibilityAPI ? zN(zN({}, {}), this.getResource(e, t)) : this.getResource(e, t);
        }
      }, {
        key: "getDataByLanguage",
        value: function (e) {
          return this.data[e];
        }
      }, {
        key: "hasLanguageSomeTranslations",
        value: function (e) {
          var t = this.getDataByLanguage(e);
          return !!(t && Object.keys(t) || []).find(function (e) {
            return t[e] && Object.keys(t[e]).length > 0;
          });
        }
      }, {
        key: "toJSON",
        value: function () {
          return this.data;
        }
      }]), n;
    }(MN),
    KN = {
      processors: {},
      addPostProcessor: function (e) {
        this.processors[e.name] = e;
      },
      handle: function (e, t, n, r, i) {
        var o = this;
        return e.forEach(function (e) {
          o.processors[e] && (t = o.processors[e].process(t, n, r, i));
        }), t;
      }
    };
  function HN(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function VN(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? HN(Object(n), !0).forEach(function (t) {
        bN(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : HN(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function $N(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = vN(e);
      if (t) {
        var i = vN(this).constructor;
        n = Reflect.construct(r, arguments, i);
      } else n = r.apply(this, arguments);
      return gN(this, n);
    };
  }
  var WN = {},
    YN = function (e) {
      mN(n, e);
      var t = $N(n);
      function n(e) {
        var r,
          i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return cN(this, n), r = t.call(this), DN && MN.call(hN(r)), function (e, t, n) {
          e.forEach(function (e) {
            t[e] && (n[e] = t[e]);
          });
        }(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, hN(r)), r.options = i, void 0 === r.options.keySeparator && (r.options.keySeparator = "."), r.logger = kN.create("translator"), r;
      }
      return fN(n, [{
        key: "changeLanguage",
        value: function (e) {
          e && (this.language = e);
        }
      }, {
        key: "exists",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            interpolation: {}
          };
          if (null == e) return !1;
          var n = this.resolve(e, t);
          return n && void 0 !== n.res;
        }
      }, {
        key: "extractFromKey",
        value: function (e, t) {
          var n = void 0 !== t.nsSeparator ? t.nsSeparator : this.options.nsSeparator;
          void 0 === n && (n = ":");
          var r = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
            i = t.ns || this.options.defaultNS || [],
            o = n && e.indexOf(n) > -1,
            a = !(this.options.userDefinedKeySeparator || t.keySeparator || this.options.userDefinedNsSeparator || t.nsSeparator || function (e, t, n) {
              t = t || "", n = n || "";
              var r = BN.filter(function (e) {
                return t.indexOf(e) < 0 && n.indexOf(e) < 0;
              });
              if (0 === r.length) return !0;
              var i = new RegExp("(".concat(r.map(function (e) {
                  return "?" === e ? "\\?" : e;
                }).join("|"), ")")),
                o = !i.test(e);
              if (!o) {
                var a = e.indexOf(n);
                a > 0 && !i.test(e.substring(0, a)) && (o = !0);
              }
              return o;
            }(e, n, r));
          if (o && !a) {
            var s = e.match(this.interpolator.nestingRegexp);
            if (s && s.length > 0) return {
              key: e,
              namespaces: i
            };
            var u = e.split(n);
            (n !== r || n === r && this.options.ns.indexOf(u[0]) > -1) && (i = u.shift()), e = u.join(r);
          }
          return "string" == typeof i && (i = [i]), {
            key: e,
            namespaces: i
          };
        }
      }, {
        key: "translate",
        value: function (e, t, r) {
          var i = this;
          if ("object" !== uN(t) && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), "object" === uN(t) && (t = VN({}, t)), t || (t = {}), null == e) return "";
          Array.isArray(e) || (e = [String(e)]);
          var o = void 0 !== t.returnDetails ? t.returnDetails : this.options.returnDetails,
            a = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
            s = this.extractFromKey(e[e.length - 1], t),
            u = s.key,
            c = s.namespaces,
            l = c[c.length - 1],
            d = t.lng || this.language,
            f = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
          if (d && "cimode" === d.toLowerCase()) {
            if (f) {
              var h = t.nsSeparator || this.options.nsSeparator;
              return o ? {
                res: "".concat(l).concat(h).concat(u),
                usedKey: u,
                exactUsedKey: u,
                usedLng: d,
                usedNS: l
              } : "".concat(l).concat(h).concat(u);
            }
            return o ? {
              res: u,
              usedKey: u,
              exactUsedKey: u,
              usedLng: d,
              usedNS: l
            } : u;
          }
          var p = this.resolve(e, t),
            m = p && p.res,
            g = p && p.usedKey || u,
            v = p && p.exactUsedKey || u,
            b = Object.prototype.toString.apply(m),
            y = void 0 !== t.joinArrays ? t.joinArrays : this.options.joinArrays,
            w = !this.i18nFormat || this.i18nFormat.handleAsObject;
          if (w && m && "string" != typeof m && "boolean" != typeof m && "number" != typeof m && ["[object Number]", "[object Function]", "[object RegExp]"].indexOf(b) < 0 && ("string" != typeof y || "[object Array]" !== b)) {
            if (!t.returnObjects && !this.options.returnObjects) {
              this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
              var A = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(g, m, VN(VN({}, t), {}, {
                ns: c
              })) : "key '".concat(u, " (").concat(this.language, ")' returned an object instead of string.");
              return o ? (p.res = A, p) : A;
            }
            if (a) {
              var _ = "[object Array]" === b,
                E = _ ? [] : {},
                S = _ ? v : g;
              for (var k in m) if (Object.prototype.hasOwnProperty.call(m, k)) {
                var M = "".concat(S).concat(a).concat(k);
                E[k] = this.translate(M, VN(VN({}, t), {
                  joinArrays: !1,
                  ns: c
                })), E[k] === M && (E[k] = m[k]);
              }
              m = E;
            }
          } else if (w && "string" == typeof y && "[object Array]" === b) (m = m.join(y)) && (m = this.extendTranslation(m, e, t, r));else {
            var C = !1,
              x = !1,
              R = void 0 !== t.count && "string" != typeof t.count,
              I = n.hasDefaultValue(t),
              T = R ? this.pluralResolver.getSuffix(d, t.count, t) : "",
              P = t["defaultValue".concat(T)] || t.defaultValue;
            !this.isValidLookup(m) && I && (C = !0, m = P), this.isValidLookup(m) || (x = !0, m = u);
            var O = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && x ? void 0 : m,
              L = I && P !== m && this.options.updateMissing;
            if (x || C || L) {
              if (this.logger.log(L ? "updateKey" : "missingKey", d, l, u, L ? P : m), a) {
                var N = this.resolve(u, VN(VN({}, t), {}, {
                  keySeparator: !1
                }));
                N && N.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
              }
              var D = [],
                B = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
              if ("fallback" === this.options.saveMissingTo && B && B[0]) for (var j = 0; j < B.length; j++) D.push(B[j]);else "all" === this.options.saveMissingTo ? D = this.languageUtils.toResolveHierarchy(t.lng || this.language) : D.push(t.lng || this.language);
              var F = function (e, n, r) {
                var o = I && r !== m ? r : O;
                i.options.missingKeyHandler ? i.options.missingKeyHandler(e, l, n, o, L, t) : i.backendConnector && i.backendConnector.saveMissing && i.backendConnector.saveMissing(e, l, n, o, L, t), i.emit("missingKey", e, l, n, m);
              };
              this.options.saveMissing && (this.options.saveMissingPlurals && R ? D.forEach(function (e) {
                i.pluralResolver.getSuffixes(e, t).forEach(function (n) {
                  F([e], u + n, t["defaultValue".concat(n)] || P);
                });
              }) : F(D, u, P));
            }
            m = this.extendTranslation(m, e, t, p, r), x && m === u && this.options.appendNamespaceToMissingKey && (m = "".concat(l, ":").concat(u)), (x || C) && this.options.parseMissingKeyHandler && (m = "v1" !== this.options.compatibilityAPI ? this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(l, ":").concat(u) : u, C ? m : void 0) : this.options.parseMissingKeyHandler(m));
          }
          return o ? (p.res = m, p) : m;
        }
      }, {
        key: "extendTranslation",
        value: function (e, t, n, r, i) {
          var o = this;
          if (this.i18nFormat && this.i18nFormat.parse) e = this.i18nFormat.parse(e, VN(VN({}, this.options.interpolation.defaultVariables), n), r.usedLng, r.usedNS, r.usedKey, {
            resolved: r
          });else if (!n.skipInterpolation) {
            n.interpolation && this.interpolator.init(VN(VN({}, n), {
              interpolation: VN(VN({}, this.options.interpolation), n.interpolation)
            }));
            var a,
              s = "string" == typeof e && (n && n.interpolation && void 0 !== n.interpolation.skipOnVariables ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            if (s) {
              var u = e.match(this.interpolator.nestingRegexp);
              a = u && u.length;
            }
            var c = n.replace && "string" != typeof n.replace ? n.replace : n;
            if (this.options.interpolation.defaultVariables && (c = VN(VN({}, this.options.interpolation.defaultVariables), c)), e = this.interpolator.interpolate(e, c, n.lng || this.language, n), s) {
              var l = e.match(this.interpolator.nestingRegexp);
              a < (l && l.length) && (n.nest = !1);
            }
            !n.lng && "v1" !== this.options.compatibilityAPI && r && r.res && (n.lng = r.usedLng), !1 !== n.nest && (e = this.interpolator.nest(e, function () {
              for (var e = arguments.length, r = new Array(e), a = 0; a < e; a++) r[a] = arguments[a];
              return i && i[0] === r[0] && !n.context ? (o.logger.warn("It seems you are nesting recursively key: ".concat(r[0], " in key: ").concat(t[0])), null) : o.translate.apply(o, r.concat([t]));
            }, n)), n.interpolation && this.interpolator.reset();
          }
          var d = n.postProcess || this.options.postProcess,
            f = "string" == typeof d ? [d] : d;
          return null != e && f && f.length && !1 !== n.applyPostProcessor && (e = KN.handle(f, e, t, this.options && this.options.postProcessPassResolved ? VN({
            i18nResolved: r
          }, n) : n, this)), e;
        }
      }, {
        key: "resolve",
        value: function (e) {
          var t,
            n,
            r,
            i,
            o,
            a = this,
            s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return "string" == typeof e && (e = [e]), e.forEach(function (e) {
            if (!a.isValidLookup(t)) {
              var u = a.extractFromKey(e, s),
                c = u.key;
              n = c;
              var l = u.namespaces;
              a.options.fallbackNS && (l = l.concat(a.options.fallbackNS));
              var d = void 0 !== s.count && "string" != typeof s.count,
                f = d && !s.ordinal && 0 === s.count && a.pluralResolver.shouldUseIntlApi(),
                h = void 0 !== s.context && ("string" == typeof s.context || "number" == typeof s.context) && "" !== s.context,
                p = s.lngs ? s.lngs : a.languageUtils.toResolveHierarchy(s.lng || a.language, s.fallbackLng);
              l.forEach(function (e) {
                a.isValidLookup(t) || (o = e, !WN["".concat(p[0], "-").concat(e)] && a.utils && a.utils.hasLoadedNamespace && !a.utils.hasLoadedNamespace(o) && (WN["".concat(p[0], "-").concat(e)] = !0, a.logger.warn('key "'.concat(n, '" for languages "').concat(p.join(", "), '" won\'t get resolved as namespace "').concat(o, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), p.forEach(function (n) {
                  if (!a.isValidLookup(t)) {
                    i = n;
                    var o,
                      u = [c];
                    if (a.i18nFormat && a.i18nFormat.addLookupKeys) a.i18nFormat.addLookupKeys(u, c, n, e, s);else {
                      var l;
                      d && (l = a.pluralResolver.getSuffix(n, s.count, s));
                      var p = "".concat(a.options.pluralSeparator, "zero");
                      if (d && (u.push(c + l), f && u.push(c + p)), h) {
                        var m = "".concat(c).concat(a.options.contextSeparator).concat(s.context);
                        u.push(m), d && (u.push(m + l), f && u.push(m + p));
                      }
                    }
                    for (; o = u.pop();) a.isValidLookup(t) || (r = o, t = a.getResource(n, e, o, s));
                  }
                }));
              });
            }
          }), {
            res: t,
            usedKey: n,
            exactUsedKey: r,
            usedLng: i,
            usedNS: o
          };
        }
      }, {
        key: "isValidLookup",
        value: function (e) {
          return !(void 0 === e || !this.options.returnNull && null === e || !this.options.returnEmptyString && "" === e);
        }
      }, {
        key: "getResource",
        value: function (e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, n, r) : this.resourceStore.getResource(e, t, n, r);
        }
      }], [{
        key: "hasDefaultValue",
        value: function (e) {
          var t = "defaultValue";
          for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n) && t === n.substring(0, 12) && void 0 !== e[n]) return !0;
          return !1;
        }
      }]), n;
    }(MN);
  function GN(e) {
    return e.charAt(0).toUpperCase() + e.slice(1);
  }
  var QN = function () {
      function e(t) {
        cN(this, e), this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = kN.create("languageUtils");
      }
      return fN(e, [{
        key: "getScriptPartFromCode",
        value: function (e) {
          if (!e || e.indexOf("-") < 0) return null;
          var t = e.split("-");
          return 2 === t.length ? null : (t.pop(), "x" === t[t.length - 1].toLowerCase() ? null : this.formatLanguageCode(t.join("-")));
        }
      }, {
        key: "getLanguagePartFromCode",
        value: function (e) {
          if (!e || e.indexOf("-") < 0) return e;
          var t = e.split("-");
          return this.formatLanguageCode(t[0]);
        }
      }, {
        key: "formatLanguageCode",
        value: function (e) {
          if ("string" == typeof e && e.indexOf("-") > -1) {
            var t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"],
              n = e.split("-");
            return this.options.lowerCaseLng ? n = n.map(function (e) {
              return e.toLowerCase();
            }) : 2 === n.length ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = GN(n[1].toLowerCase()))) : 3 === n.length && (n[0] = n[0].toLowerCase(), 2 === n[1].length && (n[1] = n[1].toUpperCase()), "sgn" !== n[0] && 2 === n[2].length && (n[2] = n[2].toUpperCase()), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = GN(n[1].toLowerCase())), t.indexOf(n[2].toLowerCase()) > -1 && (n[2] = GN(n[2].toLowerCase()))), n.join("-");
          }
          return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
        }
      }, {
        key: "isSupportedCode",
        value: function (e) {
          return ("languageOnly" === this.options.load || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
        }
      }, {
        key: "getBestMatchFromCodes",
        value: function (e) {
          var t,
            n = this;
          return e ? (e.forEach(function (e) {
            if (!t) {
              var r = n.formatLanguageCode(e);
              n.options.supportedLngs && !n.isSupportedCode(r) || (t = r);
            }
          }), !t && this.options.supportedLngs && e.forEach(function (e) {
            if (!t) {
              var r = n.getLanguagePartFromCode(e);
              if (n.isSupportedCode(r)) return t = r;
              t = n.options.supportedLngs.find(function (e) {
                return e === r ? e : e.indexOf("-") < 0 && r.indexOf("-") < 0 ? void 0 : 0 === e.indexOf(r) ? e : void 0;
              });
            }
          }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t) : null;
        }
      }, {
        key: "getFallbackCodes",
        value: function (e, t) {
          if (!e) return [];
          if ("function" == typeof e && (e = e(t)), "string" == typeof e && (e = [e]), "[object Array]" === Object.prototype.toString.apply(e)) return e;
          if (!t) return e.default || [];
          var n = e[t];
          return n || (n = e[this.getScriptPartFromCode(t)]), n || (n = e[this.formatLanguageCode(t)]), n || (n = e[this.getLanguagePartFromCode(t)]), n || (n = e.default), n || [];
        }
      }, {
        key: "toResolveHierarchy",
        value: function (e, t) {
          var n = this,
            r = this.getFallbackCodes(t || this.options.fallbackLng || [], e),
            i = [],
            o = function (e) {
              e && (n.isSupportedCode(e) ? i.push(e) : n.logger.warn("rejecting language code not found in supportedLngs: ".concat(e)));
            };
          return "string" == typeof e && e.indexOf("-") > -1 ? ("languageOnly" !== this.options.load && o(this.formatLanguageCode(e)), "languageOnly" !== this.options.load && "currentOnly" !== this.options.load && o(this.getScriptPartFromCode(e)), "currentOnly" !== this.options.load && o(this.getLanguagePartFromCode(e))) : "string" == typeof e && o(this.formatLanguageCode(e)), r.forEach(function (e) {
            i.indexOf(e) < 0 && o(n.formatLanguageCode(e));
          }), i;
        }
      }]), e;
    }(),
    ZN = [{
      lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
      nr: [1, 2],
      fc: 1
    }, {
      lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
      nr: [1, 2],
      fc: 2
    }, {
      lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
      nr: [1],
      fc: 3
    }, {
      lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
      nr: [1, 2, 5],
      fc: 4
    }, {
      lngs: ["ar"],
      nr: [0, 1, 2, 3, 11, 100],
      fc: 5
    }, {
      lngs: ["cs", "sk"],
      nr: [1, 2, 5],
      fc: 6
    }, {
      lngs: ["csb", "pl"],
      nr: [1, 2, 5],
      fc: 7
    }, {
      lngs: ["cy"],
      nr: [1, 2, 3, 8],
      fc: 8
    }, {
      lngs: ["fr"],
      nr: [1, 2],
      fc: 9
    }, {
      lngs: ["ga"],
      nr: [1, 2, 3, 7, 11],
      fc: 10
    }, {
      lngs: ["gd"],
      nr: [1, 2, 3, 20],
      fc: 11
    }, {
      lngs: ["is"],
      nr: [1, 2],
      fc: 12
    }, {
      lngs: ["jv"],
      nr: [0, 1],
      fc: 13
    }, {
      lngs: ["kw"],
      nr: [1, 2, 3, 4],
      fc: 14
    }, {
      lngs: ["lt"],
      nr: [1, 2, 10],
      fc: 15
    }, {
      lngs: ["lv"],
      nr: [1, 2, 0],
      fc: 16
    }, {
      lngs: ["mk"],
      nr: [1, 2],
      fc: 17
    }, {
      lngs: ["mnk"],
      nr: [0, 1, 2],
      fc: 18
    }, {
      lngs: ["mt"],
      nr: [1, 2, 11, 20],
      fc: 19
    }, {
      lngs: ["or"],
      nr: [2, 1],
      fc: 2
    }, {
      lngs: ["ro"],
      nr: [1, 2, 20],
      fc: 20
    }, {
      lngs: ["sl"],
      nr: [5, 1, 2, 3],
      fc: 21
    }, {
      lngs: ["he", "iw"],
      nr: [1, 2, 20, 21],
      fc: 22
    }],
    JN = {
      1: function (e) {
        return Number(e > 1);
      },
      2: function (e) {
        return Number(1 != e);
      },
      3: function (e) {
        return 0;
      },
      4: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      5: function (e) {
        return Number(0 == e ? 0 : 1 == e ? 1 : 2 == e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5);
      },
      6: function (e) {
        return Number(1 == e ? 0 : e >= 2 && e <= 4 ? 1 : 2);
      },
      7: function (e) {
        return Number(1 == e ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      8: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : 8 != e && 11 != e ? 2 : 3);
      },
      9: function (e) {
        return Number(e >= 2);
      },
      10: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4);
      },
      11: function (e) {
        return Number(1 == e || 11 == e ? 0 : 2 == e || 12 == e ? 1 : e > 2 && e < 20 ? 2 : 3);
      },
      12: function (e) {
        return Number(e % 10 != 1 || e % 100 == 11);
      },
      13: function (e) {
        return Number(0 !== e);
      },
      14: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : 3 == e ? 2 : 3);
      },
      15: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      16: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : 0 !== e ? 1 : 2);
      },
      17: function (e) {
        return Number(1 == e || e % 10 == 1 && e % 100 != 11 ? 0 : 1);
      },
      18: function (e) {
        return Number(0 == e ? 0 : 1 == e ? 1 : 2);
      },
      19: function (e) {
        return Number(1 == e ? 0 : 0 == e || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3);
      },
      20: function (e) {
        return Number(1 == e ? 0 : 0 == e || e % 100 > 0 && e % 100 < 20 ? 1 : 2);
      },
      21: function (e) {
        return Number(e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0);
      },
      22: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3);
      }
    },
    XN = ["v1", "v2", "v3"],
    eD = {
      zero: 0,
      one: 1,
      two: 2,
      few: 3,
      many: 4,
      other: 5
    };
  var tD = function () {
    function e(t) {
      var n,
        r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      cN(this, e), this.languageUtils = t, this.options = r, this.logger = kN.create("pluralResolver"), this.options.compatibilityJSON && "v4" !== this.options.compatibilityJSON || "undefined" != typeof Intl && Intl.PluralRules || (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = (n = {}, ZN.forEach(function (e) {
        e.lngs.forEach(function (t) {
          n[t] = {
            numbers: e.nr,
            plurals: JN[e.fc]
          };
        });
      }), n);
    }
    return fN(e, [{
      key: "addRule",
      value: function (e, t) {
        this.rules[e] = t;
      }
    }, {
      key: "getRule",
      value: function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
          return new Intl.PluralRules(e, {
            type: t.ordinal ? "ordinal" : "cardinal"
          });
        } catch (e) {
          return;
        }
        return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
      }
    }, {
      key: "needsPlural",
      value: function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = this.getRule(e, t);
        return this.shouldUseIntlApi() ? n && n.resolvedOptions().pluralCategories.length > 1 : n && n.numbers.length > 1;
      }
    }, {
      key: "getPluralFormsOfKey",
      value: function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return this.getSuffixes(e, n).map(function (e) {
          return "".concat(t).concat(e);
        });
      }
    }, {
      key: "getSuffixes",
      value: function (e) {
        var t = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = this.getRule(e, n);
        return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort(function (e, t) {
          return eD[e] - eD[t];
        }).map(function (e) {
          return "".concat(t.options.prepend).concat(e);
        }) : r.numbers.map(function (r) {
          return t.getSuffix(e, r, n);
        }) : [];
      }
    }, {
      key: "getSuffix",
      value: function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = this.getRule(e, n);
        return r ? this.shouldUseIntlApi() ? "".concat(this.options.prepend).concat(r.select(t)) : this.getSuffixRetroCompatible(r, t) : (this.logger.warn("no plural rule found for: ".concat(e)), "");
      }
    }, {
      key: "getSuffixRetroCompatible",
      value: function (e, t) {
        var n = this,
          r = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t)),
          i = e.numbers[r];
        this.options.simplifyPluralSuffix && 2 === e.numbers.length && 1 === e.numbers[0] && (2 === i ? i = "plural" : 1 === i && (i = ""));
        var o = function () {
          return n.options.prepend && i.toString() ? n.options.prepend + i.toString() : i.toString();
        };
        return "v1" === this.options.compatibilityJSON ? 1 === i ? "" : "number" == typeof i ? "_plural_".concat(i.toString()) : o() : "v2" === this.options.compatibilityJSON || this.options.simplifyPluralSuffix && 2 === e.numbers.length && 1 === e.numbers[0] ? o() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
      }
    }, {
      key: "shouldUseIntlApi",
      value: function () {
        return !XN.includes(this.options.compatibilityJSON);
      }
    }]), e;
  }();
  function nD(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function rD(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? nD(Object(n), !0).forEach(function (t) {
        bN(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nD(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function iD(e, t, n) {
    var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".",
      i = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
      o = function (e, t, n) {
        var r = TN(e, n);
        return void 0 !== r ? r : TN(t, n);
      }(e, t, n);
    return !o && i && "string" == typeof n && void 0 === (o = jN(e, n, r)) && (o = jN(t, n, r)), o;
  }
  var oD = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      cN(this, e), this.logger = kN.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function (e) {
        return e;
      }, this.init(t);
    }
    return fN(e, [{
      key: "init",
      value: function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        e.interpolation || (e.interpolation = {
          escapeValue: !0
        });
        var t = e.interpolation;
        this.escape = void 0 !== t.escape ? t.escape : NN, this.escapeValue = void 0 === t.escapeValue || t.escapeValue, this.useRawValueToEscape = void 0 !== t.useRawValueToEscape && t.useRawValueToEscape, this.prefix = t.prefix ? ON(t.prefix) : t.prefixEscaped || "{{", this.suffix = t.suffix ? ON(t.suffix) : t.suffixEscaped || "}}", this.formatSeparator = t.formatSeparator ? t.formatSeparator : t.formatSeparator || ",", this.unescapePrefix = t.unescapeSuffix ? "" : t.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : t.unescapeSuffix || "", this.nestingPrefix = t.nestingPrefix ? ON(t.nestingPrefix) : t.nestingPrefixEscaped || ON("$t("), this.nestingSuffix = t.nestingSuffix ? ON(t.nestingSuffix) : t.nestingSuffixEscaped || ON(")"), this.nestingOptionsSeparator = t.nestingOptionsSeparator ? t.nestingOptionsSeparator : t.nestingOptionsSeparator || ",", this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3, this.alwaysFormat = void 0 !== t.alwaysFormat && t.alwaysFormat, this.resetRegExp();
      }
    }, {
      key: "reset",
      value: function () {
        this.options && this.init(this.options);
      }
    }, {
      key: "resetRegExp",
      value: function () {
        var e = "".concat(this.prefix, "(.+?)").concat(this.suffix);
        this.regexp = new RegExp(e, "g");
        var t = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
        this.regexpUnescape = new RegExp(t, "g");
        var n = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
        this.nestingRegexp = new RegExp(n, "g");
      }
    }, {
      key: "interpolate",
      value: function (e, t, n, r) {
        var i,
          o,
          a,
          s = this,
          u = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function c(e) {
          return e.replace(/\$/g, "$$$$");
        }
        var l = function (e) {
          if (e.indexOf(s.formatSeparator) < 0) {
            var i = iD(t, u, e, s.options.keySeparator, s.options.ignoreJSONStructure);
            return s.alwaysFormat ? s.format(i, void 0, n, rD(rD(rD({}, r), t), {}, {
              interpolationkey: e
            })) : i;
          }
          var o = e.split(s.formatSeparator),
            a = o.shift().trim(),
            c = o.join(s.formatSeparator).trim();
          return s.format(iD(t, u, a, s.options.keySeparator, s.options.ignoreJSONStructure), c, n, rD(rD(rD({}, r), t), {}, {
            interpolationkey: a
          }));
        };
        this.resetRegExp();
        var d = r && r.missingInterpolationHandler || this.options.missingInterpolationHandler,
          f = r && r.interpolation && void 0 !== r.interpolation.skipOnVariables ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        return [{
          regex: this.regexpUnescape,
          safeValue: function (e) {
            return c(e);
          }
        }, {
          regex: this.regexp,
          safeValue: function (e) {
            return s.escapeValue ? c(s.escape(e)) : c(e);
          }
        }].forEach(function (t) {
          for (a = 0; i = t.regex.exec(e);) {
            var n = i[1].trim();
            if (void 0 === (o = l(n))) {
              if ("function" == typeof d) {
                var u = d(e, i, r);
                o = "string" == typeof u ? u : "";
              } else if (r && Object.prototype.hasOwnProperty.call(r, n)) o = "";else {
                if (f) {
                  o = i[0];
                  continue;
                }
                s.logger.warn("missed to pass in variable ".concat(n, " for interpolating ").concat(e)), o = "";
              }
            } else "string" == typeof o || s.useRawValueToEscape || (o = xN(o));
            var c = t.safeValue(o);
            if (e = e.replace(i[0], c), f ? (t.regex.lastIndex += o.length, t.regex.lastIndex -= i[0].length) : t.regex.lastIndex = 0, ++a >= s.maxReplaces) break;
          }
        }), e;
      }
    }, {
      key: "nest",
      value: function (e, t) {
        var n,
          r,
          i,
          o = this,
          a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        function s(e, t) {
          var n = this.nestingOptionsSeparator;
          if (e.indexOf(n) < 0) return e;
          var r = e.split(new RegExp("".concat(n, "[ ]*{"))),
            o = "{".concat(r[1]);
          e = r[0];
          var a = (o = this.interpolate(o, i)).match(/'/g),
            s = o.match(/"/g);
          (a && a.length % 2 == 0 && !s || s.length % 2 != 0) && (o = o.replace(/'/g, '"'));
          try {
            i = JSON.parse(o), t && (i = rD(rD({}, t), i));
          } catch (t) {
            return this.logger.warn("failed parsing options string in nesting for key ".concat(e), t), "".concat(e).concat(n).concat(o);
          }
          return delete i.defaultValue, e;
        }
        for (; n = this.nestingRegexp.exec(e);) {
          var u = [];
          (i = (i = rD({}, a)).replace && "string" != typeof i.replace ? i.replace : i).applyPostProcessor = !1, delete i.defaultValue;
          var c = !1;
          if (-1 !== n[0].indexOf(this.formatSeparator) && !/{.*}/.test(n[1])) {
            var l = n[1].split(this.formatSeparator).map(function (e) {
              return e.trim();
            });
            n[1] = l.shift(), u = l, c = !0;
          }
          if ((r = t(s.call(this, n[1].trim(), i), i)) && n[0] === e && "string" != typeof r) return r;
          "string" != typeof r && (r = xN(r)), r || (this.logger.warn("missed to resolve ".concat(n[1], " for nesting ").concat(e)), r = ""), c && (r = u.reduce(function (e, t) {
            return o.format(e, t, a.lng, rD(rD({}, a), {}, {
              interpolationkey: n[1].trim()
            }));
          }, r.trim())), e = e.replace(n[0], r), this.regexp.lastIndex = 0;
        }
        return e;
      }
    }]), e;
  }();
  function aD(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function sD(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? aD(Object(n), !0).forEach(function (t) {
        bN(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : aD(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function uD(e) {
    var t = {};
    return function (n, r, i) {
      var o = r + JSON.stringify(i),
        a = t[o];
      return a || (a = e(r, i), t[o] = a), a(n);
    };
  }
  var cD = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      cN(this, e), this.logger = kN.create("formatter"), this.options = t, this.formats = {
        number: uD(function (e, t) {
          var n = new Intl.NumberFormat(e, sD({}, t));
          return function (e) {
            return n.format(e);
          };
        }),
        currency: uD(function (e, t) {
          var n = new Intl.NumberFormat(e, sD(sD({}, t), {}, {
            style: "currency"
          }));
          return function (e) {
            return n.format(e);
          };
        }),
        datetime: uD(function (e, t) {
          var n = new Intl.DateTimeFormat(e, sD({}, t));
          return function (e) {
            return n.format(e);
          };
        }),
        relativetime: uD(function (e, t) {
          var n = new Intl.RelativeTimeFormat(e, sD({}, t));
          return function (e) {
            return n.format(e, t.range || "day");
          };
        }),
        list: uD(function (e, t) {
          var n = new Intl.ListFormat(e, sD({}, t));
          return function (e) {
            return n.format(e);
          };
        })
      }, this.init(t);
    }
    return fN(e, [{
      key: "init",
      value: function (e) {
        var t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
          interpolation: {}
        }).interpolation;
        this.formatSeparator = t.formatSeparator ? t.formatSeparator : t.formatSeparator || ",";
      }
    }, {
      key: "add",
      value: function (e, t) {
        this.formats[e.toLowerCase().trim()] = t;
      }
    }, {
      key: "addCached",
      value: function (e, t) {
        this.formats[e.toLowerCase().trim()] = uD(t);
      }
    }, {
      key: "format",
      value: function (e, t, n) {
        var r = this,
          i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
          o = t.split(this.formatSeparator).reduce(function (e, t) {
            var o = function (e) {
                var t = e.toLowerCase().trim(),
                  n = {};
                if (e.indexOf("(") > -1) {
                  var r = e.split("(");
                  t = r[0].toLowerCase().trim();
                  var i = r[1].substring(0, r[1].length - 1);
                  "currency" === t && i.indexOf(":") < 0 ? n.currency || (n.currency = i.trim()) : "relativetime" === t && i.indexOf(":") < 0 ? n.range || (n.range = i.trim()) : i.split(";").forEach(function (e) {
                    if (e) {
                      var t = wN(e.split(":")),
                        r = t[0],
                        i = t.slice(1).join(":").trim().replace(/^'+|'+$/g, "");
                      n[r.trim()] || (n[r.trim()] = i), "false" === i && (n[r.trim()] = !1), "true" === i && (n[r.trim()] = !0), isNaN(i) || (n[r.trim()] = parseInt(i, 10));
                    }
                  });
                }
                return {
                  formatName: t,
                  formatOptions: n
                };
              }(t),
              a = o.formatName,
              s = o.formatOptions;
            if (r.formats[a]) {
              var u = e;
              try {
                var c = i && i.formatParams && i.formatParams[i.interpolationkey] || {},
                  l = c.locale || c.lng || i.locale || i.lng || n;
                u = r.formats[a](e, l, sD(sD(sD({}, s), i), c));
              } catch (e) {
                r.logger.warn(e);
              }
              return u;
            }
            return r.logger.warn("there was no format function for ".concat(a)), e;
          }, e);
        return o;
      }
    }]), e;
  }();
  function lD(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function dD(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? lD(Object(n), !0).forEach(function (t) {
        bN(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lD(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function fD(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = vN(e);
      if (t) {
        var i = vN(this).constructor;
        n = Reflect.construct(r, arguments, i);
      } else n = r.apply(this, arguments);
      return gN(this, n);
    };
  }
  var hD = function (e) {
    mN(n, e);
    var t = fD(n);
    function n(e, r, i) {
      var o,
        a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      return cN(this, n), o = t.call(this), DN && MN.call(hN(o)), o.backend = e, o.store = r, o.services = i, o.languageUtils = i.languageUtils, o.options = a, o.logger = kN.create("backendConnector"), o.waitingReads = [], o.maxParallelReads = a.maxParallelReads || 10, o.readingCalls = 0, o.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, o.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, o.state = {}, o.queue = [], o.backend && o.backend.init && o.backend.init(i, a.backend, a), o;
    }
    return fN(n, [{
      key: "queueLoad",
      value: function (e, t, n, r) {
        var i = this,
          o = {},
          a = {},
          s = {},
          u = {};
        return e.forEach(function (e) {
          var r = !0;
          t.forEach(function (t) {
            var s = "".concat(e, "|").concat(t);
            !n.reload && i.store.hasResourceBundle(e, t) ? i.state[s] = 2 : i.state[s] < 0 || (1 === i.state[s] ? void 0 === a[s] && (a[s] = !0) : (i.state[s] = 1, r = !1, void 0 === a[s] && (a[s] = !0), void 0 === o[s] && (o[s] = !0), void 0 === u[t] && (u[t] = !0)));
          }), r || (s[e] = !0);
        }), (Object.keys(o).length || Object.keys(a).length) && this.queue.push({
          pending: a,
          pendingCount: Object.keys(a).length,
          loaded: {},
          errors: [],
          callback: r
        }), {
          toLoad: Object.keys(o),
          pending: Object.keys(a),
          toLoadLanguages: Object.keys(s),
          toLoadNamespaces: Object.keys(u)
        };
      }
    }, {
      key: "loaded",
      value: function (e, t, n) {
        var r = e.split("|"),
          i = r[0],
          o = r[1];
        t && this.emit("failedLoading", i, o, t), n && this.store.addResourceBundle(i, o, n), this.state[e] = t ? -1 : 2;
        var a = {};
        this.queue.forEach(function (n) {
          !function (e, t, n, r) {
            var i = RN(e, t, Object),
              o = i.obj,
              a = i.k;
            o[a] = o[a] || [], r && (o[a] = o[a].concat(n)), r || o[a].push(n);
          }(n.loaded, [i], o), function (e, t) {
            void 0 !== e.pending[t] && (delete e.pending[t], e.pendingCount--);
          }(n, e), t && n.errors.push(t), 0 !== n.pendingCount || n.done || (Object.keys(n.loaded).forEach(function (e) {
            a[e] || (a[e] = {});
            var t = n.loaded[e];
            t.length && t.forEach(function (t) {
              void 0 === a[e][t] && (a[e][t] = !0);
            });
          }), n.done = !0, n.errors.length ? n.callback(n.errors) : n.callback());
        }), this.emit("loaded", a), this.queue = this.queue.filter(function (e) {
          return !e.done;
        });
      }
    }, {
      key: "read",
      value: function (e, t, n) {
        var r = this,
          i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
          o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.retryTimeout,
          a = arguments.length > 5 ? arguments[5] : void 0;
        if (!e.length) return a(null, {});
        if (this.readingCalls >= this.maxParallelReads) this.waitingReads.push({
          lng: e,
          ns: t,
          fcName: n,
          tried: i,
          wait: o,
          callback: a
        });else {
          this.readingCalls++;
          var s = function (s, u) {
              if (r.readingCalls--, r.waitingReads.length > 0) {
                var c = r.waitingReads.shift();
                r.read(c.lng, c.ns, c.fcName, c.tried, c.wait, c.callback);
              }
              s && u && i < r.maxRetries ? setTimeout(function () {
                r.read.call(r, e, t, n, i + 1, 2 * o, a);
              }, o) : a(s, u);
            },
            u = this.backend[n].bind(this.backend);
          if (2 !== u.length) return u(e, t, s);
          try {
            var c = u(e, t);
            c && "function" == typeof c.then ? c.then(function (e) {
              return s(null, e);
            }).catch(s) : s(null, c);
          } catch (e) {
            s(e);
          }
        }
      }
    }, {
      key: "prepareLoading",
      value: function (e, t) {
        var n = this,
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          i = arguments.length > 3 ? arguments[3] : void 0;
        if (!this.backend) return this.logger.warn("No backend was added via i18next.use. Will not load resources."), i && i();
        "string" == typeof e && (e = this.languageUtils.toResolveHierarchy(e)), "string" == typeof t && (t = [t]);
        var o = this.queueLoad(e, t, r, i);
        if (!o.toLoad.length) return o.pending.length || i(), null;
        o.toLoad.forEach(function (e) {
          n.loadOne(e);
        });
      }
    }, {
      key: "load",
      value: function (e, t, n) {
        this.prepareLoading(e, t, {}, n);
      }
    }, {
      key: "reload",
      value: function (e, t, n) {
        this.prepareLoading(e, t, {
          reload: !0
        }, n);
      }
    }, {
      key: "loadOne",
      value: function (e) {
        var t = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          r = e.split("|"),
          i = r[0],
          o = r[1];
        this.read(i, o, "read", void 0, void 0, function (r, a) {
          r && t.logger.warn("".concat(n, "loading namespace ").concat(o, " for language ").concat(i, " failed"), r), !r && a && t.logger.log("".concat(n, "loaded namespace ").concat(o, " for language ").concat(i), a), t.loaded(e, r, a);
        });
      }
    }, {
      key: "saveMissing",
      value: function (e, t, n, r, i) {
        var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {},
          a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : function () {};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) this.logger.warn('did not save key "'.concat(n, '" as the namespace "').concat(t, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");else if (null != n && "" !== n) {
          if (this.backend && this.backend.create) {
            var s = dD(dD({}, o), {}, {
                isUpdate: i
              }),
              u = this.backend.create.bind(this.backend);
            if (u.length < 6) try {
              var c;
              (c = 5 === u.length ? u(e, t, n, r, s) : u(e, t, n, r)) && "function" == typeof c.then ? c.then(function (e) {
                return a(null, e);
              }).catch(a) : a(null, c);
            } catch (e) {
              a(e);
            } else u(e, t, n, r, a, s);
          }
          e && e[0] && this.store.addResource(e[0], t, n, r);
        }
      }
    }]), n;
  }(MN);
  function pD() {
    return {
      debug: !1,
      initImmediate: !0,
      ns: ["translation"],
      defaultNS: ["translation"],
      fallbackLng: ["dev"],
      fallbackNS: !1,
      supportedLngs: !1,
      nonExplicitSupportedLngs: !1,
      load: "all",
      preload: !1,
      simplifyPluralSuffix: !0,
      keySeparator: ".",
      nsSeparator: ":",
      pluralSeparator: "_",
      contextSeparator: "_",
      partialBundledLanguages: !1,
      saveMissing: !1,
      updateMissing: !1,
      saveMissingTo: "fallback",
      saveMissingPlurals: !0,
      missingKeyHandler: !1,
      missingInterpolationHandler: !1,
      postProcess: !1,
      postProcessPassResolved: !1,
      returnNull: !0,
      returnEmptyString: !0,
      returnObjects: !1,
      joinArrays: !1,
      returnedObjectHandler: !1,
      parseMissingKeyHandler: !1,
      appendNamespaceToMissingKey: !1,
      appendNamespaceToCIMode: !1,
      overloadTranslationOptionHandler: function (e) {
        var t = {};
        if ("object" === uN(e[1]) && (t = e[1]), "string" == typeof e[1] && (t.defaultValue = e[1]), "string" == typeof e[2] && (t.tDescription = e[2]), "object" === uN(e[2]) || "object" === uN(e[3])) {
          var n = e[3] || e[2];
          Object.keys(n).forEach(function (e) {
            t[e] = n[e];
          });
        }
        return t;
      },
      interpolation: {
        escapeValue: !0,
        format: function (e, t, n, r) {
          return e;
        },
        prefix: "{{",
        suffix: "}}",
        formatSeparator: ",",
        unescapePrefix: "-",
        nestingPrefix: "$t(",
        nestingSuffix: ")",
        nestingOptionsSeparator: ",",
        maxReplaces: 1e3,
        skipOnVariables: !0
      }
    };
  }
  function mD(e) {
    return "string" == typeof e.ns && (e.ns = [e.ns]), "string" == typeof e.fallbackLng && (e.fallbackLng = [e.fallbackLng]), "string" == typeof e.fallbackNS && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
  }
  function gD(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function vD(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? gD(Object(n), !0).forEach(function (t) {
        bN(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gD(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function bD(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = vN(e);
      if (t) {
        var i = vN(this).constructor;
        n = Reflect.construct(r, arguments, i);
      } else n = r.apply(this, arguments);
      return gN(this, n);
    };
  }
  function yD() {}
  var wD = function (e) {
    mN(n, e);
    var t = bD(n);
    function n() {
      var e,
        r,
        i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        o = arguments.length > 1 ? arguments[1] : void 0;
      if (cN(this, n), e = t.call(this), DN && MN.call(hN(e)), e.options = mD(i), e.services = {}, e.logger = kN, e.modules = {
        external: []
      }, r = hN(e), Object.getOwnPropertyNames(Object.getPrototypeOf(r)).forEach(function (e) {
        "function" == typeof r[e] && (r[e] = r[e].bind(r));
      }), o && !e.isInitialized && !i.isClone) {
        if (!e.options.initImmediate) return e.init(i, o), gN(e, hN(e));
        setTimeout(function () {
          e.init(i, o);
        }, 0);
      }
      return e;
    }
    return fN(n, [{
      key: "init",
      value: function () {
        var e = this,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = arguments.length > 1 ? arguments[1] : void 0;
        "function" == typeof t && (n = t, t = {}), !t.defaultNS && !1 !== t.defaultNS && t.ns && ("string" == typeof t.ns ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
        var r = pD();
        function i(e) {
          return e ? "function" == typeof e ? new e() : e : null;
        }
        if (this.options = vD(vD(vD({}, r), this.options), mD(t)), "v1" !== this.options.compatibilityAPI && (this.options.interpolation = vD(vD({}, r.interpolation), this.options.interpolation)), void 0 !== t.keySeparator && (this.options.userDefinedKeySeparator = t.keySeparator), void 0 !== t.nsSeparator && (this.options.userDefinedNsSeparator = t.nsSeparator), !this.options.isClone) {
          var o;
          this.modules.logger ? kN.init(i(this.modules.logger), this.options) : kN.init(null, this.options), this.modules.formatter ? o = this.modules.formatter : "undefined" != typeof Intl && (o = cD);
          var a = new QN(this.options);
          this.store = new qN(this.options.resources, this.options);
          var s = this.services;
          s.logger = kN, s.resourceStore = this.store, s.languageUtils = a, s.pluralResolver = new tD(a, {
            prepend: this.options.pluralSeparator,
            compatibilityJSON: this.options.compatibilityJSON,
            simplifyPluralSuffix: this.options.simplifyPluralSuffix
          }), !o || this.options.interpolation.format && this.options.interpolation.format !== r.interpolation.format || (s.formatter = i(o), s.formatter.init(s, this.options), this.options.interpolation.format = s.formatter.format.bind(s.formatter)), s.interpolator = new oD(this.options), s.utils = {
            hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
          }, s.backendConnector = new hD(i(this.modules.backend), s.resourceStore, s, this.options), s.backendConnector.on("*", function (t) {
            for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
            e.emit.apply(e, [t].concat(r));
          }), this.modules.languageDetector && (s.languageDetector = i(this.modules.languageDetector), s.languageDetector.init && s.languageDetector.init(s, this.options.detection, this.options)), this.modules.i18nFormat && (s.i18nFormat = i(this.modules.i18nFormat), s.i18nFormat.init && s.i18nFormat.init(this)), this.translator = new YN(this.services, this.options), this.translator.on("*", function (t) {
            for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
            e.emit.apply(e, [t].concat(r));
          }), this.modules.external.forEach(function (t) {
            t.init && t.init(e);
          });
        }
        if (this.format = this.options.interpolation.format, n || (n = yD), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
          var u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          u.length > 0 && "dev" !== u[0] && (this.options.lng = u[0]);
        }
        this.services.languageDetector || this.options.lng || this.logger.warn("init: no languageDetector is used and no lng is defined");
        ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach(function (t) {
          e[t] = function () {
            var n;
            return (n = e.store)[t].apply(n, arguments);
          };
        });
        ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach(function (t) {
          e[t] = function () {
            var n;
            return (n = e.store)[t].apply(n, arguments), e;
          };
        });
        var c = CN(),
          l = function () {
            var t = function (t, r) {
              e.isInitialized && !e.initializedStoreOnce && e.logger.warn("init: i18next is already initialized. You should call init just once!"), e.isInitialized = !0, e.options.isClone || e.logger.log("initialized", e.options), e.emit("initialized", e.options), c.resolve(r), n(t, r);
            };
            if (e.languages && "v1" !== e.options.compatibilityAPI && !e.isInitialized) return t(null, e.t.bind(e));
            e.changeLanguage(e.options.lng, t);
          };
        return this.options.resources || !this.options.initImmediate ? l() : setTimeout(l, 0), c;
      }
    }, {
      key: "loadResources",
      value: function (e) {
        var t = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : yD,
          r = "string" == typeof e ? e : this.language;
        if ("function" == typeof e && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
          if (r && "cimode" === r.toLowerCase()) return n();
          var i = [],
            o = function (e) {
              e && t.services.languageUtils.toResolveHierarchy(e).forEach(function (e) {
                i.indexOf(e) < 0 && i.push(e);
              });
            };
          if (r) o(r);else this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach(function (e) {
            return o(e);
          });
          this.options.preload && this.options.preload.forEach(function (e) {
            return o(e);
          }), this.services.backendConnector.load(i, this.options.ns, function (e) {
            e || t.resolvedLanguage || !t.language || t.setResolvedLanguage(t.language), n(e);
          });
        } else n(null);
      }
    }, {
      key: "reloadResources",
      value: function (e, t, n) {
        var r = CN();
        return e || (e = this.languages), t || (t = this.options.ns), n || (n = yD), this.services.backendConnector.reload(e, t, function (e) {
          r.resolve(), n(e);
        }), r;
      }
    }, {
      key: "use",
      value: function (e) {
        if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        return "backend" === e.type && (this.modules.backend = e), ("logger" === e.type || e.log && e.warn && e.error) && (this.modules.logger = e), "languageDetector" === e.type && (this.modules.languageDetector = e), "i18nFormat" === e.type && (this.modules.i18nFormat = e), "postProcessor" === e.type && KN.addPostProcessor(e), "formatter" === e.type && (this.modules.formatter = e), "3rdParty" === e.type && this.modules.external.push(e), this;
      }
    }, {
      key: "setResolvedLanguage",
      value: function (e) {
        if (e && this.languages && !(["cimode", "dev"].indexOf(e) > -1)) for (var t = 0; t < this.languages.length; t++) {
          var n = this.languages[t];
          if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
            this.resolvedLanguage = n;
            break;
          }
        }
      }
    }, {
      key: "changeLanguage",
      value: function (e, t) {
        var n = this;
        this.isLanguageChangingTo = e;
        var r = CN();
        this.emit("languageChanging", e);
        var i = function (e) {
            n.language = e, n.languages = n.services.languageUtils.toResolveHierarchy(e), n.resolvedLanguage = void 0, n.setResolvedLanguage(e);
          },
          o = function (o) {
            e || o || !n.services.languageDetector || (o = []);
            var a = "string" == typeof o ? o : n.services.languageUtils.getBestMatchFromCodes(o);
            a && (n.language || i(a), n.translator.language || n.translator.changeLanguage(a), n.services.languageDetector && n.services.languageDetector.cacheUserLanguage && n.services.languageDetector.cacheUserLanguage(a)), n.loadResources(a, function (e) {
              !function (e, o) {
                o ? (i(o), n.translator.changeLanguage(o), n.isLanguageChangingTo = void 0, n.emit("languageChanged", o), n.logger.log("languageChanged", o)) : n.isLanguageChangingTo = void 0, r.resolve(function () {
                  return n.t.apply(n, arguments);
                }), t && t(e, function () {
                  return n.t.apply(n, arguments);
                });
              }(e, a);
            });
          };
        return e || !this.services.languageDetector || this.services.languageDetector.async ? !e && this.services.languageDetector && this.services.languageDetector.async ? 0 === this.services.languageDetector.detect.length ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e) : o(this.services.languageDetector.detect()), r;
      }
    }, {
      key: "getFixedT",
      value: function (e, t, n) {
        var r = this,
          i = function e(t, i) {
            var o;
            if ("object" !== uN(i)) {
              for (var a = arguments.length, s = new Array(a > 2 ? a - 2 : 0), u = 2; u < a; u++) s[u - 2] = arguments[u];
              o = r.options.overloadTranslationOptionHandler([t, i].concat(s));
            } else o = vD({}, i);
            o.lng = o.lng || e.lng, o.lngs = o.lngs || e.lngs, o.ns = o.ns || e.ns, o.keyPrefix = o.keyPrefix || n || e.keyPrefix;
            var c,
              l = r.options.keySeparator || ".";
            return c = o.keyPrefix && Array.isArray(t) ? t.map(function (e) {
              return "".concat(o.keyPrefix).concat(l).concat(e);
            }) : o.keyPrefix ? "".concat(o.keyPrefix).concat(l).concat(t) : t, r.t(c, o);
          };
        return "string" == typeof e ? i.lng = e : i.lngs = e, i.ns = t, i.keyPrefix = n, i;
      }
    }, {
      key: "t",
      value: function () {
        var e;
        return this.translator && (e = this.translator).translate.apply(e, arguments);
      }
    }, {
      key: "exists",
      value: function () {
        var e;
        return this.translator && (e = this.translator).exists.apply(e, arguments);
      }
    }, {
      key: "setDefaultNamespace",
      value: function (e) {
        this.options.defaultNS = e;
      }
    }, {
      key: "hasLoadedNamespace",
      value: function (e) {
        var t = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!this.isInitialized) return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
        if (!this.languages || !this.languages.length) return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
        var r = n.lng || this.resolvedLanguage || this.languages[0],
          i = !!this.options && this.options.fallbackLng,
          o = this.languages[this.languages.length - 1];
        if ("cimode" === r.toLowerCase()) return !0;
        var a = function (e, n) {
          var r = t.services.backendConnector.state["".concat(e, "|").concat(n)];
          return -1 === r || 2 === r;
        };
        if (n.precheck) {
          var s = n.precheck(this, a);
          if (void 0 !== s) return s;
        }
        return !!this.hasResourceBundle(r, e) || !(this.services.backendConnector.backend && (!this.options.resources || this.options.partialBundledLanguages)) || !(!a(r, e) || i && !a(o, e));
      }
    }, {
      key: "loadNamespaces",
      value: function (e, t) {
        var n = this,
          r = CN();
        return this.options.ns ? ("string" == typeof e && (e = [e]), e.forEach(function (e) {
          n.options.ns.indexOf(e) < 0 && n.options.ns.push(e);
        }), this.loadResources(function (e) {
          r.resolve(), t && t(e);
        }), r) : (t && t(), Promise.resolve());
      }
    }, {
      key: "loadLanguages",
      value: function (e, t) {
        var n = CN();
        "string" == typeof e && (e = [e]);
        var r = this.options.preload || [],
          i = e.filter(function (e) {
            return r.indexOf(e) < 0;
          });
        return i.length ? (this.options.preload = r.concat(i), this.loadResources(function (e) {
          n.resolve(), t && t(e);
        }), n) : (t && t(), Promise.resolve());
      }
    }, {
      key: "dir",
      value: function (e) {
        if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
        var t = this.services && this.services.languageUtils || new QN(pD());
        return ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"].indexOf(t.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
      }
    }, {
      key: "cloneInstance",
      value: function () {
        var e = this,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : yD,
          i = vD(vD(vD({}, this.options), t), {
            isClone: !0
          }),
          o = new n(i);
        void 0 === t.debug && void 0 === t.prefix || (o.logger = o.logger.clone(t));
        return ["store", "services", "language"].forEach(function (t) {
          o[t] = e[t];
        }), o.services = vD({}, this.services), o.services.utils = {
          hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
        }, o.translator = new YN(o.services, o.options), o.translator.on("*", function (e) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          o.emit.apply(o, [e].concat(n));
        }), o.init(i, r), o.translator.options = o.options, o.translator.backendConnector.services.utils = {
          hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
        }, o;
      }
    }, {
      key: "toJSON",
      value: function () {
        return {
          options: this.options,
          store: this.store,
          language: this.language,
          languages: this.languages,
          resolvedLanguage: this.resolvedLanguage
        };
      }
    }]), n;
  }(MN);
  bN(wD, "createInstance", function () {
    return new wD(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, arguments.length > 1 ? arguments[1] : void 0);
  });
  var AD = wD.createInstance();
  AD.createInstance = wD.createInstance;
  var _D = AD.createInstance;
  AD.dir, AD.init, AD.loadResources, AD.reloadResources, AD.use, AD.changeLanguage, AD.getFixedT, AD.t, AD.exists, AD.setDefaultNamespace, AD.hasLoadedNamespace, AD.loadNamespaces, AD.loadLanguages;
  var ED,
    SD = "0.20.3";
  e.PROVIDER_UPDATE_TYPE = void 0, (ED = e.PROVIDER_UPDATE_TYPE || (e.PROVIDER_UPDATE_TYPE = {})).TERMINATE = "terminate", ED.EXTENSION = "extension", ED.INITIALIZED = "initialized";
  const kD = "undefined" != typeof window && window.localStorage;
  function MD(t) {
    var n, r;
    return wS(this, void 0, void 0, function* () {
      OL("[MetaMaskSDK: connectWithExtensionProvider()] ", t), t.sdkProvider = t.activeProvider, t.activeProvider = window.extension, window.ethereum = window.extension;
      try {
        const e = yield null === (n = window.extension) || void 0 === n ? void 0 : n.request({
          method: "eth_requestAccounts"
        });
        OL(`[MetaMaskSDK: connectWithExtensionProvider()] accounts=${e}`);
      } catch (e) {
        return void console.warn("[MetaMaskSDK: connectWithExtensionProvider()] can't request accounts error", e);
      }
      localStorage.setItem(XL, "extension"), t.extensionActive = !0, t.emit(e.EventType.PROVIDER_UPDATE, e.PROVIDER_UPDATE_TYPE.EXTENSION), t.options.enableAnalytics && (null === (r = t.analytics) || void 0 === r || r.send({
        event: XE.SDK_USE_EXTENSION
      }));
    });
  }
  var CD;
  !function (e) {
    e.INPAGE = "metamask-inpage", e.CONTENT_SCRIPT = "metamask-contentscript", e.PROVIDER = "metamask-provider";
  }(CD || (CD = {}));
  const xD = "https://metamask.app.link/connect",
    RD = "metamask://connect",
    ID = {
      NAME: "MetaMask",
      RDNS: "io.metamask"
    },
    TD = /(?:^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}$)|(?:^0{8}-0{4}-0{4}-0{4}-0{12}$)/u,
    PD = 36e5;
  class OD {
    constructor({
      shouldSetOnWindow: e,
      connectionStream: t,
      shouldSendMetadata: n = !1,
      shouldShimWeb3: r
    }) {
      const i = new oN({
          connectionStream: t,
          shouldSendMetadata: n,
          shouldSetOnWindow: e,
          shouldShimWeb3: r,
          autoRequestAccounts: !1
        }),
        o = new Proxy(i, {
          deleteProperty: () => !0
        });
      var a;
      this.provider = o, e && "undefined" != typeof window && (a = this.provider, window.ethereum = a, window.dispatchEvent(new Event("ethereum#initialized"))), r && "undefined" != typeof window && function (e, t = console) {
        let n = !1,
          r = !1;
        if (!window.web3) {
          const i = "__isMetaMaskShim__";
          let o = {
            currentProvider: e
          };
          Object.defineProperty(o, i, {
            value: !0,
            enumerable: !0,
            configurable: !1,
            writable: !1
          }), o = new Proxy(o, {
            get: (o, a, ...s) => ("currentProvider" !== a || n ? "currentProvider" === a || a === i || r || (r = !0, t.error("MetaMask no longer injects web3. For details, see: https://docs.metamask.io/guide/provider-migration.html#replacing-window-web3"), e.request({
              method: "metamask_logWeb3ShimUsage"
            }).catch(e => {
              t.debug("MetaMask: Failed to log web3 shim usage.", e);
            })) : (n = !0, t.warn("You are accessing the MetaMask window.web3.currentProvider shim. This property is deprecated; use window.ethereum instead. For details, see: https://docs.metamask.io/guide/provider-migration.html#replacing-window-web3")), Reflect.get(o, a, ...s)),
            set: (...e) => (t.warn("You are accessing the MetaMask window.web3 shim. This object is deprecated; use window.ethereum instead. For details, see: https://docs.metamask.io/guide/provider-migration.html#replacing-window-web3"), Reflect.set(...e))
          }), Object.defineProperty(window, "web3", {
            value: o,
            enumerable: !1,
            configurable: !0,
            writable: !0
          });
        }
      }(this.provider), this.provider.on("_initialized", () => {
        const e = {
          chainId: this.provider.getChainId(),
          isConnected: this.provider.isConnected(),
          isMetaNask: this.provider.isMetaMask,
          selectedAddress: this.provider.getSelectedAddress(),
          networkVersion: this.provider.getNetworkVersion()
        };
        OL("[Ethereum: constructor()] provider initialized", e);
      });
    }
    static init(e) {
      var t;
      return OL("[Ethereum: init()] Initializing Ethereum service"), this.instance = new OD(e), null === (t = this.instance) || void 0 === t ? void 0 : t.provider;
    }
    static destroy() {
      OD.instance = void 0;
    }
    static getInstance() {
      var e;
      if (!(null === (e = this.instance) || void 0 === e ? void 0 : e.provider)) throw new Error("Ethereum instance not intiialized - call Ethereum.factory first.");
      return this.instance;
    }
    static getProvider() {
      var e;
      if (!(null === (e = this.instance) || void 0 === e ? void 0 : e.provider)) throw new Error("Ethereum instance not intiialized - call Ethereum.factory first.");
      return this.instance.provider;
    }
  }
  function LD(e, t, n, r) {
    var i, o, a, s, u, c, l, d, f, h, p, m, g, v;
    return wS(this, void 0, void 0, function* () {
      const n = null === (i = e.state.remote) || void 0 === i ? void 0 : i.isReady(),
        b = null === (o = e.state.remote) || void 0 === o ? void 0 : o.isConnected(),
        y = null === (a = e.state.remote) || void 0 === a ? void 0 : a.isPaused(),
        w = OD.getProvider(),
        _ = null === (s = e.state.remote) || void 0 === s ? void 0 : s.getChannelId(),
        E = null === (u = e.state.remote) || void 0 === u ? void 0 : u.isAuthorized(),
        {
          method: S,
          data: k
        } = (e => {
          var t;
          let n;
          return A.isBuffer(e) ? (n = e.toJSON(), n._isBuffer = !0) : n = e, {
            method: null === (t = null == n ? void 0 : n.data) || void 0 === t ? void 0 : t.method,
            data: n
          };
        })(t);
      if (OL(`[RCPMS: write()] method='${S}' isRemoteReady=${n} channelId=${_} isSocketConnected=${b} isRemotePaused=${y} providerConnected=${w.isConnected()}`, t), !_) return S !== YL.METAMASK_GETPROVIDERSTATE && OL("[RCPMS: write()] Invalid channel id -- undefined"), r();
      OL(`[RCPMS: write()] remote.isPaused()=${null === (c = e.state.remote) || void 0 === c ? void 0 : c.isPaused()} authorized=${E} ready=${n} socketConnected=${b}`, t);
      try {
        if (null === (l = e.state.remote) || void 0 === l || l.sendMessage(null == k ? void 0 : k.data).then(() => {
          OL(`[RCPMS: _write()] ${S} sent successfully`);
        }).catch(e => {
          OL("[RCPMS: _write()] error sending message", e);
        }), !(null === (d = e.state.platformManager) || void 0 === d ? void 0 : d.isSecure())) return OL(`[RCPMS: _write()] unsecure platform for method ${S} -- return callback`), r();
        if (!b && !n) return OL(`[RCPMS: _write()] invalid connection status targetMethod=${S} socketConnected=${b} ready=${n} providerConnected=${w.isConnected()}`), r();
        if (!b && n) return console.warn("[RCPMS: _write()] invalid socket status -- shouldn't happen"), r();
        const t = null !== (p = null === (h = null === (f = e.state.remote) || void 0 === f ? void 0 : f.getKeyInfo()) || void 0 === h ? void 0 : h.ecies.public) && void 0 !== p ? p : "",
          i = encodeURI(`channelId=${_}&pubkey=${t}&comm=socket&t=d&v=2`);
        GL[S] ? (OL(`[RCPMS: _write()] redirect link for '${S}' socketConnected=${b} connect?${i}`), null === (m = e.state.platformManager) || void 0 === m || m.openDeeplink(`${xD}?${i}`, `${RD}?${i}`, "_self")) : (null === (g = e.state.remote) || void 0 === g ? void 0 : g.isPaused()) ? (OL(`[RCPMS: _write()] MM is PAUSED! deeplink with connect! targetMethod=${S}`), null === (v = e.state.platformManager) || void 0 === v || v.openDeeplink(`${xD}?redirect=true&${i}`, `${RD}?redirect=true&${i}`, "_self")) : OL(`[RCPMS: _write()] method ${S} doesn't need redirect.`);
      } catch (e) {
        return OL("[RCPMS: _write()] error sending message", e), r(new Error("RemoteCommunicationPostMessageStream - disconnected"));
      }
      return r();
    });
  }
  class ND extends Hn.Duplex {
    constructor({
      name: t,
      remote: n,
      platformManager: r
    }) {
      super({
        objectMode: !0
      }), this.state = {
        _name: null,
        remote: null,
        platformManager: null
      }, this.state._name = t, this.state.remote = n, this.state.platformManager = r, this._onMessage = this._onMessage.bind(this), this.state.remote.on(e.EventType.MESSAGE, this._onMessage);
    }
    _write(e, t, n) {
      return wS(this, void 0, void 0, function* () {
        return LD(this, e, 0, n);
      });
    }
    _read() {}
    _onMessage(e) {
      return function (e, t) {
        try {
          if (OL("[RCPMS: onMessage()] message", t), !t || "object" != typeof t) return;
          if ("object" != typeof (null == t ? void 0 : t.data)) return;
          if (!(null == t ? void 0 : t.name)) return void OL(`[RCPMS: onMessage()] ignore message without name message=${t}`);
          if ((null == t ? void 0 : t.name) !== CD.PROVIDER) return void OL(`[RCPMS: onMessage()] ignore message with wrong name message=${t}`);
          if (A.isBuffer(t)) {
            const n = A.from(t);
            e.push(n);
          } else e.push(t);
        } catch (e) {
          OL(`[RCPMS: onMessage()] ignore message error err=${e}`);
        }
      }(this, e);
    }
    start() {}
  }
  var DD = {
    exports: {}
  };
  !function (e, t) {
    var r = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== n && n,
      i = function () {
        function e() {
          this.fetch = !1, this.DOMException = r.DOMException;
        }
        return e.prototype = r, new e();
      }();
    !function (e) {
      !function (t) {
        var n = void 0 !== e && e || "undefined" != typeof self && self || void 0 !== n && n,
          r = ("URLSearchParams" in n),
          i = "Symbol" in n && "iterator" in Symbol,
          o = "FileReader" in n && "Blob" in n && function () {
            try {
              return new Blob(), !0;
            } catch (e) {
              return !1;
            }
          }(),
          a = ("FormData" in n),
          s = ("ArrayBuffer" in n);
        if (s) var u = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
          c = ArrayBuffer.isView || function (e) {
            return e && u.indexOf(Object.prototype.toString.call(e)) > -1;
          };
        function l(e) {
          if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || "" === e) throw new TypeError('Invalid character in header field name: "' + e + '"');
          return e.toLowerCase();
        }
        function d(e) {
          return "string" != typeof e && (e = String(e)), e;
        }
        function f(e) {
          var t = {
            next: function () {
              var t = e.shift();
              return {
                done: void 0 === t,
                value: t
              };
            }
          };
          return i && (t[Symbol.iterator] = function () {
            return t;
          }), t;
        }
        function h(e) {
          this.map = {}, e instanceof h ? e.forEach(function (e, t) {
            this.append(t, e);
          }, this) : Array.isArray(e) ? e.forEach(function (e) {
            this.append(e[0], e[1]);
          }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
            this.append(t, e[t]);
          }, this);
        }
        function p(e) {
          if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
          e.bodyUsed = !0;
        }
        function m(e) {
          return new Promise(function (t, n) {
            e.onload = function () {
              t(e.result);
            }, e.onerror = function () {
              n(e.error);
            };
          });
        }
        function g(e) {
          var t = new FileReader(),
            n = m(t);
          return t.readAsArrayBuffer(e), n;
        }
        function v(e) {
          if (e.slice) return e.slice(0);
          var t = new Uint8Array(e.byteLength);
          return t.set(new Uint8Array(e)), t.buffer;
        }
        function b() {
          return this.bodyUsed = !1, this._initBody = function (e) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : o && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : a && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : r && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : s && o && function (e) {
              return e && DataView.prototype.isPrototypeOf(e);
            }(e) ? (this._bodyArrayBuffer = v(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : s && (ArrayBuffer.prototype.isPrototypeOf(e) || c(e)) ? this._bodyArrayBuffer = v(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : r && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, o && (this.blob = function () {
            var e = p(this);
            if (e) return e;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function () {
            if (this._bodyArrayBuffer) {
              var e = p(this);
              return e || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer));
            }
            return this.blob().then(g);
          }), this.text = function () {
            var e,
              t,
              n,
              r = p(this);
            if (r) return r;
            if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader(), n = m(t), t.readAsText(e), n;
            if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
              for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++) n[r] = String.fromCharCode(t[r]);
              return n.join("");
            }(this._bodyArrayBuffer));
            if (this._bodyFormData) throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, a && (this.formData = function () {
            return this.text().then(A);
          }), this.json = function () {
            return this.text().then(JSON.parse);
          }, this;
        }
        h.prototype.append = function (e, t) {
          e = l(e), t = d(t);
          var n = this.map[e];
          this.map[e] = n ? n + ", " + t : t;
        }, h.prototype.delete = function (e) {
          delete this.map[l(e)];
        }, h.prototype.get = function (e) {
          return e = l(e), this.has(e) ? this.map[e] : null;
        }, h.prototype.has = function (e) {
          return this.map.hasOwnProperty(l(e));
        }, h.prototype.set = function (e, t) {
          this.map[l(e)] = d(t);
        }, h.prototype.forEach = function (e, t) {
          for (var n in this.map) this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
        }, h.prototype.keys = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push(n);
          }), f(e);
        }, h.prototype.values = function () {
          var e = [];
          return this.forEach(function (t) {
            e.push(t);
          }), f(e);
        }, h.prototype.entries = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push([n, t]);
          }), f(e);
        }, i && (h.prototype[Symbol.iterator] = h.prototype.entries);
        var y = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function w(e, t) {
          if (!(this instanceof w)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          var n = (t = t || {}).body;
          if (e instanceof w) {
            if (e.bodyUsed) throw new TypeError("Already read");
            this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new h(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, n || null == e._bodyInit || (n = e._bodyInit, e.bodyUsed = !0);
          } else this.url = String(e);
          if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new h(t.headers)), this.method = function (e) {
            var t = e.toUpperCase();
            return y.indexOf(t) > -1 ? t : e;
          }(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && n) throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(n), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== t.cache && "no-cache" !== t.cache)) {
            var r = /([?&])_=[^&]*/;
            if (r.test(this.url)) this.url = this.url.replace(r, "$1_=" + new Date().getTime());else {
              this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
            }
          }
        }
        function A(e) {
          var t = new FormData();
          return e.trim().split("&").forEach(function (e) {
            if (e) {
              var n = e.split("="),
                r = n.shift().replace(/\+/g, " "),
                i = n.join("=").replace(/\+/g, " ");
              t.append(decodeURIComponent(r), decodeURIComponent(i));
            }
          }), t;
        }
        function _(e, t) {
          if (!(this instanceof _)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === t.statusText ? "" : "" + t.statusText, this.headers = new h(t.headers), this.url = t.url || "", this._initBody(e);
        }
        w.prototype.clone = function () {
          return new w(this, {
            body: this._bodyInit
          });
        }, b.call(w.prototype), b.call(_.prototype), _.prototype.clone = function () {
          return new _(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new h(this.headers),
            url: this.url
          });
        }, _.error = function () {
          var e = new _(null, {
            status: 0,
            statusText: ""
          });
          return e.type = "error", e;
        };
        var E = [301, 302, 303, 307, 308];
        _.redirect = function (e, t) {
          if (-1 === E.indexOf(t)) throw new RangeError("Invalid status code");
          return new _(null, {
            status: t,
            headers: {
              location: e
            }
          });
        }, t.DOMException = n.DOMException;
        try {
          new t.DOMException();
        } catch (e) {
          t.DOMException = function (e, t) {
            this.message = e, this.name = t;
            var n = Error(e);
            this.stack = n.stack;
          }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
        }
        function S(e, r) {
          return new Promise(function (i, a) {
            var u = new w(e, r);
            if (u.signal && u.signal.aborted) return a(new t.DOMException("Aborted", "AbortError"));
            var c = new XMLHttpRequest();
            function l() {
              c.abort();
            }
            c.onload = function () {
              var e,
                t,
                n = {
                  status: c.status,
                  statusText: c.statusText,
                  headers: (e = c.getAllResponseHeaders() || "", t = new h(), e.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function (e) {
                    return 0 === e.indexOf("\n") ? e.substr(1, e.length) : e;
                  }).forEach(function (e) {
                    var n = e.split(":"),
                      r = n.shift().trim();
                    if (r) {
                      var i = n.join(":").trim();
                      t.append(r, i);
                    }
                  }), t)
                };
              n.url = "responseURL" in c ? c.responseURL : n.headers.get("X-Request-URL");
              var r = "response" in c ? c.response : c.responseText;
              setTimeout(function () {
                i(new _(r, n));
              }, 0);
            }, c.onerror = function () {
              setTimeout(function () {
                a(new TypeError("Network request failed"));
              }, 0);
            }, c.ontimeout = function () {
              setTimeout(function () {
                a(new TypeError("Network request failed"));
              }, 0);
            }, c.onabort = function () {
              setTimeout(function () {
                a(new t.DOMException("Aborted", "AbortError"));
              }, 0);
            }, c.open(u.method, function (e) {
              try {
                return "" === e && n.location.href ? n.location.href : e;
              } catch (t) {
                return e;
              }
            }(u.url), !0), "include" === u.credentials ? c.withCredentials = !0 : "omit" === u.credentials && (c.withCredentials = !1), "responseType" in c && (o ? c.responseType = "blob" : s && u.headers.get("Content-Type") && -1 !== u.headers.get("Content-Type").indexOf("application/octet-stream") && (c.responseType = "arraybuffer")), !r || "object" != typeof r.headers || r.headers instanceof h ? u.headers.forEach(function (e, t) {
              c.setRequestHeader(t, e);
            }) : Object.getOwnPropertyNames(r.headers).forEach(function (e) {
              c.setRequestHeader(e, d(r.headers[e]));
            }), u.signal && (u.signal.addEventListener("abort", l), c.onreadystatechange = function () {
              4 === c.readyState && u.signal.removeEventListener("abort", l);
            }), c.send(void 0 === u._bodyInit ? null : u._bodyInit);
          });
        }
        S.polyfill = !0, n.fetch || (n.fetch = S, n.Headers = h, n.Request = w, n.Response = _), t.Headers = h, t.Request = w, t.Response = _, t.fetch = S;
      }({});
    }(i), i.fetch.ponyfill = !0, delete i.fetch.polyfill;
    var o = r.fetch ? r : i;
    (t = o.fetch).default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e.exports = t;
  }(DD, DD.exports);
  var BD = r(DD.exports);
  let jD = 1;
  const FD = e => new Promise(t => {
      setTimeout(() => {
        t(!0);
      }, e);
    }),
    zD = ({
      checkInstallationOnAllCalls: t = !1,
      communicationLayerPreference: n,
      injectProvider: r,
      shouldShimWeb3: i,
      platformManager: o,
      installer: a,
      sdk: s,
      remoteConnection: u,
      debug: c
    }) => wS(void 0, void 0, void 0, function* () {
      var l, d;
      const f = (({
          name: e,
          remoteConnection: t
        }) => {
          if (!t || !(null == t ? void 0 : t.getConnector())) throw new Error("Missing remote connection parameter");
          return new ND({
            name: e,
            remote: null == t ? void 0 : t.getConnector(),
            platformManager: null == t ? void 0 : t.getPlatformManager()
          });
        })({
          name: CD.INPAGE,
          target: CD.CONTENT_SCRIPT,
          platformManager: o,
          communicationLayerPreference: n,
          remoteConnection: u
        }),
        h = o.getPlatformType(),
        p = s.options.dappMetadata,
        m = `Sdk/Javascript SdkVersion/${SD} Platform/${h} dApp/${null !== (l = p.url) && void 0 !== l ? l : p.name} dAppTitle/${p.name}`;
      let g = null,
        v = null;
      const b = null === (d = s.options.storage) || void 0 === d ? void 0 : d.storageManager;
      if (b) {
        try {
          const e = yield b.getCachedAccounts();
          e.length > 0 && (g = e[0]);
        } catch (e) {
          console.error(`[initializeMobileProvider] failed to get cached addresses: ${e}`);
        }
        try {
          const e = yield b.getCachedChainId();
          e && (v = e);
        } catch (e) {
          console.error(`[initializeMobileProvider] failed to parse cached chainId: ${e}`);
        }
      }
      OL(`[initializeMobileProvider] cachedAccountAddress: ${g}, cachedChainId: ${v}`);
      const y = !(!r || h === e.PlatformType.NonBrowser || h === e.PlatformType.ReactNative),
        w = OD.init({
          shouldSetOnWindow: y,
          connectionStream: f,
          shouldShimWeb3: i
        });
      let A = !1;
      const _ = e => {
          A = e;
        },
        E = () => A,
        S = (n, r, i, c) => wS(void 0, void 0, void 0, function* () {
          var l, d, f, h, p, y, w, S, k;
          if (A) {
            null == u || u.showActiveModal();
            let e = E();
            for (; e;) yield FD(1e3), e = E();
            return OL("[initializeMobileProvider: sendRequest()] initial method completed -- prevent installation and call provider"), i(...r);
          }
          const M = o.isMetaMaskInstalled(),
            C = null == u ? void 0 : u.isConnected(),
            x = OD.getProvider();
          let R = null,
            I = null;
          if (R = null !== (l = x.getSelectedAddress()) && void 0 !== l ? l : g, I = x.getChainId() || v, R && b && R !== g && b.persistAccounts([R]).catch(e => {
            console.error(`[initializeMobileProvider] failed to persist account: ${e}`);
          }), I && (v = I, b && b.persistChainId(I).catch(e => {
            console.error(`[initializeMobileProvider] failed to persist chainId: ${e}`);
          })), OL("[initializeMobileProvider: sendRequest()]", {
            selectedAddress: R,
            chainId: I
          }), c && OL(`[initializeMobileProvider: sendRequest()] method=${n} ongoing=${A} selectedAddress=${R} isInstalled=${M} checkInstallationOnAllCalls=${t} socketConnected=${C}`), R && n.toLowerCase() === YL.ETH_ACCOUNTS.toLowerCase()) return [R];
          if (I && n.toLowerCase() === YL.ETH_CHAINID.toLowerCase()) return I;
          const T = [YL.ETH_REQUESTACCOUNTS, YL.WALLET_REQUESTPERMISSIONS, YL.METAMASK_CONNECTSIGN, YL.METAMASK_CONNECTWITH],
            P = !GL[n],
            O = null === (d = s.options.readonlyRPCMap) || void 0 === d ? void 0 : d[I];
          if (O && P) try {
            const e = null === (f = null == r ? void 0 : r[0]) || void 0 === f ? void 0 : f.params,
              t = yield (({
                rpcEndpoint: e,
                method: t,
                sdkInfo: n,
                params: r
              }) => wS(void 0, void 0, void 0, function* () {
                const i = JSON.stringify({
                    jsonrpc: "2.0",
                    method: t,
                    params: r,
                    id: (jD += 1, jD)
                  }),
                  o = {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                  };
                let a;
                e.includes("infura") && (o["Metamask-Sdk-Info"] = n);
                try {
                  a = yield BD(e, {
                    method: "POST",
                    headers: o,
                    body: i
                  });
                } catch (e) {
                  throw e instanceof Error ? new Error(`Failed to fetch from RPC: ${e.message}`) : new Error(`Failed to fetch from RPC: ${e}`);
                }
                if (!a.ok) throw new Error(`Server responded with a status of ${a.status}`);
                return (yield a.json()).result;
              }))({
                rpcEndpoint: O,
                sdkInfo: m,
                method: n,
                params: e || []
              });
            return c && OL(`initializeProvider::ReadOnlyRPCResponse ${t}`), t;
          } catch (e) {
            console.warn(`[initializeMobileProvider: sendRequest()] method=${n} readOnlyRPCRequest failed:`, e);
          }
          if ((!M || M && !C) && n !== YL.METAMASK_GETPROVIDERSTATE) {
            const c = (null === (h = null == r ? void 0 : r[0]) || void 0 === h ? void 0 : h.params) || [];
            if (-1 !== T.indexOf(n) || t) {
              _(!0);
              try {
                yield a.start({
                  wait: !1
                });
              } catch (t) {
                if (_(!1), e.PROVIDER_UPDATE_TYPE.EXTENSION === t) {
                  if (OL(`[initializeMobileProvider: sendRequest()] extension provider detect: re-create ${n} on the active provider`), n.toLowerCase() === YL.METAMASK_CONNECTSIGN.toLowerCase()) {
                    const e = yield null === (p = s.getProvider()) || void 0 === p ? void 0 : p.request({
                      method: YL.ETH_REQUESTACCOUNTS,
                      params: []
                    });
                    if (!e.length) throw new Error("SDK state invalid -- undefined accounts");
                    return yield null === (y = s.getProvider()) || void 0 === y ? void 0 : y.request({
                      method: YL.PERSONAL_SIGN,
                      params: [c[0], e[0]]
                    });
                  }
                  if (n.toLowerCase() === YL.METAMASK_CONNECTWITH.toLowerCase()) {
                    const [e] = c;
                    return yield (({
                      method: e,
                      sdk: t,
                      params: n
                    }) => wS(void 0, void 0, void 0, function* () {
                      var r, i, o, a;
                      if (!t.isExtensionActive()) throw new Error("SDK state invalid -- extension is not active");
                      OL("[MetaMaskProvider: extensionConnectWithOverwrite()] Overwriting request method", e, n);
                      const s = yield null === (r = t.getProvider()) || void 0 === r ? void 0 : r.request({
                        method: YL.ETH_REQUESTACCOUNTS,
                        params: []
                      });
                      if (!s.length) throw new Error("SDK state invalid -- undefined accounts");
                      if ((null == e ? void 0 : e.toLowerCase()) === YL.PERSONAL_SIGN.toLowerCase()) {
                        const r = {
                          method: e,
                          params: [n[0], s[0]]
                        };
                        return yield null === (i = t.getProvider()) || void 0 === i ? void 0 : i.request(r);
                      }
                      if ((null == e ? void 0 : e.toLowerCase()) === YL.ETH_SENDTRANSACTION.toLowerCase()) {
                        const r = {
                          method: e,
                          params: [Object.assign(Object.assign({}, n[0]), {
                            from: s[0]
                          })]
                        };
                        return yield null === (o = t.getProvider()) || void 0 === o ? void 0 : o.request(r);
                      }
                      return ZL.includes(e.toLowerCase()) ? (console.warn(`MetaMaskSDK connectWith method=${e} -- not handled by the extension -- call separately`), s) : yield null === (a = t.getProvider()) || void 0 === a ? void 0 : a.request({
                        method: e,
                        params: n
                      });
                    }))({
                      method: e.method,
                      sdk: s,
                      params: e.params
                    });
                  }
                  return OL(`[initializeMobileProvider: sendRequest()] sending '${n}' on active provider`, c), yield null === (w = s.getProvider()) || void 0 === w ? void 0 : w.request({
                    method: n,
                    params: c
                  });
                }
                throw OL(`[initializeMobileProvider: sendRequest()] failed to start installer: ${t}`), t;
              }
              const t = i(...r);
              try {
                yield new Promise((t, n) => {
                  null == u || u.getConnector().once(e.EventType.AUTHORIZED, () => {
                    t(!0);
                  }), s.once(e.EventType.PROVIDER_UPDATE, t => {
                    OL(`[initializeMobileProvider: sendRequest()] PROVIDER_UPDATE --- remote provider request interupted type=${t}`), t === e.PROVIDER_UPDATE_TYPE.EXTENSION ? n(e.EventType.PROVIDER_UPDATE) : n(new Error("Connection Terminated"));
                  });
                });
              } catch (t) {
                if (_(!1), t === e.EventType.PROVIDER_UPDATE) return yield null === (S = s.getProvider()) || void 0 === S ? void 0 : S.request({
                  method: n,
                  params: c
                });
                throw t;
              }
              return _(!1), t;
            }
            if (o.isSecure() && GL[n]) return i(...r);
            if (s.isExtensionActive()) return OL(`[initializeMobileProvider: sendRequest()] EXTENSION active - redirect request '${n}' to it`, r, c), yield null === (k = s.getProvider()) || void 0 === k ? void 0 : k.request({
              method: n,
              params: c
            });
            throw OL(`[initializeMobileProvider: sendRequest()] method=${n} --- skip --- not connected/installed`), new Error("MetaMask is not connected/installed, please call eth_requestAccounts to connect first.");
          }
          const L = yield i(...r);
          return OL(`[initializeMobileProvider: sendRequest()] method=${n} rpcResponse: ${L}`), L;
        }),
        {
          request: k
        } = w;
      w.request = (...e) => wS(void 0, void 0, void 0, function* () {
        return S(null == e ? void 0 : e[0].method, e, k, c);
      });
      const {
        send: M
      } = w;
      return w.send = (...e) => wS(void 0, void 0, void 0, function* () {
        return S(null == e ? void 0 : e[0], e, M, c);
      }), OL("[initializeMobileProvider: sendRequest()] metamaskStream.start()"), f.start(), w;
    });
  function UD(t) {
    var n, r, i;
    return wS(this, void 0, void 0, function* () {
      const {
          options: o
        } = t,
        a = {
          communicationLayerPreference: null !== (n = o.communicationLayerPreference) && void 0 !== n ? n : e.CommunicationLayerPreference.SOCKET,
          platformManager: t.platformManager,
          sdk: t,
          checkInstallationOnAllCalls: o.checkInstallationOnAllCalls,
          injectProvider: null === (r = o.injectProvider) || void 0 === r || r,
          shouldShimWeb3: null === (i = o.shouldShimWeb3) || void 0 === i || i,
          installer: t.installer,
          remoteConnection: t.remoteConnection,
          debug: t.debug
        },
        s = yield zD(a);
      t.activeProvider = s, function (t) {
        var n, r, i, o;
        null === (r = null === (n = t.remoteConnection) || void 0 === n ? void 0 : n.getConnector()) || void 0 === r || r.on(e.EventType.CONNECTION_STATUS, n => {
          t.emit(e.EventType.CONNECTION_STATUS, n);
        }), null === (o = null === (i = t.remoteConnection) || void 0 === i ? void 0 : i.getConnector()) || void 0 === o || o.on(e.EventType.SERVICE_STATUS, n => {
          t.emit(e.EventType.SERVICE_STATUS, n);
        });
      }(t);
    });
  }
  var qD, KD, HD;
  const VD = "sdk";
  class $D {
    constructor({
      serverUrl: e,
      enabled: t,
      originatorInfo: n
    }) {
      qD.set(this, qE), KD.set(this, void 0), HD.set(this, void 0), _S(this, qD, e, "f"), _S(this, HD, n, "f"), _S(this, KD, null == t || t, "f");
    }
    send({
      event: e,
      params: t
    }) {
      if (!AS(this, KD, "f")) return;
      const n = {
        id: VD,
        event: e,
        sdkVersion: SD,
        originationInfo: AS(this, HD, "f"),
        params: t
      };
      OL(`[Analytics: send()] event: ${e}`, n), q_(n, AS(this, qD, "f")).catch(e => {
        OL(`[Analytics: send()] error: ${e}`);
      });
    }
  }
  qD = new WeakMap(), KD = new WeakMap(), HD = new WeakMap();
  const WD = () => {
      if ("undefined" == typeof document) return;
      let e;
      const t = document.getElementsByTagName("link");
      for (let n = 0; n < t.length; n++) "icon" !== t[n].getAttribute("rel") && "shortcut icon" !== t[n].getAttribute("rel") || (e = t[n].getAttribute("href"));
      return e;
    },
    YD = 163400;
  const GD = ({
    provider: e,
    sdkInstance: t
  }) => {
    if ("state" in e) throw new Error("INVALID EXTENSION PROVIDER");
    return new Proxy(e, {
      get: (n, r) => "request" === r ? function (r) {
        var i, o, a;
        return wS(this, void 0, void 0, function* () {
          OL("[wrapExtensionProvider()] Overwriting request method", r);
          const {
              method: s,
              params: u
            } = r,
            c = QL.includes(s.toLowerCase());
          if (c && (null === (i = t.analytics) || void 0 === i || i.send({
            event: XE.SDK_RPC_REQUEST,
            params: {
              method: s,
              from: "extension"
            }
          })), s === YL.METAMASK_BATCH && Array.isArray(u)) {
            for (const t of u) yield null == e ? void 0 : e.request({
              method: t.method,
              params: t.params
            });
            const i = yield n.request(r);
            return c && (null === (o = t.analytics) || void 0 === o || o.send({
              event: XE.SDK_RPC_REQUEST_DONE,
              params: {
                method: s,
                from: "extension"
              }
            })), i;
          }
          const l = yield n.request(r);
          return c && (null === (a = t.analytics) || void 0 === a || a.send({
            event: XE.SDK_RPC_REQUEST_DONE,
            params: {
              method: s,
              from: "extension"
            }
          })), l;
        });
      } : "getChainId" === r ? function () {
        return e.chainId;
      } : "getNetworkVersion" === r ? function () {
        return e.networkVersion;
      } : "getSelectedAddress" === r ? function () {
        return e.selectedAddress;
      } : "isConnected" === r ? function () {
        return e._state.isConnected;
      } : n[r]
    });
  };
  var QD;
  function ZD({
    mustBeMetaMask: e,
    sdkInstance: t
  }) {
    return wS(this, void 0, void 0, function* () {
      if ("undefined" == typeof window) throw new Error("window not available");
      let n;
      try {
        return n = yield new Promise((e, t) => {
          const n = setTimeout(() => {
            t(new Error("eip6963RequestProvider timed out"));
          }, 500);
          window.addEventListener(QD.Announce, t => {
            const r = t,
              {
                detail: {
                  info: i,
                  provider: o
                } = {}
              } = r,
              {
                name: a,
                rdns: s,
                uuid: u
              } = null != i ? i : {};
            TD.test(u) && a.startsWith(ID.NAME) && s === ID.RDNS && (clearTimeout(n), e(o));
          }), window.dispatchEvent(new Event(QD.Request));
        }), GD({
          provider: n,
          sdkInstance: t
        });
      } catch (n) {
        const {
          ethereum: r
        } = window;
        if (!r) throw new Error("Ethereum not found in window object");
        if ("providers" in r) {
          if (Array.isArray(r.providers)) {
            const n = e ? r.providers.find(e => e.isMetaMask) : r.providers[0];
            if (!n) throw new Error("No suitable provider found");
            return GD({
              provider: n,
              sdkInstance: t
            });
          }
        } else if (e && !r.isMetaMask) throw new Error("MetaMask provider not found in Ethereum");
        return GD({
          provider: r,
          sdkInstance: t
        });
      }
    });
  }
  !function (e) {
    e.Announce = "eip6963:announceProvider", e.Request = "eip6963:requestProvider";
  }(QD || (QD = {}));
  var JD = {
    exports: {}
  };
  !function (e, t) {
    e.exports = function (e) {
      var t = {};
      function n(r) {
        if (t[r]) return t[r].exports;
        var i = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
      }
      return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
        return r;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 90);
    }({
      17: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r = n(18),
          i = function () {
            function e() {}
            return e.getFirstMatch = function (e, t) {
              var n = t.match(e);
              return n && n.length > 0 && n[1] || "";
            }, e.getSecondMatch = function (e, t) {
              var n = t.match(e);
              return n && n.length > 1 && n[2] || "";
            }, e.matchAndReturnConst = function (e, t, n) {
              if (e.test(t)) return n;
            }, e.getWindowsVersionName = function (e) {
              switch (e) {
                case "NT":
                  return "NT";
                case "XP":
                case "NT 5.1":
                  return "XP";
                case "NT 5.0":
                  return "2000";
                case "NT 5.2":
                  return "2003";
                case "NT 6.0":
                  return "Vista";
                case "NT 6.1":
                  return "7";
                case "NT 6.2":
                  return "8";
                case "NT 6.3":
                  return "8.1";
                case "NT 10.0":
                  return "10";
                default:
                  return;
              }
            }, e.getMacOSVersionName = function (e) {
              var t = e.split(".").splice(0, 2).map(function (e) {
                return parseInt(e, 10) || 0;
              });
              if (t.push(0), 10 === t[0]) switch (t[1]) {
                case 5:
                  return "Leopard";
                case 6:
                  return "Snow Leopard";
                case 7:
                  return "Lion";
                case 8:
                  return "Mountain Lion";
                case 9:
                  return "Mavericks";
                case 10:
                  return "Yosemite";
                case 11:
                  return "El Capitan";
                case 12:
                  return "Sierra";
                case 13:
                  return "High Sierra";
                case 14:
                  return "Mojave";
                case 15:
                  return "Catalina";
                default:
                  return;
              }
            }, e.getAndroidVersionName = function (e) {
              var t = e.split(".").splice(0, 2).map(function (e) {
                return parseInt(e, 10) || 0;
              });
              if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
            }, e.getVersionPrecision = function (e) {
              return e.split(".").length;
            }, e.compareVersions = function (t, n, r) {
              void 0 === r && (r = !1);
              var i = e.getVersionPrecision(t),
                o = e.getVersionPrecision(n),
                a = Math.max(i, o),
                s = 0,
                u = e.map([t, n], function (t) {
                  var n = a - e.getVersionPrecision(t),
                    r = t + new Array(n + 1).join(".0");
                  return e.map(r.split("."), function (e) {
                    return new Array(20 - e.length).join("0") + e;
                  }).reverse();
                });
              for (r && (s = a - Math.min(i, o)), a -= 1; a >= s;) {
                if (u[0][a] > u[1][a]) return 1;
                if (u[0][a] === u[1][a]) {
                  if (a === s) return 0;
                  a -= 1;
                } else if (u[0][a] < u[1][a]) return -1;
              }
            }, e.map = function (e, t) {
              var n,
                r = [];
              if (Array.prototype.map) return Array.prototype.map.call(e, t);
              for (n = 0; n < e.length; n += 1) r.push(t(e[n]));
              return r;
            }, e.find = function (e, t) {
              var n, r;
              if (Array.prototype.find) return Array.prototype.find.call(e, t);
              for (n = 0, r = e.length; n < r; n += 1) {
                var i = e[n];
                if (t(i, n)) return i;
              }
            }, e.assign = function (e) {
              for (var t, n, r = e, i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) o[a - 1] = arguments[a];
              if (Object.assign) return Object.assign.apply(Object, [e].concat(o));
              var s = function () {
                var e = o[t];
                "object" == typeof e && null !== e && Object.keys(e).forEach(function (t) {
                  r[t] = e[t];
                });
              };
              for (t = 0, n = o.length; t < n; t += 1) s();
              return e;
            }, e.getBrowserAlias = function (e) {
              return r.BROWSER_ALIASES_MAP[e];
            }, e.getBrowserTypeByAlias = function (e) {
              return r.BROWSER_MAP[e] || "";
            }, e;
          }();
        t.default = i, e.exports = t.default;
      },
      18: function (e, t, n) {
        t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = {
          "Amazon Silk": "amazon_silk",
          "Android Browser": "android",
          Bada: "bada",
          BlackBerry: "blackberry",
          Chrome: "chrome",
          Chromium: "chromium",
          Electron: "electron",
          Epiphany: "epiphany",
          Firefox: "firefox",
          Focus: "focus",
          Generic: "generic",
          "Google Search": "google_search",
          Googlebot: "googlebot",
          "Internet Explorer": "ie",
          "K-Meleon": "k_meleon",
          Maxthon: "maxthon",
          "Microsoft Edge": "edge",
          "MZ Browser": "mz",
          "NAVER Whale Browser": "naver",
          Opera: "opera",
          "Opera Coast": "opera_coast",
          PhantomJS: "phantomjs",
          Puffin: "puffin",
          QupZilla: "qupzilla",
          QQ: "qq",
          QQLite: "qqlite",
          Safari: "safari",
          Sailfish: "sailfish",
          "Samsung Internet for Android": "samsung_internet",
          SeaMonkey: "seamonkey",
          Sleipnir: "sleipnir",
          Swing: "swing",
          Tizen: "tizen",
          "UC Browser": "uc",
          Vivaldi: "vivaldi",
          "WebOS Browser": "webos",
          WeChat: "wechat",
          "Yandex Browser": "yandex",
          Roku: "roku"
        }, t.BROWSER_MAP = {
          amazon_silk: "Amazon Silk",
          android: "Android Browser",
          bada: "Bada",
          blackberry: "BlackBerry",
          chrome: "Chrome",
          chromium: "Chromium",
          electron: "Electron",
          epiphany: "Epiphany",
          firefox: "Firefox",
          focus: "Focus",
          generic: "Generic",
          googlebot: "Googlebot",
          google_search: "Google Search",
          ie: "Internet Explorer",
          k_meleon: "K-Meleon",
          maxthon: "Maxthon",
          edge: "Microsoft Edge",
          mz: "MZ Browser",
          naver: "NAVER Whale Browser",
          opera: "Opera",
          opera_coast: "Opera Coast",
          phantomjs: "PhantomJS",
          puffin: "Puffin",
          qupzilla: "QupZilla",
          qq: "QQ Browser",
          qqlite: "QQ Browser Lite",
          safari: "Safari",
          sailfish: "Sailfish",
          samsung_internet: "Samsung Internet for Android",
          seamonkey: "SeaMonkey",
          sleipnir: "Sleipnir",
          swing: "Swing",
          tizen: "Tizen",
          uc: "UC Browser",
          vivaldi: "Vivaldi",
          webos: "WebOS Browser",
          wechat: "WeChat",
          yandex: "Yandex Browser"
        }, t.PLATFORMS_MAP = {
          tablet: "tablet",
          mobile: "mobile",
          desktop: "desktop",
          tv: "tv"
        }, t.OS_MAP = {
          WindowsPhone: "Windows Phone",
          Windows: "Windows",
          MacOS: "macOS",
          iOS: "iOS",
          Android: "Android",
          WebOS: "WebOS",
          BlackBerry: "BlackBerry",
          Bada: "Bada",
          Tizen: "Tizen",
          Linux: "Linux",
          ChromeOS: "Chrome OS",
          PlayStation4: "PlayStation 4",
          Roku: "Roku"
        }, t.ENGINE_MAP = {
          EdgeHTML: "EdgeHTML",
          Blink: "Blink",
          Trident: "Trident",
          Presto: "Presto",
          Gecko: "Gecko",
          WebKit: "WebKit"
        };
      },
      90: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r,
          i = (r = n(91)) && r.__esModule ? r : {
            default: r
          },
          o = n(18);
        function a(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        var s = function () {
          function e() {}
          var t, n, r;
          return e.getParser = function (e, t) {
            if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
            return new i.default(e, t);
          }, e.parse = function (e) {
            return new i.default(e).getResult();
          }, t = e, r = [{
            key: "BROWSER_MAP",
            get: function () {
              return o.BROWSER_MAP;
            }
          }, {
            key: "ENGINE_MAP",
            get: function () {
              return o.ENGINE_MAP;
            }
          }, {
            key: "OS_MAP",
            get: function () {
              return o.OS_MAP;
            }
          }, {
            key: "PLATFORMS_MAP",
            get: function () {
              return o.PLATFORMS_MAP;
            }
          }], (n = null) && a(t.prototype, n), r && a(t, r), e;
        }();
        t.default = s, e.exports = t.default;
      },
      91: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r = u(n(92)),
          i = u(n(93)),
          o = u(n(94)),
          a = u(n(95)),
          s = u(n(17));
        function u(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        var c = function () {
          function e(e, t) {
            if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
            this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
          }
          var t = e.prototype;
          return t.getUA = function () {
            return this._ua;
          }, t.test = function (e) {
            return e.test(this._ua);
          }, t.parseBrowser = function () {
            var e = this;
            this.parsedResult.browser = {};
            var t = s.default.find(r.default, function (t) {
              if ("function" == typeof t.test) return t.test(e);
              if (t.test instanceof Array) return t.test.some(function (t) {
                return e.test(t);
              });
              throw new Error("Browser's test function is not valid");
            });
            return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
          }, t.getBrowser = function () {
            return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
          }, t.getBrowserName = function (e) {
            return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
          }, t.getBrowserVersion = function () {
            return this.getBrowser().version;
          }, t.getOS = function () {
            return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
          }, t.parseOS = function () {
            var e = this;
            this.parsedResult.os = {};
            var t = s.default.find(i.default, function (t) {
              if ("function" == typeof t.test) return t.test(e);
              if (t.test instanceof Array) return t.test.some(function (t) {
                return e.test(t);
              });
              throw new Error("Browser's test function is not valid");
            });
            return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
          }, t.getOSName = function (e) {
            var t = this.getOS().name;
            return e ? String(t).toLowerCase() || "" : t || "";
          }, t.getOSVersion = function () {
            return this.getOS().version;
          }, t.getPlatform = function () {
            return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
          }, t.getPlatformType = function (e) {
            void 0 === e && (e = !1);
            var t = this.getPlatform().type;
            return e ? String(t).toLowerCase() || "" : t || "";
          }, t.parsePlatform = function () {
            var e = this;
            this.parsedResult.platform = {};
            var t = s.default.find(o.default, function (t) {
              if ("function" == typeof t.test) return t.test(e);
              if (t.test instanceof Array) return t.test.some(function (t) {
                return e.test(t);
              });
              throw new Error("Browser's test function is not valid");
            });
            return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
          }, t.getEngine = function () {
            return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
          }, t.getEngineName = function (e) {
            return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
          }, t.parseEngine = function () {
            var e = this;
            this.parsedResult.engine = {};
            var t = s.default.find(a.default, function (t) {
              if ("function" == typeof t.test) return t.test(e);
              if (t.test instanceof Array) return t.test.some(function (t) {
                return e.test(t);
              });
              throw new Error("Browser's test function is not valid");
            });
            return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
          }, t.parse = function () {
            return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
          }, t.getResult = function () {
            return s.default.assign({}, this.parsedResult);
          }, t.satisfies = function (e) {
            var t = this,
              n = {},
              r = 0,
              i = {},
              o = 0;
            if (Object.keys(e).forEach(function (t) {
              var a = e[t];
              "string" == typeof a ? (i[t] = a, o += 1) : "object" == typeof a && (n[t] = a, r += 1);
            }), r > 0) {
              var a = Object.keys(n),
                u = s.default.find(a, function (e) {
                  return t.isOS(e);
                });
              if (u) {
                var c = this.satisfies(n[u]);
                if (void 0 !== c) return c;
              }
              var l = s.default.find(a, function (e) {
                return t.isPlatform(e);
              });
              if (l) {
                var d = this.satisfies(n[l]);
                if (void 0 !== d) return d;
              }
            }
            if (o > 0) {
              var f = Object.keys(i),
                h = s.default.find(f, function (e) {
                  return t.isBrowser(e, !0);
                });
              if (void 0 !== h) return this.compareVersion(i[h]);
            }
          }, t.isBrowser = function (e, t) {
            void 0 === t && (t = !1);
            var n = this.getBrowserName().toLowerCase(),
              r = e.toLowerCase(),
              i = s.default.getBrowserTypeByAlias(r);
            return t && i && (r = i.toLowerCase()), r === n;
          }, t.compareVersion = function (e) {
            var t = [0],
              n = e,
              r = !1,
              i = this.getBrowserVersion();
            if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (n = e.substr(1), "=" === e[1] ? (r = !0, n = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? n = e.substr(1) : "~" === e[0] && (r = !0, n = e.substr(1)), t.indexOf(s.default.compareVersions(i, n, r)) > -1;
          }, t.isOS = function (e) {
            return this.getOSName(!0) === String(e).toLowerCase();
          }, t.isPlatform = function (e) {
            return this.getPlatformType(!0) === String(e).toLowerCase();
          }, t.isEngine = function (e) {
            return this.getEngineName(!0) === String(e).toLowerCase();
          }, t.is = function (e, t) {
            return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
          }, t.some = function (e) {
            var t = this;
            return void 0 === e && (e = []), e.some(function (e) {
              return t.is(e);
            });
          }, e;
        }();
        t.default = c, e.exports = t.default;
      },
      92: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r,
          i = (r = n(17)) && r.__esModule ? r : {
            default: r
          },
          o = /version\/(\d+(\.?_?\d+)+)/i,
          a = [{
            test: [/googlebot/i],
            describe: function (e) {
              var t = {
                  name: "Googlebot"
                },
                n = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/opera/i],
            describe: function (e) {
              var t = {
                  name: "Opera"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/opr\/|opios/i],
            describe: function (e) {
              var t = {
                  name: "Opera"
                },
                n = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/SamsungBrowser/i],
            describe: function (e) {
              var t = {
                  name: "Samsung Internet for Android"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/Whale/i],
            describe: function (e) {
              var t = {
                  name: "NAVER Whale Browser"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/MZBrowser/i],
            describe: function (e) {
              var t = {
                  name: "MZ Browser"
                },
                n = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/focus/i],
            describe: function (e) {
              var t = {
                  name: "Focus"
                },
                n = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/swing/i],
            describe: function (e) {
              var t = {
                  name: "Swing"
                },
                n = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/coast/i],
            describe: function (e) {
              var t = {
                  name: "Opera Coast"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/opt\/\d+(?:.?_?\d+)+/i],
            describe: function (e) {
              var t = {
                  name: "Opera Touch"
                },
                n = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/yabrowser/i],
            describe: function (e) {
              var t = {
                  name: "Yandex Browser"
                },
                n = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/ucbrowser/i],
            describe: function (e) {
              var t = {
                  name: "UC Browser"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/Maxthon|mxios/i],
            describe: function (e) {
              var t = {
                  name: "Maxthon"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/epiphany/i],
            describe: function (e) {
              var t = {
                  name: "Epiphany"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/puffin/i],
            describe: function (e) {
              var t = {
                  name: "Puffin"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/sleipnir/i],
            describe: function (e) {
              var t = {
                  name: "Sleipnir"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/k-meleon/i],
            describe: function (e) {
              var t = {
                  name: "K-Meleon"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/micromessenger/i],
            describe: function (e) {
              var t = {
                  name: "WeChat"
                },
                n = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/qqbrowser/i],
            describe: function (e) {
              var t = {
                  name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                },
                n = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/msie|trident/i],
            describe: function (e) {
              var t = {
                  name: "Internet Explorer"
                },
                n = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/\sedg\//i],
            describe: function (e) {
              var t = {
                  name: "Microsoft Edge"
                },
                n = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/edg([ea]|ios)/i],
            describe: function (e) {
              var t = {
                  name: "Microsoft Edge"
                },
                n = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/vivaldi/i],
            describe: function (e) {
              var t = {
                  name: "Vivaldi"
                },
                n = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/seamonkey/i],
            describe: function (e) {
              var t = {
                  name: "SeaMonkey"
                },
                n = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/sailfish/i],
            describe: function (e) {
              var t = {
                  name: "Sailfish"
                },
                n = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/silk/i],
            describe: function (e) {
              var t = {
                  name: "Amazon Silk"
                },
                n = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/phantom/i],
            describe: function (e) {
              var t = {
                  name: "PhantomJS"
                },
                n = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/slimerjs/i],
            describe: function (e) {
              var t = {
                  name: "SlimerJS"
                },
                n = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
            describe: function (e) {
              var t = {
                  name: "BlackBerry"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/(web|hpw)[o0]s/i],
            describe: function (e) {
              var t = {
                  name: "WebOS Browser"
                },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/bada/i],
            describe: function (e) {
              var t = {
                  name: "Bada"
                },
                n = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/tizen/i],
            describe: function (e) {
              var t = {
                  name: "Tizen"
                },
                n = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/qupzilla/i],
            describe: function (e) {
              var t = {
                  name: "QupZilla"
                },
                n = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/firefox|iceweasel|fxios/i],
            describe: function (e) {
              var t = {
                  name: "Firefox"
                },
                n = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/electron/i],
            describe: function (e) {
              var t = {
                  name: "Electron"
                },
                n = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/MiuiBrowser/i],
            describe: function (e) {
              var t = {
                  name: "Miui"
                },
                n = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/chromium/i],
            describe: function (e) {
              var t = {
                  name: "Chromium"
                },
                n = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/chrome|crios|crmo/i],
            describe: function (e) {
              var t = {
                  name: "Chrome"
                },
                n = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/GSA/i],
            describe: function (e) {
              var t = {
                  name: "Google Search"
                },
                n = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: function (e) {
              var t = !e.test(/like android/i),
                n = e.test(/android/i);
              return t && n;
            },
            describe: function (e) {
              var t = {
                  name: "Android Browser"
                },
                n = i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/playstation 4/i],
            describe: function (e) {
              var t = {
                  name: "PlayStation 4"
                },
                n = i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/safari|applewebkit/i],
            describe: function (e) {
              var t = {
                  name: "Safari"
                },
                n = i.default.getFirstMatch(o, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/.*/i],
            describe: function (e) {
              var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
              return {
                name: i.default.getFirstMatch(t, e),
                version: i.default.getSecondMatch(t, e)
              };
            }
          }];
        t.default = a, e.exports = t.default;
      },
      93: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r,
          i = (r = n(17)) && r.__esModule ? r : {
            default: r
          },
          o = n(18),
          a = [{
            test: [/Roku\/DVP/],
            describe: function (e) {
              var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
              return {
                name: o.OS_MAP.Roku,
                version: t
              };
            }
          }, {
            test: [/windows phone/i],
            describe: function (e) {
              var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
              return {
                name: o.OS_MAP.WindowsPhone,
                version: t
              };
            }
          }, {
            test: [/windows /i],
            describe: function (e) {
              var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e),
                n = i.default.getWindowsVersionName(t);
              return {
                name: o.OS_MAP.Windows,
                version: t,
                versionName: n
              };
            }
          }, {
            test: [/Macintosh(.*?) FxiOS(.*?)\//],
            describe: function (e) {
              var t = {
                  name: o.OS_MAP.iOS
                },
                n = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/macintosh/i],
            describe: function (e) {
              var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."),
                n = i.default.getMacOSVersionName(t),
                r = {
                  name: o.OS_MAP.MacOS,
                  version: t
                };
              return n && (r.versionName = n), r;
            }
          }, {
            test: [/(ipod|iphone|ipad)/i],
            describe: function (e) {
              var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
              return {
                name: o.OS_MAP.iOS,
                version: t
              };
            }
          }, {
            test: function (e) {
              var t = !e.test(/like android/i),
                n = e.test(/android/i);
              return t && n;
            },
            describe: function (e) {
              var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e),
                n = i.default.getAndroidVersionName(t),
                r = {
                  name: o.OS_MAP.Android,
                  version: t
                };
              return n && (r.versionName = n), r;
            }
          }, {
            test: [/(web|hpw)[o0]s/i],
            describe: function (e) {
              var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e),
                n = {
                  name: o.OS_MAP.WebOS
                };
              return t && t.length && (n.version = t), n;
            }
          }, {
            test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
            describe: function (e) {
              var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
              return {
                name: o.OS_MAP.BlackBerry,
                version: t
              };
            }
          }, {
            test: [/bada/i],
            describe: function (e) {
              var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
              return {
                name: o.OS_MAP.Bada,
                version: t
              };
            }
          }, {
            test: [/tizen/i],
            describe: function (e) {
              var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
              return {
                name: o.OS_MAP.Tizen,
                version: t
              };
            }
          }, {
            test: [/linux/i],
            describe: function () {
              return {
                name: o.OS_MAP.Linux
              };
            }
          }, {
            test: [/CrOS/],
            describe: function () {
              return {
                name: o.OS_MAP.ChromeOS
              };
            }
          }, {
            test: [/PlayStation 4/],
            describe: function (e) {
              var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
              return {
                name: o.OS_MAP.PlayStation4,
                version: t
              };
            }
          }];
        t.default = a, e.exports = t.default;
      },
      94: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r,
          i = (r = n(17)) && r.__esModule ? r : {
            default: r
          },
          o = n(18),
          a = [{
            test: [/googlebot/i],
            describe: function () {
              return {
                type: "bot",
                vendor: "Google"
              };
            }
          }, {
            test: [/huawei/i],
            describe: function (e) {
              var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova",
                n = {
                  type: o.PLATFORMS_MAP.mobile,
                  vendor: "Huawei"
                };
              return t && (n.model = t), n;
            }
          }, {
            test: [/nexus\s*(?:7|8|9|10).*/i],
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.tablet,
                vendor: "Nexus"
              };
            }
          }, {
            test: [/ipad/i],
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.tablet,
                vendor: "Apple",
                model: "iPad"
              };
            }
          }, {
            test: [/Macintosh(.*?) FxiOS(.*?)\//],
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.tablet,
                vendor: "Apple",
                model: "iPad"
              };
            }
          }, {
            test: [/kftt build/i],
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.tablet,
                vendor: "Amazon",
                model: "Kindle Fire HD 7"
              };
            }
          }, {
            test: [/silk/i],
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.tablet,
                vendor: "Amazon"
              };
            }
          }, {
            test: [/tablet(?! pc)/i],
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.tablet
              };
            }
          }, {
            test: function (e) {
              var t = e.test(/ipod|iphone/i),
                n = e.test(/like (ipod|iphone)/i);
              return t && !n;
            },
            describe: function (e) {
              var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
              return {
                type: o.PLATFORMS_MAP.mobile,
                vendor: "Apple",
                model: t
              };
            }
          }, {
            test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.mobile,
                vendor: "Nexus"
              };
            }
          }, {
            test: [/[^-]mobi/i],
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.mobile
              };
            }
          }, {
            test: function (e) {
              return "blackberry" === e.getBrowserName(!0);
            },
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.mobile,
                vendor: "BlackBerry"
              };
            }
          }, {
            test: function (e) {
              return "bada" === e.getBrowserName(!0);
            },
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.mobile
              };
            }
          }, {
            test: function (e) {
              return "windows phone" === e.getBrowserName();
            },
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.mobile,
                vendor: "Microsoft"
              };
            }
          }, {
            test: function (e) {
              var t = Number(String(e.getOSVersion()).split(".")[0]);
              return "android" === e.getOSName(!0) && t >= 3;
            },
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.tablet
              };
            }
          }, {
            test: function (e) {
              return "android" === e.getOSName(!0);
            },
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.mobile
              };
            }
          }, {
            test: function (e) {
              return "macos" === e.getOSName(!0);
            },
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.desktop,
                vendor: "Apple"
              };
            }
          }, {
            test: function (e) {
              return "windows" === e.getOSName(!0);
            },
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.desktop
              };
            }
          }, {
            test: function (e) {
              return "linux" === e.getOSName(!0);
            },
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.desktop
              };
            }
          }, {
            test: function (e) {
              return "playstation 4" === e.getOSName(!0);
            },
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.tv
              };
            }
          }, {
            test: function (e) {
              return "roku" === e.getOSName(!0);
            },
            describe: function () {
              return {
                type: o.PLATFORMS_MAP.tv
              };
            }
          }];
        t.default = a, e.exports = t.default;
      },
      95: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r,
          i = (r = n(17)) && r.__esModule ? r : {
            default: r
          },
          o = n(18),
          a = [{
            test: function (e) {
              return "microsoft edge" === e.getBrowserName(!0);
            },
            describe: function (e) {
              if (/\sedg\//i.test(e)) return {
                name: o.ENGINE_MAP.Blink
              };
              var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
              return {
                name: o.ENGINE_MAP.EdgeHTML,
                version: t
              };
            }
          }, {
            test: [/trident/i],
            describe: function (e) {
              var t = {
                  name: o.ENGINE_MAP.Trident
                },
                n = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: function (e) {
              return e.test(/presto/i);
            },
            describe: function (e) {
              var t = {
                  name: o.ENGINE_MAP.Presto
                },
                n = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: function (e) {
              var t = e.test(/gecko/i),
                n = e.test(/like gecko/i);
              return t && !n;
            },
            describe: function (e) {
              var t = {
                  name: o.ENGINE_MAP.Gecko
                },
                n = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }, {
            test: [/(apple)?webkit\/537\.36/i],
            describe: function () {
              return {
                name: o.ENGINE_MAP.Blink
              };
            }
          }, {
            test: [/(apple)?webkit/i],
            describe: function (e) {
              var t = {
                  name: o.ENGINE_MAP.WebKit
                },
                n = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
              return n && (t.version = n), t;
            }
          }];
        t.default = a, e.exports = t.default;
      }
    });
  }(JD);
  var XD,
    eB = r(JD.exports);
  !function (e) {
    e.Disabled = "Disabled", e.Temporary = "Temporary", e.UntilResponse = "UntilResponse";
  }(XD || (XD = {}));
  const tB = () => "wakeLock" in navigator,
    nB = () => {
      if ("undefined" == typeof navigator) return !1;
      const {
          userAgent: e
        } = navigator,
        t = /CPU (?:iPhone )?OS (\d+)(?:_\d+)?_?\d+ like Mac OS X/iu.exec(e);
      if (!t) return !1;
      return parseInt(t[1], 10) < 10 && !window.MSStream;
    };
  class rB {
    constructor(e) {
      this.enabled = !1, this._eventsAdded = !1, this.debug = null != e && e;
    }
    start() {
      if (this.enabled = !1, tB() && !this._eventsAdded) {
        this._eventsAdded = !0, this._wakeLock = void 0;
        const e = () => wS(this, void 0, void 0, function* () {
          null !== this._wakeLock && "visible" === document.visibilityState && (yield this.enable());
        });
        document.addEventListener("visibilitychange", e), document.addEventListener("fullscreenchange", e);
      } else nB() ? this.noSleepTimer = void 0 : (this.noSleepVideo = document.createElement("video"), this.noSleepVideo.setAttribute("title", "MetaMask SDK - Listening for responses"), this.noSleepVideo.setAttribute("playsinline", ""), this._addSourceToVideo(this.noSleepVideo, "webm", "data:video/webm;base64,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"), this._addSourceToVideo(this.noSleepVideo, "mp4", "data:video/mp4;base64,AAAAHGZ0eXBNNFYgAAACAGlzb21pc28yYXZjMQAAAAhmcmVlAAAGF21kYXTeBAAAbGliZmFhYyAxLjI4AABCAJMgBDIARwAAArEGBf//rdxF6b3m2Ui3lizYINkj7u94MjY0IC0gY29yZSAxNDIgcjIgOTU2YzhkOCAtIEguMjY0L01QRUctNCBBVkMgY29kZWMgLSBDb3B5bGVmdCAyMDAzLTIwMTQgLSBodHRwOi8vd3d3LnZpZGVvbGFuLm9yZy94MjY0Lmh0bWwgLSBvcHRpb25zOiBjYWJhYz0wIHJlZj0zIGRlYmxvY2s9MTowOjAgYW5hbHlzZT0weDE6MHgxMTEgbWU9aGV4IHN1Ym1lPTcgcHN5PTEgcHN5X3JkPTEuMDA6MC4wMCBtaXhlZF9yZWY9MSBtZV9yYW5nZT0xNiBjaHJvbWFfbWU9MSB0cmVsbGlzPTEgOHg4ZGN0PTAgY3FtPTAgZGVhZHpvbmU9MjEsMTEgZmFzdF9wc2tpcD0xIGNocm9tYV9xcF9vZmZzZXQ9LTIgdGhyZWFkcz02IGxvb2thaGVhZF90aHJlYWRzPTEgc2xpY2VkX3RocmVhZHM9MCBucj0wIGRlY2ltYXRlPTEgaW50ZXJsYWNlZD0wIGJsdXJheV9jb21wYXQ9MCBjb25zdHJhaW5lZF9pbnRyYT0wIGJmcmFtZXM9MCB3ZWlnaHRwPTAga2V5aW50PTI1MCBrZXlpbnRfbWluPTI1IHNjZW5lY3V0PTQwIGludHJhX3JlZnJlc2g9MCByY19sb29rYWhlYWQ9NDAgcmM9Y3JmIG1idHJlZT0xIGNyZj0yMy4wIHFjb21wPTAuNjAgcXBtaW49MCBxcG1heD02OSBxcHN0ZXA9NCB2YnZfbWF4cmF0ZT03NjggdmJ2X2J1ZnNpemU9MzAwMCBjcmZfbWF4PTAuMCBuYWxfaHJkPW5vbmUgZmlsbGVyPTAgaXBfcmF0aW89MS40MCBhcT0xOjEuMDAAgAAAAFZliIQL8mKAAKvMnJycnJycnJycnXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXiEASZACGQAjgCEASZACGQAjgAAAAAdBmjgX4GSAIQBJkAIZACOAAAAAB0GaVAX4GSAhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZpgL8DJIQBJkAIZACOAIQBJkAIZACOAAAAABkGagC/AySEASZACGQAjgAAAAAZBmqAvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZrAL8DJIQBJkAIZACOAAAAABkGa4C/AySEASZACGQAjgCEASZACGQAjgAAAAAZBmwAvwMkhAEmQAhkAI4AAAAAGQZsgL8DJIQBJkAIZACOAIQBJkAIZACOAAAAABkGbQC/AySEASZACGQAjgCEASZACGQAjgAAAAAZBm2AvwMkhAEmQAhkAI4AAAAAGQZuAL8DJIQBJkAIZACOAIQBJkAIZACOAAAAABkGboC/AySEASZACGQAjgAAAAAZBm8AvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZvgL8DJIQBJkAIZACOAAAAABkGaAC/AySEASZACGQAjgCEASZACGQAjgAAAAAZBmiAvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZpAL8DJIQBJkAIZACOAAAAABkGaYC/AySEASZACGQAjgCEASZACGQAjgAAAAAZBmoAvwMkhAEmQAhkAI4AAAAAGQZqgL8DJIQBJkAIZACOAIQBJkAIZACOAAAAABkGawC/AySEASZACGQAjgAAAAAZBmuAvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZsAL8DJIQBJkAIZACOAAAAABkGbIC/AySEASZACGQAjgCEASZACGQAjgAAAAAZBm0AvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZtgL8DJIQBJkAIZACOAAAAABkGbgCvAySEASZACGQAjgCEASZACGQAjgAAAAAZBm6AnwMkhAEmQAhkAI4AhAEmQAhkAI4AhAEmQAhkAI4AhAEmQAhkAI4AAAAhubW9vdgAAAGxtdmhkAAAAAAAAAAAAAAAAAAAD6AAABDcAAQAAAQAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAAAzB0cmFrAAAAXHRraGQAAAADAAAAAAAAAAAAAAABAAAAAAAAA+kAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAALAAAACQAAAAAAAkZWR0cwAAABxlbHN0AAAAAAAAAAEAAAPpAAAAAAABAAAAAAKobWRpYQAAACBtZGhkAAAAAAAAAAAAAAAAAAB1MAAAdU5VxAAAAAAALWhkbHIAAAAAAAAAAHZpZGUAAAAAAAAAAAAAAABWaWRlb0hhbmRsZXIAAAACU21pbmYAAAAUdm1oZAAAAAEAAAAAAAAAAAAAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAAhNzdGJsAAAAr3N0c2QAAAAAAAAAAQAAAJ9hdmMxAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAALAAkABIAAAASAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGP//AAAALWF2Y0MBQsAN/+EAFWdCwA3ZAsTsBEAAAPpAADqYA8UKkgEABWjLg8sgAAAAHHV1aWRraEDyXyRPxbo5pRvPAyPzAAAAAAAAABhzdHRzAAAAAAAAAAEAAAAeAAAD6QAAABRzdHNzAAAAAAAAAAEAAAABAAAAHHN0c2MAAAAAAAAAAQAAAAEAAAABAAAAAQAAAIxzdHN6AAAAAAAAAAAAAAAeAAADDwAAAAsAAAALAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAAiHN0Y28AAAAAAAAAHgAAAEYAAANnAAADewAAA5gAAAO0AAADxwAAA+MAAAP2AAAEEgAABCUAAARBAAAEXQAABHAAAASMAAAEnwAABLsAAATOAAAE6gAABQYAAAUZAAAFNQAABUgAAAVkAAAFdwAABZMAAAWmAAAFwgAABd4AAAXxAAAGDQAABGh0cmFrAAAAXHRraGQAAAADAAAAAAAAAAAAAAACAAAAAAAABDcAAAAAAAAAAAAAAAEBAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAkZWR0cwAAABxlbHN0AAAAAAAAAAEAAAQkAAADcAABAAAAAAPgbWRpYQAAACBtZGhkAAAAAAAAAAAAAAAAAAC7gAAAykBVxAAAAAAALWhkbHIAAAAAAAAAAHNvdW4AAAAAAAAAAAAAAABTb3VuZEhhbmRsZXIAAAADi21pbmYAAAAQc21oZAAAAAAAAAAAAAAAJGRpbmYAAAAcZHJlZgAAAAAAAAABAAAADHVybCAAAAABAAADT3N0YmwAAABnc3RzZAAAAAAAAAABAAAAV21wNGEAAAAAAAAAAQAAAAAAAAAAAAIAEAAAAAC7gAAAAAAAM2VzZHMAAAAAA4CAgCIAAgAEgICAFEAVBbjYAAu4AAAADcoFgICAAhGQBoCAgAECAAAAIHN0dHMAAAAAAAAAAgAAADIAAAQAAAAAAQAAAkAAAAFUc3RzYwAAAAAAAAAbAAAAAQAAAAEAAAABAAAAAgAAAAIAAAABAAAAAwAAAAEAAAABAAAABAAAAAIAAAABAAAABgAAAAEAAAABAAAABwAAAAIAAAABAAAACAAAAAEAAAABAAAACQAAAAIAAAABAAAACgAAAAEAAAABAAAACwAAAAIAAAABAAAADQAAAAEAAAABAAAADgAAAAIAAAABAAAADwAAAAEAAAABAAAAEAAAAAIAAAABAAAAEQAAAAEAAAABAAAAEgAAAAIAAAABAAAAFAAAAAEAAAABAAAAFQAAAAIAAAABAAAAFgAAAAEAAAABAAAAFwAAAAIAAAABAAAAGAAAAAEAAAABAAAAGQAAAAIAAAABAAAAGgAAAAEAAAABAAAAGwAAAAIAAAABAAAAHQAAAAEAAAABAAAAHgAAAAIAAAABAAAAHwAAAAQAAAABAAAA4HN0c3oAAAAAAAAAAAAAADMAAAAaAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAACMc3RjbwAAAAAAAAAfAAAALAAAA1UAAANyAAADhgAAA6IAAAO+AAAD0QAAA+0AAAQAAAAEHAAABC8AAARLAAAEZwAABHoAAASWAAAEqQAABMUAAATYAAAE9AAABRAAAAUjAAAFPwAABVIAAAVuAAAFgQAABZ0AAAWwAAAFzAAABegAAAX7AAAGFwAAAGJ1ZHRhAAAAWm1ldGEAAAAAAAAAIWhkbHIAAAAAAAAAAG1kaXJhcHBsAAAAAAAAAAAAAAAALWlsc3QAAAAlqXRvbwAAAB1kYXRhAAAAAQAAAABMYXZmNTUuMzMuMTAw"), this.noSleepVideo.addEventListener("loadedmetadata", () => {
        OL("[WakeLockManager: start()] video loadedmetadata", this.noSleepVideo), this.noSleepVideo && (this.noSleepVideo.duration <= 1 ? this.noSleepVideo.setAttribute("loop", "") : this.noSleepVideo.addEventListener("timeupdate", () => {
          this.noSleepVideo && this.noSleepVideo.currentTime > .5 && (this.noSleepVideo.currentTime = Math.random());
        }));
      }));
    }
    _addSourceToVideo(e, t, n) {
      const r = document.createElement("source");
      r.src = n, r.type = `video/${t}`, e.appendChild(r);
    }
    isEnabled() {
      return this.enabled;
    }
    setDebug(e) {
      OL("[WakeLockManager: setDebug()] activate debug mode"), this.debug = e;
    }
    enable() {
      return wS(this, void 0, void 0, function* () {
        this.enabled && this.disable("from_enable");
        const e = tB(),
          t = nB();
        if (OL(`[WakeLockManager: enable()] hasWakelock=${e} isOldIos=${t}`, this.noSleepVideo), this.start(), tB()) try {
          const e = yield navigator.wakeLock.request("screen");
          this._wakeLock = e, this.enabled = !0;
        } catch (e) {
          return OL("[WakeLockManager: enable()] failed to enable wake lock", e), this.enabled = !1, !1;
        } else if (nB()) return this.disable("from_enable_old_ios"), this.noSleepTimer = window.setInterval(() => {
          document.hidden || (window.location.href = window.location.href.split("#")[0], window.setTimeout(window.stop, 0));
        }, 15e3), this.enabled = !0, !0;
        return !!this.noSleepVideo && (this.noSleepVideo.play().then(() => {
          OL("[WakeLockManager: enable()] video started playing successfully");
        }).catch(e => {
          console.warn("[WakeLockManager: enable()] video failed to play", e);
        }), this.enabled = !0, !0);
      });
    }
    disable(e) {
      if (this.enabled) {
        if (OL(`[WakeLockManager: disable()] context=${e}`), tB()) this._wakeLock && (OL("[WakeLockManager: disable()] release wake lock"), this._wakeLock.release()), this._wakeLock = void 0;else if (nB()) this.noSleepTimer && (console.warn("\n          NoSleep now disabled for older iOS devices.\n        "), window.clearInterval(this.noSleepTimer), this.noSleepTimer = void 0);else try {
          if (!this.noSleepVideo) return void OL("[WakeLockManager: disable()] noSleepVideo is undefined");
          OL("[WakeLockManager: disable()] pause noSleepVideo"), this.noSleepVideo.firstChild && (this.noSleepVideo.removeChild(this.noSleepVideo.firstChild), this.noSleepVideo.load()), this.noSleepVideo.pause(), this.noSleepVideo.src = "", this.noSleepVideo.remove();
        } catch (e) {
          console.log(e);
        }
        this.enabled = !1;
      }
    }
  }
  const iB = 2e3,
    oB = 4e4,
    aB = 500;
  class sB {
    constructor({
      useDeepLink: e,
      preferredOpenLink: t,
      wakeLockStatus: n = XD.UntilResponse,
      debug: r = !1
    }) {
      this.state = {
        wakeLock: new rB(),
        wakeLockStatus: XD.UntilResponse,
        wakeLockTimer: void 0,
        wakeLockFeatureActive: !1,
        platformType: void 0,
        useDeeplink: !1,
        preferredOpenLink: void 0,
        debug: !1
      }, this.state.platformType = this.getPlatformType(), this.state.useDeeplink = e, this.state.preferredOpenLink = t, this.state.wakeLockStatus = n, this.state.debug = r, this.state.wakeLock.setDebug(r);
    }
    enableWakeLock() {
      return function (e) {
        const {
          state: t
        } = e;
        if (t.wakeLockStatus === XD.Disabled) return void OL("[PlatfformManager: enableWakeLock()] WakeLock is disabled");
        t.wakeLock.enable().catch(e => {
          console.error("[PlatfformManager: enableWakeLock()] WakeLock is not supported", e);
        });
        const n = t.wakeLockStatus === XD.Temporary ? iB : oB;
        t.wakeLockTimer = setTimeout(() => {
          e.disableWakeLock();
        }, n), t.wakeLockFeatureActive || t.wakeLockStatus !== XD.UntilResponse || (t.wakeLockFeatureActive = !0, window.addEventListener("focus", () => {
          e.disableWakeLock();
        }));
      }(this);
    }
    disableWakeLock() {
      return function (e) {
        const {
          state: t
        } = e;
        t.wakeLockStatus !== XD.Disabled && (t.wakeLockTimer && clearTimeout(t.wakeLockTimer), t.wakeLock.disable("disableWakeLock"));
      }(this);
    }
    openDeeplink(e, t, n) {
      return function (e, t, n, r) {
        const {
          state: i
        } = e;
        OL(`[PlatfformManager: openDeeplink()] universalLink --\x3e ${t}`), OL(`[PlatfformManager: openDeeplink()] deepLink --\x3e ${n}`), e.isBrowser() && e.enableWakeLock();
        try {
          if (i.preferredOpenLink) return void i.preferredOpenLink(i.useDeeplink ? n : t, r);
          if (OL(`[PlatfformManager: openDeeplink()] open link now useDeepLink=${i.useDeeplink} link=${i.useDeeplink ? n : t}`), "undefined" != typeof window) {
            let e;
            e = i.useDeeplink ? window.open(n, "_blank") : window.open(t, "_blank"), setTimeout(() => {
              var t;
              return null === (t = null == e ? void 0 : e.close) || void 0 === t ? void 0 : t.call(e);
            }, aB);
          }
        } catch (e) {
          console.log("[PlatfformManager: openDeeplink()] can't open link", e);
        }
      }(this, e, t, n);
    }
    isReactNative() {
      var e;
      return this.isNotBrowser() && "undefined" != typeof window && (null === window || void 0 === window ? void 0 : window.navigator) && "ReactNative" === (null === (e = window.navigator) || void 0 === e ? void 0 : e.product);
    }
    isMetaMaskInstalled() {
      return function () {
        const e = OD.getProvider() || (null === window || void 0 === window ? void 0 : window.ethereum);
        return OL(`[PlatfformManager: isMetaMaskInstalled()] isMetaMask=${null == e ? void 0 : e.isMetaMask} isConnected=${null == e ? void 0 : e.isConnected()}`), (null == e ? void 0 : e.isMetaMask) && (null == e ? void 0 : e.isConnected());
      }();
    }
    isDesktopWeb() {
      return this.isBrowser() && !this.isMobileWeb();
    }
    isMobile() {
      var e, t;
      const n = eB.parse(window.navigator.userAgent);
      return "mobile" === (null === (e = null == n ? void 0 : n.platform) || void 0 === e ? void 0 : e.type) || "tablet" === (null === (t = null == n ? void 0 : n.platform) || void 0 === t ? void 0 : t.type);
    }
    isSecure() {
      return this.isReactNative() || this.isMobileWeb();
    }
    isMetaMaskMobileWebView() {
      return "undefined" != typeof window && Boolean(window.ReactNativeWebView) && Boolean(navigator.userAgent.endsWith("MetaMaskMobile"));
    }
    isMobileWeb() {
      return this.state.platformType === e.PlatformType.MobileWeb;
    }
    isNotBrowser() {
      var e;
      return "undefined" == typeof window || !(null === window || void 0 === window ? void 0 : window.navigator) || "undefined" != typeof global && "ReactNative" === (null === (e = null === global || void 0 === global ? void 0 : global.navigator) || void 0 === e ? void 0 : e.product) || "ReactNative" === (null === navigator || void 0 === navigator ? void 0 : navigator.product);
    }
    isNodeJS() {
      return this.isNotBrowser() && !this.isReactNative();
    }
    isBrowser() {
      return !this.isNotBrowser();
    }
    isUseDeepLink() {
      return this.state.useDeeplink;
    }
    getPlatformType() {
      return function (t) {
        const {
          state: n
        } = t;
        return n.platformType ? n.platformType : t.isReactNative() ? e.PlatformType.ReactNative : t.isNotBrowser() ? e.PlatformType.NonBrowser : t.isMetaMaskMobileWebView() ? e.PlatformType.MetaMaskMobileWebview : t.isMobile() ? e.PlatformType.MobileWeb : e.PlatformType.DesktopWeb;
      }(this);
    }
  }
  /*! *****************************************************************************
              Copyright (c) Microsoft Corporation.
  
              Permission to use, copy, modify, and/or distribute this software for any
              purpose with or without fee is hereby granted.
  
              THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
              REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
              AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
              INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
              LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
              OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
              PERFORMANCE OF THIS SOFTWARE.
              ***************************************************************************** */
  function uB(e, t, n, r) {
    return new (n || (n = Promise))(function (i, o) {
      function a(e) {
        try {
          u(r.next(e));
        } catch (e) {
          o(e);
        }
      }
      function s(e) {
        try {
          u(r.throw(e));
        } catch (e) {
          o(e);
        }
      }
      function u(e) {
        e.done ? i(e.value) : function (e) {
          return e instanceof n ? e : new n(function (t) {
            t(e);
          });
        }(e.value).then(a, s);
      }
      u((r = r.apply(e, t || [])).next());
    });
  }
  function cB(e, t) {
    var n,
      r,
      i,
      o,
      a = {
        label: 0,
        sent: function () {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
    return o = {
      next: s(0),
      throw: s(1),
      return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
      return this;
    }), o;
    function s(o) {
      return function (s) {
        return function (o) {
          if (n) throw new TypeError("Generator is already executing.");
          for (; a;) try {
            if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
            switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
              case 0:
              case 1:
                i = o;
                break;
              case 4:
                return a.label++, {
                  value: o[1],
                  done: !1
                };
              case 5:
                a.label++, r = o[1], o = [0];
                continue;
              case 7:
                o = a.ops.pop(), a.trys.pop();
                continue;
              default:
                if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                  a = 0;
                  continue;
                }
                if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                  a.label = o[1];
                  break;
                }
                if (6 === o[0] && a.label < i[1]) {
                  a.label = i[1], i = o;
                  break;
                }
                if (i && a.label < i[2]) {
                  a.label = i[2], a.ops.push(o);
                  break;
                }
                i[2] && a.ops.pop(), a.trys.pop();
                continue;
            }
            o = t.call(e, a);
          } catch (e) {
            o = [6, e], r = 0;
          } finally {
            n = i = 0;
          }
          if (5 & o[0]) throw o[1];
          return {
            value: o[0] ? o[1] : void 0,
            done: !0
          };
        }([o, s]);
      };
    }
  }
  var lB = "INSTALLED",
    dB = "NOT_INSTALLED",
    fB = "REGISTERED",
    hB = "REGISTERING",
    pB = "RELOADING",
    mB = {
      CHROME: "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn",
      FIREFOX: "https://addons.mozilla.org/firefox/addon/ether-metamask/",
      DEFAULT: "https://metamask.io"
    },
    gB = "REGISTRATION_IN_PROGRESS",
    vB = "FORWARDER_ID",
    bB = function () {
      function e(t) {
        var n = void 0 === t ? {} : t,
          r = n.forwarderOrigin,
          i = void 0 === r ? "https://fwd.metamask.io" : r,
          o = n.forwarderMode,
          a = void 0 === o ? e.FORWARDER_MODE.INJECT : o;
        this.forwarderOrigin = i, this.forwarderMode = a, this.state = e.isMetaMaskInstalled() ? lB : dB;
        var s = e._detectBrowser();
        this.downloadUrl = s ? mB[s] : mB.DEFAULT, this._onMessage = this._onMessage.bind(this), this._onMessageFromForwarder = this._onMessageFromForwarder.bind(this), this._openForwarder = this._openForwarder.bind(this), this._openDownloadPage = this._openDownloadPage.bind(this), this.startOnboarding = this.startOnboarding.bind(this), this.stopOnboarding = this.stopOnboarding.bind(this), window.addEventListener("message", this._onMessage), a === e.FORWARDER_MODE.INJECT && "true" === sessionStorage.getItem(gB) && e._injectForwarder(this.forwarderOrigin);
      }
      return e.prototype._onMessage = function (e) {
        if (e.origin === this.forwarderOrigin) return "metamask:reload" === e.data.type ? this._onMessageFromForwarder(e) : void console.debug("Unknown message from '" + e.origin + "' with data " + JSON.stringify(e.data));
      }, e.prototype._onMessageUnknownStateError = function (e) {
        throw new Error("Unknown state: '" + e + "'");
      }, e.prototype._onMessageFromForwarder = function (t) {
        return uB(this, void 0, void 0, function () {
          return cB(this, function (n) {
            switch (n.label) {
              case 0:
                switch (this.state) {
                  case pB:
                    return [3, 1];
                  case dB:
                    return [3, 2];
                  case lB:
                    return [3, 3];
                  case hB:
                    return [3, 5];
                  case fB:
                    return [3, 6];
                }
                return [3, 7];
              case 1:
                return console.debug("Ignoring message while reloading"), [3, 8];
              case 2:
                return console.debug("Reloading now to register with MetaMask"), this.state = pB, location.reload(), [3, 8];
              case 3:
                return console.debug("Registering with MetaMask"), this.state = hB, [4, e._register()];
              case 4:
                return n.sent(), this.state = fB, t.source.postMessage({
                  type: "metamask:registrationCompleted"
                }, t.origin), this.stopOnboarding(), [3, 8];
              case 5:
                return console.debug("Already registering - ignoring reload message"), [3, 8];
              case 6:
                return console.debug("Already registered - ignoring reload message"), [3, 8];
              case 7:
                this._onMessageUnknownStateError(this.state), n.label = 8;
              case 8:
                return [2];
            }
          });
        });
      }, e.prototype.startOnboarding = function () {
        sessionStorage.setItem(gB, "true"), this._openDownloadPage(), this._openForwarder();
      }, e.prototype.stopOnboarding = function () {
        "true" === sessionStorage.getItem(gB) && (this.forwarderMode === e.FORWARDER_MODE.INJECT && (console.debug("Removing forwarder"), e._removeForwarder()), sessionStorage.setItem(gB, "false"));
      }, e.prototype._openForwarder = function () {
        this.forwarderMode === e.FORWARDER_MODE.OPEN_TAB ? window.open(this.forwarderOrigin, "_blank") : e._injectForwarder(this.forwarderOrigin);
      }, e.prototype._openDownloadPage = function () {
        window.open(this.downloadUrl, "_blank");
      }, e.isMetaMaskInstalled = function () {
        return Boolean(window.ethereum && window.ethereum.isMetaMask);
      }, e._register = function () {
        return window.ethereum.request({
          method: "wallet_registerOnboarding"
        });
      }, e._injectForwarder = function (e) {
        var t = document.body,
          n = document.createElement("iframe");
        n.setAttribute("height", "0"), n.setAttribute("width", "0"), n.setAttribute("style", "display: none;"), n.setAttribute("src", e), n.setAttribute("id", vB), t.insertBefore(n, t.children[0]);
      }, e._removeForwarder = function () {
        var e;
        null === (e = document.getElementById(vB)) || void 0 === e || e.remove();
      }, e._detectBrowser = function () {
        var e = eB.parse(window.navigator.userAgent);
        return "Firefox" === e.browser.name ? "FIREFOX" : ["Chrome", "Chromium"].includes(e.browser.name || "") ? "CHROME" : null;
      }, e.FORWARDER_MODE = {
        INJECT: "INJECT",
        OPEN_TAB: "OPEN_TAB"
      }, e;
    }();
  function yB(e, {
    wait: t = !1
  }) {
    return wS(this, void 0, void 0, function* () {
      return OL(`[MetamaskInstaller: startInstaller()] wait=${t}`), t && (yield FD(1e3)), yield e.checkInstallation();
    });
  }
  class wB {
    constructor({
      remote: e,
      preferDesktop: t,
      platformManager: n,
      debug: r = !1
    }) {
      this.state = {
        isInstalling: !1,
        hasInstalled: !1,
        resendRequest: null,
        preferDesktop: !1,
        platformManager: null,
        remote: null,
        debug: !1
      }, this.state.remote = e, this.state.preferDesktop = t, this.state.platformManager = n, this.state.debug = r;
    }
    startDesktopOnboarding() {
      return function () {
        return wS(this, void 0, void 0, function* () {
          OL("[MetamaskInstaller: startDesktopOnboarding() starting desktop onboarding"), OD.destroy(), delete window.ethereum, new bB().startOnboarding();
        });
      }();
    }
    redirectToProperInstall() {
      return wS(this, void 0, void 0, function* () {
        return function (t) {
          var n, r;
          return wS(this, void 0, void 0, function* () {
            const {
                state: i
              } = t,
              o = null === (n = i.platformManager) || void 0 === n ? void 0 : n.getPlatformType();
            if (OL(`[MetamaskInstaller: redirectToProperInstall()] platform=${o}`), o === e.PlatformType.MetaMaskMobileWebview) return !1;
            i.isInstalling = !0;
            try {
              yield null === (r = i.remote) || void 0 === r ? void 0 : r.startConnection(), i.isInstalling = !1, i.hasInstalled = !0;
            } catch (e) {
              throw i.isInstalling = !1, e;
            }
            return !0;
          });
        }(this);
      });
    }
    checkInstallation() {
      return wS(this, void 0, void 0, function* () {
        return function (e) {
          var t;
          return wS(this, void 0, void 0, function* () {
            const {
                state: n
              } = e,
              r = null === (t = n.platformManager) || void 0 === t ? void 0 : t.isMetaMaskInstalled();
            return OL(`[MetamaskInstaller: checkInstallation()] isInstalled=${r}`), !!r || (yield e.redirectToProperInstall());
          });
        }(this);
      });
    }
    start({
      wait: e = !1
    }) {
      return wS(this, void 0, void 0, function* () {
        return yield yB(this, {
          wait: e
        });
      });
    }
  }
  var AB,
    _B = {
      exports: {}
    },
    EB = {
      exports: {}
    },
    SB = {};
  function kB() {
    if (AB) return SB;
    AB = 1;
    var e = Symbol.for("react.element"),
      t = Symbol.for("react.portal"),
      n = Symbol.for("react.fragment"),
      r = Symbol.for("react.strict_mode"),
      i = Symbol.for("react.profiler"),
      o = Symbol.for("react.provider"),
      a = Symbol.for("react.context"),
      s = Symbol.for("react.forward_ref"),
      u = Symbol.for("react.suspense"),
      c = Symbol.for("react.memo"),
      l = Symbol.for("react.lazy"),
      d = Symbol.iterator;
    var f = {
        isMounted: function () {
          return !1;
        },
        enqueueForceUpdate: function () {},
        enqueueReplaceState: function () {},
        enqueueSetState: function () {}
      },
      h = Object.assign,
      p = {};
    function m(e, t, n) {
      this.props = e, this.context = t, this.refs = p, this.updater = n || f;
    }
    function g() {}
    function v(e, t, n) {
      this.props = e, this.context = t, this.refs = p, this.updater = n || f;
    }
    m.prototype.isReactComponent = {}, m.prototype.setState = function (e, t) {
      if ("object" != typeof e && "function" != typeof e && null != e) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
      this.updater.enqueueSetState(this, e, t, "setState");
    }, m.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    }, g.prototype = m.prototype;
    var b = v.prototype = new g();
    b.constructor = v, h(b, m.prototype), b.isPureReactComponent = !0;
    var y = Array.isArray,
      w = Object.prototype.hasOwnProperty,
      A = {
        current: null
      },
      _ = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      };
    function E(t, n, r) {
      var i,
        o = {},
        a = null,
        s = null;
      if (null != n) for (i in void 0 !== n.ref && (s = n.ref), void 0 !== n.key && (a = "" + n.key), n) w.call(n, i) && !_.hasOwnProperty(i) && (o[i] = n[i]);
      var u = arguments.length - 2;
      if (1 === u) o.children = r;else if (1 < u) {
        for (var c = Array(u), l = 0; l < u; l++) c[l] = arguments[l + 2];
        o.children = c;
      }
      if (t && t.defaultProps) for (i in u = t.defaultProps) void 0 === o[i] && (o[i] = u[i]);
      return {
        $$typeof: e,
        type: t,
        key: a,
        ref: s,
        props: o,
        _owner: A.current
      };
    }
    function S(t) {
      return "object" == typeof t && null !== t && t.$$typeof === e;
    }
    var k = /\/+/g;
    function M(e, t) {
      return "object" == typeof e && null !== e && null != e.key ? function (e) {
        var t = {
          "=": "=0",
          ":": "=2"
        };
        return "$" + e.replace(/[=:]/g, function (e) {
          return t[e];
        });
      }("" + e.key) : t.toString(36);
    }
    function C(n, r, i, o, a) {
      var s = typeof n;
      "undefined" !== s && "boolean" !== s || (n = null);
      var u = !1;
      if (null === n) u = !0;else switch (s) {
        case "string":
        case "number":
          u = !0;
          break;
        case "object":
          switch (n.$$typeof) {
            case e:
            case t:
              u = !0;
          }
      }
      if (u) return a = a(u = n), n = "" === o ? "." + M(u, 0) : o, y(a) ? (i = "", null != n && (i = n.replace(k, "$&/") + "/"), C(a, r, i, "", function (e) {
        return e;
      })) : null != a && (S(a) && (a = function (t, n) {
        return {
          $$typeof: e,
          type: t.type,
          key: n,
          ref: t.ref,
          props: t.props,
          _owner: t._owner
        };
      }(a, i + (!a.key || u && u.key === a.key ? "" : ("" + a.key).replace(k, "$&/") + "/") + n)), r.push(a)), 1;
      if (u = 0, o = "" === o ? "." : o + ":", y(n)) for (var c = 0; c < n.length; c++) {
        var l = o + M(s = n[c], c);
        u += C(s, r, i, l, a);
      } else if (l = function (e) {
        return null === e || "object" != typeof e ? null : "function" == typeof (e = d && e[d] || e["@@iterator"]) ? e : null;
      }(n), "function" == typeof l) for (n = l.call(n), c = 0; !(s = n.next()).done;) u += C(s = s.value, r, i, l = o + M(s, c++), a);else if ("object" === s) throw r = String(n), Error("Objects are not valid as a React child (found: " + ("[object Object]" === r ? "object with keys {" + Object.keys(n).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
      return u;
    }
    function x(e, t, n) {
      if (null == e) return e;
      var r = [],
        i = 0;
      return C(e, r, "", "", function (e) {
        return t.call(n, e, i++);
      }), r;
    }
    function R(e) {
      if (-1 === e._status) {
        var t = e._result;
        (t = t()).then(function (t) {
          0 !== e._status && -1 !== e._status || (e._status = 1, e._result = t);
        }, function (t) {
          0 !== e._status && -1 !== e._status || (e._status = 2, e._result = t);
        }), -1 === e._status && (e._status = 0, e._result = t);
      }
      if (1 === e._status) return e._result.default;
      throw e._result;
    }
    var I = {
        current: null
      },
      T = {
        transition: null
      },
      P = {
        ReactCurrentDispatcher: I,
        ReactCurrentBatchConfig: T,
        ReactCurrentOwner: A
      };
    return SB.Children = {
      map: x,
      forEach: function (e, t, n) {
        x(e, function () {
          t.apply(this, arguments);
        }, n);
      },
      count: function (e) {
        var t = 0;
        return x(e, function () {
          t++;
        }), t;
      },
      toArray: function (e) {
        return x(e, function (e) {
          return e;
        }) || [];
      },
      only: function (e) {
        if (!S(e)) throw Error("React.Children.only expected to receive a single React element child.");
        return e;
      }
    }, SB.Component = m, SB.Fragment = n, SB.Profiler = i, SB.PureComponent = v, SB.StrictMode = r, SB.Suspense = u, SB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = P, SB.cloneElement = function (t, n, r) {
      if (null == t) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + t + ".");
      var i = h({}, t.props),
        o = t.key,
        a = t.ref,
        s = t._owner;
      if (null != n) {
        if (void 0 !== n.ref && (a = n.ref, s = A.current), void 0 !== n.key && (o = "" + n.key), t.type && t.type.defaultProps) var u = t.type.defaultProps;
        for (c in n) w.call(n, c) && !_.hasOwnProperty(c) && (i[c] = void 0 === n[c] && void 0 !== u ? u[c] : n[c]);
      }
      var c = arguments.length - 2;
      if (1 === c) i.children = r;else if (1 < c) {
        u = Array(c);
        for (var l = 0; l < c; l++) u[l] = arguments[l + 2];
        i.children = u;
      }
      return {
        $$typeof: e,
        type: t.type,
        key: o,
        ref: a,
        props: i,
        _owner: s
      };
    }, SB.createContext = function (e) {
      return (e = {
        $$typeof: a,
        _currentValue: e,
        _currentValue2: e,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
      }).Provider = {
        $$typeof: o,
        _context: e
      }, e.Consumer = e;
    }, SB.createElement = E, SB.createFactory = function (e) {
      var t = E.bind(null, e);
      return t.type = e, t;
    }, SB.createRef = function () {
      return {
        current: null
      };
    }, SB.forwardRef = function (e) {
      return {
        $$typeof: s,
        render: e
      };
    }, SB.isValidElement = S, SB.lazy = function (e) {
      return {
        $$typeof: l,
        _payload: {
          _status: -1,
          _result: e
        },
        _init: R
      };
    }, SB.memo = function (e, t) {
      return {
        $$typeof: c,
        type: e,
        compare: void 0 === t ? null : t
      };
    }, SB.startTransition = function (e) {
      var t = T.transition;
      T.transition = {};
      try {
        e();
      } finally {
        T.transition = t;
      }
    }, SB.unstable_act = function () {
      throw Error("act(...) is not supported in production builds of React.");
    }, SB.useCallback = function (e, t) {
      return I.current.useCallback(e, t);
    }, SB.useContext = function (e) {
      return I.current.useContext(e);
    }, SB.useDebugValue = function () {}, SB.useDeferredValue = function (e) {
      return I.current.useDeferredValue(e);
    }, SB.useEffect = function (e, t) {
      return I.current.useEffect(e, t);
    }, SB.useId = function () {
      return I.current.useId();
    }, SB.useImperativeHandle = function (e, t, n) {
      return I.current.useImperativeHandle(e, t, n);
    }, SB.useInsertionEffect = function (e, t) {
      return I.current.useInsertionEffect(e, t);
    }, SB.useLayoutEffect = function (e, t) {
      return I.current.useLayoutEffect(e, t);
    }, SB.useMemo = function (e, t) {
      return I.current.useMemo(e, t);
    }, SB.useReducer = function (e, t, n) {
      return I.current.useReducer(e, t, n);
    }, SB.useRef = function (e) {
      return I.current.useRef(e);
    }, SB.useState = function (e) {
      return I.current.useState(e);
    }, SB.useSyncExternalStore = function (e, t, n) {
      return I.current.useSyncExternalStore(e, t, n);
    }, SB.useTransition = function () {
      return I.current.useTransition();
    }, SB.version = "18.2.0", SB;
  }
  var MB,
    CB,
    xB = {
      exports: {}
    };
  function RB() {
    return MB || (MB = 1, function (e, t) {
      "production" !== Be.env.NODE_ENV && function () {
        "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
        var n = Symbol.for("react.element"),
          r = Symbol.for("react.portal"),
          i = Symbol.for("react.fragment"),
          o = Symbol.for("react.strict_mode"),
          a = Symbol.for("react.profiler"),
          s = Symbol.for("react.provider"),
          u = Symbol.for("react.context"),
          c = Symbol.for("react.forward_ref"),
          l = Symbol.for("react.suspense"),
          d = Symbol.for("react.suspense_list"),
          f = Symbol.for("react.memo"),
          h = Symbol.for("react.lazy"),
          p = Symbol.for("react.offscreen"),
          m = Symbol.iterator,
          g = "@@iterator";
        function v(e) {
          if (null === e || "object" != typeof e) return null;
          var t = m && e[m] || e[g];
          return "function" == typeof t ? t : null;
        }
        var b = {
            current: null
          },
          y = {
            transition: null
          },
          w = {
            current: null,
            isBatchingLegacy: !1,
            didScheduleLegacyUpdate: !1
          },
          A = {
            current: null
          },
          _ = {},
          E = null;
        function S(e) {
          E = e;
        }
        _.setExtraStackFrame = function (e) {
          E = e;
        }, _.getCurrentStack = null, _.getStackAddendum = function () {
          var e = "";
          E && (e += E);
          var t = _.getCurrentStack;
          return t && (e += t() || ""), e;
        };
        var k = !1,
          M = !1,
          C = !1,
          x = !1,
          R = !1,
          I = {
            ReactCurrentDispatcher: b,
            ReactCurrentBatchConfig: y,
            ReactCurrentOwner: A
          };
        function T(e) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          O("warn", e, n);
        }
        function P(e) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          O("error", e, n);
        }
        function O(e, t, n) {
          var r = I.ReactDebugCurrentFrame.getStackAddendum();
          "" !== r && (t += "%s", n = n.concat([r]));
          var i = n.map(function (e) {
            return String(e);
          });
          i.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, i);
        }
        I.ReactDebugCurrentFrame = _, I.ReactCurrentActQueue = w;
        var L = {};
        function N(e, t) {
          var n = e.constructor,
            r = n && (n.displayName || n.name) || "ReactClass",
            i = r + "." + t;
          L[i] || (P("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", t, r), L[i] = !0);
        }
        var D = {
            isMounted: function (e) {
              return !1;
            },
            enqueueForceUpdate: function (e, t, n) {
              N(e, "forceUpdate");
            },
            enqueueReplaceState: function (e, t, n, r) {
              N(e, "replaceState");
            },
            enqueueSetState: function (e, t, n, r) {
              N(e, "setState");
            }
          },
          B = Object.assign,
          j = {};
        function F(e, t, n) {
          this.props = e, this.context = t, this.refs = j, this.updater = n || D;
        }
        Object.freeze(j), F.prototype.isReactComponent = {}, F.prototype.setState = function (e, t) {
          if ("object" != typeof e && "function" != typeof e && null != e) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
          this.updater.enqueueSetState(this, e, t, "setState");
        }, F.prototype.forceUpdate = function (e) {
          this.updater.enqueueForceUpdate(this, e, "forceUpdate");
        };
        var z = {
            isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
            replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
          },
          U = function (e, t) {
            Object.defineProperty(F.prototype, e, {
              get: function () {
                T("%s(...) is deprecated in plain JavaScript React classes. %s", t[0], t[1]);
              }
            });
          };
        for (var q in z) z.hasOwnProperty(q) && U(q, z[q]);
        function K() {}
        function H(e, t, n) {
          this.props = e, this.context = t, this.refs = j, this.updater = n || D;
        }
        K.prototype = F.prototype;
        var V = H.prototype = new K();
        V.constructor = H, B(V, F.prototype), V.isPureReactComponent = !0;
        var $ = Array.isArray;
        function W(e) {
          return $(e);
        }
        function Y(e) {
          return "" + e;
        }
        function G(e) {
          if (function (e) {
            try {
              return Y(e), !1;
            } catch (e) {
              return !0;
            }
          }(e)) return P("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", function (e) {
            return "function" == typeof Symbol && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
          }(e)), Y(e);
        }
        function Q(e) {
          return e.displayName || "Context";
        }
        function Z(e) {
          if (null == e) return null;
          if ("number" == typeof e.tag && P("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), "function" == typeof e) return e.displayName || e.name || null;
          if ("string" == typeof e) return e;
          switch (e) {
            case i:
              return "Fragment";
            case r:
              return "Portal";
            case a:
              return "Profiler";
            case o:
              return "StrictMode";
            case l:
              return "Suspense";
            case d:
              return "SuspenseList";
          }
          if ("object" == typeof e) switch (e.$$typeof) {
            case u:
              return Q(e) + ".Consumer";
            case s:
              return Q(e._context) + ".Provider";
            case c:
              return function (e, t, n) {
                var r = e.displayName;
                if (r) return r;
                var i = t.displayName || t.name || "";
                return "" !== i ? n + "(" + i + ")" : n;
              }(e, e.render, "ForwardRef");
            case f:
              var t = e.displayName || null;
              return null !== t ? t : Z(e.type) || "Memo";
            case h:
              var n = e,
                p = n._payload,
                m = n._init;
              try {
                return Z(m(p));
              } catch (e) {
                return null;
              }
          }
          return null;
        }
        var J,
          X,
          ee,
          te = Object.prototype.hasOwnProperty,
          ne = {
            key: !0,
            ref: !0,
            __self: !0,
            __source: !0
          };
        function re(e) {
          if (te.call(e, "ref")) {
            var t = Object.getOwnPropertyDescriptor(e, "ref").get;
            if (t && t.isReactWarning) return !1;
          }
          return void 0 !== e.ref;
        }
        function ie(e) {
          if (te.call(e, "key")) {
            var t = Object.getOwnPropertyDescriptor(e, "key").get;
            if (t && t.isReactWarning) return !1;
          }
          return void 0 !== e.key;
        }
        ee = {};
        var oe = function (e, t, r, i, o, a, s) {
          var u = {
            $$typeof: n,
            type: e,
            key: t,
            ref: r,
            props: s,
            _owner: a,
            _store: {}
          };
          return Object.defineProperty(u._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: !1
          }), Object.defineProperty(u, "_self", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: i
          }), Object.defineProperty(u, "_source", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: o
          }), Object.freeze && (Object.freeze(u.props), Object.freeze(u)), u;
        };
        function ae(e, t, n) {
          var r,
            i = {},
            o = null,
            a = null,
            s = null,
            u = null;
          if (null != t) for (r in re(t) && (a = t.ref, function (e) {
            if ("string" == typeof e.ref && A.current && e.__self && A.current.stateNode !== e.__self) {
              var t = Z(A.current.type);
              ee[t] || (P('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', t, e.ref), ee[t] = !0);
            }
          }(t)), ie(t) && (G(t.key), o = "" + t.key), s = void 0 === t.__self ? null : t.__self, u = void 0 === t.__source ? null : t.__source, t) te.call(t, r) && !ne.hasOwnProperty(r) && (i[r] = t[r]);
          var c = arguments.length - 2;
          if (1 === c) i.children = n;else if (c > 1) {
            for (var l = Array(c), d = 0; d < c; d++) l[d] = arguments[d + 2];
            Object.freeze && Object.freeze(l), i.children = l;
          }
          if (e && e.defaultProps) {
            var f = e.defaultProps;
            for (r in f) void 0 === i[r] && (i[r] = f[r]);
          }
          if (o || a) {
            var h = "function" == typeof e ? e.displayName || e.name || "Unknown" : e;
            o && function (e, t) {
              var n = function () {
                J || (J = !0, P("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
              };
              n.isReactWarning = !0, Object.defineProperty(e, "key", {
                get: n,
                configurable: !0
              });
            }(i, h), a && function (e, t) {
              var n = function () {
                X || (X = !0, P("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
              };
              n.isReactWarning = !0, Object.defineProperty(e, "ref", {
                get: n,
                configurable: !0
              });
            }(i, h);
          }
          return oe(e, o, a, s, u, A.current, i);
        }
        function se(e, t, n) {
          if (null == e) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
          var r,
            i,
            o = B({}, e.props),
            a = e.key,
            s = e.ref,
            u = e._self,
            c = e._source,
            l = e._owner;
          if (null != t) for (r in re(t) && (s = t.ref, l = A.current), ie(t) && (G(t.key), a = "" + t.key), e.type && e.type.defaultProps && (i = e.type.defaultProps), t) te.call(t, r) && !ne.hasOwnProperty(r) && (void 0 === t[r] && void 0 !== i ? o[r] = i[r] : o[r] = t[r]);
          var d = arguments.length - 2;
          if (1 === d) o.children = n;else if (d > 1) {
            for (var f = Array(d), h = 0; h < d; h++) f[h] = arguments[h + 2];
            o.children = f;
          }
          return oe(e.type, a, s, u, c, l, o);
        }
        function ue(e) {
          return "object" == typeof e && null !== e && e.$$typeof === n;
        }
        var ce = ".",
          le = ":";
        var de = !1,
          fe = /\/+/g;
        function he(e) {
          return e.replace(fe, "$&/");
        }
        function pe(e, t) {
          return "object" == typeof e && null !== e && null != e.key ? (G(e.key), function (e) {
            var t = {
              "=": "=0",
              ":": "=2"
            };
            return "$" + e.replace(/[=:]/g, function (e) {
              return t[e];
            });
          }("" + e.key)) : t.toString(36);
        }
        function me(e, t, i, o, a) {
          var s = typeof e;
          "undefined" !== s && "boolean" !== s || (e = null);
          var u,
            c,
            l,
            d = !1;
          if (null === e) d = !0;else switch (s) {
            case "string":
            case "number":
              d = !0;
              break;
            case "object":
              switch (e.$$typeof) {
                case n:
                case r:
                  d = !0;
              }
          }
          if (d) {
            var f = e,
              h = a(f),
              p = "" === o ? ce + pe(f, 0) : o;
            if (W(h)) {
              var m = "";
              null != p && (m = he(p) + "/"), me(h, t, m, "", function (e) {
                return e;
              });
            } else null != h && (ue(h) && (!h.key || f && f.key === h.key || G(h.key), u = h, c = i + (!h.key || f && f.key === h.key ? "" : he("" + h.key) + "/") + p, h = oe(u.type, c, u.ref, u._self, u._source, u._owner, u.props)), t.push(h));
            return 1;
          }
          var g = 0,
            b = "" === o ? ce : o + le;
          if (W(e)) for (var y = 0; y < e.length; y++) g += me(l = e[y], t, i, b + pe(l, y), a);else {
            var w = v(e);
            if ("function" == typeof w) {
              var A = e;
              w === A.entries && (de || T("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), de = !0);
              for (var _, E = w.call(A), S = 0; !(_ = E.next()).done;) g += me(l = _.value, t, i, b + pe(l, S++), a);
            } else if ("object" === s) {
              var k = String(e);
              throw new Error("Objects are not valid as a React child (found: " + ("[object Object]" === k ? "object with keys {" + Object.keys(e).join(", ") + "}" : k) + "). If you meant to render a collection of children, use an array instead.");
            }
          }
          return g;
        }
        function ge(e, t, n) {
          if (null == e) return e;
          var r = [],
            i = 0;
          return me(e, r, "", "", function (e) {
            return t.call(n, e, i++);
          }), r;
        }
        var ve,
          be = -1,
          ye = 0,
          we = 1,
          Ae = 2;
        function _e(e) {
          if (e._status === be) {
            var t = (0, e._result)();
            if (t.then(function (t) {
              if (e._status === ye || e._status === be) {
                var n = e;
                n._status = we, n._result = t;
              }
            }, function (t) {
              if (e._status === ye || e._status === be) {
                var n = e;
                n._status = Ae, n._result = t;
              }
            }), e._status === be) {
              var n = e;
              n._status = ye, n._result = t;
            }
          }
          if (e._status === we) {
            var r = e._result;
            return void 0 === r && P("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", r), "default" in r || P("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", r), r.default;
          }
          throw e._result;
        }
        function Ee(e) {
          return "string" == typeof e || "function" == typeof e || !!(e === i || e === a || R || e === o || e === l || e === d || x || e === p || k || M || C) || "object" == typeof e && null !== e && (e.$$typeof === h || e.$$typeof === f || e.$$typeof === s || e.$$typeof === u || e.$$typeof === c || e.$$typeof === ve || void 0 !== e.getModuleId);
        }
        function Se() {
          var e = b.current;
          return null === e && P("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem."), e;
        }
        ve = Symbol.for("react.module.reference");
        var ke,
          Me,
          Ce,
          xe,
          Re,
          Ie,
          Te,
          Pe = 0;
        function Oe() {}
        Oe.__reactDisabledLog = !0;
        var Le,
          Ne = I.ReactCurrentDispatcher;
        function De(e, t, n) {
          if (void 0 === Le) try {
            throw Error();
          } catch (e) {
            var r = e.stack.trim().match(/\n( *(at )?)/);
            Le = r && r[1] || "";
          }
          return "\n" + Le + e;
        }
        var Be,
          je = !1,
          Fe = "function" == typeof WeakMap ? WeakMap : Map;
        function ze(e, t) {
          if (!e || je) return "";
          var n,
            r = Be.get(e);
          if (void 0 !== r) return r;
          je = !0;
          var i,
            o = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0, i = Ne.current, Ne.current = null, function () {
            if (0 === Pe) {
              ke = console.log, Me = console.info, Ce = console.warn, xe = console.error, Re = console.group, Ie = console.groupCollapsed, Te = console.groupEnd;
              var e = {
                configurable: !0,
                enumerable: !0,
                value: Oe,
                writable: !0
              };
              Object.defineProperties(console, {
                info: e,
                log: e,
                warn: e,
                error: e,
                group: e,
                groupCollapsed: e,
                groupEnd: e
              });
            }
            Pe++;
          }();
          try {
            if (t) {
              var a = function () {
                throw Error();
              };
              if (Object.defineProperty(a.prototype, "props", {
                set: function () {
                  throw Error();
                }
              }), "object" == typeof Reflect && Reflect.construct) {
                try {
                  Reflect.construct(a, []);
                } catch (e) {
                  n = e;
                }
                Reflect.construct(e, [], a);
              } else {
                try {
                  a.call();
                } catch (e) {
                  n = e;
                }
                e.call(a.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (e) {
                n = e;
              }
              e();
            }
          } catch (t) {
            if (t && n && "string" == typeof t.stack) {
              for (var s = t.stack.split("\n"), u = n.stack.split("\n"), c = s.length - 1, l = u.length - 1; c >= 1 && l >= 0 && s[c] !== u[l];) l--;
              for (; c >= 1 && l >= 0; c--, l--) if (s[c] !== u[l]) {
                if (1 !== c || 1 !== l) do {
                  if (c--, --l < 0 || s[c] !== u[l]) {
                    var d = "\n" + s[c].replace(" at new ", " at ");
                    return e.displayName && d.includes("<anonymous>") && (d = d.replace("<anonymous>", e.displayName)), "function" == typeof e && Be.set(e, d), d;
                  }
                } while (c >= 1 && l >= 0);
                break;
              }
            }
          } finally {
            je = !1, Ne.current = i, function () {
              if (0 == --Pe) {
                var e = {
                  configurable: !0,
                  enumerable: !0,
                  writable: !0
                };
                Object.defineProperties(console, {
                  log: B({}, e, {
                    value: ke
                  }),
                  info: B({}, e, {
                    value: Me
                  }),
                  warn: B({}, e, {
                    value: Ce
                  }),
                  error: B({}, e, {
                    value: xe
                  }),
                  group: B({}, e, {
                    value: Re
                  }),
                  groupCollapsed: B({}, e, {
                    value: Ie
                  }),
                  groupEnd: B({}, e, {
                    value: Te
                  })
                });
              }
              Pe < 0 && P("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
            }(), Error.prepareStackTrace = o;
          }
          var f = e ? e.displayName || e.name : "",
            h = f ? De(f) : "";
          return "function" == typeof e && Be.set(e, h), h;
        }
        function Ue(e, t, n) {
          if (null == e) return "";
          if ("function" == typeof e) return ze(e, function (e) {
            var t = e.prototype;
            return !(!t || !t.isReactComponent);
          }(e));
          if ("string" == typeof e) return De(e);
          switch (e) {
            case l:
              return De("Suspense");
            case d:
              return De("SuspenseList");
          }
          if ("object" == typeof e) switch (e.$$typeof) {
            case c:
              return ze(e.render, !1);
            case f:
              return Ue(e.type, t, n);
            case h:
              var r = e,
                i = r._payload,
                o = r._init;
              try {
                return Ue(o(i), t, n);
              } catch (e) {}
          }
          return "";
        }
        Be = new Fe();
        var qe,
          Ke = {},
          He = I.ReactDebugCurrentFrame;
        function Ve(e) {
          if (e) {
            var t = e._owner,
              n = Ue(e.type, e._source, t ? t.type : null);
            He.setExtraStackFrame(n);
          } else He.setExtraStackFrame(null);
        }
        function $e(e) {
          if (e) {
            var t = e._owner;
            S(Ue(e.type, e._source, t ? t.type : null));
          } else S(null);
        }
        function We() {
          if (A.current) {
            var e = Z(A.current.type);
            if (e) return "\n\nCheck the render method of `" + e + "`.";
          }
          return "";
        }
        qe = !1;
        var Ye = {};
        function Ge(e, t) {
          if (e._store && !e._store.validated && null == e.key) {
            e._store.validated = !0;
            var n = function (e) {
              var t = We();
              if (!t) {
                var n = "string" == typeof e ? e : e.displayName || e.name;
                n && (t = "\n\nCheck the top-level render call using <" + n + ">.");
              }
              return t;
            }(t);
            if (!Ye[n]) {
              Ye[n] = !0;
              var r = "";
              e && e._owner && e._owner !== A.current && (r = " It was passed a child from " + Z(e._owner.type) + "."), $e(e), P('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n, r), $e(null);
            }
          }
        }
        function Qe(e, t) {
          if ("object" == typeof e) if (W(e)) for (var n = 0; n < e.length; n++) {
            var r = e[n];
            ue(r) && Ge(r, t);
          } else if (ue(e)) e._store && (e._store.validated = !0);else if (e) {
            var i = v(e);
            if ("function" == typeof i && i !== e.entries) for (var o, a = i.call(e); !(o = a.next()).done;) ue(o.value) && Ge(o.value, t);
          }
        }
        function Ze(e) {
          var t,
            n = e.type;
          if (null != n && "string" != typeof n) {
            if ("function" == typeof n) t = n.propTypes;else {
              if ("object" != typeof n || n.$$typeof !== c && n.$$typeof !== f) return;
              t = n.propTypes;
            }
            if (t) {
              var r = Z(n);
              !function (e, t, n, r, i) {
                var o = Function.call.bind(te);
                for (var a in e) if (o(e, a)) {
                  var s = void 0;
                  try {
                    if ("function" != typeof e[a]) {
                      var u = Error((r || "React class") + ": " + n + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                      throw u.name = "Invariant Violation", u;
                    }
                    s = e[a](t, a, r, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                  } catch (e) {
                    s = e;
                  }
                  !s || s instanceof Error || (Ve(i), P("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", r || "React class", n, a, typeof s), Ve(null)), s instanceof Error && !(s.message in Ke) && (Ke[s.message] = !0, Ve(i), P("Failed %s type: %s", n, s.message), Ve(null));
                }
              }(t, e.props, "prop", r, e);
            } else if (void 0 !== n.PropTypes && !qe) {
              qe = !0, P("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Z(n) || "Unknown");
            }
            "function" != typeof n.getDefaultProps || n.getDefaultProps.isReactClassApproved || P("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
        function Je(e, t, r) {
          var o,
            a,
            s = Ee(e);
          if (!s) {
            var u = "";
            (void 0 === e || "object" == typeof e && null !== e && 0 === Object.keys(e).length) && (u += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var c,
              l = null != (o = t) && void 0 !== (a = o.__source) ? "\n\nCheck your code at " + a.fileName.replace(/^.*[\\\/]/, "") + ":" + a.lineNumber + "." : "";
            u += l || We(), null === e ? c = "null" : W(e) ? c = "array" : void 0 !== e && e.$$typeof === n ? (c = "<" + (Z(e.type) || "Unknown") + " />", u = " Did you accidentally export a JSX literal instead of a component?") : c = typeof e, P("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", c, u);
          }
          var d = ae.apply(this, arguments);
          if (null == d) return d;
          if (s) for (var f = 2; f < arguments.length; f++) Qe(arguments[f], e);
          return e === i ? function (e) {
            for (var t = Object.keys(e.props), n = 0; n < t.length; n++) {
              var r = t[n];
              if ("children" !== r && "key" !== r) {
                $e(e), P("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", r), $e(null);
                break;
              }
            }
            null !== e.ref && ($e(e), P("Invalid attribute `ref` supplied to `React.Fragment`."), $e(null));
          }(d) : Ze(d), d;
        }
        var Xe = !1;
        var et = !1,
          tt = null;
        var nt = 0,
          rt = !1;
        function it(e) {
          e !== nt - 1 && P("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), nt = e;
        }
        function ot(t, n, r) {
          var i = w.current;
          if (null !== i) try {
            st(i), function (t) {
              if (null === tt) try {
                var n = ("require" + Math.random()).slice(0, 7),
                  r = e && e[n];
                tt = r.call(e, "timers").setImmediate;
              } catch (e) {
                tt = function (e) {
                  !1 === et && (et = !0, "undefined" == typeof MessageChannel && P("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
                  var t = new MessageChannel();
                  t.port1.onmessage = e, t.port2.postMessage(void 0);
                };
              }
              tt(t);
            }(function () {
              0 === i.length ? (w.current = null, n(t)) : ot(t, n, r);
            });
          } catch (e) {
            r(e);
          } else n(t);
        }
        var at = !1;
        function st(e) {
          if (!at) {
            at = !0;
            var t = 0;
            try {
              for (; t < e.length; t++) {
                var n = e[t];
                do {
                  n = n(!0);
                } while (null !== n);
              }
              e.length = 0;
            } catch (n) {
              throw e = e.slice(t + 1), n;
            } finally {
              at = !1;
            }
          }
        }
        var ut = Je,
          ct = function (e, t, n) {
            for (var r = se.apply(this, arguments), i = 2; i < arguments.length; i++) Qe(arguments[i], r.type);
            return Ze(r), r;
          },
          lt = function (e) {
            var t = Je.bind(null, e);
            return t.type = e, Xe || (Xe = !0, T("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(t, "type", {
              enumerable: !1,
              get: function () {
                return T("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
                  value: e
                }), e;
              }
            }), t;
          },
          dt = {
            map: ge,
            forEach: function (e, t, n) {
              ge(e, function () {
                t.apply(this, arguments);
              }, n);
            },
            count: function (e) {
              var t = 0;
              return ge(e, function () {
                t++;
              }), t;
            },
            toArray: function (e) {
              return ge(e, function (e) {
                return e;
              }) || [];
            },
            only: function (e) {
              if (!ue(e)) throw new Error("React.Children.only expected to receive a single React element child.");
              return e;
            }
          };
        t.Children = dt, t.Component = F, t.Fragment = i, t.Profiler = a, t.PureComponent = H, t.StrictMode = o, t.Suspense = l, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = I, t.cloneElement = ct, t.createContext = function (e) {
          var t = {
            $$typeof: u,
            _currentValue: e,
            _currentValue2: e,
            _threadCount: 0,
            Provider: null,
            Consumer: null,
            _defaultValue: null,
            _globalName: null
          };
          t.Provider = {
            $$typeof: s,
            _context: t
          };
          var n = !1,
            r = !1,
            i = !1,
            o = {
              $$typeof: u,
              _context: t
            };
          return Object.defineProperties(o, {
            Provider: {
              get: function () {
                return r || (r = !0, P("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), t.Provider;
              },
              set: function (e) {
                t.Provider = e;
              }
            },
            _currentValue: {
              get: function () {
                return t._currentValue;
              },
              set: function (e) {
                t._currentValue = e;
              }
            },
            _currentValue2: {
              get: function () {
                return t._currentValue2;
              },
              set: function (e) {
                t._currentValue2 = e;
              }
            },
            _threadCount: {
              get: function () {
                return t._threadCount;
              },
              set: function (e) {
                t._threadCount = e;
              }
            },
            Consumer: {
              get: function () {
                return n || (n = !0, P("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), t.Consumer;
              }
            },
            displayName: {
              get: function () {
                return t.displayName;
              },
              set: function (e) {
                i || (T("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", e), i = !0);
              }
            }
          }), t.Consumer = o, t._currentRenderer = null, t._currentRenderer2 = null, t;
        }, t.createElement = ut, t.createFactory = lt, t.createRef = function () {
          var e = {
            current: null
          };
          return Object.seal(e), e;
        }, t.forwardRef = function (e) {
          null != e && e.$$typeof === f ? P("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : "function" != typeof e ? P("forwardRef requires a render function but was given %s.", null === e ? "null" : typeof e) : 0 !== e.length && 2 !== e.length && P("forwardRef render functions accept exactly two parameters: props and ref. %s", 1 === e.length ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), null != e && (null == e.defaultProps && null == e.propTypes || P("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?"));
          var t,
            n = {
              $$typeof: c,
              render: e
            };
          return Object.defineProperty(n, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function () {
              return t;
            },
            set: function (n) {
              t = n, e.name || e.displayName || (e.displayName = n);
            }
          }), n;
        }, t.isValidElement = ue, t.lazy = function (e) {
          var t,
            n,
            r = {
              $$typeof: h,
              _payload: {
                _status: be,
                _result: e
              },
              _init: _e
            };
          return Object.defineProperties(r, {
            defaultProps: {
              configurable: !0,
              get: function () {
                return t;
              },
              set: function (e) {
                P("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), t = e, Object.defineProperty(r, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function () {
                return n;
              },
              set: function (e) {
                P("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), n = e, Object.defineProperty(r, "propTypes", {
                  enumerable: !0
                });
              }
            }
          }), r;
        }, t.memo = function (e, t) {
          Ee(e) || P("memo: The first argument must be a component. Instead received: %s", null === e ? "null" : typeof e);
          var n,
            r = {
              $$typeof: f,
              type: e,
              compare: void 0 === t ? null : t
            };
          return Object.defineProperty(r, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function () {
              return n;
            },
            set: function (t) {
              n = t, e.name || e.displayName || (e.displayName = t);
            }
          }), r;
        }, t.startTransition = function (e, t) {
          var n = y.transition;
          y.transition = {};
          var r = y.transition;
          y.transition._updatedFibers = new Set();
          try {
            e();
          } finally {
            if (y.transition = n, null === n && r._updatedFibers) r._updatedFibers.size > 10 && T("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), r._updatedFibers.clear();
          }
        }, t.unstable_act = function (e) {
          var t = nt;
          nt++, null === w.current && (w.current = []);
          var n,
            r = w.isBatchingLegacy;
          try {
            if (w.isBatchingLegacy = !0, n = e(), !r && w.didScheduleLegacyUpdate) {
              var i = w.current;
              null !== i && (w.didScheduleLegacyUpdate = !1, st(i));
            }
          } catch (e) {
            throw it(t), e;
          } finally {
            w.isBatchingLegacy = r;
          }
          if (null !== n && "object" == typeof n && "function" == typeof n.then) {
            var o = n,
              a = !1,
              s = {
                then: function (e, n) {
                  a = !0, o.then(function (r) {
                    it(t), 0 === nt ? ot(r, e, n) : e(r);
                  }, function (e) {
                    it(t), n(e);
                  });
                }
              };
            return rt || "undefined" == typeof Promise || Promise.resolve().then(function () {}).then(function () {
              a || (rt = !0, P("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), s;
          }
          var u = n;
          if (it(t), 0 === nt) {
            var c = w.current;
            return null !== c && (st(c), w.current = null), {
              then: function (e, t) {
                null === w.current ? (w.current = [], ot(u, e, t)) : e(u);
              }
            };
          }
          return {
            then: function (e, t) {
              e(u);
            }
          };
        }, t.useCallback = function (e, t) {
          return Se().useCallback(e, t);
        }, t.useContext = function (e) {
          var t = Se();
          if (void 0 !== e._context) {
            var n = e._context;
            n.Consumer === e ? P("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : n.Provider === e && P("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
          }
          return t.useContext(e);
        }, t.useDebugValue = function (e, t) {
          return Se().useDebugValue(e, t);
        }, t.useDeferredValue = function (e) {
          return Se().useDeferredValue(e);
        }, t.useEffect = function (e, t) {
          return Se().useEffect(e, t);
        }, t.useId = function () {
          return Se().useId();
        }, t.useImperativeHandle = function (e, t, n) {
          return Se().useImperativeHandle(e, t, n);
        }, t.useInsertionEffect = function (e, t) {
          return Se().useInsertionEffect(e, t);
        }, t.useLayoutEffect = function (e, t) {
          return Se().useLayoutEffect(e, t);
        }, t.useMemo = function (e, t) {
          return Se().useMemo(e, t);
        }, t.useReducer = function (e, t, n) {
          return Se().useReducer(e, t, n);
        }, t.useRef = function (e) {
          return Se().useRef(e);
        }, t.useState = function (e) {
          return Se().useState(e);
        }, t.useSyncExternalStore = function (e, t, n) {
          return Se().useSyncExternalStore(e, t, n);
        }, t.useTransition = function () {
          return Se().useTransition();
        }, t.version = "18.2.0", "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }();
    }(xB, xB.exports)), xB.exports;
  }
  function IB() {
    return CB || (CB = 1, "production" === Be.env.NODE_ENV ? EB.exports = kB() : EB.exports = RB()), EB.exports;
  }
  xB.exports;
  var TB,
    PB = {},
    OB = {
      exports: {}
    },
    LB = {},
    NB = {
      exports: {}
    },
    DB = {};
  var BB,
    jB,
    FB,
    zB = {};
  function UB() {
    return BB || (BB = 1, function (e) {
      "production" !== Be.env.NODE_ENV && function () {
        "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
        var t = !1,
          n = !1;
        function r(e, t) {
          var n = e.length;
          e.push(t), function (e, t, n) {
            var r = n;
            for (; r > 0;) {
              var i = r - 1 >>> 1,
                o = e[i];
              if (!(a(o, t) > 0)) return;
              e[i] = t, e[r] = o, r = i;
            }
          }(e, t, n);
        }
        function i(e) {
          return 0 === e.length ? null : e[0];
        }
        function o(e) {
          if (0 === e.length) return null;
          var t = e[0],
            n = e.pop();
          return n !== t && (e[0] = n, function (e, t, n) {
            var r = n,
              i = e.length,
              o = i >>> 1;
            for (; r < o;) {
              var s = 2 * (r + 1) - 1,
                u = e[s],
                c = s + 1,
                l = e[c];
              if (a(u, t) < 0) c < i && a(l, u) < 0 ? (e[r] = l, e[c] = t, r = c) : (e[r] = u, e[s] = t, r = s);else {
                if (!(c < i && a(l, t) < 0)) return;
                e[r] = l, e[c] = t, r = c;
              }
            }
          }(e, n, 0)), t;
        }
        function a(e, t) {
          var n = e.sortIndex - t.sortIndex;
          return 0 !== n ? n : e.id - t.id;
        }
        if ("object" == typeof performance && "function" == typeof performance.now) {
          var s = performance;
          e.unstable_now = function () {
            return s.now();
          };
        } else {
          var u = Date,
            c = u.now();
          e.unstable_now = function () {
            return u.now() - c;
          };
        }
        var l = [],
          d = [],
          f = 1,
          h = null,
          p = 3,
          m = !1,
          g = !1,
          v = !1,
          b = "function" == typeof setTimeout ? setTimeout : null,
          y = "function" == typeof clearTimeout ? clearTimeout : null,
          w = "undefined" != typeof setImmediate ? setImmediate : null;
        function A(e) {
          for (var t = i(d); null !== t;) {
            if (null === t.callback) o(d);else {
              if (!(t.startTime <= e)) return;
              o(d), t.sortIndex = t.expirationTime, r(l, t);
            }
            t = i(d);
          }
        }
        function _(e) {
          if (v = !1, A(e), !g) if (null !== i(l)) g = !0, L(E);else {
            var t = i(d);
            null !== t && N(_, t.startTime - e);
          }
        }
        function E(r, a) {
          g = !1, v && (v = !1, D()), m = !0;
          var s = p;
          try {
            if (!n) return function (n, r) {
              var a = r;
              A(a), h = i(l);
              for (; null !== h && !t && (!(h.expirationTime > a) || n && !R());) {
                var s = h.callback;
                if ("function" == typeof s) {
                  h.callback = null, p = h.priorityLevel;
                  var u = s(h.expirationTime <= a);
                  a = e.unstable_now(), "function" == typeof u ? h.callback = u : h === i(l) && o(l), A(a);
                } else o(l);
                h = i(l);
              }
              if (null !== h) return !0;
              var c = i(d);
              return null !== c && N(_, c.startTime - a), !1;
            }(r, a);
          } finally {
            h = null, p = s, m = !1;
          }
        }
        "undefined" != typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
        var S = !1,
          k = null,
          M = -1,
          C = 5,
          x = -1;
        function R() {
          return !(e.unstable_now() - x < C);
        }
        var I,
          T = function () {
            if (null !== k) {
              var t = e.unstable_now();
              x = t;
              var n = !0;
              try {
                n = k(!0, t);
              } finally {
                n ? I() : (S = !1, k = null);
              }
            } else S = !1;
          };
        if ("function" == typeof w) I = function () {
          w(T);
        };else if ("undefined" != typeof MessageChannel) {
          var P = new MessageChannel(),
            O = P.port2;
          P.port1.onmessage = T, I = function () {
            O.postMessage(null);
          };
        } else I = function () {
          b(T, 0);
        };
        function L(e) {
          k = e, S || (S = !0, I());
        }
        function N(t, n) {
          M = b(function () {
            t(e.unstable_now());
          }, n);
        }
        function D() {
          y(M), M = -1;
        }
        var B = function () {};
        e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function (e) {
          e.callback = null;
        }, e.unstable_continueExecution = function () {
          g || m || (g = !0, L(E));
        }, e.unstable_forceFrameRate = function (e) {
          e < 0 || e > 125 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : C = e > 0 ? Math.floor(1e3 / e) : 5;
        }, e.unstable_getCurrentPriorityLevel = function () {
          return p;
        }, e.unstable_getFirstCallbackNode = function () {
          return i(l);
        }, e.unstable_next = function (e) {
          var t;
          switch (p) {
            case 1:
            case 2:
            case 3:
              t = 3;
              break;
            default:
              t = p;
          }
          var n = p;
          p = t;
          try {
            return e();
          } finally {
            p = n;
          }
        }, e.unstable_pauseExecution = function () {}, e.unstable_requestPaint = B, e.unstable_runWithPriority = function (e, t) {
          switch (e) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
              break;
            default:
              e = 3;
          }
          var n = p;
          p = e;
          try {
            return t();
          } finally {
            p = n;
          }
        }, e.unstable_scheduleCallback = function (t, n, o) {
          var a,
            s,
            u = e.unstable_now();
          if ("object" == typeof o && null !== o) {
            var c = o.delay;
            a = "number" == typeof c && c > 0 ? u + c : u;
          } else a = u;
          switch (t) {
            case 1:
              s = -1;
              break;
            case 2:
              s = 250;
              break;
            case 5:
              s = 1073741823;
              break;
            case 4:
              s = 1e4;
              break;
            default:
              s = 5e3;
          }
          var h = a + s,
            p = {
              id: f++,
              callback: n,
              priorityLevel: t,
              startTime: a,
              expirationTime: h,
              sortIndex: -1
            };
          return a > u ? (p.sortIndex = a, r(d, p), null === i(l) && p === i(d) && (v ? D() : v = !0, N(_, a - u))) : (p.sortIndex = h, r(l, p), g || m || (g = !0, L(E))), p;
        }, e.unstable_shouldYield = R, e.unstable_wrapCallback = function (e) {
          var t = p;
          return function () {
            var n = p;
            p = t;
            try {
              return e.apply(this, arguments);
            } finally {
              p = n;
            }
          };
        }, "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }();
    }(zB)), zB;
  }
  function qB() {
    return jB || (jB = 1, "production" === Be.env.NODE_ENV ? NB.exports = (TB || (TB = 1, function (e) {
      function t(e, t) {
        var n = e.length;
        e.push(t);
        e: for (; 0 < n;) {
          var r = n - 1 >>> 1,
            o = e[r];
          if (!(0 < i(o, t))) break e;
          e[r] = t, e[n] = o, n = r;
        }
      }
      function n(e) {
        return 0 === e.length ? null : e[0];
      }
      function r(e) {
        if (0 === e.length) return null;
        var t = e[0],
          n = e.pop();
        if (n !== t) {
          e[0] = n;
          e: for (var r = 0, o = e.length, a = o >>> 1; r < a;) {
            var s = 2 * (r + 1) - 1,
              u = e[s],
              c = s + 1,
              l = e[c];
            if (0 > i(u, n)) c < o && 0 > i(l, u) ? (e[r] = l, e[c] = n, r = c) : (e[r] = u, e[s] = n, r = s);else {
              if (!(c < o && 0 > i(l, n))) break e;
              e[r] = l, e[c] = n, r = c;
            }
          }
        }
        return t;
      }
      function i(e, t) {
        var n = e.sortIndex - t.sortIndex;
        return 0 !== n ? n : e.id - t.id;
      }
      if ("object" == typeof performance && "function" == typeof performance.now) {
        var o = performance;
        e.unstable_now = function () {
          return o.now();
        };
      } else {
        var a = Date,
          s = a.now();
        e.unstable_now = function () {
          return a.now() - s;
        };
      }
      var u = [],
        c = [],
        l = 1,
        d = null,
        f = 3,
        h = !1,
        p = !1,
        m = !1,
        g = "function" == typeof setTimeout ? setTimeout : null,
        v = "function" == typeof clearTimeout ? clearTimeout : null,
        b = "undefined" != typeof setImmediate ? setImmediate : null;
      function y(e) {
        for (var i = n(c); null !== i;) {
          if (null === i.callback) r(c);else {
            if (!(i.startTime <= e)) break;
            r(c), i.sortIndex = i.expirationTime, t(u, i);
          }
          i = n(c);
        }
      }
      function w(e) {
        if (m = !1, y(e), !p) if (null !== n(u)) p = !0, P(A);else {
          var t = n(c);
          null !== t && O(w, t.startTime - e);
        }
      }
      function A(t, i) {
        p = !1, m && (m = !1, v(k), k = -1), h = !0;
        var o = f;
        try {
          for (y(i), d = n(u); null !== d && (!(d.expirationTime > i) || t && !x());) {
            var a = d.callback;
            if ("function" == typeof a) {
              d.callback = null, f = d.priorityLevel;
              var s = a(d.expirationTime <= i);
              i = e.unstable_now(), "function" == typeof s ? d.callback = s : d === n(u) && r(u), y(i);
            } else r(u);
            d = n(u);
          }
          if (null !== d) var l = !0;else {
            var g = n(c);
            null !== g && O(w, g.startTime - i), l = !1;
          }
          return l;
        } finally {
          d = null, f = o, h = !1;
        }
      }
      "undefined" != typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      var _,
        E = !1,
        S = null,
        k = -1,
        M = 5,
        C = -1;
      function x() {
        return !(e.unstable_now() - C < M);
      }
      function R() {
        if (null !== S) {
          var t = e.unstable_now();
          C = t;
          var n = !0;
          try {
            n = S(!0, t);
          } finally {
            n ? _() : (E = !1, S = null);
          }
        } else E = !1;
      }
      if ("function" == typeof b) _ = function () {
        b(R);
      };else if ("undefined" != typeof MessageChannel) {
        var I = new MessageChannel(),
          T = I.port2;
        I.port1.onmessage = R, _ = function () {
          T.postMessage(null);
        };
      } else _ = function () {
        g(R, 0);
      };
      function P(e) {
        S = e, E || (E = !0, _());
      }
      function O(t, n) {
        k = g(function () {
          t(e.unstable_now());
        }, n);
      }
      e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function (e) {
        e.callback = null;
      }, e.unstable_continueExecution = function () {
        p || h || (p = !0, P(A));
      }, e.unstable_forceFrameRate = function (e) {
        0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : M = 0 < e ? Math.floor(1e3 / e) : 5;
      }, e.unstable_getCurrentPriorityLevel = function () {
        return f;
      }, e.unstable_getFirstCallbackNode = function () {
        return n(u);
      }, e.unstable_next = function (e) {
        switch (f) {
          case 1:
          case 2:
          case 3:
            var t = 3;
            break;
          default:
            t = f;
        }
        var n = f;
        f = t;
        try {
          return e();
        } finally {
          f = n;
        }
      }, e.unstable_pauseExecution = function () {}, e.unstable_requestPaint = function () {}, e.unstable_runWithPriority = function (e, t) {
        switch (e) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            e = 3;
        }
        var n = f;
        f = e;
        try {
          return t();
        } finally {
          f = n;
        }
      }, e.unstable_scheduleCallback = function (r, i, o) {
        var a = e.unstable_now();
        switch (o = "object" == typeof o && null !== o && "number" == typeof (o = o.delay) && 0 < o ? a + o : a, r) {
          case 1:
            var s = -1;
            break;
          case 2:
            s = 250;
            break;
          case 5:
            s = 1073741823;
            break;
          case 4:
            s = 1e4;
            break;
          default:
            s = 5e3;
        }
        return r = {
          id: l++,
          callback: i,
          priorityLevel: r,
          startTime: o,
          expirationTime: s = o + s,
          sortIndex: -1
        }, o > a ? (r.sortIndex = o, t(c, r), null === n(u) && r === n(c) && (m ? (v(k), k = -1) : m = !0, O(w, o - a))) : (r.sortIndex = s, t(u, r), p || h || (p = !0, P(A))), r;
      }, e.unstable_shouldYield = x, e.unstable_wrapCallback = function (e) {
        var t = f;
        return function () {
          var n = f;
          f = t;
          try {
            return e.apply(this, arguments);
          } finally {
            f = n;
          }
        };
      };
    }(DB)), DB) : NB.exports = UB()), NB.exports;
  }
  /**
               * @license React
               * react-dom.production.min.js
               *
               * Copyright (c) Facebook, Inc. and its affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */
  function KB() {
    if (FB) return LB;
    FB = 1;
    var e = IB(),
      t = qB();
    function n(e) {
      for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
      return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var r = new Set(),
      i = {};
    function o(e, t) {
      a(e, t), a(e + "Capture", t);
    }
    function a(e, t) {
      for (i[e] = t, e = 0; e < t.length; e++) r.add(t[e]);
    }
    var s = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement),
      u = Object.prototype.hasOwnProperty,
      c = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      l = {},
      d = {};
    function f(e, t, n, r, i, o, a) {
      this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = r, this.attributeNamespace = i, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o, this.removeEmptyString = a;
    }
    var h = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (e) {
      h[e] = new f(e, 0, !1, e, null, !1, !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
      var t = e[0];
      h[t] = new f(t, 1, !1, e[1], null, !1, !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
      h[e] = new f(e, 2, !1, e.toLowerCase(), null, !1, !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
      h[e] = new f(e, 2, !1, e, null, !1, !1);
    }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
      h[e] = new f(e, 3, !1, e.toLowerCase(), null, !1, !1);
    }), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
      h[e] = new f(e, 3, !0, e, null, !1, !1);
    }), ["capture", "download"].forEach(function (e) {
      h[e] = new f(e, 4, !1, e, null, !1, !1);
    }), ["cols", "rows", "size", "span"].forEach(function (e) {
      h[e] = new f(e, 6, !1, e, null, !1, !1);
    }), ["rowSpan", "start"].forEach(function (e) {
      h[e] = new f(e, 5, !1, e.toLowerCase(), null, !1, !1);
    });
    var p = /[\-:]([a-z])/g;
    function m(e) {
      return e[1].toUpperCase();
    }
    function g(e, t, n, r) {
      var i = h.hasOwnProperty(t) ? h[t] : null;
      (null !== i ? 0 !== i.type : r || !(2 < t.length) || "o" !== t[0] && "O" !== t[0] || "n" !== t[1] && "N" !== t[1]) && (function (e, t, n, r) {
        if (null == t || function (e, t, n, r) {
          if (null !== n && 0 === n.type) return !1;
          switch (typeof t) {
            case "function":
            case "symbol":
              return !0;
            case "boolean":
              return !r && (null !== n ? !n.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
            default:
              return !1;
          }
        }(e, t, n, r)) return !0;
        if (r) return !1;
        if (null !== n) switch (n.type) {
          case 3:
            return !t;
          case 4:
            return !1 === t;
          case 5:
            return isNaN(t);
          case 6:
            return isNaN(t) || 1 > t;
        }
        return !1;
      }(t, n, i, r) && (n = null), r || null === i ? function (e) {
        return !!u.call(d, e) || !u.call(l, e) && (c.test(e) ? d[e] = !0 : (l[e] = !0, !1));
      }(t) && (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : i.mustUseProperty ? e[i.propertyName] = null === n ? 3 !== i.type && "" : n : (t = i.attributeName, r = i.attributeNamespace, null === n ? e.removeAttribute(t) : (n = 3 === (i = i.type) || 4 === i && !0 === n ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
    }
    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
      var t = e.replace(p, m);
      h[t] = new f(t, 1, !1, e, null, !1, !1);
    }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
      var t = e.replace(p, m);
      h[t] = new f(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
    }), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
      var t = e.replace(p, m);
      h[t] = new f(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
    }), ["tabIndex", "crossOrigin"].forEach(function (e) {
      h[e] = new f(e, 1, !1, e.toLowerCase(), null, !1, !1);
    }), h.xlinkHref = new f("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function (e) {
      h[e] = new f(e, 1, !1, e.toLowerCase(), null, !0, !0);
    });
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
      b = Symbol.for("react.element"),
      y = Symbol.for("react.portal"),
      w = Symbol.for("react.fragment"),
      A = Symbol.for("react.strict_mode"),
      _ = Symbol.for("react.profiler"),
      E = Symbol.for("react.provider"),
      S = Symbol.for("react.context"),
      k = Symbol.for("react.forward_ref"),
      M = Symbol.for("react.suspense"),
      C = Symbol.for("react.suspense_list"),
      x = Symbol.for("react.memo"),
      R = Symbol.for("react.lazy"),
      I = Symbol.for("react.offscreen"),
      T = Symbol.iterator;
    function P(e) {
      return null === e || "object" != typeof e ? null : "function" == typeof (e = T && e[T] || e["@@iterator"]) ? e : null;
    }
    var O,
      L = Object.assign;
    function N(e) {
      if (void 0 === O) try {
        throw Error();
      } catch (e) {
        var t = e.stack.trim().match(/\n( *(at )?)/);
        O = t && t[1] || "";
      }
      return "\n" + O + e;
    }
    var D = !1;
    function B(e, t) {
      if (!e || D) return "";
      D = !0;
      var n = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      try {
        if (t) {
          if (t = function () {
            throw Error();
          }, Object.defineProperty(t.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), "object" == typeof Reflect && Reflect.construct) {
            try {
              Reflect.construct(t, []);
            } catch (e) {
              var r = e;
            }
            Reflect.construct(e, [], t);
          } else {
            try {
              t.call();
            } catch (e) {
              r = e;
            }
            e.call(t.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (e) {
            r = e;
          }
          e();
        }
      } catch (t) {
        if (t && r && "string" == typeof t.stack) {
          for (var i = t.stack.split("\n"), o = r.stack.split("\n"), a = i.length - 1, s = o.length - 1; 1 <= a && 0 <= s && i[a] !== o[s];) s--;
          for (; 1 <= a && 0 <= s; a--, s--) if (i[a] !== o[s]) {
            if (1 !== a || 1 !== s) do {
              if (a--, 0 > --s || i[a] !== o[s]) {
                var u = "\n" + i[a].replace(" at new ", " at ");
                return e.displayName && u.includes("<anonymous>") && (u = u.replace("<anonymous>", e.displayName)), u;
              }
            } while (1 <= a && 0 <= s);
            break;
          }
        }
      } finally {
        D = !1, Error.prepareStackTrace = n;
      }
      return (e = e ? e.displayName || e.name : "") ? N(e) : "";
    }
    function j(e) {
      switch (e.tag) {
        case 5:
          return N(e.type);
        case 16:
          return N("Lazy");
        case 13:
          return N("Suspense");
        case 19:
          return N("SuspenseList");
        case 0:
        case 2:
        case 15:
          return e = B(e.type, !1);
        case 11:
          return e = B(e.type.render, !1);
        case 1:
          return e = B(e.type, !0);
        default:
          return "";
      }
    }
    function F(e) {
      if (null == e) return null;
      if ("function" == typeof e) return e.displayName || e.name || null;
      if ("string" == typeof e) return e;
      switch (e) {
        case w:
          return "Fragment";
        case y:
          return "Portal";
        case _:
          return "Profiler";
        case A:
          return "StrictMode";
        case M:
          return "Suspense";
        case C:
          return "SuspenseList";
      }
      if ("object" == typeof e) switch (e.$$typeof) {
        case S:
          return (e.displayName || "Context") + ".Consumer";
        case E:
          return (e._context.displayName || "Context") + ".Provider";
        case k:
          var t = e.render;
          return (e = e.displayName) || (e = "" !== (e = t.displayName || t.name || "") ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
        case x:
          return null !== (t = e.displayName || null) ? t : F(e.type) || "Memo";
        case R:
          t = e._payload, e = e._init;
          try {
            return F(e(t));
          } catch (e) {}
      }
      return null;
    }
    function z(e) {
      var t = e.type;
      switch (e.tag) {
        case 24:
          return "Cache";
        case 9:
          return (t.displayName || "Context") + ".Consumer";
        case 10:
          return (t._context.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return e = (e = t.render).displayName || e.name || "", t.displayName || ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 5:
          return t;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return F(t);
        case 8:
          return t === A ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
          if ("function" == typeof t) return t.displayName || t.name || null;
          if ("string" == typeof t) return t;
      }
      return null;
    }
    function U(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
        case "object":
          return e;
        default:
          return "";
      }
    }
    function q(e) {
      var t = e.type;
      return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === t || "radio" === t);
    }
    function K(e) {
      e._valueTracker || (e._valueTracker = function (e) {
        var t = q(e) ? "checked" : "value",
          n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
          r = "" + e[t];
        if (!e.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
          var i = n.get,
            o = n.set;
          return Object.defineProperty(e, t, {
            configurable: !0,
            get: function () {
              return i.call(this);
            },
            set: function (e) {
              r = "" + e, o.call(this, e);
            }
          }), Object.defineProperty(e, t, {
            enumerable: n.enumerable
          }), {
            getValue: function () {
              return r;
            },
            setValue: function (e) {
              r = "" + e;
            },
            stopTracking: function () {
              e._valueTracker = null, delete e[t];
            }
          };
        }
      }(e));
    }
    function H(e) {
      if (!e) return !1;
      var t = e._valueTracker;
      if (!t) return !0;
      var n = t.getValue(),
        r = "";
      return e && (r = q(e) ? e.checked ? "true" : "false" : e.value), (e = r) !== n && (t.setValue(e), !0);
    }
    function V(e) {
      if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;
      try {
        return e.activeElement || e.body;
      } catch (t) {
        return e.body;
      }
    }
    function $(e, t) {
      var n = t.checked;
      return L({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != n ? n : e._wrapperState.initialChecked
      });
    }
    function W(e, t) {
      var n = null == t.defaultValue ? "" : t.defaultValue,
        r = null != t.checked ? t.checked : t.defaultChecked;
      n = U(null != t.value ? t.value : n), e._wrapperState = {
        initialChecked: r,
        initialValue: n,
        controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
      };
    }
    function Y(e, t) {
      null != (t = t.checked) && g(e, "checked", t, !1);
    }
    function G(e, t) {
      Y(e, t);
      var n = U(t.value),
        r = t.type;
      if (null != n) "number" === r ? (0 === n && "" === e.value || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);else if ("submit" === r || "reset" === r) return void e.removeAttribute("value");
      t.hasOwnProperty("value") ? Z(e, t.type, n) : t.hasOwnProperty("defaultValue") && Z(e, t.type, U(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked);
    }
    function Q(e, t, n) {
      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var r = t.type;
        if (!("submit" !== r && "reset" !== r || void 0 !== t.value && null !== t.value)) return;
        t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
      }
      "" !== (n = e.name) && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, "" !== n && (e.name = n);
    }
    function Z(e, t, n) {
      "number" === t && V(e.ownerDocument) === e || (null == n ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
    }
    var J = Array.isArray;
    function X(e, t, n, r) {
      if (e = e.options, t) {
        t = {};
        for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
        for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
      } else {
        for (n = "" + U(n), t = null, i = 0; i < e.length; i++) {
          if (e[i].value === n) return e[i].selected = !0, void (r && (e[i].defaultSelected = !0));
          null !== t || e[i].disabled || (t = e[i]);
        }
        null !== t && (t.selected = !0);
      }
    }
    function ee(e, t) {
      if (null != t.dangerouslySetInnerHTML) throw Error(n(91));
      return L({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: "" + e._wrapperState.initialValue
      });
    }
    function te(e, t) {
      var r = t.value;
      if (null == r) {
        if (r = t.children, t = t.defaultValue, null != r) {
          if (null != t) throw Error(n(92));
          if (J(r)) {
            if (1 < r.length) throw Error(n(93));
            r = r[0];
          }
          t = r;
        }
        null == t && (t = ""), r = t;
      }
      e._wrapperState = {
        initialValue: U(r)
      };
    }
    function ne(e, t) {
      var n = U(t.value),
        r = U(t.defaultValue);
      null != n && ((n = "" + n) !== e.value && (e.value = n), null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)), null != r && (e.defaultValue = "" + r);
    }
    function re(e) {
      var t = e.textContent;
      t === e._wrapperState.initialValue && "" !== t && null !== t && (e.value = t);
    }
    function ie(e) {
      switch (e) {
        case "svg":
          return "http://www.w3.org/2000/svg";
        case "math":
          return "http://www.w3.org/1998/Math/MathML";
        default:
          return "http://www.w3.org/1999/xhtml";
      }
    }
    function oe(e, t) {
      return null == e || "http://www.w3.org/1999/xhtml" === e ? ie(t) : "http://www.w3.org/2000/svg" === e && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e;
    }
    var ae,
      se,
      ue = (se = function (e, t) {
        if ("http://www.w3.org/2000/svg" !== e.namespaceURI || "innerHTML" in e) e.innerHTML = t;else {
          for ((ae = ae || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = ae.firstChild; e.firstChild;) e.removeChild(e.firstChild);
          for (; t.firstChild;) e.appendChild(t.firstChild);
        }
      }, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function (e, t, n, r) {
        MSApp.execUnsafeLocalFunction(function () {
          return se(e, t);
        });
      } : se);
    function ce(e, t) {
      if (t) {
        var n = e.firstChild;
        if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
      }
      e.textContent = t;
    }
    var le = {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
      },
      de = ["Webkit", "ms", "Moz", "O"];
    function fe(e, t, n) {
      return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || le.hasOwnProperty(e) && le[e] ? ("" + t).trim() : t + "px";
    }
    function he(e, t) {
      for (var n in e = e.style, t) if (t.hasOwnProperty(n)) {
        var r = 0 === n.indexOf("--"),
          i = fe(n, t[n], r);
        "float" === n && (n = "cssFloat"), r ? e.setProperty(n, i) : e[n] = i;
      }
    }
    Object.keys(le).forEach(function (e) {
      de.forEach(function (t) {
        t = t + e.charAt(0).toUpperCase() + e.substring(1), le[t] = le[e];
      });
    });
    var pe = L({
      menuitem: !0
    }, {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
    });
    function me(e, t) {
      if (t) {
        if (pe[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(n(137, e));
        if (null != t.dangerouslySetInnerHTML) {
          if (null != t.children) throw Error(n(60));
          if ("object" != typeof t.dangerouslySetInnerHTML || !("__html" in t.dangerouslySetInnerHTML)) throw Error(n(61));
        }
        if (null != t.style && "object" != typeof t.style) throw Error(n(62));
      }
    }
    function ge(e, t) {
      if (-1 === e.indexOf("-")) return "string" == typeof t.is;
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var ve = null;
    function be(e) {
      return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
    }
    var ye = null,
      we = null,
      Ae = null;
    function _e(e) {
      if (e = gi(e)) {
        if ("function" != typeof ye) throw Error(n(280));
        var t = e.stateNode;
        t && (t = bi(t), ye(e.stateNode, e.type, t));
      }
    }
    function Ee(e) {
      we ? Ae ? Ae.push(e) : Ae = [e] : we = e;
    }
    function Se() {
      if (we) {
        var e = we,
          t = Ae;
        if (Ae = we = null, _e(e), t) for (e = 0; e < t.length; e++) _e(t[e]);
      }
    }
    function ke(e, t) {
      return e(t);
    }
    function Me() {}
    var Ce = !1;
    function xe(e, t, n) {
      if (Ce) return e(t, n);
      Ce = !0;
      try {
        return ke(e, t, n);
      } finally {
        Ce = !1, (null !== we || null !== Ae) && (Me(), Se());
      }
    }
    function Re(e, t) {
      var r = e.stateNode;
      if (null === r) return null;
      var i = bi(r);
      if (null === i) return null;
      r = i[t];
      e: switch (t) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (i = !i.disabled) || (i = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !i;
          break e;
        default:
          e = !1;
      }
      if (e) return null;
      if (r && "function" != typeof r) throw Error(n(231, t, typeof r));
      return r;
    }
    var Ie = !1;
    if (s) try {
      var Te = {};
      Object.defineProperty(Te, "passive", {
        get: function () {
          Ie = !0;
        }
      }), window.addEventListener("test", Te, Te), window.removeEventListener("test", Te, Te);
    } catch (se) {
      Ie = !1;
    }
    function Pe(e, t, n, r, i, o, a, s, u) {
      var c = Array.prototype.slice.call(arguments, 3);
      try {
        t.apply(n, c);
      } catch (e) {
        this.onError(e);
      }
    }
    var Oe = !1,
      Le = null,
      Ne = !1,
      De = null,
      Be = {
        onError: function (e) {
          Oe = !0, Le = e;
        }
      };
    function je(e, t, n, r, i, o, a, s, u) {
      Oe = !1, Le = null, Pe.apply(Be, arguments);
    }
    function Fe(e) {
      var t = e,
        n = e;
      if (e.alternate) for (; t.return;) t = t.return;else {
        e = t;
        do {
          0 != (4098 & (t = e).flags) && (n = t.return), e = t.return;
        } while (e);
      }
      return 3 === t.tag ? n : null;
    }
    function ze(e) {
      if (13 === e.tag) {
        var t = e.memoizedState;
        if (null === t && null !== (e = e.alternate) && (t = e.memoizedState), null !== t) return t.dehydrated;
      }
      return null;
    }
    function Ue(e) {
      if (Fe(e) !== e) throw Error(n(188));
    }
    function qe(e) {
      return e = function (e) {
        var t = e.alternate;
        if (!t) {
          if (null === (t = Fe(e))) throw Error(n(188));
          return t !== e ? null : e;
        }
        for (var r = e, i = t;;) {
          var o = r.return;
          if (null === o) break;
          var a = o.alternate;
          if (null === a) {
            if (null !== (i = o.return)) {
              r = i;
              continue;
            }
            break;
          }
          if (o.child === a.child) {
            for (a = o.child; a;) {
              if (a === r) return Ue(o), e;
              if (a === i) return Ue(o), t;
              a = a.sibling;
            }
            throw Error(n(188));
          }
          if (r.return !== i.return) r = o, i = a;else {
            for (var s = !1, u = o.child; u;) {
              if (u === r) {
                s = !0, r = o, i = a;
                break;
              }
              if (u === i) {
                s = !0, i = o, r = a;
                break;
              }
              u = u.sibling;
            }
            if (!s) {
              for (u = a.child; u;) {
                if (u === r) {
                  s = !0, r = a, i = o;
                  break;
                }
                if (u === i) {
                  s = !0, i = a, r = o;
                  break;
                }
                u = u.sibling;
              }
              if (!s) throw Error(n(189));
            }
          }
          if (r.alternate !== i) throw Error(n(190));
        }
        if (3 !== r.tag) throw Error(n(188));
        return r.stateNode.current === r ? e : t;
      }(e), null !== e ? Ke(e) : null;
    }
    function Ke(e) {
      if (5 === e.tag || 6 === e.tag) return e;
      for (e = e.child; null !== e;) {
        var t = Ke(e);
        if (null !== t) return t;
        e = e.sibling;
      }
      return null;
    }
    var He = t.unstable_scheduleCallback,
      Ve = t.unstable_cancelCallback,
      $e = t.unstable_shouldYield,
      We = t.unstable_requestPaint,
      Ye = t.unstable_now,
      Ge = t.unstable_getCurrentPriorityLevel,
      Qe = t.unstable_ImmediatePriority,
      Ze = t.unstable_UserBlockingPriority,
      Je = t.unstable_NormalPriority,
      Xe = t.unstable_LowPriority,
      et = t.unstable_IdlePriority,
      tt = null,
      nt = null;
    var rt = Math.clz32 ? Math.clz32 : function (e) {
        return e >>>= 0, 0 === e ? 32 : 31 - (it(e) / ot | 0) | 0;
      },
      it = Math.log,
      ot = Math.LN2;
    var at = 64,
      st = 4194304;
    function ut(e) {
      switch (e & -e) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return 4194240 & e;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return 130023424 & e;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 1073741824;
        default:
          return e;
      }
    }
    function ct(e, t) {
      var n = e.pendingLanes;
      if (0 === n) return 0;
      var r = 0,
        i = e.suspendedLanes,
        o = e.pingedLanes,
        a = 268435455 & n;
      if (0 !== a) {
        var s = a & ~i;
        0 !== s ? r = ut(s) : 0 !== (o &= a) && (r = ut(o));
      } else 0 !== (a = n & ~i) ? r = ut(a) : 0 !== o && (r = ut(o));
      if (0 === r) return 0;
      if (0 !== t && t !== r && 0 == (t & i) && ((i = r & -r) >= (o = t & -t) || 16 === i && 0 != (4194240 & o))) return t;
      if (0 != (4 & r) && (r |= 16 & n), 0 !== (t = e.entangledLanes)) for (e = e.entanglements, t &= r; 0 < t;) i = 1 << (n = 31 - rt(t)), r |= e[n], t &= ~i;
      return r;
    }
    function lt(e, t) {
      switch (e) {
        case 1:
        case 2:
        case 4:
          return t + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return t + 5e3;
        default:
          return -1;
      }
    }
    function dt(e) {
      return 0 !== (e = -1073741825 & e.pendingLanes) ? e : 1073741824 & e ? 1073741824 : 0;
    }
    function ft() {
      var e = at;
      return 0 == (4194240 & (at <<= 1)) && (at = 64), e;
    }
    function ht(e) {
      for (var t = [], n = 0; 31 > n; n++) t.push(e);
      return t;
    }
    function pt(e, t, n) {
      e.pendingLanes |= t, 536870912 !== t && (e.suspendedLanes = 0, e.pingedLanes = 0), (e = e.eventTimes)[t = 31 - rt(t)] = n;
    }
    function mt(e, t) {
      var n = e.entangledLanes |= t;
      for (e = e.entanglements; n;) {
        var r = 31 - rt(n),
          i = 1 << r;
        i & t | e[r] & t && (e[r] |= t), n &= ~i;
      }
    }
    var gt = 0;
    function vt(e) {
      return 1 < (e &= -e) ? 4 < e ? 0 != (268435455 & e) ? 16 : 536870912 : 4 : 1;
    }
    var bt,
      yt,
      wt,
      At,
      _t,
      Et = !1,
      St = [],
      kt = null,
      Mt = null,
      Ct = null,
      xt = new Map(),
      Rt = new Map(),
      It = [],
      Tt = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
    function Pt(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          kt = null;
          break;
        case "dragenter":
        case "dragleave":
          Mt = null;
          break;
        case "mouseover":
        case "mouseout":
          Ct = null;
          break;
        case "pointerover":
        case "pointerout":
          xt.delete(t.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          Rt.delete(t.pointerId);
      }
    }
    function Ot(e, t, n, r, i, o) {
      return null === e || e.nativeEvent !== o ? (e = {
        blockedOn: t,
        domEventName: n,
        eventSystemFlags: r,
        nativeEvent: o,
        targetContainers: [i]
      }, null !== t && null !== (t = gi(t)) && yt(t), e) : (e.eventSystemFlags |= r, t = e.targetContainers, null !== i && -1 === t.indexOf(i) && t.push(i), e);
    }
    function Lt(e) {
      var t = mi(e.target);
      if (null !== t) {
        var n = Fe(t);
        if (null !== n) if (13 === (t = n.tag)) {
          if (null !== (t = ze(n))) return e.blockedOn = t, void _t(e.priority, function () {
            wt(n);
          });
        } else if (3 === t && n.stateNode.current.memoizedState.isDehydrated) return void (e.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
      }
      e.blockedOn = null;
    }
    function Nt(e) {
      if (null !== e.blockedOn) return !1;
      for (var t = e.targetContainers; 0 < t.length;) {
        var n = $t(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
        if (null !== n) return null !== (t = gi(n)) && yt(t), e.blockedOn = n, !1;
        var r = new (n = e.nativeEvent).constructor(n.type, n);
        ve = r, n.target.dispatchEvent(r), ve = null, t.shift();
      }
      return !0;
    }
    function Dt(e, t, n) {
      Nt(e) && n.delete(t);
    }
    function Bt() {
      Et = !1, null !== kt && Nt(kt) && (kt = null), null !== Mt && Nt(Mt) && (Mt = null), null !== Ct && Nt(Ct) && (Ct = null), xt.forEach(Dt), Rt.forEach(Dt);
    }
    function jt(e, n) {
      e.blockedOn === n && (e.blockedOn = null, Et || (Et = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, Bt)));
    }
    function Ft(e) {
      function t(t) {
        return jt(t, e);
      }
      if (0 < St.length) {
        jt(St[0], e);
        for (var n = 1; n < St.length; n++) {
          var r = St[n];
          r.blockedOn === e && (r.blockedOn = null);
        }
      }
      for (null !== kt && jt(kt, e), null !== Mt && jt(Mt, e), null !== Ct && jt(Ct, e), xt.forEach(t), Rt.forEach(t), n = 0; n < It.length; n++) (r = It[n]).blockedOn === e && (r.blockedOn = null);
      for (; 0 < It.length && null === (n = It[0]).blockedOn;) Lt(n), null === n.blockedOn && It.shift();
    }
    var zt = v.ReactCurrentBatchConfig,
      Ut = !0;
    function qt(e, t, n, r) {
      var i = gt,
        o = zt.transition;
      zt.transition = null;
      try {
        gt = 1, Ht(e, t, n, r);
      } finally {
        gt = i, zt.transition = o;
      }
    }
    function Kt(e, t, n, r) {
      var i = gt,
        o = zt.transition;
      zt.transition = null;
      try {
        gt = 4, Ht(e, t, n, r);
      } finally {
        gt = i, zt.transition = o;
      }
    }
    function Ht(e, t, n, r) {
      if (Ut) {
        var i = $t(e, t, n, r);
        if (null === i) Ur(e, t, r, Vt, n), Pt(e, r);else if (function (e, t, n, r, i) {
          switch (t) {
            case "focusin":
              return kt = Ot(kt, e, t, n, r, i), !0;
            case "dragenter":
              return Mt = Ot(Mt, e, t, n, r, i), !0;
            case "mouseover":
              return Ct = Ot(Ct, e, t, n, r, i), !0;
            case "pointerover":
              var o = i.pointerId;
              return xt.set(o, Ot(xt.get(o) || null, e, t, n, r, i)), !0;
            case "gotpointercapture":
              return o = i.pointerId, Rt.set(o, Ot(Rt.get(o) || null, e, t, n, r, i)), !0;
          }
          return !1;
        }(i, e, t, n, r)) r.stopPropagation();else if (Pt(e, r), 4 & t && -1 < Tt.indexOf(e)) {
          for (; null !== i;) {
            var o = gi(i);
            if (null !== o && bt(o), null === (o = $t(e, t, n, r)) && Ur(e, t, r, Vt, n), o === i) break;
            i = o;
          }
          null !== i && r.stopPropagation();
        } else Ur(e, t, r, null, n);
      }
    }
    var Vt = null;
    function $t(e, t, n, r) {
      if (Vt = null, null !== (e = mi(e = be(r)))) if (null === (t = Fe(e))) e = null;else if (13 === (n = t.tag)) {
        if (null !== (e = ze(t))) return e;
        e = null;
      } else if (3 === n) {
        if (t.stateNode.current.memoizedState.isDehydrated) return 3 === t.tag ? t.stateNode.containerInfo : null;
        e = null;
      } else t !== e && (e = null);
      return Vt = e, null;
    }
    function Wt(e) {
      switch (e) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return 4;
        case "message":
          switch (Ge()) {
            case Qe:
              return 1;
            case Ze:
              return 4;
            case Je:
            case Xe:
              return 16;
            case et:
              return 536870912;
            default:
              return 16;
          }
        default:
          return 16;
      }
    }
    var Yt = null,
      Gt = null,
      Qt = null;
    function Zt() {
      if (Qt) return Qt;
      var e,
        t,
        n = Gt,
        r = n.length,
        i = "value" in Yt ? Yt.value : Yt.textContent,
        o = i.length;
      for (e = 0; e < r && n[e] === i[e]; e++);
      var a = r - e;
      for (t = 1; t <= a && n[r - t] === i[o - t]; t++);
      return Qt = i.slice(e, 1 < t ? 1 - t : void 0);
    }
    function Jt(e) {
      var t = e.keyCode;
      return "charCode" in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : e = t, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
    }
    function Xt() {
      return !0;
    }
    function en() {
      return !1;
    }
    function tn(e) {
      function t(t, n, r, i, o) {
        for (var a in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = o, this.currentTarget = null, e) e.hasOwnProperty(a) && (t = e[a], this[a] = t ? t(i) : i[a]);
        return this.isDefaultPrevented = (null != i.defaultPrevented ? i.defaultPrevented : !1 === i.returnValue) ? Xt : en, this.isPropagationStopped = en, this;
      }
      return L(t.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0;
          var e = this.nativeEvent;
          e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), this.isDefaultPrevented = Xt);
        },
        stopPropagation: function () {
          var e = this.nativeEvent;
          e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), this.isPropagationStopped = Xt);
        },
        persist: function () {},
        isPersistent: Xt
      }), t;
    }
    var nn,
      rn,
      on,
      an = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function (e) {
          return e.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
      },
      sn = tn(an),
      un = L({}, an, {
        view: 0,
        detail: 0
      }),
      cn = tn(un),
      ln = L({}, un, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: _n,
        button: 0,
        buttons: 0,
        relatedTarget: function (e) {
          return void 0 === e.relatedTarget ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
        },
        movementX: function (e) {
          return "movementX" in e ? e.movementX : (e !== on && (on && "mousemove" === e.type ? (nn = e.screenX - on.screenX, rn = e.screenY - on.screenY) : rn = nn = 0, on = e), nn);
        },
        movementY: function (e) {
          return "movementY" in e ? e.movementY : rn;
        }
      }),
      dn = tn(ln),
      fn = tn(L({}, ln, {
        dataTransfer: 0
      })),
      hn = tn(L({}, un, {
        relatedTarget: 0
      })),
      pn = tn(L({}, an, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      })),
      mn = L({}, an, {
        clipboardData: function (e) {
          return "clipboardData" in e ? e.clipboardData : window.clipboardData;
        }
      }),
      gn = tn(mn),
      vn = tn(L({}, an, {
        data: 0
      })),
      bn = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
      },
      yn = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
      },
      wn = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
      };
    function An(e) {
      var t = this.nativeEvent;
      return t.getModifierState ? t.getModifierState(e) : !!(e = wn[e]) && !!t[e];
    }
    function _n() {
      return An;
    }
    var En = L({}, un, {
        key: function (e) {
          if (e.key) {
            var t = bn[e.key] || e.key;
            if ("Unidentified" !== t) return t;
          }
          return "keypress" === e.type ? 13 === (e = Jt(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? yn[e.keyCode] || "Unidentified" : "";
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: _n,
        charCode: function (e) {
          return "keypress" === e.type ? Jt(e) : 0;
        },
        keyCode: function (e) {
          return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
        },
        which: function (e) {
          return "keypress" === e.type ? Jt(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
        }
      }),
      Sn = tn(En),
      kn = tn(L({}, ln, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      })),
      Mn = tn(L({}, un, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: _n
      })),
      Cn = tn(L({}, an, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      })),
      xn = L({}, ln, {
        deltaX: function (e) {
          return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
        },
        deltaY: function (e) {
          return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
      }),
      Rn = tn(xn),
      In = [9, 13, 27, 32],
      Tn = s && "CompositionEvent" in window,
      Pn = null;
    s && "documentMode" in document && (Pn = document.documentMode);
    var On = s && "TextEvent" in window && !Pn,
      Ln = s && (!Tn || Pn && 8 < Pn && 11 >= Pn),
      Nn = String.fromCharCode(32),
      Dn = !1;
    function Bn(e, t) {
      switch (e) {
        case "keyup":
          return -1 !== In.indexOf(t.keyCode);
        case "keydown":
          return 229 !== t.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function jn(e) {
      return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
    }
    var Fn = !1;
    var zn = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Un(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return "input" === t ? !!zn[e.type] : "textarea" === t;
    }
    function qn(e, t, n, r) {
      Ee(r), 0 < (t = Kr(t, "onChange")).length && (n = new sn("onChange", "change", null, n, r), e.push({
        event: n,
        listeners: t
      }));
    }
    var Kn = null,
      Hn = null;
    function Vn(e) {
      Nr(e, 0);
    }
    function $n(e) {
      if (H(vi(e))) return e;
    }
    function Wn(e, t) {
      if ("change" === e) return t;
    }
    var Yn = !1;
    if (s) {
      var Gn;
      if (s) {
        var Qn = ("oninput" in document);
        if (!Qn) {
          var Zn = document.createElement("div");
          Zn.setAttribute("oninput", "return;"), Qn = "function" == typeof Zn.oninput;
        }
        Gn = Qn;
      } else Gn = !1;
      Yn = Gn && (!document.documentMode || 9 < document.documentMode);
    }
    function Jn() {
      Kn && (Kn.detachEvent("onpropertychange", Xn), Hn = Kn = null);
    }
    function Xn(e) {
      if ("value" === e.propertyName && $n(Hn)) {
        var t = [];
        qn(t, Hn, e, be(e)), xe(Vn, t);
      }
    }
    function er(e, t, n) {
      "focusin" === e ? (Jn(), Hn = n, (Kn = t).attachEvent("onpropertychange", Xn)) : "focusout" === e && Jn();
    }
    function tr(e) {
      if ("selectionchange" === e || "keyup" === e || "keydown" === e) return $n(Hn);
    }
    function nr(e, t) {
      if ("click" === e) return $n(t);
    }
    function rr(e, t) {
      if ("input" === e || "change" === e) return $n(t);
    }
    var ir = "function" == typeof Object.is ? Object.is : function (e, t) {
      return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
    };
    function or(e, t) {
      if (ir(e, t)) return !0;
      if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
      var n = Object.keys(e),
        r = Object.keys(t);
      if (n.length !== r.length) return !1;
      for (r = 0; r < n.length; r++) {
        var i = n[r];
        if (!u.call(t, i) || !ir(e[i], t[i])) return !1;
      }
      return !0;
    }
    function ar(e) {
      for (; e && e.firstChild;) e = e.firstChild;
      return e;
    }
    function sr(e, t) {
      var n,
        r = ar(e);
      for (e = 0; r;) {
        if (3 === r.nodeType) {
          if (n = e + r.textContent.length, e <= t && n >= t) return {
            node: r,
            offset: t - e
          };
          e = n;
        }
        e: {
          for (; r;) {
            if (r.nextSibling) {
              r = r.nextSibling;
              break e;
            }
            r = r.parentNode;
          }
          r = void 0;
        }
        r = ar(r);
      }
    }
    function ur(e, t) {
      return !(!e || !t) && (e === t || (!e || 3 !== e.nodeType) && (t && 3 === t.nodeType ? ur(e, t.parentNode) : "contains" in e ? e.contains(t) : !!e.compareDocumentPosition && !!(16 & e.compareDocumentPosition(t))));
    }
    function cr() {
      for (var e = window, t = V(); t instanceof e.HTMLIFrameElement;) {
        try {
          var n = "string" == typeof t.contentWindow.location.href;
        } catch (e) {
          n = !1;
        }
        if (!n) break;
        t = V((e = t.contentWindow).document);
      }
      return t;
    }
    function lr(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && ("input" === t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === t || "true" === e.contentEditable);
    }
    function dr(e) {
      var t = cr(),
        n = e.focusedElem,
        r = e.selectionRange;
      if (t !== n && n && n.ownerDocument && ur(n.ownerDocument.documentElement, n)) {
        if (null !== r && lr(n)) if (t = r.start, void 0 === (e = r.end) && (e = t), "selectionStart" in n) n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);else if ((e = (t = n.ownerDocument || document) && t.defaultView || window).getSelection) {
          e = e.getSelection();
          var i = n.textContent.length,
            o = Math.min(r.start, i);
          r = void 0 === r.end ? o : Math.min(r.end, i), !e.extend && o > r && (i = r, r = o, o = i), i = sr(n, o);
          var a = sr(n, r);
          i && a && (1 !== e.rangeCount || e.anchorNode !== i.node || e.anchorOffset !== i.offset || e.focusNode !== a.node || e.focusOffset !== a.offset) && ((t = t.createRange()).setStart(i.node, i.offset), e.removeAllRanges(), o > r ? (e.addRange(t), e.extend(a.node, a.offset)) : (t.setEnd(a.node, a.offset), e.addRange(t)));
        }
        for (t = [], e = n; e = e.parentNode;) 1 === e.nodeType && t.push({
          element: e,
          left: e.scrollLeft,
          top: e.scrollTop
        });
        for ("function" == typeof n.focus && n.focus(), n = 0; n < t.length; n++) (e = t[n]).element.scrollLeft = e.left, e.element.scrollTop = e.top;
      }
    }
    var fr = s && "documentMode" in document && 11 >= document.documentMode,
      hr = null,
      pr = null,
      mr = null,
      gr = !1;
    function vr(e, t, n) {
      var r = n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument;
      gr || null == hr || hr !== V(r) || ("selectionStart" in (r = hr) && lr(r) ? r = {
        start: r.selectionStart,
        end: r.selectionEnd
      } : r = {
        anchorNode: (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection()).anchorNode,
        anchorOffset: r.anchorOffset,
        focusNode: r.focusNode,
        focusOffset: r.focusOffset
      }, mr && or(mr, r) || (mr = r, 0 < (r = Kr(pr, "onSelect")).length && (t = new sn("onSelect", "select", null, t, n), e.push({
        event: t,
        listeners: r
      }), t.target = hr)));
    }
    function br(e, t) {
      var n = {};
      return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
    }
    var yr = {
        animationend: br("Animation", "AnimationEnd"),
        animationiteration: br("Animation", "AnimationIteration"),
        animationstart: br("Animation", "AnimationStart"),
        transitionend: br("Transition", "TransitionEnd")
      },
      wr = {},
      Ar = {};
    function _r(e) {
      if (wr[e]) return wr[e];
      if (!yr[e]) return e;
      var t,
        n = yr[e];
      for (t in n) if (n.hasOwnProperty(t) && t in Ar) return wr[e] = n[t];
      return e;
    }
    s && (Ar = document.createElement("div").style, "AnimationEvent" in window || (delete yr.animationend.animation, delete yr.animationiteration.animation, delete yr.animationstart.animation), "TransitionEvent" in window || delete yr.transitionend.transition);
    var Er = _r("animationend"),
      Sr = _r("animationiteration"),
      kr = _r("animationstart"),
      Mr = _r("transitionend"),
      Cr = new Map(),
      xr = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    function Rr(e, t) {
      Cr.set(e, t), o(t, [e]);
    }
    for (var Ir = 0; Ir < xr.length; Ir++) {
      var Tr = xr[Ir];
      Rr(Tr.toLowerCase(), "on" + (Tr[0].toUpperCase() + Tr.slice(1)));
    }
    Rr(Er, "onAnimationEnd"), Rr(Sr, "onAnimationIteration"), Rr(kr, "onAnimationStart"), Rr("dblclick", "onDoubleClick"), Rr("focusin", "onFocus"), Rr("focusout", "onBlur"), Rr(Mr, "onTransitionEnd"), a("onMouseEnter", ["mouseout", "mouseover"]), a("onMouseLeave", ["mouseout", "mouseover"]), a("onPointerEnter", ["pointerout", "pointerover"]), a("onPointerLeave", ["pointerout", "pointerover"]), o("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), o("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), o("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), o("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), o("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), o("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var Pr = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
      Or = new Set("cancel close invalid load scroll toggle".split(" ").concat(Pr));
    function Lr(e, t, r) {
      var i = e.type || "unknown-event";
      e.currentTarget = r, function (e, t, r, i, o, a, s, u, c) {
        if (je.apply(this, arguments), Oe) {
          if (!Oe) throw Error(n(198));
          var l = Le;
          Oe = !1, Le = null, Ne || (Ne = !0, De = l);
        }
      }(i, t, void 0, e), e.currentTarget = null;
    }
    function Nr(e, t) {
      t = 0 != (4 & t);
      for (var n = 0; n < e.length; n++) {
        var r = e[n],
          i = r.event;
        r = r.listeners;
        e: {
          var o = void 0;
          if (t) for (var a = r.length - 1; 0 <= a; a--) {
            var s = r[a],
              u = s.instance,
              c = s.currentTarget;
            if (s = s.listener, u !== o && i.isPropagationStopped()) break e;
            Lr(i, s, c), o = u;
          } else for (a = 0; a < r.length; a++) {
            if (u = (s = r[a]).instance, c = s.currentTarget, s = s.listener, u !== o && i.isPropagationStopped()) break e;
            Lr(i, s, c), o = u;
          }
        }
      }
      if (Ne) throw e = De, Ne = !1, De = null, e;
    }
    function Dr(e, t) {
      var n = t[fi];
      void 0 === n && (n = t[fi] = new Set());
      var r = e + "__bubble";
      n.has(r) || (zr(t, e, 2, !1), n.add(r));
    }
    function Br(e, t, n) {
      var r = 0;
      t && (r |= 4), zr(n, e, r, t);
    }
    var jr = "_reactListening" + Math.random().toString(36).slice(2);
    function Fr(e) {
      if (!e[jr]) {
        e[jr] = !0, r.forEach(function (t) {
          "selectionchange" !== t && (Or.has(t) || Br(t, !1, e), Br(t, !0, e));
        });
        var t = 9 === e.nodeType ? e : e.ownerDocument;
        null === t || t[jr] || (t[jr] = !0, Br("selectionchange", !1, t));
      }
    }
    function zr(e, t, n, r) {
      switch (Wt(t)) {
        case 1:
          var i = qt;
          break;
        case 4:
          i = Kt;
          break;
        default:
          i = Ht;
      }
      n = i.bind(null, t, n, e), i = void 0, !Ie || "touchstart" !== t && "touchmove" !== t && "wheel" !== t || (i = !0), r ? void 0 !== i ? e.addEventListener(t, n, {
        capture: !0,
        passive: i
      }) : e.addEventListener(t, n, !0) : void 0 !== i ? e.addEventListener(t, n, {
        passive: i
      }) : e.addEventListener(t, n, !1);
    }
    function Ur(e, t, n, r, i) {
      var o = r;
      if (0 == (1 & t) && 0 == (2 & t) && null !== r) e: for (;;) {
        if (null === r) return;
        var a = r.tag;
        if (3 === a || 4 === a) {
          var s = r.stateNode.containerInfo;
          if (s === i || 8 === s.nodeType && s.parentNode === i) break;
          if (4 === a) for (a = r.return; null !== a;) {
            var u = a.tag;
            if ((3 === u || 4 === u) && ((u = a.stateNode.containerInfo) === i || 8 === u.nodeType && u.parentNode === i)) return;
            a = a.return;
          }
          for (; null !== s;) {
            if (null === (a = mi(s))) return;
            if (5 === (u = a.tag) || 6 === u) {
              r = o = a;
              continue e;
            }
            s = s.parentNode;
          }
        }
        r = r.return;
      }
      xe(function () {
        var r = o,
          i = be(n),
          a = [];
        e: {
          var s = Cr.get(e);
          if (void 0 !== s) {
            var u = sn,
              c = e;
            switch (e) {
              case "keypress":
                if (0 === Jt(n)) break e;
              case "keydown":
              case "keyup":
                u = Sn;
                break;
              case "focusin":
                c = "focus", u = hn;
                break;
              case "focusout":
                c = "blur", u = hn;
                break;
              case "beforeblur":
              case "afterblur":
                u = hn;
                break;
              case "click":
                if (2 === n.button) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                u = dn;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                u = fn;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                u = Mn;
                break;
              case Er:
              case Sr:
              case kr:
                u = pn;
                break;
              case Mr:
                u = Cn;
                break;
              case "scroll":
                u = cn;
                break;
              case "wheel":
                u = Rn;
                break;
              case "copy":
              case "cut":
              case "paste":
                u = gn;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                u = kn;
            }
            var l = 0 != (4 & t),
              d = !l && "scroll" === e,
              f = l ? null !== s ? s + "Capture" : null : s;
            l = [];
            for (var h, p = r; null !== p;) {
              var m = (h = p).stateNode;
              if (5 === h.tag && null !== m && (h = m, null !== f && null != (m = Re(p, f)) && l.push(qr(p, m, h))), d) break;
              p = p.return;
            }
            0 < l.length && (s = new u(s, c, null, n, i), a.push({
              event: s,
              listeners: l
            }));
          }
        }
        if (0 == (7 & t)) {
          if (u = "mouseout" === e || "pointerout" === e, (!(s = "mouseover" === e || "pointerover" === e) || n === ve || !(c = n.relatedTarget || n.fromElement) || !mi(c) && !c[di]) && (u || s) && (s = i.window === i ? i : (s = i.ownerDocument) ? s.defaultView || s.parentWindow : window, u ? (u = r, null !== (c = (c = n.relatedTarget || n.toElement) ? mi(c) : null) && (c !== (d = Fe(c)) || 5 !== c.tag && 6 !== c.tag) && (c = null)) : (u = null, c = r), u !== c)) {
            if (l = dn, m = "onMouseLeave", f = "onMouseEnter", p = "mouse", "pointerout" !== e && "pointerover" !== e || (l = kn, m = "onPointerLeave", f = "onPointerEnter", p = "pointer"), d = null == u ? s : vi(u), h = null == c ? s : vi(c), (s = new l(m, p + "leave", u, n, i)).target = d, s.relatedTarget = h, m = null, mi(i) === r && ((l = new l(f, p + "enter", c, n, i)).target = h, l.relatedTarget = d, m = l), d = m, u && c) e: {
              for (f = c, p = 0, h = l = u; h; h = Hr(h)) p++;
              for (h = 0, m = f; m; m = Hr(m)) h++;
              for (; 0 < p - h;) l = Hr(l), p--;
              for (; 0 < h - p;) f = Hr(f), h--;
              for (; p--;) {
                if (l === f || null !== f && l === f.alternate) break e;
                l = Hr(l), f = Hr(f);
              }
              l = null;
            } else l = null;
            null !== u && Vr(a, s, u, l, !1), null !== c && null !== d && Vr(a, d, c, l, !0);
          }
          if ("select" === (u = (s = r ? vi(r) : window).nodeName && s.nodeName.toLowerCase()) || "input" === u && "file" === s.type) var g = Wn;else if (Un(s)) {
            if (Yn) g = rr;else {
              g = tr;
              var v = er;
            }
          } else (u = s.nodeName) && "input" === u.toLowerCase() && ("checkbox" === s.type || "radio" === s.type) && (g = nr);
          switch (g && (g = g(e, r)) ? qn(a, g, n, i) : (v && v(e, s, r), "focusout" === e && (v = s._wrapperState) && v.controlled && "number" === s.type && Z(s, "number", s.value)), v = r ? vi(r) : window, e) {
            case "focusin":
              (Un(v) || "true" === v.contentEditable) && (hr = v, pr = r, mr = null);
              break;
            case "focusout":
              mr = pr = hr = null;
              break;
            case "mousedown":
              gr = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              gr = !1, vr(a, n, i);
              break;
            case "selectionchange":
              if (fr) break;
            case "keydown":
            case "keyup":
              vr(a, n, i);
          }
          var b;
          if (Tn) e: {
            switch (e) {
              case "compositionstart":
                var y = "onCompositionStart";
                break e;
              case "compositionend":
                y = "onCompositionEnd";
                break e;
              case "compositionupdate":
                y = "onCompositionUpdate";
                break e;
            }
            y = void 0;
          } else Fn ? Bn(e, n) && (y = "onCompositionEnd") : "keydown" === e && 229 === n.keyCode && (y = "onCompositionStart");
          y && (Ln && "ko" !== n.locale && (Fn || "onCompositionStart" !== y ? "onCompositionEnd" === y && Fn && (b = Zt()) : (Gt = "value" in (Yt = i) ? Yt.value : Yt.textContent, Fn = !0)), 0 < (v = Kr(r, y)).length && (y = new vn(y, e, null, n, i), a.push({
            event: y,
            listeners: v
          }), b ? y.data = b : null !== (b = jn(n)) && (y.data = b))), (b = On ? function (e, t) {
            switch (e) {
              case "compositionend":
                return jn(t);
              case "keypress":
                return 32 !== t.which ? null : (Dn = !0, Nn);
              case "textInput":
                return (e = t.data) === Nn && Dn ? null : e;
              default:
                return null;
            }
          }(e, n) : function (e, t) {
            if (Fn) return "compositionend" === e || !Tn && Bn(e, t) ? (e = Zt(), Qt = Gt = Yt = null, Fn = !1, e) : null;
            switch (e) {
              case "paste":
              default:
                return null;
              case "keypress":
                if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                  if (t.char && 1 < t.char.length) return t.char;
                  if (t.which) return String.fromCharCode(t.which);
                }
                return null;
              case "compositionend":
                return Ln && "ko" !== t.locale ? null : t.data;
            }
          }(e, n)) && 0 < (r = Kr(r, "onBeforeInput")).length && (i = new vn("onBeforeInput", "beforeinput", null, n, i), a.push({
            event: i,
            listeners: r
          }), i.data = b);
        }
        Nr(a, t);
      });
    }
    function qr(e, t, n) {
      return {
        instance: e,
        listener: t,
        currentTarget: n
      };
    }
    function Kr(e, t) {
      for (var n = t + "Capture", r = []; null !== e;) {
        var i = e,
          o = i.stateNode;
        5 === i.tag && null !== o && (i = o, null != (o = Re(e, n)) && r.unshift(qr(e, o, i)), null != (o = Re(e, t)) && r.push(qr(e, o, i))), e = e.return;
      }
      return r;
    }
    function Hr(e) {
      if (null === e) return null;
      do {
        e = e.return;
      } while (e && 5 !== e.tag);
      return e || null;
    }
    function Vr(e, t, n, r, i) {
      for (var o = t._reactName, a = []; null !== n && n !== r;) {
        var s = n,
          u = s.alternate,
          c = s.stateNode;
        if (null !== u && u === r) break;
        5 === s.tag && null !== c && (s = c, i ? null != (u = Re(n, o)) && a.unshift(qr(n, u, s)) : i || null != (u = Re(n, o)) && a.push(qr(n, u, s))), n = n.return;
      }
      0 !== a.length && e.push({
        event: t,
        listeners: a
      });
    }
    var $r = /\r\n?/g,
      Wr = /\u0000|\uFFFD/g;
    function Yr(e) {
      return ("string" == typeof e ? e : "" + e).replace($r, "\n").replace(Wr, "");
    }
    function Gr(e, t, r) {
      if (t = Yr(t), Yr(e) !== t && r) throw Error(n(425));
    }
    function Qr() {}
    var Zr = null,
      Jr = null;
    function Xr(e, t) {
      return "textarea" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
    }
    var ei = "function" == typeof setTimeout ? setTimeout : void 0,
      ti = "function" == typeof clearTimeout ? clearTimeout : void 0,
      ni = "function" == typeof Promise ? Promise : void 0,
      ri = "function" == typeof queueMicrotask ? queueMicrotask : void 0 !== ni ? function (e) {
        return ni.resolve(null).then(e).catch(ii);
      } : ei;
    function ii(e) {
      setTimeout(function () {
        throw e;
      });
    }
    function oi(e, t) {
      var n = t,
        r = 0;
      do {
        var i = n.nextSibling;
        if (e.removeChild(n), i && 8 === i.nodeType) if ("/$" === (n = i.data)) {
          if (0 === r) return e.removeChild(i), void Ft(t);
          r--;
        } else "$" !== n && "$?" !== n && "$!" !== n || r++;
        n = i;
      } while (n);
      Ft(t);
    }
    function ai(e) {
      for (; null != e; e = e.nextSibling) {
        var t = e.nodeType;
        if (1 === t || 3 === t) break;
        if (8 === t) {
          if ("$" === (t = e.data) || "$!" === t || "$?" === t) break;
          if ("/$" === t) return null;
        }
      }
      return e;
    }
    function si(e) {
      e = e.previousSibling;
      for (var t = 0; e;) {
        if (8 === e.nodeType) {
          var n = e.data;
          if ("$" === n || "$!" === n || "$?" === n) {
            if (0 === t) return e;
            t--;
          } else "/$" === n && t++;
        }
        e = e.previousSibling;
      }
      return null;
    }
    var ui = Math.random().toString(36).slice(2),
      ci = "__reactFiber$" + ui,
      li = "__reactProps$" + ui,
      di = "__reactContainer$" + ui,
      fi = "__reactEvents$" + ui,
      hi = "__reactListeners$" + ui,
      pi = "__reactHandles$" + ui;
    function mi(e) {
      var t = e[ci];
      if (t) return t;
      for (var n = e.parentNode; n;) {
        if (t = n[di] || n[ci]) {
          if (n = t.alternate, null !== t.child || null !== n && null !== n.child) for (e = si(e); null !== e;) {
            if (n = e[ci]) return n;
            e = si(e);
          }
          return t;
        }
        n = (e = n).parentNode;
      }
      return null;
    }
    function gi(e) {
      return !(e = e[ci] || e[di]) || 5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag ? null : e;
    }
    function vi(e) {
      if (5 === e.tag || 6 === e.tag) return e.stateNode;
      throw Error(n(33));
    }
    function bi(e) {
      return e[li] || null;
    }
    var yi = [],
      wi = -1;
    function Ai(e) {
      return {
        current: e
      };
    }
    function _i(e) {
      0 > wi || (e.current = yi[wi], yi[wi] = null, wi--);
    }
    function Ei(e, t) {
      wi++, yi[wi] = e.current, e.current = t;
    }
    var Si = {},
      ki = Ai(Si),
      Mi = Ai(!1),
      Ci = Si;
    function xi(e, t) {
      var n = e.type.contextTypes;
      if (!n) return Si;
      var r = e.stateNode;
      if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
      var i,
        o = {};
      for (i in n) o[i] = t[i];
      return r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = o), o;
    }
    function Ri(e) {
      return null != (e = e.childContextTypes);
    }
    function Ii() {
      _i(Mi), _i(ki);
    }
    function Ti(e, t, r) {
      if (ki.current !== Si) throw Error(n(168));
      Ei(ki, t), Ei(Mi, r);
    }
    function Pi(e, t, r) {
      var i = e.stateNode;
      if (t = t.childContextTypes, "function" != typeof i.getChildContext) return r;
      for (var o in i = i.getChildContext()) if (!(o in t)) throw Error(n(108, z(e) || "Unknown", o));
      return L({}, r, i);
    }
    function Oi(e) {
      return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || Si, Ci = ki.current, Ei(ki, e), Ei(Mi, Mi.current), !0;
    }
    function Li(e, t, r) {
      var i = e.stateNode;
      if (!i) throw Error(n(169));
      r ? (e = Pi(e, t, Ci), i.__reactInternalMemoizedMergedChildContext = e, _i(Mi), _i(ki), Ei(ki, e)) : _i(Mi), Ei(Mi, r);
    }
    var Ni = null,
      Di = !1,
      Bi = !1;
    function ji(e) {
      null === Ni ? Ni = [e] : Ni.push(e);
    }
    function Fi() {
      if (!Bi && null !== Ni) {
        Bi = !0;
        var e = 0,
          t = gt;
        try {
          var n = Ni;
          for (gt = 1; e < n.length; e++) {
            var r = n[e];
            do {
              r = r(!0);
            } while (null !== r);
          }
          Ni = null, Di = !1;
        } catch (t) {
          throw null !== Ni && (Ni = Ni.slice(e + 1)), He(Qe, Fi), t;
        } finally {
          gt = t, Bi = !1;
        }
      }
      return null;
    }
    var zi = [],
      Ui = 0,
      qi = null,
      Ki = 0,
      Hi = [],
      Vi = 0,
      $i = null,
      Wi = 1,
      Yi = "";
    function Gi(e, t) {
      zi[Ui++] = Ki, zi[Ui++] = qi, qi = e, Ki = t;
    }
    function Qi(e, t, n) {
      Hi[Vi++] = Wi, Hi[Vi++] = Yi, Hi[Vi++] = $i, $i = e;
      var r = Wi;
      e = Yi;
      var i = 32 - rt(r) - 1;
      r &= ~(1 << i), n += 1;
      var o = 32 - rt(t) + i;
      if (30 < o) {
        var a = i - i % 5;
        o = (r & (1 << a) - 1).toString(32), r >>= a, i -= a, Wi = 1 << 32 - rt(t) + i | n << i | r, Yi = o + e;
      } else Wi = 1 << o | n << i | r, Yi = e;
    }
    function Zi(e) {
      null !== e.return && (Gi(e, 1), Qi(e, 1, 0));
    }
    function Ji(e) {
      for (; e === qi;) qi = zi[--Ui], zi[Ui] = null, Ki = zi[--Ui], zi[Ui] = null;
      for (; e === $i;) $i = Hi[--Vi], Hi[Vi] = null, Yi = Hi[--Vi], Hi[Vi] = null, Wi = Hi[--Vi], Hi[Vi] = null;
    }
    var Xi = null,
      eo = null,
      to = !1,
      no = null;
    function ro(e, t) {
      var n = Rc(5, null, null, 0);
      n.elementType = "DELETED", n.stateNode = t, n.return = e, null === (t = e.deletions) ? (e.deletions = [n], e.flags |= 16) : t.push(n);
    }
    function io(e, t) {
      switch (e.tag) {
        case 5:
          var n = e.type;
          return null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e.stateNode = t, Xi = e, eo = ai(t.firstChild), !0);
        case 6:
          return null !== (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) && (e.stateNode = t, Xi = e, eo = null, !0);
        case 13:
          return null !== (t = 8 !== t.nodeType ? null : t) && (n = null !== $i ? {
            id: Wi,
            overflow: Yi
          } : null, e.memoizedState = {
            dehydrated: t,
            treeContext: n,
            retryLane: 1073741824
          }, (n = Rc(18, null, null, 0)).stateNode = t, n.return = e, e.child = n, Xi = e, eo = null, !0);
        default:
          return !1;
      }
    }
    function oo(e) {
      return 0 != (1 & e.mode) && 0 == (128 & e.flags);
    }
    function ao(e) {
      if (to) {
        var t = eo;
        if (t) {
          var r = t;
          if (!io(e, t)) {
            if (oo(e)) throw Error(n(418));
            t = ai(r.nextSibling);
            var i = Xi;
            t && io(e, t) ? ro(i, r) : (e.flags = -4097 & e.flags | 2, to = !1, Xi = e);
          }
        } else {
          if (oo(e)) throw Error(n(418));
          e.flags = -4097 & e.flags | 2, to = !1, Xi = e;
        }
      }
    }
    function so(e) {
      for (e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;) e = e.return;
      Xi = e;
    }
    function uo(e) {
      if (e !== Xi) return !1;
      if (!to) return so(e), to = !0, !1;
      var t;
      if ((t = 3 !== e.tag) && !(t = 5 !== e.tag) && (t = "head" !== (t = e.type) && "body" !== t && !Xr(e.type, e.memoizedProps)), t && (t = eo)) {
        if (oo(e)) throw co(), Error(n(418));
        for (; t;) ro(e, t), t = ai(t.nextSibling);
      }
      if (so(e), 13 === e.tag) {
        if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(n(317));
        e: {
          for (e = e.nextSibling, t = 0; e;) {
            if (8 === e.nodeType) {
              var r = e.data;
              if ("/$" === r) {
                if (0 === t) {
                  eo = ai(e.nextSibling);
                  break e;
                }
                t--;
              } else "$" !== r && "$!" !== r && "$?" !== r || t++;
            }
            e = e.nextSibling;
          }
          eo = null;
        }
      } else eo = Xi ? ai(e.stateNode.nextSibling) : null;
      return !0;
    }
    function co() {
      for (var e = eo; e;) e = ai(e.nextSibling);
    }
    function lo() {
      eo = Xi = null, to = !1;
    }
    function fo(e) {
      null === no ? no = [e] : no.push(e);
    }
    var ho = v.ReactCurrentBatchConfig;
    function po(e, t) {
      if (e && e.defaultProps) {
        for (var n in t = L({}, t), e = e.defaultProps) void 0 === t[n] && (t[n] = e[n]);
        return t;
      }
      return t;
    }
    var mo = Ai(null),
      go = null,
      vo = null,
      bo = null;
    function yo() {
      bo = vo = go = null;
    }
    function wo(e) {
      var t = mo.current;
      _i(mo), e._currentValue = t;
    }
    function Ao(e, t, n) {
      for (; null !== e;) {
        var r = e.alternate;
        if ((e.childLanes & t) !== t ? (e.childLanes |= t, null !== r && (r.childLanes |= t)) : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
        e = e.return;
      }
    }
    function _o(e, t) {
      go = e, bo = vo = null, null !== (e = e.dependencies) && null !== e.firstContext && (0 != (e.lanes & t) && (vs = !0), e.firstContext = null);
    }
    function Eo(e) {
      var t = e._currentValue;
      if (bo !== e) if (e = {
        context: e,
        memoizedValue: t,
        next: null
      }, null === vo) {
        if (null === go) throw Error(n(308));
        vo = e, go.dependencies = {
          lanes: 0,
          firstContext: e
        };
      } else vo = vo.next = e;
      return t;
    }
    var So = null;
    function ko(e) {
      null === So ? So = [e] : So.push(e);
    }
    function Mo(e, t, n, r) {
      var i = t.interleaved;
      return null === i ? (n.next = n, ko(t)) : (n.next = i.next, i.next = n), t.interleaved = n, Co(e, r);
    }
    function Co(e, t) {
      e.lanes |= t;
      var n = e.alternate;
      for (null !== n && (n.lanes |= t), n = e, e = e.return; null !== e;) e.childLanes |= t, null !== (n = e.alternate) && (n.childLanes |= t), n = e, e = e.return;
      return 3 === n.tag ? n.stateNode : null;
    }
    var xo = !1;
    function Ro(e) {
      e.updateQueue = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: 0
        },
        effects: null
      };
    }
    function Io(e, t) {
      e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        effects: e.effects
      });
    }
    function To(e, t) {
      return {
        eventTime: e,
        lane: t,
        tag: 0,
        payload: null,
        callback: null,
        next: null
      };
    }
    function Po(e, t, n) {
      var r = e.updateQueue;
      if (null === r) return null;
      if (r = r.shared, 0 != (2 & Mu)) {
        var i = r.pending;
        return null === i ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, Co(e, n);
      }
      return null === (i = r.interleaved) ? (t.next = t, ko(r)) : (t.next = i.next, i.next = t), r.interleaved = t, Co(e, n);
    }
    function Oo(e, t, n) {
      if (null !== (t = t.updateQueue) && (t = t.shared, 0 != (4194240 & n))) {
        var r = t.lanes;
        n |= r &= e.pendingLanes, t.lanes = n, mt(e, n);
      }
    }
    function Lo(e, t) {
      var n = e.updateQueue,
        r = e.alternate;
      if (null !== r && n === (r = r.updateQueue)) {
        var i = null,
          o = null;
        if (null !== (n = n.firstBaseUpdate)) {
          do {
            var a = {
              eventTime: n.eventTime,
              lane: n.lane,
              tag: n.tag,
              payload: n.payload,
              callback: n.callback,
              next: null
            };
            null === o ? i = o = a : o = o.next = a, n = n.next;
          } while (null !== n);
          null === o ? i = o = t : o = o.next = t;
        } else i = o = t;
        return n = {
          baseState: r.baseState,
          firstBaseUpdate: i,
          lastBaseUpdate: o,
          shared: r.shared,
          effects: r.effects
        }, void (e.updateQueue = n);
      }
      null === (e = n.lastBaseUpdate) ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
    }
    function No(e, t, n, r) {
      var i = e.updateQueue;
      xo = !1;
      var o = i.firstBaseUpdate,
        a = i.lastBaseUpdate,
        s = i.shared.pending;
      if (null !== s) {
        i.shared.pending = null;
        var u = s,
          c = u.next;
        u.next = null, null === a ? o = c : a.next = c, a = u;
        var l = e.alternate;
        null !== l && (s = (l = l.updateQueue).lastBaseUpdate) !== a && (null === s ? l.firstBaseUpdate = c : s.next = c, l.lastBaseUpdate = u);
      }
      if (null !== o) {
        var d = i.baseState;
        for (a = 0, l = c = u = null, s = o;;) {
          var f = s.lane,
            h = s.eventTime;
          if ((r & f) === f) {
            null !== l && (l = l.next = {
              eventTime: h,
              lane: 0,
              tag: s.tag,
              payload: s.payload,
              callback: s.callback,
              next: null
            });
            e: {
              var p = e,
                m = s;
              switch (f = t, h = n, m.tag) {
                case 1:
                  if ("function" == typeof (p = m.payload)) {
                    d = p.call(h, d, f);
                    break e;
                  }
                  d = p;
                  break e;
                case 3:
                  p.flags = -65537 & p.flags | 128;
                case 0:
                  if (null == (f = "function" == typeof (p = m.payload) ? p.call(h, d, f) : p)) break e;
                  d = L({}, d, f);
                  break e;
                case 2:
                  xo = !0;
              }
            }
            null !== s.callback && 0 !== s.lane && (e.flags |= 64, null === (f = i.effects) ? i.effects = [s] : f.push(s));
          } else h = {
            eventTime: h,
            lane: f,
            tag: s.tag,
            payload: s.payload,
            callback: s.callback,
            next: null
          }, null === l ? (c = l = h, u = d) : l = l.next = h, a |= f;
          if (null === (s = s.next)) {
            if (null === (s = i.shared.pending)) break;
            s = (f = s).next, f.next = null, i.lastBaseUpdate = f, i.shared.pending = null;
          }
        }
        if (null === l && (u = d), i.baseState = u, i.firstBaseUpdate = c, i.lastBaseUpdate = l, null !== (t = i.shared.interleaved)) {
          i = t;
          do {
            a |= i.lane, i = i.next;
          } while (i !== t);
        } else null === o && (i.shared.lanes = 0);
        Lu |= a, e.lanes = a, e.memoizedState = d;
      }
    }
    function Do(e, t, r) {
      if (e = t.effects, t.effects = null, null !== e) for (t = 0; t < e.length; t++) {
        var i = e[t],
          o = i.callback;
        if (null !== o) {
          if (i.callback = null, i = r, "function" != typeof o) throw Error(n(191, o));
          o.call(i);
        }
      }
    }
    var Bo = new e.Component().refs;
    function jo(e, t, n, r) {
      n = null == (n = n(r, t = e.memoizedState)) ? t : L({}, t, n), e.memoizedState = n, 0 === e.lanes && (e.updateQueue.baseState = n);
    }
    var Fo = {
      isMounted: function (e) {
        return !!(e = e._reactInternals) && Fe(e) === e;
      },
      enqueueSetState: function (e, t, n) {
        e = e._reactInternals;
        var r = Ju(),
          i = Xu(e),
          o = To(r, i);
        o.payload = t, null != n && (o.callback = n), null !== (t = Po(e, o, i)) && (ec(t, e, i, r), Oo(t, e, i));
      },
      enqueueReplaceState: function (e, t, n) {
        e = e._reactInternals;
        var r = Ju(),
          i = Xu(e),
          o = To(r, i);
        o.tag = 1, o.payload = t, null != n && (o.callback = n), null !== (t = Po(e, o, i)) && (ec(t, e, i, r), Oo(t, e, i));
      },
      enqueueForceUpdate: function (e, t) {
        e = e._reactInternals;
        var n = Ju(),
          r = Xu(e),
          i = To(n, r);
        i.tag = 2, null != t && (i.callback = t), null !== (t = Po(e, i, r)) && (ec(t, e, r, n), Oo(t, e, r));
      }
    };
    function zo(e, t, n, r, i, o, a) {
      return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(r, o, a) : !t.prototype || !t.prototype.isPureReactComponent || !or(n, r) || !or(i, o);
    }
    function Uo(e, t, n) {
      var r = !1,
        i = Si,
        o = t.contextType;
      return "object" == typeof o && null !== o ? o = Eo(o) : (i = Ri(t) ? Ci : ki.current, o = (r = null != (r = t.contextTypes)) ? xi(e, i) : Si), t = new t(n, o), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = Fo, e.stateNode = t, t._reactInternals = e, r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = i, e.__reactInternalMemoizedMaskedChildContext = o), t;
    }
    function qo(e, t, n, r) {
      e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Fo.enqueueReplaceState(t, t.state, null);
    }
    function Ko(e, t, n, r) {
      var i = e.stateNode;
      i.props = n, i.state = e.memoizedState, i.refs = Bo, Ro(e);
      var o = t.contextType;
      "object" == typeof o && null !== o ? i.context = Eo(o) : (o = Ri(t) ? Ci : ki.current, i.context = xi(e, o)), i.state = e.memoizedState, "function" == typeof (o = t.getDerivedStateFromProps) && (jo(e, t, o, n), i.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof i.getSnapshotBeforeUpdate || "function" != typeof i.UNSAFE_componentWillMount && "function" != typeof i.componentWillMount || (t = i.state, "function" == typeof i.componentWillMount && i.componentWillMount(), "function" == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount(), t !== i.state && Fo.enqueueReplaceState(i, i.state, null), No(e, n, i, r), i.state = e.memoizedState), "function" == typeof i.componentDidMount && (e.flags |= 4194308);
    }
    function Ho(e, t, r) {
      if (null !== (e = r.ref) && "function" != typeof e && "object" != typeof e) {
        if (r._owner) {
          if (r = r._owner) {
            if (1 !== r.tag) throw Error(n(309));
            var i = r.stateNode;
          }
          if (!i) throw Error(n(147, e));
          var o = i,
            a = "" + e;
          return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === a ? t.ref : (t = function (e) {
            var t = o.refs;
            t === Bo && (t = o.refs = {}), null === e ? delete t[a] : t[a] = e;
          }, t._stringRef = a, t);
        }
        if ("string" != typeof e) throw Error(n(284));
        if (!r._owner) throw Error(n(290, e));
      }
      return e;
    }
    function Vo(e, t) {
      throw e = Object.prototype.toString.call(t), Error(n(31, "[object Object]" === e ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
    }
    function $o(e) {
      return (0, e._init)(e._payload);
    }
    function Wo(e) {
      function t(t, n) {
        if (e) {
          var r = t.deletions;
          null === r ? (t.deletions = [n], t.flags |= 16) : r.push(n);
        }
      }
      function r(n, r) {
        if (!e) return null;
        for (; null !== r;) t(n, r), r = r.sibling;
        return null;
      }
      function i(e, t) {
        for (e = new Map(); null !== t;) null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;
        return e;
      }
      function o(e, t) {
        return (e = Tc(e, t)).index = 0, e.sibling = null, e;
      }
      function a(t, n, r) {
        return t.index = r, e ? null !== (r = t.alternate) ? (r = r.index) < n ? (t.flags |= 2, n) : r : (t.flags |= 2, n) : (t.flags |= 1048576, n);
      }
      function s(t) {
        return e && null === t.alternate && (t.flags |= 2), t;
      }
      function u(e, t, n, r) {
        return null === t || 6 !== t.tag ? ((t = Nc(n, e.mode, r)).return = e, t) : ((t = o(t, n)).return = e, t);
      }
      function c(e, t, n, r) {
        var i = n.type;
        return i === w ? d(e, t, n.props.children, r, n.key) : null !== t && (t.elementType === i || "object" == typeof i && null !== i && i.$$typeof === R && $o(i) === t.type) ? ((r = o(t, n.props)).ref = Ho(e, t, n), r.return = e, r) : ((r = Pc(n.type, n.key, n.props, null, e.mode, r)).ref = Ho(e, t, n), r.return = e, r);
      }
      function l(e, t, n, r) {
        return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = Dc(n, e.mode, r)).return = e, t) : ((t = o(t, n.children || [])).return = e, t);
      }
      function d(e, t, n, r, i) {
        return null === t || 7 !== t.tag ? ((t = Oc(n, e.mode, r, i)).return = e, t) : ((t = o(t, n)).return = e, t);
      }
      function f(e, t, n) {
        if ("string" == typeof t && "" !== t || "number" == typeof t) return (t = Nc("" + t, e.mode, n)).return = e, t;
        if ("object" == typeof t && null !== t) {
          switch (t.$$typeof) {
            case b:
              return (n = Pc(t.type, t.key, t.props, null, e.mode, n)).ref = Ho(e, null, t), n.return = e, n;
            case y:
              return (t = Dc(t, e.mode, n)).return = e, t;
            case R:
              return f(e, (0, t._init)(t._payload), n);
          }
          if (J(t) || P(t)) return (t = Oc(t, e.mode, n, null)).return = e, t;
          Vo(e, t);
        }
        return null;
      }
      function h(e, t, n, r) {
        var i = null !== t ? t.key : null;
        if ("string" == typeof n && "" !== n || "number" == typeof n) return null !== i ? null : u(e, t, "" + n, r);
        if ("object" == typeof n && null !== n) {
          switch (n.$$typeof) {
            case b:
              return n.key === i ? c(e, t, n, r) : null;
            case y:
              return n.key === i ? l(e, t, n, r) : null;
            case R:
              return h(e, t, (i = n._init)(n._payload), r);
          }
          if (J(n) || P(n)) return null !== i ? null : d(e, t, n, r, null);
          Vo(e, n);
        }
        return null;
      }
      function p(e, t, n, r, i) {
        if ("string" == typeof r && "" !== r || "number" == typeof r) return u(t, e = e.get(n) || null, "" + r, i);
        if ("object" == typeof r && null !== r) {
          switch (r.$$typeof) {
            case b:
              return c(t, e = e.get(null === r.key ? n : r.key) || null, r, i);
            case y:
              return l(t, e = e.get(null === r.key ? n : r.key) || null, r, i);
            case R:
              return p(e, t, n, (0, r._init)(r._payload), i);
          }
          if (J(r) || P(r)) return d(t, e = e.get(n) || null, r, i, null);
          Vo(t, r);
        }
        return null;
      }
      function m(n, o, s, u) {
        for (var c = null, l = null, d = o, m = o = 0, g = null; null !== d && m < s.length; m++) {
          d.index > m ? (g = d, d = null) : g = d.sibling;
          var v = h(n, d, s[m], u);
          if (null === v) {
            null === d && (d = g);
            break;
          }
          e && d && null === v.alternate && t(n, d), o = a(v, o, m), null === l ? c = v : l.sibling = v, l = v, d = g;
        }
        if (m === s.length) return r(n, d), to && Gi(n, m), c;
        if (null === d) {
          for (; m < s.length; m++) null !== (d = f(n, s[m], u)) && (o = a(d, o, m), null === l ? c = d : l.sibling = d, l = d);
          return to && Gi(n, m), c;
        }
        for (d = i(n, d); m < s.length; m++) null !== (g = p(d, n, m, s[m], u)) && (e && null !== g.alternate && d.delete(null === g.key ? m : g.key), o = a(g, o, m), null === l ? c = g : l.sibling = g, l = g);
        return e && d.forEach(function (e) {
          return t(n, e);
        }), to && Gi(n, m), c;
      }
      function g(o, s, u, c) {
        var l = P(u);
        if ("function" != typeof l) throw Error(n(150));
        if (null == (u = l.call(u))) throw Error(n(151));
        for (var d = l = null, m = s, g = s = 0, v = null, b = u.next(); null !== m && !b.done; g++, b = u.next()) {
          m.index > g ? (v = m, m = null) : v = m.sibling;
          var y = h(o, m, b.value, c);
          if (null === y) {
            null === m && (m = v);
            break;
          }
          e && m && null === y.alternate && t(o, m), s = a(y, s, g), null === d ? l = y : d.sibling = y, d = y, m = v;
        }
        if (b.done) return r(o, m), to && Gi(o, g), l;
        if (null === m) {
          for (; !b.done; g++, b = u.next()) null !== (b = f(o, b.value, c)) && (s = a(b, s, g), null === d ? l = b : d.sibling = b, d = b);
          return to && Gi(o, g), l;
        }
        for (m = i(o, m); !b.done; g++, b = u.next()) null !== (b = p(m, o, g, b.value, c)) && (e && null !== b.alternate && m.delete(null === b.key ? g : b.key), s = a(b, s, g), null === d ? l = b : d.sibling = b, d = b);
        return e && m.forEach(function (e) {
          return t(o, e);
        }), to && Gi(o, g), l;
      }
      return function e(n, i, a, u) {
        if ("object" == typeof a && null !== a && a.type === w && null === a.key && (a = a.props.children), "object" == typeof a && null !== a) {
          switch (a.$$typeof) {
            case b:
              e: {
                for (var c = a.key, l = i; null !== l;) {
                  if (l.key === c) {
                    if ((c = a.type) === w) {
                      if (7 === l.tag) {
                        r(n, l.sibling), (i = o(l, a.props.children)).return = n, n = i;
                        break e;
                      }
                    } else if (l.elementType === c || "object" == typeof c && null !== c && c.$$typeof === R && $o(c) === l.type) {
                      r(n, l.sibling), (i = o(l, a.props)).ref = Ho(n, l, a), i.return = n, n = i;
                      break e;
                    }
                    r(n, l);
                    break;
                  }
                  t(n, l), l = l.sibling;
                }
                a.type === w ? ((i = Oc(a.props.children, n.mode, u, a.key)).return = n, n = i) : ((u = Pc(a.type, a.key, a.props, null, n.mode, u)).ref = Ho(n, i, a), u.return = n, n = u);
              }
              return s(n);
            case y:
              e: {
                for (l = a.key; null !== i;) {
                  if (i.key === l) {
                    if (4 === i.tag && i.stateNode.containerInfo === a.containerInfo && i.stateNode.implementation === a.implementation) {
                      r(n, i.sibling), (i = o(i, a.children || [])).return = n, n = i;
                      break e;
                    }
                    r(n, i);
                    break;
                  }
                  t(n, i), i = i.sibling;
                }
                (i = Dc(a, n.mode, u)).return = n, n = i;
              }
              return s(n);
            case R:
              return e(n, i, (l = a._init)(a._payload), u);
          }
          if (J(a)) return m(n, i, a, u);
          if (P(a)) return g(n, i, a, u);
          Vo(n, a);
        }
        return "string" == typeof a && "" !== a || "number" == typeof a ? (a = "" + a, null !== i && 6 === i.tag ? (r(n, i.sibling), (i = o(i, a)).return = n, n = i) : (r(n, i), (i = Nc(a, n.mode, u)).return = n, n = i), s(n)) : r(n, i);
      };
    }
    var Yo = Wo(!0),
      Go = Wo(!1),
      Qo = {},
      Zo = Ai(Qo),
      Jo = Ai(Qo),
      Xo = Ai(Qo);
    function ea(e) {
      if (e === Qo) throw Error(n(174));
      return e;
    }
    function ta(e, t) {
      switch (Ei(Xo, t), Ei(Jo, e), Ei(Zo, Qo), e = t.nodeType) {
        case 9:
        case 11:
          t = (t = t.documentElement) ? t.namespaceURI : oe(null, "");
          break;
        default:
          t = oe(t = (e = 8 === e ? t.parentNode : t).namespaceURI || null, e = e.tagName);
      }
      _i(Zo), Ei(Zo, t);
    }
    function na() {
      _i(Zo), _i(Jo), _i(Xo);
    }
    function ra(e) {
      ea(Xo.current);
      var t = ea(Zo.current),
        n = oe(t, e.type);
      t !== n && (Ei(Jo, e), Ei(Zo, n));
    }
    function ia(e) {
      Jo.current === e && (_i(Zo), _i(Jo));
    }
    var oa = Ai(0);
    function aa(e) {
      for (var t = e; null !== t;) {
        if (13 === t.tag) {
          var n = t.memoizedState;
          if (null !== n && (null === (n = n.dehydrated) || "$?" === n.data || "$!" === n.data)) return t;
        } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
          if (0 != (128 & t.flags)) return t;
        } else if (null !== t.child) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break;
        for (; null === t.sibling;) {
          if (null === t.return || t.return === e) return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    var sa = [];
    function ua() {
      for (var e = 0; e < sa.length; e++) sa[e]._workInProgressVersionPrimary = null;
      sa.length = 0;
    }
    var ca = v.ReactCurrentDispatcher,
      la = v.ReactCurrentBatchConfig,
      da = 0,
      fa = null,
      ha = null,
      pa = null,
      ma = !1,
      ga = !1,
      va = 0,
      ba = 0;
    function ya() {
      throw Error(n(321));
    }
    function wa(e, t) {
      if (null === t) return !1;
      for (var n = 0; n < t.length && n < e.length; n++) if (!ir(e[n], t[n])) return !1;
      return !0;
    }
    function Aa(e, t, r, i, o, a) {
      if (da = a, fa = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, ca.current = null === e || null === e.memoizedState ? is : os, e = r(i, o), ga) {
        a = 0;
        do {
          if (ga = !1, va = 0, 25 <= a) throw Error(n(301));
          a += 1, pa = ha = null, t.updateQueue = null, ca.current = as, e = r(i, o);
        } while (ga);
      }
      if (ca.current = rs, t = null !== ha && null !== ha.next, da = 0, pa = ha = fa = null, ma = !1, t) throw Error(n(300));
      return e;
    }
    function _a() {
      var e = 0 !== va;
      return va = 0, e;
    }
    function Ea() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return null === pa ? fa.memoizedState = pa = e : pa = pa.next = e, pa;
    }
    function Sa() {
      if (null === ha) {
        var e = fa.alternate;
        e = null !== e ? e.memoizedState : null;
      } else e = ha.next;
      var t = null === pa ? fa.memoizedState : pa.next;
      if (null !== t) pa = t, ha = e;else {
        if (null === e) throw Error(n(310));
        e = {
          memoizedState: (ha = e).memoizedState,
          baseState: ha.baseState,
          baseQueue: ha.baseQueue,
          queue: ha.queue,
          next: null
        }, null === pa ? fa.memoizedState = pa = e : pa = pa.next = e;
      }
      return pa;
    }
    function ka(e, t) {
      return "function" == typeof t ? t(e) : t;
    }
    function Ma(e) {
      var t = Sa(),
        r = t.queue;
      if (null === r) throw Error(n(311));
      r.lastRenderedReducer = e;
      var i = ha,
        o = i.baseQueue,
        a = r.pending;
      if (null !== a) {
        if (null !== o) {
          var s = o.next;
          o.next = a.next, a.next = s;
        }
        i.baseQueue = o = a, r.pending = null;
      }
      if (null !== o) {
        a = o.next, i = i.baseState;
        var u = s = null,
          c = null,
          l = a;
        do {
          var d = l.lane;
          if ((da & d) === d) null !== c && (c = c.next = {
            lane: 0,
            action: l.action,
            hasEagerState: l.hasEagerState,
            eagerState: l.eagerState,
            next: null
          }), i = l.hasEagerState ? l.eagerState : e(i, l.action);else {
            var f = {
              lane: d,
              action: l.action,
              hasEagerState: l.hasEagerState,
              eagerState: l.eagerState,
              next: null
            };
            null === c ? (u = c = f, s = i) : c = c.next = f, fa.lanes |= d, Lu |= d;
          }
          l = l.next;
        } while (null !== l && l !== a);
        null === c ? s = i : c.next = u, ir(i, t.memoizedState) || (vs = !0), t.memoizedState = i, t.baseState = s, t.baseQueue = c, r.lastRenderedState = i;
      }
      if (null !== (e = r.interleaved)) {
        o = e;
        do {
          a = o.lane, fa.lanes |= a, Lu |= a, o = o.next;
        } while (o !== e);
      } else null === o && (r.lanes = 0);
      return [t.memoizedState, r.dispatch];
    }
    function Ca(e) {
      var t = Sa(),
        r = t.queue;
      if (null === r) throw Error(n(311));
      r.lastRenderedReducer = e;
      var i = r.dispatch,
        o = r.pending,
        a = t.memoizedState;
      if (null !== o) {
        r.pending = null;
        var s = o = o.next;
        do {
          a = e(a, s.action), s = s.next;
        } while (s !== o);
        ir(a, t.memoizedState) || (vs = !0), t.memoizedState = a, null === t.baseQueue && (t.baseState = a), r.lastRenderedState = a;
      }
      return [a, i];
    }
    function xa() {}
    function Ra(e, t) {
      var r = fa,
        i = Sa(),
        o = t(),
        a = !ir(i.memoizedState, o);
      if (a && (i.memoizedState = o, vs = !0), i = i.queue, Ua(Pa.bind(null, r, i, e), [e]), i.getSnapshot !== t || a || null !== pa && 1 & pa.memoizedState.tag) {
        if (r.flags |= 2048, Da(9, Ta.bind(null, r, i, o, t), void 0, null), null === Cu) throw Error(n(349));
        0 != (30 & da) || Ia(r, t, o);
      }
      return o;
    }
    function Ia(e, t, n) {
      e.flags |= 16384, e = {
        getSnapshot: t,
        value: n
      }, null === (t = fa.updateQueue) ? (t = {
        lastEffect: null,
        stores: null
      }, fa.updateQueue = t, t.stores = [e]) : null === (n = t.stores) ? t.stores = [e] : n.push(e);
    }
    function Ta(e, t, n, r) {
      t.value = n, t.getSnapshot = r, Oa(t) && La(e);
    }
    function Pa(e, t, n) {
      return n(function () {
        Oa(t) && La(e);
      });
    }
    function Oa(e) {
      var t = e.getSnapshot;
      e = e.value;
      try {
        var n = t();
        return !ir(e, n);
      } catch (e) {
        return !0;
      }
    }
    function La(e) {
      var t = Co(e, 1);
      null !== t && ec(t, e, 1, -1);
    }
    function Na(e) {
      var t = Ea();
      return "function" == typeof e && (e = e()), t.memoizedState = t.baseState = e, e = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ka,
        lastRenderedState: e
      }, t.queue = e, e = e.dispatch = Xa.bind(null, fa, e), [t.memoizedState, e];
    }
    function Da(e, t, n, r) {
      return e = {
        tag: e,
        create: t,
        destroy: n,
        deps: r,
        next: null
      }, null === (t = fa.updateQueue) ? (t = {
        lastEffect: null,
        stores: null
      }, fa.updateQueue = t, t.lastEffect = e.next = e) : null === (n = t.lastEffect) ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
    }
    function Ba() {
      return Sa().memoizedState;
    }
    function ja(e, t, n, r) {
      var i = Ea();
      fa.flags |= e, i.memoizedState = Da(1 | t, n, void 0, void 0 === r ? null : r);
    }
    function Fa(e, t, n, r) {
      var i = Sa();
      r = void 0 === r ? null : r;
      var o = void 0;
      if (null !== ha) {
        var a = ha.memoizedState;
        if (o = a.destroy, null !== r && wa(r, a.deps)) return void (i.memoizedState = Da(t, n, o, r));
      }
      fa.flags |= e, i.memoizedState = Da(1 | t, n, o, r);
    }
    function za(e, t) {
      return ja(8390656, 8, e, t);
    }
    function Ua(e, t) {
      return Fa(2048, 8, e, t);
    }
    function qa(e, t) {
      return Fa(4, 2, e, t);
    }
    function Ka(e, t) {
      return Fa(4, 4, e, t);
    }
    function Ha(e, t) {
      return "function" == typeof t ? (e = e(), t(e), function () {
        t(null);
      }) : null != t ? (e = e(), t.current = e, function () {
        t.current = null;
      }) : void 0;
    }
    function Va(e, t, n) {
      return n = null != n ? n.concat([e]) : null, Fa(4, 4, Ha.bind(null, t, e), n);
    }
    function $a() {}
    function Wa(e, t) {
      var n = Sa();
      t = void 0 === t ? null : t;
      var r = n.memoizedState;
      return null !== r && null !== t && wa(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
    }
    function Ya(e, t) {
      var n = Sa();
      t = void 0 === t ? null : t;
      var r = n.memoizedState;
      return null !== r && null !== t && wa(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
    }
    function Ga(e, t, n) {
      return 0 == (21 & da) ? (e.baseState && (e.baseState = !1, vs = !0), e.memoizedState = n) : (ir(n, t) || (n = ft(), fa.lanes |= n, Lu |= n, e.baseState = !0), t);
    }
    function Qa(e, t) {
      var n = gt;
      gt = 0 !== n && 4 > n ? n : 4, e(!0);
      var r = la.transition;
      la.transition = {};
      try {
        e(!1), t();
      } finally {
        gt = n, la.transition = r;
      }
    }
    function Za() {
      return Sa().memoizedState;
    }
    function Ja(e, t, n) {
      var r = Xu(e);
      if (n = {
        lane: r,
        action: n,
        hasEagerState: !1,
        eagerState: null,
        next: null
      }, es(e)) ts(t, n);else if (null !== (n = Mo(e, t, n, r))) {
        ec(n, e, r, Ju()), ns(n, t, r);
      }
    }
    function Xa(e, t, n) {
      var r = Xu(e),
        i = {
          lane: r,
          action: n,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
      if (es(e)) ts(t, i);else {
        var o = e.alternate;
        if (0 === e.lanes && (null === o || 0 === o.lanes) && null !== (o = t.lastRenderedReducer)) try {
          var a = t.lastRenderedState,
            s = o(a, n);
          if (i.hasEagerState = !0, i.eagerState = s, ir(s, a)) {
            var u = t.interleaved;
            return null === u ? (i.next = i, ko(t)) : (i.next = u.next, u.next = i), void (t.interleaved = i);
          }
        } catch (e) {}
        null !== (n = Mo(e, t, i, r)) && (ec(n, e, r, i = Ju()), ns(n, t, r));
      }
    }
    function es(e) {
      var t = e.alternate;
      return e === fa || null !== t && t === fa;
    }
    function ts(e, t) {
      ga = ma = !0;
      var n = e.pending;
      null === n ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
    }
    function ns(e, t, n) {
      if (0 != (4194240 & n)) {
        var r = t.lanes;
        n |= r &= e.pendingLanes, t.lanes = n, mt(e, n);
      }
    }
    var rs = {
        readContext: Eo,
        useCallback: ya,
        useContext: ya,
        useEffect: ya,
        useImperativeHandle: ya,
        useInsertionEffect: ya,
        useLayoutEffect: ya,
        useMemo: ya,
        useReducer: ya,
        useRef: ya,
        useState: ya,
        useDebugValue: ya,
        useDeferredValue: ya,
        useTransition: ya,
        useMutableSource: ya,
        useSyncExternalStore: ya,
        useId: ya,
        unstable_isNewReconciler: !1
      },
      is = {
        readContext: Eo,
        useCallback: function (e, t) {
          return Ea().memoizedState = [e, void 0 === t ? null : t], e;
        },
        useContext: Eo,
        useEffect: za,
        useImperativeHandle: function (e, t, n) {
          return n = null != n ? n.concat([e]) : null, ja(4194308, 4, Ha.bind(null, t, e), n);
        },
        useLayoutEffect: function (e, t) {
          return ja(4194308, 4, e, t);
        },
        useInsertionEffect: function (e, t) {
          return ja(4, 2, e, t);
        },
        useMemo: function (e, t) {
          var n = Ea();
          return t = void 0 === t ? null : t, e = e(), n.memoizedState = [e, t], e;
        },
        useReducer: function (e, t, n) {
          var r = Ea();
          return t = void 0 !== n ? n(t) : t, r.memoizedState = r.baseState = t, e = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: e,
            lastRenderedState: t
          }, r.queue = e, e = e.dispatch = Ja.bind(null, fa, e), [r.memoizedState, e];
        },
        useRef: function (e) {
          return e = {
            current: e
          }, Ea().memoizedState = e;
        },
        useState: Na,
        useDebugValue: $a,
        useDeferredValue: function (e) {
          return Ea().memoizedState = e;
        },
        useTransition: function () {
          var e = Na(!1),
            t = e[0];
          return e = Qa.bind(null, e[1]), Ea().memoizedState = e, [t, e];
        },
        useMutableSource: function () {},
        useSyncExternalStore: function (e, t, r) {
          var i = fa,
            o = Ea();
          if (to) {
            if (void 0 === r) throw Error(n(407));
            r = r();
          } else {
            if (r = t(), null === Cu) throw Error(n(349));
            0 != (30 & da) || Ia(i, t, r);
          }
          o.memoizedState = r;
          var a = {
            value: r,
            getSnapshot: t
          };
          return o.queue = a, za(Pa.bind(null, i, a, e), [e]), i.flags |= 2048, Da(9, Ta.bind(null, i, a, r, t), void 0, null), r;
        },
        useId: function () {
          var e = Ea(),
            t = Cu.identifierPrefix;
          if (to) {
            var n = Yi;
            t = ":" + t + "R" + (n = (Wi & ~(1 << 32 - rt(Wi) - 1)).toString(32) + n), 0 < (n = va++) && (t += "H" + n.toString(32)), t += ":";
          } else t = ":" + t + "r" + (n = ba++).toString(32) + ":";
          return e.memoizedState = t;
        },
        unstable_isNewReconciler: !1
      },
      os = {
        readContext: Eo,
        useCallback: Wa,
        useContext: Eo,
        useEffect: Ua,
        useImperativeHandle: Va,
        useInsertionEffect: qa,
        useLayoutEffect: Ka,
        useMemo: Ya,
        useReducer: Ma,
        useRef: Ba,
        useState: function () {
          return Ma(ka);
        },
        useDebugValue: $a,
        useDeferredValue: function (e) {
          return Ga(Sa(), ha.memoizedState, e);
        },
        useTransition: function () {
          return [Ma(ka)[0], Sa().memoizedState];
        },
        useMutableSource: xa,
        useSyncExternalStore: Ra,
        useId: Za,
        unstable_isNewReconciler: !1
      },
      as = {
        readContext: Eo,
        useCallback: Wa,
        useContext: Eo,
        useEffect: Ua,
        useImperativeHandle: Va,
        useInsertionEffect: qa,
        useLayoutEffect: Ka,
        useMemo: Ya,
        useReducer: Ca,
        useRef: Ba,
        useState: function () {
          return Ca(ka);
        },
        useDebugValue: $a,
        useDeferredValue: function (e) {
          var t = Sa();
          return null === ha ? t.memoizedState = e : Ga(t, ha.memoizedState, e);
        },
        useTransition: function () {
          return [Ca(ka)[0], Sa().memoizedState];
        },
        useMutableSource: xa,
        useSyncExternalStore: Ra,
        useId: Za,
        unstable_isNewReconciler: !1
      };
    function ss(e, t) {
      try {
        var n = "",
          r = t;
        do {
          n += j(r), r = r.return;
        } while (r);
        var i = n;
      } catch (e) {
        i = "\nError generating stack: " + e.message + "\n" + e.stack;
      }
      return {
        value: e,
        source: t,
        stack: i,
        digest: null
      };
    }
    function us(e, t, n) {
      return {
        value: e,
        source: null,
        stack: null != n ? n : null,
        digest: null != t ? t : null
      };
    }
    function cs(e, t) {
      try {
        console.error(t.value);
      } catch (e) {
        setTimeout(function () {
          throw e;
        });
      }
    }
    var ls = "function" == typeof WeakMap ? WeakMap : Map;
    function ds(e, t, n) {
      (n = To(-1, n)).tag = 3, n.payload = {
        element: null
      };
      var r = t.value;
      return n.callback = function () {
        qu || (qu = !0, Ku = r), cs(0, t);
      }, n;
    }
    function fs(e, t, n) {
      (n = To(-1, n)).tag = 3;
      var r = e.type.getDerivedStateFromError;
      if ("function" == typeof r) {
        var i = t.value;
        n.payload = function () {
          return r(i);
        }, n.callback = function () {
          cs(0, t);
        };
      }
      var o = e.stateNode;
      return null !== o && "function" == typeof o.componentDidCatch && (n.callback = function () {
        cs(0, t), "function" != typeof r && (null === Hu ? Hu = new Set([this]) : Hu.add(this));
        var e = t.stack;
        this.componentDidCatch(t.value, {
          componentStack: null !== e ? e : ""
        });
      }), n;
    }
    function hs(e, t, n) {
      var r = e.pingCache;
      if (null === r) {
        r = e.pingCache = new ls();
        var i = new Set();
        r.set(t, i);
      } else void 0 === (i = r.get(t)) && (i = new Set(), r.set(t, i));
      i.has(n) || (i.add(n), e = Ec.bind(null, e, t, n), t.then(e, e));
    }
    function ps(e) {
      do {
        var t;
        if ((t = 13 === e.tag) && (t = null === (t = e.memoizedState) || null !== t.dehydrated), t) return e;
        e = e.return;
      } while (null !== e);
      return null;
    }
    function ms(e, t, n, r, i) {
      return 0 == (1 & e.mode) ? (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, 1 === n.tag && (null === n.alternate ? n.tag = 17 : ((t = To(-1, 1)).tag = 2, Po(n, t, 1))), n.lanes |= 1), e) : (e.flags |= 65536, e.lanes = i, e);
    }
    var gs = v.ReactCurrentOwner,
      vs = !1;
    function bs(e, t, n, r) {
      t.child = null === e ? Go(t, null, n, r) : Yo(t, e.child, n, r);
    }
    function ys(e, t, n, r, i) {
      n = n.render;
      var o = t.ref;
      return _o(t, i), r = Aa(e, t, n, r, o, i), n = _a(), null === e || vs ? (to && n && Zi(t), t.flags |= 1, bs(e, t, r, i), t.child) : (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i, qs(e, t, i));
    }
    function ws(e, t, n, r, i) {
      if (null === e) {
        var o = n.type;
        return "function" != typeof o || Ic(o) || void 0 !== o.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e = Pc(n.type, null, r, t, t.mode, i)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = o, As(e, t, o, r, i));
      }
      if (o = e.child, 0 == (e.lanes & i)) {
        var a = o.memoizedProps;
        if ((n = null !== (n = n.compare) ? n : or)(a, r) && e.ref === t.ref) return qs(e, t, i);
      }
      return t.flags |= 1, (e = Tc(o, r)).ref = t.ref, e.return = t, t.child = e;
    }
    function As(e, t, n, r, i) {
      if (null !== e) {
        var o = e.memoizedProps;
        if (or(o, r) && e.ref === t.ref) {
          if (vs = !1, t.pendingProps = r = o, 0 == (e.lanes & i)) return t.lanes = e.lanes, qs(e, t, i);
          0 != (131072 & e.flags) && (vs = !0);
        }
      }
      return Ss(e, t, n, r, i);
    }
    function _s(e, t, n) {
      var r = t.pendingProps,
        i = r.children,
        o = null !== e ? e.memoizedState : null;
      if ("hidden" === r.mode) {
        if (0 == (1 & t.mode)) t.memoizedState = {
          baseLanes: 0,
          cachePool: null,
          transitions: null
        }, Ei(Tu, Iu), Iu |= n;else {
          if (0 == (1073741824 & n)) return e = null !== o ? o.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = {
            baseLanes: e,
            cachePool: null,
            transitions: null
          }, t.updateQueue = null, Ei(Tu, Iu), Iu |= e, null;
          t.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
          }, r = null !== o ? o.baseLanes : n, Ei(Tu, Iu), Iu |= r;
        }
      } else null !== o ? (r = o.baseLanes | n, t.memoizedState = null) : r = n, Ei(Tu, Iu), Iu |= r;
      return bs(e, t, i, n), t.child;
    }
    function Es(e, t) {
      var n = t.ref;
      (null === e && null !== n || null !== e && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
    }
    function Ss(e, t, n, r, i) {
      var o = Ri(n) ? Ci : ki.current;
      return o = xi(t, o), _o(t, i), n = Aa(e, t, n, r, o, i), r = _a(), null === e || vs ? (to && r && Zi(t), t.flags |= 1, bs(e, t, n, i), t.child) : (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i, qs(e, t, i));
    }
    function ks(e, t, n, r, i) {
      if (Ri(n)) {
        var o = !0;
        Oi(t);
      } else o = !1;
      if (_o(t, i), null === t.stateNode) Us(e, t), Uo(t, n, r), Ko(t, n, r, i), r = !0;else if (null === e) {
        var a = t.stateNode,
          s = t.memoizedProps;
        a.props = s;
        var u = a.context,
          c = n.contextType;
        "object" == typeof c && null !== c ? c = Eo(c) : c = xi(t, c = Ri(n) ? Ci : ki.current);
        var l = n.getDerivedStateFromProps,
          d = "function" == typeof l || "function" == typeof a.getSnapshotBeforeUpdate;
        d || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (s !== r || u !== c) && qo(t, a, r, c), xo = !1;
        var f = t.memoizedState;
        a.state = f, No(t, r, a, i), u = t.memoizedState, s !== r || f !== u || Mi.current || xo ? ("function" == typeof l && (jo(t, n, l, r), u = t.memoizedState), (s = xo || zo(t, n, s, r, f, u, c)) ? (d || "function" != typeof a.UNSAFE_componentWillMount && "function" != typeof a.componentWillMount || ("function" == typeof a.componentWillMount && a.componentWillMount(), "function" == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()), "function" == typeof a.componentDidMount && (t.flags |= 4194308)) : ("function" == typeof a.componentDidMount && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = u), a.props = r, a.state = u, a.context = c, r = s) : ("function" == typeof a.componentDidMount && (t.flags |= 4194308), r = !1);
      } else {
        a = t.stateNode, Io(e, t), s = t.memoizedProps, c = t.type === t.elementType ? s : po(t.type, s), a.props = c, d = t.pendingProps, f = a.context, "object" == typeof (u = n.contextType) && null !== u ? u = Eo(u) : u = xi(t, u = Ri(n) ? Ci : ki.current);
        var h = n.getDerivedStateFromProps;
        (l = "function" == typeof h || "function" == typeof a.getSnapshotBeforeUpdate) || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (s !== d || f !== u) && qo(t, a, r, u), xo = !1, f = t.memoizedState, a.state = f, No(t, r, a, i);
        var p = t.memoizedState;
        s !== d || f !== p || Mi.current || xo ? ("function" == typeof h && (jo(t, n, h, r), p = t.memoizedState), (c = xo || zo(t, n, c, r, f, p, u) || !1) ? (l || "function" != typeof a.UNSAFE_componentWillUpdate && "function" != typeof a.componentWillUpdate || ("function" == typeof a.componentWillUpdate && a.componentWillUpdate(r, p, u), "function" == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(r, p, u)), "function" == typeof a.componentDidUpdate && (t.flags |= 4), "function" == typeof a.getSnapshotBeforeUpdate && (t.flags |= 1024)) : ("function" != typeof a.componentDidUpdate || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = u, r = c) : ("function" != typeof a.componentDidUpdate || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
      }
      return Ms(e, t, n, r, o, i);
    }
    function Ms(e, t, n, r, i, o) {
      Es(e, t);
      var a = 0 != (128 & t.flags);
      if (!r && !a) return i && Li(t, n, !1), qs(e, t, o);
      r = t.stateNode, gs.current = t;
      var s = a && "function" != typeof n.getDerivedStateFromError ? null : r.render();
      return t.flags |= 1, null !== e && a ? (t.child = Yo(t, e.child, null, o), t.child = Yo(t, null, s, o)) : bs(e, t, s, o), t.memoizedState = r.state, i && Li(t, n, !0), t.child;
    }
    function Cs(e) {
      var t = e.stateNode;
      t.pendingContext ? Ti(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Ti(0, t.context, !1), ta(e, t.containerInfo);
    }
    function xs(e, t, n, r, i) {
      return lo(), fo(i), t.flags |= 256, bs(e, t, n, r), t.child;
    }
    var Rs,
      Is,
      Ts,
      Ps,
      Os = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
      };
    function Ls(e) {
      return {
        baseLanes: e,
        cachePool: null,
        transitions: null
      };
    }
    function Ns(e, t, r) {
      var i,
        o = t.pendingProps,
        a = oa.current,
        s = !1,
        u = 0 != (128 & t.flags);
      if ((i = u) || (i = (null === e || null !== e.memoizedState) && 0 != (2 & a)), i ? (s = !0, t.flags &= -129) : null !== e && null === e.memoizedState || (a |= 1), Ei(oa, 1 & a), null === e) return ao(t), null !== (e = t.memoizedState) && null !== (e = e.dehydrated) ? (0 == (1 & t.mode) ? t.lanes = 1 : "$!" === e.data ? t.lanes = 8 : t.lanes = 1073741824, null) : (u = o.children, e = o.fallback, s ? (o = t.mode, s = t.child, u = {
        mode: "hidden",
        children: u
      }, 0 == (1 & o) && null !== s ? (s.childLanes = 0, s.pendingProps = u) : s = Lc(u, o, 0, null), e = Oc(e, o, r, null), s.return = t, e.return = t, s.sibling = e, t.child = s, t.child.memoizedState = Ls(r), t.memoizedState = Os, e) : Ds(t, u));
      if (null !== (a = e.memoizedState) && null !== (i = a.dehydrated)) return function (e, t, r, i, o, a, s) {
        if (r) return 256 & t.flags ? (t.flags &= -257, Bs(e, t, s, i = us(Error(n(422))))) : null !== t.memoizedState ? (t.child = e.child, t.flags |= 128, null) : (a = i.fallback, o = t.mode, i = Lc({
          mode: "visible",
          children: i.children
        }, o, 0, null), (a = Oc(a, o, s, null)).flags |= 2, i.return = t, a.return = t, i.sibling = a, t.child = i, 0 != (1 & t.mode) && Yo(t, e.child, null, s), t.child.memoizedState = Ls(s), t.memoizedState = Os, a);
        if (0 == (1 & t.mode)) return Bs(e, t, s, null);
        if ("$!" === o.data) {
          if (i = o.nextSibling && o.nextSibling.dataset) var u = i.dgst;
          return i = u, Bs(e, t, s, i = us(a = Error(n(419)), i, void 0));
        }
        if (u = 0 != (s & e.childLanes), vs || u) {
          if (null !== (i = Cu)) {
            switch (s & -s) {
              case 4:
                o = 2;
                break;
              case 16:
                o = 8;
                break;
              case 64:
              case 128:
              case 256:
              case 512:
              case 1024:
              case 2048:
              case 4096:
              case 8192:
              case 16384:
              case 32768:
              case 65536:
              case 131072:
              case 262144:
              case 524288:
              case 1048576:
              case 2097152:
              case 4194304:
              case 8388608:
              case 16777216:
              case 33554432:
              case 67108864:
                o = 32;
                break;
              case 536870912:
                o = 268435456;
                break;
              default:
                o = 0;
            }
            0 !== (o = 0 != (o & (i.suspendedLanes | s)) ? 0 : o) && o !== a.retryLane && (a.retryLane = o, Co(e, o), ec(i, e, o, -1));
          }
          return hc(), Bs(e, t, s, i = us(Error(n(421))));
        }
        return "$?" === o.data ? (t.flags |= 128, t.child = e.child, t = kc.bind(null, e), o._reactRetry = t, null) : (e = a.treeContext, eo = ai(o.nextSibling), Xi = t, to = !0, no = null, null !== e && (Hi[Vi++] = Wi, Hi[Vi++] = Yi, Hi[Vi++] = $i, Wi = e.id, Yi = e.overflow, $i = t), t = Ds(t, i.children), t.flags |= 4096, t);
      }(e, t, u, o, i, a, r);
      if (s) {
        s = o.fallback, u = t.mode, i = (a = e.child).sibling;
        var c = {
          mode: "hidden",
          children: o.children
        };
        return 0 == (1 & u) && t.child !== a ? ((o = t.child).childLanes = 0, o.pendingProps = c, t.deletions = null) : (o = Tc(a, c)).subtreeFlags = 14680064 & a.subtreeFlags, null !== i ? s = Tc(i, s) : (s = Oc(s, u, r, null)).flags |= 2, s.return = t, o.return = t, o.sibling = s, t.child = o, o = s, s = t.child, u = null === (u = e.child.memoizedState) ? Ls(r) : {
          baseLanes: u.baseLanes | r,
          cachePool: null,
          transitions: u.transitions
        }, s.memoizedState = u, s.childLanes = e.childLanes & ~r, t.memoizedState = Os, o;
      }
      return e = (s = e.child).sibling, o = Tc(s, {
        mode: "visible",
        children: o.children
      }), 0 == (1 & t.mode) && (o.lanes = r), o.return = t, o.sibling = null, null !== e && (null === (r = t.deletions) ? (t.deletions = [e], t.flags |= 16) : r.push(e)), t.child = o, t.memoizedState = null, o;
    }
    function Ds(e, t) {
      return (t = Lc({
        mode: "visible",
        children: t
      }, e.mode, 0, null)).return = e, e.child = t;
    }
    function Bs(e, t, n, r) {
      return null !== r && fo(r), Yo(t, e.child, null, n), (e = Ds(t, t.pendingProps.children)).flags |= 2, t.memoizedState = null, e;
    }
    function js(e, t, n) {
      e.lanes |= t;
      var r = e.alternate;
      null !== r && (r.lanes |= t), Ao(e.return, t, n);
    }
    function Fs(e, t, n, r, i) {
      var o = e.memoizedState;
      null === o ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: r,
        tail: n,
        tailMode: i
      } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i);
    }
    function zs(e, t, n) {
      var r = t.pendingProps,
        i = r.revealOrder,
        o = r.tail;
      if (bs(e, t, r.children, n), 0 != (2 & (r = oa.current))) r = 1 & r | 2, t.flags |= 128;else {
        if (null !== e && 0 != (128 & e.flags)) e: for (e = t.child; null !== e;) {
          if (13 === e.tag) null !== e.memoizedState && js(e, n, t);else if (19 === e.tag) js(e, n, t);else if (null !== e.child) {
            e.child.return = e, e = e.child;
            continue;
          }
          if (e === t) break e;
          for (; null === e.sibling;) {
            if (null === e.return || e.return === t) break e;
            e = e.return;
          }
          e.sibling.return = e.return, e = e.sibling;
        }
        r &= 1;
      }
      if (Ei(oa, r), 0 == (1 & t.mode)) t.memoizedState = null;else switch (i) {
        case "forwards":
          for (n = t.child, i = null; null !== n;) null !== (e = n.alternate) && null === aa(e) && (i = n), n = n.sibling;
          null === (n = i) ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), Fs(t, !1, i, n, o);
          break;
        case "backwards":
          for (n = null, i = t.child, t.child = null; null !== i;) {
            if (null !== (e = i.alternate) && null === aa(e)) {
              t.child = i;
              break;
            }
            e = i.sibling, i.sibling = n, n = i, i = e;
          }
          Fs(t, !0, n, null, o);
          break;
        case "together":
          Fs(t, !1, null, null, void 0);
          break;
        default:
          t.memoizedState = null;
      }
      return t.child;
    }
    function Us(e, t) {
      0 == (1 & t.mode) && null !== e && (e.alternate = null, t.alternate = null, t.flags |= 2);
    }
    function qs(e, t, r) {
      if (null !== e && (t.dependencies = e.dependencies), Lu |= t.lanes, 0 == (r & t.childLanes)) return null;
      if (null !== e && t.child !== e.child) throw Error(n(153));
      if (null !== t.child) {
        for (r = Tc(e = t.child, e.pendingProps), t.child = r, r.return = t; null !== e.sibling;) e = e.sibling, (r = r.sibling = Tc(e, e.pendingProps)).return = t;
        r.sibling = null;
      }
      return t.child;
    }
    function Ks(e, t) {
      if (!to) switch (e.tailMode) {
        case "hidden":
          t = e.tail;
          for (var n = null; null !== t;) null !== t.alternate && (n = t), t = t.sibling;
          null === n ? e.tail = null : n.sibling = null;
          break;
        case "collapsed":
          n = e.tail;
          for (var r = null; null !== n;) null !== n.alternate && (r = n), n = n.sibling;
          null === r ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : r.sibling = null;
      }
    }
    function Hs(e) {
      var t = null !== e.alternate && e.alternate.child === e.child,
        n = 0,
        r = 0;
      if (t) for (var i = e.child; null !== i;) n |= i.lanes | i.childLanes, r |= 14680064 & i.subtreeFlags, r |= 14680064 & i.flags, i.return = e, i = i.sibling;else for (i = e.child; null !== i;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
      return e.subtreeFlags |= r, e.childLanes = n, t;
    }
    function Vs(e, t, r) {
      var o = t.pendingProps;
      switch (Ji(t), t.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return Hs(t), null;
        case 1:
        case 17:
          return Ri(t.type) && Ii(), Hs(t), null;
        case 3:
          return o = t.stateNode, na(), _i(Mi), _i(ki), ua(), o.pendingContext && (o.context = o.pendingContext, o.pendingContext = null), null !== e && null !== e.child || (uo(t) ? t.flags |= 4 : null === e || e.memoizedState.isDehydrated && 0 == (256 & t.flags) || (t.flags |= 1024, null !== no && (ic(no), no = null))), Is(e, t), Hs(t), null;
        case 5:
          ia(t);
          var a = ea(Xo.current);
          if (r = t.type, null !== e && null != t.stateNode) Ts(e, t, r, o, a), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);else {
            if (!o) {
              if (null === t.stateNode) throw Error(n(166));
              return Hs(t), null;
            }
            if (e = ea(Zo.current), uo(t)) {
              o = t.stateNode, r = t.type;
              var s = t.memoizedProps;
              switch (o[ci] = t, o[li] = s, e = 0 != (1 & t.mode), r) {
                case "dialog":
                  Dr("cancel", o), Dr("close", o);
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Dr("load", o);
                  break;
                case "video":
                case "audio":
                  for (a = 0; a < Pr.length; a++) Dr(Pr[a], o);
                  break;
                case "source":
                  Dr("error", o);
                  break;
                case "img":
                case "image":
                case "link":
                  Dr("error", o), Dr("load", o);
                  break;
                case "details":
                  Dr("toggle", o);
                  break;
                case "input":
                  W(o, s), Dr("invalid", o);
                  break;
                case "select":
                  o._wrapperState = {
                    wasMultiple: !!s.multiple
                  }, Dr("invalid", o);
                  break;
                case "textarea":
                  te(o, s), Dr("invalid", o);
              }
              for (var u in me(r, s), a = null, s) if (s.hasOwnProperty(u)) {
                var c = s[u];
                "children" === u ? "string" == typeof c ? o.textContent !== c && (!0 !== s.suppressHydrationWarning && Gr(o.textContent, c, e), a = ["children", c]) : "number" == typeof c && o.textContent !== "" + c && (!0 !== s.suppressHydrationWarning && Gr(o.textContent, c, e), a = ["children", "" + c]) : i.hasOwnProperty(u) && null != c && "onScroll" === u && Dr("scroll", o);
              }
              switch (r) {
                case "input":
                  K(o), Q(o, s, !0);
                  break;
                case "textarea":
                  K(o), re(o);
                  break;
                case "select":
                case "option":
                  break;
                default:
                  "function" == typeof s.onClick && (o.onclick = Qr);
              }
              o = a, t.updateQueue = o, null !== o && (t.flags |= 4);
            } else {
              u = 9 === a.nodeType ? a : a.ownerDocument, "http://www.w3.org/1999/xhtml" === e && (e = ie(r)), "http://www.w3.org/1999/xhtml" === e ? "script" === r ? ((e = u.createElement("div")).innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : "string" == typeof o.is ? e = u.createElement(r, {
                is: o.is
              }) : (e = u.createElement(r), "select" === r && (u = e, o.multiple ? u.multiple = !0 : o.size && (u.size = o.size))) : e = u.createElementNS(e, r), e[ci] = t, e[li] = o, Rs(e, t, !1, !1), t.stateNode = e;
              e: {
                switch (u = ge(r, o), r) {
                  case "dialog":
                    Dr("cancel", e), Dr("close", e), a = o;
                    break;
                  case "iframe":
                  case "object":
                  case "embed":
                    Dr("load", e), a = o;
                    break;
                  case "video":
                  case "audio":
                    for (a = 0; a < Pr.length; a++) Dr(Pr[a], e);
                    a = o;
                    break;
                  case "source":
                    Dr("error", e), a = o;
                    break;
                  case "img":
                  case "image":
                  case "link":
                    Dr("error", e), Dr("load", e), a = o;
                    break;
                  case "details":
                    Dr("toggle", e), a = o;
                    break;
                  case "input":
                    W(e, o), a = $(e, o), Dr("invalid", e);
                    break;
                  case "option":
                  default:
                    a = o;
                    break;
                  case "select":
                    e._wrapperState = {
                      wasMultiple: !!o.multiple
                    }, a = L({}, o, {
                      value: void 0
                    }), Dr("invalid", e);
                    break;
                  case "textarea":
                    te(e, o), a = ee(e, o), Dr("invalid", e);
                }
                for (s in me(r, a), c = a) if (c.hasOwnProperty(s)) {
                  var l = c[s];
                  "style" === s ? he(e, l) : "dangerouslySetInnerHTML" === s ? null != (l = l ? l.__html : void 0) && ue(e, l) : "children" === s ? "string" == typeof l ? ("textarea" !== r || "" !== l) && ce(e, l) : "number" == typeof l && ce(e, "" + l) : "suppressContentEditableWarning" !== s && "suppressHydrationWarning" !== s && "autoFocus" !== s && (i.hasOwnProperty(s) ? null != l && "onScroll" === s && Dr("scroll", e) : null != l && g(e, s, l, u));
                }
                switch (r) {
                  case "input":
                    K(e), Q(e, o, !1);
                    break;
                  case "textarea":
                    K(e), re(e);
                    break;
                  case "option":
                    null != o.value && e.setAttribute("value", "" + U(o.value));
                    break;
                  case "select":
                    e.multiple = !!o.multiple, null != (s = o.value) ? X(e, !!o.multiple, s, !1) : null != o.defaultValue && X(e, !!o.multiple, o.defaultValue, !0);
                    break;
                  default:
                    "function" == typeof a.onClick && (e.onclick = Qr);
                }
                switch (r) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    o = !!o.autoFocus;
                    break e;
                  case "img":
                    o = !0;
                    break e;
                  default:
                    o = !1;
                }
              }
              o && (t.flags |= 4);
            }
            null !== t.ref && (t.flags |= 512, t.flags |= 2097152);
          }
          return Hs(t), null;
        case 6:
          if (e && null != t.stateNode) Ps(e, t, e.memoizedProps, o);else {
            if ("string" != typeof o && null === t.stateNode) throw Error(n(166));
            if (r = ea(Xo.current), ea(Zo.current), uo(t)) {
              if (o = t.stateNode, r = t.memoizedProps, o[ci] = t, (s = o.nodeValue !== r) && null !== (e = Xi)) switch (e.tag) {
                case 3:
                  Gr(o.nodeValue, r, 0 != (1 & e.mode));
                  break;
                case 5:
                  !0 !== e.memoizedProps.suppressHydrationWarning && Gr(o.nodeValue, r, 0 != (1 & e.mode));
              }
              s && (t.flags |= 4);
            } else (o = (9 === r.nodeType ? r : r.ownerDocument).createTextNode(o))[ci] = t, t.stateNode = o;
          }
          return Hs(t), null;
        case 13:
          if (_i(oa), o = t.memoizedState, null === e || null !== e.memoizedState && null !== e.memoizedState.dehydrated) {
            if (to && null !== eo && 0 != (1 & t.mode) && 0 == (128 & t.flags)) co(), lo(), t.flags |= 98560, s = !1;else if (s = uo(t), null !== o && null !== o.dehydrated) {
              if (null === e) {
                if (!s) throw Error(n(318));
                if (!(s = null !== (s = t.memoizedState) ? s.dehydrated : null)) throw Error(n(317));
                s[ci] = t;
              } else lo(), 0 == (128 & t.flags) && (t.memoizedState = null), t.flags |= 4;
              Hs(t), s = !1;
            } else null !== no && (ic(no), no = null), s = !0;
            if (!s) return 65536 & t.flags ? t : null;
          }
          return 0 != (128 & t.flags) ? (t.lanes = r, t) : ((o = null !== o) !== (null !== e && null !== e.memoizedState) && o && (t.child.flags |= 8192, 0 != (1 & t.mode) && (null === e || 0 != (1 & oa.current) ? 0 === Pu && (Pu = 3) : hc())), null !== t.updateQueue && (t.flags |= 4), Hs(t), null);
        case 4:
          return na(), Is(e, t), null === e && Fr(t.stateNode.containerInfo), Hs(t), null;
        case 10:
          return wo(t.type._context), Hs(t), null;
        case 19:
          if (_i(oa), null === (s = t.memoizedState)) return Hs(t), null;
          if (o = 0 != (128 & t.flags), null === (u = s.rendering)) {
            if (o) Ks(s, !1);else {
              if (0 !== Pu || null !== e && 0 != (128 & e.flags)) for (e = t.child; null !== e;) {
                if (null !== (u = aa(e))) {
                  for (t.flags |= 128, Ks(s, !1), null !== (o = u.updateQueue) && (t.updateQueue = o, t.flags |= 4), t.subtreeFlags = 0, o = r, r = t.child; null !== r;) e = o, (s = r).flags &= 14680066, null === (u = s.alternate) ? (s.childLanes = 0, s.lanes = e, s.child = null, s.subtreeFlags = 0, s.memoizedProps = null, s.memoizedState = null, s.updateQueue = null, s.dependencies = null, s.stateNode = null) : (s.childLanes = u.childLanes, s.lanes = u.lanes, s.child = u.child, s.subtreeFlags = 0, s.deletions = null, s.memoizedProps = u.memoizedProps, s.memoizedState = u.memoizedState, s.updateQueue = u.updateQueue, s.type = u.type, e = u.dependencies, s.dependencies = null === e ? null : {
                    lanes: e.lanes,
                    firstContext: e.firstContext
                  }), r = r.sibling;
                  return Ei(oa, 1 & oa.current | 2), t.child;
                }
                e = e.sibling;
              }
              null !== s.tail && Ye() > zu && (t.flags |= 128, o = !0, Ks(s, !1), t.lanes = 4194304);
            }
          } else {
            if (!o) if (null !== (e = aa(u))) {
              if (t.flags |= 128, o = !0, null !== (r = e.updateQueue) && (t.updateQueue = r, t.flags |= 4), Ks(s, !0), null === s.tail && "hidden" === s.tailMode && !u.alternate && !to) return Hs(t), null;
            } else 2 * Ye() - s.renderingStartTime > zu && 1073741824 !== r && (t.flags |= 128, o = !0, Ks(s, !1), t.lanes = 4194304);
            s.isBackwards ? (u.sibling = t.child, t.child = u) : (null !== (r = s.last) ? r.sibling = u : t.child = u, s.last = u);
          }
          return null !== s.tail ? (t = s.tail, s.rendering = t, s.tail = t.sibling, s.renderingStartTime = Ye(), t.sibling = null, r = oa.current, Ei(oa, o ? 1 & r | 2 : 1 & r), t) : (Hs(t), null);
        case 22:
        case 23:
          return cc(), o = null !== t.memoizedState, null !== e && null !== e.memoizedState !== o && (t.flags |= 8192), o && 0 != (1 & t.mode) ? 0 != (1073741824 & Iu) && (Hs(t), 6 & t.subtreeFlags && (t.flags |= 8192)) : Hs(t), null;
        case 24:
        case 25:
          return null;
      }
      throw Error(n(156, t.tag));
    }
    function $s(e, t) {
      switch (Ji(t), t.tag) {
        case 1:
          return Ri(t.type) && Ii(), 65536 & (e = t.flags) ? (t.flags = -65537 & e | 128, t) : null;
        case 3:
          return na(), _i(Mi), _i(ki), ua(), 0 != (65536 & (e = t.flags)) && 0 == (128 & e) ? (t.flags = -65537 & e | 128, t) : null;
        case 5:
          return ia(t), null;
        case 13:
          if (_i(oa), null !== (e = t.memoizedState) && null !== e.dehydrated) {
            if (null === t.alternate) throw Error(n(340));
            lo();
          }
          return 65536 & (e = t.flags) ? (t.flags = -65537 & e | 128, t) : null;
        case 19:
          return _i(oa), null;
        case 4:
          return na(), null;
        case 10:
          return wo(t.type._context), null;
        case 22:
        case 23:
          return cc(), null;
        default:
          return null;
      }
    }
    Rs = function (e, t) {
      for (var n = t.child; null !== n;) {
        if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);else if (4 !== n.tag && null !== n.child) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === t) break;
        for (; null === n.sibling;) {
          if (null === n.return || n.return === t) return;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
    }, Is = function () {}, Ts = function (e, t, n, r) {
      var o = e.memoizedProps;
      if (o !== r) {
        e = t.stateNode, ea(Zo.current);
        var a,
          s = null;
        switch (n) {
          case "input":
            o = $(e, o), r = $(e, r), s = [];
            break;
          case "select":
            o = L({}, o, {
              value: void 0
            }), r = L({}, r, {
              value: void 0
            }), s = [];
            break;
          case "textarea":
            o = ee(e, o), r = ee(e, r), s = [];
            break;
          default:
            "function" != typeof o.onClick && "function" == typeof r.onClick && (e.onclick = Qr);
        }
        for (l in me(n, r), n = null, o) if (!r.hasOwnProperty(l) && o.hasOwnProperty(l) && null != o[l]) if ("style" === l) {
          var u = o[l];
          for (a in u) u.hasOwnProperty(a) && (n || (n = {}), n[a] = "");
        } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (i.hasOwnProperty(l) ? s || (s = []) : (s = s || []).push(l, null));
        for (l in r) {
          var c = r[l];
          if (u = null != o ? o[l] : void 0, r.hasOwnProperty(l) && c !== u && (null != c || null != u)) if ("style" === l) {
            if (u) {
              for (a in u) !u.hasOwnProperty(a) || c && c.hasOwnProperty(a) || (n || (n = {}), n[a] = "");
              for (a in c) c.hasOwnProperty(a) && u[a] !== c[a] && (n || (n = {}), n[a] = c[a]);
            } else n || (s || (s = []), s.push(l, n)), n = c;
          } else "dangerouslySetInnerHTML" === l ? (c = c ? c.__html : void 0, u = u ? u.__html : void 0, null != c && u !== c && (s = s || []).push(l, c)) : "children" === l ? "string" != typeof c && "number" != typeof c || (s = s || []).push(l, "" + c) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (i.hasOwnProperty(l) ? (null != c && "onScroll" === l && Dr("scroll", e), s || u === c || (s = [])) : (s = s || []).push(l, c));
        }
        n && (s = s || []).push("style", n);
        var l = s;
        (t.updateQueue = l) && (t.flags |= 4);
      }
    }, Ps = function (e, t, n, r) {
      n !== r && (t.flags |= 4);
    };
    var Ws = !1,
      Ys = !1,
      Gs = "function" == typeof WeakSet ? WeakSet : Set,
      Qs = null;
    function Zs(e, t) {
      var n = e.ref;
      if (null !== n) if ("function" == typeof n) try {
        n(null);
      } catch (n) {
        _c(e, t, n);
      } else n.current = null;
    }
    function Js(e, t, n) {
      try {
        n();
      } catch (n) {
        _c(e, t, n);
      }
    }
    var Xs = !1;
    function eu(e, t, n) {
      var r = t.updateQueue;
      if (null !== (r = null !== r ? r.lastEffect : null)) {
        var i = r = r.next;
        do {
          if ((i.tag & e) === e) {
            var o = i.destroy;
            i.destroy = void 0, void 0 !== o && Js(t, n, o);
          }
          i = i.next;
        } while (i !== r);
      }
    }
    function tu(e, t) {
      if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
        var n = t = t.next;
        do {
          if ((n.tag & e) === e) {
            var r = n.create;
            n.destroy = r();
          }
          n = n.next;
        } while (n !== t);
      }
    }
    function nu(e) {
      var t = e.ref;
      if (null !== t) {
        var n = e.stateNode;
        e.tag, e = n, "function" == typeof t ? t(e) : t.current = e;
      }
    }
    function ru(e) {
      var t = e.alternate;
      null !== t && (e.alternate = null, ru(t)), e.child = null, e.deletions = null, e.sibling = null, 5 === e.tag && null !== (t = e.stateNode) && (delete t[ci], delete t[li], delete t[fi], delete t[hi], delete t[pi]), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
    }
    function iu(e) {
      return 5 === e.tag || 3 === e.tag || 4 === e.tag;
    }
    function ou(e) {
      e: for (;;) {
        for (; null === e.sibling;) {
          if (null === e.return || iu(e.return)) return null;
          e = e.return;
        }
        for (e.sibling.return = e.return, e = e.sibling; 5 !== e.tag && 6 !== e.tag && 18 !== e.tag;) {
          if (2 & e.flags) continue e;
          if (null === e.child || 4 === e.tag) continue e;
          e.child.return = e, e = e.child;
        }
        if (!(2 & e.flags)) return e.stateNode;
      }
    }
    function au(e, t, n) {
      var r = e.tag;
      if (5 === r || 6 === r) e = e.stateNode, t ? 8 === n.nodeType ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (8 === n.nodeType ? (t = n.parentNode).insertBefore(e, n) : (t = n).appendChild(e), null != (n = n._reactRootContainer) || null !== t.onclick || (t.onclick = Qr));else if (4 !== r && null !== (e = e.child)) for (au(e, t, n), e = e.sibling; null !== e;) au(e, t, n), e = e.sibling;
    }
    function su(e, t, n) {
      var r = e.tag;
      if (5 === r || 6 === r) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);else if (4 !== r && null !== (e = e.child)) for (su(e, t, n), e = e.sibling; null !== e;) su(e, t, n), e = e.sibling;
    }
    var uu = null,
      cu = !1;
    function lu(e, t, n) {
      for (n = n.child; null !== n;) du(e, t, n), n = n.sibling;
    }
    function du(e, t, n) {
      if (nt && "function" == typeof nt.onCommitFiberUnmount) try {
        nt.onCommitFiberUnmount(tt, n);
      } catch (e) {}
      switch (n.tag) {
        case 5:
          Ys || Zs(n, t);
        case 6:
          var r = uu,
            i = cu;
          uu = null, lu(e, t, n), cu = i, null !== (uu = r) && (cu ? (e = uu, n = n.stateNode, 8 === e.nodeType ? e.parentNode.removeChild(n) : e.removeChild(n)) : uu.removeChild(n.stateNode));
          break;
        case 18:
          null !== uu && (cu ? (e = uu, n = n.stateNode, 8 === e.nodeType ? oi(e.parentNode, n) : 1 === e.nodeType && oi(e, n), Ft(e)) : oi(uu, n.stateNode));
          break;
        case 4:
          r = uu, i = cu, uu = n.stateNode.containerInfo, cu = !0, lu(e, t, n), uu = r, cu = i;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          if (!Ys && null !== (r = n.updateQueue) && null !== (r = r.lastEffect)) {
            i = r = r.next;
            do {
              var o = i,
                a = o.destroy;
              o = o.tag, void 0 !== a && (0 != (2 & o) || 0 != (4 & o)) && Js(n, t, a), i = i.next;
            } while (i !== r);
          }
          lu(e, t, n);
          break;
        case 1:
          if (!Ys && (Zs(n, t), "function" == typeof (r = n.stateNode).componentWillUnmount)) try {
            r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
          } catch (e) {
            _c(n, t, e);
          }
          lu(e, t, n);
          break;
        case 21:
          lu(e, t, n);
          break;
        case 22:
          1 & n.mode ? (Ys = (r = Ys) || null !== n.memoizedState, lu(e, t, n), Ys = r) : lu(e, t, n);
          break;
        default:
          lu(e, t, n);
      }
    }
    function fu(e) {
      var t = e.updateQueue;
      if (null !== t) {
        e.updateQueue = null;
        var n = e.stateNode;
        null === n && (n = e.stateNode = new Gs()), t.forEach(function (t) {
          var r = Mc.bind(null, e, t);
          n.has(t) || (n.add(t), t.then(r, r));
        });
      }
    }
    function hu(e, t) {
      var r = t.deletions;
      if (null !== r) for (var i = 0; i < r.length; i++) {
        var o = r[i];
        try {
          var a = e,
            s = t,
            u = s;
          e: for (; null !== u;) {
            switch (u.tag) {
              case 5:
                uu = u.stateNode, cu = !1;
                break e;
              case 3:
              case 4:
                uu = u.stateNode.containerInfo, cu = !0;
                break e;
            }
            u = u.return;
          }
          if (null === uu) throw Error(n(160));
          du(a, s, o), uu = null, cu = !1;
          var c = o.alternate;
          null !== c && (c.return = null), o.return = null;
        } catch (e) {
          _c(o, t, e);
        }
      }
      if (12854 & t.subtreeFlags) for (t = t.child; null !== t;) pu(t, e), t = t.sibling;
    }
    function pu(e, t) {
      var r = e.alternate,
        i = e.flags;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          if (hu(t, e), mu(e), 4 & i) {
            try {
              eu(3, e, e.return), tu(3, e);
            } catch (t) {
              _c(e, e.return, t);
            }
            try {
              eu(5, e, e.return);
            } catch (t) {
              _c(e, e.return, t);
            }
          }
          break;
        case 1:
          hu(t, e), mu(e), 512 & i && null !== r && Zs(r, r.return);
          break;
        case 5:
          if (hu(t, e), mu(e), 512 & i && null !== r && Zs(r, r.return), 32 & e.flags) {
            var o = e.stateNode;
            try {
              ce(o, "");
            } catch (t) {
              _c(e, e.return, t);
            }
          }
          if (4 & i && null != (o = e.stateNode)) {
            var a = e.memoizedProps,
              s = null !== r ? r.memoizedProps : a,
              u = e.type,
              c = e.updateQueue;
            if (e.updateQueue = null, null !== c) try {
              "input" === u && "radio" === a.type && null != a.name && Y(o, a), ge(u, s);
              var l = ge(u, a);
              for (s = 0; s < c.length; s += 2) {
                var d = c[s],
                  f = c[s + 1];
                "style" === d ? he(o, f) : "dangerouslySetInnerHTML" === d ? ue(o, f) : "children" === d ? ce(o, f) : g(o, d, f, l);
              }
              switch (u) {
                case "input":
                  G(o, a);
                  break;
                case "textarea":
                  ne(o, a);
                  break;
                case "select":
                  var h = o._wrapperState.wasMultiple;
                  o._wrapperState.wasMultiple = !!a.multiple;
                  var p = a.value;
                  null != p ? X(o, !!a.multiple, p, !1) : h !== !!a.multiple && (null != a.defaultValue ? X(o, !!a.multiple, a.defaultValue, !0) : X(o, !!a.multiple, a.multiple ? [] : "", !1));
              }
              o[li] = a;
            } catch (t) {
              _c(e, e.return, t);
            }
          }
          break;
        case 6:
          if (hu(t, e), mu(e), 4 & i) {
            if (null === e.stateNode) throw Error(n(162));
            o = e.stateNode, a = e.memoizedProps;
            try {
              o.nodeValue = a;
            } catch (t) {
              _c(e, e.return, t);
            }
          }
          break;
        case 3:
          if (hu(t, e), mu(e), 4 & i && null !== r && r.memoizedState.isDehydrated) try {
            Ft(t.containerInfo);
          } catch (t) {
            _c(e, e.return, t);
          }
          break;
        case 4:
        default:
          hu(t, e), mu(e);
          break;
        case 13:
          hu(t, e), mu(e), 8192 & (o = e.child).flags && (a = null !== o.memoizedState, o.stateNode.isHidden = a, !a || null !== o.alternate && null !== o.alternate.memoizedState || (Fu = Ye())), 4 & i && fu(e);
          break;
        case 22:
          if (d = null !== r && null !== r.memoizedState, 1 & e.mode ? (Ys = (l = Ys) || d, hu(t, e), Ys = l) : hu(t, e), mu(e), 8192 & i) {
            if (l = null !== e.memoizedState, (e.stateNode.isHidden = l) && !d && 0 != (1 & e.mode)) for (Qs = e, d = e.child; null !== d;) {
              for (f = Qs = d; null !== Qs;) {
                switch (p = (h = Qs).child, h.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    eu(4, h, h.return);
                    break;
                  case 1:
                    Zs(h, h.return);
                    var m = h.stateNode;
                    if ("function" == typeof m.componentWillUnmount) {
                      i = h, r = h.return;
                      try {
                        t = i, m.props = t.memoizedProps, m.state = t.memoizedState, m.componentWillUnmount();
                      } catch (e) {
                        _c(i, r, e);
                      }
                    }
                    break;
                  case 5:
                    Zs(h, h.return);
                    break;
                  case 22:
                    if (null !== h.memoizedState) {
                      yu(f);
                      continue;
                    }
                }
                null !== p ? (p.return = h, Qs = p) : yu(f);
              }
              d = d.sibling;
            }
            e: for (d = null, f = e;;) {
              if (5 === f.tag) {
                if (null === d) {
                  d = f;
                  try {
                    o = f.stateNode, l ? "function" == typeof (a = o.style).setProperty ? a.setProperty("display", "none", "important") : a.display = "none" : (u = f.stateNode, s = null != (c = f.memoizedProps.style) && c.hasOwnProperty("display") ? c.display : null, u.style.display = fe("display", s));
                  } catch (t) {
                    _c(e, e.return, t);
                  }
                }
              } else if (6 === f.tag) {
                if (null === d) try {
                  f.stateNode.nodeValue = l ? "" : f.memoizedProps;
                } catch (t) {
                  _c(e, e.return, t);
                }
              } else if ((22 !== f.tag && 23 !== f.tag || null === f.memoizedState || f === e) && null !== f.child) {
                f.child.return = f, f = f.child;
                continue;
              }
              if (f === e) break e;
              for (; null === f.sibling;) {
                if (null === f.return || f.return === e) break e;
                d === f && (d = null), f = f.return;
              }
              d === f && (d = null), f.sibling.return = f.return, f = f.sibling;
            }
          }
          break;
        case 19:
          hu(t, e), mu(e), 4 & i && fu(e);
        case 21:
      }
    }
    function mu(e) {
      var t = e.flags;
      if (2 & t) {
        try {
          e: {
            for (var r = e.return; null !== r;) {
              if (iu(r)) {
                var i = r;
                break e;
              }
              r = r.return;
            }
            throw Error(n(160));
          }
          switch (i.tag) {
            case 5:
              var o = i.stateNode;
              32 & i.flags && (ce(o, ""), i.flags &= -33), su(e, ou(e), o);
              break;
            case 3:
            case 4:
              var a = i.stateNode.containerInfo;
              au(e, ou(e), a);
              break;
            default:
              throw Error(n(161));
          }
        } catch (t) {
          _c(e, e.return, t);
        }
        e.flags &= -3;
      }
      4096 & t && (e.flags &= -4097);
    }
    function gu(e, t, n) {
      Qs = e, vu(e);
    }
    function vu(e, t, n) {
      for (var r = 0 != (1 & e.mode); null !== Qs;) {
        var i = Qs,
          o = i.child;
        if (22 === i.tag && r) {
          var a = null !== i.memoizedState || Ws;
          if (!a) {
            var s = i.alternate,
              u = null !== s && null !== s.memoizedState || Ys;
            s = Ws;
            var c = Ys;
            if (Ws = a, (Ys = u) && !c) for (Qs = i; null !== Qs;) u = (a = Qs).child, 22 === a.tag && null !== a.memoizedState ? wu(i) : null !== u ? (u.return = a, Qs = u) : wu(i);
            for (; null !== o;) Qs = o, vu(o), o = o.sibling;
            Qs = i, Ws = s, Ys = c;
          }
          bu(e);
        } else 0 != (8772 & i.subtreeFlags) && null !== o ? (o.return = i, Qs = o) : bu(e);
      }
    }
    function bu(e) {
      for (; null !== Qs;) {
        var t = Qs;
        if (0 != (8772 & t.flags)) {
          var r = t.alternate;
          try {
            if (0 != (8772 & t.flags)) switch (t.tag) {
              case 0:
              case 11:
              case 15:
                Ys || tu(5, t);
                break;
              case 1:
                var i = t.stateNode;
                if (4 & t.flags && !Ys) if (null === r) i.componentDidMount();else {
                  var o = t.elementType === t.type ? r.memoizedProps : po(t.type, r.memoizedProps);
                  i.componentDidUpdate(o, r.memoizedState, i.__reactInternalSnapshotBeforeUpdate);
                }
                var a = t.updateQueue;
                null !== a && Do(t, a, i);
                break;
              case 3:
                var s = t.updateQueue;
                if (null !== s) {
                  if (r = null, null !== t.child) switch (t.child.tag) {
                    case 5:
                    case 1:
                      r = t.child.stateNode;
                  }
                  Do(t, s, r);
                }
                break;
              case 5:
                var u = t.stateNode;
                if (null === r && 4 & t.flags) {
                  r = u;
                  var c = t.memoizedProps;
                  switch (t.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      c.autoFocus && r.focus();
                      break;
                    case "img":
                      c.src && (r.src = c.src);
                  }
                }
                break;
              case 6:
              case 4:
              case 12:
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              case 13:
                if (null === t.memoizedState) {
                  var l = t.alternate;
                  if (null !== l) {
                    var d = l.memoizedState;
                    if (null !== d) {
                      var f = d.dehydrated;
                      null !== f && Ft(f);
                    }
                  }
                }
                break;
              default:
                throw Error(n(163));
            }
            Ys || 512 & t.flags && nu(t);
          } catch (e) {
            _c(t, t.return, e);
          }
        }
        if (t === e) {
          Qs = null;
          break;
        }
        if (null !== (r = t.sibling)) {
          r.return = t.return, Qs = r;
          break;
        }
        Qs = t.return;
      }
    }
    function yu(e) {
      for (; null !== Qs;) {
        var t = Qs;
        if (t === e) {
          Qs = null;
          break;
        }
        var n = t.sibling;
        if (null !== n) {
          n.return = t.return, Qs = n;
          break;
        }
        Qs = t.return;
      }
    }
    function wu(e) {
      for (; null !== Qs;) {
        var t = Qs;
        try {
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              var n = t.return;
              try {
                tu(4, t);
              } catch (e) {
                _c(t, n, e);
              }
              break;
            case 1:
              var r = t.stateNode;
              if ("function" == typeof r.componentDidMount) {
                var i = t.return;
                try {
                  r.componentDidMount();
                } catch (e) {
                  _c(t, i, e);
                }
              }
              var o = t.return;
              try {
                nu(t);
              } catch (e) {
                _c(t, o, e);
              }
              break;
            case 5:
              var a = t.return;
              try {
                nu(t);
              } catch (e) {
                _c(t, a, e);
              }
          }
        } catch (e) {
          _c(t, t.return, e);
        }
        if (t === e) {
          Qs = null;
          break;
        }
        var s = t.sibling;
        if (null !== s) {
          s.return = t.return, Qs = s;
          break;
        }
        Qs = t.return;
      }
    }
    var Au,
      _u = Math.ceil,
      Eu = v.ReactCurrentDispatcher,
      Su = v.ReactCurrentOwner,
      ku = v.ReactCurrentBatchConfig,
      Mu = 0,
      Cu = null,
      xu = null,
      Ru = 0,
      Iu = 0,
      Tu = Ai(0),
      Pu = 0,
      Ou = null,
      Lu = 0,
      Nu = 0,
      Du = 0,
      Bu = null,
      ju = null,
      Fu = 0,
      zu = 1 / 0,
      Uu = null,
      qu = !1,
      Ku = null,
      Hu = null,
      Vu = !1,
      $u = null,
      Wu = 0,
      Yu = 0,
      Gu = null,
      Qu = -1,
      Zu = 0;
    function Ju() {
      return 0 != (6 & Mu) ? Ye() : -1 !== Qu ? Qu : Qu = Ye();
    }
    function Xu(e) {
      return 0 == (1 & e.mode) ? 1 : 0 != (2 & Mu) && 0 !== Ru ? Ru & -Ru : null !== ho.transition ? (0 === Zu && (Zu = ft()), Zu) : 0 !== (e = gt) ? e : e = void 0 === (e = window.event) ? 16 : Wt(e.type);
    }
    function ec(e, t, r, i) {
      if (50 < Yu) throw Yu = 0, Gu = null, Error(n(185));
      pt(e, r, i), 0 != (2 & Mu) && e === Cu || (e === Cu && (0 == (2 & Mu) && (Nu |= r), 4 === Pu && oc(e, Ru)), tc(e, i), 1 === r && 0 === Mu && 0 == (1 & t.mode) && (zu = Ye() + 500, Di && Fi()));
    }
    function tc(e, t) {
      var n = e.callbackNode;
      !function (e, t) {
        for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, o = e.pendingLanes; 0 < o;) {
          var a = 31 - rt(o),
            s = 1 << a,
            u = i[a];
          -1 === u ? 0 != (s & n) && 0 == (s & r) || (i[a] = lt(s, t)) : u <= t && (e.expiredLanes |= s), o &= ~s;
        }
      }(e, t);
      var r = ct(e, e === Cu ? Ru : 0);
      if (0 === r) null !== n && Ve(n), e.callbackNode = null, e.callbackPriority = 0;else if (t = r & -r, e.callbackPriority !== t) {
        if (null != n && Ve(n), 1 === t) 0 === e.tag ? function (e) {
          Di = !0, ji(e);
        }(ac.bind(null, e)) : ji(ac.bind(null, e)), ri(function () {
          0 == (6 & Mu) && Fi();
        }), n = null;else {
          switch (vt(r)) {
            case 1:
              n = Qe;
              break;
            case 4:
              n = Ze;
              break;
            case 16:
            default:
              n = Je;
              break;
            case 536870912:
              n = et;
          }
          n = Cc(n, nc.bind(null, e));
        }
        e.callbackPriority = t, e.callbackNode = n;
      }
    }
    function nc(e, t) {
      if (Qu = -1, Zu = 0, 0 != (6 & Mu)) throw Error(n(327));
      var r = e.callbackNode;
      if (wc() && e.callbackNode !== r) return null;
      var i = ct(e, e === Cu ? Ru : 0);
      if (0 === i) return null;
      if (0 != (30 & i) || 0 != (i & e.expiredLanes) || t) t = pc(e, i);else {
        t = i;
        var o = Mu;
        Mu |= 2;
        var a = fc();
        for (Cu === e && Ru === t || (Uu = null, zu = Ye() + 500, lc(e, t));;) try {
          gc();
          break;
        } catch (t) {
          dc(e, t);
        }
        yo(), Eu.current = a, Mu = o, null !== xu ? t = 0 : (Cu = null, Ru = 0, t = Pu);
      }
      if (0 !== t) {
        if (2 === t && 0 !== (o = dt(e)) && (i = o, t = rc(e, o)), 1 === t) throw r = Ou, lc(e, 0), oc(e, i), tc(e, Ye()), r;
        if (6 === t) oc(e, i);else {
          if (o = e.current.alternate, 0 == (30 & i) && !function (e) {
            for (var t = e;;) {
              if (16384 & t.flags) {
                var n = t.updateQueue;
                if (null !== n && null !== (n = n.stores)) for (var r = 0; r < n.length; r++) {
                  var i = n[r],
                    o = i.getSnapshot;
                  i = i.value;
                  try {
                    if (!ir(o(), i)) return !1;
                  } catch (e) {
                    return !1;
                  }
                }
              }
              if (n = t.child, 16384 & t.subtreeFlags && null !== n) n.return = t, t = n;else {
                if (t === e) break;
                for (; null === t.sibling;) {
                  if (null === t.return || t.return === e) return !0;
                  t = t.return;
                }
                t.sibling.return = t.return, t = t.sibling;
              }
            }
            return !0;
          }(o) && (2 === (t = pc(e, i)) && 0 !== (a = dt(e)) && (i = a, t = rc(e, a)), 1 === t)) throw r = Ou, lc(e, 0), oc(e, i), tc(e, Ye()), r;
          switch (e.finishedWork = o, e.finishedLanes = i, t) {
            case 0:
            case 1:
              throw Error(n(345));
            case 2:
            case 5:
              yc(e, ju, Uu);
              break;
            case 3:
              if (oc(e, i), (130023424 & i) === i && 10 < (t = Fu + 500 - Ye())) {
                if (0 !== ct(e, 0)) break;
                if (((o = e.suspendedLanes) & i) !== i) {
                  Ju(), e.pingedLanes |= e.suspendedLanes & o;
                  break;
                }
                e.timeoutHandle = ei(yc.bind(null, e, ju, Uu), t);
                break;
              }
              yc(e, ju, Uu);
              break;
            case 4:
              if (oc(e, i), (4194240 & i) === i) break;
              for (t = e.eventTimes, o = -1; 0 < i;) {
                var s = 31 - rt(i);
                a = 1 << s, (s = t[s]) > o && (o = s), i &= ~a;
              }
              if (i = o, 10 < (i = (120 > (i = Ye() - i) ? 120 : 480 > i ? 480 : 1080 > i ? 1080 : 1920 > i ? 1920 : 3e3 > i ? 3e3 : 4320 > i ? 4320 : 1960 * _u(i / 1960)) - i)) {
                e.timeoutHandle = ei(yc.bind(null, e, ju, Uu), i);
                break;
              }
              yc(e, ju, Uu);
              break;
            default:
              throw Error(n(329));
          }
        }
      }
      return tc(e, Ye()), e.callbackNode === r ? nc.bind(null, e) : null;
    }
    function rc(e, t) {
      var n = Bu;
      return e.current.memoizedState.isDehydrated && (lc(e, t).flags |= 256), 2 !== (e = pc(e, t)) && (t = ju, ju = n, null !== t && ic(t)), e;
    }
    function ic(e) {
      null === ju ? ju = e : ju.push.apply(ju, e);
    }
    function oc(e, t) {
      for (t &= ~Du, t &= ~Nu, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t;) {
        var n = 31 - rt(t),
          r = 1 << n;
        e[n] = -1, t &= ~r;
      }
    }
    function ac(e) {
      if (0 != (6 & Mu)) throw Error(n(327));
      wc();
      var t = ct(e, 0);
      if (0 == (1 & t)) return tc(e, Ye()), null;
      var r = pc(e, t);
      if (0 !== e.tag && 2 === r) {
        var i = dt(e);
        0 !== i && (t = i, r = rc(e, i));
      }
      if (1 === r) throw r = Ou, lc(e, 0), oc(e, t), tc(e, Ye()), r;
      if (6 === r) throw Error(n(345));
      return e.finishedWork = e.current.alternate, e.finishedLanes = t, yc(e, ju, Uu), tc(e, Ye()), null;
    }
    function sc(e, t) {
      var n = Mu;
      Mu |= 1;
      try {
        return e(t);
      } finally {
        0 === (Mu = n) && (zu = Ye() + 500, Di && Fi());
      }
    }
    function uc(e) {
      null !== $u && 0 === $u.tag && 0 == (6 & Mu) && wc();
      var t = Mu;
      Mu |= 1;
      var n = ku.transition,
        r = gt;
      try {
        if (ku.transition = null, gt = 1, e) return e();
      } finally {
        gt = r, ku.transition = n, 0 == (6 & (Mu = t)) && Fi();
      }
    }
    function cc() {
      Iu = Tu.current, _i(Tu);
    }
    function lc(e, t) {
      e.finishedWork = null, e.finishedLanes = 0;
      var n = e.timeoutHandle;
      if (-1 !== n && (e.timeoutHandle = -1, ti(n)), null !== xu) for (n = xu.return; null !== n;) {
        var r = n;
        switch (Ji(r), r.tag) {
          case 1:
            null != (r = r.type.childContextTypes) && Ii();
            break;
          case 3:
            na(), _i(Mi), _i(ki), ua();
            break;
          case 5:
            ia(r);
            break;
          case 4:
            na();
            break;
          case 13:
          case 19:
            _i(oa);
            break;
          case 10:
            wo(r.type._context);
            break;
          case 22:
          case 23:
            cc();
        }
        n = n.return;
      }
      if (Cu = e, xu = e = Tc(e.current, null), Ru = Iu = t, Pu = 0, Ou = null, Du = Nu = Lu = 0, ju = Bu = null, null !== So) {
        for (t = 0; t < So.length; t++) if (null !== (r = (n = So[t]).interleaved)) {
          n.interleaved = null;
          var i = r.next,
            o = n.pending;
          if (null !== o) {
            var a = o.next;
            o.next = i, r.next = a;
          }
          n.pending = r;
        }
        So = null;
      }
      return e;
    }
    function dc(e, t) {
      for (;;) {
        var r = xu;
        try {
          if (yo(), ca.current = rs, ma) {
            for (var i = fa.memoizedState; null !== i;) {
              var o = i.queue;
              null !== o && (o.pending = null), i = i.next;
            }
            ma = !1;
          }
          if (da = 0, pa = ha = fa = null, ga = !1, va = 0, Su.current = null, null === r || null === r.return) {
            Pu = 1, Ou = t, xu = null;
            break;
          }
          e: {
            var a = e,
              s = r.return,
              u = r,
              c = t;
            if (t = Ru, u.flags |= 32768, null !== c && "object" == typeof c && "function" == typeof c.then) {
              var l = c,
                d = u,
                f = d.tag;
              if (0 == (1 & d.mode) && (0 === f || 11 === f || 15 === f)) {
                var h = d.alternate;
                h ? (d.updateQueue = h.updateQueue, d.memoizedState = h.memoizedState, d.lanes = h.lanes) : (d.updateQueue = null, d.memoizedState = null);
              }
              var p = ps(s);
              if (null !== p) {
                p.flags &= -257, ms(p, s, u, 0, t), 1 & p.mode && hs(a, l, t), c = l;
                var m = (t = p).updateQueue;
                if (null === m) {
                  var g = new Set();
                  g.add(c), t.updateQueue = g;
                } else m.add(c);
                break e;
              }
              if (0 == (1 & t)) {
                hs(a, l, t), hc();
                break e;
              }
              c = Error(n(426));
            } else if (to && 1 & u.mode) {
              var v = ps(s);
              if (null !== v) {
                0 == (65536 & v.flags) && (v.flags |= 256), ms(v, s, u, 0, t), fo(ss(c, u));
                break e;
              }
            }
            a = c = ss(c, u), 4 !== Pu && (Pu = 2), null === Bu ? Bu = [a] : Bu.push(a), a = s;
            do {
              switch (a.tag) {
                case 3:
                  a.flags |= 65536, t &= -t, a.lanes |= t, Lo(a, ds(0, c, t));
                  break e;
                case 1:
                  u = c;
                  var b = a.type,
                    y = a.stateNode;
                  if (0 == (128 & a.flags) && ("function" == typeof b.getDerivedStateFromError || null !== y && "function" == typeof y.componentDidCatch && (null === Hu || !Hu.has(y)))) {
                    a.flags |= 65536, t &= -t, a.lanes |= t, Lo(a, fs(a, u, t));
                    break e;
                  }
              }
              a = a.return;
            } while (null !== a);
          }
          bc(r);
        } catch (e) {
          t = e, xu === r && null !== r && (xu = r = r.return);
          continue;
        }
        break;
      }
    }
    function fc() {
      var e = Eu.current;
      return Eu.current = rs, null === e ? rs : e;
    }
    function hc() {
      0 !== Pu && 3 !== Pu && 2 !== Pu || (Pu = 4), null === Cu || 0 == (268435455 & Lu) && 0 == (268435455 & Nu) || oc(Cu, Ru);
    }
    function pc(e, t) {
      var r = Mu;
      Mu |= 2;
      var i = fc();
      for (Cu === e && Ru === t || (Uu = null, lc(e, t));;) try {
        mc();
        break;
      } catch (t) {
        dc(e, t);
      }
      if (yo(), Mu = r, Eu.current = i, null !== xu) throw Error(n(261));
      return Cu = null, Ru = 0, Pu;
    }
    function mc() {
      for (; null !== xu;) vc(xu);
    }
    function gc() {
      for (; null !== xu && !$e();) vc(xu);
    }
    function vc(e) {
      var t = Au(e.alternate, e, Iu);
      e.memoizedProps = e.pendingProps, null === t ? bc(e) : xu = t, Su.current = null;
    }
    function bc(e) {
      var t = e;
      do {
        var n = t.alternate;
        if (e = t.return, 0 == (32768 & t.flags)) {
          if (null !== (n = Vs(n, t, Iu))) return void (xu = n);
        } else {
          if (null !== (n = $s(n, t))) return n.flags &= 32767, void (xu = n);
          if (null === e) return Pu = 6, void (xu = null);
          e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
        }
        if (null !== (t = t.sibling)) return void (xu = t);
        xu = t = e;
      } while (null !== t);
      0 === Pu && (Pu = 5);
    }
    function yc(e, t, r) {
      var i = gt,
        o = ku.transition;
      try {
        ku.transition = null, gt = 1, function (e, t, r, i) {
          do {
            wc();
          } while (null !== $u);
          if (0 != (6 & Mu)) throw Error(n(327));
          r = e.finishedWork;
          var o = e.finishedLanes;
          if (null === r) return null;
          if (e.finishedWork = null, e.finishedLanes = 0, r === e.current) throw Error(n(177));
          e.callbackNode = null, e.callbackPriority = 0;
          var a = r.lanes | r.childLanes;
          if (function (e, t) {
            var n = e.pendingLanes & ~t;
            e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
            var r = e.eventTimes;
            for (e = e.expirationTimes; 0 < n;) {
              var i = 31 - rt(n),
                o = 1 << i;
              t[i] = 0, r[i] = -1, e[i] = -1, n &= ~o;
            }
          }(e, a), e === Cu && (xu = Cu = null, Ru = 0), 0 == (2064 & r.subtreeFlags) && 0 == (2064 & r.flags) || Vu || (Vu = !0, Cc(Je, function () {
            return wc(), null;
          })), a = 0 != (15990 & r.flags), 0 != (15990 & r.subtreeFlags) || a) {
            a = ku.transition, ku.transition = null;
            var s = gt;
            gt = 1;
            var u = Mu;
            Mu |= 4, Su.current = null, function (e, t) {
              if (Zr = Ut, lr(e = cr())) {
                if ("selectionStart" in e) var r = {
                  start: e.selectionStart,
                  end: e.selectionEnd
                };else e: {
                  var i = (r = (r = e.ownerDocument) && r.defaultView || window).getSelection && r.getSelection();
                  if (i && 0 !== i.rangeCount) {
                    r = i.anchorNode;
                    var o = i.anchorOffset,
                      a = i.focusNode;
                    i = i.focusOffset;
                    try {
                      r.nodeType, a.nodeType;
                    } catch (e) {
                      r = null;
                      break e;
                    }
                    var s = 0,
                      u = -1,
                      c = -1,
                      l = 0,
                      d = 0,
                      f = e,
                      h = null;
                    t: for (;;) {
                      for (var p; f !== r || 0 !== o && 3 !== f.nodeType || (u = s + o), f !== a || 0 !== i && 3 !== f.nodeType || (c = s + i), 3 === f.nodeType && (s += f.nodeValue.length), null !== (p = f.firstChild);) h = f, f = p;
                      for (;;) {
                        if (f === e) break t;
                        if (h === r && ++l === o && (u = s), h === a && ++d === i && (c = s), null !== (p = f.nextSibling)) break;
                        h = (f = h).parentNode;
                      }
                      f = p;
                    }
                    r = -1 === u || -1 === c ? null : {
                      start: u,
                      end: c
                    };
                  } else r = null;
                }
                r = r || {
                  start: 0,
                  end: 0
                };
              } else r = null;
              for (Jr = {
                focusedElem: e,
                selectionRange: r
              }, Ut = !1, Qs = t; null !== Qs;) if (e = (t = Qs).child, 0 != (1028 & t.subtreeFlags) && null !== e) e.return = t, Qs = e;else for (; null !== Qs;) {
                t = Qs;
                try {
                  var m = t.alternate;
                  if (0 != (1024 & t.flags)) switch (t.tag) {
                    case 0:
                    case 11:
                    case 15:
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                      break;
                    case 1:
                      if (null !== m) {
                        var g = m.memoizedProps,
                          v = m.memoizedState,
                          b = t.stateNode,
                          y = b.getSnapshotBeforeUpdate(t.elementType === t.type ? g : po(t.type, g), v);
                        b.__reactInternalSnapshotBeforeUpdate = y;
                      }
                      break;
                    case 3:
                      var w = t.stateNode.containerInfo;
                      1 === w.nodeType ? w.textContent = "" : 9 === w.nodeType && w.documentElement && w.removeChild(w.documentElement);
                      break;
                    default:
                      throw Error(n(163));
                  }
                } catch (e) {
                  _c(t, t.return, e);
                }
                if (null !== (e = t.sibling)) {
                  e.return = t.return, Qs = e;
                  break;
                }
                Qs = t.return;
              }
              m = Xs, Xs = !1;
            }(e, r), pu(r, e), dr(Jr), Ut = !!Zr, Jr = Zr = null, e.current = r, gu(r), We(), Mu = u, gt = s, ku.transition = a;
          } else e.current = r;
          if (Vu && (Vu = !1, $u = e, Wu = o), a = e.pendingLanes, 0 === a && (Hu = null), function (e) {
            if (nt && "function" == typeof nt.onCommitFiberRoot) try {
              nt.onCommitFiberRoot(tt, e, void 0, 128 == (128 & e.current.flags));
            } catch (e) {}
          }(r.stateNode), tc(e, Ye()), null !== t) for (i = e.onRecoverableError, r = 0; r < t.length; r++) o = t[r], i(o.value, {
            componentStack: o.stack,
            digest: o.digest
          });
          if (qu) throw qu = !1, e = Ku, Ku = null, e;
          0 != (1 & Wu) && 0 !== e.tag && wc(), a = e.pendingLanes, 0 != (1 & a) ? e === Gu ? Yu++ : (Yu = 0, Gu = e) : Yu = 0, Fi();
        }(e, t, r, i);
      } finally {
        ku.transition = o, gt = i;
      }
      return null;
    }
    function wc() {
      if (null !== $u) {
        var e = vt(Wu),
          t = ku.transition,
          r = gt;
        try {
          if (ku.transition = null, gt = 16 > e ? 16 : e, null === $u) var i = !1;else {
            if (e = $u, $u = null, Wu = 0, 0 != (6 & Mu)) throw Error(n(331));
            var o = Mu;
            for (Mu |= 4, Qs = e.current; null !== Qs;) {
              var a = Qs,
                s = a.child;
              if (0 != (16 & Qs.flags)) {
                var u = a.deletions;
                if (null !== u) {
                  for (var c = 0; c < u.length; c++) {
                    var l = u[c];
                    for (Qs = l; null !== Qs;) {
                      var d = Qs;
                      switch (d.tag) {
                        case 0:
                        case 11:
                        case 15:
                          eu(8, d, a);
                      }
                      var f = d.child;
                      if (null !== f) f.return = d, Qs = f;else for (; null !== Qs;) {
                        var h = (d = Qs).sibling,
                          p = d.return;
                        if (ru(d), d === l) {
                          Qs = null;
                          break;
                        }
                        if (null !== h) {
                          h.return = p, Qs = h;
                          break;
                        }
                        Qs = p;
                      }
                    }
                  }
                  var m = a.alternate;
                  if (null !== m) {
                    var g = m.child;
                    if (null !== g) {
                      m.child = null;
                      do {
                        var v = g.sibling;
                        g.sibling = null, g = v;
                      } while (null !== g);
                    }
                  }
                  Qs = a;
                }
              }
              if (0 != (2064 & a.subtreeFlags) && null !== s) s.return = a, Qs = s;else e: for (; null !== Qs;) {
                if (0 != (2048 & (a = Qs).flags)) switch (a.tag) {
                  case 0:
                  case 11:
                  case 15:
                    eu(9, a, a.return);
                }
                var b = a.sibling;
                if (null !== b) {
                  b.return = a.return, Qs = b;
                  break e;
                }
                Qs = a.return;
              }
            }
            var y = e.current;
            for (Qs = y; null !== Qs;) {
              var w = (s = Qs).child;
              if (0 != (2064 & s.subtreeFlags) && null !== w) w.return = s, Qs = w;else e: for (s = y; null !== Qs;) {
                if (0 != (2048 & (u = Qs).flags)) try {
                  switch (u.tag) {
                    case 0:
                    case 11:
                    case 15:
                      tu(9, u);
                  }
                } catch (e) {
                  _c(u, u.return, e);
                }
                if (u === s) {
                  Qs = null;
                  break e;
                }
                var A = u.sibling;
                if (null !== A) {
                  A.return = u.return, Qs = A;
                  break e;
                }
                Qs = u.return;
              }
            }
            if (Mu = o, Fi(), nt && "function" == typeof nt.onPostCommitFiberRoot) try {
              nt.onPostCommitFiberRoot(tt, e);
            } catch (e) {}
            i = !0;
          }
          return i;
        } finally {
          gt = r, ku.transition = t;
        }
      }
      return !1;
    }
    function Ac(e, t, n) {
      e = Po(e, t = ds(0, t = ss(n, t), 1), 1), t = Ju(), null !== e && (pt(e, 1, t), tc(e, t));
    }
    function _c(e, t, n) {
      if (3 === e.tag) Ac(e, e, n);else for (; null !== t;) {
        if (3 === t.tag) {
          Ac(t, e, n);
          break;
        }
        if (1 === t.tag) {
          var r = t.stateNode;
          if ("function" == typeof t.type.getDerivedStateFromError || "function" == typeof r.componentDidCatch && (null === Hu || !Hu.has(r))) {
            t = Po(t, e = fs(t, e = ss(n, e), 1), 1), e = Ju(), null !== t && (pt(t, 1, e), tc(t, e));
            break;
          }
        }
        t = t.return;
      }
    }
    function Ec(e, t, n) {
      var r = e.pingCache;
      null !== r && r.delete(t), t = Ju(), e.pingedLanes |= e.suspendedLanes & n, Cu === e && (Ru & n) === n && (4 === Pu || 3 === Pu && (130023424 & Ru) === Ru && 500 > Ye() - Fu ? lc(e, 0) : Du |= n), tc(e, t);
    }
    function Sc(e, t) {
      0 === t && (0 == (1 & e.mode) ? t = 1 : (t = st, 0 == (130023424 & (st <<= 1)) && (st = 4194304)));
      var n = Ju();
      null !== (e = Co(e, t)) && (pt(e, t, n), tc(e, n));
    }
    function kc(e) {
      var t = e.memoizedState,
        n = 0;
      null !== t && (n = t.retryLane), Sc(e, n);
    }
    function Mc(e, t) {
      var r = 0;
      switch (e.tag) {
        case 13:
          var i = e.stateNode,
            o = e.memoizedState;
          null !== o && (r = o.retryLane);
          break;
        case 19:
          i = e.stateNode;
          break;
        default:
          throw Error(n(314));
      }
      null !== i && i.delete(t), Sc(e, r);
    }
    function Cc(e, t) {
      return He(e, t);
    }
    function xc(e, t, n, r) {
      this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
    }
    function Rc(e, t, n, r) {
      return new xc(e, t, n, r);
    }
    function Ic(e) {
      return !(!(e = e.prototype) || !e.isReactComponent);
    }
    function Tc(e, t) {
      var n = e.alternate;
      return null === n ? ((n = Rc(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = 14680064 & e.flags, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = null === t ? null : {
        lanes: t.lanes,
        firstContext: t.firstContext
      }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
    }
    function Pc(e, t, r, i, o, a) {
      var s = 2;
      if (i = e, "function" == typeof e) Ic(e) && (s = 1);else if ("string" == typeof e) s = 5;else e: switch (e) {
        case w:
          return Oc(r.children, o, a, t);
        case A:
          s = 8, o |= 8;
          break;
        case _:
          return (e = Rc(12, r, t, 2 | o)).elementType = _, e.lanes = a, e;
        case M:
          return (e = Rc(13, r, t, o)).elementType = M, e.lanes = a, e;
        case C:
          return (e = Rc(19, r, t, o)).elementType = C, e.lanes = a, e;
        case I:
          return Lc(r, o, a, t);
        default:
          if ("object" == typeof e && null !== e) switch (e.$$typeof) {
            case E:
              s = 10;
              break e;
            case S:
              s = 9;
              break e;
            case k:
              s = 11;
              break e;
            case x:
              s = 14;
              break e;
            case R:
              s = 16, i = null;
              break e;
          }
          throw Error(n(130, null == e ? e : typeof e, ""));
      }
      return (t = Rc(s, r, t, o)).elementType = e, t.type = i, t.lanes = a, t;
    }
    function Oc(e, t, n, r) {
      return (e = Rc(7, e, r, t)).lanes = n, e;
    }
    function Lc(e, t, n, r) {
      return (e = Rc(22, e, r, t)).elementType = I, e.lanes = n, e.stateNode = {
        isHidden: !1
      }, e;
    }
    function Nc(e, t, n) {
      return (e = Rc(6, e, null, t)).lanes = n, e;
    }
    function Dc(e, t, n) {
      return (t = Rc(4, null !== e.children ? e.children : [], e.key, t)).lanes = n, t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation
      }, t;
    }
    function Bc(e, t, n, r, i) {
      this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = ht(0), this.expirationTimes = ht(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ht(0), this.identifierPrefix = r, this.onRecoverableError = i, this.mutableSourceEagerHydrationData = null;
    }
    function jc(e, t, n, r, i, o, a, s, u) {
      return e = new Bc(e, t, n, s, u), 1 === t ? (t = 1, !0 === o && (t |= 8)) : t = 0, o = Rc(3, null, null, t), e.current = o, o.stateNode = e, o.memoizedState = {
        element: r,
        isDehydrated: n,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
      }, Ro(o), e;
    }
    function Fc(e) {
      if (!e) return Si;
      e: {
        if (Fe(e = e._reactInternals) !== e || 1 !== e.tag) throw Error(n(170));
        var t = e;
        do {
          switch (t.tag) {
            case 3:
              t = t.stateNode.context;
              break e;
            case 1:
              if (Ri(t.type)) {
                t = t.stateNode.__reactInternalMemoizedMergedChildContext;
                break e;
              }
          }
          t = t.return;
        } while (null !== t);
        throw Error(n(171));
      }
      if (1 === e.tag) {
        var r = e.type;
        if (Ri(r)) return Pi(e, r, t);
      }
      return t;
    }
    function zc(e, t, n, r, i, o, a, s, u) {
      return (e = jc(n, r, !0, e, 0, o, 0, s, u)).context = Fc(null), n = e.current, (o = To(r = Ju(), i = Xu(n))).callback = null != t ? t : null, Po(n, o, i), e.current.lanes = i, pt(e, i, r), tc(e, r), e;
    }
    function Uc(e, t, n, r) {
      var i = t.current,
        o = Ju(),
        a = Xu(i);
      return n = Fc(n), null === t.context ? t.context = n : t.pendingContext = n, (t = To(o, a)).payload = {
        element: e
      }, null !== (r = void 0 === r ? null : r) && (t.callback = r), null !== (e = Po(i, t, a)) && (ec(e, i, a, o), Oo(e, i, a)), a;
    }
    function qc(e) {
      return (e = e.current).child ? (e.child.tag, e.child.stateNode) : null;
    }
    function Kc(e, t) {
      if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
        var n = e.retryLane;
        e.retryLane = 0 !== n && n < t ? n : t;
      }
    }
    function Hc(e, t) {
      Kc(e, t), (e = e.alternate) && Kc(e, t);
    }
    Au = function (e, t, r) {
      if (null !== e) {
        if (e.memoizedProps !== t.pendingProps || Mi.current) vs = !0;else {
          if (0 == (e.lanes & r) && 0 == (128 & t.flags)) return vs = !1, function (e, t, n) {
            switch (t.tag) {
              case 3:
                Cs(t), lo();
                break;
              case 5:
                ra(t);
                break;
              case 1:
                Ri(t.type) && Oi(t);
                break;
              case 4:
                ta(t, t.stateNode.containerInfo);
                break;
              case 10:
                var r = t.type._context,
                  i = t.memoizedProps.value;
                Ei(mo, r._currentValue), r._currentValue = i;
                break;
              case 13:
                if (null !== (r = t.memoizedState)) return null !== r.dehydrated ? (Ei(oa, 1 & oa.current), t.flags |= 128, null) : 0 != (n & t.child.childLanes) ? Ns(e, t, n) : (Ei(oa, 1 & oa.current), null !== (e = qs(e, t, n)) ? e.sibling : null);
                Ei(oa, 1 & oa.current);
                break;
              case 19:
                if (r = 0 != (n & t.childLanes), 0 != (128 & e.flags)) {
                  if (r) return zs(e, t, n);
                  t.flags |= 128;
                }
                if (null !== (i = t.memoizedState) && (i.rendering = null, i.tail = null, i.lastEffect = null), Ei(oa, oa.current), r) break;
                return null;
              case 22:
              case 23:
                return t.lanes = 0, _s(e, t, n);
            }
            return qs(e, t, n);
          }(e, t, r);
          vs = 0 != (131072 & e.flags);
        }
      } else vs = !1, to && 0 != (1048576 & t.flags) && Qi(t, Ki, t.index);
      switch (t.lanes = 0, t.tag) {
        case 2:
          var i = t.type;
          Us(e, t), e = t.pendingProps;
          var o = xi(t, ki.current);
          _o(t, r), o = Aa(null, t, i, e, o, r);
          var a = _a();
          return t.flags |= 1, "object" == typeof o && null !== o && "function" == typeof o.render && void 0 === o.$$typeof ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, Ri(i) ? (a = !0, Oi(t)) : a = !1, t.memoizedState = null !== o.state && void 0 !== o.state ? o.state : null, Ro(t), o.updater = Fo, t.stateNode = o, o._reactInternals = t, Ko(t, i, e, r), t = Ms(null, t, i, !0, a, r)) : (t.tag = 0, to && a && Zi(t), bs(null, t, o, r), t = t.child), t;
        case 16:
          i = t.elementType;
          e: {
            switch (Us(e, t), e = t.pendingProps, i = (o = i._init)(i._payload), t.type = i, o = t.tag = function (e) {
              if ("function" == typeof e) return Ic(e) ? 1 : 0;
              if (null != e) {
                if ((e = e.$$typeof) === k) return 11;
                if (e === x) return 14;
              }
              return 2;
            }(i), e = po(i, e), o) {
              case 0:
                t = Ss(null, t, i, e, r);
                break e;
              case 1:
                t = ks(null, t, i, e, r);
                break e;
              case 11:
                t = ys(null, t, i, e, r);
                break e;
              case 14:
                t = ws(null, t, i, po(i.type, e), r);
                break e;
            }
            throw Error(n(306, i, ""));
          }
          return t;
        case 0:
          return i = t.type, o = t.pendingProps, Ss(e, t, i, o = t.elementType === i ? o : po(i, o), r);
        case 1:
          return i = t.type, o = t.pendingProps, ks(e, t, i, o = t.elementType === i ? o : po(i, o), r);
        case 3:
          e: {
            if (Cs(t), null === e) throw Error(n(387));
            i = t.pendingProps, o = (a = t.memoizedState).element, Io(e, t), No(t, i, null, r);
            var s = t.memoizedState;
            if (i = s.element, a.isDehydrated) {
              if (a = {
                element: i,
                isDehydrated: !1,
                cache: s.cache,
                pendingSuspenseBoundaries: s.pendingSuspenseBoundaries,
                transitions: s.transitions
              }, t.updateQueue.baseState = a, t.memoizedState = a, 256 & t.flags) {
                t = xs(e, t, i, r, o = ss(Error(n(423)), t));
                break e;
              }
              if (i !== o) {
                t = xs(e, t, i, r, o = ss(Error(n(424)), t));
                break e;
              }
              for (eo = ai(t.stateNode.containerInfo.firstChild), Xi = t, to = !0, no = null, r = Go(t, null, i, r), t.child = r; r;) r.flags = -3 & r.flags | 4096, r = r.sibling;
            } else {
              if (lo(), i === o) {
                t = qs(e, t, r);
                break e;
              }
              bs(e, t, i, r);
            }
            t = t.child;
          }
          return t;
        case 5:
          return ra(t), null === e && ao(t), i = t.type, o = t.pendingProps, a = null !== e ? e.memoizedProps : null, s = o.children, Xr(i, o) ? s = null : null !== a && Xr(i, a) && (t.flags |= 32), Es(e, t), bs(e, t, s, r), t.child;
        case 6:
          return null === e && ao(t), null;
        case 13:
          return Ns(e, t, r);
        case 4:
          return ta(t, t.stateNode.containerInfo), i = t.pendingProps, null === e ? t.child = Yo(t, null, i, r) : bs(e, t, i, r), t.child;
        case 11:
          return i = t.type, o = t.pendingProps, ys(e, t, i, o = t.elementType === i ? o : po(i, o), r);
        case 7:
          return bs(e, t, t.pendingProps, r), t.child;
        case 8:
        case 12:
          return bs(e, t, t.pendingProps.children, r), t.child;
        case 10:
          e: {
            if (i = t.type._context, o = t.pendingProps, a = t.memoizedProps, s = o.value, Ei(mo, i._currentValue), i._currentValue = s, null !== a) if (ir(a.value, s)) {
              if (a.children === o.children && !Mi.current) {
                t = qs(e, t, r);
                break e;
              }
            } else for (null !== (a = t.child) && (a.return = t); null !== a;) {
              var u = a.dependencies;
              if (null !== u) {
                s = a.child;
                for (var c = u.firstContext; null !== c;) {
                  if (c.context === i) {
                    if (1 === a.tag) {
                      (c = To(-1, r & -r)).tag = 2;
                      var l = a.updateQueue;
                      if (null !== l) {
                        var d = (l = l.shared).pending;
                        null === d ? c.next = c : (c.next = d.next, d.next = c), l.pending = c;
                      }
                    }
                    a.lanes |= r, null !== (c = a.alternate) && (c.lanes |= r), Ao(a.return, r, t), u.lanes |= r;
                    break;
                  }
                  c = c.next;
                }
              } else if (10 === a.tag) s = a.type === t.type ? null : a.child;else if (18 === a.tag) {
                if (null === (s = a.return)) throw Error(n(341));
                s.lanes |= r, null !== (u = s.alternate) && (u.lanes |= r), Ao(s, r, t), s = a.sibling;
              } else s = a.child;
              if (null !== s) s.return = a;else for (s = a; null !== s;) {
                if (s === t) {
                  s = null;
                  break;
                }
                if (null !== (a = s.sibling)) {
                  a.return = s.return, s = a;
                  break;
                }
                s = s.return;
              }
              a = s;
            }
            bs(e, t, o.children, r), t = t.child;
          }
          return t;
        case 9:
          return o = t.type, i = t.pendingProps.children, _o(t, r), i = i(o = Eo(o)), t.flags |= 1, bs(e, t, i, r), t.child;
        case 14:
          return o = po(i = t.type, t.pendingProps), ws(e, t, i, o = po(i.type, o), r);
        case 15:
          return As(e, t, t.type, t.pendingProps, r);
        case 17:
          return i = t.type, o = t.pendingProps, o = t.elementType === i ? o : po(i, o), Us(e, t), t.tag = 1, Ri(i) ? (e = !0, Oi(t)) : e = !1, _o(t, r), Uo(t, i, o), Ko(t, i, o, r), Ms(null, t, i, !0, e, r);
        case 19:
          return zs(e, t, r);
        case 22:
          return _s(e, t, r);
      }
      throw Error(n(156, t.tag));
    };
    var Vc = "function" == typeof reportError ? reportError : function (e) {
      console.error(e);
    };
    function $c(e) {
      this._internalRoot = e;
    }
    function Wc(e) {
      this._internalRoot = e;
    }
    function Yc(e) {
      return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType);
    }
    function Gc(e) {
      return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType && (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue));
    }
    function Qc() {}
    function Zc(e, t, n, r, i) {
      var o = n._reactRootContainer;
      if (o) {
        var a = o;
        if ("function" == typeof i) {
          var s = i;
          i = function () {
            var e = qc(a);
            s.call(e);
          };
        }
        Uc(t, a, e, i);
      } else a = function (e, t, n, r, i) {
        if (i) {
          if ("function" == typeof r) {
            var o = r;
            r = function () {
              var e = qc(a);
              o.call(e);
            };
          }
          var a = zc(t, r, e, 0, null, !1, 0, "", Qc);
          return e._reactRootContainer = a, e[di] = a.current, Fr(8 === e.nodeType ? e.parentNode : e), uc(), a;
        }
        for (; i = e.lastChild;) e.removeChild(i);
        if ("function" == typeof r) {
          var s = r;
          r = function () {
            var e = qc(u);
            s.call(e);
          };
        }
        var u = jc(e, 0, !1, null, 0, !1, 0, "", Qc);
        return e._reactRootContainer = u, e[di] = u.current, Fr(8 === e.nodeType ? e.parentNode : e), uc(function () {
          Uc(t, u, n, r);
        }), u;
      }(n, t, e, i, r);
      return qc(a);
    }
    Wc.prototype.render = $c.prototype.render = function (e) {
      var t = this._internalRoot;
      if (null === t) throw Error(n(409));
      Uc(e, t, null, null);
    }, Wc.prototype.unmount = $c.prototype.unmount = function () {
      var e = this._internalRoot;
      if (null !== e) {
        this._internalRoot = null;
        var t = e.containerInfo;
        uc(function () {
          Uc(null, e, null, null);
        }), t[di] = null;
      }
    }, Wc.prototype.unstable_scheduleHydration = function (e) {
      if (e) {
        var t = At();
        e = {
          blockedOn: null,
          target: e,
          priority: t
        };
        for (var n = 0; n < It.length && 0 !== t && t < It[n].priority; n++);
        It.splice(n, 0, e), 0 === n && Lt(e);
      }
    }, bt = function (e) {
      switch (e.tag) {
        case 3:
          var t = e.stateNode;
          if (t.current.memoizedState.isDehydrated) {
            var n = ut(t.pendingLanes);
            0 !== n && (mt(t, 1 | n), tc(t, Ye()), 0 == (6 & Mu) && (zu = Ye() + 500, Fi()));
          }
          break;
        case 13:
          uc(function () {
            var t = Co(e, 1);
            if (null !== t) {
              var n = Ju();
              ec(t, e, 1, n);
            }
          }), Hc(e, 1);
      }
    }, yt = function (e) {
      if (13 === e.tag) {
        var t = Co(e, 134217728);
        if (null !== t) ec(t, e, 134217728, Ju());
        Hc(e, 134217728);
      }
    }, wt = function (e) {
      if (13 === e.tag) {
        var t = Xu(e),
          n = Co(e, t);
        if (null !== n) ec(n, e, t, Ju());
        Hc(e, t);
      }
    }, At = function () {
      return gt;
    }, _t = function (e, t) {
      var n = gt;
      try {
        return gt = e, t();
      } finally {
        gt = n;
      }
    }, ye = function (e, t, r) {
      switch (t) {
        case "input":
          if (G(e, r), t = r.name, "radio" === r.type && null != t) {
            for (r = e; r.parentNode;) r = r.parentNode;
            for (r = r.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < r.length; t++) {
              var i = r[t];
              if (i !== e && i.form === e.form) {
                var o = bi(i);
                if (!o) throw Error(n(90));
                H(i), G(i, o);
              }
            }
          }
          break;
        case "textarea":
          ne(e, r);
          break;
        case "select":
          null != (t = r.value) && X(e, !!r.multiple, t, !1);
      }
    }, ke = sc, Me = uc;
    var Jc = {
        usingClientEntryPoint: !1,
        Events: [gi, vi, bi, Ee, Se, sc]
      },
      Xc = {
        findFiberByHostInstance: mi,
        bundleType: 0,
        version: "18.2.0",
        rendererPackageName: "react-dom"
      },
      el = {
        bundleType: Xc.bundleType,
        version: Xc.version,
        rendererPackageName: Xc.rendererPackageName,
        rendererConfig: Xc.rendererConfig,
        overrideHookState: null,
        overrideHookStateDeletePath: null,
        overrideHookStateRenamePath: null,
        overrideProps: null,
        overridePropsDeletePath: null,
        overridePropsRenamePath: null,
        setErrorHandler: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: v.ReactCurrentDispatcher,
        findHostInstanceByFiber: function (e) {
          return null === (e = qe(e)) ? null : e.stateNode;
        },
        findFiberByHostInstance: Xc.findFiberByHostInstance || function () {
          return null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null,
        reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
      };
    if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
      var tl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (!tl.isDisabled && tl.supportsFiber) try {
        tt = tl.inject(el), nt = tl;
      } catch (se) {}
    }
    return LB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Jc, LB.createPortal = function (e, t) {
      var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
      if (!Yc(t)) throw Error(n(200));
      return function (e, t, n) {
        var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
          $$typeof: y,
          key: null == r ? null : "" + r,
          children: e,
          containerInfo: t,
          implementation: n
        };
      }(e, t, null, r);
    }, LB.createRoot = function (e, t) {
      if (!Yc(e)) throw Error(n(299));
      var r = !1,
        i = "",
        o = Vc;
      return null != t && (!0 === t.unstable_strictMode && (r = !0), void 0 !== t.identifierPrefix && (i = t.identifierPrefix), void 0 !== t.onRecoverableError && (o = t.onRecoverableError)), t = jc(e, 1, !1, null, 0, r, 0, i, o), e[di] = t.current, Fr(8 === e.nodeType ? e.parentNode : e), new $c(t);
    }, LB.findDOMNode = function (e) {
      if (null == e) return null;
      if (1 === e.nodeType) return e;
      var t = e._reactInternals;
      if (void 0 === t) {
        if ("function" == typeof e.render) throw Error(n(188));
        throw e = Object.keys(e).join(","), Error(n(268, e));
      }
      return e = null === (e = qe(t)) ? null : e.stateNode;
    }, LB.flushSync = function (e) {
      return uc(e);
    }, LB.hydrate = function (e, t, r) {
      if (!Gc(t)) throw Error(n(200));
      return Zc(null, e, t, !0, r);
    }, LB.hydrateRoot = function (e, t, r) {
      if (!Yc(e)) throw Error(n(405));
      var i = null != r && r.hydratedSources || null,
        o = !1,
        a = "",
        s = Vc;
      if (null != r && (!0 === r.unstable_strictMode && (o = !0), void 0 !== r.identifierPrefix && (a = r.identifierPrefix), void 0 !== r.onRecoverableError && (s = r.onRecoverableError)), t = zc(t, null, e, 1, null != r ? r : null, o, 0, a, s), e[di] = t.current, Fr(e), i) for (e = 0; e < i.length; e++) o = (o = (r = i[e])._getVersion)(r._source), null == t.mutableSourceEagerHydrationData ? t.mutableSourceEagerHydrationData = [r, o] : t.mutableSourceEagerHydrationData.push(r, o);
      return new Wc(t);
    }, LB.render = function (e, t, r) {
      if (!Gc(t)) throw Error(n(200));
      return Zc(null, e, t, !1, r);
    }, LB.unmountComponentAtNode = function (e) {
      if (!Gc(e)) throw Error(n(40));
      return !!e._reactRootContainer && (uc(function () {
        Zc(null, null, e, !1, function () {
          e._reactRootContainer = null, e[di] = null;
        });
      }), !0);
    }, LB.unstable_batchedUpdates = sc, LB.unstable_renderSubtreeIntoContainer = function (e, t, r, i) {
      if (!Gc(r)) throw Error(n(200));
      if (null == e || void 0 === e._reactInternals) throw Error(n(38));
      return Zc(e, t, r, !1, i);
    }, LB.version = "18.2.0-next-9e3b772b8-20220608", LB;
  }
  var HB,
    VB,
    $B,
    WB = {};
  function YB() {
    return HB || (HB = 1, "production" !== Be.env.NODE_ENV && function () {
      "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var e = IB(),
        t = qB(),
        n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
        r = !1;
      function i(e) {
        if (!r) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) n[i - 1] = arguments[i];
          a("warn", e, n);
        }
      }
      function o(e) {
        if (!r) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) n[i - 1] = arguments[i];
          a("error", e, n);
        }
      }
      function a(e, t, r) {
        var i = n.ReactDebugCurrentFrame.getStackAddendum();
        "" !== i && (t += "%s", r = r.concat([i]));
        var o = r.map(function (e) {
          return String(e);
        });
        o.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, o);
      }
      var s = 0,
        u = 1,
        c = 2,
        l = 3,
        d = 4,
        f = 5,
        h = 6,
        p = 7,
        m = 8,
        g = 9,
        v = 10,
        b = 11,
        y = 12,
        w = 13,
        A = 14,
        _ = 15,
        E = 16,
        S = 17,
        k = 18,
        M = 19,
        C = 21,
        x = 22,
        R = 23,
        I = 24,
        T = 25,
        P = !0,
        O = !1,
        L = !1,
        N = !1,
        D = !1,
        B = !0,
        j = !1,
        F = !1,
        z = !0,
        U = !0,
        q = !0,
        K = new Set(),
        H = {},
        V = {};
      function $(e, t) {
        W(e, t), W(e + "Capture", t);
      }
      function W(e, t) {
        H[e] && o("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), H[e] = t;
        var n = e.toLowerCase();
        V[n] = e, "onDoubleClick" === e && (V.ondblclick = e);
        for (var r = 0; r < t.length; r++) K.add(t[r]);
      }
      var Y = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement),
        G = Object.prototype.hasOwnProperty;
      function Q(e) {
        return "function" == typeof Symbol && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
      }
      function Z(e) {
        try {
          return J(e), !1;
        } catch (e) {
          return !0;
        }
      }
      function J(e) {
        return "" + e;
      }
      function X(e, t) {
        if (Z(e)) return o("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", t, Q(e)), J(e);
      }
      function ee(e) {
        if (Z(e)) return o("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Q(e)), J(e);
      }
      var te = 0,
        ne = 3,
        re = 4,
        ie = 5,
        oe = 6,
        ae = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",
        se = ae + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
        ue = new RegExp("^[" + ae + "][" + se + "]*$"),
        ce = {},
        le = {};
      function de(e) {
        return !!G.call(le, e) || !G.call(ce, e) && (ue.test(e) ? (le[e] = !0, !0) : (ce[e] = !0, o("Invalid attribute name: `%s`", e), !1));
      }
      function fe(e, t, n) {
        return null !== t ? t.type === te : !n && e.length > 2 && ("o" === e[0] || "O" === e[0]) && ("n" === e[1] || "N" === e[1]);
      }
      function he(e, t, n, r) {
        if (null !== n && n.type === te) return !1;
        switch (typeof t) {
          case "function":
          case "symbol":
            return !0;
          case "boolean":
            if (r) return !1;
            if (null !== n) return !n.acceptsBooleans;
            var i = e.toLowerCase().slice(0, 5);
            return "data-" !== i && "aria-" !== i;
          default:
            return !1;
        }
      }
      function pe(e, t, n, r) {
        if (null == t) return !0;
        if (he(e, t, n, r)) return !0;
        if (r) return !1;
        if (null !== n) switch (n.type) {
          case ne:
            return !t;
          case re:
            return !1 === t;
          case ie:
            return isNaN(t);
          case oe:
            return isNaN(t) || t < 1;
        }
        return !1;
      }
      function me(e) {
        return ve.hasOwnProperty(e) ? ve[e] : null;
      }
      function ge(e, t, n, r, i, o, a) {
        this.acceptsBooleans = 2 === t || t === ne || t === re, this.attributeName = r, this.attributeNamespace = i, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o, this.removeEmptyString = a;
      }
      var ve = {};
      ["children", "dangerouslySetInnerHTML", "defaultValue", "defaultChecked", "innerHTML", "suppressContentEditableWarning", "suppressHydrationWarning", "style"].forEach(function (e) {
        ve[e] = new ge(e, te, !1, e, null, !1, !1);
      }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
        var t = e[0],
          n = e[1];
        ve[t] = new ge(t, 1, !1, n, null, !1, !1);
      }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
        ve[e] = new ge(e, 2, !1, e.toLowerCase(), null, !1, !1);
      }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
        ve[e] = new ge(e, 2, !1, e, null, !1, !1);
      }), ["allowFullScreen", "async", "autoFocus", "autoPlay", "controls", "default", "defer", "disabled", "disablePictureInPicture", "disableRemotePlayback", "formNoValidate", "hidden", "loop", "noModule", "noValidate", "open", "playsInline", "readOnly", "required", "reversed", "scoped", "seamless", "itemScope"].forEach(function (e) {
        ve[e] = new ge(e, ne, !1, e.toLowerCase(), null, !1, !1);
      }), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
        ve[e] = new ge(e, ne, !0, e, null, !1, !1);
      }), ["capture", "download"].forEach(function (e) {
        ve[e] = new ge(e, re, !1, e, null, !1, !1);
      }), ["cols", "rows", "size", "span"].forEach(function (e) {
        ve[e] = new ge(e, oe, !1, e, null, !1, !1);
      }), ["rowSpan", "start"].forEach(function (e) {
        ve[e] = new ge(e, ie, !1, e.toLowerCase(), null, !1, !1);
      });
      var be = /[\-\:]([a-z])/g,
        ye = function (e) {
          return e[1].toUpperCase();
        };
      ["accent-height", "alignment-baseline", "arabic-form", "baseline-shift", "cap-height", "clip-path", "clip-rule", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "dominant-baseline", "enable-background", "fill-opacity", "fill-rule", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "glyph-name", "glyph-orientation-horizontal", "glyph-orientation-vertical", "horiz-adv-x", "horiz-origin-x", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "overline-position", "overline-thickness", "paint-order", "panose-1", "pointer-events", "rendering-intent", "shape-rendering", "stop-color", "stop-opacity", "strikethrough-position", "strikethrough-thickness", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-rendering", "underline-position", "underline-thickness", "unicode-bidi", "unicode-range", "units-per-em", "v-alphabetic", "v-hanging", "v-ideographic", "v-mathematical", "vector-effect", "vert-adv-y", "vert-origin-x", "vert-origin-y", "word-spacing", "writing-mode", "xmlns:xlink", "x-height"].forEach(function (e) {
        var t = e.replace(be, ye);
        ve[t] = new ge(t, 1, !1, e, null, !1, !1);
      }), ["xlink:actuate", "xlink:arcrole", "xlink:role", "xlink:show", "xlink:title", "xlink:type"].forEach(function (e) {
        var t = e.replace(be, ye);
        ve[t] = new ge(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
      }), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
        var t = e.replace(be, ye);
        ve[t] = new ge(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
      }), ["tabIndex", "crossOrigin"].forEach(function (e) {
        ve[e] = new ge(e, 1, !1, e.toLowerCase(), null, !1, !1);
      });
      ve.xlinkHref = new ge("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function (e) {
        ve[e] = new ge(e, 1, !1, e.toLowerCase(), null, !0, !0);
      });
      var we = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i,
        Ae = !1;
      function _e(e) {
        !Ae && we.test(e) && (Ae = !0, o("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
      }
      function Ee(e, t, n, r) {
        if (r.mustUseProperty) return e[r.propertyName];
        X(n, t), r.sanitizeURL && _e("" + n);
        var i = r.attributeName,
          o = null;
        if (r.type === re) {
          if (e.hasAttribute(i)) {
            var a = e.getAttribute(i);
            return "" === a || (pe(t, n, r, !1) ? a : a === "" + n ? n : a);
          }
        } else if (e.hasAttribute(i)) {
          if (pe(t, n, r, !1)) return e.getAttribute(i);
          if (r.type === ne) return n;
          o = e.getAttribute(i);
        }
        return pe(t, n, r, !1) ? null === o ? n : o : o === "" + n ? n : o;
      }
      function Se(e, t, n, r) {
        if (de(t)) {
          if (!e.hasAttribute(t)) return void 0 === n ? void 0 : null;
          var i = e.getAttribute(t);
          return X(n, t), i === "" + n ? n : i;
        }
      }
      function ke(e, t, n, r) {
        var i = me(t);
        if (!fe(t, i, r)) if (pe(t, n, i, r) && (n = null), r || null === i) {
          if (de(t)) {
            var o = t;
            null === n ? e.removeAttribute(o) : (X(n, t), e.setAttribute(o, "" + n));
          }
        } else if (i.mustUseProperty) {
          var a = i.propertyName;
          if (null === n) {
            var s = i.type;
            e[a] = s !== ne && "";
          } else e[a] = n;
        } else {
          var u = i.attributeName,
            c = i.attributeNamespace;
          if (null === n) e.removeAttribute(u);else {
            var l,
              d = i.type;
            d === ne || d === re && !0 === n ? l = "" : (X(n, u), l = "" + n, i.sanitizeURL && _e(l.toString())), c ? e.setAttributeNS(c, u, l) : e.setAttribute(u, l);
          }
        }
      }
      var Me = Symbol.for("react.element"),
        Ce = Symbol.for("react.portal"),
        xe = Symbol.for("react.fragment"),
        Re = Symbol.for("react.strict_mode"),
        Ie = Symbol.for("react.profiler"),
        Te = Symbol.for("react.provider"),
        Pe = Symbol.for("react.context"),
        Oe = Symbol.for("react.forward_ref"),
        Le = Symbol.for("react.suspense"),
        Ne = Symbol.for("react.suspense_list"),
        De = Symbol.for("react.memo"),
        Be = Symbol.for("react.lazy"),
        je = (Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode"), Symbol.for("react.offscreen")),
        Fe = (Symbol.for("react.legacy_hidden"), Symbol.for("react.cache"), Symbol.for("react.tracing_marker"), Symbol.iterator),
        ze = "@@iterator";
      function Ue(e) {
        if (null === e || "object" != typeof e) return null;
        var t = Fe && e[Fe] || e[ze];
        return "function" == typeof t ? t : null;
      }
      var qe,
        Ke,
        He,
        Ve,
        $e,
        We,
        Ye,
        Ge = Object.assign,
        Qe = 0;
      function Ze() {}
      Ze.__reactDisabledLog = !0;
      var Je,
        Xe = n.ReactCurrentDispatcher;
      function et(e, t, n) {
        if (void 0 === Je) try {
          throw Error();
        } catch (e) {
          var r = e.stack.trim().match(/\n( *(at )?)/);
          Je = r && r[1] || "";
        }
        return "\n" + Je + e;
      }
      var tt,
        nt = !1,
        rt = "function" == typeof WeakMap ? WeakMap : Map;
      function it(e, t) {
        if (!e || nt) return "";
        var n,
          r = tt.get(e);
        if (void 0 !== r) return r;
        nt = !0;
        var i,
          a = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0, i = Xe.current, Xe.current = null, function () {
          if (0 === Qe) {
            qe = console.log, Ke = console.info, He = console.warn, Ve = console.error, $e = console.group, We = console.groupCollapsed, Ye = console.groupEnd;
            var e = {
              configurable: !0,
              enumerable: !0,
              value: Ze,
              writable: !0
            };
            Object.defineProperties(console, {
              info: e,
              log: e,
              warn: e,
              error: e,
              group: e,
              groupCollapsed: e,
              groupEnd: e
            });
          }
          Qe++;
        }();
        try {
          if (t) {
            var s = function () {
              throw Error();
            };
            if (Object.defineProperty(s.prototype, "props", {
              set: function () {
                throw Error();
              }
            }), "object" == typeof Reflect && Reflect.construct) {
              try {
                Reflect.construct(s, []);
              } catch (e) {
                n = e;
              }
              Reflect.construct(e, [], s);
            } else {
              try {
                s.call();
              } catch (e) {
                n = e;
              }
              e.call(s.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (e) {
              n = e;
            }
            e();
          }
        } catch (t) {
          if (t && n && "string" == typeof t.stack) {
            for (var u = t.stack.split("\n"), c = n.stack.split("\n"), l = u.length - 1, d = c.length - 1; l >= 1 && d >= 0 && u[l] !== c[d];) d--;
            for (; l >= 1 && d >= 0; l--, d--) if (u[l] !== c[d]) {
              if (1 !== l || 1 !== d) do {
                if (l--, --d < 0 || u[l] !== c[d]) {
                  var f = "\n" + u[l].replace(" at new ", " at ");
                  return e.displayName && f.includes("<anonymous>") && (f = f.replace("<anonymous>", e.displayName)), "function" == typeof e && tt.set(e, f), f;
                }
              } while (l >= 1 && d >= 0);
              break;
            }
          }
        } finally {
          nt = !1, Xe.current = i, function () {
            if (0 == --Qe) {
              var e = {
                configurable: !0,
                enumerable: !0,
                writable: !0
              };
              Object.defineProperties(console, {
                log: Ge({}, e, {
                  value: qe
                }),
                info: Ge({}, e, {
                  value: Ke
                }),
                warn: Ge({}, e, {
                  value: He
                }),
                error: Ge({}, e, {
                  value: Ve
                }),
                group: Ge({}, e, {
                  value: $e
                }),
                groupCollapsed: Ge({}, e, {
                  value: We
                }),
                groupEnd: Ge({}, e, {
                  value: Ye
                })
              });
            }
            Qe < 0 && o("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }(), Error.prepareStackTrace = a;
        }
        var h = e ? e.displayName || e.name : "",
          p = h ? et(h) : "";
        return "function" == typeof e && tt.set(e, p), p;
      }
      function ot(e, t, n) {
        return it(e, !1);
      }
      function at(e, t, n) {
        if (null == e) return "";
        if ("function" == typeof e) return it(e, !(!(r = e.prototype) || !r.isReactComponent));
        var r;
        if ("string" == typeof e) return et(e);
        switch (e) {
          case Le:
            return et("Suspense");
          case Ne:
            return et("SuspenseList");
        }
        if ("object" == typeof e) switch (e.$$typeof) {
          case Oe:
            return ot(e.render);
          case De:
            return at(e.type, t, n);
          case Be:
            var i = e,
              o = i._payload,
              a = i._init;
            try {
              return at(a(o), t, n);
            } catch (e) {}
        }
        return "";
      }
      function st(e) {
        switch (e._debugOwner && e._debugOwner.type, e._debugSource, e.tag) {
          case f:
            return et(e.type);
          case E:
            return et("Lazy");
          case w:
            return et("Suspense");
          case M:
            return et("SuspenseList");
          case s:
          case c:
          case _:
            return ot(e.type);
          case b:
            return ot(e.type.render);
          case u:
            return it(e.type, !0);
          default:
            return "";
        }
      }
      function ut(e) {
        try {
          var t = "",
            n = e;
          do {
            t += st(n), n = n.return;
          } while (n);
          return t;
        } catch (e) {
          return "\nError generating stack: " + e.message + "\n" + e.stack;
        }
      }
      function ct(e) {
        return e.displayName || "Context";
      }
      function lt(e) {
        if (null == e) return null;
        if ("number" == typeof e.tag && o("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), "function" == typeof e) return e.displayName || e.name || null;
        if ("string" == typeof e) return e;
        switch (e) {
          case xe:
            return "Fragment";
          case Ce:
            return "Portal";
          case Ie:
            return "Profiler";
          case Re:
            return "StrictMode";
          case Le:
            return "Suspense";
          case Ne:
            return "SuspenseList";
        }
        if ("object" == typeof e) switch (e.$$typeof) {
          case Pe:
            return ct(e) + ".Consumer";
          case Te:
            return ct(e._context) + ".Provider";
          case Oe:
            return function (e, t, n) {
              var r = e.displayName;
              if (r) return r;
              var i = t.displayName || t.name || "";
              return "" !== i ? n + "(" + i + ")" : n;
            }(e, e.render, "ForwardRef");
          case De:
            var t = e.displayName || null;
            return null !== t ? t : lt(e.type) || "Memo";
          case Be:
            var n = e,
              r = n._payload,
              i = n._init;
            try {
              return lt(i(r));
            } catch (e) {
              return null;
            }
        }
        return null;
      }
      function dt(e) {
        return e.displayName || "Context";
      }
      function ft(e) {
        var t,
          n,
          r,
          i,
          o = e.tag,
          a = e.type;
        switch (o) {
          case I:
            return "Cache";
          case g:
            return dt(a) + ".Consumer";
          case v:
            return dt(a._context) + ".Provider";
          case k:
            return "DehydratedFragment";
          case b:
            return t = a, n = a.render, r = "ForwardRef", i = n.displayName || n.name || "", t.displayName || ("" !== i ? r + "(" + i + ")" : r);
          case p:
            return "Fragment";
          case f:
            return a;
          case d:
            return "Portal";
          case l:
            return "Root";
          case h:
            return "Text";
          case E:
            return lt(a);
          case m:
            return a === Re ? "StrictMode" : "Mode";
          case x:
            return "Offscreen";
          case y:
            return "Profiler";
          case C:
            return "Scope";
          case w:
            return "Suspense";
          case M:
            return "SuspenseList";
          case T:
            return "TracingMarker";
          case u:
          case s:
          case S:
          case c:
          case A:
          case _:
            if ("function" == typeof a) return a.displayName || a.name || null;
            if ("string" == typeof a) return a;
        }
        return null;
      }
      tt = new rt();
      var ht = n.ReactDebugCurrentFrame,
        pt = null,
        mt = !1;
      function gt() {
        if (null === pt) return null;
        var e = pt._debugOwner;
        return null != e ? ft(e) : null;
      }
      function vt() {
        return null === pt ? "" : ut(pt);
      }
      function bt() {
        ht.getCurrentStack = null, pt = null, mt = !1;
      }
      function yt(e) {
        ht.getCurrentStack = null === e ? null : vt, pt = e, mt = !1;
      }
      function wt(e) {
        mt = e;
      }
      function At(e) {
        return "" + e;
      }
      function _t(e) {
        switch (typeof e) {
          case "boolean":
          case "number":
          case "string":
          case "undefined":
            return e;
          case "object":
            return ee(e), e;
          default:
            return "";
        }
      }
      var Et = {
        button: !0,
        checkbox: !0,
        image: !0,
        hidden: !0,
        radio: !0,
        reset: !0,
        submit: !0
      };
      function St(e, t) {
        Et[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || null == t.value || o("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), t.onChange || t.readOnly || t.disabled || null == t.checked || o("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
      }
      function kt(e) {
        var t = e.type,
          n = e.nodeName;
        return n && "input" === n.toLowerCase() && ("checkbox" === t || "radio" === t);
      }
      function Mt(e) {
        return e._valueTracker;
      }
      function Ct(e) {
        Mt(e) || (e._valueTracker = function (e) {
          var t = kt(e) ? "checked" : "value",
            n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
          ee(e[t]);
          var r = "" + e[t];
          if (!e.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
            var i = n.get,
              o = n.set;
            Object.defineProperty(e, t, {
              configurable: !0,
              get: function () {
                return i.call(this);
              },
              set: function (e) {
                ee(e), r = "" + e, o.call(this, e);
              }
            }), Object.defineProperty(e, t, {
              enumerable: n.enumerable
            });
            var a = {
              getValue: function () {
                return r;
              },
              setValue: function (e) {
                ee(e), r = "" + e;
              },
              stopTracking: function () {
                !function (e) {
                  e._valueTracker = null;
                }(e), delete e[t];
              }
            };
            return a;
          }
        }(e));
      }
      function xt(e) {
        if (!e) return !1;
        var t = Mt(e);
        if (!t) return !0;
        var n = t.getValue(),
          r = function (e) {
            var t = "";
            return e ? t = kt(e) ? e.checked ? "true" : "false" : e.value : t;
          }(e);
        return r !== n && (t.setValue(r), !0);
      }
      function Rt(e) {
        if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;
        try {
          return e.activeElement || e.body;
        } catch (t) {
          return e.body;
        }
      }
      var It = !1,
        Tt = !1,
        Pt = !1,
        Ot = !1;
      function Lt(e) {
        return "checkbox" === e.type || "radio" === e.type ? null != e.checked : null != e.value;
      }
      function Nt(e, t) {
        var n = e,
          r = t.checked;
        return Ge({}, t, {
          defaultChecked: void 0,
          defaultValue: void 0,
          value: void 0,
          checked: null != r ? r : n._wrapperState.initialChecked
        });
      }
      function Dt(e, t) {
        St(0, t), void 0 === t.checked || void 0 === t.defaultChecked || Tt || (o("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", gt() || "A component", t.type), Tt = !0), void 0 === t.value || void 0 === t.defaultValue || It || (o("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", gt() || "A component", t.type), It = !0);
        var n = e,
          r = null == t.defaultValue ? "" : t.defaultValue;
        n._wrapperState = {
          initialChecked: null != t.checked ? t.checked : t.defaultChecked,
          initialValue: _t(null != t.value ? t.value : r),
          controlled: Lt(t)
        };
      }
      function Bt(e, t) {
        var n = e,
          r = t.checked;
        null != r && ke(n, "checked", r, !1);
      }
      function jt(e, t) {
        var n = e,
          r = Lt(t);
        n._wrapperState.controlled || !r || Ot || (o("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Ot = !0), !n._wrapperState.controlled || r || Pt || (o("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Pt = !0), Bt(e, t);
        var i = _t(t.value),
          a = t.type;
        if (null != i) "number" === a ? (0 === i && "" === n.value || n.value != i) && (n.value = At(i)) : n.value !== At(i) && (n.value = At(i));else if ("submit" === a || "reset" === a) return void n.removeAttribute("value");
        t.hasOwnProperty("value") ? Ut(n, t.type, i) : t.hasOwnProperty("defaultValue") && Ut(n, t.type, _t(t.defaultValue)), null == t.checked && null != t.defaultChecked && (n.defaultChecked = !!t.defaultChecked);
      }
      function Ft(e, t, n) {
        var r = e;
        if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
          var i = t.type;
          if (("submit" === i || "reset" === i) && (void 0 === t.value || null === t.value)) return;
          var o = At(r._wrapperState.initialValue);
          n || o !== r.value && (r.value = o), r.defaultValue = o;
        }
        var a = r.name;
        "" !== a && (r.name = ""), r.defaultChecked = !r.defaultChecked, r.defaultChecked = !!r._wrapperState.initialChecked, "" !== a && (r.name = a);
      }
      function zt(e, t) {
        var n = e;
        jt(n, t), function (e, t) {
          var n = t.name;
          if ("radio" === t.type && null != n) {
            for (var r = e; r.parentNode;) r = r.parentNode;
            X(n, "name");
            for (var i = r.querySelectorAll("input[name=" + JSON.stringify("" + n) + '][type="radio"]'), o = 0; o < i.length; o++) {
              var a = i[o];
              if (a !== e && a.form === e.form) {
                var s = Yl(a);
                if (!s) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                xt(a), jt(a, s);
              }
            }
          }
        }(n, t);
      }
      function Ut(e, t, n) {
        "number" === t && Rt(e.ownerDocument) === e || (null == n ? e.defaultValue = At(e._wrapperState.initialValue) : e.defaultValue !== At(n) && (e.defaultValue = At(n)));
      }
      var qt = !1,
        Kt = !1,
        Ht = !1;
      function Vt(t, n) {
        null == n.value && ("object" == typeof n.children && null !== n.children ? e.Children.forEach(n.children, function (e) {
          null != e && "string" != typeof e && "number" != typeof e && (Kt || (Kt = !0, o("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
        }) : null != n.dangerouslySetInnerHTML && (Ht || (Ht = !0, o("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), null == n.selected || qt || (o("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), qt = !0);
      }
      var $t,
        Wt = Array.isArray;
      function Yt(e) {
        return Wt(e);
      }
      function Gt() {
        var e = gt();
        return e ? "\n\nCheck the render method of `" + e + "`." : "";
      }
      $t = !1;
      var Qt = ["value", "defaultValue"];
      function Zt(e, t, n, r) {
        var i = e.options;
        if (t) {
          for (var o = n, a = {}, s = 0; s < o.length; s++) a["$" + o[s]] = !0;
          for (var u = 0; u < i.length; u++) {
            var c = a.hasOwnProperty("$" + i[u].value);
            i[u].selected !== c && (i[u].selected = c), c && r && (i[u].defaultSelected = !0);
          }
        } else {
          for (var l = At(_t(n)), d = null, f = 0; f < i.length; f++) {
            if (i[f].value === l) return i[f].selected = !0, void (r && (i[f].defaultSelected = !0));
            null !== d || i[f].disabled || (d = i[f]);
          }
          null !== d && (d.selected = !0);
        }
      }
      function Jt(e, t) {
        return Ge({}, t, {
          value: void 0
        });
      }
      function Xt(e, t) {
        var n = e;
        !function (e) {
          St(0, e);
          for (var t = 0; t < Qt.length; t++) {
            var n = Qt[t];
            if (null != e[n]) {
              var r = Yt(e[n]);
              e.multiple && !r ? o("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", n, Gt()) : !e.multiple && r && o("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", n, Gt());
            }
          }
        }(t), n._wrapperState = {
          wasMultiple: !!t.multiple
        }, void 0 === t.value || void 0 === t.defaultValue || $t || (o("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), $t = !0);
      }
      var en = !1;
      function tn(e, t) {
        var n = e;
        if (null != t.dangerouslySetInnerHTML) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
        return Ge({}, t, {
          value: void 0,
          defaultValue: void 0,
          children: At(n._wrapperState.initialValue)
        });
      }
      function nn(e, t) {
        var n = e;
        St(0, t), void 0 === t.value || void 0 === t.defaultValue || en || (o("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", gt() || "A component"), en = !0);
        var r = t.value;
        if (null == r) {
          var i = t.children,
            a = t.defaultValue;
          if (null != i) {
            if (o("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), null != a) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Yt(i)) {
              if (i.length > 1) throw new Error("<textarea> can only have at most one child.");
              i = i[0];
            }
            a = i;
          }
          null == a && (a = ""), r = a;
        }
        n._wrapperState = {
          initialValue: _t(r)
        };
      }
      function rn(e, t) {
        var n = e,
          r = _t(t.value),
          i = _t(t.defaultValue);
        if (null != r) {
          var o = At(r);
          o !== n.value && (n.value = o), null == t.defaultValue && n.defaultValue !== o && (n.defaultValue = o);
        }
        null != i && (n.defaultValue = At(i));
      }
      function on(e, t) {
        var n = e,
          r = n.textContent;
        r === n._wrapperState.initialValue && "" !== r && null !== r && (n.value = r);
      }
      var an = "http://www.w3.org/1999/xhtml",
        sn = "http://www.w3.org/1998/Math/MathML",
        un = "http://www.w3.org/2000/svg";
      function cn(e) {
        switch (e) {
          case "svg":
            return un;
          case "math":
            return sn;
          default:
            return an;
        }
      }
      function ln(e, t) {
        return null == e || e === an ? cn(t) : e === un && "foreignObject" === t ? an : e;
      }
      var dn,
        fn = function (e) {
          return "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function (t, n, r, i) {
            MSApp.execUnsafeLocalFunction(function () {
              return e(t, n, r, i);
            });
          } : e;
        }(function (e, t) {
          if (e.namespaceURI !== un || "innerHTML" in e) e.innerHTML = t;else {
            (dn = dn || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>";
            for (var n = dn.firstChild; e.firstChild;) e.removeChild(e.firstChild);
            for (; n.firstChild;) e.appendChild(n.firstChild);
          }
        }),
        hn = 1,
        pn = 3,
        mn = 8,
        gn = 9,
        vn = 11,
        bn = function (e, t) {
          if (t) {
            var n = e.firstChild;
            if (n && n === e.lastChild && n.nodeType === pn) return void (n.nodeValue = t);
          }
          e.textContent = t;
        },
        yn = {
          animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
          background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
          backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
          border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
          borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
          borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
          borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
          borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
          borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
          borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
          borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
          borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
          borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
          borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
          borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
          borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
          borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
          columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
          columns: ["columnCount", "columnWidth"],
          flex: ["flexBasis", "flexGrow", "flexShrink"],
          flexFlow: ["flexDirection", "flexWrap"],
          font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
          fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
          gap: ["columnGap", "rowGap"],
          grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
          gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
          gridColumn: ["gridColumnEnd", "gridColumnStart"],
          gridColumnGap: ["columnGap"],
          gridGap: ["columnGap", "rowGap"],
          gridRow: ["gridRowEnd", "gridRowStart"],
          gridRowGap: ["rowGap"],
          gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
          listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
          margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
          marker: ["markerEnd", "markerMid", "markerStart"],
          mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
          maskPosition: ["maskPositionX", "maskPositionY"],
          outline: ["outlineColor", "outlineStyle", "outlineWidth"],
          overflow: ["overflowX", "overflowY"],
          padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
          placeContent: ["alignContent", "justifyContent"],
          placeItems: ["alignItems", "justifyItems"],
          placeSelf: ["alignSelf", "justifySelf"],
          textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
          textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
          transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
          wordWrap: ["overflowWrap"]
        },
        wn = {
          animationIterationCount: !0,
          aspectRatio: !0,
          borderImageOutset: !0,
          borderImageSlice: !0,
          borderImageWidth: !0,
          boxFlex: !0,
          boxFlexGroup: !0,
          boxOrdinalGroup: !0,
          columnCount: !0,
          columns: !0,
          flex: !0,
          flexGrow: !0,
          flexPositive: !0,
          flexShrink: !0,
          flexNegative: !0,
          flexOrder: !0,
          gridArea: !0,
          gridRow: !0,
          gridRowEnd: !0,
          gridRowSpan: !0,
          gridRowStart: !0,
          gridColumn: !0,
          gridColumnEnd: !0,
          gridColumnSpan: !0,
          gridColumnStart: !0,
          fontWeight: !0,
          lineClamp: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          tabSize: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
          fillOpacity: !0,
          floodOpacity: !0,
          stopOpacity: !0,
          strokeDasharray: !0,
          strokeDashoffset: !0,
          strokeMiterlimit: !0,
          strokeOpacity: !0,
          strokeWidth: !0
        };
      var An = ["Webkit", "ms", "Moz", "O"];
      function _n(e, t, n) {
        return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || wn.hasOwnProperty(e) && wn[e] ? (function (e, t) {
          if (Z(e)) o("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", t, Q(e)), J(e);
        }(t, e), ("" + t).trim()) : t + "px";
      }
      Object.keys(wn).forEach(function (e) {
        An.forEach(function (t) {
          wn[function (e, t) {
            return e + t.charAt(0).toUpperCase() + t.substring(1);
          }(t, e)] = wn[e];
        });
      });
      var En = /([A-Z])/g,
        Sn = /^ms-/;
      function kn(e) {
        return e.replace(En, "-$1").toLowerCase().replace(Sn, "-ms-");
      }
      var Mn,
        Cn = /^(?:webkit|moz|o)[A-Z]/,
        xn = /^-ms-/,
        Rn = /-(.)/g,
        In = /;\s*$/,
        Tn = {},
        Pn = {},
        On = !1,
        Ln = !1,
        Nn = function (e) {
          Tn.hasOwnProperty(e) && Tn[e] || (Tn[e] = !0, o("Unsupported style property %s. Did you mean %s?", e, function (e) {
            return e.replace(Rn, function (e, t) {
              return t.toUpperCase();
            });
          }(e.replace(xn, "ms-"))));
        };
      Mn = function (e, t) {
        e.indexOf("-") > -1 ? Nn(e) : Cn.test(e) ? function (e) {
          Tn.hasOwnProperty(e) && Tn[e] || (Tn[e] = !0, o("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
        }(e) : In.test(t) && function (e, t) {
          Pn.hasOwnProperty(t) && Pn[t] || (Pn[t] = !0, o('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', e, t.replace(In, "")));
        }(e, t), "number" == typeof t && (isNaN(t) ? function (e, t) {
          On || (On = !0, o("`NaN` is an invalid value for the `%s` css style property.", e));
        }(e) : isFinite(t) || function (e, t) {
          Ln || (Ln = !0, o("`Infinity` is an invalid value for the `%s` css style property.", e));
        }(e));
      };
      var Dn = Mn;
      function Bn(e) {
        var t = "",
          n = "";
        for (var r in e) if (e.hasOwnProperty(r)) {
          var i = e[r];
          if (null != i) {
            var o = 0 === r.indexOf("--");
            t += n + (o ? r : kn(r)) + ":", t += _n(r, i, o), n = ";";
          }
        }
        return t || null;
      }
      function jn(e, t) {
        var n = e.style;
        for (var r in t) if (t.hasOwnProperty(r)) {
          var i = 0 === r.indexOf("--");
          i || Dn(r, t[r]);
          var o = _n(r, t[r], i);
          "float" === r && (r = "cssFloat"), i ? n.setProperty(r, o) : n[r] = o;
        }
      }
      function Fn(e) {
        return null == e || "boolean" == typeof e || "" === e;
      }
      function zn(e) {
        var t = {};
        for (var n in e) for (var r = yn[n] || [n], i = 0; i < r.length; i++) t[r[i]] = n;
        return t;
      }
      var Un = Ge({
          menuitem: !0
        }, {
          area: !0,
          base: !0,
          br: !0,
          col: !0,
          embed: !0,
          hr: !0,
          img: !0,
          input: !0,
          keygen: !0,
          link: !0,
          meta: !0,
          param: !0,
          source: !0,
          track: !0,
          wbr: !0
        }),
        qn = "__html";
      function Kn(e, t) {
        if (t) {
          if (Un[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw new Error(e + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
          if (null != t.dangerouslySetInnerHTML) {
            if (null != t.children) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if ("object" != typeof t.dangerouslySetInnerHTML || !(qn in t.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
          }
          if (!t.suppressContentEditableWarning && t.contentEditable && null != t.children && o("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), null != t.style && "object" != typeof t.style) throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        }
      }
      function Hn(e, t) {
        if (-1 === e.indexOf("-")) return "string" == typeof t.is;
        switch (e) {
          case "annotation-xml":
          case "color-profile":
          case "font-face":
          case "font-face-src":
          case "font-face-uri":
          case "font-face-format":
          case "font-face-name":
          case "missing-glyph":
            return !1;
          default:
            return !0;
        }
      }
      var Vn = {
          accept: "accept",
          acceptcharset: "acceptCharset",
          "accept-charset": "acceptCharset",
          accesskey: "accessKey",
          action: "action",
          allowfullscreen: "allowFullScreen",
          alt: "alt",
          as: "as",
          async: "async",
          autocapitalize: "autoCapitalize",
          autocomplete: "autoComplete",
          autocorrect: "autoCorrect",
          autofocus: "autoFocus",
          autoplay: "autoPlay",
          autosave: "autoSave",
          capture: "capture",
          cellpadding: "cellPadding",
          cellspacing: "cellSpacing",
          challenge: "challenge",
          charset: "charSet",
          checked: "checked",
          children: "children",
          cite: "cite",
          class: "className",
          classid: "classID",
          classname: "className",
          cols: "cols",
          colspan: "colSpan",
          content: "content",
          contenteditable: "contentEditable",
          contextmenu: "contextMenu",
          controls: "controls",
          controlslist: "controlsList",
          coords: "coords",
          crossorigin: "crossOrigin",
          dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
          data: "data",
          datetime: "dateTime",
          default: "default",
          defaultchecked: "defaultChecked",
          defaultvalue: "defaultValue",
          defer: "defer",
          dir: "dir",
          disabled: "disabled",
          disablepictureinpicture: "disablePictureInPicture",
          disableremoteplayback: "disableRemotePlayback",
          download: "download",
          draggable: "draggable",
          enctype: "encType",
          enterkeyhint: "enterKeyHint",
          for: "htmlFor",
          form: "form",
          formmethod: "formMethod",
          formaction: "formAction",
          formenctype: "formEncType",
          formnovalidate: "formNoValidate",
          formtarget: "formTarget",
          frameborder: "frameBorder",
          headers: "headers",
          height: "height",
          hidden: "hidden",
          high: "high",
          href: "href",
          hreflang: "hrefLang",
          htmlfor: "htmlFor",
          httpequiv: "httpEquiv",
          "http-equiv": "httpEquiv",
          icon: "icon",
          id: "id",
          imagesizes: "imageSizes",
          imagesrcset: "imageSrcSet",
          innerhtml: "innerHTML",
          inputmode: "inputMode",
          integrity: "integrity",
          is: "is",
          itemid: "itemID",
          itemprop: "itemProp",
          itemref: "itemRef",
          itemscope: "itemScope",
          itemtype: "itemType",
          keyparams: "keyParams",
          keytype: "keyType",
          kind: "kind",
          label: "label",
          lang: "lang",
          list: "list",
          loop: "loop",
          low: "low",
          manifest: "manifest",
          marginwidth: "marginWidth",
          marginheight: "marginHeight",
          max: "max",
          maxlength: "maxLength",
          media: "media",
          mediagroup: "mediaGroup",
          method: "method",
          min: "min",
          minlength: "minLength",
          multiple: "multiple",
          muted: "muted",
          name: "name",
          nomodule: "noModule",
          nonce: "nonce",
          novalidate: "noValidate",
          open: "open",
          optimum: "optimum",
          pattern: "pattern",
          placeholder: "placeholder",
          playsinline: "playsInline",
          poster: "poster",
          preload: "preload",
          profile: "profile",
          radiogroup: "radioGroup",
          readonly: "readOnly",
          referrerpolicy: "referrerPolicy",
          rel: "rel",
          required: "required",
          reversed: "reversed",
          role: "role",
          rows: "rows",
          rowspan: "rowSpan",
          sandbox: "sandbox",
          scope: "scope",
          scoped: "scoped",
          scrolling: "scrolling",
          seamless: "seamless",
          selected: "selected",
          shape: "shape",
          size: "size",
          sizes: "sizes",
          span: "span",
          spellcheck: "spellCheck",
          src: "src",
          srcdoc: "srcDoc",
          srclang: "srcLang",
          srcset: "srcSet",
          start: "start",
          step: "step",
          style: "style",
          summary: "summary",
          tabindex: "tabIndex",
          target: "target",
          title: "title",
          type: "type",
          usemap: "useMap",
          value: "value",
          width: "width",
          wmode: "wmode",
          wrap: "wrap",
          about: "about",
          accentheight: "accentHeight",
          "accent-height": "accentHeight",
          accumulate: "accumulate",
          additive: "additive",
          alignmentbaseline: "alignmentBaseline",
          "alignment-baseline": "alignmentBaseline",
          allowreorder: "allowReorder",
          alphabetic: "alphabetic",
          amplitude: "amplitude",
          arabicform: "arabicForm",
          "arabic-form": "arabicForm",
          ascent: "ascent",
          attributename: "attributeName",
          attributetype: "attributeType",
          autoreverse: "autoReverse",
          azimuth: "azimuth",
          basefrequency: "baseFrequency",
          baselineshift: "baselineShift",
          "baseline-shift": "baselineShift",
          baseprofile: "baseProfile",
          bbox: "bbox",
          begin: "begin",
          bias: "bias",
          by: "by",
          calcmode: "calcMode",
          capheight: "capHeight",
          "cap-height": "capHeight",
          clip: "clip",
          clippath: "clipPath",
          "clip-path": "clipPath",
          clippathunits: "clipPathUnits",
          cliprule: "clipRule",
          "clip-rule": "clipRule",
          color: "color",
          colorinterpolation: "colorInterpolation",
          "color-interpolation": "colorInterpolation",
          colorinterpolationfilters: "colorInterpolationFilters",
          "color-interpolation-filters": "colorInterpolationFilters",
          colorprofile: "colorProfile",
          "color-profile": "colorProfile",
          colorrendering: "colorRendering",
          "color-rendering": "colorRendering",
          contentscripttype: "contentScriptType",
          contentstyletype: "contentStyleType",
          cursor: "cursor",
          cx: "cx",
          cy: "cy",
          d: "d",
          datatype: "datatype",
          decelerate: "decelerate",
          descent: "descent",
          diffuseconstant: "diffuseConstant",
          direction: "direction",
          display: "display",
          divisor: "divisor",
          dominantbaseline: "dominantBaseline",
          "dominant-baseline": "dominantBaseline",
          dur: "dur",
          dx: "dx",
          dy: "dy",
          edgemode: "edgeMode",
          elevation: "elevation",
          enablebackground: "enableBackground",
          "enable-background": "enableBackground",
          end: "end",
          exponent: "exponent",
          externalresourcesrequired: "externalResourcesRequired",
          fill: "fill",
          fillopacity: "fillOpacity",
          "fill-opacity": "fillOpacity",
          fillrule: "fillRule",
          "fill-rule": "fillRule",
          filter: "filter",
          filterres: "filterRes",
          filterunits: "filterUnits",
          floodopacity: "floodOpacity",
          "flood-opacity": "floodOpacity",
          floodcolor: "floodColor",
          "flood-color": "floodColor",
          focusable: "focusable",
          fontfamily: "fontFamily",
          "font-family": "fontFamily",
          fontsize: "fontSize",
          "font-size": "fontSize",
          fontsizeadjust: "fontSizeAdjust",
          "font-size-adjust": "fontSizeAdjust",
          fontstretch: "fontStretch",
          "font-stretch": "fontStretch",
          fontstyle: "fontStyle",
          "font-style": "fontStyle",
          fontvariant: "fontVariant",
          "font-variant": "fontVariant",
          fontweight: "fontWeight",
          "font-weight": "fontWeight",
          format: "format",
          from: "from",
          fx: "fx",
          fy: "fy",
          g1: "g1",
          g2: "g2",
          glyphname: "glyphName",
          "glyph-name": "glyphName",
          glyphorientationhorizontal: "glyphOrientationHorizontal",
          "glyph-orientation-horizontal": "glyphOrientationHorizontal",
          glyphorientationvertical: "glyphOrientationVertical",
          "glyph-orientation-vertical": "glyphOrientationVertical",
          glyphref: "glyphRef",
          gradienttransform: "gradientTransform",
          gradientunits: "gradientUnits",
          hanging: "hanging",
          horizadvx: "horizAdvX",
          "horiz-adv-x": "horizAdvX",
          horizoriginx: "horizOriginX",
          "horiz-origin-x": "horizOriginX",
          ideographic: "ideographic",
          imagerendering: "imageRendering",
          "image-rendering": "imageRendering",
          in2: "in2",
          in: "in",
          inlist: "inlist",
          intercept: "intercept",
          k1: "k1",
          k2: "k2",
          k3: "k3",
          k4: "k4",
          k: "k",
          kernelmatrix: "kernelMatrix",
          kernelunitlength: "kernelUnitLength",
          kerning: "kerning",
          keypoints: "keyPoints",
          keysplines: "keySplines",
          keytimes: "keyTimes",
          lengthadjust: "lengthAdjust",
          letterspacing: "letterSpacing",
          "letter-spacing": "letterSpacing",
          lightingcolor: "lightingColor",
          "lighting-color": "lightingColor",
          limitingconeangle: "limitingConeAngle",
          local: "local",
          markerend: "markerEnd",
          "marker-end": "markerEnd",
          markerheight: "markerHeight",
          markermid: "markerMid",
          "marker-mid": "markerMid",
          markerstart: "markerStart",
          "marker-start": "markerStart",
          markerunits: "markerUnits",
          markerwidth: "markerWidth",
          mask: "mask",
          maskcontentunits: "maskContentUnits",
          maskunits: "maskUnits",
          mathematical: "mathematical",
          mode: "mode",
          numoctaves: "numOctaves",
          offset: "offset",
          opacity: "opacity",
          operator: "operator",
          order: "order",
          orient: "orient",
          orientation: "orientation",
          origin: "origin",
          overflow: "overflow",
          overlineposition: "overlinePosition",
          "overline-position": "overlinePosition",
          overlinethickness: "overlineThickness",
          "overline-thickness": "overlineThickness",
          paintorder: "paintOrder",
          "paint-order": "paintOrder",
          panose1: "panose1",
          "panose-1": "panose1",
          pathlength: "pathLength",
          patterncontentunits: "patternContentUnits",
          patterntransform: "patternTransform",
          patternunits: "patternUnits",
          pointerevents: "pointerEvents",
          "pointer-events": "pointerEvents",
          points: "points",
          pointsatx: "pointsAtX",
          pointsaty: "pointsAtY",
          pointsatz: "pointsAtZ",
          prefix: "prefix",
          preservealpha: "preserveAlpha",
          preserveaspectratio: "preserveAspectRatio",
          primitiveunits: "primitiveUnits",
          property: "property",
          r: "r",
          radius: "radius",
          refx: "refX",
          refy: "refY",
          renderingintent: "renderingIntent",
          "rendering-intent": "renderingIntent",
          repeatcount: "repeatCount",
          repeatdur: "repeatDur",
          requiredextensions: "requiredExtensions",
          requiredfeatures: "requiredFeatures",
          resource: "resource",
          restart: "restart",
          result: "result",
          results: "results",
          rotate: "rotate",
          rx: "rx",
          ry: "ry",
          scale: "scale",
          security: "security",
          seed: "seed",
          shaperendering: "shapeRendering",
          "shape-rendering": "shapeRendering",
          slope: "slope",
          spacing: "spacing",
          specularconstant: "specularConstant",
          specularexponent: "specularExponent",
          speed: "speed",
          spreadmethod: "spreadMethod",
          startoffset: "startOffset",
          stddeviation: "stdDeviation",
          stemh: "stemh",
          stemv: "stemv",
          stitchtiles: "stitchTiles",
          stopcolor: "stopColor",
          "stop-color": "stopColor",
          stopopacity: "stopOpacity",
          "stop-opacity": "stopOpacity",
          strikethroughposition: "strikethroughPosition",
          "strikethrough-position": "strikethroughPosition",
          strikethroughthickness: "strikethroughThickness",
          "strikethrough-thickness": "strikethroughThickness",
          string: "string",
          stroke: "stroke",
          strokedasharray: "strokeDasharray",
          "stroke-dasharray": "strokeDasharray",
          strokedashoffset: "strokeDashoffset",
          "stroke-dashoffset": "strokeDashoffset",
          strokelinecap: "strokeLinecap",
          "stroke-linecap": "strokeLinecap",
          strokelinejoin: "strokeLinejoin",
          "stroke-linejoin": "strokeLinejoin",
          strokemiterlimit: "strokeMiterlimit",
          "stroke-miterlimit": "strokeMiterlimit",
          strokewidth: "strokeWidth",
          "stroke-width": "strokeWidth",
          strokeopacity: "strokeOpacity",
          "stroke-opacity": "strokeOpacity",
          suppresscontenteditablewarning: "suppressContentEditableWarning",
          suppresshydrationwarning: "suppressHydrationWarning",
          surfacescale: "surfaceScale",
          systemlanguage: "systemLanguage",
          tablevalues: "tableValues",
          targetx: "targetX",
          targety: "targetY",
          textanchor: "textAnchor",
          "text-anchor": "textAnchor",
          textdecoration: "textDecoration",
          "text-decoration": "textDecoration",
          textlength: "textLength",
          textrendering: "textRendering",
          "text-rendering": "textRendering",
          to: "to",
          transform: "transform",
          typeof: "typeof",
          u1: "u1",
          u2: "u2",
          underlineposition: "underlinePosition",
          "underline-position": "underlinePosition",
          underlinethickness: "underlineThickness",
          "underline-thickness": "underlineThickness",
          unicode: "unicode",
          unicodebidi: "unicodeBidi",
          "unicode-bidi": "unicodeBidi",
          unicoderange: "unicodeRange",
          "unicode-range": "unicodeRange",
          unitsperem: "unitsPerEm",
          "units-per-em": "unitsPerEm",
          unselectable: "unselectable",
          valphabetic: "vAlphabetic",
          "v-alphabetic": "vAlphabetic",
          values: "values",
          vectoreffect: "vectorEffect",
          "vector-effect": "vectorEffect",
          version: "version",
          vertadvy: "vertAdvY",
          "vert-adv-y": "vertAdvY",
          vertoriginx: "vertOriginX",
          "vert-origin-x": "vertOriginX",
          vertoriginy: "vertOriginY",
          "vert-origin-y": "vertOriginY",
          vhanging: "vHanging",
          "v-hanging": "vHanging",
          videographic: "vIdeographic",
          "v-ideographic": "vIdeographic",
          viewbox: "viewBox",
          viewtarget: "viewTarget",
          visibility: "visibility",
          vmathematical: "vMathematical",
          "v-mathematical": "vMathematical",
          vocab: "vocab",
          widths: "widths",
          wordspacing: "wordSpacing",
          "word-spacing": "wordSpacing",
          writingmode: "writingMode",
          "writing-mode": "writingMode",
          x1: "x1",
          x2: "x2",
          x: "x",
          xchannelselector: "xChannelSelector",
          xheight: "xHeight",
          "x-height": "xHeight",
          xlinkactuate: "xlinkActuate",
          "xlink:actuate": "xlinkActuate",
          xlinkarcrole: "xlinkArcrole",
          "xlink:arcrole": "xlinkArcrole",
          xlinkhref: "xlinkHref",
          "xlink:href": "xlinkHref",
          xlinkrole: "xlinkRole",
          "xlink:role": "xlinkRole",
          xlinkshow: "xlinkShow",
          "xlink:show": "xlinkShow",
          xlinktitle: "xlinkTitle",
          "xlink:title": "xlinkTitle",
          xlinktype: "xlinkType",
          "xlink:type": "xlinkType",
          xmlbase: "xmlBase",
          "xml:base": "xmlBase",
          xmllang: "xmlLang",
          "xml:lang": "xmlLang",
          xmlns: "xmlns",
          "xml:space": "xmlSpace",
          xmlnsxlink: "xmlnsXlink",
          "xmlns:xlink": "xmlnsXlink",
          xmlspace: "xmlSpace",
          y1: "y1",
          y2: "y2",
          y: "y",
          ychannelselector: "yChannelSelector",
          z: "z",
          zoomandpan: "zoomAndPan"
        },
        $n = {
          "aria-current": 0,
          "aria-description": 0,
          "aria-details": 0,
          "aria-disabled": 0,
          "aria-hidden": 0,
          "aria-invalid": 0,
          "aria-keyshortcuts": 0,
          "aria-label": 0,
          "aria-roledescription": 0,
          "aria-autocomplete": 0,
          "aria-checked": 0,
          "aria-expanded": 0,
          "aria-haspopup": 0,
          "aria-level": 0,
          "aria-modal": 0,
          "aria-multiline": 0,
          "aria-multiselectable": 0,
          "aria-orientation": 0,
          "aria-placeholder": 0,
          "aria-pressed": 0,
          "aria-readonly": 0,
          "aria-required": 0,
          "aria-selected": 0,
          "aria-sort": 0,
          "aria-valuemax": 0,
          "aria-valuemin": 0,
          "aria-valuenow": 0,
          "aria-valuetext": 0,
          "aria-atomic": 0,
          "aria-busy": 0,
          "aria-live": 0,
          "aria-relevant": 0,
          "aria-dropeffect": 0,
          "aria-grabbed": 0,
          "aria-activedescendant": 0,
          "aria-colcount": 0,
          "aria-colindex": 0,
          "aria-colspan": 0,
          "aria-controls": 0,
          "aria-describedby": 0,
          "aria-errormessage": 0,
          "aria-flowto": 0,
          "aria-labelledby": 0,
          "aria-owns": 0,
          "aria-posinset": 0,
          "aria-rowcount": 0,
          "aria-rowindex": 0,
          "aria-rowspan": 0,
          "aria-setsize": 0
        },
        Wn = {},
        Yn = new RegExp("^(aria)-[" + se + "]*$"),
        Gn = new RegExp("^(aria)[A-Z][" + se + "]*$");
      function Qn(e, t) {
        if (G.call(Wn, t) && Wn[t]) return !0;
        if (Gn.test(t)) {
          var n = "aria-" + t.slice(4).toLowerCase(),
            r = $n.hasOwnProperty(n) ? n : null;
          if (null == r) return o("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", t), Wn[t] = !0, !0;
          if (t !== r) return o("Invalid ARIA attribute `%s`. Did you mean `%s`?", t, r), Wn[t] = !0, !0;
        }
        if (Yn.test(t)) {
          var i = t.toLowerCase(),
            a = $n.hasOwnProperty(i) ? i : null;
          if (null == a) return Wn[t] = !0, !1;
          if (t !== a) return o("Unknown ARIA attribute `%s`. Did you mean `%s`?", t, a), Wn[t] = !0, !0;
        }
        return !0;
      }
      function Zn(e, t) {
        Hn(e, t) || function (e, t) {
          var n = [];
          for (var r in t) Qn(0, r) || n.push(r);
          var i = n.map(function (e) {
            return "`" + e + "`";
          }).join(", ");
          1 === n.length ? o("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", i, e) : n.length > 1 && o("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", i, e);
        }(e, t);
      }
      var Jn = !1;
      var Xn,
        er = {},
        tr = /^on./,
        nr = /^on[^A-Z]/,
        rr = new RegExp("^(aria)-[" + se + "]*$"),
        ir = new RegExp("^(aria)[A-Z][" + se + "]*$");
      Xn = function (e, t, n, r) {
        if (G.call(er, t) && er[t]) return !0;
        var i = t.toLowerCase();
        if ("onfocusin" === i || "onfocusout" === i) return o("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), er[t] = !0, !0;
        if (null != r) {
          var a = r.registrationNameDependencies,
            s = r.possibleRegistrationNames;
          if (a.hasOwnProperty(t)) return !0;
          var u = s.hasOwnProperty(i) ? s[i] : null;
          if (null != u) return o("Invalid event handler property `%s`. Did you mean `%s`?", t, u), er[t] = !0, !0;
          if (tr.test(t)) return o("Unknown event handler property `%s`. It will be ignored.", t), er[t] = !0, !0;
        } else if (tr.test(t)) return nr.test(t) && o("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", t), er[t] = !0, !0;
        if (rr.test(t) || ir.test(t)) return !0;
        if ("innerhtml" === i) return o("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), er[t] = !0, !0;
        if ("aria" === i) return o("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), er[t] = !0, !0;
        if ("is" === i && null != n && "string" != typeof n) return o("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof n), er[t] = !0, !0;
        if ("number" == typeof n && isNaN(n)) return o("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", t), er[t] = !0, !0;
        var c = me(t),
          l = null !== c && c.type === te;
        if (Vn.hasOwnProperty(i)) {
          var d = Vn[i];
          if (d !== t) return o("Invalid DOM property `%s`. Did you mean `%s`?", t, d), er[t] = !0, !0;
        } else if (!l && t !== i) return o("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", t, i), er[t] = !0, !0;
        return "boolean" == typeof n && he(t, n, c, !1) ? (n ? o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', n, t, t, n, t) : o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', n, t, t, n, t, t, t), er[t] = !0, !0) : !!l || (he(t, n, c, !1) ? (er[t] = !0, !1) : ("false" !== n && "true" !== n || null === c || c.type !== ne || (o("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", n, t, "false" === n ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', t, n), er[t] = !0), !0));
      };
      function or(e, t, n) {
        Hn(e, t) || function (e, t, n) {
          var r = [];
          for (var i in t) Xn(0, i, t[i], n) || r.push(i);
          var a = r.map(function (e) {
            return "`" + e + "`";
          }).join(", ");
          1 === r.length ? o("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", a, e) : r.length > 1 && o("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", a, e);
        }(e, t, n);
      }
      var ar = 1,
        sr = 2,
        ur = 4,
        cr = ar | sr | ur,
        lr = null;
      function dr(e) {
        var t = e.target || e.srcElement || window;
        return t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === pn ? t.parentNode : t;
      }
      var fr = null,
        hr = null,
        pr = null;
      function mr(e) {
        var t = $l(e);
        if (t) {
          if ("function" != typeof fr) throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
          var n = t.stateNode;
          if (n) {
            var r = Yl(n);
            fr(t.stateNode, t.type, r);
          }
        }
      }
      function gr(e) {
        hr ? pr ? pr.push(e) : pr = [e] : hr = e;
      }
      function vr() {
        if (hr) {
          var e = hr,
            t = pr;
          if (hr = null, pr = null, mr(e), t) for (var n = 0; n < t.length; n++) mr(t[n]);
        }
      }
      var br = function (e, t) {
          return e(t);
        },
        yr = function () {},
        wr = !1;
      function Ar() {
        (null !== hr || null !== pr) && (yr(), vr());
      }
      function _r(e, t, n) {
        if (wr) return e(t, n);
        wr = !0;
        try {
          return br(e, t, n);
        } finally {
          wr = !1, Ar();
        }
      }
      function Er(e, t) {
        var n = e.stateNode;
        if (null === n) return null;
        var r = Yl(n);
        if (null === r) return null;
        var i = r[t];
        if (function (e, t, n) {
          switch (e) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              return !(!n.disabled || (r = t, "button" !== r && "input" !== r && "select" !== r && "textarea" !== r));
            default:
              return !1;
          }
          var r;
        }(t, e.type, r)) return null;
        if (i && "function" != typeof i) throw new Error("Expected `" + t + "` listener to be a function, instead got a value of `" + typeof i + "` type.");
        return i;
      }
      var Sr = !1;
      if (Y) try {
        var kr = {};
        Object.defineProperty(kr, "passive", {
          get: function () {
            Sr = !0;
          }
        }), window.addEventListener("test", kr, kr), window.removeEventListener("test", kr, kr);
      } catch (e) {
        Sr = !1;
      }
      function Mr(e, t, n, r, i, o, a, s, u) {
        var c = Array.prototype.slice.call(arguments, 3);
        try {
          t.apply(n, c);
        } catch (e) {
          this.onError(e);
        }
      }
      var Cr = Mr;
      if ("undefined" != typeof window && "function" == typeof window.dispatchEvent && "undefined" != typeof document && "function" == typeof document.createEvent) {
        var xr = document.createElement("react");
        Cr = function (e, t, n, r, i, o, a, s, u) {
          if ("undefined" == typeof document || null === document) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
          var c = document.createEvent("Event"),
            l = !1,
            d = !0,
            f = window.event,
            h = Object.getOwnPropertyDescriptor(window, "event");
          function p() {
            xr.removeEventListener(A, v, !1), void 0 !== window.event && window.hasOwnProperty("event") && (window.event = f);
          }
          var m,
            g = Array.prototype.slice.call(arguments, 3);
          function v() {
            l = !0, p(), t.apply(n, g), d = !1;
          }
          var b = !1,
            y = !1;
          function w(e) {
            if (m = e.error, b = !0, null === m && 0 === e.colno && 0 === e.lineno && (y = !0), e.defaultPrevented && null != m && "object" == typeof m) try {
              m._suppressLogging = !0;
            } catch (e) {}
          }
          var A = "react-" + (e || "invokeguardedcallback");
          if (window.addEventListener("error", w), xr.addEventListener(A, v, !1), c.initEvent(A, !1, !1), xr.dispatchEvent(c), h && Object.defineProperty(window, "event", h), l && d && (b ? y && (m = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : m = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue."), this.onError(m)), window.removeEventListener("error", w), !l) return p(), Mr.apply(this, arguments);
        };
      }
      var Rr = Cr,
        Ir = !1,
        Tr = null,
        Pr = !1,
        Or = null,
        Lr = {
          onError: function (e) {
            Ir = !0, Tr = e;
          }
        };
      function Nr(e, t, n, r, i, o, a, s, u) {
        Ir = !1, Tr = null, Rr.apply(Lr, arguments);
      }
      function Dr() {
        if (Ir) {
          var e = Tr;
          return Ir = !1, Tr = null, e;
        }
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
      }
      function Br(e) {
        return e._reactInternals;
      }
      var jr = 0,
        Fr = 1,
        zr = 2,
        Ur = 4,
        qr = 16,
        Kr = 32,
        Hr = 64,
        Vr = 128,
        $r = 256,
        Wr = 512,
        Yr = 1024,
        Gr = 2048,
        Qr = 4096,
        Zr = 8192,
        Jr = 16384,
        Xr = Gr | Ur | Hr | Wr | Yr | Jr,
        ei = 32767,
        ti = 32768,
        ni = 65536,
        ri = 131072,
        ii = 1048576,
        oi = 2097152,
        ai = 4194304,
        si = 8388608,
        ui = 16777216,
        ci = 33554432,
        li = Ur | Yr | 0,
        di = zr | Ur | qr | Kr | Wr | Qr | Zr,
        fi = Ur | Hr | Wr | Zr,
        hi = Gr | qr,
        pi = ai | si | oi,
        mi = n.ReactCurrentOwner;
      function gi(e) {
        var t = e,
          n = e;
        if (e.alternate) for (; t.return;) t = t.return;else {
          var r = t;
          do {
            ((t = r).flags & (zr | Qr)) !== jr && (n = t.return), r = t.return;
          } while (r);
        }
        return t.tag === l ? n : null;
      }
      function vi(e) {
        if (e.tag === w) {
          var t = e.memoizedState;
          if (null === t) {
            var n = e.alternate;
            null !== n && (t = n.memoizedState);
          }
          if (null !== t) return t.dehydrated;
        }
        return null;
      }
      function bi(e) {
        return e.tag === l ? e.stateNode.containerInfo : null;
      }
      function yi(e) {
        if (gi(e) !== e) throw new Error("Unable to find node on an unmounted component.");
      }
      function wi(e) {
        var t = e.alternate;
        if (!t) {
          var n = gi(e);
          if (null === n) throw new Error("Unable to find node on an unmounted component.");
          return n !== e ? null : e;
        }
        for (var r = e, i = t;;) {
          var o = r.return;
          if (null === o) break;
          var a = o.alternate;
          if (null === a) {
            var s = o.return;
            if (null !== s) {
              r = i = s;
              continue;
            }
            break;
          }
          if (o.child === a.child) {
            for (var u = o.child; u;) {
              if (u === r) return yi(o), e;
              if (u === i) return yi(o), t;
              u = u.sibling;
            }
            throw new Error("Unable to find node on an unmounted component.");
          }
          if (r.return !== i.return) r = o, i = a;else {
            for (var c = !1, d = o.child; d;) {
              if (d === r) {
                c = !0, r = o, i = a;
                break;
              }
              if (d === i) {
                c = !0, i = o, r = a;
                break;
              }
              d = d.sibling;
            }
            if (!c) {
              for (d = a.child; d;) {
                if (d === r) {
                  c = !0, r = a, i = o;
                  break;
                }
                if (d === i) {
                  c = !0, i = a, r = o;
                  break;
                }
                d = d.sibling;
              }
              if (!c) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
            }
          }
          if (r.alternate !== i) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (r.tag !== l) throw new Error("Unable to find node on an unmounted component.");
        return r.stateNode.current === r ? e : t;
      }
      function Ai(e) {
        var t = wi(e);
        return null !== t ? _i(t) : null;
      }
      function _i(e) {
        if (e.tag === f || e.tag === h) return e;
        for (var t = e.child; null !== t;) {
          var n = _i(t);
          if (null !== n) return n;
          t = t.sibling;
        }
        return null;
      }
      function Ei(e) {
        var t = wi(e);
        return null !== t ? Si(t) : null;
      }
      function Si(e) {
        if (e.tag === f || e.tag === h) return e;
        for (var t = e.child; null !== t;) {
          if (t.tag !== d) {
            var n = Si(t);
            if (null !== n) return n;
          }
          t = t.sibling;
        }
        return null;
      }
      var ki = t.unstable_scheduleCallback,
        Mi = t.unstable_cancelCallback,
        Ci = t.unstable_shouldYield,
        xi = t.unstable_requestPaint,
        Ri = t.unstable_now,
        Ii = t.unstable_getCurrentPriorityLevel,
        Ti = t.unstable_ImmediatePriority,
        Pi = t.unstable_UserBlockingPriority,
        Oi = t.unstable_NormalPriority,
        Li = t.unstable_LowPriority,
        Ni = t.unstable_IdlePriority,
        Di = t.unstable_yieldValue,
        Bi = t.unstable_setDisableYieldValue,
        ji = null,
        Fi = null,
        zi = null,
        Ui = !1,
        qi = "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
      function Ki(e) {
        if ("function" == typeof Di && (Bi(e), r = e), Fi && "function" == typeof Fi.setStrictMode) try {
          Fi.setStrictMode(ji, e);
        } catch (e) {
          Ui || (Ui = !0, o("React instrumentation encountered an error: %s", e));
        }
      }
      function Hi(e) {
        zi = e;
      }
      function Vi() {
        for (var e = new Map(), t = 1, n = 0; n < fo; n++) {
          var r = Qo(t);
          e.set(t, r), t *= 2;
        }
        return e;
      }
      function $i() {
        null !== zi && "function" == typeof zi.markCommitStopped && zi.markCommitStopped();
      }
      function Wi(e) {
        null !== zi && "function" == typeof zi.markComponentRenderStarted && zi.markComponentRenderStarted(e);
      }
      function Yi() {
        null !== zi && "function" == typeof zi.markComponentRenderStopped && zi.markComponentRenderStopped();
      }
      function Gi(e) {
        null !== zi && "function" == typeof zi.markComponentLayoutEffectMountStarted && zi.markComponentLayoutEffectMountStarted(e);
      }
      function Qi(e) {
        null !== zi && "function" == typeof zi.markComponentLayoutEffectUnmountStarted && zi.markComponentLayoutEffectUnmountStarted(e);
      }
      function Zi() {
        null !== zi && "function" == typeof zi.markComponentLayoutEffectUnmountStopped && zi.markComponentLayoutEffectUnmountStopped();
      }
      function Ji(e, t, n) {
        null !== zi && "function" == typeof zi.markComponentErrored && zi.markComponentErrored(e, t, n);
      }
      function Xi(e, t, n) {
        null !== zi && "function" == typeof zi.markComponentSuspended && zi.markComponentSuspended(e, t, n);
      }
      function eo(e) {
        null !== zi && "function" == typeof zi.markRenderStarted && zi.markRenderStarted(e);
      }
      function to() {
        null !== zi && "function" == typeof zi.markRenderStopped && zi.markRenderStopped();
      }
      function no(e, t) {
        null !== zi && "function" == typeof zi.markStateUpdateScheduled && zi.markStateUpdateScheduled(e, t);
      }
      var ro = 0,
        io = 1,
        oo = 2,
        ao = 8,
        so = 16,
        uo = Math.clz32 ? Math.clz32 : function (e) {
          var t = e >>> 0;
          if (0 === t) return 32;
          return 31 - (co(t) / lo | 0) | 0;
        },
        co = Math.log,
        lo = Math.LN2;
      var fo = 31,
        ho = 0,
        po = 0,
        mo = 1,
        go = 2,
        vo = 4,
        bo = 8,
        yo = 16,
        wo = 32,
        Ao = 4194240,
        _o = 64,
        Eo = 128,
        So = 256,
        ko = 512,
        Mo = 1024,
        Co = 2048,
        xo = 4096,
        Ro = 8192,
        Io = 16384,
        To = 32768,
        Po = 65536,
        Oo = 131072,
        Lo = 262144,
        No = 524288,
        Do = 1048576,
        Bo = 2097152,
        jo = 130023424,
        Fo = 4194304,
        zo = 8388608,
        Uo = 16777216,
        qo = 33554432,
        Ko = 67108864,
        Ho = Fo,
        Vo = 134217728,
        $o = 268435455,
        Wo = 268435456,
        Yo = 536870912,
        Go = 1073741824;
      function Qo(e) {
        return e & mo ? "Sync" : e & go ? "InputContinuousHydration" : e & vo ? "InputContinuous" : e & bo ? "DefaultHydration" : e & yo ? "Default" : e & wo ? "TransitionHydration" : e & Ao ? "Transition" : e & jo ? "Retry" : e & Vo ? "SelectiveHydration" : e & Wo ? "IdleHydration" : e & Yo ? "Idle" : e & Go ? "Offscreen" : void 0;
      }
      var Zo = -1,
        Jo = _o,
        Xo = Fo;
      function ea(e) {
        switch (ca(e)) {
          case mo:
            return mo;
          case go:
            return go;
          case vo:
            return vo;
          case bo:
            return bo;
          case yo:
            return yo;
          case wo:
            return wo;
          case _o:
          case Eo:
          case So:
          case ko:
          case Mo:
          case Co:
          case xo:
          case Ro:
          case Io:
          case To:
          case Po:
          case Oo:
          case Lo:
          case No:
          case Do:
          case Bo:
            return e & Ao;
          case Fo:
          case zo:
          case Uo:
          case qo:
          case Ko:
            return e & jo;
          case Vo:
            return Vo;
          case Wo:
            return Wo;
          case Yo:
            return Yo;
          case Go:
            return Go;
          default:
            return o("Should have found matching lanes. This is a bug in React."), e;
        }
      }
      function ta(e, t) {
        var n = e.pendingLanes;
        if (n === ho) return ho;
        var r = ho,
          i = e.suspendedLanes,
          o = e.pingedLanes,
          a = n & $o;
        if (a !== ho) {
          var s = a & ~i;
          if (s !== ho) r = ea(s);else {
            var u = a & o;
            u !== ho && (r = ea(u));
          }
        } else {
          var c = n & ~i;
          c !== ho ? r = ea(c) : o !== ho && (r = ea(o));
        }
        if (r === ho) return ho;
        if (t !== ho && t !== r && (t & i) === ho) {
          var l = ca(r),
            d = ca(t);
          if (l >= d || l === yo && (d & Ao) !== ho) return t;
        }
        (r & vo) !== ho && (r |= n & yo);
        var f = e.entangledLanes;
        if (f !== ho) for (var h = e.entanglements, p = r & f; p > 0;) {
          var m = da(p),
            g = 1 << m;
          r |= h[m], p &= ~g;
        }
        return r;
      }
      function na(e, t) {
        switch (e) {
          case mo:
          case go:
          case vo:
            return t + 250;
          case bo:
          case yo:
          case wo:
          case _o:
          case Eo:
          case So:
          case ko:
          case Mo:
          case Co:
          case xo:
          case Ro:
          case Io:
          case To:
          case Po:
          case Oo:
          case Lo:
          case No:
          case Do:
          case Bo:
            return t + 5e3;
          case Fo:
          case zo:
          case Uo:
          case qo:
          case Ko:
          case Vo:
          case Wo:
          case Yo:
          case Go:
            return Zo;
          default:
            return o("Should have found matching lanes. This is a bug in React."), Zo;
        }
      }
      function ra(e) {
        var t = e.pendingLanes & ~Go;
        return t !== ho ? t : t & Go ? Go : ho;
      }
      function ia(e) {
        return (e & $o) !== ho;
      }
      function oa(e) {
        return (e & jo) === e;
      }
      function aa(e, t) {
        return (t & (go | vo | bo | yo)) !== ho;
      }
      function sa(e) {
        return (e & Ao) !== ho;
      }
      function ua() {
        var e = Jo;
        return ((Jo <<= 1) & Ao) === ho && (Jo = _o), e;
      }
      function ca(e) {
        return e & -e;
      }
      function la(e) {
        return ca(e);
      }
      function da(e) {
        return 31 - uo(e);
      }
      function fa(e) {
        return da(e);
      }
      function ha(e, t) {
        return (e & t) !== ho;
      }
      function pa(e, t) {
        return (e & t) === t;
      }
      function ma(e, t) {
        return e | t;
      }
      function ga(e, t) {
        return e & ~t;
      }
      function va(e, t) {
        return e & t;
      }
      function ba(e) {
        for (var t = [], n = 0; n < fo; n++) t.push(e);
        return t;
      }
      function ya(e, t, n) {
        e.pendingLanes |= t, t !== Yo && (e.suspendedLanes = ho, e.pingedLanes = ho), e.eventTimes[fa(t)] = n;
      }
      function wa(e, t, n) {
        e.pingedLanes |= e.suspendedLanes & t;
      }
      function Aa(e, t) {
        for (var n = e.entangledLanes |= t, r = e.entanglements, i = n; i;) {
          var o = da(i),
            a = 1 << o;
          a & t | r[o] & t && (r[o] |= t), i &= ~a;
        }
      }
      function _a(e, t, n) {
        if (qi) for (var r = e.pendingUpdatersLaneMap; n > 0;) {
          var i = fa(n),
            o = 1 << i;
          r[i].add(t), n &= ~o;
        }
      }
      function Ea(e, t) {
        if (qi) for (var n = e.pendingUpdatersLaneMap, r = e.memoizedUpdaters; t > 0;) {
          var i = fa(t),
            o = 1 << i,
            a = n[i];
          a.size > 0 && (a.forEach(function (e) {
            var t = e.alternate;
            null !== t && r.has(t) || r.add(e);
          }), a.clear()), t &= ~o;
        }
      }
      var Sa,
        ka,
        Ma,
        Ca,
        xa,
        Ra = mo,
        Ia = vo,
        Ta = yo,
        Pa = Yo,
        Oa = po;
      function La() {
        return Oa;
      }
      function Na(e) {
        Oa = e;
      }
      function Da(e, t) {
        return 0 !== e && e < t;
      }
      function Ba(e) {
        var t = ca(e);
        return Da(Ra, t) ? Da(Ia, t) ? ia(t) ? Ta : Pa : Ia : Ra;
      }
      function ja(e) {
        return e.current.memoizedState.isDehydrated;
      }
      function Fa(e) {
        Sa(e);
      }
      var za = !1,
        Ua = [],
        qa = null,
        Ka = null,
        Ha = null,
        Va = new Map(),
        $a = new Map(),
        Wa = [],
        Ya = ["mousedown", "mouseup", "touchcancel", "touchend", "touchstart", "auxclick", "dblclick", "pointercancel", "pointerdown", "pointerup", "dragend", "dragstart", "drop", "compositionend", "compositionstart", "keydown", "keypress", "keyup", "input", "textInput", "copy", "cut", "paste", "click", "change", "contextmenu", "reset", "submit"];
      function Ga(e, t) {
        switch (e) {
          case "focusin":
          case "focusout":
            qa = null;
            break;
          case "dragenter":
          case "dragleave":
            Ka = null;
            break;
          case "mouseover":
          case "mouseout":
            Ha = null;
            break;
          case "pointerover":
          case "pointerout":
            var n = t.pointerId;
            Va.delete(n);
            break;
          case "gotpointercapture":
          case "lostpointercapture":
            var r = t.pointerId;
            $a.delete(r);
        }
      }
      function Qa(e, t, n, r, i, o) {
        if (null === e || e.nativeEvent !== o) {
          var a = function (e, t, n, r, i) {
            return {
              blockedOn: e,
              domEventName: t,
              eventSystemFlags: n,
              nativeEvent: i,
              targetContainers: [r]
            };
          }(t, n, r, i, o);
          if (null !== t) {
            var s = $l(t);
            null !== s && ka(s);
          }
          return a;
        }
        e.eventSystemFlags |= r;
        var u = e.targetContainers;
        return null !== i && -1 === u.indexOf(i) && u.push(i), e;
      }
      function Za(e) {
        var t = Vl(e.target);
        if (null !== t) {
          var n = gi(t);
          if (null !== n) {
            var r = n.tag;
            if (r === w) {
              var i = vi(n);
              if (null !== i) return e.blockedOn = i, void xa(e.priority, function () {
                Ma(n);
              });
            } else if (r === l) {
              if (ja(n.stateNode)) return void (e.blockedOn = bi(n));
            }
          }
        }
        e.blockedOn = null;
      }
      function Ja(e) {
        if (null !== e.blockedOn) return !1;
        for (var t, n = e.targetContainers; n.length > 0;) {
          var r = n[0],
            i = ls(e.domEventName, e.eventSystemFlags, r, e.nativeEvent);
          if (null !== i) {
            var a = $l(i);
            return null !== a && ka(a), e.blockedOn = i, !1;
          }
          var s = e.nativeEvent,
            u = new s.constructor(s.type, s);
          t = u, null !== lr && o("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), lr = t, s.target.dispatchEvent(u), null === lr && o("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), lr = null, n.shift();
        }
        return !0;
      }
      function Xa(e, t, n) {
        Ja(e) && n.delete(t);
      }
      function es() {
        za = !1, null !== qa && Ja(qa) && (qa = null), null !== Ka && Ja(Ka) && (Ka = null), null !== Ha && Ja(Ha) && (Ha = null), Va.forEach(Xa), $a.forEach(Xa);
      }
      function ts(e, n) {
        e.blockedOn === n && (e.blockedOn = null, za || (za = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, es)));
      }
      function ns(e) {
        if (Ua.length > 0) {
          ts(Ua[0], e);
          for (var t = 1; t < Ua.length; t++) {
            var n = Ua[t];
            n.blockedOn === e && (n.blockedOn = null);
          }
        }
        null !== qa && ts(qa, e), null !== Ka && ts(Ka, e), null !== Ha && ts(Ha, e);
        var r = function (t) {
          return ts(t, e);
        };
        Va.forEach(r), $a.forEach(r);
        for (var i = 0; i < Wa.length; i++) {
          var o = Wa[i];
          o.blockedOn === e && (o.blockedOn = null);
        }
        for (; Wa.length > 0;) {
          var a = Wa[0];
          if (null !== a.blockedOn) break;
          Za(a), null === a.blockedOn && Wa.shift();
        }
      }
      var rs = n.ReactCurrentBatchConfig,
        is = !0;
      function os(e) {
        is = !!e;
      }
      function as(e, t, n, r) {
        var i = La(),
          o = rs.transition;
        rs.transition = null;
        try {
          Na(Ra), us(e, t, n, r);
        } finally {
          Na(i), rs.transition = o;
        }
      }
      function ss(e, t, n, r) {
        var i = La(),
          o = rs.transition;
        rs.transition = null;
        try {
          Na(Ia), us(e, t, n, r);
        } finally {
          Na(i), rs.transition = o;
        }
      }
      function us(e, t, n, r) {
        is && function (e, t, n, r) {
          var i = ls(e, t, n, r);
          if (null === i) return vc(e, t, r, cs, n), void Ga(e, r);
          if (function (e, t, n, r, i) {
            switch (t) {
              case "focusin":
                return qa = Qa(qa, e, t, n, r, i), !0;
              case "dragenter":
                return Ka = Qa(Ka, e, t, n, r, i), !0;
              case "mouseover":
                return Ha = Qa(Ha, e, t, n, r, i), !0;
              case "pointerover":
                var o = i,
                  a = o.pointerId;
                return Va.set(a, Qa(Va.get(a) || null, e, t, n, r, o)), !0;
              case "gotpointercapture":
                var s = i,
                  u = s.pointerId;
                return $a.set(u, Qa($a.get(u) || null, e, t, n, r, s)), !0;
            }
            return !1;
          }(i, e, t, n, r)) return void r.stopPropagation();
          if (Ga(e, r), t & ur && function (e) {
            return Ya.indexOf(e) > -1;
          }(e)) {
            for (; null !== i;) {
              var o = $l(i);
              null !== o && Fa(o);
              var a = ls(e, t, n, r);
              if (null === a && vc(e, t, r, cs, n), a === i) break;
              i = a;
            }
            return void (null !== i && r.stopPropagation());
          }
          vc(e, t, r, null, n);
        }(e, t, n, r);
      }
      var cs = null;
      function ls(e, t, n, r) {
        cs = null;
        var i = Vl(dr(r));
        if (null !== i) {
          var o = gi(i);
          if (null === o) i = null;else {
            var a = o.tag;
            if (a === w) {
              var s = vi(o);
              if (null !== s) return s;
              i = null;
            } else if (a === l) {
              if (ja(o.stateNode)) return bi(o);
              i = null;
            } else o !== i && (i = null);
          }
        }
        return cs = i, null;
      }
      function ds(e) {
        switch (e) {
          case "cancel":
          case "click":
          case "close":
          case "contextmenu":
          case "copy":
          case "cut":
          case "auxclick":
          case "dblclick":
          case "dragend":
          case "dragstart":
          case "drop":
          case "focusin":
          case "focusout":
          case "input":
          case "invalid":
          case "keydown":
          case "keypress":
          case "keyup":
          case "mousedown":
          case "mouseup":
          case "paste":
          case "pause":
          case "play":
          case "pointercancel":
          case "pointerdown":
          case "pointerup":
          case "ratechange":
          case "reset":
          case "resize":
          case "seeked":
          case "submit":
          case "touchcancel":
          case "touchend":
          case "touchstart":
          case "volumechange":
          case "change":
          case "selectionchange":
          case "textInput":
          case "compositionstart":
          case "compositionend":
          case "compositionupdate":
          case "beforeblur":
          case "afterblur":
          case "beforeinput":
          case "blur":
          case "fullscreenchange":
          case "focus":
          case "hashchange":
          case "popstate":
          case "select":
          case "selectstart":
            return Ra;
          case "drag":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "mousemove":
          case "mouseout":
          case "mouseover":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "scroll":
          case "toggle":
          case "touchmove":
          case "wheel":
          case "mouseenter":
          case "mouseleave":
          case "pointerenter":
          case "pointerleave":
            return Ia;
          case "message":
            switch (Ii()) {
              case Ti:
                return Ra;
              case Pi:
                return Ia;
              case Oi:
              case Li:
                return Ta;
              case Ni:
                return Pa;
              default:
                return Ta;
            }
          default:
            return Ta;
        }
      }
      var fs = null,
        hs = null,
        ps = null;
      function ms() {
        if (ps) return ps;
        var e,
          t,
          n = hs,
          r = n.length,
          i = gs(),
          o = i.length;
        for (e = 0; e < r && n[e] === i[e]; e++);
        var a = r - e;
        for (t = 1; t <= a && n[r - t] === i[o - t]; t++);
        var s = t > 1 ? 1 - t : void 0;
        return ps = i.slice(e, s);
      }
      function gs() {
        return "value" in fs ? fs.value : fs.textContent;
      }
      function vs(e) {
        var t,
          n = e.keyCode;
        return "charCode" in e ? 0 === (t = e.charCode) && 13 === n && (t = 13) : t = n, 10 === t && (t = 13), t >= 32 || 13 === t ? t : 0;
      }
      function bs() {
        return !0;
      }
      function ys() {
        return !1;
      }
      function ws(e) {
        function t(t, n, r, i, o) {
          for (var a in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = o, this.currentTarget = null, e) if (e.hasOwnProperty(a)) {
            var s = e[a];
            this[a] = s ? s(i) : i[a];
          }
          var u = null != i.defaultPrevented ? i.defaultPrevented : !1 === i.returnValue;
          return this.isDefaultPrevented = u ? bs : ys, this.isPropagationStopped = ys, this;
        }
        return Ge(t.prototype, {
          preventDefault: function () {
            this.defaultPrevented = !0;
            var e = this.nativeEvent;
            e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), this.isDefaultPrevented = bs);
          },
          stopPropagation: function () {
            var e = this.nativeEvent;
            e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), this.isPropagationStopped = bs);
          },
          persist: function () {},
          isPersistent: bs
        }), t;
      }
      var As,
        _s,
        Es,
        Ss = {
          eventPhase: 0,
          bubbles: 0,
          cancelable: 0,
          timeStamp: function (e) {
            return e.timeStamp || Date.now();
          },
          defaultPrevented: 0,
          isTrusted: 0
        },
        ks = ws(Ss),
        Ms = Ge({}, Ss, {
          view: 0,
          detail: 0
        }),
        Cs = ws(Ms);
      var xs = Ge({}, Ms, {
          screenX: 0,
          screenY: 0,
          clientX: 0,
          clientY: 0,
          pageX: 0,
          pageY: 0,
          ctrlKey: 0,
          shiftKey: 0,
          altKey: 0,
          metaKey: 0,
          getModifierState: zs,
          button: 0,
          buttons: 0,
          relatedTarget: function (e) {
            return void 0 === e.relatedTarget ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
          },
          movementX: function (e) {
            return "movementX" in e ? e.movementX : (function (e) {
              e !== Es && (Es && "mousemove" === e.type ? (As = e.screenX - Es.screenX, _s = e.screenY - Es.screenY) : (As = 0, _s = 0), Es = e);
            }(e), As);
          },
          movementY: function (e) {
            return "movementY" in e ? e.movementY : _s;
          }
        }),
        Rs = ws(xs),
        Is = ws(Ge({}, xs, {
          dataTransfer: 0
        })),
        Ts = ws(Ge({}, Ms, {
          relatedTarget: 0
        })),
        Ps = ws(Ge({}, Ss, {
          animationName: 0,
          elapsedTime: 0,
          pseudoElement: 0
        })),
        Os = ws(Ge({}, Ss, {
          clipboardData: function (e) {
            return "clipboardData" in e ? e.clipboardData : window.clipboardData;
          }
        })),
        Ls = ws(Ge({}, Ss, {
          data: 0
        })),
        Ns = Ls,
        Ds = {
          Esc: "Escape",
          Spacebar: " ",
          Left: "ArrowLeft",
          Up: "ArrowUp",
          Right: "ArrowRight",
          Down: "ArrowDown",
          Del: "Delete",
          Win: "OS",
          Menu: "ContextMenu",
          Apps: "ContextMenu",
          Scroll: "ScrollLock",
          MozPrintableKey: "Unidentified"
        },
        Bs = {
          8: "Backspace",
          9: "Tab",
          12: "Clear",
          13: "Enter",
          16: "Shift",
          17: "Control",
          18: "Alt",
          19: "Pause",
          20: "CapsLock",
          27: "Escape",
          32: " ",
          33: "PageUp",
          34: "PageDown",
          35: "End",
          36: "Home",
          37: "ArrowLeft",
          38: "ArrowUp",
          39: "ArrowRight",
          40: "ArrowDown",
          45: "Insert",
          46: "Delete",
          112: "F1",
          113: "F2",
          114: "F3",
          115: "F4",
          116: "F5",
          117: "F6",
          118: "F7",
          119: "F8",
          120: "F9",
          121: "F10",
          122: "F11",
          123: "F12",
          144: "NumLock",
          145: "ScrollLock",
          224: "Meta"
        };
      var js = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
      };
      function Fs(e) {
        var t = this.nativeEvent;
        if (t.getModifierState) return t.getModifierState(e);
        var n = js[e];
        return !!n && !!t[n];
      }
      function zs(e) {
        return Fs;
      }
      var Us = Ge({}, Ms, {
          key: function (e) {
            if (e.key) {
              var t = Ds[e.key] || e.key;
              if ("Unidentified" !== t) return t;
            }
            if ("keypress" === e.type) {
              var n = vs(e);
              return 13 === n ? "Enter" : String.fromCharCode(n);
            }
            return "keydown" === e.type || "keyup" === e.type ? Bs[e.keyCode] || "Unidentified" : "";
          },
          code: 0,
          location: 0,
          ctrlKey: 0,
          shiftKey: 0,
          altKey: 0,
          metaKey: 0,
          repeat: 0,
          locale: 0,
          getModifierState: zs,
          charCode: function (e) {
            return "keypress" === e.type ? vs(e) : 0;
          },
          keyCode: function (e) {
            return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
          },
          which: function (e) {
            return "keypress" === e.type ? vs(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
          }
        }),
        qs = ws(Us),
        Ks = ws(Ge({}, xs, {
          pointerId: 0,
          width: 0,
          height: 0,
          pressure: 0,
          tangentialPressure: 0,
          tiltX: 0,
          tiltY: 0,
          twist: 0,
          pointerType: 0,
          isPrimary: 0
        })),
        Hs = ws(Ge({}, Ms, {
          touches: 0,
          targetTouches: 0,
          changedTouches: 0,
          altKey: 0,
          metaKey: 0,
          ctrlKey: 0,
          shiftKey: 0,
          getModifierState: zs
        })),
        Vs = ws(Ge({}, Ss, {
          propertyName: 0,
          elapsedTime: 0,
          pseudoElement: 0
        })),
        $s = ws(Ge({}, xs, {
          deltaX: function (e) {
            return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
          },
          deltaY: function (e) {
            return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
          },
          deltaZ: 0,
          deltaMode: 0
        })),
        Ws = [9, 13, 27, 32],
        Ys = 229,
        Gs = Y && "CompositionEvent" in window,
        Qs = null;
      Y && "documentMode" in document && (Qs = document.documentMode);
      var Zs = Y && "TextEvent" in window && !Qs,
        Js = Y && (!Gs || Qs && Qs > 8 && Qs <= 11),
        Xs = 32,
        eu = String.fromCharCode(Xs);
      var tu = !1;
      function nu(e, t) {
        switch (e) {
          case "keyup":
            return -1 !== Ws.indexOf(t.keyCode);
          case "keydown":
            return t.keyCode !== Ys;
          case "keypress":
          case "mousedown":
          case "focusout":
            return !0;
          default:
            return !1;
        }
      }
      function ru(e) {
        var t = e.detail;
        return "object" == typeof t && "data" in t ? t.data : null;
      }
      function iu(e) {
        return "ko" === e.locale;
      }
      var ou = !1;
      function au(e, t, n, r, i) {
        var o, a;
        if (Gs ? o = function (e) {
          switch (e) {
            case "compositionstart":
              return "onCompositionStart";
            case "compositionend":
              return "onCompositionEnd";
            case "compositionupdate":
              return "onCompositionUpdate";
          }
        }(t) : ou ? nu(t, r) && (o = "onCompositionEnd") : function (e, t) {
          return "keydown" === e && t.keyCode === Ys;
        }(t, r) && (o = "onCompositionStart"), !o) return null;
        Js && !iu(r) && (ou || "onCompositionStart" !== o ? "onCompositionEnd" === o && ou && (a = ms()) : ou = function (e) {
          return fs = e, hs = gs(), !0;
        }(i));
        var s = yc(n, o);
        if (s.length > 0) {
          var u = new Ls(o, t, null, r, i);
          if (e.push({
            event: u,
            listeners: s
          }), a) u.data = a;else {
            var c = ru(r);
            null !== c && (u.data = c);
          }
        }
      }
      function su(e, t) {
        if (ou) {
          if ("compositionend" === e || !Gs && nu(e, t)) {
            var n = ms();
            return fs = null, hs = null, ps = null, ou = !1, n;
          }
          return null;
        }
        switch (e) {
          case "paste":
          default:
            return null;
          case "keypress":
            if (!function (e) {
              return (e.ctrlKey || e.altKey || e.metaKey) && !(e.ctrlKey && e.altKey);
            }(t)) {
              if (t.char && t.char.length > 1) return t.char;
              if (t.which) return String.fromCharCode(t.which);
            }
            return null;
          case "compositionend":
            return Js && !iu(t) ? null : t.data;
        }
      }
      function uu(e, t, n, r, i) {
        var o;
        if (!(o = Zs ? function (e, t) {
          switch (e) {
            case "compositionend":
              return ru(t);
            case "keypress":
              return t.which !== Xs ? null : (tu = !0, eu);
            case "textInput":
              var n = t.data;
              return n === eu && tu ? null : n;
            default:
              return null;
          }
        }(t, r) : su(t, r))) return null;
        var a = yc(n, "onBeforeInput");
        if (a.length > 0) {
          var s = new Ns("onBeforeInput", "beforeinput", null, r, i);
          e.push({
            event: s,
            listeners: a
          }), s.data = o;
        }
      }
      var cu = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
      };
      function lu(e) {
        var t = e && e.nodeName && e.nodeName.toLowerCase();
        return "input" === t ? !!cu[e.type] : "textarea" === t;
      }
      /**
                  	 * Checks if an event is supported in the current execution environment.
                  	 *
                  	 * NOTE: This will not work correctly for non-generic events such as `change`,
                  	 * `reset`, `load`, `error`, and `select`.
                  	 *
                  	 * Borrows from Modernizr.
                  	 *
                  	 * @param {string} eventNameSuffix Event name, e.g. "click".
                  	 * @return {boolean} True if the event is supported.
                  	 * @internal
                  	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
                  	 */
      function du(e, t, n, r) {
        gr(r);
        var i = yc(t, "onChange");
        if (i.length > 0) {
          var o = new ks("onChange", "change", null, n, r);
          e.push({
            event: o,
            listeners: i
          });
        }
      }
      var fu = null,
        hu = null;
      function pu(e) {
        lc(e, 0);
      }
      function mu(e) {
        if (xt(Wl(e))) return e;
      }
      function gu(e, t) {
        if ("change" === e) return t;
      }
      var vu = !1;
      function bu() {
        fu && (fu.detachEvent("onpropertychange", yu), fu = null, hu = null);
      }
      function yu(e) {
        "value" === e.propertyName && mu(hu) && function (e) {
          var t = [];
          du(t, hu, e, dr(e)), _r(pu, t);
        }(e);
      }
      function wu(e, t, n) {
        "focusin" === e ? (bu(), function (e, t) {
          hu = t, (fu = e).attachEvent("onpropertychange", yu);
        }(t, n)) : "focusout" === e && bu();
      }
      function Au(e, t) {
        if ("selectionchange" === e || "keyup" === e || "keydown" === e) return mu(hu);
      }
      function _u(e, t) {
        if ("click" === e) return mu(t);
      }
      function Eu(e, t) {
        if ("input" === e || "change" === e) return mu(t);
      }
      function Su(e, t, n, r, i, o, a) {
        var s,
          u,
          c,
          l,
          d = n ? Wl(n) : window;
        if ("select" === (l = (c = d).nodeName && c.nodeName.toLowerCase()) || "input" === l && "file" === c.type ? s = gu : lu(d) ? vu ? s = Eu : (s = Au, u = wu) : function (e) {
          var t = e.nodeName;
          return t && "input" === t.toLowerCase() && ("checkbox" === e.type || "radio" === e.type);
        }(d) && (s = _u), s) {
          var f = s(t, n);
          if (f) return void du(e, f, r, i);
        }
        u && u(t, d, n), "focusout" === t && function (e) {
          var t = e._wrapperState;
          t && t.controlled && "number" === e.type && Ut(e, "number", e.value);
        }(d);
      }
      function ku(e, t, n, r, i, o, a) {
        var s = "mouseover" === t || "pointerover" === t,
          u = "mouseout" === t || "pointerout" === t;
        if (s && r !== lr) {
          var c = r.relatedTarget || r.fromElement;
          if (c && (Vl(c) || Hl(c))) return;
        }
        if (u || s) {
          var l, d, p;
          if (i.window === i) l = i;else {
            var m = i.ownerDocument;
            l = m ? m.defaultView || m.parentWindow : window;
          }
          if (u) {
            var g = r.relatedTarget || r.toElement;
            if (d = n, null !== (p = g ? Vl(g) : null)) (p !== gi(p) || p.tag !== f && p.tag !== h) && (p = null);
          } else d = null, p = n;
          if (d !== p) {
            var v = Rs,
              b = "onMouseLeave",
              y = "onMouseEnter",
              w = "mouse";
            "pointerout" !== t && "pointerover" !== t || (v = Ks, b = "onPointerLeave", y = "onPointerEnter", w = "pointer");
            var A = null == d ? l : Wl(d),
              _ = null == p ? l : Wl(p),
              E = new v(b, w + "leave", d, r, i);
            E.target = A, E.relatedTarget = _;
            var S = null;
            if (Vl(i) === n) {
              var k = new v(y, w + "enter", p, r, i);
              k.target = _, k.relatedTarget = A, S = k;
            }
            !function (e, t, n, r, i) {
              var o = r && i ? function (e, t) {
                for (var n = e, r = t, i = 0, o = n; o; o = wc(o)) i++;
                for (var a = 0, s = r; s; s = wc(s)) a++;
                for (; i - a > 0;) n = wc(n), i--;
                for (; a - i > 0;) r = wc(r), a--;
                var u = i;
                for (; u--;) {
                  if (n === r || null !== r && n === r.alternate) return n;
                  n = wc(n), r = wc(r);
                }
                return null;
              }(r, i) : null;
              null !== r && Ac(e, t, r, o, !1);
              null !== i && null !== n && Ac(e, n, i, o, !0);
            }(e, E, S, d, p);
          }
        }
      }
      Y && (vu = function (e) {
        if (!Y) return !1;
        var t = "on" + e,
          n = (t in document);
        if (!n) {
          var r = document.createElement("div");
          r.setAttribute(t, "return;"), n = "function" == typeof r[t];
        }
        return n;
      }("input") && (!document.documentMode || document.documentMode > 9));
      var Mu = "function" == typeof Object.is ? Object.is : function (e, t) {
        return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
      };
      function Cu(e, t) {
        if (Mu(e, t)) return !0;
        if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
        var n = Object.keys(e),
          r = Object.keys(t);
        if (n.length !== r.length) return !1;
        for (var i = 0; i < n.length; i++) {
          var o = n[i];
          if (!G.call(t, o) || !Mu(e[o], t[o])) return !1;
        }
        return !0;
      }
      function xu(e) {
        for (; e && e.firstChild;) e = e.firstChild;
        return e;
      }
      function Ru(e) {
        for (; e;) {
          if (e.nextSibling) return e.nextSibling;
          e = e.parentNode;
        }
      }
      function Iu(e, t) {
        for (var n = xu(e), r = 0, i = 0; n;) {
          if (n.nodeType === pn) {
            if (i = r + n.textContent.length, r <= t && i >= t) return {
              node: n,
              offset: t - r
            };
            r = i;
          }
          n = xu(Ru(n));
        }
      }
      function Tu(e) {
        var t = e.ownerDocument,
          n = t && t.defaultView || window,
          r = n.getSelection && n.getSelection();
        if (!r || 0 === r.rangeCount) return null;
        var i = r.anchorNode,
          o = r.anchorOffset,
          a = r.focusNode,
          s = r.focusOffset;
        try {
          i.nodeType, a.nodeType;
        } catch (e) {
          return null;
        }
        return function (e, t, n, r, i) {
          var o = 0,
            a = -1,
            s = -1,
            u = 0,
            c = 0,
            l = e,
            d = null;
          e: for (;;) {
            for (var f = null; l !== t || 0 !== n && l.nodeType !== pn || (a = o + n), l !== r || 0 !== i && l.nodeType !== pn || (s = o + i), l.nodeType === pn && (o += l.nodeValue.length), null !== (f = l.firstChild);) d = l, l = f;
            for (;;) {
              if (l === e) break e;
              if (d === t && ++u === n && (a = o), d === r && ++c === i && (s = o), null !== (f = l.nextSibling)) break;
              d = (l = d).parentNode;
            }
            l = f;
          }
          if (-1 === a || -1 === s) return null;
          return {
            start: a,
            end: s
          };
        }(e, i, o, a, s);
      }
      function Pu(e) {
        return e && e.nodeType === pn;
      }
      function Ou(e, t) {
        return !(!e || !t) && (e === t || !Pu(e) && (Pu(t) ? Ou(e, t.parentNode) : "contains" in e ? e.contains(t) : !!e.compareDocumentPosition && !!(16 & e.compareDocumentPosition(t))));
      }
      function Lu(e) {
        return e && e.ownerDocument && Ou(e.ownerDocument.documentElement, e);
      }
      function Nu(e) {
        try {
          return "string" == typeof e.contentWindow.location.href;
        } catch (e) {
          return !1;
        }
      }
      function Du() {
        for (var e = window, t = Rt(); t instanceof e.HTMLIFrameElement;) {
          if (!Nu(t)) return t;
          t = Rt((e = t.contentWindow).document);
        }
        return t;
      }
      function Bu(e) {
        var t = e && e.nodeName && e.nodeName.toLowerCase();
        return t && ("input" === t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === t || "true" === e.contentEditable);
      }
      function ju(e) {
        var t = Du(),
          n = e.focusedElem,
          r = e.selectionRange;
        if (t !== n && Lu(n)) {
          null !== r && Bu(n) && function (e, t) {
            var n = t.start,
              r = t.end;
            void 0 === r && (r = n);
            "selectionStart" in e ? (e.selectionStart = n, e.selectionEnd = Math.min(r, e.value.length)) : function (e, t) {
              var n = e.ownerDocument || document,
                r = n && n.defaultView || window;
              if (r.getSelection) {
                var i = r.getSelection(),
                  o = e.textContent.length,
                  a = Math.min(t.start, o),
                  s = void 0 === t.end ? a : Math.min(t.end, o);
                if (!i.extend && a > s) {
                  var u = s;
                  s = a, a = u;
                }
                var c = Iu(e, a),
                  l = Iu(e, s);
                if (c && l) {
                  if (1 === i.rangeCount && i.anchorNode === c.node && i.anchorOffset === c.offset && i.focusNode === l.node && i.focusOffset === l.offset) return;
                  var d = n.createRange();
                  d.setStart(c.node, c.offset), i.removeAllRanges(), a > s ? (i.addRange(d), i.extend(l.node, l.offset)) : (d.setEnd(l.node, l.offset), i.addRange(d));
                }
              }
            }(e, t);
          }(n, r);
          for (var i = [], o = n; o = o.parentNode;) o.nodeType === hn && i.push({
            element: o,
            left: o.scrollLeft,
            top: o.scrollTop
          });
          "function" == typeof n.focus && n.focus();
          for (var a = 0; a < i.length; a++) {
            var s = i[a];
            s.element.scrollLeft = s.left, s.element.scrollTop = s.top;
          }
        }
      }
      function Fu(e) {
        return ("selectionStart" in e ? {
          start: e.selectionStart,
          end: e.selectionEnd
        } : Tu(e)) || {
          start: 0,
          end: 0
        };
      }
      var zu = Y && "documentMode" in document && document.documentMode <= 11;
      var Uu = null,
        qu = null,
        Ku = null,
        Hu = !1;
      function Vu(e, t, n) {
        var r,
          i = (r = n).window === r ? r.document : r.nodeType === gn ? r : r.ownerDocument;
        if (!Hu && null != Uu && Uu === Rt(i)) {
          var o = function (e) {
            if ("selectionStart" in e && Bu(e)) return {
              start: e.selectionStart,
              end: e.selectionEnd
            };
            var t = (e.ownerDocument && e.ownerDocument.defaultView || window).getSelection();
            return {
              anchorNode: t.anchorNode,
              anchorOffset: t.anchorOffset,
              focusNode: t.focusNode,
              focusOffset: t.focusOffset
            };
          }(Uu);
          if (!Ku || !Cu(Ku, o)) {
            Ku = o;
            var a = yc(qu, "onSelect");
            if (a.length > 0) {
              var s = new ks("onSelect", "select", null, t, n);
              e.push({
                event: s,
                listeners: a
              }), s.target = Uu;
            }
          }
        }
      }
      function $u(e, t) {
        var n = {};
        return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
      }
      var Wu = {
          animationend: $u("Animation", "AnimationEnd"),
          animationiteration: $u("Animation", "AnimationIteration"),
          animationstart: $u("Animation", "AnimationStart"),
          transitionend: $u("Transition", "TransitionEnd")
        },
        Yu = {},
        Gu = {};
      function Qu(e) {
        if (Yu[e]) return Yu[e];
        if (!Wu[e]) return e;
        var t = Wu[e];
        for (var n in t) if (t.hasOwnProperty(n) && n in Gu) return Yu[e] = t[n];
        return e;
      }
      Y && (Gu = document.createElement("div").style, "AnimationEvent" in window || (delete Wu.animationend.animation, delete Wu.animationiteration.animation, delete Wu.animationstart.animation), "TransitionEvent" in window || delete Wu.transitionend.transition);
      var Zu = Qu("animationend"),
        Ju = Qu("animationiteration"),
        Xu = Qu("animationstart"),
        ec = Qu("transitionend"),
        tc = new Map(),
        nc = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
      function rc(e, t) {
        tc.set(e, t), $(t, [e]);
      }
      function ic(e, t, n, r, i, o, a) {
        var s = tc.get(t);
        if (void 0 !== s) {
          var u = ks,
            c = t;
          switch (t) {
            case "keypress":
              if (0 === vs(r)) return;
            case "keydown":
            case "keyup":
              u = qs;
              break;
            case "focusin":
              c = "focus", u = Ts;
              break;
            case "focusout":
              c = "blur", u = Ts;
              break;
            case "beforeblur":
            case "afterblur":
              u = Ts;
              break;
            case "click":
              if (2 === r.button) return;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              u = Rs;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              u = Is;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              u = Hs;
              break;
            case Zu:
            case Ju:
            case Xu:
              u = Ps;
              break;
            case ec:
              u = Vs;
              break;
            case "scroll":
              u = Cs;
              break;
            case "wheel":
              u = $s;
              break;
            case "copy":
            case "cut":
            case "paste":
              u = Os;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              u = Ks;
          }
          var l = 0 != (o & ur),
            d = !l && "scroll" === t,
            h = function (e, t, n, r, i, o) {
              var a = null !== t ? t + "Capture" : null,
                s = r ? a : t,
                u = [],
                c = e,
                l = null;
              for (; null !== c;) {
                var d = c,
                  h = d.stateNode;
                if (d.tag === f && null !== h && (l = h, null !== s)) {
                  var p = Er(c, s);
                  null != p && u.push(bc(c, p, l));
                }
                if (i) break;
                c = c.return;
              }
              return u;
            }(n, s, r.type, l, d);
          if (h.length > 0) {
            var p = new u(s, c, null, r, i);
            e.push({
              event: p,
              listeners: h
            });
          }
        }
      }
      function oc(e, t, n, r, i, o, a) {
        ic(e, t, n, r, i, o), 0 == (o & cr) && (ku(e, t, n, r, i), Su(e, t, n, r, i), function (e, t, n, r, i, o, a) {
          var s = n ? Wl(n) : window;
          switch (t) {
            case "focusin":
              (lu(s) || "true" === s.contentEditable) && (Uu = s, qu = n, Ku = null);
              break;
            case "focusout":
              Uu = null, qu = null, Ku = null;
              break;
            case "mousedown":
              Hu = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              Hu = !1, Vu(e, r, i);
              break;
            case "selectionchange":
              if (zu) break;
            case "keydown":
            case "keyup":
              Vu(e, r, i);
          }
        }(e, t, n, r, i), function (e, t, n, r, i, o, a) {
          au(e, t, n, r, i), uu(e, t, n, r, i);
        }(e, t, n, r, i));
      }
      !function () {
        for (var e = 0; e < nc.length; e++) {
          var t = nc[e];
          rc(t.toLowerCase(), "on" + (t[0].toUpperCase() + t.slice(1)));
        }
        rc(Zu, "onAnimationEnd"), rc(Ju, "onAnimationIteration"), rc(Xu, "onAnimationStart"), rc("dblclick", "onDoubleClick"), rc("focusin", "onFocus"), rc("focusout", "onBlur"), rc(ec, "onTransitionEnd");
      }(), W("onMouseEnter", ["mouseout", "mouseover"]), W("onMouseLeave", ["mouseout", "mouseover"]), W("onPointerEnter", ["pointerout", "pointerover"]), W("onPointerLeave", ["pointerout", "pointerover"]), $("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]), $("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]), $("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), $("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), $("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), $("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
      var ac = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"],
        sc = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(ac));
      function uc(e, t, n) {
        var r = e.type || "unknown-event";
        e.currentTarget = n, function (e, t, n, r, i, o, a, s, u) {
          if (Nr.apply(this, arguments), Ir) {
            var c = Dr();
            Pr || (Pr = !0, Or = c);
          }
        }(r, t, void 0, e), e.currentTarget = null;
      }
      function cc(e, t, n) {
        var r;
        if (n) for (var i = t.length - 1; i >= 0; i--) {
          var o = t[i],
            a = o.instance,
            s = o.currentTarget,
            u = o.listener;
          if (a !== r && e.isPropagationStopped()) return;
          uc(e, u, s), r = a;
        } else for (var c = 0; c < t.length; c++) {
          var l = t[c],
            d = l.instance,
            f = l.currentTarget,
            h = l.listener;
          if (d !== r && e.isPropagationStopped()) return;
          uc(e, h, f), r = d;
        }
      }
      function lc(e, t) {
        for (var n = 0 != (t & ur), r = 0; r < e.length; r++) {
          var i = e[r];
          cc(i.event, i.listeners, n);
        }
        !function () {
          if (Pr) {
            var e = Or;
            throw Pr = !1, Or = null, e;
          }
        }();
      }
      function dc(e, t) {
        sc.has(e) || o('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
        var n = function (e) {
            var t = e[jl];
            void 0 === t && (t = e[jl] = new Set());
            return t;
          }(t),
          r = function (e, t) {
            return e + "__" + (t ? "capture" : "bubble");
          }(e, false);
        n.has(r) || (mc(t, e, sr, false), n.add(r));
      }
      function fc(e, t, n) {
        sc.has(e) && !t && o('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
        var r = 0;
        t && (r |= ur), mc(n, e, r, t);
      }
      var hc = "_reactListening" + Math.random().toString(36).slice(2);
      function pc(e) {
        if (!e[hc]) {
          e[hc] = !0, K.forEach(function (t) {
            "selectionchange" !== t && (sc.has(t) || fc(t, !1, e), fc(t, !0, e));
          });
          var t = e.nodeType === gn ? e : e.ownerDocument;
          null !== t && (t[hc] || (t[hc] = !0, fc("selectionchange", !1, t)));
        }
      }
      function mc(e, t, n, r, i) {
        var o = function (e, t, n) {
            var r;
            switch (ds(t)) {
              case Ra:
                r = as;
                break;
              case Ia:
                r = ss;
                break;
              default:
                r = us;
            }
            return r.bind(null, t, n, e);
          }(e, t, n),
          a = void 0;
        Sr && ("touchstart" !== t && "touchmove" !== t && "wheel" !== t || (a = !0)), r ? void 0 !== a ? function (e, t, n, r) {
          e.addEventListener(t, n, {
            capture: !0,
            passive: r
          });
        }(e, t, o, a) : function (e, t, n) {
          e.addEventListener(t, n, !0);
        }(e, t, o) : void 0 !== a ? function (e, t, n, r) {
          e.addEventListener(t, n, {
            passive: r
          });
        }(e, t, o, a) : function (e, t, n) {
          e.addEventListener(t, n, !1);
        }(e, t, o);
      }
      function gc(e, t) {
        return e === t || e.nodeType === mn && e.parentNode === t;
      }
      function vc(e, t, n, r, i) {
        var o = r;
        if (0 == (t & ar) && 0 == (t & sr)) {
          var a = i;
          if (null !== r) {
            var s = r;
            e: for (;;) {
              if (null === s) return;
              var u = s.tag;
              if (u === l || u === d) {
                var c = s.stateNode.containerInfo;
                if (gc(c, a)) break;
                if (u === d) for (var p = s.return; null !== p;) {
                  var m = p.tag;
                  if (m === l || m === d) if (gc(p.stateNode.containerInfo, a)) return;
                  p = p.return;
                }
                for (; null !== c;) {
                  var g = Vl(c);
                  if (null === g) return;
                  var v = g.tag;
                  if (v === f || v === h) {
                    s = o = g;
                    continue e;
                  }
                  c = c.parentNode;
                }
              }
              s = s.return;
            }
          }
        }
        _r(function () {
          return function (e, t, n, r, i) {
            var o = [];
            oc(o, e, r, n, dr(n), t), lc(o, t);
          }(e, t, n, o);
        });
      }
      function bc(e, t, n) {
        return {
          instance: e,
          listener: t,
          currentTarget: n
        };
      }
      function yc(e, t) {
        for (var n = t + "Capture", r = [], i = e; null !== i;) {
          var o = i,
            a = o.stateNode;
          if (o.tag === f && null !== a) {
            var s = a,
              u = Er(i, n);
            null != u && r.unshift(bc(i, u, s));
            var c = Er(i, t);
            null != c && r.push(bc(i, c, s));
          }
          i = i.return;
        }
        return r;
      }
      function wc(e) {
        if (null === e) return null;
        do {
          e = e.return;
        } while (e && e.tag !== f);
        return e || null;
      }
      function Ac(e, t, n, r, i) {
        for (var o = t._reactName, a = [], s = n; null !== s && s !== r;) {
          var u = s,
            c = u.alternate,
            l = u.stateNode,
            d = u.tag;
          if (null !== c && c === r) break;
          if (d === f && null !== l) {
            var h = l;
            if (i) {
              var p = Er(s, o);
              null != p && a.unshift(bc(s, p, h));
            } else if (!i) {
              var m = Er(s, o);
              null != m && a.push(bc(s, m, h));
            }
          }
          s = s.return;
        }
        0 !== a.length && e.push({
          event: t,
          listeners: a
        });
      }
      var _c,
        Ec,
        Sc,
        kc,
        Mc,
        Cc,
        xc,
        Rc = !1,
        Ic = "dangerouslySetInnerHTML",
        Tc = "suppressContentEditableWarning",
        Pc = "suppressHydrationWarning",
        Oc = "autoFocus",
        Lc = "children",
        Nc = "style",
        Dc = "__html";
      _c = {
        dialog: !0,
        webview: !0
      }, Ec = function (e, t) {
        Zn(e, t), function (e, t) {
          "input" !== e && "textarea" !== e && "select" !== e || null == t || null !== t.value || Jn || (Jn = !0, "select" === e && t.multiple ? o("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : o("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
        }(e, t), or(e, t, {
          registrationNameDependencies: H,
          possibleRegistrationNames: V
        });
      }, Cc = Y && !document.documentMode, Sc = function (e, t, n) {
        if (!Rc) {
          var r = Fc(n),
            i = Fc(t);
          i !== r && (Rc = !0, o("Prop `%s` did not match. Server: %s Client: %s", e, JSON.stringify(i), JSON.stringify(r)));
        }
      }, kc = function (e) {
        if (!Rc) {
          Rc = !0;
          var t = [];
          e.forEach(function (e) {
            t.push(e);
          }), o("Extra attributes from the server: %s", t);
        }
      }, Mc = function (e, t) {
        !1 === t ? o("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : o("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof t);
      }, xc = function (e, t) {
        var n = e.namespaceURI === an ? e.ownerDocument.createElement(e.tagName) : e.ownerDocument.createElementNS(e.namespaceURI, e.tagName);
        return n.innerHTML = t, n.innerHTML;
      };
      var Bc = /\r\n?/g,
        jc = /\u0000|\uFFFD/g;
      function Fc(e) {
        return function (e) {
          if (Z(e)) o("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Q(e)), J(e);
        }(e), ("string" == typeof e ? e : "" + e).replace(Bc, "\n").replace(jc, "");
      }
      function zc(e, t, n, r) {
        var i = Fc(t),
          a = Fc(e);
        if (a !== i && (r && (Rc || (Rc = !0, o('Text content did not match. Server: "%s" Client: "%s"', a, i))), n && P)) throw new Error("Text content does not match server-rendered HTML.");
      }
      function Uc(e) {
        return e.nodeType === gn ? e : e.ownerDocument;
      }
      function qc() {}
      function Kc(e) {
        e.onclick = qc;
      }
      function Hc(e, t, n, r) {
        var i,
          o = Hn(t, n);
        switch (Ec(t, n), t) {
          case "dialog":
            dc("cancel", e), dc("close", e), i = n;
            break;
          case "iframe":
          case "object":
          case "embed":
            dc("load", e), i = n;
            break;
          case "video":
          case "audio":
            for (var a = 0; a < ac.length; a++) dc(ac[a], e);
            i = n;
            break;
          case "source":
            dc("error", e), i = n;
            break;
          case "img":
          case "image":
          case "link":
            dc("error", e), dc("load", e), i = n;
            break;
          case "details":
            dc("toggle", e), i = n;
            break;
          case "input":
            Dt(e, n), i = Nt(e, n), dc("invalid", e);
            break;
          case "option":
            Vt(0, n), i = n;
            break;
          case "select":
            Xt(e, n), i = Jt(0, n), dc("invalid", e);
            break;
          case "textarea":
            nn(e, n), i = tn(e, n), dc("invalid", e);
            break;
          default:
            i = n;
        }
        switch (Kn(t, i), function (e, t, n, r, i) {
          for (var o in r) if (r.hasOwnProperty(o)) {
            var a = r[o];
            if (o === Nc) a && Object.freeze(a), jn(t, a);else if (o === Ic) {
              var s = a ? a[Dc] : void 0;
              null != s && fn(t, s);
            } else o === Lc ? "string" == typeof a ? ("textarea" !== e || "" !== a) && bn(t, a) : "number" == typeof a && bn(t, "" + a) : o === Tc || o === Pc || o === Oc || (H.hasOwnProperty(o) ? null != a && ("function" != typeof a && Mc(o, a), "onScroll" === o && dc("scroll", t)) : null != a && ke(t, o, a, i));
          }
        }(t, e, 0, i, o), t) {
          case "input":
            Ct(e), Ft(e, n, !1);
            break;
          case "textarea":
            Ct(e), on(e);
            break;
          case "option":
            !function (e, t) {
              null != t.value && e.setAttribute("value", At(_t(t.value)));
            }(e, n);
            break;
          case "select":
            !function (e, t) {
              var n = e;
              n.multiple = !!t.multiple;
              var r = t.value;
              null != r ? Zt(n, !!t.multiple, r, !1) : null != t.defaultValue && Zt(n, !!t.multiple, t.defaultValue, !0);
            }(e, n);
            break;
          default:
            "function" == typeof i.onClick && Kc(e);
        }
      }
      function Vc(e, t, n, r, i) {
        Ec(t, r);
        var a,
          s,
          u,
          c,
          l = null;
        switch (t) {
          case "input":
            a = Nt(e, n), s = Nt(e, r), l = [];
            break;
          case "select":
            a = Jt(0, n), s = Jt(0, r), l = [];
            break;
          case "textarea":
            a = tn(e, n), s = tn(e, r), l = [];
            break;
          default:
            s = r, "function" != typeof (a = n).onClick && "function" == typeof s.onClick && Kc(e);
        }
        Kn(t, s);
        var d = null;
        for (u in a) if (!s.hasOwnProperty(u) && a.hasOwnProperty(u) && null != a[u]) if (u === Nc) {
          var f = a[u];
          for (c in f) f.hasOwnProperty(c) && (d || (d = {}), d[c] = "");
        } else u === Ic || u === Lc || u === Tc || u === Pc || u === Oc || (H.hasOwnProperty(u) ? l || (l = []) : (l = l || []).push(u, null));
        for (u in s) {
          var h = s[u],
            p = null != a ? a[u] : void 0;
          if (s.hasOwnProperty(u) && h !== p && (null != h || null != p)) if (u === Nc) {
            if (h && Object.freeze(h), p) {
              for (c in p) !p.hasOwnProperty(c) || h && h.hasOwnProperty(c) || (d || (d = {}), d[c] = "");
              for (c in h) h.hasOwnProperty(c) && p[c] !== h[c] && (d || (d = {}), d[c] = h[c]);
            } else d || (l || (l = []), l.push(u, d)), d = h;
          } else if (u === Ic) {
            var m = h ? h[Dc] : void 0,
              g = p ? p[Dc] : void 0;
            null != m && g !== m && (l = l || []).push(u, m);
          } else u === Lc ? "string" != typeof h && "number" != typeof h || (l = l || []).push(u, "" + h) : u === Tc || u === Pc || (H.hasOwnProperty(u) ? (null != h && ("function" != typeof h && Mc(u, h), "onScroll" === u && dc("scroll", e)), l || p === h || (l = [])) : (l = l || []).push(u, h));
        }
        return d && (!function (e, t) {
          if (t) {
            var n = zn(e),
              r = zn(t),
              i = {};
            for (var a in n) {
              var s = n[a],
                u = r[a];
              if (u && s !== u) {
                var c = s + "," + u;
                if (i[c]) continue;
                i[c] = !0, o("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", Fn(e[s]) ? "Removing" : "Updating", s, u);
              }
            }
          }
        }(d, s[Nc]), (l = l || []).push(Nc, d)), l;
      }
      function $c(e, t, n, r, i) {
        "input" === n && "radio" === i.type && null != i.name && Bt(e, i);
        Hn(n, r);
        switch (function (e, t, n, r) {
          for (var i = 0; i < t.length; i += 2) {
            var o = t[i],
              a = t[i + 1];
            o === Nc ? jn(e, a) : o === Ic ? fn(e, a) : o === Lc ? bn(e, a) : ke(e, o, a, r);
          }
        }(e, t, 0, Hn(n, i)), n) {
          case "input":
            jt(e, i);
            break;
          case "textarea":
            rn(e, i);
            break;
          case "select":
            !function (e, t) {
              var n = e,
                r = n._wrapperState.wasMultiple;
              n._wrapperState.wasMultiple = !!t.multiple;
              var i = t.value;
              null != i ? Zt(n, !!t.multiple, i, !1) : r !== !!t.multiple && (null != t.defaultValue ? Zt(n, !!t.multiple, t.defaultValue, !0) : Zt(n, !!t.multiple, t.multiple ? [] : "", !1));
            }(e, i);
        }
      }
      function Wc(e, t) {
        Rc || (Rc = !0, o("Did not expect server HTML to contain a <%s> in <%s>.", t.nodeName.toLowerCase(), e.nodeName.toLowerCase()));
      }
      function Yc(e, t) {
        Rc || (Rc = !0, o('Did not expect server HTML to contain the text node "%s" in <%s>.', t.nodeValue, e.nodeName.toLowerCase()));
      }
      function Gc(e, t, n) {
        Rc || (Rc = !0, o("Expected server HTML to contain a matching <%s> in <%s>.", t, e.nodeName.toLowerCase()));
      }
      function Qc(e, t) {
        "" !== t && (Rc || (Rc = !0, o('Expected server HTML to contain a matching text node for "%s" in <%s>.', t, e.nodeName.toLowerCase())));
      }
      var Zc = function () {},
        Jc = function () {},
        Xc = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"],
        el = ["applet", "caption", "html", "table", "td", "th", "marquee", "object", "template", "foreignObject", "desc", "title"],
        tl = el.concat(["button"]),
        nl = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"],
        rl = {
          current: null,
          formTag: null,
          aTagInScope: null,
          buttonTagInScope: null,
          nobrTagInScope: null,
          pTagInButtonScope: null,
          listItemTagAutoclosing: null,
          dlItemTagAutoclosing: null
        };
      Jc = function (e, t) {
        var n = Ge({}, e || rl),
          r = {
            tag: t
          };
        return -1 !== el.indexOf(t) && (n.aTagInScope = null, n.buttonTagInScope = null, n.nobrTagInScope = null), -1 !== tl.indexOf(t) && (n.pTagInButtonScope = null), -1 !== Xc.indexOf(t) && "address" !== t && "div" !== t && "p" !== t && (n.listItemTagAutoclosing = null, n.dlItemTagAutoclosing = null), n.current = r, "form" === t && (n.formTag = r), "a" === t && (n.aTagInScope = r), "button" === t && (n.buttonTagInScope = r), "nobr" === t && (n.nobrTagInScope = r), "p" === t && (n.pTagInButtonScope = r), "li" === t && (n.listItemTagAutoclosing = r), "dd" !== t && "dt" !== t || (n.dlItemTagAutoclosing = r), n;
      };
      var il = {};
      Zc = function (e, t, n) {
        var r = (n = n || rl).current,
          i = r && r.tag;
        null != t && (null != e && o("validateDOMNesting: when childText is passed, childTag should be null"), e = "#text");
        var a = function (e, t) {
            switch (t) {
              case "select":
                return "option" === e || "optgroup" === e || "#text" === e;
              case "optgroup":
                return "option" === e || "#text" === e;
              case "option":
                return "#text" === e;
              case "tr":
                return "th" === e || "td" === e || "style" === e || "script" === e || "template" === e;
              case "tbody":
              case "thead":
              case "tfoot":
                return "tr" === e || "style" === e || "script" === e || "template" === e;
              case "colgroup":
                return "col" === e || "template" === e;
              case "table":
                return "caption" === e || "colgroup" === e || "tbody" === e || "tfoot" === e || "thead" === e || "style" === e || "script" === e || "template" === e;
              case "head":
                return "base" === e || "basefont" === e || "bgsound" === e || "link" === e || "meta" === e || "title" === e || "noscript" === e || "noframes" === e || "style" === e || "script" === e || "template" === e;
              case "html":
                return "head" === e || "body" === e || "frameset" === e;
              case "frameset":
                return "frame" === e;
              case "#document":
                return "html" === e;
            }
            switch (e) {
              case "h1":
              case "h2":
              case "h3":
              case "h4":
              case "h5":
              case "h6":
                return "h1" !== t && "h2" !== t && "h3" !== t && "h4" !== t && "h5" !== t && "h6" !== t;
              case "rp":
              case "rt":
                return -1 === nl.indexOf(t);
              case "body":
              case "caption":
              case "col":
              case "colgroup":
              case "frameset":
              case "frame":
              case "head":
              case "html":
              case "tbody":
              case "td":
              case "tfoot":
              case "th":
              case "thead":
              case "tr":
                return null == t;
            }
            return !0;
          }(e, i) ? null : r,
          s = a ? null : function (e, t) {
            switch (e) {
              case "address":
              case "article":
              case "aside":
              case "blockquote":
              case "center":
              case "details":
              case "dialog":
              case "dir":
              case "div":
              case "dl":
              case "fieldset":
              case "figcaption":
              case "figure":
              case "footer":
              case "header":
              case "hgroup":
              case "main":
              case "menu":
              case "nav":
              case "ol":
              case "p":
              case "section":
              case "summary":
              case "ul":
              case "pre":
              case "listing":
              case "table":
              case "hr":
              case "xmp":
              case "h1":
              case "h2":
              case "h3":
              case "h4":
              case "h5":
              case "h6":
                return t.pTagInButtonScope;
              case "form":
                return t.formTag || t.pTagInButtonScope;
              case "li":
                return t.listItemTagAutoclosing;
              case "dd":
              case "dt":
                return t.dlItemTagAutoclosing;
              case "button":
                return t.buttonTagInScope;
              case "a":
                return t.aTagInScope;
              case "nobr":
                return t.nobrTagInScope;
            }
            return null;
          }(e, n),
          u = a || s;
        if (u) {
          var c = u.tag,
            l = !!a + "|" + e + "|" + c;
          if (!il[l]) {
            il[l] = !0;
            var d = e,
              f = "";
            if ("#text" === e ? /\S/.test(t) ? d = "Text nodes" : (d = "Whitespace text nodes", f = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : d = "<" + e + ">", a) {
              var h = "";
              "table" === c && "tr" === e && (h += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), o("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", d, c, f, h);
            } else o("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", d, c);
          }
        }
      };
      var ol = "suppressHydrationWarning",
        al = "$",
        sl = "/$",
        ul = "$?",
        cl = "$!",
        ll = "style",
        dl = null,
        fl = null;
      function hl(e) {
        var t;
        dl = is, t = Du(), fl = {
          focusedElem: t,
          selectionRange: Bu(t) ? Fu(t) : null
        };
        return os(!1), null;
      }
      function pl(e, t, n, r, i) {
        var a = r;
        if (Zc(e, null, a.ancestorInfo), "string" == typeof t.children || "number" == typeof t.children) {
          var s = "" + t.children,
            u = Jc(a.ancestorInfo, e);
          Zc(null, s, u);
        }
        var c = function (e, t, n, r) {
          var i,
            a,
            s = Uc(n),
            u = r;
          if (u === an && (u = cn(e)), u === an) {
            if ((i = Hn(e, t)) || e === e.toLowerCase() || o("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), "script" === e) {
              var c = s.createElement("div");
              c.innerHTML = "<script><\/script>";
              var l = c.firstChild;
              a = c.removeChild(l);
            } else if ("string" == typeof t.is) a = s.createElement(e, {
              is: t.is
            });else if (a = s.createElement(e), "select" === e) {
              var d = a;
              t.multiple ? d.multiple = !0 : t.size && (d.size = t.size);
            }
          } else a = s.createElementNS(u, e);
          return u === an && (i || "[object HTMLUnknownElement]" !== Object.prototype.toString.call(a) || G.call(_c, e) || (_c[e] = !0, o("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", e))), a;
        }(e, t, n, a.namespace);
        return Ul(i, c), Gl(c, t), c;
      }
      function ml(e, t) {
        return "textarea" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
      }
      function gl(e, t, n, r) {
        Zc(null, e, n.ancestorInfo);
        var i = function (e, t) {
          return Uc(t).createTextNode(e);
        }(e, t);
        return Ul(r, i), i;
      }
      var vl = "function" == typeof setTimeout ? setTimeout : void 0,
        bl = "function" == typeof clearTimeout ? clearTimeout : void 0,
        yl = -1,
        wl = "function" == typeof Promise ? Promise : void 0,
        Al = "function" == typeof queueMicrotask ? queueMicrotask : void 0 !== wl ? function (e) {
          return wl.resolve(null).then(e).catch(_l);
        } : vl;
      function _l(e) {
        setTimeout(function () {
          throw e;
        });
      }
      function El(e) {
        bn(e, "");
      }
      function Sl(e, t) {
        var n = t,
          r = 0;
        do {
          var i = n.nextSibling;
          if (e.removeChild(n), i && i.nodeType === mn) {
            var o = i.data;
            if (o === sl) {
              if (0 === r) return e.removeChild(i), void ns(t);
              r--;
            } else o !== al && o !== ul && o !== cl || r++;
          }
          n = i;
        } while (n);
        ns(t);
      }
      function kl(e) {
        var t = e.style;
        "function" == typeof t.setProperty ? t.setProperty("display", "none", "important") : t.display = "none";
      }
      function Ml(e, t) {
        var n = t[ll],
          r = null != n && n.hasOwnProperty("display") ? n.display : null;
        e.style.display = _n("display", r);
      }
      function Cl(e, t) {
        e.nodeValue = t;
      }
      function xl(e) {
        return e.data === ul;
      }
      function Rl(e) {
        return e.data === cl;
      }
      function Il(e) {
        for (; null != e; e = e.nextSibling) {
          var t = e.nodeType;
          if (t === hn || t === pn) break;
          if (t === mn) {
            var n = e.data;
            if (n === al || n === cl || n === ul) break;
            if (n === sl) return null;
          }
        }
        return e;
      }
      function Tl(e) {
        return Il(e.nextSibling);
      }
      function Pl(e, t, n, r, i, o, a) {
        return Ul(o, e), Gl(e, n), function (e, t, n, r, i, o, a) {
          var s, u;
          switch (s = Hn(t, n), Ec(t, n), t) {
            case "dialog":
              dc("cancel", e), dc("close", e);
              break;
            case "iframe":
            case "object":
            case "embed":
              dc("load", e);
              break;
            case "video":
            case "audio":
              for (var c = 0; c < ac.length; c++) dc(ac[c], e);
              break;
            case "source":
              dc("error", e);
              break;
            case "img":
            case "image":
            case "link":
              dc("error", e), dc("load", e);
              break;
            case "details":
              dc("toggle", e);
              break;
            case "input":
              Dt(e, n), dc("invalid", e);
              break;
            case "option":
              Vt(0, n);
              break;
            case "select":
              Xt(e, n), dc("invalid", e);
              break;
            case "textarea":
              nn(e, n), dc("invalid", e);
          }
          Kn(t, n), u = new Set();
          for (var l = e.attributes, d = 0; d < l.length; d++) switch (l[d].name.toLowerCase()) {
            case "value":
            case "checked":
            case "selected":
              break;
            default:
              u.add(l[d].name);
          }
          var f,
            h = null;
          for (var p in n) if (n.hasOwnProperty(p)) {
            var m = n[p];
            if (p === Lc) "string" == typeof m ? e.textContent !== m && (!0 !== n[Pc] && zc(e.textContent, m, o, a), h = [Lc, m]) : "number" == typeof m && e.textContent !== "" + m && (!0 !== n[Pc] && zc(e.textContent, m, o, a), h = [Lc, "" + m]);else if (H.hasOwnProperty(p)) null != m && ("function" != typeof m && Mc(p, m), "onScroll" === p && dc("scroll", e));else if (a && "boolean" == typeof s) {
              var g = void 0,
                v = s && j ? null : me(p);
              if (!0 === n[Pc]) ;else if (p === Tc || p === Pc || "value" === p || "checked" === p || "selected" === p) ;else if (p === Ic) {
                var b = e.innerHTML,
                  y = m ? m[Dc] : void 0;
                if (null != y) {
                  var w = xc(e, y);
                  w !== b && Sc(p, b, w);
                }
              } else if (p === Nc) {
                if (u.delete(p), Cc) {
                  var A = Bn(m);
                  A !== (g = e.getAttribute("style")) && Sc(p, g, A);
                }
              } else if (s && !j) u.delete(p.toLowerCase()), m !== (g = Se(e, p, m)) && Sc(p, g, m);else if (!fe(p, v, s) && !pe(p, m, v, s)) {
                var _ = !1;
                if (null !== v) u.delete(v.attributeName), g = Ee(e, p, m, v);else {
                  var E = r;
                  if (E === an && (E = cn(t)), E === an) u.delete(p.toLowerCase());else {
                    var S = (f = void 0, f = p.toLowerCase(), Vn.hasOwnProperty(f) && Vn[f] || null);
                    null !== S && S !== p && (_ = !0, u.delete(S)), u.delete(p);
                  }
                  g = Se(e, p, m);
                }
                j || m === g || _ || Sc(p, g, m);
              }
            }
          }
          switch (a && u.size > 0 && !0 !== n[Pc] && kc(u), t) {
            case "input":
              Ct(e), Ft(e, n, !0);
              break;
            case "textarea":
              Ct(e), on(e);
              break;
            case "select":
            case "option":
              break;
            default:
              "function" == typeof n.onClick && Kc(e);
          }
          return h;
        }(e, t, n, i.namespace, 0, (o.mode & io) !== ro, a);
      }
      function Ol(e) {
        for (var t = e.previousSibling, n = 0; t;) {
          if (t.nodeType === mn) {
            var r = t.data;
            if (r === al || r === cl || r === ul) {
              if (0 === n) return t;
              n--;
            } else r === sl && n++;
          }
          t = t.previousSibling;
        }
        return null;
      }
      var Ll = Math.random().toString(36).slice(2),
        Nl = "__reactFiber$" + Ll,
        Dl = "__reactProps$" + Ll,
        Bl = "__reactContainer$" + Ll,
        jl = "__reactEvents$" + Ll,
        Fl = "__reactListeners$" + Ll,
        zl = "__reactHandles$" + Ll;
      function Ul(e, t) {
        t[Nl] = e;
      }
      function ql(e, t) {
        t[Bl] = e;
      }
      function Kl(e) {
        e[Bl] = null;
      }
      function Hl(e) {
        return !!e[Bl];
      }
      function Vl(e) {
        var t = e[Nl];
        if (t) return t;
        for (var n = e.parentNode; n;) {
          if (t = n[Bl] || n[Nl]) {
            var r = t.alternate;
            if (null !== t.child || null !== r && null !== r.child) for (var i = Ol(e); null !== i;) {
              var o = i[Nl];
              if (o) return o;
              i = Ol(i);
            }
            return t;
          }
          n = (e = n).parentNode;
        }
        return null;
      }
      function $l(e) {
        var t = e[Nl] || e[Bl];
        return t && (t.tag === f || t.tag === h || t.tag === w || t.tag === l) ? t : null;
      }
      function Wl(e) {
        if (e.tag === f || e.tag === h) return e.stateNode;
        throw new Error("getNodeFromInstance: Invalid argument.");
      }
      function Yl(e) {
        return e[Dl] || null;
      }
      function Gl(e, t) {
        e[Dl] = t;
      }
      var Ql = {},
        Zl = n.ReactDebugCurrentFrame;
      function Jl(e) {
        if (e) {
          var t = e._owner,
            n = at(e.type, e._source, t ? t.type : null);
          Zl.setExtraStackFrame(n);
        } else Zl.setExtraStackFrame(null);
      }
      function Xl(e, t, n, r, i) {
        var a = Function.call.bind(G);
        for (var s in e) if (a(e, s)) {
          var u = void 0;
          try {
            if ("function" != typeof e[s]) {
              var c = Error((r || "React class") + ": " + n + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw c.name = "Invariant Violation", c;
            }
            u = e[s](t, s, r, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (e) {
            u = e;
          }
          !u || u instanceof Error || (Jl(i), o("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", r || "React class", n, s, typeof u), Jl(null)), u instanceof Error && !(u.message in Ql) && (Ql[u.message] = !0, Jl(i), o("Failed %s type: %s", n, u.message), Jl(null));
        }
      }
      var ed,
        td = [];
      ed = [];
      var nd,
        rd = -1;
      function id(e) {
        return {
          current: e
        };
      }
      function od(e, t) {
        rd < 0 ? o("Unexpected pop.") : (t !== ed[rd] && o("Unexpected Fiber popped."), e.current = td[rd], td[rd] = null, ed[rd] = null, rd--);
      }
      function ad(e, t, n) {
        rd++, td[rd] = e.current, ed[rd] = n, e.current = t;
      }
      nd = {};
      var sd = {};
      Object.freeze(sd);
      var ud = id(sd),
        cd = id(!1),
        ld = sd;
      function dd(e, t, n) {
        return n && md(t) ? ld : ud.current;
      }
      function fd(e, t, n) {
        var r = e.stateNode;
        r.__reactInternalMemoizedUnmaskedChildContext = t, r.__reactInternalMemoizedMaskedChildContext = n;
      }
      function hd(e, t) {
        var n = e.type.contextTypes;
        if (!n) return sd;
        var r = e.stateNode;
        if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
        var i = {};
        for (var o in n) i[o] = t[o];
        return Xl(n, i, "context", ft(e) || "Unknown"), r && fd(e, t, i), i;
      }
      function pd() {
        return cd.current;
      }
      function md(e) {
        var t = e.childContextTypes;
        return null != t;
      }
      function gd(e) {
        od(cd, e), od(ud, e);
      }
      function vd(e) {
        od(cd, e), od(ud, e);
      }
      function bd(e, t, n) {
        if (ud.current !== sd) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        ad(ud, t, e), ad(cd, n, e);
      }
      function yd(e, t, n) {
        var r = e.stateNode,
          i = t.childContextTypes;
        if ("function" != typeof r.getChildContext) {
          var a = ft(e) || "Unknown";
          return nd[a] || (nd[a] = !0, o("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", a, a)), n;
        }
        var s = r.getChildContext();
        for (var u in s) if (!(u in i)) throw new Error((ft(e) || "Unknown") + '.getChildContext(): key "' + u + '" is not defined in childContextTypes.');
        return Xl(i, s, "child context", ft(e) || "Unknown"), Ge({}, n, s);
      }
      function wd(e) {
        var t = e.stateNode,
          n = t && t.__reactInternalMemoizedMergedChildContext || sd;
        return ld = ud.current, ad(ud, n, e), ad(cd, cd.current, e), !0;
      }
      function Ad(e, t, n) {
        var r = e.stateNode;
        if (!r) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (n) {
          var i = yd(e, t, ld);
          r.__reactInternalMemoizedMergedChildContext = i, od(cd, e), od(ud, e), ad(ud, i, e), ad(cd, n, e);
        } else od(cd, e), ad(cd, n, e);
      }
      function _d(e) {
        if (!function (e) {
          return gi(e) === e;
        }(e) || e.tag !== u) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var t = e;
        do {
          switch (t.tag) {
            case l:
              return t.stateNode.context;
            case u:
              if (md(t.type)) return t.stateNode.__reactInternalMemoizedMergedChildContext;
          }
          t = t.return;
        } while (null !== t);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
      var Ed = 0,
        Sd = 1,
        kd = null,
        Md = !1,
        Cd = !1;
      function xd(e) {
        null === kd ? kd = [e] : kd.push(e);
      }
      function Rd() {
        Md && Id();
      }
      function Id() {
        if (!Cd && null !== kd) {
          Cd = !0;
          var e = 0,
            t = La();
          try {
            var n = kd;
            for (Na(Ra); e < n.length; e++) {
              var r = n[e];
              do {
                r = r(true);
              } while (null !== r);
            }
            kd = null, Md = !1;
          } catch (t) {
            throw null !== kd && (kd = kd.slice(e + 1)), ki(Ti, Id), t;
          } finally {
            Na(t), Cd = !1;
          }
        }
        return null;
      }
      var Td = [],
        Pd = 0,
        Od = null,
        Ld = 0,
        Nd = [],
        Dd = 0,
        Bd = null,
        jd = 1,
        Fd = "";
      function zd() {
        var e = Fd;
        return (jd & ~function (e) {
          return 1 << Hd(e) - 1;
        }(jd)).toString(32) + e;
      }
      function Ud(e, t) {
        $d(), Td[Pd++] = Ld, Td[Pd++] = Od, Od = e, Ld = t;
      }
      function qd(e, t, n) {
        $d(), Nd[Dd++] = jd, Nd[Dd++] = Fd, Nd[Dd++] = Bd, Bd = e;
        var r = jd,
          i = Fd,
          o = Hd(r) - 1,
          a = r & ~(1 << o),
          s = n + 1,
          u = Hd(t) + o;
        if (u > 30) {
          var c = o - o % 5,
            l = (a & (1 << c) - 1).toString(32),
            d = a >> c,
            f = o - c,
            h = Hd(t) + f;
          jd = 1 << h | (s << f | d), Fd = l + i;
        } else {
          jd = 1 << u | (s << o | a), Fd = i;
        }
      }
      function Kd(e) {
        if ($d(), null !== e.return) {
          Ud(e, 1), qd(e, 1, 0);
        }
      }
      function Hd(e) {
        return 32 - uo(e);
      }
      function Vd(e) {
        for (; e === Od;) Od = Td[--Pd], Td[Pd] = null, Ld = Td[--Pd], Td[Pd] = null;
        for (; e === Bd;) Bd = Nd[--Dd], Nd[Dd] = null, Fd = Nd[--Dd], Nd[Dd] = null, jd = Nd[--Dd], Nd[Dd] = null;
      }
      function $d() {
        yf() || o("Expected to be hydrating. This is a bug in React. Please file an issue.");
      }
      var Wd = null,
        Yd = null,
        Gd = !1,
        Qd = !1,
        Zd = null;
      function Jd() {
        Gd && o("We should not be hydrating here. This is a bug in React. Please file a bug.");
      }
      function Xd() {
        Qd = !0;
      }
      function ef(e) {
        var t = e.stateNode.containerInfo;
        return Yd = Il(t.firstChild), Wd = e, Gd = !0, Zd = null, Qd = !1, !0;
      }
      function tf(e, t, n) {
        return Yd = Il(t.nextSibling), Wd = e, Gd = !0, Zd = null, Qd = !1, null !== n && function (e, t) {
          $d(), Nd[Dd++] = jd, Nd[Dd++] = Fd, Nd[Dd++] = Bd, jd = t.id, Fd = t.overflow, Bd = e;
        }(e, n), !0;
      }
      function nf(e, t) {
        switch (e.tag) {
          case l:
            !function (e, t) {
              t.nodeType === hn ? Wc(e, t) : t.nodeType === mn || Yc(e, t);
            }(e.stateNode.containerInfo, t);
            break;
          case f:
            var n = (e.mode & io) !== ro;
            !function (e, t, n, r, i) {
              (i || !0 !== t[ol]) && (r.nodeType === hn ? Wc(n, r) : r.nodeType === mn || Yc(n, r));
            }(e.type, e.memoizedProps, e.stateNode, t, n);
            break;
          case w:
            var r = e.memoizedState;
            null !== r.dehydrated && function (e, t) {
              var n = e.parentNode;
              null !== n && (t.nodeType === hn ? Wc(n, t) : t.nodeType === mn || Yc(n, t));
            }(r.dehydrated, t);
        }
      }
      function rf(e, t) {
        nf(e, t);
        var n,
          r = ((n = aA(f, null, null, ro)).elementType = "DELETED", n);
        r.stateNode = t, r.return = e;
        var i = e.deletions;
        null === i ? (e.deletions = [r], e.flags |= qr) : i.push(r);
      }
      function of(e, t) {
        if (!Qd) switch (e.tag) {
          case l:
            var n = e.stateNode.containerInfo;
            switch (t.tag) {
              case f:
                var r = t.type;
                t.pendingProps, function (e, t, n) {
                  Gc(e, t);
                }(n, r);
                break;
              case h:
                !function (e, t) {
                  Qc(e, t);
                }(n, t.pendingProps);
            }
            break;
          case f:
            e.type;
            var i = e.memoizedProps,
              o = e.stateNode;
            switch (t.tag) {
              case f:
                var a = t.type;
                t.pendingProps;
                !function (e, t, n, r, i, o) {
                  (o || !0 !== t[ol]) && Gc(n, r);
                }(0, i, o, a, 0, (e.mode & io) !== ro);
                break;
              case h:
                !function (e, t, n, r, i) {
                  (i || !0 !== t[ol]) && Qc(n, r);
                }(0, i, o, t.pendingProps, (e.mode & io) !== ro);
            }
            break;
          case w:
            var s = e.memoizedState.dehydrated;
            if (null !== s) switch (t.tag) {
              case f:
                var u = t.type;
                t.pendingProps, function (e, t, n) {
                  var r = e.parentNode;
                  null !== r && Gc(r, t);
                }(s, u);
                break;
              case h:
                !function (e, t) {
                  var n = e.parentNode;
                  null !== n && Qc(n, t);
                }(s, t.pendingProps);
            }
            break;
          default:
            return;
        }
      }
      function af(e, t) {
        t.flags = t.flags & ~Qr | zr, of(e, t);
      }
      function sf(e, t) {
        switch (e.tag) {
          case f:
            var n = e.type;
            e.pendingProps;
            var r = function (e, t, n) {
              return e.nodeType !== hn || t.toLowerCase() !== e.nodeName.toLowerCase() ? null : e;
            }(t, n);
            return null !== r && (e.stateNode = r, Wd = e, Yd = Il(r.firstChild), !0);
          case h:
            var i = function (e, t) {
              return "" === t || e.nodeType !== pn ? null : e;
            }(t, e.pendingProps);
            return null !== i && (e.stateNode = i, Wd = e, Yd = null, !0);
          case w:
            var o = function (e) {
              return e.nodeType !== mn ? null : e;
            }(t);
            if (null !== o) {
              var a = {
                dehydrated: o,
                treeContext: ($d(), null !== Bd ? {
                  id: jd,
                  overflow: Fd
                } : null),
                retryLane: Go
              };
              e.memoizedState = a;
              var s = function (e) {
                var t = aA(k, null, null, ro);
                return t.stateNode = e, t;
              }(o);
              return s.return = e, e.child = s, Wd = e, Yd = null, !0;
            }
            return !1;
          default:
            return !1;
        }
      }
      function uf(e) {
        return (e.mode & io) !== ro && (e.flags & Vr) === jr;
      }
      function cf(e) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
      }
      function lf(e) {
        if (Gd) {
          var t = Yd;
          if (!t) return uf(e) && (of(Wd, e), cf()), af(Wd, e), Gd = !1, void (Wd = e);
          var n = t;
          if (!sf(e, t)) {
            uf(e) && (of(Wd, e), cf()), t = Tl(n);
            var r = Wd;
            if (!t || !sf(e, t)) return af(Wd, e), Gd = !1, void (Wd = e);
            rf(r, n);
          }
        }
      }
      function df(e) {
        var t = e.stateNode,
          n = e.memoizedProps,
          r = function (e, t, n, r) {
            return Ul(n, e), n.mode, function (e, t, n) {
              return e.nodeValue !== t;
            }(e, t);
          }(t, n, e);
        if (r) {
          var i = Wd;
          if (null !== i) switch (i.tag) {
            case l:
              i.stateNode.containerInfo;
              !function (e, t, n, r) {
                zc(t.nodeValue, n, r, !0);
              }(0, t, n, (i.mode & io) !== ro);
              break;
            case f:
              i.type;
              var o = i.memoizedProps;
              i.stateNode;
              !function (e, t, n, r, i, o) {
                !0 !== t[ol] && zc(r.nodeValue, i, o, !0);
              }(0, o, 0, t, n, (i.mode & io) !== ro);
          }
        }
        return r;
      }
      function ff(e) {
        var t = e.memoizedState,
          n = null !== t ? t.dehydrated : null;
        if (!n) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        !function (e, t) {
          Ul(t, e);
        }(n, e);
      }
      function hf(e) {
        var t = e.memoizedState,
          n = null !== t ? t.dehydrated : null;
        if (!n) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return function (e) {
          for (var t = e.nextSibling, n = 0; t;) {
            if (t.nodeType === mn) {
              var r = t.data;
              if (r === sl) {
                if (0 === n) return Tl(t);
                n--;
              } else r !== al && r !== cl && r !== ul || n++;
            }
            t = t.nextSibling;
          }
          return null;
        }(n);
      }
      function pf(e) {
        for (var t = e.return; null !== t && t.tag !== f && t.tag !== l && t.tag !== w;) t = t.return;
        Wd = t;
      }
      function mf(e) {
        if (e !== Wd) return !1;
        if (!Gd) return pf(e), Gd = !0, !1;
        if (e.tag !== l && (e.tag !== f || "head" !== (n = e.type) && "body" !== n && !ml(e.type, e.memoizedProps))) {
          var t = Yd;
          if (t) if (uf(e)) gf(e), cf();else for (; t;) rf(e, t), t = Tl(t);
        }
        var n;
        return pf(e), Yd = e.tag === w ? hf(e) : Wd ? Tl(e.stateNode) : null, !0;
      }
      function gf(e) {
        for (var t = Yd; t;) nf(e, t), t = Tl(t);
      }
      function vf() {
        Wd = null, Yd = null, Gd = !1, Qd = !1;
      }
      function bf() {
        null !== Zd && (nw(Zd), Zd = null);
      }
      function yf() {
        return Gd;
      }
      function wf(e) {
        null === Zd ? Zd = [e] : Zd.push(e);
      }
      var Af = n.ReactCurrentBatchConfig,
        _f = null;
      var Ef = {
          recordUnsafeLifecycleWarnings: function (e, t) {},
          flushPendingUnsafeLifecycleWarnings: function () {},
          recordLegacyContextWarning: function (e, t) {},
          flushLegacyContextWarning: function () {},
          discardPendingWarnings: function () {}
        },
        Sf = function (e) {
          var t = [];
          return e.forEach(function (e) {
            t.push(e);
          }), t.sort().join(", ");
        },
        kf = [],
        Mf = [],
        Cf = [],
        xf = [],
        Rf = [],
        If = [],
        Tf = new Set();
      Ef.recordUnsafeLifecycleWarnings = function (e, t) {
        Tf.has(e.type) || ("function" == typeof t.componentWillMount && !0 !== t.componentWillMount.__suppressDeprecationWarning && kf.push(e), e.mode & ao && "function" == typeof t.UNSAFE_componentWillMount && Mf.push(e), "function" == typeof t.componentWillReceiveProps && !0 !== t.componentWillReceiveProps.__suppressDeprecationWarning && Cf.push(e), e.mode & ao && "function" == typeof t.UNSAFE_componentWillReceiveProps && xf.push(e), "function" == typeof t.componentWillUpdate && !0 !== t.componentWillUpdate.__suppressDeprecationWarning && Rf.push(e), e.mode & ao && "function" == typeof t.UNSAFE_componentWillUpdate && If.push(e));
      }, Ef.flushPendingUnsafeLifecycleWarnings = function () {
        var e = new Set();
        kf.length > 0 && (kf.forEach(function (t) {
          e.add(ft(t) || "Component"), Tf.add(t.type);
        }), kf = []);
        var t = new Set();
        Mf.length > 0 && (Mf.forEach(function (e) {
          t.add(ft(e) || "Component"), Tf.add(e.type);
        }), Mf = []);
        var n = new Set();
        Cf.length > 0 && (Cf.forEach(function (e) {
          n.add(ft(e) || "Component"), Tf.add(e.type);
        }), Cf = []);
        var r = new Set();
        xf.length > 0 && (xf.forEach(function (e) {
          r.add(ft(e) || "Component"), Tf.add(e.type);
        }), xf = []);
        var a = new Set();
        Rf.length > 0 && (Rf.forEach(function (e) {
          a.add(ft(e) || "Component"), Tf.add(e.type);
        }), Rf = []);
        var s = new Set();
        (If.length > 0 && (If.forEach(function (e) {
          s.add(ft(e) || "Component"), Tf.add(e.type);
        }), If = []), t.size > 0) && o("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", Sf(t));
        r.size > 0 && o("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", Sf(r));
        s.size > 0 && o("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", Sf(s));
        e.size > 0 && i("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", Sf(e));
        n.size > 0 && i("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", Sf(n));
        a.size > 0 && i("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", Sf(a));
      };
      var Pf = new Map(),
        Of = new Set();
      function Lf(e, t) {
        if (e && e.defaultProps) {
          var n = Ge({}, t),
            r = e.defaultProps;
          for (var i in r) void 0 === n[i] && (n[i] = r[i]);
          return n;
        }
        return t;
      }
      Ef.recordLegacyContextWarning = function (e, t) {
        var n = function (e) {
          for (var t = null, n = e; null !== n;) n.mode & ao && (t = n), n = n.return;
          return t;
        }(e);
        if (null !== n) {
          if (!Of.has(e.type)) {
            var r = Pf.get(n);
            (null != e.type.contextTypes || null != e.type.childContextTypes || null !== t && "function" == typeof t.getChildContext) && (void 0 === r && (r = [], Pf.set(n, r)), r.push(e));
          }
        } else o("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
      }, Ef.flushLegacyContextWarning = function () {
        Pf.forEach(function (e, t) {
          if (0 !== e.length) {
            var n = e[0],
              r = new Set();
            e.forEach(function (e) {
              r.add(ft(e) || "Component"), Of.add(e.type);
            });
            var i = Sf(r);
            try {
              yt(n), o("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", i);
            } finally {
              bt();
            }
          }
        });
      }, Ef.discardPendingWarnings = function () {
        kf = [], Mf = [], Cf = [], xf = [], Rf = [], If = [], Pf = new Map();
      };
      var Nf,
        Df = id(null);
      Nf = {};
      var Bf = null,
        jf = null,
        Ff = null,
        zf = !1;
      function Uf() {
        Bf = null, jf = null, Ff = null, zf = !1;
      }
      function qf() {
        zf = !0;
      }
      function Kf() {
        zf = !1;
      }
      function Hf(e, t, n) {
        ad(Df, t._currentValue, e), t._currentValue = n, void 0 !== t._currentRenderer && null !== t._currentRenderer && t._currentRenderer !== Nf && o("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), t._currentRenderer = Nf;
      }
      function Vf(e, t) {
        var n = Df.current;
        od(Df, t), e._currentValue = n;
      }
      function $f(e, t, n) {
        for (var r = e; null !== r;) {
          var i = r.alternate;
          if (pa(r.childLanes, t) ? null === i || pa(i.childLanes, t) || (i.childLanes = ma(i.childLanes, t)) : (r.childLanes = ma(r.childLanes, t), null !== i && (i.childLanes = ma(i.childLanes, t))), r === n) break;
          r = r.return;
        }
        r !== n && o("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
      }
      function Wf(e, t, n) {
        !function (e, t, n) {
          var r = e.child;
          null !== r && (r.return = e);
          for (; null !== r;) {
            var i = void 0,
              o = r.dependencies;
            if (null !== o) {
              i = r.child;
              for (var a = o.firstContext; null !== a;) {
                if (a.context === t) {
                  if (r.tag === u) {
                    var s = la(n),
                      c = dh(Zo, s);
                    c.tag = ah;
                    var l = r.updateQueue;
                    if (null === l) ;else {
                      var d = l.shared,
                        f = d.pending;
                      null === f ? c.next = c : (c.next = f.next, f.next = c), d.pending = c;
                    }
                  }
                  r.lanes = ma(r.lanes, n);
                  var h = r.alternate;
                  null !== h && (h.lanes = ma(h.lanes, n)), $f(r.return, n, e), o.lanes = ma(o.lanes, n);
                  break;
                }
                a = a.next;
              }
            } else if (r.tag === v) i = r.type === e.type ? null : r.child;else if (r.tag === k) {
              var p = r.return;
              if (null === p) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
              p.lanes = ma(p.lanes, n);
              var m = p.alternate;
              null !== m && (m.lanes = ma(m.lanes, n)), $f(p, n, e), i = r.sibling;
            } else i = r.child;
            if (null !== i) i.return = r;else for (i = r; null !== i;) {
              if (i === e) {
                i = null;
                break;
              }
              var g = i.sibling;
              if (null !== g) {
                g.return = i.return, i = g;
                break;
              }
              i = i.return;
            }
            r = i;
          }
        }(e, t, n);
      }
      function Yf(e, t) {
        Bf = e, jf = null, Ff = null;
        var n = e.dependencies;
        null !== n && null !== n.firstContext && (ha(n.lanes, t) && Mv(), n.firstContext = null);
      }
      function Gf(e) {
        zf && o("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var t = e._currentValue;
        if (Ff === e) ;else {
          var n = {
            context: e,
            memoizedValue: t,
            next: null
          };
          if (null === jf) {
            if (null === Bf) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            jf = n, Bf.dependencies = {
              lanes: ho,
              firstContext: n
            };
          } else jf = jf.next = n;
        }
        return t;
      }
      var Qf = null;
      function Zf(e) {
        null === Qf ? Qf = [e] : Qf.push(e);
      }
      function Jf(e, t, n, r) {
        var i = t.interleaved;
        return null === i ? (n.next = n, Zf(t)) : (n.next = i.next, i.next = n), t.interleaved = n, th(e, r);
      }
      function Xf(e, t) {
        return th(e, t);
      }
      var eh = th;
      function th(e, t) {
        e.lanes = ma(e.lanes, t);
        var n = e.alternate;
        null !== n && (n.lanes = ma(n.lanes, t)), null === n && (e.flags & (zr | Qr)) !== jr && Nw(e);
        for (var r = e, i = e.return; null !== i;) i.childLanes = ma(i.childLanes, t), null !== (n = i.alternate) ? n.childLanes = ma(n.childLanes, t) : (i.flags & (zr | Qr)) !== jr && Nw(e), r = i, i = i.return;
        return r.tag === l ? r.stateNode : null;
      }
      var nh,
        rh,
        ih = 0,
        oh = 1,
        ah = 2,
        sh = 3,
        uh = !1;
      function ch(e) {
        var t = {
          baseState: e.memoizedState,
          firstBaseUpdate: null,
          lastBaseUpdate: null,
          shared: {
            pending: null,
            interleaved: null,
            lanes: ho
          },
          effects: null
        };
        e.updateQueue = t;
      }
      function lh(e, t) {
        var n = t.updateQueue,
          r = e.updateQueue;
        if (n === r) {
          var i = {
            baseState: r.baseState,
            firstBaseUpdate: r.firstBaseUpdate,
            lastBaseUpdate: r.lastBaseUpdate,
            shared: r.shared,
            effects: r.effects
          };
          t.updateQueue = i;
        }
      }
      function dh(e, t) {
        return {
          eventTime: e,
          lane: t,
          tag: ih,
          payload: null,
          callback: null,
          next: null
        };
      }
      function fh(e, t, n) {
        var r = e.updateQueue;
        if (null === r) return null;
        var i = r.shared;
        if (rh !== i || nh || (o("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), nh = !0), (cy & ey) !== Jb) {
          var a = i.pending;
          return null === a ? t.next = t : (t.next = a.next, a.next = t), i.pending = t, eh(e, n);
        }
        return function (e, t, n, r) {
          var i = t.interleaved;
          return null === i ? (n.next = n, Zf(t)) : (n.next = i.next, i.next = n), t.interleaved = n, th(e, r);
        }(e, i, t, n);
      }
      function hh(e, t, n) {
        var r = t.updateQueue;
        if (null !== r) {
          var i = r.shared;
          if (sa(n)) {
            var o = i.lanes,
              a = ma(o = va(o, e.pendingLanes), n);
            i.lanes = a, Aa(e, a);
          }
        }
      }
      function ph(e, t) {
        var n = e.updateQueue,
          r = e.alternate;
        if (null !== r) {
          var i = r.updateQueue;
          if (n === i) {
            var o = null,
              a = null,
              s = n.firstBaseUpdate;
            if (null !== s) {
              var u = s;
              do {
                var c = {
                  eventTime: u.eventTime,
                  lane: u.lane,
                  tag: u.tag,
                  payload: u.payload,
                  callback: u.callback,
                  next: null
                };
                null === a ? o = a = c : (a.next = c, a = c), u = u.next;
              } while (null !== u);
              null === a ? o = a = t : (a.next = t, a = t);
            } else o = a = t;
            return n = {
              baseState: i.baseState,
              firstBaseUpdate: o,
              lastBaseUpdate: a,
              shared: i.shared,
              effects: i.effects
            }, void (e.updateQueue = n);
          }
        }
        var l = n.lastBaseUpdate;
        null === l ? n.firstBaseUpdate = t : l.next = t, n.lastBaseUpdate = t;
      }
      function mh(e, t, n, r, i, o) {
        switch (n.tag) {
          case oh:
            var a = n.payload;
            if ("function" == typeof a) {
              qf();
              var s = a.call(o, r, i);
              if (e.mode & ao) {
                Ki(!0);
                try {
                  a.call(o, r, i);
                } finally {
                  Ki(!1);
                }
              }
              return Kf(), s;
            }
            return a;
          case sh:
            e.flags = e.flags & ~ni | Vr;
          case ih:
            var u,
              c = n.payload;
            if ("function" == typeof c) {
              if (qf(), u = c.call(o, r, i), e.mode & ao) {
                Ki(!0);
                try {
                  c.call(o, r, i);
                } finally {
                  Ki(!1);
                }
              }
              Kf();
            } else u = c;
            return null == u ? r : Ge({}, r, u);
          case ah:
            return uh = !0, r;
        }
        return r;
      }
      function gh(e, t, n, r) {
        var i = e.updateQueue;
        uh = !1, rh = i.shared;
        var o = i.firstBaseUpdate,
          a = i.lastBaseUpdate,
          s = i.shared.pending;
        if (null !== s) {
          i.shared.pending = null;
          var u = s,
            c = u.next;
          u.next = null, null === a ? o = c : a.next = c, a = u;
          var l = e.alternate;
          if (null !== l) {
            var d = l.updateQueue,
              f = d.lastBaseUpdate;
            f !== a && (null === f ? d.firstBaseUpdate = c : f.next = c, d.lastBaseUpdate = u);
          }
        }
        if (null !== o) {
          for (var h = i.baseState, p = ho, m = null, g = null, v = null, b = o;;) {
            var y = b.lane,
              w = b.eventTime;
            if (pa(r, y)) {
              if (null !== v) {
                var A = {
                  eventTime: w,
                  lane: po,
                  tag: b.tag,
                  payload: b.payload,
                  callback: b.callback,
                  next: null
                };
                v = v.next = A;
              }
              if (h = mh(e, 0, b, h, t, n), null !== b.callback && b.lane !== po) {
                e.flags |= Hr;
                var _ = i.effects;
                null === _ ? i.effects = [b] : _.push(b);
              }
            } else {
              var E = {
                eventTime: w,
                lane: y,
                tag: b.tag,
                payload: b.payload,
                callback: b.callback,
                next: null
              };
              null === v ? (g = v = E, m = h) : v = v.next = E, p = ma(p, y);
            }
            if (null === (b = b.next)) {
              if (null === (s = i.shared.pending)) break;
              var S = s,
                k = S.next;
              S.next = null, b = k, i.lastBaseUpdate = S, i.shared.pending = null;
            }
          }
          null === v && (m = h), i.baseState = m, i.firstBaseUpdate = g, i.lastBaseUpdate = v;
          var M = i.shared.interleaved;
          if (null !== M) {
            var C = M;
            do {
              p = ma(p, C.lane), C = C.next;
            } while (C !== M);
          } else null === o && (i.shared.lanes = ho);
          pw(p), e.lanes = p, e.memoizedState = h;
        }
        rh = null;
      }
      function vh(e, t) {
        if ("function" != typeof e) throw new Error("Invalid argument passed as callback. Expected a function. Instead received: " + e);
        e.call(t);
      }
      function bh() {
        uh = !1;
      }
      function yh() {
        return uh;
      }
      function wh(e, t, n) {
        var r = t.effects;
        if (t.effects = null, null !== r) for (var i = 0; i < r.length; i++) {
          var o = r[i],
            a = o.callback;
          null !== a && (o.callback = null, vh(a, n));
        }
      }
      nh = !1, rh = null;
      var Ah,
        _h,
        Eh,
        Sh,
        kh,
        Mh,
        Ch,
        xh,
        Rh,
        Ih,
        Th = {},
        Ph = new e.Component().refs;
      Ah = new Set(), _h = new Set(), Eh = new Set(), Sh = new Set(), xh = new Set(), kh = new Set(), Rh = new Set(), Ih = new Set();
      var Oh = new Set();
      function Lh(e, t, n, r) {
        var i = e.memoizedState,
          o = n(r, i);
        if (e.mode & ao) {
          Ki(!0);
          try {
            o = n(r, i);
          } finally {
            Ki(!1);
          }
        }
        Mh(t, o);
        var a = null == o ? i : Ge({}, i, o);
        (e.memoizedState = a, e.lanes === ho) && (e.updateQueue.baseState = a);
      }
      Ch = function (e, t) {
        if (null !== e && "function" != typeof e) {
          var n = t + "_" + e;
          Oh.has(n) || (Oh.add(n), o("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e));
        }
      }, Mh = function (e, t) {
        if (void 0 === t) {
          var n = lt(e) || "Component";
          kh.has(n) || (kh.add(n), o("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", n));
        }
      }, Object.defineProperty(Th, "_processChildContext", {
        enumerable: !1,
        value: function () {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(Th);
      var Nh,
        Dh,
        Bh,
        jh,
        Fh,
        zh = {
          isMounted: function (e) {
            var t = mi.current;
            if (null !== t && t.tag === u) {
              var n = t,
                r = n.stateNode;
              r._warnedAboutRefsInRender || o("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", ft(n) || "A component"), r._warnedAboutRefsInRender = !0;
            }
            var i = Br(e);
            return !!i && gi(i) === i;
          },
          enqueueSetState: function (e, t, n) {
            var r = Br(e),
              i = Gy(),
              o = Qy(r),
              a = dh(i, o);
            a.payload = t, null != n && (Ch(n, "setState"), a.callback = n);
            var s = fh(r, a, o);
            null !== s && (Jy(s, r, o, i), hh(s, r, o)), no(r, o);
          },
          enqueueReplaceState: function (e, t, n) {
            var r = Br(e),
              i = Gy(),
              o = Qy(r),
              a = dh(i, o);
            a.tag = oh, a.payload = t, null != n && (Ch(n, "replaceState"), a.callback = n);
            var s = fh(r, a, o);
            null !== s && (Jy(s, r, o, i), hh(s, r, o)), no(r, o);
          },
          enqueueForceUpdate: function (e, t) {
            var n = Br(e),
              r = Gy(),
              i = Qy(n),
              o = dh(r, i);
            o.tag = ah, null != t && (Ch(t, "forceUpdate"), o.callback = t);
            var a = fh(n, o, i);
            null !== a && (Jy(a, n, i, r), hh(a, n, i)), function (e, t) {
              null !== zi && "function" == typeof zi.markForceUpdateScheduled && zi.markForceUpdateScheduled(e, t);
            }(n, i);
          }
        };
      function Uh(e, t, n, r, i, a, s) {
        var u = e.stateNode;
        if ("function" == typeof u.shouldComponentUpdate) {
          var c = u.shouldComponentUpdate(r, a, s);
          if (e.mode & ao) {
            Ki(!0);
            try {
              c = u.shouldComponentUpdate(r, a, s);
            } finally {
              Ki(!1);
            }
          }
          return void 0 === c && o("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", lt(t) || "Component"), c;
        }
        return !t.prototype || !t.prototype.isPureReactComponent || !Cu(n, r) || !Cu(i, a);
      }
      function qh(e, t) {
        t.updater = zh, e.stateNode = t, function (e, t) {
          e._reactInternals = t;
        }(t, e), t._reactInternalInstance = Th;
      }
      function Kh(e, t, n) {
        var r = !1,
          i = sd,
          a = sd,
          s = t.contextType;
        if ("contextType" in t && !(null === s || void 0 !== s && s.$$typeof === Pe && void 0 === s._context) && !Ih.has(t)) {
          Ih.add(t);
          var u = "";
          u = void 0 === s ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : "object" != typeof s ? " However, it is set to a " + typeof s + "." : s.$$typeof === Te ? " Did you accidentally pass the Context.Provider instead?" : void 0 !== s._context ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(s).join(", ") + "}.", o("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", lt(t) || "Component", u);
        }
        if ("object" == typeof s && null !== s) a = Gf(s);else {
          i = dd(0, t, !0);
          var c = t.contextTypes;
          a = (r = null != c) ? hd(e, i) : sd;
        }
        var l = new t(n, a);
        if (e.mode & ao) {
          Ki(!0);
          try {
            l = new t(n, a);
          } finally {
            Ki(!1);
          }
        }
        var d = e.memoizedState = null !== l.state && void 0 !== l.state ? l.state : null;
        if (qh(e, l), "function" == typeof t.getDerivedStateFromProps && null === d) {
          var f = lt(t) || "Component";
          _h.has(f) || (_h.add(f), o("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", f, null === l.state ? "null" : "undefined", f));
        }
        if ("function" == typeof t.getDerivedStateFromProps || "function" == typeof l.getSnapshotBeforeUpdate) {
          var h = null,
            p = null,
            m = null;
          if ("function" == typeof l.componentWillMount && !0 !== l.componentWillMount.__suppressDeprecationWarning ? h = "componentWillMount" : "function" == typeof l.UNSAFE_componentWillMount && (h = "UNSAFE_componentWillMount"), "function" == typeof l.componentWillReceiveProps && !0 !== l.componentWillReceiveProps.__suppressDeprecationWarning ? p = "componentWillReceiveProps" : "function" == typeof l.UNSAFE_componentWillReceiveProps && (p = "UNSAFE_componentWillReceiveProps"), "function" == typeof l.componentWillUpdate && !0 !== l.componentWillUpdate.__suppressDeprecationWarning ? m = "componentWillUpdate" : "function" == typeof l.UNSAFE_componentWillUpdate && (m = "UNSAFE_componentWillUpdate"), null !== h || null !== p || null !== m) {
            var g = lt(t) || "Component",
              v = "function" == typeof t.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Sh.has(g) || (Sh.add(g), o("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", g, v, null !== h ? "\n  " + h : "", null !== p ? "\n  " + p : "", null !== m ? "\n  " + m : ""));
          }
        }
        return r && fd(e, i, a), l;
      }
      function Hh(e, t, n, r) {
        var i = t.state;
        if ("function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== i) {
          var a = ft(e) || "Component";
          Ah.has(a) || (Ah.add(a), o("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", a)), zh.enqueueReplaceState(t, t.state, null);
        }
      }
      function Vh(e, t, n, r) {
        !function (e, t, n) {
          var r = e.stateNode,
            i = lt(t) || "Component";
          r.render || (t.prototype && "function" == typeof t.prototype.render ? o("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", i) : o("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", i)), !r.getInitialState || r.getInitialState.isReactClassApproved || r.state || o("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", i), r.getDefaultProps && !r.getDefaultProps.isReactClassApproved && o("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", i), r.propTypes && o("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", i), r.contextType && o("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", i), r.contextTypes && o("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", i), t.contextType && t.contextTypes && !Rh.has(t) && (Rh.add(t), o("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", i)), "function" == typeof r.componentShouldUpdate && o("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", i), t.prototype && t.prototype.isPureReactComponent && void 0 !== r.shouldComponentUpdate && o("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", lt(t) || "A pure component"), "function" == typeof r.componentDidUnmount && o("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", i), "function" == typeof r.componentDidReceiveProps && o("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", i), "function" == typeof r.componentWillRecieveProps && o("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", i), "function" == typeof r.UNSAFE_componentWillRecieveProps && o("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", i);
          var a = r.props !== n;
          void 0 !== r.props && a && o("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", i, i), r.defaultProps && o("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", i, i), "function" != typeof r.getSnapshotBeforeUpdate || "function" == typeof r.componentDidUpdate || Eh.has(t) || (Eh.add(t), o("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", lt(t))), "function" == typeof r.getDerivedStateFromProps && o("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", i), "function" == typeof r.getDerivedStateFromError && o("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", i), "function" == typeof t.getSnapshotBeforeUpdate && o("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", i);
          var s = r.state;
          s && ("object" != typeof s || Yt(s)) && o("%s.state: must be set to an object or null", i), "function" == typeof r.getChildContext && "object" != typeof t.childContextTypes && o("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", i);
        }(e, t, n);
        var i = e.stateNode;
        i.props = n, i.state = e.memoizedState, i.refs = Ph, ch(e);
        var a = t.contextType;
        if ("object" == typeof a && null !== a) i.context = Gf(a);else {
          var s = dd(0, t, !0);
          i.context = hd(e, s);
        }
        if (i.state === n) {
          var u = lt(t) || "Component";
          xh.has(u) || (xh.add(u), o("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", u));
        }
        e.mode & ao && Ef.recordLegacyContextWarning(e, i), Ef.recordUnsafeLifecycleWarnings(e, i), i.state = e.memoizedState;
        var c = t.getDerivedStateFromProps;
        if ("function" == typeof c && (Lh(e, t, c, n), i.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof i.getSnapshotBeforeUpdate || "function" != typeof i.UNSAFE_componentWillMount && "function" != typeof i.componentWillMount || (!function (e, t) {
          var n = t.state;
          "function" == typeof t.componentWillMount && t.componentWillMount(), "function" == typeof t.UNSAFE_componentWillMount && t.UNSAFE_componentWillMount(), n !== t.state && (o("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", ft(e) || "Component"), zh.enqueueReplaceState(t, t.state, null));
        }(e, i), gh(e, n, i, r), i.state = e.memoizedState), "function" == typeof i.componentDidMount) {
          var l = Ur;
          l |= ai, (e.mode & so) !== ro && (l |= ui), e.flags |= l;
        }
      }
      var $h;
      function Wh(e, t, n) {
        var r = n.ref;
        if (null !== r && "function" != typeof r && "object" != typeof r) {
          if ((e.mode & ao || F) && (!n._owner || !n._self || n._owner.stateNode === n._self)) {
            var i = ft(e) || "Component";
            Bh[i] || (o('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', r), Bh[i] = !0);
          }
          if (n._owner) {
            var a,
              s = n._owner;
            if (s) {
              var c = s;
              if (c.tag !== u) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
              a = c.stateNode;
            }
            if (!a) throw new Error("Missing owner for string ref " + r + ". This error is likely caused by a bug in React. Please file an issue.");
            var l = a;
            !function (e, t) {
              if (Z(e)) o("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", t, Q(e)), J(e);
            }(r, "ref");
            var d = "" + r;
            if (null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === d) return t.ref;
            var f = function (e) {
              var t = l.refs;
              t === Ph && (t = l.refs = {}), null === e ? delete t[d] : t[d] = e;
            };
            return f._stringRef = d, f;
          }
          if ("string" != typeof r) throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!n._owner) throw new Error("Element ref was specified as a string (" + r + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information.");
        }
        return r;
      }
      function Yh(e, t) {
        var n = Object.prototype.toString.call(t);
        throw new Error("Objects are not valid as a React child (found: " + ("[object Object]" === n ? "object with keys {" + Object.keys(t).join(", ") + "}" : n) + "). If you meant to render a collection of children, use an array instead.");
      }
      function Gh(e) {
        var t = ft(e) || "Component";
        Fh[t] || (Fh[t] = !0, o("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it."));
      }
      function Qh(e) {
        var t = e._payload;
        return (0, e._init)(t);
      }
      function Zh(e) {
        function t(t, n) {
          if (e) {
            var r = t.deletions;
            null === r ? (t.deletions = [n], t.flags |= qr) : r.push(n);
          }
        }
        function n(n, r) {
          if (!e) return null;
          for (var i = r; null !== i;) t(n, i), i = i.sibling;
          return null;
        }
        function r(e, t) {
          for (var n = new Map(), r = t; null !== r;) null !== r.key ? n.set(r.key, r) : n.set(r.index, r), r = r.sibling;
          return n;
        }
        function i(e, t) {
          var n = uA(e, t);
          return n.index = 0, n.sibling = null, n;
        }
        function a(t, n, r) {
          if (t.index = r, !e) return t.flags |= ii, n;
          var i = t.alternate;
          if (null !== i) {
            var o = i.index;
            return o < n ? (t.flags |= zr, n) : o;
          }
          return t.flags |= zr, n;
        }
        function s(t) {
          return e && null === t.alternate && (t.flags |= zr), t;
        }
        function u(e, t, n, r) {
          if (null === t || t.tag !== h) {
            var o = pA(n, e.mode, r);
            return o.return = e, o;
          }
          var a = i(t, n);
          return a.return = e, a;
        }
        function c(e, t, n, r) {
          var o = n.type;
          if (o === xe) return f(e, t, n.props.children, r, n.key);
          if (null !== t && (t.elementType === o || Qw(t, n) || "object" == typeof o && null !== o && o.$$typeof === Be && Qh(o) === t.type)) {
            var a = i(t, n.props);
            return a.ref = Wh(e, t, n), a.return = e, a._debugSource = n._source, a._debugOwner = n._owner, a;
          }
          var s = dA(n, e.mode, r);
          return s.ref = Wh(e, t, n), s.return = e, s;
        }
        function l(e, t, n, r) {
          if (null === t || t.tag !== d || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation) {
            var o = mA(n, e.mode, r);
            return o.return = e, o;
          }
          var a = i(t, n.children || []);
          return a.return = e, a;
        }
        function f(e, t, n, r, o) {
          if (null === t || t.tag !== p) {
            var a = fA(n, e.mode, r, o);
            return a.return = e, a;
          }
          var s = i(t, n);
          return s.return = e, s;
        }
        function m(e, t, n) {
          if ("string" == typeof t && "" !== t || "number" == typeof t) {
            var r = pA("" + t, e.mode, n);
            return r.return = e, r;
          }
          if ("object" == typeof t && null !== t) {
            switch (t.$$typeof) {
              case Me:
                var i = dA(t, e.mode, n);
                return i.ref = Wh(e, null, t), i.return = e, i;
              case Ce:
                var o = mA(t, e.mode, n);
                return o.return = e, o;
              case Be:
                var a = t._payload;
                return m(e, (0, t._init)(a), n);
            }
            if (Yt(t) || Ue(t)) {
              var s = fA(t, e.mode, n, null);
              return s.return = e, s;
            }
            Yh(0, t);
          }
          return "function" == typeof t && Gh(e), null;
        }
        function g(e, t, n, r) {
          var i = null !== t ? t.key : null;
          if ("string" == typeof n && "" !== n || "number" == typeof n) return null !== i ? null : u(e, t, "" + n, r);
          if ("object" == typeof n && null !== n) {
            switch (n.$$typeof) {
              case Me:
                return n.key === i ? c(e, t, n, r) : null;
              case Ce:
                return n.key === i ? l(e, t, n, r) : null;
              case Be:
                var o = n._payload;
                return g(e, t, (0, n._init)(o), r);
            }
            if (Yt(n) || Ue(n)) return null !== i ? null : f(e, t, n, r, null);
            Yh(0, n);
          }
          return "function" == typeof n && Gh(e), null;
        }
        function v(e, t, n, r, i) {
          if ("string" == typeof r && "" !== r || "number" == typeof r) return u(t, e.get(n) || null, "" + r, i);
          if ("object" == typeof r && null !== r) {
            switch (r.$$typeof) {
              case Me:
                return c(t, e.get(null === r.key ? n : r.key) || null, r, i);
              case Ce:
                return l(t, e.get(null === r.key ? n : r.key) || null, r, i);
              case Be:
                var o = r._payload;
                return v(e, t, n, (0, r._init)(o), i);
            }
            if (Yt(r) || Ue(r)) return f(t, e.get(n) || null, r, i, null);
            Yh(0, r);
          }
          return "function" == typeof r && Gh(t), null;
        }
        function b(e, t, n) {
          if ("object" != typeof e || null === e) return t;
          switch (e.$$typeof) {
            case Me:
            case Ce:
              $h(e, n);
              var r = e.key;
              if ("string" != typeof r) break;
              if (null === t) {
                (t = new Set()).add(r);
                break;
              }
              if (!t.has(r)) {
                t.add(r);
                break;
              }
              o("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", r);
              break;
            case Be:
              var i = e._payload;
              b((0, e._init)(i), t, n);
          }
          return t;
        }
        return function u(c, l, f, y) {
          if ("object" == typeof f && null !== f && f.type === xe && null === f.key && (f = f.props.children), "object" == typeof f && null !== f) {
            switch (f.$$typeof) {
              case Me:
                return s(function (e, r, o, a) {
                  for (var s = o.key, u = r; null !== u;) {
                    if (u.key === s) {
                      var c = o.type;
                      if (c === xe) {
                        if (u.tag === p) {
                          n(e, u.sibling);
                          var l = i(u, o.props.children);
                          return l.return = e, l._debugSource = o._source, l._debugOwner = o._owner, l;
                        }
                      } else if (u.elementType === c || Qw(u, o) || "object" == typeof c && null !== c && c.$$typeof === Be && Qh(c) === u.type) {
                        n(e, u.sibling);
                        var d = i(u, o.props);
                        return d.ref = Wh(e, u, o), d.return = e, d._debugSource = o._source, d._debugOwner = o._owner, d;
                      }
                      n(e, u);
                      break;
                    }
                    t(e, u), u = u.sibling;
                  }
                  if (o.type === xe) {
                    var f = fA(o.props.children, e.mode, a, o.key);
                    return f.return = e, f;
                  }
                  var h = dA(o, e.mode, a);
                  return h.ref = Wh(e, r, o), h.return = e, h;
                }(c, l, f, y));
              case Ce:
                return s(function (e, r, o, a) {
                  for (var s = o.key, u = r; null !== u;) {
                    if (u.key === s) {
                      if (u.tag === d && u.stateNode.containerInfo === o.containerInfo && u.stateNode.implementation === o.implementation) {
                        n(e, u.sibling);
                        var c = i(u, o.children || []);
                        return c.return = e, c;
                      }
                      n(e, u);
                      break;
                    }
                    t(e, u), u = u.sibling;
                  }
                  var l = mA(o, e.mode, a);
                  return l.return = e, l;
                }(c, l, f, y));
              case Be:
                var w = f._payload;
                return u(c, l, (0, f._init)(w), y);
            }
            if (Yt(f)) return function (i, o, s, u) {
              for (var c = null, l = 0; l < s.length; l++) c = b(s[l], c, i);
              for (var d = null, f = null, h = o, p = 0, y = 0, w = null; null !== h && y < s.length; y++) {
                h.index > y ? (w = h, h = null) : w = h.sibling;
                var A = g(i, h, s[y], u);
                if (null === A) {
                  null === h && (h = w);
                  break;
                }
                e && h && null === A.alternate && t(i, h), p = a(A, p, y), null === f ? d = A : f.sibling = A, f = A, h = w;
              }
              if (y === s.length) return n(i, h), yf() && Ud(i, y), d;
              if (null === h) {
                for (; y < s.length; y++) {
                  var _ = m(i, s[y], u);
                  null !== _ && (p = a(_, p, y), null === f ? d = _ : f.sibling = _, f = _);
                }
                return yf() && Ud(i, y), d;
              }
              for (var E = r(0, h); y < s.length; y++) {
                var S = v(E, i, y, s[y], u);
                null !== S && (e && null !== S.alternate && E.delete(null === S.key ? y : S.key), p = a(S, p, y), null === f ? d = S : f.sibling = S, f = S);
              }
              return e && E.forEach(function (e) {
                return t(i, e);
              }), yf() && Ud(i, y), d;
            }(c, l, f, y);
            if (Ue(f)) return function (i, s, u, c) {
              var l = Ue(u);
              if ("function" != typeof l) throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
              "function" == typeof Symbol && "Generator" === u[Symbol.toStringTag] && (Dh || o("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), Dh = !0), u.entries === l && (Nh || o("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Nh = !0);
              var d = l.call(u);
              if (d) for (var f = null, h = d.next(); !h.done; h = d.next()) f = b(h.value, f, i);
              var p = l.call(u);
              if (null == p) throw new Error("An iterable object provided no iterator.");
              for (var y = null, w = null, A = s, _ = 0, E = 0, S = null, k = p.next(); null !== A && !k.done; E++, k = p.next()) {
                A.index > E ? (S = A, A = null) : S = A.sibling;
                var M = g(i, A, k.value, c);
                if (null === M) {
                  null === A && (A = S);
                  break;
                }
                e && A && null === M.alternate && t(i, A), _ = a(M, _, E), null === w ? y = M : w.sibling = M, w = M, A = S;
              }
              if (k.done) return n(i, A), yf() && Ud(i, E), y;
              if (null === A) {
                for (; !k.done; E++, k = p.next()) {
                  var C = m(i, k.value, c);
                  null !== C && (_ = a(C, _, E), null === w ? y = C : w.sibling = C, w = C);
                }
                return yf() && Ud(i, E), y;
              }
              for (var x = r(0, A); !k.done; E++, k = p.next()) {
                var R = v(x, i, E, k.value, c);
                null !== R && (e && null !== R.alternate && x.delete(null === R.key ? E : R.key), _ = a(R, _, E), null === w ? y = R : w.sibling = R, w = R);
              }
              return e && x.forEach(function (e) {
                return t(i, e);
              }), yf() && Ud(i, E), y;
            }(c, l, f, y);
            Yh(0, f);
          }
          return "string" == typeof f && "" !== f || "number" == typeof f ? s(function (e, t, r, o) {
            if (null !== t && t.tag === h) {
              n(e, t.sibling);
              var a = i(t, r);
              return a.return = e, a;
            }
            n(e, t);
            var s = pA(r, e.mode, o);
            return s.return = e, s;
          }(c, l, "" + f, y)) : ("function" == typeof f && Gh(c), n(c, l));
        };
      }
      Nh = !1, Dh = !1, Bh = {}, jh = {}, Fh = {}, $h = function (e, t) {
        if (null !== e && "object" == typeof e && e._store && !e._store.validated && null == e.key) {
          if ("object" != typeof e._store) throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
          e._store.validated = !0;
          var n = ft(t) || "Component";
          jh[n] || (jh[n] = !0, o('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
        }
      };
      var Jh = Zh(!0),
        Xh = Zh(!1);
      function ep(e, t) {
        for (var n = e.child; null !== n;) cA(n, t), n = n.sibling;
      }
      var tp = {},
        np = id(tp),
        rp = id(tp),
        ip = id(tp);
      function op(e) {
        if (e === tp) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return e;
      }
      function ap() {
        return op(ip.current);
      }
      function sp(e, t) {
        ad(ip, t, e), ad(rp, e, e), ad(np, tp, e);
        var n = function (e) {
          var t,
            n,
            r = e.nodeType;
          switch (r) {
            case gn:
            case vn:
              t = r === gn ? "#document" : "#fragment";
              var i = e.documentElement;
              n = i ? i.namespaceURI : ln(null, "");
              break;
            default:
              var o = r === mn ? e.parentNode : e;
              n = ln(o.namespaceURI || null, t = o.tagName);
          }
          var a = t.toLowerCase();
          return {
            namespace: n,
            ancestorInfo: Jc(null, a)
          };
        }(t);
        od(np, e), ad(np, n, e);
      }
      function up(e) {
        od(np, e), od(rp, e), od(ip, e);
      }
      function cp() {
        return op(np.current);
      }
      function lp(e) {
        op(ip.current);
        var t = op(np.current),
          n = function (e, t, n) {
            var r = e;
            return {
              namespace: ln(r.namespace, t),
              ancestorInfo: Jc(r.ancestorInfo, t)
            };
          }(t, e.type);
        t !== n && (ad(rp, e, e), ad(np, n, e));
      }
      function dp(e) {
        rp.current === e && (od(np, e), od(rp, e));
      }
      var fp = 1,
        hp = 1,
        pp = 2,
        mp = id(0);
      function gp(e, t) {
        return 0 != (e & t);
      }
      function vp(e) {
        return e & fp;
      }
      function bp(e, t) {
        return e & fp | t;
      }
      function yp(e, t) {
        ad(mp, t, e);
      }
      function wp(e) {
        od(mp, e);
      }
      function Ap(e, t) {
        var n = e.memoizedState;
        return null !== n ? null !== n.dehydrated : (e.memoizedProps, !0);
      }
      function _p(e) {
        for (var t = e; null !== t;) {
          if (t.tag === w) {
            var n = t.memoizedState;
            if (null !== n) {
              var r = n.dehydrated;
              if (null === r || xl(r) || Rl(r)) return t;
            }
          } else if (t.tag === M && void 0 !== t.memoizedProps.revealOrder) {
            if ((t.flags & Vr) !== jr) return t;
          } else if (null !== t.child) {
            t.child.return = t, t = t.child;
            continue;
          }
          if (t === e) return null;
          for (; null === t.sibling;) {
            if (null === t.return || t.return === e) return null;
            t = t.return;
          }
          t.sibling.return = t.return, t = t.sibling;
        }
        return null;
      }
      var Ep = 0,
        Sp = 1,
        kp = 2,
        Mp = 4,
        Cp = 8,
        xp = [];
      function Rp() {
        for (var e = 0; e < xp.length; e++) {
          xp[e]._workInProgressVersionPrimary = null;
        }
        xp.length = 0;
      }
      function Ip(e, t) {
        var n = (0, t._getVersion)(t._source);
        null == e.mutableSourceEagerHydrationData ? e.mutableSourceEagerHydrationData = [t, n] : e.mutableSourceEagerHydrationData.push(t, n);
      }
      var Tp,
        Pp,
        Op = n.ReactCurrentDispatcher,
        Lp = n.ReactCurrentBatchConfig;
      Tp = new Set();
      var Np = ho,
        Dp = null,
        Bp = null,
        jp = null,
        Fp = !1,
        zp = !1,
        Up = 0,
        qp = 0,
        Kp = 25,
        Hp = null,
        Vp = null,
        $p = -1,
        Wp = !1;
      function Yp() {
        var e = Hp;
        null === Vp ? Vp = [e] : Vp.push(e);
      }
      function Gp() {
        var e = Hp;
        null !== Vp && ($p++, Vp[$p] !== e && function (e) {
          var t = ft(Dp);
          if (!Tp.has(t) && (Tp.add(t), null !== Vp)) {
            for (var n = "", r = 30, i = 0; i <= $p; i++) {
              for (var a = Vp[i], s = i === $p ? e : a, u = i + 1 + ". " + a; u.length < r;) u += " ";
              n += u += s + "\n";
            }
            o("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", t, n);
          }
        }(e));
      }
      function Qp(e) {
        null == e || Yt(e) || o("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", Hp, typeof e);
      }
      function Zp() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
      }
      function Jp(e, t) {
        if (Wp) return !1;
        if (null === t) return o("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Hp), !1;
        e.length !== t.length && o("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", Hp, "[" + t.join(", ") + "]", "[" + e.join(", ") + "]");
        for (var n = 0; n < t.length && n < e.length; n++) if (!Mu(e[n], t[n])) return !1;
        return !0;
      }
      function Xp(e, t, n, r, i, a) {
        Np = a, Dp = t, Vp = null !== e ? e._debugHookTypes : null, $p = -1, Wp = null !== e && e.type !== t.type, t.memoizedState = null, t.updateQueue = null, t.lanes = ho, null !== e && null !== e.memoizedState ? Op.current = og : Op.current = null !== Vp ? ig : rg;
        var s = n(r, i);
        if (zp) {
          var u = 0;
          do {
            if (zp = !1, Up = 0, u >= Kp) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
            u += 1, Wp = !1, Bp = null, jp = null, t.updateQueue = null, $p = -1, Op.current = ag, s = n(r, i);
          } while (zp);
        }
        Op.current = ng, t._debugHookTypes = Vp;
        var c = null !== Bp && null !== Bp.next;
        if (Np = ho, Dp = null, Bp = null, jp = null, Hp = null, Vp = null, $p = -1, null !== e && (e.flags & pi) != (t.flags & pi) && (e.mode & io) !== ro && o("Internal React error: Expected static flag was missing. Please notify the React team."), Fp = !1, c) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return s;
      }
      function em() {
        var e = 0 !== Up;
        return Up = 0, e;
      }
      function tm(e, t, n) {
        t.updateQueue = e.updateQueue, (t.mode & so) !== ro ? t.flags &= ~(ci | ui | Gr | Ur) : t.flags &= ~(Gr | Ur), e.lanes = ga(e.lanes, n);
      }
      function nm() {
        if (Op.current = ng, Fp) {
          for (var e = Dp.memoizedState; null !== e;) {
            var t = e.queue;
            null !== t && (t.pending = null), e = e.next;
          }
          Fp = !1;
        }
        Np = ho, Dp = null, Bp = null, jp = null, Vp = null, $p = -1, Hp = null, Wm = !1, zp = !1, Up = 0;
      }
      function rm() {
        var e = {
          memoizedState: null,
          baseState: null,
          baseQueue: null,
          queue: null,
          next: null
        };
        return null === jp ? Dp.memoizedState = jp = e : jp = jp.next = e, jp;
      }
      function im() {
        var e, t;
        if (null === Bp) {
          var n = Dp.alternate;
          e = null !== n ? n.memoizedState : null;
        } else e = Bp.next;
        if (null !== (t = null === jp ? Dp.memoizedState : jp.next)) t = (jp = t).next, Bp = e;else {
          if (null === e) throw new Error("Rendered more hooks than during the previous render.");
          var r = {
            memoizedState: (Bp = e).memoizedState,
            baseState: Bp.baseState,
            baseQueue: Bp.baseQueue,
            queue: Bp.queue,
            next: null
          };
          null === jp ? Dp.memoizedState = jp = r : jp = jp.next = r;
        }
        return jp;
      }
      function om(e, t) {
        return "function" == typeof t ? t(e) : t;
      }
      function am(e, t, n) {
        var r,
          i = rm();
        r = void 0 !== n ? n(t) : t, i.memoizedState = i.baseState = r;
        var o = {
          pending: null,
          interleaved: null,
          lanes: ho,
          dispatch: null,
          lastRenderedReducer: e,
          lastRenderedState: r
        };
        i.queue = o;
        var a = o.dispatch = Qm.bind(null, Dp, o);
        return [i.memoizedState, a];
      }
      function sm(e, t, n) {
        var r = im(),
          i = r.queue;
        if (null === i) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        i.lastRenderedReducer = e;
        var a = Bp,
          s = a.baseQueue,
          u = i.pending;
        if (null !== u) {
          if (null !== s) {
            var c = s.next,
              l = u.next;
            s.next = l, u.next = c;
          }
          a.baseQueue !== s && o("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), a.baseQueue = s = u, i.pending = null;
        }
        if (null !== s) {
          var d = s.next,
            f = a.baseState,
            h = null,
            p = null,
            m = null,
            g = d;
          do {
            var v = g.lane;
            if (pa(Np, v)) {
              if (null !== m) {
                var b = {
                  lane: po,
                  action: g.action,
                  hasEagerState: g.hasEagerState,
                  eagerState: g.eagerState,
                  next: null
                };
                m = m.next = b;
              }
              if (g.hasEagerState) f = g.eagerState;else f = e(f, g.action);
            } else {
              var y = {
                lane: v,
                action: g.action,
                hasEagerState: g.hasEagerState,
                eagerState: g.eagerState,
                next: null
              };
              null === m ? (p = m = y, h = f) : m = m.next = y, Dp.lanes = ma(Dp.lanes, v), pw(v);
            }
            g = g.next;
          } while (null !== g && g !== d);
          null === m ? h = f : m.next = p, Mu(f, r.memoizedState) || Mv(), r.memoizedState = f, r.baseState = h, r.baseQueue = m, i.lastRenderedState = f;
        }
        var w = i.interleaved;
        if (null !== w) {
          var A = w;
          do {
            var _ = A.lane;
            Dp.lanes = ma(Dp.lanes, _), pw(_), A = A.next;
          } while (A !== w);
        } else null === s && (i.lanes = ho);
        var E = i.dispatch;
        return [r.memoizedState, E];
      }
      function um(e, t, n) {
        var r = im(),
          i = r.queue;
        if (null === i) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        i.lastRenderedReducer = e;
        var o = i.dispatch,
          a = i.pending,
          s = r.memoizedState;
        if (null !== a) {
          i.pending = null;
          var u = a.next,
            c = u;
          do {
            s = e(s, c.action), c = c.next;
          } while (c !== u);
          Mu(s, r.memoizedState) || Mv(), r.memoizedState = s, null === r.baseQueue && (r.baseState = s), i.lastRenderedState = s;
        }
        return [s, o];
      }
      function cm(e, t, n) {
        var r,
          i = Dp,
          a = rm();
        if (yf()) {
          if (void 0 === n) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
          r = n(), Pp || r !== n() && (o("The result of getServerSnapshot should be cached to avoid an infinite loop"), Pp = !0);
        } else {
          if (r = t(), !Pp) {
            var s = t();
            Mu(r, s) || (o("The result of getSnapshot should be cached to avoid an infinite loop"), Pp = !0);
          }
          var u = Yy();
          if (null === u) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
          aa(0, Np) || dm(i, t, r);
        }
        a.memoizedState = r;
        var c = {
          value: r,
          getSnapshot: t
        };
        return a.queue = c, Sm(hm.bind(null, i, c, e), [e]), i.flags |= Gr, ym(Sp | Cp, fm.bind(null, i, c, r, t), void 0, null), r;
      }
      function lm(e, t, n) {
        var r = Dp,
          i = im(),
          a = t();
        if (!Pp) {
          var s = t();
          Mu(a, s) || (o("The result of getSnapshot should be cached to avoid an infinite loop"), Pp = !0);
        }
        var u = i.memoizedState,
          c = !Mu(u, a);
        c && (i.memoizedState = a, Mv());
        var l = i.queue;
        if (km(hm.bind(null, r, l, e), [e]), l.getSnapshot !== t || c || null !== jp && jp.memoizedState.tag & Sp) {
          r.flags |= Gr, ym(Sp | Cp, fm.bind(null, r, l, a, t), void 0, null);
          var d = Yy();
          if (null === d) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
          aa(0, Np) || dm(r, t, a);
        }
        return a;
      }
      function dm(e, t, n) {
        e.flags |= Jr;
        var r = {
            getSnapshot: t,
            value: n
          },
          i = Dp.updateQueue;
        if (null === i) i = {
          lastEffect: null,
          stores: null
        }, Dp.updateQueue = i, i.stores = [r];else {
          var o = i.stores;
          null === o ? i.stores = [r] : o.push(r);
        }
      }
      function fm(e, t, n, r) {
        t.value = n, t.getSnapshot = r, pm(t) && mm(e);
      }
      function hm(e, t, n) {
        return n(function () {
          pm(t) && mm(e);
        });
      }
      function pm(e) {
        var t = e.getSnapshot,
          n = e.value;
        try {
          var r = t();
          return !Mu(n, r);
        } catch (e) {
          return !0;
        }
      }
      function mm(e) {
        var t = Xf(e, mo);
        null !== t && Jy(t, e, mo, Zo);
      }
      function gm(e) {
        var t = rm();
        "function" == typeof e && (e = e()), t.memoizedState = t.baseState = e;
        var n = {
          pending: null,
          interleaved: null,
          lanes: ho,
          dispatch: null,
          lastRenderedReducer: om,
          lastRenderedState: e
        };
        t.queue = n;
        var r = n.dispatch = Zm.bind(null, Dp, n);
        return [t.memoizedState, r];
      }
      function vm(e) {
        return sm(om);
      }
      function bm(e) {
        return um(om);
      }
      function ym(e, t, n, r) {
        var i = {
            tag: e,
            create: t,
            destroy: n,
            deps: r,
            next: null
          },
          o = Dp.updateQueue;
        if (null === o) o = {
          lastEffect: null,
          stores: null
        }, Dp.updateQueue = o, o.lastEffect = i.next = i;else {
          var a = o.lastEffect;
          if (null === a) o.lastEffect = i.next = i;else {
            var s = a.next;
            a.next = i, i.next = s, o.lastEffect = i;
          }
        }
        return i;
      }
      function wm(e) {
        var t = {
          current: e
        };
        return rm().memoizedState = t, t;
      }
      function Am(e) {
        return im().memoizedState;
      }
      function _m(e, t, n, r) {
        var i = rm(),
          o = void 0 === r ? null : r;
        Dp.flags |= e, i.memoizedState = ym(Sp | t, n, void 0, o);
      }
      function Em(e, t, n, r) {
        var i = im(),
          o = void 0 === r ? null : r,
          a = void 0;
        if (null !== Bp) {
          var s = Bp.memoizedState;
          if (a = s.destroy, null !== o) if (Jp(o, s.deps)) return void (i.memoizedState = ym(t, n, a, o));
        }
        Dp.flags |= e, i.memoizedState = ym(Sp | t, n, a, o);
      }
      function Sm(e, t) {
        return (Dp.mode & so) !== ro ? _m(ci | Gr | si, Cp, e, t) : _m(Gr | si, Cp, e, t);
      }
      function km(e, t) {
        return Em(Gr, Cp, e, t);
      }
      function Mm(e, t) {
        return _m(Ur, kp, e, t);
      }
      function Cm(e, t) {
        return Em(Ur, kp, e, t);
      }
      function xm(e, t) {
        var n = Ur;
        return n |= ai, (Dp.mode & so) !== ro && (n |= ui), _m(n, Mp, e, t);
      }
      function Rm(e, t) {
        return Em(Ur, Mp, e, t);
      }
      function Im(e, t) {
        if ("function" == typeof t) {
          var n = t,
            r = e();
          return n(r), function () {
            n(null);
          };
        }
        if (null != t) {
          var i = t;
          i.hasOwnProperty("current") || o("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(i).join(", ") + "}");
          var a = e();
          return i.current = a, function () {
            i.current = null;
          };
        }
      }
      function Tm(e, t, n) {
        "function" != typeof t && o("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== t ? typeof t : "null");
        var r = null != n ? n.concat([e]) : null,
          i = Ur;
        return i |= ai, (Dp.mode & so) !== ro && (i |= ui), _m(i, Mp, Im.bind(null, t, e), r);
      }
      function Pm(e, t, n) {
        "function" != typeof t && o("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== t ? typeof t : "null");
        var r = null != n ? n.concat([e]) : null;
        return Em(Ur, Mp, Im.bind(null, t, e), r);
      }
      function Om(e, t) {}
      var Lm = Om;
      function Nm(e, t) {
        var n = void 0 === t ? null : t;
        return rm().memoizedState = [e, n], e;
      }
      function Dm(e, t) {
        var n = im(),
          r = void 0 === t ? null : t,
          i = n.memoizedState;
        if (null !== i && null !== r && Jp(r, i[1])) return i[0];
        return n.memoizedState = [e, r], e;
      }
      function Bm(e, t) {
        var n = rm(),
          r = void 0 === t ? null : t,
          i = e();
        return n.memoizedState = [i, r], i;
      }
      function jm(e, t) {
        var n = im(),
          r = void 0 === t ? null : t,
          i = n.memoizedState;
        if (null !== i && null !== r && Jp(r, i[1])) return i[0];
        var o = e();
        return n.memoizedState = [o, r], o;
      }
      function Fm(e) {
        return rm().memoizedState = e, e;
      }
      function zm(e) {
        return qm(im(), Bp.memoizedState, e);
      }
      function Um(e) {
        var t = im();
        return null === Bp ? (t.memoizedState = e, e) : qm(t, Bp.memoizedState, e);
      }
      function qm(e, t, n) {
        if (!((Np & (mo | vo | yo)) === ho)) {
          if (!Mu(n, t)) {
            var r = ua();
            Dp.lanes = ma(Dp.lanes, r), pw(r), e.baseState = !0;
          }
          return t;
        }
        return e.baseState && (e.baseState = !1, Mv()), e.memoizedState = n, n;
      }
      function Km(e, t, n) {
        var r = La();
        Na(function (e, t) {
          return 0 !== e && e < t ? e : t;
        }(r, Ia)), e(!0);
        var o = Lp.transition;
        Lp.transition = {};
        var a = Lp.transition;
        Lp.transition._updatedFibers = new Set();
        try {
          e(!1), t();
        } finally {
          if (Na(r), Lp.transition = o, null === o && a._updatedFibers) a._updatedFibers.size > 10 && i("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), a._updatedFibers.clear();
        }
      }
      function Hm() {
        var e = gm(!1),
          t = e[0],
          n = e[1],
          r = Km.bind(null, n);
        return rm().memoizedState = r, [t, r];
      }
      function Vm() {
        return [vm()[0], im().memoizedState];
      }
      function $m() {
        return [bm()[0], im().memoizedState];
      }
      var Wm = !1;
      function Ym() {
        var e,
          t = rm(),
          n = Yy().identifierPrefix;
        if (yf()) {
          e = ":" + n + "R" + zd();
          var r = Up++;
          r > 0 && (e += "H" + r.toString(32)), e += ":";
        } else {
          e = ":" + n + "r" + (qp++).toString(32) + ":";
        }
        return t.memoizedState = e, e;
      }
      function Gm() {
        return im().memoizedState;
      }
      function Qm(e, t, n) {
        "function" == typeof arguments[3] && o("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var r = Qy(e),
          i = {
            lane: r,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null
          };
        if (Jm(e)) Xm(t, i);else {
          var a = Jf(e, t, i, r);
          if (null !== a) Jy(a, e, r, Gy()), eg(a, t, r);
        }
        tg(e, r);
      }
      function Zm(e, t, n) {
        "function" == typeof arguments[3] && o("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var r = Qy(e),
          i = {
            lane: r,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null
          };
        if (Jm(e)) Xm(t, i);else {
          var a = e.alternate;
          if (e.lanes === ho && (null === a || a.lanes === ho)) {
            var s = t.lastRenderedReducer;
            if (null !== s) {
              var u;
              u = Op.current, Op.current = ug;
              try {
                var c = t.lastRenderedState,
                  l = s(c, n);
                if (i.hasEagerState = !0, i.eagerState = l, Mu(l, c)) return void function (e, t, n, r) {
                  var i = t.interleaved;
                  null === i ? (n.next = n, Zf(t)) : (n.next = i.next, i.next = n), t.interleaved = n;
                }(0, t, i);
              } catch (e) {} finally {
                Op.current = u;
              }
            }
          }
          var d = Jf(e, t, i, r);
          if (null !== d) Jy(d, e, r, Gy()), eg(d, t, r);
        }
        tg(e, r);
      }
      function Jm(e) {
        var t = e.alternate;
        return e === Dp || null !== t && t === Dp;
      }
      function Xm(e, t) {
        zp = Fp = !0;
        var n = e.pending;
        null === n ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
      }
      function eg(e, t, n) {
        if (sa(n)) {
          var r = t.lanes,
            i = ma(r = va(r, e.pendingLanes), n);
          t.lanes = i, Aa(e, i);
        }
      }
      function tg(e, t, n) {
        no(e, t);
      }
      var ng = {
          readContext: Gf,
          useCallback: Zp,
          useContext: Zp,
          useEffect: Zp,
          useImperativeHandle: Zp,
          useInsertionEffect: Zp,
          useLayoutEffect: Zp,
          useMemo: Zp,
          useReducer: Zp,
          useRef: Zp,
          useState: Zp,
          useDebugValue: Zp,
          useDeferredValue: Zp,
          useTransition: Zp,
          useMutableSource: Zp,
          useSyncExternalStore: Zp,
          useId: Zp,
          unstable_isNewReconciler: O
        },
        rg = null,
        ig = null,
        og = null,
        ag = null,
        sg = null,
        ug = null,
        cg = null,
        lg = function () {
          o("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        },
        dg = function () {
          o("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
        };
      rg = {
        readContext: function (e) {
          return Gf(e);
        },
        useCallback: function (e, t) {
          return Hp = "useCallback", Yp(), Qp(t), Nm(e, t);
        },
        useContext: function (e) {
          return Hp = "useContext", Yp(), Gf(e);
        },
        useEffect: function (e, t) {
          return Hp = "useEffect", Yp(), Qp(t), Sm(e, t);
        },
        useImperativeHandle: function (e, t, n) {
          return Hp = "useImperativeHandle", Yp(), Qp(n), Tm(e, t, n);
        },
        useInsertionEffect: function (e, t) {
          return Hp = "useInsertionEffect", Yp(), Qp(t), Mm(e, t);
        },
        useLayoutEffect: function (e, t) {
          return Hp = "useLayoutEffect", Yp(), Qp(t), xm(e, t);
        },
        useMemo: function (e, t) {
          Hp = "useMemo", Yp(), Qp(t);
          var n = Op.current;
          Op.current = sg;
          try {
            return Bm(e, t);
          } finally {
            Op.current = n;
          }
        },
        useReducer: function (e, t, n) {
          Hp = "useReducer", Yp();
          var r = Op.current;
          Op.current = sg;
          try {
            return am(e, t, n);
          } finally {
            Op.current = r;
          }
        },
        useRef: function (e) {
          return Hp = "useRef", Yp(), wm(e);
        },
        useState: function (e) {
          Hp = "useState", Yp();
          var t = Op.current;
          Op.current = sg;
          try {
            return gm(e);
          } finally {
            Op.current = t;
          }
        },
        useDebugValue: function (e, t) {
          Hp = "useDebugValue", Yp();
        },
        useDeferredValue: function (e) {
          return Hp = "useDeferredValue", Yp(), Fm(e);
        },
        useTransition: function () {
          return Hp = "useTransition", Yp(), Hm();
        },
        useMutableSource: function (e, t, n) {
          Hp = "useMutableSource", Yp();
        },
        useSyncExternalStore: function (e, t, n) {
          return Hp = "useSyncExternalStore", Yp(), cm(e, t, n);
        },
        useId: function () {
          return Hp = "useId", Yp(), Ym();
        },
        unstable_isNewReconciler: O
      }, ig = {
        readContext: function (e) {
          return Gf(e);
        },
        useCallback: function (e, t) {
          return Hp = "useCallback", Gp(), Nm(e, t);
        },
        useContext: function (e) {
          return Hp = "useContext", Gp(), Gf(e);
        },
        useEffect: function (e, t) {
          return Hp = "useEffect", Gp(), Sm(e, t);
        },
        useImperativeHandle: function (e, t, n) {
          return Hp = "useImperativeHandle", Gp(), Tm(e, t, n);
        },
        useInsertionEffect: function (e, t) {
          return Hp = "useInsertionEffect", Gp(), Mm(e, t);
        },
        useLayoutEffect: function (e, t) {
          return Hp = "useLayoutEffect", Gp(), xm(e, t);
        },
        useMemo: function (e, t) {
          Hp = "useMemo", Gp();
          var n = Op.current;
          Op.current = sg;
          try {
            return Bm(e, t);
          } finally {
            Op.current = n;
          }
        },
        useReducer: function (e, t, n) {
          Hp = "useReducer", Gp();
          var r = Op.current;
          Op.current = sg;
          try {
            return am(e, t, n);
          } finally {
            Op.current = r;
          }
        },
        useRef: function (e) {
          return Hp = "useRef", Gp(), wm(e);
        },
        useState: function (e) {
          Hp = "useState", Gp();
          var t = Op.current;
          Op.current = sg;
          try {
            return gm(e);
          } finally {
            Op.current = t;
          }
        },
        useDebugValue: function (e, t) {
          Hp = "useDebugValue", Gp();
        },
        useDeferredValue: function (e) {
          return Hp = "useDeferredValue", Gp(), Fm(e);
        },
        useTransition: function () {
          return Hp = "useTransition", Gp(), Hm();
        },
        useMutableSource: function (e, t, n) {
          Hp = "useMutableSource", Gp();
        },
        useSyncExternalStore: function (e, t, n) {
          return Hp = "useSyncExternalStore", Gp(), cm(e, t, n);
        },
        useId: function () {
          return Hp = "useId", Gp(), Ym();
        },
        unstable_isNewReconciler: O
      }, og = {
        readContext: function (e) {
          return Gf(e);
        },
        useCallback: function (e, t) {
          return Hp = "useCallback", Gp(), Dm(e, t);
        },
        useContext: function (e) {
          return Hp = "useContext", Gp(), Gf(e);
        },
        useEffect: function (e, t) {
          return Hp = "useEffect", Gp(), km(e, t);
        },
        useImperativeHandle: function (e, t, n) {
          return Hp = "useImperativeHandle", Gp(), Pm(e, t, n);
        },
        useInsertionEffect: function (e, t) {
          return Hp = "useInsertionEffect", Gp(), Cm(e, t);
        },
        useLayoutEffect: function (e, t) {
          return Hp = "useLayoutEffect", Gp(), Rm(e, t);
        },
        useMemo: function (e, t) {
          Hp = "useMemo", Gp();
          var n = Op.current;
          Op.current = ug;
          try {
            return jm(e, t);
          } finally {
            Op.current = n;
          }
        },
        useReducer: function (e, t, n) {
          Hp = "useReducer", Gp();
          var r = Op.current;
          Op.current = ug;
          try {
            return sm(e);
          } finally {
            Op.current = r;
          }
        },
        useRef: function (e) {
          return Hp = "useRef", Gp(), Am();
        },
        useState: function (e) {
          Hp = "useState", Gp();
          var t = Op.current;
          Op.current = ug;
          try {
            return vm();
          } finally {
            Op.current = t;
          }
        },
        useDebugValue: function (e, t) {
          return Hp = "useDebugValue", Gp(), Lm();
        },
        useDeferredValue: function (e) {
          return Hp = "useDeferredValue", Gp(), zm(e);
        },
        useTransition: function () {
          return Hp = "useTransition", Gp(), Vm();
        },
        useMutableSource: function (e, t, n) {
          Hp = "useMutableSource", Gp();
        },
        useSyncExternalStore: function (e, t, n) {
          return Hp = "useSyncExternalStore", Gp(), lm(e, t);
        },
        useId: function () {
          return Hp = "useId", Gp(), Gm();
        },
        unstable_isNewReconciler: O
      }, ag = {
        readContext: function (e) {
          return Gf(e);
        },
        useCallback: function (e, t) {
          return Hp = "useCallback", Gp(), Dm(e, t);
        },
        useContext: function (e) {
          return Hp = "useContext", Gp(), Gf(e);
        },
        useEffect: function (e, t) {
          return Hp = "useEffect", Gp(), km(e, t);
        },
        useImperativeHandle: function (e, t, n) {
          return Hp = "useImperativeHandle", Gp(), Pm(e, t, n);
        },
        useInsertionEffect: function (e, t) {
          return Hp = "useInsertionEffect", Gp(), Cm(e, t);
        },
        useLayoutEffect: function (e, t) {
          return Hp = "useLayoutEffect", Gp(), Rm(e, t);
        },
        useMemo: function (e, t) {
          Hp = "useMemo", Gp();
          var n = Op.current;
          Op.current = cg;
          try {
            return jm(e, t);
          } finally {
            Op.current = n;
          }
        },
        useReducer: function (e, t, n) {
          Hp = "useReducer", Gp();
          var r = Op.current;
          Op.current = cg;
          try {
            return um(e);
          } finally {
            Op.current = r;
          }
        },
        useRef: function (e) {
          return Hp = "useRef", Gp(), Am();
        },
        useState: function (e) {
          Hp = "useState", Gp();
          var t = Op.current;
          Op.current = cg;
          try {
            return bm();
          } finally {
            Op.current = t;
          }
        },
        useDebugValue: function (e, t) {
          return Hp = "useDebugValue", Gp(), Lm();
        },
        useDeferredValue: function (e) {
          return Hp = "useDeferredValue", Gp(), Um(e);
        },
        useTransition: function () {
          return Hp = "useTransition", Gp(), $m();
        },
        useMutableSource: function (e, t, n) {
          Hp = "useMutableSource", Gp();
        },
        useSyncExternalStore: function (e, t, n) {
          return Hp = "useSyncExternalStore", Gp(), lm(e, t);
        },
        useId: function () {
          return Hp = "useId", Gp(), Gm();
        },
        unstable_isNewReconciler: O
      }, sg = {
        readContext: function (e) {
          return lg(), Gf(e);
        },
        useCallback: function (e, t) {
          return Hp = "useCallback", dg(), Yp(), Nm(e, t);
        },
        useContext: function (e) {
          return Hp = "useContext", dg(), Yp(), Gf(e);
        },
        useEffect: function (e, t) {
          return Hp = "useEffect", dg(), Yp(), Sm(e, t);
        },
        useImperativeHandle: function (e, t, n) {
          return Hp = "useImperativeHandle", dg(), Yp(), Tm(e, t, n);
        },
        useInsertionEffect: function (e, t) {
          return Hp = "useInsertionEffect", dg(), Yp(), Mm(e, t);
        },
        useLayoutEffect: function (e, t) {
          return Hp = "useLayoutEffect", dg(), Yp(), xm(e, t);
        },
        useMemo: function (e, t) {
          Hp = "useMemo", dg(), Yp();
          var n = Op.current;
          Op.current = sg;
          try {
            return Bm(e, t);
          } finally {
            Op.current = n;
          }
        },
        useReducer: function (e, t, n) {
          Hp = "useReducer", dg(), Yp();
          var r = Op.current;
          Op.current = sg;
          try {
            return am(e, t, n);
          } finally {
            Op.current = r;
          }
        },
        useRef: function (e) {
          return Hp = "useRef", dg(), Yp(), wm(e);
        },
        useState: function (e) {
          Hp = "useState", dg(), Yp();
          var t = Op.current;
          Op.current = sg;
          try {
            return gm(e);
          } finally {
            Op.current = t;
          }
        },
        useDebugValue: function (e, t) {
          Hp = "useDebugValue", dg(), Yp();
        },
        useDeferredValue: function (e) {
          return Hp = "useDeferredValue", dg(), Yp(), Fm(e);
        },
        useTransition: function () {
          return Hp = "useTransition", dg(), Yp(), Hm();
        },
        useMutableSource: function (e, t, n) {
          Hp = "useMutableSource", dg(), Yp();
        },
        useSyncExternalStore: function (e, t, n) {
          return Hp = "useSyncExternalStore", dg(), Yp(), cm(e, t, n);
        },
        useId: function () {
          return Hp = "useId", dg(), Yp(), Ym();
        },
        unstable_isNewReconciler: O
      }, ug = {
        readContext: function (e) {
          return lg(), Gf(e);
        },
        useCallback: function (e, t) {
          return Hp = "useCallback", dg(), Gp(), Dm(e, t);
        },
        useContext: function (e) {
          return Hp = "useContext", dg(), Gp(), Gf(e);
        },
        useEffect: function (e, t) {
          return Hp = "useEffect", dg(), Gp(), km(e, t);
        },
        useImperativeHandle: function (e, t, n) {
          return Hp = "useImperativeHandle", dg(), Gp(), Pm(e, t, n);
        },
        useInsertionEffect: function (e, t) {
          return Hp = "useInsertionEffect", dg(), Gp(), Cm(e, t);
        },
        useLayoutEffect: function (e, t) {
          return Hp = "useLayoutEffect", dg(), Gp(), Rm(e, t);
        },
        useMemo: function (e, t) {
          Hp = "useMemo", dg(), Gp();
          var n = Op.current;
          Op.current = ug;
          try {
            return jm(e, t);
          } finally {
            Op.current = n;
          }
        },
        useReducer: function (e, t, n) {
          Hp = "useReducer", dg(), Gp();
          var r = Op.current;
          Op.current = ug;
          try {
            return sm(e);
          } finally {
            Op.current = r;
          }
        },
        useRef: function (e) {
          return Hp = "useRef", dg(), Gp(), Am();
        },
        useState: function (e) {
          Hp = "useState", dg(), Gp();
          var t = Op.current;
          Op.current = ug;
          try {
            return vm();
          } finally {
            Op.current = t;
          }
        },
        useDebugValue: function (e, t) {
          return Hp = "useDebugValue", dg(), Gp(), Lm();
        },
        useDeferredValue: function (e) {
          return Hp = "useDeferredValue", dg(), Gp(), zm(e);
        },
        useTransition: function () {
          return Hp = "useTransition", dg(), Gp(), Vm();
        },
        useMutableSource: function (e, t, n) {
          Hp = "useMutableSource", dg(), Gp();
        },
        useSyncExternalStore: function (e, t, n) {
          return Hp = "useSyncExternalStore", dg(), Gp(), lm(e, t);
        },
        useId: function () {
          return Hp = "useId", dg(), Gp(), Gm();
        },
        unstable_isNewReconciler: O
      }, cg = {
        readContext: function (e) {
          return lg(), Gf(e);
        },
        useCallback: function (e, t) {
          return Hp = "useCallback", dg(), Gp(), Dm(e, t);
        },
        useContext: function (e) {
          return Hp = "useContext", dg(), Gp(), Gf(e);
        },
        useEffect: function (e, t) {
          return Hp = "useEffect", dg(), Gp(), km(e, t);
        },
        useImperativeHandle: function (e, t, n) {
          return Hp = "useImperativeHandle", dg(), Gp(), Pm(e, t, n);
        },
        useInsertionEffect: function (e, t) {
          return Hp = "useInsertionEffect", dg(), Gp(), Cm(e, t);
        },
        useLayoutEffect: function (e, t) {
          return Hp = "useLayoutEffect", dg(), Gp(), Rm(e, t);
        },
        useMemo: function (e, t) {
          Hp = "useMemo", dg(), Gp();
          var n = Op.current;
          Op.current = ug;
          try {
            return jm(e, t);
          } finally {
            Op.current = n;
          }
        },
        useReducer: function (e, t, n) {
          Hp = "useReducer", dg(), Gp();
          var r = Op.current;
          Op.current = ug;
          try {
            return um(e);
          } finally {
            Op.current = r;
          }
        },
        useRef: function (e) {
          return Hp = "useRef", dg(), Gp(), Am();
        },
        useState: function (e) {
          Hp = "useState", dg(), Gp();
          var t = Op.current;
          Op.current = ug;
          try {
            return bm();
          } finally {
            Op.current = t;
          }
        },
        useDebugValue: function (e, t) {
          return Hp = "useDebugValue", dg(), Gp(), Lm();
        },
        useDeferredValue: function (e) {
          return Hp = "useDeferredValue", dg(), Gp(), Um(e);
        },
        useTransition: function () {
          return Hp = "useTransition", dg(), Gp(), $m();
        },
        useMutableSource: function (e, t, n) {
          Hp = "useMutableSource", dg(), Gp();
        },
        useSyncExternalStore: function (e, t, n) {
          return Hp = "useSyncExternalStore", dg(), Gp(), lm(e, t);
        },
        useId: function () {
          return Hp = "useId", dg(), Gp(), Gm();
        },
        unstable_isNewReconciler: O
      };
      var fg = t.unstable_now,
        hg = 0,
        pg = -1,
        mg = -1,
        gg = -1,
        vg = !1,
        bg = !1;
      function yg() {
        return vg;
      }
      function wg() {
        return hg;
      }
      function Ag() {
        hg = fg();
      }
      function _g(e) {
        mg = fg(), e.actualStartTime < 0 && (e.actualStartTime = fg());
      }
      function Eg(e) {
        mg = -1;
      }
      function Sg(e, t) {
        if (mg >= 0) {
          var n = fg() - mg;
          e.actualDuration += n, t && (e.selfBaseDuration = n), mg = -1;
        }
      }
      function kg(e) {
        if (pg >= 0) {
          var t = fg() - pg;
          pg = -1;
          for (var n = e.return; null !== n;) {
            switch (n.tag) {
              case l:
                return void (n.stateNode.effectDuration += t);
              case y:
                return void (n.stateNode.effectDuration += t);
            }
            n = n.return;
          }
        }
      }
      function Mg(e) {
        if (gg >= 0) {
          var t = fg() - gg;
          gg = -1;
          for (var n = e.return; null !== n;) {
            switch (n.tag) {
              case l:
                var r = n.stateNode;
                return void (null !== r && (r.passiveEffectDuration += t));
              case y:
                var i = n.stateNode;
                return void (null !== i && (i.passiveEffectDuration += t));
            }
            n = n.return;
          }
        }
      }
      function Cg() {
        pg = fg();
      }
      function xg() {
        gg = fg();
      }
      function Rg(e) {
        for (var t = e.child; t;) e.actualDuration += t.actualDuration, t = t.sibling;
      }
      function Ig(e, t) {
        return {
          value: e,
          source: t,
          stack: ut(t),
          digest: null
        };
      }
      function Tg(e, t, n) {
        return {
          value: e,
          source: null,
          stack: null != n ? n : null,
          digest: null != t ? t : null
        };
      }
      function Pg(e, t) {
        try {
          0;
          var n = t.value,
            r = t.source,
            i = t.stack,
            o = null !== i ? i : "";
          if (null != n && n._suppressLogging) {
            if (e.tag === u) return;
            console.error(n);
          }
          var a = r ? ft(r) : null,
            s = (a ? "The above error occurred in the <" + a + "> component:" : "The above error occurred in one of your React components:") + "\n" + o + "\n\n" + (e.tag === l ? "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries." : "React will try to recreate this component tree from scratch using the error boundary you provided, " + (ft(e) || "Anonymous") + ".");
          console.error(s);
        } catch (e) {
          setTimeout(function () {
            throw e;
          });
        }
      }
      var Og = "function" == typeof WeakMap ? WeakMap : Map;
      function Lg(e, t, n) {
        var r = dh(Zo, n);
        r.tag = sh, r.payload = {
          element: null
        };
        var i = t.value;
        return r.callback = function () {
          Sw(i), Pg(e, t);
        }, r;
      }
      function Ng(e, t, n) {
        var r = dh(Zo, n);
        r.tag = sh;
        var i = e.type.getDerivedStateFromError;
        if ("function" == typeof i) {
          var a = t.value;
          r.payload = function () {
            return i(a);
          }, r.callback = function () {
            Zw(e), Pg(e, t);
          };
        }
        var s = e.stateNode;
        return null !== s && "function" == typeof s.componentDidCatch && (r.callback = function () {
          Zw(e), Pg(e, t), "function" != typeof i && function (e) {
            null === Ty ? Ty = new Set([e]) : Ty.add(e);
          }(this);
          var n = t.value,
            r = t.stack;
          this.componentDidCatch(n, {
            componentStack: null !== r ? r : ""
          }), "function" != typeof i && (ha(e.lanes, mo) || o("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", ft(e) || "Unknown"));
        }), r;
      }
      function Dg(e, t, n) {
        var r,
          i = e.pingCache;
        if (null === i ? (i = e.pingCache = new Og(), r = new Set(), i.set(t, r)) : void 0 === (r = i.get(t)) && (r = new Set(), i.set(t, r)), !r.has(n)) {
          r.add(n);
          var o = Cw.bind(null, e, t, n);
          qi && jw(e, n), t.then(o, o);
        }
      }
      function Bg(e) {
        var t = e;
        do {
          if (t.tag === w && Ap(t)) return t;
          t = t.return;
        } while (null !== t);
        return null;
      }
      function jg(e, t, n, r, i) {
        if ((e.mode & io) === ro) {
          if (e === t) e.flags |= ni;else {
            if (e.flags |= Vr, n.flags |= ri, n.flags &= ~(Xr | ti), n.tag === u) if (null === n.alternate) n.tag = S;else {
              var o = dh(Zo, mo);
              o.tag = ah, fh(n, o, mo);
            }
            n.lanes = ma(n.lanes, mo);
          }
          return e;
        }
        return e.flags |= ni, e.lanes = i, e;
      }
      function Fg(e, t, n, r, i) {
        if (n.flags |= ti, qi && jw(e, i), null !== r && "object" == typeof r && "function" == typeof r.then) {
          var o = r;
          !function (e, t) {
            var n = e.tag;
            if ((e.mode & io) === ro && (n === s || n === b || n === _)) {
              var r = e.alternate;
              r ? (e.updateQueue = r.updateQueue, e.memoizedState = r.memoizedState, e.lanes = r.lanes) : (e.updateQueue = null, e.memoizedState = null);
            }
          }(n), yf() && n.mode & io && Xd();
          var a = Bg(t);
          if (null !== a) return a.flags &= ~$r, jg(a, t, n, 0, i), a.mode & io && Dg(e, o, i), void function (e, t, n, r) {
            var i = e.updateQueue;
            if (null === i) {
              var o = new Set();
              o.add(n), e.updateQueue = o;
            } else i.add(n);
          }(a, 0, o);
          if ((i & mo) === ho) return Dg(e, o, i), void mw();
          r = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
        } else if (yf() && n.mode & io) {
          Xd();
          var c = Bg(t);
          if (null !== c) return (c.flags & ni) === jr && (c.flags |= $r), jg(c, t, n, 0, i), void wf(Ig(r, n));
        }
        !function (e) {
          my !== ay && (my = iy);
          null === wy ? wy = [e] : wy.push(e);
        }(r = Ig(r, n));
        var d = t;
        do {
          switch (d.tag) {
            case l:
              var f = r;
              d.flags |= ni;
              var h = la(i);
              return d.lanes = ma(d.lanes, h), void ph(d, Lg(d, f, h));
            case u:
              var p = r,
                m = d.type,
                g = d.stateNode;
              if ((d.flags & Vr) === jr && ("function" == typeof m.getDerivedStateFromError || null !== g && "function" == typeof g.componentDidCatch && !Ew(g))) {
                d.flags |= ni;
                var v = la(i);
                return d.lanes = ma(d.lanes, v), void ph(d, Ng(d, p, v));
              }
          }
          d = d.return;
        } while (null !== d);
      }
      var zg,
        Ug,
        qg,
        Kg,
        Hg,
        Vg,
        $g,
        Wg,
        Yg = n.ReactCurrentOwner,
        Gg = !1;
      function Qg(e, t, n, r) {
        t.child = null === e ? Xh(t, null, n, r) : Jh(t, e.child, n, r);
      }
      function Zg(e, t, n, r, i) {
        if (t.type !== t.elementType) {
          var o = n.propTypes;
          o && Xl(o, r, "prop", lt(n));
        }
        var a,
          s,
          u = n.render,
          c = t.ref;
        if (Yf(t, i), Wi(t), Yg.current = t, wt(!0), a = Xp(e, t, u, r, c, i), s = em(), t.mode & ao) {
          Ki(!0);
          try {
            a = Xp(e, t, u, r, c, i), s = em();
          } finally {
            Ki(!1);
          }
        }
        return wt(!1), Yi(), null === e || Gg ? (yf() && s && Kd(t), t.flags |= Fr, Qg(e, t, a, i), t.child) : (tm(e, t, i), xv(e, t, i));
      }
      function Jg(e, t, n, r, i) {
        if (null === e) {
          var o = n.type;
          if (function (e) {
            return "function" == typeof e && !sA(e) && void 0 === e.defaultProps;
          }(o) && null === n.compare && void 0 === n.defaultProps) {
            var a;
            return a = Ww(o), t.tag = _, t.type = a, uv(t, o), Xg(e, t, a, r, i);
          }
          var s = o.propTypes;
          s && Xl(s, r, "prop", lt(o));
          var u = lA(n.type, null, r, t, t.mode, i);
          return u.ref = t.ref, u.return = t, t.child = u, u;
        }
        var c = n.type,
          l = c.propTypes;
        l && Xl(l, r, "prop", lt(c));
        var d = e.child;
        if (!Rv(e, i)) {
          var f = d.memoizedProps,
            h = n.compare;
          if ((h = null !== h ? h : Cu)(f, r) && e.ref === t.ref) return xv(e, t, i);
        }
        t.flags |= Fr;
        var p = uA(d, r);
        return p.ref = t.ref, p.return = t, t.child = p, p;
      }
      function Xg(e, t, n, r, i) {
        if (t.type !== t.elementType) {
          var o = t.elementType;
          if (o.$$typeof === Be) {
            var a = o,
              s = a._payload,
              u = a._init;
            try {
              o = u(s);
            } catch (e) {
              o = null;
            }
            var c = o && o.propTypes;
            c && Xl(c, r, "prop", lt(o));
          }
        }
        if (null !== e) {
          var l = e.memoizedProps;
          if (Cu(l, r) && e.ref === t.ref && t.type === e.type) {
            if (Gg = !1, t.pendingProps = r = l, !Rv(e, i)) return t.lanes = e.lanes, xv(e, t, i);
            (e.flags & ri) !== jr && (Gg = !0);
          }
        }
        return nv(e, t, n, r, i);
      }
      function ev(e, t, n) {
        var r,
          i = t.pendingProps,
          o = i.children,
          a = null !== e ? e.memoizedState : null;
        if ("hidden" === i.mode || N) {
          if ((t.mode & io) === ro) {
            var s = {
              baseLanes: ho,
              cachePool: null,
              transitions: null
            };
            t.memoizedState = s, uw(t, n);
          } else {
            if (!ha(n, Go)) {
              var u;
              if (null !== a) u = ma(a.baseLanes, n);else u = n;
              t.lanes = t.childLanes = Go;
              var c = {
                baseLanes: u,
                cachePool: null,
                transitions: null
              };
              return t.memoizedState = c, t.updateQueue = null, uw(t, u), null;
            }
            var l = {
              baseLanes: ho,
              cachePool: null,
              transitions: null
            };
            t.memoizedState = l, uw(t, null !== a ? a.baseLanes : n);
          }
        } else null !== a ? (r = ma(a.baseLanes, n), t.memoizedState = null) : r = n, uw(t, r);
        return Qg(e, t, o, n), t.child;
      }
      function tv(e, t) {
        var n = t.ref;
        (null === e && null !== n || null !== e && e.ref !== n) && (t.flags |= Wr, t.flags |= oi);
      }
      function nv(e, t, n, r, i) {
        if (t.type !== t.elementType) {
          var o = n.propTypes;
          o && Xl(o, r, "prop", lt(n));
        }
        var a, s, u;
        if (a = hd(t, dd(0, n, !0)), Yf(t, i), Wi(t), Yg.current = t, wt(!0), s = Xp(e, t, n, r, a, i), u = em(), t.mode & ao) {
          Ki(!0);
          try {
            s = Xp(e, t, n, r, a, i), u = em();
          } finally {
            Ki(!1);
          }
        }
        return wt(!1), Yi(), null === e || Gg ? (yf() && u && Kd(t), t.flags |= Fr, Qg(e, t, s, i), t.child) : (tm(e, t, i), xv(e, t, i));
      }
      function rv(e, t, n, r, i) {
        switch (TA(t)) {
          case !1:
            var a = t.stateNode,
              s = new (0, t.type)(t.memoizedProps, a.context).state;
            a.updater.enqueueSetState(a, s, null);
            break;
          case !0:
            t.flags |= Vr, t.flags |= ni;
            var u = new Error("Simulated error coming from DevTools"),
              c = la(i);
            t.lanes = ma(t.lanes, c), ph(t, Ng(t, Ig(u, t), c));
        }
        if (t.type !== t.elementType) {
          var l = n.propTypes;
          l && Xl(l, r, "prop", lt(n));
        }
        var d, f;
        md(n) ? (d = !0, wd(t)) : d = !1, Yf(t, i), null === t.stateNode ? (Cv(e, t), Kh(t, n, r), Vh(t, n, r, i), f = !0) : f = null === e ? function (e, t, n, r) {
          var i = e.stateNode,
            o = e.memoizedProps;
          i.props = o;
          var a = i.context,
            s = t.contextType,
            u = sd;
          u = "object" == typeof s && null !== s ? Gf(s) : hd(e, dd(0, t, !0));
          var c = t.getDerivedStateFromProps,
            l = "function" == typeof c || "function" == typeof i.getSnapshotBeforeUpdate;
          l || "function" != typeof i.UNSAFE_componentWillReceiveProps && "function" != typeof i.componentWillReceiveProps || o === n && a === u || Hh(e, i, n, u), bh();
          var d = e.memoizedState,
            f = i.state = d;
          if (gh(e, n, i, r), f = e.memoizedState, o === n && d === f && !pd() && !yh()) {
            if ("function" == typeof i.componentDidMount) {
              var h = Ur;
              h |= ai, (e.mode & so) !== ro && (h |= ui), e.flags |= h;
            }
            return !1;
          }
          "function" == typeof c && (Lh(e, t, c, n), f = e.memoizedState);
          var p = yh() || Uh(e, t, o, n, d, f, u);
          if (p) {
            if (l || "function" != typeof i.UNSAFE_componentWillMount && "function" != typeof i.componentWillMount || ("function" == typeof i.componentWillMount && i.componentWillMount(), "function" == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount()), "function" == typeof i.componentDidMount) {
              var m = Ur;
              m |= ai, (e.mode & so) !== ro && (m |= ui), e.flags |= m;
            }
          } else {
            if ("function" == typeof i.componentDidMount) {
              var g = Ur;
              g |= ai, (e.mode & so) !== ro && (g |= ui), e.flags |= g;
            }
            e.memoizedProps = n, e.memoizedState = f;
          }
          return i.props = n, i.state = f, i.context = u, p;
        }(t, n, r, i) : function (e, t, n, r, i) {
          var o = t.stateNode;
          lh(e, t);
          var a = t.memoizedProps,
            s = t.type === t.elementType ? a : Lf(t.type, a);
          o.props = s;
          var u = t.pendingProps,
            c = o.context,
            l = n.contextType,
            d = sd;
          d = "object" == typeof l && null !== l ? Gf(l) : hd(t, dd(0, n, !0));
          var f = n.getDerivedStateFromProps,
            h = "function" == typeof f || "function" == typeof o.getSnapshotBeforeUpdate;
          h || "function" != typeof o.UNSAFE_componentWillReceiveProps && "function" != typeof o.componentWillReceiveProps || a === u && c === d || Hh(t, o, r, d), bh();
          var p = t.memoizedState,
            m = o.state = p;
          if (gh(t, r, o, i), m = t.memoizedState, a === u && p === m && !pd() && !yh() && !L) return "function" == typeof o.componentDidUpdate && (a === e.memoizedProps && p === e.memoizedState || (t.flags |= Ur)), "function" == typeof o.getSnapshotBeforeUpdate && (a === e.memoizedProps && p === e.memoizedState || (t.flags |= Yr)), !1;
          "function" == typeof f && (Lh(t, n, f, r), m = t.memoizedState);
          var g = yh() || Uh(t, n, s, r, p, m, d) || L;
          return g ? (h || "function" != typeof o.UNSAFE_componentWillUpdate && "function" != typeof o.componentWillUpdate || ("function" == typeof o.componentWillUpdate && o.componentWillUpdate(r, m, d), "function" == typeof o.UNSAFE_componentWillUpdate && o.UNSAFE_componentWillUpdate(r, m, d)), "function" == typeof o.componentDidUpdate && (t.flags |= Ur), "function" == typeof o.getSnapshotBeforeUpdate && (t.flags |= Yr)) : ("function" == typeof o.componentDidUpdate && (a === e.memoizedProps && p === e.memoizedState || (t.flags |= Ur)), "function" == typeof o.getSnapshotBeforeUpdate && (a === e.memoizedProps && p === e.memoizedState || (t.flags |= Yr)), t.memoizedProps = r, t.memoizedState = m), o.props = r, o.state = m, o.context = d, g;
        }(e, t, n, r, i);
        var h = iv(e, t, n, f, d, i),
          p = t.stateNode;
        return f && p.props !== r && (Vg || o("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", ft(t) || "a component"), Vg = !0), h;
      }
      function iv(e, t, n, r, i, o) {
        tv(e, t);
        var a = (t.flags & Vr) !== jr;
        if (!r && !a) return i && Ad(t, n, !1), xv(e, t, o);
        var s,
          u = t.stateNode;
        if (Yg.current = t, a && "function" != typeof n.getDerivedStateFromError) s = null, Eg();else {
          if (Wi(t), wt(!0), s = u.render(), t.mode & ao) {
            Ki(!0);
            try {
              u.render();
            } finally {
              Ki(!1);
            }
          }
          wt(!1), Yi();
        }
        return t.flags |= Fr, null !== e && a ? function (e, t, n, r) {
          t.child = Jh(t, e.child, null, r), t.child = Jh(t, null, n, r);
        }(e, t, s, o) : Qg(e, t, s, o), t.memoizedState = u.state, i && Ad(t, n, !0), t.child;
      }
      function ov(e) {
        var t = e.stateNode;
        t.pendingContext ? bd(e, t.pendingContext, t.pendingContext !== t.context) : t.context && bd(e, t.context, !1), sp(e, t.containerInfo);
      }
      function av(e, t, n, r, i) {
        return vf(), wf(i), t.flags |= $r, Qg(e, t, n, r), t.child;
      }
      function sv(e, t, n, r) {
        Cv(e, t);
        var i = t.pendingProps,
          o = n,
          a = o._payload,
          l = (0, o._init)(a);
        t.type = l;
        var d = t.tag = function (e) {
            if ("function" == typeof e) return sA(e) ? u : s;
            if (null != e) {
              var t = e.$$typeof;
              if (t === Oe) return b;
              if (t === De) return A;
            }
            return c;
          }(l),
          f = Lf(l, i);
        switch (d) {
          case s:
            return uv(t, l), t.type = l = Ww(l), nv(null, t, l, f, r);
          case u:
            return t.type = l = Yw(l), rv(null, t, l, f, r);
          case b:
            return t.type = l = Gw(l), Zg(null, t, l, f, r);
          case A:
            if (t.type !== t.elementType) {
              var h = l.propTypes;
              h && Xl(h, f, "prop", lt(l));
            }
            return Jg(null, t, l, Lf(l.type, f), r);
        }
        var p = "";
        throw null !== l && "object" == typeof l && l.$$typeof === Be && (p = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + l + ". Lazy element type must resolve to a class or function." + p);
      }
      function uv(e, t) {
        if (t && t.childContextTypes && o("%s(...): childContextTypes cannot be defined on a function component.", t.displayName || t.name || "Component"), null !== e.ref) {
          var n = "",
            r = gt();
          r && (n += "\n\nCheck the render method of `" + r + "`.");
          var i = r || "",
            a = e._debugSource;
          a && (i = a.fileName + ":" + a.lineNumber), Hg[i] || (Hg[i] = !0, o("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", n));
        }
        if ("function" == typeof t.getDerivedStateFromProps) {
          var s = lt(t) || "Unknown";
          Kg[s] || (o("%s: Function components do not support getDerivedStateFromProps.", s), Kg[s] = !0);
        }
        if ("object" == typeof t.contextType && null !== t.contextType) {
          var u = lt(t) || "Unknown";
          qg[u] || (o("%s: Function components do not support contextType.", u), qg[u] = !0);
        }
      }
      zg = {}, Ug = {}, qg = {}, Kg = {}, Hg = {}, Vg = !1, $g = {}, Wg = {};
      var cv = {
        dehydrated: null,
        treeContext: null,
        retryLane: po
      };
      function lv(e) {
        return {
          baseLanes: e,
          cachePool: null,
          transitions: null
        };
      }
      function dv(e, t, n) {
        var r = t.pendingProps;
        PA(t) && (t.flags |= Vr);
        var i = mp.current,
          a = !1,
          s = (t.flags & Vr) !== jr;
        if (s || function (e, t, n, r) {
          return (null === t || null !== t.memoizedState) && gp(e, pp);
        }(i, e) ? (a = !0, t.flags &= ~Vr) : null !== e && null === e.memoizedState || (i = i | hp), yp(t, i = vp(i)), null === e) {
          lf(t);
          var u = t.memoizedState;
          if (null !== u) {
            var c = u.dehydrated;
            if (null !== c) return function (e, t, n) {
              (e.mode & io) === ro ? (o("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), e.lanes = mo) : Rl(t) ? e.lanes = bo : e.lanes = Go;
              return null;
            }(t, c);
          }
          var l = r.children,
            d = r.fallback;
          if (a) {
            var f = function (e, t, n, r) {
              var i,
                o,
                a = e.mode,
                s = e.child,
                u = {
                  mode: "hidden",
                  children: t
                };
              (a & io) === ro && null !== s ? ((i = s).childLanes = ho, i.pendingProps = u, e.mode & oo && (i.actualDuration = 0, i.actualStartTime = -1, i.selfBaseDuration = 0, i.treeBaseDuration = 0), o = fA(n, a, r, null)) : (i = hv(u, a), o = fA(n, a, r, null));
              return i.return = e, o.return = e, i.sibling = o, e.child = i, o;
            }(t, l, d, n);
            return t.child.memoizedState = lv(n), t.memoizedState = cv, f;
          }
          return fv(t, l);
        }
        var h = e.memoizedState;
        if (null !== h) {
          var p = h.dehydrated;
          if (null !== p) return function (e, t, n, r, i, o, a) {
            if (n) {
              if (t.flags & $r) return t.flags &= ~$r, mv(e, t, a, Tg(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering.")));
              if (null !== t.memoizedState) return t.child = e.child, t.flags |= Vr, null;
              var s = function (e, t, n, r, i) {
                var o = t.mode,
                  a = {
                    mode: "visible",
                    children: n
                  },
                  s = hv(a, o),
                  u = fA(r, o, i, null);
                u.flags |= zr, s.return = t, u.return = t, s.sibling = u, t.child = s, (t.mode & io) !== ro && Jh(t, e.child, null, i);
                return u;
              }(e, t, r.children, r.fallback, a);
              return t.child.memoizedState = lv(a), t.memoizedState = cv, s;
            }
            if (Jd(), (t.mode & io) === ro) return mv(e, t, a, null);
            if (Rl(i)) {
              var u,
                c,
                l,
                d = function (e) {
                  var t,
                    n,
                    r,
                    i = e.nextSibling && e.nextSibling.dataset;
                  return i && (t = i.dgst, n = i.msg, r = i.stck), {
                    message: n,
                    digest: t,
                    stack: r
                  };
                }(i);
              return u = d.digest, c = d.message, l = d.stack, mv(e, t, a, Tg(c ? new Error(c) : new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), u, l));
            }
            var f = ha(a, e.childLanes);
            if (Gg || f) {
              var h = Yy();
              if (null !== h) {
                var p = function (e, t) {
                  var n;
                  switch (ca(t)) {
                    case vo:
                      n = go;
                      break;
                    case yo:
                      n = bo;
                      break;
                    case _o:
                    case Eo:
                    case So:
                    case ko:
                    case Mo:
                    case Co:
                    case xo:
                    case Ro:
                    case Io:
                    case To:
                    case Po:
                    case Oo:
                    case Lo:
                    case No:
                    case Do:
                    case Bo:
                    case Fo:
                    case zo:
                    case Uo:
                    case qo:
                    case Ko:
                      n = wo;
                      break;
                    case Yo:
                      n = Wo;
                      break;
                    default:
                      n = po;
                  }
                  return (n & (e.suspendedLanes | t)) !== po ? po : n;
                }(h, a);
                if (p !== po && p !== o.retryLane) {
                  o.retryLane = p;
                  var m = Zo;
                  Xf(e, p), Jy(h, e, p, m);
                }
              }
              return mw(), mv(e, t, a, Tg(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.")));
            }
            if (xl(i)) return t.flags |= Vr, t.child = e.child, function (e, t) {
              e._reactRetry = t;
            }(i, Rw.bind(null, e)), null;
            tf(t, i, o.treeContext);
            var g = fv(t, r.children);
            return g.flags |= Qr, g;
          }(e, t, s, r, p, h, n);
        }
        if (a) {
          var m = r.fallback,
            g = function (e, t, n, r, i) {
              var o,
                a,
                s = t.mode,
                u = e.child,
                c = u.sibling,
                l = {
                  mode: "hidden",
                  children: n
                };
              if ((s & io) === ro && t.child !== u) {
                (o = t.child).childLanes = ho, o.pendingProps = l, t.mode & oo && (o.actualDuration = 0, o.actualStartTime = -1, o.selfBaseDuration = u.selfBaseDuration, o.treeBaseDuration = u.treeBaseDuration), t.deletions = null;
              } else (o = pv(u, l)).subtreeFlags = u.subtreeFlags & pi;
              null !== c ? a = uA(c, r) : (a = fA(r, s, i, null)).flags |= zr;
              return a.return = t, o.return = t, o.sibling = a, t.child = o, a;
            }(e, t, r.children, m, n),
            v = t.child,
            b = e.child.memoizedState;
          return v.memoizedState = null === b ? lv(n) : function (e, t) {
            return {
              baseLanes: ma(e.baseLanes, t),
              cachePool: null,
              transitions: e.transitions
            };
          }(b, n), v.childLanes = function (e, t) {
            return ga(e.childLanes, t);
          }(e, n), t.memoizedState = cv, g;
        }
        var y = function (e, t, n, r) {
          var i = e.child,
            o = i.sibling,
            a = pv(i, {
              mode: "visible",
              children: n
            });
          (t.mode & io) === ro && (a.lanes = r);
          if (a.return = t, a.sibling = null, null !== o) {
            var s = t.deletions;
            null === s ? (t.deletions = [o], t.flags |= qr) : s.push(o);
          }
          return t.child = a, a;
        }(e, t, r.children, n);
        return t.memoizedState = null, y;
      }
      function fv(e, t, n) {
        var r = hv({
          mode: "visible",
          children: t
        }, e.mode);
        return r.return = e, e.child = r, r;
      }
      function hv(e, t, n) {
        return hA(e, t, ho, null);
      }
      function pv(e, t) {
        return uA(e, t);
      }
      function mv(e, t, n, r) {
        null !== r && wf(r), Jh(t, e.child, null, n);
        var i = fv(t, t.pendingProps.children);
        return i.flags |= zr, t.memoizedState = null, i;
      }
      function gv(e, t, n) {
        e.lanes = ma(e.lanes, t);
        var r = e.alternate;
        null !== r && (r.lanes = ma(r.lanes, t)), $f(e.return, t, n);
      }
      function vv(e, t) {
        var n = Yt(e),
          r = !n && "function" == typeof Ue(e);
        if (n || r) {
          var i = n ? "array" : "iterable";
          return o("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", i, t, i), !1;
        }
        return !0;
      }
      function bv(e, t, n, r, i) {
        var o = e.memoizedState;
        null === o ? e.memoizedState = {
          isBackwards: t,
          rendering: null,
          renderingStartTime: 0,
          last: r,
          tail: n,
          tailMode: i
        } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i);
      }
      function yv(e, t, n) {
        var r = t.pendingProps,
          i = r.revealOrder,
          a = r.tail,
          s = r.children;
        !function (e) {
          if (void 0 !== e && "forwards" !== e && "backwards" !== e && "together" !== e && !$g[e]) if ($g[e] = !0, "string" == typeof e) switch (e.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
              o('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', e, e.toLowerCase());
              break;
            case "forward":
            case "backward":
              o('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', e, e.toLowerCase());
              break;
            default:
              o('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
          } else o('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
        }(i), function (e, t) {
          void 0 === e || Wg[e] || ("collapsed" !== e && "hidden" !== e ? (Wg[e] = !0, o('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', e)) : "forwards" !== t && "backwards" !== t && (Wg[e] = !0, o('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', e)));
        }(a, i), function (e, t) {
          if (("forwards" === t || "backwards" === t) && null != e && !1 !== e) if (Yt(e)) {
            for (var n = 0; n < e.length; n++) if (!vv(e[n], n)) return;
          } else {
            var r = Ue(e);
            if ("function" == typeof r) {
              var i = r.call(e);
              if (i) for (var a = i.next(), s = 0; !a.done; a = i.next()) {
                if (!vv(a.value, s)) return;
                s++;
              }
            } else o('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', t);
          }
        }(s, i), Qg(e, t, s, n);
        var u = mp.current;
        gp(u, pp) ? (u = bp(u, pp), t.flags |= Vr) : (null !== e && (e.flags & Vr) !== jr && function (e, t, n) {
          for (var r = t; null !== r;) {
            if (r.tag === w) null !== r.memoizedState && gv(r, n, e);else if (r.tag === M) gv(r, n, e);else if (null !== r.child) {
              r.child.return = r, r = r.child;
              continue;
            }
            if (r === e) return;
            for (; null === r.sibling;) {
              if (null === r.return || r.return === e) return;
              r = r.return;
            }
            r.sibling.return = r.return, r = r.sibling;
          }
        }(t, t.child, n), u = vp(u));
        if (yp(t, u), (t.mode & io) === ro) t.memoizedState = null;else switch (i) {
          case "forwards":
            var c,
              l = function (e) {
                for (var t = e, n = null; null !== t;) {
                  var r = t.alternate;
                  null !== r && null === _p(r) && (n = t), t = t.sibling;
                }
                return n;
              }(t.child);
            null === l ? (c = t.child, t.child = null) : (c = l.sibling, l.sibling = null), bv(t, !1, c, l, a);
            break;
          case "backwards":
            var d = null,
              f = t.child;
            for (t.child = null; null !== f;) {
              var h = f.alternate;
              if (null !== h && null === _p(h)) {
                t.child = f;
                break;
              }
              var p = f.sibling;
              f.sibling = d, d = f, f = p;
            }
            bv(t, !0, d, null, a);
            break;
          case "together":
            bv(t, !1, null, null, void 0);
            break;
          default:
            t.memoizedState = null;
        }
        return t.child;
      }
      var wv = !1;
      var Av,
        _v,
        Ev,
        Sv,
        kv = !1;
      function Mv() {
        Gg = !0;
      }
      function Cv(e, t) {
        (t.mode & io) === ro && null !== e && (e.alternate = null, t.alternate = null, t.flags |= zr);
      }
      function xv(e, t, n) {
        return null !== e && (t.dependencies = e.dependencies), Eg(), pw(t.lanes), ha(n, t.childLanes) ? (function (e, t) {
          if (null !== e && t.child !== e.child) throw new Error("Resuming work not yet implemented.");
          if (null !== t.child) {
            var n = t.child,
              r = uA(n, n.pendingProps);
            for (t.child = r, r.return = t; null !== n.sibling;) n = n.sibling, (r = r.sibling = uA(n, n.pendingProps)).return = t;
            r.sibling = null;
          }
        }(e, t), t.child) : null;
      }
      function Rv(e, t) {
        return !!ha(e.lanes, t);
      }
      function Iv(e, t, n) {
        if (t._debugNeedsRemount && null !== e) return function (e, t, n) {
          var r = t.return;
          if (null === r) throw new Error("Cannot swap the root fiber.");
          if (e.alternate = null, t.alternate = null, n.index = t.index, n.sibling = t.sibling, n.return = t.return, n.ref = t.ref, t === r.child) r.child = n;else {
            var i = r.child;
            if (null === i) throw new Error("Expected parent to have a child.");
            for (; i.sibling !== t;) if (null === (i = i.sibling)) throw new Error("Expected to find the previous sibling.");
            i.sibling = n;
          }
          var o = r.deletions;
          return null === o ? (r.deletions = [e], r.flags |= qr) : o.push(e), n.flags |= zr, n;
        }(e, t, lA(t.type, t.key, t.pendingProps, t._debugOwner || null, t.mode, t.lanes));
        if (null !== e) {
          if (e.memoizedProps !== t.pendingProps || pd() || t.type !== e.type) Gg = !0;else {
            if (!Rv(e, n) && (t.flags & Vr) === jr) return Gg = !1, function (e, t, n) {
              switch (t.tag) {
                case l:
                  ov(t), t.stateNode, vf();
                  break;
                case f:
                  lp(t);
                  break;
                case u:
                  md(t.type) && wd(t);
                  break;
                case d:
                  sp(t, t.stateNode.containerInfo);
                  break;
                case v:
                  var r = t.memoizedProps.value;
                  Hf(t, t.type._context, r);
                  break;
                case y:
                  ha(n, t.childLanes) && (t.flags |= Ur);
                  var i = t.stateNode;
                  i.effectDuration = 0, i.passiveEffectDuration = 0;
                  break;
                case w:
                  var o = t.memoizedState;
                  if (null !== o) {
                    if (null !== o.dehydrated) return yp(t, vp(mp.current)), t.flags |= Vr, null;
                    if (ha(n, t.child.childLanes)) return dv(e, t, n);
                    yp(t, vp(mp.current));
                    var a = xv(e, t, n);
                    return null !== a ? a.sibling : null;
                  }
                  yp(t, vp(mp.current));
                  break;
                case M:
                  var s = (e.flags & Vr) !== jr,
                    c = ha(n, t.childLanes);
                  if (s) {
                    if (c) return yv(e, t, n);
                    t.flags |= Vr;
                  }
                  var h = t.memoizedState;
                  if (null !== h && (h.rendering = null, h.tail = null, h.lastEffect = null), yp(t, mp.current), c) break;
                  return null;
                case x:
                case R:
                  return t.lanes = ho, ev(e, t, n);
              }
              return xv(e, t, n);
            }(e, t, n);
            Gg = (e.flags & ri) !== jr;
          }
        } else if (Gg = !1, yf() && function (e) {
          return $d(), (e.flags & ii) !== jr;
        }(t)) {
          var r = t.index;
          qd(t, ($d(), Ld), r);
        }
        switch (t.lanes = ho, t.tag) {
          case c:
            return function (e, t, n, r) {
              Cv(e, t);
              var i,
                a,
                c,
                l = t.pendingProps;
              if (i = hd(t, dd(0, n, !1)), Yf(t, r), Wi(t), n.prototype && "function" == typeof n.prototype.render) {
                var d = lt(n) || "Unknown";
                zg[d] || (o("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", d, d), zg[d] = !0);
              }
              if (t.mode & ao && Ef.recordLegacyContextWarning(t, null), wt(!0), Yg.current = t, a = Xp(null, t, n, l, i, r), c = em(), wt(!1), Yi(), t.flags |= Fr, "object" == typeof a && null !== a && "function" == typeof a.render && void 0 === a.$$typeof) {
                var f = lt(n) || "Unknown";
                Ug[f] || (o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", f, f, f), Ug[f] = !0);
              }
              if ("object" == typeof a && null !== a && "function" == typeof a.render && void 0 === a.$$typeof) {
                var h = lt(n) || "Unknown";
                Ug[h] || (o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", h, h, h), Ug[h] = !0), t.tag = u, t.memoizedState = null, t.updateQueue = null;
                var p = !1;
                return md(n) ? (p = !0, wd(t)) : p = !1, t.memoizedState = null !== a.state && void 0 !== a.state ? a.state : null, ch(t), qh(t, a), Vh(t, n, l, r), iv(null, t, n, !0, p, r);
              }
              if (t.tag = s, t.mode & ao) {
                Ki(!0);
                try {
                  a = Xp(null, t, n, l, i, r), c = em();
                } finally {
                  Ki(!1);
                }
              }
              return yf() && c && Kd(t), Qg(null, t, a, r), uv(t, n), t.child;
            }(e, t, t.type, n);
          case E:
            return sv(e, t, t.elementType, n);
          case s:
            var i = t.type,
              a = t.pendingProps;
            return nv(e, t, i, t.elementType === i ? a : Lf(i, a), n);
          case u:
            var k = t.type,
              I = t.pendingProps;
            return rv(e, t, k, t.elementType === k ? I : Lf(k, I), n);
          case l:
            return function (e, t, n) {
              if (ov(t), null === e) throw new Error("Should have a current fiber. This is a bug in React.");
              var r = t.pendingProps,
                i = t.memoizedState,
                o = i.element;
              lh(e, t), gh(t, r, null, n);
              var a = t.memoizedState;
              t.stateNode;
              var s = a.element;
              if (i.isDehydrated) {
                var u = {
                  element: s,
                  isDehydrated: !1,
                  cache: a.cache,
                  pendingSuspenseBoundaries: a.pendingSuspenseBoundaries,
                  transitions: a.transitions
                };
                if (t.updateQueue.baseState = u, t.memoizedState = u, t.flags & $r) return av(e, t, s, n, Ig(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), t));
                if (s !== o) return av(e, t, s, n, Ig(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), t));
                ef(t);
                var c = Xh(t, null, s, n);
                t.child = c;
                for (var l = c; l;) l.flags = l.flags & ~zr | Qr, l = l.sibling;
              } else {
                if (vf(), s === o) return xv(e, t, n);
                Qg(e, t, s, n);
              }
              return t.child;
            }(e, t, n);
          case f:
            return function (e, t, n) {
              lp(t), null === e && lf(t);
              var r = t.type,
                i = t.pendingProps,
                o = null !== e ? e.memoizedProps : null,
                a = i.children;
              return ml(r, i) ? a = null : null !== o && ml(r, o) && (t.flags |= Kr), tv(e, t), Qg(e, t, a, n), t.child;
            }(e, t, n);
          case h:
            return function (e, t) {
              return null === e && lf(t), null;
            }(e, t);
          case w:
            return dv(e, t, n);
          case d:
            return function (e, t, n) {
              sp(t, t.stateNode.containerInfo);
              var r = t.pendingProps;
              return null === e ? t.child = Jh(t, null, r, n) : Qg(e, t, r, n), t.child;
            }(e, t, n);
          case b:
            var T = t.type,
              P = t.pendingProps;
            return Zg(e, t, T, t.elementType === T ? P : Lf(T, P), n);
          case p:
            return function (e, t, n) {
              return Qg(e, t, t.pendingProps, n), t.child;
            }(e, t, n);
          case m:
            return function (e, t, n) {
              return Qg(e, t, t.pendingProps.children, n), t.child;
            }(e, t, n);
          case y:
            return function (e, t, n) {
              t.flags |= Ur;
              var r = t.stateNode;
              return r.effectDuration = 0, r.passiveEffectDuration = 0, Qg(e, t, t.pendingProps.children, n), t.child;
            }(e, t, n);
          case v:
            return function (e, t, n) {
              var r = t.type._context,
                i = t.pendingProps,
                a = t.memoizedProps,
                s = i.value;
              "value" in i || wv || (wv = !0, o("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
              var u = t.type.propTypes;
              if (u && Xl(u, i, "prop", "Context.Provider"), Hf(t, r, s), null !== a) {
                var c = a.value;
                if (Mu(c, s)) {
                  if (a.children === i.children && !pd()) return xv(e, t, n);
                } else Wf(t, r, n);
              }
              return Qg(e, t, i.children, n), t.child;
            }(e, t, n);
          case g:
            return function (e, t, n) {
              var r = t.type;
              void 0 === r._context ? r !== r.Consumer && (kv || (kv = !0, o("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : r = r._context;
              var i = t.pendingProps.children;
              "function" != typeof i && o("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Yf(t, n);
              var a,
                s = Gf(r);
              return Wi(t), Yg.current = t, wt(!0), a = i(s), wt(!1), Yi(), t.flags |= Fr, Qg(e, t, a, n), t.child;
            }(e, t, n);
          case A:
            var O = t.type,
              L = Lf(O, t.pendingProps);
            if (t.type !== t.elementType) {
              var N = O.propTypes;
              N && Xl(N, L, "prop", lt(O));
            }
            return Jg(e, t, O, L = Lf(O.type, L), n);
          case _:
            return Xg(e, t, t.type, t.pendingProps, n);
          case S:
            var D = t.type,
              B = t.pendingProps;
            return function (e, t, n, r, i) {
              var o;
              return Cv(e, t), t.tag = u, md(n) ? (o = !0, wd(t)) : o = !1, Yf(t, i), Kh(t, n, r), Vh(t, n, r, i), iv(null, t, n, !0, o, i);
            }(e, t, D, t.elementType === D ? B : Lf(D, B), n);
          case M:
            return yv(e, t, n);
          case C:
            break;
          case x:
            return ev(e, t, n);
        }
        throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
      }
      function Tv(e) {
        e.flags |= Ur;
      }
      function Pv(e) {
        e.flags |= Wr, e.flags |= oi;
      }
      function Ov(e, t) {
        if (!yf()) switch (e.tailMode) {
          case "hidden":
            for (var n = e.tail, r = null; null !== n;) null !== n.alternate && (r = n), n = n.sibling;
            null === r ? e.tail = null : r.sibling = null;
            break;
          case "collapsed":
            for (var i = e.tail, o = null; null !== i;) null !== i.alternate && (o = i), i = i.sibling;
            null === o ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : o.sibling = null;
        }
      }
      function Lv(e) {
        var t = null !== e.alternate && e.alternate.child === e.child,
          n = ho,
          r = jr;
        if (t) {
          if ((e.mode & oo) !== ro) {
            for (var i = e.selfBaseDuration, o = e.child; null !== o;) n = ma(n, ma(o.lanes, o.childLanes)), r |= o.subtreeFlags & pi, r |= o.flags & pi, i += o.treeBaseDuration, o = o.sibling;
            e.treeBaseDuration = i;
          } else for (var a = e.child; null !== a;) n = ma(n, ma(a.lanes, a.childLanes)), r |= a.subtreeFlags & pi, r |= a.flags & pi, a.return = e, a = a.sibling;
          e.subtreeFlags |= r;
        } else {
          if ((e.mode & oo) !== ro) {
            for (var s = e.actualDuration, u = e.selfBaseDuration, c = e.child; null !== c;) n = ma(n, ma(c.lanes, c.childLanes)), r |= c.subtreeFlags, r |= c.flags, s += c.actualDuration, u += c.treeBaseDuration, c = c.sibling;
            e.actualDuration = s, e.treeBaseDuration = u;
          } else for (var l = e.child; null !== l;) n = ma(n, ma(l.lanes, l.childLanes)), r |= l.subtreeFlags, r |= l.flags, l.return = e, l = l.sibling;
          e.subtreeFlags |= r;
        }
        return e.childLanes = n, t;
      }
      function Nv(e, t, n) {
        if (Gd && null !== Yd && (t.mode & io) !== ro && (t.flags & Vr) === jr) return gf(t), vf(), t.flags |= $r | ti | ni, !1;
        var r = mf(t);
        if (null !== n && null !== n.dehydrated) {
          if (null === e) {
            if (!r) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
            if (ff(t), Lv(t), (t.mode & oo) !== ro) if (null !== n) {
              var i = t.child;
              null !== i && (t.treeBaseDuration -= i.treeBaseDuration);
            }
            return !1;
          }
          if (vf(), (t.flags & Vr) === jr && (t.memoizedState = null), t.flags |= Ur, Lv(t), (t.mode & oo) !== ro && null !== n) {
            var o = t.child;
            null !== o && (t.treeBaseDuration -= o.treeBaseDuration);
          }
          return !1;
        }
        return bf(), !0;
      }
      function Dv(e, t, n) {
        var r = t.pendingProps;
        switch (Vd(t), t.tag) {
          case c:
          case E:
          case _:
          case s:
          case b:
          case p:
          case m:
          case y:
          case g:
          case A:
            return Lv(t), null;
          case u:
            return md(t.type) && gd(t), Lv(t), null;
          case l:
            var i = t.stateNode;
            if (up(t), vd(t), Rp(), i.pendingContext && (i.context = i.pendingContext, i.pendingContext = null), null === e || null === e.child) if (mf(t)) Tv(t);else if (null !== e) e.memoizedState.isDehydrated && (t.flags & $r) === jr || (t.flags |= Yr, bf());
            return _v(e, t), Lv(t), null;
          case f:
            dp(t);
            var o = ap(),
              a = t.type;
            if (null !== e && null != t.stateNode) Ev(e, t, a, r, o), e.ref !== t.ref && Pv(t);else {
              if (!r) {
                if (null === t.stateNode) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                return Lv(t), null;
              }
              var k = cp();
              if (mf(t)) (function (e, t, n) {
                var r = e.stateNode,
                  i = !Qd,
                  o = Pl(r, e.type, e.memoizedProps, 0, n, e, i);
                return e.updateQueue = o, null !== o;
              })(t, 0, k) && Tv(t);else {
                var P = pl(a, r, o, k, t);
                Av(P, t, !1, !1), t.stateNode = P, function (e, t, n, r, i) {
                  switch (Hc(e, t, n), t) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      return !!n.autoFocus;
                    case "img":
                      return !0;
                    default:
                      return !1;
                  }
                }(P, a, r) && Tv(t);
              }
              null !== t.ref && Pv(t);
            }
            return Lv(t), null;
          case h:
            var O = r;
            if (e && null != t.stateNode) {
              var L = e.memoizedProps;
              Sv(e, t, L, O);
            } else {
              if ("string" != typeof O && null === t.stateNode) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              var B = ap(),
                j = cp();
              mf(t) ? df(t) && Tv(t) : t.stateNode = gl(O, B, j, t);
            }
            return Lv(t), null;
          case w:
            wp(t);
            var F = t.memoizedState;
            if (null === e || null !== e.memoizedState && null !== e.memoizedState.dehydrated) if (!Nv(e, t, F)) return t.flags & ni ? t : null;
            if ((t.flags & Vr) !== jr) return t.lanes = n, (t.mode & oo) !== ro && Rg(t), t;
            var z = null !== F;
            if (z !== (null !== e && null !== e.memoizedState)) if (z) if (t.child.flags |= Zr, (t.mode & io) !== ro) null === e && (!0 !== t.memoizedProps.unstable_avoidThisFallback || !D) || gp(mp.current, hp) ? my === ny && (my = oy) : mw();
            if (null !== t.updateQueue && (t.flags |= Ur), Lv(t), (t.mode & oo) !== ro && z) {
              var U = t.child;
              null !== U && (t.treeBaseDuration -= U.treeBaseDuration);
            }
            return null;
          case d:
            return up(t), _v(e, t), null === e && pc(t.stateNode.containerInfo), Lv(t), null;
          case v:
            return Vf(t.type._context, t), Lv(t), null;
          case S:
            return md(t.type) && gd(t), Lv(t), null;
          case M:
            wp(t);
            var q = t.memoizedState;
            if (null === q) return Lv(t), null;
            var K = (t.flags & Vr) !== jr,
              H = q.rendering;
            if (null === H) {
              if (K) Ov(q, !1);else {
                if (!(my === ny && (null === e || (e.flags & Vr) === jr))) for (var V = t.child; null !== V;) {
                  var $ = _p(V);
                  if (null !== $) {
                    K = !0, t.flags |= Vr, Ov(q, !1);
                    var W = $.updateQueue;
                    return null !== W && (t.updateQueue = W, t.flags |= Ur), t.subtreeFlags = jr, ep(t, n), yp(t, bp(mp.current, pp)), t.child;
                  }
                  V = V.sibling;
                }
                null !== q.tail && Ri() > xy() && (t.flags |= Vr, K = !0, Ov(q, !1), t.lanes = Ho);
              }
            } else {
              if (!K) {
                var Y = _p(H);
                if (null !== Y) {
                  t.flags |= Vr, K = !0;
                  var G = Y.updateQueue;
                  if (null !== G && (t.updateQueue = G, t.flags |= Ur), Ov(q, !0), null === q.tail && "hidden" === q.tailMode && !H.alternate && !yf()) return Lv(t), null;
                } else 2 * Ri() - q.renderingStartTime > xy() && n !== Go && (t.flags |= Vr, K = !0, Ov(q, !1), t.lanes = Ho);
              }
              if (q.isBackwards) H.sibling = t.child, t.child = H;else {
                var Q = q.last;
                null !== Q ? Q.sibling = H : t.child = H, q.last = H;
              }
            }
            if (null !== q.tail) {
              var Z = q.tail;
              q.rendering = Z, q.tail = Z.sibling, q.renderingStartTime = Ri(), Z.sibling = null;
              var J = mp.current;
              return yp(t, J = K ? bp(J, pp) : vp(J)), Z;
            }
            return Lv(t), null;
          case C:
            break;
          case x:
          case R:
            cw(t);
            var X = null !== t.memoizedState;
            if (null !== e) null !== e.memoizedState === X || N || (t.flags |= Zr);
            return X && (t.mode & io) !== ro ? ha(hy, Go) && (Lv(t), t.subtreeFlags & (zr | Ur) && (t.flags |= Zr)) : Lv(t), null;
          case I:
          case T:
            return null;
        }
        throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
      }
      function Bv(e, t, n) {
        switch (Vd(t), t.tag) {
          case u:
            md(t.type) && gd(t);
            var r = t.flags;
            return r & ni ? (t.flags = r & ~ni | Vr, (t.mode & oo) !== ro && Rg(t), t) : null;
          case l:
            t.stateNode, up(t), vd(t), Rp();
            var i = t.flags;
            return (i & ni) !== jr && (i & Vr) === jr ? (t.flags = i & ~ni | Vr, t) : null;
          case f:
            return dp(t), null;
          case w:
            wp(t);
            var o = t.memoizedState;
            if (null !== o && null !== o.dehydrated) {
              if (null === t.alternate) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
              vf();
            }
            var a = t.flags;
            return a & ni ? (t.flags = a & ~ni | Vr, (t.mode & oo) !== ro && Rg(t), t) : null;
          case M:
            return wp(t), null;
          case d:
            return up(t), null;
          case v:
            return Vf(t.type._context, t), null;
          case x:
          case R:
            return cw(t), null;
          default:
            return null;
        }
      }
      function jv(e, t, n) {
        switch (Vd(t), t.tag) {
          case u:
            var r = t.type.childContextTypes;
            null != r && gd(t);
            break;
          case l:
            t.stateNode, up(t), vd(t), Rp();
            break;
          case f:
            dp(t);
            break;
          case d:
            up(t);
            break;
          case w:
          case M:
            wp(t);
            break;
          case v:
            Vf(t.type._context, t);
            break;
          case x:
          case R:
            cw(t);
        }
      }
      Av = function (e, t, n, r) {
        for (var i, o, a = t.child; null !== a;) {
          if (a.tag === f || a.tag === h) i = e, o = a.stateNode, i.appendChild(o);else if (a.tag === d) ;else if (null !== a.child) {
            a.child.return = a, a = a.child;
            continue;
          }
          if (a === t) return;
          for (; null === a.sibling;) {
            if (null === a.return || a.return === t) return;
            a = a.return;
          }
          a.sibling.return = a.return, a = a.sibling;
        }
      }, _v = function (e, t) {}, Ev = function (e, t, n, r, i) {
        var o = e.memoizedProps;
        if (o !== r) {
          var a = function (e, t, n, r, i, o) {
            var a = o;
            if (typeof r.children != typeof n.children && ("string" == typeof r.children || "number" == typeof r.children)) {
              var s = "" + r.children,
                u = Jc(a.ancestorInfo, t);
              Zc(null, s, u);
            }
            return Vc(e, t, n, r);
          }(t.stateNode, n, o, r, 0, cp());
          t.updateQueue = a, a && Tv(t);
        }
      }, Sv = function (e, t, n, r) {
        n !== r && Tv(t);
      };
      var Fv = null;
      Fv = new Set();
      var zv = !1,
        Uv = !1,
        qv = "function" == typeof WeakSet ? WeakSet : Set,
        Kv = null,
        Hv = null,
        Vv = null;
      var $v = function (e, t) {
        if (t.props = e.memoizedProps, t.state = e.memoizedState, e.mode & oo) try {
          Cg(), t.componentWillUnmount();
        } finally {
          kg(e);
        } else t.componentWillUnmount();
      };
      function Wv(e, t) {
        try {
          rb(Mp, e);
        } catch (n) {
          Mw(e, t, n);
        }
      }
      function Yv(e, t, n) {
        try {
          $v(e, n);
        } catch (n) {
          Mw(e, t, n);
        }
      }
      function Gv(e, t) {
        try {
          sb(e);
        } catch (n) {
          Mw(e, t, n);
        }
      }
      function Qv(e, t) {
        var n = e.ref;
        if (null !== n) if ("function" == typeof n) {
          var r;
          try {
            if (U && q && e.mode & oo) try {
              Cg(), r = n(null);
            } finally {
              kg(e);
            } else r = n(null);
          } catch (n) {
            Mw(e, t, n);
          }
          "function" == typeof r && o("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", ft(e));
        } else n.current = null;
      }
      function Zv(e, t, n) {
        try {
          n();
        } catch (n) {
          Mw(e, t, n);
        }
      }
      var Jv = !1;
      function Xv(e, t) {
        hl(e.containerInfo), Kv = t, function () {
          for (; null !== Kv;) {
            var e = Kv,
              t = e.child;
            (e.subtreeFlags & li) !== jr && null !== t ? (t.return = e, Kv = t) : eb();
          }
        }();
        var n = Jv;
        return Jv = !1, n;
      }
      function eb() {
        for (; null !== Kv;) {
          var e = Kv;
          yt(e);
          try {
            tb(e);
          } catch (t) {
            Mw(e, e.return, t);
          }
          bt();
          var t = e.sibling;
          if (null !== t) return t.return = e.return, void (Kv = t);
          Kv = e.return;
        }
      }
      function tb(e) {
        var t,
          n = e.alternate;
        if ((e.flags & Yr) !== jr) {
          switch (yt(e), e.tag) {
            case s:
            case b:
            case _:
              break;
            case u:
              if (null !== n) {
                var r = n.memoizedProps,
                  i = n.memoizedState,
                  a = e.stateNode;
                e.type !== e.elementType || Vg || (a.props !== e.memoizedProps && o("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ft(e) || "instance"), a.state !== e.memoizedState && o("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ft(e) || "instance"));
                var c = a.getSnapshotBeforeUpdate(e.elementType === e.type ? r : Lf(e.type, r), i),
                  p = Fv;
                void 0 !== c || p.has(e.type) || (p.add(e.type), o("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", ft(e))), a.__reactInternalSnapshotBeforeUpdate = c;
              }
              break;
            case l:
              var m = e.stateNode;
              (t = m.containerInfo).nodeType === hn ? t.textContent = "" : t.nodeType === gn && t.documentElement && t.removeChild(t.documentElement);
              break;
            case f:
            case h:
            case d:
            case S:
              break;
            default:
              throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
          bt();
        }
      }
      function nb(e, t, n) {
        var r,
          i = t.updateQueue,
          o = null !== i ? i.lastEffect : null;
        if (null !== o) {
          var a = o.next,
            s = a;
          do {
            if ((s.tag & e) === e) {
              var u = s.destroy;
              s.destroy = void 0, void 0 !== u && ((e & Cp) !== Ep ? (r = t, null !== zi && "function" == typeof zi.markComponentPassiveEffectUnmountStarted && zi.markComponentPassiveEffectUnmountStarted(r)) : (e & Mp) !== Ep && Qi(t), (e & kp) !== Ep && Kw(!0), Zv(t, n, u), (e & kp) !== Ep && Kw(!1), (e & Cp) !== Ep ? null !== zi && "function" == typeof zi.markComponentPassiveEffectUnmountStopped && zi.markComponentPassiveEffectUnmountStopped() : (e & Mp) !== Ep && Zi());
            }
            s = s.next;
          } while (s !== a);
        }
      }
      function rb(e, t) {
        var n,
          r = t.updateQueue,
          i = null !== r ? r.lastEffect : null;
        if (null !== i) {
          var a = i.next,
            s = a;
          do {
            if ((s.tag & e) === e) {
              (e & Cp) !== Ep ? (n = t, null !== zi && "function" == typeof zi.markComponentPassiveEffectMountStarted && zi.markComponentPassiveEffectMountStarted(n)) : (e & Mp) !== Ep && Gi(t);
              var u = s.create;
              (e & kp) !== Ep && Kw(!0), s.destroy = u(), (e & kp) !== Ep && Kw(!1), (e & Cp) !== Ep ? null !== zi && "function" == typeof zi.markComponentPassiveEffectMountStopped && zi.markComponentPassiveEffectMountStopped() : (e & Mp) !== Ep && null !== zi && "function" == typeof zi.markComponentLayoutEffectMountStopped && zi.markComponentLayoutEffectMountStopped();
              var c = s.destroy;
              if (void 0 !== c && "function" != typeof c) {
                var l = void 0;
                o("%s must not return anything besides a function, which is used for clean-up.%s", l = (s.tag & Mp) !== jr ? "useLayoutEffect" : (s.tag & kp) !== jr ? "useInsertionEffect" : "useEffect", null === c ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : "function" == typeof c.then ? "\n\nIt looks like you wrote " + l + "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" + l + "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching" : " You returned: " + c);
              }
            }
            s = s.next;
          } while (s !== a);
        }
      }
      function ib(e, t) {
        if ((t.flags & Ur) !== jr && t.tag === y) {
          var n = t.stateNode.passiveEffectDuration,
            r = t.memoizedProps,
            i = r.id,
            o = r.onPostCommit,
            a = wg(),
            s = null === t.alternate ? "mount" : "update";
          yg() && (s = "nested-update"), "function" == typeof o && o(i, s, n, a);
          var u = t.return;
          e: for (; null !== u;) {
            switch (u.tag) {
              case l:
                u.stateNode.passiveEffectDuration += n;
                break e;
              case y:
                u.stateNode.passiveEffectDuration += n;
                break e;
            }
            u = u.return;
          }
        }
      }
      function ob(e, t, n, r) {
        if ((n.flags & fi) !== jr) switch (n.tag) {
          case s:
          case b:
          case _:
            if (!Uv) if (n.mode & oo) try {
              Cg(), rb(Mp | Sp, n);
            } finally {
              kg(n);
            } else rb(Mp | Sp, n);
            break;
          case u:
            var i = n.stateNode;
            if (n.flags & Ur && !Uv) if (null === t) {
              if (n.type !== n.elementType || Vg || (i.props !== n.memoizedProps && o("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ft(n) || "instance"), i.state !== n.memoizedState && o("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ft(n) || "instance")), n.mode & oo) try {
                Cg(), i.componentDidMount();
              } finally {
                kg(n);
              } else i.componentDidMount();
            } else {
              var a = n.elementType === n.type ? t.memoizedProps : Lf(n.type, t.memoizedProps),
                c = t.memoizedState;
              if (n.type !== n.elementType || Vg || (i.props !== n.memoizedProps && o("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ft(n) || "instance"), i.state !== n.memoizedState && o("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ft(n) || "instance")), n.mode & oo) try {
                Cg(), i.componentDidUpdate(a, c, i.__reactInternalSnapshotBeforeUpdate);
              } finally {
                kg(n);
              } else i.componentDidUpdate(a, c, i.__reactInternalSnapshotBeforeUpdate);
            }
            var p = n.updateQueue;
            null !== p && (n.type !== n.elementType || Vg || (i.props !== n.memoizedProps && o("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ft(n) || "instance"), i.state !== n.memoizedState && o("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ft(n) || "instance")), wh(0, p, i));
            break;
          case l:
            var m = n.updateQueue;
            if (null !== m) {
              var g = null;
              if (null !== n.child) switch (n.child.tag) {
                case f:
                case u:
                  g = n.child.stateNode;
              }
              wh(0, m, g);
            }
            break;
          case f:
            var v = n.stateNode;
            if (null === t && n.flags & Ur) !function (e, t, n, r) {
              switch (t) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  return void (n.autoFocus && e.focus());
                case "img":
                  n.src && (e.src = n.src);
              }
            }(v, n.type, n.memoizedProps);
            break;
          case h:
          case d:
            break;
          case y:
            var A = n.memoizedProps,
              E = A.onCommit,
              k = A.onRender,
              I = n.stateNode.effectDuration,
              P = wg(),
              O = null === t ? "mount" : "update";
            yg() && (O = "nested-update"), "function" == typeof k && k(n.memoizedProps.id, O, n.actualDuration, n.treeBaseDuration, n.actualStartTime, P), "function" == typeof E && E(n.memoizedProps.id, O, I, P), N = n, Ny.push(N), Py || (Py = !0, zw(Oi, function () {
              return _w(), null;
            }));
            var L = n.return;
            e: for (; null !== L;) {
              switch (L.tag) {
                case l:
                  L.stateNode.effectDuration += I;
                  break e;
                case y:
                  L.stateNode.effectDuration += I;
                  break e;
              }
              L = L.return;
            }
            break;
          case w:
            !function (e, t) {
              var n = t.memoizedState;
              if (null === n) {
                var r = t.alternate;
                if (null !== r) {
                  var i = r.memoizedState;
                  if (null !== i) {
                    var o = i.dehydrated;
                    null !== o && function (e) {
                      ns(e);
                    }(o);
                  }
                }
              }
            }(0, n);
            break;
          case M:
          case S:
          case C:
          case x:
          case R:
          case T:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        var N;
        Uv || n.flags & Wr && sb(n);
      }
      function ab(e) {
        switch (e.tag) {
          case s:
          case b:
          case _:
            if (e.mode & oo) try {
              Cg(), Wv(e, e.return);
            } finally {
              kg(e);
            } else Wv(e, e.return);
            break;
          case u:
            var t = e.stateNode;
            "function" == typeof t.componentDidMount && function (e, t, n) {
              try {
                n.componentDidMount();
              } catch (n) {
                Mw(e, t, n);
              }
            }(e, e.return, t), Gv(e, e.return);
            break;
          case f:
            Gv(e, e.return);
        }
      }
      function sb(e) {
        var t = e.ref;
        if (null !== t) {
          var n,
            r = e.stateNode;
          if (e.tag, n = r, "function" == typeof t) {
            var i;
            if (e.mode & oo) try {
              Cg(), i = t(n);
            } finally {
              kg(e);
            } else i = t(n);
            "function" == typeof i && o("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", ft(e));
          } else t.hasOwnProperty("current") || o("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", ft(e)), t.current = n;
        }
      }
      function ub(e) {
        var t = e.alternate;
        if (null !== t && (e.alternate = null, ub(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === f) {
          var n = e.stateNode;
          null !== n && function (e) {
            delete e[Nl], delete e[Dl], delete e[jl], delete e[Fl], delete e[zl];
          }(n);
        }
        e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
      }
      function cb(e) {
        return e.tag === f || e.tag === l || e.tag === d;
      }
      function lb(e) {
        var t = e;
        e: for (;;) {
          for (; null === t.sibling;) {
            if (null === t.return || cb(t.return)) return null;
            t = t.return;
          }
          for (t.sibling.return = t.return, t = t.sibling; t.tag !== f && t.tag !== h && t.tag !== k;) {
            if (t.flags & zr) continue e;
            if (null === t.child || t.tag === d) continue e;
            t.child.return = t, t = t.child;
          }
          if (!(t.flags & zr)) return t.stateNode;
        }
      }
      function db(e) {
        var t = function (e) {
          for (var t = e.return; null !== t;) {
            if (cb(t)) return t;
            t = t.return;
          }
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        }(e);
        switch (t.tag) {
          case f:
            var n = t.stateNode;
            t.flags & Kr && (El(n), t.flags &= ~Kr), hb(e, lb(e), n);
            break;
          case l:
          case d:
            var r = t.stateNode.containerInfo;
            fb(e, lb(e), r);
            break;
          default:
            throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
      }
      function fb(e, t, n) {
        var r = e.tag;
        if (r === f || r === h) {
          var i = e.stateNode;
          t ? function (e, t, n) {
            e.nodeType === mn ? e.parentNode.insertBefore(t, n) : e.insertBefore(t, n);
          }(n, i, t) : function (e, t) {
            var n;
            e.nodeType === mn ? (n = e.parentNode).insertBefore(t, e) : (n = e).appendChild(t), null == e._reactRootContainer && null === n.onclick && Kc(n);
          }(n, i);
        } else if (r === d) ;else {
          var o = e.child;
          if (null !== o) {
            fb(o, t, n);
            for (var a = o.sibling; null !== a;) fb(a, t, n), a = a.sibling;
          }
        }
      }
      function hb(e, t, n) {
        var r = e.tag;
        if (r === f || r === h) {
          var i = e.stateNode;
          t ? function (e, t, n) {
            e.insertBefore(t, n);
          }(n, i, t) : function (e, t) {
            e.appendChild(t);
          }(n, i);
        } else if (r === d) ;else {
          var o = e.child;
          if (null !== o) {
            hb(o, t, n);
            for (var a = o.sibling; null !== a;) hb(a, t, n), a = a.sibling;
          }
        }
      }
      var pb = null,
        mb = !1;
      function gb(e, t, n) {
        var r,
          i,
          o = t;
        e: for (; null !== o;) {
          switch (o.tag) {
            case f:
              pb = o.stateNode, mb = !1;
              break e;
            case l:
            case d:
              pb = o.stateNode.containerInfo, mb = !0;
              break e;
          }
          o = o.return;
        }
        if (null === pb) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        bb(e, t, n), pb = null, mb = !1, null !== (i = (r = n).alternate) && (i.return = null), r.return = null;
      }
      function vb(e, t, n) {
        for (var r = n.child; null !== r;) bb(e, t, r), r = r.sibling;
      }
      function bb(e, t, n) {
        switch (function (e) {
          if (Fi && "function" == typeof Fi.onCommitFiberUnmount) try {
            Fi.onCommitFiberUnmount(ji, e);
          } catch (e) {
            Ui || (Ui = !0, o("React instrumentation encountered an error: %s", e));
          }
        }(n), n.tag) {
          case f:
            Uv || Qv(n, t);
          case h:
            var r = pb,
              i = mb;
            return pb = null, vb(e, t, n), mb = i, void (null !== (pb = r) && (mb ? (M = pb, R = n.stateNode, M.nodeType === mn ? M.parentNode.removeChild(R) : M.removeChild(R)) : function (e, t) {
              e.removeChild(t);
            }(pb, n.stateNode)));
          case k:
            return void (null !== pb && (mb ? function (e, t) {
              e.nodeType === mn ? Sl(e.parentNode, t) : e.nodeType === hn && Sl(e, t), ns(e);
            }(pb, n.stateNode) : Sl(pb, n.stateNode)));
          case d:
            var a = pb,
              c = mb;
            return pb = n.stateNode.containerInfo, mb = !0, vb(e, t, n), pb = a, void (mb = c);
          case s:
          case b:
          case A:
          case _:
            if (!Uv) {
              var l = n.updateQueue;
              if (null !== l) {
                var p = l.lastEffect;
                if (null !== p) {
                  var m = p.next,
                    g = m;
                  do {
                    var v = g,
                      y = v.destroy,
                      w = v.tag;
                    void 0 !== y && ((w & kp) !== Ep ? Zv(n, t, y) : (w & Mp) !== Ep && (Qi(n), n.mode & oo ? (Cg(), Zv(n, t, y), kg(n)) : Zv(n, t, y), Zi())), g = g.next;
                  } while (g !== m);
                }
              }
            }
            return void vb(e, t, n);
          case u:
            if (!Uv) {
              Qv(n, t);
              var E = n.stateNode;
              "function" == typeof E.componentWillUnmount && Yv(n, t, E);
            }
            return void vb(e, t, n);
          case C:
            return void vb(e, t, n);
          case x:
            if (n.mode & io) {
              var S = Uv;
              Uv = S || null !== n.memoizedState, vb(e, t, n), Uv = S;
            } else vb(e, t, n);
            break;
          default:
            return void vb(e, t, n);
        }
        var M, R;
      }
      function yb(e) {
        var t = e.updateQueue;
        if (null !== t) {
          e.updateQueue = null;
          var n = e.stateNode;
          null === n && (n = e.stateNode = new qv()), t.forEach(function (t) {
            var r = Iw.bind(null, e, t);
            if (!n.has(t)) {
              if (n.add(t), qi) {
                if (null === Hv || null === Vv) throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                jw(Vv, Hv);
              }
              t.then(r, r);
            }
          });
        }
      }
      function wb(e, t, n) {
        var r = t.deletions;
        if (null !== r) for (var i = 0; i < r.length; i++) {
          var o = r[i];
          try {
            gb(e, t, o);
          } catch (e) {
            Mw(o, t, e);
          }
        }
        var a = pt;
        if (t.subtreeFlags & di) for (var s = t.child; null !== s;) yt(s), Ab(s, e), s = s.sibling;
        yt(a);
      }
      function Ab(e, t, n) {
        var r = e.alternate,
          i = e.flags;
        switch (e.tag) {
          case s:
          case b:
          case A:
          case _:
            if (wb(t, e), _b(e), i & Ur) {
              try {
                nb(kp | Sp, e, e.return), rb(kp | Sp, e);
              } catch (t) {
                Mw(e, e.return, t);
              }
              if (e.mode & oo) {
                try {
                  Cg(), nb(Mp | Sp, e, e.return);
                } catch (t) {
                  Mw(e, e.return, t);
                }
                kg(e);
              } else try {
                nb(Mp | Sp, e, e.return);
              } catch (t) {
                Mw(e, e.return, t);
              }
            }
            return;
          case u:
            return wb(t, e), _b(e), void (i & Wr && null !== r && Qv(r, r.return));
          case f:
            if (wb(t, e), _b(e), i & Wr && null !== r && Qv(r, r.return), e.flags & Kr) {
              var o = e.stateNode;
              try {
                El(o);
              } catch (t) {
                Mw(e, e.return, t);
              }
            }
            if (i & Ur) {
              var a = e.stateNode;
              if (null != a) {
                var c = e.memoizedProps,
                  p = null !== r ? r.memoizedProps : c,
                  m = e.type,
                  g = e.updateQueue;
                if (e.updateQueue = null, null !== g) try {
                  !function (e, t, n, r, i, o) {
                    $c(e, t, n, r, i), Gl(e, i);
                  }(a, g, m, p, c);
                } catch (t) {
                  Mw(e, e.return, t);
                }
              }
            }
            return;
          case h:
            if (wb(t, e), _b(e), i & Ur) {
              if (null === e.stateNode) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
              var v = e.stateNode,
                y = e.memoizedProps;
              null !== r && r.memoizedProps;
              try {
                !function (e, t, n) {
                  e.nodeValue = n;
                }(v, 0, y);
              } catch (t) {
                Mw(e, e.return, t);
              }
            }
            return;
          case l:
            if (wb(t, e), _b(e), i & Ur) if (null !== r) if (r.memoizedState.isDehydrated) try {
              ns(t.containerInfo);
            } catch (t) {
              Mw(e, e.return, t);
            }
            return;
          case d:
            return wb(t, e), void _b(e);
          case w:
            wb(t, e), _b(e);
            var E = e.child;
            if (E.flags & Zr) {
              var S = E.stateNode,
                k = null !== E.memoizedState;
              if (S.isHidden = k, k) null !== E.alternate && null !== E.alternate.memoizedState || (_y = Ri());
            }
            if (i & Ur) {
              try {
                !function (e) {
                  e.memoizedState;
                }(e);
              } catch (t) {
                Mw(e, e.return, t);
              }
              yb(e);
            }
            return;
          case x:
            var I = null !== r && null !== r.memoizedState;
            if (e.mode & io) {
              var T = Uv;
              Uv = T || I, wb(t, e), Uv = T;
            } else wb(t, e);
            if (_b(e), i & Zr) {
              var P = e.stateNode,
                O = null !== e.memoizedState,
                L = e;
              if (P.isHidden = O, O && !I && (L.mode & io) !== ro) {
                Kv = L;
                for (var N = L.child; null !== N;) Kv = N, Mb(N), N = N.sibling;
              }
              !function (e, t) {
                for (var n = null, r = e;;) {
                  if (r.tag === f) {
                    if (null === n) {
                      n = r;
                      try {
                        var i = r.stateNode;
                        t ? kl(i) : Ml(r.stateNode, r.memoizedProps);
                      } catch (t) {
                        Mw(e, e.return, t);
                      }
                    }
                  } else if (r.tag === h) {
                    if (null === n) try {
                      var o = r.stateNode;
                      t ? o.nodeValue = "" : Cl(o, r.memoizedProps);
                    } catch (t) {
                      Mw(e, e.return, t);
                    }
                  } else if ((r.tag !== x && r.tag !== R || null === r.memoizedState || r === e) && null !== r.child) {
                    r.child.return = r, r = r.child;
                    continue;
                  }
                  if (r === e) return;
                  for (; null === r.sibling;) {
                    if (null === r.return || r.return === e) return;
                    n === r && (n = null), r = r.return;
                  }
                  n === r && (n = null), r.sibling.return = r.return, r = r.sibling;
                }
              }(L, O);
            }
            return;
          case M:
            return wb(t, e), _b(e), void (i & Ur && yb(e));
          case C:
            return;
          default:
            return wb(t, e), void _b(e);
        }
      }
      function _b(e) {
        var t = e.flags;
        if (t & zr) {
          try {
            db(e);
          } catch (t) {
            Mw(e, e.return, t);
          }
          e.flags &= ~zr;
        }
        t & Qr && (e.flags &= ~Qr);
      }
      function Eb(e, t, n) {
        Hv = n, Vv = t, Kv = e, Sb(e, t, n), Hv = null, Vv = null;
      }
      function Sb(e, t, n) {
        for (var r = (e.mode & io) !== ro; null !== Kv;) {
          var i = Kv,
            o = i.child;
          if (i.tag === x && r) {
            var a = null !== i.memoizedState || zv;
            if (a) {
              kb(e, t, n);
              continue;
            }
            var s = i.alternate,
              u = null !== s && null !== s.memoizedState,
              c = zv,
              l = Uv;
            zv = a, (Uv = u || Uv) && !l && (Kv = i, xb(i));
            for (var d = o; null !== d;) Kv = d, Sb(d, t, n), d = d.sibling;
            Kv = i, zv = c, Uv = l, kb(e, t, n);
          } else (i.subtreeFlags & fi) !== jr && null !== o ? (o.return = i, Kv = o) : kb(e, t, n);
        }
      }
      function kb(e, t, n) {
        for (; null !== Kv;) {
          var r = Kv;
          if ((r.flags & fi) !== jr) {
            var i = r.alternate;
            yt(r);
            try {
              ob(0, i, r);
            } catch (e) {
              Mw(r, r.return, e);
            }
            bt();
          }
          if (r === e) return void (Kv = null);
          var o = r.sibling;
          if (null !== o) return o.return = r.return, void (Kv = o);
          Kv = r.return;
        }
      }
      function Mb(e) {
        for (; null !== Kv;) {
          var t = Kv,
            n = t.child;
          switch (t.tag) {
            case s:
            case b:
            case A:
            case _:
              if (t.mode & oo) try {
                Cg(), nb(Mp, t, t.return);
              } finally {
                kg(t);
              } else nb(Mp, t, t.return);
              break;
            case u:
              Qv(t, t.return);
              var r = t.stateNode;
              "function" == typeof r.componentWillUnmount && Yv(t, t.return, r);
              break;
            case f:
              Qv(t, t.return);
              break;
            case x:
              if (null !== t.memoizedState) {
                Cb(e);
                continue;
              }
          }
          null !== n ? (n.return = t, Kv = n) : Cb(e);
        }
      }
      function Cb(e) {
        for (; null !== Kv;) {
          var t = Kv;
          if (t === e) return void (Kv = null);
          var n = t.sibling;
          if (null !== n) return n.return = t.return, void (Kv = n);
          Kv = t.return;
        }
      }
      function xb(e) {
        for (; null !== Kv;) {
          var t = Kv,
            n = t.child;
          if (t.tag === x) if (null !== t.memoizedState) {
            Rb(e);
            continue;
          }
          null !== n ? (n.return = t, Kv = n) : Rb(e);
        }
      }
      function Rb(e) {
        for (; null !== Kv;) {
          var t = Kv;
          yt(t);
          try {
            ab(t);
          } catch (e) {
            Mw(t, t.return, e);
          }
          if (bt(), t === e) return void (Kv = null);
          var n = t.sibling;
          if (null !== n) return n.return = t.return, void (Kv = n);
          Kv = t.return;
        }
      }
      function Ib(e, t, n, r) {
        Kv = t, function (e, t, n, r) {
          for (; null !== Kv;) {
            var i = Kv,
              o = i.child;
            (i.subtreeFlags & hi) !== jr && null !== o ? (o.return = i, Kv = o) : Tb(e, t, n, r);
          }
        }(t, e, n, r);
      }
      function Tb(e, t, n, r) {
        for (; null !== Kv;) {
          var i = Kv;
          if ((i.flags & Gr) !== jr) {
            yt(i);
            try {
              Pb(t, i, n, r);
            } catch (e) {
              Mw(i, i.return, e);
            }
            bt();
          }
          if (i === e) return void (Kv = null);
          var o = i.sibling;
          if (null !== o) return o.return = i.return, void (Kv = o);
          Kv = i.return;
        }
      }
      function Pb(e, t, n, r) {
        switch (t.tag) {
          case s:
          case b:
          case _:
            if (t.mode & oo) {
              xg();
              try {
                rb(Cp | Sp, t);
              } finally {
                Mg(t);
              }
            } else rb(Cp | Sp, t);
        }
      }
      function Ob(e) {
        Kv = e, function () {
          for (; null !== Kv;) {
            var e = Kv,
              t = e.child;
            if ((Kv.flags & qr) !== jr) {
              var n = e.deletions;
              if (null !== n) {
                for (var r = 0; r < n.length; r++) {
                  var i = n[r];
                  Kv = i, Db(i, e);
                }
                var o = e.alternate;
                if (null !== o) {
                  var a = o.child;
                  if (null !== a) {
                    o.child = null;
                    do {
                      var s = a.sibling;
                      a.sibling = null, a = s;
                    } while (null !== a);
                  }
                }
                Kv = e;
              }
            }
            (e.subtreeFlags & hi) !== jr && null !== t ? (t.return = e, Kv = t) : Lb();
          }
        }();
      }
      function Lb() {
        for (; null !== Kv;) {
          var e = Kv;
          (e.flags & Gr) !== jr && (yt(e), Nb(e), bt());
          var t = e.sibling;
          if (null !== t) return t.return = e.return, void (Kv = t);
          Kv = e.return;
        }
      }
      function Nb(e) {
        switch (e.tag) {
          case s:
          case b:
          case _:
            e.mode & oo ? (xg(), nb(Cp | Sp, e, e.return), Mg(e)) : nb(Cp | Sp, e, e.return);
        }
      }
      function Db(e, t) {
        for (; null !== Kv;) {
          var n = Kv;
          yt(n), jb(n, t), bt();
          var r = n.child;
          null !== r ? (r.return = n, Kv = r) : Bb(e);
        }
      }
      function Bb(e) {
        for (; null !== Kv;) {
          var t = Kv,
            n = t.sibling,
            r = t.return;
          if (ub(t), t === e) return void (Kv = null);
          if (null !== n) return n.return = r, void (Kv = n);
          Kv = r;
        }
      }
      function jb(e, t) {
        switch (e.tag) {
          case s:
          case b:
          case _:
            e.mode & oo ? (xg(), nb(Cp, e, t), Mg(e)) : nb(Cp, e, t);
        }
      }
      function Fb(e) {
        switch (e.tag) {
          case s:
          case b:
          case _:
            try {
              rb(Mp | Sp, e);
            } catch (t) {
              Mw(e, e.return, t);
            }
            break;
          case u:
            var t = e.stateNode;
            try {
              t.componentDidMount();
            } catch (t) {
              Mw(e, e.return, t);
            }
        }
      }
      function zb(e) {
        switch (e.tag) {
          case s:
          case b:
          case _:
            try {
              rb(Cp | Sp, e);
            } catch (t) {
              Mw(e, e.return, t);
            }
        }
      }
      function Ub(e) {
        switch (e.tag) {
          case s:
          case b:
          case _:
            try {
              nb(Mp | Sp, e, e.return);
            } catch (t) {
              Mw(e, e.return, t);
            }
            break;
          case u:
            var t = e.stateNode;
            "function" == typeof t.componentWillUnmount && Yv(e, e.return, t);
        }
      }
      function qb(e) {
        switch (e.tag) {
          case s:
          case b:
          case _:
            try {
              nb(Cp | Sp, e, e.return);
            } catch (t) {
              Mw(e, e.return, t);
            }
        }
      }
      if ("function" == typeof Symbol && Symbol.for) {
        var Kb = Symbol.for;
        Kb("selector.component"), Kb("selector.has_pseudo_class"), Kb("selector.role"), Kb("selector.test_id"), Kb("selector.text");
      }
      var Hb = [];
      var Vb = n.ReactCurrentActQueue;
      function $b() {
        var e = "undefined" != typeof IS_REACT_ACT_ENVIRONMENT ? IS_REACT_ACT_ENVIRONMENT : void 0;
        return e || null === Vb.current || o("The current testing environment is not configured to support act(...)"), e;
      }
      var Wb = Math.ceil,
        Yb = n.ReactCurrentDispatcher,
        Gb = n.ReactCurrentOwner,
        Qb = n.ReactCurrentBatchConfig,
        Zb = n.ReactCurrentActQueue,
        Jb = 0,
        Xb = 1,
        ey = 2,
        ty = 4,
        ny = 0,
        ry = 1,
        iy = 2,
        oy = 3,
        ay = 4,
        sy = 5,
        uy = 6,
        cy = Jb,
        ly = null,
        dy = null,
        fy = ho,
        hy = ho,
        py = id(ho),
        my = ny,
        gy = null,
        vy = ho,
        by = ho,
        yy = ho,
        wy = null,
        Ay = null,
        _y = 0,
        Ey = 500,
        Sy = 1 / 0,
        ky = 500,
        My = null;
      function Cy() {
        Sy = Ri() + ky;
      }
      function xy() {
        return Sy;
      }
      var Ry = !1,
        Iy = null,
        Ty = null,
        Py = !1,
        Oy = null,
        Ly = ho,
        Ny = [],
        Dy = null,
        By = 50,
        jy = 0,
        Fy = null,
        zy = !1,
        Uy = !1,
        qy = 50,
        Ky = 0,
        Hy = null,
        Vy = Zo,
        $y = ho,
        Wy = !1;
      function Yy() {
        return ly;
      }
      function Gy() {
        return (cy & (ey | ty)) !== Jb ? Ri() : Vy !== Zo ? Vy : Vy = Ri();
      }
      function Qy(e) {
        if ((e.mode & io) === ro) return mo;
        if ((cy & ey) !== Jb && fy !== ho) return la(fy);
        if (Af.transition !== _f) {
          if (null !== Qb.transition) {
            var t = Qb.transition;
            t._updatedFibers || (t._updatedFibers = new Set()), t._updatedFibers.add(e);
          }
          return $y === po && ($y = ua()), $y;
        }
        var n,
          r = La();
        return r !== po ? r : void 0 === (n = window.event) ? Ta : ds(n.type);
      }
      function Zy(e) {
        var t;
        return (e.mode & io) === ro ? mo : (t = Xo, ((Xo <<= 1) & jo) === ho && (Xo = Fo), t);
      }
      function Jy(e, t, n, r) {
        !function () {
          if (jy > By) throw jy = 0, Fy = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
          Ky > qy && (Ky = 0, Hy = null, o("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
        }(), Wy && o("useInsertionEffect must not schedule updates."), zy && (Uy = !0), ya(e, n, r), (cy & ey) !== ho && e === ly ? function (e) {
          if (mt && !Wm) switch (e.tag) {
            case s:
            case b:
            case _:
              var t = dy && ft(dy) || "Unknown",
                n = t;
              if (!Dw.has(n)) Dw.add(n), o("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", ft(e) || "Unknown", t, t);
              break;
            case u:
              Bw || (o("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), Bw = !0);
          }
        }(t) : (qi && _a(e, t, n), function (e) {
          if (e.mode & io) {
            if (!$b()) return;
          } else {
            if (t = "undefined" != typeof IS_REACT_ACT_ENVIRONMENT ? IS_REACT_ACT_ENVIRONMENT : void 0, "undefined" == typeof jest || !1 === t) return;
            if (cy !== Jb) return;
            if (e.tag !== s && e.tag !== b && e.tag !== _) return;
          }
          var t;
          if (null === Zb.current) {
            var n = pt;
            try {
              yt(e), o("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", ft(e));
            } finally {
              n ? yt(e) : bt();
            }
          }
        }(t), e === ly && ((cy & ey) === Jb && (by = ma(by, n)), my === ay && rw(e, fy)), Xy(e, r), n !== mo || cy !== Jb || (t.mode & io) !== ro || Zb.isBatchingLegacy || (Cy(), Rd()));
      }
      function Xy(e, t) {
        var n = e.callbackNode;
        !function (e, t) {
          for (var n = e.pendingLanes, r = e.suspendedLanes, i = e.pingedLanes, o = e.expirationTimes, a = n; a > 0;) {
            var s = da(a),
              u = 1 << s,
              c = o[s];
            c === Zo ? (u & r) !== ho && (u & i) === ho || (o[s] = na(u, t)) : c <= t && (e.expiredLanes |= u), a &= ~u;
          }
        }(e, t);
        var r = ta(e, e === ly ? fy : ho);
        if (r === ho) return null !== n && Uw(n), e.callbackNode = null, void (e.callbackPriority = po);
        var i = ca(r),
          a = e.callbackPriority;
        if (a !== i || null !== Zb.current && n !== Fw) {
          var s, u;
          if (null != n && Uw(n), i === mo) e.tag === Ed ? (null !== Zb.isBatchingLegacy && (Zb.didScheduleLegacyUpdate = !0), u = iw.bind(null, e), Md = !0, xd(u)) : xd(iw.bind(null, e)), null !== Zb.current ? Zb.current.push(Id) : Al(function () {
            (cy & (ey | ty)) === Jb && Id();
          }), s = null;else {
            var c;
            switch (Ba(r)) {
              case Ra:
                c = Ti;
                break;
              case Ia:
                c = Pi;
                break;
              case Ta:
                c = Oi;
                break;
              case Pa:
                c = Ni;
                break;
              default:
                c = Oi;
            }
            s = zw(c, ew.bind(null, e));
          }
          e.callbackPriority = i, e.callbackNode = s;
        } else null == n && a !== mo && o("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
      }
      function ew(e, t) {
        if (vg = !1, bg = !1, Vy = Zo, $y = ho, (cy & (ey | ty)) !== Jb) throw new Error("Should not already be working.");
        var n = e.callbackNode;
        if (_w() && e.callbackNode !== n) return null;
        var r = ta(e, e === ly ? fy : ho);
        if (r === ho) return null;
        var i = !aa(0, r) && !function (e, t) {
            return (t & e.expiredLanes) !== ho;
          }(e, r) && !t,
          o = i ? function (e, t) {
            var n = cy;
            cy |= ey;
            var r = fw();
            if (ly !== e || fy !== t) {
              if (qi) {
                var i = e.memoizedUpdaters;
                i.size > 0 && (jw(e, fy), i.clear()), Ea(e, t);
              }
              My = null, Cy(), lw(e, t);
            }
            eo(t);
            for (;;) try {
              bw();
              break;
            } catch (t) {
              dw(e, t);
            }
            return Uf(), hw(r), cy = n, null !== dy ? (null !== zi && "function" == typeof zi.markRenderYielded && zi.markRenderYielded(), ny) : (to(), ly = null, fy = ho, my);
          }(e, r) : gw(e, r);
        if (o !== ny) {
          if (o === iy) {
            var a = ra(e);
            a !== ho && (r = a, o = tw(e, a));
          }
          if (o === ry) {
            var s = gy;
            throw lw(e, ho), rw(e, r), Xy(e, Ri()), s;
          }
          if (o === uy) rw(e, r);else {
            var u = !aa(0, r),
              c = e.current.alternate;
            if (u && !function (e) {
              var t = e;
              for (;;) {
                if (t.flags & Jr) {
                  var n = t.updateQueue;
                  if (null !== n) {
                    var r = n.stores;
                    if (null !== r) for (var i = 0; i < r.length; i++) {
                      var o = r[i],
                        a = o.getSnapshot,
                        s = o.value;
                      try {
                        if (!Mu(a(), s)) return !1;
                      } catch (e) {
                        return !1;
                      }
                    }
                  }
                }
                var u = t.child;
                if (t.subtreeFlags & Jr && null !== u) u.return = t, t = u;else {
                  if (t === e) return !0;
                  for (; null === t.sibling;) {
                    if (null === t.return || t.return === e) return !0;
                    t = t.return;
                  }
                  t.sibling.return = t.return, t = t.sibling;
                }
              }
              return !0;
            }(c)) {
              if ((o = gw(e, r)) === iy) {
                var l = ra(e);
                l !== ho && (r = l, o = tw(e, l));
              }
              if (o === ry) {
                var d = gy;
                throw lw(e, ho), rw(e, r), Xy(e, Ri()), d;
              }
            }
            e.finishedWork = c, e.finishedLanes = r, function (e, t, n) {
              switch (t) {
                case ny:
                case ry:
                  throw new Error("Root did not complete. This is a bug in React.");
                case iy:
                  Aw(e, Ay, My);
                  break;
                case oy:
                  if (rw(e, n), oa(n) && !qw()) {
                    var r = _y + Ey - Ri();
                    if (r > 10) {
                      if (ta(e, ho) !== ho) break;
                      var i = e.suspendedLanes;
                      if (!pa(i, n)) {
                        Gy(), wa(e, i);
                        break;
                      }
                      e.timeoutHandle = vl(Aw.bind(null, e, Ay, My), r);
                      break;
                    }
                  }
                  Aw(e, Ay, My);
                  break;
                case ay:
                  if (rw(e, n), function (e) {
                    return (e & Ao) === e;
                  }(n)) break;
                  if (!qw()) {
                    var o = function (e, t) {
                        for (var n = e.eventTimes, r = Zo; t > 0;) {
                          var i = da(t),
                            o = 1 << i,
                            a = n[i];
                          a > r && (r = a), t &= ~o;
                        }
                        return r;
                      }(e, n),
                      a = o,
                      s = Ri() - a,
                      u = ((c = s) < 120 ? 120 : c < 480 ? 480 : c < 1080 ? 1080 : c < 1920 ? 1920 : c < 3e3 ? 3e3 : c < 4320 ? 4320 : 1960 * Wb(c / 1960)) - s;
                    if (u > 10) {
                      e.timeoutHandle = vl(Aw.bind(null, e, Ay, My), u);
                      break;
                    }
                  }
                  Aw(e, Ay, My);
                  break;
                case sy:
                  Aw(e, Ay, My);
                  break;
                default:
                  throw new Error("Unknown root exit status.");
              }
              var c;
            }(e, o, r);
          }
        }
        return Xy(e, Ri()), e.callbackNode === n ? ew.bind(null, e) : null;
      }
      function tw(e, t) {
        var n = wy;
        ja(e) && (lw(e, t).flags |= $r, o("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", e.containerInfo.nodeName.toLowerCase()));
        var r = gw(e, t);
        if (r !== iy) {
          var i = Ay;
          Ay = n, null !== i && nw(i);
        }
        return r;
      }
      function nw(e) {
        null === Ay ? Ay = e : Ay.push.apply(Ay, e);
      }
      function rw(e, t) {
        t = ga(t, yy), function (e, t) {
          e.suspendedLanes |= t, e.pingedLanes &= ~t;
          for (var n = e.expirationTimes, r = t; r > 0;) {
            var i = da(r),
              o = 1 << i;
            n[i] = Zo, r &= ~o;
          }
        }(e, t = ga(t, by));
      }
      function iw(e) {
        if (vg = bg, bg = !1, (cy & (ey | ty)) !== Jb) throw new Error("Should not already be working.");
        _w();
        var t = ta(e, ho);
        if (!ha(t, mo)) return Xy(e, Ri()), null;
        var n = gw(e, t);
        if (e.tag !== Ed && n === iy) {
          var r = ra(e);
          r !== ho && (t = r, n = tw(e, r));
        }
        if (n === ry) {
          var i = gy;
          throw lw(e, ho), rw(e, t), Xy(e, Ri()), i;
        }
        if (n === uy) throw new Error("Root did not complete. This is a bug in React.");
        var o = e.current.alternate;
        return e.finishedWork = o, e.finishedLanes = t, Aw(e, Ay, My), Xy(e, Ri()), null;
      }
      function ow(e, t) {
        var n = cy;
        cy |= Xb;
        try {
          return e(t);
        } finally {
          (cy = n) !== Jb || Zb.isBatchingLegacy || (Cy(), Rd());
        }
      }
      function aw(e) {
        null !== Oy && Oy.tag === Ed && (cy & (ey | ty)) === Jb && _w();
        var t = cy;
        cy |= Xb;
        var n = Qb.transition,
          r = La();
        try {
          return Qb.transition = null, Na(Ra), e ? e() : void 0;
        } finally {
          Na(r), Qb.transition = n, ((cy = t) & (ey | ty)) === Jb && Id();
        }
      }
      function sw() {
        return (cy & (ey | ty)) !== Jb;
      }
      function uw(e, t) {
        ad(py, hy, e), hy = ma(hy, t);
      }
      function cw(e) {
        hy = py.current, od(py, e);
      }
      function lw(e, t) {
        e.finishedWork = null, e.finishedLanes = ho;
        var n = e.timeoutHandle;
        if (n !== yl && (e.timeoutHandle = yl, bl(n)), null !== dy) for (var r = dy.return; null !== r;) {
          r.alternate;
          jv(0, r), r = r.return;
        }
        ly = e;
        var i = uA(e.current, null);
        return dy = i, fy = hy = t, my = ny, gy = null, vy = ho, by = ho, yy = ho, wy = null, Ay = null, function () {
          if (null !== Qf) {
            for (var e = 0; e < Qf.length; e++) {
              var t = Qf[e],
                n = t.interleaved;
              if (null !== n) {
                t.interleaved = null;
                var r = n.next,
                  i = t.pending;
                if (null !== i) {
                  var o = i.next;
                  i.next = r, n.next = o;
                }
                t.pending = n;
              }
            }
            Qf = null;
          }
        }(), Ef.discardPendingWarnings(), i;
      }
      function dw(e, t) {
        for (;;) {
          var n = dy;
          try {
            if (Uf(), nm(), bt(), Gb.current = null, null === n || null === n.return) return my = ry, gy = t, void (dy = null);
            if (U && n.mode & oo && Sg(n, !0), z) if (Yi(), null !== t && "object" == typeof t && "function" == typeof t.then) Xi(n, t, fy);else Ji(n, t, fy);
            Fg(e, n.return, n, t, fy), ww(n);
          } catch (e) {
            t = e, dy === n && null !== n ? (n = n.return, dy = n) : n = dy;
            continue;
          }
          return;
        }
      }
      function fw() {
        var e = Yb.current;
        return Yb.current = ng, null === e ? ng : e;
      }
      function hw(e) {
        Yb.current = e;
      }
      function pw(e) {
        vy = ma(e, vy);
      }
      function mw() {
        my !== ny && my !== oy && my !== iy || (my = ay), null !== ly && (ia(vy) || ia(by)) && rw(ly, fy);
      }
      function gw(e, t) {
        var n = cy;
        cy |= ey;
        var r = fw();
        if (ly !== e || fy !== t) {
          if (qi) {
            var i = e.memoizedUpdaters;
            i.size > 0 && (jw(e, fy), i.clear()), Ea(e, t);
          }
          My = null, lw(e, t);
        }
        for (eo(t);;) try {
          vw();
          break;
        } catch (t) {
          dw(e, t);
        }
        if (Uf(), cy = n, hw(r), null !== dy) throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        return to(), ly = null, fy = ho, my;
      }
      function vw() {
        for (; null !== dy;) yw(dy);
      }
      function bw() {
        for (; null !== dy && !Ci();) yw(dy);
      }
      function yw(e) {
        var t,
          n = e.alternate;
        yt(e), (e.mode & oo) !== ro ? (_g(e), t = Ow(n, e, hy), Sg(e, !0)) : t = Ow(n, e, hy), bt(), e.memoizedProps = e.pendingProps, null === t ? ww(e) : dy = t, Gb.current = null;
      }
      function ww(e) {
        var t = e;
        do {
          var n = t.alternate,
            r = t.return;
          if ((t.flags & ti) === jr) {
            yt(t);
            var i = void 0;
            if ((t.mode & oo) === ro ? i = Dv(n, t, hy) : (_g(t), i = Dv(n, t, hy), Sg(t, !1)), bt(), null !== i) return void (dy = i);
          } else {
            var o = Bv(0, t);
            if (null !== o) return o.flags &= ei, void (dy = o);
            if ((t.mode & oo) !== ro) {
              Sg(t, !1);
              for (var a = t.actualDuration, s = t.child; null !== s;) a += s.actualDuration, s = s.sibling;
              t.actualDuration = a;
            }
            if (null === r) return my = uy, void (dy = null);
            r.flags |= ti, r.subtreeFlags = jr, r.deletions = null;
          }
          var u = t.sibling;
          if (null !== u) return void (dy = u);
          dy = t = r;
        } while (null !== t);
        my === ny && (my = sy);
      }
      function Aw(e, t, n) {
        var r = La(),
          i = Qb.transition;
        try {
          Qb.transition = null, Na(Ra), function (e, t, n, r) {
            do {
              _w();
            } while (null !== Oy);
            if (function () {
              Ef.flushLegacyContextWarning(), Ef.flushPendingUnsafeLifecycleWarnings();
            }(), (cy & (ey | ty)) !== Jb) throw new Error("Should not already be working.");
            var i = e.finishedWork,
              a = e.finishedLanes;
            if (function (e) {
              null !== zi && "function" == typeof zi.markCommitStarted && zi.markCommitStarted(e);
            }(a), null === i) return $i(), null;
            a === ho && o("root.finishedLanes should not be empty during a commit. This is a bug in React.");
            if (e.finishedWork = null, e.finishedLanes = ho, i === e.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
            e.callbackNode = null, e.callbackPriority = po;
            var s = ma(i.lanes, i.childLanes);
            (function (e, t) {
              var n = e.pendingLanes & ~t;
              e.pendingLanes = t, e.suspendedLanes = ho, e.pingedLanes = ho, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t;
              for (var r = e.entanglements, i = e.eventTimes, o = e.expirationTimes, a = n; a > 0;) {
                var s = da(a),
                  u = 1 << s;
                r[s] = ho, i[s] = Zo, o[s] = Zo, a &= ~u;
              }
            })(e, s), e === ly && (ly = null, dy = null, fy = ho);
            (i.subtreeFlags & hi) === jr && (i.flags & hi) === jr || Py || (Py = !0, Dy = n, zw(Oi, function () {
              return _w(), null;
            }));
            var u = (i.subtreeFlags & (li | di | fi | hi)) !== jr,
              c = (i.flags & (li | di | fi | hi)) !== jr;
            if (u || c) {
              var l = Qb.transition;
              Qb.transition = null;
              var d = La();
              Na(Ra);
              var f = cy;
              cy |= ty, Gb.current = null, Xv(e, i), Ag(), function (e, t, n) {
                Hv = n, Vv = e, yt(t), Ab(t, e), yt(t), Hv = null, Vv = null;
              }(e, i, a), e.containerInfo, ju(fl), os(dl), dl = null, fl = null, e.current = i, function (e) {
                null !== zi && "function" == typeof zi.markLayoutEffectsStarted && zi.markLayoutEffectsStarted(e);
              }(a), Eb(i, e, a), null !== zi && "function" == typeof zi.markLayoutEffectsStopped && zi.markLayoutEffectsStopped(), xi(), cy = f, Na(d), Qb.transition = l;
            } else e.current = i, Ag();
            var h = Py;
            Py ? (Py = !1, Oy = e, Ly = a) : (Ky = 0, Hy = null);
            s = e.pendingLanes, s === ho && (Ty = null);
            h || Tw(e.current, !1);
            (function (e, t) {
              if (Fi && "function" == typeof Fi.onCommitFiberRoot) try {
                var n = (e.current.flags & Vr) === Vr;
                if (U) {
                  var r;
                  switch (t) {
                    case Ra:
                      r = Ti;
                      break;
                    case Ia:
                      r = Pi;
                      break;
                    case Ta:
                      r = Oi;
                      break;
                    case Pa:
                      r = Ni;
                      break;
                    default:
                      r = Oi;
                  }
                  Fi.onCommitFiberRoot(ji, e, r, n);
                }
              } catch (e) {
                Ui || (Ui = !0, o("React instrumentation encountered an error: %s", e));
              }
            })(i.stateNode, r), qi && e.memoizedUpdaters.clear();
            if (function () {
              Hb.forEach(function (e) {
                return e();
              });
            }(), Xy(e, Ri()), null !== t) for (var p = e.onRecoverableError, m = 0; m < t.length; m++) {
              var g = t[m],
                v = g.stack,
                b = g.digest;
              p(g.value, {
                componentStack: v,
                digest: b
              });
            }
            if (Ry) {
              Ry = !1;
              var y = Iy;
              throw Iy = null, y;
            }
            ha(Ly, mo) && e.tag !== Ed && _w();
            s = e.pendingLanes, ha(s, mo) ? (bg = !0, e === Fy ? jy++ : (jy = 0, Fy = e)) : jy = 0;
            Id(), $i();
          }(e, t, n, r);
        } finally {
          Qb.transition = i, Na(r);
        }
        return null;
      }
      function _w() {
        if (null !== Oy) {
          var e = Ba(Ly),
            t = function (e, t) {
              return 0 === e || e > t ? e : t;
            }(Ta, e),
            n = Qb.transition,
            r = La();
          try {
            return Qb.transition = null, Na(t), function () {
              if (null === Oy) return !1;
              var e = Dy;
              Dy = null;
              var t = Oy,
                n = Ly;
              if (Oy = null, Ly = ho, (cy & (ey | ty)) !== Jb) throw new Error("Cannot flush passive effects while already rendering.");
              zy = !0, Uy = !1, function (e) {
                null !== zi && "function" == typeof zi.markPassiveEffectsStarted && zi.markPassiveEffectsStarted(e);
              }(n);
              var r = cy;
              cy |= ty, Ob(t.current), Ib(t, t.current, n, e);
              var i = Ny;
              Ny = [];
              for (var a = 0; a < i.length; a++) {
                ib(0, i[a]);
              }
              void (null !== zi && "function" == typeof zi.markPassiveEffectsStopped && zi.markPassiveEffectsStopped()), Tw(t.current, !0), cy = r, Id(), Uy ? t === Hy ? Ky++ : (Ky = 0, Hy = t) : Ky = 0;
              zy = !1, Uy = !1, function (e) {
                if (Fi && "function" == typeof Fi.onPostCommitFiberRoot) try {
                  Fi.onPostCommitFiberRoot(ji, e);
                } catch (e) {
                  Ui || (Ui = !0, o("React instrumentation encountered an error: %s", e));
                }
              }(t);
              var s = t.current.stateNode;
              return s.effectDuration = 0, s.passiveEffectDuration = 0, !0;
            }();
          } finally {
            Na(r), Qb.transition = n;
          }
        }
        return !1;
      }
      function Ew(e) {
        return null !== Ty && Ty.has(e);
      }
      var Sw = function (e) {
        Ry || (Ry = !0, Iy = e);
      };
      function kw(e, t, n) {
        var r = fh(e, Lg(e, Ig(n, t), mo), mo),
          i = Gy();
        null !== r && (ya(r, mo, i), Xy(r, i));
      }
      function Mw(e, t, n) {
        if (function (e) {
          Nr(null, function () {
            throw e;
          }), Dr();
        }(n), Kw(!1), e.tag !== l) {
          var r = null;
          for (r = t; null !== r;) {
            if (r.tag === l) return void kw(r, e, n);
            if (r.tag === u) {
              var i = r.type,
                a = r.stateNode;
              if ("function" == typeof i.getDerivedStateFromError || "function" == typeof a.componentDidCatch && !Ew(a)) {
                var s = fh(r, Ng(r, Ig(n, e), mo), mo),
                  c = Gy();
                return void (null !== s && (ya(s, mo, c), Xy(s, c)));
              }
            }
            r = r.return;
          }
          o("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", n);
        } else kw(e, e, n);
      }
      function Cw(e, t, n) {
        var r = e.pingCache;
        null !== r && r.delete(t);
        var i = Gy();
        wa(e, n), function (e) {
          e.tag !== Ed && $b() && null === Zb.current && o("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
        }(e), ly === e && pa(fy, n) && (my === ay || my === oy && oa(fy) && Ri() - _y < Ey ? lw(e, ho) : yy = ma(yy, n)), Xy(e, i);
      }
      function xw(e, t) {
        t === po && (t = Zy(e));
        var n = Gy(),
          r = Xf(e, t);
        null !== r && (ya(r, t, n), Xy(r, n));
      }
      function Rw(e) {
        var t = e.memoizedState,
          n = po;
        null !== t && (n = t.retryLane), xw(e, n);
      }
      function Iw(e, t) {
        var n,
          r = po;
        switch (e.tag) {
          case w:
            n = e.stateNode;
            var i = e.memoizedState;
            null !== i && (r = i.retryLane);
            break;
          case M:
            n = e.stateNode;
            break;
          default:
            throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        null !== n && n.delete(t), xw(e, r);
      }
      function Tw(e, t) {
        yt(e), Pw(e, ui, Ub), t && Pw(e, ci, qb), Pw(e, ui, Fb), t && Pw(e, ci, zb), bt();
      }
      function Pw(e, t, n) {
        for (var r = e, i = null; null !== r;) {
          var o = r.subtreeFlags & t;
          r !== i && null !== r.child && o !== jr ? r = r.child : ((r.flags & t) !== jr && n(r), r = null !== r.sibling ? r.sibling : i = r.return);
        }
      }
      var Ow,
        Lw = null;
      function Nw(e) {
        if ((cy & ey) === Jb && e.mode & io) {
          var t = e.tag;
          if (t === c || t === l || t === u || t === s || t === b || t === A || t === _) {
            var n = ft(e) || "ReactComponent";
            if (null !== Lw) {
              if (Lw.has(n)) return;
              Lw.add(n);
            } else Lw = new Set([n]);
            var r = pt;
            try {
              yt(e), o("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
            } finally {
              r ? yt(e) : bt();
            }
          }
        }
      }
      Ow = function (e, t, n) {
        var r = gA(null, t);
        try {
          return Iv(e, t, n);
        } catch (o) {
          if (Qd || null !== o && "object" == typeof o && "function" == typeof o.then) throw o;
          if (Uf(), nm(), jv(0, t), gA(t, r), t.mode & oo && _g(t), Nr(null, Iv, null, e, t, n), Ir) {
            var i = Dr();
            "object" == typeof i && null !== i && i._suppressLogging && "object" == typeof o && null !== o && !o._suppressLogging && (o._suppressLogging = !0);
          }
          throw o;
        }
      };
      var Dw,
        Bw = !1;
      function jw(e, t) {
        qi && e.memoizedUpdaters.forEach(function (n) {
          _a(e, n, t);
        });
      }
      Dw = new Set();
      var Fw = {};
      function zw(e, t) {
        var n = Zb.current;
        return null !== n ? (n.push(t), Fw) : ki(e, t);
      }
      function Uw(e) {
        if (e !== Fw) return Mi(e);
      }
      function qw() {
        return null !== Zb.current;
      }
      function Kw(e) {
        Wy = e;
      }
      var Hw = null,
        Vw = null,
        $w = function (e) {
          Hw = e;
        };
      function Ww(e) {
        if (null === Hw) return e;
        var t = Hw(e);
        return void 0 === t ? e : t.current;
      }
      function Yw(e) {
        return Ww(e);
      }
      function Gw(e) {
        if (null === Hw) return e;
        var t = Hw(e);
        if (void 0 === t) {
          if (null != e && "function" == typeof e.render) {
            var n = Ww(e.render);
            if (e.render !== n) {
              var r = {
                $$typeof: Oe,
                render: n
              };
              return void 0 !== e.displayName && (r.displayName = e.displayName), r;
            }
          }
          return e;
        }
        return t.current;
      }
      function Qw(e, t) {
        if (null === Hw) return !1;
        var n = e.elementType,
          r = t.type,
          i = !1,
          o = "object" == typeof r && null !== r ? r.$$typeof : null;
        switch (e.tag) {
          case u:
            "function" == typeof r && (i = !0);
            break;
          case s:
            ("function" == typeof r || o === Be) && (i = !0);
            break;
          case b:
            (o === Oe || o === Be) && (i = !0);
            break;
          case A:
          case _:
            (o === De || o === Be) && (i = !0);
            break;
          default:
            return !1;
        }
        if (i) {
          var a = Hw(n);
          if (void 0 !== a && a === Hw(r)) return !0;
        }
        return !1;
      }
      function Zw(e) {
        null !== Hw && "function" == typeof WeakSet && (null === Vw && (Vw = new WeakSet()), Vw.add(e));
      }
      var Jw = function (e, t) {
          if (null !== Hw) {
            var n = t.staleFamilies,
              r = t.updatedFamilies;
            _w(), aw(function () {
              eA(e.current, r, n);
            });
          }
        },
        Xw = function (e, t) {
          e.context === sd && (_w(), aw(function () {
            MA(t, e, null, null);
          }));
        };
      function eA(e, t, n) {
        var r = e.alternate,
          i = e.child,
          o = e.sibling,
          a = e.tag,
          c = e.type,
          l = null;
        switch (a) {
          case s:
          case _:
          case u:
            l = c;
            break;
          case b:
            l = c.render;
        }
        if (null === Hw) throw new Error("Expected resolveFamily to be set during hot reload.");
        var d = !1,
          f = !1;
        if (null !== l) {
          var h = Hw(l);
          void 0 !== h && (n.has(h) ? f = !0 : t.has(h) && (a === u ? f = !0 : d = !0));
        }
        if (null !== Vw && (Vw.has(e) || null !== r && Vw.has(r)) && (f = !0), f && (e._debugNeedsRemount = !0), f || d) {
          var p = Xf(e, mo);
          null !== p && Jy(p, e, mo, Zo);
        }
        null === i || f || eA(i, t, n), null !== o && eA(o, t, n);
      }
      var tA,
        nA = function (e, t) {
          var n = new Set(),
            r = new Set(t.map(function (e) {
              return e.current;
            }));
          return rA(e.current, r, n), n;
        };
      function rA(e, t, n) {
        var r = e.child,
          i = e.sibling,
          o = e.tag,
          a = e.type,
          c = null;
        switch (o) {
          case s:
          case _:
          case u:
            c = a;
            break;
          case b:
            c = a.render;
        }
        var h = !1;
        null !== c && t.has(c) && (h = !0), h ? function (e, t) {
          var n = function (e, t) {
            var n = e,
              r = !1;
            for (;;) {
              if (n.tag === f) r = !0, t.add(n.stateNode);else if (null !== n.child) {
                n.child.return = n, n = n.child;
                continue;
              }
              if (n === e) return r;
              for (; null === n.sibling;) {
                if (null === n.return || n.return === e) return r;
                n = n.return;
              }
              n.sibling.return = n.return, n = n.sibling;
            }
            return !1;
          }(e, t);
          if (n) return;
          var r = e;
          for (;;) {
            switch (r.tag) {
              case f:
                return void t.add(r.stateNode);
              case d:
              case l:
                return void t.add(r.stateNode.containerInfo);
            }
            if (null === r.return) throw new Error("Expected to reach root first.");
            r = r.return;
          }
        }(e, n) : null !== r && rA(r, t, n), null !== i && rA(i, t, n);
      }
      tA = !1;
      try {
        var iA = Object.preventExtensions({});
        new Map([[iA, null]]), new Set([iA]);
      } catch (e) {
        tA = !0;
      }
      function oA(e, t, n, r) {
        this.tag = e, this.key = n, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = t, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = r, this.flags = jr, this.subtreeFlags = jr, this.deletions = null, this.lanes = ho, this.childLanes = ho, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, tA || "function" != typeof Object.preventExtensions || Object.preventExtensions(this);
      }
      var aA = function (e, t, n, r) {
        return new oA(e, t, n, r);
      };
      function sA(e) {
        var t = e.prototype;
        return !(!t || !t.isReactComponent);
      }
      function uA(e, t) {
        var n = e.alternate;
        null === n ? ((n = aA(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n._debugSource = e._debugSource, n._debugOwner = e._debugOwner, n._debugHookTypes = e._debugHookTypes, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = jr, n.subtreeFlags = jr, n.deletions = null, n.actualDuration = 0, n.actualStartTime = -1), n.flags = e.flags & pi, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue;
        var r = e.dependencies;
        switch (n.dependencies = null === r ? null : {
          lanes: r.lanes,
          firstContext: r.firstContext
        }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.selfBaseDuration = e.selfBaseDuration, n.treeBaseDuration = e.treeBaseDuration, n._debugNeedsRemount = e._debugNeedsRemount, n.tag) {
          case c:
          case s:
          case _:
            n.type = Ww(e.type);
            break;
          case u:
            n.type = Yw(e.type);
            break;
          case b:
            n.type = Gw(e.type);
        }
        return n;
      }
      function cA(e, t) {
        e.flags &= pi | zr;
        var n = e.alternate;
        if (null === n) e.childLanes = ho, e.lanes = t, e.child = null, e.subtreeFlags = jr, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0;else {
          e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = jr, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type;
          var r = n.dependencies;
          e.dependencies = null === r ? null : {
            lanes: r.lanes,
            firstContext: r.firstContext
          }, e.selfBaseDuration = n.selfBaseDuration, e.treeBaseDuration = n.treeBaseDuration;
        }
        return e;
      }
      function lA(e, t, n, r, i, a) {
        var s = c,
          l = e;
        if ("function" == typeof e) sA(e) ? (s = u, l = Yw(l)) : l = Ww(l);else if ("string" == typeof e) s = f;else e: switch (e) {
          case xe:
            return fA(n.children, i, a, t);
          case Re:
            s = m, ((i |= ao) & io) !== ro && (i |= so);
            break;
          case Ie:
            return function (e, t, n, r) {
              "string" != typeof e.id && o('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id);
              var i = aA(y, e, r, t | oo);
              return i.elementType = Ie, i.lanes = n, i.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
              }, i;
            }(n, i, a, t);
          case Le:
            return function (e, t, n, r) {
              var i = aA(w, e, r, t);
              return i.elementType = Le, i.lanes = n, i;
            }(n, i, a, t);
          case Ne:
            return function (e, t, n, r) {
              var i = aA(M, e, r, t);
              return i.elementType = Ne, i.lanes = n, i;
            }(n, i, a, t);
          case je:
            return hA(n, i, a, t);
          default:
            if ("object" == typeof e && null !== e) switch (e.$$typeof) {
              case Te:
                s = v;
                break e;
              case Pe:
                s = g;
                break e;
              case Oe:
                s = b, l = Gw(l);
                break e;
              case De:
                s = A;
                break e;
              case Be:
                s = E, l = null;
                break e;
            }
            var d = "";
            (void 0 === e || "object" == typeof e && null !== e && 0 === Object.keys(e).length) && (d += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var h = r ? ft(r) : null;
            throw h && (d += "\n\nCheck the render method of `" + h + "`."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (null == e ? e : typeof e) + "." + d);
        }
        var p = aA(s, n, t, i);
        return p.elementType = e, p.type = l, p.lanes = a, p._debugOwner = r, p;
      }
      function dA(e, t, n) {
        var r;
        r = e._owner;
        var i = lA(e.type, e.key, e.props, r, t, n);
        return i._debugSource = e._source, i._debugOwner = e._owner, i;
      }
      function fA(e, t, n, r) {
        var i = aA(p, e, r, t);
        return i.lanes = n, i;
      }
      function hA(e, t, n, r) {
        var i = aA(x, e, r, t);
        i.elementType = je, i.lanes = n;
        return i.stateNode = {
          isHidden: !1
        }, i;
      }
      function pA(e, t, n) {
        var r = aA(h, e, null, t);
        return r.lanes = n, r;
      }
      function mA(e, t, n) {
        var r = null !== e.children ? e.children : [],
          i = aA(d, r, e.key, t);
        return i.lanes = n, i.stateNode = {
          containerInfo: e.containerInfo,
          pendingChildren: null,
          implementation: e.implementation
        }, i;
      }
      function gA(e, t) {
        return null === e && (e = aA(c, null, null, ro)), e.tag = t.tag, e.key = t.key, e.elementType = t.elementType, e.type = t.type, e.stateNode = t.stateNode, e.return = t.return, e.child = t.child, e.sibling = t.sibling, e.index = t.index, e.ref = t.ref, e.pendingProps = t.pendingProps, e.memoizedProps = t.memoizedProps, e.updateQueue = t.updateQueue, e.memoizedState = t.memoizedState, e.dependencies = t.dependencies, e.mode = t.mode, e.flags = t.flags, e.subtreeFlags = t.subtreeFlags, e.deletions = t.deletions, e.lanes = t.lanes, e.childLanes = t.childLanes, e.alternate = t.alternate, e.actualDuration = t.actualDuration, e.actualStartTime = t.actualStartTime, e.selfBaseDuration = t.selfBaseDuration, e.treeBaseDuration = t.treeBaseDuration, e._debugSource = t._debugSource, e._debugOwner = t._debugOwner, e._debugNeedsRemount = t._debugNeedsRemount, e._debugHookTypes = t._debugHookTypes, e;
      }
      function vA(e, t, n, r, i) {
        this.tag = t, this.containerInfo = e, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = yl, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = po, this.eventTimes = ba(ho), this.expirationTimes = ba(Zo), this.pendingLanes = ho, this.suspendedLanes = ho, this.pingedLanes = ho, this.expiredLanes = ho, this.mutableReadLanes = ho, this.finishedLanes = ho, this.entangledLanes = ho, this.entanglements = ba(ho), this.identifierPrefix = r, this.onRecoverableError = i, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0, this.memoizedUpdaters = new Set();
        for (var o = this.pendingUpdatersLaneMap = [], a = 0; a < fo; a++) o.push(new Set());
        switch (t) {
          case Sd:
            this._debugRootType = n ? "hydrateRoot()" : "createRoot()";
            break;
          case Ed:
            this._debugRootType = n ? "hydrate()" : "render()";
        }
      }
      function bA(e, t, n, r, i, o, a, s, u, c) {
        var d = new vA(e, t, n, s, u),
          f = function (e, t, n) {
            var r;
            return e === Sd ? (r = io, !0 === t && (r |= ao, r |= so)) : r = ro, qi && (r |= oo), aA(l, null, null, r);
          }(t, o);
        d.current = f, f.stateNode = d;
        var h = {
          element: r,
          isDehydrated: n,
          cache: null,
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        return f.memoizedState = h, ch(f), d;
      }
      var yA,
        wA,
        AA = "18.2.0";
      function _A(e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
        return function (e) {
          if (Z(e)) o("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Q(e)), J(e);
        }(r), {
          $$typeof: Ce,
          key: null == r ? null : "" + r,
          children: e,
          containerInfo: t,
          implementation: n
        };
      }
      function EA(e) {
        if (!e) return sd;
        var t = Br(e),
          n = _d(t);
        if (t.tag === u) {
          var r = t.type;
          if (md(r)) return yd(t, r, n);
        }
        return n;
      }
      function SA(e, t, n, r, i, o, a, s) {
        return bA(e, t, !1, null, 0, r, 0, o, a);
      }
      function kA(e, t, n, r, i, o, a, s, u, c) {
        var l = bA(n, r, !0, e, 0, o, 0, s, u);
        l.context = EA(null);
        var d = l.current,
          f = Gy(),
          h = Qy(d),
          p = dh(f, h);
        return p.callback = null != t ? t : null, fh(d, p, h), function (e, t, n) {
          e.current.lanes = t, ya(e, t, n), Xy(e, n);
        }(l, h, f), l;
      }
      function MA(e, t, n, r) {
        !function (e, t) {
          if (Fi && "function" == typeof Fi.onScheduleFiberRoot) try {
            Fi.onScheduleFiberRoot(ji, e, t);
          } catch (e) {
            Ui || (Ui = !0, o("React instrumentation encountered an error: %s", e));
          }
        }(t, e);
        var i = t.current,
          a = Gy(),
          s = Qy(i);
        !function (e) {
          null !== zi && "function" == typeof zi.markRenderScheduled && zi.markRenderScheduled(e);
        }(s);
        var u = EA(n);
        null === t.context ? t.context = u : t.pendingContext = u, mt && null !== pt && !yA && (yA = !0, o("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", ft(pt) || "Unknown"));
        var c = dh(a, s);
        c.payload = {
          element: e
        }, null !== (r = void 0 === r ? null : r) && ("function" != typeof r && o("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", r), c.callback = r);
        var l = fh(i, c, s);
        return null !== l && (Jy(l, i, s, a), hh(l, i, s)), s;
      }
      function CA(e) {
        var t = e.current;
        return t.child ? (t.child.tag, t.child.stateNode) : null;
      }
      function xA(e, t) {
        var n = e.memoizedState;
        null !== n && null !== n.dehydrated && (n.retryLane = function (e, t) {
          return e !== po && e < t ? e : t;
        }(n.retryLane, t));
      }
      function RA(e, t) {
        xA(e, t);
        var n = e.alternate;
        n && xA(n, t);
      }
      function IA(e) {
        var t = Ei(e);
        return null === t ? null : t.stateNode;
      }
      yA = !1, wA = {};
      var TA = function (e) {
        return null;
      };
      var PA = function (e) {
        return !1;
      };
      var OA,
        LA,
        NA,
        DA,
        BA,
        jA,
        FA,
        zA,
        UA,
        qA = function (e, t, n) {
          var r = t[n],
            i = Yt(e) ? e.slice() : Ge({}, e);
          return n + 1 === t.length ? (Yt(i) ? i.splice(r, 1) : delete i[r], i) : (i[r] = qA(e[r], t, n + 1), i);
        },
        KA = function (e, t) {
          return qA(e, t, 0);
        },
        HA = function (e, t, n, r) {
          var i = t[r],
            o = Yt(e) ? e.slice() : Ge({}, e);
          r + 1 === t.length ? (o[n[r]] = o[i], Yt(o) ? o.splice(i, 1) : delete o[i]) : o[i] = HA(e[i], t, n, r + 1);
          return o;
        },
        VA = function (e, t, n) {
          if (t.length === n.length) {
            for (var r = 0; r < n.length - 1; r++) if (t[r] !== n[r]) return void i("copyWithRename() expects paths to be the same except for the deepest key");
            return HA(e, t, n, 0);
          }
          i("copyWithRename() expects paths of the same length");
        },
        $A = function (e, t, n, r) {
          if (n >= t.length) return r;
          var i = t[n],
            o = Yt(e) ? e.slice() : Ge({}, e);
          return o[i] = $A(e[i], t, n + 1, r), o;
        },
        WA = function (e, t, n) {
          return $A(e, t, 0, n);
        },
        YA = function (e, t) {
          for (var n = e.memoizedState; null !== n && t > 0;) n = n.next, t--;
          return n;
        };
      function GA(e) {
        var t = Ai(e);
        return null === t ? null : t.stateNode;
      }
      function QA(e) {
        return null;
      }
      function ZA() {
        return pt;
      }
      OA = function (e, t, n, r) {
        var i = YA(e, t);
        if (null !== i) {
          var o = WA(i.memoizedState, n, r);
          i.memoizedState = o, i.baseState = o, e.memoizedProps = Ge({}, e.memoizedProps);
          var a = Xf(e, mo);
          null !== a && Jy(a, e, mo, Zo);
        }
      }, LA = function (e, t, n) {
        var r = YA(e, t);
        if (null !== r) {
          var i = KA(r.memoizedState, n);
          r.memoizedState = i, r.baseState = i, e.memoizedProps = Ge({}, e.memoizedProps);
          var o = Xf(e, mo);
          null !== o && Jy(o, e, mo, Zo);
        }
      }, NA = function (e, t, n, r) {
        var i = YA(e, t);
        if (null !== i) {
          var o = VA(i.memoizedState, n, r);
          i.memoizedState = o, i.baseState = o, e.memoizedProps = Ge({}, e.memoizedProps);
          var a = Xf(e, mo);
          null !== a && Jy(a, e, mo, Zo);
        }
      }, DA = function (e, t, n) {
        e.pendingProps = WA(e.memoizedProps, t, n), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var r = Xf(e, mo);
        null !== r && Jy(r, e, mo, Zo);
      }, BA = function (e, t) {
        e.pendingProps = KA(e.memoizedProps, t), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var n = Xf(e, mo);
        null !== n && Jy(n, e, mo, Zo);
      }, jA = function (e, t, n) {
        e.pendingProps = VA(e.memoizedProps, t, n), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var r = Xf(e, mo);
        null !== r && Jy(r, e, mo, Zo);
      }, FA = function (e) {
        var t = Xf(e, mo);
        null !== t && Jy(t, e, mo, Zo);
      }, zA = function (e) {
        TA = e;
      }, UA = function (e) {
        PA = e;
      };
      var JA = "function" == typeof reportError ? reportError : function (e) {
        console.error(e);
      };
      function XA(e) {
        this._internalRoot = e;
      }
      function e_(e) {
        this._internalRoot = e;
      }
      function t_(e) {
        return !(!e || e.nodeType !== hn && e.nodeType !== gn && e.nodeType !== vn && B);
      }
      function n_(e) {
        return !(!e || e.nodeType !== hn && e.nodeType !== gn && e.nodeType !== vn && (e.nodeType !== mn || " react-mount-point-unstable " !== e.nodeValue));
      }
      function r_(e) {
        e.nodeType === hn && e.tagName && "BODY" === e.tagName.toUpperCase() && o("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), Hl(e) && (e._reactRootContainer ? o("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : o("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
      }
      e_.prototype.render = XA.prototype.render = function (e) {
        var t = this._internalRoot;
        if (null === t) throw new Error("Cannot update an unmounted root.");
        "function" == typeof arguments[1] ? o("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : t_(arguments[1]) ? o("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : void 0 !== arguments[1] && o("You passed a second argument to root.render(...) but it only accepts one argument.");
        var n = t.containerInfo;
        if (n.nodeType !== mn) {
          var r = IA(t.current);
          r && r.parentNode !== n && o("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
        MA(e, t, null, null);
      }, e_.prototype.unmount = XA.prototype.unmount = function () {
        "function" == typeof arguments[0] && o("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var e = this._internalRoot;
        if (null !== e) {
          this._internalRoot = null;
          var t = e.containerInfo;
          sw() && o("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), aw(function () {
            MA(null, e, null, null);
          }), Kl(t);
        }
      }, e_.prototype.unstable_scheduleHydration = function (e) {
        e && function (e) {
          for (var t = Ca(), n = {
              blockedOn: null,
              target: e,
              priority: t
            }, r = 0; r < Wa.length && Da(t, Wa[r].priority); r++);
          Wa.splice(r, 0, n), 0 === r && Za(n);
        }(e);
      };
      var i_,
        o_,
        a_,
        s_ = n.ReactCurrentOwner;
      function u_(e) {
        return e ? e.nodeType === gn ? e.documentElement : e.firstChild : null;
      }
      function c_() {}
      function l_(e, t, n, r, i) {
        i_(n), function (e, t) {
          null !== e && "function" != typeof e && o("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e);
        }(void 0 === i ? null : i, "render");
        var a,
          s = n._reactRootContainer;
        if (s) {
          if ("function" == typeof i) {
            var u = i;
            i = function () {
              var e = CA(a);
              u.call(e);
            };
          }
          MA(t, a = s, e, i);
        } else a = function (e, t, n, r, i) {
          if (i) {
            if ("function" == typeof r) {
              var o = r;
              r = function () {
                var e = CA(a);
                o.call(e);
              };
            }
            var a = kA(t, r, e, Ed, 0, !1, 0, "", c_);
            return e._reactRootContainer = a, ql(a.current, e), pc(e.nodeType === mn ? e.parentNode : e), aw(), a;
          }
          for (var s; s = e.lastChild;) e.removeChild(s);
          if ("function" == typeof r) {
            var u = r;
            r = function () {
              var e = CA(c);
              u.call(e);
            };
          }
          var c = SA(e, Ed, 0, !1, 0, "", c_);
          return e._reactRootContainer = c, ql(c.current, e), pc(e.nodeType === mn ? e.parentNode : e), aw(function () {
            MA(t, c, n, r);
          }), c;
        }(n, t, e, i, r);
        return CA(a);
      }
      i_ = function (e) {
        if (e._reactRootContainer && e.nodeType !== mn) {
          var t = IA(e._reactRootContainer.current);
          t && t.parentNode !== e && o("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
        }
        var n = !!e._reactRootContainer,
          r = u_(e);
        !(!r || !$l(r)) && !n && o("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), e.nodeType === hn && e.tagName && "BODY" === e.tagName.toUpperCase() && o("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
      }, o_ = function (e) {
        switch (e.tag) {
          case l:
            var t = e.stateNode;
            if (ja(t)) {
              var n = function (e) {
                return ea(e.pendingLanes);
              }(t);
              !function (e, t) {
                t !== ho && (Aa(e, ma(t, mo)), Xy(e, Ri()), (cy & (ey | ty)) === Jb && (Cy(), Id()));
              }(t, n);
            }
            break;
          case w:
            aw(function () {
              var t = Xf(e, mo);
              if (null !== t) {
                var n = Gy();
                Jy(t, e, mo, n);
              }
            }), RA(e, mo);
        }
      }, Sa = o_, function (e) {
        ka = e;
      }(function (e) {
        if (e.tag === w) {
          var t = Vo,
            n = Xf(e, t);
          if (null !== n) Jy(n, e, t, Gy());
          RA(e, t);
        }
      }), function (e) {
        Ma = e;
      }(function (e) {
        if (e.tag === w) {
          var t = Qy(e),
            n = Xf(e, t);
          if (null !== n) Jy(n, e, t, Gy());
          RA(e, t);
        }
      }), function (e) {
        Ca = e;
      }(La), function (e) {
        xa = e;
      }(function (e, t) {
        var n = Oa;
        try {
          return Oa = e, t();
        } finally {
          Oa = n;
        }
      }), "function" == typeof Map && null != Map.prototype && "function" == typeof Map.prototype.forEach && "function" == typeof Set && null != Set.prototype && "function" == typeof Set.prototype.clear && "function" == typeof Set.prototype.forEach || o("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), a_ = function (e, t, n) {
        switch (t) {
          case "input":
            return void zt(e, n);
          case "textarea":
            return void function (e, t) {
              rn(e, t);
            }(e, n);
          case "select":
            return void function (e, t) {
              var n = e,
                r = t.value;
              null != r && Zt(n, !!t.multiple, r, !1);
            }(e, n);
        }
      }, fr = a_, br = ow, yr = aw;
      var d_ = {
        usingClientEntryPoint: !1,
        Events: [$l, Wl, Yl, gr, vr, ow]
      };
      var f_ = function (e) {
        var t = e.findFiberByHostInstance,
          r = n.ReactCurrentDispatcher;
        return function (e) {
          if ("undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
          var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (t.isDisabled) return !0;
          if (!t.supportsFiber) return o("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
          try {
            z && (e = Ge({}, e, {
              getLaneLabelMap: Vi,
              injectProfilingHooks: Hi
            })), ji = t.inject(e), Fi = t;
          } catch (e) {
            o("React instrumentation encountered an error: %s.", e);
          }
          return !!t.checkDCE;
        }({
          bundleType: e.bundleType,
          version: e.version,
          rendererPackageName: e.rendererPackageName,
          rendererConfig: e.rendererConfig,
          overrideHookState: OA,
          overrideHookStateDeletePath: LA,
          overrideHookStateRenamePath: NA,
          overrideProps: DA,
          overridePropsDeletePath: BA,
          overridePropsRenamePath: jA,
          setErrorHandler: zA,
          setSuspenseHandler: UA,
          scheduleUpdate: FA,
          currentDispatcherRef: r,
          findHostInstanceByFiber: GA,
          findFiberByHostInstance: t || QA,
          findHostInstancesForRefresh: nA,
          scheduleRefresh: Jw,
          scheduleRoot: Xw,
          setRefreshHandler: $w,
          getCurrentFiber: ZA,
          reconcilerVersion: AA
        });
      }({
        findFiberByHostInstance: Vl,
        bundleType: 1,
        version: AA,
        rendererPackageName: "react-dom"
      });
      if (!f_ && Y && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && -1 === navigator.userAgent.indexOf("Edge") || navigator.userAgent.indexOf("Firefox") > -1)) {
        var h_ = window.location.protocol;
        /^(https?|file):$/.test(h_) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + ("file:" === h_ ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
      }
      WB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = d_, WB.createPortal = function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        if (!t_(t)) throw new Error("Target container is not a DOM element.");
        return _A(e, t, null, n);
      }, WB.createRoot = function (e, t) {
        return d_.usingClientEntryPoint || o('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), function (e, t) {
          if (!t_(e)) throw new Error("createRoot(...): Target container is not a DOM element.");
          r_(e);
          var n = !1,
            r = "",
            a = JA;
          null != t && (t.hydrate ? i("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : "object" == typeof t && null !== t && t.$$typeof === Me && o("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);"), !0 === t.unstable_strictMode && (n = !0), void 0 !== t.identifierPrefix && (r = t.identifierPrefix), void 0 !== t.onRecoverableError && (a = t.onRecoverableError), void 0 !== t.transitionCallbacks && t.transitionCallbacks);
          var s = SA(e, Sd, 0, n, 0, r, a);
          return ql(s.current, e), pc(e.nodeType === mn ? e.parentNode : e), new XA(s);
        }(e, t);
      }, WB.findDOMNode = function (e) {
        var t = s_.current;
        return null !== t && null !== t.stateNode && (t.stateNode._warnedAboutRefsInRender || o("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", lt(t.type) || "A component"), t.stateNode._warnedAboutRefsInRender = !0), null == e ? null : e.nodeType === hn ? e : function (e, t) {
          var n = Br(e);
          if (void 0 === n) {
            if ("function" == typeof e.render) throw new Error("Unable to find node on an unmounted component.");
            var r = Object.keys(e).join(",");
            throw new Error("Argument appears to not be a ReactComponent. Keys: " + r);
          }
          var i = Ai(n);
          if (null === i) return null;
          if (i.mode & ao) {
            var a = ft(n) || "Component";
            if (!wA[a]) {
              wA[a] = !0;
              var s = pt;
              try {
                yt(i), n.mode & ao ? o("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, a) : o("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, a);
              } finally {
                s ? yt(s) : bt();
              }
            }
          }
          return i.stateNode;
        }(e, "findDOMNode");
      }, WB.flushSync = function (e) {
        return sw() && o("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), aw(e);
      }, WB.hydrate = function (e, t, n) {
        if (o("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !n_(t)) throw new Error("Target container is not a DOM element.");
        return Hl(t) && void 0 === t._reactRootContainer && o("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?"), l_(null, e, t, !0, n);
      }, WB.hydrateRoot = function (e, t, n) {
        return d_.usingClientEntryPoint || o('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), function (e, t, n) {
          if (!t_(e)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
          r_(e), void 0 === t && o("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
          var r = null != n && n.hydratedSources || null,
            i = !1,
            a = "",
            s = JA;
          null != n && (!0 === n.unstable_strictMode && (i = !0), void 0 !== n.identifierPrefix && (a = n.identifierPrefix), void 0 !== n.onRecoverableError && (s = n.onRecoverableError));
          var u = kA(t, null, e, Sd, 0, i, 0, a, s);
          if (ql(u.current, e), pc(e), r) for (var c = 0; c < r.length; c++) Ip(u, r[c]);
          return new e_(u);
        }(e, t, n);
      }, WB.render = function (e, t, n) {
        if (o("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !n_(t)) throw new Error("Target container is not a DOM element.");
        return Hl(t) && void 0 === t._reactRootContainer && o("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?"), l_(null, e, t, !1, n);
      }, WB.unmountComponentAtNode = function (e) {
        if (!n_(e)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        if (Hl(e) && void 0 === e._reactRootContainer && o("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?"), e._reactRootContainer) {
          var t = u_(e);
          return t && !$l(t) && o("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React."), aw(function () {
            l_(null, null, e, !1, function () {
              e._reactRootContainer = null, Kl(e);
            });
          }), !0;
        }
        var n = u_(e),
          r = !(!n || !$l(n)),
          i = e.nodeType === hn && n_(e.parentNode) && !!e.parentNode._reactRootContainer;
        return r && o("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", i ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component."), !1;
      }, WB.unstable_batchedUpdates = ow, WB.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
        return function (e, t, n, r) {
          if (o("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !n_(n)) throw new Error("Target container is not a DOM element.");
          if (null == e || !function (e) {
            return void 0 !== e._reactInternals;
          }(e)) throw new Error("parentComponent must be a valid React Component");
          return l_(e, t, n, !1, r);
        }(e, t, n, r);
      }, WB.version = AA, "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }()), WB;
  }
  function GB() {
    if ($B) return PB;
    $B = 1;
    var e = (VB || (VB = 1, "production" === Be.env.NODE_ENV ? (function e() {
      if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) {
        if ("production" !== Be.env.NODE_ENV) throw new Error("^_^");
        try {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
        } catch (e) {
          console.error(e);
        }
      }
    }(), OB.exports = KB()) : OB.exports = YB()), OB.exports);
    if ("production" === Be.env.NODE_ENV) PB.createRoot = e.createRoot, PB.hydrateRoot = e.hydrateRoot;else {
      var t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      PB.createRoot = function (n, r) {
        t.usingClientEntryPoint = !0;
        try {
          return e.createRoot(n, r);
        } finally {
          t.usingClientEntryPoint = !1;
        }
      }, PB.hydrateRoot = function (n, r, i) {
        t.usingClientEntryPoint = !0;
        try {
          return e.hydrateRoot(n, r, i);
        } finally {
          t.usingClientEntryPoint = !1;
        }
      };
    }
    return PB;
  }
  var QB,
    ZB = {
      exports: {}
    };
  function JB() {
    return QB || (QB = 1, function (e, t) {
      self, e.exports = (() => {
        var e = {
            192: (e, t) => {
              var n,
                r,
                i = function () {
                  var e = function (e, t) {
                    var n = e,
                      r = a[t],
                      i = null,
                      o = 0,
                      u = null,
                      g = [],
                      v = {},
                      y = function (e, t) {
                        i = function (e) {
                          for (var t = new Array(e), n = 0; n < e; n += 1) {
                            t[n] = new Array(e);
                            for (var r = 0; r < e; r += 1) t[n][r] = null;
                          }
                          return t;
                        }(o = 4 * n + 17), w(0, 0), w(o - 7, 0), w(0, o - 7), _(), A(), S(e, t), n >= 7 && E(e), null == u && (u = M(n, r, g)), k(u, t);
                      },
                      w = function (e, t) {
                        for (var n = -1; n <= 7; n += 1) if (!(e + n <= -1 || o <= e + n)) for (var r = -1; r <= 7; r += 1) t + r <= -1 || o <= t + r || (i[e + n][t + r] = 0 <= n && n <= 6 && (0 == r || 6 == r) || 0 <= r && r <= 6 && (0 == n || 6 == n) || 2 <= n && n <= 4 && 2 <= r && r <= 4);
                      },
                      A = function () {
                        for (var e = 8; e < o - 8; e += 1) null == i[e][6] && (i[e][6] = e % 2 == 0);
                        for (var t = 8; t < o - 8; t += 1) null == i[6][t] && (i[6][t] = t % 2 == 0);
                      },
                      _ = function () {
                        for (var e = s.getPatternPosition(n), t = 0; t < e.length; t += 1) for (var r = 0; r < e.length; r += 1) {
                          var o = e[t],
                            a = e[r];
                          if (null == i[o][a]) for (var u = -2; u <= 2; u += 1) for (var c = -2; c <= 2; c += 1) i[o + u][a + c] = -2 == u || 2 == u || -2 == c || 2 == c || 0 == u && 0 == c;
                        }
                      },
                      E = function (e) {
                        for (var t = s.getBCHTypeNumber(n), r = 0; r < 18; r += 1) {
                          var a = !e && 1 == (t >> r & 1);
                          i[Math.floor(r / 3)][r % 3 + o - 8 - 3] = a;
                        }
                        for (r = 0; r < 18; r += 1) a = !e && 1 == (t >> r & 1), i[r % 3 + o - 8 - 3][Math.floor(r / 3)] = a;
                      },
                      S = function (e, t) {
                        for (var n = r << 3 | t, a = s.getBCHTypeInfo(n), u = 0; u < 15; u += 1) {
                          var c = !e && 1 == (a >> u & 1);
                          u < 6 ? i[u][8] = c : u < 8 ? i[u + 1][8] = c : i[o - 15 + u][8] = c;
                        }
                        for (u = 0; u < 15; u += 1) c = !e && 1 == (a >> u & 1), u < 8 ? i[8][o - u - 1] = c : u < 9 ? i[8][15 - u - 1 + 1] = c : i[8][15 - u - 1] = c;
                        i[o - 8][8] = !e;
                      },
                      k = function (e, t) {
                        for (var n = -1, r = o - 1, a = 7, u = 0, c = s.getMaskFunction(t), l = o - 1; l > 0; l -= 2) for (6 == l && (l -= 1);;) {
                          for (var d = 0; d < 2; d += 1) if (null == i[r][l - d]) {
                            var f = !1;
                            u < e.length && (f = 1 == (e[u] >>> a & 1)), c(r, l - d) && (f = !f), i[r][l - d] = f, -1 == (a -= 1) && (u += 1, a = 7);
                          }
                          if ((r += n) < 0 || o <= r) {
                            r -= n, n = -n;
                            break;
                          }
                        }
                      },
                      M = function (e, t, n) {
                        for (var r = l.getRSBlocks(e, t), i = d(), o = 0; o < n.length; o += 1) {
                          var a = n[o];
                          i.put(a.getMode(), 4), i.put(a.getLength(), s.getLengthInBits(a.getMode(), e)), a.write(i);
                        }
                        var u = 0;
                        for (o = 0; o < r.length; o += 1) u += r[o].dataCount;
                        if (i.getLengthInBits() > 8 * u) throw "code length overflow. (" + i.getLengthInBits() + ">" + 8 * u + ")";
                        for (i.getLengthInBits() + 4 <= 8 * u && i.put(0, 4); i.getLengthInBits() % 8 != 0;) i.putBit(!1);
                        for (; !(i.getLengthInBits() >= 8 * u || (i.put(236, 8), i.getLengthInBits() >= 8 * u));) i.put(17, 8);
                        return function (e, t) {
                          for (var n = 0, r = 0, i = 0, o = new Array(t.length), a = new Array(t.length), u = 0; u < t.length; u += 1) {
                            var l = t[u].dataCount,
                              d = t[u].totalCount - l;
                            r = Math.max(r, l), i = Math.max(i, d), o[u] = new Array(l);
                            for (var f = 0; f < o[u].length; f += 1) o[u][f] = 255 & e.getBuffer()[f + n];
                            n += l;
                            var h = s.getErrorCorrectPolynomial(d),
                              p = c(o[u], h.getLength() - 1).mod(h);
                            for (a[u] = new Array(h.getLength() - 1), f = 0; f < a[u].length; f += 1) {
                              var m = f + p.getLength() - a[u].length;
                              a[u][f] = m >= 0 ? p.getAt(m) : 0;
                            }
                          }
                          var g = 0;
                          for (f = 0; f < t.length; f += 1) g += t[f].totalCount;
                          var v = new Array(g),
                            b = 0;
                          for (f = 0; f < r; f += 1) for (u = 0; u < t.length; u += 1) f < o[u].length && (v[b] = o[u][f], b += 1);
                          for (f = 0; f < i; f += 1) for (u = 0; u < t.length; u += 1) f < a[u].length && (v[b] = a[u][f], b += 1);
                          return v;
                        }(i, r);
                      };
                    v.addData = function (e, t) {
                      var n = null;
                      switch (t = t || "Byte") {
                        case "Numeric":
                          n = f(e);
                          break;
                        case "Alphanumeric":
                          n = h(e);
                          break;
                        case "Byte":
                          n = p(e);
                          break;
                        case "Kanji":
                          n = m(e);
                          break;
                        default:
                          throw "mode:" + t;
                      }
                      g.push(n), u = null;
                    }, v.isDark = function (e, t) {
                      if (e < 0 || o <= e || t < 0 || o <= t) throw e + "," + t;
                      return i[e][t];
                    }, v.getModuleCount = function () {
                      return o;
                    }, v.make = function () {
                      if (n < 1) {
                        for (var e = 1; e < 40; e++) {
                          for (var t = l.getRSBlocks(e, r), i = d(), o = 0; o < g.length; o++) {
                            var a = g[o];
                            i.put(a.getMode(), 4), i.put(a.getLength(), s.getLengthInBits(a.getMode(), e)), a.write(i);
                          }
                          var u = 0;
                          for (o = 0; o < t.length; o++) u += t[o].dataCount;
                          if (i.getLengthInBits() <= 8 * u) break;
                        }
                        n = e;
                      }
                      y(!1, function () {
                        for (var e = 0, t = 0, n = 0; n < 8; n += 1) {
                          y(!0, n);
                          var r = s.getLostPoint(v);
                          (0 == n || e > r) && (e = r, t = n);
                        }
                        return t;
                      }());
                    }, v.createTableTag = function (e, t) {
                      e = e || 2;
                      var n = "";
                      n += '<table style="', n += " border-width: 0px; border-style: none;", n += " border-collapse: collapse;", n += " padding: 0px; margin: " + (t = void 0 === t ? 4 * e : t) + "px;", n += '">', n += "<tbody>";
                      for (var r = 0; r < v.getModuleCount(); r += 1) {
                        n += "<tr>";
                        for (var i = 0; i < v.getModuleCount(); i += 1) n += '<td style="', n += " border-width: 0px; border-style: none;", n += " border-collapse: collapse;", n += " padding: 0px; margin: 0px;", n += " width: " + e + "px;", n += " height: " + e + "px;", n += " background-color: ", n += v.isDark(r, i) ? "#000000" : "#ffffff", n += ";", n += '"/>';
                        n += "</tr>";
                      }
                      return (n += "</tbody>") + "</table>";
                    }, v.createSvgTag = function (e, t, n, r) {
                      var i = {};
                      "object" == typeof arguments[0] && (e = (i = arguments[0]).cellSize, t = i.margin, n = i.alt, r = i.title), e = e || 2, t = void 0 === t ? 4 * e : t, (n = "string" == typeof n ? {
                        text: n
                      } : n || {}).text = n.text || null, n.id = n.text ? n.id || "qrcode-description" : null, (r = "string" == typeof r ? {
                        text: r
                      } : r || {}).text = r.text || null, r.id = r.text ? r.id || "qrcode-title" : null;
                      var o,
                        a,
                        s,
                        u,
                        c = v.getModuleCount() * e + 2 * t,
                        l = "";
                      for (u = "l" + e + ",0 0," + e + " -" + e + ",0 0,-" + e + "z ", l += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"', l += i.scalable ? "" : ' width="' + c + 'px" height="' + c + 'px"', l += ' viewBox="0 0 ' + c + " " + c + '" ', l += ' preserveAspectRatio="xMinYMin meet"', l += r.text || n.text ? ' role="img" aria-labelledby="' + C([r.id, n.id].join(" ").trim()) + '"' : "", l += ">", l += r.text ? '<title id="' + C(r.id) + '">' + C(r.text) + "</title>" : "", l += n.text ? '<description id="' + C(n.id) + '">' + C(n.text) + "</description>" : "", l += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>', l += '<path d="', a = 0; a < v.getModuleCount(); a += 1) for (s = a * e + t, o = 0; o < v.getModuleCount(); o += 1) v.isDark(a, o) && (l += "M" + (o * e + t) + "," + s + u);
                      return (l += '" stroke="transparent" fill="black"/>') + "</svg>";
                    }, v.createDataURL = function (e, t) {
                      e = e || 2, t = void 0 === t ? 4 * e : t;
                      var n = v.getModuleCount() * e + 2 * t,
                        r = t,
                        i = n - t;
                      return b(n, n, function (t, n) {
                        if (r <= t && t < i && r <= n && n < i) {
                          var o = Math.floor((t - r) / e),
                            a = Math.floor((n - r) / e);
                          return v.isDark(a, o) ? 0 : 1;
                        }
                        return 1;
                      });
                    }, v.createImgTag = function (e, t, n) {
                      e = e || 2, t = void 0 === t ? 4 * e : t;
                      var r = v.getModuleCount() * e + 2 * t,
                        i = "";
                      return i += "<img", i += ' src="', i += v.createDataURL(e, t), i += '"', i += ' width="', i += r, i += '"', i += ' height="', i += r, i += '"', n && (i += ' alt="', i += C(n), i += '"'), i + "/>";
                    };
                    var C = function (e) {
                      for (var t = "", n = 0; n < e.length; n += 1) {
                        var r = e.charAt(n);
                        switch (r) {
                          case "<":
                            t += "&lt;";
                            break;
                          case ">":
                            t += "&gt;";
                            break;
                          case "&":
                            t += "&amp;";
                            break;
                          case '"':
                            t += "&quot;";
                            break;
                          default:
                            t += r;
                        }
                      }
                      return t;
                    };
                    return v.createASCII = function (e, t) {
                      if ((e = e || 1) < 2) return function (e) {
                        e = void 0 === e ? 2 : e;
                        var t,
                          n,
                          r,
                          i,
                          o,
                          a = 1 * v.getModuleCount() + 2 * e,
                          s = e,
                          u = a - e,
                          c = {
                            "██": "█",
                            "█ ": "▀",
                            " █": "▄",
                            "  ": " "
                          },
                          l = {
                            "██": "▀",
                            "█ ": "▀",
                            " █": " ",
                            "  ": " "
                          },
                          d = "";
                        for (t = 0; t < a; t += 2) {
                          for (r = Math.floor((t - s) / 1), i = Math.floor((t + 1 - s) / 1), n = 0; n < a; n += 1) o = "█", s <= n && n < u && s <= t && t < u && v.isDark(r, Math.floor((n - s) / 1)) && (o = " "), s <= n && n < u && s <= t + 1 && t + 1 < u && v.isDark(i, Math.floor((n - s) / 1)) ? o += " " : o += "█", d += e < 1 && t + 1 >= u ? l[o] : c[o];
                          d += "\n";
                        }
                        return a % 2 && e > 0 ? d.substring(0, d.length - a - 1) + Array(a + 1).join("▀") : d.substring(0, d.length - 1);
                      }(t);
                      e -= 1, t = void 0 === t ? 2 * e : t;
                      var n,
                        r,
                        i,
                        o,
                        a = v.getModuleCount() * e + 2 * t,
                        s = t,
                        u = a - t,
                        c = Array(e + 1).join("██"),
                        l = Array(e + 1).join("  "),
                        d = "",
                        f = "";
                      for (n = 0; n < a; n += 1) {
                        for (i = Math.floor((n - s) / e), f = "", r = 0; r < a; r += 1) o = 1, s <= r && r < u && s <= n && n < u && v.isDark(i, Math.floor((r - s) / e)) && (o = 0), f += o ? c : l;
                        for (i = 0; i < e; i += 1) d += f + "\n";
                      }
                      return d.substring(0, d.length - 1);
                    }, v.renderTo2dContext = function (e, t) {
                      t = t || 2;
                      for (var n = v.getModuleCount(), r = 0; r < n; r++) for (var i = 0; i < n; i++) e.fillStyle = v.isDark(r, i) ? "black" : "white", e.fillRect(r * t, i * t, t, t);
                    }, v;
                  };
                  e.stringToBytes = (e.stringToBytesFuncs = {
                    default: function (e) {
                      for (var t = [], n = 0; n < e.length; n += 1) {
                        var r = e.charCodeAt(n);
                        t.push(255 & r);
                      }
                      return t;
                    }
                  }).default, e.createStringToBytes = function (e, t) {
                    var n = function () {
                        for (var n = v(e), r = function () {
                            var e = n.read();
                            if (-1 == e) throw "eof";
                            return e;
                          }, i = 0, o = {};;) {
                          var a = n.read();
                          if (-1 == a) break;
                          var s = r(),
                            u = r() << 8 | r();
                          o[String.fromCharCode(a << 8 | s)] = u, i += 1;
                        }
                        if (i != t) throw i + " != " + t;
                        return o;
                      }(),
                      r = "?".charCodeAt(0);
                    return function (e) {
                      for (var t = [], i = 0; i < e.length; i += 1) {
                        var o = e.charCodeAt(i);
                        if (o < 128) t.push(o);else {
                          var a = n[e.charAt(i)];
                          "number" == typeof a ? (255 & a) == a ? t.push(a) : (t.push(a >>> 8), t.push(255 & a)) : t.push(r);
                        }
                      }
                      return t;
                    };
                  };
                  var t,
                    n,
                    r,
                    i,
                    o,
                    a = {
                      L: 1,
                      M: 0,
                      Q: 3,
                      H: 2
                    },
                    s = (t = [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]], n = 1335, r = 7973, o = function (e) {
                      for (var t = 0; 0 != e;) t += 1, e >>>= 1;
                      return t;
                    }, (i = {}).getBCHTypeInfo = function (e) {
                      for (var t = e << 10; o(t) - o(n) >= 0;) t ^= n << o(t) - o(n);
                      return 21522 ^ (e << 10 | t);
                    }, i.getBCHTypeNumber = function (e) {
                      for (var t = e << 12; o(t) - o(r) >= 0;) t ^= r << o(t) - o(r);
                      return e << 12 | t;
                    }, i.getPatternPosition = function (e) {
                      return t[e - 1];
                    }, i.getMaskFunction = function (e) {
                      switch (e) {
                        case 0:
                          return function (e, t) {
                            return (e + t) % 2 == 0;
                          };
                        case 1:
                          return function (e, t) {
                            return e % 2 == 0;
                          };
                        case 2:
                          return function (e, t) {
                            return t % 3 == 0;
                          };
                        case 3:
                          return function (e, t) {
                            return (e + t) % 3 == 0;
                          };
                        case 4:
                          return function (e, t) {
                            return (Math.floor(e / 2) + Math.floor(t / 3)) % 2 == 0;
                          };
                        case 5:
                          return function (e, t) {
                            return e * t % 2 + e * t % 3 == 0;
                          };
                        case 6:
                          return function (e, t) {
                            return (e * t % 2 + e * t % 3) % 2 == 0;
                          };
                        case 7:
                          return function (e, t) {
                            return (e * t % 3 + (e + t) % 2) % 2 == 0;
                          };
                        default:
                          throw "bad maskPattern:" + e;
                      }
                    }, i.getErrorCorrectPolynomial = function (e) {
                      for (var t = c([1], 0), n = 0; n < e; n += 1) t = t.multiply(c([1, u.gexp(n)], 0));
                      return t;
                    }, i.getLengthInBits = function (e, t) {
                      if (1 <= t && t < 10) switch (e) {
                        case 1:
                          return 10;
                        case 2:
                          return 9;
                        case 4:
                        case 8:
                          return 8;
                        default:
                          throw "mode:" + e;
                      } else if (t < 27) switch (e) {
                        case 1:
                          return 12;
                        case 2:
                          return 11;
                        case 4:
                          return 16;
                        case 8:
                          return 10;
                        default:
                          throw "mode:" + e;
                      } else {
                        if (!(t < 41)) throw "type:" + t;
                        switch (e) {
                          case 1:
                            return 14;
                          case 2:
                            return 13;
                          case 4:
                            return 16;
                          case 8:
                            return 12;
                          default:
                            throw "mode:" + e;
                        }
                      }
                    }, i.getLostPoint = function (e) {
                      for (var t = e.getModuleCount(), n = 0, r = 0; r < t; r += 1) for (var i = 0; i < t; i += 1) {
                        for (var o = 0, a = e.isDark(r, i), s = -1; s <= 1; s += 1) if (!(r + s < 0 || t <= r + s)) for (var u = -1; u <= 1; u += 1) i + u < 0 || t <= i + u || 0 == s && 0 == u || a == e.isDark(r + s, i + u) && (o += 1);
                        o > 5 && (n += 3 + o - 5);
                      }
                      for (r = 0; r < t - 1; r += 1) for (i = 0; i < t - 1; i += 1) {
                        var c = 0;
                        e.isDark(r, i) && (c += 1), e.isDark(r + 1, i) && (c += 1), e.isDark(r, i + 1) && (c += 1), e.isDark(r + 1, i + 1) && (c += 1), 0 != c && 4 != c || (n += 3);
                      }
                      for (r = 0; r < t; r += 1) for (i = 0; i < t - 6; i += 1) e.isDark(r, i) && !e.isDark(r, i + 1) && e.isDark(r, i + 2) && e.isDark(r, i + 3) && e.isDark(r, i + 4) && !e.isDark(r, i + 5) && e.isDark(r, i + 6) && (n += 40);
                      for (i = 0; i < t; i += 1) for (r = 0; r < t - 6; r += 1) e.isDark(r, i) && !e.isDark(r + 1, i) && e.isDark(r + 2, i) && e.isDark(r + 3, i) && e.isDark(r + 4, i) && !e.isDark(r + 5, i) && e.isDark(r + 6, i) && (n += 40);
                      var l = 0;
                      for (i = 0; i < t; i += 1) for (r = 0; r < t; r += 1) e.isDark(r, i) && (l += 1);
                      return n + Math.abs(100 * l / t / t - 50) / 5 * 10;
                    }, i),
                    u = function () {
                      for (var e = new Array(256), t = new Array(256), n = 0; n < 8; n += 1) e[n] = 1 << n;
                      for (n = 8; n < 256; n += 1) e[n] = e[n - 4] ^ e[n - 5] ^ e[n - 6] ^ e[n - 8];
                      for (n = 0; n < 255; n += 1) t[e[n]] = n;
                      return {
                        glog: function (e) {
                          if (e < 1) throw "glog(" + e + ")";
                          return t[e];
                        },
                        gexp: function (t) {
                          for (; t < 0;) t += 255;
                          for (; t >= 256;) t -= 255;
                          return e[t];
                        }
                      };
                    }();
                  function c(e, t) {
                    if (void 0 === e.length) throw e.length + "/" + t;
                    var n = function () {
                        for (var n = 0; n < e.length && 0 == e[n];) n += 1;
                        for (var r = new Array(e.length - n + t), i = 0; i < e.length - n; i += 1) r[i] = e[i + n];
                        return r;
                      }(),
                      r = {
                        getAt: function (e) {
                          return n[e];
                        },
                        getLength: function () {
                          return n.length;
                        },
                        multiply: function (e) {
                          for (var t = new Array(r.getLength() + e.getLength() - 1), n = 0; n < r.getLength(); n += 1) for (var i = 0; i < e.getLength(); i += 1) t[n + i] ^= u.gexp(u.glog(r.getAt(n)) + u.glog(e.getAt(i)));
                          return c(t, 0);
                        },
                        mod: function (e) {
                          if (r.getLength() - e.getLength() < 0) return r;
                          for (var t = u.glog(r.getAt(0)) - u.glog(e.getAt(0)), n = new Array(r.getLength()), i = 0; i < r.getLength(); i += 1) n[i] = r.getAt(i);
                          for (i = 0; i < e.getLength(); i += 1) n[i] ^= u.gexp(u.glog(e.getAt(i)) + t);
                          return c(n, 0).mod(e);
                        }
                      };
                    return r;
                  }
                  var l = function () {
                      var e = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12, 7, 37, 13], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]],
                        t = function (e, t) {
                          var n = {};
                          return n.totalCount = e, n.dataCount = t, n;
                        },
                        n = {
                          getRSBlocks: function (n, r) {
                            var i = function (t, n) {
                              switch (n) {
                                case a.L:
                                  return e[4 * (t - 1) + 0];
                                case a.M:
                                  return e[4 * (t - 1) + 1];
                                case a.Q:
                                  return e[4 * (t - 1) + 2];
                                case a.H:
                                  return e[4 * (t - 1) + 3];
                                default:
                                  return;
                              }
                            }(n, r);
                            if (void 0 === i) throw "bad rs block @ typeNumber:" + n + "/errorCorrectionLevel:" + r;
                            for (var o = i.length / 3, s = [], u = 0; u < o; u += 1) for (var c = i[3 * u + 0], l = i[3 * u + 1], d = i[3 * u + 2], f = 0; f < c; f += 1) s.push(t(l, d));
                            return s;
                          }
                        };
                      return n;
                    }(),
                    d = function () {
                      var e = [],
                        t = 0,
                        n = {
                          getBuffer: function () {
                            return e;
                          },
                          getAt: function (t) {
                            var n = Math.floor(t / 8);
                            return 1 == (e[n] >>> 7 - t % 8 & 1);
                          },
                          put: function (e, t) {
                            for (var r = 0; r < t; r += 1) n.putBit(1 == (e >>> t - r - 1 & 1));
                          },
                          getLengthInBits: function () {
                            return t;
                          },
                          putBit: function (n) {
                            var r = Math.floor(t / 8);
                            e.length <= r && e.push(0), n && (e[r] |= 128 >>> t % 8), t += 1;
                          }
                        };
                      return n;
                    },
                    f = function (e) {
                      var t = e,
                        n = {
                          getMode: function () {
                            return 1;
                          },
                          getLength: function (e) {
                            return t.length;
                          },
                          write: function (e) {
                            for (var n = t, i = 0; i + 2 < n.length;) e.put(r(n.substring(i, i + 3)), 10), i += 3;
                            i < n.length && (n.length - i == 1 ? e.put(r(n.substring(i, i + 1)), 4) : n.length - i == 2 && e.put(r(n.substring(i, i + 2)), 7));
                          }
                        },
                        r = function (e) {
                          for (var t = 0, n = 0; n < e.length; n += 1) t = 10 * t + i(e.charAt(n));
                          return t;
                        },
                        i = function (e) {
                          if ("0" <= e && e <= "9") return e.charCodeAt(0) - "0".charCodeAt(0);
                          throw "illegal char :" + e;
                        };
                      return n;
                    },
                    h = function (e) {
                      var t = e,
                        n = {
                          getMode: function () {
                            return 2;
                          },
                          getLength: function (e) {
                            return t.length;
                          },
                          write: function (e) {
                            for (var n = t, i = 0; i + 1 < n.length;) e.put(45 * r(n.charAt(i)) + r(n.charAt(i + 1)), 11), i += 2;
                            i < n.length && e.put(r(n.charAt(i)), 6);
                          }
                        },
                        r = function (e) {
                          if ("0" <= e && e <= "9") return e.charCodeAt(0) - "0".charCodeAt(0);
                          if ("A" <= e && e <= "Z") return e.charCodeAt(0) - "A".charCodeAt(0) + 10;
                          switch (e) {
                            case " ":
                              return 36;
                            case "$":
                              return 37;
                            case "%":
                              return 38;
                            case "*":
                              return 39;
                            case "+":
                              return 40;
                            case "-":
                              return 41;
                            case ".":
                              return 42;
                            case "/":
                              return 43;
                            case ":":
                              return 44;
                            default:
                              throw "illegal char :" + e;
                          }
                        };
                      return n;
                    },
                    p = function (t) {
                      var n = e.stringToBytes(t);
                      return {
                        getMode: function () {
                          return 4;
                        },
                        getLength: function (e) {
                          return n.length;
                        },
                        write: function (e) {
                          for (var t = 0; t < n.length; t += 1) e.put(n[t], 8);
                        }
                      };
                    },
                    m = function (t) {
                      var n = e.stringToBytesFuncs.SJIS;
                      if (!n) throw "sjis not supported.";
                      !function (e, t) {
                        var r = n("友");
                        if (2 != r.length || 38726 != (r[0] << 8 | r[1])) throw "sjis not supported.";
                      }();
                      var r = n(t);
                      return {
                        getMode: function () {
                          return 8;
                        },
                        getLength: function (e) {
                          return ~~(r.length / 2);
                        },
                        write: function (e) {
                          for (var t = r, n = 0; n + 1 < t.length;) {
                            var i = (255 & t[n]) << 8 | 255 & t[n + 1];
                            if (33088 <= i && i <= 40956) i -= 33088;else {
                              if (!(57408 <= i && i <= 60351)) throw "illegal char at " + (n + 1) + "/" + i;
                              i -= 49472;
                            }
                            i = 192 * (i >>> 8 & 255) + (255 & i), e.put(i, 13), n += 2;
                          }
                          if (n < t.length) throw "illegal char at " + (n + 1);
                        }
                      };
                    },
                    g = function () {
                      var e = [],
                        t = {
                          writeByte: function (t) {
                            e.push(255 & t);
                          },
                          writeShort: function (e) {
                            t.writeByte(e), t.writeByte(e >>> 8);
                          },
                          writeBytes: function (e, n, r) {
                            n = n || 0, r = r || e.length;
                            for (var i = 0; i < r; i += 1) t.writeByte(e[i + n]);
                          },
                          writeString: function (e) {
                            for (var n = 0; n < e.length; n += 1) t.writeByte(e.charCodeAt(n));
                          },
                          toByteArray: function () {
                            return e;
                          },
                          toString: function () {
                            var t = "";
                            t += "[";
                            for (var n = 0; n < e.length; n += 1) n > 0 && (t += ","), t += e[n];
                            return t + "]";
                          }
                        };
                      return t;
                    },
                    v = function (e) {
                      var t = e,
                        n = 0,
                        r = 0,
                        i = 0,
                        o = {
                          read: function () {
                            for (; i < 8;) {
                              if (n >= t.length) {
                                if (0 == i) return -1;
                                throw "unexpected end of file./" + i;
                              }
                              var e = t.charAt(n);
                              if (n += 1, "=" == e) return i = 0, -1;
                              e.match(/^\s$/) || (r = r << 6 | a(e.charCodeAt(0)), i += 6);
                            }
                            var o = r >>> i - 8 & 255;
                            return i -= 8, o;
                          }
                        },
                        a = function (e) {
                          if (65 <= e && e <= 90) return e - 65;
                          if (97 <= e && e <= 122) return e - 97 + 26;
                          if (48 <= e && e <= 57) return e - 48 + 52;
                          if (43 == e) return 62;
                          if (47 == e) return 63;
                          throw "c:" + e;
                        };
                      return o;
                    },
                    b = function (e, t, n) {
                      for (var r = function (e, t) {
                          var n = e,
                            r = t,
                            i = new Array(e * t),
                            o = {
                              setPixel: function (e, t, r) {
                                i[t * n + e] = r;
                              },
                              write: function (e) {
                                e.writeString("GIF87a"), e.writeShort(n), e.writeShort(r), e.writeByte(128), e.writeByte(0), e.writeByte(0), e.writeByte(0), e.writeByte(0), e.writeByte(0), e.writeByte(255), e.writeByte(255), e.writeByte(255), e.writeString(","), e.writeShort(0), e.writeShort(0), e.writeShort(n), e.writeShort(r), e.writeByte(0);
                                var t = a(2);
                                e.writeByte(2);
                                for (var i = 0; t.length - i > 255;) e.writeByte(255), e.writeBytes(t, i, 255), i += 255;
                                e.writeByte(t.length - i), e.writeBytes(t, i, t.length - i), e.writeByte(0), e.writeString(";");
                              }
                            },
                            a = function (e) {
                              for (var t = 1 << e, n = 1 + (1 << e), r = e + 1, o = s(), a = 0; a < t; a += 1) o.add(String.fromCharCode(a));
                              o.add(String.fromCharCode(t)), o.add(String.fromCharCode(n));
                              var u,
                                c,
                                l,
                                d = g(),
                                f = (u = d, c = 0, l = 0, {
                                  write: function (e, t) {
                                    if (e >>> t != 0) throw "length over";
                                    for (; c + t >= 8;) u.writeByte(255 & (e << c | l)), t -= 8 - c, e >>>= 8 - c, l = 0, c = 0;
                                    l |= e << c, c += t;
                                  },
                                  flush: function () {
                                    c > 0 && u.writeByte(l);
                                  }
                                });
                              f.write(t, r);
                              var h = 0,
                                p = String.fromCharCode(i[h]);
                              for (h += 1; h < i.length;) {
                                var m = String.fromCharCode(i[h]);
                                h += 1, o.contains(p + m) ? p += m : (f.write(o.indexOf(p), r), o.size() < 4095 && (o.size() == 1 << r && (r += 1), o.add(p + m)), p = m);
                              }
                              return f.write(o.indexOf(p), r), f.write(n, r), f.flush(), d.toByteArray();
                            },
                            s = function () {
                              var e = {},
                                t = 0,
                                n = {
                                  add: function (r) {
                                    if (n.contains(r)) throw "dup key:" + r;
                                    e[r] = t, t += 1;
                                  },
                                  size: function () {
                                    return t;
                                  },
                                  indexOf: function (t) {
                                    return e[t];
                                  },
                                  contains: function (t) {
                                    return void 0 !== e[t];
                                  }
                                };
                              return n;
                            };
                          return o;
                        }(e, t), i = 0; i < t; i += 1) for (var o = 0; o < e; o += 1) r.setPixel(o, i, n(o, i));
                      var a = g();
                      r.write(a);
                      for (var s = function () {
                          var e = 0,
                            t = 0,
                            n = 0,
                            r = "",
                            i = {},
                            o = function (e) {
                              r += String.fromCharCode(a(63 & e));
                            },
                            a = function (e) {
                              if (e < 0) ;else {
                                if (e < 26) return 65 + e;
                                if (e < 52) return e - 26 + 97;
                                if (e < 62) return e - 52 + 48;
                                if (62 == e) return 43;
                                if (63 == e) return 47;
                              }
                              throw "n:" + e;
                            };
                          return i.writeByte = function (r) {
                            for (e = e << 8 | 255 & r, t += 8, n += 1; t >= 6;) o(e >>> t - 6), t -= 6;
                          }, i.flush = function () {
                            if (t > 0 && (o(e << 6 - t), e = 0, t = 0), n % 3 != 0) for (var i = 3 - n % 3, a = 0; a < i; a += 1) r += "=";
                          }, i.toString = function () {
                            return r;
                          }, i;
                        }(), u = a.toByteArray(), c = 0; c < u.length; c += 1) s.writeByte(u[c]);
                      return s.flush(), "data:image/gif;base64," + s;
                    };
                  return e;
                }();
              i.stringToBytesFuncs["UTF-8"] = function (e) {
                return function (e) {
                  for (var t = [], n = 0; n < e.length; n++) {
                    var r = e.charCodeAt(n);
                    r < 128 ? t.push(r) : r < 2048 ? t.push(192 | r >> 6, 128 | 63 & r) : r < 55296 || r >= 57344 ? t.push(224 | r >> 12, 128 | r >> 6 & 63, 128 | 63 & r) : (n++, r = 65536 + ((1023 & r) << 10 | 1023 & e.charCodeAt(n)), t.push(240 | r >> 18, 128 | r >> 12 & 63, 128 | r >> 6 & 63, 128 | 63 & r));
                  }
                  return t;
                }(e);
              }, void 0 === (r = "function" == typeof (n = function () {
                return i;
              }) ? n.apply(t, []) : n) || (e.exports = r);
            },
            676: (e, t, n) => {
              n.d(t, {
                default: () => O
              });
              var r = function () {
                  return (r = Object.assign || function (e) {
                    for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    return e;
                  }).apply(this, arguments);
                },
                i = function () {
                  for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
                  var r = Array(e),
                    i = 0;
                  for (t = 0; t < n; t++) for (var o = arguments[t], a = 0, s = o.length; a < s; a++, i++) r[i] = o[a];
                  return r;
                },
                o = function (e) {
                  return !!e && "object" == typeof e && !Array.isArray(e);
                };
              function a(e) {
                for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
                if (!t.length) return e;
                var s = t.shift();
                return void 0 !== s && o(e) && o(s) ? (e = r({}, e), Object.keys(s).forEach(function (t) {
                  var n = e[t],
                    r = s[t];
                  Array.isArray(n) && Array.isArray(r) ? e[t] = r : o(n) && o(r) ? e[t] = a(Object.assign({}, n), r) : e[t] = r;
                }), a.apply(void 0, i([e], t))) : e;
              }
              function s(e, t) {
                var n = document.createElement("a");
                n.download = t, n.href = e, document.body.appendChild(n), n.click(), document.body.removeChild(n);
              }
              function u(e) {
                return t = this, n = void 0, i = function () {
                  return function (e, t) {
                    var n,
                      r,
                      i,
                      o,
                      a = {
                        label: 0,
                        sent: function () {
                          if (1 & i[0]) throw i[1];
                          return i[1];
                        },
                        trys: [],
                        ops: []
                      };
                    return o = {
                      next: s(0),
                      throw: s(1),
                      return: s(2)
                    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                      return this;
                    }), o;
                    function s(o) {
                      return function (s) {
                        return function (o) {
                          if (n) throw new TypeError("Generator is already executing.");
                          for (; a;) try {
                            if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                            switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                              case 0:
                              case 1:
                                i = o;
                                break;
                              case 4:
                                return a.label++, {
                                  value: o[1],
                                  done: !1
                                };
                              case 5:
                                a.label++, r = o[1], o = [0];
                                continue;
                              case 7:
                                o = a.ops.pop(), a.trys.pop();
                                continue;
                              default:
                                if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                  a = 0;
                                  continue;
                                }
                                if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                  a.label = o[1];
                                  break;
                                }
                                if (6 === o[0] && a.label < i[1]) {
                                  a.label = i[1], i = o;
                                  break;
                                }
                                if (i && a.label < i[2]) {
                                  a.label = i[2], a.ops.push(o);
                                  break;
                                }
                                i[2] && a.ops.pop(), a.trys.pop();
                                continue;
                            }
                            o = t.call(e, a);
                          } catch (e) {
                            o = [6, e], r = 0;
                          } finally {
                            n = i = 0;
                          }
                          if (5 & o[0]) throw o[1];
                          return {
                            value: o[0] ? o[1] : void 0,
                            done: !0
                          };
                        }([o, s]);
                      };
                    }
                  }(this, function (t) {
                    return [2, new Promise(function (t) {
                      var n = new XMLHttpRequest();
                      n.onload = function () {
                        var e = new FileReader();
                        e.onloadend = function () {
                          t(e.result);
                        }, e.readAsDataURL(n.response);
                      }, n.open("GET", e), n.responseType = "blob", n.send();
                    })];
                  });
                }, new ((r = void 0) || (r = Promise))(function (e, o) {
                  function a(e) {
                    try {
                      u(i.next(e));
                    } catch (e) {
                      o(e);
                    }
                  }
                  function s(e) {
                    try {
                      u(i.throw(e));
                    } catch (e) {
                      o(e);
                    }
                  }
                  function u(t) {
                    var n;
                    t.done ? e(t.value) : (n = t.value, n instanceof r ? n : new r(function (e) {
                      e(n);
                    })).then(a, s);
                  }
                  u((i = i.apply(t, n || [])).next());
                });
                var t, n, r, i;
              }
              const c = {
                L: .07,
                M: .15,
                Q: .25,
                H: .3
              };
              var l = function () {
                return (l = Object.assign || function (e) {
                  for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                  return e;
                }).apply(this, arguments);
              };
              const d = function () {
                function e(e) {
                  var t = e.svg,
                    n = e.type;
                  this._svg = t, this._type = n;
                }
                return e.prototype.draw = function (e, t, n, r) {
                  var i;
                  switch (this._type) {
                    case "dots":
                      i = this._drawDot;
                      break;
                    case "classy":
                      i = this._drawClassy;
                      break;
                    case "classy-rounded":
                      i = this._drawClassyRounded;
                      break;
                    case "rounded":
                      i = this._drawRounded;
                      break;
                    case "extra-rounded":
                      i = this._drawExtraRounded;
                      break;
                    default:
                      i = this._drawSquare;
                  }
                  i.call(this, {
                    x: e,
                    y: t,
                    size: n,
                    getNeighbor: r
                  });
                }, e.prototype._rotateFigure = function (e) {
                  var t,
                    n = e.x,
                    r = e.y,
                    i = e.size,
                    o = e.rotation,
                    a = void 0 === o ? 0 : o,
                    s = n + i / 2,
                    u = r + i / 2;
                  (0, e.draw)(), null === (t = this._element) || void 0 === t || t.setAttribute("transform", "rotate(" + 180 * a / Math.PI + "," + s + "," + u + ")");
                }, e.prototype._basicDot = function (e) {
                  var t = this,
                    n = e.size,
                    r = e.x,
                    i = e.y;
                  this._rotateFigure(l(l({}, e), {
                    draw: function () {
                      t._element = document.createElementNS("http://www.w3.org/2000/svg", "circle"), t._element.setAttribute("cx", String(r + n / 2)), t._element.setAttribute("cy", String(i + n / 2)), t._element.setAttribute("r", String(n / 2));
                    }
                  }));
                }, e.prototype._basicSquare = function (e) {
                  var t = this,
                    n = e.size,
                    r = e.x,
                    i = e.y;
                  this._rotateFigure(l(l({}, e), {
                    draw: function () {
                      t._element = document.createElementNS("http://www.w3.org/2000/svg", "rect"), t._element.setAttribute("x", String(r)), t._element.setAttribute("y", String(i)), t._element.setAttribute("width", String(n)), t._element.setAttribute("height", String(n));
                    }
                  }));
                }, e.prototype._basicSideRounded = function (e) {
                  var t = this,
                    n = e.size,
                    r = e.x,
                    i = e.y;
                  this._rotateFigure(l(l({}, e), {
                    draw: function () {
                      t._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), t._element.setAttribute("d", "M " + r + " " + i + "v " + n + "h " + n / 2 + "a " + n / 2 + " " + n / 2 + ", 0, 0, 0, 0 " + -n);
                    }
                  }));
                }, e.prototype._basicCornerRounded = function (e) {
                  var t = this,
                    n = e.size,
                    r = e.x,
                    i = e.y;
                  this._rotateFigure(l(l({}, e), {
                    draw: function () {
                      t._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), t._element.setAttribute("d", "M " + r + " " + i + "v " + n + "h " + n + "v " + -n / 2 + "a " + n / 2 + " " + n / 2 + ", 0, 0, 0, " + -n / 2 + " " + -n / 2);
                    }
                  }));
                }, e.prototype._basicCornerExtraRounded = function (e) {
                  var t = this,
                    n = e.size,
                    r = e.x,
                    i = e.y;
                  this._rotateFigure(l(l({}, e), {
                    draw: function () {
                      t._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), t._element.setAttribute("d", "M " + r + " " + i + "v " + n + "h " + n + "a " + n + " " + n + ", 0, 0, 0, " + -n + " " + -n);
                    }
                  }));
                }, e.prototype._basicCornersRounded = function (e) {
                  var t = this,
                    n = e.size,
                    r = e.x,
                    i = e.y;
                  this._rotateFigure(l(l({}, e), {
                    draw: function () {
                      t._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), t._element.setAttribute("d", "M " + r + " " + i + "v " + n / 2 + "a " + n / 2 + " " + n / 2 + ", 0, 0, 0, " + n / 2 + " " + n / 2 + "h " + n / 2 + "v " + -n / 2 + "a " + n / 2 + " " + n / 2 + ", 0, 0, 0, " + -n / 2 + " " + -n / 2);
                    }
                  }));
                }, e.prototype._drawDot = function (e) {
                  var t = e.x,
                    n = e.y,
                    r = e.size;
                  this._basicDot({
                    x: t,
                    y: n,
                    size: r,
                    rotation: 0
                  });
                }, e.prototype._drawSquare = function (e) {
                  var t = e.x,
                    n = e.y,
                    r = e.size;
                  this._basicSquare({
                    x: t,
                    y: n,
                    size: r,
                    rotation: 0
                  });
                }, e.prototype._drawRounded = function (e) {
                  var t = e.x,
                    n = e.y,
                    r = e.size,
                    i = e.getNeighbor,
                    o = i ? +i(-1, 0) : 0,
                    a = i ? +i(1, 0) : 0,
                    s = i ? +i(0, -1) : 0,
                    u = i ? +i(0, 1) : 0,
                    c = o + a + s + u;
                  if (0 !== c) {
                    if (c > 2 || o && a || s && u) this._basicSquare({
                      x: t,
                      y: n,
                      size: r,
                      rotation: 0
                    });else {
                      if (2 === c) {
                        var l = 0;
                        return o && s ? l = Math.PI / 2 : s && a ? l = Math.PI : a && u && (l = -Math.PI / 2), void this._basicCornerRounded({
                          x: t,
                          y: n,
                          size: r,
                          rotation: l
                        });
                      }
                      if (1 === c) return l = 0, s ? l = Math.PI / 2 : a ? l = Math.PI : u && (l = -Math.PI / 2), void this._basicSideRounded({
                        x: t,
                        y: n,
                        size: r,
                        rotation: l
                      });
                    }
                  } else this._basicDot({
                    x: t,
                    y: n,
                    size: r,
                    rotation: 0
                  });
                }, e.prototype._drawExtraRounded = function (e) {
                  var t = e.x,
                    n = e.y,
                    r = e.size,
                    i = e.getNeighbor,
                    o = i ? +i(-1, 0) : 0,
                    a = i ? +i(1, 0) : 0,
                    s = i ? +i(0, -1) : 0,
                    u = i ? +i(0, 1) : 0,
                    c = o + a + s + u;
                  if (0 !== c) {
                    if (c > 2 || o && a || s && u) this._basicSquare({
                      x: t,
                      y: n,
                      size: r,
                      rotation: 0
                    });else {
                      if (2 === c) {
                        var l = 0;
                        return o && s ? l = Math.PI / 2 : s && a ? l = Math.PI : a && u && (l = -Math.PI / 2), void this._basicCornerExtraRounded({
                          x: t,
                          y: n,
                          size: r,
                          rotation: l
                        });
                      }
                      if (1 === c) return l = 0, s ? l = Math.PI / 2 : a ? l = Math.PI : u && (l = -Math.PI / 2), void this._basicSideRounded({
                        x: t,
                        y: n,
                        size: r,
                        rotation: l
                      });
                    }
                  } else this._basicDot({
                    x: t,
                    y: n,
                    size: r,
                    rotation: 0
                  });
                }, e.prototype._drawClassy = function (e) {
                  var t = e.x,
                    n = e.y,
                    r = e.size,
                    i = e.getNeighbor,
                    o = i ? +i(-1, 0) : 0,
                    a = i ? +i(1, 0) : 0,
                    s = i ? +i(0, -1) : 0,
                    u = i ? +i(0, 1) : 0;
                  0 !== o + a + s + u ? o || s ? a || u ? this._basicSquare({
                    x: t,
                    y: n,
                    size: r,
                    rotation: 0
                  }) : this._basicCornerRounded({
                    x: t,
                    y: n,
                    size: r,
                    rotation: Math.PI / 2
                  }) : this._basicCornerRounded({
                    x: t,
                    y: n,
                    size: r,
                    rotation: -Math.PI / 2
                  }) : this._basicCornersRounded({
                    x: t,
                    y: n,
                    size: r,
                    rotation: Math.PI / 2
                  });
                }, e.prototype._drawClassyRounded = function (e) {
                  var t = e.x,
                    n = e.y,
                    r = e.size,
                    i = e.getNeighbor,
                    o = i ? +i(-1, 0) : 0,
                    a = i ? +i(1, 0) : 0,
                    s = i ? +i(0, -1) : 0,
                    u = i ? +i(0, 1) : 0;
                  0 !== o + a + s + u ? o || s ? a || u ? this._basicSquare({
                    x: t,
                    y: n,
                    size: r,
                    rotation: 0
                  }) : this._basicCornerExtraRounded({
                    x: t,
                    y: n,
                    size: r,
                    rotation: Math.PI / 2
                  }) : this._basicCornerExtraRounded({
                    x: t,
                    y: n,
                    size: r,
                    rotation: -Math.PI / 2
                  }) : this._basicCornersRounded({
                    x: t,
                    y: n,
                    size: r,
                    rotation: Math.PI / 2
                  });
                }, e;
              }();
              var f = function () {
                return (f = Object.assign || function (e) {
                  for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                  return e;
                }).apply(this, arguments);
              };
              const h = function () {
                function e(e) {
                  var t = e.svg,
                    n = e.type;
                  this._svg = t, this._type = n;
                }
                return e.prototype.draw = function (e, t, n, r) {
                  var i;
                  switch (this._type) {
                    case "square":
                      i = this._drawSquare;
                      break;
                    case "extra-rounded":
                      i = this._drawExtraRounded;
                      break;
                    default:
                      i = this._drawDot;
                  }
                  i.call(this, {
                    x: e,
                    y: t,
                    size: n,
                    rotation: r
                  });
                }, e.prototype._rotateFigure = function (e) {
                  var t,
                    n = e.x,
                    r = e.y,
                    i = e.size,
                    o = e.rotation,
                    a = void 0 === o ? 0 : o,
                    s = n + i / 2,
                    u = r + i / 2;
                  (0, e.draw)(), null === (t = this._element) || void 0 === t || t.setAttribute("transform", "rotate(" + 180 * a / Math.PI + "," + s + "," + u + ")");
                }, e.prototype._basicDot = function (e) {
                  var t = this,
                    n = e.size,
                    r = e.x,
                    i = e.y,
                    o = n / 7;
                  this._rotateFigure(f(f({}, e), {
                    draw: function () {
                      t._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), t._element.setAttribute("clip-rule", "evenodd"), t._element.setAttribute("d", "M " + (r + n / 2) + " " + i + "a " + n / 2 + " " + n / 2 + " 0 1 0 0.1 0zm 0 " + o + "a " + (n / 2 - o) + " " + (n / 2 - o) + " 0 1 1 -0.1 0Z");
                    }
                  }));
                }, e.prototype._basicSquare = function (e) {
                  var t = this,
                    n = e.size,
                    r = e.x,
                    i = e.y,
                    o = n / 7;
                  this._rotateFigure(f(f({}, e), {
                    draw: function () {
                      t._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), t._element.setAttribute("clip-rule", "evenodd"), t._element.setAttribute("d", "M " + r + " " + i + "v " + n + "h " + n + "v " + -n + "zM " + (r + o) + " " + (i + o) + "h " + (n - 2 * o) + "v " + (n - 2 * o) + "h " + (2 * o - n) + "z");
                    }
                  }));
                }, e.prototype._basicExtraRounded = function (e) {
                  var t = this,
                    n = e.size,
                    r = e.x,
                    i = e.y,
                    o = n / 7;
                  this._rotateFigure(f(f({}, e), {
                    draw: function () {
                      t._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), t._element.setAttribute("clip-rule", "evenodd"), t._element.setAttribute("d", "M " + r + " " + (i + 2.5 * o) + "v " + 2 * o + "a " + 2.5 * o + " " + 2.5 * o + ", 0, 0, 0, " + 2.5 * o + " " + 2.5 * o + "h " + 2 * o + "a " + 2.5 * o + " " + 2.5 * o + ", 0, 0, 0, " + 2.5 * o + " " + 2.5 * -o + "v " + -2 * o + "a " + 2.5 * o + " " + 2.5 * o + ", 0, 0, 0, " + 2.5 * -o + " " + 2.5 * -o + "h " + -2 * o + "a " + 2.5 * o + " " + 2.5 * o + ", 0, 0, 0, " + 2.5 * -o + " " + 2.5 * o + "M " + (r + 2.5 * o) + " " + (i + o) + "h " + 2 * o + "a " + 1.5 * o + " " + 1.5 * o + ", 0, 0, 1, " + 1.5 * o + " " + 1.5 * o + "v " + 2 * o + "a " + 1.5 * o + " " + 1.5 * o + ", 0, 0, 1, " + 1.5 * -o + " " + 1.5 * o + "h " + -2 * o + "a " + 1.5 * o + " " + 1.5 * o + ", 0, 0, 1, " + 1.5 * -o + " " + 1.5 * -o + "v " + -2 * o + "a " + 1.5 * o + " " + 1.5 * o + ", 0, 0, 1, " + 1.5 * o + " " + 1.5 * -o);
                    }
                  }));
                }, e.prototype._drawDot = function (e) {
                  var t = e.x,
                    n = e.y,
                    r = e.size,
                    i = e.rotation;
                  this._basicDot({
                    x: t,
                    y: n,
                    size: r,
                    rotation: i
                  });
                }, e.prototype._drawSquare = function (e) {
                  var t = e.x,
                    n = e.y,
                    r = e.size,
                    i = e.rotation;
                  this._basicSquare({
                    x: t,
                    y: n,
                    size: r,
                    rotation: i
                  });
                }, e.prototype._drawExtraRounded = function (e) {
                  var t = e.x,
                    n = e.y,
                    r = e.size,
                    i = e.rotation;
                  this._basicExtraRounded({
                    x: t,
                    y: n,
                    size: r,
                    rotation: i
                  });
                }, e;
              }();
              var p = function () {
                return (p = Object.assign || function (e) {
                  for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                  return e;
                }).apply(this, arguments);
              };
              const m = function () {
                  function e(e) {
                    var t = e.svg,
                      n = e.type;
                    this._svg = t, this._type = n;
                  }
                  return e.prototype.draw = function (e, t, n, r) {
                    ("square" === this._type ? this._drawSquare : this._drawDot).call(this, {
                      x: e,
                      y: t,
                      size: n,
                      rotation: r
                    });
                  }, e.prototype._rotateFigure = function (e) {
                    var t,
                      n = e.x,
                      r = e.y,
                      i = e.size,
                      o = e.rotation,
                      a = void 0 === o ? 0 : o,
                      s = n + i / 2,
                      u = r + i / 2;
                    (0, e.draw)(), null === (t = this._element) || void 0 === t || t.setAttribute("transform", "rotate(" + 180 * a / Math.PI + "," + s + "," + u + ")");
                  }, e.prototype._basicDot = function (e) {
                    var t = this,
                      n = e.size,
                      r = e.x,
                      i = e.y;
                    this._rotateFigure(p(p({}, e), {
                      draw: function () {
                        t._element = document.createElementNS("http://www.w3.org/2000/svg", "circle"), t._element.setAttribute("cx", String(r + n / 2)), t._element.setAttribute("cy", String(i + n / 2)), t._element.setAttribute("r", String(n / 2));
                      }
                    }));
                  }, e.prototype._basicSquare = function (e) {
                    var t = this,
                      n = e.size,
                      r = e.x,
                      i = e.y;
                    this._rotateFigure(p(p({}, e), {
                      draw: function () {
                        t._element = document.createElementNS("http://www.w3.org/2000/svg", "rect"), t._element.setAttribute("x", String(r)), t._element.setAttribute("y", String(i)), t._element.setAttribute("width", String(n)), t._element.setAttribute("height", String(n));
                      }
                    }));
                  }, e.prototype._drawDot = function (e) {
                    var t = e.x,
                      n = e.y,
                      r = e.size,
                      i = e.rotation;
                    this._basicDot({
                      x: t,
                      y: n,
                      size: r,
                      rotation: i
                    });
                  }, e.prototype._drawSquare = function (e) {
                    var t = e.x,
                      n = e.y,
                      r = e.size,
                      i = e.rotation;
                    this._basicSquare({
                      x: t,
                      y: n,
                      size: r,
                      rotation: i
                    });
                  }, e;
                }(),
                g = "circle";
              var v = function (e, t, n, r) {
                  return new (n || (n = Promise))(function (i, o) {
                    function a(e) {
                      try {
                        u(r.next(e));
                      } catch (e) {
                        o(e);
                      }
                    }
                    function s(e) {
                      try {
                        u(r.throw(e));
                      } catch (e) {
                        o(e);
                      }
                    }
                    function u(e) {
                      var t;
                      e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                        e(t);
                      })).then(a, s);
                    }
                    u((r = r.apply(e, t || [])).next());
                  });
                },
                b = function (e, t) {
                  var n,
                    r,
                    i,
                    o,
                    a = {
                      label: 0,
                      sent: function () {
                        if (1 & i[0]) throw i[1];
                        return i[1];
                      },
                      trys: [],
                      ops: []
                    };
                  return o = {
                    next: s(0),
                    throw: s(1),
                    return: s(2)
                  }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this;
                  }), o;
                  function s(o) {
                    return function (s) {
                      return function (o) {
                        if (n) throw new TypeError("Generator is already executing.");
                        for (; a;) try {
                          if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                          switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                            case 0:
                            case 1:
                              i = o;
                              break;
                            case 4:
                              return a.label++, {
                                value: o[1],
                                done: !1
                              };
                            case 5:
                              a.label++, r = o[1], o = [0];
                              continue;
                            case 7:
                              o = a.ops.pop(), a.trys.pop();
                              continue;
                            default:
                              if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                a = 0;
                                continue;
                              }
                              if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                a.label = o[1];
                                break;
                              }
                              if (6 === o[0] && a.label < i[1]) {
                                a.label = i[1], i = o;
                                break;
                              }
                              if (i && a.label < i[2]) {
                                a.label = i[2], a.ops.push(o);
                                break;
                              }
                              i[2] && a.ops.pop(), a.trys.pop();
                              continue;
                          }
                          o = t.call(e, a);
                        } catch (e) {
                          o = [6, e], r = 0;
                        } finally {
                          n = i = 0;
                        }
                        if (5 & o[0]) throw o[1];
                        return {
                          value: o[0] ? o[1] : void 0,
                          done: !0
                        };
                      }([o, s]);
                    };
                  }
                },
                y = [[1, 1, 1, 1, 1, 1, 1], [1, 0, 0, 0, 0, 0, 1], [1, 0, 0, 0, 0, 0, 1], [1, 0, 0, 0, 0, 0, 1], [1, 0, 0, 0, 0, 0, 1], [1, 0, 0, 0, 0, 0, 1], [1, 1, 1, 1, 1, 1, 1]],
                w = [[0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0], [0, 0, 1, 1, 1, 0, 0], [0, 0, 1, 1, 1, 0, 0], [0, 0, 1, 1, 1, 0, 0], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]];
              const A = function () {
                  function e(e) {
                    this._element = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this._element.setAttribute("width", String(e.width)), this._element.setAttribute("height", String(e.height)), this._defs = document.createElementNS("http://www.w3.org/2000/svg", "defs"), this._element.appendChild(this._defs), this._options = e;
                  }
                  return Object.defineProperty(e.prototype, "width", {
                    get: function () {
                      return this._options.width;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(e.prototype, "height", {
                    get: function () {
                      return this._options.height;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), e.prototype.getElement = function () {
                    return this._element;
                  }, e.prototype.drawQR = function (e) {
                    return v(this, void 0, void 0, function () {
                      var t,
                        n,
                        r,
                        i,
                        o,
                        a,
                        s,
                        u,
                        l,
                        d,
                        f = this;
                      return b(this, function (h) {
                        switch (h.label) {
                          case 0:
                            return t = e.getModuleCount(), n = Math.min(this._options.width, this._options.height) - 2 * this._options.margin, r = this._options.shape === g ? n / Math.sqrt(2) : n, i = Math.floor(r / t), o = {
                              hideXDots: 0,
                              hideYDots: 0,
                              width: 0,
                              height: 0
                            }, this._qr = e, this._options.image ? [4, this.loadImage()] : [3, 2];
                          case 1:
                            if (h.sent(), !this._image) return [2];
                            a = this._options, s = a.imageOptions, u = a.qrOptions, l = s.imageSize * c[u.errorCorrectionLevel], d = Math.floor(l * t * t), o = function (e) {
                              var t = e.originalHeight,
                                n = e.originalWidth,
                                r = e.maxHiddenDots,
                                i = e.maxHiddenAxisDots,
                                o = e.dotSize,
                                a = {
                                  x: 0,
                                  y: 0
                                },
                                s = {
                                  x: 0,
                                  y: 0
                                };
                              if (t <= 0 || n <= 0 || r <= 0 || o <= 0) return {
                                height: 0,
                                width: 0,
                                hideYDots: 0,
                                hideXDots: 0
                              };
                              var u = t / n;
                              return a.x = Math.floor(Math.sqrt(r / u)), a.x <= 0 && (a.x = 1), i && i < a.x && (a.x = i), a.x % 2 == 0 && a.x--, s.x = a.x * o, a.y = 1 + 2 * Math.ceil((a.x * u - 1) / 2), s.y = Math.round(s.x * u), (a.y * a.x > r || i && i < a.y) && (i && i < a.y ? (a.y = i, a.y % 2 == 0 && a.x--) : a.y -= 2, s.y = a.y * o, a.x = 1 + 2 * Math.ceil((a.y / u - 1) / 2), s.x = Math.round(s.y / u)), {
                                height: s.y,
                                width: s.x,
                                hideYDots: a.y,
                                hideXDots: a.x
                              };
                            }({
                              originalWidth: this._image.width,
                              originalHeight: this._image.height,
                              maxHiddenDots: d,
                              maxHiddenAxisDots: t - 14,
                              dotSize: i
                            }), h.label = 2;
                          case 2:
                            return this.drawBackground(), this.drawDots(function (e, n) {
                              var r, i, a, s, u, c;
                              return !(f._options.imageOptions.hideBackgroundDots && e >= (t - o.hideXDots) / 2 && e < (t + o.hideXDots) / 2 && n >= (t - o.hideYDots) / 2 && n < (t + o.hideYDots) / 2 || (null === (r = y[e]) || void 0 === r ? void 0 : r[n]) || (null === (i = y[e - t + 7]) || void 0 === i ? void 0 : i[n]) || (null === (a = y[e]) || void 0 === a ? void 0 : a[n - t + 7]) || (null === (s = w[e]) || void 0 === s ? void 0 : s[n]) || (null === (u = w[e - t + 7]) || void 0 === u ? void 0 : u[n]) || (null === (c = w[e]) || void 0 === c ? void 0 : c[n - t + 7]));
                            }), this.drawCorners(), this._options.image ? [4, this.drawImage({
                              width: o.width,
                              height: o.height,
                              count: t,
                              dotSize: i
                            })] : [3, 4];
                          case 3:
                            h.sent(), h.label = 4;
                          case 4:
                            return [2];
                        }
                      });
                    });
                  }, e.prototype.drawBackground = function () {
                    var e,
                      t,
                      n,
                      r = this._element,
                      i = this._options;
                    if (r) {
                      var o = null === (e = i.backgroundOptions) || void 0 === e ? void 0 : e.gradient,
                        a = null === (t = i.backgroundOptions) || void 0 === t ? void 0 : t.color;
                      if ((o || a) && this._createColor({
                        options: o,
                        color: a,
                        additionalRotation: 0,
                        x: 0,
                        y: 0,
                        height: i.height,
                        width: i.width,
                        name: "background-color"
                      }), null === (n = i.backgroundOptions) || void 0 === n ? void 0 : n.round) {
                        var s = Math.min(i.width, i.height),
                          u = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                        this._backgroundClipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath"), this._backgroundClipPath.setAttribute("id", "clip-path-background-color"), this._defs.appendChild(this._backgroundClipPath), u.setAttribute("x", String((i.width - s) / 2)), u.setAttribute("y", String((i.height - s) / 2)), u.setAttribute("width", String(s)), u.setAttribute("height", String(s)), u.setAttribute("rx", String(s / 2 * i.backgroundOptions.round)), this._backgroundClipPath.appendChild(u);
                      }
                    }
                  }, e.prototype.drawDots = function (e) {
                    var t,
                      n,
                      r = this;
                    if (!this._qr) throw "QR code is not defined";
                    var i = this._options,
                      o = this._qr.getModuleCount();
                    if (o > i.width || o > i.height) throw "The canvas is too small.";
                    var a = Math.min(i.width, i.height) - 2 * i.margin,
                      s = i.shape === g ? a / Math.sqrt(2) : a,
                      u = Math.floor(s / o),
                      c = Math.floor((i.width - o * u) / 2),
                      l = Math.floor((i.height - o * u) / 2),
                      f = new d({
                        svg: this._element,
                        type: i.dotsOptions.type
                      });
                    this._dotsClipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath"), this._dotsClipPath.setAttribute("id", "clip-path-dot-color"), this._defs.appendChild(this._dotsClipPath), this._createColor({
                      options: null === (t = i.dotsOptions) || void 0 === t ? void 0 : t.gradient,
                      color: i.dotsOptions.color,
                      additionalRotation: 0,
                      x: 0,
                      y: 0,
                      height: i.height,
                      width: i.width,
                      name: "dot-color"
                    });
                    for (var h = function (t) {
                        for (var i = function (i) {
                            return e && !e(t, i) ? "continue" : (null === (n = p._qr) || void 0 === n ? void 0 : n.isDark(t, i)) ? (f.draw(c + t * u, l + i * u, u, function (n, a) {
                              return !(t + n < 0 || i + a < 0 || t + n >= o || i + a >= o) && !(e && !e(t + n, i + a)) && !!r._qr && r._qr.isDark(t + n, i + a);
                            }), void (f._element && p._dotsClipPath && p._dotsClipPath.appendChild(f._element))) : "continue";
                          }, a = 0; a < o; a++) i(a);
                      }, p = this, m = 0; m < o; m++) h(m);
                    if (i.shape === g) {
                      var v = Math.floor((a / u - o) / 2),
                        b = o + 2 * v,
                        y = c - v * u,
                        w = l - v * u,
                        A = [],
                        _ = Math.floor(b / 2);
                      for (m = 0; m < b; m++) {
                        A[m] = [];
                        for (var E = 0; E < b; E++) m >= v - 1 && m <= b - v && E >= v - 1 && E <= b - v || Math.sqrt((m - _) * (m - _) + (E - _) * (E - _)) > _ ? A[m][E] = 0 : A[m][E] = this._qr.isDark(E - 2 * v < 0 ? E : E >= o ? E - 2 * v : E - v, m - 2 * v < 0 ? m : m >= o ? m - 2 * v : m - v) ? 1 : 0;
                      }
                      var S = function (e) {
                          for (var t = function (t) {
                              if (!A[e][t]) return "continue";
                              f.draw(y + e * u, w + t * u, u, function (n, r) {
                                var i;
                                return !!(null === (i = A[e + n]) || void 0 === i ? void 0 : i[t + r]);
                              }), f._element && k._dotsClipPath && k._dotsClipPath.appendChild(f._element);
                            }, n = 0; n < b; n++) t(n);
                        },
                        k = this;
                      for (m = 0; m < b; m++) S(m);
                    }
                  }, e.prototype.drawCorners = function () {
                    var e = this;
                    if (!this._qr) throw "QR code is not defined";
                    var t = this._element,
                      n = this._options;
                    if (!t) throw "Element code is not defined";
                    var r = this._qr.getModuleCount(),
                      i = Math.min(n.width, n.height) - 2 * n.margin,
                      o = n.shape === g ? i / Math.sqrt(2) : i,
                      a = Math.floor(o / r),
                      s = 7 * a,
                      u = 3 * a,
                      c = Math.floor((n.width - r * a) / 2),
                      l = Math.floor((n.height - r * a) / 2);
                    [[0, 0, 0], [1, 0, Math.PI / 2], [0, 1, -Math.PI / 2]].forEach(function (t) {
                      var i,
                        o,
                        f,
                        p,
                        g,
                        v,
                        b,
                        A,
                        _,
                        E,
                        S,
                        k,
                        M = t[0],
                        C = t[1],
                        x = t[2],
                        R = c + M * a * (r - 7),
                        I = l + C * a * (r - 7),
                        T = e._dotsClipPath,
                        P = e._dotsClipPath;
                      if (((null === (i = n.cornersSquareOptions) || void 0 === i ? void 0 : i.gradient) || (null === (o = n.cornersSquareOptions) || void 0 === o ? void 0 : o.color)) && ((T = document.createElementNS("http://www.w3.org/2000/svg", "clipPath")).setAttribute("id", "clip-path-corners-square-color-" + M + "-" + C), e._defs.appendChild(T), e._cornersSquareClipPath = e._cornersDotClipPath = P = T, e._createColor({
                        options: null === (f = n.cornersSquareOptions) || void 0 === f ? void 0 : f.gradient,
                        color: null === (p = n.cornersSquareOptions) || void 0 === p ? void 0 : p.color,
                        additionalRotation: x,
                        x: R,
                        y: I,
                        height: s,
                        width: s,
                        name: "corners-square-color-" + M + "-" + C
                      })), null === (g = n.cornersSquareOptions) || void 0 === g ? void 0 : g.type) {
                        var O = new h({
                          svg: e._element,
                          type: n.cornersSquareOptions.type
                        });
                        O.draw(R, I, s, x), O._element && T && T.appendChild(O._element);
                      } else for (var L = new d({
                          svg: e._element,
                          type: n.dotsOptions.type
                        }), N = function (e) {
                          for (var t = function (t) {
                              if (!(null === (v = y[e]) || void 0 === v ? void 0 : v[t])) return "continue";
                              L.draw(R + e * a, I + t * a, a, function (n, r) {
                                var i;
                                return !!(null === (i = y[e + n]) || void 0 === i ? void 0 : i[t + r]);
                              }), L._element && T && T.appendChild(L._element);
                            }, n = 0; n < y[e].length; n++) t(n);
                        }, D = 0; D < y.length; D++) N(D);
                      if (((null === (b = n.cornersDotOptions) || void 0 === b ? void 0 : b.gradient) || (null === (A = n.cornersDotOptions) || void 0 === A ? void 0 : A.color)) && ((P = document.createElementNS("http://www.w3.org/2000/svg", "clipPath")).setAttribute("id", "clip-path-corners-dot-color-" + M + "-" + C), e._defs.appendChild(P), e._cornersDotClipPath = P, e._createColor({
                        options: null === (_ = n.cornersDotOptions) || void 0 === _ ? void 0 : _.gradient,
                        color: null === (E = n.cornersDotOptions) || void 0 === E ? void 0 : E.color,
                        additionalRotation: x,
                        x: R + 2 * a,
                        y: I + 2 * a,
                        height: u,
                        width: u,
                        name: "corners-dot-color-" + M + "-" + C
                      })), null === (S = n.cornersDotOptions) || void 0 === S ? void 0 : S.type) {
                        var B = new m({
                          svg: e._element,
                          type: n.cornersDotOptions.type
                        });
                        B.draw(R + 2 * a, I + 2 * a, u, x), B._element && P && P.appendChild(B._element);
                      } else {
                        L = new d({
                          svg: e._element,
                          type: n.dotsOptions.type
                        });
                        var j = function (e) {
                          for (var t = function (t) {
                              if (!(null === (k = w[e]) || void 0 === k ? void 0 : k[t])) return "continue";
                              L.draw(R + e * a, I + t * a, a, function (n, r) {
                                var i;
                                return !!(null === (i = w[e + n]) || void 0 === i ? void 0 : i[t + r]);
                              }), L._element && P && P.appendChild(L._element);
                            }, n = 0; n < w[e].length; n++) t(n);
                        };
                        for (D = 0; D < w.length; D++) j(D);
                      }
                    });
                  }, e.prototype.loadImage = function () {
                    var e = this;
                    return new Promise(function (t, n) {
                      var r = e._options,
                        i = new Image();
                      if (!r.image) return n("Image is not defined");
                      "string" == typeof r.imageOptions.crossOrigin && (i.crossOrigin = r.imageOptions.crossOrigin), e._image = i, i.onload = function () {
                        t();
                      }, i.src = r.image;
                    });
                  }, e.prototype.drawImage = function (e) {
                    var t = e.width,
                      n = e.height,
                      r = e.count,
                      i = e.dotSize;
                    return v(this, void 0, void 0, function () {
                      var e, o, a, s, c, l, d, f, h;
                      return b(this, function (p) {
                        switch (p.label) {
                          case 0:
                            return e = this._options, o = Math.floor((e.width - r * i) / 2), a = Math.floor((e.height - r * i) / 2), s = o + e.imageOptions.margin + (r * i - t) / 2, c = a + e.imageOptions.margin + (r * i - n) / 2, l = t - 2 * e.imageOptions.margin, d = n - 2 * e.imageOptions.margin, (f = document.createElementNS("http://www.w3.org/2000/svg", "image")).setAttribute("x", String(s)), f.setAttribute("y", String(c)), f.setAttribute("width", l + "px"), f.setAttribute("height", d + "px"), [4, u(e.image || "")];
                          case 1:
                            return h = p.sent(), f.setAttribute("href", h || ""), this._element.appendChild(f), [2];
                        }
                      });
                    });
                  }, e.prototype._createColor = function (e) {
                    var t = e.options,
                      n = e.color,
                      r = e.additionalRotation,
                      i = e.x,
                      o = e.y,
                      a = e.height,
                      s = e.width,
                      u = e.name,
                      c = s > a ? s : a,
                      l = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                    if (l.setAttribute("x", String(i)), l.setAttribute("y", String(o)), l.setAttribute("height", String(a)), l.setAttribute("width", String(s)), l.setAttribute("clip-path", "url('#clip-path-" + u + "')"), t) {
                      var d;
                      if ("radial" === t.type) (d = document.createElementNS("http://www.w3.org/2000/svg", "radialGradient")).setAttribute("id", u), d.setAttribute("gradientUnits", "userSpaceOnUse"), d.setAttribute("fx", String(i + s / 2)), d.setAttribute("fy", String(o + a / 2)), d.setAttribute("cx", String(i + s / 2)), d.setAttribute("cy", String(o + a / 2)), d.setAttribute("r", String(c / 2));else {
                        var f = ((t.rotation || 0) + r) % (2 * Math.PI),
                          h = (f + 2 * Math.PI) % (2 * Math.PI),
                          p = i + s / 2,
                          m = o + a / 2,
                          g = i + s / 2,
                          v = o + a / 2;
                        h >= 0 && h <= .25 * Math.PI || h > 1.75 * Math.PI && h <= 2 * Math.PI ? (p -= s / 2, m -= a / 2 * Math.tan(f), g += s / 2, v += a / 2 * Math.tan(f)) : h > .25 * Math.PI && h <= .75 * Math.PI ? (m -= a / 2, p -= s / 2 / Math.tan(f), v += a / 2, g += s / 2 / Math.tan(f)) : h > .75 * Math.PI && h <= 1.25 * Math.PI ? (p += s / 2, m += a / 2 * Math.tan(f), g -= s / 2, v -= a / 2 * Math.tan(f)) : h > 1.25 * Math.PI && h <= 1.75 * Math.PI && (m += a / 2, p += s / 2 / Math.tan(f), v -= a / 2, g -= s / 2 / Math.tan(f)), (d = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient")).setAttribute("id", u), d.setAttribute("gradientUnits", "userSpaceOnUse"), d.setAttribute("x1", String(Math.round(p))), d.setAttribute("y1", String(Math.round(m))), d.setAttribute("x2", String(Math.round(g))), d.setAttribute("y2", String(Math.round(v)));
                      }
                      t.colorStops.forEach(function (e) {
                        var t = e.offset,
                          n = e.color,
                          r = document.createElementNS("http://www.w3.org/2000/svg", "stop");
                        r.setAttribute("offset", 100 * t + "%"), r.setAttribute("stop-color", n), d.appendChild(r);
                      }), l.setAttribute("fill", "url('#" + u + "')"), this._defs.appendChild(d);
                    } else n && l.setAttribute("fill", n);
                    this._element.appendChild(l);
                  }, e;
                }(),
                _ = "canvas";
              for (var E = {}, S = 0; S <= 40; S++) E[S] = S;
              const k = {
                type: _,
                shape: "square",
                width: 300,
                height: 300,
                data: "",
                margin: 0,
                qrOptions: {
                  typeNumber: E[0],
                  mode: void 0,
                  errorCorrectionLevel: "Q"
                },
                imageOptions: {
                  hideBackgroundDots: !0,
                  imageSize: .4,
                  crossOrigin: void 0,
                  margin: 0
                },
                dotsOptions: {
                  type: "square",
                  color: "#000"
                },
                backgroundOptions: {
                  round: 0,
                  color: "#fff"
                }
              };
              var M = function () {
                return (M = Object.assign || function (e) {
                  for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                  return e;
                }).apply(this, arguments);
              };
              function C(e) {
                var t = M({}, e);
                if (!t.colorStops || !t.colorStops.length) throw "Field 'colorStops' is required in gradient";
                return t.rotation ? t.rotation = Number(t.rotation) : t.rotation = 0, t.colorStops = t.colorStops.map(function (e) {
                  return M(M({}, e), {
                    offset: Number(e.offset)
                  });
                }), t;
              }
              function x(e) {
                var t = M({}, e);
                return t.width = Number(t.width), t.height = Number(t.height), t.margin = Number(t.margin), t.imageOptions = M(M({}, t.imageOptions), {
                  hideBackgroundDots: Boolean(t.imageOptions.hideBackgroundDots),
                  imageSize: Number(t.imageOptions.imageSize),
                  margin: Number(t.imageOptions.margin)
                }), t.margin > Math.min(t.width, t.height) && (t.margin = Math.min(t.width, t.height)), t.dotsOptions = M({}, t.dotsOptions), t.dotsOptions.gradient && (t.dotsOptions.gradient = C(t.dotsOptions.gradient)), t.cornersSquareOptions && (t.cornersSquareOptions = M({}, t.cornersSquareOptions), t.cornersSquareOptions.gradient && (t.cornersSquareOptions.gradient = C(t.cornersSquareOptions.gradient))), t.cornersDotOptions && (t.cornersDotOptions = M({}, t.cornersDotOptions), t.cornersDotOptions.gradient && (t.cornersDotOptions.gradient = C(t.cornersDotOptions.gradient))), t.backgroundOptions && (t.backgroundOptions = M({}, t.backgroundOptions), t.backgroundOptions.gradient && (t.backgroundOptions.gradient = C(t.backgroundOptions.gradient))), t;
              }
              var R = n(192),
                I = n.n(R),
                T = function (e, t, n, r) {
                  return new (n || (n = Promise))(function (i, o) {
                    function a(e) {
                      try {
                        u(r.next(e));
                      } catch (e) {
                        o(e);
                      }
                    }
                    function s(e) {
                      try {
                        u(r.throw(e));
                      } catch (e) {
                        o(e);
                      }
                    }
                    function u(e) {
                      var t;
                      e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                        e(t);
                      })).then(a, s);
                    }
                    u((r = r.apply(e, t || [])).next());
                  });
                },
                P = function (e, t) {
                  var n,
                    r,
                    i,
                    o,
                    a = {
                      label: 0,
                      sent: function () {
                        if (1 & i[0]) throw i[1];
                        return i[1];
                      },
                      trys: [],
                      ops: []
                    };
                  return o = {
                    next: s(0),
                    throw: s(1),
                    return: s(2)
                  }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this;
                  }), o;
                  function s(o) {
                    return function (s) {
                      return function (o) {
                        if (n) throw new TypeError("Generator is already executing.");
                        for (; a;) try {
                          if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                          switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                            case 0:
                            case 1:
                              i = o;
                              break;
                            case 4:
                              return a.label++, {
                                value: o[1],
                                done: !1
                              };
                            case 5:
                              a.label++, r = o[1], o = [0];
                              continue;
                            case 7:
                              o = a.ops.pop(), a.trys.pop();
                              continue;
                            default:
                              if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                a = 0;
                                continue;
                              }
                              if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                a.label = o[1];
                                break;
                              }
                              if (6 === o[0] && a.label < i[1]) {
                                a.label = i[1], i = o;
                                break;
                              }
                              if (i && a.label < i[2]) {
                                a.label = i[2], a.ops.push(o);
                                break;
                              }
                              i[2] && a.ops.pop(), a.trys.pop();
                              continue;
                          }
                          o = t.call(e, a);
                        } catch (e) {
                          o = [6, e], r = 0;
                        } finally {
                          n = i = 0;
                        }
                        if (5 & o[0]) throw o[1];
                        return {
                          value: o[0] ? o[1] : void 0,
                          done: !0
                        };
                      }([o, s]);
                    };
                  }
                };
              const O = function () {
                function e(e) {
                  this._options = e ? x(a(k, e)) : k, this.update();
                }
                return e._clearContainer = function (e) {
                  e && (e.innerHTML = "");
                }, e.prototype._setupSvg = function () {
                  var e = this;
                  if (this._qr) {
                    var t = new A(this._options);
                    this._svg = t.getElement(), this._svgDrawingPromise = t.drawQR(this._qr).then(function () {
                      var n;
                      e._svg && (null === (n = e._extension) || void 0 === n || n.call(e, t.getElement(), e._options));
                    });
                  }
                }, e.prototype._setupCanvas = function () {
                  var e,
                    t = this;
                  this._qr && (this._canvas = document.createElement("canvas"), this._canvas.width = this._options.width, this._canvas.height = this._options.height, this._setupSvg(), this._canvasDrawingPromise = null === (e = this._svgDrawingPromise) || void 0 === e ? void 0 : e.then(function () {
                    if (t._svg) {
                      var e = t._svg,
                        n = new XMLSerializer().serializeToString(e),
                        r = "data:image/svg+xml;base64," + btoa(n),
                        i = new Image();
                      return new Promise(function (e) {
                        i.onload = function () {
                          var n, r;
                          null === (r = null === (n = t._canvas) || void 0 === n ? void 0 : n.getContext("2d")) || void 0 === r || r.drawImage(i, 0, 0), e();
                        }, i.src = r;
                      });
                    }
                  }));
                }, e.prototype._getElement = function (e) {
                  return void 0 === e && (e = "png"), T(this, void 0, void 0, function () {
                    return P(this, function (t) {
                      switch (t.label) {
                        case 0:
                          if (!this._qr) throw "QR code is empty";
                          return "svg" !== e.toLowerCase() ? [3, 2] : (this._svg && this._svgDrawingPromise || this._setupSvg(), [4, this._svgDrawingPromise]);
                        case 1:
                          return t.sent(), [2, this._svg];
                        case 2:
                          return this._canvas && this._canvasDrawingPromise || this._setupCanvas(), [4, this._canvasDrawingPromise];
                        case 3:
                          return t.sent(), [2, this._canvas];
                      }
                    });
                  });
                }, e.prototype.update = function (t) {
                  e._clearContainer(this._container), this._options = t ? x(a(this._options, t)) : this._options, this._options.data && (this._qr = I()(this._options.qrOptions.typeNumber, this._options.qrOptions.errorCorrectionLevel), this._qr.addData(this._options.data, this._options.qrOptions.mode || function (e) {
                    switch (!0) {
                      case /^[0-9]*$/.test(e):
                        return "Numeric";
                      case /^[0-9A-Z $%*+\-./:]*$/.test(e):
                        return "Alphanumeric";
                      default:
                        return "Byte";
                    }
                  }(this._options.data)), this._qr.make(), this._options.type === _ ? this._setupCanvas() : this._setupSvg(), this.append(this._container));
                }, e.prototype.append = function (e) {
                  if (e) {
                    if ("function" != typeof e.appendChild) throw "Container should be a single DOM node";
                    this._options.type === _ ? this._canvas && e.appendChild(this._canvas) : this._svg && e.appendChild(this._svg), this._container = e;
                  }
                }, e.prototype.applyExtension = function (e) {
                  if (!e) throw "Extension function should be defined.";
                  this._extension = e, this.update();
                }, e.prototype.deleteExtension = function () {
                  this._extension = void 0, this.update();
                }, e.prototype.getRawData = function (e) {
                  return void 0 === e && (e = "png"), T(this, void 0, void 0, function () {
                    var t, n, r;
                    return P(this, function (i) {
                      switch (i.label) {
                        case 0:
                          if (!this._qr) throw "QR code is empty";
                          return [4, this._getElement(e)];
                        case 1:
                          return (t = i.sent()) ? "svg" === e.toLowerCase() ? (n = new XMLSerializer(), r = n.serializeToString(t), [2, new Blob(['<?xml version="1.0" standalone="no"?>\r\n' + r], {
                            type: "image/svg+xml"
                          })]) : [2, new Promise(function (n) {
                            return t.toBlob(n, "image/" + e, 1);
                          })] : [2, null];
                      }
                    });
                  });
                }, e.prototype.download = function (e) {
                  return T(this, void 0, void 0, function () {
                    var t, n, r, i, o;
                    return P(this, function (a) {
                      switch (a.label) {
                        case 0:
                          if (!this._qr) throw "QR code is empty";
                          return t = "png", n = "qr", "string" == typeof e ? (t = e, console.warn("Extension is deprecated as argument for 'download' method, please pass object { name: '...', extension: '...' } as argument")) : "object" == typeof e && null !== e && (e.name && (n = e.name), e.extension && (t = e.extension)), [4, this._getElement(t)];
                        case 1:
                          return (r = a.sent()) ? ("svg" === t.toLowerCase() ? (i = new XMLSerializer(), o = '<?xml version="1.0" standalone="no"?>\r\n' + (o = i.serializeToString(r)), s("data:image/svg+xml;charset=utf-8," + encodeURIComponent(o), n + ".svg")) : s(r.toDataURL("image/" + t), n + "." + t), [2]) : [2];
                      }
                    });
                  });
                }, e;
              }();
            }
          },
          t = {};
        function n(r) {
          if (t[r]) return t[r].exports;
          var i = t[r] = {
            exports: {}
          };
          return e[r](i, i.exports, n), i.exports;
        }
        return n.n = e => {
          var t = e && e.__esModule ? () => e.default : () => e;
          return n.d(t, {
            a: t
          }), t;
        }, n.d = (e, t) => {
          for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
          });
        }, n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n(676);
      })().default;
    }(ZB)), ZB.exports;
  }
  !function (e, t) {
    !function (e, t, n) {
      var r = "data:image/png;base64,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",
        i = function () {
          return i = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e;
          }, i.apply(this, arguments);
        };
      "function" == typeof SuppressedError && SuppressedError;
      var o = {
          fontFamily: "Roboto, sans-serif"
        },
        a = function (e) {
          var n = e.children,
            r = e.className;
          return t.createElement("div", {
            style: o,
            className: r
          }, n);
        },
        s = {
          flexContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row"
          },
          flexItem: {
            flex: 1,
            justifyContent: "center",
            alignItems: "center"
          },
          flexItem11: {
            flex: 11,
            justifyContent: "center",
            alignItems: "center"
          },
          flexItem1: {
            flex: 1,
            justifyContent: "center",
            alignItems: "center"
          },
          tab: {
            padding: 8,
            cursor: "pointer",
            backgroundColor: "#F2F4F6",
            fontSize: 12,
            textAlign: "center",
            color: "#24292E"
          },
          tabcontainer: {
            padding: "4px",
            backgroundColor: "#F2F4F6",
            borderRadius: "8px",
            marginBottom: 30,
            marginTop: 30
          },
          tabactive: {
            backgroundColor: "white",
            WebkitTransition: "background-color 300ms linear",
            msTransition: "background-color 300ms linear",
            transition: "background-color 300ms linear",
            borderRadius: "8px"
          },
          item: {
            fontSize: "12px",
            marginBottom: 16,
            borderRadius: "8px",
            padding: "10px",
            border: "2px #F2F4F6 solid",
            color: "#24292E"
          },
          extensionLabel: {
            fontsStyle: "normal",
            fontWeight: "bold",
            fontSize: 14,
            textAlign: "center",
            color: "#24272A"
          },
          notice: {
            fontSize: 12,
            marginLeft: 10,
            marginRight: 10,
            color: "grey"
          },
          button: {
            marginTop: "41.5px",
            marginBottom: "20px",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "12px 20px",
            background: "#037DD6",
            borderRadius: "32px",
            color: "white",
            border: "0",
            fontSize: "14px",
            cursor: "pointer"
          },
          backdrop: {
            visibility: "visible",
            position: "fixed",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            width: "100%",
            zIndex: 99998,
            background: "rgba(0, 0, 0, 0.87)",
            opacity: .3
          },
          modal: {
            visibility: "visible",
            position: "fixed",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 99999,
            background: "#fff",
            padding: "20px",
            borderRadius: "8px",
            top: "50%",
            maxWidth: "100%",
            width: 460,
            minWidth: 300,
            boxShadow: "rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px",
            WebkitFontSmoothing: "antialiased"
          },
          closeButton: {
            color: "#BBC0C5",
            cursor: "pointer"
          },
          closeButtonContainer: {},
          logoContainer: {
            marginHorizontal: 24,
            marginTop: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          connectMobileText: {
            fontSize: 14,
            color: "black",
            marginTop: 28,
            marginBottom: 28,
            lineHeight: 2
          },
          blue: {
            color: "#037DD6",
            fontWeight: 700
          },
          installExtensionText: {
            marginLeft: 10
          },
          center: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          right: {
            display: "flex",
            alignItems: "center",
            justifyContent: "right"
          }
        },
        u = function (e) {
          var n = e.Icon,
            r = e.text;
          return t.createElement("div", {
            style: i(i({
              padding: 6
            }, s.flexContainer), {
              flexDirection: "row"
            })
          }, t.createElement("div", {
            style: s.flexItem1
          }, t.createElement(n, null)), t.createElement("div", {
            style: s.flexItem11
          }, t.createElement("span", {
            style: {
              lineHeight: "2",
              color: "black"
            }
          }, r)));
        },
        c = function () {
          return t.createElement("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, t.createElement("rect", {
            width: "16",
            height: "16",
            fill: "white"
          }), t.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.40554 2.40554C2.94627 1.86482 3.82296 1.86482 4.36369 2.40554L8 6.04186L11.6363 2.40554C12.177 1.86482 13.0537 1.86482 13.5945 2.40554C14.1352 2.94627 14.1352 3.82296 13.5945 4.36369L9.95814 8L13.5945 11.6363C14.1352 12.177 14.1352 13.0537 13.5945 13.5945C13.0537 14.1352 12.177 14.1352 11.6363 13.5945L8 9.95814L4.36369 13.5945C3.82296 14.1352 2.94627 14.1352 2.40554 13.5945C1.86482 13.0537 1.86482 12.177 2.40554 11.6363L6.04186 8L2.40554 4.36369C1.86482 3.82296 1.86482 2.94627 2.40554 2.40554Z",
            fill: "#BBC0C5"
          }));
        },
        l = function () {
          return t.createElement("svg", {
            width: "20",
            height: "18",
            viewBox: "0 0 20 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, t.createElement("path", {
            d: "M14.44 0.0999756C12.63 0.0999756 11.01 0.979976 10 2.32998C8.99 0.979976 7.37 0.0999756 5.56 0.0999756C2.49 0.0999756 0 2.59998 0 5.68998C0 6.87998 0.19 7.97998 0.52 8.99998C2.1 14 6.97 16.99 9.38 17.81C9.72 17.93 10.28 17.93 10.62 17.81C13.03 16.99 17.9 14 19.48 8.99998C19.81 7.97998 20 6.87998 20 5.68998C20 2.59998 17.51 0.0999756 14.44 0.0999756Z",
            fill: "#037DD6"
          }));
        },
        d = function () {
          return t.createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, t.createElement("path", {
            d: "M16.4405 8.8999C20.0405 9.2099 21.5105 11.0599 21.5105 15.1099V15.2399C21.5105 19.7099 19.7205 21.4999 15.2505 21.4999H8.74047C4.27047 21.4999 2.48047 19.7099 2.48047 15.2399V15.1099C2.48047 11.0899 3.93047 9.2399 7.47047 8.9099",
            stroke: "white",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M12 2V14.88",
            stroke: "white",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M15.3504 12.6499L12.0004 15.9999L8.65039 12.6499",
            stroke: "white",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }));
        },
        f = function () {
          return t.createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, t.createElement("path", {
            d: "M16.28 7.53V6.28C16.28 3.58 15.63 0 10 0C4.37 0 3.72 3.58 3.72 6.28V7.53C0.92 7.88 0 9.3 0 12.79V14.65C0 18.75 1.25 20 5.35 20H14.65C18.75 20 20 18.75 20 14.65V12.79C20 9.3 19.08 7.88 16.28 7.53ZM10 16.74C8.33 16.74 6.98 15.38 6.98 13.72C6.98 12.05 8.34 10.7 10 10.7C11.66 10.7 13.02 12.06 13.02 13.72C13.02 15.39 11.67 16.74 10 16.74ZM5.35 7.44C5.27 7.44 5.2 7.44 5.12 7.44V6.28C5.12 3.35 5.95 1.4 10 1.4C14.05 1.4 14.88 3.35 14.88 6.28V7.45C14.8 7.45 14.73 7.45 14.65 7.45H5.35V7.44Z",
            fill: "#037DD6"
          }));
        },
        h = function () {
          return t.createElement("svg", {
            width: "273",
            height: "51",
            viewBox: "0 0 273 51",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, t.createElement("path", {
            d: "M240.882 25.9263C239.472 24.997 237.916 24.3361 236.443 23.5101C235.489 22.9731 234.473 22.4982 233.643 21.8167C232.233 20.6602 232.524 18.3885 233.996 17.3973C236.112 15.993 239.617 16.7777 239.99 19.6483C239.99 19.7102 240.052 19.7515 240.114 19.7515H243.308C243.391 19.7515 243.454 19.6896 243.433 19.607C243.267 17.6244 242.5 15.9723 241.089 14.9191C239.741 13.9072 238.206 13.3702 236.568 13.3702C228.127 13.3702 227.359 22.271 231.901 25.0796C232.42 25.41 236.879 27.6404 238.455 28.611C240.032 29.5816 240.529 31.3576 239.845 32.7619C239.223 34.0423 237.605 34.9303 235.987 34.8271C234.224 34.7238 232.855 33.7738 232.378 32.2869C232.295 32.0185 232.254 31.5022 232.254 31.275C232.254 31.2131 232.192 31.1511 232.129 31.1511H228.666C228.604 31.1511 228.541 31.2131 228.541 31.275C228.541 33.7738 229.164 35.1575 230.864 36.4172C232.461 37.615 234.203 38.1106 236.008 38.1106C240.737 38.1106 243.184 35.4466 243.682 32.6793C244.117 29.974 243.308 27.5371 240.882 25.9263Z",
            fill: "#24292E"
          }), t.createElement("path", {
            d: "M90.4943 13.8246H88.9595H87.2795C87.2173 13.8246 87.1758 13.8659 87.1551 13.9072L84.3137 23.2416C84.2722 23.3655 84.1063 23.3655 84.0648 23.2416L81.2234 13.9072C81.2026 13.8452 81.1612 13.8246 81.0989 13.8246H79.419H77.8842H75.8102C75.748 13.8246 75.6857 13.8865 75.6857 13.9485V37.7802C75.6857 37.8422 75.748 37.9041 75.8102 37.9041H79.2738C79.336 37.9041 79.3982 37.8422 79.3982 37.7802V19.6689C79.3982 19.5244 79.6056 19.5037 79.6471 19.6276L82.5093 29.024L82.7167 29.6849C82.7374 29.7468 82.7789 29.7675 82.8411 29.7675H85.4959C85.5581 29.7675 85.5996 29.7262 85.6203 29.6849L85.8277 29.024L88.6899 19.6276C88.7313 19.4831 88.9387 19.5244 88.9387 19.6689V37.7802C88.9387 37.8422 89.001 37.9041 89.0632 37.9041H92.5268C92.589 37.9041 92.6513 37.8422 92.6513 37.7802V13.9485C92.6513 13.8865 92.589 13.8246 92.5268 13.8246H90.4943Z",
            fill: "#24292E"
          }), t.createElement("path", {
            d: "M187.849 13.8246C187.787 13.8246 187.745 13.8659 187.725 13.9072L184.883 23.2416C184.842 23.3655 184.676 23.3655 184.634 23.2416L181.793 13.9072C181.772 13.8452 181.731 13.8246 181.668 13.8246H176.4C176.338 13.8246 176.276 13.8865 176.276 13.9485V37.7802C176.276 37.8422 176.338 37.9041 176.4 37.9041H179.864C179.926 37.9041 179.988 37.8422 179.988 37.7802V19.6689C179.988 19.5244 180.196 19.5037 180.237 19.6276L183.099 29.024L183.307 29.6849C183.328 29.7468 183.369 29.7675 183.431 29.7675H186.086C186.148 29.7675 186.19 29.7262 186.211 29.6849L186.418 29.024L189.28 19.6276C189.322 19.4831 189.529 19.5244 189.529 19.6689V37.7802C189.529 37.8422 189.591 37.9041 189.653 37.9041H193.117C193.179 37.9041 193.241 37.8422 193.241 37.7802V13.9485C193.241 13.8865 193.179 13.8246 193.117 13.8246H187.849Z",
            fill: "#24292E"
          }), t.createElement("path", {
            d: "M143.174 13.8246H136.724H133.261H126.81C126.748 13.8246 126.686 13.8865 126.686 13.9485V16.9223C126.686 16.9843 126.748 17.0462 126.81 17.0462H133.136V37.7802C133.136 37.8422 133.198 37.9041 133.261 37.9041H136.724C136.786 37.9041 136.849 37.8422 136.849 37.7802V17.0462H143.174C143.237 17.0462 143.299 16.9843 143.299 16.9223V13.9485C143.299 13.8865 143.257 13.8246 143.174 13.8246Z",
            fill: "#24292E"
          }), t.createElement("path", {
            d: "M163.604 37.9041H166.756C166.839 37.9041 166.901 37.8215 166.881 37.7389L160.368 13.8245C160.347 13.7626 160.306 13.7419 160.244 13.7419H159.041H156.925H155.722C155.66 13.7419 155.619 13.7832 155.598 13.8245L149.085 37.7389C149.065 37.8215 149.127 37.9041 149.21 37.9041H152.362C152.425 37.9041 152.466 37.8628 152.487 37.8215L154.374 30.862C154.395 30.8 154.436 30.7794 154.499 30.7794H161.467C161.53 30.7794 161.571 30.8207 161.592 30.862L163.479 37.8215C163.5 37.8628 163.562 37.9041 163.604 37.9041ZM155.328 27.3719L157.859 18.0581C157.9 17.9342 158.066 17.9342 158.107 18.0581L160.638 27.3719C160.659 27.4545 160.596 27.5371 160.513 27.5371H155.453C155.37 27.5371 155.308 27.4545 155.328 27.3719Z",
            fill: "#24292E"
          }), t.createElement("path", {
            d: "M217.362 37.9041H220.515C220.598 37.9041 220.66 37.8215 220.639 37.7389L214.127 13.8245C214.106 13.7626 214.065 13.7419 214.002 13.7419H212.8H210.684H209.481C209.419 13.7419 209.377 13.7832 209.357 13.8245L202.844 37.7389C202.823 37.8215 202.886 37.9041 202.969 37.9041H206.121C206.183 37.9041 206.225 37.8628 206.246 37.8215L208.133 30.862C208.154 30.8 208.195 30.7794 208.257 30.7794H215.226C215.288 30.7794 215.33 30.8207 215.351 30.862L217.238 37.8215C217.259 37.8628 217.3 37.9041 217.362 37.9041ZM209.087 27.3719L211.617 18.0581C211.659 17.9342 211.825 17.9342 211.866 18.0581L214.397 27.3719C214.417 27.4545 214.355 27.5371 214.272 27.5371H209.211C209.129 27.5371 209.066 27.4545 209.087 27.3719Z",
            fill: "#24292E"
          }), t.createElement("path", {
            d: "M106.713 34.3727V26.9795C106.713 26.9176 106.775 26.8556 106.837 26.8556H116.067C116.129 26.8556 116.191 26.7936 116.191 26.7317V23.7579C116.191 23.6959 116.129 23.634 116.067 23.634H106.837C106.775 23.634 106.713 23.572 106.713 23.5101V17.1907C106.713 17.1288 106.775 17.0668 106.837 17.0668H117.332C117.394 17.0668 117.457 17.0049 117.457 16.9429V13.9691C117.457 13.9072 117.394 13.8452 117.332 13.8452H106.713H103.125C103.063 13.8452 103.001 13.9072 103.001 13.9691V17.0668V23.6546V26.8763V34.5173V37.7802C103.001 37.8422 103.063 37.9041 103.125 37.9041H106.713H117.768C117.83 37.9041 117.892 37.8422 117.892 37.7802V34.6412C117.892 34.5792 117.83 34.5173 117.768 34.5173H106.817C106.755 34.4966 106.713 34.4553 106.713 34.3727Z",
            fill: "#24292E"
          }), t.createElement("path", {
            d: "M272.532 37.6976L260.544 25.3687C260.502 25.3274 260.502 25.2448 260.544 25.2035L271.329 14.0517C271.412 13.9691 271.349 13.8452 271.246 13.8452H266.828C266.787 13.8452 266.766 13.8659 266.745 13.8865L257.599 23.3449C257.516 23.4275 257.391 23.3655 257.391 23.2623V13.9691C257.391 13.9072 257.329 13.8452 257.267 13.8452H253.803C253.741 13.8452 253.679 13.9072 253.679 13.9691V37.8009C253.679 37.8628 253.741 37.9248 253.803 37.9248H257.267C257.329 37.9248 257.391 37.8628 257.391 37.8009V27.3099C257.391 27.2067 257.536 27.1447 257.599 27.2273L267.969 37.8835C267.989 37.9041 268.031 37.9248 268.052 37.9248H272.469C272.552 37.9041 272.615 37.7596 272.532 37.6976Z",
            fill: "#24292E"
          }), t.createElement("path", {
            d: "M52.021 1L31.0526 16.4886L34.9517 7.36063L52.021 1Z",
            fill: "#E17726",
            stroke: "#E17726",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M3.65491 1L24.4366 16.6331L20.7241 7.36063L3.65491 1Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M44.4716 36.9127L38.8925 45.4211L50.8389 48.7047L54.261 37.0986L44.4716 36.9127Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M1.43555 37.0986L4.83695 48.7047L16.7626 45.4211L11.2042 36.9127L1.43555 37.0986Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M16.1197 22.5395L12.8013 27.5371L24.6232 28.074L24.2292 15.3734L16.1197 22.5395Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M39.5561 22.5394L31.3222 15.2288L31.0526 28.0739L42.8746 27.537L39.5561 22.5394Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M16.7626 45.4212L23.918 41.9724L17.7582 37.1813L16.7626 45.4212Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M31.7578 41.9724L38.8925 45.4212L37.9177 37.1813L31.7578 41.9724Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M38.8923 45.4212L31.7577 41.9724L32.3384 46.5983L32.2762 48.5602L38.8923 45.4212Z",
            fill: "#D5BFB2",
            stroke: "#D5BFB2",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M16.7625 45.4212L23.3994 48.5602L23.3579 46.5983L23.9179 41.9724L16.7625 45.4212Z",
            fill: "#D5BFB2",
            stroke: "#D5BFB2",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M23.5239 34.1249L17.5922 32.3902L21.7818 30.4696L23.5239 34.1249Z",
            fill: "#233447",
            stroke: "#233447",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M32.1517 34.1249L33.8939 30.4696L38.1042 32.3902L32.1517 34.1249Z",
            fill: "#233447",
            stroke: "#233447",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M16.7626 45.4212L17.7996 36.9128L11.2042 37.0987L16.7626 45.4212Z",
            fill: "#CC6228",
            stroke: "#CC6228",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M37.8761 36.9128L38.8924 45.4212L44.4715 37.0987L37.8761 36.9128Z",
            fill: "#CC6228",
            stroke: "#CC6228",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M42.8745 27.5371L31.0526 28.074L32.1518 34.1249L33.894 30.4696L38.1042 32.3902L42.8745 27.5371Z",
            fill: "#CC6228",
            stroke: "#CC6228",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M17.5922 32.3902L21.7817 30.4696L23.5239 34.1249L24.6232 28.074L12.8012 27.5371L17.5922 32.3902Z",
            fill: "#CC6228",
            stroke: "#CC6228",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M12.8013 27.5371L17.7582 37.1813L17.5923 32.3902L12.8013 27.5371Z",
            fill: "#E27525",
            stroke: "#E27525",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M38.1044 32.3902L37.9177 37.1813L42.8746 27.5371L38.1044 32.3902Z",
            fill: "#E27525",
            stroke: "#E27525",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M24.6232 28.0741L23.524 34.125L24.9136 41.2703L25.2247 31.8533L24.6232 28.0741Z",
            fill: "#E27525",
            stroke: "#E27525",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M31.0526 28.0741L30.4719 31.8327L30.7623 41.2703L32.1519 34.125L31.0526 28.0741Z",
            fill: "#E27525",
            stroke: "#E27525",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M32.1519 34.1249L30.7623 41.2702L31.7578 41.9724L37.9177 37.1813L38.1043 32.3901L32.1519 34.1249Z",
            fill: "#F5841F",
            stroke: "#F5841F",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M17.5922 32.3901L17.7581 37.1813L23.918 41.9724L24.9135 41.2702L23.5239 34.1249L17.5922 32.3901Z",
            fill: "#F5841F",
            stroke: "#F5841F",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M32.2763 48.5602L32.3385 46.5983L31.7993 46.1439H23.8765L23.358 46.5983L23.3995 48.5602L16.7626 45.4211L19.0855 47.3211L23.7935 50.5633H31.8615L36.5903 47.3211L38.8924 45.4211L32.2763 48.5602Z",
            fill: "#C0AC9D",
            stroke: "#C0AC9D",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M31.7578 41.9724L30.7622 41.2703H24.9135L23.918 41.9724L23.358 46.5983L23.8765 46.144H31.7993L32.3385 46.5983L31.7578 41.9724Z",
            fill: "#24292E",
            stroke: "#24292E",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M52.9128 17.5005L54.6757 8.95079L52.021 1L31.7578 15.9723L39.5561 22.5394L50.5692 25.7404L52.9958 22.9111L51.938 22.147L53.618 20.6188L52.3321 19.6276L54.0121 18.3472L52.9128 17.5005Z",
            fill: "#763E1A",
            stroke: "#763E1A",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M1 8.95079L2.78366 17.5005L1.64295 18.3472L3.34365 19.6276L2.05775 20.6188L3.73771 22.147L2.67996 22.9111L5.10657 25.7404L16.1196 22.5394L23.918 15.9723L3.65475 1L1 8.95079Z",
            fill: "#763E1A",
            stroke: "#763E1A",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M50.5692 25.7404L39.5561 22.5394L42.8746 27.5371L37.9177 37.1813L44.4716 37.0987H54.261L50.5692 25.7404Z",
            fill: "#F5841F",
            stroke: "#F5841F",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M16.1196 22.5394L5.10651 25.7404L1.43549 37.0987H11.2041L17.7581 37.1813L12.8011 27.5371L16.1196 22.5394Z",
            fill: "#F5841F",
            stroke: "#F5841F",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M31.0526 28.0741L31.7578 15.9724L34.9518 7.36072H20.7239L23.9179 15.9724L24.6231 28.0741L24.8927 31.8739L24.9135 41.2703H30.7622L30.783 31.8739L31.0526 28.0741Z",
            fill: "#F5841F",
            stroke: "#F5841F",
            strokeWidth: "0.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }));
        },
        p = function () {
          return t.createElement("svg", {
            width: "20",
            height: "18",
            viewBox: "0 0 20 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, t.createElement("path", {
            d: "M20.0002 7.9702V10.0302C20.0002 10.5802 19.5602 11.0302 19.0002 11.0502H17.0402C15.9602 11.0502 14.9702 10.2602 14.8802 9.1802C14.8202 8.5502 15.0602 7.9602 15.4802 7.5502C15.8502 7.1702 16.3602 6.9502 16.9202 6.9502H19.0002C19.5602 6.9702 20.0002 7.4202 20.0002 7.9702Z",
            fill: "#037DD6"
          }), t.createElement("path", {
            d: "M18.47 12.55H17.04C15.14 12.55 13.54 11.12 13.38 9.3C13.29 8.26 13.67 7.22 14.43 6.48C15.07 5.82 15.96 5.45 16.92 5.45H18.47C18.76 5.45 19 5.21 18.97 4.92C18.75 2.49 17.14 0.83 14.75 0.55C14.51 0.51 14.26 0.5 14 0.5H5C4.72 0.5 4.45 0.52 4.19 0.56C1.64 0.88 0 2.78 0 5.5V12.5C0 15.26 2.24 17.5 5 17.5H14C16.8 17.5 18.73 15.75 18.97 13.08C19 12.79 18.76 12.55 18.47 12.55ZM11 6.75H5C4.59 6.75 4.25 6.41 4.25 6C4.25 5.59 4.59 5.25 5 5.25H11C11.41 5.25 11.75 5.59 11.75 6C11.75 6.41 11.41 6.75 11 6.75Z",
            fill: "#037DD6"
          }));
        };
      function m(e) {
        var n = e.version;
        return t.createElement("div", {
          style: {
            textAlign: "center",
            color: "#BBC0C5",
            fontSize: 12
          }
        }, "SDK Version ", n ? "v".concat(n) : "unknown");
      }
      var g = function (e) {
          var n = t.useState(e.preferDesktop ? 1 : 2),
            o = n[0],
            g = n[1],
            v = t.useRef(null),
            b = e.sdkVersion,
            y = e.i18nInstance.t;
          return t.useEffect(function () {
            v.current && new (JB())({
              width: 270,
              height: 270,
              type: "svg",
              data: e.link,
              image: r,
              dotsOptions: {
                color: "black",
                type: "rounded"
              },
              imageOptions: {
                margin: 5
              },
              cornersDotOptions: {
                color: "#f66a07"
              },
              qrOptions: {
                errorCorrectionLevel: "M"
              }
            }).append(v.current);
          }, [v]), t.createElement(a, {
            className: "install-model"
          }, t.createElement("div", {
            style: s.backdrop,
            onClick: e.onClose
          }), t.createElement("div", {
            style: s.modal
          }, t.createElement("div", {
            style: s.closeButtonContainer
          }, t.createElement("div", {
            style: s.right
          }, t.createElement("span", {
            style: s.closeButton,
            onClick: e.onClose
          }, t.createElement(c, null)))), t.createElement("div", {
            style: s.logoContainer
          }, t.createElement(h, null)), t.createElement("div", null, t.createElement("div", {
            style: s.tabcontainer
          }, t.createElement("div", {
            style: s.flexContainer
          }, t.createElement("div", {
            onClick: function () {
              return g(1);
            },
            style: i(i(i({}, s.tab), 1 === o ? s.tabactive : {}), s.flexItem)
          }, y("DESKTOP")), t.createElement("div", {
            onClick: function () {
              return g(2);
            },
            style: i(i(i({}, s.tab), 2 === o ? s.tabactive : {}), s.flexItem)
          }, y("MOBILE")))), t.createElement("div", {
            style: {
              display: 1 === o ? "none" : "block"
            }
          }, t.createElement("div", {
            style: s.flexContainer
          }, t.createElement("div", {
            style: i({
              textAlign: "center",
              marginTop: 4
            }, s.flexItem)
          }, t.createElement("div", {
            ref: v,
            style: s.center
          }), t.createElement("div", {
            style: s.connectMobileText
          }, y("SCAN_TO_CONNECT"), " ", t.createElement("br", null), t.createElement("span", {
            style: s.blue
          }, t.createElement("b", null, y("META_MASK_MOBILE_APP"))))))), t.createElement("div", {
            style: {
              display: 2 === o ? "none" : "block"
            }
          }, t.createElement("div", {
            style: s.item
          }, t.createElement(u, {
            Icon: l,
            text: y("INSTALL_MODAL.TRUSTED_BY_USERS")
          })), t.createElement("div", {
            style: s.item
          }, t.createElement(u, {
            Icon: f,
            text: y("INSTALL_MODAL.LEADING_CRYPTO_WALLET")
          })), t.createElement("div", {
            style: s.item
          }, t.createElement(u, {
            Icon: p,
            text: y("INSTALL_MODAL.CONTROL_DIGITAL_INTERACTIONS")
          })), t.createElement("button", {
            style: s.button,
            onClick: e.metaMaskInstaller.startDesktopOnboarding
          }, t.createElement(d, null), t.createElement("span", {
            style: s.installExtensionText
          }, y("INSTALL_MODAL.INSTALL_META_MASK_EXTENSION"))))), t.createElement(m, {
            version: b
          })));
        },
        v = function (e) {
          var n,
            r = null === (n = e.displayOTP) || void 0 === n || n,
            o = e.sdkVersion,
            u = e.i18nInstance.t;
          return t.createElement(a, {
            className: "pending-modal"
          }, t.createElement("div", {
            style: s.backdrop,
            onClick: e.onClose
          }), t.createElement("div", {
            style: s.modal
          }, t.createElement("div", {
            style: s.closeButtonContainer
          }, t.createElement("div", {
            style: s.right
          }, t.createElement("span", {
            style: s.closeButton,
            onClick: e.onClose
          }, t.createElement(c, null)))), t.createElement("div", {
            style: s.logoContainer
          }, t.createElement(h, null)), t.createElement("div", null, t.createElement("div", {
            style: i(i({}, s.flexContainer), {
              flexDirection: "column",
              color: "black"
            })
          }, t.createElement("div", {
            style: i(i({
              textAlign: "center",
              marginTop: "30px",
              marginBottom: "30px"
            }, s.flexItem), {
              fontSize: 16
            })
          }, u(r ? "PENDING_MODAL.OPEN_META_MASK_SELECT_CODE" : "PENDING_MODAL.OPEN_META_MASK_CONTINUE")), t.createElement("div", {
            id: "sdk-mm-otp-value",
            style: {
              padding: 10,
              fontSize: 32,
              display: "none"
            }
          }), r && t.createElement("div", {
            style: i({}, s.notice)
          }, "* ", u("PENDING_MODAL.NUMBER_AFTER_OPEN_NOTICE"))), t.createElement("div", {
            style: {
              marginTop: "20px"
            }
          }, t.createElement("button", {
            style: i(i(i({}, s.button), s.blue), {
              marginTop: "5px",
              color: "#0376C9",
              borderColor: "#0376C9",
              borderWidth: "1px",
              borderStyle: "solid",
              backgroundColor: "white"
            }),
            onClick: e.onDisconnect
          }, u("PENDING_MODAL.DISCONNECT")))), t.createElement(m, {
            version: o
          })));
        },
        b = function () {
          return t.createElement("svg", {
            width: "21",
            height: "15",
            viewBox: "0 0 21 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, t.createElement("path", {
            d: "M14.1364 14.9851C13.5909 14.9851 13.2273 14.5851 13.2273 13.9851C13.2273 13.3851 13.5909 12.9851 14.1364 12.9851C16.6818 12.9851 18.6818 10.7851 18.6818 7.98508C18.6818 5.18508 16.6818 2.98508 14.1364 2.98508C11.5909 2.98508 9.59091 5.18508 9.59091 7.98508C9.59091 8.58508 9.22727 8.98508 8.68182 8.98508C8.13636 8.98508 7.77273 8.58508 7.77273 7.98508C7.77273 4.08508 10.5909 0.985077 14.1364 0.985077C17.6818 0.985077 20.5 4.08508 20.5 7.98508C20.5 11.8851 17.6818 14.9851 14.1364 14.9851ZM6.68182 14.7851C3.22727 14.7851 0.5 11.6851 0.5 7.98508C0.5 4.28508 3.22727 1.18508 6.68182 1.18508C7.22727 1.18508 7.59091 1.58508 7.59091 2.18508C7.59091 2.78508 7.22727 3.18508 6.68182 3.18508C4.22727 3.18508 2.31818 5.38508 2.31818 7.98508C2.31818 10.5851 4.22727 12.7851 6.68182 12.7851C9.13636 12.7851 11.0455 10.6851 11.0455 7.98508C11.0455 7.38508 11.4091 6.98508 11.9545 6.98508C12.5 6.98508 12.8636 7.38508 12.8636 7.98508C12.7727 11.6851 10.0455 14.7851 6.68182 14.7851Z",
            fill: "white"
          }));
        },
        y = function () {
          return t.createElement("svg", {
            width: "400",
            height: "300",
            viewBox: "0 0 467 300",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, t.createElement("path", {
            d: "M312.387 280.629C312.549 280.583 312.247 280.735 312.387 280.629L339.678 260.425C340.088 260.118 340.132 259.156 340.07 258.647C340.008 258.138 339.573 258.257 339.106 258.084L311.712 247.455C311.292 247.301 311.308 247.402 310.939 247.673C310.569 247.944 310.356 248.21 310.356 248.672L310.459 279.504C310.461 280.025 311.163 280.619 311.614 280.847C311.913 280.996 312.072 280.718 312.387 280.629ZM336.204 259.736L312.979 276.292L313.439 251.139L336.204 259.736Z",
            fill: "url(#paint0_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M324.639 260.342C324.358 259.547 323.485 258.91 322.707 259.215C319.6 260.432 318.17 262.313 317.287 264.066C316.482 265.665 316.197 267.482 314.188 268.269C312.178 269.055 310.763 268.663 309.162 268.007C307.406 267.287 305.504 266.182 302.397 267.399C299.289 268.616 297.859 270.497 296.976 272.25C296.171 273.849 295.697 274.886 293.685 275.673C291.675 276.459 290.261 276.067 288.659 275.411C286.903 274.691 284.999 273.587 281.894 274.803C278.789 276.019 277.549 278.681 276.666 280.434C275.861 282.034 275.386 283.07 273.374 283.857C272.596 284.161 271.931 285.055 272.211 285.849C272.492 286.644 273.365 287.281 274.143 286.977C277.25 285.76 278.68 283.879 279.563 282.125C280.368 280.526 280.65 278.71 282.662 277.923C284.672 277.136 286.087 277.528 287.688 278.184C289.444 278.904 291.348 280.009 294.453 278.793C297.561 277.576 298.991 275.695 299.874 273.941C300.679 272.342 301.153 271.306 303.165 270.519C305.175 269.732 306.589 270.124 308.191 270.78C309.947 271.5 311.849 272.605 314.956 271.388C318.063 270.172 319.301 267.511 320.184 265.757C320.989 264.158 321.466 263.121 323.476 262.335C324.254 262.032 324.919 261.137 324.639 260.342Z",
            fill: "url(#paint1_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M389.034 111.124C388.968 112.406 387.342 113.113 386.324 113.549C384.297 114.419 382.089 114.493 379.942 114.5C376.607 114.509 373.215 114.163 369.89 113.976C366.712 113.798 363.156 113.311 360.03 114.232C357.705 114.919 355.667 116.762 353.452 117.739C351.129 118.765 348.957 119.198 346.489 119.687C335.569 121.85 323.587 120.825 312.656 119.977C311.92 119.92 312.539 118.997 313.237 118.981C313.207 118.815 313.001 118.394 313.045 118.201C313.086 118.029 312.781 117.586 312.853 117.421C312.67 117.198 313.316 117.427 313.626 117.204C315.912 115.557 318.721 114.79 321.363 115.041C324.677 115.355 327.293 116.04 330.641 115.781C334.392 115.491 338.125 114.787 341.857 114.312C345.142 113.892 349.09 113.941 352.106 112.28C352.916 111.834 353.137 111.262 353.269 110.287C353.331 109.828 353.672 108.969 353.658 108.511C353.629 107.529 354.191 107.886 355.013 107.298C356.857 105.981 358.274 105.516 360.428 105.784C362.841 106.083 365.264 107.273 367.578 107.953C370.761 108.888 374.328 108.646 377.631 108.477C380.517 108.329 383.141 107.901 385.944 108.653C387.013 108.941 389.104 109.745 389.034 111.124Z",
            fill: "url(#paint2_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M278.118 85.4414C280.313 83.8186 283.302 83.9 285.853 83.2728C290.501 82.127 295.644 78.4476 300.549 79.1524C301.299 79.2595 300.904 81.0355 300.159 80.9295C300.131 80.9256 300.187 80.9333 300.159 80.9295C300.089 81.0185 299.516 81.1051 299.385 81.1463C294.999 82.515 292.895 87.5083 289.126 89.8598C287.799 90.688 286.771 90.8351 285.258 90.9441C283.515 91.0691 280.964 90.5775 279.269 90.1219C277.15 89.5532 275.965 87.034 278.118 85.4414Z",
            fill: "url(#paint3_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M122.567 166.093C113.597 172.832 104.535 179.836 99.517 190.092C98.5342 192.099 97.519 195.019 97.9533 197.204C98.9699 202.316 105.76 203.049 110.691 201.96C113.468 201.347 116.325 199.231 115.921 196.319C115.576 193.81 113.158 192.986 112.072 190.73C110.779 188.04 112.35 184.97 114.218 182.62C128.134 165.099 150.074 157.394 171.093 151.607C175.385 150.425 180.897 147.69 180.581 143.099C180.372 140.072 177.118 137.683 174.221 137.383C171.324 137.082 168.481 138.773 165.715 139.776C158.416 142.419 151.17 143.799 143.489 143.526C136.865 143.29 130.976 143.316 129.562 150.781C128.138 158.276 129.53 160.863 122.567 166.093Z",
            fill: "url(#paint4_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M79.1056 153.531C60.3932 164.378 43.7478 178.354 32.8214 197.415C30.3313 201.76 27.9216 206.554 27.1821 211.512C26.4448 216.47 27.7591 222.525 30.8133 226.337C34.908 231.446 41.6938 232.915 48.1811 233.125C50.7248 233.208 53.0035 233.066 55.3316 231.947C57.6602 230.83 59.7548 228.359 59.5978 225.742C59.3303 221.315 54.5491 219.665 50.9271 217.34C42.6566 212.037 40.4958 199.493 44.2381 190.032C47.9803 180.57 55.8228 173.173 63.2316 166.338C67.229 162.651 71.5194 158.372 76.777 157.522C79.9167 157.015 83.4706 157.589 86.6295 157.252C93.9004 156.479 99.64 151.404 105.588 146.912C115.048 139.765 126.045 134.283 137.501 132.093C141.913 131.248 146.293 130.493 149.682 127.831C151.37 126.507 150.803 123.567 148.726 123.93C138.542 125.713 128.652 131.135 119.142 134.758C105.627 139.914 91.7133 146.223 79.1056 153.531Z",
            fill: "url(#paint5_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M96.3677 117.321C96.0315 116.64 95.2914 116.612 94.6293 116.975C91.9858 118.417 91.5452 120.509 90.9466 122.178C90.4004 123.702 89.3647 124.67 87.6542 125.604C85.9437 126.538 85.0983 126.316 83.5956 125.91C81.9481 125.465 79.8603 125.424 77.2168 126.866C74.5734 128.309 74.1348 130.401 73.5341 132.07C72.9879 133.593 71.9522 134.562 70.2417 135.496C68.5313 136.43 67.6859 136.208 66.1832 135.801C64.5357 135.357 62.2569 134.538 59.6128 135.978C56.9694 137.42 56.5308 139.512 55.9301 141.181C55.3839 142.705 54.5398 144.454 52.8293 145.388C52.1667 145.748 52.1006 146.485 52.439 147.165C52.7752 147.845 53.5153 147.874 54.1773 147.511C56.8208 146.069 57.2594 143.977 57.86 142.307C58.4062 140.784 59.4419 139.815 61.1524 138.881C62.8629 137.948 63.7083 138.17 65.211 138.576C66.8585 139.021 68.9458 139.059 71.5898 137.619C74.2333 136.177 74.6718 134.085 75.2725 132.416C75.8187 130.892 76.8544 129.924 78.5649 128.99C80.2754 128.056 81.1207 128.278 82.6235 128.684C84.2709 129.129 86.5503 129.95 89.1938 128.507C91.8373 127.065 92.2779 124.973 92.8765 123.304C93.4227 121.78 94.2663 120.03 95.9773 119.098C96.6378 118.738 96.7039 118.001 96.3677 117.321Z",
            fill: "#FBC49D"
          }), t.createElement("path", {
            d: "M391.827 164.699C392.04 164.639 392.39 164.573 392.6 164.481C393.87 163.921 395.363 162.429 395.893 161.051C396.421 159.673 396.237 158.321 395.712 156.931C394.629 154.061 391.777 152.62 389.155 153.775C386.531 154.931 384.962 158.455 386.042 161.325C387.038 163.963 389.369 165.392 391.827 164.699ZM394.166 157.367C394.529 158.332 394.52 159.751 394.156 160.706C393.792 161.662 393.1 162.534 392.218 162.921C390.398 163.723 388.338 162.878 387.589 160.889C387.226 159.925 387.234 158.506 387.599 157.55C387.963 156.594 388.654 155.723 389.536 155.336C391.356 154.534 393.416 155.376 394.166 157.367Z",
            fill: "#86E29B"
          }), t.createElement("path", {
            d: "M62.7198 108.691C64.4912 108.191 66.6152 106.609 67.5596 104.824C68.4273 103.187 68.465 101.455 67.9609 99.7066C67.4547 97.9586 66.0792 96.5141 64.4963 95.6786C62.9135 94.843 61.2077 94.8578 59.4756 95.4255C57.7435 95.9933 56.2768 97.4364 55.409 99.074C53.6185 102.456 55.2032 106.494 58.4723 108.22C60.0142 109.035 61.1315 109.138 62.7198 108.691ZM60.6304 96.7682C61.819 96.4332 63.0232 96.8871 64.1048 97.4571C65.2463 98.0603 66.0495 98.8796 66.4145 100.142C66.7791 101.403 66.4488 103.299 65.8224 104.48C64.5299 106.919 61.2212 107.686 58.8638 106.441C56.5063 105.197 55.8538 101.858 57.1462 99.4185C57.7726 98.2375 58.6059 97.3957 59.8573 96.9862C59.9214 96.9635 60.5631 96.7872 60.6304 96.7682Z",
            fill: "#FFB0EB"
          }), t.createElement("path", {
            d: "M77.0217 242.979C75.9542 243.28 75.1664 242.151 74.9029 241.074C74.6394 239.996 75 239.378 76.0676 239.077C77.1351 238.776 78.5053 238.907 78.7688 239.984C79.0323 241.061 78.0893 242.678 77.0217 242.979Z",
            fill: "url(#paint6_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M380.506 184.577C379.439 184.878 378.651 183.749 378.387 182.672C378.124 181.594 378.484 180.976 379.552 180.675C380.619 180.374 381.99 180.505 382.253 181.582C382.517 182.659 381.574 184.276 380.506 184.577Z",
            fill: "url(#paint7_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M348.82 246.969C347.752 247.27 346.382 247.14 346.119 246.063C345.855 244.985 346.798 243.369 347.866 243.068C348.933 242.767 349.721 243.896 349.985 244.973C350.248 246.05 349.888 246.669 348.82 246.969Z",
            fill: "url(#paint8_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M140.419 282.412C139.351 282.713 138.754 282.365 138.491 281.288C138.227 280.21 138.397 278.812 139.464 278.511C140.532 278.21 142.093 279.121 142.357 280.198C142.62 281.275 141.486 282.111 140.419 282.412Z",
            fill: "url(#paint9_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M121.462 101.679C120.395 101.979 119.798 101.631 119.534 100.554C119.271 99.4764 119.44 98.0779 120.508 97.777C121.575 97.4761 123.136 98.3868 123.4 99.4642C123.663 100.542 122.53 101.378 121.462 101.679Z",
            fill: "url(#paint10_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M370.749 159.005C369.682 159.306 368.311 159.175 368.048 158.098C367.784 157.021 368.727 155.404 369.795 155.103C370.863 154.802 371.65 155.931 371.914 157.008C372.177 158.086 371.817 158.704 370.749 159.005Z",
            fill: "url(#paint11_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M384.211 245.345C383.143 245.646 381.773 245.515 381.51 244.438C381.246 243.361 382.189 241.744 383.257 241.443C384.324 241.142 385.112 242.271 385.376 243.348C385.639 244.426 385.278 245.044 384.211 245.345Z",
            fill: "url(#paint12_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M364.771 41.3873C363.063 41.8687 361.337 40.8616 360.915 39.1378C360.493 37.414 361.536 35.6263 363.244 35.1449C364.953 34.6634 366.679 35.6706 367.101 37.3944C367.522 39.1182 366.479 40.9059 364.771 41.3873Z",
            fill: "url(#paint13_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M404.311 77.905C404.602 77.8231 404.875 77.9236 405.084 77.6871C405.437 77.2908 404.814 76.6385 404.703 76.1265L401.277 58.7418C401.149 58.163 400.687 57.5371 400.123 57.3991C399.558 57.2611 398.969 57.3812 398.576 57.835L385.784 73.1179C385.395 73.564 385.199 74.3453 385.393 74.8964C385.585 75.4481 385.978 76.1646 386.548 76.2391L403.538 78.123C403.744 78.1479 404.114 77.9607 404.311 77.905ZM398.948 62.7348L401.811 74.4394L389.841 72.8085L398.948 62.7348Z",
            fill: "#FFB0EB"
          }), t.createElement("path", {
            d: "M97.5393 295.311C97.7108 295.263 97.4284 295.461 97.5393 295.311L108.785 280.464C108.975 280.211 108.718 279.972 108.594 279.684C108.47 279.396 108.124 279.917 107.821 279.902L88.5106 278.672C88.2101 278.659 87.895 278.62 87.7374 278.89C87.5798 279.159 87.7755 279.402 87.9283 279.67L96.5753 294.749C96.7102 294.99 97.2696 295.297 97.5393 295.311C97.6283 295.319 97.4556 295.335 97.5393 295.311ZM106.465 281.118L96.9667 292.97L90.6295 280.577L106.465 281.118Z",
            fill: "#86E29B"
          }), t.createElement("path", {
            d: "M393.699 108.848C389.518 104.446 414.629 114.366 413.945 120.659C413.259 126.952 401.355 129.102 403.894 123.491C406.042 118.747 400.376 115.876 393.699 108.848Z",
            fill: "#FBC49D"
          }), t.createElement("path", {
            d: "M139.414 115.959C139.434 115.953 139.392 115.965 139.414 115.959C141.963 115.2 143.436 111.976 142.717 109.189C142.37 107.839 141.526 107.199 140.408 106.504C139.289 105.808 138.171 105.449 136.933 105.815C135.698 106.182 134.85 107.033 134.222 108.247C133.595 109.461 133.282 111.234 133.63 112.585C133.978 113.935 134.821 114.574 135.94 115.27C137.04 115.952 138.199 116.301 139.414 115.959ZM137.315 107.375C138.222 107.12 139.005 106.994 139.825 107.502C140.661 108.02 140.912 108.618 141.171 109.625C141.708 111.704 140.935 113.834 139.032 114.398C138.11 114.675 137.356 114.791 136.522 114.272C135.686 113.753 135.436 113.155 135.176 112.149C134.917 111.142 134.718 109.714 135.186 108.81C135.654 107.905 136.394 107.649 137.315 107.375C137.329 107.371 137.299 107.38 137.315 107.375Z",
            fill: "#75C4FD"
          }), t.createElement("path", {
            d: "M308.981 78.7519C310.052 78.4043 311.158 78.7096 312.265 78.6613C313.655 78.6006 314.936 78.517 316.323 78.3531C319.497 77.9795 322.798 77.4906 325.984 77.3012C329.309 77.1025 332.514 76.8551 335.836 77.0295C338.809 77.1842 342.163 77.3405 345.105 77.7558C352.129 78.7468 359.331 79.0578 366.347 80.1158C372.252 81.008 377.93 82.1319 383.722 83.5644C385.925 84.0054 388.267 85.0754 389.126 85.3792C389.421 85.4833 389.37 85.8347 389.317 86.1595C389.306 86.2271 389.353 86.1146 389.317 86.1595C388.269 87.414 386.564 86.8124 385.259 86.4677C384.406 86.241 381.488 85.9494 381.011 85.9957C380.14 86.0815 379.277 86.014 379.656 87.2114C380.122 88.6824 382.391 89.7375 383.704 90.2419C385.883 91.0803 388.771 91.2561 390.845 92.4015C392.968 92.821 395.425 93.5002 397.022 93.9986C402.83 95.8103 407.806 98.8678 413.033 102.002C415.503 103.482 417.829 104.764 419.973 106.72C421.647 108.248 423.771 109.882 424.595 112.091C425.113 113.482 424.451 115.471 422.848 115.085C420.353 114.488 419.638 111.665 418.227 109.714C415.003 105.251 410.067 102.067 405.118 100.06C402.64 99.0556 399.803 98.729 397.204 98.1176C394.411 97.4613 391.597 97.0442 388.707 97.1736C385.646 97.3097 382.846 97.5534 379.819 98.0078C377.027 98.4264 374.252 98.4441 371.514 97.8441C368.766 97.2421 366.276 96.7553 363.6 95.9021C361.662 95.2848 359.013 94.5583 357.232 93.5247C355.699 92.6339 355.631 91.2381 357.241 90.186C359.87 88.4656 362.778 89.8021 365.546 90.3497C365.561 90.3527 365.532 90.3468 365.546 90.3497C367.858 90.804 369.649 90.098 371.923 89.3884C372.489 89.2128 373.255 89.0482 373.47 88.953C374.383 88.5432 375.895 87.8227 375.407 86.7394C374.868 85.5457 372.659 84.8846 371.55 84.4891C369.74 83.8428 368.053 82.9215 366.147 82.6743C365.654 82.6095 365.109 83.1606 364.6 83.1097C363.36 83.1121 361.769 83.348 360.543 83.418C357.43 83.5916 354.583 83.6228 351.464 83.4719C348.714 83.3377 346.432 82.8542 343.741 82.3102C340.773 81.7101 337.52 81.5879 334.471 81.5839C331.393 81.5811 328.6 81.7214 325.583 82.4181C322.758 83.0702 319.757 83.6198 316.887 84.0326C314.698 84.3481 312.467 84.6054 310.319 84.2137C309.079 83.9871 306.994 83.3394 306.461 81.9635C305.846 80.3659 307.736 79.1556 308.981 78.7519Z",
            fill: "url(#paint14_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M242.269 242.95C242.295 242.947 242.244 242.955 242.269 242.95C244.934 242.606 247.53 241.858 250.2 241.574C253.133 241.264 256.006 240.56 258.906 239.982C263.26 239.117 268.026 238.52 272.254 237.097C274.429 236.365 276.067 235.298 278.251 234.592C280.361 233.909 283.058 233.12 285.216 232.652C289.317 231.764 293.049 231.66 297.016 230.198C301.109 228.69 305.088 226.673 308.819 224.409C312.645 222.086 316.282 219.769 320.622 218.62C322.381 218.154 323.919 218.219 325.65 218.886C327.016 219.413 327.739 220.337 327.196 221.79C326.557 223.504 324.659 224.7 323.131 225.423C320.854 226.5 319.53 227.184 317.134 227.927C314.619 228.707 311.888 229.24 309.395 230.083C308.226 230.947 307.17 232.522 306.105 233.501C303.996 235.441 301.666 237.03 298.945 237.996C292.934 240.129 286.354 238.602 280.183 239.056C279.661 239.095 279.162 239.442 278.635 239.487C275.592 240.135 272.2 240.63 269.156 241.294C264.546 242.299 260.456 243.409 255.808 244.179C251.971 244.814 243.815 245.854 243.815 245.854L242.074 245.505C240.575 245.281 240.751 243.152 242.269 242.95Z",
            fill: "url(#paint15_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M432.985 171.626C438.212 165.465 445.109 153.64 442.906 144.649C442.162 137.999 433.671 132.912 424.963 135.518C420.16 136.957 416.435 142.146 419.724 144.498C420.656 145.164 422.187 145.591 423.391 145.969C434.204 149.375 434.925 162.538 425.069 169.683C421.087 172.569 416.347 174.292 411.914 176.719C400.151 183.162 399.887 196.847 387.7 202.712C382.326 205.298 375.761 206.838 370.297 209.275C359.98 213.88 352.555 221.733 342.241 226.341C337.225 228.584 330.266 231.632 323.483 234.12C321.475 234.855 321.999 237.058 324.056 236.46C324.098 236.449 324.017 236.474 324.056 236.46C329.079 234.971 334.437 233.161 339.331 231.33C352.278 226.48 365.28 220.971 377.43 214.775C401.78 202.367 416.881 190.609 432.985 171.626Z",
            fill: "url(#paint16_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M343.644 241.104C348.002 234.144 357.126 232.455 364.343 231.134C368.176 230.431 372.406 229.878 376.137 228.662C380.691 227.175 384.558 224.095 388.327 221.077C389.452 220.177 391.204 218.466 392.393 217.436C393.185 216.748 393.644 216.026 394.33 215.225C396 213.275 399.599 209.812 401.687 208.16C403.263 206.914 407.779 204.758 408.259 207.986C408.611 210.359 406.379 213.087 404.961 214.747C402.224 217.953 398.998 221.079 395.475 223.243C391.749 225.531 387.701 227.439 383.674 229.051C381.672 229.853 379.519 230.073 377.486 230.785C376.001 231.307 374.486 232.236 373.037 232.866C371.034 233.738 368.99 234.28 367.041 235.38C364.436 236.849 361.782 238.783 359.108 240.105C356.331 241.477 353.823 242.691 350.791 243.27C348.6 243.687 345.501 243.641 343.836 241.884C343.526 241.554 343.389 241.51 343.644 241.104Z",
            fill: "url(#paint17_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M190.163 273.219C222.905 268.849 232.64 262.943 213.962 259.057C195.285 255.172 187.5 262.08 188.434 266.2C189.366 270.32 180.381 271.326 169.286 272.39C158.193 273.454 157.141 276.354 190.163 273.219Z",
            fill: "url(#paint18_linear_1356_14057)"
          }), t.createElement("path", {
            d: "M295.952 95.4242L241.395 135.226L251.54 111.77L295.952 95.4242Z",
            fill: "#E17726",
            stroke: "#E17726",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M170.111 95.4242L224.181 135.598L214.522 111.77L170.111 95.4242Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M276.309 187.712L261.793 209.576L292.876 218.014L301.78 188.189L276.309 187.712Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M164.336 188.189L173.186 218.014L204.215 209.576L189.753 187.712L164.336 188.189Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M202.542 150.776L193.908 163.618L224.667 164.998L223.642 132.36L202.542 150.776Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M263.52 150.775L242.097 131.989L241.395 164.998L272.154 163.618L263.52 150.775Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M204.215 209.576L222.832 200.714L206.805 188.402L204.215 209.576Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M243.23 200.714L261.793 209.576L259.257 188.402L243.23 200.714Z",
            fill: "#E27625",
            stroke: "#E27625",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M261.793 209.576L243.23 200.714L244.741 212.601L244.579 217.643L261.793 209.576Z",
            fill: "#D5BFB2",
            stroke: "#D5BFB2",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M204.215 209.576L221.483 217.643L221.375 212.601L222.832 200.714L204.215 209.576Z",
            fill: "#D5BFB2",
            stroke: "#D5BFB2",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M221.807 180.547L206.373 176.09L217.274 171.154L221.807 180.547Z",
            fill: "#233447",
            stroke: "#233447",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M244.255 180.547L248.788 171.154L259.742 176.09L244.255 180.547Z",
            fill: "#233447",
            stroke: "#233447",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M204.215 209.576L206.913 187.712L189.753 188.189L204.215 209.576Z",
            fill: "#CC6228",
            stroke: "#CC6228",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M259.149 187.712L261.793 209.576L276.309 188.189L259.149 187.712Z",
            fill: "#CC6228",
            stroke: "#CC6228",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M272.154 163.618L241.395 164.998L244.255 180.547L248.788 171.154L259.742 176.09L272.154 163.618Z",
            fill: "#CC6228",
            stroke: "#CC6228",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M206.373 176.09L217.274 171.154L221.807 180.547L224.667 164.998L193.908 163.618L206.373 176.09Z",
            fill: "#CC6228",
            stroke: "#CC6228",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M193.908 163.618L206.805 188.402L206.373 176.09L193.908 163.618Z",
            fill: "#E27525",
            stroke: "#E27525",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M259.743 176.09L259.257 188.402L272.154 163.618L259.743 176.09Z",
            fill: "#E27525",
            stroke: "#E27525",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M224.667 164.998L221.807 180.548L225.422 198.909L226.232 174.71L224.667 164.998Z",
            fill: "#E27525",
            stroke: "#E27525",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M241.395 164.998L239.884 174.657L240.64 198.909L244.255 180.548L241.395 164.998Z",
            fill: "#E27525",
            stroke: "#E27525",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M244.255 180.547L240.64 198.909L243.23 200.714L259.257 188.402L259.743 176.09L244.255 180.547Z",
            fill: "#F5841F",
            stroke: "#F5841F",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M206.373 176.09L206.805 188.402L222.832 200.714L225.422 198.909L221.807 180.547L206.373 176.09Z",
            fill: "#F5841F",
            stroke: "#F5841F",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M244.579 217.643L244.741 212.601L243.338 211.434H222.724L221.375 212.601L221.483 217.643L204.215 209.576L210.259 214.459L222.508 222.791H243.5L255.803 214.459L261.793 209.576L244.579 217.643Z",
            fill: "#C0AC9D",
            stroke: "#C0AC9D",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M243.23 200.714L240.64 198.909H225.422L222.832 200.714L221.375 212.601L222.724 211.434H243.338L244.741 212.601L243.23 200.714Z",
            fill: "#161616",
            stroke: "#161616",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M298.272 137.827L302.859 115.856L295.952 95.4242L243.23 133.899L263.52 150.775L292.174 159.001L298.488 151.731L295.736 149.767L300.107 145.84L296.761 143.293L301.132 140.002L298.272 137.827Z",
            fill: "#763E1A",
            stroke: "#763E1A",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M163.203 115.856L167.844 137.827L164.876 140.002L169.301 143.293L165.955 145.84L170.326 149.767L167.574 151.731L173.888 159.001L202.542 150.775L222.832 133.899L170.11 95.4242L163.203 115.856Z",
            fill: "#763E1A",
            stroke: "#763E1A",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M292.175 159.001L263.52 150.775L272.154 163.618L259.257 188.402L276.309 188.189H301.78L292.175 159.001Z",
            fill: "#F5841F",
            stroke: "#F5841F",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M202.542 150.775L173.888 159.001L164.336 188.189H189.753L206.805 188.402L193.908 163.618L202.542 150.775Z",
            fill: "#F5841F",
            stroke: "#F5841F",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("path", {
            d: "M241.395 164.998L243.23 133.9L251.54 111.77H214.522L222.832 133.9L224.667 164.998L225.368 174.763L225.422 198.909H240.64L240.694 174.763L241.395 164.998Z",
            fill: "#F5841F",
            stroke: "#F5841F",
            strokeWidth: "0.94513",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), t.createElement("defs", null, t.createElement("linearGradient", {
            id: "paint0_linear_1356_14057",
            x1: "335.991",
            y1: "250.487",
            x2: "303.873",
            y2: "266.801",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#FFE466"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#FFAFEA"
          })), t.createElement("linearGradient", {
            id: "paint1_linear_1356_14057",
            x1: "276.993",
            y1: "303.722",
            x2: "205.254",
            y2: "401.574",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "0.0929",
            stopColor: "#81C2F6"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#F0B8BD"
          })), t.createElement("linearGradient", {
            id: "paint2_linear_1356_14057",
            x1: "271.074",
            y1: "119.924",
            x2: "553.077",
            y2: "104.53",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#FFE466"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#FFAFEA"
          })), t.createElement("linearGradient", {
            id: "paint3_linear_1356_14057",
            x1: "264.209",
            y1: "91.0943",
            x2: "357.834",
            y2: "72.8792",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#FFE466"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#FFAFEA"
          })), t.createElement("linearGradient", {
            id: "paint4_linear_1356_14057",
            x1: "212.46",
            y1: "121.997",
            x2: "92.6119",
            y2: "183.406",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#FFE466"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#FFAFEA"
          })), t.createElement("linearGradient", {
            id: "paint5_linear_1356_14057",
            x1: "23.0498",
            y1: "204.411",
            x2: "161.86",
            y2: "163.003",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "0.0929",
            stopColor: "#81C2F6"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#F0B8BD"
          })), t.createElement("linearGradient", {
            id: "paint6_linear_1356_14057",
            x1: "78.8647",
            y1: "240.375",
            x2: "74.9655",
            y2: "241.328",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#75C3FC"
          })), t.createElement("linearGradient", {
            id: "paint7_linear_1356_14057",
            x1: "382.349",
            y1: "181.971",
            x2: "378.45",
            y2: "182.925",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#75C3FC"
          })), t.createElement("linearGradient", {
            id: "paint8_linear_1356_14057",
            x1: "349.889",
            y1: "244.583",
            x2: "345.99",
            y2: "245.537",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#75C3FC"
          })), t.createElement("linearGradient", {
            id: "paint9_linear_1356_14057",
            x1: "142.262",
            y1: "279.808",
            x2: "138.362",
            y2: "280.762",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#75C3FC"
          })), t.createElement("linearGradient", {
            id: "paint10_linear_1356_14057",
            x1: "123.305",
            y1: "99.0746",
            x2: "119.406",
            y2: "100.028",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#75C3FC"
          })), t.createElement("linearGradient", {
            id: "paint11_linear_1356_14057",
            x1: "371.818",
            y1: "156.617",
            x2: "367.919",
            y2: "157.571",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#75C3FC"
          })), t.createElement("linearGradient", {
            id: "paint12_linear_1356_14057",
            x1: "385.281",
            y1: "242.958",
            x2: "381.382",
            y2: "243.911",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#75C3FC"
          })), t.createElement("linearGradient", {
            id: "paint13_linear_1356_14057",
            x1: "367.125",
            y1: "37.5052",
            x2: "360.843",
            y2: "38.8076",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#75C3FC"
          })), t.createElement("linearGradient", {
            id: "paint14_linear_1356_14057",
            x1: "300.182",
            y1: "91.321",
            x2: "479.464",
            y2: "104.041",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#FFE466"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#FFAFEA"
          })), t.createElement("linearGradient", {
            id: "paint15_linear_1356_14057",
            x1: "363.434",
            y1: "201.232",
            x2: "102.977",
            y2: "302.269",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#FFE466"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#FFAFEA"
          })), t.createElement("linearGradient", {
            id: "paint16_linear_1356_14057",
            x1: "447.962",
            y1: "165.159",
            x2: "313.049",
            y2: "197.95",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "0.0929",
            stopColor: "#81C2F6"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#F0B8BD"
          })), t.createElement("linearGradient", {
            id: "paint17_linear_1356_14057",
            x1: "410.211",
            y1: "215.859",
            x2: "341.378",
            y2: "232.788",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#75C3FC"
          }), t.createElement("stop", {
            offset: "0.0929",
            stopColor: "#81C2F6"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#F0B8BD"
          })), t.createElement("linearGradient", {
            id: "paint18_linear_1356_14057",
            x1: "222.282",
            y1: "258.986",
            x2: "162.257",
            y2: "273.774",
            gradientUnits: "userSpaceOnUse"
          }, t.createElement("stop", {
            stopColor: "#FFE466"
          }), t.createElement("stop", {
            offset: "1",
            stopColor: "#FFAFEA"
          }))));
        },
        w = function (e) {
          var n = t.useState(2),
            r = n[0],
            o = n[1],
            u = e.sdkVersion,
            l = e.i18nInstance.t;
          return t.createElement(a, {
            className: "select-modal"
          }, t.createElement("div", {
            style: s.backdrop,
            onClick: e.onClose
          }), t.createElement("div", {
            style: s.modal
          }, t.createElement("div", {
            style: s.closeButtonContainer
          }, t.createElement("div", {
            style: s.right
          }, t.createElement("span", {
            style: s.closeButton,
            onClick: e.onClose
          }, t.createElement(c, null)))), t.createElement("div", {
            style: s.logoContainer
          }, t.createElement(h, null)), t.createElement("div", null, t.createElement("div", {
            style: s.tabcontainer
          }, t.createElement("div", {
            style: s.flexContainer
          }, t.createElement("div", {
            onClick: function () {
              return o(1);
            },
            style: i(i(i({}, s.tab), 1 === r ? s.tabactive : {}), s.flexItem)
          }, l("DESKTOP")), t.createElement("div", {
            onClick: function () {
              return o(2);
            },
            style: i(i(i({}, s.tab), 2 === r ? s.tabactive : {}), s.flexItem)
          }, l("MOBILE")))), t.createElement("div", {
            style: {
              display: 1 === r ? "none" : "block"
            }
          }, t.createElement("div", {
            style: s.flexContainer
          }, t.createElement("div", {
            style: i({
              textAlign: "center",
              marginTop: 4
            }, s.flexItem)
          }, t.createElement("div", {
            id: "sdk-qrcode-container",
            style: s.center
          }), t.createElement("div", {
            style: s.connectMobileText
          }, l("SCAN_TO_CONNECT"), t.createElement("br", null), t.createElement("span", {
            style: s.blue
          }, t.createElement("b", null, l("META_MASK_MOBILE_APP"))))))), t.createElement("div", {
            style: {
              display: 2 === r ? "none" : "block"
            }
          }, t.createElement("div", {
            style: {
              display: "flex",
              justifyContent: "center",
              height: 300,
              marginTop: -20
            }
          }, t.createElement(y, null)), t.createElement("div", {
            style: s.extensionLabel
          }, l("SELECT_MODAL.CRYPTO_TAKE_CONTROL_TEXT")), t.createElement("button", {
            style: s.button,
            onClick: e.connectWithExtension
          }, t.createElement(b, null), t.createElement("span", {
            style: s.installExtensionText
          }, l("CONNECT_WITH_EXTENSION"))))), t.createElement(m, {
            version: u
          })));
        },
        A = function () {
          function e(e) {
            var t = e.debug,
              n = e.sdkVersion,
              i = this;
            this.debug = !1, this.updateOTPValue = function (e) {
              i.debug && console.debug("ModalLoader: updateOTPValue", e), setTimeout(function () {
                var t;
                i.debug && console.debug("ModalLoader: updateOTPValue: delayed otp update"), t = document.getElementById("sdk-mm-otp-value"), i.debug && console.debug("ModalLoader: updateOTPValue: otpNode", t), t && (t.textContent = e, t.style.display = "block");
              }, 800);
            }, this.updateQRCode = function (e) {
              i.debug && console.debug("ModalLoader: updateQRCode", e);
              var t = document.getElementById("sdk-qrcode-container");
              t && (t.innerHTML = "", new (JB())({
                width: 270,
                height: 270,
                type: "svg",
                data: e,
                image: r,
                dotsOptions: {
                  color: "black",
                  type: "rounded"
                },
                imageOptions: {
                  margin: 5
                },
                cornersDotOptions: {
                  color: "#f66a07"
                },
                qrOptions: {
                  errorCorrectionLevel: "M"
                }
              }).append(t));
            }, this.debug = null != t && t, this.sdkVersion = n;
          }
          return e.prototype.renderInstallModal = function (e) {
            this.debug && console.debug("ModalLoader: renderInstallModal", e), this.installContainer = e.parentElement, n.createRoot(e.parentElement).render(t.createElement(g, {
              link: e.link,
              preferDesktop: e.preferDesktop,
              onClose: e.onClose,
              sdkVersion: this.sdkVersion,
              metaMaskInstaller: e.metaMaskInstaller,
              i18nInstance: e.i18nInstance
            }));
          }, e.prototype.renderSelectModal = function (e) {
            var r = this;
            this.debug && console.debug("ModalLoader: renderSelectModal", e), this.selectContainer = e.parentElement, n.createRoot(e.parentElement).render(t.createElement(w, {
              link: e.link,
              sdkVersion: this.sdkVersion,
              onClose: e.onClose,
              connectWithExtension: e.connectWithExtension,
              i18nInstance: e.i18nInstance
            })), setTimeout(function () {
              r.updateQRCode(e.link);
            }, 100);
          }, e.prototype.renderPendingModal = function (e) {
            this.debug && console.debug("ModalLoader: renderPendingModal", e), this.pendingContainer = e.parentElement, n.createRoot(e.parentElement).render(t.createElement(v, {
              onClose: e.onClose,
              onDisconnect: e.onDisconnect,
              sdkVersion: this.sdkVersion,
              updateOTPValue: e.updateOTPValue,
              displayOTP: e.displayOTP,
              i18nInstance: e.i18nInstance
            }));
          }, e.prototype.unmount = function () {
            var e, t, n, r, i, o;
            null === (t = null === (e = this.pendingContainer) || void 0 === e ? void 0 : e.parentNode) || void 0 === t || t.removeChild(this.pendingContainer), this.pendingContainer = void 0, null === (r = null === (n = this.installContainer) || void 0 === n ? void 0 : n.parentNode) || void 0 === r || r.removeChild(this.installContainer), this.installContainer = void 0, null === (o = null === (i = this.selectContainer) || void 0 === i ? void 0 : i.parentNode) || void 0 === o || o.removeChild(this.selectContainer), this.selectContainer = void 0;
          }, e;
        }();
      e.ModalLoader = A;
    }(t, IB(), GB());
  }(0, _B.exports);
  var XB = _B.exports;
  const ej = ({
      link: e,
      debug: t,
      installer: n,
      terminate: r,
      connectWithExtension: i,
      preferDesktop: o,
      i18nInstance: a
    }) => {
      let s = null,
        u = null;
      OL("[UI: InstallModal-web: sdkWebInstallModal()] ################## Installing Modal #################"), OL(`[UI: InstallModal-web: sdkWebInstallModal()] link=${e}`), OL(`[UI: InstallModal-web: sdkWebInstallModal()] npx uri-scheme open "${e}" --ios`), OL(`[UI: InstallModal-web: sdkWebInstallModal()] npx uri-scheme open "${e}" --android`), OL(`[UI: InstallModal-web: sdkWebInstallModal()] adb shell am start -a android.intent.action.VIEW -d "${e}"`);
      const c = e => {
        var t;
        OL(`[UI: InstallModal-web: sdkWebInstallModal()] installModal-web unmounting install modal -- shouldTerminate=${e}`, u), (null == u ? void 0 : u.parentNode) && (null === (t = u.parentNode) || void 0 === t || t.removeChild(u)), u = null, s = null, !0 === e && (null == r || r());
      };
      return {
        mount: r => {
          if (OL("[UI: InstallModal-web: sdkWebInstallModal()] installModal-web mounting install modal", u), u) return u.style.display = "block", void (null == s || s.updateQRCode(r));
          s = new XB.ModalLoader({
            debug: t,
            sdkVersion: SD
          }), u = document.createElement("div"), document.body.appendChild(u), window.extension ? s.renderSelectModal({
            i18nInstance: a,
            parentElement: u,
            connectWithExtension: () => {
              c(), null == i || i();
            },
            onClose: c,
            link: e
          }) : s.renderInstallModal({
            i18nInstance: a,
            parentElement: u,
            preferDesktop: null != o && o,
            link: e,
            metaMaskInstaller: n,
            onClose: c
          });
        },
        unmount: c
      };
    },
    tj = ({
      onDisconnect: e,
      i18nInstance: t,
      debug: n
    }) => {
      let r = null,
        i = null;
      const o = () => {
          OL("[UI: pendingModal-web: sdkWebPendingModal()] pendingModal-web unmount", r), (null == r ? void 0 : r.parentNode) && r.parentNode.removeChild(r), r = null, i = null;
        },
        a = e => {
          OL("[UI: pendingModal-web: sdkWebPendingModal()] pendingModal-web updateOTPValue", e), i && i.updateOTPValue(e);
        },
        s = ({
          displayOTP: s
        } = {
          displayOTP: !0
        }) => {
          OL("[UI: pendingModal-web: sdkWebPendingModal()] pendingModal-web mount", r), r ? r.style.display = "block" : (i = new XB.ModalLoader({
            debug: n,
            sdkVersion: SD
          }), r = document.createElement("div"), document.body.appendChild(r), i.renderPendingModal({
            i18nInstance: t,
            parentElement: r,
            onClose: o,
            onDisconnect: e,
            updateOTPValue: a,
            displayOTP: s
          }));
        };
      return s(), {
        mount: s,
        unmount: o,
        updateOTPValue: a
      };
    };
  function nj(t, n, r) {
    return wS(this, void 0, void 0, function* () {
      return new Promise((i, o) => {
        if (!t.connector) return void o(new Error("No connector available"));
        OL("[RemoteConnection: connectWithModalInstaller()]", {
          state: t,
          options: n,
          linkParams: r
        });
        const a = `${t.useDeeplink ? RD : xD}?${r}`;
        !function (e, t, n) {
          var r, i, o, a;
          e.installModal = null === (i = (r = t.modals).install) || void 0 === i ? void 0 : i.call(r, {
            i18nInstance: t.sdk.i18nInstance,
            link: n,
            preferDesktop: e.preferDesktop,
            installer: t.getMetaMaskInstaller(),
            terminate: () => {
              OL("[RemoteConnection: showInstallModal() => terminate()] terminate connection"), t.sdk.terminate();
            },
            debug: e.developerMode,
            connectWithExtension: () => {
              var e;
              return null === (e = t.connectWithExtensionProvider) || void 0 === e || e.call(t), !1;
            }
          }), null === (a = null === (o = e.installModal) || void 0 === o ? void 0 : o.mount) || void 0 === a || a.call(o, n);
        }(t, n, a), n.sdk.once(e.EventType.PROVIDER_UPDATE, e => wS(this, void 0, void 0, function* () {
          OL("[RemoteConnection: connectWithModalInstaller()] once provider_update -- resolving startConnection promise"), o(e);
        })), t.connector.once(e.EventType.CLIENTS_READY, () => wS(this, void 0, void 0, function* () {
          OL("[RemoteConnection: connectWithModalInstaller()] once clients_ready -- resolving startConnection promise"), i();
        }));
      });
    });
  }
  function rj(e, t) {
    var n, r, i, o;
    null === (r = (n = e.modals).onPendingModalDisconnect) || void 0 === r || r.call(n), null === (o = null === (i = t.pendingModal) || void 0 === i ? void 0 : i.unmount) || void 0 === o || o.call(i);
  }
  function ij(e, t, n) {
    var r, i, o, a, s, u, c, l, d, f, h, p, m, g;
    return wS(this, void 0, void 0, function* () {
      const v = OD.getProvider(),
        b = Date.now();
      if (void 0 !== n.lastActive && b - n.lastActive < PD) return v._setConnected(), e.pendingModal = null === (i = (r = t.modals).otp) || void 0 === i ? void 0 : i.call(r, {
        i18nInstance: t.i18nInstance,
        debug: e.developerMode,
        onDisconnect: () => rj(t, e)
      }), null === (a = null === (o = e.installModal) || void 0 === o ? void 0 : o.unmount) || void 0 === a || a.call(o, !1), null === (u = null === (s = e.pendingModal) || void 0 === s ? void 0 : s.unmount) || void 0 === u || u.call(s), null === (l = null === (c = e.pendingModal) || void 0 === c ? void 0 : c.mount) || void 0 === l || l.call(c, {
        displayOTP: !1
      }), e.authorized = !0, void (e.developerMode && console.debug("RCPMS::on 'authorized' provider.state", v.getState()));
      e.pendingModal ? null === (f = null === (d = e.pendingModal) || void 0 === d ? void 0 : d.mount) || void 0 === f || f.call(d) : e.pendingModal = null === (p = (h = t.modals).otp) || void 0 === p ? void 0 : p.call(h, {
        i18nInstance: t.i18nInstance,
        debug: e.developerMode,
        onDisconnect: () => rj(t, e)
      });
      const y = yield function (e) {
        return wS(this, void 0, void 0, function* () {
          for (; void 0 === e.otpAnswer;) yield new Promise(e => setTimeout(() => e(), 1e3));
          return e.otpAnswer;
        });
      }(e);
      e.otpAnswer !== y && (e.otpAnswer = y, null === (g = null === (m = e.pendingModal) || void 0 === m ? void 0 : m.updateOTPValue) || void 0 === g || g.call(m, y));
    });
  }
  function oj(e, t, {
    initialCheck: n
  } = {}) {
    var r, i, o, a, s, u, c, l, d, f, h, p, m, g;
    return wS(this, void 0, void 0, function* () {
      if (!e.connector) throw new Error("no connector defined");
      const v = OD.getProvider();
      e.authorized = !1, v.emit("connecting");
      const b = yield null === (r = e.connector) || void 0 === r ? void 0 : r.originatorSessionConnect();
      OL(`[RemoteConnection: startConnection()] after originatorSessionConnect initialCheck=${n}`, b);
      let y = null !== (i = null == b ? void 0 : b.channelId) && void 0 !== i ? i : "",
        w = null !== (a = null === (o = e.connector.getKeyInfo()) || void 0 === o ? void 0 : o.ecies.public) && void 0 !== a ? a : "";
      if (n && !b) return Promise.resolve();
      if (n && !(null == b ? void 0 : b.relayPersistence)) return Promise.resolve();
      if (!b && !n) {
        const t = yield e.connector.generateChannelIdConnect();
        y = null !== (s = t.channelId) && void 0 !== s ? s : "", w = null !== (c = null === (u = e.connector.getKeyInfo()) || void 0 === u ? void 0 : u.ecies.public) && void 0 !== c ? c : "";
      }
      if (n && (null == b ? void 0 : b.channelId)) return (null === (l = e.connector) || void 0 === l ? void 0 : l.isConnected()) || (OL(`[RemoteConnection: startConnection()] reconnecting to channel initialCheck=${n}`, b), null === (d = e.connector) || void 0 === d || d.connectToChannel({
        channelId: y
      })), Promise.resolve();
      b && !(null === (f = e.connector) || void 0 === f ? void 0 : f.isConnected()) && (OL("[RemoteConnection: startConnection()] reconnecting to channel", b), null === (h = e.connector) || void 0 === h || h.connectToChannel({
        channelId: y
      }));
      const A = (null === (p = e.platformManager) || void 0 === p ? void 0 : p.isSecure()) ? "" : "&t=q",
        _ = encodeURI(`channelId=${y}&v=2&comm=${null !== (m = e.communicationLayerPreference) && void 0 !== m ? m : ""}&pubkey=${w}${A}`),
        E = `${e.useDeeplink ? RD : xD}?${_}`;
      return e.qrcodeLink = E, e.developerMode && OL(`[RemoteConnection: startConnection()] qrcodeLink=${E}`), (null === (g = e.platformManager) || void 0 === g ? void 0 : g.isSecure()) ? function (e, t) {
        var n, r;
        return wS(this, void 0, void 0, function* () {
          const i = `${xD}?${t}`,
            o = `${RD}?${t}`;
          null === (r = null === (n = e.platformManager) || void 0 === n ? void 0 : n.openDeeplink) || void 0 === r || r.call(n, i, o, "_self");
        });
      }(e, _) : (null == b ? void 0 : b.lastActive) ? ij(e, t, b) : nj(e, t, _);
    });
  }
  class aj {
    constructor(t) {
      var n, r, i;
      this.state = {
        connector: void 0,
        qrcodeLink: void 0,
        analytics: void 0,
        developerMode: !1,
        authorized: !1,
        reconnection: !1,
        preferDesktop: !1,
        communicationLayerPreference: void 0,
        platformManager: void 0,
        pendingModal: void 0,
        installModal: void 0,
        otpAnswer: void 0
      }, this.options = t;
      const o = !0 === (null === (n = t.logging) || void 0 === n ? void 0 : n.developerMode) || !0 === (null === (r = t.logging) || void 0 === r ? void 0 : r.sdk);
      this.state.developerMode = o, this.state.analytics = t.analytics, this.state.preferDesktop = null !== (i = t.preferDesktop) && void 0 !== i && i, this.state.useDeeplink = t.sdk.options.useDeeplink, this.state.communicationLayerPreference = t.communicationLayerPreference, this.state.platformManager = t.platformManager, t.modals.install || (t.modals.install = ej), t.modals.otp || (t.modals.otp = tj), function (e, t) {
        var n, r, i, o;
        OL("[RemoteConnection: initializeConnector()] initialize connector"), e.connector = new yS({
          platformType: t.platformManager.getPlatformType(),
          communicationLayerPreference: t.communicationLayerPreference,
          transports: t.transports,
          dappMetadata: Object.assign(Object.assign({}, t.dappMetadata), {
            source: t._source
          }),
          analytics: t.enableAnalytics,
          communicationServerUrl: t.communicationServerUrl,
          sdkVersion: SD,
          context: "dapp",
          ecies: t.ecies,
          storage: t.storage,
          logging: t.logging
        }), t.timer && (OL("[RemoteConnection: initializeConnector()] reset background timer", t.timer), null === (r = null === (n = t.timer) || void 0 === n ? void 0 : n.stopBackgroundTimer) || void 0 === r || r.call(n), null === (o = null === (i = t.timer) || void 0 === i ? void 0 : i.runBackgroundTimer) || void 0 === o || o.call(i, () => !1, 1e4));
      }(this.state, this.options), function (t, n) {
        var r;
        t.connector && ((null === (r = t.platformManager) || void 0 === r ? void 0 : r.isSecure()) || t.connector.on(e.EventType.OTP, e => {
          var r, i, o, a, s, u;
          if (t.otpAnswer !== e) {
            if (OL("[RemoteConnection: setupListeners() => EventType.OTP] 'OTP' ", e), t.otpAnswer = e, !t.pendingModal) {
              OL("[RemoteConnection: setupListeners() => EventType.OTP] 'OTP' init pending modal");
              const e = () => {
                var e, r, i, o, a, s;
                null === (r = (e = n.modals).onPendingModalDisconnect) || void 0 === r || r.call(e), null === (o = null === (i = t.pendingModal) || void 0 === i ? void 0 : i.unmount) || void 0 === o || o.call(i), null === (s = null === (a = t.pendingModal) || void 0 === a ? void 0 : a.updateOTPValue) || void 0 === s || s.call(a, "");
              };
              t.pendingModal = null === (i = (r = n.modals).otp) || void 0 === i ? void 0 : i.call(r, {
                i18nInstance: n.i18nInstance,
                onDisconnect: e
              });
            }
            null === (a = null === (o = t.pendingModal) || void 0 === o ? void 0 : o.mount) || void 0 === a || a.call(o), null === (u = null === (s = t.pendingModal) || void 0 === s ? void 0 : s.updateOTPValue) || void 0 === u || u.call(s, e);
          }
        }), t.connector.on(e.EventType.SDK_RPC_CALL, e => wS(this, void 0, void 0, function* () {
          var n, r;
          OL("[RemoteConnection: setupListeners() => EventType.SDK_RPC_CALL] 'sdk_rpc_call' requestParam", e);
          const i = OD.getProvider(),
            o = yield i.request(e);
          OL("[RemoteConnection: setupListeners() => EventType.SDK_RPC_CALL] 'sdk_rpc_call' result", o), null === (r = null === (n = t.pendingModal) || void 0 === n ? void 0 : n.unmount) || void 0 === r || r.call(n);
        })), t.connector.on(e.EventType.AUTHORIZED, () => wS(this, void 0, void 0, function* () {
          var e, r, i, o, a;
          try {
            OL("[RemoteConnection: setupListeners() => EventType.AUTHORIZED] 'authorized' closing modals", t.pendingModal, t.installModal), n.enableAnalytics && (null === (e = t.analytics) || void 0 === e || e.send({
              event: XE.AUTHORIZED
            }));
            const s = OD.getProvider();
            s._setConnected(), null === (i = null === (r = t.pendingModal) || void 0 === r ? void 0 : r.unmount) || void 0 === i || i.call(r), null === (a = null === (o = t.installModal) || void 0 === o ? void 0 : o.unmount) || void 0 === a || a.call(o, !1), t.otpAnswer = void 0, t.authorized = !0, OL("[RemoteConnection: setupListeners() => EventType.AUTHORIZED] 'authorized' provider.state", s.getState()), yield s.forceInitializeState();
          } catch (e) {
            console.log("🟠 ~ file: setupListeners.ts:107 ~ state.connector.on ~ err:", e);
          }
        })), t.connector.on(e.EventType.CLIENTS_DISCONNECTED, () => {
          var n, r, i;
          OL(`[RemoteConnection: setupListeners() => EventType.CLIENTS_DISCONNECTED] received '${e.EventType.CLIENTS_DISCONNECTED}'`), (null === (n = t.platformManager) || void 0 === n ? void 0 : n.isSecure()) || (OD.getProvider().handleDisconnect({
            terminate: !1
          }), null === (i = null === (r = t.pendingModal) || void 0 === r ? void 0 : r.updateOTPValue) || void 0 === i || i.call(r, ""));
        }), t.connector.on(e.EventType.TERMINATE, () => {
          var e, r, i, o, a, s, u, c;
          (null === (e = t.connector) || void 0 === e ? void 0 : e.isAuthorized()) || n.enableAnalytics && (null === (r = t.analytics) || void 0 === r || r.send({
            event: XE.REJECTED
          })), (null === (i = t.platformManager) || void 0 === i ? void 0 : i.isBrowser()) ? alert("SDK Connection has been terminated from MetaMask.") : console.info("SDK Connection has been terminated"), null === (a = null === (o = t.pendingModal) || void 0 === o ? void 0 : o.unmount) || void 0 === a || a.call(o), null === (u = null === (s = t.installModal) || void 0 === s ? void 0 : s.unmount) || void 0 === u || u.call(s, !0), t.pendingModal = void 0, t.installModal = void 0, t.otpAnswer = void 0, null === (c = t.connector) || void 0 === c || c.disconnect({
            terminate: !0
          }), t.authorized = !1, OD.getProvider().handleDisconnect({
            terminate: !0
          });
        }));
      }(this.state, this.options);
    }
    startConnection(e) {
      return wS(this, void 0, void 0, function* () {
        return oj(this.state, this.options, e);
      });
    }
    showActiveModal() {
      return function (e) {
        var t, n, r, i;
        e.authorized ? OL("[RemoteConnection: showActiveModal()] already authorized") : e.pendingModal ? null === (n = (t = e.pendingModal).mount) || void 0 === n || n.call(t) : e.installModal && (null === (i = (r = e.installModal).mount) || void 0 === i || i.call(r, e.qrcodeLink || ""));
      }(this.state);
    }
    getUniversalLink() {
      if (!this.state.qrcodeLink) throw new Error("connection not started. run startConnection() first.");
      return this.state.qrcodeLink;
    }
    getChannelConfig() {
      var e;
      return null === (e = this.state.connector) || void 0 === e ? void 0 : e.getChannelConfig();
    }
    getKeyInfo() {
      var e;
      return null === (e = this.state.connector) || void 0 === e ? void 0 : e.getKeyInfo();
    }
    getConnector() {
      if (!this.state.connector) throw new Error("invalid remote connector");
      return this.state.connector;
    }
    getPlatformManager() {
      if (!this.state.platformManager) throw new Error("platformManager is not initialized");
      return this.state.platformManager;
    }
    isConnected() {
      var e;
      return (null === (e = this.state.connector) || void 0 === e ? void 0 : e.isReady()) || !1;
    }
    isAuthorized() {
      var e;
      return (null === (e = this.state.connector) || void 0 === e ? void 0 : e.isAuthorized()) || !1;
    }
    isPaused() {
      var e;
      return null === (e = this.state.connector) || void 0 === e ? void 0 : e.isPaused();
    }
    disconnect(e) {
      var t, n, r;
      OL("[RemoteConnection: disconnect()]", e), (null == e ? void 0 : e.terminate) && (OD.getProvider().handleDisconnect({
        terminate: !0
      }), null === (n = null === (t = this.state.pendingModal) || void 0 === t ? void 0 : t.unmount) || void 0 === n || n.call(t), this.state.otpAnswer = void 0), null === (r = this.state.connector) || void 0 === r || r.disconnect(e);
    }
  }
  const sj = e => wS(void 0, void 0, void 0, function* () {
      const {
          options: t
        } = e,
        {
          infuraAPIKey: n
        } = t;
      if (!n) return;
      const r = {
        "0x1": `https://mainnet.infura.io/v3/${n}`,
        "0x5": `https://goerli.infura.io/v3/${n}`,
        "0x2a": `https://sepolia.infura.io/v3/${n}`,
        "0xe708": `https://linea-mainnet.infura.io/v3/${n}`,
        "0xe704": `https://linea-goerli.infura.io/v3/${n}`,
        "0x89": `https://polygon-mainnet.infura.io/v3/${n}`,
        "0x13881": `https://polygon-mumbai.infura.io/v3/${n}`,
        "0x45": `https://optimism-mainnet.infura.io/v3/${n}`,
        "0x1a4": `https://optimism-goerli.infura.io/v3/${n}`,
        "0xa4b1": `https://arbitrum-mainnet.infura.io/v3/${n}`,
        "0x66eed": `https://arbitrum-goerli.infura.io/v3/${n}`,
        "0x2a15c308d": `https://palm-mainnet.infura.io/v3/${n}`,
        "0x2a15c3083": `https://palm-testnet.infura.io/v3/${n}`,
        "0xa86a": `https://avalanche-mainnet.infura.io/v3/${n}`,
        "0xa869": `https://avalanche-fuji.infura.io/v3/${n}`,
        "0x4e454152": `https://aurora-mainnet.infura.io/v3/${n}`,
        "0x4e454153": `https://aurora-testnet.infura.io/v3/${n}`,
        "0x534e5f4d41494e": `https://starknet-mainnet.infura.io/v3/${n}`,
        "0x534e5f474f45524c49": `https://starknet-goerli.infura.io/v3/${n}`,
        "0x534e5f474f45524c4932": `https://starknet-goerli2.infura.io/v3/${n}`,
        "0xa4ec": `https://celo-mainnet.infura.io/v3/${n}`,
        "0xaef3": `https://celo-alfajores.infura.io/v3/${n}`
      };
      e.options.readonlyRPCMap ? e.options.readonlyRPCMap = Object.assign(Object.assign({}, e.options.readonlyRPCMap), r) : e.options.readonlyRPCMap = r;
    }),
    uj = e => wS(void 0, void 0, void 0, function* () {
      const {
          options: t
        } = e,
        {
          readonlyRPCMap: n
        } = t;
      if (n) try {
        OL("[MetaMaskSDK: setupReadOnlyRPCProviders()] Setting up Readonly RPC Providers", n), e.setReadOnlyRPCCalls(!0);
      } catch (e) {
        throw new Error("Invalid Infura Settings");
      }
    });
  function cj(e) {
    return cj = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, cj(e);
  }
  function lj(e) {
    var t = function (e, t) {
      if ("object" !== cj(e) || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t || "default");
        if ("object" !== cj(r)) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === cj(t) ? t : String(t);
  }
  function dj(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, lj(r.key), r);
    }
  }
  var fj = [],
    hj = fj.forEach,
    pj = fj.slice;
  var mj = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/,
    gj = function (e, t, n, r) {
      var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {
        path: "/",
        sameSite: "strict"
      };
      n && (i.expires = new Date(), i.expires.setTime(i.expires.getTime() + 60 * n * 1e3)), r && (i.domain = r), document.cookie = function (e, t, n) {
        var r = n || {};
        r.path = r.path || "/";
        var i = encodeURIComponent(t),
          o = "".concat(e, "=").concat(i);
        if (r.maxAge > 0) {
          var a = r.maxAge - 0;
          if (Number.isNaN(a)) throw new Error("maxAge should be a Number");
          o += "; Max-Age=".concat(Math.floor(a));
        }
        if (r.domain) {
          if (!mj.test(r.domain)) throw new TypeError("option domain is invalid");
          o += "; Domain=".concat(r.domain);
        }
        if (r.path) {
          if (!mj.test(r.path)) throw new TypeError("option path is invalid");
          o += "; Path=".concat(r.path);
        }
        if (r.expires) {
          if ("function" != typeof r.expires.toUTCString) throw new TypeError("option expires is invalid");
          o += "; Expires=".concat(r.expires.toUTCString());
        }
        if (r.httpOnly && (o += "; HttpOnly"), r.secure && (o += "; Secure"), r.sameSite) switch ("string" == typeof r.sameSite ? r.sameSite.toLowerCase() : r.sameSite) {
          case !0:
            o += "; SameSite=Strict";
            break;
          case "lax":
            o += "; SameSite=Lax";
            break;
          case "strict":
            o += "; SameSite=Strict";
            break;
          case "none":
            o += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
        return o;
      }(e, encodeURIComponent(t), i);
    },
    vj = function (e) {
      for (var t = "".concat(e, "="), n = document.cookie.split(";"), r = 0; r < n.length; r++) {
        for (var i = n[r]; " " === i.charAt(0);) i = i.substring(1, i.length);
        if (0 === i.indexOf(t)) return i.substring(t.length, i.length);
      }
      return null;
    },
    bj = {
      name: "cookie",
      lookup: function (e) {
        var t;
        if (e.lookupCookie && "undefined" != typeof document) {
          var n = vj(e.lookupCookie);
          n && (t = n);
        }
        return t;
      },
      cacheUserLanguage: function (e, t) {
        t.lookupCookie && "undefined" != typeof document && gj(t.lookupCookie, e, t.cookieMinutes, t.cookieDomain, t.cookieOptions);
      }
    },
    yj = {
      name: "querystring",
      lookup: function (e) {
        var t;
        if ("undefined" != typeof window) {
          var n = window.location.search;
          !window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1 && (n = window.location.hash.substring(window.location.hash.indexOf("?")));
          for (var r = n.substring(1).split("&"), i = 0; i < r.length; i++) {
            var o = r[i].indexOf("=");
            if (o > 0) r[i].substring(0, o) === e.lookupQuerystring && (t = r[i].substring(o + 1));
          }
        }
        return t;
      }
    },
    wj = null,
    Aj = function () {
      if (null !== wj) return wj;
      try {
        wj = "undefined" !== window && null !== window.localStorage;
        var e = "i18next.translate.boo";
        window.localStorage.setItem(e, "foo"), window.localStorage.removeItem(e);
      } catch (e) {
        wj = !1;
      }
      return wj;
    },
    _j = {
      name: "localStorage",
      lookup: function (e) {
        var t;
        if (e.lookupLocalStorage && Aj()) {
          var n = window.localStorage.getItem(e.lookupLocalStorage);
          n && (t = n);
        }
        return t;
      },
      cacheUserLanguage: function (e, t) {
        t.lookupLocalStorage && Aj() && window.localStorage.setItem(t.lookupLocalStorage, e);
      }
    },
    Ej = null,
    Sj = function () {
      if (null !== Ej) return Ej;
      try {
        Ej = "undefined" !== window && null !== window.sessionStorage;
        var e = "i18next.translate.boo";
        window.sessionStorage.setItem(e, "foo"), window.sessionStorage.removeItem(e);
      } catch (e) {
        Ej = !1;
      }
      return Ej;
    },
    kj = {
      name: "sessionStorage",
      lookup: function (e) {
        var t;
        if (e.lookupSessionStorage && Sj()) {
          var n = window.sessionStorage.getItem(e.lookupSessionStorage);
          n && (t = n);
        }
        return t;
      },
      cacheUserLanguage: function (e, t) {
        t.lookupSessionStorage && Sj() && window.sessionStorage.setItem(t.lookupSessionStorage, e);
      }
    },
    Mj = {
      name: "navigator",
      lookup: function (e) {
        var t = [];
        if ("undefined" != typeof navigator) {
          if (navigator.languages) for (var n = 0; n < navigator.languages.length; n++) t.push(navigator.languages[n]);
          navigator.userLanguage && t.push(navigator.userLanguage), navigator.language && t.push(navigator.language);
        }
        return t.length > 0 ? t : void 0;
      }
    },
    Cj = {
      name: "htmlTag",
      lookup: function (e) {
        var t,
          n = e.htmlTag || ("undefined" != typeof document ? document.documentElement : null);
        return n && "function" == typeof n.getAttribute && (t = n.getAttribute("lang")), t;
      }
    },
    xj = {
      name: "path",
      lookup: function (e) {
        var t;
        if ("undefined" != typeof window) {
          var n = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
          if (n instanceof Array) if ("number" == typeof e.lookupFromPathIndex) {
            if ("string" != typeof n[e.lookupFromPathIndex]) return;
            t = n[e.lookupFromPathIndex].replace("/", "");
          } else t = n[0].replace("/", "");
        }
        return t;
      }
    },
    Rj = {
      name: "subdomain",
      lookup: function (e) {
        var t = "number" == typeof e.lookupFromSubdomainIndex ? e.lookupFromSubdomainIndex + 1 : 1,
          n = "undefined" != typeof window && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        if (n) return n[t];
      }
    };
  var Ij = function () {
    function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.type = "languageDetector", this.detectors = {}, this.init(t, n);
    }
    var t, n, r;
    return t = e, n = [{
      key: "init",
      value: function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        this.services = e || {
          languageUtils: {}
        }, this.options = function (e) {
          return hj.call(pj.call(arguments, 1), function (t) {
            if (t) for (var n in t) void 0 === e[n] && (e[n] = t[n]);
          }), e;
        }(t, this.options || {}, {
          order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
          lookupQuerystring: "lng",
          lookupCookie: "i18next",
          lookupLocalStorage: "i18nextLng",
          lookupSessionStorage: "i18nextLng",
          caches: ["localStorage"],
          excludeCacheFor: ["cimode"],
          convertDetectedLanguage: function (e) {
            return e;
          }
        }), "string" == typeof this.options.convertDetectedLanguage && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = function (e) {
          return e.replace("-", "_");
        }), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = n, this.addDetector(bj), this.addDetector(yj), this.addDetector(_j), this.addDetector(kj), this.addDetector(Mj), this.addDetector(Cj), this.addDetector(xj), this.addDetector(Rj);
      }
    }, {
      key: "addDetector",
      value: function (e) {
        this.detectors[e.name] = e;
      }
    }, {
      key: "detect",
      value: function (e) {
        var t = this;
        e || (e = this.options.order);
        var n = [];
        return e.forEach(function (e) {
          if (t.detectors[e]) {
            var r = t.detectors[e].lookup(t.options);
            r && "string" == typeof r && (r = [r]), r && (n = n.concat(r));
          }
        }), n = n.map(function (e) {
          return t.options.convertDetectedLanguage(e);
        }), this.services.languageUtils.getBestMatchFromCodes ? n : n.length > 0 ? n[0] : null;
      }
    }, {
      key: "cacheUserLanguage",
      value: function (e, t) {
        var n = this;
        t || (t = this.options.caches), t && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(e) > -1 || t.forEach(function (t) {
          n.detectors[t] && n.detectors[t].cacheUserLanguage(e, n.options);
        }));
      }
    }], n && dj(t.prototype, n), r && dj(t, r), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e;
  }();
  Ij.type = "languageDetector";
  var Tj = {
      DESKTOP: "Desktop",
      MOBILE: "Mobile",
      META_MASK_MOBILE_APP: "MetaMask mobile app",
      SCAN_TO_CONNECT: "Scan to connect and sign with",
      CONNECT_WITH_EXTENSION: "Connect With MetaMask Extension",
      INSTALL_MODAL: {
        TRUSTED_BY_USERS: "Trusted by over 30 million users to buy, store, send and swap crypto securely",
        LEADING_CRYPTO_WALLET: "The leading crypto wallet & gateway to blockchain apps built on Ethereum Mainnet, Polygon, Optimism, and many other networks",
        CONTROL_DIGITAL_INTERACTIONS: "Puts you in control of your digital interactions by making power of cryptography more accessible",
        INSTALL_META_MASK_EXTENSION: "Install MetaMask Extension"
      },
      PENDING_MODAL: {
        OPEN_META_MASK_SELECT_CODE: "Please open the MetaMask wallet app and select the code on the screen OR disconnect",
        OPEN_META_MASK_CONTINUE: "Open the MetaMask app to continue with your session.",
        NUMBER_AFTER_OPEN_NOTICE: "If a number doesn't appear after opening MetaMask, please click disconnect and re-scan the QRCode.",
        DISCONNECT: "Disconnect"
      },
      SELECT_MODAL: {
        CRYPTO_TAKE_CONTROL_TEXT: "Take control of your crypto and explore the blockchain with the wallet trusted by over 30 million people worldwide"
      },
      META_MASK_MODAL: {
        ADDRESS_COPIED: "Address copied to clipboard!",
        DISCONNECT: "Disconnect",
        ACTIVE_NETWORK: "Active Network"
      }
    },
    Pj = {
      DESKTOP: "Escritorio",
      MOBILE: "Móvil",
      META_MASK_MOBILE_APP: "Aplicación móvil de MetaMask",
      SCAN_TO_CONNECT: "Escanear para conectar y firmar con",
      CONNECT_WITH_EXTENSION: "Conectar con la Extensión de MetaMask",
      INSTALL_MODAL: {
        TRUSTED_BY_USERS: "Confiado por más de 30 millones de usuarios para comprar, almacenar, enviar e intercambiar cripto de manera segura",
        LEADING_CRYPTO_WALLET: "La principal billetera de criptomonedas y pasarela hacia aplicaciones blockchain construidas en Ethereum Mainnet, Polygon, Optimism y muchas otras redes",
        CONTROL_DIGITAL_INTERACTIONS: "Te da el control de tus interacciones digitales al hacer que el poder de la criptografía sea más accesible",
        INSTALL_META_MASK_EXTENSION: "Instalar la Extensión de MetaMask"
      },
      PENDING_MODAL: {
        OPEN_META_MASK_SELECT_CODE: "Por favor, abre la aplicación de billetera MetaMask y selecciona el código en la pantalla O desconecta",
        OPEN_META_MASK_CONTINUE: "Abre la aplicación de MetaMask para continuar con tu sesión.",
        NUMBER_AFTER_OPEN_NOTICE: "Si no aparece un número después de abrir MetaMask, por favor haz clic en desconectar y vuelve a escanear el código QR.",
        DISCONNECT: "Desconectar"
      },
      SELECT_MODAL: {
        CRYPTO_TAKE_CONTROL_TEXT: "Toma el control de tu cripto y explora la blockchain con la billetera en la que confían más de 30 millones de personas en todo el mundo"
      },
      META_MASK_MODAL: {
        ADDRESS_COPIED: "¡Dirección copiada al portapapeles!",
        DISCONNECT: "Desconectar",
        ACTIVE_NETWORK: "Red activa"
      }
    },
    Oj = {
      DESKTOP: "Bureau",
      MOBILE: "Mobile",
      META_MASK_MOBILE_APP: "Application mobile MetaMask",
      SCAN_TO_CONNECT: "Scannez pour vous connecter et signer avec",
      CONNECT_WITH_EXTENSION: "Connectez-vous avec l'extension MetaMask",
      INSTALL_MODAL: {
        TRUSTED_BY_USERS: "Fait confiance à plus de 30 millions d'utilisateurs pour acheter, stocker, envoyer et échanger des crypto en toute sécurité",
        LEADING_CRYPTO_WALLET: "Le portefeuille crypto leader et la passerelle vers des applications blockchain basées sur Ethereum Mainnet, Polygon, Optimism, et de nombreux autres réseaux",
        CONTROL_DIGITAL_INTERACTIONS: "Vous donne le contrôle de vos interactions numériques en rendant la puissance de la cryptographie plus accessible",
        INSTALL_META_MASK_EXTENSION: "Installez l'extension MetaMask"
      },
      PENDING_MODAL: {
        OPEN_META_MASK_SELECT_CODE: "Veuillez ouvrir l'application MetaMask et sélectionnez le code à l'écran OU déconnectez-vous",
        OPEN_META_MASK_CONTINUE: "Ouvrez l'application MetaMask pour continuer votre session.",
        NUMBER_AFTER_OPEN_NOTICE: "Si un numéro n'apparaît pas après avoir ouvert MetaMask, veuillez cliquer sur déconnecter et rescanner le QRCode.",
        DISCONNECT: "Déconnecter"
      },
      SELECT_MODAL: {
        CRYPTO_TAKE_CONTROL_TEXT: "Prenez le contrôle de votre crypto et explorez la blockchain avec le portefeuille fait confiance par plus de 30 millions de personnes à travers le monde"
      },
      META_MASK_MODAL: {
        ADDRESS_COPIED: "Adresse copiée dans le presse-papiers!",
        DISCONNECT: "Déconnecter",
        ACTIVE_NETWORK: "Réseau actif"
      }
    },
    Lj = {
      DESKTOP: "שולחן עבודה",
      MOBILE: "נייד",
      META_MASK_MOBILE_APP: "אפליקציית מטא מאסק לנייד",
      SCAN_TO_CONNECT: "סרוק כדי להתחבר ולחתום עם",
      CONNECT_WITH_EXTENSION: "התחבר עם התוסף של מטא מאסק",
      INSTALL_MODAL: {
        TRUSTED_BY_USERS: "מהימנים על ידי למעלה מ-30 מיליון משתמשים לקנות, לאחסן, לשלוח ולהחליף מטבע קריפטוגרפי בבטחה",
        LEADING_CRYPTO_WALLET: "ארנק הקריפטו המוביל והשער ליישומי בלוקצ'יין המתוכנתים על אתריום, פוליגון, ורשתות רבות נוספות",
        CONTROL_DIGITAL_INTERACTIONS: "מכניס אותך לשליטה על האינטראקציות הדיגיטליות שלך על ידי הפיכת כוח הקריפטוגרפיה לנגיש יותר",
        INSTALL_META_MASK_EXTENSION: "התקן את ההרחבה של מטא מאסק"
      },
      PENDING_MODAL: {
        OPEN_META_MASK_SELECT_CODE: "אנא פתח את אפליקציית ארנק מטא מאסק ובחר את הקוד שמופיע על המסך או התנתק",
        OPEN_META_MASK_CONTINUE: "פתח את האפליקציה של מטא מאסק כדי להמשיך בפעולה שלך.",
        NUMBER_AFTER_OPEN_NOTICE: "אם מספר אינו מופיע לאחר פתיחת מטא מאסק, אנא לחץ על התנתקות וסרוק מחדש את ה-QRCode.",
        DISCONNECT: "התנתק"
      },
      SELECT_MODAL: {
        CRYPTO_TAKE_CONTROL_TEXT: "קח שליטה על הקריפטו שלך וחקור את הבלוקצ'יין עם הארנק האמין שבשימוש על ידי למעלה מ-30 מיליון אנשים ברחבי העולם"
      },
      META_MASK_MODAL: {
        ADDRESS_COPIED: "הכתובת הועתקה ללוח!",
        DISCONNECT: "התנתק",
        ACTIVE_NETWORK: "רשת פעילה"
      }
    },
    Nj = {
      DESKTOP: "Desktop",
      MOBILE: "Mobile",
      META_MASK_MOBILE_APP: "App mobile MetaMask",
      SCAN_TO_CONNECT: "Scansiona per connetterti e firmare con",
      CONNECT_WITH_EXTENSION: "Connettiti con l'estensione MetaMask",
      INSTALL_MODAL: {
        TRUSTED_BY_USERS: "Ritenuto affidabile da oltre 30 milioni di utenti per acquistare, conservare, inviare e scambiare cripto in modo sicuro",
        LEADING_CRYPTO_WALLET: "Il principale portafoglio cripto e gateway per applicazioni blockchain funzionanti su Ethereum Mainnet, Polygon, Optimism e molte altre reti",
        CONTROL_DIGITAL_INTERACTIONS: "Ti da il controllo delle tue interazioni digitali rendendo piu' accessibile il potere della crittografia",
        INSTALL_META_MASK_EXTENSION: "Installa l'estensione MetaMask"
      },
      PENDING_MODAL: {
        OPEN_META_MASK_SELECT_CODE: "Si prega di aprire l'app mobile MetaMask Wallet e selezionare il codice sullo schermo OPPURE scollegarsi",
        OPEN_META_MASK_CONTINUE: "Apri l'app mobile MetaMask per continuare con la tua sessione.",
        NUMBER_AFTER_OPEN_NOTICE: "Se, dopo aver aperto MetaMask, non appare alcun numero, si prega di fare clic su disconnetti e ris canzionare il QRCode.",
        DISCONNECT: "Disconnetti"
      },
      SELECT_MODAL: {
        CRYPTO_TAKE_CONTROL_TEXT: "Prendi il controllo delle tue cripto e esplora la blockchain con il portafoglio ritenuto affidabile da oltre 30 milioni di persone in tutto il mondo"
      },
      META_MASK_MODAL: {
        ADDRESS_COPIED: "Indirizzo copiato negli appunti!",
        DISCONNECT: "Disconnetti",
        ACTIVE_NETWORK: "Rete attiva"
      }
    },
    Dj = {
      DESKTOP: "Desktop",
      MOBILE: "Móvel",
      META_MASK_MOBILE_APP: "Aplicativo móvel MetaMask",
      SCAN_TO_CONNECT: "Escanear para conectar e assinar com",
      CONNECT_WITH_EXTENSION: "Conectar com a extensão MetaMask",
      INSTALL_MODAL: {
        TRUSTED_BY_USERS: "Confiado por mais de 30 milhões de usuários para comprar, armazenar, enviar e trocar cripto com segurança",
        LEADING_CRYPTO_WALLET: "A principal carteira de cripto & portal para aplicativos blockchain construídos em Ethereum Mainnet, Polygon, Optimism, e muitas outras redes",
        CONTROL_DIGITAL_INTERACTIONS: "Coloca você no controle de suas interações digitais, tornando o poder da criptografia mais acessível",
        INSTALL_META_MASK_EXTENSION: "Instalar a extensão MetaMask"
      },
      PENDING_MODAL: {
        OPEN_META_MASK_SELECT_CODE: "Por favor, abra o aplicativo MetaMask e selecione o código na tela OU desconecte",
        OPEN_META_MASK_CONTINUE: "Abra o aplicativo MetaMask para continuar sua sessão.",
        NUMBER_AFTER_OPEN_NOTICE: "Se um número não aparecer após abrir o MetaMask, por favor clique em desconectar e re-escaneie o QRCode.",
        DISCONNECT: "Desconectar"
      },
      SELECT_MODAL: {
        CRYPTO_TAKE_CONTROL_TEXT: "Assuma o controle de sua cripto e explore a blockchain com a carteira confiada por mais de 30 milhões de pessoas em todo o mundo"
      },
      META_MASK_MODAL: {
        ADDRESS_COPIED: "Endereço copiado para a área de transferência!",
        DISCONNECT: "Desconectar",
        ACTIVE_NETWORK: "Rede ativa"
      }
    },
    Bj = {
      DESKTOP: "Masaüstü",
      MOBILE: "Mobil",
      META_MASK_MOBILE_APP: "MetaMask mobil uygulama",
      SCAN_TO_CONNECT: "Bağlanmak ve imzalamak için tarayın",
      CONNECT_WITH_EXTENSION: "MetaMask Eklentisi ile Bağlan",
      INSTALL_MODAL: {
        TRUSTED_BY_USERS: "Kriptoyu güvenle satın almak, saklamak, göndermek ve değiştirmek için 30 milyondan fazla kullanıcı tarafından güvenilir",
        LEADING_CRYPTO_WALLET: "Ethereum Ana Ağı, Polygon, Optimism ve birçok diğer ağda kurulu blockchain uygulamalarına erişim sağlayan öncü kripto cüzdanı",
        CONTROL_DIGITAL_INTERACTIONS: "Kriptografinin gücünü daha erişilebilir kılarak dijital etkileşimlerinizin kontrolünü size verir",
        INSTALL_META_MASK_EXTENSION: "MetaMask Eklentisini Yükleyin"
      },
      PENDING_MODAL: {
        OPEN_META_MASK_SELECT_CODE: "Lütfen MetaMask cüzdan uygulamasını açın ve ekrandaki kodu seçin YA DA bağlantıyı kesin",
        OPEN_META_MASK_CONTINUE: "Oturumunuzla devam etmek için MetaMask uygulamasını açın.",
        NUMBER_AFTER_OPEN_NOTICE: "MetaMask'ı açtıktan sonra bir numara görünmezse, lütfen bağlantıyı kesin ve QR Kodunu tekrar tarayın.",
        DISCONNECT: "Bağlantıyı Kes"
      },
      SELECT_MODAL: {
        CRYPTO_TAKE_CONTROL_TEXT: "Kriptonuzu kontrol edin ve dünya genelinde 30 milyondan fazla kişi tarafından güvenilen cüzdanla blockchain'i keşfedin"
      },
      META_MASK_MODAL: {
        ADDRESS_COPIED: "Adres panoya kopyalandı!",
        DISCONNECT: "Bağlantıyı Kes",
        ACTIVE_NETWORK: "Aktif Ağ"
      }
    };
  function jj(t) {
    var n, r, i, o, a, s, u, c, l, d;
    return wS(this, void 0, void 0, function* () {
      const {
        options: f
      } = t;
      f.logging = null !== (n = f.logging) && void 0 !== n ? n : {}, f.communicationLayerPreference = null !== (r = f.communicationLayerPreference) && void 0 !== r ? r : e.CommunicationLayerPreference.SOCKET, void 0 !== f.enableDebug && (HI.enable("MM_SDK"), console.warn("enableDebug is removed. Please use enableAnalytics instead.")), f.enableAnalytics = null === (i = f.enableAnalytics) || void 0 === i || i, f.injectProvider = null === (o = f.injectProvider) || void 0 === o || o, f.shouldShimWeb3 = null === (a = f.shouldShimWeb3) || void 0 === a || a, f.useDeeplink = null !== (s = f.useDeeplink) && void 0 !== s && s, f.storage = null !== (u = f.storage) && void 0 !== u ? u : {
        enabled: !0
      };
      const h = !0 === (null === (c = f.logging) || void 0 === c ? void 0 : c.developerMode);
      t.debug = (null === (l = f.logging) || void 0 === l ? void 0 : l.sdk) || h, OL("[MetaMaskSDK: performSDKInitialization()] options", t.options);
      const p = Object.assign({}, f.logging);
      h && (p.sdk = !0, p.eciesLayer = !0, p.keyExchangeLayer = !0, p.remoteLayer = !0, p.serviceLayer = !0, p.plaintext = !0), yield function (e) {
        var t, n, r;
        return wS(this, void 0, void 0, function* () {
          const i = null !== (t = e.options.i18nOptions) && void 0 !== t ? t : {},
            o = i.enabled;
          yield e.i18nInstance.use(Ij).init({
            debug: null !== (n = i.debug) && void 0 !== n && n,
            compatibilityJSON: "v3",
            fallbackLng: "en",
            interpolation: {
              escapeValue: !1
            },
            resources: o ? {
              en: {
                translation: Tj
              },
              es: {
                translation: Pj
              },
              it: {
                translation: Nj
              },
              fr: {
                translation: Oj
              },
              pt: {
                translation: Dj
              },
              tr: {
                translation: Bj
              },
              he: {
                translation: Lj
              }
            } : {
              en: {
                translation: Tj
              }
            },
            detection: {
              order: ["localStorage", "navigator"],
              lookupLocalStorage: "MetaMaskSDKLng",
              caches: ["localStorage"]
            }
          }), e.availableLanguages = Object.keys(null !== (r = e.i18nInstance.services.resourceStore.data) && void 0 !== r ? r : {});
        });
      }(t), yield function (e) {
        var t;
        return wS(this, void 0, void 0, function* () {
          const {
            options: n
          } = e;
          e.platformManager = new sB({
            useDeepLink: null !== (t = n.useDeeplink) && void 0 !== t && t,
            preferredOpenLink: n.openDeeplink,
            wakeLockStatus: n.wakeLockType,
            debug: e.debug
          });
        });
      }(t), yield function (e) {
        var t, n, r, i, o, a, s, u, c;
        return wS(this, void 0, void 0, function* () {
          const {
              options: l
            } = e,
            d = null === (t = e.platformManager) || void 0 === t ? void 0 : t.getPlatformType();
          e.analytics = new $D({
            serverUrl: null !== (n = l.communicationServerUrl) && void 0 !== n ? n : qE,
            enabled: l.enableAnalytics,
            originatorInfo: {
              url: null !== (r = l.dappMetadata.url) && void 0 !== r ? r : "",
              title: null !== (i = l.dappMetadata.name) && void 0 !== i ? i : "",
              dappId: "undefined" == typeof window || void 0 === window.location ? null !== (u = null !== (a = null === (o = l.dappMetadata) || void 0 === o ? void 0 : o.name) && void 0 !== a ? a : null === (s = l.dappMetadata) || void 0 === s ? void 0 : s.url) && void 0 !== u ? u : "unkown" : window.location.hostname,
              platform: null != d ? d : "",
              source: null !== (c = l._source) && void 0 !== c ? c : ""
            }
          });
        });
      }(t), yield function (e) {
        var t;
        return wS(this, void 0, void 0, function* () {
          const {
            options: n
          } = e;
          !0 !== (null === (t = n.storage) || void 0 === t ? void 0 : t.enabled) || n.storage.storageManager || (n.storage.storageManager = iN(n.storage));
        });
      }(t), yield function (e) {
        return wS(this, void 0, void 0, function* () {
          const {
              options: t
            } = e,
            n = /^(http|https):\/\/[^\s]*$/;
          if (t.dappMetadata) {
            t.dappMetadata.iconUrl && !n.test(t.dappMetadata.iconUrl) && (console.warn("Invalid dappMetadata.iconUrl: URL must start with http:// or https://"), t.dappMetadata.iconUrl = void 0), t.dappMetadata.base64Icon && t.dappMetadata.base64Icon.length > YD && (console.warn("Invalid dappMetadata.base64Icon: Base64-encoded icon string length must be less than 163400 characters"), t.dappMetadata.base64Icon = void 0), t.dappMetadata.url && !n.test(t.dappMetadata.url) && console.warn("Invalid dappMetadata.url: URL must start with http:// or https://");
            const e = WD();
            if (e && !t.dappMetadata.iconUrl && !t.dappMetadata.base64Icon) {
              const n = `${window.location.protocol}//${window.location.host}${e}`;
              t.dappMetadata.iconUrl = n;
            }
          }
          e.dappMetadata = t.dappMetadata;
        });
      }(t), yield sj(t), yield uj(t);
      const {
        metamaskBrowserExtension: m,
        preferExtension: g,
        shouldReturn: v
      } = yield function (e) {
        var t, n, r, i;
        return wS(this, void 0, void 0, function* () {
          const {
            options: o
          } = e;
          let a,
            s = !1,
            u = !1;
          if ("undefined" != typeof window && window.ethereum && !(null === (t = e.platformManager) || void 0 === t ? void 0 : t.isMetaMaskMobileWebView())) {
            s = "extension" === localStorage.getItem(XL);
            try {
              a = yield ZD({
                mustBeMetaMask: !0,
                sdkInstance: e
              }), window.extension = a, a.on(nN.CHAIN_CHANGED, t => {
                OL(`[MetaMaskSDK: setupExtensionPreferences()] PROPAGATE chainChanged chainId=${t}`), Boolean(e.sdkProvider) && e.getMobileProvider().emit(nN.CHAIN_CHANGED, t);
              }), a.on(nN.ACCOUNTS_CHANGED, t => {
                OL(`[MetaMaskSDK: setupExtensionPreferences()] PROPAGATE accountsChanged accounts=${t}`), Boolean(e.sdkProvider) && e.getMobileProvider().emit(nN.ACCOUNTS_CHANGED, t);
              }), a.on(nN.DISCONNECT, t => {
                OL(`[MetaMaskSDK: setupExtensionPreferences()] PROPAGATE disconnect error=${t}`), Boolean(e.sdkProvider) && e.getMobileProvider().emit(nN.DISCONNECT, t);
              }), a.on(nN.CONNECT, t => {
                OL(`[MetaMaskSDK: setupExtensionPreferences()] PROPAGATE connect args=${t}`), Boolean(e.sdkProvider) && e.getMobileProvider().emit(nN.CONNECT, t);
              }), a.on(nN.CONNECTED, t => {
                OL("[MetaMaskSDK: setupExtensionPreferences()] PROPAGATE connected", t), Boolean(e.sdkProvider) && e.getMobileProvider().emit(nN.CONNECTED, t);
              });
            } catch (e) {
              window.extension = void 0;
            }
            OD.destroy();
          } else (null === (n = e.platformManager) || void 0 === n ? void 0 : n.isMetaMaskMobileWebView()) && (null === (r = e.analytics) || void 0 === r || r.send({
            event: XE.SDK_USE_INAPP_BROWSER
          }), e.activeProvider = GD({
            provider: window.ethereum,
            sdkInstance: e
          }), e._initialized = !0, u = !0);
          return a && o.extensionOnly && (OL("[MetaMaskSDK: setupExtensionPreferences()] EXTENSION ONLY --- prevent sdk initialization"), null === (i = e.analytics) || void 0 === i || i.send({
            event: XE.SDK_USE_EXTENSION
          }), e.activeProvider = a, e.extensionActive = !0, e.extension = a, e._initialized = !0, u = !0), {
            preferExtension: s,
            shouldReturn: u,
            metamaskBrowserExtension: a
          };
        });
      }(t);
      if (v) OL("[MetaMaskSDK: performSDKInitialization()] shouldReturn=true --- prevent sdk initialization");else {
        yield function (t, n) {
          var r, i, o, a, s;
          return wS(this, void 0, void 0, function* () {
            const {
                options: u
              } = t,
              c = Object.assign({}, u.logging);
            t.remoteConnection = new aj({
              i18nInstance: t.i18nInstance,
              preferDesktop: null !== (r = u.preferDesktop) && void 0 !== r && r,
              communicationLayerPreference: null !== (i = u.communicationLayerPreference) && void 0 !== i ? i : e.CommunicationLayerPreference.SOCKET,
              analytics: t.analytics,
              dappMetadata: u.dappMetadata,
              _source: u._source,
              enableAnalytics: null === (o = u.enableAnalytics) || void 0 === o || o,
              timer: u.timer,
              sdk: t,
              platformManager: t.platformManager,
              transports: u.transports,
              communicationServerUrl: u.communicationServerUrl,
              storage: null !== (a = u.storage) && void 0 !== a ? a : {
                enabled: !0
              },
              getMetaMaskInstaller: () => {
                if (!t.installer) throw new Error("Invalid SDK status -- installer not initialized");
                return t.installer;
              },
              logging: c,
              connectWithExtensionProvider: void 0 === n ? void 0 : () => MD(t),
              modals: Object.assign(Object.assign({}, u.modals), {
                onPendingModalDisconnect: t.terminate.bind(t)
              })
            }), t.installer = new wB({
              remote: t.remoteConnection,
              preferDesktop: null !== (s = u.preferDesktop) && void 0 !== s && s,
              platformManager: t.platformManager,
              debug: t.debug
            });
          });
        }(t, m), yield UD(t), yield function (e, t) {
          var n, r;
          return wS(this, void 0, void 0, function* () {
            const {
              options: i
            } = e;
            t ? (OL("[MetaMaskSDK: handleAutoAndExtensionConnections()] preferExtension is detected -- connect with it."), null === (n = e.analytics) || void 0 === n || n.send({
              event: XE.SDK_EXTENSION_UTILIZED
            }), MD(e).catch(e => {
              console.warn("Can't connect with MetaMask extension...", e), localStorage.removeItem(XL);
            })) : i.checkInstallationImmediately && ((null === (r = e.platformManager) || void 0 === r ? void 0 : r.isDesktopWeb()) ? (OL("[MetaMaskSDK: handleAutoAndExtensionConnections()] checkInstallationImmediately"), e.connect().catch(e => {
              OL(`[MetaMaskSDK: handleAutoAndExtensionConnections()] checkInstallationImmediately --- IGNORED --- error on autoconnect _err=${e}`);
            })) : console.warn("[handleAutoAndExtensionConnections()] checkInstallationImmediately --- IGNORED --- only for web desktop")), e._initialized = !0;
          });
        }(t, g);
        try {
          yield null === (d = t.remoteConnection) || void 0 === d ? void 0 : d.startConnection({
            initialCheck: !0
          });
        } catch (e) {
          console.error("[MetaMaskSDK: setupRemoteConnectionAndInstaller()] Error while checking installation", e);
        }
        t.emit(e.EventType.PROVIDER_UPDATE, e.PROVIDER_UPDATE_TYPE.INITIALIZED);
      }
    });
  }
  class Fj extends sN {
    constructor(e = {
      storage: {
        enabled: !0
      },
      injectProvider: !0,
      forceInjectProvider: !1,
      enableAnalytics: !0,
      shouldShimWeb3: !0,
      useDeeplink: !1,
      dappMetadata: {
        name: "",
        url: ""
      },
      i18nOptions: {
        enabled: !1
      }
    }) {
      var t, n, r, i;
      super(), this.extensionActive = !1, this._initialized = !1, this.sdkInitPromise = void 0, this.debug = !1, this.readonlyRPCCalls = !1, this.defaultReadOnlyChainId = "0x1", this.i18nInstance = _D(), this.availableLanguages = ["en"], HI.disable();
      const o = !0 === (null === (t = e.logging) || void 0 === t ? void 0 : t.developerMode);
      if (((null === (n = e.logging) || void 0 === n ? void 0 : n.sdk) || o) && HI.enable("MM_SDK"), OL("[MetaMaskSDK: constructor()]: begin."), this.setMaxListeners(50), !(null === (r = e.dappMetadata) || void 0 === r ? void 0 : r.name) && !(null === (i = e.dappMetadata) || void 0 === i ? void 0 : i.url)) {
        if ("undefined" == typeof window || "undefined" == typeof document) throw new Error("You must provide dAppMetadata option (name and/or url)");
        e.dappMetadata = {
          url: window.location.href,
          name: document.title
        };
      }
      if (e.defaultReadOnlyChainId) {
        if ("number" == typeof e.defaultReadOnlyChainId) this.defaultReadOnlyChainId = `0x${e.defaultReadOnlyChainId.toString(16)}`;else if ("string" == typeof e.defaultReadOnlyChainId && !e.defaultReadOnlyChainId.startsWith("0x")) throw new Error("Invalid defaultReadOnlyChainId, must start with '0x'");
        this.defaultReadOnlyChainId = e.defaultReadOnlyChainId.toString();
      }
      this.options = e, this.init().then(() => {
        OL("[MetaMaskSDK: constructor()]: initialized successfully."), "undefined" != typeof window && (window.mmsdk = this);
      }).catch(e => {
        console.error("[MetaMaskSDK: constructor()] error during initialization", e);
      });
    }
    init() {
      return wS(this, void 0, void 0, function* () {
        return function (e) {
          var t;
          return wS(this, void 0, void 0, function* () {
            if ("undefined" != typeof window && (null === (t = window.mmsdk) || void 0 === t ? void 0 : t.isInitialized())) return OL("[MetaMaskSDK: initializeMetaMaskSDK()] already initialized"), Promise.resolve(window.mmsdk);
            if (e._initialized) return OL("[MetaMaskSDK: initializeMetaMaskSDK()] already initialized"), e.sdkInitPromise;
            if (e.sdkInitPromise) return OL("[MetaMaskSDK: initializeMetaMaskSDK()] already initializing"), e.sdkInitPromise;
            try {
              e.sdkInitPromise = jj(e), yield e.sdkInitPromise;
            } catch (e) {
              throw console.error(e), e;
            }
            return e.sdkInitPromise;
          });
        }(this);
      });
    }
    isExtensionActive() {
      return this.extensionActive;
    }
    connect() {
      return wS(this, void 0, void 0, function* () {
        return function (e) {
          return wS(this, void 0, void 0, function* () {
            if (e._initialized || (OL("[MetaMaskSDK: connect()] provider not ready -- wait for init()"), yield e.init()), OL(`[MetaMaskSDK: connect()] isExtensionActive=${e.isExtensionActive()} activeProvider`, e.activeProvider), !e.activeProvider) throw new Error("SDK state invalid -- undefined provider");
            return e.activeProvider.request({
              method: YL.ETH_REQUESTACCOUNTS,
              params: []
            });
          });
        }(this);
      });
    }
    connectAndSign({
      msg: e
    }) {
      return wS(this, void 0, void 0, function* () {
        return function ({
          instance: e,
          msg: t
        }) {
          return wS(this, void 0, void 0, function* () {
            if (e._initialized || (OL("[MetaMaskSDK: connectAndSign()] provider not ready -- wait for init()"), yield e.init()), OL(`[MetaMaskSDK: connectAndSign()] activeProvider=${e.activeProvider}`), !e.activeProvider) throw new Error("SDK state invalid -- undefined provider");
            return e.activeProvider.request({
              method: YL.METAMASK_CONNECTSIGN,
              params: [t]
            });
          });
        }({
          instance: this,
          msg: e
        });
      });
    }
    connectWith(e) {
      return wS(this, void 0, void 0, function* () {
        return function ({
          instance: e,
          rpc: t
        }) {
          return wS(this, void 0, void 0, function* () {
            if (e._initialized || (OL("[MetaMaskSDK: connectWith()] provider not ready -- wait for init()"), yield e.init()), OL(`[MetaMaskSDK: connectWith()] method: ${t.method} rpc=${t}`), !e.activeProvider) throw new Error("SDK state invalid -- undefined provider");
            return e.activeProvider.request({
              method: YL.METAMASK_CONNECTWITH,
              params: [t]
            });
          });
        }({
          instance: this,
          rpc: e
        });
      });
    }
    resume() {
      return function (e) {
        var t, n, r;
        return wS(this, void 0, void 0, function* () {
          if (!(null === (n = null === (t = e.remoteConnection) || void 0 === t ? void 0 : t.getConnector()) || void 0 === n ? void 0 : n.isReady())) return OL("[MetaMaskSDK: resume()] channel is not ready -- starting connection"), void (null === (r = e.remoteConnection) || void 0 === r || r.startConnection());
          OL("[MetaMaskSDK: resume()] channel is ready");
        });
      }(this);
    }
    disconnect() {
      console.warn("MetaMaskSDK.disconnect() is deprecated, use terminate()"), this.terminate();
    }
    isAuthorized() {
      var e;
      null === (e = this.remoteConnection) || void 0 === e || e.isAuthorized();
    }
    terminate() {
      return function (t) {
        var n, r;
        if (!(null === (n = t.platformManager) || void 0 === n ? void 0 : n.isMetaMaskMobileWebView())) {
          if (kD && (window.localStorage.removeItem(XL), window.localStorage.removeItem(tN), window.localStorage.removeItem(eN)), t.extensionActive) return t.options.extensionOnly ? void OL("[MetaMaskSDK: terminate()] extensionOnly --- prevent switching providers") : (t.activeProvider = t.sdkProvider, window.ethereum = t.activeProvider, t.extensionActive = !1, void t.emit(e.EventType.PROVIDER_UPDATE, e.PROVIDER_UPDATE_TYPE.TERMINATE));
          t.emit(e.EventType.PROVIDER_UPDATE, e.PROVIDER_UPDATE_TYPE.TERMINATE), OL(`[MetaMaskSDK: terminate()] remoteConnection=${t.remoteConnection}`), null === (r = t.remoteConnection) || void 0 === r || r.disconnect({
            terminate: !0,
            sendMessage: !0
          });
        }
      }(this);
    }
    isInitialized() {
      return this._initialized;
    }
    setReadOnlyRPCCalls(e) {
      this.readonlyRPCCalls = e;
    }
    hasReadOnlyRPCCalls() {
      return this.readonlyRPCCalls;
    }
    getProvider() {
      if (this.activeProvider) return this.activeProvider;
      console.warn("MetaMaskSDK: No active provider found");
    }
    getMobileProvider() {
      if (!this.sdkProvider) throw new Error("SDK state invalid -- undefined mobile provider");
      return this.sdkProvider;
    }
    getUniversalLink() {
      var e;
      const t = null === (e = this.remoteConnection) || void 0 === e ? void 0 : e.getUniversalLink();
      if (!t) throw new Error("No Universal Link available, please call eth_requestAccounts first.");
      return t;
    }
    getChannelId() {
      var e, t;
      return null === (t = null === (e = this.remoteConnection) || void 0 === e ? void 0 : e.getChannelConfig()) || void 0 === t ? void 0 : t.channelId;
    }
    getRPCHistory() {
      var e, t;
      return null === (t = null === (e = this.remoteConnection) || void 0 === e ? void 0 : e.getConnector()) || void 0 === t ? void 0 : t.getRPCMethodTracker();
    }
    getVersion() {
      return SD;
    }
    getWalletStatus() {
      var e, t;
      return null === (t = null === (e = this.remoteConnection) || void 0 === e ? void 0 : e.getConnector()) || void 0 === t ? void 0 : t.getConnectionStatus();
    }
    _getChannelConfig() {
      var e;
      return null === (e = this.remoteConnection) || void 0 === e ? void 0 : e.getChannelConfig();
    }
    _ping() {
      var e, t;
      null === (t = null === (e = this.remoteConnection) || void 0 === e ? void 0 : e.getConnector()) || void 0 === t || t.ping();
    }
    _keyCheck() {
      var e, t;
      null === (t = null === (e = this.remoteConnection) || void 0 === e ? void 0 : e.getConnector()) || void 0 === t || t.keyCheck();
    }
    _getServiceStatus() {
      var e, t;
      return null === (t = null === (e = this.remoteConnection) || void 0 === e ? void 0 : e.getConnector()) || void 0 === t ? void 0 : t.getServiceStatus();
    }
    _getRemoteConnection() {
      return this.remoteConnection;
    }
    _getDappMetadata() {
      return this.dappMetadata;
    }
    _getKeyInfo() {
      var e;
      return null === (e = this.remoteConnection) || void 0 === e ? void 0 : e.getKeyInfo();
    }
    _resetKeys() {
      var e, t;
      null === (t = null === (e = this.remoteConnection) || void 0 === e ? void 0 : e.getConnector()) || void 0 === t || t.resetKeys();
    }
    _getConnection() {
      return this.remoteConnection;
    }
  }
  e.DEFAULT_SERVER_URL = qE, e.MetaMaskSDK = Fj, e.SDKProvider = oN, e.default = Fj, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});
